/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @enum {string}
 */

export const AccountRole = {
    generalUser: 'GENERAL_USER',
    organizationAdmin: 'ORGANIZATION_ADMIN',
    viewer: 'VIEWER',
    bookkeeper: 'BOOKKEEPER'
} as const;

export type AccountRole = typeof AccountRole[keyof typeof AccountRole];


/**
 * 
 * @export
 * @interface AddCommentRequest
 */
export interface AddCommentRequest {
    /**
     * 
     * @type {string}
     * @memberof AddCommentRequest
     */
    'comment': string;
}
/**
 * 
 * @export
 * @interface AddOrganizationCreateRequest200Response
 */
export interface AddOrganizationCreateRequest200Response {
    /**
     * 
     * @type {string}
     * @memberof AddOrganizationCreateRequest200Response
     */
    'id': string;
}
/**
 * 
 * @export
 * @interface AddOrganizationCreateRequestRequest
 */
export interface AddOrganizationCreateRequestRequest {
    /**
     * 
     * @type {string}
     * @memberof AddOrganizationCreateRequestRequest
     */
    'organizationName': string;
    /**
     * 
     * @type {string}
     * @memberof AddOrganizationCreateRequestRequest
     */
    'corporateNumber': string;
    /**
     * 
     * @type {string}
     * @memberof AddOrganizationCreateRequestRequest
     */
    'businessDescriptionId': string;
    /**
     * 
     * @type {number}
     * @memberof AddOrganizationCreateRequestRequest
     */
    'purposeTransaction': number;
    /**
     * 
     * @type {string}
     * @memberof AddOrganizationCreateRequestRequest
     */
    'purposeTransactionOther'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddOrganizationCreateRequestRequest
     */
    'postalCode': string;
    /**
     * 
     * @type {string}
     * @memberof AddOrganizationCreateRequestRequest
     */
    'address': string;
    /**
     * 
     * @type {string}
     * @memberof AddOrganizationCreateRequestRequest
     */
    'phoneNumber': string;
    /**
     * 
     * @type {string}
     * @memberof AddOrganizationCreateRequestRequest
     */
    'representativeName': string;
    /**
     * 
     * @type {string}
     * @memberof AddOrganizationCreateRequestRequest
     */
    'bankName': string;
    /**
     * 
     * @type {string}
     * @memberof AddOrganizationCreateRequestRequest
     */
    'branchName': string;
    /**
     * 
     * @type {string}
     * @memberof AddOrganizationCreateRequestRequest
     */
    'bankAccountType': AddOrganizationCreateRequestRequestBankAccountTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AddOrganizationCreateRequestRequest
     */
    'bankAccountNumber': string;
    /**
     * 
     * @type {string}
     * @memberof AddOrganizationCreateRequestRequest
     */
    'bankAccountHolder': string;
    /**
     * 
     * @type {Array<AddOrganizationCreateRequestRequestOrganizationUsersInner>}
     * @memberof AddOrganizationCreateRequestRequest
     */
    'organizationUsers': Array<AddOrganizationCreateRequestRequestOrganizationUsersInner>;
    /**
     * 
     * @type {string}
     * @memberof AddOrganizationCreateRequestRequest
     */
    'vcCooperationPlan': string;
    /**
     * 
     * @type {AddOrganizationCreateRequestRequestVcCooperationPlanRewardType}
     * @memberof AddOrganizationCreateRequestRequest
     */
    'vcCooperationPlanRewardType'?: AddOrganizationCreateRequestRequestVcCooperationPlanRewardType | null;
    /**
     * 
     * @type {string}
     * @memberof AddOrganizationCreateRequestRequest
     */
    'promotionCode'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AddOrganizationCreateRequestRequest
     */
    'isExistsBeneficialOwner': boolean;
    /**
     * 
     * @type {AddOrganizationCreateRequestRequestCorporateType}
     * @memberof AddOrganizationCreateRequestRequest
     */
    'corporateType'?: AddOrganizationCreateRequestRequestCorporateType | null;
    /**
     * 
     * @type {Array<AddOrganizationCreateRequestRequestBeneficialOwnersInner>}
     * @memberof AddOrganizationCreateRequestRequest
     */
    'beneficialOwners'?: Array<AddOrganizationCreateRequestRequestBeneficialOwnersInner> | null;
    /**
     * 
     * @type {boolean}
     * @memberof AddOrganizationCreateRequestRequest
     */
    'isRepresentative': boolean;
    /**
     * 
     * @type {string}
     * @memberof AddOrganizationCreateRequestRequest
     */
    'transactionManagerName': string;
    /**
     * 
     * @type {string}
     * @memberof AddOrganizationCreateRequestRequest
     */
    'transactionManagerBirthday': string;
    /**
     * 
     * @type {string}
     * @memberof AddOrganizationCreateRequestRequest
     */
    'transactionManagerAddress': string;
    /**
     * 
     * @type {string}
     * @memberof AddOrganizationCreateRequestRequest
     */
    'transactionManagerEmail': string;
    /**
     * 
     * @type {string}
     * @memberof AddOrganizationCreateRequestRequest
     */
    'preRequestCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddOrganizationCreateRequestRequest
     */
    'mediaCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddOrganizationCreateRequestRequest
     */
    'campaignApplicationCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddOrganizationCreateRequestRequest
     */
    'identificationId'?: string | null;
}

export const AddOrganizationCreateRequestRequestBankAccountTypeEnum = {
    savingsAccount: 'SAVINGS_ACCOUNT',
    currentAccount: 'CURRENT_ACCOUNT',
    depositAccount: 'DEPOSIT_ACCOUNT',
    otherAccount: 'OTHER_ACCOUNT'
} as const;

export type AddOrganizationCreateRequestRequestBankAccountTypeEnum = typeof AddOrganizationCreateRequestRequestBankAccountTypeEnum[keyof typeof AddOrganizationCreateRequestRequestBankAccountTypeEnum];

/**
 * 
 * @export
 * @interface AddOrganizationCreateRequestRequestBeneficialOwnersInner
 */
export interface AddOrganizationCreateRequestRequestBeneficialOwnersInner {
    /**
     * 
     * @type {string}
     * @memberof AddOrganizationCreateRequestRequestBeneficialOwnersInner
     */
    'corporateRelationships'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddOrganizationCreateRequestRequestBeneficialOwnersInner
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AddOrganizationCreateRequestRequestBeneficialOwnersInner
     */
    'beneficialOwnerType': string;
    /**
     * 
     * @type {string}
     * @memberof AddOrganizationCreateRequestRequestBeneficialOwnersInner
     */
    'gender': string;
    /**
     * 
     * @type {string}
     * @memberof AddOrganizationCreateRequestRequestBeneficialOwnersInner
     */
    'birthday': string;
    /**
     * 
     * @type {string}
     * @memberof AddOrganizationCreateRequestRequestBeneficialOwnersInner
     */
    'countryResidence': string;
    /**
     * 
     * @type {string}
     * @memberof AddOrganizationCreateRequestRequestBeneficialOwnersInner
     */
    'address': string;
    /**
     * 
     * @type {string}
     * @memberof AddOrganizationCreateRequestRequestBeneficialOwnersInner
     */
    'isPoliticallyExposedPersons': string;
}
/**
 * @type AddOrganizationCreateRequestRequestCorporateType
 * @export
 */
export type AddOrganizationCreateRequestRequestCorporateType = AddOrganizationCreateRequestRequestCorporateTypeOneOf;

/**
 * 
 * @export
 * @enum {string}
 */

export const AddOrganizationCreateRequestRequestCorporateTypeOneOf = {
    majorityCapitalVoteCorporate: 'MAJORITY_CAPITAL_VOTE_CORPORATE',
    exceptMajorityCapitalVoteCorporate: 'EXCEPT_MAJORITY_CAPITAL_VOTE_CORPORATE'
} as const;

export type AddOrganizationCreateRequestRequestCorporateTypeOneOf = typeof AddOrganizationCreateRequestRequestCorporateTypeOneOf[keyof typeof AddOrganizationCreateRequestRequestCorporateTypeOneOf];


/**
 * 
 * @export
 * @interface AddOrganizationCreateRequestRequestOrganizationUsersInner
 */
export interface AddOrganizationCreateRequestRequestOrganizationUsersInner {
    /**
     * 
     * @type {string}
     * @memberof AddOrganizationCreateRequestRequestOrganizationUsersInner
     */
    'userName': string;
    /**
     * 
     * @type {string}
     * @memberof AddOrganizationCreateRequestRequestOrganizationUsersInner
     */
    'userMailAddress': string;
    /**
     * 
     * @type {string}
     * @memberof AddOrganizationCreateRequestRequestOrganizationUsersInner
     */
    'userPrivilege': AddOrganizationCreateRequestRequestOrganizationUsersInnerUserPrivilegeEnum;
}

export const AddOrganizationCreateRequestRequestOrganizationUsersInnerUserPrivilegeEnum = {
    generalUser: 'GENERAL_USER',
    organizationAdmin: 'ORGANIZATION_ADMIN',
    viewer: 'VIEWER',
    bookkeeper: 'BOOKKEEPER'
} as const;

export type AddOrganizationCreateRequestRequestOrganizationUsersInnerUserPrivilegeEnum = typeof AddOrganizationCreateRequestRequestOrganizationUsersInnerUserPrivilegeEnum[keyof typeof AddOrganizationCreateRequestRequestOrganizationUsersInnerUserPrivilegeEnum];

/**
 * @type AddOrganizationCreateRequestRequestVcCooperationPlanRewardType
 * @export
 */
export type AddOrganizationCreateRequestRequestVcCooperationPlanRewardType = AddOrganizationCreateRequestRequestVcCooperationPlanRewardTypeOneOf;

/**
 * 
 * @export
 * @enum {string}
 */

export const AddOrganizationCreateRequestRequestVcCooperationPlanRewardTypeOneOf = {
    advertising: 'ADVERTISING',
    fixed: 'FIXED'
} as const;

export type AddOrganizationCreateRequestRequestVcCooperationPlanRewardTypeOneOf = typeof AddOrganizationCreateRequestRequestVcCooperationPlanRewardTypeOneOf[keyof typeof AddOrganizationCreateRequestRequestVcCooperationPlanRewardTypeOneOf];


/**
 * 
 * @export
 * @interface AddPointToOrganizationRequest
 */
export interface AddPointToOrganizationRequest {
    /**
     * 
     * @type {number}
     * @memberof AddPointToOrganizationRequest
     */
    'amount': number;
    /**
     * 
     * @type {string}
     * @memberof AddPointToOrganizationRequest
     */
    'memo': string;
}
/**
 * 
 * @export
 * @interface Alliance
 */
export interface Alliance {
    /**
     * 
     * @type {string}
     * @memberof Alliance
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Alliance
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof Alliance
     */
    'partnerName': string;
    /**
     * 
     * @type {string}
     * @memberof Alliance
     */
    'serviceName': string;
    /**
     * 
     * @type {string}
     * @memberof Alliance
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof Alliance
     */
    'startAt': string;
    /**
     * 
     * @type {string}
     * @memberof Alliance
     */
    'endAt': string;
}
/**
 * 
 * @export
 * @interface AnalyzeEvidence200Response
 */
export interface AnalyzeEvidence200Response {
    /**
     * 
     * @type {string}
     * @memberof AnalyzeEvidence200Response
     */
    'fileId': string;
    /**
     * 
     * @type {string}
     * @memberof AnalyzeEvidence200Response
     */
    'fileName': string;
    /**
     * 
     * @type {string}
     * @memberof AnalyzeEvidence200Response
     */
    'issuerName': string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalyzeEvidence200Response
     */
    'qualifiedInvoiceIssuerNumber': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AnalyzeEvidence200Response
     */
    'isQualified': boolean;
}
/**
 * 
 * @export
 * @interface AnalyzeEvidenceRequest
 */
export interface AnalyzeEvidenceRequest {
    /**
     * 
     * @type {File}
     * @memberof AnalyzeEvidenceRequest
     */
    'file'?: File;
}
/**
 * 
 * @export
 * @interface AnalyzeInvoiceOfPaymentRequests200Response
 */
export interface AnalyzeInvoiceOfPaymentRequests200Response {
    /**
     * 
     * @type {string}
     * @memberof AnalyzeInvoiceOfPaymentRequests200Response
     */
    'fileId': string;
    /**
     * To return an OK response even if the result of OCR analysis fails, express in this field whether the OCR analysis was successful.
     * @type {boolean}
     * @memberof AnalyzeInvoiceOfPaymentRequests200Response
     */
    'analyzed': boolean;
    /**
     * 
     * @type {AnalyzeInvoiceOfPaymentRequests200ResponseSupplier}
     * @memberof AnalyzeInvoiceOfPaymentRequests200Response
     */
    'supplier': AnalyzeInvoiceOfPaymentRequests200ResponseSupplier;
    /**
     * 
     * @type {string}
     * @memberof AnalyzeInvoiceOfPaymentRequests200Response
     */
    'billingDate': string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalyzeInvoiceOfPaymentRequests200Response
     */
    'dueDate': string | null;
    /**
     * 
     * @type {number}
     * @memberof AnalyzeInvoiceOfPaymentRequests200Response
     */
    'totalAmount': number | null;
    /**
     * 
     * @type {string}
     * @memberof AnalyzeInvoiceOfPaymentRequests200Response
     */
    'invoiceIssuerName': string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalyzeInvoiceOfPaymentRequests200Response
     */
    'invoiceIssuerRegistrationNumber': string | null;
}
/**
 * 
 * @export
 * @interface AnalyzeInvoiceOfPaymentRequests200ResponseSupplier
 */
export interface AnalyzeInvoiceOfPaymentRequests200ResponseSupplier {
    /**
     * 
     * @type {string}
     * @memberof AnalyzeInvoiceOfPaymentRequests200ResponseSupplier
     */
    'partnerId': string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalyzeInvoiceOfPaymentRequests200ResponseSupplier
     */
    'name': string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalyzeInvoiceOfPaymentRequests200ResponseSupplier
     */
    'bankNumber': string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalyzeInvoiceOfPaymentRequests200ResponseSupplier
     */
    'bankName': string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalyzeInvoiceOfPaymentRequests200ResponseSupplier
     */
    'branchNumber': string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalyzeInvoiceOfPaymentRequests200ResponseSupplier
     */
    'branchName': string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalyzeInvoiceOfPaymentRequests200ResponseSupplier
     */
    'accountNumber': string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalyzeInvoiceOfPaymentRequests200ResponseSupplier
     */
    'accountType': AnalyzeInvoiceOfPaymentRequests200ResponseSupplierAccountTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AnalyzeInvoiceOfPaymentRequests200ResponseSupplier
     */
    'companyName': string | null;
}

export const AnalyzeInvoiceOfPaymentRequests200ResponseSupplierAccountTypeEnum = {
    savingsAccount: 'SAVINGS_ACCOUNT',
    currentAccount: 'CURRENT_ACCOUNT',
    thriftAccount: 'THRIFT_ACCOUNT',
    other: 'OTHER'
} as const;

export type AnalyzeInvoiceOfPaymentRequests200ResponseSupplierAccountTypeEnum = typeof AnalyzeInvoiceOfPaymentRequests200ResponseSupplierAccountTypeEnum[keyof typeof AnalyzeInvoiceOfPaymentRequests200ResponseSupplierAccountTypeEnum];

/**
 * 
 * @export
 * @interface AnalyzeInvoiceOfPaymentRequestsRequest
 */
export interface AnalyzeInvoiceOfPaymentRequestsRequest {
    /**
     * 
     * @type {File}
     * @memberof AnalyzeInvoiceOfPaymentRequestsRequest
     */
    'file': File;
}
/**
 * 
 * @export
 * @interface Applicant
 */
export interface Applicant {
    /**
     * 
     * @type {string}
     * @memberof Applicant
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof Applicant
     */
    'organizationName': string;
    /**
     * 
     * @type {string}
     * @memberof Applicant
     */
    'organizationAddress': string;
    /**
     * 
     * @type {string}
     * @memberof Applicant
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof Applicant
     */
    'userName': string;
    /**
     * 
     * @type {string}
     * @memberof Applicant
     */
    'userEmail': string;
}
/**
 * 
 * @export
 * @interface ApproveOrganizationIdentityVerification200Response
 */
export interface ApproveOrganizationIdentityVerification200Response {
    /**
     * 
     * @type {string}
     * @memberof ApproveOrganizationIdentityVerification200Response
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ApproveOrganizationIdentityVerification200Response
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof ApproveOrganizationIdentityVerification200Response
     */
    'organizationCreateRequestId': string | null;
    /**
     * 
     * @type {string}
     * @memberof ApproveOrganizationIdentityVerification200Response
     */
    'organizationName': string;
    /**
     * 
     * @type {string}
     * @memberof ApproveOrganizationIdentityVerification200Response
     */
    'corporateNumber': string;
    /**
     * 
     * @type {number}
     * @memberof ApproveOrganizationIdentityVerification200Response
     */
    'businessDescriptionId': number;
    /**
     * 
     * @type {number}
     * @memberof ApproveOrganizationIdentityVerification200Response
     */
    'purposeTransaction': number;
    /**
     * 
     * @type {string}
     * @memberof ApproveOrganizationIdentityVerification200Response
     */
    'purposeTransactionOther': string | null;
    /**
     * 
     * @type {string}
     * @memberof ApproveOrganizationIdentityVerification200Response
     */
    'postalCode': string;
    /**
     * 
     * @type {string}
     * @memberof ApproveOrganizationIdentityVerification200Response
     */
    'address': string;
    /**
     * 
     * @type {string}
     * @memberof ApproveOrganizationIdentityVerification200Response
     */
    'phoneNumber': string;
    /**
     * 
     * @type {string}
     * @memberof ApproveOrganizationIdentityVerification200Response
     */
    'representativeName': string;
    /**
     * 
     * @type {boolean}
     * @memberof ApproveOrganizationIdentityVerification200Response
     */
    'isExistsBeneficialOwner': boolean;
    /**
     * 
     * @type {string}
     * @memberof ApproveOrganizationIdentityVerification200Response
     */
    'corporateType': string | null;
    /**
     * 
     * @type {Array<ApproveOrganizationIdentityVerification200ResponseBeneficialOwnersInner>}
     * @memberof ApproveOrganizationIdentityVerification200Response
     */
    'beneficialOwners': Array<ApproveOrganizationIdentityVerification200ResponseBeneficialOwnersInner>;
    /**
     * 
     * @type {boolean}
     * @memberof ApproveOrganizationIdentityVerification200Response
     */
    'isRepresentative': boolean;
    /**
     * 
     * @type {string}
     * @memberof ApproveOrganizationIdentityVerification200Response
     */
    'transactionManagerName': string;
    /**
     * 
     * @type {string}
     * @memberof ApproveOrganizationIdentityVerification200Response
     */
    'transactionManagerBirthday': string;
    /**
     * 
     * @type {string}
     * @memberof ApproveOrganizationIdentityVerification200Response
     */
    'transactionManagerAddress': string;
    /**
     * 
     * @type {string}
     * @memberof ApproveOrganizationIdentityVerification200Response
     */
    'transactionManagerEmail': string;
    /**
     * 
     * @type {string}
     * @memberof ApproveOrganizationIdentityVerification200Response
     */
    'note': string | null;
    /**
     * 
     * @type {ApproveOrganizationIdentityVerification200ResponseStatus}
     * @memberof ApproveOrganizationIdentityVerification200Response
     */
    'status': ApproveOrganizationIdentityVerification200ResponseStatus | null;
    /**
     * 
     * @type {Array<ApproveOrganizationIdentityVerification200ResponseIdentificationInner>}
     * @memberof ApproveOrganizationIdentityVerification200Response
     */
    'identification': Array<ApproveOrganizationIdentityVerification200ResponseIdentificationInner>;
    /**
     * 
     * @type {Array<ApproveOrganizationIdentityVerification200ResponseAntisocialForcesCheckInner>}
     * @memberof ApproveOrganizationIdentityVerification200Response
     */
    'antisocialForcesCheck': Array<ApproveOrganizationIdentityVerification200ResponseAntisocialForcesCheckInner>;
    /**
     * 
     * @type {Array<ApproveOrganizationIdentityVerification200ResponseSnailMailVerificationInner>}
     * @memberof ApproveOrganizationIdentityVerification200Response
     */
    'snailMailVerification': Array<ApproveOrganizationIdentityVerification200ResponseSnailMailVerificationInner> | null;
    /**
     * 
     * @type {string}
     * @memberof ApproveOrganizationIdentityVerification200Response
     */
    'createdAt': string;
}
/**
 * 
 * @export
 * @interface ApproveOrganizationIdentityVerification200ResponseAntisocialForcesCheckInner
 */
export interface ApproveOrganizationIdentityVerification200ResponseAntisocialForcesCheckInner {
    /**
     * 
     * @type {string}
     * @memberof ApproveOrganizationIdentityVerification200ResponseAntisocialForcesCheckInner
     */
    'organizationIdentityVerificationId': string;
    /**
     * 
     * @type {string}
     * @memberof ApproveOrganizationIdentityVerification200ResponseAntisocialForcesCheckInner
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof ApproveOrganizationIdentityVerification200ResponseAntisocialForcesCheckInner
     */
    'payloadId': string;
    /**
     * 
     * @type {number}
     * @memberof ApproveOrganizationIdentityVerification200ResponseAntisocialForcesCheckInner
     */
    'payloadDetailId': number;
    /**
     * 
     * @type {string}
     * @memberof ApproveOrganizationIdentityVerification200ResponseAntisocialForcesCheckInner
     */
    'category': string;
    /**
     * 
     * @type {object}
     * @memberof ApproveOrganizationIdentityVerification200ResponseAntisocialForcesCheckInner
     */
    'condition'?: object;
    /**
     * 
     * @type {Array<object>}
     * @memberof ApproveOrganizationIdentityVerification200ResponseAntisocialForcesCheckInner
     */
    'results'?: Array<object> | null;
}
/**
 * 
 * @export
 * @interface ApproveOrganizationIdentityVerification200ResponseBeneficialOwnersInner
 */
export interface ApproveOrganizationIdentityVerification200ResponseBeneficialOwnersInner {
    /**
     * 
     * @type {string}
     * @memberof ApproveOrganizationIdentityVerification200ResponseBeneficialOwnersInner
     */
    'corporateRelationships'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApproveOrganizationIdentityVerification200ResponseBeneficialOwnersInner
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ApproveOrganizationIdentityVerification200ResponseBeneficialOwnersInner
     */
    'beneficialOwnerType': string;
    /**
     * 
     * @type {string}
     * @memberof ApproveOrganizationIdentityVerification200ResponseBeneficialOwnersInner
     */
    'gender': string;
    /**
     * 
     * @type {string}
     * @memberof ApproveOrganizationIdentityVerification200ResponseBeneficialOwnersInner
     */
    'birthday': string;
    /**
     * 
     * @type {string}
     * @memberof ApproveOrganizationIdentityVerification200ResponseBeneficialOwnersInner
     */
    'countryResidence': string;
    /**
     * 
     * @type {string}
     * @memberof ApproveOrganizationIdentityVerification200ResponseBeneficialOwnersInner
     */
    'address': string;
    /**
     * 
     * @type {boolean}
     * @memberof ApproveOrganizationIdentityVerification200ResponseBeneficialOwnersInner
     */
    'isPoliticallyExposedPersons': boolean;
}
/**
 * 
 * @export
 * @interface ApproveOrganizationIdentityVerification200ResponseIdentificationInner
 */
export interface ApproveOrganizationIdentityVerification200ResponseIdentificationInner {
    /**
     * 
     * @type {string}
     * @memberof ApproveOrganizationIdentityVerification200ResponseIdentificationInner
     */
    'trustdockIdentificationId': string;
    /**
     * 
     * @type {string}
     * @memberof ApproveOrganizationIdentityVerification200ResponseIdentificationInner
     */
    'state': string;
    /**
     * 
     * @type {string}
     * @memberof ApproveOrganizationIdentityVerification200ResponseIdentificationInner
     */
    'result': string | null;
    /**
     * 
     * @type {Array<ApproveOrganizationIdentityVerification200ResponseIdentificationInnerRecordsInner>}
     * @memberof ApproveOrganizationIdentityVerification200ResponseIdentificationInner
     */
    'records'?: Array<ApproveOrganizationIdentityVerification200ResponseIdentificationInnerRecordsInner> | null;
}
/**
 * 
 * @export
 * @interface ApproveOrganizationIdentityVerification200ResponseIdentificationInnerRecordsInner
 */
export interface ApproveOrganizationIdentityVerification200ResponseIdentificationInnerRecordsInner {
    /**
     * 
     * @type {string}
     * @memberof ApproveOrganizationIdentityVerification200ResponseIdentificationInnerRecordsInner
     */
    'state': string;
    /**
     * 
     * @type {string}
     * @memberof ApproveOrganizationIdentityVerification200ResponseIdentificationInnerRecordsInner
     */
    'result': string | null;
    /**
     * 
     * @type {string}
     * @memberof ApproveOrganizationIdentityVerification200ResponseIdentificationInnerRecordsInner
     */
    'planId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApproveOrganizationIdentityVerification200ResponseIdentificationInnerRecordsInner
     */
    'plan'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ApproveOrganizationIdentityVerification200ResponseIdentificationInnerRecordsInner
     */
    'reasons'?: Array<string>;
}
/**
 * 
 * @export
 * @interface ApproveOrganizationIdentityVerification200ResponseSnailMailVerificationInner
 */
export interface ApproveOrganizationIdentityVerification200ResponseSnailMailVerificationInner {
    /**
     * 
     * @type {string}
     * @memberof ApproveOrganizationIdentityVerification200ResponseSnailMailVerificationInner
     */
    'organizationIdentityVerificationId': string;
    /**
     * 
     * @type {string}
     * @memberof ApproveOrganizationIdentityVerification200ResponseSnailMailVerificationInner
     */
    'snailMailVerificationId': string;
    /**
     * 
     * @type {string}
     * @memberof ApproveOrganizationIdentityVerification200ResponseSnailMailVerificationInner
     */
    'result': string;
    /**
     * 
     * @type {string}
     * @memberof ApproveOrganizationIdentityVerification200ResponseSnailMailVerificationInner
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof ApproveOrganizationIdentityVerification200ResponseSnailMailVerificationInner
     */
    'detail': string;
    /**
     * 
     * @type {string}
     * @memberof ApproveOrganizationIdentityVerification200ResponseSnailMailVerificationInner
     */
    'inquiryNumber': string;
    /**
     * 
     * @type {string}
     * @memberof ApproveOrganizationIdentityVerification200ResponseSnailMailVerificationInner
     */
    'acceptAt': string;
    /**
     * 
     * @type {string}
     * @memberof ApproveOrganizationIdentityVerification200ResponseSnailMailVerificationInner
     */
    'confirmedAt': string;
    /**
     * 
     * @type {string}
     * @memberof ApproveOrganizationIdentityVerification200ResponseSnailMailVerificationInner
     */
    'confirmedBy': string | null;
}
/**
 * 
 * @export
 * @interface ApproveOrganizationIdentityVerification200ResponseStatus
 */
export interface ApproveOrganizationIdentityVerification200ResponseStatus {
    /**
     * 
     * @type {string}
     * @memberof ApproveOrganizationIdentityVerification200ResponseStatus
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ApproveOrganizationIdentityVerification200ResponseStatus
     */
    'statusChangedUserId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApproveOrganizationIdentityVerification200ResponseStatus
     */
    'statusChangedUserName': string;
    /**
     * 
     * @type {string}
     * @memberof ApproveOrganizationIdentityVerification200ResponseStatus
     */
    'statusChangedAt': string;
}
/**
 * 
 * @export
 * @interface ApprovePurchaseApplicationRequest
 */
export interface ApprovePurchaseApplicationRequest {
    /**
     * 
     * @type {string}
     * @memberof ApprovePurchaseApplicationRequest
     */
    'comment': string;
}
/**
 * 
 * @export
 * @interface ApproveWorkflowStepPaymentRequestsRequest
 */
export interface ApproveWorkflowStepPaymentRequestsRequest {
    /**
     * 
     * @type {string}
     * @memberof ApproveWorkflowStepPaymentRequestsRequest
     */
    'workflowStepInstanceId': string;
    /**
     * 
     * @type {string}
     * @memberof ApproveWorkflowStepPaymentRequestsRequest
     */
    'comment': string | null;
    /**
     * 
     * @type {string}
     * @memberof ApproveWorkflowStepPaymentRequestsRequest
     */
    'id': string;
    /**
     * 
     * @type {ApproveWorkflowStepPaymentRequestsRequestSupplier}
     * @memberof ApproveWorkflowStepPaymentRequestsRequest
     */
    'supplier': ApproveWorkflowStepPaymentRequestsRequestSupplier;
    /**
     * 
     * @type {string}
     * @memberof ApproveWorkflowStepPaymentRequestsRequest
     */
    'dueDate': string;
    /**
     * 
     * @type {number}
     * @memberof ApproveWorkflowStepPaymentRequestsRequest
     */
    'totalAmount': number;
    /**
     * 
     * @type {string}
     * @memberof ApproveWorkflowStepPaymentRequestsRequest
     */
    'transferFeeResponsibility': ApproveWorkflowStepPaymentRequestsRequestTransferFeeResponsibilityEnum;
    /**
     * 
     * @type {string}
     * @memberof ApproveWorkflowStepPaymentRequestsRequest
     */
    'memo': string | null;
    /**
     * 
     * @type {string}
     * @memberof ApproveWorkflowStepPaymentRequestsRequest
     */
    'withholdingCalculatingMethod': ApproveWorkflowStepPaymentRequestsRequestWithholdingCalculatingMethodEnum;
    /**
     * 
     * @type {number}
     * @memberof ApproveWorkflowStepPaymentRequestsRequest
     */
    'withholdingAmount': number | null;
}

export const ApproveWorkflowStepPaymentRequestsRequestTransferFeeResponsibilityEnum = {
    self: 'SELF',
    supplier: 'SUPPLIER'
} as const;

export type ApproveWorkflowStepPaymentRequestsRequestTransferFeeResponsibilityEnum = typeof ApproveWorkflowStepPaymentRequestsRequestTransferFeeResponsibilityEnum[keyof typeof ApproveWorkflowStepPaymentRequestsRequestTransferFeeResponsibilityEnum];
export const ApproveWorkflowStepPaymentRequestsRequestWithholdingCalculatingMethodEnum = {
    none: 'NONE',
    manuscriptOrLecture: 'MANUSCRIPT_OR_LECTURE',
    lawyerOrCpa: 'LAWYER_OR_CPA',
    judicialScrivener: 'JUDICIAL_SCRIVENER',
    other: 'OTHER'
} as const;

export type ApproveWorkflowStepPaymentRequestsRequestWithholdingCalculatingMethodEnum = typeof ApproveWorkflowStepPaymentRequestsRequestWithholdingCalculatingMethodEnum[keyof typeof ApproveWorkflowStepPaymentRequestsRequestWithholdingCalculatingMethodEnum];

/**
 * 
 * @export
 * @interface ApproveWorkflowStepPaymentRequestsRequestSupplier
 */
export interface ApproveWorkflowStepPaymentRequestsRequestSupplier {
    /**
     * 
     * @type {string}
     * @memberof ApproveWorkflowStepPaymentRequestsRequestSupplier
     */
    'partnerId': string | null;
    /**
     * 
     * @type {string}
     * @memberof ApproveWorkflowStepPaymentRequestsRequestSupplier
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ApproveWorkflowStepPaymentRequestsRequestSupplier
     */
    'bankName': string;
    /**
     * 
     * @type {string}
     * @memberof ApproveWorkflowStepPaymentRequestsRequestSupplier
     */
    'branchName': string;
    /**
     * 
     * @type {string}
     * @memberof ApproveWorkflowStepPaymentRequestsRequestSupplier
     */
    'accountNumber': string;
    /**
     * 
     * @type {string}
     * @memberof ApproveWorkflowStepPaymentRequestsRequestSupplier
     */
    'accountType': ApproveWorkflowStepPaymentRequestsRequestSupplierAccountTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ApproveWorkflowStepPaymentRequestsRequestSupplier
     */
    'companyName': string;
}

export const ApproveWorkflowStepPaymentRequestsRequestSupplierAccountTypeEnum = {
    savingsAccount: 'SAVINGS_ACCOUNT',
    currentAccount: 'CURRENT_ACCOUNT',
    thriftAccount: 'THRIFT_ACCOUNT',
    other: 'OTHER'
} as const;

export type ApproveWorkflowStepPaymentRequestsRequestSupplierAccountTypeEnum = typeof ApproveWorkflowStepPaymentRequestsRequestSupplierAccountTypeEnum[keyof typeof ApproveWorkflowStepPaymentRequestsRequestSupplierAccountTypeEnum];

/**
 * 
 * @export
 * @interface Authentication
 */
export interface Authentication {
    /**
     * 
     * @type {string}
     * @memberof Authentication
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Authentication
     */
    'userName': string;
    /**
     * 
     * @type {string}
     * @memberof Authentication
     */
    'email': string;
    /**
     * 
     * @type {AuthenticationOrganization}
     * @memberof Authentication
     */
    'organization': AuthenticationOrganization;
    /**
     * 
     * @type {string}
     * @memberof Authentication
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof Authentication
     */
    'organizationName': string;
    /**
     * 
     * @type {Array<AuthenticationContractsInner>}
     * @memberof Authentication
     */
    'contracts': Array<AuthenticationContractsInner>;
    /**
     * 
     * @type {boolean}
     * @memberof Authentication
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Authentication
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Authentication
     */
    'isSystemAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Authentication
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Authentication
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Authentication
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof Authentication
     */
    'roles': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof Authentication
     */
    'twoFactorAuthRegisterStatus': string;
    /**
     * 
     * @type {string}
     * @memberof Authentication
     */
    'smsPhoneNumber': string;
    /**
     * 
     * @type {boolean}
     * @memberof Authentication
     */
    'hasCardContract': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Authentication
     */
    'hasPayContract': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Authentication
     */
    'isJournalFeatureEnabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof Authentication
     */
    'freeeCompanyId': string | null;
    /**
     * 
     * @type {string}
     * @memberof Authentication
     */
    'token': string;
}
/**
 * 
 * @export
 * @interface AuthenticationContractsInner
 */
export interface AuthenticationContractsInner {
    /**
     * 
     * @type {number}
     * @memberof AuthenticationContractsInner
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof AuthenticationContractsInner
     */
    'organizationId': number;
    /**
     * 
     * @type {string}
     * @memberof AuthenticationContractsInner
     */
    'contractType': string;
    /**
     * 
     * @type {string}
     * @memberof AuthenticationContractsInner
     */
    'startAt': string;
    /**
     * 
     * @type {string}
     * @memberof AuthenticationContractsInner
     */
    'endAt': string;
}
/**
 * 
 * @export
 * @interface AuthenticationOrganization
 */
export interface AuthenticationOrganization {
    /**
     * 
     * @type {string}
     * @memberof AuthenticationOrganization
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AuthenticationOrganization
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AuthenticationOrganization
     */
    'representativeName': string;
    /**
     * 
     * @type {string}
     * @memberof AuthenticationOrganization
     */
    'phoneNumber': string;
    /**
     * 
     * @type {string}
     * @memberof AuthenticationOrganization
     */
    'postalCode': string;
    /**
     * 
     * @type {string}
     * @memberof AuthenticationOrganization
     */
    'address': string;
    /**
     * 
     * @type {string}
     * @memberof AuthenticationOrganization
     */
    'deliveryPostalCode': string;
    /**
     * 
     * @type {string}
     * @memberof AuthenticationOrganization
     */
    'deliveryAddress': string;
    /**
     * 
     * @type {string}
     * @memberof AuthenticationOrganization
     */
    'invoiceEmail': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AuthenticationOrganization
     */
    'isApprovalFeatureEnabled': boolean;
}
/**
 * 
 * @export
 * @interface AutomaticallyJournalizeDealsFromRulesRequest
 */
export interface AutomaticallyJournalizeDealsFromRulesRequest {
    /**
     * 
     * @type {string}
     * @memberof AutomaticallyJournalizeDealsFromRulesRequest
     */
    'yearMonth': string;
}
/**
 * 
 * @export
 * @interface BankAccountActivitiesWithdrawalReserve200Response
 */
export interface BankAccountActivitiesWithdrawalReserve200Response {
    /**
     * 
     * @type {string}
     * @memberof BankAccountActivitiesWithdrawalReserve200Response
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof BankAccountActivitiesWithdrawalReserve200Response
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof BankAccountActivitiesWithdrawalReserve200Response
     */
    'organizationName': string;
    /**
     * 
     * @type {string}
     * @memberof BankAccountActivitiesWithdrawalReserve200Response
     */
    'type': BankAccountActivitiesWithdrawalReserve200ResponseTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof BankAccountActivitiesWithdrawalReserve200Response
     */
    'status': BankAccountActivitiesWithdrawalReserve200ResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof BankAccountActivitiesWithdrawalReserve200Response
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof BankAccountActivitiesWithdrawalReserve200Response
     */
    'supplierName': string;
    /**
     * 
     * @type {number}
     * @memberof BankAccountActivitiesWithdrawalReserve200Response
     */
    'amount': number;
    /**
     * 
     * @type {number}
     * @memberof BankAccountActivitiesWithdrawalReserve200Response
     */
    'pointAmount': number | null;
    /**
     * 
     * @type {number}
     * @memberof BankAccountActivitiesWithdrawalReserve200Response
     */
    'balance': number | null;
    /**
     * 
     * @type {number}
     * @memberof BankAccountActivitiesWithdrawalReserve200Response
     */
    'pointBalance': number | null;
    /**
     * 
     * @type {boolean}
     * @memberof BankAccountActivitiesWithdrawalReserve200Response
     */
    'isConfirmed': boolean;
    /**
     * 
     * @type {string}
     * @memberof BankAccountActivitiesWithdrawalReserve200Response
     */
    'appliedAt': string | null;
    /**
     * 
     * @type {BankAccountActivitiesWithdrawalReserve200ResponseAppliedBy}
     * @memberof BankAccountActivitiesWithdrawalReserve200Response
     */
    'appliedBy': BankAccountActivitiesWithdrawalReserve200ResponseAppliedBy;
    /**
     * 
     * @type {string}
     * @memberof BankAccountActivitiesWithdrawalReserve200Response
     */
    'executedAt': string | null;
}

export const BankAccountActivitiesWithdrawalReserve200ResponseTypeEnum = {
    payBill: 'PAY_BILL',
    deposit: 'DEPOSIT',
    withdrawal: 'WITHDRAWAL',
    reward: 'REWARD',
    usageFee: 'USAGE_FEE',
    point: 'POINT',
    cardPoint: 'CARD_POINT',
    campaignPoint: 'CAMPAIGN_POINT',
    card: 'CARD',
    depositFromGuaranteeMoney: 'DEPOSIT_FROM_GUARANTEE_MONEY',
    withdrawalToGuaranteeMoney: 'WITHDRAWAL_TO_GUARANTEE_MONEY'
} as const;

export type BankAccountActivitiesWithdrawalReserve200ResponseTypeEnum = typeof BankAccountActivitiesWithdrawalReserve200ResponseTypeEnum[keyof typeof BankAccountActivitiesWithdrawalReserve200ResponseTypeEnum];
export const BankAccountActivitiesWithdrawalReserve200ResponseStatusEnum = {
    reserved: 'RESERVED',
    requestingExternalAccountTransfer: 'REQUESTING_EXTERNAL_ACCOUNT_TRANSFER',
    completed: 'COMPLETED',
    insufficientBalance: 'INSUFFICIENT_BALANCE',
    uploaded: 'UPLOADED',
    readCompleted: 'READ_COMPLETED',
    awaitingApproval: 'AWAITING_APPROVAL',
    approved: 'APPROVED',
    transferCompleted: 'TRANSFER_COMPLETED',
    readError: 'READ_ERROR',
    transferFailed: 'TRANSFER_FAILED',
    approvalExpired: 'APPROVAL_EXPIRED',
    approvalRejected: 'APPROVAL_REJECTED',
    otherError: 'OTHER_ERROR',
    pending: 'PENDING'
} as const;

export type BankAccountActivitiesWithdrawalReserve200ResponseStatusEnum = typeof BankAccountActivitiesWithdrawalReserve200ResponseStatusEnum[keyof typeof BankAccountActivitiesWithdrawalReserve200ResponseStatusEnum];

/**
 * 
 * @export
 * @interface BankAccountActivitiesWithdrawalReserve200ResponseAppliedBy
 */
export interface BankAccountActivitiesWithdrawalReserve200ResponseAppliedBy {
    /**
     * 
     * @type {string}
     * @memberof BankAccountActivitiesWithdrawalReserve200ResponseAppliedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof BankAccountActivitiesWithdrawalReserve200ResponseAppliedBy
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof BankAccountActivitiesWithdrawalReserve200ResponseAppliedBy
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof BankAccountActivitiesWithdrawalReserve200ResponseAppliedBy
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof BankAccountActivitiesWithdrawalReserve200ResponseAppliedBy
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof BankAccountActivitiesWithdrawalReserve200ResponseAppliedBy
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BankAccountActivitiesWithdrawalReserve200ResponseAppliedBy
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BankAccountActivitiesWithdrawalReserve200ResponseAppliedBy
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BankAccountActivitiesWithdrawalReserve200ResponseAppliedBy
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BankAccountActivitiesWithdrawalReserve200ResponseAppliedBy
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof BankAccountActivitiesWithdrawalReserve200ResponseAppliedBy
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface BankAccountActivitiesWithdrawalReserveRequest
 */
export interface BankAccountActivitiesWithdrawalReserveRequest {
    /**
     * 
     * @type {number}
     * @memberof BankAccountActivitiesWithdrawalReserveRequest
     */
    'amount': number;
    /**
     * 
     * @type {string}
     * @memberof BankAccountActivitiesWithdrawalReserveRequest
     */
    'organizationId': string;
}
/**
 * 
 * @export
 * @interface BankAccountActivity
 */
export interface BankAccountActivity {
    /**
     * 
     * @type {string}
     * @memberof BankAccountActivity
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof BankAccountActivity
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof BankAccountActivity
     */
    'organizationName': string;
    /**
     * 
     * @type {string}
     * @memberof BankAccountActivity
     */
    'type': BankAccountActivityTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof BankAccountActivity
     */
    'status': BankAccountActivityStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof BankAccountActivity
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof BankAccountActivity
     */
    'supplierName': string;
    /**
     * 
     * @type {number}
     * @memberof BankAccountActivity
     */
    'amount': number;
    /**
     * 
     * @type {number}
     * @memberof BankAccountActivity
     */
    'pointAmount': number | null;
    /**
     * 
     * @type {number}
     * @memberof BankAccountActivity
     */
    'balance': number | null;
    /**
     * 
     * @type {number}
     * @memberof BankAccountActivity
     */
    'pointBalance': number | null;
    /**
     * 
     * @type {boolean}
     * @memberof BankAccountActivity
     */
    'isConfirmed': boolean;
    /**
     * 
     * @type {string}
     * @memberof BankAccountActivity
     */
    'appliedAt': string | null;
    /**
     * 
     * @type {BankAccountActivityAppliedBy}
     * @memberof BankAccountActivity
     */
    'appliedBy': BankAccountActivityAppliedBy;
    /**
     * 
     * @type {string}
     * @memberof BankAccountActivity
     */
    'executedAt': string | null;
}

export const BankAccountActivityTypeEnum = {
    payBill: 'PAY_BILL',
    deposit: 'DEPOSIT',
    withdrawal: 'WITHDRAWAL',
    reward: 'REWARD',
    usageFee: 'USAGE_FEE',
    point: 'POINT',
    cardPoint: 'CARD_POINT',
    campaignPoint: 'CAMPAIGN_POINT',
    card: 'CARD',
    depositFromGuaranteeMoney: 'DEPOSIT_FROM_GUARANTEE_MONEY',
    withdrawalToGuaranteeMoney: 'WITHDRAWAL_TO_GUARANTEE_MONEY'
} as const;

export type BankAccountActivityTypeEnum = typeof BankAccountActivityTypeEnum[keyof typeof BankAccountActivityTypeEnum];
export const BankAccountActivityStatusEnum = {
    reserved: 'RESERVED',
    requestingExternalAccountTransfer: 'REQUESTING_EXTERNAL_ACCOUNT_TRANSFER',
    completed: 'COMPLETED',
    insufficientBalance: 'INSUFFICIENT_BALANCE',
    uploaded: 'UPLOADED',
    readCompleted: 'READ_COMPLETED',
    awaitingApproval: 'AWAITING_APPROVAL',
    approved: 'APPROVED',
    transferCompleted: 'TRANSFER_COMPLETED',
    readError: 'READ_ERROR',
    transferFailed: 'TRANSFER_FAILED',
    approvalExpired: 'APPROVAL_EXPIRED',
    approvalRejected: 'APPROVAL_REJECTED',
    otherError: 'OTHER_ERROR',
    pending: 'PENDING'
} as const;

export type BankAccountActivityStatusEnum = typeof BankAccountActivityStatusEnum[keyof typeof BankAccountActivityStatusEnum];

/**
 * 
 * @export
 * @interface BankAccountActivityAppliedBy
 */
export interface BankAccountActivityAppliedBy {
    /**
     * 
     * @type {string}
     * @memberof BankAccountActivityAppliedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof BankAccountActivityAppliedBy
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof BankAccountActivityAppliedBy
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof BankAccountActivityAppliedBy
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof BankAccountActivityAppliedBy
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof BankAccountActivityAppliedBy
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BankAccountActivityAppliedBy
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BankAccountActivityAppliedBy
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BankAccountActivityAppliedBy
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BankAccountActivityAppliedBy
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof BankAccountActivityAppliedBy
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const BankAccountType = {
    savingsAccount: 'SAVINGS_ACCOUNT',
    currentAccount: 'CURRENT_ACCOUNT',
    depositAccount: 'DEPOSIT_ACCOUNT',
    otherAccount: 'OTHER_ACCOUNT'
} as const;

export type BankAccountType = typeof BankAccountType[keyof typeof BankAccountType];


/**
 * 
 * @export
 * @interface Bill
 */
export interface Bill {
    /**
     * 
     * @type {string}
     * @memberof Bill
     */
    'billId': string;
    /**
     * 
     * @type {BillOrganization}
     * @memberof Bill
     */
    'organization': BillOrganization;
    /**
     * 
     * @type {string}
     * @memberof Bill
     */
    'fileName': string;
    /**
     * 
     * @type {string}
     * @memberof Bill
     */
    'fileExtension': string;
    /**
     * 
     * @type {Array<BillStatusHistoryInner>}
     * @memberof Bill
     */
    'statusHistory': Array<BillStatusHistoryInner>;
    /**
     * 
     * @type {BillDetail}
     * @memberof Bill
     */
    'detail': BillDetail | null;
    /**
     * 
     * @type {BillLatestStatus}
     * @memberof Bill
     */
    'latestStatus': BillLatestStatus;
    /**
     * 
     * @type {string}
     * @memberof Bill
     */
    'uploadedAt': string;
    /**
     * 
     * @type {BillUploadedBy}
     * @memberof Bill
     */
    'uploadedBy': BillUploadedBy;
    /**
     * 
     * @type {boolean}
     * @memberof Bill
     */
    'isCancelable': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Bill
     */
    'isReadyToTransfer': boolean;
    /**
     * 
     * @type {string}
     * @memberof Bill
     */
    'bankAccountActivityId': string | null;
    /**
     * 
     * @type {string}
     * @memberof Bill
     */
    'approvedAt': string | null;
    /**
     * 
     * @type {BillApprovedBy}
     * @memberof Bill
     */
    'approvedBy': BillApprovedBy | null;
}
/**
 * 
 * @export
 * @interface BillApprovedBy
 */
export interface BillApprovedBy {
    /**
     * 
     * @type {string}
     * @memberof BillApprovedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof BillApprovedBy
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof BillApprovedBy
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof BillApprovedBy
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof BillApprovedBy
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof BillApprovedBy
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BillApprovedBy
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BillApprovedBy
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BillApprovedBy
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BillApprovedBy
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof BillApprovedBy
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface BillDetail
 */
export interface BillDetail {
    /**
     * 
     * @type {number}
     * @memberof BillDetail
     */
    'amount': number;
    /**
     * 
     * @type {string}
     * @memberof BillDetail
     */
    'scheduledTransferDate': string | null;
    /**
     * 
     * @type {string}
     * @memberof BillDetail
     */
    'paymentDate': string | null;
    /**
     * 
     * @type {string}
     * @memberof BillDetail
     */
    'ediInfo': string | null;
    /**
     * 
     * @type {string}
     * @memberof BillDetail
     */
    'note': string | null;
    /**
     * 
     * @type {BillDetailPayee1}
     * @memberof BillDetail
     */
    'payee': BillDetailPayee1 | null;
}
/**
 * 
 * @export
 * @interface BillDetailPayee
 */
export interface BillDetailPayee {
    /**
     * 
     * @type {string}
     * @memberof BillDetailPayee
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof BillDetailPayee
     */
    'bankCode': string | null;
    /**
     * 
     * @type {string}
     * @memberof BillDetailPayee
     */
    'bankName': string | null;
    /**
     * 
     * @type {string}
     * @memberof BillDetailPayee
     */
    'branchCode': string | null;
    /**
     * 
     * @type {string}
     * @memberof BillDetailPayee
     */
    'branchName': string | null;
    /**
     * 
     * @type {string}
     * @memberof BillDetailPayee
     */
    'accountType': BillDetailPayeeAccountTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof BillDetailPayee
     */
    'accountNumber': string;
    /**
     * 
     * @type {string}
     * @memberof BillDetailPayee
     */
    'accountHolder': string;
    /**
     * 
     * @type {boolean}
     * @memberof BillDetailPayee
     */
    'isSaved': boolean;
}

export const BillDetailPayeeAccountTypeEnum = {
    savingsAccount: 'SAVINGS_ACCOUNT',
    currentAccount: 'CURRENT_ACCOUNT',
    depositAccount: 'DEPOSIT_ACCOUNT',
    otherAccount: 'OTHER_ACCOUNT'
} as const;

export type BillDetailPayeeAccountTypeEnum = typeof BillDetailPayeeAccountTypeEnum[keyof typeof BillDetailPayeeAccountTypeEnum];

/**
 * 
 * @export
 * @interface BillDetailPayee1
 */
export interface BillDetailPayee1 {
    /**
     * 
     * @type {string}
     * @memberof BillDetailPayee1
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof BillDetailPayee1
     */
    'bankCode': string | null;
    /**
     * 
     * @type {string}
     * @memberof BillDetailPayee1
     */
    'bankName': string | null;
    /**
     * 
     * @type {string}
     * @memberof BillDetailPayee1
     */
    'branchCode': string | null;
    /**
     * 
     * @type {string}
     * @memberof BillDetailPayee1
     */
    'branchName': string | null;
    /**
     * 
     * @type {string}
     * @memberof BillDetailPayee1
     */
    'accountType': BillDetailPayee1AccountTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof BillDetailPayee1
     */
    'accountNumber': string;
    /**
     * 
     * @type {string}
     * @memberof BillDetailPayee1
     */
    'accountHolder': string;
    /**
     * 
     * @type {boolean}
     * @memberof BillDetailPayee1
     */
    'isSaved': boolean;
}

export const BillDetailPayee1AccountTypeEnum = {
    savingsAccount: 'SAVINGS_ACCOUNT',
    currentAccount: 'CURRENT_ACCOUNT',
    depositAccount: 'DEPOSIT_ACCOUNT',
    otherAccount: 'OTHER_ACCOUNT'
} as const;

export type BillDetailPayee1AccountTypeEnum = typeof BillDetailPayee1AccountTypeEnum[keyof typeof BillDetailPayee1AccountTypeEnum];

/**
 * 
 * @export
 * @interface BillForUsageFee
 */
export interface BillForUsageFee {
    /**
     * 
     * @type {string}
     * @memberof BillForUsageFee
     */
    'billId': string;
    /**
     * 
     * @type {string}
     * @memberof BillForUsageFee
     */
    'bankAccountActivityId': string;
    /**
     * 
     * @type {string}
     * @memberof BillForUsageFee
     */
    'supplierName': string;
    /**
     * 
     * @type {string}
     * @memberof BillForUsageFee
     */
    'latestStatus': BillForUsageFeeLatestStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof BillForUsageFee
     */
    'amount': number;
    /**
     * 
     * @type {string}
     * @memberof BillForUsageFee
     */
    'appliedAt': string;
    /**
     * 
     * @type {string}
     * @memberof BillForUsageFee
     */
    'transferDate': string;
}

export const BillForUsageFeeLatestStatusEnum = {
    reserved: 'RESERVED',
    requestingExternalAccountTransfer: 'REQUESTING_EXTERNAL_ACCOUNT_TRANSFER',
    completed: 'COMPLETED',
    insufficientBalance: 'INSUFFICIENT_BALANCE',
    uploaded: 'UPLOADED',
    readCompleted: 'READ_COMPLETED',
    awaitingApproval: 'AWAITING_APPROVAL',
    approved: 'APPROVED',
    transferCompleted: 'TRANSFER_COMPLETED',
    readError: 'READ_ERROR',
    transferFailed: 'TRANSFER_FAILED',
    approvalExpired: 'APPROVAL_EXPIRED',
    approvalRejected: 'APPROVAL_REJECTED',
    otherError: 'OTHER_ERROR',
    pending: 'PENDING'
} as const;

export type BillForUsageFeeLatestStatusEnum = typeof BillForUsageFeeLatestStatusEnum[keyof typeof BillForUsageFeeLatestStatusEnum];

/**
 * 
 * @export
 * @interface BillLatestStatus
 */
export interface BillLatestStatus {
    /**
     * 
     * @type {string}
     * @memberof BillLatestStatus
     */
    'status'?: BillLatestStatusStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof BillLatestStatus
     */
    'comment'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BillLatestStatus
     */
    'statusChangedAt'?: string;
    /**
     * 
     * @type {BillLatestStatusStatusChangedBy}
     * @memberof BillLatestStatus
     */
    'statusChangedBy'?: BillLatestStatusStatusChangedBy;
}

export const BillLatestStatusStatusEnum = {
    reserved: 'RESERVED',
    requestingExternalAccountTransfer: 'REQUESTING_EXTERNAL_ACCOUNT_TRANSFER',
    completed: 'COMPLETED',
    insufficientBalance: 'INSUFFICIENT_BALANCE',
    uploaded: 'UPLOADED',
    readCompleted: 'READ_COMPLETED',
    awaitingApproval: 'AWAITING_APPROVAL',
    approved: 'APPROVED',
    transferCompleted: 'TRANSFER_COMPLETED',
    readError: 'READ_ERROR',
    transferFailed: 'TRANSFER_FAILED',
    approvalExpired: 'APPROVAL_EXPIRED',
    approvalRejected: 'APPROVAL_REJECTED',
    otherError: 'OTHER_ERROR',
    pending: 'PENDING'
} as const;

export type BillLatestStatusStatusEnum = typeof BillLatestStatusStatusEnum[keyof typeof BillLatestStatusStatusEnum];

/**
 * 
 * @export
 * @interface BillLatestStatusStatusChangedBy
 */
export interface BillLatestStatusStatusChangedBy {
    /**
     * 
     * @type {string}
     * @memberof BillLatestStatusStatusChangedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof BillLatestStatusStatusChangedBy
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof BillLatestStatusStatusChangedBy
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof BillLatestStatusStatusChangedBy
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof BillLatestStatusStatusChangedBy
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof BillLatestStatusStatusChangedBy
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BillLatestStatusStatusChangedBy
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BillLatestStatusStatusChangedBy
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BillLatestStatusStatusChangedBy
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BillLatestStatusStatusChangedBy
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof BillLatestStatusStatusChangedBy
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface BillOrganization
 */
export interface BillOrganization {
    /**
     * 
     * @type {string}
     * @memberof BillOrganization
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof BillOrganization
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof BillOrganization
     */
    'representativeName': string;
    /**
     * 
     * @type {string}
     * @memberof BillOrganization
     */
    'phoneNumber': string;
    /**
     * 
     * @type {string}
     * @memberof BillOrganization
     */
    'postalCode': string;
    /**
     * 
     * @type {string}
     * @memberof BillOrganization
     */
    'address': string;
    /**
     * 
     * @type {string}
     * @memberof BillOrganization
     */
    'deliveryPostalCode': string;
    /**
     * 
     * @type {string}
     * @memberof BillOrganization
     */
    'deliveryAddress': string;
    /**
     * 
     * @type {string}
     * @memberof BillOrganization
     */
    'invoiceEmail': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof BillOrganization
     */
    'isApprovalFeatureEnabled': boolean;
}
/**
 * 
 * @export
 * @interface BillPayee
 */
export interface BillPayee {
    /**
     * 
     * @type {string}
     * @memberof BillPayee
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof BillPayee
     */
    'bankCode': string | null;
    /**
     * 
     * @type {string}
     * @memberof BillPayee
     */
    'bankName': string | null;
    /**
     * 
     * @type {string}
     * @memberof BillPayee
     */
    'branchCode': string | null;
    /**
     * 
     * @type {string}
     * @memberof BillPayee
     */
    'branchName': string | null;
    /**
     * 
     * @type {string}
     * @memberof BillPayee
     */
    'accountType': BillPayeeAccountTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof BillPayee
     */
    'accountNumber': string;
    /**
     * 
     * @type {string}
     * @memberof BillPayee
     */
    'accountHolder': string;
    /**
     * 
     * @type {boolean}
     * @memberof BillPayee
     */
    'isSaved': boolean;
}

export const BillPayeeAccountTypeEnum = {
    savingsAccount: 'SAVINGS_ACCOUNT',
    currentAccount: 'CURRENT_ACCOUNT',
    depositAccount: 'DEPOSIT_ACCOUNT',
    otherAccount: 'OTHER_ACCOUNT'
} as const;

export type BillPayeeAccountTypeEnum = typeof BillPayeeAccountTypeEnum[keyof typeof BillPayeeAccountTypeEnum];

/**
 * 
 * @export
 * @interface BillStatus
 */
export interface BillStatus {
    /**
     * 
     * @type {string}
     * @memberof BillStatus
     */
    'status'?: BillStatusStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof BillStatus
     */
    'comment'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BillStatus
     */
    'statusChangedAt'?: string;
    /**
     * 
     * @type {BillStatusStatusChangedBy}
     * @memberof BillStatus
     */
    'statusChangedBy'?: BillStatusStatusChangedBy;
}

export const BillStatusStatusEnum = {
    reserved: 'RESERVED',
    requestingExternalAccountTransfer: 'REQUESTING_EXTERNAL_ACCOUNT_TRANSFER',
    completed: 'COMPLETED',
    insufficientBalance: 'INSUFFICIENT_BALANCE',
    uploaded: 'UPLOADED',
    readCompleted: 'READ_COMPLETED',
    awaitingApproval: 'AWAITING_APPROVAL',
    approved: 'APPROVED',
    transferCompleted: 'TRANSFER_COMPLETED',
    readError: 'READ_ERROR',
    transferFailed: 'TRANSFER_FAILED',
    approvalExpired: 'APPROVAL_EXPIRED',
    approvalRejected: 'APPROVAL_REJECTED',
    otherError: 'OTHER_ERROR',
    pending: 'PENDING'
} as const;

export type BillStatusStatusEnum = typeof BillStatusStatusEnum[keyof typeof BillStatusStatusEnum];

/**
 * 
 * @export
 * @interface BillStatusHistoryInner
 */
export interface BillStatusHistoryInner {
    /**
     * 
     * @type {string}
     * @memberof BillStatusHistoryInner
     */
    'status'?: BillStatusHistoryInnerStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof BillStatusHistoryInner
     */
    'comment'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BillStatusHistoryInner
     */
    'statusChangedAt'?: string;
    /**
     * 
     * @type {BillStatusHistoryInnerStatusChangedBy}
     * @memberof BillStatusHistoryInner
     */
    'statusChangedBy'?: BillStatusHistoryInnerStatusChangedBy;
}

export const BillStatusHistoryInnerStatusEnum = {
    reserved: 'RESERVED',
    requestingExternalAccountTransfer: 'REQUESTING_EXTERNAL_ACCOUNT_TRANSFER',
    completed: 'COMPLETED',
    insufficientBalance: 'INSUFFICIENT_BALANCE',
    uploaded: 'UPLOADED',
    readCompleted: 'READ_COMPLETED',
    awaitingApproval: 'AWAITING_APPROVAL',
    approved: 'APPROVED',
    transferCompleted: 'TRANSFER_COMPLETED',
    readError: 'READ_ERROR',
    transferFailed: 'TRANSFER_FAILED',
    approvalExpired: 'APPROVAL_EXPIRED',
    approvalRejected: 'APPROVAL_REJECTED',
    otherError: 'OTHER_ERROR',
    pending: 'PENDING'
} as const;

export type BillStatusHistoryInnerStatusEnum = typeof BillStatusHistoryInnerStatusEnum[keyof typeof BillStatusHistoryInnerStatusEnum];

/**
 * 
 * @export
 * @interface BillStatusHistoryInnerStatusChangedBy
 */
export interface BillStatusHistoryInnerStatusChangedBy {
    /**
     * 
     * @type {string}
     * @memberof BillStatusHistoryInnerStatusChangedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof BillStatusHistoryInnerStatusChangedBy
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof BillStatusHistoryInnerStatusChangedBy
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof BillStatusHistoryInnerStatusChangedBy
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof BillStatusHistoryInnerStatusChangedBy
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof BillStatusHistoryInnerStatusChangedBy
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BillStatusHistoryInnerStatusChangedBy
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BillStatusHistoryInnerStatusChangedBy
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BillStatusHistoryInnerStatusChangedBy
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BillStatusHistoryInnerStatusChangedBy
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof BillStatusHistoryInnerStatusChangedBy
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface BillStatusStatusChangedBy
 */
export interface BillStatusStatusChangedBy {
    /**
     * 
     * @type {string}
     * @memberof BillStatusStatusChangedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof BillStatusStatusChangedBy
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof BillStatusStatusChangedBy
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof BillStatusStatusChangedBy
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof BillStatusStatusChangedBy
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof BillStatusStatusChangedBy
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BillStatusStatusChangedBy
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BillStatusStatusChangedBy
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BillStatusStatusChangedBy
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BillStatusStatusChangedBy
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof BillStatusStatusChangedBy
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface BillUploadedBy
 */
export interface BillUploadedBy {
    /**
     * 
     * @type {string}
     * @memberof BillUploadedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof BillUploadedBy
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof BillUploadedBy
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof BillUploadedBy
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof BillUploadedBy
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof BillUploadedBy
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BillUploadedBy
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BillUploadedBy
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BillUploadedBy
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BillUploadedBy
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof BillUploadedBy
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface BillingAdminOrganization
 */
export interface BillingAdminOrganization {
    /**
     * 
     * @type {boolean}
     * @memberof BillingAdminOrganization
     */
    'sameAsApplicant': boolean;
    /**
     * 
     * @type {string}
     * @memberof BillingAdminOrganization
     */
    'name': string | null;
    /**
     * 
     * @type {string}
     * @memberof BillingAdminOrganization
     */
    'address': string | null;
}
/**
 * 
 * @export
 * @interface BillingAdminPerson
 */
export interface BillingAdminPerson {
    /**
     * 
     * @type {string}
     * @memberof BillingAdminPerson
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof BillingAdminPerson
     */
    'tel': string;
    /**
     * 
     * @type {string}
     * @memberof BillingAdminPerson
     */
    'email': string;
}
/**
 * 
 * @export
 * @interface BulkDisableDailyUserUsageLimit200ResponseInner
 */
export interface BulkDisableDailyUserUsageLimit200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof BulkDisableDailyUserUsageLimit200ResponseInner
     */
    'cardId': string;
    /**
     * 
     * @type {string}
     * @memberof BulkDisableDailyUserUsageLimit200ResponseInner
     */
    'cardLabel': string;
    /**
     * 
     * @type {boolean}
     * @memberof BulkDisableDailyUserUsageLimit200ResponseInner
     */
    'isActivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BulkDisableDailyUserUsageLimit200ResponseInner
     */
    'isDeactivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BulkDisableDailyUserUsageLimit200ResponseInner
     */
    'isLocked': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BulkDisableDailyUserUsageLimit200ResponseInner
     */
    'isSuspended': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BulkDisableDailyUserUsageLimit200ResponseInner
     */
    'isFrozen': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BulkDisableDailyUserUsageLimit200ResponseInner
     */
    'isVirtualCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BulkDisableDailyUserUsageLimit200ResponseInner
     */
    'isCreditCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BulkDisableDailyUserUsageLimit200ResponseInner
     */
    'isOnDemand': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BulkDisableDailyUserUsageLimit200ResponseInner
     */
    'isMetalCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BulkDisableDailyUserUsageLimit200ResponseInner
     */
    'isPhysicalStorePaymentDisabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof BulkDisableDailyUserUsageLimit200ResponseInner
     */
    'panLastFourDigits': string;
    /**
     * 
     * @type {string}
     * @memberof BulkDisableDailyUserUsageLimit200ResponseInner
     */
    'userAccountId': string;
    /**
     * 
     * @type {number}
     * @memberof BulkDisableDailyUserUsageLimit200ResponseInner
     */
    'transactionUpperLimit': number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof BulkDisableDailyUserUsageLimit200ResponseInner
     */
    'availableCurrencies': Array<BulkDisableDailyUserUsageLimit200ResponseInnerAvailableCurrenciesEnum>;
    /**
     * 
     * @type {Array<BulkDisableDailyUserUsageLimit200ResponseInnerAvailableMerchantCategoriesInner>}
     * @memberof BulkDisableDailyUserUsageLimit200ResponseInner
     */
    'availableMerchantCategories': Array<BulkDisableDailyUserUsageLimit200ResponseInnerAvailableMerchantCategoriesInner> | null;
    /**
     * 
     * @type {BulkDisableDailyUserUsageLimit200ResponseInnerUser}
     * @memberof BulkDisableDailyUserUsageLimit200ResponseInner
     */
    'user': BulkDisableDailyUserUsageLimit200ResponseInnerUser;
    /**
     * 
     * @type {BulkDisableDailyUserUsageLimit200ResponseInnerUserAccountGroup}
     * @memberof BulkDisableDailyUserUsageLimit200ResponseInner
     */
    'userAccountGroup'?: BulkDisableDailyUserUsageLimit200ResponseInnerUserAccountGroup | null;
    /**
     * 
     * @type {number}
     * @memberof BulkDisableDailyUserUsageLimit200ResponseInner
     */
    'monthlyTotalUsage': number;
    /**
     * 
     * @type {number}
     * @memberof BulkDisableDailyUserUsageLimit200ResponseInner
     */
    'monthlyUsageLimit': number | null;
    /**
     * 
     * @type {number}
     * @memberof BulkDisableDailyUserUsageLimit200ResponseInner
     */
    'dailyTotalUsage': number;
    /**
     * 
     * @type {number}
     * @memberof BulkDisableDailyUserUsageLimit200ResponseInner
     */
    'dailyUsageLimit': number | null;
    /**
     * 
     * @type {number}
     * @memberof BulkDisableDailyUserUsageLimit200ResponseInner
     */
    'totalUsageAmount': number;
    /**
     * 
     * @type {number}
     * @memberof BulkDisableDailyUserUsageLimit200ResponseInner
     */
    'totalUsageAmountLimit': number | null;
    /**
     * 
     * @type {string}
     * @memberof BulkDisableDailyUserUsageLimit200ResponseInner
     */
    'expiredDate': string | null;
}

export const BulkDisableDailyUserUsageLimit200ResponseInnerAvailableCurrenciesEnum = {
    jpy: 'JPY',
    usd: 'USD',
    gbp: 'GBP',
    eur: 'EUR',
    sgd: 'SGD',
    aud: 'AUD',
    cny: 'CNY',
    hkd: 'HKD',
    idr: 'IDR',
    krw: 'KRW',
    nzd: 'NZD',
    php: 'PHP',
    rub: 'RUB',
    vnd: 'VND',
    inr: 'INR',
    thb: 'THB',
    lak: 'LAK',
    myr: 'MYR',
    twd: 'TWD',
    chf: 'CHF',
    cad: 'CAD',
    mxn: 'MXN',
    nok: 'NOK',
    huf: 'HUF',
    hrk: 'HRK',
    czk: 'CZK',
    dkk: 'DKK',
    isk: 'ISK',
    mdl: 'MDL',
    sek: 'SEK',
    mkd: 'MKD',
    rsd: 'RSD',
    ron: 'RON',
    bgn: 'BGN',
    bam: 'BAM',
    pln: 'PLN',
    mad: 'MAD',
    zar: 'ZAR',
    rwf: 'RWF',
    kes: 'KES',
    ngn: 'NGN',
    aed: 'AED',
    sar: 'SAR',
    egp: 'EGP',
    qar: 'QAR',
    omr: 'OMR',
    ils: 'ILS',
    try: 'TRY',
    kzt: 'KZT',
    cop: 'COP',
    gtq: 'GTQ'
} as const;

export type BulkDisableDailyUserUsageLimit200ResponseInnerAvailableCurrenciesEnum = typeof BulkDisableDailyUserUsageLimit200ResponseInnerAvailableCurrenciesEnum[keyof typeof BulkDisableDailyUserUsageLimit200ResponseInnerAvailableCurrenciesEnum];

/**
 * 
 * @export
 * @interface BulkDisableDailyUserUsageLimit200ResponseInnerAvailableMerchantCategoriesInner
 */
export interface BulkDisableDailyUserUsageLimit200ResponseInnerAvailableMerchantCategoriesInner {
    /**
     * 
     * @type {string}
     * @memberof BulkDisableDailyUserUsageLimit200ResponseInnerAvailableMerchantCategoriesInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof BulkDisableDailyUserUsageLimit200ResponseInnerAvailableMerchantCategoriesInner
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof BulkDisableDailyUserUsageLimit200ResponseInnerAvailableMerchantCategoriesInner
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof BulkDisableDailyUserUsageLimit200ResponseInnerAvailableMerchantCategoriesInner
     */
    'logoUrl': string;
}
/**
 * 
 * @export
 * @interface BulkDisableDailyUserUsageLimit200ResponseInnerUser
 */
export interface BulkDisableDailyUserUsageLimit200ResponseInnerUser {
    /**
     * 
     * @type {string}
     * @memberof BulkDisableDailyUserUsageLimit200ResponseInnerUser
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof BulkDisableDailyUserUsageLimit200ResponseInnerUser
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof BulkDisableDailyUserUsageLimit200ResponseInnerUser
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof BulkDisableDailyUserUsageLimit200ResponseInnerUser
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof BulkDisableDailyUserUsageLimit200ResponseInnerUser
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof BulkDisableDailyUserUsageLimit200ResponseInnerUser
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BulkDisableDailyUserUsageLimit200ResponseInnerUser
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BulkDisableDailyUserUsageLimit200ResponseInnerUser
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BulkDisableDailyUserUsageLimit200ResponseInnerUser
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BulkDisableDailyUserUsageLimit200ResponseInnerUser
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof BulkDisableDailyUserUsageLimit200ResponseInnerUser
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface BulkDisableDailyUserUsageLimit200ResponseInnerUserAccountGroup
 */
export interface BulkDisableDailyUserUsageLimit200ResponseInnerUserAccountGroup {
    /**
     * 
     * @type {string}
     * @memberof BulkDisableDailyUserUsageLimit200ResponseInnerUserAccountGroup
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof BulkDisableDailyUserUsageLimit200ResponseInnerUserAccountGroup
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof BulkDisableDailyUserUsageLimit200ResponseInnerUserAccountGroup
     */
    'sortNum': number;
}
/**
 * 
 * @export
 * @interface BulkDisableDailyUserUsageLimitRequest
 */
export interface BulkDisableDailyUserUsageLimitRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof BulkDisableDailyUserUsageLimitRequest
     */
    'userAccountIdList': Array<string>;
}
/**
 * 
 * @export
 * @interface BulkDisableMonthlyUsageLimit200ResponseInner
 */
export interface BulkDisableMonthlyUsageLimit200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof BulkDisableMonthlyUsageLimit200ResponseInner
     */
    'cardId': string;
    /**
     * 
     * @type {string}
     * @memberof BulkDisableMonthlyUsageLimit200ResponseInner
     */
    'cardLabel': string;
    /**
     * 
     * @type {boolean}
     * @memberof BulkDisableMonthlyUsageLimit200ResponseInner
     */
    'isActivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BulkDisableMonthlyUsageLimit200ResponseInner
     */
    'isDeactivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BulkDisableMonthlyUsageLimit200ResponseInner
     */
    'isLocked': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BulkDisableMonthlyUsageLimit200ResponseInner
     */
    'isSuspended': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BulkDisableMonthlyUsageLimit200ResponseInner
     */
    'isFrozen': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BulkDisableMonthlyUsageLimit200ResponseInner
     */
    'isVirtualCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BulkDisableMonthlyUsageLimit200ResponseInner
     */
    'isCreditCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BulkDisableMonthlyUsageLimit200ResponseInner
     */
    'isOnDemand': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BulkDisableMonthlyUsageLimit200ResponseInner
     */
    'isMetalCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BulkDisableMonthlyUsageLimit200ResponseInner
     */
    'isPhysicalStorePaymentDisabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof BulkDisableMonthlyUsageLimit200ResponseInner
     */
    'panLastFourDigits': string;
    /**
     * 
     * @type {string}
     * @memberof BulkDisableMonthlyUsageLimit200ResponseInner
     */
    'userAccountId': string;
    /**
     * 
     * @type {number}
     * @memberof BulkDisableMonthlyUsageLimit200ResponseInner
     */
    'transactionUpperLimit': number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof BulkDisableMonthlyUsageLimit200ResponseInner
     */
    'availableCurrencies': Array<BulkDisableMonthlyUsageLimit200ResponseInnerAvailableCurrenciesEnum>;
    /**
     * 
     * @type {Array<BulkDisableMonthlyUsageLimit200ResponseInnerAvailableMerchantCategoriesInner>}
     * @memberof BulkDisableMonthlyUsageLimit200ResponseInner
     */
    'availableMerchantCategories': Array<BulkDisableMonthlyUsageLimit200ResponseInnerAvailableMerchantCategoriesInner> | null;
    /**
     * 
     * @type {BulkDisableMonthlyUsageLimit200ResponseInnerUser}
     * @memberof BulkDisableMonthlyUsageLimit200ResponseInner
     */
    'user': BulkDisableMonthlyUsageLimit200ResponseInnerUser;
    /**
     * 
     * @type {BulkDisableMonthlyUsageLimit200ResponseInnerUserAccountGroup}
     * @memberof BulkDisableMonthlyUsageLimit200ResponseInner
     */
    'userAccountGroup'?: BulkDisableMonthlyUsageLimit200ResponseInnerUserAccountGroup | null;
    /**
     * 
     * @type {number}
     * @memberof BulkDisableMonthlyUsageLimit200ResponseInner
     */
    'monthlyTotalUsage': number;
    /**
     * 
     * @type {number}
     * @memberof BulkDisableMonthlyUsageLimit200ResponseInner
     */
    'monthlyUsageLimit': number | null;
    /**
     * 
     * @type {number}
     * @memberof BulkDisableMonthlyUsageLimit200ResponseInner
     */
    'dailyTotalUsage': number;
    /**
     * 
     * @type {number}
     * @memberof BulkDisableMonthlyUsageLimit200ResponseInner
     */
    'dailyUsageLimit': number | null;
    /**
     * 
     * @type {number}
     * @memberof BulkDisableMonthlyUsageLimit200ResponseInner
     */
    'totalUsageAmount': number;
    /**
     * 
     * @type {number}
     * @memberof BulkDisableMonthlyUsageLimit200ResponseInner
     */
    'totalUsageAmountLimit': number | null;
    /**
     * 
     * @type {string}
     * @memberof BulkDisableMonthlyUsageLimit200ResponseInner
     */
    'expiredDate': string | null;
}

export const BulkDisableMonthlyUsageLimit200ResponseInnerAvailableCurrenciesEnum = {
    jpy: 'JPY',
    usd: 'USD',
    gbp: 'GBP',
    eur: 'EUR',
    sgd: 'SGD',
    aud: 'AUD',
    cny: 'CNY',
    hkd: 'HKD',
    idr: 'IDR',
    krw: 'KRW',
    nzd: 'NZD',
    php: 'PHP',
    rub: 'RUB',
    vnd: 'VND',
    inr: 'INR',
    thb: 'THB',
    lak: 'LAK',
    myr: 'MYR',
    twd: 'TWD',
    chf: 'CHF',
    cad: 'CAD',
    mxn: 'MXN',
    nok: 'NOK',
    huf: 'HUF',
    hrk: 'HRK',
    czk: 'CZK',
    dkk: 'DKK',
    isk: 'ISK',
    mdl: 'MDL',
    sek: 'SEK',
    mkd: 'MKD',
    rsd: 'RSD',
    ron: 'RON',
    bgn: 'BGN',
    bam: 'BAM',
    pln: 'PLN',
    mad: 'MAD',
    zar: 'ZAR',
    rwf: 'RWF',
    kes: 'KES',
    ngn: 'NGN',
    aed: 'AED',
    sar: 'SAR',
    egp: 'EGP',
    qar: 'QAR',
    omr: 'OMR',
    ils: 'ILS',
    try: 'TRY',
    kzt: 'KZT',
    cop: 'COP',
    gtq: 'GTQ'
} as const;

export type BulkDisableMonthlyUsageLimit200ResponseInnerAvailableCurrenciesEnum = typeof BulkDisableMonthlyUsageLimit200ResponseInnerAvailableCurrenciesEnum[keyof typeof BulkDisableMonthlyUsageLimit200ResponseInnerAvailableCurrenciesEnum];

/**
 * 
 * @export
 * @interface BulkDisableMonthlyUsageLimit200ResponseInnerAvailableMerchantCategoriesInner
 */
export interface BulkDisableMonthlyUsageLimit200ResponseInnerAvailableMerchantCategoriesInner {
    /**
     * 
     * @type {string}
     * @memberof BulkDisableMonthlyUsageLimit200ResponseInnerAvailableMerchantCategoriesInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof BulkDisableMonthlyUsageLimit200ResponseInnerAvailableMerchantCategoriesInner
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof BulkDisableMonthlyUsageLimit200ResponseInnerAvailableMerchantCategoriesInner
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof BulkDisableMonthlyUsageLimit200ResponseInnerAvailableMerchantCategoriesInner
     */
    'logoUrl': string;
}
/**
 * 
 * @export
 * @interface BulkDisableMonthlyUsageLimit200ResponseInnerUser
 */
export interface BulkDisableMonthlyUsageLimit200ResponseInnerUser {
    /**
     * 
     * @type {string}
     * @memberof BulkDisableMonthlyUsageLimit200ResponseInnerUser
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof BulkDisableMonthlyUsageLimit200ResponseInnerUser
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof BulkDisableMonthlyUsageLimit200ResponseInnerUser
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof BulkDisableMonthlyUsageLimit200ResponseInnerUser
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof BulkDisableMonthlyUsageLimit200ResponseInnerUser
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof BulkDisableMonthlyUsageLimit200ResponseInnerUser
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BulkDisableMonthlyUsageLimit200ResponseInnerUser
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BulkDisableMonthlyUsageLimit200ResponseInnerUser
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BulkDisableMonthlyUsageLimit200ResponseInnerUser
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BulkDisableMonthlyUsageLimit200ResponseInnerUser
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof BulkDisableMonthlyUsageLimit200ResponseInnerUser
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface BulkDisableMonthlyUsageLimit200ResponseInnerUserAccountGroup
 */
export interface BulkDisableMonthlyUsageLimit200ResponseInnerUserAccountGroup {
    /**
     * 
     * @type {string}
     * @memberof BulkDisableMonthlyUsageLimit200ResponseInnerUserAccountGroup
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof BulkDisableMonthlyUsageLimit200ResponseInnerUserAccountGroup
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof BulkDisableMonthlyUsageLimit200ResponseInnerUserAccountGroup
     */
    'sortNum': number;
}
/**
 * 
 * @export
 * @interface BulkDisableMonthlyUsageLimitRequest
 */
export interface BulkDisableMonthlyUsageLimitRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof BulkDisableMonthlyUsageLimitRequest
     */
    'userAccountIdList': Array<string>;
}
/**
 * 
 * @export
 * @interface BulkUpdateDailyUsageLimit200ResponseInner
 */
export interface BulkUpdateDailyUsageLimit200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof BulkUpdateDailyUsageLimit200ResponseInner
     */
    'cardId': string;
    /**
     * 
     * @type {string}
     * @memberof BulkUpdateDailyUsageLimit200ResponseInner
     */
    'cardLabel': string;
    /**
     * 
     * @type {boolean}
     * @memberof BulkUpdateDailyUsageLimit200ResponseInner
     */
    'isActivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BulkUpdateDailyUsageLimit200ResponseInner
     */
    'isDeactivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BulkUpdateDailyUsageLimit200ResponseInner
     */
    'isLocked': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BulkUpdateDailyUsageLimit200ResponseInner
     */
    'isSuspended': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BulkUpdateDailyUsageLimit200ResponseInner
     */
    'isFrozen': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BulkUpdateDailyUsageLimit200ResponseInner
     */
    'isVirtualCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BulkUpdateDailyUsageLimit200ResponseInner
     */
    'isCreditCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BulkUpdateDailyUsageLimit200ResponseInner
     */
    'isOnDemand': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BulkUpdateDailyUsageLimit200ResponseInner
     */
    'isMetalCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BulkUpdateDailyUsageLimit200ResponseInner
     */
    'isPhysicalStorePaymentDisabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof BulkUpdateDailyUsageLimit200ResponseInner
     */
    'panLastFourDigits': string;
    /**
     * 
     * @type {string}
     * @memberof BulkUpdateDailyUsageLimit200ResponseInner
     */
    'userAccountId': string;
    /**
     * 
     * @type {number}
     * @memberof BulkUpdateDailyUsageLimit200ResponseInner
     */
    'transactionUpperLimit': number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof BulkUpdateDailyUsageLimit200ResponseInner
     */
    'availableCurrencies': Array<BulkUpdateDailyUsageLimit200ResponseInnerAvailableCurrenciesEnum>;
    /**
     * 
     * @type {Array<BulkUpdateDailyUsageLimit200ResponseInnerAvailableMerchantCategoriesInner>}
     * @memberof BulkUpdateDailyUsageLimit200ResponseInner
     */
    'availableMerchantCategories': Array<BulkUpdateDailyUsageLimit200ResponseInnerAvailableMerchantCategoriesInner> | null;
    /**
     * 
     * @type {BulkUpdateDailyUsageLimit200ResponseInnerUser}
     * @memberof BulkUpdateDailyUsageLimit200ResponseInner
     */
    'user': BulkUpdateDailyUsageLimit200ResponseInnerUser;
    /**
     * 
     * @type {BulkUpdateDailyUsageLimit200ResponseInnerUserAccountGroup}
     * @memberof BulkUpdateDailyUsageLimit200ResponseInner
     */
    'userAccountGroup'?: BulkUpdateDailyUsageLimit200ResponseInnerUserAccountGroup | null;
    /**
     * 
     * @type {number}
     * @memberof BulkUpdateDailyUsageLimit200ResponseInner
     */
    'monthlyTotalUsage': number;
    /**
     * 
     * @type {number}
     * @memberof BulkUpdateDailyUsageLimit200ResponseInner
     */
    'monthlyUsageLimit': number | null;
    /**
     * 
     * @type {number}
     * @memberof BulkUpdateDailyUsageLimit200ResponseInner
     */
    'dailyTotalUsage': number;
    /**
     * 
     * @type {number}
     * @memberof BulkUpdateDailyUsageLimit200ResponseInner
     */
    'dailyUsageLimit': number | null;
    /**
     * 
     * @type {number}
     * @memberof BulkUpdateDailyUsageLimit200ResponseInner
     */
    'totalUsageAmount': number;
    /**
     * 
     * @type {number}
     * @memberof BulkUpdateDailyUsageLimit200ResponseInner
     */
    'totalUsageAmountLimit': number | null;
    /**
     * 
     * @type {string}
     * @memberof BulkUpdateDailyUsageLimit200ResponseInner
     */
    'expiredDate': string | null;
}

export const BulkUpdateDailyUsageLimit200ResponseInnerAvailableCurrenciesEnum = {
    jpy: 'JPY',
    usd: 'USD',
    gbp: 'GBP',
    eur: 'EUR',
    sgd: 'SGD',
    aud: 'AUD',
    cny: 'CNY',
    hkd: 'HKD',
    idr: 'IDR',
    krw: 'KRW',
    nzd: 'NZD',
    php: 'PHP',
    rub: 'RUB',
    vnd: 'VND',
    inr: 'INR',
    thb: 'THB',
    lak: 'LAK',
    myr: 'MYR',
    twd: 'TWD',
    chf: 'CHF',
    cad: 'CAD',
    mxn: 'MXN',
    nok: 'NOK',
    huf: 'HUF',
    hrk: 'HRK',
    czk: 'CZK',
    dkk: 'DKK',
    isk: 'ISK',
    mdl: 'MDL',
    sek: 'SEK',
    mkd: 'MKD',
    rsd: 'RSD',
    ron: 'RON',
    bgn: 'BGN',
    bam: 'BAM',
    pln: 'PLN',
    mad: 'MAD',
    zar: 'ZAR',
    rwf: 'RWF',
    kes: 'KES',
    ngn: 'NGN',
    aed: 'AED',
    sar: 'SAR',
    egp: 'EGP',
    qar: 'QAR',
    omr: 'OMR',
    ils: 'ILS',
    try: 'TRY',
    kzt: 'KZT',
    cop: 'COP',
    gtq: 'GTQ'
} as const;

export type BulkUpdateDailyUsageLimit200ResponseInnerAvailableCurrenciesEnum = typeof BulkUpdateDailyUsageLimit200ResponseInnerAvailableCurrenciesEnum[keyof typeof BulkUpdateDailyUsageLimit200ResponseInnerAvailableCurrenciesEnum];

/**
 * 
 * @export
 * @interface BulkUpdateDailyUsageLimit200ResponseInnerAvailableMerchantCategoriesInner
 */
export interface BulkUpdateDailyUsageLimit200ResponseInnerAvailableMerchantCategoriesInner {
    /**
     * 
     * @type {string}
     * @memberof BulkUpdateDailyUsageLimit200ResponseInnerAvailableMerchantCategoriesInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof BulkUpdateDailyUsageLimit200ResponseInnerAvailableMerchantCategoriesInner
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof BulkUpdateDailyUsageLimit200ResponseInnerAvailableMerchantCategoriesInner
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof BulkUpdateDailyUsageLimit200ResponseInnerAvailableMerchantCategoriesInner
     */
    'logoUrl': string;
}
/**
 * 
 * @export
 * @interface BulkUpdateDailyUsageLimit200ResponseInnerUser
 */
export interface BulkUpdateDailyUsageLimit200ResponseInnerUser {
    /**
     * 
     * @type {string}
     * @memberof BulkUpdateDailyUsageLimit200ResponseInnerUser
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof BulkUpdateDailyUsageLimit200ResponseInnerUser
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof BulkUpdateDailyUsageLimit200ResponseInnerUser
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof BulkUpdateDailyUsageLimit200ResponseInnerUser
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof BulkUpdateDailyUsageLimit200ResponseInnerUser
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof BulkUpdateDailyUsageLimit200ResponseInnerUser
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BulkUpdateDailyUsageLimit200ResponseInnerUser
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BulkUpdateDailyUsageLimit200ResponseInnerUser
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BulkUpdateDailyUsageLimit200ResponseInnerUser
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BulkUpdateDailyUsageLimit200ResponseInnerUser
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof BulkUpdateDailyUsageLimit200ResponseInnerUser
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface BulkUpdateDailyUsageLimit200ResponseInnerUserAccountGroup
 */
export interface BulkUpdateDailyUsageLimit200ResponseInnerUserAccountGroup {
    /**
     * 
     * @type {string}
     * @memberof BulkUpdateDailyUsageLimit200ResponseInnerUserAccountGroup
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof BulkUpdateDailyUsageLimit200ResponseInnerUserAccountGroup
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof BulkUpdateDailyUsageLimit200ResponseInnerUserAccountGroup
     */
    'sortNum': number;
}
/**
 * 
 * @export
 * @interface BulkUpdateDailyUsageLimitRequest
 */
export interface BulkUpdateDailyUsageLimitRequest {
    /**
     * 
     * @type {number}
     * @memberof BulkUpdateDailyUsageLimitRequest
     */
    'newUsageLimit': number;
    /**
     * 
     * @type {Array<string>}
     * @memberof BulkUpdateDailyUsageLimitRequest
     */
    'userAccountIdList': Array<string>;
}
/**
 * 
 * @export
 * @interface BulkUpdateMonthlyUsageLimit200ResponseInner
 */
export interface BulkUpdateMonthlyUsageLimit200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof BulkUpdateMonthlyUsageLimit200ResponseInner
     */
    'cardId': string;
    /**
     * 
     * @type {string}
     * @memberof BulkUpdateMonthlyUsageLimit200ResponseInner
     */
    'cardLabel': string;
    /**
     * 
     * @type {boolean}
     * @memberof BulkUpdateMonthlyUsageLimit200ResponseInner
     */
    'isActivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BulkUpdateMonthlyUsageLimit200ResponseInner
     */
    'isDeactivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BulkUpdateMonthlyUsageLimit200ResponseInner
     */
    'isLocked': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BulkUpdateMonthlyUsageLimit200ResponseInner
     */
    'isSuspended': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BulkUpdateMonthlyUsageLimit200ResponseInner
     */
    'isFrozen': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BulkUpdateMonthlyUsageLimit200ResponseInner
     */
    'isVirtualCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BulkUpdateMonthlyUsageLimit200ResponseInner
     */
    'isCreditCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BulkUpdateMonthlyUsageLimit200ResponseInner
     */
    'isOnDemand': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BulkUpdateMonthlyUsageLimit200ResponseInner
     */
    'isMetalCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BulkUpdateMonthlyUsageLimit200ResponseInner
     */
    'isPhysicalStorePaymentDisabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof BulkUpdateMonthlyUsageLimit200ResponseInner
     */
    'panLastFourDigits': string;
    /**
     * 
     * @type {string}
     * @memberof BulkUpdateMonthlyUsageLimit200ResponseInner
     */
    'userAccountId': string;
    /**
     * 
     * @type {number}
     * @memberof BulkUpdateMonthlyUsageLimit200ResponseInner
     */
    'transactionUpperLimit': number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof BulkUpdateMonthlyUsageLimit200ResponseInner
     */
    'availableCurrencies': Array<BulkUpdateMonthlyUsageLimit200ResponseInnerAvailableCurrenciesEnum>;
    /**
     * 
     * @type {Array<BulkUpdateMonthlyUsageLimit200ResponseInnerAvailableMerchantCategoriesInner>}
     * @memberof BulkUpdateMonthlyUsageLimit200ResponseInner
     */
    'availableMerchantCategories': Array<BulkUpdateMonthlyUsageLimit200ResponseInnerAvailableMerchantCategoriesInner> | null;
    /**
     * 
     * @type {BulkUpdateMonthlyUsageLimit200ResponseInnerUser}
     * @memberof BulkUpdateMonthlyUsageLimit200ResponseInner
     */
    'user': BulkUpdateMonthlyUsageLimit200ResponseInnerUser;
    /**
     * 
     * @type {BulkUpdateMonthlyUsageLimit200ResponseInnerUserAccountGroup}
     * @memberof BulkUpdateMonthlyUsageLimit200ResponseInner
     */
    'userAccountGroup'?: BulkUpdateMonthlyUsageLimit200ResponseInnerUserAccountGroup | null;
    /**
     * 
     * @type {number}
     * @memberof BulkUpdateMonthlyUsageLimit200ResponseInner
     */
    'monthlyTotalUsage': number;
    /**
     * 
     * @type {number}
     * @memberof BulkUpdateMonthlyUsageLimit200ResponseInner
     */
    'monthlyUsageLimit': number | null;
    /**
     * 
     * @type {number}
     * @memberof BulkUpdateMonthlyUsageLimit200ResponseInner
     */
    'dailyTotalUsage': number;
    /**
     * 
     * @type {number}
     * @memberof BulkUpdateMonthlyUsageLimit200ResponseInner
     */
    'dailyUsageLimit': number | null;
    /**
     * 
     * @type {number}
     * @memberof BulkUpdateMonthlyUsageLimit200ResponseInner
     */
    'totalUsageAmount': number;
    /**
     * 
     * @type {number}
     * @memberof BulkUpdateMonthlyUsageLimit200ResponseInner
     */
    'totalUsageAmountLimit': number | null;
    /**
     * 
     * @type {string}
     * @memberof BulkUpdateMonthlyUsageLimit200ResponseInner
     */
    'expiredDate': string | null;
}

export const BulkUpdateMonthlyUsageLimit200ResponseInnerAvailableCurrenciesEnum = {
    jpy: 'JPY',
    usd: 'USD',
    gbp: 'GBP',
    eur: 'EUR',
    sgd: 'SGD',
    aud: 'AUD',
    cny: 'CNY',
    hkd: 'HKD',
    idr: 'IDR',
    krw: 'KRW',
    nzd: 'NZD',
    php: 'PHP',
    rub: 'RUB',
    vnd: 'VND',
    inr: 'INR',
    thb: 'THB',
    lak: 'LAK',
    myr: 'MYR',
    twd: 'TWD',
    chf: 'CHF',
    cad: 'CAD',
    mxn: 'MXN',
    nok: 'NOK',
    huf: 'HUF',
    hrk: 'HRK',
    czk: 'CZK',
    dkk: 'DKK',
    isk: 'ISK',
    mdl: 'MDL',
    sek: 'SEK',
    mkd: 'MKD',
    rsd: 'RSD',
    ron: 'RON',
    bgn: 'BGN',
    bam: 'BAM',
    pln: 'PLN',
    mad: 'MAD',
    zar: 'ZAR',
    rwf: 'RWF',
    kes: 'KES',
    ngn: 'NGN',
    aed: 'AED',
    sar: 'SAR',
    egp: 'EGP',
    qar: 'QAR',
    omr: 'OMR',
    ils: 'ILS',
    try: 'TRY',
    kzt: 'KZT',
    cop: 'COP',
    gtq: 'GTQ'
} as const;

export type BulkUpdateMonthlyUsageLimit200ResponseInnerAvailableCurrenciesEnum = typeof BulkUpdateMonthlyUsageLimit200ResponseInnerAvailableCurrenciesEnum[keyof typeof BulkUpdateMonthlyUsageLimit200ResponseInnerAvailableCurrenciesEnum];

/**
 * 
 * @export
 * @interface BulkUpdateMonthlyUsageLimit200ResponseInnerAvailableMerchantCategoriesInner
 */
export interface BulkUpdateMonthlyUsageLimit200ResponseInnerAvailableMerchantCategoriesInner {
    /**
     * 
     * @type {string}
     * @memberof BulkUpdateMonthlyUsageLimit200ResponseInnerAvailableMerchantCategoriesInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof BulkUpdateMonthlyUsageLimit200ResponseInnerAvailableMerchantCategoriesInner
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof BulkUpdateMonthlyUsageLimit200ResponseInnerAvailableMerchantCategoriesInner
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof BulkUpdateMonthlyUsageLimit200ResponseInnerAvailableMerchantCategoriesInner
     */
    'logoUrl': string;
}
/**
 * 
 * @export
 * @interface BulkUpdateMonthlyUsageLimit200ResponseInnerUser
 */
export interface BulkUpdateMonthlyUsageLimit200ResponseInnerUser {
    /**
     * 
     * @type {string}
     * @memberof BulkUpdateMonthlyUsageLimit200ResponseInnerUser
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof BulkUpdateMonthlyUsageLimit200ResponseInnerUser
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof BulkUpdateMonthlyUsageLimit200ResponseInnerUser
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof BulkUpdateMonthlyUsageLimit200ResponseInnerUser
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof BulkUpdateMonthlyUsageLimit200ResponseInnerUser
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof BulkUpdateMonthlyUsageLimit200ResponseInnerUser
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BulkUpdateMonthlyUsageLimit200ResponseInnerUser
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BulkUpdateMonthlyUsageLimit200ResponseInnerUser
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BulkUpdateMonthlyUsageLimit200ResponseInnerUser
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BulkUpdateMonthlyUsageLimit200ResponseInnerUser
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof BulkUpdateMonthlyUsageLimit200ResponseInnerUser
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface BulkUpdateMonthlyUsageLimit200ResponseInnerUserAccountGroup
 */
export interface BulkUpdateMonthlyUsageLimit200ResponseInnerUserAccountGroup {
    /**
     * 
     * @type {string}
     * @memberof BulkUpdateMonthlyUsageLimit200ResponseInnerUserAccountGroup
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof BulkUpdateMonthlyUsageLimit200ResponseInnerUserAccountGroup
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof BulkUpdateMonthlyUsageLimit200ResponseInnerUserAccountGroup
     */
    'sortNum': number;
}
/**
 * 
 * @export
 * @interface BulkUpdateMonthlyUsageLimitRequest
 */
export interface BulkUpdateMonthlyUsageLimitRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof BulkUpdateMonthlyUsageLimitRequest
     */
    'userAccountIdList': Array<string>;
}
/**
 * 
 * @export
 * @interface BulkUpdateOrganizationUserPrivilegesRequest
 */
export interface BulkUpdateOrganizationUserPrivilegesRequest {
    /**
     * 
     * @type {Array<BulkUpdateOrganizationUserPrivilegesRequestUsersInner>}
     * @memberof BulkUpdateOrganizationUserPrivilegesRequest
     */
    'users': Array<BulkUpdateOrganizationUserPrivilegesRequestUsersInner>;
}
/**
 * 
 * @export
 * @interface BulkUpdateOrganizationUserPrivilegesRequestUsersInner
 */
export interface BulkUpdateOrganizationUserPrivilegesRequestUsersInner {
    /**
     * 
     * @type {number}
     * @memberof BulkUpdateOrganizationUserPrivilegesRequestUsersInner
     */
    'userId': number;
    /**
     * 
     * @type {string}
     * @memberof BulkUpdateOrganizationUserPrivilegesRequestUsersInner
     */
    'userPrivilege': BulkUpdateOrganizationUserPrivilegesRequestUsersInnerUserPrivilegeEnum;
}

export const BulkUpdateOrganizationUserPrivilegesRequestUsersInnerUserPrivilegeEnum = {
    generalUser: 'GENERAL_USER',
    organizationAdmin: 'ORGANIZATION_ADMIN',
    viewer: 'VIEWER',
    bookkeeper: 'BOOKKEEPER'
} as const;

export type BulkUpdateOrganizationUserPrivilegesRequestUsersInnerUserPrivilegeEnum = typeof BulkUpdateOrganizationUserPrivilegesRequestUsersInnerUserPrivilegeEnum[keyof typeof BulkUpdateOrganizationUserPrivilegesRequestUsersInnerUserPrivilegeEnum];

/**
 * 
 * @export
 * @interface CardExtended
 */
export interface CardExtended {
    /**
     * 
     * @type {string}
     * @memberof CardExtended
     */
    'cardId': string;
    /**
     * 
     * @type {string}
     * @memberof CardExtended
     */
    'userAccountId': string;
    /**
     * 
     * @type {string}
     * @memberof CardExtended
     */
    'expiredDate': string | null;
    /**
     * 
     * @type {number}
     * @memberof CardExtended
     */
    'monthlyUsageLimit': number | null;
    /**
     * 
     * @type {number}
     * @memberof CardExtended
     */
    'monthlyUsageAmount': number;
    /**
     * 
     * @type {number}
     * @memberof CardExtended
     */
    'totalUsageLimit': number | null;
    /**
     * 
     * @type {number}
     * @memberof CardExtended
     */
    'totalUsageAmount': number;
}
/**
 * 
 * @export
 * @interface CardState
 */
export interface CardState {
    /**
     * 
     * @type {string}
     * @memberof CardState
     */
    'cardId': string;
    /**
     * 
     * @type {boolean}
     * @memberof CardState
     */
    'isActivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CardState
     */
    'isDeactivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CardState
     */
    'isLocked': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CardState
     */
    'isSuspended': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CardState
     */
    'isFrozen': boolean;
    /**
     * 
     * @type {string}
     * @memberof CardState
     */
    'panLastFourDigits': string;
    /**
     * 
     * @type {string}
     * @memberof CardState
     */
    'linkedUserAccountId': string;
    /**
     * 
     * @type {string}
     * @memberof CardState
     */
    'createdAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof CardState
     */
    'isActive': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CardState
     */
    'isVirtualCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CardState
     */
    'isCreditCard': boolean;
}
/**
 * 
 * @export
 * @interface CardTransactionComment
 */
export interface CardTransactionComment {
    /**
     * 
     * @type {string}
     * @memberof CardTransactionComment
     */
    'cardTransactionCommentId': string;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionComment
     */
    'visaTransactionReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionComment
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionComment
     */
    'comment': string;
    /**
     * 
     * @type {CardTransactionCommentCreatedBy}
     * @memberof CardTransactionComment
     */
    'createdBy': CardTransactionCommentCreatedBy;
}
/**
 * 
 * @export
 * @interface CardTransactionCommentCreatedBy
 */
export interface CardTransactionCommentCreatedBy {
    /**
     * 
     * @type {string}
     * @memberof CardTransactionCommentCreatedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionCommentCreatedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface CardTransactionEvidence
 */
export interface CardTransactionEvidence {
    /**
     * 
     * @type {string}
     * @memberof CardTransactionEvidence
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionEvidence
     * @deprecated
     */
    'cardTransactionEvidenceId': string;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionEvidence
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionEvidence
     * @deprecated
     */
    'visaTransactionReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionEvidence
     */
    'paymentType': CardTransactionEvidencePaymentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionEvidence
     */
    'fileName': string;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionEvidence
     */
    'fileExtension': string;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionEvidence
     */
    'electronicMethod': CardTransactionEvidenceElectronicMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionEvidence
     */
    'documentSize': CardTransactionEvidenceDocumentSizeEnum;
    /**
     * 
     * @type {number}
     * @memberof CardTransactionEvidence
     * @deprecated
     */
    'dpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof CardTransactionEvidence
     */
    'detectedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof CardTransactionEvidence
     */
    'calculatedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof CardTransactionEvidence
     */
    'colorGradation': number | null;
    /**
     * 
     * @type {number}
     * @memberof CardTransactionEvidence
     */
    'verticalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof CardTransactionEvidence
     */
    'horizontalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof CardTransactionEvidence
     */
    'heightMillis': number | null;
    /**
     * 
     * @type {number}
     * @memberof CardTransactionEvidence
     */
    'widthMillis': number | null;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionEvidence
     */
    'legalValidity': CardTransactionEvidenceLegalValidityEnum;
    /**
     * 
     * @type {boolean}
     * @memberof CardTransactionEvidence
     */
    'dpiForciblyValid': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CardTransactionEvidence
     */
    'colorGradationForciblyValid': boolean;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionEvidence
     */
    'note': string;
    /**
     * 
     * @type {boolean}
     * @memberof CardTransactionEvidence
     */
    'irrelevantToLedger': boolean;
    /**
     * 
     * @type {CardTransactionEvidenceInvoiceIssuer}
     * @memberof CardTransactionEvidence
     */
    'invoiceIssuer': CardTransactionEvidenceInvoiceIssuer | null;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionEvidence
     * @deprecated
     */
    'dpiError': CardTransactionEvidenceDpiErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionEvidence
     * @deprecated
     */
    'detectedDpiError': CardTransactionEvidenceDetectedDpiErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionEvidence
     * @deprecated
     */
    'calculatedDpiError': CardTransactionEvidenceCalculatedDpiErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionEvidence
     * @deprecated
     */
    'colorGradationError': CardTransactionEvidenceColorGradationErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionEvidence
     * @deprecated
     */
    'heightMillisError': CardTransactionEvidenceHeightMillisErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionEvidence
     * @deprecated
     */
    'widthMillisError': CardTransactionEvidenceWidthMillisErrorEnum;
    /**
     * 
     * @type {CardTransactionEvidenceErrors}
     * @memberof CardTransactionEvidence
     */
    'errors': CardTransactionEvidenceErrors;
    /**
     * 
     * @type {CardTransactionEvidenceWarnings}
     * @memberof CardTransactionEvidence
     */
    'warnings': CardTransactionEvidenceWarnings;
    /**
     * 
     * @type {CardTransactionEvidenceCreatedBy}
     * @memberof CardTransactionEvidence
     */
    'createdBy': CardTransactionEvidenceCreatedBy;
    /**
     * 
     * @type {CardTransactionEvidenceUpdatedBy}
     * @memberof CardTransactionEvidence
     */
    'updatedBy': CardTransactionEvidenceUpdatedBy;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionEvidence
     */
    'updatedAt': string;
    /**
     * 
     * @type {CardTransactionEvidenceUploadedBy}
     * @memberof CardTransactionEvidence
     */
    'uploadedBy': CardTransactionEvidenceUploadedBy;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionEvidence
     */
    'uploadedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof CardTransactionEvidence
     */
    'uploadedByRecipient': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CardTransactionEvidence
     */
    'needsMigration': boolean | null;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionEvidence
     */
    'uploadedFrom': string;
}

export const CardTransactionEvidencePaymentTypeEnum = {
    cardTransaction: 'CARD_TRANSACTION',
    paymentRequest: 'PAYMENT_REQUEST'
} as const;

export type CardTransactionEvidencePaymentTypeEnum = typeof CardTransactionEvidencePaymentTypeEnum[keyof typeof CardTransactionEvidencePaymentTypeEnum];
export const CardTransactionEvidenceElectronicMethodEnum = {
    fullElectronic: 'FULL_ELECTRONIC',
    originallyPaper: 'ORIGINALLY_PAPER',
    unknown: 'UNKNOWN'
} as const;

export type CardTransactionEvidenceElectronicMethodEnum = typeof CardTransactionEvidenceElectronicMethodEnum[keyof typeof CardTransactionEvidenceElectronicMethodEnum];
export const CardTransactionEvidenceDocumentSizeEnum = {
    overA4: 'OVER_A4',
    a4OrSmaller: 'A4_OR_SMALLER',
    unknown: 'UNKNOWN'
} as const;

export type CardTransactionEvidenceDocumentSizeEnum = typeof CardTransactionEvidenceDocumentSizeEnum[keyof typeof CardTransactionEvidenceDocumentSizeEnum];
export const CardTransactionEvidenceLegalValidityEnum = {
    valid: 'VALID',
    invalid: 'INVALID',
    inputRequired: 'INPUT_REQUIRED',
    outOfTarget: 'OUT_OF_TARGET'
} as const;

export type CardTransactionEvidenceLegalValidityEnum = typeof CardTransactionEvidenceLegalValidityEnum[keyof typeof CardTransactionEvidenceLegalValidityEnum];
export const CardTransactionEvidenceDpiErrorEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type CardTransactionEvidenceDpiErrorEnum = typeof CardTransactionEvidenceDpiErrorEnum[keyof typeof CardTransactionEvidenceDpiErrorEnum];
export const CardTransactionEvidenceDetectedDpiErrorEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type CardTransactionEvidenceDetectedDpiErrorEnum = typeof CardTransactionEvidenceDetectedDpiErrorEnum[keyof typeof CardTransactionEvidenceDetectedDpiErrorEnum];
export const CardTransactionEvidenceCalculatedDpiErrorEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type CardTransactionEvidenceCalculatedDpiErrorEnum = typeof CardTransactionEvidenceCalculatedDpiErrorEnum[keyof typeof CardTransactionEvidenceCalculatedDpiErrorEnum];
export const CardTransactionEvidenceColorGradationErrorEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type CardTransactionEvidenceColorGradationErrorEnum = typeof CardTransactionEvidenceColorGradationErrorEnum[keyof typeof CardTransactionEvidenceColorGradationErrorEnum];
export const CardTransactionEvidenceHeightMillisErrorEnum = {
    required: 'REQUIRED'
} as const;

export type CardTransactionEvidenceHeightMillisErrorEnum = typeof CardTransactionEvidenceHeightMillisErrorEnum[keyof typeof CardTransactionEvidenceHeightMillisErrorEnum];
export const CardTransactionEvidenceWidthMillisErrorEnum = {
    required: 'REQUIRED'
} as const;

export type CardTransactionEvidenceWidthMillisErrorEnum = typeof CardTransactionEvidenceWidthMillisErrorEnum[keyof typeof CardTransactionEvidenceWidthMillisErrorEnum];

/**
 * 
 * @export
 * @interface CardTransactionEvidenceCreatedBy
 */
export interface CardTransactionEvidenceCreatedBy {
    /**
     * 
     * @type {string}
     * @memberof CardTransactionEvidenceCreatedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionEvidenceCreatedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface CardTransactionEvidenceErrors
 */
export interface CardTransactionEvidenceErrors {
    /**
     * 
     * @type {string}
     * @memberof CardTransactionEvidenceErrors
     */
    'detectedDpi'?: CardTransactionEvidenceErrorsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionEvidenceErrors
     */
    'calculatedDpi'?: CardTransactionEvidenceErrorsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionEvidenceErrors
     */
    'colorGradation'?: CardTransactionEvidenceErrorsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionEvidenceErrors
     */
    'heightMillis'?: CardTransactionEvidenceErrorsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionEvidenceErrors
     */
    'widthMillis'?: CardTransactionEvidenceErrorsWidthMillisEnum;
}

export const CardTransactionEvidenceErrorsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type CardTransactionEvidenceErrorsDetectedDpiEnum = typeof CardTransactionEvidenceErrorsDetectedDpiEnum[keyof typeof CardTransactionEvidenceErrorsDetectedDpiEnum];
export const CardTransactionEvidenceErrorsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type CardTransactionEvidenceErrorsCalculatedDpiEnum = typeof CardTransactionEvidenceErrorsCalculatedDpiEnum[keyof typeof CardTransactionEvidenceErrorsCalculatedDpiEnum];
export const CardTransactionEvidenceErrorsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type CardTransactionEvidenceErrorsColorGradationEnum = typeof CardTransactionEvidenceErrorsColorGradationEnum[keyof typeof CardTransactionEvidenceErrorsColorGradationEnum];
export const CardTransactionEvidenceErrorsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type CardTransactionEvidenceErrorsHeightMillisEnum = typeof CardTransactionEvidenceErrorsHeightMillisEnum[keyof typeof CardTransactionEvidenceErrorsHeightMillisEnum];
export const CardTransactionEvidenceErrorsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type CardTransactionEvidenceErrorsWidthMillisEnum = typeof CardTransactionEvidenceErrorsWidthMillisEnum[keyof typeof CardTransactionEvidenceErrorsWidthMillisEnum];

/**
 * 
 * @export
 * @interface CardTransactionEvidenceInfo
 */
export interface CardTransactionEvidenceInfo {
    /**
     * 
     * @type {CardTransactionEvidenceInfoEvidenceStatus}
     * @memberof CardTransactionEvidenceInfo
     */
    'evidenceStatus': CardTransactionEvidenceInfoEvidenceStatus | null;
    /**
     * 
     * @type {CardTransactionEvidenceInfoEvidenceRemindStatus}
     * @memberof CardTransactionEvidenceInfo
     */
    'evidenceRemindStatus': CardTransactionEvidenceInfoEvidenceRemindStatus | null;
    /**
     * 
     * @type {Array<CardTransactionEvidenceInfoRequestHistoryInner>}
     * @memberof CardTransactionEvidenceInfo
     */
    'requestHistory': Array<CardTransactionEvidenceInfoRequestHistoryInner>;
}
/**
 * 
 * @export
 * @interface CardTransactionEvidenceInfoEvidenceRemindStatus
 */
export interface CardTransactionEvidenceInfoEvidenceRemindStatus {
    /**
     * 
     * @type {boolean}
     * @memberof CardTransactionEvidenceInfoEvidenceRemindStatus
     */
    'isAutoRemind': boolean;
}
/**
 * 
 * @export
 * @interface CardTransactionEvidenceInfoEvidenceStatus
 */
export interface CardTransactionEvidenceInfoEvidenceStatus {
    /**
     * 
     * @type {string}
     * @memberof CardTransactionEvidenceInfoEvidenceStatus
     */
    'visaTransactionReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionEvidenceInfoEvidenceStatus
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {boolean}
     * @memberof CardTransactionEvidenceInfoEvidenceStatus
     */
    'isRequested': boolean;
    /**
     * 
     * @type {CardTransactionEvidenceInfoEvidenceStatusRequestedBy}
     * @memberof CardTransactionEvidenceInfoEvidenceStatus
     */
    'requestedBy': CardTransactionEvidenceInfoEvidenceStatusRequestedBy | null;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionEvidenceInfoEvidenceStatus
     */
    'requestedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof CardTransactionEvidenceInfoEvidenceStatus
     */
    'isLocked': boolean;
    /**
     * 
     * @type {CardTransactionEvidenceInfoEvidenceStatusLockedBy}
     * @memberof CardTransactionEvidenceInfoEvidenceStatus
     */
    'lockedBy': CardTransactionEvidenceInfoEvidenceStatusLockedBy | null;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionEvidenceInfoEvidenceStatus
     */
    'lockedAt': string;
}
/**
 * 
 * @export
 * @interface CardTransactionEvidenceInfoEvidenceStatusLockedBy
 */
export interface CardTransactionEvidenceInfoEvidenceStatusLockedBy {
    /**
     * 
     * @type {string}
     * @memberof CardTransactionEvidenceInfoEvidenceStatusLockedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionEvidenceInfoEvidenceStatusLockedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface CardTransactionEvidenceInfoEvidenceStatusRequestedBy
 */
export interface CardTransactionEvidenceInfoEvidenceStatusRequestedBy {
    /**
     * 
     * @type {string}
     * @memberof CardTransactionEvidenceInfoEvidenceStatusRequestedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionEvidenceInfoEvidenceStatusRequestedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface CardTransactionEvidenceInfoRequestHistoryInner
 */
export interface CardTransactionEvidenceInfoRequestHistoryInner {
    /**
     * 
     * @type {number}
     * @memberof CardTransactionEvidenceInfoRequestHistoryInner
     */
    'requestId': number;
    /**
     * 
     * @type {CardTransactionEvidenceInfoRequestHistoryInnerRequestedBy}
     * @memberof CardTransactionEvidenceInfoRequestHistoryInner
     */
    'requestedBy': CardTransactionEvidenceInfoRequestHistoryInnerRequestedBy;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionEvidenceInfoRequestHistoryInner
     */
    'requestedAt': string;
}
/**
 * 
 * @export
 * @interface CardTransactionEvidenceInfoRequestHistoryInnerRequestedBy
 */
export interface CardTransactionEvidenceInfoRequestHistoryInnerRequestedBy {
    /**
     * 
     * @type {string}
     * @memberof CardTransactionEvidenceInfoRequestHistoryInnerRequestedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionEvidenceInfoRequestHistoryInnerRequestedBy
     */
    'name': string;
}
/**
 * Set null if it\'s evidence not analyzed using invoicing-system-compliance feature. Also set null if invoicing-system-compliance feature has been made not available for the organization by the feature-flag.
 * @export
 * @interface CardTransactionEvidenceInvoiceIssuer
 */
export interface CardTransactionEvidenceInvoiceIssuer {
    /**
     * 
     * @type {string}
     * @memberof CardTransactionEvidenceInvoiceIssuer
     */
    'name': string | null;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionEvidenceInvoiceIssuer
     */
    'registrationNumber': string | null;
    /**
     * isQualified retains the result of querying the 国税庁API to see if registrationNumber is qualified, as is.
     * @type {boolean}
     * @memberof CardTransactionEvidenceInvoiceIssuer
     */
    'isQualified': boolean;
    /**
     * AsQualified indicates whether this issuer should be treated as a qualified invoice issuer within the user\'s system, even if the RegistrationNumber is not confirmed as qualified in the National Tax Agency\'s business registration system.
     * @type {boolean}
     * @memberof CardTransactionEvidenceInvoiceIssuer
     */
    'asQualified': boolean;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionEvidenceInvoiceIssuer
     */
    'partnerId': string | null;
}
/**
 * 
 * @export
 * @interface CardTransactionEvidenceRequestHistory
 */
export interface CardTransactionEvidenceRequestHistory {
    /**
     * 
     * @type {number}
     * @memberof CardTransactionEvidenceRequestHistory
     */
    'requestId': number;
    /**
     * 
     * @type {CardTransactionEvidenceRequestHistoryRequestedBy}
     * @memberof CardTransactionEvidenceRequestHistory
     */
    'requestedBy': CardTransactionEvidenceRequestHistoryRequestedBy;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionEvidenceRequestHistory
     */
    'requestedAt': string;
}
/**
 * 
 * @export
 * @interface CardTransactionEvidenceRequestHistoryRequestedBy
 */
export interface CardTransactionEvidenceRequestHistoryRequestedBy {
    /**
     * 
     * @type {string}
     * @memberof CardTransactionEvidenceRequestHistoryRequestedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionEvidenceRequestHistoryRequestedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface CardTransactionEvidenceStatus
 */
export interface CardTransactionEvidenceStatus {
    /**
     * 
     * @type {string}
     * @memberof CardTransactionEvidenceStatus
     */
    'visaTransactionReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionEvidenceStatus
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {boolean}
     * @memberof CardTransactionEvidenceStatus
     */
    'isRequested': boolean;
    /**
     * 
     * @type {CardTransactionEvidenceStatusRequestedBy}
     * @memberof CardTransactionEvidenceStatus
     */
    'requestedBy': CardTransactionEvidenceStatusRequestedBy | null;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionEvidenceStatus
     */
    'requestedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof CardTransactionEvidenceStatus
     */
    'isLocked': boolean;
    /**
     * 
     * @type {CardTransactionEvidenceStatusLockedBy}
     * @memberof CardTransactionEvidenceStatus
     */
    'lockedBy': CardTransactionEvidenceStatusLockedBy | null;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionEvidenceStatus
     */
    'lockedAt': string;
}
/**
 * 
 * @export
 * @interface CardTransactionEvidenceStatusLockedBy
 */
export interface CardTransactionEvidenceStatusLockedBy {
    /**
     * 
     * @type {string}
     * @memberof CardTransactionEvidenceStatusLockedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionEvidenceStatusLockedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface CardTransactionEvidenceStatusRequestedBy
 */
export interface CardTransactionEvidenceStatusRequestedBy {
    /**
     * 
     * @type {string}
     * @memberof CardTransactionEvidenceStatusRequestedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionEvidenceStatusRequestedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface CardTransactionEvidenceUpdatedBy
 */
export interface CardTransactionEvidenceUpdatedBy {
    /**
     * 
     * @type {string}
     * @memberof CardTransactionEvidenceUpdatedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionEvidenceUpdatedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface CardTransactionEvidenceUploadedBy
 */
export interface CardTransactionEvidenceUploadedBy {
    /**
     * 
     * @type {string}
     * @memberof CardTransactionEvidenceUploadedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionEvidenceUploadedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface CardTransactionEvidenceWarnings
 */
export interface CardTransactionEvidenceWarnings {
    /**
     * 
     * @type {string}
     * @memberof CardTransactionEvidenceWarnings
     */
    'detectedDpi'?: CardTransactionEvidenceWarningsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionEvidenceWarnings
     */
    'calculatedDpi'?: CardTransactionEvidenceWarningsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionEvidenceWarnings
     */
    'colorGradation'?: CardTransactionEvidenceWarningsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionEvidenceWarnings
     */
    'heightMillis'?: CardTransactionEvidenceWarningsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionEvidenceWarnings
     */
    'widthMillis'?: CardTransactionEvidenceWarningsWidthMillisEnum;
}

export const CardTransactionEvidenceWarningsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type CardTransactionEvidenceWarningsDetectedDpiEnum = typeof CardTransactionEvidenceWarningsDetectedDpiEnum[keyof typeof CardTransactionEvidenceWarningsDetectedDpiEnum];
export const CardTransactionEvidenceWarningsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type CardTransactionEvidenceWarningsCalculatedDpiEnum = typeof CardTransactionEvidenceWarningsCalculatedDpiEnum[keyof typeof CardTransactionEvidenceWarningsCalculatedDpiEnum];
export const CardTransactionEvidenceWarningsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type CardTransactionEvidenceWarningsColorGradationEnum = typeof CardTransactionEvidenceWarningsColorGradationEnum[keyof typeof CardTransactionEvidenceWarningsColorGradationEnum];
export const CardTransactionEvidenceWarningsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type CardTransactionEvidenceWarningsHeightMillisEnum = typeof CardTransactionEvidenceWarningsHeightMillisEnum[keyof typeof CardTransactionEvidenceWarningsHeightMillisEnum];
export const CardTransactionEvidenceWarningsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type CardTransactionEvidenceWarningsWidthMillisEnum = typeof CardTransactionEvidenceWarningsWidthMillisEnum[keyof typeof CardTransactionEvidenceWarningsWidthMillisEnum];

/**
 * 
 * @export
 * @interface CardTransactionRecord
 */
export interface CardTransactionRecord {
    /**
     * 
     * @type {number}
     * @memberof CardTransactionRecord
     */
    'amount': number;
    /**
     * 
     * @type {number}
     * @memberof CardTransactionRecord
     */
    'amountFx': number;
    /**
     * 
     * @type {number}
     * @memberof CardTransactionRecord
     */
    'totalAmount': number;
    /**
     * 
     * @type {number}
     * @memberof CardTransactionRecord
     */
    'totalAmountFx': number;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionRecord
     */
    'currencyCode': string;
    /**
     * 
     * @type {number}
     * @memberof CardTransactionRecord
     */
    'fxRate': number | null;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionRecord
     */
    'processedAt': string;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionRecord
     */
    'transactionDetailType': CardTransactionRecordTransactionDetailTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof CardTransactionRecord
     */
    'isCleared': boolean;
}

export const CardTransactionRecordTransactionDetailTypeEnum = {
    purchase: 'PURCHASE',
    settlement: 'SETTLEMENT',
    validation: 'VALIDATION',
    refund: 'REFUND',
    cancel: 'CANCEL',
    refundCancel: 'REFUND_CANCEL',
    refundPartialCancel: 'REFUND_PARTIAL_CANCEL'
} as const;

export type CardTransactionRecordTransactionDetailTypeEnum = typeof CardTransactionRecordTransactionDetailTypeEnum[keyof typeof CardTransactionRecordTransactionDetailTypeEnum];

/**
 * 
 * @export
 * @interface CardTransactions
 */
export interface CardTransactions {
    /**
     * 
     * @type {number}
     * @memberof CardTransactions
     */
    'amount': number;
    /**
     * 
     * @type {Array<CardTransactionsMergedTransactionDetailListInner>}
     * @memberof CardTransactions
     */
    'mergedTransactionDetailList': Array<CardTransactionsMergedTransactionDetailListInner>;
}
/**
 * 
 * @export
 * @interface CardTransactionsMergedTransactionDetailListInner
 */
export interface CardTransactionsMergedTransactionDetailListInner {
    /**
     * 
     * @type {CardTransactionsMergedTransactionDetailListInnerMergedCardTransaction}
     * @memberof CardTransactionsMergedTransactionDetailListInner
     */
    'mergedCardTransaction': CardTransactionsMergedTransactionDetailListInnerMergedCardTransaction;
    /**
     * 
     * @type {CardTransactionsMergedTransactionDetailListInnerCardTransactionEvidenceStatus}
     * @memberof CardTransactionsMergedTransactionDetailListInner
     */
    'cardTransactionEvidenceStatus': CardTransactionsMergedTransactionDetailListInnerCardTransactionEvidenceStatus;
    /**
     * 
     * @type {Array<CardTransactionsMergedTransactionDetailListInnerEvidenceListInner>}
     * @memberof CardTransactionsMergedTransactionDetailListInner
     */
    'evidenceList': Array<CardTransactionsMergedTransactionDetailListInnerEvidenceListInner>;
    /**
     * 
     * @type {Array<CardTransactionsMergedTransactionDetailListInnerRequestHistoryInner>}
     * @memberof CardTransactionsMergedTransactionDetailListInner
     */
    'requestHistory': Array<CardTransactionsMergedTransactionDetailListInnerRequestHistoryInner>;
    /**
     * 
     * @type {CardTransactionsMergedTransactionDetailListInnerComment}
     * @memberof CardTransactionsMergedTransactionDetailListInner
     */
    'comment'?: CardTransactionsMergedTransactionDetailListInnerComment;
    /**
     * 
     * @type {CardTransactionsMergedTransactionDetailListInnerEvidenceRemindStatus}
     * @memberof CardTransactionsMergedTransactionDetailListInner
     */
    'evidenceRemindStatus': CardTransactionsMergedTransactionDetailListInnerEvidenceRemindStatus;
    /**
     * 
     * @type {CardTransactionsMergedTransactionDetailListInnerUserAccount}
     * @memberof CardTransactionsMergedTransactionDetailListInner
     */
    'userAccount': CardTransactionsMergedTransactionDetailListInnerUserAccount;
    /**
     * 
     * @type {Array<CardTransactionsMergedTransactionDetailListInnerPurchaseApplicationsInner>}
     * @memberof CardTransactionsMergedTransactionDetailListInner
     */
    'purchaseApplications': Array<CardTransactionsMergedTransactionDetailListInnerPurchaseApplicationsInner>;
}
/**
 * 
 * @export
 * @interface CardTransactionsMergedTransactionDetailListInnerCardTransactionEvidenceStatus
 */
export interface CardTransactionsMergedTransactionDetailListInnerCardTransactionEvidenceStatus {
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerCardTransactionEvidenceStatus
     */
    'visaTransactionReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerCardTransactionEvidenceStatus
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {boolean}
     * @memberof CardTransactionsMergedTransactionDetailListInnerCardTransactionEvidenceStatus
     */
    'isRequested': boolean;
    /**
     * 
     * @type {CardTransactionsMergedTransactionDetailListInnerCardTransactionEvidenceStatusRequestedBy}
     * @memberof CardTransactionsMergedTransactionDetailListInnerCardTransactionEvidenceStatus
     */
    'requestedBy': CardTransactionsMergedTransactionDetailListInnerCardTransactionEvidenceStatusRequestedBy | null;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerCardTransactionEvidenceStatus
     */
    'requestedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof CardTransactionsMergedTransactionDetailListInnerCardTransactionEvidenceStatus
     */
    'isLocked': boolean;
    /**
     * 
     * @type {CardTransactionsMergedTransactionDetailListInnerCardTransactionEvidenceStatusLockedBy}
     * @memberof CardTransactionsMergedTransactionDetailListInnerCardTransactionEvidenceStatus
     */
    'lockedBy': CardTransactionsMergedTransactionDetailListInnerCardTransactionEvidenceStatusLockedBy | null;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerCardTransactionEvidenceStatus
     */
    'lockedAt': string;
}
/**
 * 
 * @export
 * @interface CardTransactionsMergedTransactionDetailListInnerCardTransactionEvidenceStatusLockedBy
 */
export interface CardTransactionsMergedTransactionDetailListInnerCardTransactionEvidenceStatusLockedBy {
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerCardTransactionEvidenceStatusLockedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerCardTransactionEvidenceStatusLockedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface CardTransactionsMergedTransactionDetailListInnerCardTransactionEvidenceStatusRequestedBy
 */
export interface CardTransactionsMergedTransactionDetailListInnerCardTransactionEvidenceStatusRequestedBy {
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerCardTransactionEvidenceStatusRequestedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerCardTransactionEvidenceStatusRequestedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface CardTransactionsMergedTransactionDetailListInnerComment
 */
export interface CardTransactionsMergedTransactionDetailListInnerComment {
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerComment
     */
    'cardTransactionCommentId': string;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerComment
     */
    'visaTransactionReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerComment
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerComment
     */
    'comment': string;
    /**
     * 
     * @type {CardTransactionsMergedTransactionDetailListInnerCommentCreatedBy}
     * @memberof CardTransactionsMergedTransactionDetailListInnerComment
     */
    'createdBy': CardTransactionsMergedTransactionDetailListInnerCommentCreatedBy;
}
/**
 * 
 * @export
 * @interface CardTransactionsMergedTransactionDetailListInnerCommentCreatedBy
 */
export interface CardTransactionsMergedTransactionDetailListInnerCommentCreatedBy {
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerCommentCreatedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerCommentCreatedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface CardTransactionsMergedTransactionDetailListInnerEvidenceListInner
 */
export interface CardTransactionsMergedTransactionDetailListInnerEvidenceListInner {
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInner
     * @deprecated
     */
    'cardTransactionEvidenceId': string;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInner
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInner
     * @deprecated
     */
    'visaTransactionReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInner
     */
    'paymentType': CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerPaymentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInner
     */
    'fileName': string;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInner
     */
    'fileExtension': string;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInner
     */
    'electronicMethod': CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerElectronicMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInner
     */
    'documentSize': CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerDocumentSizeEnum;
    /**
     * 
     * @type {number}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInner
     * @deprecated
     */
    'dpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInner
     */
    'detectedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInner
     */
    'calculatedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInner
     */
    'colorGradation': number | null;
    /**
     * 
     * @type {number}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInner
     */
    'verticalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInner
     */
    'horizontalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInner
     */
    'heightMillis': number | null;
    /**
     * 
     * @type {number}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInner
     */
    'widthMillis': number | null;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInner
     */
    'legalValidity': CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerLegalValidityEnum;
    /**
     * 
     * @type {boolean}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInner
     */
    'dpiForciblyValid': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInner
     */
    'colorGradationForciblyValid': boolean;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInner
     */
    'note': string;
    /**
     * 
     * @type {boolean}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInner
     */
    'irrelevantToLedger': boolean;
    /**
     * 
     * @type {CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerInvoiceIssuer}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInner
     */
    'invoiceIssuer': CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerInvoiceIssuer | null;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInner
     * @deprecated
     */
    'dpiError': CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerDpiErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInner
     * @deprecated
     */
    'detectedDpiError': CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerDetectedDpiErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInner
     * @deprecated
     */
    'calculatedDpiError': CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerCalculatedDpiErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInner
     * @deprecated
     */
    'colorGradationError': CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerColorGradationErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInner
     * @deprecated
     */
    'heightMillisError': CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerHeightMillisErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInner
     * @deprecated
     */
    'widthMillisError': CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerWidthMillisErrorEnum;
    /**
     * 
     * @type {CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerErrors}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInner
     */
    'errors': CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerErrors;
    /**
     * 
     * @type {CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerWarnings}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInner
     */
    'warnings': CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerWarnings;
    /**
     * 
     * @type {CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerCreatedBy}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInner
     */
    'createdBy': CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerCreatedBy;
    /**
     * 
     * @type {CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerUpdatedBy}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInner
     */
    'updatedBy': CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerUpdatedBy;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInner
     */
    'updatedAt': string;
    /**
     * 
     * @type {CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerUploadedBy}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInner
     */
    'uploadedBy': CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerUploadedBy;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInner
     */
    'uploadedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInner
     */
    'uploadedByRecipient': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInner
     */
    'needsMigration': boolean | null;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInner
     */
    'uploadedFrom': string;
}

export const CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerPaymentTypeEnum = {
    cardTransaction: 'CARD_TRANSACTION',
    paymentRequest: 'PAYMENT_REQUEST'
} as const;

export type CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerPaymentTypeEnum = typeof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerPaymentTypeEnum[keyof typeof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerPaymentTypeEnum];
export const CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerElectronicMethodEnum = {
    fullElectronic: 'FULL_ELECTRONIC',
    originallyPaper: 'ORIGINALLY_PAPER',
    unknown: 'UNKNOWN'
} as const;

export type CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerElectronicMethodEnum = typeof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerElectronicMethodEnum[keyof typeof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerElectronicMethodEnum];
export const CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerDocumentSizeEnum = {
    overA4: 'OVER_A4',
    a4OrSmaller: 'A4_OR_SMALLER',
    unknown: 'UNKNOWN'
} as const;

export type CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerDocumentSizeEnum = typeof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerDocumentSizeEnum[keyof typeof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerDocumentSizeEnum];
export const CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerLegalValidityEnum = {
    valid: 'VALID',
    invalid: 'INVALID',
    inputRequired: 'INPUT_REQUIRED',
    outOfTarget: 'OUT_OF_TARGET'
} as const;

export type CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerLegalValidityEnum = typeof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerLegalValidityEnum[keyof typeof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerLegalValidityEnum];
export const CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerDpiErrorEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerDpiErrorEnum = typeof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerDpiErrorEnum[keyof typeof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerDpiErrorEnum];
export const CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerDetectedDpiErrorEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerDetectedDpiErrorEnum = typeof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerDetectedDpiErrorEnum[keyof typeof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerDetectedDpiErrorEnum];
export const CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerCalculatedDpiErrorEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerCalculatedDpiErrorEnum = typeof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerCalculatedDpiErrorEnum[keyof typeof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerCalculatedDpiErrorEnum];
export const CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerColorGradationErrorEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerColorGradationErrorEnum = typeof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerColorGradationErrorEnum[keyof typeof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerColorGradationErrorEnum];
export const CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerHeightMillisErrorEnum = {
    required: 'REQUIRED'
} as const;

export type CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerHeightMillisErrorEnum = typeof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerHeightMillisErrorEnum[keyof typeof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerHeightMillisErrorEnum];
export const CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerWidthMillisErrorEnum = {
    required: 'REQUIRED'
} as const;

export type CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerWidthMillisErrorEnum = typeof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerWidthMillisErrorEnum[keyof typeof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerWidthMillisErrorEnum];

/**
 * 
 * @export
 * @interface CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerCreatedBy
 */
export interface CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerCreatedBy {
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerCreatedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerCreatedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerErrors
 */
export interface CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerErrors {
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerErrors
     */
    'detectedDpi'?: CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerErrorsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerErrors
     */
    'calculatedDpi'?: CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerErrorsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerErrors
     */
    'colorGradation'?: CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerErrorsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerErrors
     */
    'heightMillis'?: CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerErrorsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerErrors
     */
    'widthMillis'?: CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerErrorsWidthMillisEnum;
}

export const CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerErrorsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerErrorsDetectedDpiEnum = typeof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerErrorsDetectedDpiEnum[keyof typeof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerErrorsDetectedDpiEnum];
export const CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerErrorsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerErrorsCalculatedDpiEnum = typeof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerErrorsCalculatedDpiEnum[keyof typeof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerErrorsCalculatedDpiEnum];
export const CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerErrorsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerErrorsColorGradationEnum = typeof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerErrorsColorGradationEnum[keyof typeof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerErrorsColorGradationEnum];
export const CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerErrorsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerErrorsHeightMillisEnum = typeof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerErrorsHeightMillisEnum[keyof typeof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerErrorsHeightMillisEnum];
export const CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerErrorsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerErrorsWidthMillisEnum = typeof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerErrorsWidthMillisEnum[keyof typeof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerErrorsWidthMillisEnum];

/**
 * Set null if it\'s evidence not analyzed using invoicing-system-compliance feature. Also set null if invoicing-system-compliance feature has been made not available for the organization by the feature-flag.
 * @export
 * @interface CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerInvoiceIssuer
 */
export interface CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerInvoiceIssuer {
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerInvoiceIssuer
     */
    'name': string | null;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerInvoiceIssuer
     */
    'registrationNumber': string | null;
    /**
     * isQualified retains the result of querying the 国税庁API to see if registrationNumber is qualified, as is.
     * @type {boolean}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerInvoiceIssuer
     */
    'isQualified': boolean;
    /**
     * AsQualified indicates whether this issuer should be treated as a qualified invoice issuer within the user\'s system, even if the RegistrationNumber is not confirmed as qualified in the National Tax Agency\'s business registration system.
     * @type {boolean}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerInvoiceIssuer
     */
    'asQualified': boolean;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerInvoiceIssuer
     */
    'partnerId': string | null;
}
/**
 * 
 * @export
 * @interface CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerUpdatedBy
 */
export interface CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerUpdatedBy {
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerUpdatedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerUpdatedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerUploadedBy
 */
export interface CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerUploadedBy {
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerUploadedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerUploadedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerWarnings
 */
export interface CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerWarnings {
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerWarnings
     */
    'detectedDpi'?: CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerWarningsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerWarnings
     */
    'calculatedDpi'?: CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerWarningsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerWarnings
     */
    'colorGradation'?: CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerWarningsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerWarnings
     */
    'heightMillis'?: CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerWarningsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerWarnings
     */
    'widthMillis'?: CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerWarningsWidthMillisEnum;
}

export const CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerWarningsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerWarningsDetectedDpiEnum = typeof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerWarningsDetectedDpiEnum[keyof typeof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerWarningsDetectedDpiEnum];
export const CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerWarningsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerWarningsCalculatedDpiEnum = typeof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerWarningsCalculatedDpiEnum[keyof typeof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerWarningsCalculatedDpiEnum];
export const CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerWarningsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerWarningsColorGradationEnum = typeof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerWarningsColorGradationEnum[keyof typeof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerWarningsColorGradationEnum];
export const CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerWarningsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerWarningsHeightMillisEnum = typeof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerWarningsHeightMillisEnum[keyof typeof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerWarningsHeightMillisEnum];
export const CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerWarningsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerWarningsWidthMillisEnum = typeof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerWarningsWidthMillisEnum[keyof typeof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerWarningsWidthMillisEnum];

/**
 * 
 * @export
 * @interface CardTransactionsMergedTransactionDetailListInnerEvidenceRemindStatus
 */
export interface CardTransactionsMergedTransactionDetailListInnerEvidenceRemindStatus {
    /**
     * 
     * @type {boolean}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceRemindStatus
     */
    'isAutoRemind': boolean;
}
/**
 * 
 * @export
 * @interface CardTransactionsMergedTransactionDetailListInnerMergedCardTransaction
 */
export interface CardTransactionsMergedTransactionDetailListInnerMergedCardTransaction {
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerMergedCardTransaction
     */
    'visaTransactionReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerMergedCardTransaction
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerMergedCardTransaction
     */
    'merchantName': string;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerMergedCardTransaction
     */
    'merchantNameKana': string;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerMergedCardTransaction
     */
    'merchantNameKanji': string;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerMergedCardTransaction
     */
    'mergedMerchantName': string;
    /**
     * 
     * @type {number}
     * @memberof CardTransactionsMergedTransactionDetailListInnerMergedCardTransaction
     */
    'amount': number;
    /**
     * 
     * @type {number}
     * @memberof CardTransactionsMergedTransactionDetailListInnerMergedCardTransaction
     */
    'amountFx': number;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerMergedCardTransaction
     */
    'currencyCode': string;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerMergedCardTransaction
     */
    'processedAt': string;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerMergedCardTransaction
     */
    'transactionType': CardTransactionsMergedTransactionDetailListInnerMergedCardTransactionTransactionTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof CardTransactionsMergedTransactionDetailListInnerMergedCardTransaction
     */
    'creditSettlement': number;
    /**
     * 
     * @type {Array<CardTransactionsMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner>}
     * @memberof CardTransactionsMergedTransactionDetailListInnerMergedCardTransaction
     */
    'transactionRecordList': Array<CardTransactionsMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner>;
    /**
     * 
     * @type {boolean}
     * @memberof CardTransactionsMergedTransactionDetailListInnerMergedCardTransaction
     */
    'isCleared': boolean;
}

export const CardTransactionsMergedTransactionDetailListInnerMergedCardTransactionTransactionTypeEnum = {
    confirm: 'CONFIRM',
    notConfirm: 'NOT_CONFIRM'
} as const;

export type CardTransactionsMergedTransactionDetailListInnerMergedCardTransactionTransactionTypeEnum = typeof CardTransactionsMergedTransactionDetailListInnerMergedCardTransactionTransactionTypeEnum[keyof typeof CardTransactionsMergedTransactionDetailListInnerMergedCardTransactionTransactionTypeEnum];

/**
 * 
 * @export
 * @interface CardTransactionsMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner
 */
export interface CardTransactionsMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner {
    /**
     * 
     * @type {number}
     * @memberof CardTransactionsMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner
     */
    'amount': number;
    /**
     * 
     * @type {number}
     * @memberof CardTransactionsMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner
     */
    'amountFx': number;
    /**
     * 
     * @type {number}
     * @memberof CardTransactionsMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner
     */
    'totalAmount': number;
    /**
     * 
     * @type {number}
     * @memberof CardTransactionsMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner
     */
    'totalAmountFx': number;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner
     */
    'currencyCode': string;
    /**
     * 
     * @type {number}
     * @memberof CardTransactionsMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner
     */
    'fxRate': number | null;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner
     */
    'processedAt': string;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner
     */
    'transactionDetailType': CardTransactionsMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof CardTransactionsMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner
     */
    'isCleared': boolean;
}

export const CardTransactionsMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum = {
    purchase: 'PURCHASE',
    settlement: 'SETTLEMENT',
    validation: 'VALIDATION',
    refund: 'REFUND',
    cancel: 'CANCEL',
    refundCancel: 'REFUND_CANCEL',
    refundPartialCancel: 'REFUND_PARTIAL_CANCEL'
} as const;

export type CardTransactionsMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum = typeof CardTransactionsMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum[keyof typeof CardTransactionsMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum];

/**
 * 
 * @export
 * @interface CardTransactionsMergedTransactionDetailListInnerPurchaseApplicationsInner
 */
export interface CardTransactionsMergedTransactionDetailListInnerPurchaseApplicationsInner {
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerPurchaseApplicationsInner
     */
    'applicationId': string;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerPurchaseApplicationsInner
     */
    'applicationNumber': string;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerPurchaseApplicationsInner
     */
    'paymentDate': string;
    /**
     * 
     * @type {CardTransactionsMergedTransactionDetailListInnerPurchaseApplicationsInnerSubmittedBy}
     * @memberof CardTransactionsMergedTransactionDetailListInnerPurchaseApplicationsInner
     */
    'submittedBy': CardTransactionsMergedTransactionDetailListInnerPurchaseApplicationsInnerSubmittedBy;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerPurchaseApplicationsInner
     */
    'submittedAt': string;
    /**
     * 
     * @type {Array<CardTransactionsMergedTransactionDetailListInnerPurchaseApplicationsInnerApproversInner>}
     * @memberof CardTransactionsMergedTransactionDetailListInnerPurchaseApplicationsInner
     */
    'approvers': Array<CardTransactionsMergedTransactionDetailListInnerPurchaseApplicationsInnerApproversInner>;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerPurchaseApplicationsInner
     */
    'department': string;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerPurchaseApplicationsInner
     */
    'purchaseReason': string;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerPurchaseApplicationsInner
     */
    'purchaseDetails': string;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerPurchaseApplicationsInner
     */
    'placeOfUse': string;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerPurchaseApplicationsInner
     */
    'purposeOfUse': string;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerPurchaseApplicationsInner
     */
    'url': string;
    /**
     * 
     * @type {number}
     * @memberof CardTransactionsMergedTransactionDetailListInnerPurchaseApplicationsInner
     */
    'amount': number;
    /**
     * 
     * @type {CardTransactionsMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccount}
     * @memberof CardTransactionsMergedTransactionDetailListInnerPurchaseApplicationsInner
     */
    'userAccount': CardTransactionsMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccount | null;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerPurchaseApplicationsInner
     */
    'remarks': string;
    /**
     * 
     * @type {CardTransactionsMergedTransactionDetailListInnerPurchaseApplicationsInnerWorkRequestedBy}
     * @memberof CardTransactionsMergedTransactionDetailListInnerPurchaseApplicationsInner
     */
    'workRequestedBy': CardTransactionsMergedTransactionDetailListInnerPurchaseApplicationsInnerWorkRequestedBy;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerPurchaseApplicationsInner
     */
    'workRequestApprovers': string;
    /**
     * 
     * @type {CardTransactionsMergedTransactionDetailListInnerPurchaseApplicationsInnerStatus}
     * @memberof CardTransactionsMergedTransactionDetailListInnerPurchaseApplicationsInner
     */
    'status': CardTransactionsMergedTransactionDetailListInnerPurchaseApplicationsInnerStatus;
    /**
     * 
     * @type {CardTransactionsMergedTransactionDetailListInnerPurchaseApplicationsInnerCreatedBy}
     * @memberof CardTransactionsMergedTransactionDetailListInnerPurchaseApplicationsInner
     */
    'createdBy': CardTransactionsMergedTransactionDetailListInnerPurchaseApplicationsInnerCreatedBy;
}
/**
 * 
 * @export
 * @interface CardTransactionsMergedTransactionDetailListInnerPurchaseApplicationsInnerApproversInner
 */
export interface CardTransactionsMergedTransactionDetailListInnerPurchaseApplicationsInnerApproversInner {
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerPurchaseApplicationsInnerApproversInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerPurchaseApplicationsInnerApproversInner
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface CardTransactionsMergedTransactionDetailListInnerPurchaseApplicationsInnerCreatedBy
 */
export interface CardTransactionsMergedTransactionDetailListInnerPurchaseApplicationsInnerCreatedBy {
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerPurchaseApplicationsInnerCreatedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerPurchaseApplicationsInnerCreatedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface CardTransactionsMergedTransactionDetailListInnerPurchaseApplicationsInnerStatus
 */
export interface CardTransactionsMergedTransactionDetailListInnerPurchaseApplicationsInnerStatus {
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerPurchaseApplicationsInnerStatus
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerPurchaseApplicationsInnerStatus
     */
    'comment': string;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerPurchaseApplicationsInnerStatus
     */
    'statusChangedAt': string;
    /**
     * 
     * @type {CardTransactionsMergedTransactionDetailListInnerPurchaseApplicationsInnerStatusCreatedBy}
     * @memberof CardTransactionsMergedTransactionDetailListInnerPurchaseApplicationsInnerStatus
     */
    'createdBy': CardTransactionsMergedTransactionDetailListInnerPurchaseApplicationsInnerStatusCreatedBy;
}
/**
 * 
 * @export
 * @interface CardTransactionsMergedTransactionDetailListInnerPurchaseApplicationsInnerStatusCreatedBy
 */
export interface CardTransactionsMergedTransactionDetailListInnerPurchaseApplicationsInnerStatusCreatedBy {
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerPurchaseApplicationsInnerStatusCreatedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerPurchaseApplicationsInnerStatusCreatedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface CardTransactionsMergedTransactionDetailListInnerPurchaseApplicationsInnerSubmittedBy
 */
export interface CardTransactionsMergedTransactionDetailListInnerPurchaseApplicationsInnerSubmittedBy {
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerPurchaseApplicationsInnerSubmittedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerPurchaseApplicationsInnerSubmittedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface CardTransactionsMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccount
 */
export interface CardTransactionsMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccount {
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccount
     */
    'userAccountId': string;
    /**
     * 
     * @type {CardTransactionsMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUser}
     * @memberof CardTransactionsMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccount
     */
    'user': CardTransactionsMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUser;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccount
     */
    'cardLabel': string;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccount
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccount
     */
    'organizationName': string;
    /**
     * 
     * @type {CardTransactionsMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUserAccountGroup}
     * @memberof CardTransactionsMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccount
     */
    'userAccountGroup': CardTransactionsMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUserAccountGroup | null;
    /**
     * 
     * @type {boolean}
     * @memberof CardTransactionsMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccount
     */
    'isOnDemand': boolean;
}
/**
 * 
 * @export
 * @interface CardTransactionsMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUser
 */
export interface CardTransactionsMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUser {
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUser
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUser
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUser
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUser
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUser
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CardTransactionsMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUser
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CardTransactionsMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUser
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CardTransactionsMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUser
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CardTransactionsMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUser
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CardTransactionsMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUser
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUser
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface CardTransactionsMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUserAccountGroup
 */
export interface CardTransactionsMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUserAccountGroup {
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUserAccountGroup
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUserAccountGroup
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof CardTransactionsMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUserAccountGroup
     */
    'sortNum': number;
}
/**
 * 
 * @export
 * @interface CardTransactionsMergedTransactionDetailListInnerPurchaseApplicationsInnerWorkRequestedBy
 */
export interface CardTransactionsMergedTransactionDetailListInnerPurchaseApplicationsInnerWorkRequestedBy {
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerPurchaseApplicationsInnerWorkRequestedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerPurchaseApplicationsInnerWorkRequestedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface CardTransactionsMergedTransactionDetailListInnerRequestHistoryInner
 */
export interface CardTransactionsMergedTransactionDetailListInnerRequestHistoryInner {
    /**
     * 
     * @type {number}
     * @memberof CardTransactionsMergedTransactionDetailListInnerRequestHistoryInner
     */
    'requestId': number;
    /**
     * 
     * @type {CardTransactionsMergedTransactionDetailListInnerRequestHistoryInnerRequestedBy}
     * @memberof CardTransactionsMergedTransactionDetailListInnerRequestHistoryInner
     */
    'requestedBy': CardTransactionsMergedTransactionDetailListInnerRequestHistoryInnerRequestedBy;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerRequestHistoryInner
     */
    'requestedAt': string;
}
/**
 * 
 * @export
 * @interface CardTransactionsMergedTransactionDetailListInnerRequestHistoryInnerRequestedBy
 */
export interface CardTransactionsMergedTransactionDetailListInnerRequestHistoryInnerRequestedBy {
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerRequestHistoryInnerRequestedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerRequestHistoryInnerRequestedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface CardTransactionsMergedTransactionDetailListInnerUserAccount
 */
export interface CardTransactionsMergedTransactionDetailListInnerUserAccount {
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerUserAccount
     */
    'userAccountId': string;
    /**
     * 
     * @type {CardTransactionsMergedTransactionDetailListInnerUserAccountUser}
     * @memberof CardTransactionsMergedTransactionDetailListInnerUserAccount
     */
    'user': CardTransactionsMergedTransactionDetailListInnerUserAccountUser;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerUserAccount
     */
    'cardLabel': string;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerUserAccount
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerUserAccount
     */
    'organizationName': string;
    /**
     * 
     * @type {CardTransactionsMergedTransactionDetailListInnerUserAccountUserAccountGroup}
     * @memberof CardTransactionsMergedTransactionDetailListInnerUserAccount
     */
    'userAccountGroup': CardTransactionsMergedTransactionDetailListInnerUserAccountUserAccountGroup | null;
    /**
     * 
     * @type {boolean}
     * @memberof CardTransactionsMergedTransactionDetailListInnerUserAccount
     */
    'isOnDemand': boolean;
}
/**
 * 
 * @export
 * @interface CardTransactionsMergedTransactionDetailListInnerUserAccountUser
 */
export interface CardTransactionsMergedTransactionDetailListInnerUserAccountUser {
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerUserAccountUser
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerUserAccountUser
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerUserAccountUser
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerUserAccountUser
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerUserAccountUser
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CardTransactionsMergedTransactionDetailListInnerUserAccountUser
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CardTransactionsMergedTransactionDetailListInnerUserAccountUser
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CardTransactionsMergedTransactionDetailListInnerUserAccountUser
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CardTransactionsMergedTransactionDetailListInnerUserAccountUser
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CardTransactionsMergedTransactionDetailListInnerUserAccountUser
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerUserAccountUser
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface CardTransactionsMergedTransactionDetailListInnerUserAccountUserAccountGroup
 */
export interface CardTransactionsMergedTransactionDetailListInnerUserAccountUserAccountGroup {
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerUserAccountUserAccountGroup
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerUserAccountUserAccountGroup
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof CardTransactionsMergedTransactionDetailListInnerUserAccountUserAccountGroup
     */
    'sortNum': number;
}
/**
 * 
 * @export
 * @interface CardWithUser
 */
export interface CardWithUser {
    /**
     * 
     * @type {string}
     * @memberof CardWithUser
     */
    'cardId': string;
    /**
     * 
     * @type {string}
     * @memberof CardWithUser
     */
    'cardLabel': string;
    /**
     * 
     * @type {boolean}
     * @memberof CardWithUser
     */
    'isActivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CardWithUser
     */
    'isDeactivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CardWithUser
     */
    'isLocked': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CardWithUser
     */
    'isSuspended': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CardWithUser
     */
    'isFrozen': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CardWithUser
     */
    'isVirtualCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CardWithUser
     */
    'isCreditCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CardWithUser
     */
    'isOnDemand': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CardWithUser
     */
    'isMetalCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CardWithUser
     */
    'isPhysicalStorePaymentDisabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof CardWithUser
     */
    'panLastFourDigits': string;
    /**
     * 
     * @type {string}
     * @memberof CardWithUser
     */
    'userAccountId': string;
    /**
     * 
     * @type {number}
     * @memberof CardWithUser
     */
    'transactionUpperLimit': number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CardWithUser
     */
    'availableCurrencies': Array<CardWithUserAvailableCurrenciesEnum>;
    /**
     * 
     * @type {Array<CardWithUserAvailableMerchantCategoriesInner>}
     * @memberof CardWithUser
     */
    'availableMerchantCategories': Array<CardWithUserAvailableMerchantCategoriesInner> | null;
    /**
     * 
     * @type {CardWithUserUser}
     * @memberof CardWithUser
     */
    'user': CardWithUserUser;
    /**
     * 
     * @type {CardWithUserUserAccountGroup}
     * @memberof CardWithUser
     */
    'userAccountGroup'?: CardWithUserUserAccountGroup | null;
    /**
     * 
     * @type {number}
     * @memberof CardWithUser
     */
    'monthlyTotalUsage': number;
    /**
     * 
     * @type {number}
     * @memberof CardWithUser
     */
    'monthlyUsageLimit': number | null;
    /**
     * 
     * @type {number}
     * @memberof CardWithUser
     */
    'dailyTotalUsage': number;
    /**
     * 
     * @type {number}
     * @memberof CardWithUser
     */
    'dailyUsageLimit': number | null;
    /**
     * 
     * @type {number}
     * @memberof CardWithUser
     */
    'totalUsageAmount': number;
    /**
     * 
     * @type {number}
     * @memberof CardWithUser
     */
    'totalUsageAmountLimit': number | null;
    /**
     * 
     * @type {string}
     * @memberof CardWithUser
     */
    'expiredDate': string | null;
}

export const CardWithUserAvailableCurrenciesEnum = {
    jpy: 'JPY',
    usd: 'USD',
    gbp: 'GBP',
    eur: 'EUR',
    sgd: 'SGD',
    aud: 'AUD',
    cny: 'CNY',
    hkd: 'HKD',
    idr: 'IDR',
    krw: 'KRW',
    nzd: 'NZD',
    php: 'PHP',
    rub: 'RUB',
    vnd: 'VND',
    inr: 'INR',
    thb: 'THB',
    lak: 'LAK',
    myr: 'MYR',
    twd: 'TWD',
    chf: 'CHF',
    cad: 'CAD',
    mxn: 'MXN',
    nok: 'NOK',
    huf: 'HUF',
    hrk: 'HRK',
    czk: 'CZK',
    dkk: 'DKK',
    isk: 'ISK',
    mdl: 'MDL',
    sek: 'SEK',
    mkd: 'MKD',
    rsd: 'RSD',
    ron: 'RON',
    bgn: 'BGN',
    bam: 'BAM',
    pln: 'PLN',
    mad: 'MAD',
    zar: 'ZAR',
    rwf: 'RWF',
    kes: 'KES',
    ngn: 'NGN',
    aed: 'AED',
    sar: 'SAR',
    egp: 'EGP',
    qar: 'QAR',
    omr: 'OMR',
    ils: 'ILS',
    try: 'TRY',
    kzt: 'KZT',
    cop: 'COP',
    gtq: 'GTQ'
} as const;

export type CardWithUserAvailableCurrenciesEnum = typeof CardWithUserAvailableCurrenciesEnum[keyof typeof CardWithUserAvailableCurrenciesEnum];

/**
 * 
 * @export
 * @interface CardWithUserAccountResourceLight
 */
export interface CardWithUserAccountResourceLight {
    /**
     * 
     * @type {string}
     * @memberof CardWithUserAccountResourceLight
     */
    'cardId': string;
    /**
     * 
     * @type {string}
     * @memberof CardWithUserAccountResourceLight
     */
    'cardLabel': string;
    /**
     * 
     * @type {boolean}
     * @memberof CardWithUserAccountResourceLight
     */
    'isActivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CardWithUserAccountResourceLight
     */
    'isDeactivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CardWithUserAccountResourceLight
     */
    'isFrozen': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CardWithUserAccountResourceLight
     */
    'isLocked': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CardWithUserAccountResourceLight
     */
    'isSuspended': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CardWithUserAccountResourceLight
     */
    'isVirtualCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CardWithUserAccountResourceLight
     */
    'isCreaditCard'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CardWithUserAccountResourceLight
     */
    'isOnDemand'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CardWithUserAccountResourceLight
     */
    'panLastFourDigits': string;
    /**
     * 
     * @type {CardWithUserAccountResourceLightUser}
     * @memberof CardWithUserAccountResourceLight
     */
    'user'?: CardWithUserAccountResourceLightUser;
    /**
     * 
     * @type {string}
     * @memberof CardWithUserAccountResourceLight
     */
    'userAccountId': string;
    /**
     * 
     * @type {CardWithUserAccountResourceLightUserAccountGroup}
     * @memberof CardWithUserAccountResourceLight
     */
    'userAccountGroup'?: CardWithUserAccountResourceLightUserAccountGroup;
    /**
     * 
     * @type {string}
     * @memberof CardWithUserAccountResourceLight
     */
    'resourceScope': CardWithUserAccountResourceLightResourceScopeEnum;
    /**
     * 
     * @type {string}
     * @memberof CardWithUserAccountResourceLight
     */
    'resourceId': string;
    /**
     * 
     * @type {string}
     * @memberof CardWithUserAccountResourceLight
     */
    'role': CardWithUserAccountResourceLightRoleEnum;
}

export const CardWithUserAccountResourceLightResourceScopeEnum = {
    account: 'USER_ACCOUNT',
    accountGroup: 'USER_ACCOUNT_GROUP',
    accountAll: 'USER_ACCOUNT_ALL'
} as const;

export type CardWithUserAccountResourceLightResourceScopeEnum = typeof CardWithUserAccountResourceLightResourceScopeEnum[keyof typeof CardWithUserAccountResourceLightResourceScopeEnum];
export const CardWithUserAccountResourceLightRoleEnum = {
    admin: 'USER_ACCOUNT_ADMIN',
    assist: 'USER_ACCOUNT_ASSIST'
} as const;

export type CardWithUserAccountResourceLightRoleEnum = typeof CardWithUserAccountResourceLightRoleEnum[keyof typeof CardWithUserAccountResourceLightRoleEnum];

/**
 * 
 * @export
 * @interface CardWithUserAccountResourceLightUser
 */
export interface CardWithUserAccountResourceLightUser {
    /**
     * 
     * @type {string}
     * @memberof CardWithUserAccountResourceLightUser
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CardWithUserAccountResourceLightUser
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof CardWithUserAccountResourceLightUser
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CardWithUserAccountResourceLightUser
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof CardWithUserAccountResourceLightUser
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CardWithUserAccountResourceLightUser
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CardWithUserAccountResourceLightUser
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CardWithUserAccountResourceLightUser
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CardWithUserAccountResourceLightUser
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CardWithUserAccountResourceLightUser
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof CardWithUserAccountResourceLightUser
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface CardWithUserAccountResourceLightUserAccountGroup
 */
export interface CardWithUserAccountResourceLightUserAccountGroup {
    /**
     * 
     * @type {string}
     * @memberof CardWithUserAccountResourceLightUserAccountGroup
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CardWithUserAccountResourceLightUserAccountGroup
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof CardWithUserAccountResourceLightUserAccountGroup
     */
    'sortNum': number;
}
/**
 * 
 * @export
 * @interface CardWithUserAvailableMerchantCategoriesInner
 */
export interface CardWithUserAvailableMerchantCategoriesInner {
    /**
     * 
     * @type {string}
     * @memberof CardWithUserAvailableMerchantCategoriesInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CardWithUserAvailableMerchantCategoriesInner
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CardWithUserAvailableMerchantCategoriesInner
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof CardWithUserAvailableMerchantCategoriesInner
     */
    'logoUrl': string;
}
/**
 * 
 * @export
 * @interface CardWithUserLight
 */
export interface CardWithUserLight {
    /**
     * 
     * @type {string}
     * @memberof CardWithUserLight
     */
    'cardId': string;
    /**
     * 
     * @type {string}
     * @memberof CardWithUserLight
     */
    'cardLabel': string;
    /**
     * 
     * @type {boolean}
     * @memberof CardWithUserLight
     */
    'isActivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CardWithUserLight
     */
    'isDeactivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CardWithUserLight
     */
    'isFrozen': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CardWithUserLight
     */
    'isLocked': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CardWithUserLight
     */
    'isSuspended': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CardWithUserLight
     */
    'isVirtualCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CardWithUserLight
     */
    'isCreaditCard'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CardWithUserLight
     */
    'isOnDemand'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CardWithUserLight
     */
    'isMetalCard': boolean;
    /**
     * 
     * @type {string}
     * @memberof CardWithUserLight
     */
    'panLastFourDigits': string;
    /**
     * 
     * @type {CardWithUserLightUser}
     * @memberof CardWithUserLight
     */
    'user'?: CardWithUserLightUser;
    /**
     * 
     * @type {string}
     * @memberof CardWithUserLight
     */
    'userAccountId': string;
    /**
     * 
     * @type {CardWithUserLightUserAccountGroup}
     * @memberof CardWithUserLight
     */
    'userAccountGroup'?: CardWithUserLightUserAccountGroup;
    /**
     * 
     * @type {boolean}
     * @memberof CardWithUserLight
     */
    'isPhysicalStorePaymentDisabled': boolean;
}
/**
 * 
 * @export
 * @interface CardWithUserLightUser
 */
export interface CardWithUserLightUser {
    /**
     * 
     * @type {string}
     * @memberof CardWithUserLightUser
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CardWithUserLightUser
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof CardWithUserLightUser
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CardWithUserLightUser
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof CardWithUserLightUser
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CardWithUserLightUser
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CardWithUserLightUser
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CardWithUserLightUser
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CardWithUserLightUser
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CardWithUserLightUser
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof CardWithUserLightUser
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface CardWithUserLightUserAccountGroup
 */
export interface CardWithUserLightUserAccountGroup {
    /**
     * 
     * @type {string}
     * @memberof CardWithUserLightUserAccountGroup
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CardWithUserLightUserAccountGroup
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof CardWithUserLightUserAccountGroup
     */
    'sortNum': number;
}
/**
 * 
 * @export
 * @interface CardWithUserUser
 */
export interface CardWithUserUser {
    /**
     * 
     * @type {string}
     * @memberof CardWithUserUser
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CardWithUserUser
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof CardWithUserUser
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CardWithUserUser
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof CardWithUserUser
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CardWithUserUser
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CardWithUserUser
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CardWithUserUser
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CardWithUserUser
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CardWithUserUser
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof CardWithUserUser
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface CardWithUserUserAccountGroup
 */
export interface CardWithUserUserAccountGroup {
    /**
     * 
     * @type {string}
     * @memberof CardWithUserUserAccountGroup
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CardWithUserUserAccountGroup
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof CardWithUserUserAccountGroup
     */
    'sortNum': number;
}
/**
 * 
 * @export
 * @interface ChangeIdentityVerificationScheduledDate200Response
 */
export interface ChangeIdentityVerificationScheduledDate200Response {
    /**
     * 
     * @type {string}
     * @memberof ChangeIdentityVerificationScheduledDate200Response
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ChangeIdentityVerificationScheduledDate200Response
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ChangeIdentityVerificationScheduledDate200Response
     */
    'representativeName': string;
    /**
     * 
     * @type {string}
     * @memberof ChangeIdentityVerificationScheduledDate200Response
     */
    'phoneNumber': string;
    /**
     * 
     * @type {string}
     * @memberof ChangeIdentityVerificationScheduledDate200Response
     */
    'postalCode': string;
    /**
     * 
     * @type {string}
     * @memberof ChangeIdentityVerificationScheduledDate200Response
     */
    'address': string;
    /**
     * 
     * @type {string}
     * @memberof ChangeIdentityVerificationScheduledDate200Response
     */
    'deliveryPostalCode': string;
    /**
     * 
     * @type {string}
     * @memberof ChangeIdentityVerificationScheduledDate200Response
     */
    'deliveryAddress': string;
    /**
     * 
     * @type {string}
     * @memberof ChangeIdentityVerificationScheduledDate200Response
     */
    'invoiceEmail': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ChangeIdentityVerificationScheduledDate200Response
     */
    'isApprovalFeatureEnabled': boolean;
    /**
     * 
     * @type {number}
     * @memberof ChangeIdentityVerificationScheduledDate200Response
     */
    'balance': number;
    /**
     * 
     * @type {number}
     * @memberof ChangeIdentityVerificationScheduledDate200Response
     */
    'pointBalance': number;
    /**
     * 
     * @type {number}
     * @memberof ChangeIdentityVerificationScheduledDate200Response
     */
    'guaranteeMoneyBalance': number;
    /**
     * 
     * @type {number}
     * @memberof ChangeIdentityVerificationScheduledDate200Response
     */
    'availableLimit': number;
    /**
     * 
     * @type {number}
     * @memberof ChangeIdentityVerificationScheduledDate200Response
     */
    'creditLimit': number | null;
    /**
     * 
     * @type {number}
     * @memberof ChangeIdentityVerificationScheduledDate200Response
     */
    'creditSettlement': number | null;
    /**
     * 
     * @type {number}
     * @memberof ChangeIdentityVerificationScheduledDate200Response
     */
    'creditUsage': number | null;
    /**
     * 
     * @type {boolean}
     * @memberof ChangeIdentityVerificationScheduledDate200Response
     */
    'isVCCooperationPlanEnabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof ChangeIdentityVerificationScheduledDate200Response
     */
    'paymentScheme': string;
    /**
     * 
     * @type {string}
     * @memberof ChangeIdentityVerificationScheduledDate200Response
     */
    'identityVerificationScheduledDate': string | null;
    /**
     * 
     * @type {string}
     * @memberof ChangeIdentityVerificationScheduledDate200Response
     */
    'externalAccountTransferAgency': ChangeIdentityVerificationScheduledDate200ResponseExternalAccountTransferAgencyEnum;
    /**
     * 
     * @type {number}
     * @memberof ChangeIdentityVerificationScheduledDate200Response
     */
    'cardCountLimit': number;
}

export const ChangeIdentityVerificationScheduledDate200ResponseExternalAccountTransferAgencyEnum = {
    moneyForwardKessai: 'MONEY_FORWARD_KESSAI',
    ufj: 'UFJ'
} as const;

export type ChangeIdentityVerificationScheduledDate200ResponseExternalAccountTransferAgencyEnum = typeof ChangeIdentityVerificationScheduledDate200ResponseExternalAccountTransferAgencyEnum[keyof typeof ChangeIdentityVerificationScheduledDate200ResponseExternalAccountTransferAgencyEnum];

/**
 * 
 * @export
 * @interface ChangeIdentityVerificationScheduledDateRequest
 */
export interface ChangeIdentityVerificationScheduledDateRequest {
    /**
     * 
     * @type {string}
     * @memberof ChangeIdentityVerificationScheduledDateRequest
     */
    'identityVerificationScheduledDate': string | null;
}
/**
 * 
 * @export
 * @interface ChangeInvoiceEmail200Response
 */
export interface ChangeInvoiceEmail200Response {
    /**
     * 
     * @type {string}
     * @memberof ChangeInvoiceEmail200Response
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ChangeInvoiceEmail200Response
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ChangeInvoiceEmail200Response
     */
    'representativeName': string;
    /**
     * 
     * @type {string}
     * @memberof ChangeInvoiceEmail200Response
     */
    'phoneNumber': string;
    /**
     * 
     * @type {string}
     * @memberof ChangeInvoiceEmail200Response
     */
    'postalCode': string;
    /**
     * 
     * @type {string}
     * @memberof ChangeInvoiceEmail200Response
     */
    'address': string;
    /**
     * 
     * @type {string}
     * @memberof ChangeInvoiceEmail200Response
     */
    'deliveryPostalCode': string;
    /**
     * 
     * @type {string}
     * @memberof ChangeInvoiceEmail200Response
     */
    'deliveryAddress': string;
    /**
     * 
     * @type {string}
     * @memberof ChangeInvoiceEmail200Response
     */
    'invoiceEmail': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ChangeInvoiceEmail200Response
     */
    'isApprovalFeatureEnabled': boolean;
}
/**
 * 
 * @export
 * @interface ChangeInvoiceEmailRequest
 */
export interface ChangeInvoiceEmailRequest {
    /**
     * 
     * @type {string}
     * @memberof ChangeInvoiceEmailRequest
     */
    'invoiceEmail': string;
}
/**
 * 
 * @export
 * @interface CheckAlreadyRegisteredPhoneNumber200Response
 */
export interface CheckAlreadyRegisteredPhoneNumber200Response {
    /**
     * 
     * @type {boolean}
     * @memberof CheckAlreadyRegisteredPhoneNumber200Response
     */
    'registered': boolean;
}
/**
 * 
 * @export
 * @interface CheckAlreadyRegisteredPhoneNumberRequest
 */
export interface CheckAlreadyRegisteredPhoneNumberRequest {
    /**
     * 
     * @type {string}
     * @memberof CheckAlreadyRegisteredPhoneNumberRequest
     */
    'phoneNumber': string;
}
/**
 * 
 * @export
 * @interface CheckDuplicateEmailAddresses200ResponseInner
 */
export interface CheckDuplicateEmailAddresses200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof CheckDuplicateEmailAddresses200ResponseInner
     */
    'emailAddress'?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckDuplicateEmailAddresses200ResponseInner
     */
    'organizationId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckDuplicateEmailAddresses200ResponseInner
     */
    'organizationName'?: string;
}
/**
 * 
 * @export
 * @interface CompleteRedirectFromSlack200Response
 */
export interface CompleteRedirectFromSlack200Response {
    /**
     * 
     * @type {string}
     * @memberof CompleteRedirectFromSlack200Response
     */
    'id': string;
}
/**
 * 
 * @export
 * @interface CompleteRedirectFromSlackRequest
 */
export interface CompleteRedirectFromSlackRequest {
    /**
     * 
     * @type {string}
     * @memberof CompleteRedirectFromSlackRequest
     */
    'channelId': string;
    /**
     * 
     * @type {string}
     * @memberof CompleteRedirectFromSlackRequest
     */
    'messageTimestamp': string;
    /**
     * 
     * @type {string}
     * @memberof CompleteRedirectFromSlackRequest
     */
    'slackUserId': string;
}
/**
 * 
 * @export
 * @interface ConfirmedActivityLight
 */
export interface ConfirmedActivityLight {
    /**
     * 
     * @type {string}
     * @memberof ConfirmedActivityLight
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ConfirmedActivityLight
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof ConfirmedActivityLight
     */
    'organizationName': string;
    /**
     * 
     * @type {string}
     * @memberof ConfirmedActivityLight
     */
    'type': ConfirmedActivityLightTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ConfirmedActivityLight
     */
    'usageFeeId': string;
    /**
     * 
     * @type {string}
     * @memberof ConfirmedActivityLight
     */
    'cardBillId': string;
    /**
     * 
     * @type {string}
     * @memberof ConfirmedActivityLight
     */
    'cardPointId': string;
    /**
     * 
     * @type {string}
     * @memberof ConfirmedActivityLight
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof ConfirmedActivityLight
     */
    'supplierName': string;
    /**
     * 
     * @type {number}
     * @memberof ConfirmedActivityLight
     */
    'amount': number;
    /**
     * 
     * @type {number}
     * @memberof ConfirmedActivityLight
     */
    'pointAmount'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ConfirmedActivityLight
     */
    'balance': number;
    /**
     * 
     * @type {number}
     * @memberof ConfirmedActivityLight
     */
    'pointBalance'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof ConfirmedActivityLight
     */
    'isConfirmed': boolean;
    /**
     * 
     * @type {string}
     * @memberof ConfirmedActivityLight
     */
    'appliedAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof ConfirmedActivityLight
     */
    'executedAt': string | null;
}

export const ConfirmedActivityLightTypeEnum = {
    payBill: 'PAY_BILL',
    deposit: 'DEPOSIT',
    withdrawal: 'WITHDRAWAL',
    reward: 'REWARD',
    usageFee: 'USAGE_FEE',
    point: 'POINT',
    cardPoint: 'CARD_POINT',
    campaignPoint: 'CAMPAIGN_POINT',
    card: 'CARD',
    depositFromGuaranteeMoney: 'DEPOSIT_FROM_GUARANTEE_MONEY',
    withdrawalToGuaranteeMoney: 'WITHDRAWAL_TO_GUARANTEE_MONEY'
} as const;

export type ConfirmedActivityLightTypeEnum = typeof ConfirmedActivityLightTypeEnum[keyof typeof ConfirmedActivityLightTypeEnum];

/**
 * 
 * @export
 * @interface Contract
 */
export interface Contract {
    /**
     * 
     * @type {number}
     * @memberof Contract
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof Contract
     */
    'organizationId': number;
    /**
     * 
     * @type {string}
     * @memberof Contract
     */
    'contractType': string;
    /**
     * 
     * @type {string}
     * @memberof Contract
     */
    'startAt': string;
    /**
     * 
     * @type {string}
     * @memberof Contract
     */
    'endAt': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const CorporateType = {
    majorityCapitalVoteCorporate: 'MAJORITY_CAPITAL_VOTE_CORPORATE',
    exceptMajorityCapitalVoteCorporate: 'EXCEPT_MAJORITY_CAPITAL_VOTE_CORPORATE'
} as const;

export type CorporateType = typeof CorporateType[keyof typeof CorporateType];


/**
 * 
 * @export
 * @interface CountDealsRequest
 */
export interface CountDealsRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof CountDealsRequest
     */
    'dealStatusList'?: Array<CountDealsRequestDealStatusListEnum>;
    /**
     * 
     * @type {string}
     * @memberof CountDealsRequest
     */
    'userAccountId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CountDealsRequest
     */
    'userAccountGroupId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CountDealsRequest
     */
    'dealKeyword'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CountDealsRequest
     */
    'dealIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof CountDealsRequest
     */
    'yearMonth'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CountDealsRequest
     */
    'startDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CountDealsRequest
     */
    'endDate'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CountDealsRequest
     */
    'amountLowerLimit'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CountDealsRequest
     */
    'amountUpperLimit'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CountDealsRequest
     */
    'qualifiedEvidence'?: CountDealsRequestQualifiedEvidenceEnum;
    /**
     * 
     * @type {number}
     * @memberof CountDealsRequest
     */
    'accountItemId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CountDealsRequest
     */
    'taxCode'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CountDealsRequest
     */
    'itemId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CountDealsRequest
     */
    'sectionId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CountDealsRequest
     */
    'tagId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CountDealsRequest
     */
    'partnerId'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof CountDealsRequest
     */
    'canSync'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof CountDealsRequest
     */
    'isInvalidTaxCode'?: boolean | null;
}

export const CountDealsRequestDealStatusListEnum = {
    notEntered: 'NOT_ENTERED',
    automaticJournalized: 'AUTOMATIC_JOURNALIZED',
    automaticIntegrated: 'AUTOMATIC_INTEGRATED',
    entering: 'ENTERING',
    journalized: 'JOURNALIZED',
    changedAfterJournalization: 'CHANGED_AFTER_JOURNALIZATION',
    integrated: 'INTEGRATED',
    changedAfterIntegration: 'CHANGED_AFTER_INTEGRATION',
    ignored: 'IGNORED',
    readyAutomaticIntegration: 'READY_AUTOMATIC_INTEGRATION'
} as const;

export type CountDealsRequestDealStatusListEnum = typeof CountDealsRequestDealStatusListEnum[keyof typeof CountDealsRequestDealStatusListEnum];
export const CountDealsRequestQualifiedEvidenceEnum = {
    allNotQualified: 'ALL_NOT_QUALIFIED',
    containQualified: 'CONTAIN_QUALIFIED'
} as const;

export type CountDealsRequestQualifiedEvidenceEnum = typeof CountDealsRequestQualifiedEvidenceEnum[keyof typeof CountDealsRequestQualifiedEvidenceEnum];

/**
 * 
 * @export
 * @interface CreateBankTransfers200Response
 */
export interface CreateBankTransfers200Response {
    /**
     * 
     * @type {string}
     * @memberof CreateBankTransfers200Response
     */
    'bankTransferId': string;
}
/**
 * 
 * @export
 * @interface CreateBankTransfersRequest
 */
export interface CreateBankTransfersRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateBankTransfersRequest
     */
    'paymentRequestIds': Array<string>;
    /**
     * yyyy-MM-dd format Date when the bank transfers are to be executed.
     * @type {string}
     * @memberof CreateBankTransfersRequest
     */
    'transferDate': string;
    /**
     * 
     * @type {string}
     * @memberof CreateBankTransfersRequest
     */
    'fileFormat': CreateBankTransfersRequestFileFormatEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateBankTransfersRequest
     */
    'bankAccountId': string;
    /**
     * 
     * @type {string}
     * @memberof CreateBankTransfersRequest
     */
    'bankAccountRecordId': string;
}

export const CreateBankTransfersRequestFileFormatEnum = {
    disableLineBreak: 'ZENGIN_DISABLE_LINE_BREAK',
    enableLineBreak: 'ZENGIN_ENABLE_LINE_BREAK',
    csv: 'ZENGIN_CSV'
} as const;

export type CreateBankTransfersRequestFileFormatEnum = typeof CreateBankTransfersRequestFileFormatEnum[keyof typeof CreateBankTransfersRequestFileFormatEnum];

/**
 * 
 * @export
 * @interface CreateCategoryOfThePurchaseApplicationTemplateRequest
 */
export interface CreateCategoryOfThePurchaseApplicationTemplateRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateCategoryOfThePurchaseApplicationTemplateRequest
     */
    'templateCategory'?: string;
}
/**
 * 
 * @export
 * @interface CreateCommentTemplateRequest
 */
export interface CreateCommentTemplateRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateCommentTemplateRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateCommentTemplateRequest
     */
    'template': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateCommentTemplateRequest
     */
    'userAccountIdsSetAsDefault'?: Array<string>;
}
/**
 * 
 * @export
 * @interface CreateDepositRestrictionForOrganizationRequest
 */
export interface CreateDepositRestrictionForOrganizationRequest {
    /**
     * 入金禁止フラグ
     * @type {boolean}
     * @memberof CreateDepositRestrictionForOrganizationRequest
     */
    'depositBlocked': boolean;
    /**
     * 入金制限開始日時
     * @type {string}
     * @memberof CreateDepositRestrictionForOrganizationRequest
     */
    'startAt': string;
    /**
     * 入金制限終了日時
     * @type {string}
     * @memberof CreateDepositRestrictionForOrganizationRequest
     */
    'endAt': string;
}
/**
 * 
 * @export
 * @interface CreateDraftOfPaymentRequests200Response
 */
export interface CreateDraftOfPaymentRequests200Response {
    /**
     * 
     * @type {string}
     * @memberof CreateDraftOfPaymentRequests200Response
     */
    'id': string;
}
/**
 * 
 * @export
 * @interface CreateDraftOfPaymentRequestsRequest
 */
export interface CreateDraftOfPaymentRequestsRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateDraftOfPaymentRequestsRequest
     */
    'fileId': string;
    /**
     * 
     * @type {CreateDraftOfPaymentRequestsRequestSupplier}
     * @memberof CreateDraftOfPaymentRequestsRequest
     */
    'supplier': CreateDraftOfPaymentRequestsRequestSupplier;
    /**
     * 
     * @type {string}
     * @memberof CreateDraftOfPaymentRequestsRequest
     */
    'dueDate': string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateDraftOfPaymentRequestsRequest
     */
    'totalAmount': number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateDraftOfPaymentRequestsRequest
     */
    'invoiceIssuerName': string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateDraftOfPaymentRequestsRequest
     */
    'invoiceIssuerRegistrationNumber': string | null;
}
/**
 * 
 * @export
 * @interface CreateDraftOfPaymentRequestsRequestSupplier
 */
export interface CreateDraftOfPaymentRequestsRequestSupplier {
    /**
     * 
     * @type {string}
     * @memberof CreateDraftOfPaymentRequestsRequestSupplier
     */
    'partnerId': string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateDraftOfPaymentRequestsRequestSupplier
     */
    'name': string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateDraftOfPaymentRequestsRequestSupplier
     */
    'bankNumber': string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateDraftOfPaymentRequestsRequestSupplier
     */
    'bankName': string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateDraftOfPaymentRequestsRequestSupplier
     */
    'branchNumber': string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateDraftOfPaymentRequestsRequestSupplier
     */
    'branchName': string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateDraftOfPaymentRequestsRequestSupplier
     */
    'accountNumber': string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateDraftOfPaymentRequestsRequestSupplier
     */
    'accountType': CreateDraftOfPaymentRequestsRequestSupplierAccountTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateDraftOfPaymentRequestsRequestSupplier
     */
    'companyName': string | null;
}

export const CreateDraftOfPaymentRequestsRequestSupplierAccountTypeEnum = {
    savingsAccount: 'SAVINGS_ACCOUNT',
    currentAccount: 'CURRENT_ACCOUNT',
    thriftAccount: 'THRIFT_ACCOUNT',
    other: 'OTHER'
} as const;

export type CreateDraftOfPaymentRequestsRequestSupplierAccountTypeEnum = typeof CreateDraftOfPaymentRequestsRequestSupplierAccountTypeEnum[keyof typeof CreateDraftOfPaymentRequestsRequestSupplierAccountTypeEnum];

/**
 * 
 * @export
 * @interface CreateEvidenceRequest200Response
 */
export interface CreateEvidenceRequest200Response {
    /**
     * 
     * @type {CreateEvidenceRequest200ResponseEvidenceStatus}
     * @memberof CreateEvidenceRequest200Response
     */
    'evidenceStatus': CreateEvidenceRequest200ResponseEvidenceStatus | null;
    /**
     * 
     * @type {CreateEvidenceRequest200ResponseEvidenceRemindStatus}
     * @memberof CreateEvidenceRequest200Response
     */
    'evidenceRemindStatus': CreateEvidenceRequest200ResponseEvidenceRemindStatus | null;
    /**
     * 
     * @type {Array<CreateEvidenceRequest200ResponseRequestHistoryInner>}
     * @memberof CreateEvidenceRequest200Response
     */
    'requestHistory': Array<CreateEvidenceRequest200ResponseRequestHistoryInner>;
}
/**
 * 
 * @export
 * @interface CreateEvidenceRequest200ResponseEvidenceRemindStatus
 */
export interface CreateEvidenceRequest200ResponseEvidenceRemindStatus {
    /**
     * 
     * @type {boolean}
     * @memberof CreateEvidenceRequest200ResponseEvidenceRemindStatus
     */
    'isAutoRemind': boolean;
}
/**
 * 
 * @export
 * @interface CreateEvidenceRequest200ResponseEvidenceStatus
 */
export interface CreateEvidenceRequest200ResponseEvidenceStatus {
    /**
     * 
     * @type {string}
     * @memberof CreateEvidenceRequest200ResponseEvidenceStatus
     */
    'visaTransactionReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof CreateEvidenceRequest200ResponseEvidenceStatus
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateEvidenceRequest200ResponseEvidenceStatus
     */
    'isRequested': boolean;
    /**
     * 
     * @type {CreateEvidenceRequest200ResponseEvidenceStatusRequestedBy}
     * @memberof CreateEvidenceRequest200ResponseEvidenceStatus
     */
    'requestedBy': CreateEvidenceRequest200ResponseEvidenceStatusRequestedBy | null;
    /**
     * 
     * @type {string}
     * @memberof CreateEvidenceRequest200ResponseEvidenceStatus
     */
    'requestedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateEvidenceRequest200ResponseEvidenceStatus
     */
    'isLocked': boolean;
    /**
     * 
     * @type {CreateEvidenceRequest200ResponseEvidenceStatusLockedBy}
     * @memberof CreateEvidenceRequest200ResponseEvidenceStatus
     */
    'lockedBy': CreateEvidenceRequest200ResponseEvidenceStatusLockedBy | null;
    /**
     * 
     * @type {string}
     * @memberof CreateEvidenceRequest200ResponseEvidenceStatus
     */
    'lockedAt': string;
}
/**
 * 
 * @export
 * @interface CreateEvidenceRequest200ResponseEvidenceStatusLockedBy
 */
export interface CreateEvidenceRequest200ResponseEvidenceStatusLockedBy {
    /**
     * 
     * @type {string}
     * @memberof CreateEvidenceRequest200ResponseEvidenceStatusLockedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CreateEvidenceRequest200ResponseEvidenceStatusLockedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface CreateEvidenceRequest200ResponseEvidenceStatusRequestedBy
 */
export interface CreateEvidenceRequest200ResponseEvidenceStatusRequestedBy {
    /**
     * 
     * @type {string}
     * @memberof CreateEvidenceRequest200ResponseEvidenceStatusRequestedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CreateEvidenceRequest200ResponseEvidenceStatusRequestedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface CreateEvidenceRequest200ResponseRequestHistoryInner
 */
export interface CreateEvidenceRequest200ResponseRequestHistoryInner {
    /**
     * 
     * @type {number}
     * @memberof CreateEvidenceRequest200ResponseRequestHistoryInner
     */
    'requestId': number;
    /**
     * 
     * @type {CreateEvidenceRequest200ResponseRequestHistoryInnerRequestedBy}
     * @memberof CreateEvidenceRequest200ResponseRequestHistoryInner
     */
    'requestedBy': CreateEvidenceRequest200ResponseRequestHistoryInnerRequestedBy;
    /**
     * 
     * @type {string}
     * @memberof CreateEvidenceRequest200ResponseRequestHistoryInner
     */
    'requestedAt': string;
}
/**
 * 
 * @export
 * @interface CreateEvidenceRequest200ResponseRequestHistoryInnerRequestedBy
 */
export interface CreateEvidenceRequest200ResponseRequestHistoryInnerRequestedBy {
    /**
     * 
     * @type {string}
     * @memberof CreateEvidenceRequest200ResponseRequestHistoryInnerRequestedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CreateEvidenceRequest200ResponseRequestHistoryInnerRequestedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface CreateFreeePartner200Response
 */
export interface CreateFreeePartner200Response {
    /**
     * 
     * @type {string}
     * @memberof CreateFreeePartner200Response
     */
    'freeeCompanyId': string;
    /**
     * 
     * @type {string}
     * @memberof CreateFreeePartner200Response
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateFreeePartner200Response
     */
    'freeePartnerId': string;
    /**
     * 
     * @type {string}
     * @memberof CreateFreeePartner200Response
     */
    'freeePartnerCode': string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateFreeePartner200Response
     */
    'orphaned': boolean;
}
/**
 * 
 * @export
 * @interface CreateFreeePartnerRequest
 */
export interface CreateFreeePartnerRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateFreeePartnerRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateFreeePartnerRequest
     */
    'code': string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateFreeePartnerRequest
     */
    'invoiceRegistrationNumber': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateFreeePartnerRequest
     */
    'asQualified': boolean | null;
}
/**
 * 
 * @export
 * @interface CreatePastDealsRequest
 */
export interface CreatePastDealsRequest {
    /**
     * 
     * @type {string}
     * @memberof CreatePastDealsRequest
     */
    'startDate'?: string;
}
/**
 * 
 * @export
 * @interface CreatePurchaseApplicationRequest
 */
export interface CreatePurchaseApplicationRequest {
    /**
     * 
     * @type {string}
     * @memberof CreatePurchaseApplicationRequest
     */
    'paymentDate': string;
    /**
     * 
     * @type {string}
     * @memberof CreatePurchaseApplicationRequest
     */
    'department': string;
    /**
     * 
     * @type {string}
     * @memberof CreatePurchaseApplicationRequest
     */
    'purchaseReason': string;
    /**
     * 
     * @type {string}
     * @memberof CreatePurchaseApplicationRequest
     */
    'purchaseDetails': string;
    /**
     * 
     * @type {string}
     * @memberof CreatePurchaseApplicationRequest
     */
    'placeOfUse': string;
    /**
     * 
     * @type {string}
     * @memberof CreatePurchaseApplicationRequest
     */
    'purposeOfUse': CreatePurchaseApplicationRequestPurposeOfUseEnum;
    /**
     * 
     * @type {string}
     * @memberof CreatePurchaseApplicationRequest
     */
    'url': string;
    /**
     * 
     * @type {number}
     * @memberof CreatePurchaseApplicationRequest
     */
    'amount': number;
    /**
     * 
     * @type {string}
     * @memberof CreatePurchaseApplicationRequest
     */
    'userAccountId': string | null;
    /**
     * 
     * @type {string}
     * @memberof CreatePurchaseApplicationRequest
     */
    'remarks': string;
    /**
     * 
     * @type {Array<CreatePurchaseApplicationRequestAttachmentsInner>}
     * @memberof CreatePurchaseApplicationRequest
     */
    'attachments': Array<CreatePurchaseApplicationRequestAttachmentsInner>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreatePurchaseApplicationRequest
     */
    'approvers': Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof CreatePurchaseApplicationRequest
     */
    'workRequestedBy': string | null;
    /**
     * 
     * @type {string}
     * @memberof CreatePurchaseApplicationRequest
     */
    'workRequestApprovers': string | null;
}

export const CreatePurchaseApplicationRequestPurposeOfUseEnum = {
    software: 'SOFTWARE',
    fixtures: 'FIXTURES',
    conference: 'CONFERENCE',
    entertainment: 'ENTERTAINMENT',
    travel: 'TRAVEL',
    other: 'OTHER',
    initialValue: 'INITIAL_VALUE'
} as const;

export type CreatePurchaseApplicationRequestPurposeOfUseEnum = typeof CreatePurchaseApplicationRequestPurposeOfUseEnum[keyof typeof CreatePurchaseApplicationRequestPurposeOfUseEnum];

/**
 * 
 * @export
 * @interface CreatePurchaseApplicationRequestAttachmentsInner
 */
export interface CreatePurchaseApplicationRequestAttachmentsInner {
    /**
     * 
     * @type {string}
     * @memberof CreatePurchaseApplicationRequestAttachmentsInner
     */
    'fileName': string;
    /**
     * 
     * @type {string}
     * @memberof CreatePurchaseApplicationRequestAttachmentsInner
     */
    'data': string;
}
/**
 * 
 * @export
 * @interface CreatePurchaseApplicationTemplateRequest
 */
export interface CreatePurchaseApplicationTemplateRequest {
    /**
     * 
     * @type {string}
     * @memberof CreatePurchaseApplicationTemplateRequest
     */
    'templateName': string;
    /**
     * 
     * @type {string}
     * @memberof CreatePurchaseApplicationTemplateRequest
     */
    'scopeDisclosure': CreatePurchaseApplicationTemplateRequestScopeDisclosureEnum;
    /**
     * 
     * @type {string}
     * @memberof CreatePurchaseApplicationTemplateRequest
     */
    'templateCategory': string;
    /**
     * 
     * @type {string}
     * @memberof CreatePurchaseApplicationTemplateRequest
     */
    'templateDetail': string;
    /**
     * 
     * @type {string}
     * @memberof CreatePurchaseApplicationTemplateRequest
     */
    'department': string;
    /**
     * 
     * @type {string}
     * @memberof CreatePurchaseApplicationTemplateRequest
     */
    'purchaseReason': string;
    /**
     * 
     * @type {string}
     * @memberof CreatePurchaseApplicationTemplateRequest
     */
    'purchaseDetails': string;
    /**
     * 
     * @type {string}
     * @memberof CreatePurchaseApplicationTemplateRequest
     */
    'placeOfUse': string;
    /**
     * 
     * @type {string}
     * @memberof CreatePurchaseApplicationTemplateRequest
     */
    'purposeOfUse': CreatePurchaseApplicationTemplateRequestPurposeOfUseEnum;
    /**
     * 
     * @type {string}
     * @memberof CreatePurchaseApplicationTemplateRequest
     */
    'url': string;
    /**
     * 
     * @type {number}
     * @memberof CreatePurchaseApplicationTemplateRequest
     */
    'amount': number | null;
    /**
     * 
     * @type {string}
     * @memberof CreatePurchaseApplicationTemplateRequest
     */
    'userAccountId': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreatePurchaseApplicationTemplateRequest
     */
    'isOnDemandCard': boolean;
    /**
     * 
     * @type {string}
     * @memberof CreatePurchaseApplicationTemplateRequest
     */
    'remarks': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreatePurchaseApplicationTemplateRequest
     */
    'approvers': Array<string>;
}

export const CreatePurchaseApplicationTemplateRequestScopeDisclosureEnum = {
    public: 'PUBLIC',
    individual: 'INDIVIDUAL'
} as const;

export type CreatePurchaseApplicationTemplateRequestScopeDisclosureEnum = typeof CreatePurchaseApplicationTemplateRequestScopeDisclosureEnum[keyof typeof CreatePurchaseApplicationTemplateRequestScopeDisclosureEnum];
export const CreatePurchaseApplicationTemplateRequestPurposeOfUseEnum = {
    software: 'SOFTWARE',
    fixtures: 'FIXTURES',
    conference: 'CONFERENCE',
    entertainment: 'ENTERTAINMENT',
    travel: 'TRAVEL',
    other: 'OTHER',
    initialValue: 'INITIAL_VALUE'
} as const;

export type CreatePurchaseApplicationTemplateRequestPurposeOfUseEnum = typeof CreatePurchaseApplicationTemplateRequestPurposeOfUseEnum[keyof typeof CreatePurchaseApplicationTemplateRequestPurposeOfUseEnum];

/**
 * 
 * @export
 * @interface CreateSlackCardNotificationsRequest
 */
export interface CreateSlackCardNotificationsRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateSlackCardNotificationsRequest
     */
    'channelId': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateSlackCardNotificationsRequest
     */
    'transactionTypes': Array<CreateSlackCardNotificationsRequestTransactionTypesEnum>;
    /**
     * 
     * @type {number}
     * @memberof CreateSlackCardNotificationsRequest
     */
    'largeAmountThreshold'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateSlackCardNotificationsRequest
     */
    'userAccountIds': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateSlackCardNotificationsRequest
     */
    'groupIds': Array<string>;
}

export const CreateSlackCardNotificationsRequestTransactionTypesEnum = {
    unknownTransactionType: 'UNKNOWN_TRANSACTION_TYPE',
    successfulTransaction: 'SUCCESSFUL_TRANSACTION',
    incorrectCardInput: 'INCORRECT_CARD_INPUT',
    insufficientBalance: 'INSUFFICIENT_BALANCE',
    otherError: 'OTHER_ERROR',
    potentialFraud: 'POTENTIAL_FRAUD',
    criticalError: 'CRITICAL_ERROR',
    unusualUser: 'UNUSUAL_USER',
    limitationByUser: 'LIMITATION_BY_USER',
    unsupportedTransaction: 'UNSUPPORTED_TRANSACTION',
    carelessUser: 'CARELESS_USER'
} as const;

export type CreateSlackCardNotificationsRequestTransactionTypesEnum = typeof CreateSlackCardNotificationsRequestTransactionTypesEnum[keyof typeof CreateSlackCardNotificationsRequestTransactionTypesEnum];

/**
 * 
 * @export
 * @interface CreateSlackNotificationSettingsForPurchaseApplicationRequest
 */
export interface CreateSlackNotificationSettingsForPurchaseApplicationRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateSlackNotificationSettingsForPurchaseApplicationRequest
     */
    'channelId': string;
}
/**
 * 
 * @export
 * @interface CreateTeamsCardNotificationsRequest
 */
export interface CreateTeamsCardNotificationsRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateTeamsCardNotificationsRequest
     */
    'channelId': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateTeamsCardNotificationsRequest
     */
    'transactionTypes': Array<CreateTeamsCardNotificationsRequestTransactionTypesEnum>;
    /**
     * 
     * @type {number}
     * @memberof CreateTeamsCardNotificationsRequest
     */
    'largeAmountThreshold'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateTeamsCardNotificationsRequest
     */
    'userAccountIds': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateTeamsCardNotificationsRequest
     */
    'groupIds': Array<string>;
}

export const CreateTeamsCardNotificationsRequestTransactionTypesEnum = {
    unknownTransactionType: 'UNKNOWN_TRANSACTION_TYPE',
    successfulTransaction: 'SUCCESSFUL_TRANSACTION',
    incorrectCardInput: 'INCORRECT_CARD_INPUT',
    insufficientBalance: 'INSUFFICIENT_BALANCE',
    otherError: 'OTHER_ERROR',
    potentialFraud: 'POTENTIAL_FRAUD',
    criticalError: 'CRITICAL_ERROR',
    unusualUser: 'UNUSUAL_USER',
    limitationByUser: 'LIMITATION_BY_USER',
    unsupportedTransaction: 'UNSUPPORTED_TRANSACTION',
    carelessUser: 'CARELESS_USER'
} as const;

export type CreateTeamsCardNotificationsRequestTransactionTypesEnum = typeof CreateTeamsCardNotificationsRequestTransactionTypesEnum[keyof typeof CreateTeamsCardNotificationsRequestTransactionTypesEnum];

/**
 * 
 * @export
 * @interface CreateUserAccountGroups200ResponseInner
 */
export interface CreateUserAccountGroups200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof CreateUserAccountGroups200ResponseInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserAccountGroups200ResponseInner
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof CreateUserAccountGroups200ResponseInner
     */
    'sortNum': number;
}
/**
 * 
 * @export
 * @interface CreateUserAccountGroups400Response
 */
export interface CreateUserAccountGroups400Response {
    /**
     * 
     * @type {object}
     * @memberof CreateUserAccountGroups400Response
     */
    'errors': object;
}
/**
 * 
 * @export
 * @interface CreateUserAccountGroupsRequest
 */
export interface CreateUserAccountGroupsRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateUserAccountGroupsRequest
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface DeactivateCard200Response
 */
export interface DeactivateCard200Response {
    /**
     * 
     * @type {string}
     * @memberof DeactivateCard200Response
     */
    'cardId': string;
    /**
     * 
     * @type {boolean}
     * @memberof DeactivateCard200Response
     */
    'isActivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DeactivateCard200Response
     */
    'isDeactivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DeactivateCard200Response
     */
    'isLocked': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DeactivateCard200Response
     */
    'isSuspended': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DeactivateCard200Response
     */
    'isFrozen': boolean;
    /**
     * 
     * @type {string}
     * @memberof DeactivateCard200Response
     */
    'panLastFourDigits': string;
    /**
     * 
     * @type {string}
     * @memberof DeactivateCard200Response
     */
    'linkedUserAccountId': string;
    /**
     * 
     * @type {string}
     * @memberof DeactivateCard200Response
     */
    'createdAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof DeactivateCard200Response
     */
    'isActive': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DeactivateCard200Response
     */
    'isVirtualCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DeactivateCard200Response
     */
    'isCreditCard': boolean;
}
/**
 * 
 * @export
 * @interface Deal
 */
export interface Deal {
    /**
     * 
     * @type {string}
     * @memberof Deal
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Deal
     */
    'issuedAt': string;
    /**
     * 
     * @type {string}
     * @memberof Deal
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof Deal
     */
    'freeeDealId': string | null;
    /**
     * 
     * @type {string}
     * @memberof Deal
     */
    'freeePartnerId': string | null;
    /**
     * 
     * @type {number}
     * @memberof Deal
     */
    'partnerId': number | null;
    /**
     * 
     * @type {number}
     * @memberof Deal
     */
    'amountYen': number;
    /**
     * 
     * @type {string}
     * @memberof Deal
     */
    'visaTransactionReferenceId': string | null;
    /**
     * 
     * @type {string}
     * @memberof Deal
     */
    'status': DealStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof Deal
     */
    'cardHolder': string | null;
    /**
     * 
     * @type {DealJournalizedBy}
     * @memberof Deal
     */
    'journalizedBy': DealJournalizedBy | null;
    /**
     * 
     * @type {string}
     * @memberof Deal
     */
    'journalizedAt': string | null;
    /**
     * 
     * @type {DealIntegratedBy}
     * @memberof Deal
     */
    'integratedBy': DealIntegratedBy | null;
    /**
     * 
     * @type {string}
     * @memberof Deal
     */
    'integratedAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof Deal
     */
    'userAccountId': string | null;
    /**
     * 
     * @type {string}
     * @memberof Deal
     */
    'userAccountName': string | null;
    /**
     * 
     * @type {string}
     * @memberof Deal
     */
    'userAccountGroupId': string | null;
    /**
     * 
     * @type {string}
     * @memberof Deal
     */
    'userAccountGroupName': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof Deal
     */
    'isOnDemand': boolean | null;
    /**
     * 
     * @type {Array<DealJournalEntriesInner>}
     * @memberof Deal
     */
    'journalEntries': Array<DealJournalEntriesInner>;
    /**
     * 
     * @type {Array<DealCardTransactionEvidenceListInner>}
     * @memberof Deal
     */
    'cardTransactionEvidenceList': Array<DealCardTransactionEvidenceListInner>;
    /**
     * true if the deal has one or more evidences and those all are not qualified, which should be shown as a warning to users.
     * @type {boolean}
     * @memberof Deal
     */
    'isAllEvidencesNotQualified': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Deal
     */
    'canSync': boolean;
    /**
     * 
     * @type {DealInvoiceIssuer}
     * @memberof Deal
     */
    'invoiceIssuer': DealInvoiceIssuer | null;
}

export const DealStatusEnum = {
    notEntered: 'NOT_ENTERED',
    automaticJournalized: 'AUTOMATIC_JOURNALIZED',
    automaticIntegrated: 'AUTOMATIC_INTEGRATED',
    entering: 'ENTERING',
    journalized: 'JOURNALIZED',
    changedAfterJournalization: 'CHANGED_AFTER_JOURNALIZATION',
    integrated: 'INTEGRATED',
    changedAfterIntegration: 'CHANGED_AFTER_INTEGRATION',
    ignored: 'IGNORED',
    readyAutomaticIntegration: 'READY_AUTOMATIC_INTEGRATION'
} as const;

export type DealStatusEnum = typeof DealStatusEnum[keyof typeof DealStatusEnum];

/**
 * 
 * @export
 * @interface DealCardTransactionEvidenceListInner
 */
export interface DealCardTransactionEvidenceListInner {
    /**
     * 
     * @type {string}
     * @memberof DealCardTransactionEvidenceListInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof DealCardTransactionEvidenceListInner
     * @deprecated
     */
    'cardTransactionEvidenceId': string;
    /**
     * 
     * @type {string}
     * @memberof DealCardTransactionEvidenceListInner
     * @deprecated
     */
    'visaTransactionReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof DealCardTransactionEvidenceListInner
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof DealCardTransactionEvidenceListInner
     */
    'fileName': string;
    /**
     * 
     * @type {DealCardTransactionEvidenceListInnerCreatedBy}
     * @memberof DealCardTransactionEvidenceListInner
     */
    'createdBy': DealCardTransactionEvidenceListInnerCreatedBy;
    /**
     * 
     * @type {string}
     * @memberof DealCardTransactionEvidenceListInner
     */
    'uploadedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof DealCardTransactionEvidenceListInner
     */
    'isQualified': boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof DealCardTransactionEvidenceListInner
     */
    'asQualified': boolean | null;
}
/**
 * 
 * @export
 * @interface DealCardTransactionEvidenceListInnerCreatedBy
 */
export interface DealCardTransactionEvidenceListInnerCreatedBy {
    /**
     * 
     * @type {string}
     * @memberof DealCardTransactionEvidenceListInnerCreatedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof DealCardTransactionEvidenceListInnerCreatedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface DealEvidence
 */
export interface DealEvidence {
    /**
     * 
     * @type {string}
     * @memberof DealEvidence
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof DealEvidence
     * @deprecated
     */
    'cardTransactionEvidenceId': string;
    /**
     * 
     * @type {string}
     * @memberof DealEvidence
     * @deprecated
     */
    'visaTransactionReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof DealEvidence
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof DealEvidence
     */
    'fileName': string;
    /**
     * 
     * @type {DealEvidenceCreatedBy}
     * @memberof DealEvidence
     */
    'createdBy': DealEvidenceCreatedBy;
    /**
     * 
     * @type {string}
     * @memberof DealEvidence
     */
    'uploadedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof DealEvidence
     */
    'isQualified': boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof DealEvidence
     */
    'asQualified': boolean | null;
}
/**
 * 
 * @export
 * @interface DealEvidenceCreatedBy
 */
export interface DealEvidenceCreatedBy {
    /**
     * 
     * @type {string}
     * @memberof DealEvidenceCreatedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof DealEvidenceCreatedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface DealIntegratedBy
 */
export interface DealIntegratedBy {
    /**
     * 
     * @type {string}
     * @memberof DealIntegratedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof DealIntegratedBy
     */
    'name': string;
}
/**
 * null if none of the related evidences have been processed according to the invoicing system compliance. partnerId in this object is currently not supported and is always set as null.
 * @export
 * @interface DealInvoiceIssuer
 */
export interface DealInvoiceIssuer {
    /**
     * 
     * @type {string}
     * @memberof DealInvoiceIssuer
     */
    'name': string | null;
    /**
     * 
     * @type {string}
     * @memberof DealInvoiceIssuer
     */
    'registrationNumber': string | null;
    /**
     * isQualified retains the result of querying the 国税庁API to see if registrationNumber is qualified, as is.
     * @type {boolean}
     * @memberof DealInvoiceIssuer
     */
    'isQualified': boolean;
    /**
     * AsQualified indicates whether this issuer should be treated as a qualified invoice issuer within the user\'s system, even if the RegistrationNumber is not confirmed as qualified in the National Tax Agency\'s business registration system.
     * @type {boolean}
     * @memberof DealInvoiceIssuer
     */
    'asQualified': boolean;
    /**
     * 
     * @type {string}
     * @memberof DealInvoiceIssuer
     */
    'partnerId': string | null;
}
/**
 * 
 * @export
 * @interface DealJournalEntriesInner
 */
export interface DealJournalEntriesInner {
    /**
     * 
     * @type {string}
     * @memberof DealJournalEntriesInner
     */
    'id': string;
    /**
     * 
     * @type {number}
     * @memberof DealJournalEntriesInner
     */
    'amount': number | null;
    /**
     * 
     * @type {string}
     * @memberof DealJournalEntriesInner
     */
    'freeeAccountItemId': string | null;
    /**
     * 
     * @type {string}
     * @memberof DealJournalEntriesInner
     */
    'freeeTaxCode': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DealJournalEntriesInner
     */
    'isInvalidTaxCode': boolean;
    /**
     * 
     * @type {string}
     * @memberof DealJournalEntriesInner
     */
    'invalidTaxCodeCause': DealJournalEntriesInnerInvalidTaxCodeCauseEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof DealJournalEntriesInner
     */
    'freeeMemoTags': Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof DealJournalEntriesInner
     */
    'freeeSectionId': string | null;
    /**
     * 
     * @type {string}
     * @memberof DealJournalEntriesInner
     */
    'freeeItemId': string | null;
    /**
     * 
     * @type {string}
     * @memberof DealJournalEntriesInner
     */
    'segment1TagId': string | null;
    /**
     * 
     * @type {string}
     * @memberof DealJournalEntriesInner
     */
    'segment2TagId': string | null;
    /**
     * 
     * @type {string}
     * @memberof DealJournalEntriesInner
     */
    'segment3TagId': string | null;
    /**
     * 
     * @type {string}
     * @memberof DealJournalEntriesInner
     */
    'description': string | null;
}

export const DealJournalEntriesInnerInvalidTaxCodeCauseEnum = {
    qualifiedButPartDeduct: 'QUALIFIED_BUT_PART_DEDUCT',
    notQualifiedButFullDeduct: 'NOT_QUALIFIED_BUT_FULL_DEDUCT',
    preStartButPartDeduct: 'PRE_START_BUT_PART_DEDUCT',
    inconsistentDeductRate: 'INCONSISTENT_DEDUCT_RATE'
} as const;

export type DealJournalEntriesInnerInvalidTaxCodeCauseEnum = typeof DealJournalEntriesInnerInvalidTaxCodeCauseEnum[keyof typeof DealJournalEntriesInnerInvalidTaxCodeCauseEnum];

/**
 * 
 * @export
 * @interface DealJournalizedBy
 */
export interface DealJournalizedBy {
    /**
     * 
     * @type {string}
     * @memberof DealJournalizedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof DealJournalizedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface DealsSearchCriteriaForm
 */
export interface DealsSearchCriteriaForm {
    /**
     * 
     * @type {Array<string>}
     * @memberof DealsSearchCriteriaForm
     */
    'dealStatusList'?: Array<DealsSearchCriteriaFormDealStatusListEnum>;
    /**
     * 
     * @type {string}
     * @memberof DealsSearchCriteriaForm
     */
    'userAccountId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DealsSearchCriteriaForm
     */
    'userAccountGroupId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DealsSearchCriteriaForm
     */
    'dealKeyword'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DealsSearchCriteriaForm
     */
    'dealIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof DealsSearchCriteriaForm
     */
    'yearMonth'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DealsSearchCriteriaForm
     */
    'startDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DealsSearchCriteriaForm
     */
    'endDate'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DealsSearchCriteriaForm
     */
    'amountLowerLimit'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DealsSearchCriteriaForm
     */
    'amountUpperLimit'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DealsSearchCriteriaForm
     */
    'qualifiedEvidence'?: DealsSearchCriteriaFormQualifiedEvidenceEnum;
    /**
     * 
     * @type {number}
     * @memberof DealsSearchCriteriaForm
     */
    'accountItemId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DealsSearchCriteriaForm
     */
    'taxCode'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DealsSearchCriteriaForm
     */
    'itemId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DealsSearchCriteriaForm
     */
    'sectionId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DealsSearchCriteriaForm
     */
    'tagId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DealsSearchCriteriaForm
     */
    'partnerId'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof DealsSearchCriteriaForm
     */
    'canSync'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof DealsSearchCriteriaForm
     */
    'isInvalidTaxCode'?: boolean | null;
}

export const DealsSearchCriteriaFormDealStatusListEnum = {
    notEntered: 'NOT_ENTERED',
    automaticJournalized: 'AUTOMATIC_JOURNALIZED',
    automaticIntegrated: 'AUTOMATIC_INTEGRATED',
    entering: 'ENTERING',
    journalized: 'JOURNALIZED',
    changedAfterJournalization: 'CHANGED_AFTER_JOURNALIZATION',
    integrated: 'INTEGRATED',
    changedAfterIntegration: 'CHANGED_AFTER_INTEGRATION',
    ignored: 'IGNORED',
    readyAutomaticIntegration: 'READY_AUTOMATIC_INTEGRATION'
} as const;

export type DealsSearchCriteriaFormDealStatusListEnum = typeof DealsSearchCriteriaFormDealStatusListEnum[keyof typeof DealsSearchCriteriaFormDealStatusListEnum];
export const DealsSearchCriteriaFormQualifiedEvidenceEnum = {
    allNotQualified: 'ALL_NOT_QUALIFIED',
    containQualified: 'CONTAIN_QUALIFIED'
} as const;

export type DealsSearchCriteriaFormQualifiedEvidenceEnum = typeof DealsSearchCriteriaFormQualifiedEvidenceEnum[keyof typeof DealsSearchCriteriaFormQualifiedEvidenceEnum];

/**
 * 
 * @export
 * @interface Default400Error
 */
export interface Default400Error {
    /**
     * 
     * @type {string}
     * @memberof Default400Error
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof Default400Error
     */
    'message': string;
    /**
     * 
     * @type {Array<Default400ErrorDetailsInner>}
     * @memberof Default400Error
     */
    'details'?: Array<Default400ErrorDetailsInner>;
}
/**
 * 
 * @export
 * @interface Default400ErrorDetail
 */
export interface Default400ErrorDetail {
    /**
     * 
     * @type {string}
     * @memberof Default400ErrorDetail
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof Default400ErrorDetail
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface Default400ErrorDetailsInner
 */
export interface Default400ErrorDetailsInner {
    /**
     * 
     * @type {string}
     * @memberof Default400ErrorDetailsInner
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof Default400ErrorDetailsInner
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface DefrostCard200Response
 */
export interface DefrostCard200Response {
    /**
     * 
     * @type {string}
     * @memberof DefrostCard200Response
     */
    'cardId': string;
    /**
     * 
     * @type {boolean}
     * @memberof DefrostCard200Response
     */
    'isActivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DefrostCard200Response
     */
    'isDeactivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DefrostCard200Response
     */
    'isLocked': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DefrostCard200Response
     */
    'isSuspended': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DefrostCard200Response
     */
    'isFrozen': boolean;
    /**
     * 
     * @type {string}
     * @memberof DefrostCard200Response
     */
    'panLastFourDigits': string;
    /**
     * 
     * @type {string}
     * @memberof DefrostCard200Response
     */
    'linkedUserAccountId': string;
    /**
     * 
     * @type {string}
     * @memberof DefrostCard200Response
     */
    'createdAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof DefrostCard200Response
     */
    'isActive': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DefrostCard200Response
     */
    'isVirtualCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DefrostCard200Response
     */
    'isCreditCard': boolean;
}
/**
 * 
 * @export
 * @interface DeleteFreeeConnected200Response
 */
export interface DeleteFreeeConnected200Response {
    /**
     * 
     * @type {boolean}
     * @memberof DeleteFreeeConnected200Response
     */
    'disconnected': boolean;
}
/**
 * 
 * @export
 * @interface DeleteUserAccountGroup200ResponseInner
 */
export interface DeleteUserAccountGroup200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof DeleteUserAccountGroup200ResponseInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof DeleteUserAccountGroup200ResponseInner
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof DeleteUserAccountGroup200ResponseInner
     */
    'sortNum': number;
}
/**
 * 
 * @export
 * @interface DepositGuaranteeMoneyBalanceRequest
 */
export interface DepositGuaranteeMoneyBalanceRequest {
    /**
     * 
     * @type {string}
     * @memberof DepositGuaranteeMoneyBalanceRequest
     */
    'amount': string;
}
/**
 * 
 * @export
 * @interface DepositRestriction
 */
export interface DepositRestriction {
    /**
     * ID番号
     * @type {string}
     * @memberof DepositRestriction
     */
    'id': string;
    /**
     * 企業ID
     * @type {string}
     * @memberof DepositRestriction
     */
    'organizationId': string;
    /**
     * 入金禁止フラグ
     * @type {boolean}
     * @memberof DepositRestriction
     */
    'depositBlocked': boolean;
    /**
     * 入金制限開始日時
     * @type {string}
     * @memberof DepositRestriction
     */
    'startAt': string;
    /**
     * 入金制限終了日時
     * @type {string}
     * @memberof DepositRestriction
     */
    'endAt': string;
}
/**
 * 
 * @export
 * @interface DisableApproval200Response
 */
export interface DisableApproval200Response {
    /**
     * 
     * @type {string}
     * @memberof DisableApproval200Response
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof DisableApproval200Response
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof DisableApproval200Response
     */
    'representativeName': string;
    /**
     * 
     * @type {string}
     * @memberof DisableApproval200Response
     */
    'phoneNumber': string;
    /**
     * 
     * @type {string}
     * @memberof DisableApproval200Response
     */
    'postalCode': string;
    /**
     * 
     * @type {string}
     * @memberof DisableApproval200Response
     */
    'address': string;
    /**
     * 
     * @type {string}
     * @memberof DisableApproval200Response
     */
    'deliveryPostalCode': string;
    /**
     * 
     * @type {string}
     * @memberof DisableApproval200Response
     */
    'deliveryAddress': string;
    /**
     * 
     * @type {string}
     * @memberof DisableApproval200Response
     */
    'invoiceEmail': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DisableApproval200Response
     */
    'isApprovalFeatureEnabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof DisableApproval200Response
     */
    'identityVerificationScheduledDate': string | null;
}
/**
 * 
 * @export
 * @interface DisableDailyUserUsageLimit200Response
 */
export interface DisableDailyUserUsageLimit200Response {
    /**
     * 
     * @type {string}
     * @memberof DisableDailyUserUsageLimit200Response
     */
    'cardId': string;
    /**
     * 
     * @type {string}
     * @memberof DisableDailyUserUsageLimit200Response
     */
    'cardLabel': string;
    /**
     * 
     * @type {boolean}
     * @memberof DisableDailyUserUsageLimit200Response
     */
    'isActivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisableDailyUserUsageLimit200Response
     */
    'isDeactivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisableDailyUserUsageLimit200Response
     */
    'isLocked': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisableDailyUserUsageLimit200Response
     */
    'isSuspended': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisableDailyUserUsageLimit200Response
     */
    'isFrozen': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisableDailyUserUsageLimit200Response
     */
    'isVirtualCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisableDailyUserUsageLimit200Response
     */
    'isCreditCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisableDailyUserUsageLimit200Response
     */
    'isOnDemand': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisableDailyUserUsageLimit200Response
     */
    'isMetalCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisableDailyUserUsageLimit200Response
     */
    'isPhysicalStorePaymentDisabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof DisableDailyUserUsageLimit200Response
     */
    'panLastFourDigits': string;
    /**
     * 
     * @type {string}
     * @memberof DisableDailyUserUsageLimit200Response
     */
    'userAccountId': string;
    /**
     * 
     * @type {number}
     * @memberof DisableDailyUserUsageLimit200Response
     */
    'transactionUpperLimit': number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DisableDailyUserUsageLimit200Response
     */
    'availableCurrencies': Array<DisableDailyUserUsageLimit200ResponseAvailableCurrenciesEnum>;
    /**
     * 
     * @type {Array<DisableDailyUserUsageLimit200ResponseAvailableMerchantCategoriesInner>}
     * @memberof DisableDailyUserUsageLimit200Response
     */
    'availableMerchantCategories': Array<DisableDailyUserUsageLimit200ResponseAvailableMerchantCategoriesInner> | null;
    /**
     * 
     * @type {DisableDailyUserUsageLimit200ResponseUser}
     * @memberof DisableDailyUserUsageLimit200Response
     */
    'user': DisableDailyUserUsageLimit200ResponseUser;
    /**
     * 
     * @type {DisableDailyUserUsageLimit200ResponseUserAccountGroup}
     * @memberof DisableDailyUserUsageLimit200Response
     */
    'userAccountGroup'?: DisableDailyUserUsageLimit200ResponseUserAccountGroup | null;
    /**
     * 
     * @type {number}
     * @memberof DisableDailyUserUsageLimit200Response
     */
    'monthlyTotalUsage': number;
    /**
     * 
     * @type {number}
     * @memberof DisableDailyUserUsageLimit200Response
     */
    'monthlyUsageLimit': number | null;
    /**
     * 
     * @type {number}
     * @memberof DisableDailyUserUsageLimit200Response
     */
    'dailyTotalUsage': number;
    /**
     * 
     * @type {number}
     * @memberof DisableDailyUserUsageLimit200Response
     */
    'dailyUsageLimit': number | null;
    /**
     * 
     * @type {number}
     * @memberof DisableDailyUserUsageLimit200Response
     */
    'totalUsageAmount': number;
    /**
     * 
     * @type {number}
     * @memberof DisableDailyUserUsageLimit200Response
     */
    'totalUsageAmountLimit': number | null;
    /**
     * 
     * @type {string}
     * @memberof DisableDailyUserUsageLimit200Response
     */
    'expiredDate': string | null;
}

export const DisableDailyUserUsageLimit200ResponseAvailableCurrenciesEnum = {
    jpy: 'JPY',
    usd: 'USD',
    gbp: 'GBP',
    eur: 'EUR',
    sgd: 'SGD',
    aud: 'AUD',
    cny: 'CNY',
    hkd: 'HKD',
    idr: 'IDR',
    krw: 'KRW',
    nzd: 'NZD',
    php: 'PHP',
    rub: 'RUB',
    vnd: 'VND',
    inr: 'INR',
    thb: 'THB',
    lak: 'LAK',
    myr: 'MYR',
    twd: 'TWD',
    chf: 'CHF',
    cad: 'CAD',
    mxn: 'MXN',
    nok: 'NOK',
    huf: 'HUF',
    hrk: 'HRK',
    czk: 'CZK',
    dkk: 'DKK',
    isk: 'ISK',
    mdl: 'MDL',
    sek: 'SEK',
    mkd: 'MKD',
    rsd: 'RSD',
    ron: 'RON',
    bgn: 'BGN',
    bam: 'BAM',
    pln: 'PLN',
    mad: 'MAD',
    zar: 'ZAR',
    rwf: 'RWF',
    kes: 'KES',
    ngn: 'NGN',
    aed: 'AED',
    sar: 'SAR',
    egp: 'EGP',
    qar: 'QAR',
    omr: 'OMR',
    ils: 'ILS',
    try: 'TRY',
    kzt: 'KZT',
    cop: 'COP',
    gtq: 'GTQ'
} as const;

export type DisableDailyUserUsageLimit200ResponseAvailableCurrenciesEnum = typeof DisableDailyUserUsageLimit200ResponseAvailableCurrenciesEnum[keyof typeof DisableDailyUserUsageLimit200ResponseAvailableCurrenciesEnum];

/**
 * 
 * @export
 * @interface DisableDailyUserUsageLimit200ResponseAvailableMerchantCategoriesInner
 */
export interface DisableDailyUserUsageLimit200ResponseAvailableMerchantCategoriesInner {
    /**
     * 
     * @type {string}
     * @memberof DisableDailyUserUsageLimit200ResponseAvailableMerchantCategoriesInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof DisableDailyUserUsageLimit200ResponseAvailableMerchantCategoriesInner
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof DisableDailyUserUsageLimit200ResponseAvailableMerchantCategoriesInner
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof DisableDailyUserUsageLimit200ResponseAvailableMerchantCategoriesInner
     */
    'logoUrl': string;
}
/**
 * 
 * @export
 * @interface DisableDailyUserUsageLimit200ResponseUser
 */
export interface DisableDailyUserUsageLimit200ResponseUser {
    /**
     * 
     * @type {string}
     * @memberof DisableDailyUserUsageLimit200ResponseUser
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof DisableDailyUserUsageLimit200ResponseUser
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof DisableDailyUserUsageLimit200ResponseUser
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof DisableDailyUserUsageLimit200ResponseUser
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof DisableDailyUserUsageLimit200ResponseUser
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DisableDailyUserUsageLimit200ResponseUser
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisableDailyUserUsageLimit200ResponseUser
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisableDailyUserUsageLimit200ResponseUser
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisableDailyUserUsageLimit200ResponseUser
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisableDailyUserUsageLimit200ResponseUser
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof DisableDailyUserUsageLimit200ResponseUser
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface DisableDailyUserUsageLimit200ResponseUserAccountGroup
 */
export interface DisableDailyUserUsageLimit200ResponseUserAccountGroup {
    /**
     * 
     * @type {string}
     * @memberof DisableDailyUserUsageLimit200ResponseUserAccountGroup
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof DisableDailyUserUsageLimit200ResponseUserAccountGroup
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof DisableDailyUserUsageLimit200ResponseUserAccountGroup
     */
    'sortNum': number;
}
/**
 * 
 * @export
 * @interface DisablePhysicalStorePaymentForTheUserAccount200Response
 */
export interface DisablePhysicalStorePaymentForTheUserAccount200Response {
    /**
     * 
     * @type {string}
     * @memberof DisablePhysicalStorePaymentForTheUserAccount200Response
     */
    'cardId': string;
    /**
     * 
     * @type {string}
     * @memberof DisablePhysicalStorePaymentForTheUserAccount200Response
     */
    'cardLabel': string;
    /**
     * 
     * @type {boolean}
     * @memberof DisablePhysicalStorePaymentForTheUserAccount200Response
     */
    'isActivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisablePhysicalStorePaymentForTheUserAccount200Response
     */
    'isDeactivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisablePhysicalStorePaymentForTheUserAccount200Response
     */
    'isLocked': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisablePhysicalStorePaymentForTheUserAccount200Response
     */
    'isSuspended': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisablePhysicalStorePaymentForTheUserAccount200Response
     */
    'isFrozen': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisablePhysicalStorePaymentForTheUserAccount200Response
     */
    'isVirtualCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisablePhysicalStorePaymentForTheUserAccount200Response
     */
    'isCreditCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisablePhysicalStorePaymentForTheUserAccount200Response
     */
    'isOnDemand': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisablePhysicalStorePaymentForTheUserAccount200Response
     */
    'isMetalCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisablePhysicalStorePaymentForTheUserAccount200Response
     */
    'isPhysicalStorePaymentDisabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof DisablePhysicalStorePaymentForTheUserAccount200Response
     */
    'panLastFourDigits': string;
    /**
     * 
     * @type {string}
     * @memberof DisablePhysicalStorePaymentForTheUserAccount200Response
     */
    'userAccountId': string;
    /**
     * 
     * @type {number}
     * @memberof DisablePhysicalStorePaymentForTheUserAccount200Response
     */
    'transactionUpperLimit': number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DisablePhysicalStorePaymentForTheUserAccount200Response
     */
    'availableCurrencies': Array<DisablePhysicalStorePaymentForTheUserAccount200ResponseAvailableCurrenciesEnum>;
    /**
     * 
     * @type {Array<DisablePhysicalStorePaymentForTheUserAccount200ResponseAvailableMerchantCategoriesInner>}
     * @memberof DisablePhysicalStorePaymentForTheUserAccount200Response
     */
    'availableMerchantCategories': Array<DisablePhysicalStorePaymentForTheUserAccount200ResponseAvailableMerchantCategoriesInner> | null;
    /**
     * 
     * @type {DisablePhysicalStorePaymentForTheUserAccount200ResponseUser}
     * @memberof DisablePhysicalStorePaymentForTheUserAccount200Response
     */
    'user': DisablePhysicalStorePaymentForTheUserAccount200ResponseUser;
    /**
     * 
     * @type {DisablePhysicalStorePaymentForTheUserAccount200ResponseUserAccountGroup}
     * @memberof DisablePhysicalStorePaymentForTheUserAccount200Response
     */
    'userAccountGroup'?: DisablePhysicalStorePaymentForTheUserAccount200ResponseUserAccountGroup | null;
    /**
     * 
     * @type {number}
     * @memberof DisablePhysicalStorePaymentForTheUserAccount200Response
     */
    'monthlyTotalUsage': number;
    /**
     * 
     * @type {number}
     * @memberof DisablePhysicalStorePaymentForTheUserAccount200Response
     */
    'monthlyUsageLimit': number | null;
    /**
     * 
     * @type {number}
     * @memberof DisablePhysicalStorePaymentForTheUserAccount200Response
     */
    'dailyTotalUsage': number;
    /**
     * 
     * @type {number}
     * @memberof DisablePhysicalStorePaymentForTheUserAccount200Response
     */
    'dailyUsageLimit': number | null;
    /**
     * 
     * @type {number}
     * @memberof DisablePhysicalStorePaymentForTheUserAccount200Response
     */
    'totalUsageAmount': number;
    /**
     * 
     * @type {number}
     * @memberof DisablePhysicalStorePaymentForTheUserAccount200Response
     */
    'totalUsageAmountLimit': number | null;
    /**
     * 
     * @type {string}
     * @memberof DisablePhysicalStorePaymentForTheUserAccount200Response
     */
    'expiredDate': string | null;
}

export const DisablePhysicalStorePaymentForTheUserAccount200ResponseAvailableCurrenciesEnum = {
    jpy: 'JPY',
    usd: 'USD',
    gbp: 'GBP',
    eur: 'EUR',
    sgd: 'SGD',
    aud: 'AUD',
    cny: 'CNY',
    hkd: 'HKD',
    idr: 'IDR',
    krw: 'KRW',
    nzd: 'NZD',
    php: 'PHP',
    rub: 'RUB',
    vnd: 'VND',
    inr: 'INR',
    thb: 'THB',
    lak: 'LAK',
    myr: 'MYR',
    twd: 'TWD',
    chf: 'CHF',
    cad: 'CAD',
    mxn: 'MXN',
    nok: 'NOK',
    huf: 'HUF',
    hrk: 'HRK',
    czk: 'CZK',
    dkk: 'DKK',
    isk: 'ISK',
    mdl: 'MDL',
    sek: 'SEK',
    mkd: 'MKD',
    rsd: 'RSD',
    ron: 'RON',
    bgn: 'BGN',
    bam: 'BAM',
    pln: 'PLN',
    mad: 'MAD',
    zar: 'ZAR',
    rwf: 'RWF',
    kes: 'KES',
    ngn: 'NGN',
    aed: 'AED',
    sar: 'SAR',
    egp: 'EGP',
    qar: 'QAR',
    omr: 'OMR',
    ils: 'ILS',
    try: 'TRY',
    kzt: 'KZT',
    cop: 'COP',
    gtq: 'GTQ'
} as const;

export type DisablePhysicalStorePaymentForTheUserAccount200ResponseAvailableCurrenciesEnum = typeof DisablePhysicalStorePaymentForTheUserAccount200ResponseAvailableCurrenciesEnum[keyof typeof DisablePhysicalStorePaymentForTheUserAccount200ResponseAvailableCurrenciesEnum];

/**
 * 
 * @export
 * @interface DisablePhysicalStorePaymentForTheUserAccount200ResponseAvailableMerchantCategoriesInner
 */
export interface DisablePhysicalStorePaymentForTheUserAccount200ResponseAvailableMerchantCategoriesInner {
    /**
     * 
     * @type {string}
     * @memberof DisablePhysicalStorePaymentForTheUserAccount200ResponseAvailableMerchantCategoriesInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof DisablePhysicalStorePaymentForTheUserAccount200ResponseAvailableMerchantCategoriesInner
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof DisablePhysicalStorePaymentForTheUserAccount200ResponseAvailableMerchantCategoriesInner
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof DisablePhysicalStorePaymentForTheUserAccount200ResponseAvailableMerchantCategoriesInner
     */
    'logoUrl': string;
}
/**
 * 
 * @export
 * @interface DisablePhysicalStorePaymentForTheUserAccount200ResponseUser
 */
export interface DisablePhysicalStorePaymentForTheUserAccount200ResponseUser {
    /**
     * 
     * @type {string}
     * @memberof DisablePhysicalStorePaymentForTheUserAccount200ResponseUser
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof DisablePhysicalStorePaymentForTheUserAccount200ResponseUser
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof DisablePhysicalStorePaymentForTheUserAccount200ResponseUser
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof DisablePhysicalStorePaymentForTheUserAccount200ResponseUser
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof DisablePhysicalStorePaymentForTheUserAccount200ResponseUser
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DisablePhysicalStorePaymentForTheUserAccount200ResponseUser
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisablePhysicalStorePaymentForTheUserAccount200ResponseUser
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisablePhysicalStorePaymentForTheUserAccount200ResponseUser
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisablePhysicalStorePaymentForTheUserAccount200ResponseUser
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisablePhysicalStorePaymentForTheUserAccount200ResponseUser
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof DisablePhysicalStorePaymentForTheUserAccount200ResponseUser
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface DisablePhysicalStorePaymentForTheUserAccount200ResponseUserAccountGroup
 */
export interface DisablePhysicalStorePaymentForTheUserAccount200ResponseUserAccountGroup {
    /**
     * 
     * @type {string}
     * @memberof DisablePhysicalStorePaymentForTheUserAccount200ResponseUserAccountGroup
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof DisablePhysicalStorePaymentForTheUserAccount200ResponseUserAccountGroup
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof DisablePhysicalStorePaymentForTheUserAccount200ResponseUserAccountGroup
     */
    'sortNum': number;
}
/**
 * 
 * @export
 * @interface DisableTransactionUpperLimitForTheUserAccount200Response
 */
export interface DisableTransactionUpperLimitForTheUserAccount200Response {
    /**
     * 
     * @type {string}
     * @memberof DisableTransactionUpperLimitForTheUserAccount200Response
     */
    'cardId': string;
    /**
     * 
     * @type {string}
     * @memberof DisableTransactionUpperLimitForTheUserAccount200Response
     */
    'cardLabel': string;
    /**
     * 
     * @type {boolean}
     * @memberof DisableTransactionUpperLimitForTheUserAccount200Response
     */
    'isActivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisableTransactionUpperLimitForTheUserAccount200Response
     */
    'isDeactivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisableTransactionUpperLimitForTheUserAccount200Response
     */
    'isLocked': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisableTransactionUpperLimitForTheUserAccount200Response
     */
    'isSuspended': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisableTransactionUpperLimitForTheUserAccount200Response
     */
    'isFrozen': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisableTransactionUpperLimitForTheUserAccount200Response
     */
    'isVirtualCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisableTransactionUpperLimitForTheUserAccount200Response
     */
    'isCreditCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisableTransactionUpperLimitForTheUserAccount200Response
     */
    'isOnDemand': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisableTransactionUpperLimitForTheUserAccount200Response
     */
    'isMetalCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisableTransactionUpperLimitForTheUserAccount200Response
     */
    'isPhysicalStorePaymentDisabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof DisableTransactionUpperLimitForTheUserAccount200Response
     */
    'panLastFourDigits': string;
    /**
     * 
     * @type {string}
     * @memberof DisableTransactionUpperLimitForTheUserAccount200Response
     */
    'userAccountId': string;
    /**
     * 
     * @type {number}
     * @memberof DisableTransactionUpperLimitForTheUserAccount200Response
     */
    'transactionUpperLimit': number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DisableTransactionUpperLimitForTheUserAccount200Response
     */
    'availableCurrencies': Array<DisableTransactionUpperLimitForTheUserAccount200ResponseAvailableCurrenciesEnum>;
    /**
     * 
     * @type {Array<DisableTransactionUpperLimitForTheUserAccount200ResponseAvailableMerchantCategoriesInner>}
     * @memberof DisableTransactionUpperLimitForTheUserAccount200Response
     */
    'availableMerchantCategories': Array<DisableTransactionUpperLimitForTheUserAccount200ResponseAvailableMerchantCategoriesInner> | null;
    /**
     * 
     * @type {DisableTransactionUpperLimitForTheUserAccount200ResponseUser}
     * @memberof DisableTransactionUpperLimitForTheUserAccount200Response
     */
    'user': DisableTransactionUpperLimitForTheUserAccount200ResponseUser;
    /**
     * 
     * @type {DisableTransactionUpperLimitForTheUserAccount200ResponseUserAccountGroup}
     * @memberof DisableTransactionUpperLimitForTheUserAccount200Response
     */
    'userAccountGroup'?: DisableTransactionUpperLimitForTheUserAccount200ResponseUserAccountGroup | null;
    /**
     * 
     * @type {number}
     * @memberof DisableTransactionUpperLimitForTheUserAccount200Response
     */
    'monthlyTotalUsage': number;
    /**
     * 
     * @type {number}
     * @memberof DisableTransactionUpperLimitForTheUserAccount200Response
     */
    'monthlyUsageLimit': number | null;
    /**
     * 
     * @type {number}
     * @memberof DisableTransactionUpperLimitForTheUserAccount200Response
     */
    'dailyTotalUsage': number;
    /**
     * 
     * @type {number}
     * @memberof DisableTransactionUpperLimitForTheUserAccount200Response
     */
    'dailyUsageLimit': number | null;
    /**
     * 
     * @type {number}
     * @memberof DisableTransactionUpperLimitForTheUserAccount200Response
     */
    'totalUsageAmount': number;
    /**
     * 
     * @type {number}
     * @memberof DisableTransactionUpperLimitForTheUserAccount200Response
     */
    'totalUsageAmountLimit': number | null;
    /**
     * 
     * @type {string}
     * @memberof DisableTransactionUpperLimitForTheUserAccount200Response
     */
    'expiredDate': string | null;
}

export const DisableTransactionUpperLimitForTheUserAccount200ResponseAvailableCurrenciesEnum = {
    jpy: 'JPY',
    usd: 'USD',
    gbp: 'GBP',
    eur: 'EUR',
    sgd: 'SGD',
    aud: 'AUD',
    cny: 'CNY',
    hkd: 'HKD',
    idr: 'IDR',
    krw: 'KRW',
    nzd: 'NZD',
    php: 'PHP',
    rub: 'RUB',
    vnd: 'VND',
    inr: 'INR',
    thb: 'THB',
    lak: 'LAK',
    myr: 'MYR',
    twd: 'TWD',
    chf: 'CHF',
    cad: 'CAD',
    mxn: 'MXN',
    nok: 'NOK',
    huf: 'HUF',
    hrk: 'HRK',
    czk: 'CZK',
    dkk: 'DKK',
    isk: 'ISK',
    mdl: 'MDL',
    sek: 'SEK',
    mkd: 'MKD',
    rsd: 'RSD',
    ron: 'RON',
    bgn: 'BGN',
    bam: 'BAM',
    pln: 'PLN',
    mad: 'MAD',
    zar: 'ZAR',
    rwf: 'RWF',
    kes: 'KES',
    ngn: 'NGN',
    aed: 'AED',
    sar: 'SAR',
    egp: 'EGP',
    qar: 'QAR',
    omr: 'OMR',
    ils: 'ILS',
    try: 'TRY',
    kzt: 'KZT',
    cop: 'COP',
    gtq: 'GTQ'
} as const;

export type DisableTransactionUpperLimitForTheUserAccount200ResponseAvailableCurrenciesEnum = typeof DisableTransactionUpperLimitForTheUserAccount200ResponseAvailableCurrenciesEnum[keyof typeof DisableTransactionUpperLimitForTheUserAccount200ResponseAvailableCurrenciesEnum];

/**
 * 
 * @export
 * @interface DisableTransactionUpperLimitForTheUserAccount200ResponseAvailableMerchantCategoriesInner
 */
export interface DisableTransactionUpperLimitForTheUserAccount200ResponseAvailableMerchantCategoriesInner {
    /**
     * 
     * @type {string}
     * @memberof DisableTransactionUpperLimitForTheUserAccount200ResponseAvailableMerchantCategoriesInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof DisableTransactionUpperLimitForTheUserAccount200ResponseAvailableMerchantCategoriesInner
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof DisableTransactionUpperLimitForTheUserAccount200ResponseAvailableMerchantCategoriesInner
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof DisableTransactionUpperLimitForTheUserAccount200ResponseAvailableMerchantCategoriesInner
     */
    'logoUrl': string;
}
/**
 * 
 * @export
 * @interface DisableTransactionUpperLimitForTheUserAccount200ResponseUser
 */
export interface DisableTransactionUpperLimitForTheUserAccount200ResponseUser {
    /**
     * 
     * @type {string}
     * @memberof DisableTransactionUpperLimitForTheUserAccount200ResponseUser
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof DisableTransactionUpperLimitForTheUserAccount200ResponseUser
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof DisableTransactionUpperLimitForTheUserAccount200ResponseUser
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof DisableTransactionUpperLimitForTheUserAccount200ResponseUser
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof DisableTransactionUpperLimitForTheUserAccount200ResponseUser
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DisableTransactionUpperLimitForTheUserAccount200ResponseUser
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisableTransactionUpperLimitForTheUserAccount200ResponseUser
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisableTransactionUpperLimitForTheUserAccount200ResponseUser
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisableTransactionUpperLimitForTheUserAccount200ResponseUser
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisableTransactionUpperLimitForTheUserAccount200ResponseUser
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof DisableTransactionUpperLimitForTheUserAccount200ResponseUser
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface DisableTransactionUpperLimitForTheUserAccount200ResponseUserAccountGroup
 */
export interface DisableTransactionUpperLimitForTheUserAccount200ResponseUserAccountGroup {
    /**
     * 
     * @type {string}
     * @memberof DisableTransactionUpperLimitForTheUserAccount200ResponseUserAccountGroup
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof DisableTransactionUpperLimitForTheUserAccount200ResponseUserAccountGroup
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof DisableTransactionUpperLimitForTheUserAccount200ResponseUserAccountGroup
     */
    'sortNum': number;
}
/**
 * 
 * @export
 * @interface DisableUserUsageLimit200Response
 */
export interface DisableUserUsageLimit200Response {
    /**
     * 
     * @type {string}
     * @memberof DisableUserUsageLimit200Response
     */
    'cardId': string;
    /**
     * 
     * @type {string}
     * @memberof DisableUserUsageLimit200Response
     */
    'cardLabel': string;
    /**
     * 
     * @type {boolean}
     * @memberof DisableUserUsageLimit200Response
     */
    'isActivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisableUserUsageLimit200Response
     */
    'isDeactivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisableUserUsageLimit200Response
     */
    'isLocked': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisableUserUsageLimit200Response
     */
    'isSuspended': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisableUserUsageLimit200Response
     */
    'isFrozen': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisableUserUsageLimit200Response
     */
    'isVirtualCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisableUserUsageLimit200Response
     */
    'isCreditCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisableUserUsageLimit200Response
     */
    'isOnDemand': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisableUserUsageLimit200Response
     */
    'isMetalCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisableUserUsageLimit200Response
     */
    'isPhysicalStorePaymentDisabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof DisableUserUsageLimit200Response
     */
    'panLastFourDigits': string;
    /**
     * 
     * @type {string}
     * @memberof DisableUserUsageLimit200Response
     */
    'userAccountId': string;
    /**
     * 
     * @type {number}
     * @memberof DisableUserUsageLimit200Response
     */
    'transactionUpperLimit': number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DisableUserUsageLimit200Response
     */
    'availableCurrencies': Array<DisableUserUsageLimit200ResponseAvailableCurrenciesEnum>;
    /**
     * 
     * @type {Array<DisableUserUsageLimit200ResponseAvailableMerchantCategoriesInner>}
     * @memberof DisableUserUsageLimit200Response
     */
    'availableMerchantCategories': Array<DisableUserUsageLimit200ResponseAvailableMerchantCategoriesInner> | null;
    /**
     * 
     * @type {DisableUserUsageLimit200ResponseUser}
     * @memberof DisableUserUsageLimit200Response
     */
    'user': DisableUserUsageLimit200ResponseUser;
    /**
     * 
     * @type {DisableUserUsageLimit200ResponseUserAccountGroup}
     * @memberof DisableUserUsageLimit200Response
     */
    'userAccountGroup'?: DisableUserUsageLimit200ResponseUserAccountGroup | null;
    /**
     * 
     * @type {number}
     * @memberof DisableUserUsageLimit200Response
     */
    'monthlyTotalUsage': number;
    /**
     * 
     * @type {number}
     * @memberof DisableUserUsageLimit200Response
     */
    'monthlyUsageLimit': number | null;
    /**
     * 
     * @type {number}
     * @memberof DisableUserUsageLimit200Response
     */
    'dailyTotalUsage': number;
    /**
     * 
     * @type {number}
     * @memberof DisableUserUsageLimit200Response
     */
    'dailyUsageLimit': number | null;
    /**
     * 
     * @type {number}
     * @memberof DisableUserUsageLimit200Response
     */
    'totalUsageAmount': number;
    /**
     * 
     * @type {number}
     * @memberof DisableUserUsageLimit200Response
     */
    'totalUsageAmountLimit': number | null;
    /**
     * 
     * @type {string}
     * @memberof DisableUserUsageLimit200Response
     */
    'expiredDate': string | null;
}

export const DisableUserUsageLimit200ResponseAvailableCurrenciesEnum = {
    jpy: 'JPY',
    usd: 'USD',
    gbp: 'GBP',
    eur: 'EUR',
    sgd: 'SGD',
    aud: 'AUD',
    cny: 'CNY',
    hkd: 'HKD',
    idr: 'IDR',
    krw: 'KRW',
    nzd: 'NZD',
    php: 'PHP',
    rub: 'RUB',
    vnd: 'VND',
    inr: 'INR',
    thb: 'THB',
    lak: 'LAK',
    myr: 'MYR',
    twd: 'TWD',
    chf: 'CHF',
    cad: 'CAD',
    mxn: 'MXN',
    nok: 'NOK',
    huf: 'HUF',
    hrk: 'HRK',
    czk: 'CZK',
    dkk: 'DKK',
    isk: 'ISK',
    mdl: 'MDL',
    sek: 'SEK',
    mkd: 'MKD',
    rsd: 'RSD',
    ron: 'RON',
    bgn: 'BGN',
    bam: 'BAM',
    pln: 'PLN',
    mad: 'MAD',
    zar: 'ZAR',
    rwf: 'RWF',
    kes: 'KES',
    ngn: 'NGN',
    aed: 'AED',
    sar: 'SAR',
    egp: 'EGP',
    qar: 'QAR',
    omr: 'OMR',
    ils: 'ILS',
    try: 'TRY',
    kzt: 'KZT',
    cop: 'COP',
    gtq: 'GTQ'
} as const;

export type DisableUserUsageLimit200ResponseAvailableCurrenciesEnum = typeof DisableUserUsageLimit200ResponseAvailableCurrenciesEnum[keyof typeof DisableUserUsageLimit200ResponseAvailableCurrenciesEnum];

/**
 * 
 * @export
 * @interface DisableUserUsageLimit200ResponseAvailableMerchantCategoriesInner
 */
export interface DisableUserUsageLimit200ResponseAvailableMerchantCategoriesInner {
    /**
     * 
     * @type {string}
     * @memberof DisableUserUsageLimit200ResponseAvailableMerchantCategoriesInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof DisableUserUsageLimit200ResponseAvailableMerchantCategoriesInner
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof DisableUserUsageLimit200ResponseAvailableMerchantCategoriesInner
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof DisableUserUsageLimit200ResponseAvailableMerchantCategoriesInner
     */
    'logoUrl': string;
}
/**
 * 
 * @export
 * @interface DisableUserUsageLimit200ResponseUser
 */
export interface DisableUserUsageLimit200ResponseUser {
    /**
     * 
     * @type {string}
     * @memberof DisableUserUsageLimit200ResponseUser
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof DisableUserUsageLimit200ResponseUser
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof DisableUserUsageLimit200ResponseUser
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof DisableUserUsageLimit200ResponseUser
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof DisableUserUsageLimit200ResponseUser
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DisableUserUsageLimit200ResponseUser
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisableUserUsageLimit200ResponseUser
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisableUserUsageLimit200ResponseUser
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisableUserUsageLimit200ResponseUser
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DisableUserUsageLimit200ResponseUser
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof DisableUserUsageLimit200ResponseUser
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface DisableUserUsageLimit200ResponseUserAccountGroup
 */
export interface DisableUserUsageLimit200ResponseUserAccountGroup {
    /**
     * 
     * @type {string}
     * @memberof DisableUserUsageLimit200ResponseUserAccountGroup
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof DisableUserUsageLimit200ResponseUserAccountGroup
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof DisableUserUsageLimit200ResponseUserAccountGroup
     */
    'sortNum': number;
}
/**
 * 
 * @export
 * @interface DownloadPaymentRequestsCsvForPaymentRequestIdsSpecificationRequest
 */
export interface DownloadPaymentRequestsCsvForPaymentRequestIdsSpecificationRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof DownloadPaymentRequestsCsvForPaymentRequestIdsSpecificationRequest
     */
    'paymentRequestIds': Array<string>;
}
/**
 * 
 * @export
 * @interface EnablePhysicalStorePaymentForTheUserAccount200Response
 */
export interface EnablePhysicalStorePaymentForTheUserAccount200Response {
    /**
     * 
     * @type {string}
     * @memberof EnablePhysicalStorePaymentForTheUserAccount200Response
     */
    'cardId': string;
    /**
     * 
     * @type {string}
     * @memberof EnablePhysicalStorePaymentForTheUserAccount200Response
     */
    'cardLabel': string;
    /**
     * 
     * @type {boolean}
     * @memberof EnablePhysicalStorePaymentForTheUserAccount200Response
     */
    'isActivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EnablePhysicalStorePaymentForTheUserAccount200Response
     */
    'isDeactivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EnablePhysicalStorePaymentForTheUserAccount200Response
     */
    'isLocked': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EnablePhysicalStorePaymentForTheUserAccount200Response
     */
    'isSuspended': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EnablePhysicalStorePaymentForTheUserAccount200Response
     */
    'isFrozen': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EnablePhysicalStorePaymentForTheUserAccount200Response
     */
    'isVirtualCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EnablePhysicalStorePaymentForTheUserAccount200Response
     */
    'isCreditCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EnablePhysicalStorePaymentForTheUserAccount200Response
     */
    'isOnDemand': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EnablePhysicalStorePaymentForTheUserAccount200Response
     */
    'isMetalCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EnablePhysicalStorePaymentForTheUserAccount200Response
     */
    'isPhysicalStorePaymentDisabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof EnablePhysicalStorePaymentForTheUserAccount200Response
     */
    'panLastFourDigits': string;
    /**
     * 
     * @type {string}
     * @memberof EnablePhysicalStorePaymentForTheUserAccount200Response
     */
    'userAccountId': string;
    /**
     * 
     * @type {number}
     * @memberof EnablePhysicalStorePaymentForTheUserAccount200Response
     */
    'transactionUpperLimit': number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof EnablePhysicalStorePaymentForTheUserAccount200Response
     */
    'availableCurrencies': Array<EnablePhysicalStorePaymentForTheUserAccount200ResponseAvailableCurrenciesEnum>;
    /**
     * 
     * @type {Array<EnablePhysicalStorePaymentForTheUserAccount200ResponseAvailableMerchantCategoriesInner>}
     * @memberof EnablePhysicalStorePaymentForTheUserAccount200Response
     */
    'availableMerchantCategories': Array<EnablePhysicalStorePaymentForTheUserAccount200ResponseAvailableMerchantCategoriesInner> | null;
    /**
     * 
     * @type {EnablePhysicalStorePaymentForTheUserAccount200ResponseUser}
     * @memberof EnablePhysicalStorePaymentForTheUserAccount200Response
     */
    'user': EnablePhysicalStorePaymentForTheUserAccount200ResponseUser;
    /**
     * 
     * @type {EnablePhysicalStorePaymentForTheUserAccount200ResponseUserAccountGroup}
     * @memberof EnablePhysicalStorePaymentForTheUserAccount200Response
     */
    'userAccountGroup'?: EnablePhysicalStorePaymentForTheUserAccount200ResponseUserAccountGroup | null;
    /**
     * 
     * @type {number}
     * @memberof EnablePhysicalStorePaymentForTheUserAccount200Response
     */
    'monthlyTotalUsage': number;
    /**
     * 
     * @type {number}
     * @memberof EnablePhysicalStorePaymentForTheUserAccount200Response
     */
    'monthlyUsageLimit': number | null;
    /**
     * 
     * @type {number}
     * @memberof EnablePhysicalStorePaymentForTheUserAccount200Response
     */
    'dailyTotalUsage': number;
    /**
     * 
     * @type {number}
     * @memberof EnablePhysicalStorePaymentForTheUserAccount200Response
     */
    'dailyUsageLimit': number | null;
    /**
     * 
     * @type {number}
     * @memberof EnablePhysicalStorePaymentForTheUserAccount200Response
     */
    'totalUsageAmount': number;
    /**
     * 
     * @type {number}
     * @memberof EnablePhysicalStorePaymentForTheUserAccount200Response
     */
    'totalUsageAmountLimit': number | null;
    /**
     * 
     * @type {string}
     * @memberof EnablePhysicalStorePaymentForTheUserAccount200Response
     */
    'expiredDate': string | null;
}

export const EnablePhysicalStorePaymentForTheUserAccount200ResponseAvailableCurrenciesEnum = {
    jpy: 'JPY',
    usd: 'USD',
    gbp: 'GBP',
    eur: 'EUR',
    sgd: 'SGD',
    aud: 'AUD',
    cny: 'CNY',
    hkd: 'HKD',
    idr: 'IDR',
    krw: 'KRW',
    nzd: 'NZD',
    php: 'PHP',
    rub: 'RUB',
    vnd: 'VND',
    inr: 'INR',
    thb: 'THB',
    lak: 'LAK',
    myr: 'MYR',
    twd: 'TWD',
    chf: 'CHF',
    cad: 'CAD',
    mxn: 'MXN',
    nok: 'NOK',
    huf: 'HUF',
    hrk: 'HRK',
    czk: 'CZK',
    dkk: 'DKK',
    isk: 'ISK',
    mdl: 'MDL',
    sek: 'SEK',
    mkd: 'MKD',
    rsd: 'RSD',
    ron: 'RON',
    bgn: 'BGN',
    bam: 'BAM',
    pln: 'PLN',
    mad: 'MAD',
    zar: 'ZAR',
    rwf: 'RWF',
    kes: 'KES',
    ngn: 'NGN',
    aed: 'AED',
    sar: 'SAR',
    egp: 'EGP',
    qar: 'QAR',
    omr: 'OMR',
    ils: 'ILS',
    try: 'TRY',
    kzt: 'KZT',
    cop: 'COP',
    gtq: 'GTQ'
} as const;

export type EnablePhysicalStorePaymentForTheUserAccount200ResponseAvailableCurrenciesEnum = typeof EnablePhysicalStorePaymentForTheUserAccount200ResponseAvailableCurrenciesEnum[keyof typeof EnablePhysicalStorePaymentForTheUserAccount200ResponseAvailableCurrenciesEnum];

/**
 * 
 * @export
 * @interface EnablePhysicalStorePaymentForTheUserAccount200ResponseAvailableMerchantCategoriesInner
 */
export interface EnablePhysicalStorePaymentForTheUserAccount200ResponseAvailableMerchantCategoriesInner {
    /**
     * 
     * @type {string}
     * @memberof EnablePhysicalStorePaymentForTheUserAccount200ResponseAvailableMerchantCategoriesInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof EnablePhysicalStorePaymentForTheUserAccount200ResponseAvailableMerchantCategoriesInner
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof EnablePhysicalStorePaymentForTheUserAccount200ResponseAvailableMerchantCategoriesInner
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof EnablePhysicalStorePaymentForTheUserAccount200ResponseAvailableMerchantCategoriesInner
     */
    'logoUrl': string;
}
/**
 * 
 * @export
 * @interface EnablePhysicalStorePaymentForTheUserAccount200ResponseUser
 */
export interface EnablePhysicalStorePaymentForTheUserAccount200ResponseUser {
    /**
     * 
     * @type {string}
     * @memberof EnablePhysicalStorePaymentForTheUserAccount200ResponseUser
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof EnablePhysicalStorePaymentForTheUserAccount200ResponseUser
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof EnablePhysicalStorePaymentForTheUserAccount200ResponseUser
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof EnablePhysicalStorePaymentForTheUserAccount200ResponseUser
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof EnablePhysicalStorePaymentForTheUserAccount200ResponseUser
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof EnablePhysicalStorePaymentForTheUserAccount200ResponseUser
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EnablePhysicalStorePaymentForTheUserAccount200ResponseUser
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EnablePhysicalStorePaymentForTheUserAccount200ResponseUser
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EnablePhysicalStorePaymentForTheUserAccount200ResponseUser
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EnablePhysicalStorePaymentForTheUserAccount200ResponseUser
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof EnablePhysicalStorePaymentForTheUserAccount200ResponseUser
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface EnablePhysicalStorePaymentForTheUserAccount200ResponseUserAccountGroup
 */
export interface EnablePhysicalStorePaymentForTheUserAccount200ResponseUserAccountGroup {
    /**
     * 
     * @type {string}
     * @memberof EnablePhysicalStorePaymentForTheUserAccount200ResponseUserAccountGroup
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof EnablePhysicalStorePaymentForTheUserAccount200ResponseUserAccountGroup
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof EnablePhysicalStorePaymentForTheUserAccount200ResponseUserAccountGroup
     */
    'sortNum': number;
}
/**
 * The simplest and standard error response format. Some types of errors may have a detail property in addition to this; since the type of detail depends on the type of error, the schemas are defined separately.
 * @export
 * @interface ErrorResponse
 */
export interface ErrorResponse {
    /**
     * 
     * @type {string}
     * @memberof ErrorResponse
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof ErrorResponse
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface ErrorResponseFormerBadRequest
 */
export interface ErrorResponseFormerBadRequest {
    /**
     * 
     * @type {object}
     * @memberof ErrorResponseFormerBadRequest
     */
    'errors': object;
}
/**
 * 
 * @export
 * @interface ErrorResponseValidationError
 */
export interface ErrorResponseValidationError {
    /**
     * Always \"validation-error\"
     * @type {string}
     * @memberof ErrorResponseValidationError
     */
    'code': string;
    /**
     * Always an empty string
     * @type {string}
     * @memberof ErrorResponseValidationError
     */
    'message': string;
    /**
     * 
     * @type {Array<ErrorResponseValidationErrorDetailInner>}
     * @memberof ErrorResponseValidationError
     */
    'detail': Array<ErrorResponseValidationErrorDetailInner>;
}
/**
 * 
 * @export
 * @interface ErrorResponseValidationErrorDetailInner
 */
export interface ErrorResponseValidationErrorDetailInner {
    /**
     * 
     * @type {string}
     * @memberof ErrorResponseValidationErrorDetailInner
     */
    'name': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ErrorResponseValidationErrorDetailInner
     */
    'messages': Array<string>;
}
/**
 * 
 * @export
 * @interface Evidence
 */
export interface Evidence {
    /**
     * 
     * @type {string}
     * @memberof Evidence
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Evidence
     */
    'userAccountId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Evidence
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof Evidence
     */
    'paymentType': EvidencePaymentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof Evidence
     */
    'electronicMethod': EvidenceElectronicMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof Evidence
     */
    'documentSize': EvidenceDocumentSizeEnum;
    /**
     * 
     * @type {number}
     * @memberof Evidence
     */
    'detectedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof Evidence
     */
    'calculatedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof Evidence
     */
    'colorGradation': number | null;
    /**
     * 
     * @type {number}
     * @memberof Evidence
     */
    'verticalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof Evidence
     */
    'horizontalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof Evidence
     */
    'heightMillis': number | null;
    /**
     * 
     * @type {number}
     * @memberof Evidence
     */
    'widthMillis': number | null;
    /**
     * 
     * @type {string}
     * @memberof Evidence
     */
    'legalValidity': EvidenceLegalValidityEnum;
    /**
     * 
     * @type {string}
     * @memberof Evidence
     */
    'note': string;
    /**
     * 
     * @type {boolean}
     * @memberof Evidence
     */
    'irrelevantToLedger': boolean;
    /**
     * 
     * @type {EvidenceFile}
     * @memberof Evidence
     */
    'file': EvidenceFile;
    /**
     * 
     * @type {EvidenceInvoiceIssuer}
     * @memberof Evidence
     */
    'invoiceIssuer': EvidenceInvoiceIssuer | null;
    /**
     * 
     * @type {EvidenceErrors}
     * @memberof Evidence
     */
    'errors': EvidenceErrors;
    /**
     * 
     * @type {EvidenceWarnings}
     * @memberof Evidence
     */
    'warnings': EvidenceWarnings;
    /**
     * 
     * @type {EvidenceUpdatedBy}
     * @memberof Evidence
     */
    'updatedBy': EvidenceUpdatedBy;
    /**
     * 
     * @type {string}
     * @memberof Evidence
     */
    'updatedAt': string;
    /**
     * 
     * @type {EvidenceUploadedBy}
     * @memberof Evidence
     */
    'uploadedBy': EvidenceUploadedBy;
    /**
     * 
     * @type {string}
     * @memberof Evidence
     */
    'uploadedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof Evidence
     */
    'needsMigration'?: boolean;
}

export const EvidencePaymentTypeEnum = {
    cardTransaction: 'CARD_TRANSACTION',
    paymentRequest: 'PAYMENT_REQUEST'
} as const;

export type EvidencePaymentTypeEnum = typeof EvidencePaymentTypeEnum[keyof typeof EvidencePaymentTypeEnum];
export const EvidenceElectronicMethodEnum = {
    fullElectronic: 'FULL_ELECTRONIC',
    originallyPaper: 'ORIGINALLY_PAPER',
    unknown: 'UNKNOWN'
} as const;

export type EvidenceElectronicMethodEnum = typeof EvidenceElectronicMethodEnum[keyof typeof EvidenceElectronicMethodEnum];
export const EvidenceDocumentSizeEnum = {
    overA4: 'OVER_A4',
    a4OrSmaller: 'A4_OR_SMALLER',
    unknown: 'UNKNOWN'
} as const;

export type EvidenceDocumentSizeEnum = typeof EvidenceDocumentSizeEnum[keyof typeof EvidenceDocumentSizeEnum];
export const EvidenceLegalValidityEnum = {
    valid: 'VALID',
    invalid: 'INVALID',
    inputRequired: 'INPUT_REQUIRED',
    outOfTarget: 'OUT_OF_TARGET'
} as const;

export type EvidenceLegalValidityEnum = typeof EvidenceLegalValidityEnum[keyof typeof EvidenceLegalValidityEnum];

/**
 * 
 * @export
 * @interface EvidenceAnalysisResult
 */
export interface EvidenceAnalysisResult {
    /**
     * 
     * @type {string}
     * @memberof EvidenceAnalysisResult
     */
    'fileId': string;
    /**
     * 
     * @type {string}
     * @memberof EvidenceAnalysisResult
     */
    'fileName': string;
    /**
     * 
     * @type {string}
     * @memberof EvidenceAnalysisResult
     */
    'issuerName': string | null;
    /**
     * 
     * @type {string}
     * @memberof EvidenceAnalysisResult
     */
    'qualifiedInvoiceIssuerNumber': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof EvidenceAnalysisResult
     */
    'isQualified': boolean;
}
/**
 * 
 * @export
 * @interface EvidenceErrors
 */
export interface EvidenceErrors {
    /**
     * 
     * @type {string}
     * @memberof EvidenceErrors
     */
    'detectedDpi'?: EvidenceErrorsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidenceErrors
     */
    'calculatedDpi'?: EvidenceErrorsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidenceErrors
     */
    'colorGradation'?: EvidenceErrorsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidenceErrors
     */
    'heightMillis'?: EvidenceErrorsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidenceErrors
     */
    'widthMillis'?: EvidenceErrorsWidthMillisEnum;
}

export const EvidenceErrorsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type EvidenceErrorsDetectedDpiEnum = typeof EvidenceErrorsDetectedDpiEnum[keyof typeof EvidenceErrorsDetectedDpiEnum];
export const EvidenceErrorsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type EvidenceErrorsCalculatedDpiEnum = typeof EvidenceErrorsCalculatedDpiEnum[keyof typeof EvidenceErrorsCalculatedDpiEnum];
export const EvidenceErrorsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type EvidenceErrorsColorGradationEnum = typeof EvidenceErrorsColorGradationEnum[keyof typeof EvidenceErrorsColorGradationEnum];
export const EvidenceErrorsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type EvidenceErrorsHeightMillisEnum = typeof EvidenceErrorsHeightMillisEnum[keyof typeof EvidenceErrorsHeightMillisEnum];
export const EvidenceErrorsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type EvidenceErrorsWidthMillisEnum = typeof EvidenceErrorsWidthMillisEnum[keyof typeof EvidenceErrorsWidthMillisEnum];

/**
 * 
 * @export
 * @interface EvidenceFile
 */
export interface EvidenceFile {
    /**
     * 
     * @type {string}
     * @memberof EvidenceFile
     */
    'id': string | null;
    /**
     * 
     * @type {string}
     * @memberof EvidenceFile
     */
    'name': string;
    /**
     * A URL with expiration date-time accessible from the front-end. This is not fully supported yet. In responses from certain endpoints, the url is set to null.
     * @type {string}
     * @memberof EvidenceFile
     */
    'url': string | null;
}
/**
 * Set null if it\'s evidence not analyzed using invoicing-system-compliance feature. Also set null if invoicing-system-compliance feature has been made not available for the organization by the feature-flag.
 * @export
 * @interface EvidenceInvoiceIssuer
 */
export interface EvidenceInvoiceIssuer {
    /**
     * 
     * @type {string}
     * @memberof EvidenceInvoiceIssuer
     */
    'name': string | null;
    /**
     * 
     * @type {string}
     * @memberof EvidenceInvoiceIssuer
     */
    'registrationNumber': string | null;
    /**
     * isQualified retains the result of querying the 国税庁API to see if registrationNumber is qualified, as is.
     * @type {boolean}
     * @memberof EvidenceInvoiceIssuer
     */
    'isQualified': boolean;
    /**
     * AsQualified indicates whether this issuer should be treated as a qualified invoice issuer within the user\'s system, even if the RegistrationNumber is not confirmed as qualified in the National Tax Agency\'s business registration system.
     * @type {boolean}
     * @memberof EvidenceInvoiceIssuer
     */
    'asQualified': boolean;
    /**
     * 
     * @type {string}
     * @memberof EvidenceInvoiceIssuer
     */
    'partnerId': string | null;
}
/**
 * 
 * @export
 * @interface EvidencePayment
 */
export interface EvidencePayment {
    /**
     * 
     * @type {string}
     * @memberof EvidencePayment
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof EvidencePayment
     */
    'paidAt': string;
    /**
     * 
     * @type {number}
     * @memberof EvidencePayment
     */
    'amount': number;
    /**
     * The issuer of the associated evidence.
     * @type {string}
     * @memberof EvidencePayment
     */
    'issuer': string;
}
/**
 * 
 * @export
 * @interface EvidencePaymentWithEvidence
 */
export interface EvidencePaymentWithEvidence {
    /**
     * 
     * @type {string}
     * @memberof EvidencePaymentWithEvidence
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof EvidencePaymentWithEvidence
     */
    'userAccountId': string;
    /**
     * 
     * @type {string}
     * @memberof EvidencePaymentWithEvidence
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof EvidencePaymentWithEvidence
     */
    'paymentType': EvidencePaymentWithEvidencePaymentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidencePaymentWithEvidence
     */
    'paidAt': string;
    /**
     * 
     * @type {number}
     * @memberof EvidencePaymentWithEvidence
     */
    'amount': number;
    /**
     * 
     * @type {number}
     * @memberof EvidencePaymentWithEvidence
     */
    'amountFx': number;
    /**
     * 
     * @type {string}
     * @memberof EvidencePaymentWithEvidence
     */
    'currency': string;
    /**
     * 
     * @type {string}
     * @memberof EvidencePaymentWithEvidence
     */
    'issuer': string;
    /**
     * 
     * @type {string}
     * @memberof EvidencePaymentWithEvidence
     */
    'fileName': string;
    /**
     * 
     * @type {string}
     * @memberof EvidencePaymentWithEvidence
     */
    'fileExtension': string;
    /**
     * 
     * @type {string}
     * @memberof EvidencePaymentWithEvidence
     */
    'electronicMethod': EvidencePaymentWithEvidenceElectronicMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidencePaymentWithEvidence
     */
    'documentSize': EvidencePaymentWithEvidenceDocumentSizeEnum;
    /**
     * 
     * @type {number}
     * @memberof EvidencePaymentWithEvidence
     * @deprecated
     */
    'dpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof EvidencePaymentWithEvidence
     */
    'detectedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof EvidencePaymentWithEvidence
     */
    'calculatedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof EvidencePaymentWithEvidence
     */
    'colorGradation': number | null;
    /**
     * 
     * @type {number}
     * @memberof EvidencePaymentWithEvidence
     */
    'verticalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof EvidencePaymentWithEvidence
     */
    'horizontalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof EvidencePaymentWithEvidence
     */
    'heightMillis': number | null;
    /**
     * 
     * @type {number}
     * @memberof EvidencePaymentWithEvidence
     */
    'widthMillis': number | null;
    /**
     * 
     * @type {string}
     * @memberof EvidencePaymentWithEvidence
     */
    'legalValidity': EvidencePaymentWithEvidenceLegalValidityEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidencePaymentWithEvidence
     */
    'note': string;
    /**
     * 
     * @type {boolean}
     * @memberof EvidencePaymentWithEvidence
     */
    'irrelevantToLedger': boolean;
    /**
     * 
     * @type {EvidencePaymentWithEvidenceInvoiceIssuer}
     * @memberof EvidencePaymentWithEvidence
     */
    'invoiceIssuer': EvidencePaymentWithEvidenceInvoiceIssuer | null;
    /**
     * 
     * @type {string}
     * @memberof EvidencePaymentWithEvidence
     * @deprecated
     */
    'dpiError': EvidencePaymentWithEvidenceDpiErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidencePaymentWithEvidence
     * @deprecated
     */
    'detectedDpiError': EvidencePaymentWithEvidenceDetectedDpiErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidencePaymentWithEvidence
     * @deprecated
     */
    'calculatedDpiError': EvidencePaymentWithEvidenceCalculatedDpiErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidencePaymentWithEvidence
     * @deprecated
     */
    'colorGradationError': EvidencePaymentWithEvidenceColorGradationErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidencePaymentWithEvidence
     * @deprecated
     */
    'heightMillisError': EvidencePaymentWithEvidenceHeightMillisErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidencePaymentWithEvidence
     * @deprecated
     */
    'widthMillisError': EvidencePaymentWithEvidenceWidthMillisErrorEnum;
    /**
     * 
     * @type {EvidencePaymentWithEvidenceErrors}
     * @memberof EvidencePaymentWithEvidence
     */
    'errors': EvidencePaymentWithEvidenceErrors;
    /**
     * 
     * @type {EvidencePaymentWithEvidenceWarnings}
     * @memberof EvidencePaymentWithEvidence
     */
    'warnings': EvidencePaymentWithEvidenceWarnings;
    /**
     * 
     * @type {EvidencePaymentWithEvidenceUpdatedBy}
     * @memberof EvidencePaymentWithEvidence
     */
    'updatedBy': EvidencePaymentWithEvidenceUpdatedBy;
    /**
     * 
     * @type {string}
     * @memberof EvidencePaymentWithEvidence
     */
    'updatedAt': string;
    /**
     * 
     * @type {EvidencePaymentWithEvidenceUploadedBy}
     * @memberof EvidencePaymentWithEvidence
     */
    'uploadedBy': EvidencePaymentWithEvidenceUploadedBy;
    /**
     * 
     * @type {string}
     * @memberof EvidencePaymentWithEvidence
     */
    'uploadedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof EvidencePaymentWithEvidence
     */
    'deleted': boolean;
}

export const EvidencePaymentWithEvidencePaymentTypeEnum = {
    cardTransaction: 'CARD_TRANSACTION',
    paymentRequest: 'PAYMENT_REQUEST'
} as const;

export type EvidencePaymentWithEvidencePaymentTypeEnum = typeof EvidencePaymentWithEvidencePaymentTypeEnum[keyof typeof EvidencePaymentWithEvidencePaymentTypeEnum];
export const EvidencePaymentWithEvidenceElectronicMethodEnum = {
    fullElectronic: 'FULL_ELECTRONIC',
    originallyPaper: 'ORIGINALLY_PAPER',
    unknown: 'UNKNOWN'
} as const;

export type EvidencePaymentWithEvidenceElectronicMethodEnum = typeof EvidencePaymentWithEvidenceElectronicMethodEnum[keyof typeof EvidencePaymentWithEvidenceElectronicMethodEnum];
export const EvidencePaymentWithEvidenceDocumentSizeEnum = {
    overA4: 'OVER_A4',
    a4OrSmaller: 'A4_OR_SMALLER',
    unknown: 'UNKNOWN'
} as const;

export type EvidencePaymentWithEvidenceDocumentSizeEnum = typeof EvidencePaymentWithEvidenceDocumentSizeEnum[keyof typeof EvidencePaymentWithEvidenceDocumentSizeEnum];
export const EvidencePaymentWithEvidenceLegalValidityEnum = {
    valid: 'VALID',
    invalid: 'INVALID',
    inputRequired: 'INPUT_REQUIRED',
    outOfTarget: 'OUT_OF_TARGET'
} as const;

export type EvidencePaymentWithEvidenceLegalValidityEnum = typeof EvidencePaymentWithEvidenceLegalValidityEnum[keyof typeof EvidencePaymentWithEvidenceLegalValidityEnum];
export const EvidencePaymentWithEvidenceDpiErrorEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type EvidencePaymentWithEvidenceDpiErrorEnum = typeof EvidencePaymentWithEvidenceDpiErrorEnum[keyof typeof EvidencePaymentWithEvidenceDpiErrorEnum];
export const EvidencePaymentWithEvidenceDetectedDpiErrorEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type EvidencePaymentWithEvidenceDetectedDpiErrorEnum = typeof EvidencePaymentWithEvidenceDetectedDpiErrorEnum[keyof typeof EvidencePaymentWithEvidenceDetectedDpiErrorEnum];
export const EvidencePaymentWithEvidenceCalculatedDpiErrorEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type EvidencePaymentWithEvidenceCalculatedDpiErrorEnum = typeof EvidencePaymentWithEvidenceCalculatedDpiErrorEnum[keyof typeof EvidencePaymentWithEvidenceCalculatedDpiErrorEnum];
export const EvidencePaymentWithEvidenceColorGradationErrorEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type EvidencePaymentWithEvidenceColorGradationErrorEnum = typeof EvidencePaymentWithEvidenceColorGradationErrorEnum[keyof typeof EvidencePaymentWithEvidenceColorGradationErrorEnum];
export const EvidencePaymentWithEvidenceHeightMillisErrorEnum = {
    required: 'REQUIRED'
} as const;

export type EvidencePaymentWithEvidenceHeightMillisErrorEnum = typeof EvidencePaymentWithEvidenceHeightMillisErrorEnum[keyof typeof EvidencePaymentWithEvidenceHeightMillisErrorEnum];
export const EvidencePaymentWithEvidenceWidthMillisErrorEnum = {
    required: 'REQUIRED'
} as const;

export type EvidencePaymentWithEvidenceWidthMillisErrorEnum = typeof EvidencePaymentWithEvidenceWidthMillisErrorEnum[keyof typeof EvidencePaymentWithEvidenceWidthMillisErrorEnum];

/**
 * 
 * @export
 * @interface EvidencePaymentWithEvidenceErrors
 */
export interface EvidencePaymentWithEvidenceErrors {
    /**
     * 
     * @type {string}
     * @memberof EvidencePaymentWithEvidenceErrors
     */
    'detectedDpi'?: EvidencePaymentWithEvidenceErrorsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidencePaymentWithEvidenceErrors
     */
    'calculatedDpi'?: EvidencePaymentWithEvidenceErrorsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidencePaymentWithEvidenceErrors
     */
    'colorGradation'?: EvidencePaymentWithEvidenceErrorsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidencePaymentWithEvidenceErrors
     */
    'heightMillis'?: EvidencePaymentWithEvidenceErrorsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidencePaymentWithEvidenceErrors
     */
    'widthMillis'?: EvidencePaymentWithEvidenceErrorsWidthMillisEnum;
}

export const EvidencePaymentWithEvidenceErrorsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type EvidencePaymentWithEvidenceErrorsDetectedDpiEnum = typeof EvidencePaymentWithEvidenceErrorsDetectedDpiEnum[keyof typeof EvidencePaymentWithEvidenceErrorsDetectedDpiEnum];
export const EvidencePaymentWithEvidenceErrorsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type EvidencePaymentWithEvidenceErrorsCalculatedDpiEnum = typeof EvidencePaymentWithEvidenceErrorsCalculatedDpiEnum[keyof typeof EvidencePaymentWithEvidenceErrorsCalculatedDpiEnum];
export const EvidencePaymentWithEvidenceErrorsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type EvidencePaymentWithEvidenceErrorsColorGradationEnum = typeof EvidencePaymentWithEvidenceErrorsColorGradationEnum[keyof typeof EvidencePaymentWithEvidenceErrorsColorGradationEnum];
export const EvidencePaymentWithEvidenceErrorsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type EvidencePaymentWithEvidenceErrorsHeightMillisEnum = typeof EvidencePaymentWithEvidenceErrorsHeightMillisEnum[keyof typeof EvidencePaymentWithEvidenceErrorsHeightMillisEnum];
export const EvidencePaymentWithEvidenceErrorsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type EvidencePaymentWithEvidenceErrorsWidthMillisEnum = typeof EvidencePaymentWithEvidenceErrorsWidthMillisEnum[keyof typeof EvidencePaymentWithEvidenceErrorsWidthMillisEnum];

/**
 * Set null if it\'s evidence not analyzed using invoicing-system-compliance feature. Also set null if invoicing-system-compliance feature has been made not available for the organization by the feature-flag.
 * @export
 * @interface EvidencePaymentWithEvidenceInvoiceIssuer
 */
export interface EvidencePaymentWithEvidenceInvoiceIssuer {
    /**
     * 
     * @type {string}
     * @memberof EvidencePaymentWithEvidenceInvoiceIssuer
     */
    'name': string | null;
    /**
     * 
     * @type {string}
     * @memberof EvidencePaymentWithEvidenceInvoiceIssuer
     */
    'registrationNumber': string | null;
    /**
     * isQualified retains the result of querying the 国税庁API to see if registrationNumber is qualified, as is.
     * @type {boolean}
     * @memberof EvidencePaymentWithEvidenceInvoiceIssuer
     */
    'isQualified': boolean;
    /**
     * AsQualified indicates whether this issuer should be treated as a qualified invoice issuer within the user\'s system, even if the RegistrationNumber is not confirmed as qualified in the National Tax Agency\'s business registration system.
     * @type {boolean}
     * @memberof EvidencePaymentWithEvidenceInvoiceIssuer
     */
    'asQualified': boolean;
    /**
     * 
     * @type {string}
     * @memberof EvidencePaymentWithEvidenceInvoiceIssuer
     */
    'partnerId': string | null;
}
/**
 * 
 * @export
 * @interface EvidencePaymentWithEvidenceUpdatedBy
 */
export interface EvidencePaymentWithEvidenceUpdatedBy {
    /**
     * 
     * @type {string}
     * @memberof EvidencePaymentWithEvidenceUpdatedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof EvidencePaymentWithEvidenceUpdatedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface EvidencePaymentWithEvidenceUploadedBy
 */
export interface EvidencePaymentWithEvidenceUploadedBy {
    /**
     * 
     * @type {string}
     * @memberof EvidencePaymentWithEvidenceUploadedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof EvidencePaymentWithEvidenceUploadedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface EvidencePaymentWithEvidenceWarnings
 */
export interface EvidencePaymentWithEvidenceWarnings {
    /**
     * 
     * @type {string}
     * @memberof EvidencePaymentWithEvidenceWarnings
     */
    'detectedDpi'?: EvidencePaymentWithEvidenceWarningsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidencePaymentWithEvidenceWarnings
     */
    'calculatedDpi'?: EvidencePaymentWithEvidenceWarningsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidencePaymentWithEvidenceWarnings
     */
    'colorGradation'?: EvidencePaymentWithEvidenceWarningsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidencePaymentWithEvidenceWarnings
     */
    'heightMillis'?: EvidencePaymentWithEvidenceWarningsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidencePaymentWithEvidenceWarnings
     */
    'widthMillis'?: EvidencePaymentWithEvidenceWarningsWidthMillisEnum;
}

export const EvidencePaymentWithEvidenceWarningsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type EvidencePaymentWithEvidenceWarningsDetectedDpiEnum = typeof EvidencePaymentWithEvidenceWarningsDetectedDpiEnum[keyof typeof EvidencePaymentWithEvidenceWarningsDetectedDpiEnum];
export const EvidencePaymentWithEvidenceWarningsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type EvidencePaymentWithEvidenceWarningsCalculatedDpiEnum = typeof EvidencePaymentWithEvidenceWarningsCalculatedDpiEnum[keyof typeof EvidencePaymentWithEvidenceWarningsCalculatedDpiEnum];
export const EvidencePaymentWithEvidenceWarningsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type EvidencePaymentWithEvidenceWarningsColorGradationEnum = typeof EvidencePaymentWithEvidenceWarningsColorGradationEnum[keyof typeof EvidencePaymentWithEvidenceWarningsColorGradationEnum];
export const EvidencePaymentWithEvidenceWarningsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type EvidencePaymentWithEvidenceWarningsHeightMillisEnum = typeof EvidencePaymentWithEvidenceWarningsHeightMillisEnum[keyof typeof EvidencePaymentWithEvidenceWarningsHeightMillisEnum];
export const EvidencePaymentWithEvidenceWarningsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type EvidencePaymentWithEvidenceWarningsWidthMillisEnum = typeof EvidencePaymentWithEvidenceWarningsWidthMillisEnum[keyof typeof EvidencePaymentWithEvidenceWarningsWidthMillisEnum];

/**
 * 
 * @export
 * @interface EvidenceRecord
 */
export interface EvidenceRecord {
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecord
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecord
     */
    'evidenceId': string;
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecord
     */
    'userAccountId': string | null;
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecord
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecord
     */
    'paymentType': EvidenceRecordPaymentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecord
     */
    'electronicMethod': EvidenceRecordElectronicMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecord
     */
    'documentSize': EvidenceRecordDocumentSizeEnum;
    /**
     * 
     * @type {number}
     * @memberof EvidenceRecord
     */
    'detectedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof EvidenceRecord
     */
    'calculatedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof EvidenceRecord
     */
    'colorGradation': number | null;
    /**
     * 
     * @type {number}
     * @memberof EvidenceRecord
     */
    'verticalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof EvidenceRecord
     */
    'horizontalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof EvidenceRecord
     */
    'heightMillis': number | null;
    /**
     * 
     * @type {number}
     * @memberof EvidenceRecord
     */
    'widthMillis': number | null;
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecord
     */
    'legalValidity': EvidenceRecordLegalValidityEnum;
    /**
     * 
     * @type {boolean}
     * @memberof EvidenceRecord
     */
    'dpiForciblyValid': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EvidenceRecord
     */
    'colorGradationForciblyValid': boolean;
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecord
     */
    'note': string;
    /**
     * 
     * @type {boolean}
     * @memberof EvidenceRecord
     */
    'irrelevantToLedger': boolean;
    /**
     * 
     * @type {EvidenceRecordFile}
     * @memberof EvidenceRecord
     */
    'file': EvidenceRecordFile;
    /**
     * 
     * @type {EvidenceRecordInvoiceIssuer}
     * @memberof EvidenceRecord
     */
    'invoiceIssuer': EvidenceRecordInvoiceIssuer | null;
    /**
     * 
     * @type {EvidenceRecordErrors}
     * @memberof EvidenceRecord
     */
    'errors': EvidenceRecordErrors;
    /**
     * 
     * @type {EvidenceRecordWarnings}
     * @memberof EvidenceRecord
     */
    'warnings': EvidenceRecordWarnings;
    /**
     * 
     * @type {EvidenceRecordUpdatedBy}
     * @memberof EvidenceRecord
     */
    'updatedBy': EvidenceRecordUpdatedBy;
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecord
     */
    'updatedAt': string;
    /**
     * 
     * @type {EvidenceRecordUploadedBy}
     * @memberof EvidenceRecord
     */
    'uploadedBy': EvidenceRecordUploadedBy;
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecord
     */
    'uploadedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof EvidenceRecord
     */
    'uploadedByRecipient': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EvidenceRecord
     */
    'deleted': boolean;
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecord
     */
    'uploadedFrom': string;
}

export const EvidenceRecordPaymentTypeEnum = {
    cardTransaction: 'CARD_TRANSACTION',
    paymentRequest: 'PAYMENT_REQUEST'
} as const;

export type EvidenceRecordPaymentTypeEnum = typeof EvidenceRecordPaymentTypeEnum[keyof typeof EvidenceRecordPaymentTypeEnum];
export const EvidenceRecordElectronicMethodEnum = {
    fullElectronic: 'FULL_ELECTRONIC',
    originallyPaper: 'ORIGINALLY_PAPER',
    unknown: 'UNKNOWN'
} as const;

export type EvidenceRecordElectronicMethodEnum = typeof EvidenceRecordElectronicMethodEnum[keyof typeof EvidenceRecordElectronicMethodEnum];
export const EvidenceRecordDocumentSizeEnum = {
    overA4: 'OVER_A4',
    a4OrSmaller: 'A4_OR_SMALLER',
    unknown: 'UNKNOWN'
} as const;

export type EvidenceRecordDocumentSizeEnum = typeof EvidenceRecordDocumentSizeEnum[keyof typeof EvidenceRecordDocumentSizeEnum];
export const EvidenceRecordLegalValidityEnum = {
    valid: 'VALID',
    invalid: 'INVALID',
    inputRequired: 'INPUT_REQUIRED',
    outOfTarget: 'OUT_OF_TARGET'
} as const;

export type EvidenceRecordLegalValidityEnum = typeof EvidenceRecordLegalValidityEnum[keyof typeof EvidenceRecordLegalValidityEnum];

/**
 * 
 * @export
 * @interface EvidenceRecordDeprecated
 */
export interface EvidenceRecordDeprecated {
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecordDeprecated
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecordDeprecated
     */
    'evidenceId': string;
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecordDeprecated
     */
    'userAccountId': string | null;
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecordDeprecated
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecordDeprecated
     */
    'paymentType': EvidenceRecordDeprecatedPaymentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecordDeprecated
     */
    'fileName': string;
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecordDeprecated
     */
    'fileExtension': string;
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecordDeprecated
     */
    'electronicMethod': EvidenceRecordDeprecatedElectronicMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecordDeprecated
     */
    'documentSize': EvidenceRecordDeprecatedDocumentSizeEnum;
    /**
     * 
     * @type {number}
     * @memberof EvidenceRecordDeprecated
     * @deprecated
     */
    'dpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof EvidenceRecordDeprecated
     */
    'detectedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof EvidenceRecordDeprecated
     */
    'calculatedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof EvidenceRecordDeprecated
     */
    'colorGradation': number | null;
    /**
     * 
     * @type {number}
     * @memberof EvidenceRecordDeprecated
     */
    'verticalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof EvidenceRecordDeprecated
     */
    'horizontalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof EvidenceRecordDeprecated
     */
    'heightMillis': number | null;
    /**
     * 
     * @type {number}
     * @memberof EvidenceRecordDeprecated
     */
    'widthMillis': number | null;
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecordDeprecated
     */
    'legalValidity': EvidenceRecordDeprecatedLegalValidityEnum;
    /**
     * 
     * @type {boolean}
     * @memberof EvidenceRecordDeprecated
     */
    'dpiForciblyValid': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EvidenceRecordDeprecated
     */
    'colorGradationForciblyValid': boolean;
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecordDeprecated
     */
    'note': string;
    /**
     * 
     * @type {boolean}
     * @memberof EvidenceRecordDeprecated
     */
    'irrelevantToLedger': boolean;
    /**
     * 
     * @type {EvidenceRecordDeprecatedInvoiceIssuer}
     * @memberof EvidenceRecordDeprecated
     */
    'invoiceIssuer': EvidenceRecordDeprecatedInvoiceIssuer | null;
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecordDeprecated
     * @deprecated
     */
    'dpiError': EvidenceRecordDeprecatedDpiErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecordDeprecated
     * @deprecated
     */
    'detectedDpiError': EvidenceRecordDeprecatedDetectedDpiErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecordDeprecated
     * @deprecated
     */
    'calculatedDpiError': EvidenceRecordDeprecatedCalculatedDpiErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecordDeprecated
     * @deprecated
     */
    'colorGradationError': EvidenceRecordDeprecatedColorGradationErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecordDeprecated
     * @deprecated
     */
    'heightMillisError': EvidenceRecordDeprecatedHeightMillisErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecordDeprecated
     * @deprecated
     */
    'widthMillisError': EvidenceRecordDeprecatedWidthMillisErrorEnum;
    /**
     * 
     * @type {EvidenceRecordDeprecatedErrors}
     * @memberof EvidenceRecordDeprecated
     */
    'errors': EvidenceRecordDeprecatedErrors;
    /**
     * 
     * @type {EvidenceRecordDeprecatedWarnings}
     * @memberof EvidenceRecordDeprecated
     */
    'warnings': EvidenceRecordDeprecatedWarnings;
    /**
     * 
     * @type {EvidenceRecordDeprecatedUpdatedBy}
     * @memberof EvidenceRecordDeprecated
     */
    'updatedBy': EvidenceRecordDeprecatedUpdatedBy;
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecordDeprecated
     */
    'updatedAt': string;
    /**
     * 
     * @type {EvidenceRecordDeprecatedUploadedBy}
     * @memberof EvidenceRecordDeprecated
     */
    'uploadedBy': EvidenceRecordDeprecatedUploadedBy;
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecordDeprecated
     */
    'uploadedAt': string;
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecordDeprecated
     */
    'uploadedFrom': string;
    /**
     * 
     * @type {boolean}
     * @memberof EvidenceRecordDeprecated
     */
    'uploadedByRecipient': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EvidenceRecordDeprecated
     */
    'deleted': boolean;
}

export const EvidenceRecordDeprecatedPaymentTypeEnum = {
    cardTransaction: 'CARD_TRANSACTION',
    paymentRequest: 'PAYMENT_REQUEST'
} as const;

export type EvidenceRecordDeprecatedPaymentTypeEnum = typeof EvidenceRecordDeprecatedPaymentTypeEnum[keyof typeof EvidenceRecordDeprecatedPaymentTypeEnum];
export const EvidenceRecordDeprecatedElectronicMethodEnum = {
    fullElectronic: 'FULL_ELECTRONIC',
    originallyPaper: 'ORIGINALLY_PAPER',
    unknown: 'UNKNOWN'
} as const;

export type EvidenceRecordDeprecatedElectronicMethodEnum = typeof EvidenceRecordDeprecatedElectronicMethodEnum[keyof typeof EvidenceRecordDeprecatedElectronicMethodEnum];
export const EvidenceRecordDeprecatedDocumentSizeEnum = {
    overA4: 'OVER_A4',
    a4OrSmaller: 'A4_OR_SMALLER',
    unknown: 'UNKNOWN'
} as const;

export type EvidenceRecordDeprecatedDocumentSizeEnum = typeof EvidenceRecordDeprecatedDocumentSizeEnum[keyof typeof EvidenceRecordDeprecatedDocumentSizeEnum];
export const EvidenceRecordDeprecatedLegalValidityEnum = {
    valid: 'VALID',
    invalid: 'INVALID',
    inputRequired: 'INPUT_REQUIRED',
    outOfTarget: 'OUT_OF_TARGET'
} as const;

export type EvidenceRecordDeprecatedLegalValidityEnum = typeof EvidenceRecordDeprecatedLegalValidityEnum[keyof typeof EvidenceRecordDeprecatedLegalValidityEnum];
export const EvidenceRecordDeprecatedDpiErrorEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type EvidenceRecordDeprecatedDpiErrorEnum = typeof EvidenceRecordDeprecatedDpiErrorEnum[keyof typeof EvidenceRecordDeprecatedDpiErrorEnum];
export const EvidenceRecordDeprecatedDetectedDpiErrorEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type EvidenceRecordDeprecatedDetectedDpiErrorEnum = typeof EvidenceRecordDeprecatedDetectedDpiErrorEnum[keyof typeof EvidenceRecordDeprecatedDetectedDpiErrorEnum];
export const EvidenceRecordDeprecatedCalculatedDpiErrorEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type EvidenceRecordDeprecatedCalculatedDpiErrorEnum = typeof EvidenceRecordDeprecatedCalculatedDpiErrorEnum[keyof typeof EvidenceRecordDeprecatedCalculatedDpiErrorEnum];
export const EvidenceRecordDeprecatedColorGradationErrorEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type EvidenceRecordDeprecatedColorGradationErrorEnum = typeof EvidenceRecordDeprecatedColorGradationErrorEnum[keyof typeof EvidenceRecordDeprecatedColorGradationErrorEnum];
export const EvidenceRecordDeprecatedHeightMillisErrorEnum = {
    required: 'REQUIRED'
} as const;

export type EvidenceRecordDeprecatedHeightMillisErrorEnum = typeof EvidenceRecordDeprecatedHeightMillisErrorEnum[keyof typeof EvidenceRecordDeprecatedHeightMillisErrorEnum];
export const EvidenceRecordDeprecatedWidthMillisErrorEnum = {
    required: 'REQUIRED'
} as const;

export type EvidenceRecordDeprecatedWidthMillisErrorEnum = typeof EvidenceRecordDeprecatedWidthMillisErrorEnum[keyof typeof EvidenceRecordDeprecatedWidthMillisErrorEnum];

/**
 * 
 * @export
 * @interface EvidenceRecordDeprecatedErrors
 */
export interface EvidenceRecordDeprecatedErrors {
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecordDeprecatedErrors
     */
    'detectedDpi'?: EvidenceRecordDeprecatedErrorsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecordDeprecatedErrors
     */
    'calculatedDpi'?: EvidenceRecordDeprecatedErrorsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecordDeprecatedErrors
     */
    'colorGradation'?: EvidenceRecordDeprecatedErrorsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecordDeprecatedErrors
     */
    'heightMillis'?: EvidenceRecordDeprecatedErrorsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecordDeprecatedErrors
     */
    'widthMillis'?: EvidenceRecordDeprecatedErrorsWidthMillisEnum;
}

export const EvidenceRecordDeprecatedErrorsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type EvidenceRecordDeprecatedErrorsDetectedDpiEnum = typeof EvidenceRecordDeprecatedErrorsDetectedDpiEnum[keyof typeof EvidenceRecordDeprecatedErrorsDetectedDpiEnum];
export const EvidenceRecordDeprecatedErrorsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type EvidenceRecordDeprecatedErrorsCalculatedDpiEnum = typeof EvidenceRecordDeprecatedErrorsCalculatedDpiEnum[keyof typeof EvidenceRecordDeprecatedErrorsCalculatedDpiEnum];
export const EvidenceRecordDeprecatedErrorsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type EvidenceRecordDeprecatedErrorsColorGradationEnum = typeof EvidenceRecordDeprecatedErrorsColorGradationEnum[keyof typeof EvidenceRecordDeprecatedErrorsColorGradationEnum];
export const EvidenceRecordDeprecatedErrorsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type EvidenceRecordDeprecatedErrorsHeightMillisEnum = typeof EvidenceRecordDeprecatedErrorsHeightMillisEnum[keyof typeof EvidenceRecordDeprecatedErrorsHeightMillisEnum];
export const EvidenceRecordDeprecatedErrorsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type EvidenceRecordDeprecatedErrorsWidthMillisEnum = typeof EvidenceRecordDeprecatedErrorsWidthMillisEnum[keyof typeof EvidenceRecordDeprecatedErrorsWidthMillisEnum];

/**
 * Set null if it\'s evidence not analyzed using invoicing-system-compliance feature. Also set null if invoicing-system-compliance feature has been made not available for the organization by the feature-flag.
 * @export
 * @interface EvidenceRecordDeprecatedInvoiceIssuer
 */
export interface EvidenceRecordDeprecatedInvoiceIssuer {
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecordDeprecatedInvoiceIssuer
     */
    'name': string | null;
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecordDeprecatedInvoiceIssuer
     */
    'registrationNumber': string | null;
    /**
     * isQualified retains the result of querying the 国税庁API to see if registrationNumber is qualified, as is.
     * @type {boolean}
     * @memberof EvidenceRecordDeprecatedInvoiceIssuer
     */
    'isQualified': boolean;
    /**
     * AsQualified indicates whether this issuer should be treated as a qualified invoice issuer within the user\'s system, even if the RegistrationNumber is not confirmed as qualified in the National Tax Agency\'s business registration system.
     * @type {boolean}
     * @memberof EvidenceRecordDeprecatedInvoiceIssuer
     */
    'asQualified': boolean;
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecordDeprecatedInvoiceIssuer
     */
    'partnerId': string | null;
}
/**
 * 
 * @export
 * @interface EvidenceRecordDeprecatedUpdatedBy
 */
export interface EvidenceRecordDeprecatedUpdatedBy {
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecordDeprecatedUpdatedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecordDeprecatedUpdatedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface EvidenceRecordDeprecatedUploadedBy
 */
export interface EvidenceRecordDeprecatedUploadedBy {
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecordDeprecatedUploadedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecordDeprecatedUploadedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface EvidenceRecordDeprecatedWarnings
 */
export interface EvidenceRecordDeprecatedWarnings {
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecordDeprecatedWarnings
     */
    'detectedDpi'?: EvidenceRecordDeprecatedWarningsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecordDeprecatedWarnings
     */
    'calculatedDpi'?: EvidenceRecordDeprecatedWarningsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecordDeprecatedWarnings
     */
    'colorGradation'?: EvidenceRecordDeprecatedWarningsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecordDeprecatedWarnings
     */
    'heightMillis'?: EvidenceRecordDeprecatedWarningsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecordDeprecatedWarnings
     */
    'widthMillis'?: EvidenceRecordDeprecatedWarningsWidthMillisEnum;
}

export const EvidenceRecordDeprecatedWarningsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type EvidenceRecordDeprecatedWarningsDetectedDpiEnum = typeof EvidenceRecordDeprecatedWarningsDetectedDpiEnum[keyof typeof EvidenceRecordDeprecatedWarningsDetectedDpiEnum];
export const EvidenceRecordDeprecatedWarningsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type EvidenceRecordDeprecatedWarningsCalculatedDpiEnum = typeof EvidenceRecordDeprecatedWarningsCalculatedDpiEnum[keyof typeof EvidenceRecordDeprecatedWarningsCalculatedDpiEnum];
export const EvidenceRecordDeprecatedWarningsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type EvidenceRecordDeprecatedWarningsColorGradationEnum = typeof EvidenceRecordDeprecatedWarningsColorGradationEnum[keyof typeof EvidenceRecordDeprecatedWarningsColorGradationEnum];
export const EvidenceRecordDeprecatedWarningsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type EvidenceRecordDeprecatedWarningsHeightMillisEnum = typeof EvidenceRecordDeprecatedWarningsHeightMillisEnum[keyof typeof EvidenceRecordDeprecatedWarningsHeightMillisEnum];
export const EvidenceRecordDeprecatedWarningsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type EvidenceRecordDeprecatedWarningsWidthMillisEnum = typeof EvidenceRecordDeprecatedWarningsWidthMillisEnum[keyof typeof EvidenceRecordDeprecatedWarningsWidthMillisEnum];

/**
 * 
 * @export
 * @interface EvidenceRecordErrors
 */
export interface EvidenceRecordErrors {
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecordErrors
     */
    'detectedDpi'?: EvidenceRecordErrorsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecordErrors
     */
    'calculatedDpi'?: EvidenceRecordErrorsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecordErrors
     */
    'colorGradation'?: EvidenceRecordErrorsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecordErrors
     */
    'heightMillis'?: EvidenceRecordErrorsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecordErrors
     */
    'widthMillis'?: EvidenceRecordErrorsWidthMillisEnum;
}

export const EvidenceRecordErrorsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type EvidenceRecordErrorsDetectedDpiEnum = typeof EvidenceRecordErrorsDetectedDpiEnum[keyof typeof EvidenceRecordErrorsDetectedDpiEnum];
export const EvidenceRecordErrorsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type EvidenceRecordErrorsCalculatedDpiEnum = typeof EvidenceRecordErrorsCalculatedDpiEnum[keyof typeof EvidenceRecordErrorsCalculatedDpiEnum];
export const EvidenceRecordErrorsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type EvidenceRecordErrorsColorGradationEnum = typeof EvidenceRecordErrorsColorGradationEnum[keyof typeof EvidenceRecordErrorsColorGradationEnum];
export const EvidenceRecordErrorsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type EvidenceRecordErrorsHeightMillisEnum = typeof EvidenceRecordErrorsHeightMillisEnum[keyof typeof EvidenceRecordErrorsHeightMillisEnum];
export const EvidenceRecordErrorsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type EvidenceRecordErrorsWidthMillisEnum = typeof EvidenceRecordErrorsWidthMillisEnum[keyof typeof EvidenceRecordErrorsWidthMillisEnum];

/**
 * 
 * @export
 * @interface EvidenceRecordFile
 */
export interface EvidenceRecordFile {
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecordFile
     */
    'id': string | null;
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecordFile
     */
    'name': string;
    /**
     * A URL with expiration date-time accessible from the front-end. This is not fully supported yet. In responses from certain endpoints, the url is set to null.
     * @type {string}
     * @memberof EvidenceRecordFile
     */
    'url': string | null;
}
/**
 * Set null if it\'s evidence not analyzed using invoicing-system-compliance feature. Also set null if invoicing-system-compliance feature has been made not available for the organization by the feature-flag.
 * @export
 * @interface EvidenceRecordInvoiceIssuer
 */
export interface EvidenceRecordInvoiceIssuer {
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecordInvoiceIssuer
     */
    'name': string | null;
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecordInvoiceIssuer
     */
    'registrationNumber': string | null;
    /**
     * isQualified retains the result of querying the 国税庁API to see if registrationNumber is qualified, as is.
     * @type {boolean}
     * @memberof EvidenceRecordInvoiceIssuer
     */
    'isQualified': boolean;
    /**
     * AsQualified indicates whether this issuer should be treated as a qualified invoice issuer within the user\'s system, even if the RegistrationNumber is not confirmed as qualified in the National Tax Agency\'s business registration system.
     * @type {boolean}
     * @memberof EvidenceRecordInvoiceIssuer
     */
    'asQualified': boolean;
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecordInvoiceIssuer
     */
    'partnerId': string | null;
}
/**
 * 
 * @export
 * @interface EvidenceRecordUpdatedBy
 */
export interface EvidenceRecordUpdatedBy {
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecordUpdatedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecordUpdatedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface EvidenceRecordUploadedBy
 */
export interface EvidenceRecordUploadedBy {
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecordUploadedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecordUploadedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface EvidenceRecordWarnings
 */
export interface EvidenceRecordWarnings {
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecordWarnings
     */
    'detectedDpi'?: EvidenceRecordWarningsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecordWarnings
     */
    'calculatedDpi'?: EvidenceRecordWarningsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecordWarnings
     */
    'colorGradation'?: EvidenceRecordWarningsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecordWarnings
     */
    'heightMillis'?: EvidenceRecordWarningsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecordWarnings
     */
    'widthMillis'?: EvidenceRecordWarningsWidthMillisEnum;
}

export const EvidenceRecordWarningsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type EvidenceRecordWarningsDetectedDpiEnum = typeof EvidenceRecordWarningsDetectedDpiEnum[keyof typeof EvidenceRecordWarningsDetectedDpiEnum];
export const EvidenceRecordWarningsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type EvidenceRecordWarningsCalculatedDpiEnum = typeof EvidenceRecordWarningsCalculatedDpiEnum[keyof typeof EvidenceRecordWarningsCalculatedDpiEnum];
export const EvidenceRecordWarningsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type EvidenceRecordWarningsColorGradationEnum = typeof EvidenceRecordWarningsColorGradationEnum[keyof typeof EvidenceRecordWarningsColorGradationEnum];
export const EvidenceRecordWarningsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type EvidenceRecordWarningsHeightMillisEnum = typeof EvidenceRecordWarningsHeightMillisEnum[keyof typeof EvidenceRecordWarningsHeightMillisEnum];
export const EvidenceRecordWarningsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type EvidenceRecordWarningsWidthMillisEnum = typeof EvidenceRecordWarningsWidthMillisEnum[keyof typeof EvidenceRecordWarningsWidthMillisEnum];

/**
 * 
 * @export
 * @interface EvidenceUpdatedBy
 */
export interface EvidenceUpdatedBy {
    /**
     * 
     * @type {string}
     * @memberof EvidenceUpdatedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof EvidenceUpdatedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface EvidenceUploadedBy
 */
export interface EvidenceUploadedBy {
    /**
     * 
     * @type {string}
     * @memberof EvidenceUploadedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof EvidenceUploadedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface EvidenceUser
 */
export interface EvidenceUser {
    /**
     * 
     * @type {string}
     * @memberof EvidenceUser
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof EvidenceUser
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface EvidenceWarnings
 */
export interface EvidenceWarnings {
    /**
     * 
     * @type {string}
     * @memberof EvidenceWarnings
     */
    'detectedDpi'?: EvidenceWarningsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidenceWarnings
     */
    'calculatedDpi'?: EvidenceWarningsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidenceWarnings
     */
    'colorGradation'?: EvidenceWarningsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidenceWarnings
     */
    'heightMillis'?: EvidenceWarningsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidenceWarnings
     */
    'widthMillis'?: EvidenceWarningsWidthMillisEnum;
}

export const EvidenceWarningsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type EvidenceWarningsDetectedDpiEnum = typeof EvidenceWarningsDetectedDpiEnum[keyof typeof EvidenceWarningsDetectedDpiEnum];
export const EvidenceWarningsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type EvidenceWarningsCalculatedDpiEnum = typeof EvidenceWarningsCalculatedDpiEnum[keyof typeof EvidenceWarningsCalculatedDpiEnum];
export const EvidenceWarningsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type EvidenceWarningsColorGradationEnum = typeof EvidenceWarningsColorGradationEnum[keyof typeof EvidenceWarningsColorGradationEnum];
export const EvidenceWarningsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type EvidenceWarningsHeightMillisEnum = typeof EvidenceWarningsHeightMillisEnum[keyof typeof EvidenceWarningsHeightMillisEnum];
export const EvidenceWarningsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type EvidenceWarningsWidthMillisEnum = typeof EvidenceWarningsWidthMillisEnum[keyof typeof EvidenceWarningsWidthMillisEnum];

/**
 * 
 * @export
 * @interface EvidenceWithPayments
 */
export interface EvidenceWithPayments {
    /**
     * 
     * @type {string}
     * @memberof EvidenceWithPayments
     */
    'id': string;
    /**
     * This is set if the payment type of the evidence is CARD_TRANSACTION. Otherwise, null.
     * @type {string}
     * @memberof EvidenceWithPayments
     */
    'userAccountId': string | null;
    /**
     * 
     * @type {string}
     * @memberof EvidenceWithPayments
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof EvidenceWithPayments
     */
    'paymentType': EvidenceWithPaymentsPaymentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidenceWithPayments
     */
    'electronicMethod': EvidenceWithPaymentsElectronicMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidenceWithPayments
     */
    'documentSize': EvidenceWithPaymentsDocumentSizeEnum;
    /**
     * 
     * @type {number}
     * @memberof EvidenceWithPayments
     */
    'detectedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof EvidenceWithPayments
     */
    'calculatedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof EvidenceWithPayments
     */
    'colorGradation': number | null;
    /**
     * 
     * @type {number}
     * @memberof EvidenceWithPayments
     */
    'verticalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof EvidenceWithPayments
     */
    'horizontalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof EvidenceWithPayments
     */
    'heightMillis': number | null;
    /**
     * 
     * @type {number}
     * @memberof EvidenceWithPayments
     */
    'widthMillis': number | null;
    /**
     * 
     * @type {string}
     * @memberof EvidenceWithPayments
     */
    'legalValidity': EvidenceWithPaymentsLegalValidityEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidenceWithPayments
     */
    'note': string;
    /**
     * 
     * @type {boolean}
     * @memberof EvidenceWithPayments
     */
    'irrelevantToLedger': boolean;
    /**
     * 
     * @type {EvidenceWithPaymentsFile}
     * @memberof EvidenceWithPayments
     */
    'file': EvidenceWithPaymentsFile;
    /**
     * 
     * @type {Array<EvidenceWithPaymentsPaymentsInner>}
     * @memberof EvidenceWithPayments
     */
    'payments': Array<EvidenceWithPaymentsPaymentsInner>;
    /**
     * 
     * @type {EvidenceWithPaymentsInvoiceIssuer}
     * @memberof EvidenceWithPayments
     */
    'invoiceIssuer': EvidenceWithPaymentsInvoiceIssuer | null;
    /**
     * 
     * @type {EvidenceWithPaymentsErrors}
     * @memberof EvidenceWithPayments
     */
    'errors': EvidenceWithPaymentsErrors;
    /**
     * 
     * @type {EvidenceWithPaymentsWarnings}
     * @memberof EvidenceWithPayments
     */
    'warnings': EvidenceWithPaymentsWarnings;
    /**
     * 
     * @type {EvidenceWithPaymentsUpdatedBy}
     * @memberof EvidenceWithPayments
     */
    'updatedBy': EvidenceWithPaymentsUpdatedBy;
    /**
     * 
     * @type {string}
     * @memberof EvidenceWithPayments
     */
    'updatedAt': string;
    /**
     * 
     * @type {EvidenceWithPaymentsUploadedBy}
     * @memberof EvidenceWithPayments
     */
    'uploadedBy': EvidenceWithPaymentsUploadedBy;
    /**
     * 
     * @type {string}
     * @memberof EvidenceWithPayments
     */
    'uploadedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof EvidenceWithPayments
     */
    'deleted': boolean;
}

export const EvidenceWithPaymentsPaymentTypeEnum = {
    cardTransaction: 'CARD_TRANSACTION',
    paymentRequest: 'PAYMENT_REQUEST'
} as const;

export type EvidenceWithPaymentsPaymentTypeEnum = typeof EvidenceWithPaymentsPaymentTypeEnum[keyof typeof EvidenceWithPaymentsPaymentTypeEnum];
export const EvidenceWithPaymentsElectronicMethodEnum = {
    fullElectronic: 'FULL_ELECTRONIC',
    originallyPaper: 'ORIGINALLY_PAPER',
    unknown: 'UNKNOWN'
} as const;

export type EvidenceWithPaymentsElectronicMethodEnum = typeof EvidenceWithPaymentsElectronicMethodEnum[keyof typeof EvidenceWithPaymentsElectronicMethodEnum];
export const EvidenceWithPaymentsDocumentSizeEnum = {
    overA4: 'OVER_A4',
    a4OrSmaller: 'A4_OR_SMALLER',
    unknown: 'UNKNOWN'
} as const;

export type EvidenceWithPaymentsDocumentSizeEnum = typeof EvidenceWithPaymentsDocumentSizeEnum[keyof typeof EvidenceWithPaymentsDocumentSizeEnum];
export const EvidenceWithPaymentsLegalValidityEnum = {
    valid: 'VALID',
    invalid: 'INVALID',
    inputRequired: 'INPUT_REQUIRED',
    outOfTarget: 'OUT_OF_TARGET'
} as const;

export type EvidenceWithPaymentsLegalValidityEnum = typeof EvidenceWithPaymentsLegalValidityEnum[keyof typeof EvidenceWithPaymentsLegalValidityEnum];

/**
 * 
 * @export
 * @interface EvidenceWithPaymentsErrors
 */
export interface EvidenceWithPaymentsErrors {
    /**
     * 
     * @type {string}
     * @memberof EvidenceWithPaymentsErrors
     */
    'detectedDpi'?: EvidenceWithPaymentsErrorsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidenceWithPaymentsErrors
     */
    'calculatedDpi'?: EvidenceWithPaymentsErrorsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidenceWithPaymentsErrors
     */
    'colorGradation'?: EvidenceWithPaymentsErrorsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidenceWithPaymentsErrors
     */
    'heightMillis'?: EvidenceWithPaymentsErrorsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidenceWithPaymentsErrors
     */
    'widthMillis'?: EvidenceWithPaymentsErrorsWidthMillisEnum;
}

export const EvidenceWithPaymentsErrorsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type EvidenceWithPaymentsErrorsDetectedDpiEnum = typeof EvidenceWithPaymentsErrorsDetectedDpiEnum[keyof typeof EvidenceWithPaymentsErrorsDetectedDpiEnum];
export const EvidenceWithPaymentsErrorsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type EvidenceWithPaymentsErrorsCalculatedDpiEnum = typeof EvidenceWithPaymentsErrorsCalculatedDpiEnum[keyof typeof EvidenceWithPaymentsErrorsCalculatedDpiEnum];
export const EvidenceWithPaymentsErrorsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type EvidenceWithPaymentsErrorsColorGradationEnum = typeof EvidenceWithPaymentsErrorsColorGradationEnum[keyof typeof EvidenceWithPaymentsErrorsColorGradationEnum];
export const EvidenceWithPaymentsErrorsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type EvidenceWithPaymentsErrorsHeightMillisEnum = typeof EvidenceWithPaymentsErrorsHeightMillisEnum[keyof typeof EvidenceWithPaymentsErrorsHeightMillisEnum];
export const EvidenceWithPaymentsErrorsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type EvidenceWithPaymentsErrorsWidthMillisEnum = typeof EvidenceWithPaymentsErrorsWidthMillisEnum[keyof typeof EvidenceWithPaymentsErrorsWidthMillisEnum];

/**
 * 
 * @export
 * @interface EvidenceWithPaymentsFile
 */
export interface EvidenceWithPaymentsFile {
    /**
     * 
     * @type {string}
     * @memberof EvidenceWithPaymentsFile
     */
    'id': string | null;
    /**
     * 
     * @type {string}
     * @memberof EvidenceWithPaymentsFile
     */
    'name': string;
    /**
     * A URL with expiration date-time accessible from the front-end. This is not fully supported yet. In responses from certain endpoints, the url is set to null.
     * @type {string}
     * @memberof EvidenceWithPaymentsFile
     */
    'url': string | null;
}
/**
 * Set null if it\'s evidence not analyzed using invoicing-system-compliance feature. Also set null if invoicing-system-compliance feature has been made not available for the organization by the feature-flag.
 * @export
 * @interface EvidenceWithPaymentsInvoiceIssuer
 */
export interface EvidenceWithPaymentsInvoiceIssuer {
    /**
     * 
     * @type {string}
     * @memberof EvidenceWithPaymentsInvoiceIssuer
     */
    'name': string | null;
    /**
     * 
     * @type {string}
     * @memberof EvidenceWithPaymentsInvoiceIssuer
     */
    'registrationNumber': string | null;
    /**
     * isQualified retains the result of querying the 国税庁API to see if registrationNumber is qualified, as is.
     * @type {boolean}
     * @memberof EvidenceWithPaymentsInvoiceIssuer
     */
    'isQualified': boolean;
    /**
     * AsQualified indicates whether this issuer should be treated as a qualified invoice issuer within the user\'s system, even if the RegistrationNumber is not confirmed as qualified in the National Tax Agency\'s business registration system.
     * @type {boolean}
     * @memberof EvidenceWithPaymentsInvoiceIssuer
     */
    'asQualified': boolean;
    /**
     * 
     * @type {string}
     * @memberof EvidenceWithPaymentsInvoiceIssuer
     */
    'partnerId': string | null;
}
/**
 * 
 * @export
 * @interface EvidenceWithPaymentsPaymentsInner
 */
export interface EvidenceWithPaymentsPaymentsInner {
    /**
     * 
     * @type {string}
     * @memberof EvidenceWithPaymentsPaymentsInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof EvidenceWithPaymentsPaymentsInner
     */
    'paidAt': string;
    /**
     * 
     * @type {number}
     * @memberof EvidenceWithPaymentsPaymentsInner
     */
    'amount': number;
    /**
     * The issuer of the associated evidence.
     * @type {string}
     * @memberof EvidenceWithPaymentsPaymentsInner
     */
    'issuer': string;
}
/**
 * 
 * @export
 * @interface EvidenceWithPaymentsUpdatedBy
 */
export interface EvidenceWithPaymentsUpdatedBy {
    /**
     * 
     * @type {string}
     * @memberof EvidenceWithPaymentsUpdatedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof EvidenceWithPaymentsUpdatedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface EvidenceWithPaymentsUploadedBy
 */
export interface EvidenceWithPaymentsUploadedBy {
    /**
     * 
     * @type {string}
     * @memberof EvidenceWithPaymentsUploadedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof EvidenceWithPaymentsUploadedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface EvidenceWithPaymentsWarnings
 */
export interface EvidenceWithPaymentsWarnings {
    /**
     * 
     * @type {string}
     * @memberof EvidenceWithPaymentsWarnings
     */
    'detectedDpi'?: EvidenceWithPaymentsWarningsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidenceWithPaymentsWarnings
     */
    'calculatedDpi'?: EvidenceWithPaymentsWarningsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidenceWithPaymentsWarnings
     */
    'colorGradation'?: EvidenceWithPaymentsWarningsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidenceWithPaymentsWarnings
     */
    'heightMillis'?: EvidenceWithPaymentsWarningsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidenceWithPaymentsWarnings
     */
    'widthMillis'?: EvidenceWithPaymentsWarningsWidthMillisEnum;
}

export const EvidenceWithPaymentsWarningsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type EvidenceWithPaymentsWarningsDetectedDpiEnum = typeof EvidenceWithPaymentsWarningsDetectedDpiEnum[keyof typeof EvidenceWithPaymentsWarningsDetectedDpiEnum];
export const EvidenceWithPaymentsWarningsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type EvidenceWithPaymentsWarningsCalculatedDpiEnum = typeof EvidenceWithPaymentsWarningsCalculatedDpiEnum[keyof typeof EvidenceWithPaymentsWarningsCalculatedDpiEnum];
export const EvidenceWithPaymentsWarningsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type EvidenceWithPaymentsWarningsColorGradationEnum = typeof EvidenceWithPaymentsWarningsColorGradationEnum[keyof typeof EvidenceWithPaymentsWarningsColorGradationEnum];
export const EvidenceWithPaymentsWarningsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type EvidenceWithPaymentsWarningsHeightMillisEnum = typeof EvidenceWithPaymentsWarningsHeightMillisEnum[keyof typeof EvidenceWithPaymentsWarningsHeightMillisEnum];
export const EvidenceWithPaymentsWarningsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type EvidenceWithPaymentsWarningsWidthMillisEnum = typeof EvidenceWithPaymentsWarningsWidthMillisEnum[keyof typeof EvidenceWithPaymentsWarningsWidthMillisEnum];

/**
 * 
 * @export
 * @interface FailCardTransaction
 */
export interface FailCardTransaction {
    /**
     * 
     * @type {FailCardTransactionCardTransaction}
     * @memberof FailCardTransaction
     */
    'cardTransaction': FailCardTransactionCardTransaction;
    /**
     * 
     * @type {FailCardTransactionComment}
     * @memberof FailCardTransaction
     */
    'comment'?: FailCardTransactionComment;
    /**
     * 
     * @type {FailCardTransactionUserAccount}
     * @memberof FailCardTransaction
     */
    'userAccount': FailCardTransactionUserAccount;
}
/**
 * 
 * @export
 * @interface FailCardTransactionCardTransaction
 */
export interface FailCardTransactionCardTransaction {
    /**
     * 
     * @type {string}
     * @memberof FailCardTransactionCardTransaction
     */
    'visaTransactionReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof FailCardTransactionCardTransaction
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof FailCardTransactionCardTransaction
     */
    'merchantName': string;
    /**
     * 
     * @type {string}
     * @memberof FailCardTransactionCardTransaction
     */
    'merchantNameKana': string;
    /**
     * 
     * @type {string}
     * @memberof FailCardTransactionCardTransaction
     */
    'merchantNameKanji': string;
    /**
     * 
     * @type {string}
     * @memberof FailCardTransactionCardTransaction
     */
    'mergedMerchantName': string;
    /**
     * 
     * @type {number}
     * @memberof FailCardTransactionCardTransaction
     */
    'amount': number;
    /**
     * 
     * @type {number}
     * @memberof FailCardTransactionCardTransaction
     */
    'amountFx': number;
    /**
     * 
     * @type {string}
     * @memberof FailCardTransactionCardTransaction
     */
    'currencyCode': string;
    /**
     * 
     * @type {string}
     * @memberof FailCardTransactionCardTransaction
     */
    'failureReason': string;
    /**
     * 
     * @type {string}
     * @memberof FailCardTransactionCardTransaction
     */
    'processedAt': string;
    /**
     * 
     * @type {string}
     * @memberof FailCardTransactionCardTransaction
     */
    'transactionType': FailCardTransactionCardTransactionTransactionTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof FailCardTransactionCardTransaction
     */
    'transactionStatus': FailCardTransactionCardTransactionTransactionStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof FailCardTransactionCardTransaction
     */
    'creditSettlement': number;
    /**
     * 
     * @type {Array<FailCardTransactionCardTransactionTransactionRecordListInner>}
     * @memberof FailCardTransactionCardTransaction
     */
    'transactionRecordList': Array<FailCardTransactionCardTransactionTransactionRecordListInner>;
}

export const FailCardTransactionCardTransactionTransactionTypeEnum = {
    confirm: 'CONFIRM',
    notConfirm: 'NOT_CONFIRM'
} as const;

export type FailCardTransactionCardTransactionTransactionTypeEnum = typeof FailCardTransactionCardTransactionTransactionTypeEnum[keyof typeof FailCardTransactionCardTransactionTransactionTypeEnum];
export const FailCardTransactionCardTransactionTransactionStatusEnum = {
    fail: 'FAIL'
} as const;

export type FailCardTransactionCardTransactionTransactionStatusEnum = typeof FailCardTransactionCardTransactionTransactionStatusEnum[keyof typeof FailCardTransactionCardTransactionTransactionStatusEnum];

/**
 * 
 * @export
 * @interface FailCardTransactionCardTransactionTransactionRecordListInner
 */
export interface FailCardTransactionCardTransactionTransactionRecordListInner {
    /**
     * 
     * @type {number}
     * @memberof FailCardTransactionCardTransactionTransactionRecordListInner
     */
    'amount': number;
    /**
     * 
     * @type {number}
     * @memberof FailCardTransactionCardTransactionTransactionRecordListInner
     */
    'amountFx': number;
    /**
     * 
     * @type {number}
     * @memberof FailCardTransactionCardTransactionTransactionRecordListInner
     */
    'totalAmount': number;
    /**
     * 
     * @type {number}
     * @memberof FailCardTransactionCardTransactionTransactionRecordListInner
     */
    'totalAmountFx': number;
    /**
     * 
     * @type {string}
     * @memberof FailCardTransactionCardTransactionTransactionRecordListInner
     */
    'currencyCode': string;
    /**
     * 
     * @type {number}
     * @memberof FailCardTransactionCardTransactionTransactionRecordListInner
     */
    'fxRate': number | null;
    /**
     * 
     * @type {string}
     * @memberof FailCardTransactionCardTransactionTransactionRecordListInner
     */
    'processedAt': string;
    /**
     * 
     * @type {string}
     * @memberof FailCardTransactionCardTransactionTransactionRecordListInner
     */
    'transactionDetailType': FailCardTransactionCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum;
}

export const FailCardTransactionCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum = {
    purchase: 'PURCHASE',
    settlement: 'SETTLEMENT',
    validation: 'VALIDATION',
    refund: 'REFUND',
    cancel: 'CANCEL',
    refundCancel: 'REFUND_CANCEL',
    refundPartialCancel: 'REFUND_PARTIAL_CANCEL'
} as const;

export type FailCardTransactionCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum = typeof FailCardTransactionCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum[keyof typeof FailCardTransactionCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum];

/**
 * 
 * @export
 * @interface FailCardTransactionComment
 */
export interface FailCardTransactionComment {
    /**
     * 
     * @type {string}
     * @memberof FailCardTransactionComment
     */
    'cardTransactionCommentId': string;
    /**
     * 
     * @type {string}
     * @memberof FailCardTransactionComment
     */
    'visaTransactionReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof FailCardTransactionComment
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof FailCardTransactionComment
     */
    'comment': string;
    /**
     * 
     * @type {FailCardTransactionCommentCreatedBy}
     * @memberof FailCardTransactionComment
     */
    'createdBy': FailCardTransactionCommentCreatedBy;
}
/**
 * 
 * @export
 * @interface FailCardTransactionCommentCreatedBy
 */
export interface FailCardTransactionCommentCreatedBy {
    /**
     * 
     * @type {string}
     * @memberof FailCardTransactionCommentCreatedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof FailCardTransactionCommentCreatedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface FailCardTransactionUserAccount
 */
export interface FailCardTransactionUserAccount {
    /**
     * 
     * @type {string}
     * @memberof FailCardTransactionUserAccount
     */
    'userAccountId': string;
    /**
     * 
     * @type {FailCardTransactionUserAccountUser}
     * @memberof FailCardTransactionUserAccount
     */
    'user': FailCardTransactionUserAccountUser;
    /**
     * 
     * @type {string}
     * @memberof FailCardTransactionUserAccount
     */
    'cardLabel': string;
    /**
     * 
     * @type {string}
     * @memberof FailCardTransactionUserAccount
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof FailCardTransactionUserAccount
     */
    'organizationName': string;
    /**
     * 
     * @type {FailCardTransactionUserAccountUserAccountGroup}
     * @memberof FailCardTransactionUserAccount
     */
    'userAccountGroup': FailCardTransactionUserAccountUserAccountGroup | null;
    /**
     * 
     * @type {boolean}
     * @memberof FailCardTransactionUserAccount
     */
    'isOnDemand': boolean;
}
/**
 * 
 * @export
 * @interface FailCardTransactionUserAccountUser
 */
export interface FailCardTransactionUserAccountUser {
    /**
     * 
     * @type {string}
     * @memberof FailCardTransactionUserAccountUser
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof FailCardTransactionUserAccountUser
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof FailCardTransactionUserAccountUser
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof FailCardTransactionUserAccountUser
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof FailCardTransactionUserAccountUser
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FailCardTransactionUserAccountUser
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FailCardTransactionUserAccountUser
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FailCardTransactionUserAccountUser
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FailCardTransactionUserAccountUser
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FailCardTransactionUserAccountUser
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof FailCardTransactionUserAccountUser
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface FailCardTransactionUserAccountUserAccountGroup
 */
export interface FailCardTransactionUserAccountUserAccountGroup {
    /**
     * 
     * @type {string}
     * @memberof FailCardTransactionUserAccountUserAccountGroup
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof FailCardTransactionUserAccountUserAccountGroup
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof FailCardTransactionUserAccountUserAccountGroup
     */
    'sortNum': number;
}
/**
 * 
 * @export
 * @interface FreeePartner
 */
export interface FreeePartner {
    /**
     * 
     * @type {string}
     * @memberof FreeePartner
     */
    'freeeCompanyId': string;
    /**
     * 
     * @type {string}
     * @memberof FreeePartner
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof FreeePartner
     */
    'freeePartnerId': string;
    /**
     * 
     * @type {string}
     * @memberof FreeePartner
     */
    'freeePartnerCode': string;
    /**
     * 
     * @type {boolean}
     * @memberof FreeePartner
     */
    'orphaned': boolean;
}
/**
 * 
 * @export
 * @interface FreezeCard200Response
 */
export interface FreezeCard200Response {
    /**
     * 
     * @type {string}
     * @memberof FreezeCard200Response
     */
    'cardId': string;
    /**
     * 
     * @type {boolean}
     * @memberof FreezeCard200Response
     */
    'isActivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FreezeCard200Response
     */
    'isDeactivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FreezeCard200Response
     */
    'isLocked': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FreezeCard200Response
     */
    'isSuspended': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FreezeCard200Response
     */
    'isFrozen': boolean;
    /**
     * 
     * @type {string}
     * @memberof FreezeCard200Response
     */
    'panLastFourDigits': string;
    /**
     * 
     * @type {string}
     * @memberof FreezeCard200Response
     */
    'linkedUserAccountId': string;
    /**
     * 
     * @type {string}
     * @memberof FreezeCard200Response
     */
    'createdAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof FreezeCard200Response
     */
    'isActive': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FreezeCard200Response
     */
    'isVirtualCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FreezeCard200Response
     */
    'isCreditCard': boolean;
}
/**
 * 
 * @export
 * @interface GenerateCreateAccountTokenRequest
 */
export interface GenerateCreateAccountTokenRequest {
    /**
     * 
     * @type {string}
     * @memberof GenerateCreateAccountTokenRequest
     */
    'identificationId': string;
    /**
     * 
     * @type {string}
     * @memberof GenerateCreateAccountTokenRequest
     */
    'transactionManagerBirthday': string;
}
/**
 * 
 * @export
 * @interface GenerateFreeeRedirectUrl200Response
 */
export interface GenerateFreeeRedirectUrl200Response {
    /**
     * 
     * @type {string}
     * @memberof GenerateFreeeRedirectUrl200Response
     */
    'url': string;
}
/**
 * 
 * @export
 * @interface GetACardDetailAsAdmin200Response
 */
export interface GetACardDetailAsAdmin200Response {
    /**
     * 
     * @type {string}
     * @memberof GetACardDetailAsAdmin200Response
     */
    'cardId': string;
    /**
     * 
     * @type {string}
     * @memberof GetACardDetailAsAdmin200Response
     */
    'pan': string;
    /**
     * 
     * @type {string}
     * @memberof GetACardDetailAsAdmin200Response
     */
    'cvv2': string;
    /**
     * 
     * @type {string}
     * @memberof GetACardDetailAsAdmin200Response
     */
    'expiryYear': string;
    /**
     * 
     * @type {string}
     * @memberof GetACardDetailAsAdmin200Response
     */
    'expiryMonth': string;
}
/**
 * 
 * @export
 * @interface GetAdminUsers200Response
 */
export interface GetAdminUsers200Response {
    /**
     * 
     * @type {string}
     * @memberof GetAdminUsers200Response
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetAdminUsers200Response
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetAdminUsers200Response
     */
    'email': string;
    /**
     * 
     * @type {Array<GetAdminUsers200ResponseRolesInner>}
     * @memberof GetAdminUsers200Response
     */
    'roles': Array<GetAdminUsers200ResponseRolesInner>;
}
/**
 * 
 * @export
 * @interface GetAdminUsers200ResponseRolesInner
 */
export interface GetAdminUsers200ResponseRolesInner {
    /**
     * 
     * @type {string}
     * @memberof GetAdminUsers200ResponseRolesInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetAdminUsers200ResponseRolesInner
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetAdminUsers200ResponseRolesInner
     */
    'category': GetAdminUsers200ResponseRolesInnerCategoryEnum;
}

export const GetAdminUsers200ResponseRolesInnerCategoryEnum = {
    system: 'SYSTEM',
    app: 'APP',
    card: 'CARD'
} as const;

export type GetAdminUsers200ResponseRolesInnerCategoryEnum = typeof GetAdminUsers200ResponseRolesInnerCategoryEnum[keyof typeof GetAdminUsers200ResponseRolesInnerCategoryEnum];

/**
 * 
 * @export
 * @interface GetAdmins200ResponseInner
 */
export interface GetAdmins200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetAdmins200ResponseInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetAdmins200ResponseInner
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetAdmins200ResponseInner
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetAdmins200ResponseInner
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof GetAdmins200ResponseInner
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetAdmins200ResponseInner
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetAdmins200ResponseInner
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetAdmins200ResponseInner
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetAdmins200ResponseInner
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetAdmins200ResponseInner
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetAdmins200ResponseInner
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface GetAgreementRequests200ResponseInner
 */
export interface GetAgreementRequests200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetAgreementRequests200ResponseInner
     */
    'agreementRequestId': string;
    /**
     * 
     * @type {string}
     * @memberof GetAgreementRequests200ResponseInner
     */
    'agreementId': string;
    /**
     * 
     * @type {string}
     * @memberof GetAgreementRequests200ResponseInner
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetAgreementRequests200ResponseInner
     */
    'requestDate': string;
    /**
     * 
     * @type {string}
     * @memberof GetAgreementRequests200ResponseInner
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetAgreementRequests200ResponseInner
     */
    'agreementStatus': GetAgreementRequests200ResponseInnerAgreementStatusEnum;
    /**
     * 
     * @type {boolean}
     * @memberof GetAgreementRequests200ResponseInner
     */
    'isRequired': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetAgreementRequests200ResponseInner
     */
    'submittedBy': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetAgreementRequests200ResponseInner
     */
    'submittedAt': string | null;
}

export const GetAgreementRequests200ResponseInnerAgreementStatusEnum = {
    notAgreed: 'NOT_AGREED',
    agreed: 'AGREED',
    disagreed: 'DISAGREED'
} as const;

export type GetAgreementRequests200ResponseInnerAgreementStatusEnum = typeof GetAgreementRequests200ResponseInnerAgreementStatusEnum[keyof typeof GetAgreementRequests200ResponseInnerAgreementStatusEnum];

/**
 * 
 * @export
 * @interface GetAllBanks200ResponseInner
 */
export interface GetAllBanks200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetAllBanks200ResponseInner
     */
    'bankCode': string;
    /**
     * 
     * @type {string}
     * @memberof GetAllBanks200ResponseInner
     */
    'bankName': string;
}
/**
 * 
 * @export
 * @interface GetAnalysisInvoiceOfPaymentRequest200Response
 */
export interface GetAnalysisInvoiceOfPaymentRequest200Response {
    /**
     * 
     * @type {string}
     * @memberof GetAnalysisInvoiceOfPaymentRequest200Response
     */
    'fileId': string;
    /**
     * To return an OK response even if the result of OCR analysis fails, express in this field whether the OCR analysis was successful.
     * @type {boolean}
     * @memberof GetAnalysisInvoiceOfPaymentRequest200Response
     */
    'analyzed': boolean;
    /**
     * 
     * @type {GetAnalysisInvoiceOfPaymentRequest200ResponseSupplier}
     * @memberof GetAnalysisInvoiceOfPaymentRequest200Response
     */
    'supplier': GetAnalysisInvoiceOfPaymentRequest200ResponseSupplier;
    /**
     * 
     * @type {string}
     * @memberof GetAnalysisInvoiceOfPaymentRequest200Response
     */
    'billingDate': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetAnalysisInvoiceOfPaymentRequest200Response
     */
    'dueDate': string | null;
    /**
     * 
     * @type {number}
     * @memberof GetAnalysisInvoiceOfPaymentRequest200Response
     */
    'totalAmount': number | null;
    /**
     * 
     * @type {string}
     * @memberof GetAnalysisInvoiceOfPaymentRequest200Response
     */
    'invoiceIssuerName': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetAnalysisInvoiceOfPaymentRequest200Response
     */
    'invoiceIssuerRegistrationNumber': string | null;
}
/**
 * 
 * @export
 * @interface GetAnalysisInvoiceOfPaymentRequest200ResponseSupplier
 */
export interface GetAnalysisInvoiceOfPaymentRequest200ResponseSupplier {
    /**
     * 
     * @type {string}
     * @memberof GetAnalysisInvoiceOfPaymentRequest200ResponseSupplier
     */
    'partnerId': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetAnalysisInvoiceOfPaymentRequest200ResponseSupplier
     */
    'name': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetAnalysisInvoiceOfPaymentRequest200ResponseSupplier
     */
    'bankNumber': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetAnalysisInvoiceOfPaymentRequest200ResponseSupplier
     */
    'bankName': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetAnalysisInvoiceOfPaymentRequest200ResponseSupplier
     */
    'branchNumber': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetAnalysisInvoiceOfPaymentRequest200ResponseSupplier
     */
    'branchName': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetAnalysisInvoiceOfPaymentRequest200ResponseSupplier
     */
    'accountNumber': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetAnalysisInvoiceOfPaymentRequest200ResponseSupplier
     */
    'accountType': GetAnalysisInvoiceOfPaymentRequest200ResponseSupplierAccountTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetAnalysisInvoiceOfPaymentRequest200ResponseSupplier
     */
    'companyName': string | null;
}

export const GetAnalysisInvoiceOfPaymentRequest200ResponseSupplierAccountTypeEnum = {
    savingsAccount: 'SAVINGS_ACCOUNT',
    currentAccount: 'CURRENT_ACCOUNT',
    thriftAccount: 'THRIFT_ACCOUNT',
    other: 'OTHER'
} as const;

export type GetAnalysisInvoiceOfPaymentRequest200ResponseSupplierAccountTypeEnum = typeof GetAnalysisInvoiceOfPaymentRequest200ResponseSupplierAccountTypeEnum[keyof typeof GetAnalysisInvoiceOfPaymentRequest200ResponseSupplierAccountTypeEnum];

/**
 * 
 * @export
 * @interface GetAnnualFeesEligibility200Response
 */
export interface GetAnnualFeesEligibility200Response {
    /**
     * Whether the organization has annual fees
     * @type {boolean}
     * @memberof GetAnnualFeesEligibility200Response
     */
    'hasAnnualFees': boolean;
}
/**
 * 
 * @export
 * @interface GetApprovers200ResponseInner
 */
export interface GetApprovers200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetApprovers200ResponseInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetApprovers200ResponseInner
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetApprovers200ResponseInner
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetApprovers200ResponseInner
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof GetApprovers200ResponseInner
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetApprovers200ResponseInner
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetApprovers200ResponseInner
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetApprovers200ResponseInner
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetApprovers200ResponseInner
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetApprovers200ResponseInner
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetApprovers200ResponseInner
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface GetAvailableMerchantCategoryOptions200Response
 */
export interface GetAvailableMerchantCategoryOptions200Response {
    /**
     * 
     * @type {Array<GetAvailableMerchantCategoryOptions200ResponseCategoriesInner>}
     * @memberof GetAvailableMerchantCategoryOptions200Response
     */
    'categories': Array<GetAvailableMerchantCategoryOptions200ResponseCategoriesInner>;
    /**
     * 
     * @type {string}
     * @memberof GetAvailableMerchantCategoryOptions200Response
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof GetAvailableMerchantCategoryOptions200Response
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetAvailableMerchantCategoryOptions200Response
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetAvailableMerchantCategoryOptions200ResponseCategoriesInner
 */
export interface GetAvailableMerchantCategoryOptions200ResponseCategoriesInner {
    /**
     * 
     * @type {string}
     * @memberof GetAvailableMerchantCategoryOptions200ResponseCategoriesInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetAvailableMerchantCategoryOptions200ResponseCategoriesInner
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetAvailableMerchantCategoryOptions200ResponseCategoriesInner
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof GetAvailableMerchantCategoryOptions200ResponseCategoriesInner
     */
    'logoUrl': string;
}
/**
 * 
 * @export
 * @interface GetBalanceState200Response
 */
export interface GetBalanceState200Response {
    /**
     * 
     * @type {number}
     * @memberof GetBalanceState200Response
     */
    'balance': number;
    /**
     * 
     * @type {number}
     * @memberof GetBalanceState200Response
     */
    'pointBalance': number;
    /**
     * 
     * @type {number}
     * @memberof GetBalanceState200Response
     */
    'cashBalance': number;
    /**
     * 
     * @type {number}
     * @memberof GetBalanceState200Response
     */
    'depositableAmount': number;
    /**
     * 
     * @type {number}
     * @memberof GetBalanceState200Response
     */
    'withdrawableAmount': number;
    /**
     * 
     * @type {Array<GetBalanceState200ResponsePredictedDailyBalanceTransitionListInner>}
     * @memberof GetBalanceState200Response
     */
    'predictedDailyBalanceTransitionList': Array<GetBalanceState200ResponsePredictedDailyBalanceTransitionListInner>;
}
/**
 * 
 * @export
 * @interface GetBalanceState200ResponsePredictedDailyBalanceTransitionListInner
 */
export interface GetBalanceState200ResponsePredictedDailyBalanceTransitionListInner {
    /**
     * 
     * @type {string}
     * @memberof GetBalanceState200ResponsePredictedDailyBalanceTransitionListInner
     */
    'targetDate': string;
    /**
     * 
     * @type {number}
     * @memberof GetBalanceState200ResponsePredictedDailyBalanceTransitionListInner
     */
    'balance': number;
    /**
     * 
     * @type {number}
     * @memberof GetBalanceState200ResponsePredictedDailyBalanceTransitionListInner
     */
    'amount': number;
    /**
     * 
     * @type {number}
     * @memberof GetBalanceState200ResponsePredictedDailyBalanceTransitionListInner
     */
    'length': number;
    /**
     * 
     * @type {string}
     * @memberof GetBalanceState200ResponsePredictedDailyBalanceTransitionListInner
     */
    'type': GetBalanceState200ResponsePredictedDailyBalanceTransitionListInnerTypeEnum;
    /**
     * 
     * @type {Array<GetBalanceState200ResponsePredictedDailyBalanceTransitionListInnerActivitiesInner>}
     * @memberof GetBalanceState200ResponsePredictedDailyBalanceTransitionListInner
     */
    'activities': Array<GetBalanceState200ResponsePredictedDailyBalanceTransitionListInnerActivitiesInner>;
    /**
     * 
     * @type {number}
     * @memberof GetBalanceState200ResponsePredictedDailyBalanceTransitionListInner
     */
    'balanceWithGuaranteeMoney': number;
}

export const GetBalanceState200ResponsePredictedDailyBalanceTransitionListInnerTypeEnum = {
    payBill: 'PAY_BILL',
    deposit: 'DEPOSIT',
    withdrawal: 'WITHDRAWAL',
    reward: 'REWARD',
    usageFee: 'USAGE_FEE',
    point: 'POINT',
    cardPoint: 'CARD_POINT',
    campaignPoint: 'CAMPAIGN_POINT',
    card: 'CARD',
    depositFromGuaranteeMoney: 'DEPOSIT_FROM_GUARANTEE_MONEY',
    withdrawalToGuaranteeMoney: 'WITHDRAWAL_TO_GUARANTEE_MONEY'
} as const;

export type GetBalanceState200ResponsePredictedDailyBalanceTransitionListInnerTypeEnum = typeof GetBalanceState200ResponsePredictedDailyBalanceTransitionListInnerTypeEnum[keyof typeof GetBalanceState200ResponsePredictedDailyBalanceTransitionListInnerTypeEnum];

/**
 * 
 * @export
 * @interface GetBalanceState200ResponsePredictedDailyBalanceTransitionListInnerActivitiesInner
 */
export interface GetBalanceState200ResponsePredictedDailyBalanceTransitionListInnerActivitiesInner {
    /**
     * 
     * @type {string}
     * @memberof GetBalanceState200ResponsePredictedDailyBalanceTransitionListInnerActivitiesInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetBalanceState200ResponsePredictedDailyBalanceTransitionListInnerActivitiesInner
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetBalanceState200ResponsePredictedDailyBalanceTransitionListInnerActivitiesInner
     */
    'organizationName': string;
    /**
     * 
     * @type {string}
     * @memberof GetBalanceState200ResponsePredictedDailyBalanceTransitionListInnerActivitiesInner
     */
    'type': GetBalanceState200ResponsePredictedDailyBalanceTransitionListInnerActivitiesInnerTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetBalanceState200ResponsePredictedDailyBalanceTransitionListInnerActivitiesInner
     */
    'status': GetBalanceState200ResponsePredictedDailyBalanceTransitionListInnerActivitiesInnerStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof GetBalanceState200ResponsePredictedDailyBalanceTransitionListInnerActivitiesInner
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof GetBalanceState200ResponsePredictedDailyBalanceTransitionListInnerActivitiesInner
     */
    'supplierName': string;
    /**
     * 
     * @type {number}
     * @memberof GetBalanceState200ResponsePredictedDailyBalanceTransitionListInnerActivitiesInner
     */
    'amount': number;
    /**
     * 
     * @type {number}
     * @memberof GetBalanceState200ResponsePredictedDailyBalanceTransitionListInnerActivitiesInner
     */
    'pointAmount': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetBalanceState200ResponsePredictedDailyBalanceTransitionListInnerActivitiesInner
     */
    'balance': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetBalanceState200ResponsePredictedDailyBalanceTransitionListInnerActivitiesInner
     */
    'pointBalance': number | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetBalanceState200ResponsePredictedDailyBalanceTransitionListInnerActivitiesInner
     */
    'isConfirmed': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetBalanceState200ResponsePredictedDailyBalanceTransitionListInnerActivitiesInner
     */
    'appliedAt': string | null;
    /**
     * 
     * @type {GetBalanceState200ResponsePredictedDailyBalanceTransitionListInnerActivitiesInnerAppliedBy}
     * @memberof GetBalanceState200ResponsePredictedDailyBalanceTransitionListInnerActivitiesInner
     */
    'appliedBy': GetBalanceState200ResponsePredictedDailyBalanceTransitionListInnerActivitiesInnerAppliedBy;
    /**
     * 
     * @type {string}
     * @memberof GetBalanceState200ResponsePredictedDailyBalanceTransitionListInnerActivitiesInner
     */
    'executedAt': string | null;
}

export const GetBalanceState200ResponsePredictedDailyBalanceTransitionListInnerActivitiesInnerTypeEnum = {
    payBill: 'PAY_BILL',
    deposit: 'DEPOSIT',
    withdrawal: 'WITHDRAWAL',
    reward: 'REWARD',
    usageFee: 'USAGE_FEE',
    point: 'POINT',
    cardPoint: 'CARD_POINT',
    campaignPoint: 'CAMPAIGN_POINT',
    card: 'CARD',
    depositFromGuaranteeMoney: 'DEPOSIT_FROM_GUARANTEE_MONEY',
    withdrawalToGuaranteeMoney: 'WITHDRAWAL_TO_GUARANTEE_MONEY'
} as const;

export type GetBalanceState200ResponsePredictedDailyBalanceTransitionListInnerActivitiesInnerTypeEnum = typeof GetBalanceState200ResponsePredictedDailyBalanceTransitionListInnerActivitiesInnerTypeEnum[keyof typeof GetBalanceState200ResponsePredictedDailyBalanceTransitionListInnerActivitiesInnerTypeEnum];
export const GetBalanceState200ResponsePredictedDailyBalanceTransitionListInnerActivitiesInnerStatusEnum = {
    reserved: 'RESERVED',
    requestingExternalAccountTransfer: 'REQUESTING_EXTERNAL_ACCOUNT_TRANSFER',
    completed: 'COMPLETED',
    insufficientBalance: 'INSUFFICIENT_BALANCE',
    uploaded: 'UPLOADED',
    readCompleted: 'READ_COMPLETED',
    awaitingApproval: 'AWAITING_APPROVAL',
    approved: 'APPROVED',
    transferCompleted: 'TRANSFER_COMPLETED',
    readError: 'READ_ERROR',
    transferFailed: 'TRANSFER_FAILED',
    approvalExpired: 'APPROVAL_EXPIRED',
    approvalRejected: 'APPROVAL_REJECTED',
    otherError: 'OTHER_ERROR',
    pending: 'PENDING'
} as const;

export type GetBalanceState200ResponsePredictedDailyBalanceTransitionListInnerActivitiesInnerStatusEnum = typeof GetBalanceState200ResponsePredictedDailyBalanceTransitionListInnerActivitiesInnerStatusEnum[keyof typeof GetBalanceState200ResponsePredictedDailyBalanceTransitionListInnerActivitiesInnerStatusEnum];

/**
 * 
 * @export
 * @interface GetBalanceState200ResponsePredictedDailyBalanceTransitionListInnerActivitiesInnerAppliedBy
 */
export interface GetBalanceState200ResponsePredictedDailyBalanceTransitionListInnerActivitiesInnerAppliedBy {
    /**
     * 
     * @type {string}
     * @memberof GetBalanceState200ResponsePredictedDailyBalanceTransitionListInnerActivitiesInnerAppliedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetBalanceState200ResponsePredictedDailyBalanceTransitionListInnerActivitiesInnerAppliedBy
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetBalanceState200ResponsePredictedDailyBalanceTransitionListInnerActivitiesInnerAppliedBy
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetBalanceState200ResponsePredictedDailyBalanceTransitionListInnerActivitiesInnerAppliedBy
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof GetBalanceState200ResponsePredictedDailyBalanceTransitionListInnerActivitiesInnerAppliedBy
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetBalanceState200ResponsePredictedDailyBalanceTransitionListInnerActivitiesInnerAppliedBy
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetBalanceState200ResponsePredictedDailyBalanceTransitionListInnerActivitiesInnerAppliedBy
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetBalanceState200ResponsePredictedDailyBalanceTransitionListInnerActivitiesInnerAppliedBy
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetBalanceState200ResponsePredictedDailyBalanceTransitionListInnerActivitiesInnerAppliedBy
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetBalanceState200ResponsePredictedDailyBalanceTransitionListInnerActivitiesInnerAppliedBy
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetBalanceState200ResponsePredictedDailyBalanceTransitionListInnerActivitiesInnerAppliedBy
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface GetBankAccountActivities200Response
 */
export interface GetBankAccountActivities200Response {
    /**
     * 
     * @type {string}
     * @memberof GetBankAccountActivities200Response
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetBankAccountActivities200Response
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetBankAccountActivities200Response
     */
    'organizationName': string;
    /**
     * 
     * @type {string}
     * @memberof GetBankAccountActivities200Response
     */
    'type': GetBankAccountActivities200ResponseTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetBankAccountActivities200Response
     */
    'status': GetBankAccountActivities200ResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof GetBankAccountActivities200Response
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof GetBankAccountActivities200Response
     */
    'supplierName': string;
    /**
     * 
     * @type {number}
     * @memberof GetBankAccountActivities200Response
     */
    'amount': number;
    /**
     * 
     * @type {number}
     * @memberof GetBankAccountActivities200Response
     */
    'pointAmount': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetBankAccountActivities200Response
     */
    'balance': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetBankAccountActivities200Response
     */
    'pointBalance': number | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetBankAccountActivities200Response
     */
    'isConfirmed': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetBankAccountActivities200Response
     */
    'appliedAt': string | null;
    /**
     * 
     * @type {GetBankAccountActivities200ResponseAppliedBy}
     * @memberof GetBankAccountActivities200Response
     */
    'appliedBy': GetBankAccountActivities200ResponseAppliedBy;
    /**
     * 
     * @type {string}
     * @memberof GetBankAccountActivities200Response
     */
    'executedAt': string | null;
}

export const GetBankAccountActivities200ResponseTypeEnum = {
    payBill: 'PAY_BILL',
    deposit: 'DEPOSIT',
    withdrawal: 'WITHDRAWAL',
    reward: 'REWARD',
    usageFee: 'USAGE_FEE',
    point: 'POINT',
    cardPoint: 'CARD_POINT',
    campaignPoint: 'CAMPAIGN_POINT',
    card: 'CARD',
    depositFromGuaranteeMoney: 'DEPOSIT_FROM_GUARANTEE_MONEY',
    withdrawalToGuaranteeMoney: 'WITHDRAWAL_TO_GUARANTEE_MONEY'
} as const;

export type GetBankAccountActivities200ResponseTypeEnum = typeof GetBankAccountActivities200ResponseTypeEnum[keyof typeof GetBankAccountActivities200ResponseTypeEnum];
export const GetBankAccountActivities200ResponseStatusEnum = {
    reserved: 'RESERVED',
    requestingExternalAccountTransfer: 'REQUESTING_EXTERNAL_ACCOUNT_TRANSFER',
    completed: 'COMPLETED',
    insufficientBalance: 'INSUFFICIENT_BALANCE',
    uploaded: 'UPLOADED',
    readCompleted: 'READ_COMPLETED',
    awaitingApproval: 'AWAITING_APPROVAL',
    approved: 'APPROVED',
    transferCompleted: 'TRANSFER_COMPLETED',
    readError: 'READ_ERROR',
    transferFailed: 'TRANSFER_FAILED',
    approvalExpired: 'APPROVAL_EXPIRED',
    approvalRejected: 'APPROVAL_REJECTED',
    otherError: 'OTHER_ERROR',
    pending: 'PENDING'
} as const;

export type GetBankAccountActivities200ResponseStatusEnum = typeof GetBankAccountActivities200ResponseStatusEnum[keyof typeof GetBankAccountActivities200ResponseStatusEnum];

/**
 * 
 * @export
 * @interface GetBankAccountActivities200ResponseAppliedBy
 */
export interface GetBankAccountActivities200ResponseAppliedBy {
    /**
     * 
     * @type {string}
     * @memberof GetBankAccountActivities200ResponseAppliedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetBankAccountActivities200ResponseAppliedBy
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetBankAccountActivities200ResponseAppliedBy
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetBankAccountActivities200ResponseAppliedBy
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof GetBankAccountActivities200ResponseAppliedBy
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetBankAccountActivities200ResponseAppliedBy
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetBankAccountActivities200ResponseAppliedBy
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetBankAccountActivities200ResponseAppliedBy
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetBankAccountActivities200ResponseAppliedBy
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetBankAccountActivities200ResponseAppliedBy
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetBankAccountActivities200ResponseAppliedBy
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface GetBankAccountConfirmedActivities200ResponseInner
 */
export interface GetBankAccountConfirmedActivities200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetBankAccountConfirmedActivities200ResponseInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetBankAccountConfirmedActivities200ResponseInner
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetBankAccountConfirmedActivities200ResponseInner
     */
    'organizationName': string;
    /**
     * 
     * @type {string}
     * @memberof GetBankAccountConfirmedActivities200ResponseInner
     */
    'type': GetBankAccountConfirmedActivities200ResponseInnerTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetBankAccountConfirmedActivities200ResponseInner
     */
    'usageFeeId': string;
    /**
     * 
     * @type {string}
     * @memberof GetBankAccountConfirmedActivities200ResponseInner
     */
    'cardBillId': string;
    /**
     * 
     * @type {string}
     * @memberof GetBankAccountConfirmedActivities200ResponseInner
     */
    'cardPointId': string;
    /**
     * 
     * @type {string}
     * @memberof GetBankAccountConfirmedActivities200ResponseInner
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof GetBankAccountConfirmedActivities200ResponseInner
     */
    'supplierName': string;
    /**
     * 
     * @type {number}
     * @memberof GetBankAccountConfirmedActivities200ResponseInner
     */
    'amount': number;
    /**
     * 
     * @type {number}
     * @memberof GetBankAccountConfirmedActivities200ResponseInner
     */
    'pointAmount'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetBankAccountConfirmedActivities200ResponseInner
     */
    'balance': number;
    /**
     * 
     * @type {number}
     * @memberof GetBankAccountConfirmedActivities200ResponseInner
     */
    'pointBalance'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetBankAccountConfirmedActivities200ResponseInner
     */
    'isConfirmed': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetBankAccountConfirmedActivities200ResponseInner
     */
    'appliedAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetBankAccountConfirmedActivities200ResponseInner
     */
    'executedAt': string | null;
}

export const GetBankAccountConfirmedActivities200ResponseInnerTypeEnum = {
    payBill: 'PAY_BILL',
    deposit: 'DEPOSIT',
    withdrawal: 'WITHDRAWAL',
    reward: 'REWARD',
    usageFee: 'USAGE_FEE',
    point: 'POINT',
    cardPoint: 'CARD_POINT',
    campaignPoint: 'CAMPAIGN_POINT',
    card: 'CARD',
    depositFromGuaranteeMoney: 'DEPOSIT_FROM_GUARANTEE_MONEY',
    withdrawalToGuaranteeMoney: 'WITHDRAWAL_TO_GUARANTEE_MONEY'
} as const;

export type GetBankAccountConfirmedActivities200ResponseInnerTypeEnum = typeof GetBankAccountConfirmedActivities200ResponseInnerTypeEnum[keyof typeof GetBankAccountConfirmedActivities200ResponseInnerTypeEnum];

/**
 * 
 * @export
 * @interface GetBankByName200Response
 */
export interface GetBankByName200Response {
    /**
     * 
     * @type {string}
     * @memberof GetBankByName200Response
     */
    'bankCode': string;
    /**
     * 
     * @type {string}
     * @memberof GetBankByName200Response
     */
    'bankName': string;
}
/**
 * 
 * @export
 * @interface GetBankTransfer200Response
 */
export interface GetBankTransfer200Response {
    /**
     * 
     * @type {string}
     * @memberof GetBankTransfer200Response
     */
    'id': string;
    /**
     * 
     * @type {number}
     * @memberof GetBankTransfer200Response
     */
    'totalCount': number;
    /**
     * 
     * @type {number}
     * @memberof GetBankTransfer200Response
     */
    'totalAmount': number;
    /**
     * 
     * @type {string}
     * @memberof GetBankTransfer200Response
     */
    'fileFormat': GetBankTransfer200ResponseFileFormatEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetBankTransfer200Response
     */
    'paymentRequestIds': Array<string>;
    /**
     * 
     * @type {GetBankTransfer200ResponseSourceBankAccount}
     * @memberof GetBankTransfer200Response
     */
    'sourceBankAccount': GetBankTransfer200ResponseSourceBankAccount;
    /**
     * 
     * @type {GetBankTransfer200ResponseRequestedBy}
     * @memberof GetBankTransfer200Response
     */
    'requestedBy': GetBankTransfer200ResponseRequestedBy;
    /**
     * 
     * @type {string}
     * @memberof GetBankTransfer200Response
     */
    'processedAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetBankTransfer200Response
     */
    'transferAt': string;
    /**
     * null if the transfer data has not been downloaded.
     * @type {string}
     * @memberof GetBankTransfer200Response
     */
    'downloadedAt': string | null;
}

export const GetBankTransfer200ResponseFileFormatEnum = {
    disableLineBreak: 'ZENGIN_DISABLE_LINE_BREAK',
    enableLineBreak: 'ZENGIN_ENABLE_LINE_BREAK',
    csv: 'ZENGIN_CSV'
} as const;

export type GetBankTransfer200ResponseFileFormatEnum = typeof GetBankTransfer200ResponseFileFormatEnum[keyof typeof GetBankTransfer200ResponseFileFormatEnum];

/**
 * 
 * @export
 * @interface GetBankTransfer200ResponseRequestedBy
 */
export interface GetBankTransfer200ResponseRequestedBy {
    /**
     * 
     * @type {string}
     * @memberof GetBankTransfer200ResponseRequestedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetBankTransfer200ResponseRequestedBy
     */
    'name': string;
}
/**
 * BankAccount without TransferFeeCondition
 * @export
 * @interface GetBankTransfer200ResponseSourceBankAccount
 */
export interface GetBankTransfer200ResponseSourceBankAccount {
    /**
     * 
     * @type {string}
     * @memberof GetBankTransfer200ResponseSourceBankAccount
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetBankTransfer200ResponseSourceBankAccount
     */
    'bankNumber': string;
    /**
     * 
     * @type {string}
     * @memberof GetBankTransfer200ResponseSourceBankAccount
     */
    'bankName': string;
    /**
     * 
     * @type {string}
     * @memberof GetBankTransfer200ResponseSourceBankAccount
     */
    'branchNumber': string;
    /**
     * 
     * @type {string}
     * @memberof GetBankTransfer200ResponseSourceBankAccount
     */
    'branchName': string;
    /**
     * 
     * @type {string}
     * @memberof GetBankTransfer200ResponseSourceBankAccount
     */
    'accountType': GetBankTransfer200ResponseSourceBankAccountAccountTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetBankTransfer200ResponseSourceBankAccount
     */
    'accountNumber': string;
    /**
     * 
     * @type {string}
     * @memberof GetBankTransfer200ResponseSourceBankAccount
     */
    'companyCode': string;
    /**
     * 
     * @type {string}
     * @memberof GetBankTransfer200ResponseSourceBankAccount
     */
    'companyName': string;
}

export const GetBankTransfer200ResponseSourceBankAccountAccountTypeEnum = {
    savingsAccount: 'SAVINGS_ACCOUNT',
    currentAccount: 'CURRENT_ACCOUNT',
    thriftAccount: 'THRIFT_ACCOUNT',
    other: 'OTHER'
} as const;

export type GetBankTransfer200ResponseSourceBankAccountAccountTypeEnum = typeof GetBankTransfer200ResponseSourceBankAccountAccountTypeEnum[keyof typeof GetBankTransfer200ResponseSourceBankAccountAccountTypeEnum];

/**
 * 
 * @export
 * @interface GetBanksAllBranches200ResponseInner
 */
export interface GetBanksAllBranches200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetBanksAllBranches200ResponseInner
     */
    'bankCode': string;
    /**
     * 
     * @type {string}
     * @memberof GetBanksAllBranches200ResponseInner
     */
    'branchCode': string;
    /**
     * 
     * @type {string}
     * @memberof GetBanksAllBranches200ResponseInner
     */
    'branchName': string;
}
/**
 * 
 * @export
 * @interface GetBookkeepers200ResponseInner
 */
export interface GetBookkeepers200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetBookkeepers200ResponseInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetBookkeepers200ResponseInner
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetBookkeepers200ResponseInner
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetBookkeepers200ResponseInner
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof GetBookkeepers200ResponseInner
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetBookkeepers200ResponseInner
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetBookkeepers200ResponseInner
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetBookkeepers200ResponseInner
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetBookkeepers200ResponseInner
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetBookkeepers200ResponseInner
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetBookkeepers200ResponseInner
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface GetBranch200Response
 */
export interface GetBranch200Response {
    /**
     * 
     * @type {string}
     * @memberof GetBranch200Response
     */
    'bankCode': string;
    /**
     * 
     * @type {string}
     * @memberof GetBranch200Response
     */
    'branchCode': string;
    /**
     * 
     * @type {string}
     * @memberof GetBranch200Response
     */
    'branchName': string;
}
/**
 * 
 * @export
 * @interface GetBusinessDescriptions200ResponseInner
 */
export interface GetBusinessDescriptions200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetBusinessDescriptions200ResponseInner
     */
    'value': string;
    /**
     * 
     * @type {string}
     * @memberof GetBusinessDescriptions200ResponseInner
     */
    'majorCode': string;
    /**
     * 
     * @type {string}
     * @memberof GetBusinessDescriptions200ResponseInner
     */
    'mediumCode': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetBusinessDescriptions200ResponseInner
     */
    'label': string;
}
/**
 * 
 * @export
 * @interface GetCanCloseStatuses200Response
 */
export interface GetCanCloseStatuses200Response {
    /**
     * 
     * @type {boolean}
     * @memberof GetCanCloseStatuses200Response
     */
    'canClose': boolean;
    /**
     * 
     * @type {object}
     * @memberof GetCanCloseStatuses200Response
     */
    'details': object;
}
/**
 * 
 * @export
 * @interface GetCanDeactivate200Response
 */
export interface GetCanDeactivate200Response {
    /**
     * 
     * @type {boolean}
     * @memberof GetCanDeactivate200Response
     */
    'canDeactivate': boolean;
}
/**
 * 
 * @export
 * @interface GetCardBill200Response
 */
export interface GetCardBill200Response {
    /**
     * 
     * @type {string}
     * @memberof GetCardBill200Response
     */
    'cardBillId': string;
    /**
     * 
     * @type {number}
     * @memberof GetCardBill200Response
     */
    'yearMonth': number;
    /**
     * 
     * @type {string}
     * @memberof GetCardBill200Response
     */
    'scheduledPaymentDate': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardBill200Response
     */
    'paymentDate': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetCardBill200Response
     */
    'paymentType': GetCardBill200ResponsePaymentTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof GetCardBill200Response
     */
    'totalAmount': number;
    /**
     * 
     * @type {number}
     * @memberof GetCardBill200Response
     */
    'pointAmount': number;
    /**
     * 
     * @type {number}
     * @memberof GetCardBill200Response
     */
    'allocateAmount': number;
    /**
     * 
     * @type {number}
     * @memberof GetCardBill200Response
     */
    'amountBeforePointDiscount': number;
    /**
     * 
     * @type {number}
     * @memberof GetCardBill200Response
     */
    'billingAmount': number;
    /**
     * 
     * @type {GetCardBill200ResponseLatestStatus}
     * @memberof GetCardBill200Response
     */
    'latestStatus': GetCardBill200ResponseLatestStatus;
    /**
     * 
     * @type {string}
     * @memberof GetCardBill200Response
     */
    'supplierName': string;
}

export const GetCardBill200ResponsePaymentTypeEnum = {
    payBill: 'PAY_BILL',
    usageFee: 'USAGE_FEE',
    card: 'CARD'
} as const;

export type GetCardBill200ResponsePaymentTypeEnum = typeof GetCardBill200ResponsePaymentTypeEnum[keyof typeof GetCardBill200ResponsePaymentTypeEnum];

/**
 * 
 * @export
 * @interface GetCardBill200ResponseLatestStatus
 */
export interface GetCardBill200ResponseLatestStatus {
    /**
     * 
     * @type {GetCardBill200ResponseLatestStatusStatus}
     * @memberof GetCardBill200ResponseLatestStatus
     */
    'status'?: GetCardBill200ResponseLatestStatusStatus;
}
/**
 * 
 * @export
 * @interface GetCardBill200ResponseLatestStatusStatus
 */
export interface GetCardBill200ResponseLatestStatusStatus {
    /**
     * 
     * @type {string}
     * @memberof GetCardBill200ResponseLatestStatusStatus
     */
    'status'?: GetCardBill200ResponseLatestStatusStatusStatusEnum;
}

export const GetCardBill200ResponseLatestStatusStatusStatusEnum = {
    reserved: 'RESERVED',
    requestingExternalAccountTransfer: 'REQUESTING_EXTERNAL_ACCOUNT_TRANSFER',
    completed: 'COMPLETED',
    insufficientBalance: 'INSUFFICIENT_BALANCE',
    uploaded: 'UPLOADED',
    readCompleted: 'READ_COMPLETED',
    awaitingApproval: 'AWAITING_APPROVAL',
    approved: 'APPROVED',
    transferCompleted: 'TRANSFER_COMPLETED',
    readError: 'READ_ERROR',
    transferFailed: 'TRANSFER_FAILED',
    approvalExpired: 'APPROVAL_EXPIRED',
    approvalRejected: 'APPROVAL_REJECTED',
    otherError: 'OTHER_ERROR',
    pending: 'PENDING'
} as const;

export type GetCardBill200ResponseLatestStatusStatusStatusEnum = typeof GetCardBill200ResponseLatestStatusStatusStatusEnum[keyof typeof GetCardBill200ResponseLatestStatusStatusStatusEnum];

/**
 * 
 * @export
 * @interface GetCardDetail200Response
 */
export interface GetCardDetail200Response {
    /**
     * 
     * @type {string}
     * @memberof GetCardDetail200Response
     */
    'cardId': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardDetail200Response
     */
    'pan': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardDetail200Response
     */
    'cvv2': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardDetail200Response
     */
    'expiryYear': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardDetail200Response
     */
    'expiryMonth': string;
}
/**
 * 
 * @export
 * @interface GetCardMonthlyTransactions200Response
 */
export interface GetCardMonthlyTransactions200Response {
    /**
     * 
     * @type {number}
     * @memberof GetCardMonthlyTransactions200Response
     */
    'amount': number;
    /**
     * 
     * @type {Array<GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInner>}
     * @memberof GetCardMonthlyTransactions200Response
     */
    'mergedTransactionDetailList': Array<GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInner>;
}
/**
 * 
 * @export
 * @interface GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInner
 */
export interface GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInner {
    /**
     * 
     * @type {GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransaction}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInner
     */
    'mergedCardTransaction': GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransaction;
    /**
     * 
     * @type {GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerCardTransactionEvidenceStatus}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInner
     */
    'cardTransactionEvidenceStatus': GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerCardTransactionEvidenceStatus;
    /**
     * 
     * @type {Array<GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner>}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInner
     */
    'evidenceList': Array<GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner>;
    /**
     * 
     * @type {Array<GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerRequestHistoryInner>}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInner
     */
    'requestHistory': Array<GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerRequestHistoryInner>;
    /**
     * 
     * @type {GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerComment}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInner
     */
    'comment'?: GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerComment;
    /**
     * 
     * @type {GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceRemindStatus}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInner
     */
    'evidenceRemindStatus': GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceRemindStatus;
    /**
     * 
     * @type {GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerUserAccount}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInner
     */
    'userAccount': GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerUserAccount;
    /**
     * 
     * @type {Array<GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInner>}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInner
     */
    'purchaseApplications': Array<GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInner>;
}
/**
 * 
 * @export
 * @interface GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerCardTransactionEvidenceStatus
 */
export interface GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerCardTransactionEvidenceStatus {
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerCardTransactionEvidenceStatus
     */
    'visaTransactionReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerCardTransactionEvidenceStatus
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerCardTransactionEvidenceStatus
     */
    'isRequested': boolean;
    /**
     * 
     * @type {GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerCardTransactionEvidenceStatusRequestedBy}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerCardTransactionEvidenceStatus
     */
    'requestedBy': GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerCardTransactionEvidenceStatusRequestedBy | null;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerCardTransactionEvidenceStatus
     */
    'requestedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerCardTransactionEvidenceStatus
     */
    'isLocked': boolean;
    /**
     * 
     * @type {GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerCardTransactionEvidenceStatusLockedBy}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerCardTransactionEvidenceStatus
     */
    'lockedBy': GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerCardTransactionEvidenceStatusLockedBy | null;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerCardTransactionEvidenceStatus
     */
    'lockedAt': string;
}
/**
 * 
 * @export
 * @interface GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerCardTransactionEvidenceStatusLockedBy
 */
export interface GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerCardTransactionEvidenceStatusLockedBy {
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerCardTransactionEvidenceStatusLockedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerCardTransactionEvidenceStatusLockedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerCardTransactionEvidenceStatusRequestedBy
 */
export interface GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerCardTransactionEvidenceStatusRequestedBy {
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerCardTransactionEvidenceStatusRequestedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerCardTransactionEvidenceStatusRequestedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerComment
 */
export interface GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerComment {
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerComment
     */
    'cardTransactionCommentId': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerComment
     */
    'visaTransactionReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerComment
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerComment
     */
    'comment': string;
    /**
     * 
     * @type {GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerCommentCreatedBy}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerComment
     */
    'createdBy': GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerCommentCreatedBy;
}
/**
 * 
 * @export
 * @interface GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerCommentCreatedBy
 */
export interface GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerCommentCreatedBy {
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerCommentCreatedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerCommentCreatedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
 */
export interface GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner {
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     * @deprecated
     */
    'cardTransactionEvidenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     * @deprecated
     */
    'visaTransactionReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'paymentType': GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerPaymentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'fileName': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'fileExtension': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'electronicMethod': GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerElectronicMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'documentSize': GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerDocumentSizeEnum;
    /**
     * 
     * @type {number}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     * @deprecated
     */
    'dpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'detectedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'calculatedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'colorGradation': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'verticalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'horizontalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'heightMillis': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'widthMillis': number | null;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'legalValidity': GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerLegalValidityEnum;
    /**
     * 
     * @type {boolean}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'dpiForciblyValid': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'colorGradationForciblyValid': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'note': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'irrelevantToLedger': boolean;
    /**
     * 
     * @type {GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerInvoiceIssuer}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'invoiceIssuer': GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerInvoiceIssuer | null;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     * @deprecated
     */
    'dpiError': GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerDpiErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     * @deprecated
     */
    'detectedDpiError': GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerDetectedDpiErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     * @deprecated
     */
    'calculatedDpiError': GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerCalculatedDpiErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     * @deprecated
     */
    'colorGradationError': GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerColorGradationErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     * @deprecated
     */
    'heightMillisError': GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerHeightMillisErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     * @deprecated
     */
    'widthMillisError': GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWidthMillisErrorEnum;
    /**
     * 
     * @type {GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrors}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'errors': GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrors;
    /**
     * 
     * @type {GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarnings}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'warnings': GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarnings;
    /**
     * 
     * @type {GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerCreatedBy}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'createdBy': GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerCreatedBy;
    /**
     * 
     * @type {GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerUpdatedBy}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'updatedBy': GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerUpdatedBy;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'updatedAt': string;
    /**
     * 
     * @type {GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerUploadedBy}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'uploadedBy': GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerUploadedBy;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'uploadedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'uploadedByRecipient': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'needsMigration': boolean | null;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'uploadedFrom': string;
}

export const GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerPaymentTypeEnum = {
    cardTransaction: 'CARD_TRANSACTION',
    paymentRequest: 'PAYMENT_REQUEST'
} as const;

export type GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerPaymentTypeEnum = typeof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerPaymentTypeEnum[keyof typeof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerPaymentTypeEnum];
export const GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerElectronicMethodEnum = {
    fullElectronic: 'FULL_ELECTRONIC',
    originallyPaper: 'ORIGINALLY_PAPER',
    unknown: 'UNKNOWN'
} as const;

export type GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerElectronicMethodEnum = typeof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerElectronicMethodEnum[keyof typeof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerElectronicMethodEnum];
export const GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerDocumentSizeEnum = {
    overA4: 'OVER_A4',
    a4OrSmaller: 'A4_OR_SMALLER',
    unknown: 'UNKNOWN'
} as const;

export type GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerDocumentSizeEnum = typeof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerDocumentSizeEnum[keyof typeof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerDocumentSizeEnum];
export const GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerLegalValidityEnum = {
    valid: 'VALID',
    invalid: 'INVALID',
    inputRequired: 'INPUT_REQUIRED',
    outOfTarget: 'OUT_OF_TARGET'
} as const;

export type GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerLegalValidityEnum = typeof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerLegalValidityEnum[keyof typeof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerLegalValidityEnum];
export const GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerDpiErrorEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerDpiErrorEnum = typeof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerDpiErrorEnum[keyof typeof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerDpiErrorEnum];
export const GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerDetectedDpiErrorEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerDetectedDpiErrorEnum = typeof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerDetectedDpiErrorEnum[keyof typeof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerDetectedDpiErrorEnum];
export const GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerCalculatedDpiErrorEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerCalculatedDpiErrorEnum = typeof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerCalculatedDpiErrorEnum[keyof typeof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerCalculatedDpiErrorEnum];
export const GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerColorGradationErrorEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerColorGradationErrorEnum = typeof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerColorGradationErrorEnum[keyof typeof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerColorGradationErrorEnum];
export const GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerHeightMillisErrorEnum = {
    required: 'REQUIRED'
} as const;

export type GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerHeightMillisErrorEnum = typeof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerHeightMillisErrorEnum[keyof typeof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerHeightMillisErrorEnum];
export const GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWidthMillisErrorEnum = {
    required: 'REQUIRED'
} as const;

export type GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWidthMillisErrorEnum = typeof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWidthMillisErrorEnum[keyof typeof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWidthMillisErrorEnum];

/**
 * 
 * @export
 * @interface GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerCreatedBy
 */
export interface GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerCreatedBy {
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerCreatedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerCreatedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrors
 */
export interface GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrors {
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrors
     */
    'detectedDpi'?: GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrors
     */
    'calculatedDpi'?: GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrors
     */
    'colorGradation'?: GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrors
     */
    'heightMillis'?: GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrors
     */
    'widthMillis'?: GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsWidthMillisEnum;
}

export const GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsDetectedDpiEnum = typeof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsDetectedDpiEnum[keyof typeof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsDetectedDpiEnum];
export const GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsCalculatedDpiEnum = typeof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsCalculatedDpiEnum[keyof typeof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsCalculatedDpiEnum];
export const GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsColorGradationEnum = typeof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsColorGradationEnum[keyof typeof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsColorGradationEnum];
export const GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsHeightMillisEnum = typeof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsHeightMillisEnum[keyof typeof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsHeightMillisEnum];
export const GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsWidthMillisEnum = typeof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsWidthMillisEnum[keyof typeof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsWidthMillisEnum];

/**
 * Set null if it\'s evidence not analyzed using invoicing-system-compliance feature. Also set null if invoicing-system-compliance feature has been made not available for the organization by the feature-flag.
 * @export
 * @interface GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerInvoiceIssuer
 */
export interface GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerInvoiceIssuer {
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerInvoiceIssuer
     */
    'name': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerInvoiceIssuer
     */
    'registrationNumber': string | null;
    /**
     * isQualified retains the result of querying the 国税庁API to see if registrationNumber is qualified, as is.
     * @type {boolean}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerInvoiceIssuer
     */
    'isQualified': boolean;
    /**
     * AsQualified indicates whether this issuer should be treated as a qualified invoice issuer within the user\'s system, even if the RegistrationNumber is not confirmed as qualified in the National Tax Agency\'s business registration system.
     * @type {boolean}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerInvoiceIssuer
     */
    'asQualified': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerInvoiceIssuer
     */
    'partnerId': string | null;
}
/**
 * 
 * @export
 * @interface GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerUpdatedBy
 */
export interface GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerUpdatedBy {
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerUpdatedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerUpdatedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerUploadedBy
 */
export interface GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerUploadedBy {
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerUploadedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerUploadedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarnings
 */
export interface GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarnings {
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarnings
     */
    'detectedDpi'?: GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarnings
     */
    'calculatedDpi'?: GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarnings
     */
    'colorGradation'?: GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarnings
     */
    'heightMillis'?: GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarnings
     */
    'widthMillis'?: GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsWidthMillisEnum;
}

export const GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsDetectedDpiEnum = typeof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsDetectedDpiEnum[keyof typeof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsDetectedDpiEnum];
export const GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsCalculatedDpiEnum = typeof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsCalculatedDpiEnum[keyof typeof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsCalculatedDpiEnum];
export const GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsColorGradationEnum = typeof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsColorGradationEnum[keyof typeof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsColorGradationEnum];
export const GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsHeightMillisEnum = typeof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsHeightMillisEnum[keyof typeof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsHeightMillisEnum];
export const GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsWidthMillisEnum = typeof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsWidthMillisEnum[keyof typeof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsWidthMillisEnum];

/**
 * 
 * @export
 * @interface GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceRemindStatus
 */
export interface GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceRemindStatus {
    /**
     * 
     * @type {boolean}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerEvidenceRemindStatus
     */
    'isAutoRemind': boolean;
}
/**
 * 
 * @export
 * @interface GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransaction
 */
export interface GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransaction {
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransaction
     */
    'visaTransactionReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransaction
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransaction
     */
    'merchantName': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransaction
     */
    'merchantNameKana': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransaction
     */
    'merchantNameKanji': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransaction
     */
    'mergedMerchantName': string;
    /**
     * 
     * @type {number}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransaction
     */
    'amount': number;
    /**
     * 
     * @type {number}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransaction
     */
    'amountFx': number;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransaction
     */
    'currencyCode': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransaction
     */
    'processedAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransaction
     */
    'transactionType': GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransaction
     */
    'creditSettlement': number;
    /**
     * 
     * @type {Array<GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner>}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransaction
     */
    'transactionRecordList': Array<GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner>;
    /**
     * 
     * @type {boolean}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransaction
     */
    'isCleared': boolean;
}

export const GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionTypeEnum = {
    confirm: 'CONFIRM',
    notConfirm: 'NOT_CONFIRM'
} as const;

export type GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionTypeEnum = typeof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionTypeEnum[keyof typeof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionTypeEnum];

/**
 * 
 * @export
 * @interface GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner
 */
export interface GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner {
    /**
     * 
     * @type {number}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner
     */
    'amount': number;
    /**
     * 
     * @type {number}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner
     */
    'amountFx': number;
    /**
     * 
     * @type {number}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner
     */
    'totalAmount': number;
    /**
     * 
     * @type {number}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner
     */
    'totalAmountFx': number;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner
     */
    'currencyCode': string;
    /**
     * 
     * @type {number}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner
     */
    'fxRate': number | null;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner
     */
    'processedAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner
     */
    'transactionDetailType': GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner
     */
    'isCleared': boolean;
}

export const GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum = {
    purchase: 'PURCHASE',
    settlement: 'SETTLEMENT',
    validation: 'VALIDATION',
    refund: 'REFUND',
    cancel: 'CANCEL',
    refundCancel: 'REFUND_CANCEL',
    refundPartialCancel: 'REFUND_PARTIAL_CANCEL'
} as const;

export type GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum = typeof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum[keyof typeof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum];

/**
 * 
 * @export
 * @interface GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInner
 */
export interface GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInner {
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInner
     */
    'applicationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInner
     */
    'applicationNumber': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInner
     */
    'paymentDate': string;
    /**
     * 
     * @type {GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerSubmittedBy}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInner
     */
    'submittedBy': GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerSubmittedBy;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInner
     */
    'submittedAt': string;
    /**
     * 
     * @type {Array<GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerApproversInner>}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInner
     */
    'approvers': Array<GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerApproversInner>;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInner
     */
    'department': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInner
     */
    'purchaseReason': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInner
     */
    'purchaseDetails': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInner
     */
    'placeOfUse': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInner
     */
    'purposeOfUse': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInner
     */
    'url': string;
    /**
     * 
     * @type {number}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInner
     */
    'amount': number;
    /**
     * 
     * @type {GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccount}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInner
     */
    'userAccount': GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccount | null;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInner
     */
    'remarks': string;
    /**
     * 
     * @type {GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerWorkRequestedBy}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInner
     */
    'workRequestedBy': GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerWorkRequestedBy;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInner
     */
    'workRequestApprovers': string;
    /**
     * 
     * @type {GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerStatus}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInner
     */
    'status': GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerStatus;
    /**
     * 
     * @type {GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerCreatedBy}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInner
     */
    'createdBy': GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerCreatedBy;
}
/**
 * 
 * @export
 * @interface GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerApproversInner
 */
export interface GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerApproversInner {
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerApproversInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerApproversInner
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerCreatedBy
 */
export interface GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerCreatedBy {
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerCreatedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerCreatedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerStatus
 */
export interface GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerStatus {
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerStatus
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerStatus
     */
    'comment': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerStatus
     */
    'statusChangedAt': string;
    /**
     * 
     * @type {GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerStatusCreatedBy}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerStatus
     */
    'createdBy': GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerStatusCreatedBy;
}
/**
 * 
 * @export
 * @interface GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerStatusCreatedBy
 */
export interface GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerStatusCreatedBy {
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerStatusCreatedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerStatusCreatedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerSubmittedBy
 */
export interface GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerSubmittedBy {
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerSubmittedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerSubmittedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccount
 */
export interface GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccount {
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccount
     */
    'userAccountId': string;
    /**
     * 
     * @type {GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUser}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccount
     */
    'user': GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUser;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccount
     */
    'cardLabel': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccount
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccount
     */
    'organizationName': string;
    /**
     * 
     * @type {GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUserAccountGroup}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccount
     */
    'userAccountGroup': GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUserAccountGroup | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccount
     */
    'isOnDemand': boolean;
}
/**
 * 
 * @export
 * @interface GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUser
 */
export interface GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUser {
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUser
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUser
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUser
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUser
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUser
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUser
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUser
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUser
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUser
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUser
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUser
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUserAccountGroup
 */
export interface GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUserAccountGroup {
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUserAccountGroup
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUserAccountGroup
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUserAccountGroup
     */
    'sortNum': number;
}
/**
 * 
 * @export
 * @interface GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerWorkRequestedBy
 */
export interface GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerWorkRequestedBy {
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerWorkRequestedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerWorkRequestedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerRequestHistoryInner
 */
export interface GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerRequestHistoryInner {
    /**
     * 
     * @type {number}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerRequestHistoryInner
     */
    'requestId': number;
    /**
     * 
     * @type {GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerRequestHistoryInnerRequestedBy}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerRequestHistoryInner
     */
    'requestedBy': GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerRequestHistoryInnerRequestedBy;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerRequestHistoryInner
     */
    'requestedAt': string;
}
/**
 * 
 * @export
 * @interface GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerRequestHistoryInnerRequestedBy
 */
export interface GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerRequestHistoryInnerRequestedBy {
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerRequestHistoryInnerRequestedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerRequestHistoryInnerRequestedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerUserAccount
 */
export interface GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerUserAccount {
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerUserAccount
     */
    'userAccountId': string;
    /**
     * 
     * @type {GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerUserAccountUser}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerUserAccount
     */
    'user': GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerUserAccountUser;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerUserAccount
     */
    'cardLabel': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerUserAccount
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerUserAccount
     */
    'organizationName': string;
    /**
     * 
     * @type {GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerUserAccountUserAccountGroup}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerUserAccount
     */
    'userAccountGroup': GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerUserAccountUserAccountGroup | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerUserAccount
     */
    'isOnDemand': boolean;
}
/**
 * 
 * @export
 * @interface GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerUserAccountUser
 */
export interface GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerUserAccountUser {
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerUserAccountUser
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerUserAccountUser
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerUserAccountUser
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerUserAccountUser
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerUserAccountUser
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerUserAccountUser
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerUserAccountUser
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerUserAccountUser
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerUserAccountUser
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerUserAccountUser
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerUserAccountUser
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerUserAccountUserAccountGroup
 */
export interface GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerUserAccountUserAccountGroup {
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerUserAccountUserAccountGroup
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerUserAccountUserAccountGroup
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof GetCardMonthlyTransactions200ResponseMergedTransactionDetailListInnerUserAccountUserAccountGroup
     */
    'sortNum': number;
}
/**
 * 
 * @export
 * @interface GetCardPointsRateConfigsByOrganizationId200ResponseInner
 */
export interface GetCardPointsRateConfigsByOrganizationId200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetCardPointsRateConfigsByOrganizationId200ResponseInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardPointsRateConfigsByOrganizationId200ResponseInner
     */
    'organizationId'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetCardPointsRateConfigsByOrganizationId200ResponseInner
     */
    'preferential': boolean;
    /**
     * 
     * @type {GetCardPointsRateConfigsByOrganizationId200ResponseInnerRule}
     * @memberof GetCardPointsRateConfigsByOrganizationId200ResponseInner
     */
    'rule'?: GetCardPointsRateConfigsByOrganizationId200ResponseInnerRule | null;
    /**
     * 
     * @type {GetCardPointsRateConfigsByOrganizationId200ResponseInnerRuleSet}
     * @memberof GetCardPointsRateConfigsByOrganizationId200ResponseInner
     */
    'ruleSet'?: GetCardPointsRateConfigsByOrganizationId200ResponseInnerRuleSet | null;
    /**
     * 
     * @type {string}
     * @memberof GetCardPointsRateConfigsByOrganizationId200ResponseInner
     */
    'startAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardPointsRateConfigsByOrganizationId200ResponseInner
     */
    'endAt': string;
}
/**
 * 
 * @export
 * @interface GetCardPointsRateConfigsByOrganizationId200ResponseInnerRule
 */
export interface GetCardPointsRateConfigsByOrganizationId200ResponseInnerRule {
    /**
     * 
     * @type {string}
     * @memberof GetCardPointsRateConfigsByOrganizationId200ResponseInnerRule
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardPointsRateConfigsByOrganizationId200ResponseInnerRule
     */
    'code': string;
    /**
     * 
     * @type {number}
     * @memberof GetCardPointsRateConfigsByOrganizationId200ResponseInnerRule
     */
    'rate': number;
    /**
     * 
     * @type {string}
     * @memberof GetCardPointsRateConfigsByOrganizationId200ResponseInnerRule
     */
    'merchantCategoryCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetCardPointsRateConfigsByOrganizationId200ResponseInnerRule
     */
    'merchantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetCardPointsRateConfigsByOrganizationId200ResponseInnerRule
     */
    'binSponsor'?: GetCardPointsRateConfigsByOrganizationId200ResponseInnerRuleBinSponsorEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardPointsRateConfigsByOrganizationId200ResponseInnerRule
     */
    'creditOrPrepaid'?: GetCardPointsRateConfigsByOrganizationId200ResponseInnerRuleCreditOrPrepaidEnum;
    /**
     * 
     * @type {number}
     * @memberof GetCardPointsRateConfigsByOrganizationId200ResponseInnerRule
     */
    'minimumTotalAmount': number;
}

export const GetCardPointsRateConfigsByOrganizationId200ResponseInnerRuleBinSponsorEnum = {
    lc: 'LC',
    cs: 'CS'
} as const;

export type GetCardPointsRateConfigsByOrganizationId200ResponseInnerRuleBinSponsorEnum = typeof GetCardPointsRateConfigsByOrganizationId200ResponseInnerRuleBinSponsorEnum[keyof typeof GetCardPointsRateConfigsByOrganizationId200ResponseInnerRuleBinSponsorEnum];
export const GetCardPointsRateConfigsByOrganizationId200ResponseInnerRuleCreditOrPrepaidEnum = {
    credit: 'CREDIT',
    prepaid: 'PREPAID'
} as const;

export type GetCardPointsRateConfigsByOrganizationId200ResponseInnerRuleCreditOrPrepaidEnum = typeof GetCardPointsRateConfigsByOrganizationId200ResponseInnerRuleCreditOrPrepaidEnum[keyof typeof GetCardPointsRateConfigsByOrganizationId200ResponseInnerRuleCreditOrPrepaidEnum];

/**
 * 
 * @export
 * @interface GetCardPointsRateConfigsByOrganizationId200ResponseInnerRuleSet
 */
export interface GetCardPointsRateConfigsByOrganizationId200ResponseInnerRuleSet {
    /**
     * 
     * @type {string}
     * @memberof GetCardPointsRateConfigsByOrganizationId200ResponseInnerRuleSet
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardPointsRateConfigsByOrganizationId200ResponseInnerRuleSet
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardPointsRateConfigsByOrganizationId200ResponseInnerRuleSet
     */
    'description': string;
    /**
     * 
     * @type {Array<GetCardPointsRateConfigsByOrganizationId200ResponseInnerRuleSetRulesInner>}
     * @memberof GetCardPointsRateConfigsByOrganizationId200ResponseInnerRuleSet
     */
    'rules': Array<GetCardPointsRateConfigsByOrganizationId200ResponseInnerRuleSetRulesInner>;
}
/**
 * 
 * @export
 * @interface GetCardPointsRateConfigsByOrganizationId200ResponseInnerRuleSetRulesInner
 */
export interface GetCardPointsRateConfigsByOrganizationId200ResponseInnerRuleSetRulesInner {
    /**
     * 
     * @type {string}
     * @memberof GetCardPointsRateConfigsByOrganizationId200ResponseInnerRuleSetRulesInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardPointsRateConfigsByOrganizationId200ResponseInnerRuleSetRulesInner
     */
    'code': string;
    /**
     * 
     * @type {number}
     * @memberof GetCardPointsRateConfigsByOrganizationId200ResponseInnerRuleSetRulesInner
     */
    'rate': number;
    /**
     * 
     * @type {string}
     * @memberof GetCardPointsRateConfigsByOrganizationId200ResponseInnerRuleSetRulesInner
     */
    'merchantCategoryCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetCardPointsRateConfigsByOrganizationId200ResponseInnerRuleSetRulesInner
     */
    'merchantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetCardPointsRateConfigsByOrganizationId200ResponseInnerRuleSetRulesInner
     */
    'binSponsor'?: GetCardPointsRateConfigsByOrganizationId200ResponseInnerRuleSetRulesInnerBinSponsorEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardPointsRateConfigsByOrganizationId200ResponseInnerRuleSetRulesInner
     */
    'creditOrPrepaid'?: GetCardPointsRateConfigsByOrganizationId200ResponseInnerRuleSetRulesInnerCreditOrPrepaidEnum;
    /**
     * 
     * @type {number}
     * @memberof GetCardPointsRateConfigsByOrganizationId200ResponseInnerRuleSetRulesInner
     */
    'minimumTotalAmount': number;
}

export const GetCardPointsRateConfigsByOrganizationId200ResponseInnerRuleSetRulesInnerBinSponsorEnum = {
    lc: 'LC',
    cs: 'CS'
} as const;

export type GetCardPointsRateConfigsByOrganizationId200ResponseInnerRuleSetRulesInnerBinSponsorEnum = typeof GetCardPointsRateConfigsByOrganizationId200ResponseInnerRuleSetRulesInnerBinSponsorEnum[keyof typeof GetCardPointsRateConfigsByOrganizationId200ResponseInnerRuleSetRulesInnerBinSponsorEnum];
export const GetCardPointsRateConfigsByOrganizationId200ResponseInnerRuleSetRulesInnerCreditOrPrepaidEnum = {
    credit: 'CREDIT',
    prepaid: 'PREPAID'
} as const;

export type GetCardPointsRateConfigsByOrganizationId200ResponseInnerRuleSetRulesInnerCreditOrPrepaidEnum = typeof GetCardPointsRateConfigsByOrganizationId200ResponseInnerRuleSetRulesInnerCreditOrPrepaidEnum[keyof typeof GetCardPointsRateConfigsByOrganizationId200ResponseInnerRuleSetRulesInnerCreditOrPrepaidEnum];

/**
 * 
 * @export
 * @interface GetCardTransactionDetails200Response
 */
export interface GetCardTransactionDetails200Response {
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactionDetails200Response
     */
    'visaTransactionReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactionDetails200Response
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactionDetails200Response
     */
    'merchantName': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactionDetails200Response
     */
    'merchantNameKana': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactionDetails200Response
     */
    'merchantNameKanji': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactionDetails200Response
     */
    'mergedMerchantName': string;
    /**
     * 
     * @type {number}
     * @memberof GetCardTransactionDetails200Response
     */
    'amount': number;
    /**
     * 
     * @type {number}
     * @memberof GetCardTransactionDetails200Response
     */
    'amountFx': number;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactionDetails200Response
     */
    'currencyCode': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactionDetails200Response
     */
    'processedAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactionDetails200Response
     */
    'transactionType': GetCardTransactionDetails200ResponseTransactionTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof GetCardTransactionDetails200Response
     */
    'creditSettlement': number;
    /**
     * 
     * @type {Array<GetCardTransactionDetails200ResponseTransactionRecordListInner>}
     * @memberof GetCardTransactionDetails200Response
     */
    'transactionRecordList': Array<GetCardTransactionDetails200ResponseTransactionRecordListInner>;
    /**
     * 
     * @type {boolean}
     * @memberof GetCardTransactionDetails200Response
     */
    'isCleared': boolean;
}

export const GetCardTransactionDetails200ResponseTransactionTypeEnum = {
    confirm: 'CONFIRM',
    notConfirm: 'NOT_CONFIRM'
} as const;

export type GetCardTransactionDetails200ResponseTransactionTypeEnum = typeof GetCardTransactionDetails200ResponseTransactionTypeEnum[keyof typeof GetCardTransactionDetails200ResponseTransactionTypeEnum];

/**
 * 
 * @export
 * @interface GetCardTransactionDetails200ResponseTransactionRecordListInner
 */
export interface GetCardTransactionDetails200ResponseTransactionRecordListInner {
    /**
     * 
     * @type {number}
     * @memberof GetCardTransactionDetails200ResponseTransactionRecordListInner
     */
    'amount': number;
    /**
     * 
     * @type {number}
     * @memberof GetCardTransactionDetails200ResponseTransactionRecordListInner
     */
    'amountFx': number;
    /**
     * 
     * @type {number}
     * @memberof GetCardTransactionDetails200ResponseTransactionRecordListInner
     */
    'totalAmount': number;
    /**
     * 
     * @type {number}
     * @memberof GetCardTransactionDetails200ResponseTransactionRecordListInner
     */
    'totalAmountFx': number;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactionDetails200ResponseTransactionRecordListInner
     */
    'currencyCode': string;
    /**
     * 
     * @type {number}
     * @memberof GetCardTransactionDetails200ResponseTransactionRecordListInner
     */
    'fxRate': number | null;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactionDetails200ResponseTransactionRecordListInner
     */
    'processedAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactionDetails200ResponseTransactionRecordListInner
     */
    'transactionDetailType': GetCardTransactionDetails200ResponseTransactionRecordListInnerTransactionDetailTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof GetCardTransactionDetails200ResponseTransactionRecordListInner
     */
    'isCleared': boolean;
}

export const GetCardTransactionDetails200ResponseTransactionRecordListInnerTransactionDetailTypeEnum = {
    purchase: 'PURCHASE',
    settlement: 'SETTLEMENT',
    validation: 'VALIDATION',
    refund: 'REFUND',
    cancel: 'CANCEL',
    refundCancel: 'REFUND_CANCEL',
    refundPartialCancel: 'REFUND_PARTIAL_CANCEL'
} as const;

export type GetCardTransactionDetails200ResponseTransactionRecordListInnerTransactionDetailTypeEnum = typeof GetCardTransactionDetails200ResponseTransactionRecordListInnerTransactionDetailTypeEnum[keyof typeof GetCardTransactionDetails200ResponseTransactionRecordListInnerTransactionDetailTypeEnum];

/**
 * 
 * @export
 * @interface GetCardTransactionEvidenceRecords200ResponseInner
 */
export interface GetCardTransactionEvidenceRecords200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInner
     */
    'evidenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInner
     */
    'userAccountId': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInner
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInner
     */
    'paymentType': GetCardTransactionEvidenceRecords200ResponseInnerPaymentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInner
     */
    'fileName': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInner
     */
    'fileExtension': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInner
     */
    'electronicMethod': GetCardTransactionEvidenceRecords200ResponseInnerElectronicMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInner
     */
    'documentSize': GetCardTransactionEvidenceRecords200ResponseInnerDocumentSizeEnum;
    /**
     * 
     * @type {number}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInner
     * @deprecated
     */
    'dpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInner
     */
    'detectedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInner
     */
    'calculatedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInner
     */
    'colorGradation': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInner
     */
    'verticalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInner
     */
    'horizontalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInner
     */
    'heightMillis': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInner
     */
    'widthMillis': number | null;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInner
     */
    'legalValidity': GetCardTransactionEvidenceRecords200ResponseInnerLegalValidityEnum;
    /**
     * 
     * @type {boolean}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInner
     */
    'dpiForciblyValid': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInner
     */
    'colorGradationForciblyValid': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInner
     */
    'note': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInner
     */
    'irrelevantToLedger': boolean;
    /**
     * 
     * @type {GetCardTransactionEvidenceRecords200ResponseInnerInvoiceIssuer}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInner
     */
    'invoiceIssuer': GetCardTransactionEvidenceRecords200ResponseInnerInvoiceIssuer | null;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInner
     * @deprecated
     */
    'dpiError': GetCardTransactionEvidenceRecords200ResponseInnerDpiErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInner
     * @deprecated
     */
    'detectedDpiError': GetCardTransactionEvidenceRecords200ResponseInnerDetectedDpiErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInner
     * @deprecated
     */
    'calculatedDpiError': GetCardTransactionEvidenceRecords200ResponseInnerCalculatedDpiErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInner
     * @deprecated
     */
    'colorGradationError': GetCardTransactionEvidenceRecords200ResponseInnerColorGradationErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInner
     * @deprecated
     */
    'heightMillisError': GetCardTransactionEvidenceRecords200ResponseInnerHeightMillisErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInner
     * @deprecated
     */
    'widthMillisError': GetCardTransactionEvidenceRecords200ResponseInnerWidthMillisErrorEnum;
    /**
     * 
     * @type {GetCardTransactionEvidenceRecords200ResponseInnerErrors}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInner
     */
    'errors': GetCardTransactionEvidenceRecords200ResponseInnerErrors;
    /**
     * 
     * @type {GetCardTransactionEvidenceRecords200ResponseInnerWarnings}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInner
     */
    'warnings': GetCardTransactionEvidenceRecords200ResponseInnerWarnings;
    /**
     * 
     * @type {GetCardTransactionEvidenceRecords200ResponseInnerUpdatedBy}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInner
     */
    'updatedBy': GetCardTransactionEvidenceRecords200ResponseInnerUpdatedBy;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInner
     */
    'updatedAt': string;
    /**
     * 
     * @type {GetCardTransactionEvidenceRecords200ResponseInnerUploadedBy}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInner
     */
    'uploadedBy': GetCardTransactionEvidenceRecords200ResponseInnerUploadedBy;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInner
     */
    'uploadedAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInner
     */
    'uploadedFrom': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInner
     */
    'uploadedByRecipient': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInner
     */
    'deleted': boolean;
}

export const GetCardTransactionEvidenceRecords200ResponseInnerPaymentTypeEnum = {
    cardTransaction: 'CARD_TRANSACTION',
    paymentRequest: 'PAYMENT_REQUEST'
} as const;

export type GetCardTransactionEvidenceRecords200ResponseInnerPaymentTypeEnum = typeof GetCardTransactionEvidenceRecords200ResponseInnerPaymentTypeEnum[keyof typeof GetCardTransactionEvidenceRecords200ResponseInnerPaymentTypeEnum];
export const GetCardTransactionEvidenceRecords200ResponseInnerElectronicMethodEnum = {
    fullElectronic: 'FULL_ELECTRONIC',
    originallyPaper: 'ORIGINALLY_PAPER',
    unknown: 'UNKNOWN'
} as const;

export type GetCardTransactionEvidenceRecords200ResponseInnerElectronicMethodEnum = typeof GetCardTransactionEvidenceRecords200ResponseInnerElectronicMethodEnum[keyof typeof GetCardTransactionEvidenceRecords200ResponseInnerElectronicMethodEnum];
export const GetCardTransactionEvidenceRecords200ResponseInnerDocumentSizeEnum = {
    overA4: 'OVER_A4',
    a4OrSmaller: 'A4_OR_SMALLER',
    unknown: 'UNKNOWN'
} as const;

export type GetCardTransactionEvidenceRecords200ResponseInnerDocumentSizeEnum = typeof GetCardTransactionEvidenceRecords200ResponseInnerDocumentSizeEnum[keyof typeof GetCardTransactionEvidenceRecords200ResponseInnerDocumentSizeEnum];
export const GetCardTransactionEvidenceRecords200ResponseInnerLegalValidityEnum = {
    valid: 'VALID',
    invalid: 'INVALID',
    inputRequired: 'INPUT_REQUIRED',
    outOfTarget: 'OUT_OF_TARGET'
} as const;

export type GetCardTransactionEvidenceRecords200ResponseInnerLegalValidityEnum = typeof GetCardTransactionEvidenceRecords200ResponseInnerLegalValidityEnum[keyof typeof GetCardTransactionEvidenceRecords200ResponseInnerLegalValidityEnum];
export const GetCardTransactionEvidenceRecords200ResponseInnerDpiErrorEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetCardTransactionEvidenceRecords200ResponseInnerDpiErrorEnum = typeof GetCardTransactionEvidenceRecords200ResponseInnerDpiErrorEnum[keyof typeof GetCardTransactionEvidenceRecords200ResponseInnerDpiErrorEnum];
export const GetCardTransactionEvidenceRecords200ResponseInnerDetectedDpiErrorEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetCardTransactionEvidenceRecords200ResponseInnerDetectedDpiErrorEnum = typeof GetCardTransactionEvidenceRecords200ResponseInnerDetectedDpiErrorEnum[keyof typeof GetCardTransactionEvidenceRecords200ResponseInnerDetectedDpiErrorEnum];
export const GetCardTransactionEvidenceRecords200ResponseInnerCalculatedDpiErrorEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetCardTransactionEvidenceRecords200ResponseInnerCalculatedDpiErrorEnum = typeof GetCardTransactionEvidenceRecords200ResponseInnerCalculatedDpiErrorEnum[keyof typeof GetCardTransactionEvidenceRecords200ResponseInnerCalculatedDpiErrorEnum];
export const GetCardTransactionEvidenceRecords200ResponseInnerColorGradationErrorEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type GetCardTransactionEvidenceRecords200ResponseInnerColorGradationErrorEnum = typeof GetCardTransactionEvidenceRecords200ResponseInnerColorGradationErrorEnum[keyof typeof GetCardTransactionEvidenceRecords200ResponseInnerColorGradationErrorEnum];
export const GetCardTransactionEvidenceRecords200ResponseInnerHeightMillisErrorEnum = {
    required: 'REQUIRED'
} as const;

export type GetCardTransactionEvidenceRecords200ResponseInnerHeightMillisErrorEnum = typeof GetCardTransactionEvidenceRecords200ResponseInnerHeightMillisErrorEnum[keyof typeof GetCardTransactionEvidenceRecords200ResponseInnerHeightMillisErrorEnum];
export const GetCardTransactionEvidenceRecords200ResponseInnerWidthMillisErrorEnum = {
    required: 'REQUIRED'
} as const;

export type GetCardTransactionEvidenceRecords200ResponseInnerWidthMillisErrorEnum = typeof GetCardTransactionEvidenceRecords200ResponseInnerWidthMillisErrorEnum[keyof typeof GetCardTransactionEvidenceRecords200ResponseInnerWidthMillisErrorEnum];

/**
 * 
 * @export
 * @interface GetCardTransactionEvidenceRecords200ResponseInnerErrors
 */
export interface GetCardTransactionEvidenceRecords200ResponseInnerErrors {
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInnerErrors
     */
    'detectedDpi'?: GetCardTransactionEvidenceRecords200ResponseInnerErrorsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInnerErrors
     */
    'calculatedDpi'?: GetCardTransactionEvidenceRecords200ResponseInnerErrorsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInnerErrors
     */
    'colorGradation'?: GetCardTransactionEvidenceRecords200ResponseInnerErrorsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInnerErrors
     */
    'heightMillis'?: GetCardTransactionEvidenceRecords200ResponseInnerErrorsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInnerErrors
     */
    'widthMillis'?: GetCardTransactionEvidenceRecords200ResponseInnerErrorsWidthMillisEnum;
}

export const GetCardTransactionEvidenceRecords200ResponseInnerErrorsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetCardTransactionEvidenceRecords200ResponseInnerErrorsDetectedDpiEnum = typeof GetCardTransactionEvidenceRecords200ResponseInnerErrorsDetectedDpiEnum[keyof typeof GetCardTransactionEvidenceRecords200ResponseInnerErrorsDetectedDpiEnum];
export const GetCardTransactionEvidenceRecords200ResponseInnerErrorsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetCardTransactionEvidenceRecords200ResponseInnerErrorsCalculatedDpiEnum = typeof GetCardTransactionEvidenceRecords200ResponseInnerErrorsCalculatedDpiEnum[keyof typeof GetCardTransactionEvidenceRecords200ResponseInnerErrorsCalculatedDpiEnum];
export const GetCardTransactionEvidenceRecords200ResponseInnerErrorsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type GetCardTransactionEvidenceRecords200ResponseInnerErrorsColorGradationEnum = typeof GetCardTransactionEvidenceRecords200ResponseInnerErrorsColorGradationEnum[keyof typeof GetCardTransactionEvidenceRecords200ResponseInnerErrorsColorGradationEnum];
export const GetCardTransactionEvidenceRecords200ResponseInnerErrorsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetCardTransactionEvidenceRecords200ResponseInnerErrorsHeightMillisEnum = typeof GetCardTransactionEvidenceRecords200ResponseInnerErrorsHeightMillisEnum[keyof typeof GetCardTransactionEvidenceRecords200ResponseInnerErrorsHeightMillisEnum];
export const GetCardTransactionEvidenceRecords200ResponseInnerErrorsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetCardTransactionEvidenceRecords200ResponseInnerErrorsWidthMillisEnum = typeof GetCardTransactionEvidenceRecords200ResponseInnerErrorsWidthMillisEnum[keyof typeof GetCardTransactionEvidenceRecords200ResponseInnerErrorsWidthMillisEnum];

/**
 * Set null if it\'s evidence not analyzed using invoicing-system-compliance feature. Also set null if invoicing-system-compliance feature has been made not available for the organization by the feature-flag.
 * @export
 * @interface GetCardTransactionEvidenceRecords200ResponseInnerInvoiceIssuer
 */
export interface GetCardTransactionEvidenceRecords200ResponseInnerInvoiceIssuer {
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInnerInvoiceIssuer
     */
    'name': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInnerInvoiceIssuer
     */
    'registrationNumber': string | null;
    /**
     * isQualified retains the result of querying the 国税庁API to see if registrationNumber is qualified, as is.
     * @type {boolean}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInnerInvoiceIssuer
     */
    'isQualified': boolean;
    /**
     * AsQualified indicates whether this issuer should be treated as a qualified invoice issuer within the user\'s system, even if the RegistrationNumber is not confirmed as qualified in the National Tax Agency\'s business registration system.
     * @type {boolean}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInnerInvoiceIssuer
     */
    'asQualified': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInnerInvoiceIssuer
     */
    'partnerId': string | null;
}
/**
 * 
 * @export
 * @interface GetCardTransactionEvidenceRecords200ResponseInnerUpdatedBy
 */
export interface GetCardTransactionEvidenceRecords200ResponseInnerUpdatedBy {
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInnerUpdatedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInnerUpdatedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetCardTransactionEvidenceRecords200ResponseInnerUploadedBy
 */
export interface GetCardTransactionEvidenceRecords200ResponseInnerUploadedBy {
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInnerUploadedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInnerUploadedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetCardTransactionEvidenceRecords200ResponseInnerWarnings
 */
export interface GetCardTransactionEvidenceRecords200ResponseInnerWarnings {
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInnerWarnings
     */
    'detectedDpi'?: GetCardTransactionEvidenceRecords200ResponseInnerWarningsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInnerWarnings
     */
    'calculatedDpi'?: GetCardTransactionEvidenceRecords200ResponseInnerWarningsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInnerWarnings
     */
    'colorGradation'?: GetCardTransactionEvidenceRecords200ResponseInnerWarningsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInnerWarnings
     */
    'heightMillis'?: GetCardTransactionEvidenceRecords200ResponseInnerWarningsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInnerWarnings
     */
    'widthMillis'?: GetCardTransactionEvidenceRecords200ResponseInnerWarningsWidthMillisEnum;
}

export const GetCardTransactionEvidenceRecords200ResponseInnerWarningsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetCardTransactionEvidenceRecords200ResponseInnerWarningsDetectedDpiEnum = typeof GetCardTransactionEvidenceRecords200ResponseInnerWarningsDetectedDpiEnum[keyof typeof GetCardTransactionEvidenceRecords200ResponseInnerWarningsDetectedDpiEnum];
export const GetCardTransactionEvidenceRecords200ResponseInnerWarningsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetCardTransactionEvidenceRecords200ResponseInnerWarningsCalculatedDpiEnum = typeof GetCardTransactionEvidenceRecords200ResponseInnerWarningsCalculatedDpiEnum[keyof typeof GetCardTransactionEvidenceRecords200ResponseInnerWarningsCalculatedDpiEnum];
export const GetCardTransactionEvidenceRecords200ResponseInnerWarningsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type GetCardTransactionEvidenceRecords200ResponseInnerWarningsColorGradationEnum = typeof GetCardTransactionEvidenceRecords200ResponseInnerWarningsColorGradationEnum[keyof typeof GetCardTransactionEvidenceRecords200ResponseInnerWarningsColorGradationEnum];
export const GetCardTransactionEvidenceRecords200ResponseInnerWarningsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetCardTransactionEvidenceRecords200ResponseInnerWarningsHeightMillisEnum = typeof GetCardTransactionEvidenceRecords200ResponseInnerWarningsHeightMillisEnum[keyof typeof GetCardTransactionEvidenceRecords200ResponseInnerWarningsHeightMillisEnum];
export const GetCardTransactionEvidenceRecords200ResponseInnerWarningsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetCardTransactionEvidenceRecords200ResponseInnerWarningsWidthMillisEnum = typeof GetCardTransactionEvidenceRecords200ResponseInnerWarningsWidthMillisEnum[keyof typeof GetCardTransactionEvidenceRecords200ResponseInnerWarningsWidthMillisEnum];

/**
 * 
 * @export
 * @interface GetCardTransactions200Response
 */
export interface GetCardTransactions200Response {
    /**
     * 
     * @type {number}
     * @memberof GetCardTransactions200Response
     */
    'amount': number;
    /**
     * 
     * @type {Array<GetCardTransactions200ResponseMergedTransactionDetailListInner>}
     * @memberof GetCardTransactions200Response
     */
    'mergedTransactionDetailList': Array<GetCardTransactions200ResponseMergedTransactionDetailListInner>;
}
/**
 * 
 * @export
 * @interface GetCardTransactions200ResponseMergedTransactionDetailListInner
 */
export interface GetCardTransactions200ResponseMergedTransactionDetailListInner {
    /**
     * 
     * @type {GetCardTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransaction}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInner
     */
    'mergedCardTransaction': GetCardTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransaction;
    /**
     * 
     * @type {GetCardTransactions200ResponseMergedTransactionDetailListInnerCardTransactionEvidenceStatus}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInner
     */
    'cardTransactionEvidenceStatus': GetCardTransactions200ResponseMergedTransactionDetailListInnerCardTransactionEvidenceStatus;
    /**
     * 
     * @type {Array<GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner>}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInner
     */
    'evidenceList': Array<GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner>;
    /**
     * 
     * @type {Array<GetCardTransactions200ResponseMergedTransactionDetailListInnerRequestHistoryInner>}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInner
     */
    'requestHistory': Array<GetCardTransactions200ResponseMergedTransactionDetailListInnerRequestHistoryInner>;
    /**
     * 
     * @type {GetCardTransactions200ResponseMergedTransactionDetailListInnerComment}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInner
     */
    'comment'?: GetCardTransactions200ResponseMergedTransactionDetailListInnerComment;
    /**
     * 
     * @type {GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceRemindStatus}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInner
     */
    'evidenceRemindStatus': GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceRemindStatus;
    /**
     * 
     * @type {GetCardTransactions200ResponseMergedTransactionDetailListInnerUserAccount}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInner
     */
    'userAccount': GetCardTransactions200ResponseMergedTransactionDetailListInnerUserAccount;
    /**
     * 
     * @type {Array<GetCardTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInner>}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInner
     */
    'purchaseApplications': Array<GetCardTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInner>;
}
/**
 * 
 * @export
 * @interface GetCardTransactions200ResponseMergedTransactionDetailListInnerCardTransactionEvidenceStatus
 */
export interface GetCardTransactions200ResponseMergedTransactionDetailListInnerCardTransactionEvidenceStatus {
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerCardTransactionEvidenceStatus
     */
    'visaTransactionReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerCardTransactionEvidenceStatus
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerCardTransactionEvidenceStatus
     */
    'isRequested': boolean;
    /**
     * 
     * @type {GetCardTransactions200ResponseMergedTransactionDetailListInnerCardTransactionEvidenceStatusRequestedBy}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerCardTransactionEvidenceStatus
     */
    'requestedBy': GetCardTransactions200ResponseMergedTransactionDetailListInnerCardTransactionEvidenceStatusRequestedBy | null;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerCardTransactionEvidenceStatus
     */
    'requestedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerCardTransactionEvidenceStatus
     */
    'isLocked': boolean;
    /**
     * 
     * @type {GetCardTransactions200ResponseMergedTransactionDetailListInnerCardTransactionEvidenceStatusLockedBy}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerCardTransactionEvidenceStatus
     */
    'lockedBy': GetCardTransactions200ResponseMergedTransactionDetailListInnerCardTransactionEvidenceStatusLockedBy | null;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerCardTransactionEvidenceStatus
     */
    'lockedAt': string;
}
/**
 * 
 * @export
 * @interface GetCardTransactions200ResponseMergedTransactionDetailListInnerCardTransactionEvidenceStatusLockedBy
 */
export interface GetCardTransactions200ResponseMergedTransactionDetailListInnerCardTransactionEvidenceStatusLockedBy {
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerCardTransactionEvidenceStatusLockedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerCardTransactionEvidenceStatusLockedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetCardTransactions200ResponseMergedTransactionDetailListInnerCardTransactionEvidenceStatusRequestedBy
 */
export interface GetCardTransactions200ResponseMergedTransactionDetailListInnerCardTransactionEvidenceStatusRequestedBy {
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerCardTransactionEvidenceStatusRequestedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerCardTransactionEvidenceStatusRequestedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetCardTransactions200ResponseMergedTransactionDetailListInnerComment
 */
export interface GetCardTransactions200ResponseMergedTransactionDetailListInnerComment {
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerComment
     */
    'cardTransactionCommentId': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerComment
     */
    'visaTransactionReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerComment
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerComment
     */
    'comment': string;
    /**
     * 
     * @type {GetCardTransactions200ResponseMergedTransactionDetailListInnerCommentCreatedBy}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerComment
     */
    'createdBy': GetCardTransactions200ResponseMergedTransactionDetailListInnerCommentCreatedBy;
}
/**
 * 
 * @export
 * @interface GetCardTransactions200ResponseMergedTransactionDetailListInnerCommentCreatedBy
 */
export interface GetCardTransactions200ResponseMergedTransactionDetailListInnerCommentCreatedBy {
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerCommentCreatedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerCommentCreatedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
 */
export interface GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner {
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     * @deprecated
     */
    'cardTransactionEvidenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     * @deprecated
     */
    'visaTransactionReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'paymentType': GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerPaymentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'fileName': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'fileExtension': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'electronicMethod': GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerElectronicMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'documentSize': GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerDocumentSizeEnum;
    /**
     * 
     * @type {number}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     * @deprecated
     */
    'dpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'detectedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'calculatedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'colorGradation': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'verticalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'horizontalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'heightMillis': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'widthMillis': number | null;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'legalValidity': GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerLegalValidityEnum;
    /**
     * 
     * @type {boolean}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'dpiForciblyValid': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'colorGradationForciblyValid': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'note': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'irrelevantToLedger': boolean;
    /**
     * 
     * @type {GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerInvoiceIssuer}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'invoiceIssuer': GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerInvoiceIssuer | null;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     * @deprecated
     */
    'dpiError': GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerDpiErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     * @deprecated
     */
    'detectedDpiError': GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerDetectedDpiErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     * @deprecated
     */
    'calculatedDpiError': GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerCalculatedDpiErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     * @deprecated
     */
    'colorGradationError': GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerColorGradationErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     * @deprecated
     */
    'heightMillisError': GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerHeightMillisErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     * @deprecated
     */
    'widthMillisError': GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWidthMillisErrorEnum;
    /**
     * 
     * @type {GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrors}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'errors': GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrors;
    /**
     * 
     * @type {GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarnings}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'warnings': GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarnings;
    /**
     * 
     * @type {GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerCreatedBy}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'createdBy': GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerCreatedBy;
    /**
     * 
     * @type {GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerUpdatedBy}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'updatedBy': GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerUpdatedBy;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'updatedAt': string;
    /**
     * 
     * @type {GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerUploadedBy}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'uploadedBy': GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerUploadedBy;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'uploadedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'uploadedByRecipient': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'needsMigration': boolean | null;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'uploadedFrom': string;
}

export const GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerPaymentTypeEnum = {
    cardTransaction: 'CARD_TRANSACTION',
    paymentRequest: 'PAYMENT_REQUEST'
} as const;

export type GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerPaymentTypeEnum = typeof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerPaymentTypeEnum[keyof typeof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerPaymentTypeEnum];
export const GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerElectronicMethodEnum = {
    fullElectronic: 'FULL_ELECTRONIC',
    originallyPaper: 'ORIGINALLY_PAPER',
    unknown: 'UNKNOWN'
} as const;

export type GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerElectronicMethodEnum = typeof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerElectronicMethodEnum[keyof typeof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerElectronicMethodEnum];
export const GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerDocumentSizeEnum = {
    overA4: 'OVER_A4',
    a4OrSmaller: 'A4_OR_SMALLER',
    unknown: 'UNKNOWN'
} as const;

export type GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerDocumentSizeEnum = typeof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerDocumentSizeEnum[keyof typeof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerDocumentSizeEnum];
export const GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerLegalValidityEnum = {
    valid: 'VALID',
    invalid: 'INVALID',
    inputRequired: 'INPUT_REQUIRED',
    outOfTarget: 'OUT_OF_TARGET'
} as const;

export type GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerLegalValidityEnum = typeof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerLegalValidityEnum[keyof typeof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerLegalValidityEnum];
export const GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerDpiErrorEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerDpiErrorEnum = typeof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerDpiErrorEnum[keyof typeof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerDpiErrorEnum];
export const GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerDetectedDpiErrorEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerDetectedDpiErrorEnum = typeof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerDetectedDpiErrorEnum[keyof typeof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerDetectedDpiErrorEnum];
export const GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerCalculatedDpiErrorEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerCalculatedDpiErrorEnum = typeof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerCalculatedDpiErrorEnum[keyof typeof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerCalculatedDpiErrorEnum];
export const GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerColorGradationErrorEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerColorGradationErrorEnum = typeof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerColorGradationErrorEnum[keyof typeof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerColorGradationErrorEnum];
export const GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerHeightMillisErrorEnum = {
    required: 'REQUIRED'
} as const;

export type GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerHeightMillisErrorEnum = typeof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerHeightMillisErrorEnum[keyof typeof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerHeightMillisErrorEnum];
export const GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWidthMillisErrorEnum = {
    required: 'REQUIRED'
} as const;

export type GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWidthMillisErrorEnum = typeof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWidthMillisErrorEnum[keyof typeof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWidthMillisErrorEnum];

/**
 * 
 * @export
 * @interface GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerCreatedBy
 */
export interface GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerCreatedBy {
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerCreatedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerCreatedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrors
 */
export interface GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrors {
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrors
     */
    'detectedDpi'?: GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrors
     */
    'calculatedDpi'?: GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrors
     */
    'colorGradation'?: GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrors
     */
    'heightMillis'?: GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrors
     */
    'widthMillis'?: GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsWidthMillisEnum;
}

export const GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsDetectedDpiEnum = typeof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsDetectedDpiEnum[keyof typeof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsDetectedDpiEnum];
export const GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsCalculatedDpiEnum = typeof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsCalculatedDpiEnum[keyof typeof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsCalculatedDpiEnum];
export const GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsColorGradationEnum = typeof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsColorGradationEnum[keyof typeof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsColorGradationEnum];
export const GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsHeightMillisEnum = typeof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsHeightMillisEnum[keyof typeof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsHeightMillisEnum];
export const GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsWidthMillisEnum = typeof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsWidthMillisEnum[keyof typeof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsWidthMillisEnum];

/**
 * Set null if it\'s evidence not analyzed using invoicing-system-compliance feature. Also set null if invoicing-system-compliance feature has been made not available for the organization by the feature-flag.
 * @export
 * @interface GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerInvoiceIssuer
 */
export interface GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerInvoiceIssuer {
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerInvoiceIssuer
     */
    'name': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerInvoiceIssuer
     */
    'registrationNumber': string | null;
    /**
     * isQualified retains the result of querying the 国税庁API to see if registrationNumber is qualified, as is.
     * @type {boolean}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerInvoiceIssuer
     */
    'isQualified': boolean;
    /**
     * AsQualified indicates whether this issuer should be treated as a qualified invoice issuer within the user\'s system, even if the RegistrationNumber is not confirmed as qualified in the National Tax Agency\'s business registration system.
     * @type {boolean}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerInvoiceIssuer
     */
    'asQualified': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerInvoiceIssuer
     */
    'partnerId': string | null;
}
/**
 * 
 * @export
 * @interface GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerUpdatedBy
 */
export interface GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerUpdatedBy {
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerUpdatedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerUpdatedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerUploadedBy
 */
export interface GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerUploadedBy {
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerUploadedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerUploadedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarnings
 */
export interface GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarnings {
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarnings
     */
    'detectedDpi'?: GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarnings
     */
    'calculatedDpi'?: GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarnings
     */
    'colorGradation'?: GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarnings
     */
    'heightMillis'?: GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarnings
     */
    'widthMillis'?: GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsWidthMillisEnum;
}

export const GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsDetectedDpiEnum = typeof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsDetectedDpiEnum[keyof typeof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsDetectedDpiEnum];
export const GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsCalculatedDpiEnum = typeof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsCalculatedDpiEnum[keyof typeof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsCalculatedDpiEnum];
export const GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsColorGradationEnum = typeof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsColorGradationEnum[keyof typeof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsColorGradationEnum];
export const GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsHeightMillisEnum = typeof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsHeightMillisEnum[keyof typeof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsHeightMillisEnum];
export const GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsWidthMillisEnum = typeof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsWidthMillisEnum[keyof typeof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsWidthMillisEnum];

/**
 * 
 * @export
 * @interface GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceRemindStatus
 */
export interface GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceRemindStatus {
    /**
     * 
     * @type {boolean}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceRemindStatus
     */
    'isAutoRemind': boolean;
}
/**
 * 
 * @export
 * @interface GetCardTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransaction
 */
export interface GetCardTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransaction {
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransaction
     */
    'visaTransactionReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransaction
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransaction
     */
    'merchantName': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransaction
     */
    'merchantNameKana': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransaction
     */
    'merchantNameKanji': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransaction
     */
    'mergedMerchantName': string;
    /**
     * 
     * @type {number}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransaction
     */
    'amount': number;
    /**
     * 
     * @type {number}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransaction
     */
    'amountFx': number;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransaction
     */
    'currencyCode': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransaction
     */
    'processedAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransaction
     */
    'transactionType': GetCardTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransaction
     */
    'creditSettlement': number;
    /**
     * 
     * @type {Array<GetCardTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner>}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransaction
     */
    'transactionRecordList': Array<GetCardTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner>;
    /**
     * 
     * @type {boolean}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransaction
     */
    'isCleared': boolean;
}

export const GetCardTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionTypeEnum = {
    confirm: 'CONFIRM',
    notConfirm: 'NOT_CONFIRM'
} as const;

export type GetCardTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionTypeEnum = typeof GetCardTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionTypeEnum[keyof typeof GetCardTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionTypeEnum];

/**
 * 
 * @export
 * @interface GetCardTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner
 */
export interface GetCardTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner {
    /**
     * 
     * @type {number}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner
     */
    'amount': number;
    /**
     * 
     * @type {number}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner
     */
    'amountFx': number;
    /**
     * 
     * @type {number}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner
     */
    'totalAmount': number;
    /**
     * 
     * @type {number}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner
     */
    'totalAmountFx': number;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner
     */
    'currencyCode': string;
    /**
     * 
     * @type {number}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner
     */
    'fxRate': number | null;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner
     */
    'processedAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner
     */
    'transactionDetailType': GetCardTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner
     */
    'isCleared': boolean;
}

export const GetCardTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum = {
    purchase: 'PURCHASE',
    settlement: 'SETTLEMENT',
    validation: 'VALIDATION',
    refund: 'REFUND',
    cancel: 'CANCEL',
    refundCancel: 'REFUND_CANCEL',
    refundPartialCancel: 'REFUND_PARTIAL_CANCEL'
} as const;

export type GetCardTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum = typeof GetCardTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum[keyof typeof GetCardTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum];

/**
 * 
 * @export
 * @interface GetCardTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInner
 */
export interface GetCardTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInner {
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInner
     */
    'applicationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInner
     */
    'applicationNumber': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInner
     */
    'paymentDate': string;
    /**
     * 
     * @type {GetCardTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerSubmittedBy}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInner
     */
    'submittedBy': GetCardTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerSubmittedBy;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInner
     */
    'submittedAt': string;
    /**
     * 
     * @type {Array<GetCardTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerApproversInner>}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInner
     */
    'approvers': Array<GetCardTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerApproversInner>;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInner
     */
    'department': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInner
     */
    'purchaseReason': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInner
     */
    'purchaseDetails': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInner
     */
    'placeOfUse': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInner
     */
    'purposeOfUse': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInner
     */
    'url': string;
    /**
     * 
     * @type {number}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInner
     */
    'amount': number;
    /**
     * 
     * @type {GetCardTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccount}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInner
     */
    'userAccount': GetCardTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccount | null;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInner
     */
    'remarks': string;
    /**
     * 
     * @type {GetCardTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerWorkRequestedBy}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInner
     */
    'workRequestedBy': GetCardTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerWorkRequestedBy;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInner
     */
    'workRequestApprovers': string;
    /**
     * 
     * @type {GetCardTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerStatus}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInner
     */
    'status': GetCardTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerStatus;
    /**
     * 
     * @type {GetCardTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerCreatedBy}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInner
     */
    'createdBy': GetCardTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerCreatedBy;
}
/**
 * 
 * @export
 * @interface GetCardTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerApproversInner
 */
export interface GetCardTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerApproversInner {
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerApproversInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerApproversInner
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetCardTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerCreatedBy
 */
export interface GetCardTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerCreatedBy {
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerCreatedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerCreatedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetCardTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerStatus
 */
export interface GetCardTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerStatus {
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerStatus
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerStatus
     */
    'comment': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerStatus
     */
    'statusChangedAt': string;
    /**
     * 
     * @type {GetCardTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerStatusCreatedBy}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerStatus
     */
    'createdBy': GetCardTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerStatusCreatedBy;
}
/**
 * 
 * @export
 * @interface GetCardTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerStatusCreatedBy
 */
export interface GetCardTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerStatusCreatedBy {
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerStatusCreatedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerStatusCreatedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetCardTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerSubmittedBy
 */
export interface GetCardTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerSubmittedBy {
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerSubmittedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerSubmittedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetCardTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccount
 */
export interface GetCardTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccount {
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccount
     */
    'userAccountId': string;
    /**
     * 
     * @type {GetCardTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUser}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccount
     */
    'user': GetCardTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUser;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccount
     */
    'cardLabel': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccount
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccount
     */
    'organizationName': string;
    /**
     * 
     * @type {GetCardTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUserAccountGroup}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccount
     */
    'userAccountGroup': GetCardTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUserAccountGroup | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccount
     */
    'isOnDemand': boolean;
}
/**
 * 
 * @export
 * @interface GetCardTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUser
 */
export interface GetCardTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUser {
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUser
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUser
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUser
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUser
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUser
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUser
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUser
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUser
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUser
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUser
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUser
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface GetCardTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUserAccountGroup
 */
export interface GetCardTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUserAccountGroup {
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUserAccountGroup
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUserAccountGroup
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUserAccountGroup
     */
    'sortNum': number;
}
/**
 * 
 * @export
 * @interface GetCardTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerWorkRequestedBy
 */
export interface GetCardTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerWorkRequestedBy {
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerWorkRequestedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerWorkRequestedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetCardTransactions200ResponseMergedTransactionDetailListInnerRequestHistoryInner
 */
export interface GetCardTransactions200ResponseMergedTransactionDetailListInnerRequestHistoryInner {
    /**
     * 
     * @type {number}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerRequestHistoryInner
     */
    'requestId': number;
    /**
     * 
     * @type {GetCardTransactions200ResponseMergedTransactionDetailListInnerRequestHistoryInnerRequestedBy}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerRequestHistoryInner
     */
    'requestedBy': GetCardTransactions200ResponseMergedTransactionDetailListInnerRequestHistoryInnerRequestedBy;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerRequestHistoryInner
     */
    'requestedAt': string;
}
/**
 * 
 * @export
 * @interface GetCardTransactions200ResponseMergedTransactionDetailListInnerRequestHistoryInnerRequestedBy
 */
export interface GetCardTransactions200ResponseMergedTransactionDetailListInnerRequestHistoryInnerRequestedBy {
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerRequestHistoryInnerRequestedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerRequestHistoryInnerRequestedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetCardTransactions200ResponseMergedTransactionDetailListInnerUserAccount
 */
export interface GetCardTransactions200ResponseMergedTransactionDetailListInnerUserAccount {
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerUserAccount
     */
    'userAccountId': string;
    /**
     * 
     * @type {GetCardTransactions200ResponseMergedTransactionDetailListInnerUserAccountUser}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerUserAccount
     */
    'user': GetCardTransactions200ResponseMergedTransactionDetailListInnerUserAccountUser;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerUserAccount
     */
    'cardLabel': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerUserAccount
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerUserAccount
     */
    'organizationName': string;
    /**
     * 
     * @type {GetCardTransactions200ResponseMergedTransactionDetailListInnerUserAccountUserAccountGroup}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerUserAccount
     */
    'userAccountGroup': GetCardTransactions200ResponseMergedTransactionDetailListInnerUserAccountUserAccountGroup | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerUserAccount
     */
    'isOnDemand': boolean;
}
/**
 * 
 * @export
 * @interface GetCardTransactions200ResponseMergedTransactionDetailListInnerUserAccountUser
 */
export interface GetCardTransactions200ResponseMergedTransactionDetailListInnerUserAccountUser {
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerUserAccountUser
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerUserAccountUser
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerUserAccountUser
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerUserAccountUser
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerUserAccountUser
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerUserAccountUser
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerUserAccountUser
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerUserAccountUser
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerUserAccountUser
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerUserAccountUser
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerUserAccountUser
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface GetCardTransactions200ResponseMergedTransactionDetailListInnerUserAccountUserAccountGroup
 */
export interface GetCardTransactions200ResponseMergedTransactionDetailListInnerUserAccountUserAccountGroup {
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerUserAccountUserAccountGroup
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerUserAccountUserAccountGroup
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerUserAccountUserAccountGroup
     */
    'sortNum': number;
}
/**
 * 
 * @export
 * @interface GetCards200ResponseInner
 */
export interface GetCards200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetCards200ResponseInner
     */
    'cardId': string;
    /**
     * 
     * @type {string}
     * @memberof GetCards200ResponseInner
     */
    'cardLabel': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetCards200ResponseInner
     */
    'isActivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCards200ResponseInner
     */
    'isDeactivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCards200ResponseInner
     */
    'isLocked': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCards200ResponseInner
     */
    'isSuspended': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCards200ResponseInner
     */
    'isFrozen': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCards200ResponseInner
     */
    'isVirtualCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCards200ResponseInner
     */
    'isCreditCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCards200ResponseInner
     */
    'isOnDemand': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCards200ResponseInner
     */
    'isMetalCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCards200ResponseInner
     */
    'isPhysicalStorePaymentDisabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetCards200ResponseInner
     */
    'panLastFourDigits': string;
    /**
     * 
     * @type {string}
     * @memberof GetCards200ResponseInner
     */
    'userAccountId': string;
    /**
     * 
     * @type {number}
     * @memberof GetCards200ResponseInner
     */
    'transactionUpperLimit': number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetCards200ResponseInner
     */
    'availableCurrencies': Array<GetCards200ResponseInnerAvailableCurrenciesEnum>;
    /**
     * 
     * @type {Array<GetCards200ResponseInnerAvailableMerchantCategoriesInner>}
     * @memberof GetCards200ResponseInner
     */
    'availableMerchantCategories': Array<GetCards200ResponseInnerAvailableMerchantCategoriesInner> | null;
    /**
     * 
     * @type {GetCards200ResponseInnerUser}
     * @memberof GetCards200ResponseInner
     */
    'user': GetCards200ResponseInnerUser;
    /**
     * 
     * @type {GetCards200ResponseInnerUserAccountGroup}
     * @memberof GetCards200ResponseInner
     */
    'userAccountGroup'?: GetCards200ResponseInnerUserAccountGroup | null;
    /**
     * 
     * @type {number}
     * @memberof GetCards200ResponseInner
     */
    'monthlyTotalUsage': number;
    /**
     * 
     * @type {number}
     * @memberof GetCards200ResponseInner
     */
    'monthlyUsageLimit': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetCards200ResponseInner
     */
    'dailyTotalUsage': number;
    /**
     * 
     * @type {number}
     * @memberof GetCards200ResponseInner
     */
    'dailyUsageLimit': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetCards200ResponseInner
     */
    'totalUsageAmount': number;
    /**
     * 
     * @type {number}
     * @memberof GetCards200ResponseInner
     */
    'totalUsageAmountLimit': number | null;
    /**
     * 
     * @type {string}
     * @memberof GetCards200ResponseInner
     */
    'expiredDate': string | null;
}

export const GetCards200ResponseInnerAvailableCurrenciesEnum = {
    jpy: 'JPY',
    usd: 'USD',
    gbp: 'GBP',
    eur: 'EUR',
    sgd: 'SGD',
    aud: 'AUD',
    cny: 'CNY',
    hkd: 'HKD',
    idr: 'IDR',
    krw: 'KRW',
    nzd: 'NZD',
    php: 'PHP',
    rub: 'RUB',
    vnd: 'VND',
    inr: 'INR',
    thb: 'THB',
    lak: 'LAK',
    myr: 'MYR',
    twd: 'TWD',
    chf: 'CHF',
    cad: 'CAD',
    mxn: 'MXN',
    nok: 'NOK',
    huf: 'HUF',
    hrk: 'HRK',
    czk: 'CZK',
    dkk: 'DKK',
    isk: 'ISK',
    mdl: 'MDL',
    sek: 'SEK',
    mkd: 'MKD',
    rsd: 'RSD',
    ron: 'RON',
    bgn: 'BGN',
    bam: 'BAM',
    pln: 'PLN',
    mad: 'MAD',
    zar: 'ZAR',
    rwf: 'RWF',
    kes: 'KES',
    ngn: 'NGN',
    aed: 'AED',
    sar: 'SAR',
    egp: 'EGP',
    qar: 'QAR',
    omr: 'OMR',
    ils: 'ILS',
    try: 'TRY',
    kzt: 'KZT',
    cop: 'COP',
    gtq: 'GTQ'
} as const;

export type GetCards200ResponseInnerAvailableCurrenciesEnum = typeof GetCards200ResponseInnerAvailableCurrenciesEnum[keyof typeof GetCards200ResponseInnerAvailableCurrenciesEnum];

/**
 * 
 * @export
 * @interface GetCards200ResponseInnerAvailableMerchantCategoriesInner
 */
export interface GetCards200ResponseInnerAvailableMerchantCategoriesInner {
    /**
     * 
     * @type {string}
     * @memberof GetCards200ResponseInnerAvailableMerchantCategoriesInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetCards200ResponseInnerAvailableMerchantCategoriesInner
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetCards200ResponseInnerAvailableMerchantCategoriesInner
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof GetCards200ResponseInnerAvailableMerchantCategoriesInner
     */
    'logoUrl': string;
}
/**
 * 
 * @export
 * @interface GetCards200ResponseInnerUser
 */
export interface GetCards200ResponseInnerUser {
    /**
     * 
     * @type {string}
     * @memberof GetCards200ResponseInnerUser
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetCards200ResponseInnerUser
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetCards200ResponseInnerUser
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetCards200ResponseInnerUser
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof GetCards200ResponseInnerUser
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetCards200ResponseInnerUser
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCards200ResponseInnerUser
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCards200ResponseInnerUser
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCards200ResponseInnerUser
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCards200ResponseInnerUser
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetCards200ResponseInnerUser
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface GetCards200ResponseInnerUserAccountGroup
 */
export interface GetCards200ResponseInnerUserAccountGroup {
    /**
     * 
     * @type {string}
     * @memberof GetCards200ResponseInnerUserAccountGroup
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetCards200ResponseInnerUserAccountGroup
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof GetCards200ResponseInnerUserAccountGroup
     */
    'sortNum': number;
}
/**
 * 
 * @export
 * @interface GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInner
 */
export interface GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInner {
    /**
     * 
     * @type {GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerMergedCardTransaction}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInner
     */
    'mergedCardTransaction': GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerMergedCardTransaction;
    /**
     * 
     * @type {GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerCardTransactionEvidenceStatus}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInner
     */
    'cardTransactionEvidenceStatus': GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerCardTransactionEvidenceStatus;
    /**
     * 
     * @type {Array<GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInner>}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInner
     */
    'evidenceList': Array<GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInner>;
    /**
     * 
     * @type {Array<GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerRequestHistoryInner>}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInner
     */
    'requestHistory': Array<GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerRequestHistoryInner>;
    /**
     * 
     * @type {GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerComment}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInner
     */
    'comment'?: GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerComment;
    /**
     * 
     * @type {GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceRemindStatus}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInner
     */
    'evidenceRemindStatus': GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceRemindStatus;
    /**
     * 
     * @type {GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerUserAccount}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInner
     */
    'userAccount': GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerUserAccount;
    /**
     * 
     * @type {Array<GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerPurchaseApplicationsInner>}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInner
     */
    'purchaseApplications': Array<GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerPurchaseApplicationsInner>;
}
/**
 * 
 * @export
 * @interface GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerCardTransactionEvidenceStatus
 */
export interface GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerCardTransactionEvidenceStatus {
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerCardTransactionEvidenceStatus
     */
    'visaTransactionReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerCardTransactionEvidenceStatus
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerCardTransactionEvidenceStatus
     */
    'isRequested': boolean;
    /**
     * 
     * @type {GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerCardTransactionEvidenceStatusRequestedBy}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerCardTransactionEvidenceStatus
     */
    'requestedBy': GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerCardTransactionEvidenceStatusRequestedBy | null;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerCardTransactionEvidenceStatus
     */
    'requestedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerCardTransactionEvidenceStatus
     */
    'isLocked': boolean;
    /**
     * 
     * @type {GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerCardTransactionEvidenceStatusLockedBy}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerCardTransactionEvidenceStatus
     */
    'lockedBy': GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerCardTransactionEvidenceStatusLockedBy | null;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerCardTransactionEvidenceStatus
     */
    'lockedAt': string;
}
/**
 * 
 * @export
 * @interface GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerCardTransactionEvidenceStatusLockedBy
 */
export interface GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerCardTransactionEvidenceStatusLockedBy {
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerCardTransactionEvidenceStatusLockedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerCardTransactionEvidenceStatusLockedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerCardTransactionEvidenceStatusRequestedBy
 */
export interface GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerCardTransactionEvidenceStatusRequestedBy {
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerCardTransactionEvidenceStatusRequestedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerCardTransactionEvidenceStatusRequestedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerComment
 */
export interface GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerComment {
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerComment
     */
    'cardTransactionCommentId': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerComment
     */
    'visaTransactionReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerComment
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerComment
     */
    'comment': string;
    /**
     * 
     * @type {GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerCommentCreatedBy}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerComment
     */
    'createdBy': GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerCommentCreatedBy;
}
/**
 * 
 * @export
 * @interface GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerCommentCreatedBy
 */
export interface GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerCommentCreatedBy {
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerCommentCreatedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerCommentCreatedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInner
 */
export interface GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInner {
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInner
     * @deprecated
     */
    'cardTransactionEvidenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInner
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInner
     * @deprecated
     */
    'visaTransactionReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInner
     */
    'paymentType': GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerPaymentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInner
     */
    'fileName': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInner
     */
    'fileExtension': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInner
     */
    'electronicMethod': GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerElectronicMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInner
     */
    'documentSize': GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerDocumentSizeEnum;
    /**
     * 
     * @type {number}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInner
     * @deprecated
     */
    'dpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInner
     */
    'detectedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInner
     */
    'calculatedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInner
     */
    'colorGradation': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInner
     */
    'verticalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInner
     */
    'horizontalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInner
     */
    'heightMillis': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInner
     */
    'widthMillis': number | null;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInner
     */
    'legalValidity': GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerLegalValidityEnum;
    /**
     * 
     * @type {boolean}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInner
     */
    'dpiForciblyValid': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInner
     */
    'colorGradationForciblyValid': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInner
     */
    'note': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInner
     */
    'irrelevantToLedger': boolean;
    /**
     * 
     * @type {GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerInvoiceIssuer}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInner
     */
    'invoiceIssuer': GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerInvoiceIssuer | null;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInner
     * @deprecated
     */
    'dpiError': GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerDpiErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInner
     * @deprecated
     */
    'detectedDpiError': GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerDetectedDpiErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInner
     * @deprecated
     */
    'calculatedDpiError': GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerCalculatedDpiErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInner
     * @deprecated
     */
    'colorGradationError': GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerColorGradationErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInner
     * @deprecated
     */
    'heightMillisError': GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerHeightMillisErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInner
     * @deprecated
     */
    'widthMillisError': GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerWidthMillisErrorEnum;
    /**
     * 
     * @type {GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerErrors}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInner
     */
    'errors': GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerErrors;
    /**
     * 
     * @type {GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerWarnings}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInner
     */
    'warnings': GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerWarnings;
    /**
     * 
     * @type {GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerCreatedBy}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInner
     */
    'createdBy': GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerCreatedBy;
    /**
     * 
     * @type {GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerUpdatedBy}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInner
     */
    'updatedBy': GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerUpdatedBy;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInner
     */
    'updatedAt': string;
    /**
     * 
     * @type {GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerUploadedBy}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInner
     */
    'uploadedBy': GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerUploadedBy;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInner
     */
    'uploadedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInner
     */
    'uploadedByRecipient': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInner
     */
    'needsMigration': boolean | null;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInner
     */
    'uploadedFrom': string;
}

export const GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerPaymentTypeEnum = {
    cardTransaction: 'CARD_TRANSACTION',
    paymentRequest: 'PAYMENT_REQUEST'
} as const;

export type GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerPaymentTypeEnum = typeof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerPaymentTypeEnum[keyof typeof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerPaymentTypeEnum];
export const GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerElectronicMethodEnum = {
    fullElectronic: 'FULL_ELECTRONIC',
    originallyPaper: 'ORIGINALLY_PAPER',
    unknown: 'UNKNOWN'
} as const;

export type GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerElectronicMethodEnum = typeof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerElectronicMethodEnum[keyof typeof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerElectronicMethodEnum];
export const GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerDocumentSizeEnum = {
    overA4: 'OVER_A4',
    a4OrSmaller: 'A4_OR_SMALLER',
    unknown: 'UNKNOWN'
} as const;

export type GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerDocumentSizeEnum = typeof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerDocumentSizeEnum[keyof typeof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerDocumentSizeEnum];
export const GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerLegalValidityEnum = {
    valid: 'VALID',
    invalid: 'INVALID',
    inputRequired: 'INPUT_REQUIRED',
    outOfTarget: 'OUT_OF_TARGET'
} as const;

export type GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerLegalValidityEnum = typeof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerLegalValidityEnum[keyof typeof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerLegalValidityEnum];
export const GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerDpiErrorEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerDpiErrorEnum = typeof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerDpiErrorEnum[keyof typeof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerDpiErrorEnum];
export const GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerDetectedDpiErrorEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerDetectedDpiErrorEnum = typeof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerDetectedDpiErrorEnum[keyof typeof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerDetectedDpiErrorEnum];
export const GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerCalculatedDpiErrorEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerCalculatedDpiErrorEnum = typeof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerCalculatedDpiErrorEnum[keyof typeof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerCalculatedDpiErrorEnum];
export const GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerColorGradationErrorEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerColorGradationErrorEnum = typeof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerColorGradationErrorEnum[keyof typeof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerColorGradationErrorEnum];
export const GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerHeightMillisErrorEnum = {
    required: 'REQUIRED'
} as const;

export type GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerHeightMillisErrorEnum = typeof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerHeightMillisErrorEnum[keyof typeof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerHeightMillisErrorEnum];
export const GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerWidthMillisErrorEnum = {
    required: 'REQUIRED'
} as const;

export type GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerWidthMillisErrorEnum = typeof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerWidthMillisErrorEnum[keyof typeof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerWidthMillisErrorEnum];

/**
 * 
 * @export
 * @interface GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerCreatedBy
 */
export interface GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerCreatedBy {
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerCreatedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerCreatedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerErrors
 */
export interface GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerErrors {
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerErrors
     */
    'detectedDpi'?: GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerErrorsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerErrors
     */
    'calculatedDpi'?: GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerErrorsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerErrors
     */
    'colorGradation'?: GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerErrorsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerErrors
     */
    'heightMillis'?: GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerErrorsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerErrors
     */
    'widthMillis'?: GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerErrorsWidthMillisEnum;
}

export const GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerErrorsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerErrorsDetectedDpiEnum = typeof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerErrorsDetectedDpiEnum[keyof typeof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerErrorsDetectedDpiEnum];
export const GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerErrorsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerErrorsCalculatedDpiEnum = typeof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerErrorsCalculatedDpiEnum[keyof typeof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerErrorsCalculatedDpiEnum];
export const GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerErrorsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerErrorsColorGradationEnum = typeof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerErrorsColorGradationEnum[keyof typeof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerErrorsColorGradationEnum];
export const GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerErrorsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerErrorsHeightMillisEnum = typeof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerErrorsHeightMillisEnum[keyof typeof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerErrorsHeightMillisEnum];
export const GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerErrorsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerErrorsWidthMillisEnum = typeof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerErrorsWidthMillisEnum[keyof typeof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerErrorsWidthMillisEnum];

/**
 * Set null if it\'s evidence not analyzed using invoicing-system-compliance feature. Also set null if invoicing-system-compliance feature has been made not available for the organization by the feature-flag.
 * @export
 * @interface GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerInvoiceIssuer
 */
export interface GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerInvoiceIssuer {
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerInvoiceIssuer
     */
    'name': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerInvoiceIssuer
     */
    'registrationNumber': string | null;
    /**
     * isQualified retains the result of querying the 国税庁API to see if registrationNumber is qualified, as is.
     * @type {boolean}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerInvoiceIssuer
     */
    'isQualified': boolean;
    /**
     * AsQualified indicates whether this issuer should be treated as a qualified invoice issuer within the user\'s system, even if the RegistrationNumber is not confirmed as qualified in the National Tax Agency\'s business registration system.
     * @type {boolean}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerInvoiceIssuer
     */
    'asQualified': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerInvoiceIssuer
     */
    'partnerId': string | null;
}
/**
 * 
 * @export
 * @interface GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerUpdatedBy
 */
export interface GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerUpdatedBy {
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerUpdatedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerUpdatedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerUploadedBy
 */
export interface GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerUploadedBy {
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerUploadedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerUploadedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerWarnings
 */
export interface GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerWarnings {
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerWarnings
     */
    'detectedDpi'?: GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerWarningsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerWarnings
     */
    'calculatedDpi'?: GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerWarningsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerWarnings
     */
    'colorGradation'?: GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerWarningsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerWarnings
     */
    'heightMillis'?: GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerWarningsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerWarnings
     */
    'widthMillis'?: GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerWarningsWidthMillisEnum;
}

export const GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerWarningsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerWarningsDetectedDpiEnum = typeof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerWarningsDetectedDpiEnum[keyof typeof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerWarningsDetectedDpiEnum];
export const GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerWarningsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerWarningsCalculatedDpiEnum = typeof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerWarningsCalculatedDpiEnum[keyof typeof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerWarningsCalculatedDpiEnum];
export const GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerWarningsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerWarningsColorGradationEnum = typeof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerWarningsColorGradationEnum[keyof typeof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerWarningsColorGradationEnum];
export const GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerWarningsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerWarningsHeightMillisEnum = typeof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerWarningsHeightMillisEnum[keyof typeof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerWarningsHeightMillisEnum];
export const GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerWarningsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerWarningsWidthMillisEnum = typeof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerWarningsWidthMillisEnum[keyof typeof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerWarningsWidthMillisEnum];

/**
 * 
 * @export
 * @interface GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceRemindStatus
 */
export interface GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceRemindStatus {
    /**
     * 
     * @type {boolean}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceRemindStatus
     */
    'isAutoRemind': boolean;
}
/**
 * 
 * @export
 * @interface GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerMergedCardTransaction
 */
export interface GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerMergedCardTransaction {
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerMergedCardTransaction
     */
    'visaTransactionReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerMergedCardTransaction
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerMergedCardTransaction
     */
    'merchantName': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerMergedCardTransaction
     */
    'merchantNameKana': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerMergedCardTransaction
     */
    'merchantNameKanji': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerMergedCardTransaction
     */
    'mergedMerchantName': string;
    /**
     * 
     * @type {number}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerMergedCardTransaction
     */
    'amount': number;
    /**
     * 
     * @type {number}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerMergedCardTransaction
     */
    'amountFx': number;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerMergedCardTransaction
     */
    'currencyCode': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerMergedCardTransaction
     */
    'processedAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerMergedCardTransaction
     */
    'transactionType': GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerMergedCardTransactionTransactionTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerMergedCardTransaction
     */
    'creditSettlement': number;
    /**
     * 
     * @type {Array<GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerMergedCardTransactionTransactionRecordListInner>}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerMergedCardTransaction
     */
    'transactionRecordList': Array<GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerMergedCardTransactionTransactionRecordListInner>;
    /**
     * 
     * @type {boolean}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerMergedCardTransaction
     */
    'isCleared': boolean;
}

export const GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerMergedCardTransactionTransactionTypeEnum = {
    confirm: 'CONFIRM',
    notConfirm: 'NOT_CONFIRM'
} as const;

export type GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerMergedCardTransactionTransactionTypeEnum = typeof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerMergedCardTransactionTransactionTypeEnum[keyof typeof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerMergedCardTransactionTransactionTypeEnum];

/**
 * 
 * @export
 * @interface GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerMergedCardTransactionTransactionRecordListInner
 */
export interface GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerMergedCardTransactionTransactionRecordListInner {
    /**
     * 
     * @type {number}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerMergedCardTransactionTransactionRecordListInner
     */
    'amount': number;
    /**
     * 
     * @type {number}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerMergedCardTransactionTransactionRecordListInner
     */
    'amountFx': number;
    /**
     * 
     * @type {number}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerMergedCardTransactionTransactionRecordListInner
     */
    'totalAmount': number;
    /**
     * 
     * @type {number}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerMergedCardTransactionTransactionRecordListInner
     */
    'totalAmountFx': number;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerMergedCardTransactionTransactionRecordListInner
     */
    'currencyCode': string;
    /**
     * 
     * @type {number}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerMergedCardTransactionTransactionRecordListInner
     */
    'fxRate': number | null;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerMergedCardTransactionTransactionRecordListInner
     */
    'processedAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerMergedCardTransactionTransactionRecordListInner
     */
    'transactionDetailType': GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerMergedCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerMergedCardTransactionTransactionRecordListInner
     */
    'isCleared': boolean;
}

export const GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerMergedCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum = {
    purchase: 'PURCHASE',
    settlement: 'SETTLEMENT',
    validation: 'VALIDATION',
    refund: 'REFUND',
    cancel: 'CANCEL',
    refundCancel: 'REFUND_CANCEL',
    refundPartialCancel: 'REFUND_PARTIAL_CANCEL'
} as const;

export type GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerMergedCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum = typeof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerMergedCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum[keyof typeof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerMergedCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum];

/**
 * 
 * @export
 * @interface GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerPurchaseApplicationsInner
 */
export interface GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerPurchaseApplicationsInner {
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerPurchaseApplicationsInner
     */
    'applicationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerPurchaseApplicationsInner
     */
    'applicationNumber': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerPurchaseApplicationsInner
     */
    'paymentDate': string;
    /**
     * 
     * @type {GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerPurchaseApplicationsInnerSubmittedBy}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerPurchaseApplicationsInner
     */
    'submittedBy': GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerPurchaseApplicationsInnerSubmittedBy;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerPurchaseApplicationsInner
     */
    'submittedAt': string;
    /**
     * 
     * @type {Array<GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerPurchaseApplicationsInnerApproversInner>}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerPurchaseApplicationsInner
     */
    'approvers': Array<GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerPurchaseApplicationsInnerApproversInner>;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerPurchaseApplicationsInner
     */
    'department': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerPurchaseApplicationsInner
     */
    'purchaseReason': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerPurchaseApplicationsInner
     */
    'purchaseDetails': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerPurchaseApplicationsInner
     */
    'placeOfUse': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerPurchaseApplicationsInner
     */
    'purposeOfUse': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerPurchaseApplicationsInner
     */
    'url': string;
    /**
     * 
     * @type {number}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerPurchaseApplicationsInner
     */
    'amount': number;
    /**
     * 
     * @type {GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerPurchaseApplicationsInnerUserAccount}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerPurchaseApplicationsInner
     */
    'userAccount': GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerPurchaseApplicationsInnerUserAccount | null;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerPurchaseApplicationsInner
     */
    'remarks': string;
    /**
     * 
     * @type {GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerPurchaseApplicationsInnerWorkRequestedBy}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerPurchaseApplicationsInner
     */
    'workRequestedBy': GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerPurchaseApplicationsInnerWorkRequestedBy;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerPurchaseApplicationsInner
     */
    'workRequestApprovers': string;
    /**
     * 
     * @type {GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerPurchaseApplicationsInnerStatus}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerPurchaseApplicationsInner
     */
    'status': GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerPurchaseApplicationsInnerStatus;
    /**
     * 
     * @type {GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerPurchaseApplicationsInnerCreatedBy}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerPurchaseApplicationsInner
     */
    'createdBy': GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerPurchaseApplicationsInnerCreatedBy;
}
/**
 * 
 * @export
 * @interface GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerPurchaseApplicationsInnerApproversInner
 */
export interface GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerPurchaseApplicationsInnerApproversInner {
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerPurchaseApplicationsInnerApproversInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerPurchaseApplicationsInnerApproversInner
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerPurchaseApplicationsInnerCreatedBy
 */
export interface GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerPurchaseApplicationsInnerCreatedBy {
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerPurchaseApplicationsInnerCreatedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerPurchaseApplicationsInnerCreatedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerPurchaseApplicationsInnerStatus
 */
export interface GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerPurchaseApplicationsInnerStatus {
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerPurchaseApplicationsInnerStatus
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerPurchaseApplicationsInnerStatus
     */
    'comment': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerPurchaseApplicationsInnerStatus
     */
    'statusChangedAt': string;
    /**
     * 
     * @type {GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerPurchaseApplicationsInnerStatusCreatedBy}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerPurchaseApplicationsInnerStatus
     */
    'createdBy': GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerPurchaseApplicationsInnerStatusCreatedBy;
}
/**
 * 
 * @export
 * @interface GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerPurchaseApplicationsInnerStatusCreatedBy
 */
export interface GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerPurchaseApplicationsInnerStatusCreatedBy {
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerPurchaseApplicationsInnerStatusCreatedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerPurchaseApplicationsInnerStatusCreatedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerPurchaseApplicationsInnerSubmittedBy
 */
export interface GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerPurchaseApplicationsInnerSubmittedBy {
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerPurchaseApplicationsInnerSubmittedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerPurchaseApplicationsInnerSubmittedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerPurchaseApplicationsInnerUserAccount
 */
export interface GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerPurchaseApplicationsInnerUserAccount {
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerPurchaseApplicationsInnerUserAccount
     */
    'userAccountId': string;
    /**
     * 
     * @type {GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerPurchaseApplicationsInnerUserAccountUser}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerPurchaseApplicationsInnerUserAccount
     */
    'user': GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerPurchaseApplicationsInnerUserAccountUser;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerPurchaseApplicationsInnerUserAccount
     */
    'cardLabel': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerPurchaseApplicationsInnerUserAccount
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerPurchaseApplicationsInnerUserAccount
     */
    'organizationName': string;
    /**
     * 
     * @type {GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerPurchaseApplicationsInnerUserAccountUserAccountGroup}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerPurchaseApplicationsInnerUserAccount
     */
    'userAccountGroup': GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerPurchaseApplicationsInnerUserAccountUserAccountGroup | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerPurchaseApplicationsInnerUserAccount
     */
    'isOnDemand': boolean;
}
/**
 * 
 * @export
 * @interface GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerPurchaseApplicationsInnerUserAccountUser
 */
export interface GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerPurchaseApplicationsInnerUserAccountUser {
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerPurchaseApplicationsInnerUserAccountUser
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerPurchaseApplicationsInnerUserAccountUser
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerPurchaseApplicationsInnerUserAccountUser
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerPurchaseApplicationsInnerUserAccountUser
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerPurchaseApplicationsInnerUserAccountUser
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerPurchaseApplicationsInnerUserAccountUser
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerPurchaseApplicationsInnerUserAccountUser
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerPurchaseApplicationsInnerUserAccountUser
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerPurchaseApplicationsInnerUserAccountUser
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerPurchaseApplicationsInnerUserAccountUser
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerPurchaseApplicationsInnerUserAccountUser
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerPurchaseApplicationsInnerUserAccountUserAccountGroup
 */
export interface GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerPurchaseApplicationsInnerUserAccountUserAccountGroup {
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerPurchaseApplicationsInnerUserAccountUserAccountGroup
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerPurchaseApplicationsInnerUserAccountUserAccountGroup
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerPurchaseApplicationsInnerUserAccountUserAccountGroup
     */
    'sortNum': number;
}
/**
 * 
 * @export
 * @interface GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerPurchaseApplicationsInnerWorkRequestedBy
 */
export interface GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerPurchaseApplicationsInnerWorkRequestedBy {
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerPurchaseApplicationsInnerWorkRequestedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerPurchaseApplicationsInnerWorkRequestedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerRequestHistoryInner
 */
export interface GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerRequestHistoryInner {
    /**
     * 
     * @type {number}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerRequestHistoryInner
     */
    'requestId': number;
    /**
     * 
     * @type {GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerRequestHistoryInnerRequestedBy}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerRequestHistoryInner
     */
    'requestedBy': GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerRequestHistoryInnerRequestedBy;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerRequestHistoryInner
     */
    'requestedAt': string;
}
/**
 * 
 * @export
 * @interface GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerRequestHistoryInnerRequestedBy
 */
export interface GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerRequestHistoryInnerRequestedBy {
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerRequestHistoryInnerRequestedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerRequestHistoryInnerRequestedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerUserAccount
 */
export interface GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerUserAccount {
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerUserAccount
     */
    'userAccountId': string;
    /**
     * 
     * @type {GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerUserAccountUser}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerUserAccount
     */
    'user': GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerUserAccountUser;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerUserAccount
     */
    'cardLabel': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerUserAccount
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerUserAccount
     */
    'organizationName': string;
    /**
     * 
     * @type {GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerUserAccountUserAccountGroup}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerUserAccount
     */
    'userAccountGroup': GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerUserAccountUserAccountGroup | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerUserAccount
     */
    'isOnDemand': boolean;
}
/**
 * 
 * @export
 * @interface GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerUserAccountUser
 */
export interface GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerUserAccountUser {
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerUserAccountUser
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerUserAccountUser
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerUserAccountUser
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerUserAccountUser
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerUserAccountUser
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerUserAccountUser
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerUserAccountUser
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerUserAccountUser
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerUserAccountUser
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerUserAccountUser
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerUserAccountUser
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerUserAccountUserAccountGroup
 */
export interface GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerUserAccountUserAccountGroup {
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerUserAccountUserAccountGroup
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerUserAccountUserAccountGroup
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerUserAccountUserAccountGroup
     */
    'sortNum': number;
}
/**
 * 
 * @export
 * @interface GetCategoryOfThePurchaseApplicationTemplate200ResponseInner
 */
export interface GetCategoryOfThePurchaseApplicationTemplate200ResponseInner {
    /**
     * 
     * @type {GetCategoryOfThePurchaseApplicationTemplate200ResponseInnerCategory}
     * @memberof GetCategoryOfThePurchaseApplicationTemplate200ResponseInner
     */
    'category': GetCategoryOfThePurchaseApplicationTemplate200ResponseInnerCategory;
    /**
     * 
     * @type {GetCategoryOfThePurchaseApplicationTemplate200ResponseInnerCreatedBy}
     * @memberof GetCategoryOfThePurchaseApplicationTemplate200ResponseInner
     */
    'createdBy': GetCategoryOfThePurchaseApplicationTemplate200ResponseInnerCreatedBy;
    /**
     * 
     * @type {GetCategoryOfThePurchaseApplicationTemplate200ResponseInnerPurchaseTemplateCategoryId}
     * @memberof GetCategoryOfThePurchaseApplicationTemplate200ResponseInner
     */
    'purchaseTemplateCategoryId': GetCategoryOfThePurchaseApplicationTemplate200ResponseInnerPurchaseTemplateCategoryId;
    /**
     * 
     * @type {string}
     * @memberof GetCategoryOfThePurchaseApplicationTemplate200ResponseInner
     */
    'submittedAt': string;
    /**
     * 
     * @type {GetCategoryOfThePurchaseApplicationTemplate200ResponseInnerSubmittedBy}
     * @memberof GetCategoryOfThePurchaseApplicationTemplate200ResponseInner
     */
    'submittedBy': GetCategoryOfThePurchaseApplicationTemplate200ResponseInnerSubmittedBy;
    /**
     * 
     * @type {boolean}
     * @memberof GetCategoryOfThePurchaseApplicationTemplate200ResponseInner
     */
    'isUsingCategory': boolean;
}
/**
 * 
 * @export
 * @interface GetCategoryOfThePurchaseApplicationTemplate200ResponseInnerCategory
 */
export interface GetCategoryOfThePurchaseApplicationTemplate200ResponseInnerCategory {
    /**
     * 
     * @type {string}
     * @memberof GetCategoryOfThePurchaseApplicationTemplate200ResponseInnerCategory
     */
    'value': string;
}
/**
 * 
 * @export
 * @interface GetCategoryOfThePurchaseApplicationTemplate200ResponseInnerCreatedBy
 */
export interface GetCategoryOfThePurchaseApplicationTemplate200ResponseInnerCreatedBy {
    /**
     * 
     * @type {string}
     * @memberof GetCategoryOfThePurchaseApplicationTemplate200ResponseInnerCreatedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetCategoryOfThePurchaseApplicationTemplate200ResponseInnerCreatedBy
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetCategoryOfThePurchaseApplicationTemplate200ResponseInnerCreatedBy
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetCategoryOfThePurchaseApplicationTemplate200ResponseInnerCreatedBy
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof GetCategoryOfThePurchaseApplicationTemplate200ResponseInnerCreatedBy
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetCategoryOfThePurchaseApplicationTemplate200ResponseInnerCreatedBy
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCategoryOfThePurchaseApplicationTemplate200ResponseInnerCreatedBy
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCategoryOfThePurchaseApplicationTemplate200ResponseInnerCreatedBy
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCategoryOfThePurchaseApplicationTemplate200ResponseInnerCreatedBy
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCategoryOfThePurchaseApplicationTemplate200ResponseInnerCreatedBy
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetCategoryOfThePurchaseApplicationTemplate200ResponseInnerCreatedBy
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface GetCategoryOfThePurchaseApplicationTemplate200ResponseInnerPurchaseTemplateCategoryId
 */
export interface GetCategoryOfThePurchaseApplicationTemplate200ResponseInnerPurchaseTemplateCategoryId {
    /**
     * 
     * @type {number}
     * @memberof GetCategoryOfThePurchaseApplicationTemplate200ResponseInnerPurchaseTemplateCategoryId
     */
    'value': number;
}
/**
 * 
 * @export
 * @interface GetCategoryOfThePurchaseApplicationTemplate200ResponseInnerSubmittedBy
 */
export interface GetCategoryOfThePurchaseApplicationTemplate200ResponseInnerSubmittedBy {
    /**
     * 
     * @type {string}
     * @memberof GetCategoryOfThePurchaseApplicationTemplate200ResponseInnerSubmittedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetCategoryOfThePurchaseApplicationTemplate200ResponseInnerSubmittedBy
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetCategoryOfThePurchaseApplicationTemplate200ResponseInnerSubmittedBy
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetCategoryOfThePurchaseApplicationTemplate200ResponseInnerSubmittedBy
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof GetCategoryOfThePurchaseApplicationTemplate200ResponseInnerSubmittedBy
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetCategoryOfThePurchaseApplicationTemplate200ResponseInnerSubmittedBy
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCategoryOfThePurchaseApplicationTemplate200ResponseInnerSubmittedBy
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCategoryOfThePurchaseApplicationTemplate200ResponseInnerSubmittedBy
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCategoryOfThePurchaseApplicationTemplate200ResponseInnerSubmittedBy
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCategoryOfThePurchaseApplicationTemplate200ResponseInnerSubmittedBy
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetCategoryOfThePurchaseApplicationTemplate200ResponseInnerSubmittedBy
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface GetComment200ResponseInner
 */
export interface GetComment200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetComment200ResponseInner
     */
    'cardTransactionCommentId': string;
    /**
     * 
     * @type {string}
     * @memberof GetComment200ResponseInner
     */
    'visaTransactionReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetComment200ResponseInner
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetComment200ResponseInner
     */
    'comment': string;
    /**
     * 
     * @type {GetComment200ResponseInnerCreatedBy}
     * @memberof GetComment200ResponseInner
     */
    'createdBy': GetComment200ResponseInnerCreatedBy;
}
/**
 * 
 * @export
 * @interface GetComment200ResponseInnerCreatedBy
 */
export interface GetComment200ResponseInnerCreatedBy {
    /**
     * 
     * @type {string}
     * @memberof GetComment200ResponseInnerCreatedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetComment200ResponseInnerCreatedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetCommentTemplates200ResponseInner
 */
export interface GetCommentTemplates200ResponseInner {
    /**
     * 
     * @type {number}
     * @memberof GetCommentTemplates200ResponseInner
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof GetCommentTemplates200ResponseInner
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetCommentTemplates200ResponseInner
     */
    'template': string;
    /**
     * 
     * @type {Array<GetCommentTemplates200ResponseInnerUserAccountsSetAsDefaultInner>}
     * @memberof GetCommentTemplates200ResponseInner
     */
    'userAccountsSetAsDefault': Array<GetCommentTemplates200ResponseInnerUserAccountsSetAsDefaultInner>;
}
/**
 * 
 * @export
 * @interface GetCommentTemplates200ResponseInnerUserAccountsSetAsDefaultInner
 */
export interface GetCommentTemplates200ResponseInnerUserAccountsSetAsDefaultInner {
    /**
     * 
     * @type {string}
     * @memberof GetCommentTemplates200ResponseInnerUserAccountsSetAsDefaultInner
     */
    'cardLabel': string;
    /**
     * 
     * @type {string}
     * @memberof GetCommentTemplates200ResponseInnerUserAccountsSetAsDefaultInner
     */
    'userAccountId': string;
}
/**
 * 
 * @export
 * @interface GetCommentTemplatesCommentTemplateId200Response
 */
export interface GetCommentTemplatesCommentTemplateId200Response {
    /**
     * 
     * @type {number}
     * @memberof GetCommentTemplatesCommentTemplateId200Response
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof GetCommentTemplatesCommentTemplateId200Response
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetCommentTemplatesCommentTemplateId200Response
     */
    'template': string;
    /**
     * 
     * @type {Array<GetCommentTemplatesCommentTemplateId200ResponseUserAccountsSetAsDefaultInner>}
     * @memberof GetCommentTemplatesCommentTemplateId200Response
     */
    'userAccountsSetAsDefault': Array<GetCommentTemplatesCommentTemplateId200ResponseUserAccountsSetAsDefaultInner>;
}
/**
 * 
 * @export
 * @interface GetCommentTemplatesCommentTemplateId200ResponseUserAccountsSetAsDefaultInner
 */
export interface GetCommentTemplatesCommentTemplateId200ResponseUserAccountsSetAsDefaultInner {
    /**
     * 
     * @type {string}
     * @memberof GetCommentTemplatesCommentTemplateId200ResponseUserAccountsSetAsDefaultInner
     */
    'cardLabel': string;
    /**
     * 
     * @type {string}
     * @memberof GetCommentTemplatesCommentTemplateId200ResponseUserAccountsSetAsDefaultInner
     */
    'userAccountId': string;
}
/**
 * 
 * @export
 * @interface GetCurrentCardAssociatedWithTheUserAccount200Response
 */
export interface GetCurrentCardAssociatedWithTheUserAccount200Response {
    /**
     * 
     * @type {string}
     * @memberof GetCurrentCardAssociatedWithTheUserAccount200Response
     */
    'cardId': string;
    /**
     * 
     * @type {string}
     * @memberof GetCurrentCardAssociatedWithTheUserAccount200Response
     */
    'cardLabel': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetCurrentCardAssociatedWithTheUserAccount200Response
     */
    'isActivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCurrentCardAssociatedWithTheUserAccount200Response
     */
    'isDeactivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCurrentCardAssociatedWithTheUserAccount200Response
     */
    'isLocked': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCurrentCardAssociatedWithTheUserAccount200Response
     */
    'isSuspended': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCurrentCardAssociatedWithTheUserAccount200Response
     */
    'isFrozen': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCurrentCardAssociatedWithTheUserAccount200Response
     */
    'isVirtualCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCurrentCardAssociatedWithTheUserAccount200Response
     */
    'isCreditCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCurrentCardAssociatedWithTheUserAccount200Response
     */
    'isOnDemand': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCurrentCardAssociatedWithTheUserAccount200Response
     */
    'isMetalCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCurrentCardAssociatedWithTheUserAccount200Response
     */
    'isPhysicalStorePaymentDisabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetCurrentCardAssociatedWithTheUserAccount200Response
     */
    'panLastFourDigits': string;
    /**
     * 
     * @type {string}
     * @memberof GetCurrentCardAssociatedWithTheUserAccount200Response
     */
    'userAccountId': string;
    /**
     * 
     * @type {number}
     * @memberof GetCurrentCardAssociatedWithTheUserAccount200Response
     */
    'transactionUpperLimit': number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetCurrentCardAssociatedWithTheUserAccount200Response
     */
    'availableCurrencies': Array<GetCurrentCardAssociatedWithTheUserAccount200ResponseAvailableCurrenciesEnum>;
    /**
     * 
     * @type {Array<GetCurrentCardAssociatedWithTheUserAccount200ResponseAvailableMerchantCategoriesInner>}
     * @memberof GetCurrentCardAssociatedWithTheUserAccount200Response
     */
    'availableMerchantCategories': Array<GetCurrentCardAssociatedWithTheUserAccount200ResponseAvailableMerchantCategoriesInner> | null;
    /**
     * 
     * @type {GetCurrentCardAssociatedWithTheUserAccount200ResponseUser}
     * @memberof GetCurrentCardAssociatedWithTheUserAccount200Response
     */
    'user': GetCurrentCardAssociatedWithTheUserAccount200ResponseUser;
    /**
     * 
     * @type {GetCurrentCardAssociatedWithTheUserAccount200ResponseUserAccountGroup}
     * @memberof GetCurrentCardAssociatedWithTheUserAccount200Response
     */
    'userAccountGroup'?: GetCurrentCardAssociatedWithTheUserAccount200ResponseUserAccountGroup | null;
    /**
     * 
     * @type {number}
     * @memberof GetCurrentCardAssociatedWithTheUserAccount200Response
     */
    'monthlyTotalUsage': number;
    /**
     * 
     * @type {number}
     * @memberof GetCurrentCardAssociatedWithTheUserAccount200Response
     */
    'monthlyUsageLimit': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetCurrentCardAssociatedWithTheUserAccount200Response
     */
    'dailyTotalUsage': number;
    /**
     * 
     * @type {number}
     * @memberof GetCurrentCardAssociatedWithTheUserAccount200Response
     */
    'dailyUsageLimit': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetCurrentCardAssociatedWithTheUserAccount200Response
     */
    'totalUsageAmount': number;
    /**
     * 
     * @type {number}
     * @memberof GetCurrentCardAssociatedWithTheUserAccount200Response
     */
    'totalUsageAmountLimit': number | null;
    /**
     * 
     * @type {string}
     * @memberof GetCurrentCardAssociatedWithTheUserAccount200Response
     */
    'expiredDate': string | null;
}

export const GetCurrentCardAssociatedWithTheUserAccount200ResponseAvailableCurrenciesEnum = {
    jpy: 'JPY',
    usd: 'USD',
    gbp: 'GBP',
    eur: 'EUR',
    sgd: 'SGD',
    aud: 'AUD',
    cny: 'CNY',
    hkd: 'HKD',
    idr: 'IDR',
    krw: 'KRW',
    nzd: 'NZD',
    php: 'PHP',
    rub: 'RUB',
    vnd: 'VND',
    inr: 'INR',
    thb: 'THB',
    lak: 'LAK',
    myr: 'MYR',
    twd: 'TWD',
    chf: 'CHF',
    cad: 'CAD',
    mxn: 'MXN',
    nok: 'NOK',
    huf: 'HUF',
    hrk: 'HRK',
    czk: 'CZK',
    dkk: 'DKK',
    isk: 'ISK',
    mdl: 'MDL',
    sek: 'SEK',
    mkd: 'MKD',
    rsd: 'RSD',
    ron: 'RON',
    bgn: 'BGN',
    bam: 'BAM',
    pln: 'PLN',
    mad: 'MAD',
    zar: 'ZAR',
    rwf: 'RWF',
    kes: 'KES',
    ngn: 'NGN',
    aed: 'AED',
    sar: 'SAR',
    egp: 'EGP',
    qar: 'QAR',
    omr: 'OMR',
    ils: 'ILS',
    try: 'TRY',
    kzt: 'KZT',
    cop: 'COP',
    gtq: 'GTQ'
} as const;

export type GetCurrentCardAssociatedWithTheUserAccount200ResponseAvailableCurrenciesEnum = typeof GetCurrentCardAssociatedWithTheUserAccount200ResponseAvailableCurrenciesEnum[keyof typeof GetCurrentCardAssociatedWithTheUserAccount200ResponseAvailableCurrenciesEnum];

/**
 * 
 * @export
 * @interface GetCurrentCardAssociatedWithTheUserAccount200ResponseAvailableMerchantCategoriesInner
 */
export interface GetCurrentCardAssociatedWithTheUserAccount200ResponseAvailableMerchantCategoriesInner {
    /**
     * 
     * @type {string}
     * @memberof GetCurrentCardAssociatedWithTheUserAccount200ResponseAvailableMerchantCategoriesInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetCurrentCardAssociatedWithTheUserAccount200ResponseAvailableMerchantCategoriesInner
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetCurrentCardAssociatedWithTheUserAccount200ResponseAvailableMerchantCategoriesInner
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof GetCurrentCardAssociatedWithTheUserAccount200ResponseAvailableMerchantCategoriesInner
     */
    'logoUrl': string;
}
/**
 * 
 * @export
 * @interface GetCurrentCardAssociatedWithTheUserAccount200ResponseUser
 */
export interface GetCurrentCardAssociatedWithTheUserAccount200ResponseUser {
    /**
     * 
     * @type {string}
     * @memberof GetCurrentCardAssociatedWithTheUserAccount200ResponseUser
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetCurrentCardAssociatedWithTheUserAccount200ResponseUser
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetCurrentCardAssociatedWithTheUserAccount200ResponseUser
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetCurrentCardAssociatedWithTheUserAccount200ResponseUser
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof GetCurrentCardAssociatedWithTheUserAccount200ResponseUser
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetCurrentCardAssociatedWithTheUserAccount200ResponseUser
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCurrentCardAssociatedWithTheUserAccount200ResponseUser
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCurrentCardAssociatedWithTheUserAccount200ResponseUser
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCurrentCardAssociatedWithTheUserAccount200ResponseUser
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCurrentCardAssociatedWithTheUserAccount200ResponseUser
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetCurrentCardAssociatedWithTheUserAccount200ResponseUser
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface GetCurrentCardAssociatedWithTheUserAccount200ResponseUserAccountGroup
 */
export interface GetCurrentCardAssociatedWithTheUserAccount200ResponseUserAccountGroup {
    /**
     * 
     * @type {string}
     * @memberof GetCurrentCardAssociatedWithTheUserAccount200ResponseUserAccountGroup
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetCurrentCardAssociatedWithTheUserAccount200ResponseUserAccountGroup
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof GetCurrentCardAssociatedWithTheUserAccount200ResponseUserAccountGroup
     */
    'sortNum': number;
}
/**
 * 
 * @export
 * @interface GetDealsTotalAmountRequest
 */
export interface GetDealsTotalAmountRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof GetDealsTotalAmountRequest
     */
    'dealStatusList'?: Array<GetDealsTotalAmountRequestDealStatusListEnum>;
    /**
     * 
     * @type {string}
     * @memberof GetDealsTotalAmountRequest
     */
    'userAccountId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetDealsTotalAmountRequest
     */
    'userAccountGroupId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetDealsTotalAmountRequest
     */
    'dealKeyword'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetDealsTotalAmountRequest
     */
    'dealIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof GetDealsTotalAmountRequest
     */
    'yearMonth'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetDealsTotalAmountRequest
     */
    'startDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetDealsTotalAmountRequest
     */
    'endDate'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GetDealsTotalAmountRequest
     */
    'amountLowerLimit'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetDealsTotalAmountRequest
     */
    'amountUpperLimit'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof GetDealsTotalAmountRequest
     */
    'qualifiedEvidence'?: GetDealsTotalAmountRequestQualifiedEvidenceEnum;
    /**
     * 
     * @type {number}
     * @memberof GetDealsTotalAmountRequest
     */
    'accountItemId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetDealsTotalAmountRequest
     */
    'taxCode'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetDealsTotalAmountRequest
     */
    'itemId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetDealsTotalAmountRequest
     */
    'sectionId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetDealsTotalAmountRequest
     */
    'tagId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetDealsTotalAmountRequest
     */
    'partnerId'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetDealsTotalAmountRequest
     */
    'canSync'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetDealsTotalAmountRequest
     */
    'isInvalidTaxCode'?: boolean | null;
}

export const GetDealsTotalAmountRequestDealStatusListEnum = {
    notEntered: 'NOT_ENTERED',
    automaticJournalized: 'AUTOMATIC_JOURNALIZED',
    automaticIntegrated: 'AUTOMATIC_INTEGRATED',
    entering: 'ENTERING',
    journalized: 'JOURNALIZED',
    changedAfterJournalization: 'CHANGED_AFTER_JOURNALIZATION',
    integrated: 'INTEGRATED',
    changedAfterIntegration: 'CHANGED_AFTER_INTEGRATION',
    ignored: 'IGNORED',
    readyAutomaticIntegration: 'READY_AUTOMATIC_INTEGRATION'
} as const;

export type GetDealsTotalAmountRequestDealStatusListEnum = typeof GetDealsTotalAmountRequestDealStatusListEnum[keyof typeof GetDealsTotalAmountRequestDealStatusListEnum];
export const GetDealsTotalAmountRequestQualifiedEvidenceEnum = {
    allNotQualified: 'ALL_NOT_QUALIFIED',
    containQualified: 'CONTAIN_QUALIFIED'
} as const;

export type GetDealsTotalAmountRequestQualifiedEvidenceEnum = typeof GetDealsTotalAmountRequestQualifiedEvidenceEnum[keyof typeof GetDealsTotalAmountRequestQualifiedEvidenceEnum];

/**
 * 
 * @export
 * @interface GetDefaultCommentTemplate200Response
 */
export interface GetDefaultCommentTemplate200Response {
    /**
     * 
     * @type {number}
     * @memberof GetDefaultCommentTemplate200Response
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof GetDefaultCommentTemplate200Response
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetDefaultCommentTemplate200Response
     */
    'template': string;
}
/**
 * 
 * @export
 * @interface GetDepositBankAccount200Response
 */
export interface GetDepositBankAccount200Response {
    /**
     * 
     * @type {string}
     * @memberof GetDepositBankAccount200Response
     */
    'bankCode': string;
    /**
     * 
     * @type {string}
     * @memberof GetDepositBankAccount200Response
     */
    'bankName': string;
    /**
     * 
     * @type {string}
     * @memberof GetDepositBankAccount200Response
     */
    'branchCode': string;
    /**
     * 
     * @type {string}
     * @memberof GetDepositBankAccount200Response
     */
    'branchName': string;
    /**
     * 
     * @type {string}
     * @memberof GetDepositBankAccount200Response
     */
    'accountNumber': string;
    /**
     * 
     * @type {string}
     * @memberof GetDepositBankAccount200Response
     */
    'accountHolder': string;
    /**
     * 
     * @type {string}
     * @memberof GetDepositBankAccount200Response
     */
    'accountType': GetDepositBankAccount200ResponseAccountTypeEnum;
}

export const GetDepositBankAccount200ResponseAccountTypeEnum = {
    savingsAccount: 'SAVINGS_ACCOUNT',
    currentAccount: 'CURRENT_ACCOUNT',
    depositAccount: 'DEPOSIT_ACCOUNT',
    otherAccount: 'OTHER_ACCOUNT'
} as const;

export type GetDepositBankAccount200ResponseAccountTypeEnum = typeof GetDepositBankAccount200ResponseAccountTypeEnum[keyof typeof GetDepositBankAccount200ResponseAccountTypeEnum];

/**
 * 
 * @export
 * @interface GetDepositRestrictionForOrganization200Response
 */
export interface GetDepositRestrictionForOrganization200Response {
    /**
     * ID番号
     * @type {string}
     * @memberof GetDepositRestrictionForOrganization200Response
     */
    'id': string;
    /**
     * 企業ID
     * @type {string}
     * @memberof GetDepositRestrictionForOrganization200Response
     */
    'organizationId': string;
    /**
     * 入金禁止フラグ
     * @type {boolean}
     * @memberof GetDepositRestrictionForOrganization200Response
     */
    'depositBlocked': boolean;
    /**
     * 入金制限開始日時
     * @type {string}
     * @memberof GetDepositRestrictionForOrganization200Response
     */
    'startAt': string;
    /**
     * 入金制限終了日時
     * @type {string}
     * @memberof GetDepositRestrictionForOrganization200Response
     */
    'endAt': string;
}
/**
 * 
 * @export
 * @interface GetDepositRestrictionListForOrganization200ResponseInner
 */
export interface GetDepositRestrictionListForOrganization200ResponseInner {
    /**
     * ID番号
     * @type {string}
     * @memberof GetDepositRestrictionListForOrganization200ResponseInner
     */
    'id': string;
    /**
     * 企業ID
     * @type {string}
     * @memberof GetDepositRestrictionListForOrganization200ResponseInner
     */
    'organizationId': string;
    /**
     * 入金禁止フラグ
     * @type {boolean}
     * @memberof GetDepositRestrictionListForOrganization200ResponseInner
     */
    'depositBlocked': boolean;
    /**
     * 入金制限開始日時
     * @type {string}
     * @memberof GetDepositRestrictionListForOrganization200ResponseInner
     */
    'startAt': string;
    /**
     * 入金制限終了日時
     * @type {string}
     * @memberof GetDepositRestrictionListForOrganization200ResponseInner
     */
    'endAt': string;
}
/**
 * 
 * @export
 * @interface GetDraftPaymentRequest200Response
 */
export interface GetDraftPaymentRequest200Response {
    /**
     * 
     * @type {string}
     * @memberof GetDraftPaymentRequest200Response
     */
    'id': string;
    /**
     * 
     * @type {GetDraftPaymentRequest200ResponseSupplier}
     * @memberof GetDraftPaymentRequest200Response
     */
    'supplier': GetDraftPaymentRequest200ResponseSupplier | null;
    /**
     * 
     * @type {number}
     * @memberof GetDraftPaymentRequest200Response
     */
    'totalAmount': number | null;
    /**
     * 
     * @type {string}
     * @memberof GetDraftPaymentRequest200Response
     */
    'dueDate': string | null;
    /**
     * 
     * @type {GetDraftPaymentRequest200ResponseRequestor}
     * @memberof GetDraftPaymentRequest200Response
     */
    'requestor': GetDraftPaymentRequest200ResponseRequestor;
    /**
     * requestorName is the name of the requesting user at the time this PaymentRequest was requested. The free word search targets the name of requesting user, but it is the requestorName that is targeted, not the name of the user at the time of the search. Use requestor.name if you want to know what is the name at present of the user.
     * @type {string}
     * @memberof GetDraftPaymentRequest200Response
     */
    'requestorName': string;
    /**
     * 
     * @type {string}
     * @memberof GetDraftPaymentRequest200Response
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetDraftPaymentRequest200Response
     */
    'invoiceEvidenceId': string;
    /**
     * 
     * @type {Array<GetDraftPaymentRequest200ResponseEvidencesInner>}
     * @memberof GetDraftPaymentRequest200Response
     */
    'evidences': Array<GetDraftPaymentRequest200ResponseEvidencesInner>;
}
/**
 * 
 * @export
 * @interface GetDraftPaymentRequest200ResponseEvidencesInner
 */
export interface GetDraftPaymentRequest200ResponseEvidencesInner {
    /**
     * 
     * @type {string}
     * @memberof GetDraftPaymentRequest200ResponseEvidencesInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetDraftPaymentRequest200ResponseEvidencesInner
     */
    'userAccountId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetDraftPaymentRequest200ResponseEvidencesInner
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetDraftPaymentRequest200ResponseEvidencesInner
     */
    'paymentType': GetDraftPaymentRequest200ResponseEvidencesInnerPaymentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetDraftPaymentRequest200ResponseEvidencesInner
     */
    'electronicMethod': GetDraftPaymentRequest200ResponseEvidencesInnerElectronicMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof GetDraftPaymentRequest200ResponseEvidencesInner
     */
    'documentSize': GetDraftPaymentRequest200ResponseEvidencesInnerDocumentSizeEnum;
    /**
     * 
     * @type {number}
     * @memberof GetDraftPaymentRequest200ResponseEvidencesInner
     */
    'detectedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetDraftPaymentRequest200ResponseEvidencesInner
     */
    'calculatedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetDraftPaymentRequest200ResponseEvidencesInner
     */
    'colorGradation': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetDraftPaymentRequest200ResponseEvidencesInner
     */
    'verticalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetDraftPaymentRequest200ResponseEvidencesInner
     */
    'horizontalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetDraftPaymentRequest200ResponseEvidencesInner
     */
    'heightMillis': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetDraftPaymentRequest200ResponseEvidencesInner
     */
    'widthMillis': number | null;
    /**
     * 
     * @type {string}
     * @memberof GetDraftPaymentRequest200ResponseEvidencesInner
     */
    'legalValidity': GetDraftPaymentRequest200ResponseEvidencesInnerLegalValidityEnum;
    /**
     * 
     * @type {string}
     * @memberof GetDraftPaymentRequest200ResponseEvidencesInner
     */
    'note': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetDraftPaymentRequest200ResponseEvidencesInner
     */
    'irrelevantToLedger': boolean;
    /**
     * 
     * @type {GetDraftPaymentRequest200ResponseEvidencesInnerFile}
     * @memberof GetDraftPaymentRequest200ResponseEvidencesInner
     */
    'file': GetDraftPaymentRequest200ResponseEvidencesInnerFile;
    /**
     * 
     * @type {GetDraftPaymentRequest200ResponseEvidencesInnerInvoiceIssuer}
     * @memberof GetDraftPaymentRequest200ResponseEvidencesInner
     */
    'invoiceIssuer': GetDraftPaymentRequest200ResponseEvidencesInnerInvoiceIssuer | null;
    /**
     * 
     * @type {GetDraftPaymentRequest200ResponseEvidencesInnerErrors}
     * @memberof GetDraftPaymentRequest200ResponseEvidencesInner
     */
    'errors': GetDraftPaymentRequest200ResponseEvidencesInnerErrors;
    /**
     * 
     * @type {GetDraftPaymentRequest200ResponseEvidencesInnerWarnings}
     * @memberof GetDraftPaymentRequest200ResponseEvidencesInner
     */
    'warnings': GetDraftPaymentRequest200ResponseEvidencesInnerWarnings;
    /**
     * 
     * @type {GetDraftPaymentRequest200ResponseEvidencesInnerUpdatedBy}
     * @memberof GetDraftPaymentRequest200ResponseEvidencesInner
     */
    'updatedBy': GetDraftPaymentRequest200ResponseEvidencesInnerUpdatedBy;
    /**
     * 
     * @type {string}
     * @memberof GetDraftPaymentRequest200ResponseEvidencesInner
     */
    'updatedAt': string;
    /**
     * 
     * @type {GetDraftPaymentRequest200ResponseEvidencesInnerUploadedBy}
     * @memberof GetDraftPaymentRequest200ResponseEvidencesInner
     */
    'uploadedBy': GetDraftPaymentRequest200ResponseEvidencesInnerUploadedBy;
    /**
     * 
     * @type {string}
     * @memberof GetDraftPaymentRequest200ResponseEvidencesInner
     */
    'uploadedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetDraftPaymentRequest200ResponseEvidencesInner
     */
    'needsMigration'?: boolean;
}

export const GetDraftPaymentRequest200ResponseEvidencesInnerPaymentTypeEnum = {
    cardTransaction: 'CARD_TRANSACTION',
    paymentRequest: 'PAYMENT_REQUEST'
} as const;

export type GetDraftPaymentRequest200ResponseEvidencesInnerPaymentTypeEnum = typeof GetDraftPaymentRequest200ResponseEvidencesInnerPaymentTypeEnum[keyof typeof GetDraftPaymentRequest200ResponseEvidencesInnerPaymentTypeEnum];
export const GetDraftPaymentRequest200ResponseEvidencesInnerElectronicMethodEnum = {
    fullElectronic: 'FULL_ELECTRONIC',
    originallyPaper: 'ORIGINALLY_PAPER',
    unknown: 'UNKNOWN'
} as const;

export type GetDraftPaymentRequest200ResponseEvidencesInnerElectronicMethodEnum = typeof GetDraftPaymentRequest200ResponseEvidencesInnerElectronicMethodEnum[keyof typeof GetDraftPaymentRequest200ResponseEvidencesInnerElectronicMethodEnum];
export const GetDraftPaymentRequest200ResponseEvidencesInnerDocumentSizeEnum = {
    overA4: 'OVER_A4',
    a4OrSmaller: 'A4_OR_SMALLER',
    unknown: 'UNKNOWN'
} as const;

export type GetDraftPaymentRequest200ResponseEvidencesInnerDocumentSizeEnum = typeof GetDraftPaymentRequest200ResponseEvidencesInnerDocumentSizeEnum[keyof typeof GetDraftPaymentRequest200ResponseEvidencesInnerDocumentSizeEnum];
export const GetDraftPaymentRequest200ResponseEvidencesInnerLegalValidityEnum = {
    valid: 'VALID',
    invalid: 'INVALID',
    inputRequired: 'INPUT_REQUIRED',
    outOfTarget: 'OUT_OF_TARGET'
} as const;

export type GetDraftPaymentRequest200ResponseEvidencesInnerLegalValidityEnum = typeof GetDraftPaymentRequest200ResponseEvidencesInnerLegalValidityEnum[keyof typeof GetDraftPaymentRequest200ResponseEvidencesInnerLegalValidityEnum];

/**
 * 
 * @export
 * @interface GetDraftPaymentRequest200ResponseEvidencesInnerErrors
 */
export interface GetDraftPaymentRequest200ResponseEvidencesInnerErrors {
    /**
     * 
     * @type {string}
     * @memberof GetDraftPaymentRequest200ResponseEvidencesInnerErrors
     */
    'detectedDpi'?: GetDraftPaymentRequest200ResponseEvidencesInnerErrorsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetDraftPaymentRequest200ResponseEvidencesInnerErrors
     */
    'calculatedDpi'?: GetDraftPaymentRequest200ResponseEvidencesInnerErrorsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetDraftPaymentRequest200ResponseEvidencesInnerErrors
     */
    'colorGradation'?: GetDraftPaymentRequest200ResponseEvidencesInnerErrorsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof GetDraftPaymentRequest200ResponseEvidencesInnerErrors
     */
    'heightMillis'?: GetDraftPaymentRequest200ResponseEvidencesInnerErrorsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof GetDraftPaymentRequest200ResponseEvidencesInnerErrors
     */
    'widthMillis'?: GetDraftPaymentRequest200ResponseEvidencesInnerErrorsWidthMillisEnum;
}

export const GetDraftPaymentRequest200ResponseEvidencesInnerErrorsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetDraftPaymentRequest200ResponseEvidencesInnerErrorsDetectedDpiEnum = typeof GetDraftPaymentRequest200ResponseEvidencesInnerErrorsDetectedDpiEnum[keyof typeof GetDraftPaymentRequest200ResponseEvidencesInnerErrorsDetectedDpiEnum];
export const GetDraftPaymentRequest200ResponseEvidencesInnerErrorsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetDraftPaymentRequest200ResponseEvidencesInnerErrorsCalculatedDpiEnum = typeof GetDraftPaymentRequest200ResponseEvidencesInnerErrorsCalculatedDpiEnum[keyof typeof GetDraftPaymentRequest200ResponseEvidencesInnerErrorsCalculatedDpiEnum];
export const GetDraftPaymentRequest200ResponseEvidencesInnerErrorsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type GetDraftPaymentRequest200ResponseEvidencesInnerErrorsColorGradationEnum = typeof GetDraftPaymentRequest200ResponseEvidencesInnerErrorsColorGradationEnum[keyof typeof GetDraftPaymentRequest200ResponseEvidencesInnerErrorsColorGradationEnum];
export const GetDraftPaymentRequest200ResponseEvidencesInnerErrorsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetDraftPaymentRequest200ResponseEvidencesInnerErrorsHeightMillisEnum = typeof GetDraftPaymentRequest200ResponseEvidencesInnerErrorsHeightMillisEnum[keyof typeof GetDraftPaymentRequest200ResponseEvidencesInnerErrorsHeightMillisEnum];
export const GetDraftPaymentRequest200ResponseEvidencesInnerErrorsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetDraftPaymentRequest200ResponseEvidencesInnerErrorsWidthMillisEnum = typeof GetDraftPaymentRequest200ResponseEvidencesInnerErrorsWidthMillisEnum[keyof typeof GetDraftPaymentRequest200ResponseEvidencesInnerErrorsWidthMillisEnum];

/**
 * 
 * @export
 * @interface GetDraftPaymentRequest200ResponseEvidencesInnerFile
 */
export interface GetDraftPaymentRequest200ResponseEvidencesInnerFile {
    /**
     * 
     * @type {string}
     * @memberof GetDraftPaymentRequest200ResponseEvidencesInnerFile
     */
    'id': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetDraftPaymentRequest200ResponseEvidencesInnerFile
     */
    'name': string;
    /**
     * A URL with expiration date-time accessible from the front-end. This is not fully supported yet. In responses from certain endpoints, the url is set to null.
     * @type {string}
     * @memberof GetDraftPaymentRequest200ResponseEvidencesInnerFile
     */
    'url': string | null;
}
/**
 * Set null if it\'s evidence not analyzed using invoicing-system-compliance feature. Also set null if invoicing-system-compliance feature has been made not available for the organization by the feature-flag.
 * @export
 * @interface GetDraftPaymentRequest200ResponseEvidencesInnerInvoiceIssuer
 */
export interface GetDraftPaymentRequest200ResponseEvidencesInnerInvoiceIssuer {
    /**
     * 
     * @type {string}
     * @memberof GetDraftPaymentRequest200ResponseEvidencesInnerInvoiceIssuer
     */
    'name': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetDraftPaymentRequest200ResponseEvidencesInnerInvoiceIssuer
     */
    'registrationNumber': string | null;
    /**
     * isQualified retains the result of querying the 国税庁API to see if registrationNumber is qualified, as is.
     * @type {boolean}
     * @memberof GetDraftPaymentRequest200ResponseEvidencesInnerInvoiceIssuer
     */
    'isQualified': boolean;
    /**
     * AsQualified indicates whether this issuer should be treated as a qualified invoice issuer within the user\'s system, even if the RegistrationNumber is not confirmed as qualified in the National Tax Agency\'s business registration system.
     * @type {boolean}
     * @memberof GetDraftPaymentRequest200ResponseEvidencesInnerInvoiceIssuer
     */
    'asQualified': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetDraftPaymentRequest200ResponseEvidencesInnerInvoiceIssuer
     */
    'partnerId': string | null;
}
/**
 * 
 * @export
 * @interface GetDraftPaymentRequest200ResponseEvidencesInnerUpdatedBy
 */
export interface GetDraftPaymentRequest200ResponseEvidencesInnerUpdatedBy {
    /**
     * 
     * @type {string}
     * @memberof GetDraftPaymentRequest200ResponseEvidencesInnerUpdatedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetDraftPaymentRequest200ResponseEvidencesInnerUpdatedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetDraftPaymentRequest200ResponseEvidencesInnerUploadedBy
 */
export interface GetDraftPaymentRequest200ResponseEvidencesInnerUploadedBy {
    /**
     * 
     * @type {string}
     * @memberof GetDraftPaymentRequest200ResponseEvidencesInnerUploadedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetDraftPaymentRequest200ResponseEvidencesInnerUploadedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetDraftPaymentRequest200ResponseEvidencesInnerWarnings
 */
export interface GetDraftPaymentRequest200ResponseEvidencesInnerWarnings {
    /**
     * 
     * @type {string}
     * @memberof GetDraftPaymentRequest200ResponseEvidencesInnerWarnings
     */
    'detectedDpi'?: GetDraftPaymentRequest200ResponseEvidencesInnerWarningsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetDraftPaymentRequest200ResponseEvidencesInnerWarnings
     */
    'calculatedDpi'?: GetDraftPaymentRequest200ResponseEvidencesInnerWarningsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetDraftPaymentRequest200ResponseEvidencesInnerWarnings
     */
    'colorGradation'?: GetDraftPaymentRequest200ResponseEvidencesInnerWarningsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof GetDraftPaymentRequest200ResponseEvidencesInnerWarnings
     */
    'heightMillis'?: GetDraftPaymentRequest200ResponseEvidencesInnerWarningsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof GetDraftPaymentRequest200ResponseEvidencesInnerWarnings
     */
    'widthMillis'?: GetDraftPaymentRequest200ResponseEvidencesInnerWarningsWidthMillisEnum;
}

export const GetDraftPaymentRequest200ResponseEvidencesInnerWarningsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetDraftPaymentRequest200ResponseEvidencesInnerWarningsDetectedDpiEnum = typeof GetDraftPaymentRequest200ResponseEvidencesInnerWarningsDetectedDpiEnum[keyof typeof GetDraftPaymentRequest200ResponseEvidencesInnerWarningsDetectedDpiEnum];
export const GetDraftPaymentRequest200ResponseEvidencesInnerWarningsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetDraftPaymentRequest200ResponseEvidencesInnerWarningsCalculatedDpiEnum = typeof GetDraftPaymentRequest200ResponseEvidencesInnerWarningsCalculatedDpiEnum[keyof typeof GetDraftPaymentRequest200ResponseEvidencesInnerWarningsCalculatedDpiEnum];
export const GetDraftPaymentRequest200ResponseEvidencesInnerWarningsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type GetDraftPaymentRequest200ResponseEvidencesInnerWarningsColorGradationEnum = typeof GetDraftPaymentRequest200ResponseEvidencesInnerWarningsColorGradationEnum[keyof typeof GetDraftPaymentRequest200ResponseEvidencesInnerWarningsColorGradationEnum];
export const GetDraftPaymentRequest200ResponseEvidencesInnerWarningsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetDraftPaymentRequest200ResponseEvidencesInnerWarningsHeightMillisEnum = typeof GetDraftPaymentRequest200ResponseEvidencesInnerWarningsHeightMillisEnum[keyof typeof GetDraftPaymentRequest200ResponseEvidencesInnerWarningsHeightMillisEnum];
export const GetDraftPaymentRequest200ResponseEvidencesInnerWarningsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetDraftPaymentRequest200ResponseEvidencesInnerWarningsWidthMillisEnum = typeof GetDraftPaymentRequest200ResponseEvidencesInnerWarningsWidthMillisEnum[keyof typeof GetDraftPaymentRequest200ResponseEvidencesInnerWarningsWidthMillisEnum];

/**
 * 
 * @export
 * @interface GetDraftPaymentRequest200ResponseRequestor
 */
export interface GetDraftPaymentRequest200ResponseRequestor {
    /**
     * 
     * @type {string}
     * @memberof GetDraftPaymentRequest200ResponseRequestor
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetDraftPaymentRequest200ResponseRequestor
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetDraftPaymentRequest200ResponseSupplier
 */
export interface GetDraftPaymentRequest200ResponseSupplier {
    /**
     * 
     * @type {string}
     * @memberof GetDraftPaymentRequest200ResponseSupplier
     */
    'partnerId': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetDraftPaymentRequest200ResponseSupplier
     */
    'name': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetDraftPaymentRequest200ResponseSupplier
     */
    'bankNumber': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetDraftPaymentRequest200ResponseSupplier
     */
    'bankName': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetDraftPaymentRequest200ResponseSupplier
     */
    'branchNumber': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetDraftPaymentRequest200ResponseSupplier
     */
    'branchName': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetDraftPaymentRequest200ResponseSupplier
     */
    'accountType': GetDraftPaymentRequest200ResponseSupplierAccountTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetDraftPaymentRequest200ResponseSupplier
     */
    'accountNumber': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetDraftPaymentRequest200ResponseSupplier
     */
    'companyCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetDraftPaymentRequest200ResponseSupplier
     */
    'companyName': string | null;
}

export const GetDraftPaymentRequest200ResponseSupplierAccountTypeEnum = {
    savingsAccount: 'SAVINGS_ACCOUNT',
    currentAccount: 'CURRENT_ACCOUNT',
    thriftAccount: 'THRIFT_ACCOUNT',
    other: 'OTHER'
} as const;

export type GetDraftPaymentRequest200ResponseSupplierAccountTypeEnum = typeof GetDraftPaymentRequest200ResponseSupplierAccountTypeEnum[keyof typeof GetDraftPaymentRequest200ResponseSupplierAccountTypeEnum];

/**
 * 
 * @export
 * @interface GetDraftPaymentRequestsOnlyCreatedOwn200ResponseInner
 */
export interface GetDraftPaymentRequestsOnlyCreatedOwn200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetDraftPaymentRequestsOnlyCreatedOwn200ResponseInner
     */
    'id': string;
    /**
     * 
     * @type {GetDraftPaymentRequestsOnlyCreatedOwn200ResponseInnerSupplier}
     * @memberof GetDraftPaymentRequestsOnlyCreatedOwn200ResponseInner
     */
    'supplier': GetDraftPaymentRequestsOnlyCreatedOwn200ResponseInnerSupplier | null;
    /**
     * 
     * @type {number}
     * @memberof GetDraftPaymentRequestsOnlyCreatedOwn200ResponseInner
     */
    'totalAmount': number | null;
    /**
     * 
     * @type {string}
     * @memberof GetDraftPaymentRequestsOnlyCreatedOwn200ResponseInner
     */
    'dueDate': string | null;
    /**
     * 
     * @type {GetDraftPaymentRequestsOnlyCreatedOwn200ResponseInnerRequestor}
     * @memberof GetDraftPaymentRequestsOnlyCreatedOwn200ResponseInner
     */
    'requestor': GetDraftPaymentRequestsOnlyCreatedOwn200ResponseInnerRequestor;
    /**
     * requestorName is the name of the requesting user at the time this PaymentRequest was requested. The free word search targets the name of requesting user, but it is the requestorName that is targeted, not the name of the user at the time of the search. Use requestor.name if you want to know what is the name at present of the user.
     * @type {string}
     * @memberof GetDraftPaymentRequestsOnlyCreatedOwn200ResponseInner
     */
    'requestorName': string;
    /**
     * 
     * @type {string}
     * @memberof GetDraftPaymentRequestsOnlyCreatedOwn200ResponseInner
     */
    'createdAt': string;
}
/**
 * 
 * @export
 * @interface GetDraftPaymentRequestsOnlyCreatedOwn200ResponseInnerRequestor
 */
export interface GetDraftPaymentRequestsOnlyCreatedOwn200ResponseInnerRequestor {
    /**
     * 
     * @type {string}
     * @memberof GetDraftPaymentRequestsOnlyCreatedOwn200ResponseInnerRequestor
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetDraftPaymentRequestsOnlyCreatedOwn200ResponseInnerRequestor
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetDraftPaymentRequestsOnlyCreatedOwn200ResponseInnerSupplier
 */
export interface GetDraftPaymentRequestsOnlyCreatedOwn200ResponseInnerSupplier {
    /**
     * 
     * @type {string}
     * @memberof GetDraftPaymentRequestsOnlyCreatedOwn200ResponseInnerSupplier
     */
    'partnerId': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetDraftPaymentRequestsOnlyCreatedOwn200ResponseInnerSupplier
     */
    'name': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetDraftPaymentRequestsOnlyCreatedOwn200ResponseInnerSupplier
     */
    'bankNumber': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetDraftPaymentRequestsOnlyCreatedOwn200ResponseInnerSupplier
     */
    'bankName': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetDraftPaymentRequestsOnlyCreatedOwn200ResponseInnerSupplier
     */
    'branchNumber': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetDraftPaymentRequestsOnlyCreatedOwn200ResponseInnerSupplier
     */
    'branchName': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetDraftPaymentRequestsOnlyCreatedOwn200ResponseInnerSupplier
     */
    'accountType': GetDraftPaymentRequestsOnlyCreatedOwn200ResponseInnerSupplierAccountTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetDraftPaymentRequestsOnlyCreatedOwn200ResponseInnerSupplier
     */
    'accountNumber': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetDraftPaymentRequestsOnlyCreatedOwn200ResponseInnerSupplier
     */
    'companyCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetDraftPaymentRequestsOnlyCreatedOwn200ResponseInnerSupplier
     */
    'companyName': string | null;
}

export const GetDraftPaymentRequestsOnlyCreatedOwn200ResponseInnerSupplierAccountTypeEnum = {
    savingsAccount: 'SAVINGS_ACCOUNT',
    currentAccount: 'CURRENT_ACCOUNT',
    thriftAccount: 'THRIFT_ACCOUNT',
    other: 'OTHER'
} as const;

export type GetDraftPaymentRequestsOnlyCreatedOwn200ResponseInnerSupplierAccountTypeEnum = typeof GetDraftPaymentRequestsOnlyCreatedOwn200ResponseInnerSupplierAccountTypeEnum[keyof typeof GetDraftPaymentRequestsOnlyCreatedOwn200ResponseInnerSupplierAccountTypeEnum];

/**
 * 
 * @export
 * @interface GetEarliestExpiringGuaranteeMoneyForOrganization200Response
 */
export interface GetEarliestExpiringGuaranteeMoneyForOrganization200Response {
    /**
     * 
     * @type {number}
     * @memberof GetEarliestExpiringGuaranteeMoneyForOrganization200Response
     */
    'totalAmount': number;
    /**
     * 
     * @type {string}
     * @memberof GetEarliestExpiringGuaranteeMoneyForOrganization200Response
     */
    'validThroughDate': string;
}
/**
 * 
 * @export
 * @interface GetEmailNotifications200ResponseInner
 */
export interface GetEmailNotifications200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetEmailNotifications200ResponseInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetEmailNotifications200ResponseInner
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetEmailNotifications200ResponseInner
     */
    'description': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetEmailNotifications200ResponseInner
     */
    'enabled': boolean;
}
/**
 * 
 * @export
 * @interface GetErrorBills200ResponseInner
 */
export interface GetErrorBills200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetErrorBills200ResponseInner
     */
    'billId': string;
    /**
     * 
     * @type {string}
     * @memberof GetErrorBills200ResponseInner
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetErrorBills200ResponseInner
     */
    'organizationName': string;
    /**
     * 
     * @type {string}
     * @memberof GetErrorBills200ResponseInner
     */
    'fileName': string;
    /**
     * 
     * @type {string}
     * @memberof GetErrorBills200ResponseInner
     */
    'fileExtension': string;
    /**
     * 
     * @type {string}
     * @memberof GetErrorBills200ResponseInner
     */
    'latestStatus': string;
    /**
     * 
     * @type {string}
     * @memberof GetErrorBills200ResponseInner
     */
    'payeeName': string | null;
    /**
     * 
     * @type {number}
     * @memberof GetErrorBills200ResponseInner
     */
    'amount': number | null;
    /**
     * 
     * @type {string}
     * @memberof GetErrorBills200ResponseInner
     */
    'scheduledTransferDate': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetErrorBills200ResponseInner
     */
    'uploadedAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetErrorBills200ResponseInner
     */
    'bankAccountActivityId'?: string | null;
}
/**
 * 
 * @export
 * @interface GetEvidence200Response
 */
export interface GetEvidence200Response {
    /**
     * 
     * @type {string}
     * @memberof GetEvidence200Response
     */
    'id': string;
    /**
     * This is set if the payment type of the evidence is CARD_TRANSACTION. Otherwise, null.
     * @type {string}
     * @memberof GetEvidence200Response
     */
    'userAccountId': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetEvidence200Response
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetEvidence200Response
     */
    'paymentType': GetEvidence200ResponsePaymentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetEvidence200Response
     */
    'electronicMethod': GetEvidence200ResponseElectronicMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof GetEvidence200Response
     */
    'documentSize': GetEvidence200ResponseDocumentSizeEnum;
    /**
     * 
     * @type {number}
     * @memberof GetEvidence200Response
     */
    'detectedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetEvidence200Response
     */
    'calculatedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetEvidence200Response
     */
    'colorGradation': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetEvidence200Response
     */
    'verticalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetEvidence200Response
     */
    'horizontalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetEvidence200Response
     */
    'heightMillis': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetEvidence200Response
     */
    'widthMillis': number | null;
    /**
     * 
     * @type {string}
     * @memberof GetEvidence200Response
     */
    'legalValidity': GetEvidence200ResponseLegalValidityEnum;
    /**
     * 
     * @type {string}
     * @memberof GetEvidence200Response
     */
    'note': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetEvidence200Response
     */
    'irrelevantToLedger': boolean;
    /**
     * 
     * @type {GetEvidence200ResponseFile}
     * @memberof GetEvidence200Response
     */
    'file': GetEvidence200ResponseFile;
    /**
     * 
     * @type {Array<GetEvidence200ResponsePaymentsInner>}
     * @memberof GetEvidence200Response
     */
    'payments': Array<GetEvidence200ResponsePaymentsInner>;
    /**
     * 
     * @type {GetEvidence200ResponseInvoiceIssuer}
     * @memberof GetEvidence200Response
     */
    'invoiceIssuer': GetEvidence200ResponseInvoiceIssuer | null;
    /**
     * 
     * @type {GetEvidence200ResponseErrors}
     * @memberof GetEvidence200Response
     */
    'errors': GetEvidence200ResponseErrors;
    /**
     * 
     * @type {GetEvidence200ResponseWarnings}
     * @memberof GetEvidence200Response
     */
    'warnings': GetEvidence200ResponseWarnings;
    /**
     * 
     * @type {GetEvidence200ResponseUpdatedBy}
     * @memberof GetEvidence200Response
     */
    'updatedBy': GetEvidence200ResponseUpdatedBy;
    /**
     * 
     * @type {string}
     * @memberof GetEvidence200Response
     */
    'updatedAt': string;
    /**
     * 
     * @type {GetEvidence200ResponseUploadedBy}
     * @memberof GetEvidence200Response
     */
    'uploadedBy': GetEvidence200ResponseUploadedBy;
    /**
     * 
     * @type {string}
     * @memberof GetEvidence200Response
     */
    'uploadedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetEvidence200Response
     */
    'deleted': boolean;
}

export const GetEvidence200ResponsePaymentTypeEnum = {
    cardTransaction: 'CARD_TRANSACTION',
    paymentRequest: 'PAYMENT_REQUEST'
} as const;

export type GetEvidence200ResponsePaymentTypeEnum = typeof GetEvidence200ResponsePaymentTypeEnum[keyof typeof GetEvidence200ResponsePaymentTypeEnum];
export const GetEvidence200ResponseElectronicMethodEnum = {
    fullElectronic: 'FULL_ELECTRONIC',
    originallyPaper: 'ORIGINALLY_PAPER',
    unknown: 'UNKNOWN'
} as const;

export type GetEvidence200ResponseElectronicMethodEnum = typeof GetEvidence200ResponseElectronicMethodEnum[keyof typeof GetEvidence200ResponseElectronicMethodEnum];
export const GetEvidence200ResponseDocumentSizeEnum = {
    overA4: 'OVER_A4',
    a4OrSmaller: 'A4_OR_SMALLER',
    unknown: 'UNKNOWN'
} as const;

export type GetEvidence200ResponseDocumentSizeEnum = typeof GetEvidence200ResponseDocumentSizeEnum[keyof typeof GetEvidence200ResponseDocumentSizeEnum];
export const GetEvidence200ResponseLegalValidityEnum = {
    valid: 'VALID',
    invalid: 'INVALID',
    inputRequired: 'INPUT_REQUIRED',
    outOfTarget: 'OUT_OF_TARGET'
} as const;

export type GetEvidence200ResponseLegalValidityEnum = typeof GetEvidence200ResponseLegalValidityEnum[keyof typeof GetEvidence200ResponseLegalValidityEnum];

/**
 * 
 * @export
 * @interface GetEvidence200ResponseErrors
 */
export interface GetEvidence200ResponseErrors {
    /**
     * 
     * @type {string}
     * @memberof GetEvidence200ResponseErrors
     */
    'detectedDpi'?: GetEvidence200ResponseErrorsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetEvidence200ResponseErrors
     */
    'calculatedDpi'?: GetEvidence200ResponseErrorsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetEvidence200ResponseErrors
     */
    'colorGradation'?: GetEvidence200ResponseErrorsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof GetEvidence200ResponseErrors
     */
    'heightMillis'?: GetEvidence200ResponseErrorsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof GetEvidence200ResponseErrors
     */
    'widthMillis'?: GetEvidence200ResponseErrorsWidthMillisEnum;
}

export const GetEvidence200ResponseErrorsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetEvidence200ResponseErrorsDetectedDpiEnum = typeof GetEvidence200ResponseErrorsDetectedDpiEnum[keyof typeof GetEvidence200ResponseErrorsDetectedDpiEnum];
export const GetEvidence200ResponseErrorsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetEvidence200ResponseErrorsCalculatedDpiEnum = typeof GetEvidence200ResponseErrorsCalculatedDpiEnum[keyof typeof GetEvidence200ResponseErrorsCalculatedDpiEnum];
export const GetEvidence200ResponseErrorsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type GetEvidence200ResponseErrorsColorGradationEnum = typeof GetEvidence200ResponseErrorsColorGradationEnum[keyof typeof GetEvidence200ResponseErrorsColorGradationEnum];
export const GetEvidence200ResponseErrorsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetEvidence200ResponseErrorsHeightMillisEnum = typeof GetEvidence200ResponseErrorsHeightMillisEnum[keyof typeof GetEvidence200ResponseErrorsHeightMillisEnum];
export const GetEvidence200ResponseErrorsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetEvidence200ResponseErrorsWidthMillisEnum = typeof GetEvidence200ResponseErrorsWidthMillisEnum[keyof typeof GetEvidence200ResponseErrorsWidthMillisEnum];

/**
 * 
 * @export
 * @interface GetEvidence200ResponseFile
 */
export interface GetEvidence200ResponseFile {
    /**
     * 
     * @type {string}
     * @memberof GetEvidence200ResponseFile
     */
    'id': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetEvidence200ResponseFile
     */
    'name': string;
    /**
     * A URL with expiration date-time accessible from the front-end. This is not fully supported yet. In responses from certain endpoints, the url is set to null.
     * @type {string}
     * @memberof GetEvidence200ResponseFile
     */
    'url': string | null;
}
/**
 * Set null if it\'s evidence not analyzed using invoicing-system-compliance feature. Also set null if invoicing-system-compliance feature has been made not available for the organization by the feature-flag.
 * @export
 * @interface GetEvidence200ResponseInvoiceIssuer
 */
export interface GetEvidence200ResponseInvoiceIssuer {
    /**
     * 
     * @type {string}
     * @memberof GetEvidence200ResponseInvoiceIssuer
     */
    'name': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetEvidence200ResponseInvoiceIssuer
     */
    'registrationNumber': string | null;
    /**
     * isQualified retains the result of querying the 国税庁API to see if registrationNumber is qualified, as is.
     * @type {boolean}
     * @memberof GetEvidence200ResponseInvoiceIssuer
     */
    'isQualified': boolean;
    /**
     * AsQualified indicates whether this issuer should be treated as a qualified invoice issuer within the user\'s system, even if the RegistrationNumber is not confirmed as qualified in the National Tax Agency\'s business registration system.
     * @type {boolean}
     * @memberof GetEvidence200ResponseInvoiceIssuer
     */
    'asQualified': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetEvidence200ResponseInvoiceIssuer
     */
    'partnerId': string | null;
}
/**
 * 
 * @export
 * @interface GetEvidence200ResponsePaymentsInner
 */
export interface GetEvidence200ResponsePaymentsInner {
    /**
     * 
     * @type {string}
     * @memberof GetEvidence200ResponsePaymentsInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetEvidence200ResponsePaymentsInner
     */
    'paidAt': string;
    /**
     * 
     * @type {number}
     * @memberof GetEvidence200ResponsePaymentsInner
     */
    'amount': number;
    /**
     * The issuer of the associated evidence.
     * @type {string}
     * @memberof GetEvidence200ResponsePaymentsInner
     */
    'issuer': string;
}
/**
 * 
 * @export
 * @interface GetEvidence200ResponseUpdatedBy
 */
export interface GetEvidence200ResponseUpdatedBy {
    /**
     * 
     * @type {string}
     * @memberof GetEvidence200ResponseUpdatedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetEvidence200ResponseUpdatedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetEvidence200ResponseUploadedBy
 */
export interface GetEvidence200ResponseUploadedBy {
    /**
     * 
     * @type {string}
     * @memberof GetEvidence200ResponseUploadedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetEvidence200ResponseUploadedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetEvidence200ResponseWarnings
 */
export interface GetEvidence200ResponseWarnings {
    /**
     * 
     * @type {string}
     * @memberof GetEvidence200ResponseWarnings
     */
    'detectedDpi'?: GetEvidence200ResponseWarningsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetEvidence200ResponseWarnings
     */
    'calculatedDpi'?: GetEvidence200ResponseWarningsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetEvidence200ResponseWarnings
     */
    'colorGradation'?: GetEvidence200ResponseWarningsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof GetEvidence200ResponseWarnings
     */
    'heightMillis'?: GetEvidence200ResponseWarningsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof GetEvidence200ResponseWarnings
     */
    'widthMillis'?: GetEvidence200ResponseWarningsWidthMillisEnum;
}

export const GetEvidence200ResponseWarningsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetEvidence200ResponseWarningsDetectedDpiEnum = typeof GetEvidence200ResponseWarningsDetectedDpiEnum[keyof typeof GetEvidence200ResponseWarningsDetectedDpiEnum];
export const GetEvidence200ResponseWarningsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetEvidence200ResponseWarningsCalculatedDpiEnum = typeof GetEvidence200ResponseWarningsCalculatedDpiEnum[keyof typeof GetEvidence200ResponseWarningsCalculatedDpiEnum];
export const GetEvidence200ResponseWarningsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type GetEvidence200ResponseWarningsColorGradationEnum = typeof GetEvidence200ResponseWarningsColorGradationEnum[keyof typeof GetEvidence200ResponseWarningsColorGradationEnum];
export const GetEvidence200ResponseWarningsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetEvidence200ResponseWarningsHeightMillisEnum = typeof GetEvidence200ResponseWarningsHeightMillisEnum[keyof typeof GetEvidence200ResponseWarningsHeightMillisEnum];
export const GetEvidence200ResponseWarningsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetEvidence200ResponseWarningsWidthMillisEnum = typeof GetEvidence200ResponseWarningsWidthMillisEnum[keyof typeof GetEvidence200ResponseWarningsWidthMillisEnum];

/**
 * 
 * @export
 * @interface GetEvidenceInformationForCardTransactions200Response
 */
export interface GetEvidenceInformationForCardTransactions200Response {
    /**
     * 
     * @type {GetEvidenceInformationForCardTransactions200ResponseEvidenceStatus}
     * @memberof GetEvidenceInformationForCardTransactions200Response
     */
    'evidenceStatus': GetEvidenceInformationForCardTransactions200ResponseEvidenceStatus | null;
    /**
     * 
     * @type {GetEvidenceInformationForCardTransactions200ResponseEvidenceRemindStatus}
     * @memberof GetEvidenceInformationForCardTransactions200Response
     */
    'evidenceRemindStatus': GetEvidenceInformationForCardTransactions200ResponseEvidenceRemindStatus | null;
    /**
     * 
     * @type {Array<GetEvidenceInformationForCardTransactions200ResponseRequestHistoryInner>}
     * @memberof GetEvidenceInformationForCardTransactions200Response
     */
    'requestHistory': Array<GetEvidenceInformationForCardTransactions200ResponseRequestHistoryInner>;
}
/**
 * 
 * @export
 * @interface GetEvidenceInformationForCardTransactions200ResponseEvidenceRemindStatus
 */
export interface GetEvidenceInformationForCardTransactions200ResponseEvidenceRemindStatus {
    /**
     * 
     * @type {boolean}
     * @memberof GetEvidenceInformationForCardTransactions200ResponseEvidenceRemindStatus
     */
    'isAutoRemind': boolean;
}
/**
 * 
 * @export
 * @interface GetEvidenceInformationForCardTransactions200ResponseEvidenceStatus
 */
export interface GetEvidenceInformationForCardTransactions200ResponseEvidenceStatus {
    /**
     * 
     * @type {string}
     * @memberof GetEvidenceInformationForCardTransactions200ResponseEvidenceStatus
     */
    'visaTransactionReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetEvidenceInformationForCardTransactions200ResponseEvidenceStatus
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetEvidenceInformationForCardTransactions200ResponseEvidenceStatus
     */
    'isRequested': boolean;
    /**
     * 
     * @type {GetEvidenceInformationForCardTransactions200ResponseEvidenceStatusRequestedBy}
     * @memberof GetEvidenceInformationForCardTransactions200ResponseEvidenceStatus
     */
    'requestedBy': GetEvidenceInformationForCardTransactions200ResponseEvidenceStatusRequestedBy | null;
    /**
     * 
     * @type {string}
     * @memberof GetEvidenceInformationForCardTransactions200ResponseEvidenceStatus
     */
    'requestedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetEvidenceInformationForCardTransactions200ResponseEvidenceStatus
     */
    'isLocked': boolean;
    /**
     * 
     * @type {GetEvidenceInformationForCardTransactions200ResponseEvidenceStatusLockedBy}
     * @memberof GetEvidenceInformationForCardTransactions200ResponseEvidenceStatus
     */
    'lockedBy': GetEvidenceInformationForCardTransactions200ResponseEvidenceStatusLockedBy | null;
    /**
     * 
     * @type {string}
     * @memberof GetEvidenceInformationForCardTransactions200ResponseEvidenceStatus
     */
    'lockedAt': string;
}
/**
 * 
 * @export
 * @interface GetEvidenceInformationForCardTransactions200ResponseEvidenceStatusLockedBy
 */
export interface GetEvidenceInformationForCardTransactions200ResponseEvidenceStatusLockedBy {
    /**
     * 
     * @type {string}
     * @memberof GetEvidenceInformationForCardTransactions200ResponseEvidenceStatusLockedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetEvidenceInformationForCardTransactions200ResponseEvidenceStatusLockedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetEvidenceInformationForCardTransactions200ResponseEvidenceStatusRequestedBy
 */
export interface GetEvidenceInformationForCardTransactions200ResponseEvidenceStatusRequestedBy {
    /**
     * 
     * @type {string}
     * @memberof GetEvidenceInformationForCardTransactions200ResponseEvidenceStatusRequestedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetEvidenceInformationForCardTransactions200ResponseEvidenceStatusRequestedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetEvidenceInformationForCardTransactions200ResponseRequestHistoryInner
 */
export interface GetEvidenceInformationForCardTransactions200ResponseRequestHistoryInner {
    /**
     * 
     * @type {number}
     * @memberof GetEvidenceInformationForCardTransactions200ResponseRequestHistoryInner
     */
    'requestId': number;
    /**
     * 
     * @type {GetEvidenceInformationForCardTransactions200ResponseRequestHistoryInnerRequestedBy}
     * @memberof GetEvidenceInformationForCardTransactions200ResponseRequestHistoryInner
     */
    'requestedBy': GetEvidenceInformationForCardTransactions200ResponseRequestHistoryInnerRequestedBy;
    /**
     * 
     * @type {string}
     * @memberof GetEvidenceInformationForCardTransactions200ResponseRequestHistoryInner
     */
    'requestedAt': string;
}
/**
 * 
 * @export
 * @interface GetEvidenceInformationForCardTransactions200ResponseRequestHistoryInnerRequestedBy
 */
export interface GetEvidenceInformationForCardTransactions200ResponseRequestHistoryInnerRequestedBy {
    /**
     * 
     * @type {string}
     * @memberof GetEvidenceInformationForCardTransactions200ResponseRequestHistoryInnerRequestedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetEvidenceInformationForCardTransactions200ResponseRequestHistoryInnerRequestedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetEvidenceRecords200ResponseInner
 */
export interface GetEvidenceRecords200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetEvidenceRecords200ResponseInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetEvidenceRecords200ResponseInner
     */
    'evidenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetEvidenceRecords200ResponseInner
     */
    'userAccountId': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetEvidenceRecords200ResponseInner
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetEvidenceRecords200ResponseInner
     */
    'paymentType': GetEvidenceRecords200ResponseInnerPaymentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetEvidenceRecords200ResponseInner
     */
    'electronicMethod': GetEvidenceRecords200ResponseInnerElectronicMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof GetEvidenceRecords200ResponseInner
     */
    'documentSize': GetEvidenceRecords200ResponseInnerDocumentSizeEnum;
    /**
     * 
     * @type {number}
     * @memberof GetEvidenceRecords200ResponseInner
     */
    'detectedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetEvidenceRecords200ResponseInner
     */
    'calculatedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetEvidenceRecords200ResponseInner
     */
    'colorGradation': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetEvidenceRecords200ResponseInner
     */
    'verticalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetEvidenceRecords200ResponseInner
     */
    'horizontalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetEvidenceRecords200ResponseInner
     */
    'heightMillis': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetEvidenceRecords200ResponseInner
     */
    'widthMillis': number | null;
    /**
     * 
     * @type {string}
     * @memberof GetEvidenceRecords200ResponseInner
     */
    'legalValidity': GetEvidenceRecords200ResponseInnerLegalValidityEnum;
    /**
     * 
     * @type {boolean}
     * @memberof GetEvidenceRecords200ResponseInner
     */
    'dpiForciblyValid': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetEvidenceRecords200ResponseInner
     */
    'colorGradationForciblyValid': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetEvidenceRecords200ResponseInner
     */
    'note': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetEvidenceRecords200ResponseInner
     */
    'irrelevantToLedger': boolean;
    /**
     * 
     * @type {GetEvidenceRecords200ResponseInnerFile}
     * @memberof GetEvidenceRecords200ResponseInner
     */
    'file': GetEvidenceRecords200ResponseInnerFile;
    /**
     * 
     * @type {GetEvidenceRecords200ResponseInnerInvoiceIssuer}
     * @memberof GetEvidenceRecords200ResponseInner
     */
    'invoiceIssuer': GetEvidenceRecords200ResponseInnerInvoiceIssuer | null;
    /**
     * 
     * @type {GetEvidenceRecords200ResponseInnerErrors}
     * @memberof GetEvidenceRecords200ResponseInner
     */
    'errors': GetEvidenceRecords200ResponseInnerErrors;
    /**
     * 
     * @type {GetEvidenceRecords200ResponseInnerWarnings}
     * @memberof GetEvidenceRecords200ResponseInner
     */
    'warnings': GetEvidenceRecords200ResponseInnerWarnings;
    /**
     * 
     * @type {GetEvidenceRecords200ResponseInnerUpdatedBy}
     * @memberof GetEvidenceRecords200ResponseInner
     */
    'updatedBy': GetEvidenceRecords200ResponseInnerUpdatedBy;
    /**
     * 
     * @type {string}
     * @memberof GetEvidenceRecords200ResponseInner
     */
    'updatedAt': string;
    /**
     * 
     * @type {GetEvidenceRecords200ResponseInnerUploadedBy}
     * @memberof GetEvidenceRecords200ResponseInner
     */
    'uploadedBy': GetEvidenceRecords200ResponseInnerUploadedBy;
    /**
     * 
     * @type {string}
     * @memberof GetEvidenceRecords200ResponseInner
     */
    'uploadedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetEvidenceRecords200ResponseInner
     */
    'uploadedByRecipient': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetEvidenceRecords200ResponseInner
     */
    'deleted': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetEvidenceRecords200ResponseInner
     */
    'uploadedFrom': string;
}

export const GetEvidenceRecords200ResponseInnerPaymentTypeEnum = {
    cardTransaction: 'CARD_TRANSACTION',
    paymentRequest: 'PAYMENT_REQUEST'
} as const;

export type GetEvidenceRecords200ResponseInnerPaymentTypeEnum = typeof GetEvidenceRecords200ResponseInnerPaymentTypeEnum[keyof typeof GetEvidenceRecords200ResponseInnerPaymentTypeEnum];
export const GetEvidenceRecords200ResponseInnerElectronicMethodEnum = {
    fullElectronic: 'FULL_ELECTRONIC',
    originallyPaper: 'ORIGINALLY_PAPER',
    unknown: 'UNKNOWN'
} as const;

export type GetEvidenceRecords200ResponseInnerElectronicMethodEnum = typeof GetEvidenceRecords200ResponseInnerElectronicMethodEnum[keyof typeof GetEvidenceRecords200ResponseInnerElectronicMethodEnum];
export const GetEvidenceRecords200ResponseInnerDocumentSizeEnum = {
    overA4: 'OVER_A4',
    a4OrSmaller: 'A4_OR_SMALLER',
    unknown: 'UNKNOWN'
} as const;

export type GetEvidenceRecords200ResponseInnerDocumentSizeEnum = typeof GetEvidenceRecords200ResponseInnerDocumentSizeEnum[keyof typeof GetEvidenceRecords200ResponseInnerDocumentSizeEnum];
export const GetEvidenceRecords200ResponseInnerLegalValidityEnum = {
    valid: 'VALID',
    invalid: 'INVALID',
    inputRequired: 'INPUT_REQUIRED',
    outOfTarget: 'OUT_OF_TARGET'
} as const;

export type GetEvidenceRecords200ResponseInnerLegalValidityEnum = typeof GetEvidenceRecords200ResponseInnerLegalValidityEnum[keyof typeof GetEvidenceRecords200ResponseInnerLegalValidityEnum];

/**
 * 
 * @export
 * @interface GetEvidenceRecords200ResponseInnerErrors
 */
export interface GetEvidenceRecords200ResponseInnerErrors {
    /**
     * 
     * @type {string}
     * @memberof GetEvidenceRecords200ResponseInnerErrors
     */
    'detectedDpi'?: GetEvidenceRecords200ResponseInnerErrorsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetEvidenceRecords200ResponseInnerErrors
     */
    'calculatedDpi'?: GetEvidenceRecords200ResponseInnerErrorsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetEvidenceRecords200ResponseInnerErrors
     */
    'colorGradation'?: GetEvidenceRecords200ResponseInnerErrorsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof GetEvidenceRecords200ResponseInnerErrors
     */
    'heightMillis'?: GetEvidenceRecords200ResponseInnerErrorsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof GetEvidenceRecords200ResponseInnerErrors
     */
    'widthMillis'?: GetEvidenceRecords200ResponseInnerErrorsWidthMillisEnum;
}

export const GetEvidenceRecords200ResponseInnerErrorsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetEvidenceRecords200ResponseInnerErrorsDetectedDpiEnum = typeof GetEvidenceRecords200ResponseInnerErrorsDetectedDpiEnum[keyof typeof GetEvidenceRecords200ResponseInnerErrorsDetectedDpiEnum];
export const GetEvidenceRecords200ResponseInnerErrorsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetEvidenceRecords200ResponseInnerErrorsCalculatedDpiEnum = typeof GetEvidenceRecords200ResponseInnerErrorsCalculatedDpiEnum[keyof typeof GetEvidenceRecords200ResponseInnerErrorsCalculatedDpiEnum];
export const GetEvidenceRecords200ResponseInnerErrorsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type GetEvidenceRecords200ResponseInnerErrorsColorGradationEnum = typeof GetEvidenceRecords200ResponseInnerErrorsColorGradationEnum[keyof typeof GetEvidenceRecords200ResponseInnerErrorsColorGradationEnum];
export const GetEvidenceRecords200ResponseInnerErrorsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetEvidenceRecords200ResponseInnerErrorsHeightMillisEnum = typeof GetEvidenceRecords200ResponseInnerErrorsHeightMillisEnum[keyof typeof GetEvidenceRecords200ResponseInnerErrorsHeightMillisEnum];
export const GetEvidenceRecords200ResponseInnerErrorsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetEvidenceRecords200ResponseInnerErrorsWidthMillisEnum = typeof GetEvidenceRecords200ResponseInnerErrorsWidthMillisEnum[keyof typeof GetEvidenceRecords200ResponseInnerErrorsWidthMillisEnum];

/**
 * 
 * @export
 * @interface GetEvidenceRecords200ResponseInnerFile
 */
export interface GetEvidenceRecords200ResponseInnerFile {
    /**
     * 
     * @type {string}
     * @memberof GetEvidenceRecords200ResponseInnerFile
     */
    'id': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetEvidenceRecords200ResponseInnerFile
     */
    'name': string;
    /**
     * A URL with expiration date-time accessible from the front-end. This is not fully supported yet. In responses from certain endpoints, the url is set to null.
     * @type {string}
     * @memberof GetEvidenceRecords200ResponseInnerFile
     */
    'url': string | null;
}
/**
 * Set null if it\'s evidence not analyzed using invoicing-system-compliance feature. Also set null if invoicing-system-compliance feature has been made not available for the organization by the feature-flag.
 * @export
 * @interface GetEvidenceRecords200ResponseInnerInvoiceIssuer
 */
export interface GetEvidenceRecords200ResponseInnerInvoiceIssuer {
    /**
     * 
     * @type {string}
     * @memberof GetEvidenceRecords200ResponseInnerInvoiceIssuer
     */
    'name': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetEvidenceRecords200ResponseInnerInvoiceIssuer
     */
    'registrationNumber': string | null;
    /**
     * isQualified retains the result of querying the 国税庁API to see if registrationNumber is qualified, as is.
     * @type {boolean}
     * @memberof GetEvidenceRecords200ResponseInnerInvoiceIssuer
     */
    'isQualified': boolean;
    /**
     * AsQualified indicates whether this issuer should be treated as a qualified invoice issuer within the user\'s system, even if the RegistrationNumber is not confirmed as qualified in the National Tax Agency\'s business registration system.
     * @type {boolean}
     * @memberof GetEvidenceRecords200ResponseInnerInvoiceIssuer
     */
    'asQualified': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetEvidenceRecords200ResponseInnerInvoiceIssuer
     */
    'partnerId': string | null;
}
/**
 * 
 * @export
 * @interface GetEvidenceRecords200ResponseInnerUpdatedBy
 */
export interface GetEvidenceRecords200ResponseInnerUpdatedBy {
    /**
     * 
     * @type {string}
     * @memberof GetEvidenceRecords200ResponseInnerUpdatedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetEvidenceRecords200ResponseInnerUpdatedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetEvidenceRecords200ResponseInnerUploadedBy
 */
export interface GetEvidenceRecords200ResponseInnerUploadedBy {
    /**
     * 
     * @type {string}
     * @memberof GetEvidenceRecords200ResponseInnerUploadedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetEvidenceRecords200ResponseInnerUploadedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetEvidenceRecords200ResponseInnerWarnings
 */
export interface GetEvidenceRecords200ResponseInnerWarnings {
    /**
     * 
     * @type {string}
     * @memberof GetEvidenceRecords200ResponseInnerWarnings
     */
    'detectedDpi'?: GetEvidenceRecords200ResponseInnerWarningsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetEvidenceRecords200ResponseInnerWarnings
     */
    'calculatedDpi'?: GetEvidenceRecords200ResponseInnerWarningsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetEvidenceRecords200ResponseInnerWarnings
     */
    'colorGradation'?: GetEvidenceRecords200ResponseInnerWarningsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof GetEvidenceRecords200ResponseInnerWarnings
     */
    'heightMillis'?: GetEvidenceRecords200ResponseInnerWarningsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof GetEvidenceRecords200ResponseInnerWarnings
     */
    'widthMillis'?: GetEvidenceRecords200ResponseInnerWarningsWidthMillisEnum;
}

export const GetEvidenceRecords200ResponseInnerWarningsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetEvidenceRecords200ResponseInnerWarningsDetectedDpiEnum = typeof GetEvidenceRecords200ResponseInnerWarningsDetectedDpiEnum[keyof typeof GetEvidenceRecords200ResponseInnerWarningsDetectedDpiEnum];
export const GetEvidenceRecords200ResponseInnerWarningsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetEvidenceRecords200ResponseInnerWarningsCalculatedDpiEnum = typeof GetEvidenceRecords200ResponseInnerWarningsCalculatedDpiEnum[keyof typeof GetEvidenceRecords200ResponseInnerWarningsCalculatedDpiEnum];
export const GetEvidenceRecords200ResponseInnerWarningsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type GetEvidenceRecords200ResponseInnerWarningsColorGradationEnum = typeof GetEvidenceRecords200ResponseInnerWarningsColorGradationEnum[keyof typeof GetEvidenceRecords200ResponseInnerWarningsColorGradationEnum];
export const GetEvidenceRecords200ResponseInnerWarningsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetEvidenceRecords200ResponseInnerWarningsHeightMillisEnum = typeof GetEvidenceRecords200ResponseInnerWarningsHeightMillisEnum[keyof typeof GetEvidenceRecords200ResponseInnerWarningsHeightMillisEnum];
export const GetEvidenceRecords200ResponseInnerWarningsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetEvidenceRecords200ResponseInnerWarningsWidthMillisEnum = typeof GetEvidenceRecords200ResponseInnerWarningsWidthMillisEnum[keyof typeof GetEvidenceRecords200ResponseInnerWarningsWidthMillisEnum];

/**
 * 
 * @export
 * @interface GetEvidences200ResponseInner
 */
export interface GetEvidences200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetEvidences200ResponseInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetEvidences200ResponseInner
     * @deprecated
     */
    'cardTransactionEvidenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetEvidences200ResponseInner
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetEvidences200ResponseInner
     * @deprecated
     */
    'visaTransactionReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetEvidences200ResponseInner
     */
    'paymentType': GetEvidences200ResponseInnerPaymentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetEvidences200ResponseInner
     */
    'fileName': string;
    /**
     * 
     * @type {string}
     * @memberof GetEvidences200ResponseInner
     */
    'fileExtension': string;
    /**
     * 
     * @type {string}
     * @memberof GetEvidences200ResponseInner
     */
    'electronicMethod': GetEvidences200ResponseInnerElectronicMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof GetEvidences200ResponseInner
     */
    'documentSize': GetEvidences200ResponseInnerDocumentSizeEnum;
    /**
     * 
     * @type {number}
     * @memberof GetEvidences200ResponseInner
     * @deprecated
     */
    'dpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetEvidences200ResponseInner
     */
    'detectedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetEvidences200ResponseInner
     */
    'calculatedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetEvidences200ResponseInner
     */
    'colorGradation': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetEvidences200ResponseInner
     */
    'verticalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetEvidences200ResponseInner
     */
    'horizontalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetEvidences200ResponseInner
     */
    'heightMillis': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetEvidences200ResponseInner
     */
    'widthMillis': number | null;
    /**
     * 
     * @type {string}
     * @memberof GetEvidences200ResponseInner
     */
    'legalValidity': GetEvidences200ResponseInnerLegalValidityEnum;
    /**
     * 
     * @type {boolean}
     * @memberof GetEvidences200ResponseInner
     */
    'dpiForciblyValid': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetEvidences200ResponseInner
     */
    'colorGradationForciblyValid': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetEvidences200ResponseInner
     */
    'note': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetEvidences200ResponseInner
     */
    'irrelevantToLedger': boolean;
    /**
     * 
     * @type {GetEvidences200ResponseInnerInvoiceIssuer}
     * @memberof GetEvidences200ResponseInner
     */
    'invoiceIssuer': GetEvidences200ResponseInnerInvoiceIssuer | null;
    /**
     * 
     * @type {string}
     * @memberof GetEvidences200ResponseInner
     * @deprecated
     */
    'dpiError': GetEvidences200ResponseInnerDpiErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof GetEvidences200ResponseInner
     * @deprecated
     */
    'detectedDpiError': GetEvidences200ResponseInnerDetectedDpiErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof GetEvidences200ResponseInner
     * @deprecated
     */
    'calculatedDpiError': GetEvidences200ResponseInnerCalculatedDpiErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof GetEvidences200ResponseInner
     * @deprecated
     */
    'colorGradationError': GetEvidences200ResponseInnerColorGradationErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof GetEvidences200ResponseInner
     * @deprecated
     */
    'heightMillisError': GetEvidences200ResponseInnerHeightMillisErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof GetEvidences200ResponseInner
     * @deprecated
     */
    'widthMillisError': GetEvidences200ResponseInnerWidthMillisErrorEnum;
    /**
     * 
     * @type {GetEvidences200ResponseInnerErrors}
     * @memberof GetEvidences200ResponseInner
     */
    'errors': GetEvidences200ResponseInnerErrors;
    /**
     * 
     * @type {GetEvidences200ResponseInnerWarnings}
     * @memberof GetEvidences200ResponseInner
     */
    'warnings': GetEvidences200ResponseInnerWarnings;
    /**
     * 
     * @type {GetEvidences200ResponseInnerCreatedBy}
     * @memberof GetEvidences200ResponseInner
     */
    'createdBy': GetEvidences200ResponseInnerCreatedBy;
    /**
     * 
     * @type {GetEvidences200ResponseInnerUpdatedBy}
     * @memberof GetEvidences200ResponseInner
     */
    'updatedBy': GetEvidences200ResponseInnerUpdatedBy;
    /**
     * 
     * @type {string}
     * @memberof GetEvidences200ResponseInner
     */
    'updatedAt': string;
    /**
     * 
     * @type {GetEvidences200ResponseInnerUploadedBy}
     * @memberof GetEvidences200ResponseInner
     */
    'uploadedBy': GetEvidences200ResponseInnerUploadedBy;
    /**
     * 
     * @type {string}
     * @memberof GetEvidences200ResponseInner
     */
    'uploadedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetEvidences200ResponseInner
     */
    'uploadedByRecipient': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetEvidences200ResponseInner
     */
    'needsMigration': boolean | null;
    /**
     * 
     * @type {string}
     * @memberof GetEvidences200ResponseInner
     */
    'uploadedFrom': string;
}

export const GetEvidences200ResponseInnerPaymentTypeEnum = {
    cardTransaction: 'CARD_TRANSACTION',
    paymentRequest: 'PAYMENT_REQUEST'
} as const;

export type GetEvidences200ResponseInnerPaymentTypeEnum = typeof GetEvidences200ResponseInnerPaymentTypeEnum[keyof typeof GetEvidences200ResponseInnerPaymentTypeEnum];
export const GetEvidences200ResponseInnerElectronicMethodEnum = {
    fullElectronic: 'FULL_ELECTRONIC',
    originallyPaper: 'ORIGINALLY_PAPER',
    unknown: 'UNKNOWN'
} as const;

export type GetEvidences200ResponseInnerElectronicMethodEnum = typeof GetEvidences200ResponseInnerElectronicMethodEnum[keyof typeof GetEvidences200ResponseInnerElectronicMethodEnum];
export const GetEvidences200ResponseInnerDocumentSizeEnum = {
    overA4: 'OVER_A4',
    a4OrSmaller: 'A4_OR_SMALLER',
    unknown: 'UNKNOWN'
} as const;

export type GetEvidences200ResponseInnerDocumentSizeEnum = typeof GetEvidences200ResponseInnerDocumentSizeEnum[keyof typeof GetEvidences200ResponseInnerDocumentSizeEnum];
export const GetEvidences200ResponseInnerLegalValidityEnum = {
    valid: 'VALID',
    invalid: 'INVALID',
    inputRequired: 'INPUT_REQUIRED',
    outOfTarget: 'OUT_OF_TARGET'
} as const;

export type GetEvidences200ResponseInnerLegalValidityEnum = typeof GetEvidences200ResponseInnerLegalValidityEnum[keyof typeof GetEvidences200ResponseInnerLegalValidityEnum];
export const GetEvidences200ResponseInnerDpiErrorEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetEvidences200ResponseInnerDpiErrorEnum = typeof GetEvidences200ResponseInnerDpiErrorEnum[keyof typeof GetEvidences200ResponseInnerDpiErrorEnum];
export const GetEvidences200ResponseInnerDetectedDpiErrorEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetEvidences200ResponseInnerDetectedDpiErrorEnum = typeof GetEvidences200ResponseInnerDetectedDpiErrorEnum[keyof typeof GetEvidences200ResponseInnerDetectedDpiErrorEnum];
export const GetEvidences200ResponseInnerCalculatedDpiErrorEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetEvidences200ResponseInnerCalculatedDpiErrorEnum = typeof GetEvidences200ResponseInnerCalculatedDpiErrorEnum[keyof typeof GetEvidences200ResponseInnerCalculatedDpiErrorEnum];
export const GetEvidences200ResponseInnerColorGradationErrorEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type GetEvidences200ResponseInnerColorGradationErrorEnum = typeof GetEvidences200ResponseInnerColorGradationErrorEnum[keyof typeof GetEvidences200ResponseInnerColorGradationErrorEnum];
export const GetEvidences200ResponseInnerHeightMillisErrorEnum = {
    required: 'REQUIRED'
} as const;

export type GetEvidences200ResponseInnerHeightMillisErrorEnum = typeof GetEvidences200ResponseInnerHeightMillisErrorEnum[keyof typeof GetEvidences200ResponseInnerHeightMillisErrorEnum];
export const GetEvidences200ResponseInnerWidthMillisErrorEnum = {
    required: 'REQUIRED'
} as const;

export type GetEvidences200ResponseInnerWidthMillisErrorEnum = typeof GetEvidences200ResponseInnerWidthMillisErrorEnum[keyof typeof GetEvidences200ResponseInnerWidthMillisErrorEnum];

/**
 * 
 * @export
 * @interface GetEvidences200ResponseInnerCreatedBy
 */
export interface GetEvidences200ResponseInnerCreatedBy {
    /**
     * 
     * @type {string}
     * @memberof GetEvidences200ResponseInnerCreatedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetEvidences200ResponseInnerCreatedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetEvidences200ResponseInnerErrors
 */
export interface GetEvidences200ResponseInnerErrors {
    /**
     * 
     * @type {string}
     * @memberof GetEvidences200ResponseInnerErrors
     */
    'detectedDpi'?: GetEvidences200ResponseInnerErrorsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetEvidences200ResponseInnerErrors
     */
    'calculatedDpi'?: GetEvidences200ResponseInnerErrorsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetEvidences200ResponseInnerErrors
     */
    'colorGradation'?: GetEvidences200ResponseInnerErrorsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof GetEvidences200ResponseInnerErrors
     */
    'heightMillis'?: GetEvidences200ResponseInnerErrorsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof GetEvidences200ResponseInnerErrors
     */
    'widthMillis'?: GetEvidences200ResponseInnerErrorsWidthMillisEnum;
}

export const GetEvidences200ResponseInnerErrorsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetEvidences200ResponseInnerErrorsDetectedDpiEnum = typeof GetEvidences200ResponseInnerErrorsDetectedDpiEnum[keyof typeof GetEvidences200ResponseInnerErrorsDetectedDpiEnum];
export const GetEvidences200ResponseInnerErrorsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetEvidences200ResponseInnerErrorsCalculatedDpiEnum = typeof GetEvidences200ResponseInnerErrorsCalculatedDpiEnum[keyof typeof GetEvidences200ResponseInnerErrorsCalculatedDpiEnum];
export const GetEvidences200ResponseInnerErrorsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type GetEvidences200ResponseInnerErrorsColorGradationEnum = typeof GetEvidences200ResponseInnerErrorsColorGradationEnum[keyof typeof GetEvidences200ResponseInnerErrorsColorGradationEnum];
export const GetEvidences200ResponseInnerErrorsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetEvidences200ResponseInnerErrorsHeightMillisEnum = typeof GetEvidences200ResponseInnerErrorsHeightMillisEnum[keyof typeof GetEvidences200ResponseInnerErrorsHeightMillisEnum];
export const GetEvidences200ResponseInnerErrorsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetEvidences200ResponseInnerErrorsWidthMillisEnum = typeof GetEvidences200ResponseInnerErrorsWidthMillisEnum[keyof typeof GetEvidences200ResponseInnerErrorsWidthMillisEnum];

/**
 * Set null if it\'s evidence not analyzed using invoicing-system-compliance feature. Also set null if invoicing-system-compliance feature has been made not available for the organization by the feature-flag.
 * @export
 * @interface GetEvidences200ResponseInnerInvoiceIssuer
 */
export interface GetEvidences200ResponseInnerInvoiceIssuer {
    /**
     * 
     * @type {string}
     * @memberof GetEvidences200ResponseInnerInvoiceIssuer
     */
    'name': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetEvidences200ResponseInnerInvoiceIssuer
     */
    'registrationNumber': string | null;
    /**
     * isQualified retains the result of querying the 国税庁API to see if registrationNumber is qualified, as is.
     * @type {boolean}
     * @memberof GetEvidences200ResponseInnerInvoiceIssuer
     */
    'isQualified': boolean;
    /**
     * AsQualified indicates whether this issuer should be treated as a qualified invoice issuer within the user\'s system, even if the RegistrationNumber is not confirmed as qualified in the National Tax Agency\'s business registration system.
     * @type {boolean}
     * @memberof GetEvidences200ResponseInnerInvoiceIssuer
     */
    'asQualified': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetEvidences200ResponseInnerInvoiceIssuer
     */
    'partnerId': string | null;
}
/**
 * 
 * @export
 * @interface GetEvidences200ResponseInnerUpdatedBy
 */
export interface GetEvidences200ResponseInnerUpdatedBy {
    /**
     * 
     * @type {string}
     * @memberof GetEvidences200ResponseInnerUpdatedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetEvidences200ResponseInnerUpdatedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetEvidences200ResponseInnerUploadedBy
 */
export interface GetEvidences200ResponseInnerUploadedBy {
    /**
     * 
     * @type {string}
     * @memberof GetEvidences200ResponseInnerUploadedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetEvidences200ResponseInnerUploadedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetEvidences200ResponseInnerWarnings
 */
export interface GetEvidences200ResponseInnerWarnings {
    /**
     * 
     * @type {string}
     * @memberof GetEvidences200ResponseInnerWarnings
     */
    'detectedDpi'?: GetEvidences200ResponseInnerWarningsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetEvidences200ResponseInnerWarnings
     */
    'calculatedDpi'?: GetEvidences200ResponseInnerWarningsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetEvidences200ResponseInnerWarnings
     */
    'colorGradation'?: GetEvidences200ResponseInnerWarningsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof GetEvidences200ResponseInnerWarnings
     */
    'heightMillis'?: GetEvidences200ResponseInnerWarningsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof GetEvidences200ResponseInnerWarnings
     */
    'widthMillis'?: GetEvidences200ResponseInnerWarningsWidthMillisEnum;
}

export const GetEvidences200ResponseInnerWarningsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetEvidences200ResponseInnerWarningsDetectedDpiEnum = typeof GetEvidences200ResponseInnerWarningsDetectedDpiEnum[keyof typeof GetEvidences200ResponseInnerWarningsDetectedDpiEnum];
export const GetEvidences200ResponseInnerWarningsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetEvidences200ResponseInnerWarningsCalculatedDpiEnum = typeof GetEvidences200ResponseInnerWarningsCalculatedDpiEnum[keyof typeof GetEvidences200ResponseInnerWarningsCalculatedDpiEnum];
export const GetEvidences200ResponseInnerWarningsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type GetEvidences200ResponseInnerWarningsColorGradationEnum = typeof GetEvidences200ResponseInnerWarningsColorGradationEnum[keyof typeof GetEvidences200ResponseInnerWarningsColorGradationEnum];
export const GetEvidences200ResponseInnerWarningsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetEvidences200ResponseInnerWarningsHeightMillisEnum = typeof GetEvidences200ResponseInnerWarningsHeightMillisEnum[keyof typeof GetEvidences200ResponseInnerWarningsHeightMillisEnum];
export const GetEvidences200ResponseInnerWarningsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetEvidences200ResponseInnerWarningsWidthMillisEnum = typeof GetEvidences200ResponseInnerWarningsWidthMillisEnum[keyof typeof GetEvidences200ResponseInnerWarningsWidthMillisEnum];

/**
 * 
 * @export
 * @interface GetEvidencesCount200Response
 */
export interface GetEvidencesCount200Response {
    /**
     * 
     * @type {number}
     * @memberof GetEvidencesCount200Response
     */
    'count': number;
}
/**
 * @type GetFraudLockedCardTransactions200ResponseInner
 * @export
 */
export type GetFraudLockedCardTransactions200ResponseInner = GetFraudLockedCardTransactions200ResponseInnerOneOf | GetFraudLockedCardTransactions200ResponseInnerOneOf1;

/**
 * 
 * @export
 * @interface GetFraudLockedCardTransactions200ResponseInnerOneOf
 */
export interface GetFraudLockedCardTransactions200ResponseInnerOneOf {
    /**
     * 
     * @type {GetFraudLockedCardTransactions200ResponseInnerOneOfCardTransaction}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOf
     */
    'cardTransaction': GetFraudLockedCardTransactions200ResponseInnerOneOfCardTransaction;
    /**
     * 
     * @type {GetFraudLockedCardTransactions200ResponseInnerOneOfCardTransactionEvidenceStatus}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOf
     */
    'cardTransactionEvidenceStatus': GetFraudLockedCardTransactions200ResponseInnerOneOfCardTransactionEvidenceStatus;
    /**
     * 
     * @type {Array<GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInner>}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOf
     */
    'evidenceList': Array<GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInner>;
    /**
     * 
     * @type {Array<GetFraudLockedCardTransactions200ResponseInnerOneOfRequestHistoryInner>}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOf
     */
    'requestHistory': Array<GetFraudLockedCardTransactions200ResponseInnerOneOfRequestHistoryInner>;
    /**
     * 
     * @type {GetFraudLockedCardTransactions200ResponseInnerOneOfComment}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOf
     */
    'comment'?: GetFraudLockedCardTransactions200ResponseInnerOneOfComment;
    /**
     * 
     * @type {GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceRemindStatus}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOf
     */
    'evidenceRemindStatus': GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceRemindStatus;
    /**
     * 
     * @type {GetFraudLockedCardTransactions200ResponseInnerOneOfUserAccount}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOf
     */
    'userAccount': GetFraudLockedCardTransactions200ResponseInnerOneOfUserAccount;
    /**
     * 
     * @type {Array<GetFraudLockedCardTransactions200ResponseInnerOneOfPurchaseApplicationsInner>}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOf
     */
    'purchaseApplications': Array<GetFraudLockedCardTransactions200ResponseInnerOneOfPurchaseApplicationsInner>;
}
/**
 * 
 * @export
 * @interface GetFraudLockedCardTransactions200ResponseInnerOneOf1
 */
export interface GetFraudLockedCardTransactions200ResponseInnerOneOf1 {
    /**
     * 
     * @type {GetFraudLockedCardTransactions200ResponseInnerOneOf1CardTransaction}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOf1
     */
    'cardTransaction': GetFraudLockedCardTransactions200ResponseInnerOneOf1CardTransaction;
    /**
     * 
     * @type {GetFraudLockedCardTransactions200ResponseInnerOneOf1Comment}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOf1
     */
    'comment'?: GetFraudLockedCardTransactions200ResponseInnerOneOf1Comment;
    /**
     * 
     * @type {GetFraudLockedCardTransactions200ResponseInnerOneOf1UserAccount}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOf1
     */
    'userAccount': GetFraudLockedCardTransactions200ResponseInnerOneOf1UserAccount;
}
/**
 * 
 * @export
 * @interface GetFraudLockedCardTransactions200ResponseInnerOneOf1CardTransaction
 */
export interface GetFraudLockedCardTransactions200ResponseInnerOneOf1CardTransaction {
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOf1CardTransaction
     */
    'visaTransactionReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOf1CardTransaction
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOf1CardTransaction
     */
    'merchantName': string;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOf1CardTransaction
     */
    'merchantNameKana': string;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOf1CardTransaction
     */
    'merchantNameKanji': string;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOf1CardTransaction
     */
    'mergedMerchantName': string;
    /**
     * 
     * @type {number}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOf1CardTransaction
     */
    'amount': number;
    /**
     * 
     * @type {number}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOf1CardTransaction
     */
    'amountFx': number;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOf1CardTransaction
     */
    'currencyCode': string;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOf1CardTransaction
     */
    'failureReason': string;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOf1CardTransaction
     */
    'processedAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOf1CardTransaction
     */
    'transactionType': GetFraudLockedCardTransactions200ResponseInnerOneOf1CardTransactionTransactionTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOf1CardTransaction
     */
    'transactionStatus': GetFraudLockedCardTransactions200ResponseInnerOneOf1CardTransactionTransactionStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOf1CardTransaction
     */
    'creditSettlement': number;
    /**
     * 
     * @type {Array<GetFraudLockedCardTransactions200ResponseInnerOneOf1CardTransactionTransactionRecordListInner>}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOf1CardTransaction
     */
    'transactionRecordList': Array<GetFraudLockedCardTransactions200ResponseInnerOneOf1CardTransactionTransactionRecordListInner>;
}

export const GetFraudLockedCardTransactions200ResponseInnerOneOf1CardTransactionTransactionTypeEnum = {
    confirm: 'CONFIRM',
    notConfirm: 'NOT_CONFIRM'
} as const;

export type GetFraudLockedCardTransactions200ResponseInnerOneOf1CardTransactionTransactionTypeEnum = typeof GetFraudLockedCardTransactions200ResponseInnerOneOf1CardTransactionTransactionTypeEnum[keyof typeof GetFraudLockedCardTransactions200ResponseInnerOneOf1CardTransactionTransactionTypeEnum];
export const GetFraudLockedCardTransactions200ResponseInnerOneOf1CardTransactionTransactionStatusEnum = {
    fail: 'FAIL'
} as const;

export type GetFraudLockedCardTransactions200ResponseInnerOneOf1CardTransactionTransactionStatusEnum = typeof GetFraudLockedCardTransactions200ResponseInnerOneOf1CardTransactionTransactionStatusEnum[keyof typeof GetFraudLockedCardTransactions200ResponseInnerOneOf1CardTransactionTransactionStatusEnum];

/**
 * 
 * @export
 * @interface GetFraudLockedCardTransactions200ResponseInnerOneOf1CardTransactionTransactionRecordListInner
 */
export interface GetFraudLockedCardTransactions200ResponseInnerOneOf1CardTransactionTransactionRecordListInner {
    /**
     * 
     * @type {number}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOf1CardTransactionTransactionRecordListInner
     */
    'amount': number;
    /**
     * 
     * @type {number}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOf1CardTransactionTransactionRecordListInner
     */
    'amountFx': number;
    /**
     * 
     * @type {number}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOf1CardTransactionTransactionRecordListInner
     */
    'totalAmount': number;
    /**
     * 
     * @type {number}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOf1CardTransactionTransactionRecordListInner
     */
    'totalAmountFx': number;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOf1CardTransactionTransactionRecordListInner
     */
    'currencyCode': string;
    /**
     * 
     * @type {number}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOf1CardTransactionTransactionRecordListInner
     */
    'fxRate': number | null;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOf1CardTransactionTransactionRecordListInner
     */
    'processedAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOf1CardTransactionTransactionRecordListInner
     */
    'transactionDetailType': GetFraudLockedCardTransactions200ResponseInnerOneOf1CardTransactionTransactionRecordListInnerTransactionDetailTypeEnum;
}

export const GetFraudLockedCardTransactions200ResponseInnerOneOf1CardTransactionTransactionRecordListInnerTransactionDetailTypeEnum = {
    purchase: 'PURCHASE',
    settlement: 'SETTLEMENT',
    validation: 'VALIDATION',
    refund: 'REFUND',
    cancel: 'CANCEL',
    refundCancel: 'REFUND_CANCEL',
    refundPartialCancel: 'REFUND_PARTIAL_CANCEL'
} as const;

export type GetFraudLockedCardTransactions200ResponseInnerOneOf1CardTransactionTransactionRecordListInnerTransactionDetailTypeEnum = typeof GetFraudLockedCardTransactions200ResponseInnerOneOf1CardTransactionTransactionRecordListInnerTransactionDetailTypeEnum[keyof typeof GetFraudLockedCardTransactions200ResponseInnerOneOf1CardTransactionTransactionRecordListInnerTransactionDetailTypeEnum];

/**
 * 
 * @export
 * @interface GetFraudLockedCardTransactions200ResponseInnerOneOf1Comment
 */
export interface GetFraudLockedCardTransactions200ResponseInnerOneOf1Comment {
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOf1Comment
     */
    'cardTransactionCommentId': string;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOf1Comment
     */
    'visaTransactionReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOf1Comment
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOf1Comment
     */
    'comment': string;
    /**
     * 
     * @type {GetFraudLockedCardTransactions200ResponseInnerOneOf1CommentCreatedBy}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOf1Comment
     */
    'createdBy': GetFraudLockedCardTransactions200ResponseInnerOneOf1CommentCreatedBy;
}
/**
 * 
 * @export
 * @interface GetFraudLockedCardTransactions200ResponseInnerOneOf1CommentCreatedBy
 */
export interface GetFraudLockedCardTransactions200ResponseInnerOneOf1CommentCreatedBy {
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOf1CommentCreatedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOf1CommentCreatedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetFraudLockedCardTransactions200ResponseInnerOneOf1UserAccount
 */
export interface GetFraudLockedCardTransactions200ResponseInnerOneOf1UserAccount {
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOf1UserAccount
     */
    'userAccountId': string;
    /**
     * 
     * @type {GetFraudLockedCardTransactions200ResponseInnerOneOf1UserAccountUser}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOf1UserAccount
     */
    'user': GetFraudLockedCardTransactions200ResponseInnerOneOf1UserAccountUser;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOf1UserAccount
     */
    'cardLabel': string;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOf1UserAccount
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOf1UserAccount
     */
    'organizationName': string;
    /**
     * 
     * @type {GetFraudLockedCardTransactions200ResponseInnerOneOf1UserAccountUserAccountGroup}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOf1UserAccount
     */
    'userAccountGroup': GetFraudLockedCardTransactions200ResponseInnerOneOf1UserAccountUserAccountGroup | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOf1UserAccount
     */
    'isOnDemand': boolean;
}
/**
 * 
 * @export
 * @interface GetFraudLockedCardTransactions200ResponseInnerOneOf1UserAccountUser
 */
export interface GetFraudLockedCardTransactions200ResponseInnerOneOf1UserAccountUser {
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOf1UserAccountUser
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOf1UserAccountUser
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOf1UserAccountUser
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOf1UserAccountUser
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOf1UserAccountUser
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOf1UserAccountUser
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOf1UserAccountUser
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOf1UserAccountUser
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOf1UserAccountUser
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOf1UserAccountUser
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOf1UserAccountUser
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface GetFraudLockedCardTransactions200ResponseInnerOneOf1UserAccountUserAccountGroup
 */
export interface GetFraudLockedCardTransactions200ResponseInnerOneOf1UserAccountUserAccountGroup {
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOf1UserAccountUserAccountGroup
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOf1UserAccountUserAccountGroup
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOf1UserAccountUserAccountGroup
     */
    'sortNum': number;
}
/**
 * 
 * @export
 * @interface GetFraudLockedCardTransactions200ResponseInnerOneOfCardTransaction
 */
export interface GetFraudLockedCardTransactions200ResponseInnerOneOfCardTransaction {
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfCardTransaction
     */
    'visaTransactionReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfCardTransaction
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfCardTransaction
     */
    'merchantName': string;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfCardTransaction
     */
    'merchantNameKana': string;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfCardTransaction
     */
    'merchantNameKanji': string;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfCardTransaction
     */
    'mergedMerchantName': string;
    /**
     * 
     * @type {number}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfCardTransaction
     */
    'amount': number;
    /**
     * 
     * @type {number}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfCardTransaction
     */
    'amountFx': number;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfCardTransaction
     */
    'currencyCode': string;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfCardTransaction
     */
    'processedAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfCardTransaction
     */
    'transactionType': GetFraudLockedCardTransactions200ResponseInnerOneOfCardTransactionTransactionTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfCardTransaction
     */
    'transactionStatus': GetFraudLockedCardTransactions200ResponseInnerOneOfCardTransactionTransactionStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfCardTransaction
     */
    'creditSettlement': number;
    /**
     * 
     * @type {Array<GetFraudLockedCardTransactions200ResponseInnerOneOfCardTransactionTransactionRecordListInner>}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfCardTransaction
     */
    'transactionRecordList': Array<GetFraudLockedCardTransactions200ResponseInnerOneOfCardTransactionTransactionRecordListInner>;
    /**
     * 
     * @type {boolean}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfCardTransaction
     */
    'isCleared': boolean;
}

export const GetFraudLockedCardTransactions200ResponseInnerOneOfCardTransactionTransactionTypeEnum = {
    confirm: 'CONFIRM',
    notConfirm: 'NOT_CONFIRM'
} as const;

export type GetFraudLockedCardTransactions200ResponseInnerOneOfCardTransactionTransactionTypeEnum = typeof GetFraudLockedCardTransactions200ResponseInnerOneOfCardTransactionTransactionTypeEnum[keyof typeof GetFraudLockedCardTransactions200ResponseInnerOneOfCardTransactionTransactionTypeEnum];
export const GetFraudLockedCardTransactions200ResponseInnerOneOfCardTransactionTransactionStatusEnum = {
    success: 'SUCCESS'
} as const;

export type GetFraudLockedCardTransactions200ResponseInnerOneOfCardTransactionTransactionStatusEnum = typeof GetFraudLockedCardTransactions200ResponseInnerOneOfCardTransactionTransactionStatusEnum[keyof typeof GetFraudLockedCardTransactions200ResponseInnerOneOfCardTransactionTransactionStatusEnum];

/**
 * 
 * @export
 * @interface GetFraudLockedCardTransactions200ResponseInnerOneOfCardTransactionEvidenceStatus
 */
export interface GetFraudLockedCardTransactions200ResponseInnerOneOfCardTransactionEvidenceStatus {
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfCardTransactionEvidenceStatus
     */
    'visaTransactionReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfCardTransactionEvidenceStatus
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfCardTransactionEvidenceStatus
     */
    'isRequested': boolean;
    /**
     * 
     * @type {GetFraudLockedCardTransactions200ResponseInnerOneOfCardTransactionEvidenceStatusRequestedBy}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfCardTransactionEvidenceStatus
     */
    'requestedBy': GetFraudLockedCardTransactions200ResponseInnerOneOfCardTransactionEvidenceStatusRequestedBy | null;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfCardTransactionEvidenceStatus
     */
    'requestedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfCardTransactionEvidenceStatus
     */
    'isLocked': boolean;
    /**
     * 
     * @type {GetFraudLockedCardTransactions200ResponseInnerOneOfCardTransactionEvidenceStatusLockedBy}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfCardTransactionEvidenceStatus
     */
    'lockedBy': GetFraudLockedCardTransactions200ResponseInnerOneOfCardTransactionEvidenceStatusLockedBy | null;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfCardTransactionEvidenceStatus
     */
    'lockedAt': string;
}
/**
 * 
 * @export
 * @interface GetFraudLockedCardTransactions200ResponseInnerOneOfCardTransactionEvidenceStatusLockedBy
 */
export interface GetFraudLockedCardTransactions200ResponseInnerOneOfCardTransactionEvidenceStatusLockedBy {
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfCardTransactionEvidenceStatusLockedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfCardTransactionEvidenceStatusLockedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetFraudLockedCardTransactions200ResponseInnerOneOfCardTransactionEvidenceStatusRequestedBy
 */
export interface GetFraudLockedCardTransactions200ResponseInnerOneOfCardTransactionEvidenceStatusRequestedBy {
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfCardTransactionEvidenceStatusRequestedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfCardTransactionEvidenceStatusRequestedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetFraudLockedCardTransactions200ResponseInnerOneOfCardTransactionTransactionRecordListInner
 */
export interface GetFraudLockedCardTransactions200ResponseInnerOneOfCardTransactionTransactionRecordListInner {
    /**
     * 
     * @type {number}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfCardTransactionTransactionRecordListInner
     */
    'amount': number;
    /**
     * 
     * @type {number}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfCardTransactionTransactionRecordListInner
     */
    'amountFx': number;
    /**
     * 
     * @type {number}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfCardTransactionTransactionRecordListInner
     */
    'totalAmount': number;
    /**
     * 
     * @type {number}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfCardTransactionTransactionRecordListInner
     */
    'totalAmountFx': number;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfCardTransactionTransactionRecordListInner
     */
    'currencyCode': string;
    /**
     * 
     * @type {number}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfCardTransactionTransactionRecordListInner
     */
    'fxRate': number | null;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfCardTransactionTransactionRecordListInner
     */
    'processedAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfCardTransactionTransactionRecordListInner
     */
    'transactionDetailType': GetFraudLockedCardTransactions200ResponseInnerOneOfCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfCardTransactionTransactionRecordListInner
     */
    'isCleared': boolean;
}

export const GetFraudLockedCardTransactions200ResponseInnerOneOfCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum = {
    purchase: 'PURCHASE',
    settlement: 'SETTLEMENT',
    validation: 'VALIDATION',
    refund: 'REFUND',
    cancel: 'CANCEL',
    refundCancel: 'REFUND_CANCEL',
    refundPartialCancel: 'REFUND_PARTIAL_CANCEL'
} as const;

export type GetFraudLockedCardTransactions200ResponseInnerOneOfCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum = typeof GetFraudLockedCardTransactions200ResponseInnerOneOfCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum[keyof typeof GetFraudLockedCardTransactions200ResponseInnerOneOfCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum];

/**
 * 
 * @export
 * @interface GetFraudLockedCardTransactions200ResponseInnerOneOfComment
 */
export interface GetFraudLockedCardTransactions200ResponseInnerOneOfComment {
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfComment
     */
    'cardTransactionCommentId': string;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfComment
     */
    'visaTransactionReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfComment
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfComment
     */
    'comment': string;
    /**
     * 
     * @type {GetFraudLockedCardTransactions200ResponseInnerOneOfCommentCreatedBy}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfComment
     */
    'createdBy': GetFraudLockedCardTransactions200ResponseInnerOneOfCommentCreatedBy;
}
/**
 * 
 * @export
 * @interface GetFraudLockedCardTransactions200ResponseInnerOneOfCommentCreatedBy
 */
export interface GetFraudLockedCardTransactions200ResponseInnerOneOfCommentCreatedBy {
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfCommentCreatedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfCommentCreatedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInner
 */
export interface GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInner {
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInner
     * @deprecated
     */
    'cardTransactionEvidenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInner
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInner
     * @deprecated
     */
    'visaTransactionReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInner
     */
    'paymentType': GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerPaymentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInner
     */
    'fileName': string;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInner
     */
    'fileExtension': string;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInner
     */
    'electronicMethod': GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerElectronicMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInner
     */
    'documentSize': GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerDocumentSizeEnum;
    /**
     * 
     * @type {number}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInner
     * @deprecated
     */
    'dpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInner
     */
    'detectedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInner
     */
    'calculatedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInner
     */
    'colorGradation': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInner
     */
    'verticalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInner
     */
    'horizontalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInner
     */
    'heightMillis': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInner
     */
    'widthMillis': number | null;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInner
     */
    'legalValidity': GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerLegalValidityEnum;
    /**
     * 
     * @type {boolean}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInner
     */
    'dpiForciblyValid': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInner
     */
    'colorGradationForciblyValid': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInner
     */
    'note': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInner
     */
    'irrelevantToLedger': boolean;
    /**
     * 
     * @type {GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerInvoiceIssuer}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInner
     */
    'invoiceIssuer': GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerInvoiceIssuer | null;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInner
     * @deprecated
     */
    'dpiError': GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerDpiErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInner
     * @deprecated
     */
    'detectedDpiError': GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerDetectedDpiErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInner
     * @deprecated
     */
    'calculatedDpiError': GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerCalculatedDpiErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInner
     * @deprecated
     */
    'colorGradationError': GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerColorGradationErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInner
     * @deprecated
     */
    'heightMillisError': GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerHeightMillisErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInner
     * @deprecated
     */
    'widthMillisError': GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerWidthMillisErrorEnum;
    /**
     * 
     * @type {GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerErrors}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInner
     */
    'errors': GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerErrors;
    /**
     * 
     * @type {GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerWarnings}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInner
     */
    'warnings': GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerWarnings;
    /**
     * 
     * @type {GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerCreatedBy}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInner
     */
    'createdBy': GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerCreatedBy;
    /**
     * 
     * @type {GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerUpdatedBy}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInner
     */
    'updatedBy': GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerUpdatedBy;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInner
     */
    'updatedAt': string;
    /**
     * 
     * @type {GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerUploadedBy}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInner
     */
    'uploadedBy': GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerUploadedBy;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInner
     */
    'uploadedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInner
     */
    'uploadedByRecipient': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInner
     */
    'needsMigration': boolean | null;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInner
     */
    'uploadedFrom': string;
}

export const GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerPaymentTypeEnum = {
    cardTransaction: 'CARD_TRANSACTION',
    paymentRequest: 'PAYMENT_REQUEST'
} as const;

export type GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerPaymentTypeEnum = typeof GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerPaymentTypeEnum[keyof typeof GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerPaymentTypeEnum];
export const GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerElectronicMethodEnum = {
    fullElectronic: 'FULL_ELECTRONIC',
    originallyPaper: 'ORIGINALLY_PAPER',
    unknown: 'UNKNOWN'
} as const;

export type GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerElectronicMethodEnum = typeof GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerElectronicMethodEnum[keyof typeof GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerElectronicMethodEnum];
export const GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerDocumentSizeEnum = {
    overA4: 'OVER_A4',
    a4OrSmaller: 'A4_OR_SMALLER',
    unknown: 'UNKNOWN'
} as const;

export type GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerDocumentSizeEnum = typeof GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerDocumentSizeEnum[keyof typeof GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerDocumentSizeEnum];
export const GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerLegalValidityEnum = {
    valid: 'VALID',
    invalid: 'INVALID',
    inputRequired: 'INPUT_REQUIRED',
    outOfTarget: 'OUT_OF_TARGET'
} as const;

export type GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerLegalValidityEnum = typeof GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerLegalValidityEnum[keyof typeof GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerLegalValidityEnum];
export const GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerDpiErrorEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerDpiErrorEnum = typeof GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerDpiErrorEnum[keyof typeof GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerDpiErrorEnum];
export const GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerDetectedDpiErrorEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerDetectedDpiErrorEnum = typeof GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerDetectedDpiErrorEnum[keyof typeof GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerDetectedDpiErrorEnum];
export const GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerCalculatedDpiErrorEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerCalculatedDpiErrorEnum = typeof GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerCalculatedDpiErrorEnum[keyof typeof GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerCalculatedDpiErrorEnum];
export const GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerColorGradationErrorEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerColorGradationErrorEnum = typeof GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerColorGradationErrorEnum[keyof typeof GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerColorGradationErrorEnum];
export const GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerHeightMillisErrorEnum = {
    required: 'REQUIRED'
} as const;

export type GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerHeightMillisErrorEnum = typeof GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerHeightMillisErrorEnum[keyof typeof GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerHeightMillisErrorEnum];
export const GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerWidthMillisErrorEnum = {
    required: 'REQUIRED'
} as const;

export type GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerWidthMillisErrorEnum = typeof GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerWidthMillisErrorEnum[keyof typeof GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerWidthMillisErrorEnum];

/**
 * 
 * @export
 * @interface GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerCreatedBy
 */
export interface GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerCreatedBy {
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerCreatedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerCreatedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerErrors
 */
export interface GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerErrors {
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerErrors
     */
    'detectedDpi'?: GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerErrorsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerErrors
     */
    'calculatedDpi'?: GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerErrorsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerErrors
     */
    'colorGradation'?: GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerErrorsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerErrors
     */
    'heightMillis'?: GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerErrorsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerErrors
     */
    'widthMillis'?: GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerErrorsWidthMillisEnum;
}

export const GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerErrorsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerErrorsDetectedDpiEnum = typeof GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerErrorsDetectedDpiEnum[keyof typeof GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerErrorsDetectedDpiEnum];
export const GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerErrorsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerErrorsCalculatedDpiEnum = typeof GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerErrorsCalculatedDpiEnum[keyof typeof GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerErrorsCalculatedDpiEnum];
export const GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerErrorsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerErrorsColorGradationEnum = typeof GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerErrorsColorGradationEnum[keyof typeof GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerErrorsColorGradationEnum];
export const GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerErrorsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerErrorsHeightMillisEnum = typeof GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerErrorsHeightMillisEnum[keyof typeof GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerErrorsHeightMillisEnum];
export const GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerErrorsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerErrorsWidthMillisEnum = typeof GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerErrorsWidthMillisEnum[keyof typeof GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerErrorsWidthMillisEnum];

/**
 * Set null if it\'s evidence not analyzed using invoicing-system-compliance feature. Also set null if invoicing-system-compliance feature has been made not available for the organization by the feature-flag.
 * @export
 * @interface GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerInvoiceIssuer
 */
export interface GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerInvoiceIssuer {
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerInvoiceIssuer
     */
    'name': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerInvoiceIssuer
     */
    'registrationNumber': string | null;
    /**
     * isQualified retains the result of querying the 国税庁API to see if registrationNumber is qualified, as is.
     * @type {boolean}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerInvoiceIssuer
     */
    'isQualified': boolean;
    /**
     * AsQualified indicates whether this issuer should be treated as a qualified invoice issuer within the user\'s system, even if the RegistrationNumber is not confirmed as qualified in the National Tax Agency\'s business registration system.
     * @type {boolean}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerInvoiceIssuer
     */
    'asQualified': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerInvoiceIssuer
     */
    'partnerId': string | null;
}
/**
 * 
 * @export
 * @interface GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerUpdatedBy
 */
export interface GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerUpdatedBy {
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerUpdatedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerUpdatedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerUploadedBy
 */
export interface GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerUploadedBy {
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerUploadedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerUploadedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerWarnings
 */
export interface GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerWarnings {
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerWarnings
     */
    'detectedDpi'?: GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerWarningsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerWarnings
     */
    'calculatedDpi'?: GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerWarningsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerWarnings
     */
    'colorGradation'?: GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerWarningsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerWarnings
     */
    'heightMillis'?: GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerWarningsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerWarnings
     */
    'widthMillis'?: GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerWarningsWidthMillisEnum;
}

export const GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerWarningsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerWarningsDetectedDpiEnum = typeof GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerWarningsDetectedDpiEnum[keyof typeof GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerWarningsDetectedDpiEnum];
export const GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerWarningsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerWarningsCalculatedDpiEnum = typeof GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerWarningsCalculatedDpiEnum[keyof typeof GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerWarningsCalculatedDpiEnum];
export const GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerWarningsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerWarningsColorGradationEnum = typeof GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerWarningsColorGradationEnum[keyof typeof GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerWarningsColorGradationEnum];
export const GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerWarningsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerWarningsHeightMillisEnum = typeof GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerWarningsHeightMillisEnum[keyof typeof GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerWarningsHeightMillisEnum];
export const GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerWarningsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerWarningsWidthMillisEnum = typeof GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerWarningsWidthMillisEnum[keyof typeof GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceListInnerWarningsWidthMillisEnum];

/**
 * 
 * @export
 * @interface GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceRemindStatus
 */
export interface GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceRemindStatus {
    /**
     * 
     * @type {boolean}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfEvidenceRemindStatus
     */
    'isAutoRemind': boolean;
}
/**
 * 
 * @export
 * @interface GetFraudLockedCardTransactions200ResponseInnerOneOfPurchaseApplicationsInner
 */
export interface GetFraudLockedCardTransactions200ResponseInnerOneOfPurchaseApplicationsInner {
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfPurchaseApplicationsInner
     */
    'applicationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfPurchaseApplicationsInner
     */
    'applicationNumber': string;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfPurchaseApplicationsInner
     */
    'paymentDate': string;
    /**
     * 
     * @type {GetFraudLockedCardTransactions200ResponseInnerOneOfPurchaseApplicationsInnerSubmittedBy}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfPurchaseApplicationsInner
     */
    'submittedBy': GetFraudLockedCardTransactions200ResponseInnerOneOfPurchaseApplicationsInnerSubmittedBy;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfPurchaseApplicationsInner
     */
    'submittedAt': string;
    /**
     * 
     * @type {Array<GetFraudLockedCardTransactions200ResponseInnerOneOfPurchaseApplicationsInnerApproversInner>}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfPurchaseApplicationsInner
     */
    'approvers': Array<GetFraudLockedCardTransactions200ResponseInnerOneOfPurchaseApplicationsInnerApproversInner>;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfPurchaseApplicationsInner
     */
    'department': string;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfPurchaseApplicationsInner
     */
    'purchaseReason': string;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfPurchaseApplicationsInner
     */
    'purchaseDetails': string;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfPurchaseApplicationsInner
     */
    'placeOfUse': string;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfPurchaseApplicationsInner
     */
    'purposeOfUse': string;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfPurchaseApplicationsInner
     */
    'url': string;
    /**
     * 
     * @type {number}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfPurchaseApplicationsInner
     */
    'amount': number;
    /**
     * 
     * @type {GetFraudLockedCardTransactions200ResponseInnerOneOfPurchaseApplicationsInnerUserAccount}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfPurchaseApplicationsInner
     */
    'userAccount': GetFraudLockedCardTransactions200ResponseInnerOneOfPurchaseApplicationsInnerUserAccount | null;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfPurchaseApplicationsInner
     */
    'remarks': string;
    /**
     * 
     * @type {GetFraudLockedCardTransactions200ResponseInnerOneOfPurchaseApplicationsInnerWorkRequestedBy}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfPurchaseApplicationsInner
     */
    'workRequestedBy': GetFraudLockedCardTransactions200ResponseInnerOneOfPurchaseApplicationsInnerWorkRequestedBy;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfPurchaseApplicationsInner
     */
    'workRequestApprovers': string;
    /**
     * 
     * @type {GetFraudLockedCardTransactions200ResponseInnerOneOfPurchaseApplicationsInnerStatus}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfPurchaseApplicationsInner
     */
    'status': GetFraudLockedCardTransactions200ResponseInnerOneOfPurchaseApplicationsInnerStatus;
    /**
     * 
     * @type {GetFraudLockedCardTransactions200ResponseInnerOneOfPurchaseApplicationsInnerCreatedBy}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfPurchaseApplicationsInner
     */
    'createdBy': GetFraudLockedCardTransactions200ResponseInnerOneOfPurchaseApplicationsInnerCreatedBy;
}
/**
 * 
 * @export
 * @interface GetFraudLockedCardTransactions200ResponseInnerOneOfPurchaseApplicationsInnerApproversInner
 */
export interface GetFraudLockedCardTransactions200ResponseInnerOneOfPurchaseApplicationsInnerApproversInner {
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfPurchaseApplicationsInnerApproversInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfPurchaseApplicationsInnerApproversInner
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetFraudLockedCardTransactions200ResponseInnerOneOfPurchaseApplicationsInnerCreatedBy
 */
export interface GetFraudLockedCardTransactions200ResponseInnerOneOfPurchaseApplicationsInnerCreatedBy {
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfPurchaseApplicationsInnerCreatedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfPurchaseApplicationsInnerCreatedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetFraudLockedCardTransactions200ResponseInnerOneOfPurchaseApplicationsInnerStatus
 */
export interface GetFraudLockedCardTransactions200ResponseInnerOneOfPurchaseApplicationsInnerStatus {
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfPurchaseApplicationsInnerStatus
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfPurchaseApplicationsInnerStatus
     */
    'comment': string;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfPurchaseApplicationsInnerStatus
     */
    'statusChangedAt': string;
    /**
     * 
     * @type {GetFraudLockedCardTransactions200ResponseInnerOneOfPurchaseApplicationsInnerStatusCreatedBy}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfPurchaseApplicationsInnerStatus
     */
    'createdBy': GetFraudLockedCardTransactions200ResponseInnerOneOfPurchaseApplicationsInnerStatusCreatedBy;
}
/**
 * 
 * @export
 * @interface GetFraudLockedCardTransactions200ResponseInnerOneOfPurchaseApplicationsInnerStatusCreatedBy
 */
export interface GetFraudLockedCardTransactions200ResponseInnerOneOfPurchaseApplicationsInnerStatusCreatedBy {
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfPurchaseApplicationsInnerStatusCreatedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfPurchaseApplicationsInnerStatusCreatedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetFraudLockedCardTransactions200ResponseInnerOneOfPurchaseApplicationsInnerSubmittedBy
 */
export interface GetFraudLockedCardTransactions200ResponseInnerOneOfPurchaseApplicationsInnerSubmittedBy {
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfPurchaseApplicationsInnerSubmittedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfPurchaseApplicationsInnerSubmittedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetFraudLockedCardTransactions200ResponseInnerOneOfPurchaseApplicationsInnerUserAccount
 */
export interface GetFraudLockedCardTransactions200ResponseInnerOneOfPurchaseApplicationsInnerUserAccount {
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfPurchaseApplicationsInnerUserAccount
     */
    'userAccountId': string;
    /**
     * 
     * @type {GetFraudLockedCardTransactions200ResponseInnerOneOfPurchaseApplicationsInnerUserAccountUser}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfPurchaseApplicationsInnerUserAccount
     */
    'user': GetFraudLockedCardTransactions200ResponseInnerOneOfPurchaseApplicationsInnerUserAccountUser;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfPurchaseApplicationsInnerUserAccount
     */
    'cardLabel': string;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfPurchaseApplicationsInnerUserAccount
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfPurchaseApplicationsInnerUserAccount
     */
    'organizationName': string;
    /**
     * 
     * @type {GetFraudLockedCardTransactions200ResponseInnerOneOfPurchaseApplicationsInnerUserAccountUserAccountGroup}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfPurchaseApplicationsInnerUserAccount
     */
    'userAccountGroup': GetFraudLockedCardTransactions200ResponseInnerOneOfPurchaseApplicationsInnerUserAccountUserAccountGroup | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfPurchaseApplicationsInnerUserAccount
     */
    'isOnDemand': boolean;
}
/**
 * 
 * @export
 * @interface GetFraudLockedCardTransactions200ResponseInnerOneOfPurchaseApplicationsInnerUserAccountUser
 */
export interface GetFraudLockedCardTransactions200ResponseInnerOneOfPurchaseApplicationsInnerUserAccountUser {
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfPurchaseApplicationsInnerUserAccountUser
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfPurchaseApplicationsInnerUserAccountUser
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfPurchaseApplicationsInnerUserAccountUser
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfPurchaseApplicationsInnerUserAccountUser
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfPurchaseApplicationsInnerUserAccountUser
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfPurchaseApplicationsInnerUserAccountUser
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfPurchaseApplicationsInnerUserAccountUser
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfPurchaseApplicationsInnerUserAccountUser
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfPurchaseApplicationsInnerUserAccountUser
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfPurchaseApplicationsInnerUserAccountUser
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfPurchaseApplicationsInnerUserAccountUser
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface GetFraudLockedCardTransactions200ResponseInnerOneOfPurchaseApplicationsInnerUserAccountUserAccountGroup
 */
export interface GetFraudLockedCardTransactions200ResponseInnerOneOfPurchaseApplicationsInnerUserAccountUserAccountGroup {
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfPurchaseApplicationsInnerUserAccountUserAccountGroup
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfPurchaseApplicationsInnerUserAccountUserAccountGroup
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfPurchaseApplicationsInnerUserAccountUserAccountGroup
     */
    'sortNum': number;
}
/**
 * 
 * @export
 * @interface GetFraudLockedCardTransactions200ResponseInnerOneOfPurchaseApplicationsInnerWorkRequestedBy
 */
export interface GetFraudLockedCardTransactions200ResponseInnerOneOfPurchaseApplicationsInnerWorkRequestedBy {
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfPurchaseApplicationsInnerWorkRequestedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfPurchaseApplicationsInnerWorkRequestedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetFraudLockedCardTransactions200ResponseInnerOneOfRequestHistoryInner
 */
export interface GetFraudLockedCardTransactions200ResponseInnerOneOfRequestHistoryInner {
    /**
     * 
     * @type {number}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfRequestHistoryInner
     */
    'requestId': number;
    /**
     * 
     * @type {GetFraudLockedCardTransactions200ResponseInnerOneOfRequestHistoryInnerRequestedBy}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfRequestHistoryInner
     */
    'requestedBy': GetFraudLockedCardTransactions200ResponseInnerOneOfRequestHistoryInnerRequestedBy;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfRequestHistoryInner
     */
    'requestedAt': string;
}
/**
 * 
 * @export
 * @interface GetFraudLockedCardTransactions200ResponseInnerOneOfRequestHistoryInnerRequestedBy
 */
export interface GetFraudLockedCardTransactions200ResponseInnerOneOfRequestHistoryInnerRequestedBy {
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfRequestHistoryInnerRequestedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfRequestHistoryInnerRequestedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetFraudLockedCardTransactions200ResponseInnerOneOfUserAccount
 */
export interface GetFraudLockedCardTransactions200ResponseInnerOneOfUserAccount {
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfUserAccount
     */
    'userAccountId': string;
    /**
     * 
     * @type {GetFraudLockedCardTransactions200ResponseInnerOneOfUserAccountUser}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfUserAccount
     */
    'user': GetFraudLockedCardTransactions200ResponseInnerOneOfUserAccountUser;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfUserAccount
     */
    'cardLabel': string;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfUserAccount
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfUserAccount
     */
    'organizationName': string;
    /**
     * 
     * @type {GetFraudLockedCardTransactions200ResponseInnerOneOfUserAccountUserAccountGroup}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfUserAccount
     */
    'userAccountGroup': GetFraudLockedCardTransactions200ResponseInnerOneOfUserAccountUserAccountGroup | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfUserAccount
     */
    'isOnDemand': boolean;
}
/**
 * 
 * @export
 * @interface GetFraudLockedCardTransactions200ResponseInnerOneOfUserAccountUser
 */
export interface GetFraudLockedCardTransactions200ResponseInnerOneOfUserAccountUser {
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfUserAccountUser
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfUserAccountUser
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfUserAccountUser
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfUserAccountUser
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfUserAccountUser
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfUserAccountUser
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfUserAccountUser
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfUserAccountUser
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfUserAccountUser
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfUserAccountUser
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfUserAccountUser
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface GetFraudLockedCardTransactions200ResponseInnerOneOfUserAccountUserAccountGroup
 */
export interface GetFraudLockedCardTransactions200ResponseInnerOneOfUserAccountUserAccountGroup {
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfUserAccountUserAccountGroup
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfUserAccountUserAccountGroup
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof GetFraudLockedCardTransactions200ResponseInnerOneOfUserAccountUserAccountGroup
     */
    'sortNum': number;
}
/**
 * 
 * @export
 * @interface GetFreeeAccountItems200ResponseInner
 */
export interface GetFreeeAccountItems200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetFreeeAccountItems200ResponseInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetFreeeAccountItems200ResponseInner
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetFreeeAccountItems200ResponseInner
     */
    'taxCode': string;
    /**
     * 
     * @type {string}
     * @memberof GetFreeeAccountItems200ResponseInner
     */
    'shortcut': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetFreeeAccountItems200ResponseInner
     */
    'shortcutNum': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetFreeeAccountItems200ResponseInner
     */
    'defaultTaxId': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetFreeeAccountItems200ResponseInner
     */
    'defaultTaxCode': string;
    /**
     * 
     * @type {string}
     * @memberof GetFreeeAccountItems200ResponseInner
     */
    'accountCategory': string;
    /**
     * 
     * @type {string}
     * @memberof GetFreeeAccountItems200ResponseInner
     */
    'accountCategoryId': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetFreeeAccountItems200ResponseInner
     */
    'categories': Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof GetFreeeAccountItems200ResponseInner
     */
    'available': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetFreeeAccountItems200ResponseInner
     */
    'walletableId': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetFreeeAccountItems200ResponseInner
     */
    'groupName': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetFreeeAccountItems200ResponseInner
     */
    'correspondingIncomeName': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetFreeeAccountItems200ResponseInner
     */
    'correspondingIncomeId': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetFreeeAccountItems200ResponseInner
     */
    'correspondingExpenseName': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetFreeeAccountItems200ResponseInner
     */
    'correspondingExpenseId': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetFreeeAccountItems200ResponseInner
     */
    'orphaned': boolean;
}
/**
 * 
 * @export
 * @interface GetFreeeCompanies200ResponseInner
 */
export interface GetFreeeCompanies200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetFreeeCompanies200ResponseInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetFreeeCompanies200ResponseInner
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetFreeeCompanies200ResponseInner
     */
    'nameKana': string;
    /**
     * 
     * @type {string}
     * @memberof GetFreeeCompanies200ResponseInner
     */
    'displayName': string;
    /**
     * 
     * @type {string}
     * @memberof GetFreeeCompanies200ResponseInner
     */
    'role': string;
}
/**
 * 
 * @export
 * @interface GetFreeeConnected200Response
 */
export interface GetFreeeConnected200Response {
    /**
     * 
     * @type {string}
     * @memberof GetFreeeConnected200Response
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetFreeeConnected200Response
     */
    'freeeCompanyId': string;
    /**
     * 
     * @type {string}
     * @memberof GetFreeeConnected200Response
     */
    'freeeCompanyName': string;
    /**
     * 
     * @type {string}
     * @memberof GetFreeeConnected200Response
     */
    'cardAccountUnit': GetFreeeConnected200ResponseCardAccountUnitEnum;
    /**
     * 
     * @type {string}
     * @memberof GetFreeeConnected200Response
     */
    'connectedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetFreeeConnected200Response
     */
    'isJournalFeatureEnabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetFreeeConnected200Response
     */
    'accountItemIdForPointUse': string;
    /**
     * 
     * @type {string}
     * @memberof GetFreeeConnected200Response
     */
    'journalEntryTransitionModeEndDate': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetFreeeConnected200Response
     */
    'journalEntryStartDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetFreeeConnected200Response
     */
    'embedUrlMethod'?: GetFreeeConnected200ResponseEmbedUrlMethodEnum;
    /**
     * Type of synchronization with freee
     * @type {string}
     * @memberof GetFreeeConnected200Response
     */
    'syncType': GetFreeeConnected200ResponseSyncTypeEnum;
}

export const GetFreeeConnected200ResponseCardAccountUnitEnum = {
    all: 'ALL',
    group: 'GROUP',
    single: 'SINGLE'
} as const;

export type GetFreeeConnected200ResponseCardAccountUnitEnum = typeof GetFreeeConnected200ResponseCardAccountUnitEnum[keyof typeof GetFreeeConnected200ResponseCardAccountUnitEnum];
export const GetFreeeConnected200ResponseEmbedUrlMethodEnum = {
    none: 'NONE',
    back: 'BACK',
    front: 'FRONT'
} as const;

export type GetFreeeConnected200ResponseEmbedUrlMethodEnum = typeof GetFreeeConnected200ResponseEmbedUrlMethodEnum[keyof typeof GetFreeeConnected200ResponseEmbedUrlMethodEnum];
export const GetFreeeConnected200ResponseSyncTypeEnum = {
    journalizeOnFreee: 'JOURNALIZE_ON_FREEE',
    journalizeOnUpsider: 'JOURNALIZE_ON_UPSIDER',
    composite: 'COMPOSITE'
} as const;

export type GetFreeeConnected200ResponseSyncTypeEnum = typeof GetFreeeConnected200ResponseSyncTypeEnum[keyof typeof GetFreeeConnected200ResponseSyncTypeEnum];

/**
 * 
 * @export
 * @interface GetFreeeConnectedUser200Response
 */
export interface GetFreeeConnectedUser200Response {
    /**
     * 
     * @type {string}
     * @memberof GetFreeeConnectedUser200Response
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof GetFreeeConnectedUser200Response
     */
    'displayName': string;
    /**
     * 
     * @type {string}
     * @memberof GetFreeeConnectedUser200Response
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof GetFreeeConnectedUser200Response
     */
    'lastName': string;
}
/**
 * 
 * @export
 * @interface GetFreeeItems200ResponseInner
 */
export interface GetFreeeItems200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetFreeeItems200ResponseInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetFreeeItems200ResponseInner
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetFreeeItems200ResponseInner
     */
    'updateData': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetFreeeItems200ResponseInner
     */
    'available': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetFreeeItems200ResponseInner
     */
    'shortcut1': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetFreeeItems200ResponseInner
     */
    'shortcut2': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetFreeeItems200ResponseInner
     */
    'orphaned': boolean;
}
/**
 * 
 * @export
 * @interface GetFreeeMemoTags200ResponseInner
 */
export interface GetFreeeMemoTags200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetFreeeMemoTags200ResponseInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetFreeeMemoTags200ResponseInner
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetFreeeMemoTags200ResponseInner
     */
    'updateDate': string;
    /**
     * 
     * @type {string}
     * @memberof GetFreeeMemoTags200ResponseInner
     */
    'shortcut1': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetFreeeMemoTags200ResponseInner
     */
    'shortcut2': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetFreeeMemoTags200ResponseInner
     */
    'orphaned': boolean;
}
/**
 * 
 * @export
 * @interface GetFreeePartners200ResponseInner
 */
export interface GetFreeePartners200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetFreeePartners200ResponseInner
     */
    'freeeCompanyId': string;
    /**
     * 
     * @type {string}
     * @memberof GetFreeePartners200ResponseInner
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetFreeePartners200ResponseInner
     */
    'freeePartnerId': string;
    /**
     * 
     * @type {string}
     * @memberof GetFreeePartners200ResponseInner
     */
    'freeePartnerCode': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetFreeePartners200ResponseInner
     */
    'orphaned': boolean;
}
/**
 * 
 * @export
 * @interface GetFreeeSections200ResponseInner
 */
export interface GetFreeeSections200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetFreeeSections200ResponseInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetFreeeSections200ResponseInner
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetFreeeSections200ResponseInner
     */
    'longName': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetFreeeSections200ResponseInner
     */
    'available': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetFreeeSections200ResponseInner
     */
    'shortcut1': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetFreeeSections200ResponseInner
     */
    'shortcut2': string | null;
    /**
     * 
     * @type {number}
     * @memberof GetFreeeSections200ResponseInner
     */
    'indentCount': number | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetFreeeSections200ResponseInner
     */
    'isLeaf': boolean;
    /**
     * 
     * @type {number}
     * @memberof GetFreeeSections200ResponseInner
     */
    'parentId': number | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetFreeeSections200ResponseInner
     */
    'orphaned': boolean;
}
/**
 * 
 * @export
 * @interface GetFreeeSegmentTags200ResponseInner
 */
export interface GetFreeeSegmentTags200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetFreeeSegmentTags200ResponseInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetFreeeSegmentTags200ResponseInner
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof GetFreeeSegmentTags200ResponseInner
     */
    'segmentId': number;
    /**
     * 
     * @type {string}
     * @memberof GetFreeeSegmentTags200ResponseInner
     */
    'description': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetFreeeSegmentTags200ResponseInner
     */
    'shortcut1': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetFreeeSegmentTags200ResponseInner
     */
    'shortcut2': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetFreeeSegmentTags200ResponseInner
     */
    'orphaned': boolean;
}
/**
 * 
 * @export
 * @interface GetFreeeSyncStatus200Response
 */
export interface GetFreeeSyncStatus200Response {
    /**
     * 
     * @type {Array<GetFreeeSyncStatus200ResponseErrorsInner>}
     * @memberof GetFreeeSyncStatus200Response
     */
    'errors': Array<GetFreeeSyncStatus200ResponseErrorsInner>;
    /**
     * 
     * @type {GetFreeeSyncStatus200ResponseRecovery}
     * @memberof GetFreeeSyncStatus200Response
     */
    'recovery': GetFreeeSyncStatus200ResponseRecovery | null;
}
/**
 * 
 * @export
 * @interface GetFreeeSyncStatus200ResponseErrorsInner
 */
export interface GetFreeeSyncStatus200ResponseErrorsInner {
    /**
     * 
     * @type {string}
     * @memberof GetFreeeSyncStatus200ResponseErrorsInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetFreeeSyncStatus200ResponseErrorsInner
     */
    'errorType': string;
    /**
     * 
     * @type {string}
     * @memberof GetFreeeSyncStatus200ResponseErrorsInner
     */
    'firstDetectedAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetFreeeSyncStatus200ResponseErrorsInner
     */
    'targetWalletableId': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetFreeeSyncStatus200ResponseErrorsInner
     */
    'syncRecoveryRequestId': string | null;
}
/**
 * 
 * @export
 * @interface GetFreeeSyncStatus200ResponseRecovery
 */
export interface GetFreeeSyncStatus200ResponseRecovery {
    /**
     * 
     * @type {boolean}
     * @memberof GetFreeeSyncStatus200ResponseRecovery
     */
    'userRecoveryPossible'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetFreeeSyncStatus200ResponseRecovery
     */
    'actions'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetFreeeSyncStatus200ResponseRecovery
     */
    'executingActions'?: Array<string>;
}
/**
 * 
 * @export
 * @interface GetFreeeTags200ResponseInner
 */
export interface GetFreeeTags200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetFreeeTags200ResponseInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetFreeeTags200ResponseInner
     */
    'type': GetFreeeTags200ResponseInnerTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetFreeeTags200ResponseInner
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetFreeeTags200ResponseInner
     */
    'shortcut1': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetFreeeTags200ResponseInner
     */
    'shortcut2': string | null;
}

export const GetFreeeTags200ResponseInnerTypeEnum = {
    section: 'SECTION',
    item: 'ITEM',
    segmentTag1: 'SEGMENT_TAG1',
    segmentTag2: 'SEGMENT_TAG2',
    segmentTag3: 'SEGMENT_TAG3',
    memoTag: 'MEMO_TAG'
} as const;

export type GetFreeeTags200ResponseInnerTypeEnum = typeof GetFreeeTags200ResponseInnerTypeEnum[keyof typeof GetFreeeTags200ResponseInnerTypeEnum];

/**
 * 
 * @export
 * @interface GetFreeeTaxes200ResponseInner
 */
export interface GetFreeeTaxes200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetFreeeTaxes200ResponseInner
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof GetFreeeTaxes200ResponseInner
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetFreeeTaxes200ResponseInner
     */
    'nameJa': string;
    /**
     * 
     * @type {string}
     * @memberof GetFreeeTaxes200ResponseInner
     */
    'displayCategory': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetFreeeTaxes200ResponseInner
     */
    'available': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetFreeeTaxes200ResponseInner
     */
    'orphaned': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetFreeeTaxes200ResponseInner
     */
    'isQualifiedTaxCategory': boolean | null;
    /**
     * 
     * @type {string}
     * @memberof GetFreeeTaxes200ResponseInner
     */
    'applicableStartAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetFreeeTaxes200ResponseInner
     */
    'applicableEndAt'?: string;
}
/**
 * 
 * @export
 * @interface GetFreeeToken200Response
 */
export interface GetFreeeToken200Response {
    /**
     * 
     * @type {string}
     * @memberof GetFreeeToken200Response
     */
    'accessToken': string;
}
/**
 * 
 * @export
 * @interface GetGuaranteeMoneyBalanceHistory200ResponseInner
 */
export interface GetGuaranteeMoneyBalanceHistory200ResponseInner {
    /**
     * 
     * @type {number}
     * @memberof GetGuaranteeMoneyBalanceHistory200ResponseInner
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof GetGuaranteeMoneyBalanceHistory200ResponseInner
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetGuaranteeMoneyBalanceHistory200ResponseInner
     */
    'organizationName': string;
    /**
     * 
     * @type {number}
     * @memberof GetGuaranteeMoneyBalanceHistory200ResponseInner
     */
    'amount': number;
    /**
     * 
     * @type {string}
     * @memberof GetGuaranteeMoneyBalanceHistory200ResponseInner
     */
    'transactionType': string;
    /**
     * 
     * @type {string}
     * @memberof GetGuaranteeMoneyBalanceHistory200ResponseInner
     */
    'cardBillId': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetGuaranteeMoneyBalanceHistory200ResponseInner
     */
    'usageFeeId': string | null;
    /**
     * 
     * @type {number}
     * @memberof GetGuaranteeMoneyBalanceHistory200ResponseInner
     */
    'balance': number;
    /**
     * 
     * @type {string}
     * @memberof GetGuaranteeMoneyBalanceHistory200ResponseInner
     */
    'confirmedAt': string;
}
/**
 * @type GetGuaranteeMoneyBalanceInformationForOrganization200Response
 * @export
 */
export type GetGuaranteeMoneyBalanceInformationForOrganization200Response = GetGuaranteeMoneyBalanceInformationForOrganization200ResponseOneOf | string;

/**
 * 
 * @export
 * @interface GetGuaranteeMoneyBalanceInformationForOrganization200ResponseOneOf
 */
export interface GetGuaranteeMoneyBalanceInformationForOrganization200ResponseOneOf {
    /**
     * 
     * @type {string}
     * @memberof GetGuaranteeMoneyBalanceInformationForOrganization200ResponseOneOf
     */
    'organizationId': string;
    /**
     * 
     * @type {number}
     * @memberof GetGuaranteeMoneyBalanceInformationForOrganization200ResponseOneOf
     */
    'sequenceNum': number;
    /**
     * 
     * @type {number}
     * @memberof GetGuaranteeMoneyBalanceInformationForOrganization200ResponseOneOf
     */
    'amount': number;
    /**
     * 
     * @type {string}
     * @memberof GetGuaranteeMoneyBalanceInformationForOrganization200ResponseOneOf
     */
    'transactionType': string;
    /**
     * 
     * @type {number}
     * @memberof GetGuaranteeMoneyBalanceInformationForOrganization200ResponseOneOf
     */
    'balance': number;
    /**
     * 
     * @type {string}
     * @memberof GetGuaranteeMoneyBalanceInformationForOrganization200ResponseOneOf
     */
    'confirmedAt': string;
}
/**
 * 
 * @export
 * @interface GetGuaranteeMoneyDepositsForOrganization200ResponseInner
 */
export interface GetGuaranteeMoneyDepositsForOrganization200ResponseInner {
    /**
     * 
     * @type {number}
     * @memberof GetGuaranteeMoneyDepositsForOrganization200ResponseInner
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof GetGuaranteeMoneyDepositsForOrganization200ResponseInner
     */
    'organizationId': string;
    /**
     * 
     * @type {number}
     * @memberof GetGuaranteeMoneyDepositsForOrganization200ResponseInner
     */
    'depositTransactionId': number;
    /**
     * 
     * @type {number}
     * @memberof GetGuaranteeMoneyDepositsForOrganization200ResponseInner
     */
    'depositAmount': number;
    /**
     * 
     * @type {number}
     * @memberof GetGuaranteeMoneyDepositsForOrganization200ResponseInner
     */
    'remainingAmount': number;
    /**
     * 
     * @type {string}
     * @memberof GetGuaranteeMoneyDepositsForOrganization200ResponseInner
     */
    'depositDate': string;
    /**
     * 
     * @type {string}
     * @memberof GetGuaranteeMoneyDepositsForOrganization200ResponseInner
     */
    'validThroughDate': string;
    /**
     * 
     * @type {string}
     * @memberof GetGuaranteeMoneyDepositsForOrganization200ResponseInner
     */
    'withdrawalDueDate': string | null;
}
/**
 * @type GetIdentifyVerificationsLatest200Response
 * @export
 */
export type GetIdentifyVerificationsLatest200Response = GetIdentifyVerificationsLatest200ResponseOneOf | GetIdentifyVerificationsLatest200ResponseOneOf1;

/**
 * 
 * @export
 * @interface GetIdentifyVerificationsLatest200ResponseOneOf
 */
export interface GetIdentifyVerificationsLatest200ResponseOneOf {
    /**
     * 
     * @type {string}
     * @memberof GetIdentifyVerificationsLatest200ResponseOneOf
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetIdentifyVerificationsLatest200ResponseOneOf
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetIdentifyVerificationsLatest200ResponseOneOf
     */
    'organizationCreateRequestId': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetIdentifyVerificationsLatest200ResponseOneOf
     */
    'organizationName': string;
    /**
     * 
     * @type {string}
     * @memberof GetIdentifyVerificationsLatest200ResponseOneOf
     */
    'corporateNumber': string;
    /**
     * 
     * @type {number}
     * @memberof GetIdentifyVerificationsLatest200ResponseOneOf
     */
    'businessDescriptionId': number;
    /**
     * 
     * @type {number}
     * @memberof GetIdentifyVerificationsLatest200ResponseOneOf
     */
    'purposeTransaction': number;
    /**
     * 
     * @type {string}
     * @memberof GetIdentifyVerificationsLatest200ResponseOneOf
     */
    'purposeTransactionOther': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetIdentifyVerificationsLatest200ResponseOneOf
     */
    'postalCode': string;
    /**
     * 
     * @type {string}
     * @memberof GetIdentifyVerificationsLatest200ResponseOneOf
     */
    'address': string;
    /**
     * 
     * @type {string}
     * @memberof GetIdentifyVerificationsLatest200ResponseOneOf
     */
    'phoneNumber': string;
    /**
     * 
     * @type {string}
     * @memberof GetIdentifyVerificationsLatest200ResponseOneOf
     */
    'representativeName': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetIdentifyVerificationsLatest200ResponseOneOf
     */
    'isExistsBeneficialOwner': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetIdentifyVerificationsLatest200ResponseOneOf
     */
    'corporateType': string | null;
    /**
     * 
     * @type {Array<GetIdentifyVerificationsLatest200ResponseOneOfBeneficialOwnersInner>}
     * @memberof GetIdentifyVerificationsLatest200ResponseOneOf
     */
    'beneficialOwners': Array<GetIdentifyVerificationsLatest200ResponseOneOfBeneficialOwnersInner>;
    /**
     * 
     * @type {boolean}
     * @memberof GetIdentifyVerificationsLatest200ResponseOneOf
     */
    'isRepresentative': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetIdentifyVerificationsLatest200ResponseOneOf
     */
    'transactionManagerName': string;
    /**
     * 
     * @type {string}
     * @memberof GetIdentifyVerificationsLatest200ResponseOneOf
     */
    'transactionManagerBirthday': string;
    /**
     * 
     * @type {string}
     * @memberof GetIdentifyVerificationsLatest200ResponseOneOf
     */
    'transactionManagerAddress': string;
    /**
     * 
     * @type {string}
     * @memberof GetIdentifyVerificationsLatest200ResponseOneOf
     */
    'transactionManagerEmail': string;
    /**
     * 
     * @type {string}
     * @memberof GetIdentifyVerificationsLatest200ResponseOneOf
     */
    'note': string | null;
    /**
     * 
     * @type {GetIdentifyVerificationsLatest200ResponseOneOfStatus}
     * @memberof GetIdentifyVerificationsLatest200ResponseOneOf
     */
    'status': GetIdentifyVerificationsLatest200ResponseOneOfStatus | null;
    /**
     * 
     * @type {Array<GetIdentifyVerificationsLatest200ResponseOneOfIdentificationInner>}
     * @memberof GetIdentifyVerificationsLatest200ResponseOneOf
     */
    'identification': Array<GetIdentifyVerificationsLatest200ResponseOneOfIdentificationInner>;
    /**
     * 
     * @type {Array<GetIdentifyVerificationsLatest200ResponseOneOfAntisocialForcesCheckInner>}
     * @memberof GetIdentifyVerificationsLatest200ResponseOneOf
     */
    'antisocialForcesCheck': Array<GetIdentifyVerificationsLatest200ResponseOneOfAntisocialForcesCheckInner>;
    /**
     * 
     * @type {Array<GetIdentifyVerificationsLatest200ResponseOneOfSnailMailVerificationInner>}
     * @memberof GetIdentifyVerificationsLatest200ResponseOneOf
     */
    'snailMailVerification': Array<GetIdentifyVerificationsLatest200ResponseOneOfSnailMailVerificationInner> | null;
    /**
     * 
     * @type {string}
     * @memberof GetIdentifyVerificationsLatest200ResponseOneOf
     */
    'createdAt': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const GetIdentifyVerificationsLatest200ResponseOneOf1 = {
    empty: ''
} as const;

export type GetIdentifyVerificationsLatest200ResponseOneOf1 = typeof GetIdentifyVerificationsLatest200ResponseOneOf1[keyof typeof GetIdentifyVerificationsLatest200ResponseOneOf1];


/**
 * 
 * @export
 * @interface GetIdentifyVerificationsLatest200ResponseOneOfAntisocialForcesCheckInner
 */
export interface GetIdentifyVerificationsLatest200ResponseOneOfAntisocialForcesCheckInner {
    /**
     * 
     * @type {string}
     * @memberof GetIdentifyVerificationsLatest200ResponseOneOfAntisocialForcesCheckInner
     */
    'organizationIdentityVerificationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetIdentifyVerificationsLatest200ResponseOneOfAntisocialForcesCheckInner
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof GetIdentifyVerificationsLatest200ResponseOneOfAntisocialForcesCheckInner
     */
    'payloadId': string;
    /**
     * 
     * @type {number}
     * @memberof GetIdentifyVerificationsLatest200ResponseOneOfAntisocialForcesCheckInner
     */
    'payloadDetailId': number;
    /**
     * 
     * @type {string}
     * @memberof GetIdentifyVerificationsLatest200ResponseOneOfAntisocialForcesCheckInner
     */
    'category': string;
    /**
     * 
     * @type {object}
     * @memberof GetIdentifyVerificationsLatest200ResponseOneOfAntisocialForcesCheckInner
     */
    'condition'?: object;
    /**
     * 
     * @type {Array<object>}
     * @memberof GetIdentifyVerificationsLatest200ResponseOneOfAntisocialForcesCheckInner
     */
    'results'?: Array<object> | null;
}
/**
 * 
 * @export
 * @interface GetIdentifyVerificationsLatest200ResponseOneOfBeneficialOwnersInner
 */
export interface GetIdentifyVerificationsLatest200ResponseOneOfBeneficialOwnersInner {
    /**
     * 
     * @type {string}
     * @memberof GetIdentifyVerificationsLatest200ResponseOneOfBeneficialOwnersInner
     */
    'corporateRelationships'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetIdentifyVerificationsLatest200ResponseOneOfBeneficialOwnersInner
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetIdentifyVerificationsLatest200ResponseOneOfBeneficialOwnersInner
     */
    'beneficialOwnerType': string;
    /**
     * 
     * @type {string}
     * @memberof GetIdentifyVerificationsLatest200ResponseOneOfBeneficialOwnersInner
     */
    'gender': string;
    /**
     * 
     * @type {string}
     * @memberof GetIdentifyVerificationsLatest200ResponseOneOfBeneficialOwnersInner
     */
    'birthday': string;
    /**
     * 
     * @type {string}
     * @memberof GetIdentifyVerificationsLatest200ResponseOneOfBeneficialOwnersInner
     */
    'countryResidence': string;
    /**
     * 
     * @type {string}
     * @memberof GetIdentifyVerificationsLatest200ResponseOneOfBeneficialOwnersInner
     */
    'address': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetIdentifyVerificationsLatest200ResponseOneOfBeneficialOwnersInner
     */
    'isPoliticallyExposedPersons': boolean;
}
/**
 * 
 * @export
 * @interface GetIdentifyVerificationsLatest200ResponseOneOfIdentificationInner
 */
export interface GetIdentifyVerificationsLatest200ResponseOneOfIdentificationInner {
    /**
     * 
     * @type {string}
     * @memberof GetIdentifyVerificationsLatest200ResponseOneOfIdentificationInner
     */
    'trustdockIdentificationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetIdentifyVerificationsLatest200ResponseOneOfIdentificationInner
     */
    'state': string;
    /**
     * 
     * @type {string}
     * @memberof GetIdentifyVerificationsLatest200ResponseOneOfIdentificationInner
     */
    'result': string | null;
    /**
     * 
     * @type {Array<GetIdentifyVerificationsLatest200ResponseOneOfIdentificationInnerRecordsInner>}
     * @memberof GetIdentifyVerificationsLatest200ResponseOneOfIdentificationInner
     */
    'records'?: Array<GetIdentifyVerificationsLatest200ResponseOneOfIdentificationInnerRecordsInner> | null;
}
/**
 * 
 * @export
 * @interface GetIdentifyVerificationsLatest200ResponseOneOfIdentificationInnerRecordsInner
 */
export interface GetIdentifyVerificationsLatest200ResponseOneOfIdentificationInnerRecordsInner {
    /**
     * 
     * @type {string}
     * @memberof GetIdentifyVerificationsLatest200ResponseOneOfIdentificationInnerRecordsInner
     */
    'state': string;
    /**
     * 
     * @type {string}
     * @memberof GetIdentifyVerificationsLatest200ResponseOneOfIdentificationInnerRecordsInner
     */
    'result': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetIdentifyVerificationsLatest200ResponseOneOfIdentificationInnerRecordsInner
     */
    'planId'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetIdentifyVerificationsLatest200ResponseOneOfIdentificationInnerRecordsInner
     */
    'plan'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetIdentifyVerificationsLatest200ResponseOneOfIdentificationInnerRecordsInner
     */
    'reasons'?: Array<string>;
}
/**
 * 
 * @export
 * @interface GetIdentifyVerificationsLatest200ResponseOneOfSnailMailVerificationInner
 */
export interface GetIdentifyVerificationsLatest200ResponseOneOfSnailMailVerificationInner {
    /**
     * 
     * @type {string}
     * @memberof GetIdentifyVerificationsLatest200ResponseOneOfSnailMailVerificationInner
     */
    'organizationIdentityVerificationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetIdentifyVerificationsLatest200ResponseOneOfSnailMailVerificationInner
     */
    'snailMailVerificationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetIdentifyVerificationsLatest200ResponseOneOfSnailMailVerificationInner
     */
    'result': string;
    /**
     * 
     * @type {string}
     * @memberof GetIdentifyVerificationsLatest200ResponseOneOfSnailMailVerificationInner
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof GetIdentifyVerificationsLatest200ResponseOneOfSnailMailVerificationInner
     */
    'detail': string;
    /**
     * 
     * @type {string}
     * @memberof GetIdentifyVerificationsLatest200ResponseOneOfSnailMailVerificationInner
     */
    'inquiryNumber': string;
    /**
     * 
     * @type {string}
     * @memberof GetIdentifyVerificationsLatest200ResponseOneOfSnailMailVerificationInner
     */
    'acceptAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetIdentifyVerificationsLatest200ResponseOneOfSnailMailVerificationInner
     */
    'confirmedAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetIdentifyVerificationsLatest200ResponseOneOfSnailMailVerificationInner
     */
    'confirmedBy': string | null;
}
/**
 * 
 * @export
 * @interface GetIdentifyVerificationsLatest200ResponseOneOfStatus
 */
export interface GetIdentifyVerificationsLatest200ResponseOneOfStatus {
    /**
     * 
     * @type {string}
     * @memberof GetIdentifyVerificationsLatest200ResponseOneOfStatus
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetIdentifyVerificationsLatest200ResponseOneOfStatus
     */
    'statusChangedUserId'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetIdentifyVerificationsLatest200ResponseOneOfStatus
     */
    'statusChangedUserName': string;
    /**
     * 
     * @type {string}
     * @memberof GetIdentifyVerificationsLatest200ResponseOneOfStatus
     */
    'statusChangedAt': string;
}
/**
 * 
 * @export
 * @interface GetIdentityVerifications200ResponseInner
 */
export interface GetIdentityVerifications200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetIdentityVerifications200ResponseInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetIdentityVerifications200ResponseInner
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetIdentityVerifications200ResponseInner
     */
    'organizationCreateRequestId': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetIdentityVerifications200ResponseInner
     */
    'organizationName': string;
    /**
     * 
     * @type {string}
     * @memberof GetIdentityVerifications200ResponseInner
     */
    'corporateNumber': string;
    /**
     * 
     * @type {number}
     * @memberof GetIdentityVerifications200ResponseInner
     */
    'businessDescriptionId': number;
    /**
     * 
     * @type {number}
     * @memberof GetIdentityVerifications200ResponseInner
     */
    'purposeTransaction': number;
    /**
     * 
     * @type {string}
     * @memberof GetIdentityVerifications200ResponseInner
     */
    'purposeTransactionOther': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetIdentityVerifications200ResponseInner
     */
    'postalCode': string;
    /**
     * 
     * @type {string}
     * @memberof GetIdentityVerifications200ResponseInner
     */
    'address': string;
    /**
     * 
     * @type {string}
     * @memberof GetIdentityVerifications200ResponseInner
     */
    'phoneNumber': string;
    /**
     * 
     * @type {string}
     * @memberof GetIdentityVerifications200ResponseInner
     */
    'representativeName': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetIdentityVerifications200ResponseInner
     */
    'isExistsBeneficialOwner': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetIdentityVerifications200ResponseInner
     */
    'corporateType': string | null;
    /**
     * 
     * @type {Array<GetIdentityVerifications200ResponseInnerBeneficialOwnersInner>}
     * @memberof GetIdentityVerifications200ResponseInner
     */
    'beneficialOwners': Array<GetIdentityVerifications200ResponseInnerBeneficialOwnersInner>;
    /**
     * 
     * @type {boolean}
     * @memberof GetIdentityVerifications200ResponseInner
     */
    'isRepresentative': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetIdentityVerifications200ResponseInner
     */
    'transactionManagerName': string;
    /**
     * 
     * @type {string}
     * @memberof GetIdentityVerifications200ResponseInner
     */
    'transactionManagerBirthday': string;
    /**
     * 
     * @type {string}
     * @memberof GetIdentityVerifications200ResponseInner
     */
    'transactionManagerAddress': string;
    /**
     * 
     * @type {string}
     * @memberof GetIdentityVerifications200ResponseInner
     */
    'transactionManagerEmail': string;
    /**
     * 
     * @type {string}
     * @memberof GetIdentityVerifications200ResponseInner
     */
    'note': string | null;
    /**
     * 
     * @type {GetIdentityVerifications200ResponseInnerStatus}
     * @memberof GetIdentityVerifications200ResponseInner
     */
    'status': GetIdentityVerifications200ResponseInnerStatus | null;
    /**
     * 
     * @type {Array<GetIdentityVerifications200ResponseInnerIdentificationInner>}
     * @memberof GetIdentityVerifications200ResponseInner
     */
    'identification': Array<GetIdentityVerifications200ResponseInnerIdentificationInner>;
    /**
     * 
     * @type {Array<GetIdentityVerifications200ResponseInnerAntisocialForcesCheckInner>}
     * @memberof GetIdentityVerifications200ResponseInner
     */
    'antisocialForcesCheck': Array<GetIdentityVerifications200ResponseInnerAntisocialForcesCheckInner>;
    /**
     * 
     * @type {Array<GetIdentityVerifications200ResponseInnerSnailMailVerificationInner>}
     * @memberof GetIdentityVerifications200ResponseInner
     */
    'snailMailVerification': Array<GetIdentityVerifications200ResponseInnerSnailMailVerificationInner> | null;
    /**
     * 
     * @type {string}
     * @memberof GetIdentityVerifications200ResponseInner
     */
    'createdAt': string;
}
/**
 * 
 * @export
 * @interface GetIdentityVerifications200ResponseInnerAntisocialForcesCheckInner
 */
export interface GetIdentityVerifications200ResponseInnerAntisocialForcesCheckInner {
    /**
     * 
     * @type {string}
     * @memberof GetIdentityVerifications200ResponseInnerAntisocialForcesCheckInner
     */
    'organizationIdentityVerificationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetIdentityVerifications200ResponseInnerAntisocialForcesCheckInner
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof GetIdentityVerifications200ResponseInnerAntisocialForcesCheckInner
     */
    'payloadId': string;
    /**
     * 
     * @type {number}
     * @memberof GetIdentityVerifications200ResponseInnerAntisocialForcesCheckInner
     */
    'payloadDetailId': number;
    /**
     * 
     * @type {string}
     * @memberof GetIdentityVerifications200ResponseInnerAntisocialForcesCheckInner
     */
    'category': string;
    /**
     * 
     * @type {object}
     * @memberof GetIdentityVerifications200ResponseInnerAntisocialForcesCheckInner
     */
    'condition'?: object;
    /**
     * 
     * @type {Array<object>}
     * @memberof GetIdentityVerifications200ResponseInnerAntisocialForcesCheckInner
     */
    'results'?: Array<object> | null;
}
/**
 * 
 * @export
 * @interface GetIdentityVerifications200ResponseInnerBeneficialOwnersInner
 */
export interface GetIdentityVerifications200ResponseInnerBeneficialOwnersInner {
    /**
     * 
     * @type {string}
     * @memberof GetIdentityVerifications200ResponseInnerBeneficialOwnersInner
     */
    'corporateRelationships'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetIdentityVerifications200ResponseInnerBeneficialOwnersInner
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetIdentityVerifications200ResponseInnerBeneficialOwnersInner
     */
    'beneficialOwnerType': string;
    /**
     * 
     * @type {string}
     * @memberof GetIdentityVerifications200ResponseInnerBeneficialOwnersInner
     */
    'gender': string;
    /**
     * 
     * @type {string}
     * @memberof GetIdentityVerifications200ResponseInnerBeneficialOwnersInner
     */
    'birthday': string;
    /**
     * 
     * @type {string}
     * @memberof GetIdentityVerifications200ResponseInnerBeneficialOwnersInner
     */
    'countryResidence': string;
    /**
     * 
     * @type {string}
     * @memberof GetIdentityVerifications200ResponseInnerBeneficialOwnersInner
     */
    'address': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetIdentityVerifications200ResponseInnerBeneficialOwnersInner
     */
    'isPoliticallyExposedPersons': boolean;
}
/**
 * 
 * @export
 * @interface GetIdentityVerifications200ResponseInnerIdentificationInner
 */
export interface GetIdentityVerifications200ResponseInnerIdentificationInner {
    /**
     * 
     * @type {string}
     * @memberof GetIdentityVerifications200ResponseInnerIdentificationInner
     */
    'trustdockIdentificationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetIdentityVerifications200ResponseInnerIdentificationInner
     */
    'state': string;
    /**
     * 
     * @type {string}
     * @memberof GetIdentityVerifications200ResponseInnerIdentificationInner
     */
    'result': string | null;
    /**
     * 
     * @type {Array<GetIdentityVerifications200ResponseInnerIdentificationInnerRecordsInner>}
     * @memberof GetIdentityVerifications200ResponseInnerIdentificationInner
     */
    'records'?: Array<GetIdentityVerifications200ResponseInnerIdentificationInnerRecordsInner> | null;
}
/**
 * 
 * @export
 * @interface GetIdentityVerifications200ResponseInnerIdentificationInnerRecordsInner
 */
export interface GetIdentityVerifications200ResponseInnerIdentificationInnerRecordsInner {
    /**
     * 
     * @type {string}
     * @memberof GetIdentityVerifications200ResponseInnerIdentificationInnerRecordsInner
     */
    'state': string;
    /**
     * 
     * @type {string}
     * @memberof GetIdentityVerifications200ResponseInnerIdentificationInnerRecordsInner
     */
    'result': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetIdentityVerifications200ResponseInnerIdentificationInnerRecordsInner
     */
    'planId'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetIdentityVerifications200ResponseInnerIdentificationInnerRecordsInner
     */
    'plan'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetIdentityVerifications200ResponseInnerIdentificationInnerRecordsInner
     */
    'reasons'?: Array<string>;
}
/**
 * 
 * @export
 * @interface GetIdentityVerifications200ResponseInnerSnailMailVerificationInner
 */
export interface GetIdentityVerifications200ResponseInnerSnailMailVerificationInner {
    /**
     * 
     * @type {string}
     * @memberof GetIdentityVerifications200ResponseInnerSnailMailVerificationInner
     */
    'organizationIdentityVerificationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetIdentityVerifications200ResponseInnerSnailMailVerificationInner
     */
    'snailMailVerificationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetIdentityVerifications200ResponseInnerSnailMailVerificationInner
     */
    'result': string;
    /**
     * 
     * @type {string}
     * @memberof GetIdentityVerifications200ResponseInnerSnailMailVerificationInner
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof GetIdentityVerifications200ResponseInnerSnailMailVerificationInner
     */
    'detail': string;
    /**
     * 
     * @type {string}
     * @memberof GetIdentityVerifications200ResponseInnerSnailMailVerificationInner
     */
    'inquiryNumber': string;
    /**
     * 
     * @type {string}
     * @memberof GetIdentityVerifications200ResponseInnerSnailMailVerificationInner
     */
    'acceptAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetIdentityVerifications200ResponseInnerSnailMailVerificationInner
     */
    'confirmedAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetIdentityVerifications200ResponseInnerSnailMailVerificationInner
     */
    'confirmedBy': string | null;
}
/**
 * 
 * @export
 * @interface GetIdentityVerifications200ResponseInnerStatus
 */
export interface GetIdentityVerifications200ResponseInnerStatus {
    /**
     * 
     * @type {string}
     * @memberof GetIdentityVerifications200ResponseInnerStatus
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetIdentityVerifications200ResponseInnerStatus
     */
    'statusChangedUserId'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetIdentityVerifications200ResponseInnerStatus
     */
    'statusChangedUserName': string;
    /**
     * 
     * @type {string}
     * @memberof GetIdentityVerifications200ResponseInnerStatus
     */
    'statusChangedAt': string;
}
/**
 * 
 * @export
 * @interface GetInvoiceList200Response
 */
export interface GetInvoiceList200Response {
    /**
     * 
     * @type {string}
     * @memberof GetInvoiceList200Response
     */
    'month': string;
    /**
     * 
     * @type {string}
     * @memberof GetInvoiceList200Response
     */
    'year': string;
    /**
     * 
     * @type {string}
     * @memberof GetInvoiceList200Response
     */
    'href': string;
    /**
     * 
     * @type {string}
     * @memberof GetInvoiceList200Response
     */
    'fileName': string;
}
/**
 * 
 * @export
 * @interface GetIssuableStatus200Response
 */
export interface GetIssuableStatus200Response {
    /**
     * 
     * @type {GetIssuableStatus200ResponseIssuableAllCards}
     * @memberof GetIssuableStatus200Response
     */
    'issuableAllCards'?: GetIssuableStatus200ResponseIssuableAllCards;
    /**
     * 
     * @type {Array<GetIssuableStatus200ResponseIssuableCardsInner>}
     * @memberof GetIssuableStatus200Response
     */
    'issuableCards'?: Array<GetIssuableStatus200ResponseIssuableCardsInner>;
}
/**
 * 
 * @export
 * @interface GetIssuableStatus200ResponseIssuableAllCards
 */
export interface GetIssuableStatus200ResponseIssuableAllCards {
    /**
     * 
     * @type {number}
     * @memberof GetIssuableStatus200ResponseIssuableAllCards
     */
    'limit'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetIssuableStatus200ResponseIssuableAllCards
     */
    'activeCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetIssuableStatus200ResponseIssuableAllCards
     */
    'issuableCount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GetIssuableStatus200ResponseIssuableAllCards
     */
    'issuable'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetIssuableStatus200ResponseIssuableAllCards
     */
    'reason'?: Array<string>;
}
/**
 * 
 * @export
 * @interface GetIssuableStatus200ResponseIssuableCardsInner
 */
export interface GetIssuableStatus200ResponseIssuableCardsInner {
    /**
     * 
     * @type {string}
     * @memberof GetIssuableStatus200ResponseIssuableCardsInner
     */
    'type'?: GetIssuableStatus200ResponseIssuableCardsInnerTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof GetIssuableStatus200ResponseIssuableCardsInner
     */
    'limit'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetIssuableStatus200ResponseIssuableCardsInner
     */
    'activeCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetIssuableStatus200ResponseIssuableCardsInner
     */
    'issuableCount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GetIssuableStatus200ResponseIssuableCardsInner
     */
    'issuable'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetIssuableStatus200ResponseIssuableCardsInner
     */
    'reason'?: Array<string>;
}

export const GetIssuableStatus200ResponseIssuableCardsInnerTypeEnum = {
    virtualCard: 'VIRTUAL_CARD',
    virtualCardOnDemand: 'VIRTUAL_CARD_ON_DEMAND',
    physicalCard: 'PHYSICAL_CARD',
    physicalCardMetal: 'PHYSICAL_CARD_METAL'
} as const;

export type GetIssuableStatus200ResponseIssuableCardsInnerTypeEnum = typeof GetIssuableStatus200ResponseIssuableCardsInnerTypeEnum[keyof typeof GetIssuableStatus200ResponseIssuableCardsInnerTypeEnum];

/**
 * 
 * @export
 * @interface GetJwtSso200Response
 */
export interface GetJwtSso200Response {
    /**
     * 
     * @type {string}
     * @memberof GetJwtSso200Response
     */
    'token': string;
    /**
     * 
     * @type {string}
     * @memberof GetJwtSso200Response
     */
    'expiresAt': string;
}
/**
 * 
 * @export
 * @interface GetKycReaderUsers200ResponseInner
 */
export interface GetKycReaderUsers200ResponseInner {
    /**
     * User ID
     * @type {string}
     * @memberof GetKycReaderUsers200ResponseInner
     */
    'userId': string;
    /**
     * User name
     * @type {string}
     * @memberof GetKycReaderUsers200ResponseInner
     */
    'userName': string;
}
/**
 * 
 * @export
 * @interface GetLatestTimeOfSyncToFreee200Response
 */
export interface GetLatestTimeOfSyncToFreee200Response {
    /**
     * 
     * @type {string}
     * @memberof GetLatestTimeOfSyncToFreee200Response
     */
    'syncTime': string;
}
/**
 * 
 * @export
 * @interface GetLockStatusOfEvidences200Response
 */
export interface GetLockStatusOfEvidences200Response {
    /**
     * 
     * @type {boolean}
     * @memberof GetLockStatusOfEvidences200Response
     */
    'isLocked': boolean;
}
/**
 * 
 * @export
 * @interface GetMerchantGeneralBlock200ResponseInner
 */
export interface GetMerchantGeneralBlock200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetMerchantGeneralBlock200ResponseInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetMerchantGeneralBlock200ResponseInner
     */
    'merchantName': string;
    /**
     * 
     * @type {string}
     * @memberof GetMerchantGeneralBlock200ResponseInner
     */
    'merchantId': string;
    /**
     * 
     * @type {string}
     * @memberof GetMerchantGeneralBlock200ResponseInner
     */
    'acquirerId': string;
    /**
     * 
     * @type {string}
     * @memberof GetMerchantGeneralBlock200ResponseInner
     */
    'patternType': GetMerchantGeneralBlock200ResponseInnerPatternTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetMerchantGeneralBlock200ResponseInner
     */
    'storeType': GetMerchantGeneralBlock200ResponseInnerStoreTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetMerchantGeneralBlock200ResponseInner
     */
    'createdAt': string;
    /**
     * 
     * @type {Array<GetMerchantGeneralBlock200ResponseInnerAllowedOrganizationListInner>}
     * @memberof GetMerchantGeneralBlock200ResponseInner
     */
    'allowedOrganizationList': Array<GetMerchantGeneralBlock200ResponseInnerAllowedOrganizationListInner>;
}

export const GetMerchantGeneralBlock200ResponseInnerPatternTypeEnum = {
    exact: 'EXACT',
    prefix: 'PREFIX',
    suffix: 'SUFFIX',
    regexp: 'REGEXP',
    unknown: 'UNKNOWN'
} as const;

export type GetMerchantGeneralBlock200ResponseInnerPatternTypeEnum = typeof GetMerchantGeneralBlock200ResponseInnerPatternTypeEnum[keyof typeof GetMerchantGeneralBlock200ResponseInnerPatternTypeEnum];
export const GetMerchantGeneralBlock200ResponseInnerStoreTypeEnum = {
    all: 'ALL',
    physicalStore: 'PHYSICAL_STORE',
    ecStore: 'EC_STORE',
    unknown: 'UNKNOWN'
} as const;

export type GetMerchantGeneralBlock200ResponseInnerStoreTypeEnum = typeof GetMerchantGeneralBlock200ResponseInnerStoreTypeEnum[keyof typeof GetMerchantGeneralBlock200ResponseInnerStoreTypeEnum];

/**
 * 
 * @export
 * @interface GetMerchantGeneralBlock200ResponseInnerAllowedOrganizationListInner
 */
export interface GetMerchantGeneralBlock200ResponseInnerAllowedOrganizationListInner {
    /**
     * 
     * @type {string}
     * @memberof GetMerchantGeneralBlock200ResponseInnerAllowedOrganizationListInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetMerchantGeneralBlock200ResponseInnerAllowedOrganizationListInner
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetMerchantGeneralBlock200ResponseInnerAllowedOrganizationListInner
     */
    'createdAt': string | null;
}
/**
 * 
 * @export
 * @interface GetMerchantGeneralBlockDetail200Response
 */
export interface GetMerchantGeneralBlockDetail200Response {
    /**
     * 
     * @type {string}
     * @memberof GetMerchantGeneralBlockDetail200Response
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetMerchantGeneralBlockDetail200Response
     */
    'merchantName': string;
    /**
     * 
     * @type {string}
     * @memberof GetMerchantGeneralBlockDetail200Response
     */
    'merchantId': string;
    /**
     * 
     * @type {string}
     * @memberof GetMerchantGeneralBlockDetail200Response
     */
    'acquirerId': string;
    /**
     * 
     * @type {string}
     * @memberof GetMerchantGeneralBlockDetail200Response
     */
    'patternType': GetMerchantGeneralBlockDetail200ResponsePatternTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetMerchantGeneralBlockDetail200Response
     */
    'storeType': GetMerchantGeneralBlockDetail200ResponseStoreTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetMerchantGeneralBlockDetail200Response
     */
    'createdAt': string;
    /**
     * 
     * @type {Array<GetMerchantGeneralBlockDetail200ResponseAllowedOrganizationListInner>}
     * @memberof GetMerchantGeneralBlockDetail200Response
     */
    'allowedOrganizationList': Array<GetMerchantGeneralBlockDetail200ResponseAllowedOrganizationListInner>;
}

export const GetMerchantGeneralBlockDetail200ResponsePatternTypeEnum = {
    exact: 'EXACT',
    prefix: 'PREFIX',
    suffix: 'SUFFIX',
    regexp: 'REGEXP',
    unknown: 'UNKNOWN'
} as const;

export type GetMerchantGeneralBlockDetail200ResponsePatternTypeEnum = typeof GetMerchantGeneralBlockDetail200ResponsePatternTypeEnum[keyof typeof GetMerchantGeneralBlockDetail200ResponsePatternTypeEnum];
export const GetMerchantGeneralBlockDetail200ResponseStoreTypeEnum = {
    all: 'ALL',
    physicalStore: 'PHYSICAL_STORE',
    ecStore: 'EC_STORE',
    unknown: 'UNKNOWN'
} as const;

export type GetMerchantGeneralBlockDetail200ResponseStoreTypeEnum = typeof GetMerchantGeneralBlockDetail200ResponseStoreTypeEnum[keyof typeof GetMerchantGeneralBlockDetail200ResponseStoreTypeEnum];

/**
 * 
 * @export
 * @interface GetMerchantGeneralBlockDetail200ResponseAllowedOrganizationListInner
 */
export interface GetMerchantGeneralBlockDetail200ResponseAllowedOrganizationListInner {
    /**
     * 
     * @type {string}
     * @memberof GetMerchantGeneralBlockDetail200ResponseAllowedOrganizationListInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetMerchantGeneralBlockDetail200ResponseAllowedOrganizationListInner
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetMerchantGeneralBlockDetail200ResponseAllowedOrganizationListInner
     */
    'createdAt': string | null;
}
/**
 * 
 * @export
 * @interface GetMerchantOrgBlock200ResponseInner
 */
export interface GetMerchantOrgBlock200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetMerchantOrgBlock200ResponseInner
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetMerchantOrgBlock200ResponseInner
     */
    'organizationName': string;
    /**
     * 
     * @type {string}
     * @memberof GetMerchantOrgBlock200ResponseInner
     */
    'createdAt': string;
    /**
     * 
     * @type {Array<GetMerchantOrgBlock200ResponseInnerMerchantOrgBlockListsInner>}
     * @memberof GetMerchantOrgBlock200ResponseInner
     */
    'merchantOrgBlockLists': Array<GetMerchantOrgBlock200ResponseInnerMerchantOrgBlockListsInner>;
}
/**
 * 
 * @export
 * @interface GetMerchantOrgBlock200ResponseInnerMerchantOrgBlockListsInner
 */
export interface GetMerchantOrgBlock200ResponseInnerMerchantOrgBlockListsInner {
    /**
     * 
     * @type {string}
     * @memberof GetMerchantOrgBlock200ResponseInnerMerchantOrgBlockListsInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetMerchantOrgBlock200ResponseInnerMerchantOrgBlockListsInner
     */
    'merchantName': string;
    /**
     * 
     * @type {string}
     * @memberof GetMerchantOrgBlock200ResponseInnerMerchantOrgBlockListsInner
     */
    'merchantId': string;
    /**
     * 
     * @type {string}
     * @memberof GetMerchantOrgBlock200ResponseInnerMerchantOrgBlockListsInner
     */
    'acquirerId': string;
    /**
     * 
     * @type {string}
     * @memberof GetMerchantOrgBlock200ResponseInnerMerchantOrgBlockListsInner
     */
    'patternType': GetMerchantOrgBlock200ResponseInnerMerchantOrgBlockListsInnerPatternTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetMerchantOrgBlock200ResponseInnerMerchantOrgBlockListsInner
     */
    'storeType': GetMerchantOrgBlock200ResponseInnerMerchantOrgBlockListsInnerStoreTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetMerchantOrgBlock200ResponseInnerMerchantOrgBlockListsInner
     */
    'createdAt': string;
}

export const GetMerchantOrgBlock200ResponseInnerMerchantOrgBlockListsInnerPatternTypeEnum = {
    exact: 'EXACT',
    prefix: 'PREFIX',
    suffix: 'SUFFIX',
    regexp: 'REGEXP',
    unknown: 'UNKNOWN'
} as const;

export type GetMerchantOrgBlock200ResponseInnerMerchantOrgBlockListsInnerPatternTypeEnum = typeof GetMerchantOrgBlock200ResponseInnerMerchantOrgBlockListsInnerPatternTypeEnum[keyof typeof GetMerchantOrgBlock200ResponseInnerMerchantOrgBlockListsInnerPatternTypeEnum];
export const GetMerchantOrgBlock200ResponseInnerMerchantOrgBlockListsInnerStoreTypeEnum = {
    all: 'ALL',
    physicalStore: 'PHYSICAL_STORE',
    ecStore: 'EC_STORE',
    unknown: 'UNKNOWN'
} as const;

export type GetMerchantOrgBlock200ResponseInnerMerchantOrgBlockListsInnerStoreTypeEnum = typeof GetMerchantOrgBlock200ResponseInnerMerchantOrgBlockListsInnerStoreTypeEnum[keyof typeof GetMerchantOrgBlock200ResponseInnerMerchantOrgBlockListsInnerStoreTypeEnum];

/**
 * 
 * @export
 * @interface GetMerchantOrgBlockList200ResponseInner
 */
export interface GetMerchantOrgBlockList200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetMerchantOrgBlockList200ResponseInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetMerchantOrgBlockList200ResponseInner
     */
    'merchantName': string;
    /**
     * 
     * @type {string}
     * @memberof GetMerchantOrgBlockList200ResponseInner
     */
    'merchantId': string;
    /**
     * 
     * @type {string}
     * @memberof GetMerchantOrgBlockList200ResponseInner
     */
    'acquirerId': string;
    /**
     * 
     * @type {string}
     * @memberof GetMerchantOrgBlockList200ResponseInner
     */
    'patternType': GetMerchantOrgBlockList200ResponseInnerPatternTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetMerchantOrgBlockList200ResponseInner
     */
    'storeType': GetMerchantOrgBlockList200ResponseInnerStoreTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetMerchantOrgBlockList200ResponseInner
     */
    'createdAt': string;
}

export const GetMerchantOrgBlockList200ResponseInnerPatternTypeEnum = {
    exact: 'EXACT',
    prefix: 'PREFIX',
    suffix: 'SUFFIX',
    regexp: 'REGEXP',
    unknown: 'UNKNOWN'
} as const;

export type GetMerchantOrgBlockList200ResponseInnerPatternTypeEnum = typeof GetMerchantOrgBlockList200ResponseInnerPatternTypeEnum[keyof typeof GetMerchantOrgBlockList200ResponseInnerPatternTypeEnum];
export const GetMerchantOrgBlockList200ResponseInnerStoreTypeEnum = {
    all: 'ALL',
    physicalStore: 'PHYSICAL_STORE',
    ecStore: 'EC_STORE',
    unknown: 'UNKNOWN'
} as const;

export type GetMerchantOrgBlockList200ResponseInnerStoreTypeEnum = typeof GetMerchantOrgBlockList200ResponseInnerStoreTypeEnum[keyof typeof GetMerchantOrgBlockList200ResponseInnerStoreTypeEnum];

/**
 * 
 * @export
 * @interface GetMerchantOrganizationUserAccountYearMonthSummary200Response
 */
export interface GetMerchantOrganizationUserAccountYearMonthSummary200Response {
    /**
     * 
     * @type {GetMerchantOrganizationUserAccountYearMonthSummary200ResponseMerchant}
     * @memberof GetMerchantOrganizationUserAccountYearMonthSummary200Response
     */
    'merchant': GetMerchantOrganizationUserAccountYearMonthSummary200ResponseMerchant;
    /**
     * 
     * @type {string}
     * @memberof GetMerchantOrganizationUserAccountYearMonthSummary200Response
     */
    'comment': string;
    /**
     * 
     * @type {GetMerchantOrganizationUserAccountYearMonthSummary200ResponseUserAccount}
     * @memberof GetMerchantOrganizationUserAccountYearMonthSummary200Response
     */
    'userAccount': GetMerchantOrganizationUserAccountYearMonthSummary200ResponseUserAccount;
}
/**
 * 
 * @export
 * @interface GetMerchantOrganizationUserAccountYearMonthSummary200ResponseMerchant
 */
export interface GetMerchantOrganizationUserAccountYearMonthSummary200ResponseMerchant {
    /**
     * 
     * @type {string}
     * @memberof GetMerchantOrganizationUserAccountYearMonthSummary200ResponseMerchant
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetMerchantOrganizationUserAccountYearMonthSummary200ResponseMerchant
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetMerchantOrganizationUserAccountYearMonthSummary200ResponseMerchant
     */
    'nameJp': string;
    /**
     * 
     * @type {string}
     * @memberof GetMerchantOrganizationUserAccountYearMonthSummary200ResponseMerchant
     */
    'logoUrl': string | null;
}
/**
 * 
 * @export
 * @interface GetMerchantOrganizationUserAccountYearMonthSummary200ResponseUserAccount
 */
export interface GetMerchantOrganizationUserAccountYearMonthSummary200ResponseUserAccount {
    /**
     * 
     * @type {GetMerchantOrganizationUserAccountYearMonthSummary200ResponseUserAccountCard}
     * @memberof GetMerchantOrganizationUserAccountYearMonthSummary200ResponseUserAccount
     */
    'card': GetMerchantOrganizationUserAccountYearMonthSummary200ResponseUserAccountCard;
    /**
     * 
     * @type {string}
     * @memberof GetMerchantOrganizationUserAccountYearMonthSummary200ResponseUserAccount
     */
    'firstUseYearMonth': string;
    /**
     * 
     * @type {string}
     * @memberof GetMerchantOrganizationUserAccountYearMonthSummary200ResponseUserAccount
     */
    'comment': string;
    /**
     * 
     * @type {Array<GetMerchantOrganizationUserAccountYearMonthSummary200ResponseUserAccountRecordsInner>}
     * @memberof GetMerchantOrganizationUserAccountYearMonthSummary200ResponseUserAccount
     */
    'records': Array<GetMerchantOrganizationUserAccountYearMonthSummary200ResponseUserAccountRecordsInner>;
}
/**
 * 
 * @export
 * @interface GetMerchantOrganizationUserAccountYearMonthSummary200ResponseUserAccountCard
 */
export interface GetMerchantOrganizationUserAccountYearMonthSummary200ResponseUserAccountCard {
    /**
     * 
     * @type {string}
     * @memberof GetMerchantOrganizationUserAccountYearMonthSummary200ResponseUserAccountCard
     */
    'cardId': string;
    /**
     * 
     * @type {string}
     * @memberof GetMerchantOrganizationUserAccountYearMonthSummary200ResponseUserAccountCard
     */
    'cardLabel': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetMerchantOrganizationUserAccountYearMonthSummary200ResponseUserAccountCard
     */
    'isActivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetMerchantOrganizationUserAccountYearMonthSummary200ResponseUserAccountCard
     */
    'isDeactivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetMerchantOrganizationUserAccountYearMonthSummary200ResponseUserAccountCard
     */
    'isFrozen': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetMerchantOrganizationUserAccountYearMonthSummary200ResponseUserAccountCard
     */
    'isLocked': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetMerchantOrganizationUserAccountYearMonthSummary200ResponseUserAccountCard
     */
    'isSuspended': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetMerchantOrganizationUserAccountYearMonthSummary200ResponseUserAccountCard
     */
    'isVirtualCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetMerchantOrganizationUserAccountYearMonthSummary200ResponseUserAccountCard
     */
    'isCreaditCard'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetMerchantOrganizationUserAccountYearMonthSummary200ResponseUserAccountCard
     */
    'isOnDemand'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetMerchantOrganizationUserAccountYearMonthSummary200ResponseUserAccountCard
     */
    'isMetalCard': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetMerchantOrganizationUserAccountYearMonthSummary200ResponseUserAccountCard
     */
    'panLastFourDigits': string;
    /**
     * 
     * @type {GetMerchantOrganizationUserAccountYearMonthSummary200ResponseUserAccountCardUser}
     * @memberof GetMerchantOrganizationUserAccountYearMonthSummary200ResponseUserAccountCard
     */
    'user'?: GetMerchantOrganizationUserAccountYearMonthSummary200ResponseUserAccountCardUser;
    /**
     * 
     * @type {string}
     * @memberof GetMerchantOrganizationUserAccountYearMonthSummary200ResponseUserAccountCard
     */
    'userAccountId': string;
    /**
     * 
     * @type {GetMerchantOrganizationUserAccountYearMonthSummary200ResponseUserAccountCardUserAccountGroup}
     * @memberof GetMerchantOrganizationUserAccountYearMonthSummary200ResponseUserAccountCard
     */
    'userAccountGroup'?: GetMerchantOrganizationUserAccountYearMonthSummary200ResponseUserAccountCardUserAccountGroup;
    /**
     * 
     * @type {boolean}
     * @memberof GetMerchantOrganizationUserAccountYearMonthSummary200ResponseUserAccountCard
     */
    'isPhysicalStorePaymentDisabled': boolean;
}
/**
 * 
 * @export
 * @interface GetMerchantOrganizationUserAccountYearMonthSummary200ResponseUserAccountCardUser
 */
export interface GetMerchantOrganizationUserAccountYearMonthSummary200ResponseUserAccountCardUser {
    /**
     * 
     * @type {string}
     * @memberof GetMerchantOrganizationUserAccountYearMonthSummary200ResponseUserAccountCardUser
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetMerchantOrganizationUserAccountYearMonthSummary200ResponseUserAccountCardUser
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetMerchantOrganizationUserAccountYearMonthSummary200ResponseUserAccountCardUser
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetMerchantOrganizationUserAccountYearMonthSummary200ResponseUserAccountCardUser
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof GetMerchantOrganizationUserAccountYearMonthSummary200ResponseUserAccountCardUser
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetMerchantOrganizationUserAccountYearMonthSummary200ResponseUserAccountCardUser
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetMerchantOrganizationUserAccountYearMonthSummary200ResponseUserAccountCardUser
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetMerchantOrganizationUserAccountYearMonthSummary200ResponseUserAccountCardUser
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetMerchantOrganizationUserAccountYearMonthSummary200ResponseUserAccountCardUser
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetMerchantOrganizationUserAccountYearMonthSummary200ResponseUserAccountCardUser
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetMerchantOrganizationUserAccountYearMonthSummary200ResponseUserAccountCardUser
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface GetMerchantOrganizationUserAccountYearMonthSummary200ResponseUserAccountCardUserAccountGroup
 */
export interface GetMerchantOrganizationUserAccountYearMonthSummary200ResponseUserAccountCardUserAccountGroup {
    /**
     * 
     * @type {string}
     * @memberof GetMerchantOrganizationUserAccountYearMonthSummary200ResponseUserAccountCardUserAccountGroup
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetMerchantOrganizationUserAccountYearMonthSummary200ResponseUserAccountCardUserAccountGroup
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof GetMerchantOrganizationUserAccountYearMonthSummary200ResponseUserAccountCardUserAccountGroup
     */
    'sortNum': number;
}
/**
 * 
 * @export
 * @interface GetMerchantOrganizationUserAccountYearMonthSummary200ResponseUserAccountRecordsInner
 */
export interface GetMerchantOrganizationUserAccountYearMonthSummary200ResponseUserAccountRecordsInner {
    /**
     * 
     * @type {string}
     * @memberof GetMerchantOrganizationUserAccountYearMonthSummary200ResponseUserAccountRecordsInner
     */
    'yearMonth': string;
    /**
     * 
     * @type {number}
     * @memberof GetMerchantOrganizationUserAccountYearMonthSummary200ResponseUserAccountRecordsInner
     */
    'amount': number;
    /**
     * 
     * @type {string}
     * @memberof GetMerchantOrganizationUserAccountYearMonthSummary200ResponseUserAccountRecordsInner
     */
    'comment': string;
}
/**
 * 
 * @export
 * @interface GetMerchantsCategoryKinds200ResponseInner
 */
export interface GetMerchantsCategoryKinds200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetMerchantsCategoryKinds200ResponseInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetMerchantsCategoryKinds200ResponseInner
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetMerchantsCategoryKinds200ResponseInner
     */
    'description': string;
    /**
     * 
     * @type {Array<GetMerchantsCategoryKinds200ResponseInnerCategoriesInner>}
     * @memberof GetMerchantsCategoryKinds200ResponseInner
     */
    'categories': Array<GetMerchantsCategoryKinds200ResponseInnerCategoriesInner>;
}
/**
 * 
 * @export
 * @interface GetMerchantsCategoryKinds200ResponseInnerCategoriesInner
 */
export interface GetMerchantsCategoryKinds200ResponseInnerCategoriesInner {
    /**
     * 
     * @type {string}
     * @memberof GetMerchantsCategoryKinds200ResponseInnerCategoriesInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetMerchantsCategoryKinds200ResponseInnerCategoriesInner
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetMerchantsCategoryKinds200ResponseInnerCategoriesInner
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof GetMerchantsCategoryKinds200ResponseInnerCategoriesInner
     */
    'logoUrl': string;
}
/**
 * 
 * @export
 * @interface GetModifiableDailyLimitsForTheUserAccount200Response
 */
export interface GetModifiableDailyLimitsForTheUserAccount200Response {
    /**
     * 
     * @type {string}
     * @memberof GetModifiableDailyLimitsForTheUserAccount200Response
     */
    'userAccountId': string;
    /**
     * 
     * @type {string}
     * @memberof GetModifiableDailyLimitsForTheUserAccount200Response
     */
    'limitType': GetModifiableDailyLimitsForTheUserAccount200ResponseLimitTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof GetModifiableDailyLimitsForTheUserAccount200Response
     */
    'limit': number | null;
}

export const GetModifiableDailyLimitsForTheUserAccount200ResponseLimitTypeEnum = {
    dailyLimit: 'DAILY_LIMIT',
    monthlyLimit: 'MONTHLY_LIMIT',
    transactionLimit: 'TRANSACTION_LIMIT'
} as const;

export type GetModifiableDailyLimitsForTheUserAccount200ResponseLimitTypeEnum = typeof GetModifiableDailyLimitsForTheUserAccount200ResponseLimitTypeEnum[keyof typeof GetModifiableDailyLimitsForTheUserAccount200ResponseLimitTypeEnum];

/**
 * 
 * @export
 * @interface GetModifiableMonthlyLimitsForTheUserAccount200Response
 */
export interface GetModifiableMonthlyLimitsForTheUserAccount200Response {
    /**
     * 
     * @type {string}
     * @memberof GetModifiableMonthlyLimitsForTheUserAccount200Response
     */
    'userAccountId': string;
    /**
     * 
     * @type {string}
     * @memberof GetModifiableMonthlyLimitsForTheUserAccount200Response
     */
    'limitType': GetModifiableMonthlyLimitsForTheUserAccount200ResponseLimitTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof GetModifiableMonthlyLimitsForTheUserAccount200Response
     */
    'limit': number | null;
}

export const GetModifiableMonthlyLimitsForTheUserAccount200ResponseLimitTypeEnum = {
    dailyLimit: 'DAILY_LIMIT',
    monthlyLimit: 'MONTHLY_LIMIT',
    transactionLimit: 'TRANSACTION_LIMIT'
} as const;

export type GetModifiableMonthlyLimitsForTheUserAccount200ResponseLimitTypeEnum = typeof GetModifiableMonthlyLimitsForTheUserAccount200ResponseLimitTypeEnum[keyof typeof GetModifiableMonthlyLimitsForTheUserAccount200ResponseLimitTypeEnum];

/**
 * 
 * @export
 * @interface GetModifiableTransactionLimitsForTheUserAccount200Response
 */
export interface GetModifiableTransactionLimitsForTheUserAccount200Response {
    /**
     * 
     * @type {string}
     * @memberof GetModifiableTransactionLimitsForTheUserAccount200Response
     */
    'userAccountId': string;
    /**
     * 
     * @type {string}
     * @memberof GetModifiableTransactionLimitsForTheUserAccount200Response
     */
    'limitType': GetModifiableTransactionLimitsForTheUserAccount200ResponseLimitTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof GetModifiableTransactionLimitsForTheUserAccount200Response
     */
    'limit': number | null;
}

export const GetModifiableTransactionLimitsForTheUserAccount200ResponseLimitTypeEnum = {
    dailyLimit: 'DAILY_LIMIT',
    monthlyLimit: 'MONTHLY_LIMIT',
    transactionLimit: 'TRANSACTION_LIMIT'
} as const;

export type GetModifiableTransactionLimitsForTheUserAccount200ResponseLimitTypeEnum = typeof GetModifiableTransactionLimitsForTheUserAccount200ResponseLimitTypeEnum[keyof typeof GetModifiableTransactionLimitsForTheUserAccount200ResponseLimitTypeEnum];

/**
 * 
 * @export
 * @interface GetMoneytreeConnected200Response
 */
export interface GetMoneytreeConnected200Response {
    /**
     * 
     * @type {boolean}
     * @memberof GetMoneytreeConnected200Response
     */
    'connected': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetMoneytreeConnected200Response
     */
    'isSsoLinked': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetMoneytreeConnected200Response
     */
    'hasBankAccount': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetMoneytreeConnected200Response
     */
    'hasUnlinkedBankAccount': boolean;
}
/**
 * 
 * @export
 * @interface GetMoneytreeOauthUrl200Response
 */
export interface GetMoneytreeOauthUrl200Response {
    /**
     * 
     * @type {string}
     * @memberof GetMoneytreeOauthUrl200Response
     */
    'url': string;
}
/**
 * 
 * @export
 * @interface GetMoneytreeStatus200Response
 */
export interface GetMoneytreeStatus200Response {
    /**
     * 
     * @type {boolean}
     * @memberof GetMoneytreeStatus200Response
     */
    'connected': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetMoneytreeStatus200Response
     */
    'isSsoLinked': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetMoneytreeStatus200Response
     */
    'hasBankAccount': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetMoneytreeStatus200Response
     */
    'hasUnlinkedBankAccount': boolean;
}
/**
 * @type GetMonthlyCardBill200Response
 * @export
 */
export type GetMonthlyCardBill200Response = Array<GetMonthlyCardBill200ResponseOneOf1Inner> | GetMonthlyCardBill200ResponseOneOf;

/**
 * 
 * @export
 * @interface GetMonthlyCardBill200ResponseOneOf
 */
export interface GetMonthlyCardBill200ResponseOneOf {
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardBill200ResponseOneOf
     */
    'yearMonth': string;
    /**
     * 
     * @type {number}
     * @memberof GetMonthlyCardBill200ResponseOneOf
     */
    'billingAmountBeforePointDiscount': number;
    /**
     * 
     * @type {number}
     * @memberof GetMonthlyCardBill200ResponseOneOf
     */
    'billingAmount': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetMonthlyCardBill200ResponseOneOf
     */
    'pointAmount': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetMonthlyCardBill200ResponseOneOf
     */
    'cardBalance': number;
    /**
     * 
     * @type {boolean}
     * @memberof GetMonthlyCardBill200ResponseOneOf
     */
    'isInvoiced': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardBill200ResponseOneOf
     */
    'cardBillId': string | null;
}
/**
 * 
 * @export
 * @interface GetMonthlyCardBill200ResponseOneOf1Inner
 */
export interface GetMonthlyCardBill200ResponseOneOf1Inner {
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardBill200ResponseOneOf1Inner
     */
    'yearMonth': string;
    /**
     * 
     * @type {number}
     * @memberof GetMonthlyCardBill200ResponseOneOf1Inner
     */
    'billingAmountBeforePointDiscount': number;
    /**
     * 
     * @type {number}
     * @memberof GetMonthlyCardBill200ResponseOneOf1Inner
     */
    'billingAmount': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetMonthlyCardBill200ResponseOneOf1Inner
     */
    'pointAmount': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetMonthlyCardBill200ResponseOneOf1Inner
     */
    'cardBalance': number;
    /**
     * 
     * @type {boolean}
     * @memberof GetMonthlyCardBill200ResponseOneOf1Inner
     */
    'isInvoiced': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardBill200ResponseOneOf1Inner
     */
    'cardBillId': string | null;
}
/**
 * 
 * @export
 * @interface GetMonthlyCardTransactionsForTheOrganization200Response
 */
export interface GetMonthlyCardTransactionsForTheOrganization200Response {
    /**
     * 
     * @type {number}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200Response
     */
    'amount': number;
    /**
     * 
     * @type {Array<GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInner>}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200Response
     */
    'mergedTransactionDetailList': Array<GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInner>;
}
/**
 * 
 * @export
 * @interface GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInner
 */
export interface GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInner {
    /**
     * 
     * @type {GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerMergedCardTransaction}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInner
     */
    'mergedCardTransaction': GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerMergedCardTransaction;
    /**
     * 
     * @type {GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerCardTransactionEvidenceStatus}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInner
     */
    'cardTransactionEvidenceStatus': GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerCardTransactionEvidenceStatus;
    /**
     * 
     * @type {Array<GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInner>}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInner
     */
    'evidenceList': Array<GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInner>;
    /**
     * 
     * @type {Array<GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerRequestHistoryInner>}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInner
     */
    'requestHistory': Array<GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerRequestHistoryInner>;
    /**
     * 
     * @type {GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerComment}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInner
     */
    'comment'?: GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerComment;
    /**
     * 
     * @type {GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceRemindStatus}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInner
     */
    'evidenceRemindStatus': GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceRemindStatus;
    /**
     * 
     * @type {GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerUserAccount}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInner
     */
    'userAccount': GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerUserAccount;
    /**
     * 
     * @type {Array<GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInner>}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInner
     */
    'purchaseApplications': Array<GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInner>;
}
/**
 * 
 * @export
 * @interface GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerCardTransactionEvidenceStatus
 */
export interface GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerCardTransactionEvidenceStatus {
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerCardTransactionEvidenceStatus
     */
    'visaTransactionReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerCardTransactionEvidenceStatus
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerCardTransactionEvidenceStatus
     */
    'isRequested': boolean;
    /**
     * 
     * @type {GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerCardTransactionEvidenceStatusRequestedBy}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerCardTransactionEvidenceStatus
     */
    'requestedBy': GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerCardTransactionEvidenceStatusRequestedBy | null;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerCardTransactionEvidenceStatus
     */
    'requestedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerCardTransactionEvidenceStatus
     */
    'isLocked': boolean;
    /**
     * 
     * @type {GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerCardTransactionEvidenceStatusLockedBy}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerCardTransactionEvidenceStatus
     */
    'lockedBy': GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerCardTransactionEvidenceStatusLockedBy | null;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerCardTransactionEvidenceStatus
     */
    'lockedAt': string;
}
/**
 * 
 * @export
 * @interface GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerCardTransactionEvidenceStatusLockedBy
 */
export interface GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerCardTransactionEvidenceStatusLockedBy {
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerCardTransactionEvidenceStatusLockedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerCardTransactionEvidenceStatusLockedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerCardTransactionEvidenceStatusRequestedBy
 */
export interface GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerCardTransactionEvidenceStatusRequestedBy {
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerCardTransactionEvidenceStatusRequestedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerCardTransactionEvidenceStatusRequestedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerComment
 */
export interface GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerComment {
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerComment
     */
    'cardTransactionCommentId': string;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerComment
     */
    'visaTransactionReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerComment
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerComment
     */
    'comment': string;
    /**
     * 
     * @type {GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerCommentCreatedBy}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerComment
     */
    'createdBy': GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerCommentCreatedBy;
}
/**
 * 
 * @export
 * @interface GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerCommentCreatedBy
 */
export interface GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerCommentCreatedBy {
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerCommentCreatedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerCommentCreatedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInner
 */
export interface GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInner {
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInner
     * @deprecated
     */
    'cardTransactionEvidenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInner
     * @deprecated
     */
    'visaTransactionReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'paymentType': GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerPaymentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'fileName': string;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'fileExtension': string;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'electronicMethod': GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerElectronicMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'documentSize': GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerDocumentSizeEnum;
    /**
     * 
     * @type {number}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInner
     * @deprecated
     */
    'dpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'detectedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'calculatedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'colorGradation': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'verticalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'horizontalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'heightMillis': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'widthMillis': number | null;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'legalValidity': GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerLegalValidityEnum;
    /**
     * 
     * @type {boolean}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'dpiForciblyValid': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'colorGradationForciblyValid': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'note': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'irrelevantToLedger': boolean;
    /**
     * 
     * @type {GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerInvoiceIssuer}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'invoiceIssuer': GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerInvoiceIssuer | null;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInner
     * @deprecated
     */
    'dpiError': GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerDpiErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInner
     * @deprecated
     */
    'detectedDpiError': GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerDetectedDpiErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInner
     * @deprecated
     */
    'calculatedDpiError': GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerCalculatedDpiErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInner
     * @deprecated
     */
    'colorGradationError': GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerColorGradationErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInner
     * @deprecated
     */
    'heightMillisError': GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerHeightMillisErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInner
     * @deprecated
     */
    'widthMillisError': GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerWidthMillisErrorEnum;
    /**
     * 
     * @type {GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrors}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'errors': GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrors;
    /**
     * 
     * @type {GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarnings}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'warnings': GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarnings;
    /**
     * 
     * @type {GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerCreatedBy}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'createdBy': GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerCreatedBy;
    /**
     * 
     * @type {GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerUpdatedBy}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'updatedBy': GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerUpdatedBy;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'updatedAt': string;
    /**
     * 
     * @type {GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerUploadedBy}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'uploadedBy': GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerUploadedBy;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'uploadedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'uploadedByRecipient': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'needsMigration': boolean | null;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'uploadedFrom': string;
}

export const GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerPaymentTypeEnum = {
    cardTransaction: 'CARD_TRANSACTION',
    paymentRequest: 'PAYMENT_REQUEST'
} as const;

export type GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerPaymentTypeEnum = typeof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerPaymentTypeEnum[keyof typeof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerPaymentTypeEnum];
export const GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerElectronicMethodEnum = {
    fullElectronic: 'FULL_ELECTRONIC',
    originallyPaper: 'ORIGINALLY_PAPER',
    unknown: 'UNKNOWN'
} as const;

export type GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerElectronicMethodEnum = typeof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerElectronicMethodEnum[keyof typeof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerElectronicMethodEnum];
export const GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerDocumentSizeEnum = {
    overA4: 'OVER_A4',
    a4OrSmaller: 'A4_OR_SMALLER',
    unknown: 'UNKNOWN'
} as const;

export type GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerDocumentSizeEnum = typeof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerDocumentSizeEnum[keyof typeof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerDocumentSizeEnum];
export const GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerLegalValidityEnum = {
    valid: 'VALID',
    invalid: 'INVALID',
    inputRequired: 'INPUT_REQUIRED',
    outOfTarget: 'OUT_OF_TARGET'
} as const;

export type GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerLegalValidityEnum = typeof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerLegalValidityEnum[keyof typeof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerLegalValidityEnum];
export const GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerDpiErrorEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerDpiErrorEnum = typeof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerDpiErrorEnum[keyof typeof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerDpiErrorEnum];
export const GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerDetectedDpiErrorEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerDetectedDpiErrorEnum = typeof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerDetectedDpiErrorEnum[keyof typeof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerDetectedDpiErrorEnum];
export const GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerCalculatedDpiErrorEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerCalculatedDpiErrorEnum = typeof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerCalculatedDpiErrorEnum[keyof typeof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerCalculatedDpiErrorEnum];
export const GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerColorGradationErrorEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerColorGradationErrorEnum = typeof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerColorGradationErrorEnum[keyof typeof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerColorGradationErrorEnum];
export const GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerHeightMillisErrorEnum = {
    required: 'REQUIRED'
} as const;

export type GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerHeightMillisErrorEnum = typeof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerHeightMillisErrorEnum[keyof typeof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerHeightMillisErrorEnum];
export const GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerWidthMillisErrorEnum = {
    required: 'REQUIRED'
} as const;

export type GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerWidthMillisErrorEnum = typeof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerWidthMillisErrorEnum[keyof typeof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerWidthMillisErrorEnum];

/**
 * 
 * @export
 * @interface GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerCreatedBy
 */
export interface GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerCreatedBy {
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerCreatedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerCreatedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrors
 */
export interface GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrors {
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrors
     */
    'detectedDpi'?: GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrors
     */
    'calculatedDpi'?: GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrors
     */
    'colorGradation'?: GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrors
     */
    'heightMillis'?: GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrors
     */
    'widthMillis'?: GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsWidthMillisEnum;
}

export const GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsDetectedDpiEnum = typeof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsDetectedDpiEnum[keyof typeof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsDetectedDpiEnum];
export const GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsCalculatedDpiEnum = typeof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsCalculatedDpiEnum[keyof typeof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsCalculatedDpiEnum];
export const GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsColorGradationEnum = typeof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsColorGradationEnum[keyof typeof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsColorGradationEnum];
export const GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsHeightMillisEnum = typeof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsHeightMillisEnum[keyof typeof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsHeightMillisEnum];
export const GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsWidthMillisEnum = typeof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsWidthMillisEnum[keyof typeof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsWidthMillisEnum];

/**
 * Set null if it\'s evidence not analyzed using invoicing-system-compliance feature. Also set null if invoicing-system-compliance feature has been made not available for the organization by the feature-flag.
 * @export
 * @interface GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerInvoiceIssuer
 */
export interface GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerInvoiceIssuer {
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerInvoiceIssuer
     */
    'name': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerInvoiceIssuer
     */
    'registrationNumber': string | null;
    /**
     * isQualified retains the result of querying the 国税庁API to see if registrationNumber is qualified, as is.
     * @type {boolean}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerInvoiceIssuer
     */
    'isQualified': boolean;
    /**
     * AsQualified indicates whether this issuer should be treated as a qualified invoice issuer within the user\'s system, even if the RegistrationNumber is not confirmed as qualified in the National Tax Agency\'s business registration system.
     * @type {boolean}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerInvoiceIssuer
     */
    'asQualified': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerInvoiceIssuer
     */
    'partnerId': string | null;
}
/**
 * 
 * @export
 * @interface GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerUpdatedBy
 */
export interface GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerUpdatedBy {
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerUpdatedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerUpdatedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerUploadedBy
 */
export interface GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerUploadedBy {
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerUploadedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerUploadedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarnings
 */
export interface GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarnings {
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarnings
     */
    'detectedDpi'?: GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarnings
     */
    'calculatedDpi'?: GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarnings
     */
    'colorGradation'?: GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarnings
     */
    'heightMillis'?: GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarnings
     */
    'widthMillis'?: GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsWidthMillisEnum;
}

export const GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsDetectedDpiEnum = typeof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsDetectedDpiEnum[keyof typeof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsDetectedDpiEnum];
export const GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsCalculatedDpiEnum = typeof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsCalculatedDpiEnum[keyof typeof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsCalculatedDpiEnum];
export const GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsColorGradationEnum = typeof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsColorGradationEnum[keyof typeof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsColorGradationEnum];
export const GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsHeightMillisEnum = typeof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsHeightMillisEnum[keyof typeof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsHeightMillisEnum];
export const GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsWidthMillisEnum = typeof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsWidthMillisEnum[keyof typeof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsWidthMillisEnum];

/**
 * 
 * @export
 * @interface GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceRemindStatus
 */
export interface GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceRemindStatus {
    /**
     * 
     * @type {boolean}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceRemindStatus
     */
    'isAutoRemind': boolean;
}
/**
 * 
 * @export
 * @interface GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerMergedCardTransaction
 */
export interface GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerMergedCardTransaction {
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerMergedCardTransaction
     */
    'visaTransactionReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerMergedCardTransaction
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerMergedCardTransaction
     */
    'merchantName': string;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerMergedCardTransaction
     */
    'merchantNameKana': string;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerMergedCardTransaction
     */
    'merchantNameKanji': string;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerMergedCardTransaction
     */
    'mergedMerchantName': string;
    /**
     * 
     * @type {number}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerMergedCardTransaction
     */
    'amount': number;
    /**
     * 
     * @type {number}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerMergedCardTransaction
     */
    'amountFx': number;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerMergedCardTransaction
     */
    'currencyCode': string;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerMergedCardTransaction
     */
    'processedAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerMergedCardTransaction
     */
    'transactionType': GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerMergedCardTransaction
     */
    'creditSettlement': number;
    /**
     * 
     * @type {Array<GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner>}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerMergedCardTransaction
     */
    'transactionRecordList': Array<GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner>;
    /**
     * 
     * @type {boolean}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerMergedCardTransaction
     */
    'isCleared': boolean;
}

export const GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionTypeEnum = {
    confirm: 'CONFIRM',
    notConfirm: 'NOT_CONFIRM'
} as const;

export type GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionTypeEnum = typeof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionTypeEnum[keyof typeof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionTypeEnum];

/**
 * 
 * @export
 * @interface GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner
 */
export interface GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner {
    /**
     * 
     * @type {number}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner
     */
    'amount': number;
    /**
     * 
     * @type {number}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner
     */
    'amountFx': number;
    /**
     * 
     * @type {number}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner
     */
    'totalAmount': number;
    /**
     * 
     * @type {number}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner
     */
    'totalAmountFx': number;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner
     */
    'currencyCode': string;
    /**
     * 
     * @type {number}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner
     */
    'fxRate': number | null;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner
     */
    'processedAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner
     */
    'transactionDetailType': GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner
     */
    'isCleared': boolean;
}

export const GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum = {
    purchase: 'PURCHASE',
    settlement: 'SETTLEMENT',
    validation: 'VALIDATION',
    refund: 'REFUND',
    cancel: 'CANCEL',
    refundCancel: 'REFUND_CANCEL',
    refundPartialCancel: 'REFUND_PARTIAL_CANCEL'
} as const;

export type GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum = typeof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum[keyof typeof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum];

/**
 * 
 * @export
 * @interface GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInner
 */
export interface GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInner {
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInner
     */
    'applicationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInner
     */
    'applicationNumber': string;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInner
     */
    'paymentDate': string;
    /**
     * 
     * @type {GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerSubmittedBy}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInner
     */
    'submittedBy': GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerSubmittedBy;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInner
     */
    'submittedAt': string;
    /**
     * 
     * @type {Array<GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerApproversInner>}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInner
     */
    'approvers': Array<GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerApproversInner>;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInner
     */
    'department': string;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInner
     */
    'purchaseReason': string;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInner
     */
    'purchaseDetails': string;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInner
     */
    'placeOfUse': string;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInner
     */
    'purposeOfUse': string;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInner
     */
    'url': string;
    /**
     * 
     * @type {number}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInner
     */
    'amount': number;
    /**
     * 
     * @type {GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccount}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInner
     */
    'userAccount': GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccount | null;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInner
     */
    'remarks': string;
    /**
     * 
     * @type {GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerWorkRequestedBy}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInner
     */
    'workRequestedBy': GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerWorkRequestedBy;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInner
     */
    'workRequestApprovers': string;
    /**
     * 
     * @type {GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerStatus}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInner
     */
    'status': GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerStatus;
    /**
     * 
     * @type {GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerCreatedBy}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInner
     */
    'createdBy': GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerCreatedBy;
}
/**
 * 
 * @export
 * @interface GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerApproversInner
 */
export interface GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerApproversInner {
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerApproversInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerApproversInner
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerCreatedBy
 */
export interface GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerCreatedBy {
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerCreatedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerCreatedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerStatus
 */
export interface GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerStatus {
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerStatus
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerStatus
     */
    'comment': string;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerStatus
     */
    'statusChangedAt': string;
    /**
     * 
     * @type {GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerStatusCreatedBy}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerStatus
     */
    'createdBy': GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerStatusCreatedBy;
}
/**
 * 
 * @export
 * @interface GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerStatusCreatedBy
 */
export interface GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerStatusCreatedBy {
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerStatusCreatedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerStatusCreatedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerSubmittedBy
 */
export interface GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerSubmittedBy {
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerSubmittedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerSubmittedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccount
 */
export interface GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccount {
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccount
     */
    'userAccountId': string;
    /**
     * 
     * @type {GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUser}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccount
     */
    'user': GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUser;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccount
     */
    'cardLabel': string;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccount
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccount
     */
    'organizationName': string;
    /**
     * 
     * @type {GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUserAccountGroup}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccount
     */
    'userAccountGroup': GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUserAccountGroup | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccount
     */
    'isOnDemand': boolean;
}
/**
 * 
 * @export
 * @interface GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUser
 */
export interface GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUser {
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUser
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUser
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUser
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUser
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUser
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUser
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUser
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUser
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUser
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUser
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUser
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUserAccountGroup
 */
export interface GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUserAccountGroup {
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUserAccountGroup
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUserAccountGroup
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUserAccountGroup
     */
    'sortNum': number;
}
/**
 * 
 * @export
 * @interface GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerWorkRequestedBy
 */
export interface GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerWorkRequestedBy {
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerWorkRequestedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerPurchaseApplicationsInnerWorkRequestedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerRequestHistoryInner
 */
export interface GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerRequestHistoryInner {
    /**
     * 
     * @type {number}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerRequestHistoryInner
     */
    'requestId': number;
    /**
     * 
     * @type {GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerRequestHistoryInnerRequestedBy}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerRequestHistoryInner
     */
    'requestedBy': GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerRequestHistoryInnerRequestedBy;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerRequestHistoryInner
     */
    'requestedAt': string;
}
/**
 * 
 * @export
 * @interface GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerRequestHistoryInnerRequestedBy
 */
export interface GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerRequestHistoryInnerRequestedBy {
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerRequestHistoryInnerRequestedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerRequestHistoryInnerRequestedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerUserAccount
 */
export interface GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerUserAccount {
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerUserAccount
     */
    'userAccountId': string;
    /**
     * 
     * @type {GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerUserAccountUser}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerUserAccount
     */
    'user': GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerUserAccountUser;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerUserAccount
     */
    'cardLabel': string;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerUserAccount
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerUserAccount
     */
    'organizationName': string;
    /**
     * 
     * @type {GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerUserAccountUserAccountGroup}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerUserAccount
     */
    'userAccountGroup': GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerUserAccountUserAccountGroup | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerUserAccount
     */
    'isOnDemand': boolean;
}
/**
 * 
 * @export
 * @interface GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerUserAccountUser
 */
export interface GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerUserAccountUser {
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerUserAccountUser
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerUserAccountUser
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerUserAccountUser
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerUserAccountUser
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerUserAccountUser
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerUserAccountUser
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerUserAccountUser
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerUserAccountUser
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerUserAccountUser
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerUserAccountUser
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerUserAccountUser
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerUserAccountUserAccountGroup
 */
export interface GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerUserAccountUserAccountGroup {
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerUserAccountUserAccountGroup
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerUserAccountUserAccountGroup
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerUserAccountUserAccountGroup
     */
    'sortNum': number;
}
/**
 * 
 * @export
 * @interface GetMonthlyUserCardSummaries200ResponseInner
 */
export interface GetMonthlyUserCardSummaries200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyUserCardSummaries200ResponseInner
     */
    'userAccountId': string;
    /**
     * 
     * @type {GetMonthlyUserCardSummaries200ResponseInnerUser}
     * @memberof GetMonthlyUserCardSummaries200ResponseInner
     */
    'user': GetMonthlyUserCardSummaries200ResponseInnerUser;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyUserCardSummaries200ResponseInner
     */
    'cardLabel': string;
    /**
     * 
     * @type {GetMonthlyUserCardSummaries200ResponseInnerCurrentCard}
     * @memberof GetMonthlyUserCardSummaries200ResponseInner
     */
    'currentCard': GetMonthlyUserCardSummaries200ResponseInnerCurrentCard;
    /**
     * 
     * @type {number}
     * @memberof GetMonthlyUserCardSummaries200ResponseInner
     */
    'amount': number;
    /**
     * 
     * @type {boolean}
     * @memberof GetMonthlyUserCardSummaries200ResponseInner
     */
    'isPhysicalStorePaymentDisabled': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetMonthlyUserCardSummaries200ResponseInner
     */
    'isOnDemand': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyUserCardSummaries200ResponseInner
     */
    'expiredDate': string | null;
    /**
     * 
     * @type {GetMonthlyUserCardSummaries200ResponseInnerUserAccountGroup}
     * @memberof GetMonthlyUserCardSummaries200ResponseInner
     */
    'userAccountGroup': GetMonthlyUserCardSummaries200ResponseInnerUserAccountGroup | null;
}
/**
 * 
 * @export
 * @interface GetMonthlyUserCardSummaries200ResponseInnerCurrentCard
 */
export interface GetMonthlyUserCardSummaries200ResponseInnerCurrentCard {
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyUserCardSummaries200ResponseInnerCurrentCard
     */
    'cardId': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetMonthlyUserCardSummaries200ResponseInnerCurrentCard
     */
    'isActivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetMonthlyUserCardSummaries200ResponseInnerCurrentCard
     */
    'isDeactivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetMonthlyUserCardSummaries200ResponseInnerCurrentCard
     */
    'isLocked': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetMonthlyUserCardSummaries200ResponseInnerCurrentCard
     */
    'isSuspended': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetMonthlyUserCardSummaries200ResponseInnerCurrentCard
     */
    'isFrozen': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyUserCardSummaries200ResponseInnerCurrentCard
     */
    'panLastFourDigits': string;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyUserCardSummaries200ResponseInnerCurrentCard
     */
    'linkedUserAccountId': string;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyUserCardSummaries200ResponseInnerCurrentCard
     */
    'createdAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetMonthlyUserCardSummaries200ResponseInnerCurrentCard
     */
    'isActive': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetMonthlyUserCardSummaries200ResponseInnerCurrentCard
     */
    'isVirtualCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetMonthlyUserCardSummaries200ResponseInnerCurrentCard
     */
    'isCreditCard': boolean;
}
/**
 * 
 * @export
 * @interface GetMonthlyUserCardSummaries200ResponseInnerUser
 */
export interface GetMonthlyUserCardSummaries200ResponseInnerUser {
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyUserCardSummaries200ResponseInnerUser
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyUserCardSummaries200ResponseInnerUser
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyUserCardSummaries200ResponseInnerUser
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyUserCardSummaries200ResponseInnerUser
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyUserCardSummaries200ResponseInnerUser
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetMonthlyUserCardSummaries200ResponseInnerUser
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetMonthlyUserCardSummaries200ResponseInnerUser
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetMonthlyUserCardSummaries200ResponseInnerUser
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetMonthlyUserCardSummaries200ResponseInnerUser
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetMonthlyUserCardSummaries200ResponseInnerUser
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyUserCardSummaries200ResponseInnerUser
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface GetMonthlyUserCardSummaries200ResponseInnerUserAccountGroup
 */
export interface GetMonthlyUserCardSummaries200ResponseInnerUserAccountGroup {
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyUserCardSummaries200ResponseInnerUserAccountGroup
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyUserCardSummaries200ResponseInnerUserAccountGroup
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof GetMonthlyUserCardSummaries200ResponseInnerUserAccountGroup
     */
    'sortNum'?: number;
}
/**
 * 
 * @export
 * @interface GetOnboardingRequestById200Response
 */
export interface GetOnboardingRequestById200Response {
    /**
     * 本社所在地：住所
     * @type {string}
     * @memberof GetOnboardingRequestById200Response
     */
    'address'?: string;
    /**
     * 反社チェック一覧
     * @type {Array<GetOnboardingRequestById200ResponseAntisocialForcesCheckInner>}
     * @memberof GetOnboardingRequestById200Response
     */
    'antisocialForcesCheck'?: Array<GetOnboardingRequestById200ResponseAntisocialForcesCheckInner>;
    /**
     * 実質的支配者
     * @type {Array<GetOnboardingRequestById200ResponseBeneficialOwnersInner>}
     * @memberof GetOnboardingRequestById200Response
     */
    'beneficialOwners'?: Array<GetOnboardingRequestById200ResponseBeneficialOwnersInner>;
    /**
     * 法人番号
     * @type {string}
     * @memberof GetOnboardingRequestById200Response
     */
    'corporateNumber'?: string;
    /**
     * 法人種別(enum)
     * @type {string}
     * @memberof GetOnboardingRequestById200Response
     */
    'corporateType'?: GetOnboardingRequestById200ResponseCorporateTypeEnum;
    /**
     * 作成日時
     * @type {string}
     * @memberof GetOnboardingRequestById200Response
     */
    'createdAt'?: string;
    /**
     * メールアドレス
     * @type {string}
     * @memberof GetOnboardingRequestById200Response
     */
    'email'?: string;
    /**
     * マイナンバーで確認済の認証情報一式
     * @type {Array<GetOnboardingRequestById200ResponseIdentityVerificationInner>}
     * @memberof GetOnboardingRequestById200Response
     */
    'identityVerification'?: Array<GetOnboardingRequestById200ResponseIdentityVerificationInner>;
    /**
     * 実質的支配者有無
     * @type {boolean}
     * @memberof GetOnboardingRequestById200Response
     */
    'isExistsBeneficialOwner'?: boolean;
    /**
     * マイナンバー検証サービスの検証ID
     * @type {string}
     * @memberof GetOnboardingRequestById200Response
     */
    'jpkiVerificationId'?: string;
    /**
     * メモ
     * @type {string}
     * @memberof GetOnboardingRequestById200Response
     */
    'note'?: string;
    /**
     * オンボーディング途中再開用のセッションID
     * @type {string}
     * @memberof GetOnboardingRequestById200Response
     */
    'onboardingSessionId'?: string;
    /**
     * 法人名
     * @type {string}
     * @memberof GetOnboardingRequestById200Response
     */
    'organizationName'?: string;
    /**
     * 初期作成ユーザー
     * @type {Array<GetOnboardingRequestById200ResponseOrganizationUsersInner>}
     * @memberof GetOnboardingRequestById200Response
     */
    'organizationUsers'?: Array<GetOnboardingRequestById200ResponseOrganizationUsersInner>;
    /**
     * 電話番号
     * @type {string}
     * @memberof GetOnboardingRequestById200Response
     */
    'phoneNumber'?: string;
    /**
     * 本社所在地：郵便番号
     * @type {string}
     * @memberof GetOnboardingRequestById200Response
     */
    'postalCode'?: string;
    /**
     * 取引目的
     * @type {string}
     * @memberof GetOnboardingRequestById200Response
     */
    'purposeTransaction'?: GetOnboardingRequestById200ResponsePurposeTransactionEnum;
    /**
     * 取引目的その他自由記述
     * @type {string}
     * @memberof GetOnboardingRequestById200Response
     */
    'purposeTransactionOther'?: string;
    /**
     * 代表者氏名
     * @type {string}
     * @memberof GetOnboardingRequestById200Response
     */
    'representativeName'?: string;
    /**
     * 代表者電話番号
     * @type {string}
     * @memberof GetOnboardingRequestById200Response
     */
    'representativePhoneNumber'?: string;
    /**
     * 代表者生年月日
     * @type {string}
     * @memberof GetOnboardingRequestById200Response
     */
    'representativeBirthday'?: string;
    /**
     * 代表者住所
     * @type {string}
     * @memberof GetOnboardingRequestById200Response
     */
    'representativeAddress'?: string;
    /**
     * 郵送確認一覧
     * @type {Array<GetOnboardingRequestById200ResponseSnailMailVerificationInner>}
     * @memberof GetOnboardingRequestById200Response
     */
    'snailMailVerification'?: Array<GetOnboardingRequestById200ResponseSnailMailVerificationInner>;
}

export const GetOnboardingRequestById200ResponseCorporateTypeEnum = {
    exceptMajorityCapitalVoteCorporate: 'EXCEPT_MAJORITY_CAPITAL_VOTE_CORPORATE',
    majorityCapitalVoteCorporate: 'MAJORITY_CAPITAL_VOTE_CORPORATE'
} as const;

export type GetOnboardingRequestById200ResponseCorporateTypeEnum = typeof GetOnboardingRequestById200ResponseCorporateTypeEnum[keyof typeof GetOnboardingRequestById200ResponseCorporateTypeEnum];
export const GetOnboardingRequestById200ResponsePurposeTransactionEnum = {
    adExpenses: 'AD_EXPENSES',
    calculatedAsExpense: 'CALCULATED_AS_EXPENSE',
    other: 'OTHER',
    stocking: 'STOCKING',
    systemUsageFee: 'SYSTEM_USAGE_FEE'
} as const;

export type GetOnboardingRequestById200ResponsePurposeTransactionEnum = typeof GetOnboardingRequestById200ResponsePurposeTransactionEnum[keyof typeof GetOnboardingRequestById200ResponsePurposeTransactionEnum];

/**
 * 
 * @export
 * @interface GetOnboardingRequestById200ResponseAntisocialForcesCheckInner
 */
export interface GetOnboardingRequestById200ResponseAntisocialForcesCheckInner {
    /**
     * 
     * @type {string}
     * @memberof GetOnboardingRequestById200ResponseAntisocialForcesCheckInner
     */
    'category'?: GetOnboardingRequestById200ResponseAntisocialForcesCheckInnerCategoryEnum;
    /**
     * 
     * @type {GetOnboardingRequestById200ResponseAntisocialForcesCheckInnerCondition}
     * @memberof GetOnboardingRequestById200ResponseAntisocialForcesCheckInner
     */
    'condition'?: GetOnboardingRequestById200ResponseAntisocialForcesCheckInnerCondition;
    /**
     * 
     * @type {string}
     * @memberof GetOnboardingRequestById200ResponseAntisocialForcesCheckInner
     */
    'organizationIdentityVerificationId'?: string;
    /**
     * 
     * @type {number}
     * @memberof GetOnboardingRequestById200ResponseAntisocialForcesCheckInner
     */
    'payloadDetailId'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetOnboardingRequestById200ResponseAntisocialForcesCheckInner
     */
    'payloadId'?: string;
    /**
     * 
     * @type {Array<GetOnboardingRequestById200ResponseAntisocialForcesCheckInnerResultsInner>}
     * @memberof GetOnboardingRequestById200ResponseAntisocialForcesCheckInner
     */
    'results'?: Array<GetOnboardingRequestById200ResponseAntisocialForcesCheckInnerResultsInner>;
    /**
     * 
     * @type {string}
     * @memberof GetOnboardingRequestById200ResponseAntisocialForcesCheckInner
     */
    'status'?: GetOnboardingRequestById200ResponseAntisocialForcesCheckInnerStatusEnum;
}

export const GetOnboardingRequestById200ResponseAntisocialForcesCheckInnerCategoryEnum = {
    company: 'company',
    customer: 'customer'
} as const;

export type GetOnboardingRequestById200ResponseAntisocialForcesCheckInnerCategoryEnum = typeof GetOnboardingRequestById200ResponseAntisocialForcesCheckInnerCategoryEnum[keyof typeof GetOnboardingRequestById200ResponseAntisocialForcesCheckInnerCategoryEnum];
export const GetOnboardingRequestById200ResponseAntisocialForcesCheckInnerStatusEnum = {
    done: 'DONE',
    requested: 'REQUESTED',
    manualApproval: 'MANUAL_APPROVAL'
} as const;

export type GetOnboardingRequestById200ResponseAntisocialForcesCheckInnerStatusEnum = typeof GetOnboardingRequestById200ResponseAntisocialForcesCheckInnerStatusEnum[keyof typeof GetOnboardingRequestById200ResponseAntisocialForcesCheckInnerStatusEnum];

/**
 * 
 * @export
 * @interface GetOnboardingRequestById200ResponseAntisocialForcesCheckInnerCondition
 */
export interface GetOnboardingRequestById200ResponseAntisocialForcesCheckInnerCondition {
    /**
     * 
     * @type {string}
     * @memberof GetOnboardingRequestById200ResponseAntisocialForcesCheckInnerCondition
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface GetOnboardingRequestById200ResponseAntisocialForcesCheckInnerResultsInner
 */
export interface GetOnboardingRequestById200ResponseAntisocialForcesCheckInnerResultsInner {
    /**
     * 
     * @type {string}
     * @memberof GetOnboardingRequestById200ResponseAntisocialForcesCheckInnerResultsInner
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetOnboardingRequestById200ResponseAntisocialForcesCheckInnerResultsInner
     */
    'address'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetOnboardingRequestById200ResponseAntisocialForcesCheckInnerResultsInner
     */
    'antisocial_group'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetOnboardingRequestById200ResponseAntisocialForcesCheckInnerResultsInner
     */
    'journal_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetOnboardingRequestById200ResponseAntisocialForcesCheckInnerResultsInner
     */
    'reported_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetOnboardingRequestById200ResponseAntisocialForcesCheckInnerResultsInner
     */
    'note'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetOnboardingRequestById200ResponseAntisocialForcesCheckInnerResultsInner
     */
    'birthday'?: string;
}
/**
 * 
 * @export
 * @interface GetOnboardingRequestById200ResponseBeneficialOwnersInner
 */
export interface GetOnboardingRequestById200ResponseBeneficialOwnersInner {
    /**
     * 住所
     * @type {string}
     * @memberof GetOnboardingRequestById200ResponseBeneficialOwnersInner
     */
    'address'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetOnboardingRequestById200ResponseBeneficialOwnersInner
     */
    'beneficialOwnerType'?: GetOnboardingRequestById200ResponseBeneficialOwnersInnerBeneficialOwnerTypeEnum;
    /**
     * 生年月日
     * @type {string}
     * @memberof GetOnboardingRequestById200ResponseBeneficialOwnersInner
     */
    'birthday'?: string;
    /**
     * 法人との関係性
     * @type {string}
     * @memberof GetOnboardingRequestById200ResponseBeneficialOwnersInner
     */
    'corporateRelationships'?: GetOnboardingRequestById200ResponseBeneficialOwnersInnerCorporateRelationshipsEnum;
    /**
     * 居住国
     * @type {string}
     * @memberof GetOnboardingRequestById200ResponseBeneficialOwnersInner
     */
    'countryResidence'?: string;
    /**
     * 性別
     * @type {string}
     * @memberof GetOnboardingRequestById200ResponseBeneficialOwnersInner
     */
    'gender'?: GetOnboardingRequestById200ResponseBeneficialOwnersInnerGenderEnum;
    /**
     * 外国人PEPsに該当するか
     * @type {boolean}
     * @memberof GetOnboardingRequestById200ResponseBeneficialOwnersInner
     */
    'isPoliticallyExposedPersons'?: boolean;
    /**
     * 氏名・法人名
     * @type {string}
     * @memberof GetOnboardingRequestById200ResponseBeneficialOwnersInner
     */
    'name'?: string;
}

export const GetOnboardingRequestById200ResponseBeneficialOwnersInnerBeneficialOwnerTypeEnum = {
    corporation: 'CORPORATION',
    person: 'PERSON'
} as const;

export type GetOnboardingRequestById200ResponseBeneficialOwnersInnerBeneficialOwnerTypeEnum = typeof GetOnboardingRequestById200ResponseBeneficialOwnersInnerBeneficialOwnerTypeEnum[keyof typeof GetOnboardingRequestById200ResponseBeneficialOwnersInnerBeneficialOwnerTypeEnum];
export const GetOnboardingRequestById200ResponseBeneficialOwnersInnerCorporateRelationshipsEnum = {
    businessExecutor: 'BUSINESS_EXECUTOR',
    hasControllingInfluenceOverBusinessActivity: 'HAS_CONTROLLING_INFLUENCE_OVER_BUSINESS_ACTIVITY',
    hasRightOver25Per: 'HAS_RIGHT_OVER_25PER',
    hasRightOver50Per: 'HAS_RIGHT_OVER_50PER'
} as const;

export type GetOnboardingRequestById200ResponseBeneficialOwnersInnerCorporateRelationshipsEnum = typeof GetOnboardingRequestById200ResponseBeneficialOwnersInnerCorporateRelationshipsEnum[keyof typeof GetOnboardingRequestById200ResponseBeneficialOwnersInnerCorporateRelationshipsEnum];
export const GetOnboardingRequestById200ResponseBeneficialOwnersInnerGenderEnum = {
    female: 'FEMALE',
    male: 'MALE'
} as const;

export type GetOnboardingRequestById200ResponseBeneficialOwnersInnerGenderEnum = typeof GetOnboardingRequestById200ResponseBeneficialOwnersInnerGenderEnum[keyof typeof GetOnboardingRequestById200ResponseBeneficialOwnersInnerGenderEnum];

/**
 * 
 * @export
 * @interface GetOnboardingRequestById200ResponseIdentityVerificationInner
 */
export interface GetOnboardingRequestById200ResponseIdentityVerificationInner {
    /**
     * 
     * @type {Array<GetOnboardingRequestById200ResponseIdentityVerificationInnerRecordsInner>}
     * @memberof GetOnboardingRequestById200ResponseIdentityVerificationInner
     */
    'records'?: Array<GetOnboardingRequestById200ResponseIdentityVerificationInnerRecordsInner>;
    /**
     * 
     * @type {string}
     * @memberof GetOnboardingRequestById200ResponseIdentityVerificationInner
     */
    'state'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetOnboardingRequestById200ResponseIdentityVerificationInner
     */
    'result'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetOnboardingRequestById200ResponseIdentityVerificationInner
     */
    'methodType'?: GetOnboardingRequestById200ResponseIdentityVerificationInnerMethodTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetOnboardingRequestById200ResponseIdentityVerificationInner
     */
    'relatedIdentityVerificationId'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetOnboardingRequestById200ResponseIdentityVerificationInner
     */
    'verificationSourceType'?: GetOnboardingRequestById200ResponseIdentityVerificationInnerVerificationSourceTypeEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetOnboardingRequestById200ResponseIdentityVerificationInner
     */
    'verificationReferenceURLs'?: Array<string>;
}

export const GetOnboardingRequestById200ResponseIdentityVerificationInnerMethodTypeEnum = {
    idDocument: 'ID_DOCUMENT',
    idDocumentWa: 'ID_DOCUMENT_WA',
    idDocumentI: 'ID_DOCUMENT_I',
    companyVerificationDocument: 'COMPANY_VERIFICATION_DOCUMENT',
    supplementalDocument: 'SUPPLEMENTAL_DOCUMENT'
} as const;

export type GetOnboardingRequestById200ResponseIdentityVerificationInnerMethodTypeEnum = typeof GetOnboardingRequestById200ResponseIdentityVerificationInnerMethodTypeEnum[keyof typeof GetOnboardingRequestById200ResponseIdentityVerificationInnerMethodTypeEnum];
export const GetOnboardingRequestById200ResponseIdentityVerificationInnerVerificationSourceTypeEnum = {
    trustdock: 'TRUSTDOCK',
    pocketSign: 'POCKET_SIGN',
    internal: 'INTERNAL'
} as const;

export type GetOnboardingRequestById200ResponseIdentityVerificationInnerVerificationSourceTypeEnum = typeof GetOnboardingRequestById200ResponseIdentityVerificationInnerVerificationSourceTypeEnum[keyof typeof GetOnboardingRequestById200ResponseIdentityVerificationInnerVerificationSourceTypeEnum];

/**
 * 
 * @export
 * @interface GetOnboardingRequestById200ResponseIdentityVerificationInnerRecordsInner
 */
export interface GetOnboardingRequestById200ResponseIdentityVerificationInnerRecordsInner {
    /**
     * 
     * @type {Array<string>}
     * @memberof GetOnboardingRequestById200ResponseIdentityVerificationInnerRecordsInner
     */
    'reasons'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof GetOnboardingRequestById200ResponseIdentityVerificationInnerRecordsInner
     */
    'result'?: GetOnboardingRequestById200ResponseIdentityVerificationInnerRecordsInnerResultEnum;
    /**
     * 
     * @type {string}
     * @memberof GetOnboardingRequestById200ResponseIdentityVerificationInnerRecordsInner
     */
    'state'?: GetOnboardingRequestById200ResponseIdentityVerificationInnerRecordsInnerStateEnum;
}

export const GetOnboardingRequestById200ResponseIdentityVerificationInnerRecordsInnerResultEnum = {
    approved: 'APPROVED',
    denied: 'DENIED'
} as const;

export type GetOnboardingRequestById200ResponseIdentityVerificationInnerRecordsInnerResultEnum = typeof GetOnboardingRequestById200ResponseIdentityVerificationInnerRecordsInnerResultEnum[keyof typeof GetOnboardingRequestById200ResponseIdentityVerificationInnerRecordsInnerResultEnum];
export const GetOnboardingRequestById200ResponseIdentityVerificationInnerRecordsInnerStateEnum = {
    accepted: 'ACCEPTED',
    plansSelected: 'PLANS_SELECTED',
    inProgress: 'IN_PROGRESS',
    verified: 'VERIFIED'
} as const;

export type GetOnboardingRequestById200ResponseIdentityVerificationInnerRecordsInnerStateEnum = typeof GetOnboardingRequestById200ResponseIdentityVerificationInnerRecordsInnerStateEnum[keyof typeof GetOnboardingRequestById200ResponseIdentityVerificationInnerRecordsInnerStateEnum];

/**
 * 
 * @export
 * @interface GetOnboardingRequestById200ResponseOrganizationUsersInner
 */
export interface GetOnboardingRequestById200ResponseOrganizationUsersInner {
    /**
     * 
     * @type {string}
     * @memberof GetOnboardingRequestById200ResponseOrganizationUsersInner
     */
    'userMailAddress'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetOnboardingRequestById200ResponseOrganizationUsersInner
     */
    'userName'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetOnboardingRequestById200ResponseOrganizationUsersInner
     */
    'userPrivilege'?: GetOnboardingRequestById200ResponseOrganizationUsersInnerUserPrivilegeEnum;
}

export const GetOnboardingRequestById200ResponseOrganizationUsersInnerUserPrivilegeEnum = {
    bookkeeper: 'BOOKKEEPER',
    generalUser: 'GENERAL_USER',
    organizationAdmin: 'ORGANIZATION_ADMIN',
    viewer: 'VIEWER'
} as const;

export type GetOnboardingRequestById200ResponseOrganizationUsersInnerUserPrivilegeEnum = typeof GetOnboardingRequestById200ResponseOrganizationUsersInnerUserPrivilegeEnum[keyof typeof GetOnboardingRequestById200ResponseOrganizationUsersInnerUserPrivilegeEnum];

/**
 * 
 * @export
 * @interface GetOnboardingRequestById200ResponseSnailMailVerificationInner
 */
export interface GetOnboardingRequestById200ResponseSnailMailVerificationInner {
    /**
     * 
     * @type {string}
     * @memberof GetOnboardingRequestById200ResponseSnailMailVerificationInner
     */
    'acceptAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetOnboardingRequestById200ResponseSnailMailVerificationInner
     */
    'confirmedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetOnboardingRequestById200ResponseSnailMailVerificationInner
     */
    'confirmedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetOnboardingRequestById200ResponseSnailMailVerificationInner
     */
    'detail'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetOnboardingRequestById200ResponseSnailMailVerificationInner
     */
    'inquiryNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetOnboardingRequestById200ResponseSnailMailVerificationInner
     */
    'organizationIdentityVerificationId'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetOnboardingRequestById200ResponseSnailMailVerificationInner
     */
    'result'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetOnboardingRequestById200ResponseSnailMailVerificationInner
     */
    'snailMailVerificationId'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetOnboardingRequestById200ResponseSnailMailVerificationInner
     */
    'status'?: string;
}
/**
 * 
 * @export
 * @interface GetOnboardingRequestPersonalInfo200Response
 */
export interface GetOnboardingRequestPersonalInfo200Response {
    /**
     * Representative\'s address
     * @type {string}
     * @memberof GetOnboardingRequestPersonalInfo200Response
     */
    'representativeAddress'?: string;
    /**
     * Representative\'s date of birth (YYYYMMDD)
     * @type {string}
     * @memberof GetOnboardingRequestPersonalInfo200Response
     */
    'representativeBirthday': string;
    /**
     * Representative\'s name
     * @type {string}
     * @memberof GetOnboardingRequestPersonalInfo200Response
     */
    'representativeName': string;
}
/**
 * 
 * @export
 * @interface GetOnboardingRequests200Response
 */
export interface GetOnboardingRequests200Response {
    /**
     * 
     * @type {Array<GetOnboardingRequests200ResponseOnboardingRequestsInner>}
     * @memberof GetOnboardingRequests200Response
     */
    'onboardingRequests': Array<GetOnboardingRequests200ResponseOnboardingRequestsInner>;
    /**
     * Total number of onboarding requests
     * @type {number}
     * @memberof GetOnboardingRequests200Response
     */
    'totalCount': number;
}
/**
 * 
 * @export
 * @interface GetOnboardingRequests200ResponseOnboardingRequestsInner
 */
export interface GetOnboardingRequests200ResponseOnboardingRequestsInner {
    /**
     * 
     * @type {string}
     * @memberof GetOnboardingRequests200ResponseOnboardingRequestsInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetOnboardingRequests200ResponseOnboardingRequestsInner
     */
    'organizationName': string;
    /**
     * 
     * @type {string}
     * @memberof GetOnboardingRequests200ResponseOnboardingRequestsInner
     */
    'corporateNumber': string;
    /**
     * 
     * @type {string}
     * @memberof GetOnboardingRequests200ResponseOnboardingRequestsInner
     */
    'representativeName': string;
    /**
     * 
     * @type {string}
     * @memberof GetOnboardingRequests200ResponseOnboardingRequestsInner
     */
    'phoneNumber': string;
    /**
     * 
     * @type {string}
     * @memberof GetOnboardingRequests200ResponseOnboardingRequestsInner
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetOnboardingRequests200ResponseOnboardingRequestsInner
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface GetOrgAccountState200Response
 */
export interface GetOrgAccountState200Response {
    /**
     * 
     * @type {string}
     * @memberof GetOrgAccountState200Response
     */
    'orgAccountId': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrgAccountState200Response
     */
    'cashBalance': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrgAccountState200Response
     */
    'pointBalance': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrgAccountState200Response
     */
    'creditUsage': string;
    /**
     * 
     * @type {number}
     * @memberof GetOrgAccountState200Response
     */
    'availableLimit': number;
}
/**
 * 
 * @export
 * @interface GetOrganization200Response
 */
export interface GetOrganization200Response {
    /**
     * 
     * @type {string}
     * @memberof GetOrganization200Response
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrganization200Response
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrganization200Response
     */
    'representativeName': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrganization200Response
     */
    'phoneNumber': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrganization200Response
     */
    'postalCode': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrganization200Response
     */
    'address': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrganization200Response
     */
    'deliveryPostalCode': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrganization200Response
     */
    'deliveryAddress': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrganization200Response
     */
    'invoiceEmail': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetOrganization200Response
     */
    'isApprovalFeatureEnabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetOrganization200Response
     */
    'identityVerificationScheduledDate': string | null;
}
/**
 * 
 * @export
 * @interface GetOrganizationAccountingCsvFieldsTypes200ResponseInner
 */
export interface GetOrganizationAccountingCsvFieldsTypes200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationAccountingCsvFieldsTypes200ResponseInner
     */
    'label': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationAccountingCsvFieldsTypes200ResponseInner
     */
    'value': string;
}
/**
 * 
 * @export
 * @interface GetOrganizationCardsExtended200ResponseInner
 */
export interface GetOrganizationCardsExtended200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationCardsExtended200ResponseInner
     */
    'cardId': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationCardsExtended200ResponseInner
     */
    'userAccountId': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationCardsExtended200ResponseInner
     */
    'expiredDate': string | null;
    /**
     * 
     * @type {number}
     * @memberof GetOrganizationCardsExtended200ResponseInner
     */
    'monthlyUsageLimit': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetOrganizationCardsExtended200ResponseInner
     */
    'monthlyUsageAmount': number;
    /**
     * 
     * @type {number}
     * @memberof GetOrganizationCardsExtended200ResponseInner
     */
    'totalUsageLimit': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetOrganizationCardsExtended200ResponseInner
     */
    'totalUsageAmount': number;
}
/**
 * 
 * @export
 * @interface GetOrganizationCardsLight200ResponseInner
 */
export interface GetOrganizationCardsLight200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationCardsLight200ResponseInner
     */
    'cardId': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationCardsLight200ResponseInner
     */
    'cardLabel': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetOrganizationCardsLight200ResponseInner
     */
    'isActivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetOrganizationCardsLight200ResponseInner
     */
    'isDeactivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetOrganizationCardsLight200ResponseInner
     */
    'isFrozen': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetOrganizationCardsLight200ResponseInner
     */
    'isLocked': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetOrganizationCardsLight200ResponseInner
     */
    'isSuspended': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetOrganizationCardsLight200ResponseInner
     */
    'isVirtualCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetOrganizationCardsLight200ResponseInner
     */
    'isCreaditCard'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetOrganizationCardsLight200ResponseInner
     */
    'isOnDemand'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetOrganizationCardsLight200ResponseInner
     */
    'isMetalCard': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationCardsLight200ResponseInner
     */
    'panLastFourDigits': string;
    /**
     * 
     * @type {GetOrganizationCardsLight200ResponseInnerUser}
     * @memberof GetOrganizationCardsLight200ResponseInner
     */
    'user'?: GetOrganizationCardsLight200ResponseInnerUser;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationCardsLight200ResponseInner
     */
    'userAccountId': string;
    /**
     * 
     * @type {GetOrganizationCardsLight200ResponseInnerUserAccountGroup}
     * @memberof GetOrganizationCardsLight200ResponseInner
     */
    'userAccountGroup'?: GetOrganizationCardsLight200ResponseInnerUserAccountGroup;
    /**
     * 
     * @type {boolean}
     * @memberof GetOrganizationCardsLight200ResponseInner
     */
    'isPhysicalStorePaymentDisabled': boolean;
}
/**
 * 
 * @export
 * @interface GetOrganizationCardsLight200ResponseInnerUser
 */
export interface GetOrganizationCardsLight200ResponseInnerUser {
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationCardsLight200ResponseInnerUser
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationCardsLight200ResponseInnerUser
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationCardsLight200ResponseInnerUser
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationCardsLight200ResponseInnerUser
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationCardsLight200ResponseInnerUser
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetOrganizationCardsLight200ResponseInnerUser
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetOrganizationCardsLight200ResponseInnerUser
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetOrganizationCardsLight200ResponseInnerUser
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetOrganizationCardsLight200ResponseInnerUser
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetOrganizationCardsLight200ResponseInnerUser
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationCardsLight200ResponseInnerUser
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface GetOrganizationCardsLight200ResponseInnerUserAccountGroup
 */
export interface GetOrganizationCardsLight200ResponseInnerUserAccountGroup {
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationCardsLight200ResponseInnerUserAccountGroup
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationCardsLight200ResponseInnerUserAccountGroup
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof GetOrganizationCardsLight200ResponseInnerUserAccountGroup
     */
    'sortNum': number;
}
/**
 * 
 * @export
 * @interface GetOrganizationChartDepartments200ResponseInner
 */
export interface GetOrganizationChartDepartments200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationChartDepartments200ResponseInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationChartDepartments200ResponseInner
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetOrganizationChartEmployees200ResponseInner
 */
export interface GetOrganizationChartEmployees200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationChartEmployees200ResponseInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationChartEmployees200ResponseInner
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationChartEmployees200ResponseInner
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationChartEmployees200ResponseInner
     */
    'email': string;
    /**
     * 
     * @type {Array<GetOrganizationChartEmployees200ResponseInnerDepartmentsInner>}
     * @memberof GetOrganizationChartEmployees200ResponseInner
     */
    'departments': Array<GetOrganizationChartEmployees200ResponseInnerDepartmentsInner>;
    /**
     * 
     * @type {Array<GetOrganizationChartEmployees200ResponseInnerRolesInner>}
     * @memberof GetOrganizationChartEmployees200ResponseInner
     */
    'roles': Array<GetOrganizationChartEmployees200ResponseInnerRolesInner>;
}
/**
 * 
 * @export
 * @interface GetOrganizationChartEmployees200ResponseInnerDepartmentsInner
 */
export interface GetOrganizationChartEmployees200ResponseInnerDepartmentsInner {
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationChartEmployees200ResponseInnerDepartmentsInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationChartEmployees200ResponseInnerDepartmentsInner
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetOrganizationChartEmployees200ResponseInnerRolesInner
 */
export interface GetOrganizationChartEmployees200ResponseInnerRolesInner {
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationChartEmployees200ResponseInnerRolesInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationChartEmployees200ResponseInnerRolesInner
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetOrganizationChartRoles200ResponseInner
 */
export interface GetOrganizationChartRoles200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationChartRoles200ResponseInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationChartRoles200ResponseInner
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetOrganizationCreateRequests200Response
 */
export interface GetOrganizationCreateRequests200Response {
    /**
     * 
     * @type {Array<GetOrganizationCreateRequests200ResponseOrganizationCreateRequestsInner>}
     * @memberof GetOrganizationCreateRequests200Response
     */
    'organizationCreateRequests': Array<GetOrganizationCreateRequests200ResponseOrganizationCreateRequestsInner>;
    /**
     * Total number of messages
     * @type {number}
     * @memberof GetOrganizationCreateRequests200Response
     */
    'totalCount': number;
}
/**
 * 
 * @export
 * @interface GetOrganizationCreateRequests200ResponseOrganizationCreateRequestsInner
 */
export interface GetOrganizationCreateRequests200ResponseOrganizationCreateRequestsInner {
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationCreateRequests200ResponseOrganizationCreateRequestsInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationCreateRequests200ResponseOrganizationCreateRequestsInner
     */
    'organizationName': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationCreateRequests200ResponseOrganizationCreateRequestsInner
     */
    'corporateNumber': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationCreateRequests200ResponseOrganizationCreateRequestsInner
     */
    'representativeName': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationCreateRequests200ResponseOrganizationCreateRequestsInner
     */
    'phoneNumber': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationCreateRequests200ResponseOrganizationCreateRequestsInner
     */
    'createdAt': string;
}
/**
 * 
 * @export
 * @interface GetOrganizationMe200Response
 */
export interface GetOrganizationMe200Response {
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationMe200Response
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationMe200Response
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationMe200Response
     */
    'representativeName': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationMe200Response
     */
    'phoneNumber': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationMe200Response
     */
    'postalCode': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationMe200Response
     */
    'address': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationMe200Response
     */
    'deliveryPostalCode': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationMe200Response
     */
    'deliveryAddress': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationMe200Response
     */
    'invoiceEmail': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetOrganizationMe200Response
     */
    'isApprovalFeatureEnabled': boolean;
}
/**
 * 
 * @export
 * @interface GetOrganizationPaymentSchemes200ResponseInnerInner
 */
export interface GetOrganizationPaymentSchemes200ResponseInnerInner {
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationPaymentSchemes200ResponseInnerInner
     */
    'paymentMethod': GetOrganizationPaymentSchemes200ResponseInnerInnerPaymentMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationPaymentSchemes200ResponseInnerInner
     */
    'externalAccountTransferAgency': GetOrganizationPaymentSchemes200ResponseInnerInnerExternalAccountTransferAgencyEnum;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationPaymentSchemes200ResponseInnerInner
     */
    'paymentScheme': GetOrganizationPaymentSchemes200ResponseInnerInnerPaymentSchemeEnum;
}

export const GetOrganizationPaymentSchemes200ResponseInnerInnerPaymentMethodEnum = {
    accountTransfer: 'ACCOUNT_TRANSFER',
    bankTransfer: 'BANK_TRANSFER'
} as const;

export type GetOrganizationPaymentSchemes200ResponseInnerInnerPaymentMethodEnum = typeof GetOrganizationPaymentSchemes200ResponseInnerInnerPaymentMethodEnum[keyof typeof GetOrganizationPaymentSchemes200ResponseInnerInnerPaymentMethodEnum];
export const GetOrganizationPaymentSchemes200ResponseInnerInnerExternalAccountTransferAgencyEnum = {
    moneyForwardKessai: 'MONEY_FORWARD_KESSAI',
    ufj: 'UFJ'
} as const;

export type GetOrganizationPaymentSchemes200ResponseInnerInnerExternalAccountTransferAgencyEnum = typeof GetOrganizationPaymentSchemes200ResponseInnerInnerExternalAccountTransferAgencyEnum[keyof typeof GetOrganizationPaymentSchemes200ResponseInnerInnerExternalAccountTransferAgencyEnum];
export const GetOrganizationPaymentSchemes200ResponseInnerInnerPaymentSchemeEnum = {
    fifteenthDayPayment: 'FIFTEENTH_DAY_PAYMENT',
    twoMonthsLaterFifteenthDayPayment: 'TWO_MONTHS_LATER_FIFTEENTH_DAY_PAYMENT',
    endOfTwoMonthsLaterPayment: 'END_OF_TWO_MONTHS_LATER_PAYMENT',
    twentiethDayPayment: 'TWENTIETH_DAY_PAYMENT',
    endOfMonthPayment: 'END_OF_MONTH_PAYMENT',
    twoMonthsLaterSixthDayPayment: 'TWO_MONTHS_LATER_SIXTH_DAY_PAYMENT'
} as const;

export type GetOrganizationPaymentSchemes200ResponseInnerInnerPaymentSchemeEnum = typeof GetOrganizationPaymentSchemes200ResponseInnerInnerPaymentSchemeEnum[keyof typeof GetOrganizationPaymentSchemes200ResponseInnerInnerPaymentSchemeEnum];

/**
 * 
 * @export
 * @interface GetOrganizationPayments200ResponseInner
 */
export interface GetOrganizationPayments200ResponseInner {
    /**
     * 
     * @type {number}
     * @memberof GetOrganizationPayments200ResponseInner
     */
    'amount': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetOrganizationPayments200ResponseInner
     */
    'pointAmount': number | null;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationPayments200ResponseInner
     */
    'type': GetOrganizationPayments200ResponseInnerTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationPayments200ResponseInner
     */
    'supplierName': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationPayments200ResponseInner
     */
    'paymentDate': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationPayments200ResponseInner
     */
    'registeredAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetOrganizationPayments200ResponseInner
     */
    'isError': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationPayments200ResponseInner
     */
    'status': GetOrganizationPayments200ResponseInnerStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationPayments200ResponseInner
     */
    'fileName': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationPayments200ResponseInner
     */
    'fileExtension': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationPayments200ResponseInner
     */
    'bankAccountActivityId': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationPayments200ResponseInner
     */
    'billId': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationPayments200ResponseInner
     */
    'usageFeeId': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationPayments200ResponseInner
     */
    'cardBillId': string | null;
}

export const GetOrganizationPayments200ResponseInnerTypeEnum = {
    payBill: 'PAY_BILL',
    usageFee: 'USAGE_FEE',
    card: 'CARD'
} as const;

export type GetOrganizationPayments200ResponseInnerTypeEnum = typeof GetOrganizationPayments200ResponseInnerTypeEnum[keyof typeof GetOrganizationPayments200ResponseInnerTypeEnum];
export const GetOrganizationPayments200ResponseInnerStatusEnum = {
    uploaded: 'UPLOADED',
    readCompleted: 'READ_COMPLETED',
    awaitingApproval: 'AWAITING_APPROVAL',
    approved: 'APPROVED',
    transferCompleted: 'TRANSFER_COMPLETED',
    readError: 'READ_ERROR',
    insufficientBalance: 'INSUFFICIENT_BALANCE',
    transferFailed: 'TRANSFER_FAILED',
    approvalExpired: 'APPROVAL_EXPIRED',
    approvalRejected: 'APPROVAL_REJECTED',
    otherError: 'OTHER_ERROR',
    pending: 'PENDING',
    canceled: 'CANCELED',
    reserved: 'RESERVED',
    requestingExternalAccountTransfer: 'REQUESTING_EXTERNAL_ACCOUNT_TRANSFER',
    completed: 'COMPLETED'
} as const;

export type GetOrganizationPayments200ResponseInnerStatusEnum = typeof GetOrganizationPayments200ResponseInnerStatusEnum[keyof typeof GetOrganizationPayments200ResponseInnerStatusEnum];

/**
 * 
 * @export
 * @interface GetOrganizations200ResponseInner
 */
export interface GetOrganizations200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetOrganizations200ResponseInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizations200ResponseInner
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizations200ResponseInner
     */
    'representativeName': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizations200ResponseInner
     */
    'phoneNumber': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizations200ResponseInner
     */
    'postalCode': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizations200ResponseInner
     */
    'address': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizations200ResponseInner
     */
    'deliveryPostalCode': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizations200ResponseInner
     */
    'deliveryAddress': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizations200ResponseInner
     */
    'invoiceEmail': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetOrganizations200ResponseInner
     */
    'isApprovalFeatureEnabled': boolean;
}
/**
 * 
 * @export
 * @interface GetOrganizationsBills200ResponseInner
 */
export interface GetOrganizationsBills200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsBills200ResponseInner
     */
    'billId': string;
    /**
     * 
     * @type {GetOrganizationsBills200ResponseInnerOrganization}
     * @memberof GetOrganizationsBills200ResponseInner
     */
    'organization': GetOrganizationsBills200ResponseInnerOrganization;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsBills200ResponseInner
     */
    'fileName': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsBills200ResponseInner
     */
    'fileExtension': string;
    /**
     * 
     * @type {Array<GetOrganizationsBills200ResponseInnerStatusHistoryInner>}
     * @memberof GetOrganizationsBills200ResponseInner
     */
    'statusHistory': Array<GetOrganizationsBills200ResponseInnerStatusHistoryInner>;
    /**
     * 
     * @type {GetOrganizationsBills200ResponseInnerDetail}
     * @memberof GetOrganizationsBills200ResponseInner
     */
    'detail': GetOrganizationsBills200ResponseInnerDetail | null;
    /**
     * 
     * @type {GetOrganizationsBills200ResponseInnerLatestStatus}
     * @memberof GetOrganizationsBills200ResponseInner
     */
    'latestStatus': GetOrganizationsBills200ResponseInnerLatestStatus;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsBills200ResponseInner
     */
    'uploadedAt': string;
    /**
     * 
     * @type {GetOrganizationsBills200ResponseInnerUploadedBy}
     * @memberof GetOrganizationsBills200ResponseInner
     */
    'uploadedBy': GetOrganizationsBills200ResponseInnerUploadedBy;
    /**
     * 
     * @type {boolean}
     * @memberof GetOrganizationsBills200ResponseInner
     */
    'isCancelable': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetOrganizationsBills200ResponseInner
     */
    'isReadyToTransfer': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsBills200ResponseInner
     */
    'bankAccountActivityId': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsBills200ResponseInner
     */
    'approvedAt': string | null;
    /**
     * 
     * @type {GetOrganizationsBills200ResponseInnerApprovedBy}
     * @memberof GetOrganizationsBills200ResponseInner
     */
    'approvedBy': GetOrganizationsBills200ResponseInnerApprovedBy | null;
}
/**
 * 
 * @export
 * @interface GetOrganizationsBills200ResponseInnerApprovedBy
 */
export interface GetOrganizationsBills200ResponseInnerApprovedBy {
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsBills200ResponseInnerApprovedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsBills200ResponseInnerApprovedBy
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsBills200ResponseInnerApprovedBy
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsBills200ResponseInnerApprovedBy
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsBills200ResponseInnerApprovedBy
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetOrganizationsBills200ResponseInnerApprovedBy
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetOrganizationsBills200ResponseInnerApprovedBy
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetOrganizationsBills200ResponseInnerApprovedBy
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetOrganizationsBills200ResponseInnerApprovedBy
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetOrganizationsBills200ResponseInnerApprovedBy
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsBills200ResponseInnerApprovedBy
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface GetOrganizationsBills200ResponseInnerDetail
 */
export interface GetOrganizationsBills200ResponseInnerDetail {
    /**
     * 
     * @type {number}
     * @memberof GetOrganizationsBills200ResponseInnerDetail
     */
    'amount': number;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsBills200ResponseInnerDetail
     */
    'scheduledTransferDate': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsBills200ResponseInnerDetail
     */
    'paymentDate': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsBills200ResponseInnerDetail
     */
    'ediInfo': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsBills200ResponseInnerDetail
     */
    'note': string | null;
    /**
     * 
     * @type {GetOrganizationsBills200ResponseInnerDetailPayee}
     * @memberof GetOrganizationsBills200ResponseInnerDetail
     */
    'payee': GetOrganizationsBills200ResponseInnerDetailPayee | null;
}
/**
 * 
 * @export
 * @interface GetOrganizationsBills200ResponseInnerDetailPayee
 */
export interface GetOrganizationsBills200ResponseInnerDetailPayee {
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsBills200ResponseInnerDetailPayee
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsBills200ResponseInnerDetailPayee
     */
    'bankCode': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsBills200ResponseInnerDetailPayee
     */
    'bankName': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsBills200ResponseInnerDetailPayee
     */
    'branchCode': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsBills200ResponseInnerDetailPayee
     */
    'branchName': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsBills200ResponseInnerDetailPayee
     */
    'accountType': GetOrganizationsBills200ResponseInnerDetailPayeeAccountTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsBills200ResponseInnerDetailPayee
     */
    'accountNumber': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsBills200ResponseInnerDetailPayee
     */
    'accountHolder': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetOrganizationsBills200ResponseInnerDetailPayee
     */
    'isSaved': boolean;
}

export const GetOrganizationsBills200ResponseInnerDetailPayeeAccountTypeEnum = {
    savingsAccount: 'SAVINGS_ACCOUNT',
    currentAccount: 'CURRENT_ACCOUNT',
    depositAccount: 'DEPOSIT_ACCOUNT',
    otherAccount: 'OTHER_ACCOUNT'
} as const;

export type GetOrganizationsBills200ResponseInnerDetailPayeeAccountTypeEnum = typeof GetOrganizationsBills200ResponseInnerDetailPayeeAccountTypeEnum[keyof typeof GetOrganizationsBills200ResponseInnerDetailPayeeAccountTypeEnum];

/**
 * 
 * @export
 * @interface GetOrganizationsBills200ResponseInnerLatestStatus
 */
export interface GetOrganizationsBills200ResponseInnerLatestStatus {
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsBills200ResponseInnerLatestStatus
     */
    'status'?: GetOrganizationsBills200ResponseInnerLatestStatusStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsBills200ResponseInnerLatestStatus
     */
    'comment'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsBills200ResponseInnerLatestStatus
     */
    'statusChangedAt'?: string;
    /**
     * 
     * @type {GetOrganizationsBills200ResponseInnerLatestStatusStatusChangedBy}
     * @memberof GetOrganizationsBills200ResponseInnerLatestStatus
     */
    'statusChangedBy'?: GetOrganizationsBills200ResponseInnerLatestStatusStatusChangedBy;
}

export const GetOrganizationsBills200ResponseInnerLatestStatusStatusEnum = {
    reserved: 'RESERVED',
    requestingExternalAccountTransfer: 'REQUESTING_EXTERNAL_ACCOUNT_TRANSFER',
    completed: 'COMPLETED',
    insufficientBalance: 'INSUFFICIENT_BALANCE',
    uploaded: 'UPLOADED',
    readCompleted: 'READ_COMPLETED',
    awaitingApproval: 'AWAITING_APPROVAL',
    approved: 'APPROVED',
    transferCompleted: 'TRANSFER_COMPLETED',
    readError: 'READ_ERROR',
    transferFailed: 'TRANSFER_FAILED',
    approvalExpired: 'APPROVAL_EXPIRED',
    approvalRejected: 'APPROVAL_REJECTED',
    otherError: 'OTHER_ERROR',
    pending: 'PENDING'
} as const;

export type GetOrganizationsBills200ResponseInnerLatestStatusStatusEnum = typeof GetOrganizationsBills200ResponseInnerLatestStatusStatusEnum[keyof typeof GetOrganizationsBills200ResponseInnerLatestStatusStatusEnum];

/**
 * 
 * @export
 * @interface GetOrganizationsBills200ResponseInnerLatestStatusStatusChangedBy
 */
export interface GetOrganizationsBills200ResponseInnerLatestStatusStatusChangedBy {
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsBills200ResponseInnerLatestStatusStatusChangedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsBills200ResponseInnerLatestStatusStatusChangedBy
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsBills200ResponseInnerLatestStatusStatusChangedBy
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsBills200ResponseInnerLatestStatusStatusChangedBy
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsBills200ResponseInnerLatestStatusStatusChangedBy
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetOrganizationsBills200ResponseInnerLatestStatusStatusChangedBy
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetOrganizationsBills200ResponseInnerLatestStatusStatusChangedBy
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetOrganizationsBills200ResponseInnerLatestStatusStatusChangedBy
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetOrganizationsBills200ResponseInnerLatestStatusStatusChangedBy
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetOrganizationsBills200ResponseInnerLatestStatusStatusChangedBy
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsBills200ResponseInnerLatestStatusStatusChangedBy
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface GetOrganizationsBills200ResponseInnerOrganization
 */
export interface GetOrganizationsBills200ResponseInnerOrganization {
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsBills200ResponseInnerOrganization
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsBills200ResponseInnerOrganization
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsBills200ResponseInnerOrganization
     */
    'representativeName': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsBills200ResponseInnerOrganization
     */
    'phoneNumber': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsBills200ResponseInnerOrganization
     */
    'postalCode': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsBills200ResponseInnerOrganization
     */
    'address': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsBills200ResponseInnerOrganization
     */
    'deliveryPostalCode': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsBills200ResponseInnerOrganization
     */
    'deliveryAddress': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsBills200ResponseInnerOrganization
     */
    'invoiceEmail': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetOrganizationsBills200ResponseInnerOrganization
     */
    'isApprovalFeatureEnabled': boolean;
}
/**
 * 
 * @export
 * @interface GetOrganizationsBills200ResponseInnerStatusHistoryInner
 */
export interface GetOrganizationsBills200ResponseInnerStatusHistoryInner {
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsBills200ResponseInnerStatusHistoryInner
     */
    'status'?: GetOrganizationsBills200ResponseInnerStatusHistoryInnerStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsBills200ResponseInnerStatusHistoryInner
     */
    'comment'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsBills200ResponseInnerStatusHistoryInner
     */
    'statusChangedAt'?: string;
    /**
     * 
     * @type {GetOrganizationsBills200ResponseInnerStatusHistoryInnerStatusChangedBy}
     * @memberof GetOrganizationsBills200ResponseInnerStatusHistoryInner
     */
    'statusChangedBy'?: GetOrganizationsBills200ResponseInnerStatusHistoryInnerStatusChangedBy;
}

export const GetOrganizationsBills200ResponseInnerStatusHistoryInnerStatusEnum = {
    reserved: 'RESERVED',
    requestingExternalAccountTransfer: 'REQUESTING_EXTERNAL_ACCOUNT_TRANSFER',
    completed: 'COMPLETED',
    insufficientBalance: 'INSUFFICIENT_BALANCE',
    uploaded: 'UPLOADED',
    readCompleted: 'READ_COMPLETED',
    awaitingApproval: 'AWAITING_APPROVAL',
    approved: 'APPROVED',
    transferCompleted: 'TRANSFER_COMPLETED',
    readError: 'READ_ERROR',
    transferFailed: 'TRANSFER_FAILED',
    approvalExpired: 'APPROVAL_EXPIRED',
    approvalRejected: 'APPROVAL_REJECTED',
    otherError: 'OTHER_ERROR',
    pending: 'PENDING'
} as const;

export type GetOrganizationsBills200ResponseInnerStatusHistoryInnerStatusEnum = typeof GetOrganizationsBills200ResponseInnerStatusHistoryInnerStatusEnum[keyof typeof GetOrganizationsBills200ResponseInnerStatusHistoryInnerStatusEnum];

/**
 * 
 * @export
 * @interface GetOrganizationsBills200ResponseInnerStatusHistoryInnerStatusChangedBy
 */
export interface GetOrganizationsBills200ResponseInnerStatusHistoryInnerStatusChangedBy {
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsBills200ResponseInnerStatusHistoryInnerStatusChangedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsBills200ResponseInnerStatusHistoryInnerStatusChangedBy
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsBills200ResponseInnerStatusHistoryInnerStatusChangedBy
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsBills200ResponseInnerStatusHistoryInnerStatusChangedBy
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsBills200ResponseInnerStatusHistoryInnerStatusChangedBy
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetOrganizationsBills200ResponseInnerStatusHistoryInnerStatusChangedBy
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetOrganizationsBills200ResponseInnerStatusHistoryInnerStatusChangedBy
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetOrganizationsBills200ResponseInnerStatusHistoryInnerStatusChangedBy
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetOrganizationsBills200ResponseInnerStatusHistoryInnerStatusChangedBy
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetOrganizationsBills200ResponseInnerStatusHistoryInnerStatusChangedBy
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsBills200ResponseInnerStatusHistoryInnerStatusChangedBy
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface GetOrganizationsBills200ResponseInnerUploadedBy
 */
export interface GetOrganizationsBills200ResponseInnerUploadedBy {
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsBills200ResponseInnerUploadedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsBills200ResponseInnerUploadedBy
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsBills200ResponseInnerUploadedBy
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsBills200ResponseInnerUploadedBy
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsBills200ResponseInnerUploadedBy
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetOrganizationsBills200ResponseInnerUploadedBy
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetOrganizationsBills200ResponseInnerUploadedBy
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetOrganizationsBills200ResponseInnerUploadedBy
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetOrganizationsBills200ResponseInnerUploadedBy
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetOrganizationsBills200ResponseInnerUploadedBy
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsBills200ResponseInnerUploadedBy
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface GetOrganizationsDeals200ResponseInner
 */
export interface GetOrganizationsDeals200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsDeals200ResponseInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsDeals200ResponseInner
     */
    'issuedAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsDeals200ResponseInner
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsDeals200ResponseInner
     */
    'freeeDealId': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsDeals200ResponseInner
     */
    'freeePartnerId': string | null;
    /**
     * 
     * @type {number}
     * @memberof GetOrganizationsDeals200ResponseInner
     */
    'partnerId': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetOrganizationsDeals200ResponseInner
     */
    'amountYen': number;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsDeals200ResponseInner
     */
    'visaTransactionReferenceId': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsDeals200ResponseInner
     */
    'status': GetOrganizationsDeals200ResponseInnerStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsDeals200ResponseInner
     */
    'cardHolder': string | null;
    /**
     * 
     * @type {GetOrganizationsDeals200ResponseInnerJournalizedBy}
     * @memberof GetOrganizationsDeals200ResponseInner
     */
    'journalizedBy': GetOrganizationsDeals200ResponseInnerJournalizedBy | null;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsDeals200ResponseInner
     */
    'journalizedAt': string | null;
    /**
     * 
     * @type {GetOrganizationsDeals200ResponseInnerIntegratedBy}
     * @memberof GetOrganizationsDeals200ResponseInner
     */
    'integratedBy': GetOrganizationsDeals200ResponseInnerIntegratedBy | null;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsDeals200ResponseInner
     */
    'integratedAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsDeals200ResponseInner
     */
    'userAccountId': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsDeals200ResponseInner
     */
    'userAccountName': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsDeals200ResponseInner
     */
    'userAccountGroupId': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsDeals200ResponseInner
     */
    'userAccountGroupName': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetOrganizationsDeals200ResponseInner
     */
    'isOnDemand': boolean | null;
    /**
     * 
     * @type {Array<GetOrganizationsDeals200ResponseInnerJournalEntriesInner>}
     * @memberof GetOrganizationsDeals200ResponseInner
     */
    'journalEntries': Array<GetOrganizationsDeals200ResponseInnerJournalEntriesInner>;
    /**
     * 
     * @type {Array<GetOrganizationsDeals200ResponseInnerCardTransactionEvidenceListInner>}
     * @memberof GetOrganizationsDeals200ResponseInner
     */
    'cardTransactionEvidenceList': Array<GetOrganizationsDeals200ResponseInnerCardTransactionEvidenceListInner>;
    /**
     * true if the deal has one or more evidences and those all are not qualified, which should be shown as a warning to users.
     * @type {boolean}
     * @memberof GetOrganizationsDeals200ResponseInner
     */
    'isAllEvidencesNotQualified': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetOrganizationsDeals200ResponseInner
     */
    'canSync': boolean;
    /**
     * 
     * @type {GetOrganizationsDeals200ResponseInnerInvoiceIssuer}
     * @memberof GetOrganizationsDeals200ResponseInner
     */
    'invoiceIssuer': GetOrganizationsDeals200ResponseInnerInvoiceIssuer | null;
}

export const GetOrganizationsDeals200ResponseInnerStatusEnum = {
    notEntered: 'NOT_ENTERED',
    automaticJournalized: 'AUTOMATIC_JOURNALIZED',
    automaticIntegrated: 'AUTOMATIC_INTEGRATED',
    entering: 'ENTERING',
    journalized: 'JOURNALIZED',
    changedAfterJournalization: 'CHANGED_AFTER_JOURNALIZATION',
    integrated: 'INTEGRATED',
    changedAfterIntegration: 'CHANGED_AFTER_INTEGRATION',
    ignored: 'IGNORED',
    readyAutomaticIntegration: 'READY_AUTOMATIC_INTEGRATION'
} as const;

export type GetOrganizationsDeals200ResponseInnerStatusEnum = typeof GetOrganizationsDeals200ResponseInnerStatusEnum[keyof typeof GetOrganizationsDeals200ResponseInnerStatusEnum];

/**
 * 
 * @export
 * @interface GetOrganizationsDeals200ResponseInnerCardTransactionEvidenceListInner
 */
export interface GetOrganizationsDeals200ResponseInnerCardTransactionEvidenceListInner {
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsDeals200ResponseInnerCardTransactionEvidenceListInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsDeals200ResponseInnerCardTransactionEvidenceListInner
     * @deprecated
     */
    'cardTransactionEvidenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsDeals200ResponseInnerCardTransactionEvidenceListInner
     * @deprecated
     */
    'visaTransactionReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsDeals200ResponseInnerCardTransactionEvidenceListInner
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsDeals200ResponseInnerCardTransactionEvidenceListInner
     */
    'fileName': string;
    /**
     * 
     * @type {GetOrganizationsDeals200ResponseInnerCardTransactionEvidenceListInnerCreatedBy}
     * @memberof GetOrganizationsDeals200ResponseInnerCardTransactionEvidenceListInner
     */
    'createdBy': GetOrganizationsDeals200ResponseInnerCardTransactionEvidenceListInnerCreatedBy;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsDeals200ResponseInnerCardTransactionEvidenceListInner
     */
    'uploadedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetOrganizationsDeals200ResponseInnerCardTransactionEvidenceListInner
     */
    'isQualified': boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetOrganizationsDeals200ResponseInnerCardTransactionEvidenceListInner
     */
    'asQualified': boolean | null;
}
/**
 * 
 * @export
 * @interface GetOrganizationsDeals200ResponseInnerCardTransactionEvidenceListInnerCreatedBy
 */
export interface GetOrganizationsDeals200ResponseInnerCardTransactionEvidenceListInnerCreatedBy {
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsDeals200ResponseInnerCardTransactionEvidenceListInnerCreatedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsDeals200ResponseInnerCardTransactionEvidenceListInnerCreatedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetOrganizationsDeals200ResponseInnerIntegratedBy
 */
export interface GetOrganizationsDeals200ResponseInnerIntegratedBy {
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsDeals200ResponseInnerIntegratedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsDeals200ResponseInnerIntegratedBy
     */
    'name': string;
}
/**
 * null if none of the related evidences have been processed according to the invoicing system compliance. partnerId in this object is currently not supported and is always set as null.
 * @export
 * @interface GetOrganizationsDeals200ResponseInnerInvoiceIssuer
 */
export interface GetOrganizationsDeals200ResponseInnerInvoiceIssuer {
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsDeals200ResponseInnerInvoiceIssuer
     */
    'name': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsDeals200ResponseInnerInvoiceIssuer
     */
    'registrationNumber': string | null;
    /**
     * isQualified retains the result of querying the 国税庁API to see if registrationNumber is qualified, as is.
     * @type {boolean}
     * @memberof GetOrganizationsDeals200ResponseInnerInvoiceIssuer
     */
    'isQualified': boolean;
    /**
     * AsQualified indicates whether this issuer should be treated as a qualified invoice issuer within the user\'s system, even if the RegistrationNumber is not confirmed as qualified in the National Tax Agency\'s business registration system.
     * @type {boolean}
     * @memberof GetOrganizationsDeals200ResponseInnerInvoiceIssuer
     */
    'asQualified': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsDeals200ResponseInnerInvoiceIssuer
     */
    'partnerId': string | null;
}
/**
 * 
 * @export
 * @interface GetOrganizationsDeals200ResponseInnerJournalEntriesInner
 */
export interface GetOrganizationsDeals200ResponseInnerJournalEntriesInner {
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsDeals200ResponseInnerJournalEntriesInner
     */
    'id': string;
    /**
     * 
     * @type {number}
     * @memberof GetOrganizationsDeals200ResponseInnerJournalEntriesInner
     */
    'amount': number | null;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsDeals200ResponseInnerJournalEntriesInner
     */
    'freeeAccountItemId': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsDeals200ResponseInnerJournalEntriesInner
     */
    'freeeTaxCode': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetOrganizationsDeals200ResponseInnerJournalEntriesInner
     */
    'isInvalidTaxCode': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsDeals200ResponseInnerJournalEntriesInner
     */
    'invalidTaxCodeCause': GetOrganizationsDeals200ResponseInnerJournalEntriesInnerInvalidTaxCodeCauseEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetOrganizationsDeals200ResponseInnerJournalEntriesInner
     */
    'freeeMemoTags': Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsDeals200ResponseInnerJournalEntriesInner
     */
    'freeeSectionId': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsDeals200ResponseInnerJournalEntriesInner
     */
    'freeeItemId': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsDeals200ResponseInnerJournalEntriesInner
     */
    'segment1TagId': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsDeals200ResponseInnerJournalEntriesInner
     */
    'segment2TagId': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsDeals200ResponseInnerJournalEntriesInner
     */
    'segment3TagId': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsDeals200ResponseInnerJournalEntriesInner
     */
    'description': string | null;
}

export const GetOrganizationsDeals200ResponseInnerJournalEntriesInnerInvalidTaxCodeCauseEnum = {
    qualifiedButPartDeduct: 'QUALIFIED_BUT_PART_DEDUCT',
    notQualifiedButFullDeduct: 'NOT_QUALIFIED_BUT_FULL_DEDUCT',
    preStartButPartDeduct: 'PRE_START_BUT_PART_DEDUCT',
    inconsistentDeductRate: 'INCONSISTENT_DEDUCT_RATE'
} as const;

export type GetOrganizationsDeals200ResponseInnerJournalEntriesInnerInvalidTaxCodeCauseEnum = typeof GetOrganizationsDeals200ResponseInnerJournalEntriesInnerInvalidTaxCodeCauseEnum[keyof typeof GetOrganizationsDeals200ResponseInnerJournalEntriesInnerInvalidTaxCodeCauseEnum];

/**
 * 
 * @export
 * @interface GetOrganizationsDeals200ResponseInnerJournalizedBy
 */
export interface GetOrganizationsDeals200ResponseInnerJournalizedBy {
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsDeals200ResponseInnerJournalizedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsDeals200ResponseInnerJournalizedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetPaymentRequestDetail200Response
 */
export interface GetPaymentRequestDetail200Response {
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200Response
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200Response
     */
    'serialNumber': string;
    /**
     * 
     * @type {GetPaymentRequestDetail200ResponseSupplier}
     * @memberof GetPaymentRequestDetail200Response
     */
    'supplier': GetPaymentRequestDetail200ResponseSupplier;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200Response
     */
    'dueDate': string;
    /**
     * 
     * @type {number}
     * @memberof GetPaymentRequestDetail200Response
     */
    'totalAmount': number;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200Response
     */
    'transferFeeResponsibility': GetPaymentRequestDetail200ResponseTransferFeeResponsibilityEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200Response
     */
    'memo': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200Response
     */
    'withholdingCalculatingMethod': GetPaymentRequestDetail200ResponseWithholdingCalculatingMethodEnum;
    /**
     * 
     * @type {number}
     * @memberof GetPaymentRequestDetail200Response
     */
    'withholdingAmount': number | null;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200Response
     */
    'status': GetPaymentRequestDetail200ResponseStatusEnum;
    /**
     * 
     * @type {GetPaymentRequestDetail200ResponseRequestor}
     * @memberof GetPaymentRequestDetail200Response
     */
    'requestor': GetPaymentRequestDetail200ResponseRequestor;
    /**
     * requestorName is the name of the requesting user at the time this PaymentRequest was requested. The free word search targets the name of requesting user, but it is the requestorName that is targeted, not the name of the user at the time of the search. Use requestor.name if you want to know what is the name at present of the user.
     * @type {string}
     * @memberof GetPaymentRequestDetail200Response
     */
    'requestorName': string;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200Response
     */
    'requestedAt': string;
    /**
     * If bank transfer data has already been created, return the ID. Otherwise, null.
     * @type {string}
     * @memberof GetPaymentRequestDetail200Response
     */
    'bankTransferId': string | null;
    /**
     * One or more evidences are associated with a payment request, and one of them is the invoice that motivated creating the payment request. invoiceEvidenceId is the ID of the evidence selected as the invoice among the evidences array.
     * @type {string}
     * @memberof GetPaymentRequestDetail200Response
     */
    'invoiceEvidenceId': string;
    /**
     * 
     * @type {Array<GetPaymentRequestDetail200ResponseEvidencesInner>}
     * @memberof GetPaymentRequestDetail200Response
     */
    'evidences': Array<GetPaymentRequestDetail200ResponseEvidencesInner>;
    /**
     * 
     * @type {GetPaymentRequestDetail200ResponseDeal}
     * @memberof GetPaymentRequestDetail200Response
     */
    'deal': GetPaymentRequestDetail200ResponseDeal | null;
    /**
     * 
     * @type {Array<GetPaymentRequestDetail200ResponseCommentsInner>}
     * @memberof GetPaymentRequestDetail200Response
     */
    'comments': Array<GetPaymentRequestDetail200ResponseCommentsInner>;
    /**
     * 
     * @type {Array<GetPaymentRequestDetail200ResponseApprovalStepsInner>}
     * @memberof GetPaymentRequestDetail200Response
     */
    'approvalSteps': Array<GetPaymentRequestDetail200ResponseApprovalStepsInner>;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetPaymentRequestDetail200Response
     */
    'deletableEvidenceIds': Array<string>;
}

export const GetPaymentRequestDetail200ResponseTransferFeeResponsibilityEnum = {
    self: 'SELF',
    supplier: 'SUPPLIER'
} as const;

export type GetPaymentRequestDetail200ResponseTransferFeeResponsibilityEnum = typeof GetPaymentRequestDetail200ResponseTransferFeeResponsibilityEnum[keyof typeof GetPaymentRequestDetail200ResponseTransferFeeResponsibilityEnum];
export const GetPaymentRequestDetail200ResponseWithholdingCalculatingMethodEnum = {
    none: 'NONE',
    manuscriptOrLecture: 'MANUSCRIPT_OR_LECTURE',
    lawyerOrCpa: 'LAWYER_OR_CPA',
    judicialScrivener: 'JUDICIAL_SCRIVENER',
    other: 'OTHER'
} as const;

export type GetPaymentRequestDetail200ResponseWithholdingCalculatingMethodEnum = typeof GetPaymentRequestDetail200ResponseWithholdingCalculatingMethodEnum[keyof typeof GetPaymentRequestDetail200ResponseWithholdingCalculatingMethodEnum];
export const GetPaymentRequestDetail200ResponseStatusEnum = {
    pendingWorkflowCompletion: 'PENDING_WORKFLOW_COMPLETION',
    canceled: 'CANCELED',
    payable: 'PAYABLE',
    attachedToBankTransfer: 'ATTACHED_TO_BANK_TRANSFER',
    deactivated: 'DEACTIVATED'
} as const;

export type GetPaymentRequestDetail200ResponseStatusEnum = typeof GetPaymentRequestDetail200ResponseStatusEnum[keyof typeof GetPaymentRequestDetail200ResponseStatusEnum];

/**
 * 
 * @export
 * @interface GetPaymentRequestDetail200ResponseApprovalStepsInner
 */
export interface GetPaymentRequestDetail200ResponseApprovalStepsInner {
    /**
     * 
     * @type {number}
     * @memberof GetPaymentRequestDetail200ResponseApprovalStepsInner
     */
    'stepNumber': number;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseApprovalStepsInner
     */
    'approveType': GetPaymentRequestDetail200ResponseApprovalStepsInnerApproveTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof GetPaymentRequestDetail200ResponseApprovalStepsInner
     */
    'isApproved': boolean | null;
    /**
     * 
     * @type {Array<GetPaymentRequestDetail200ResponseApprovalStepsInnerApproverCandidatesInner>}
     * @memberof GetPaymentRequestDetail200ResponseApprovalStepsInner
     */
    'approverCandidates': Array<GetPaymentRequestDetail200ResponseApprovalStepsInnerApproverCandidatesInner>;
}

export const GetPaymentRequestDetail200ResponseApprovalStepsInnerApproveTypeEnum = {
    all: 'APPROVE_BY_ALL',
    any: 'APPROVE_BY_ANY'
} as const;

export type GetPaymentRequestDetail200ResponseApprovalStepsInnerApproveTypeEnum = typeof GetPaymentRequestDetail200ResponseApprovalStepsInnerApproveTypeEnum[keyof typeof GetPaymentRequestDetail200ResponseApprovalStepsInnerApproveTypeEnum];

/**
 * 
 * @export
 * @interface GetPaymentRequestDetail200ResponseApprovalStepsInnerApproverCandidatesInner
 */
export interface GetPaymentRequestDetail200ResponseApprovalStepsInnerApproverCandidatesInner {
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseApprovalStepsInnerApproverCandidatesInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseApprovalStepsInnerApproverCandidatesInner
     */
    'name': string;
    /**
     * 
     * @type {GetPaymentRequestDetail200ResponseApprovalStepsInnerApproverCandidatesInnerDepartment}
     * @memberof GetPaymentRequestDetail200ResponseApprovalStepsInnerApproverCandidatesInner
     */
    'department': GetPaymentRequestDetail200ResponseApprovalStepsInnerApproverCandidatesInnerDepartment;
    /**
     * 
     * @type {GetPaymentRequestDetail200ResponseApprovalStepsInnerApproverCandidatesInnerRole}
     * @memberof GetPaymentRequestDetail200ResponseApprovalStepsInnerApproverCandidatesInner
     */
    'role': GetPaymentRequestDetail200ResponseApprovalStepsInnerApproverCandidatesInnerRole;
    /**
     * 
     * @type {GetPaymentRequestDetail200ResponseApprovalStepsInnerApproverCandidatesInnerAction}
     * @memberof GetPaymentRequestDetail200ResponseApprovalStepsInnerApproverCandidatesInner
     */
    'action': GetPaymentRequestDetail200ResponseApprovalStepsInnerApproverCandidatesInnerAction | null;
}
/**
 * @type GetPaymentRequestDetail200ResponseApprovalStepsInnerApproverCandidatesInnerAction
 * @export
 */
export type GetPaymentRequestDetail200ResponseApprovalStepsInnerApproverCandidatesInnerAction = GetPaymentRequestDetail200ResponseApprovalStepsInnerApproverCandidatesInnerActionOneOf;

/**
 * 
 * @export
 * @enum {string}
 */

export const GetPaymentRequestDetail200ResponseApprovalStepsInnerApproverCandidatesInnerActionOneOf = {
    approved: 'APPROVED',
    rejected: 'REJECTED',
    sendback: 'SENDBACK'
} as const;

export type GetPaymentRequestDetail200ResponseApprovalStepsInnerApproverCandidatesInnerActionOneOf = typeof GetPaymentRequestDetail200ResponseApprovalStepsInnerApproverCandidatesInnerActionOneOf[keyof typeof GetPaymentRequestDetail200ResponseApprovalStepsInnerApproverCandidatesInnerActionOneOf];


/**
 * 
 * @export
 * @interface GetPaymentRequestDetail200ResponseApprovalStepsInnerApproverCandidatesInnerDepartment
 */
export interface GetPaymentRequestDetail200ResponseApprovalStepsInnerApproverCandidatesInnerDepartment {
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseApprovalStepsInnerApproverCandidatesInnerDepartment
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseApprovalStepsInnerApproverCandidatesInnerDepartment
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetPaymentRequestDetail200ResponseApprovalStepsInnerApproverCandidatesInnerRole
 */
export interface GetPaymentRequestDetail200ResponseApprovalStepsInnerApproverCandidatesInnerRole {
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseApprovalStepsInnerApproverCandidatesInnerRole
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseApprovalStepsInnerApproverCandidatesInnerRole
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetPaymentRequestDetail200ResponseCommentsInner
 */
export interface GetPaymentRequestDetail200ResponseCommentsInner {
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseCommentsInner
     */
    'content': string;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseCommentsInner
     */
    'notificateTarget': GetPaymentRequestDetail200ResponseCommentsInnerNotificateTargetEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseCommentsInner
     */
    'commentedAt': string;
    /**
     * 
     * @type {GetPaymentRequestDetail200ResponseCommentsInnerCommentedBy}
     * @memberof GetPaymentRequestDetail200ResponseCommentsInner
     */
    'commentedBy': GetPaymentRequestDetail200ResponseCommentsInnerCommentedBy;
}

export const GetPaymentRequestDetail200ResponseCommentsInnerNotificateTargetEnum = {
    approverCandidate: 'APPROVER_CANDIDATE',
    applicant: 'APPLICANT'
} as const;

export type GetPaymentRequestDetail200ResponseCommentsInnerNotificateTargetEnum = typeof GetPaymentRequestDetail200ResponseCommentsInnerNotificateTargetEnum[keyof typeof GetPaymentRequestDetail200ResponseCommentsInnerNotificateTargetEnum];

/**
 * 
 * @export
 * @interface GetPaymentRequestDetail200ResponseCommentsInnerCommentedBy
 */
export interface GetPaymentRequestDetail200ResponseCommentsInnerCommentedBy {
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseCommentsInnerCommentedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseCommentsInnerCommentedBy
     */
    'name': string;
}
/**
 * The deal associated with this payment request. But this property is not supported at present, so the value always be null.
 * @export
 * @interface GetPaymentRequestDetail200ResponseDeal
 */
export interface GetPaymentRequestDetail200ResponseDeal {
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseDeal
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseDeal
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseDeal
     */
    'freeeDealId': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseDeal
     */
    'freeePartnerId': string | null;
    /**
     * 
     * @type {Array<GetPaymentRequestDetail200ResponseDealFreeeJournalEntriesInner>}
     * @memberof GetPaymentRequestDetail200ResponseDeal
     */
    'freeeJournalEntries': Array<GetPaymentRequestDetail200ResponseDealFreeeJournalEntriesInner>;
}
/**
 * 
 * @export
 * @interface GetPaymentRequestDetail200ResponseDealFreeeJournalEntriesInner
 */
export interface GetPaymentRequestDetail200ResponseDealFreeeJournalEntriesInner {
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseDealFreeeJournalEntriesInner
     */
    'id': string;
    /**
     * 
     * @type {number}
     * @memberof GetPaymentRequestDetail200ResponseDealFreeeJournalEntriesInner
     */
    'amount': number | null;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseDealFreeeJournalEntriesInner
     */
    'freeeAccountItemId': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseDealFreeeJournalEntriesInner
     */
    'freeeTaxCode': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetPaymentRequestDetail200ResponseDealFreeeJournalEntriesInner
     */
    'isInvalidTaxCode': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseDealFreeeJournalEntriesInner
     */
    'invalidTaxCodeCause': GetPaymentRequestDetail200ResponseDealFreeeJournalEntriesInnerInvalidTaxCodeCauseEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetPaymentRequestDetail200ResponseDealFreeeJournalEntriesInner
     */
    'freeeMemoTags': Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseDealFreeeJournalEntriesInner
     */
    'freeeSectionId': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseDealFreeeJournalEntriesInner
     */
    'freeeItemId': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseDealFreeeJournalEntriesInner
     */
    'segment1TagId': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseDealFreeeJournalEntriesInner
     */
    'segment2TagId': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseDealFreeeJournalEntriesInner
     */
    'segment3TagId': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseDealFreeeJournalEntriesInner
     */
    'description': string | null;
}

export const GetPaymentRequestDetail200ResponseDealFreeeJournalEntriesInnerInvalidTaxCodeCauseEnum = {
    qualifiedButPartDeduct: 'QUALIFIED_BUT_PART_DEDUCT',
    notQualifiedButFullDeduct: 'NOT_QUALIFIED_BUT_FULL_DEDUCT',
    preStartButPartDeduct: 'PRE_START_BUT_PART_DEDUCT',
    inconsistentDeductRate: 'INCONSISTENT_DEDUCT_RATE'
} as const;

export type GetPaymentRequestDetail200ResponseDealFreeeJournalEntriesInnerInvalidTaxCodeCauseEnum = typeof GetPaymentRequestDetail200ResponseDealFreeeJournalEntriesInnerInvalidTaxCodeCauseEnum[keyof typeof GetPaymentRequestDetail200ResponseDealFreeeJournalEntriesInnerInvalidTaxCodeCauseEnum];

/**
 * 
 * @export
 * @interface GetPaymentRequestDetail200ResponseEvidencesInner
 */
export interface GetPaymentRequestDetail200ResponseEvidencesInner {
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseEvidencesInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseEvidencesInner
     */
    'userAccountId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseEvidencesInner
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseEvidencesInner
     */
    'paymentType': GetPaymentRequestDetail200ResponseEvidencesInnerPaymentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseEvidencesInner
     */
    'electronicMethod': GetPaymentRequestDetail200ResponseEvidencesInnerElectronicMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseEvidencesInner
     */
    'documentSize': GetPaymentRequestDetail200ResponseEvidencesInnerDocumentSizeEnum;
    /**
     * 
     * @type {number}
     * @memberof GetPaymentRequestDetail200ResponseEvidencesInner
     */
    'detectedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetPaymentRequestDetail200ResponseEvidencesInner
     */
    'calculatedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetPaymentRequestDetail200ResponseEvidencesInner
     */
    'colorGradation': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetPaymentRequestDetail200ResponseEvidencesInner
     */
    'verticalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetPaymentRequestDetail200ResponseEvidencesInner
     */
    'horizontalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetPaymentRequestDetail200ResponseEvidencesInner
     */
    'heightMillis': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetPaymentRequestDetail200ResponseEvidencesInner
     */
    'widthMillis': number | null;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseEvidencesInner
     */
    'legalValidity': GetPaymentRequestDetail200ResponseEvidencesInnerLegalValidityEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseEvidencesInner
     */
    'note': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetPaymentRequestDetail200ResponseEvidencesInner
     */
    'irrelevantToLedger': boolean;
    /**
     * 
     * @type {GetPaymentRequestDetail200ResponseEvidencesInnerFile}
     * @memberof GetPaymentRequestDetail200ResponseEvidencesInner
     */
    'file': GetPaymentRequestDetail200ResponseEvidencesInnerFile;
    /**
     * 
     * @type {GetPaymentRequestDetail200ResponseEvidencesInnerInvoiceIssuer}
     * @memberof GetPaymentRequestDetail200ResponseEvidencesInner
     */
    'invoiceIssuer': GetPaymentRequestDetail200ResponseEvidencesInnerInvoiceIssuer | null;
    /**
     * 
     * @type {GetPaymentRequestDetail200ResponseEvidencesInnerErrors}
     * @memberof GetPaymentRequestDetail200ResponseEvidencesInner
     */
    'errors': GetPaymentRequestDetail200ResponseEvidencesInnerErrors;
    /**
     * 
     * @type {GetPaymentRequestDetail200ResponseEvidencesInnerWarnings}
     * @memberof GetPaymentRequestDetail200ResponseEvidencesInner
     */
    'warnings': GetPaymentRequestDetail200ResponseEvidencesInnerWarnings;
    /**
     * 
     * @type {GetPaymentRequestDetail200ResponseEvidencesInnerUpdatedBy}
     * @memberof GetPaymentRequestDetail200ResponseEvidencesInner
     */
    'updatedBy': GetPaymentRequestDetail200ResponseEvidencesInnerUpdatedBy;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseEvidencesInner
     */
    'updatedAt': string;
    /**
     * 
     * @type {GetPaymentRequestDetail200ResponseEvidencesInnerUploadedBy}
     * @memberof GetPaymentRequestDetail200ResponseEvidencesInner
     */
    'uploadedBy': GetPaymentRequestDetail200ResponseEvidencesInnerUploadedBy;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseEvidencesInner
     */
    'uploadedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetPaymentRequestDetail200ResponseEvidencesInner
     */
    'needsMigration'?: boolean;
}

export const GetPaymentRequestDetail200ResponseEvidencesInnerPaymentTypeEnum = {
    cardTransaction: 'CARD_TRANSACTION',
    paymentRequest: 'PAYMENT_REQUEST'
} as const;

export type GetPaymentRequestDetail200ResponseEvidencesInnerPaymentTypeEnum = typeof GetPaymentRequestDetail200ResponseEvidencesInnerPaymentTypeEnum[keyof typeof GetPaymentRequestDetail200ResponseEvidencesInnerPaymentTypeEnum];
export const GetPaymentRequestDetail200ResponseEvidencesInnerElectronicMethodEnum = {
    fullElectronic: 'FULL_ELECTRONIC',
    originallyPaper: 'ORIGINALLY_PAPER',
    unknown: 'UNKNOWN'
} as const;

export type GetPaymentRequestDetail200ResponseEvidencesInnerElectronicMethodEnum = typeof GetPaymentRequestDetail200ResponseEvidencesInnerElectronicMethodEnum[keyof typeof GetPaymentRequestDetail200ResponseEvidencesInnerElectronicMethodEnum];
export const GetPaymentRequestDetail200ResponseEvidencesInnerDocumentSizeEnum = {
    overA4: 'OVER_A4',
    a4OrSmaller: 'A4_OR_SMALLER',
    unknown: 'UNKNOWN'
} as const;

export type GetPaymentRequestDetail200ResponseEvidencesInnerDocumentSizeEnum = typeof GetPaymentRequestDetail200ResponseEvidencesInnerDocumentSizeEnum[keyof typeof GetPaymentRequestDetail200ResponseEvidencesInnerDocumentSizeEnum];
export const GetPaymentRequestDetail200ResponseEvidencesInnerLegalValidityEnum = {
    valid: 'VALID',
    invalid: 'INVALID',
    inputRequired: 'INPUT_REQUIRED',
    outOfTarget: 'OUT_OF_TARGET'
} as const;

export type GetPaymentRequestDetail200ResponseEvidencesInnerLegalValidityEnum = typeof GetPaymentRequestDetail200ResponseEvidencesInnerLegalValidityEnum[keyof typeof GetPaymentRequestDetail200ResponseEvidencesInnerLegalValidityEnum];

/**
 * 
 * @export
 * @interface GetPaymentRequestDetail200ResponseEvidencesInnerErrors
 */
export interface GetPaymentRequestDetail200ResponseEvidencesInnerErrors {
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseEvidencesInnerErrors
     */
    'detectedDpi'?: GetPaymentRequestDetail200ResponseEvidencesInnerErrorsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseEvidencesInnerErrors
     */
    'calculatedDpi'?: GetPaymentRequestDetail200ResponseEvidencesInnerErrorsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseEvidencesInnerErrors
     */
    'colorGradation'?: GetPaymentRequestDetail200ResponseEvidencesInnerErrorsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseEvidencesInnerErrors
     */
    'heightMillis'?: GetPaymentRequestDetail200ResponseEvidencesInnerErrorsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseEvidencesInnerErrors
     */
    'widthMillis'?: GetPaymentRequestDetail200ResponseEvidencesInnerErrorsWidthMillisEnum;
}

export const GetPaymentRequestDetail200ResponseEvidencesInnerErrorsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetPaymentRequestDetail200ResponseEvidencesInnerErrorsDetectedDpiEnum = typeof GetPaymentRequestDetail200ResponseEvidencesInnerErrorsDetectedDpiEnum[keyof typeof GetPaymentRequestDetail200ResponseEvidencesInnerErrorsDetectedDpiEnum];
export const GetPaymentRequestDetail200ResponseEvidencesInnerErrorsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetPaymentRequestDetail200ResponseEvidencesInnerErrorsCalculatedDpiEnum = typeof GetPaymentRequestDetail200ResponseEvidencesInnerErrorsCalculatedDpiEnum[keyof typeof GetPaymentRequestDetail200ResponseEvidencesInnerErrorsCalculatedDpiEnum];
export const GetPaymentRequestDetail200ResponseEvidencesInnerErrorsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type GetPaymentRequestDetail200ResponseEvidencesInnerErrorsColorGradationEnum = typeof GetPaymentRequestDetail200ResponseEvidencesInnerErrorsColorGradationEnum[keyof typeof GetPaymentRequestDetail200ResponseEvidencesInnerErrorsColorGradationEnum];
export const GetPaymentRequestDetail200ResponseEvidencesInnerErrorsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetPaymentRequestDetail200ResponseEvidencesInnerErrorsHeightMillisEnum = typeof GetPaymentRequestDetail200ResponseEvidencesInnerErrorsHeightMillisEnum[keyof typeof GetPaymentRequestDetail200ResponseEvidencesInnerErrorsHeightMillisEnum];
export const GetPaymentRequestDetail200ResponseEvidencesInnerErrorsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetPaymentRequestDetail200ResponseEvidencesInnerErrorsWidthMillisEnum = typeof GetPaymentRequestDetail200ResponseEvidencesInnerErrorsWidthMillisEnum[keyof typeof GetPaymentRequestDetail200ResponseEvidencesInnerErrorsWidthMillisEnum];

/**
 * 
 * @export
 * @interface GetPaymentRequestDetail200ResponseEvidencesInnerFile
 */
export interface GetPaymentRequestDetail200ResponseEvidencesInnerFile {
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseEvidencesInnerFile
     */
    'id': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseEvidencesInnerFile
     */
    'name': string;
    /**
     * A URL with expiration date-time accessible from the front-end. This is not fully supported yet. In responses from certain endpoints, the url is set to null.
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseEvidencesInnerFile
     */
    'url': string | null;
}
/**
 * Set null if it\'s evidence not analyzed using invoicing-system-compliance feature. Also set null if invoicing-system-compliance feature has been made not available for the organization by the feature-flag.
 * @export
 * @interface GetPaymentRequestDetail200ResponseEvidencesInnerInvoiceIssuer
 */
export interface GetPaymentRequestDetail200ResponseEvidencesInnerInvoiceIssuer {
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseEvidencesInnerInvoiceIssuer
     */
    'name': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseEvidencesInnerInvoiceIssuer
     */
    'registrationNumber': string | null;
    /**
     * isQualified retains the result of querying the 国税庁API to see if registrationNumber is qualified, as is.
     * @type {boolean}
     * @memberof GetPaymentRequestDetail200ResponseEvidencesInnerInvoiceIssuer
     */
    'isQualified': boolean;
    /**
     * AsQualified indicates whether this issuer should be treated as a qualified invoice issuer within the user\'s system, even if the RegistrationNumber is not confirmed as qualified in the National Tax Agency\'s business registration system.
     * @type {boolean}
     * @memberof GetPaymentRequestDetail200ResponseEvidencesInnerInvoiceIssuer
     */
    'asQualified': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseEvidencesInnerInvoiceIssuer
     */
    'partnerId': string | null;
}
/**
 * 
 * @export
 * @interface GetPaymentRequestDetail200ResponseEvidencesInnerUpdatedBy
 */
export interface GetPaymentRequestDetail200ResponseEvidencesInnerUpdatedBy {
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseEvidencesInnerUpdatedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseEvidencesInnerUpdatedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetPaymentRequestDetail200ResponseEvidencesInnerUploadedBy
 */
export interface GetPaymentRequestDetail200ResponseEvidencesInnerUploadedBy {
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseEvidencesInnerUploadedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseEvidencesInnerUploadedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetPaymentRequestDetail200ResponseEvidencesInnerWarnings
 */
export interface GetPaymentRequestDetail200ResponseEvidencesInnerWarnings {
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseEvidencesInnerWarnings
     */
    'detectedDpi'?: GetPaymentRequestDetail200ResponseEvidencesInnerWarningsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseEvidencesInnerWarnings
     */
    'calculatedDpi'?: GetPaymentRequestDetail200ResponseEvidencesInnerWarningsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseEvidencesInnerWarnings
     */
    'colorGradation'?: GetPaymentRequestDetail200ResponseEvidencesInnerWarningsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseEvidencesInnerWarnings
     */
    'heightMillis'?: GetPaymentRequestDetail200ResponseEvidencesInnerWarningsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseEvidencesInnerWarnings
     */
    'widthMillis'?: GetPaymentRequestDetail200ResponseEvidencesInnerWarningsWidthMillisEnum;
}

export const GetPaymentRequestDetail200ResponseEvidencesInnerWarningsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetPaymentRequestDetail200ResponseEvidencesInnerWarningsDetectedDpiEnum = typeof GetPaymentRequestDetail200ResponseEvidencesInnerWarningsDetectedDpiEnum[keyof typeof GetPaymentRequestDetail200ResponseEvidencesInnerWarningsDetectedDpiEnum];
export const GetPaymentRequestDetail200ResponseEvidencesInnerWarningsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetPaymentRequestDetail200ResponseEvidencesInnerWarningsCalculatedDpiEnum = typeof GetPaymentRequestDetail200ResponseEvidencesInnerWarningsCalculatedDpiEnum[keyof typeof GetPaymentRequestDetail200ResponseEvidencesInnerWarningsCalculatedDpiEnum];
export const GetPaymentRequestDetail200ResponseEvidencesInnerWarningsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type GetPaymentRequestDetail200ResponseEvidencesInnerWarningsColorGradationEnum = typeof GetPaymentRequestDetail200ResponseEvidencesInnerWarningsColorGradationEnum[keyof typeof GetPaymentRequestDetail200ResponseEvidencesInnerWarningsColorGradationEnum];
export const GetPaymentRequestDetail200ResponseEvidencesInnerWarningsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetPaymentRequestDetail200ResponseEvidencesInnerWarningsHeightMillisEnum = typeof GetPaymentRequestDetail200ResponseEvidencesInnerWarningsHeightMillisEnum[keyof typeof GetPaymentRequestDetail200ResponseEvidencesInnerWarningsHeightMillisEnum];
export const GetPaymentRequestDetail200ResponseEvidencesInnerWarningsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetPaymentRequestDetail200ResponseEvidencesInnerWarningsWidthMillisEnum = typeof GetPaymentRequestDetail200ResponseEvidencesInnerWarningsWidthMillisEnum[keyof typeof GetPaymentRequestDetail200ResponseEvidencesInnerWarningsWidthMillisEnum];

/**
 * 
 * @export
 * @interface GetPaymentRequestDetail200ResponseRequestor
 */
export interface GetPaymentRequestDetail200ResponseRequestor {
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseRequestor
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseRequestor
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetPaymentRequestDetail200ResponseSupplier
 */
export interface GetPaymentRequestDetail200ResponseSupplier {
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseSupplier
     */
    'partnerId': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseSupplier
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseSupplier
     */
    'bankNumber': string;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseSupplier
     */
    'bankName': string;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseSupplier
     */
    'branchNumber': string;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseSupplier
     */
    'branchName': string;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseSupplier
     */
    'accountType': GetPaymentRequestDetail200ResponseSupplierAccountTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseSupplier
     */
    'accountNumber': string;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseSupplier
     */
    'companyCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseSupplier
     */
    'companyName': string;
}

export const GetPaymentRequestDetail200ResponseSupplierAccountTypeEnum = {
    savingsAccount: 'SAVINGS_ACCOUNT',
    currentAccount: 'CURRENT_ACCOUNT',
    thriftAccount: 'THRIFT_ACCOUNT',
    other: 'OTHER'
} as const;

export type GetPaymentRequestDetail200ResponseSupplierAccountTypeEnum = typeof GetPaymentRequestDetail200ResponseSupplierAccountTypeEnum[keyof typeof GetPaymentRequestDetail200ResponseSupplierAccountTypeEnum];

/**
 * 
 * @export
 * @interface GetPaymentRequestEvidence200Response
 */
export interface GetPaymentRequestEvidence200Response {
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidence200Response
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidence200Response
     */
    'userAccountId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidence200Response
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidence200Response
     */
    'paymentType': GetPaymentRequestEvidence200ResponsePaymentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidence200Response
     */
    'electronicMethod': GetPaymentRequestEvidence200ResponseElectronicMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidence200Response
     */
    'documentSize': GetPaymentRequestEvidence200ResponseDocumentSizeEnum;
    /**
     * 
     * @type {number}
     * @memberof GetPaymentRequestEvidence200Response
     */
    'detectedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetPaymentRequestEvidence200Response
     */
    'calculatedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetPaymentRequestEvidence200Response
     */
    'colorGradation': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetPaymentRequestEvidence200Response
     */
    'verticalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetPaymentRequestEvidence200Response
     */
    'horizontalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetPaymentRequestEvidence200Response
     */
    'heightMillis': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetPaymentRequestEvidence200Response
     */
    'widthMillis': number | null;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidence200Response
     */
    'legalValidity': GetPaymentRequestEvidence200ResponseLegalValidityEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidence200Response
     */
    'note': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetPaymentRequestEvidence200Response
     */
    'irrelevantToLedger': boolean;
    /**
     * 
     * @type {GetPaymentRequestEvidence200ResponseFile}
     * @memberof GetPaymentRequestEvidence200Response
     */
    'file': GetPaymentRequestEvidence200ResponseFile;
    /**
     * 
     * @type {GetPaymentRequestEvidence200ResponseInvoiceIssuer}
     * @memberof GetPaymentRequestEvidence200Response
     */
    'invoiceIssuer': GetPaymentRequestEvidence200ResponseInvoiceIssuer | null;
    /**
     * 
     * @type {GetPaymentRequestEvidence200ResponseErrors}
     * @memberof GetPaymentRequestEvidence200Response
     */
    'errors': GetPaymentRequestEvidence200ResponseErrors;
    /**
     * 
     * @type {GetPaymentRequestEvidence200ResponseWarnings}
     * @memberof GetPaymentRequestEvidence200Response
     */
    'warnings': GetPaymentRequestEvidence200ResponseWarnings;
    /**
     * 
     * @type {GetPaymentRequestEvidence200ResponseUpdatedBy}
     * @memberof GetPaymentRequestEvidence200Response
     */
    'updatedBy': GetPaymentRequestEvidence200ResponseUpdatedBy;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidence200Response
     */
    'updatedAt': string;
    /**
     * 
     * @type {GetPaymentRequestEvidence200ResponseUploadedBy}
     * @memberof GetPaymentRequestEvidence200Response
     */
    'uploadedBy': GetPaymentRequestEvidence200ResponseUploadedBy;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidence200Response
     */
    'uploadedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetPaymentRequestEvidence200Response
     */
    'needsMigration'?: boolean;
}

export const GetPaymentRequestEvidence200ResponsePaymentTypeEnum = {
    cardTransaction: 'CARD_TRANSACTION',
    paymentRequest: 'PAYMENT_REQUEST'
} as const;

export type GetPaymentRequestEvidence200ResponsePaymentTypeEnum = typeof GetPaymentRequestEvidence200ResponsePaymentTypeEnum[keyof typeof GetPaymentRequestEvidence200ResponsePaymentTypeEnum];
export const GetPaymentRequestEvidence200ResponseElectronicMethodEnum = {
    fullElectronic: 'FULL_ELECTRONIC',
    originallyPaper: 'ORIGINALLY_PAPER',
    unknown: 'UNKNOWN'
} as const;

export type GetPaymentRequestEvidence200ResponseElectronicMethodEnum = typeof GetPaymentRequestEvidence200ResponseElectronicMethodEnum[keyof typeof GetPaymentRequestEvidence200ResponseElectronicMethodEnum];
export const GetPaymentRequestEvidence200ResponseDocumentSizeEnum = {
    overA4: 'OVER_A4',
    a4OrSmaller: 'A4_OR_SMALLER',
    unknown: 'UNKNOWN'
} as const;

export type GetPaymentRequestEvidence200ResponseDocumentSizeEnum = typeof GetPaymentRequestEvidence200ResponseDocumentSizeEnum[keyof typeof GetPaymentRequestEvidence200ResponseDocumentSizeEnum];
export const GetPaymentRequestEvidence200ResponseLegalValidityEnum = {
    valid: 'VALID',
    invalid: 'INVALID',
    inputRequired: 'INPUT_REQUIRED',
    outOfTarget: 'OUT_OF_TARGET'
} as const;

export type GetPaymentRequestEvidence200ResponseLegalValidityEnum = typeof GetPaymentRequestEvidence200ResponseLegalValidityEnum[keyof typeof GetPaymentRequestEvidence200ResponseLegalValidityEnum];

/**
 * 
 * @export
 * @interface GetPaymentRequestEvidence200ResponseErrors
 */
export interface GetPaymentRequestEvidence200ResponseErrors {
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidence200ResponseErrors
     */
    'detectedDpi'?: GetPaymentRequestEvidence200ResponseErrorsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidence200ResponseErrors
     */
    'calculatedDpi'?: GetPaymentRequestEvidence200ResponseErrorsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidence200ResponseErrors
     */
    'colorGradation'?: GetPaymentRequestEvidence200ResponseErrorsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidence200ResponseErrors
     */
    'heightMillis'?: GetPaymentRequestEvidence200ResponseErrorsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidence200ResponseErrors
     */
    'widthMillis'?: GetPaymentRequestEvidence200ResponseErrorsWidthMillisEnum;
}

export const GetPaymentRequestEvidence200ResponseErrorsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetPaymentRequestEvidence200ResponseErrorsDetectedDpiEnum = typeof GetPaymentRequestEvidence200ResponseErrorsDetectedDpiEnum[keyof typeof GetPaymentRequestEvidence200ResponseErrorsDetectedDpiEnum];
export const GetPaymentRequestEvidence200ResponseErrorsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetPaymentRequestEvidence200ResponseErrorsCalculatedDpiEnum = typeof GetPaymentRequestEvidence200ResponseErrorsCalculatedDpiEnum[keyof typeof GetPaymentRequestEvidence200ResponseErrorsCalculatedDpiEnum];
export const GetPaymentRequestEvidence200ResponseErrorsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type GetPaymentRequestEvidence200ResponseErrorsColorGradationEnum = typeof GetPaymentRequestEvidence200ResponseErrorsColorGradationEnum[keyof typeof GetPaymentRequestEvidence200ResponseErrorsColorGradationEnum];
export const GetPaymentRequestEvidence200ResponseErrorsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetPaymentRequestEvidence200ResponseErrorsHeightMillisEnum = typeof GetPaymentRequestEvidence200ResponseErrorsHeightMillisEnum[keyof typeof GetPaymentRequestEvidence200ResponseErrorsHeightMillisEnum];
export const GetPaymentRequestEvidence200ResponseErrorsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetPaymentRequestEvidence200ResponseErrorsWidthMillisEnum = typeof GetPaymentRequestEvidence200ResponseErrorsWidthMillisEnum[keyof typeof GetPaymentRequestEvidence200ResponseErrorsWidthMillisEnum];

/**
 * 
 * @export
 * @interface GetPaymentRequestEvidence200ResponseFile
 */
export interface GetPaymentRequestEvidence200ResponseFile {
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidence200ResponseFile
     */
    'id': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidence200ResponseFile
     */
    'name': string;
    /**
     * A URL with expiration date-time accessible from the front-end. This is not fully supported yet. In responses from certain endpoints, the url is set to null.
     * @type {string}
     * @memberof GetPaymentRequestEvidence200ResponseFile
     */
    'url': string | null;
}
/**
 * Set null if it\'s evidence not analyzed using invoicing-system-compliance feature. Also set null if invoicing-system-compliance feature has been made not available for the organization by the feature-flag.
 * @export
 * @interface GetPaymentRequestEvidence200ResponseInvoiceIssuer
 */
export interface GetPaymentRequestEvidence200ResponseInvoiceIssuer {
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidence200ResponseInvoiceIssuer
     */
    'name': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidence200ResponseInvoiceIssuer
     */
    'registrationNumber': string | null;
    /**
     * isQualified retains the result of querying the 国税庁API to see if registrationNumber is qualified, as is.
     * @type {boolean}
     * @memberof GetPaymentRequestEvidence200ResponseInvoiceIssuer
     */
    'isQualified': boolean;
    /**
     * AsQualified indicates whether this issuer should be treated as a qualified invoice issuer within the user\'s system, even if the RegistrationNumber is not confirmed as qualified in the National Tax Agency\'s business registration system.
     * @type {boolean}
     * @memberof GetPaymentRequestEvidence200ResponseInvoiceIssuer
     */
    'asQualified': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidence200ResponseInvoiceIssuer
     */
    'partnerId': string | null;
}
/**
 * 
 * @export
 * @interface GetPaymentRequestEvidence200ResponseUpdatedBy
 */
export interface GetPaymentRequestEvidence200ResponseUpdatedBy {
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidence200ResponseUpdatedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidence200ResponseUpdatedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetPaymentRequestEvidence200ResponseUploadedBy
 */
export interface GetPaymentRequestEvidence200ResponseUploadedBy {
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidence200ResponseUploadedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidence200ResponseUploadedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetPaymentRequestEvidence200ResponseWarnings
 */
export interface GetPaymentRequestEvidence200ResponseWarnings {
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidence200ResponseWarnings
     */
    'detectedDpi'?: GetPaymentRequestEvidence200ResponseWarningsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidence200ResponseWarnings
     */
    'calculatedDpi'?: GetPaymentRequestEvidence200ResponseWarningsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidence200ResponseWarnings
     */
    'colorGradation'?: GetPaymentRequestEvidence200ResponseWarningsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidence200ResponseWarnings
     */
    'heightMillis'?: GetPaymentRequestEvidence200ResponseWarningsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidence200ResponseWarnings
     */
    'widthMillis'?: GetPaymentRequestEvidence200ResponseWarningsWidthMillisEnum;
}

export const GetPaymentRequestEvidence200ResponseWarningsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetPaymentRequestEvidence200ResponseWarningsDetectedDpiEnum = typeof GetPaymentRequestEvidence200ResponseWarningsDetectedDpiEnum[keyof typeof GetPaymentRequestEvidence200ResponseWarningsDetectedDpiEnum];
export const GetPaymentRequestEvidence200ResponseWarningsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetPaymentRequestEvidence200ResponseWarningsCalculatedDpiEnum = typeof GetPaymentRequestEvidence200ResponseWarningsCalculatedDpiEnum[keyof typeof GetPaymentRequestEvidence200ResponseWarningsCalculatedDpiEnum];
export const GetPaymentRequestEvidence200ResponseWarningsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type GetPaymentRequestEvidence200ResponseWarningsColorGradationEnum = typeof GetPaymentRequestEvidence200ResponseWarningsColorGradationEnum[keyof typeof GetPaymentRequestEvidence200ResponseWarningsColorGradationEnum];
export const GetPaymentRequestEvidence200ResponseWarningsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetPaymentRequestEvidence200ResponseWarningsHeightMillisEnum = typeof GetPaymentRequestEvidence200ResponseWarningsHeightMillisEnum[keyof typeof GetPaymentRequestEvidence200ResponseWarningsHeightMillisEnum];
export const GetPaymentRequestEvidence200ResponseWarningsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetPaymentRequestEvidence200ResponseWarningsWidthMillisEnum = typeof GetPaymentRequestEvidence200ResponseWarningsWidthMillisEnum[keyof typeof GetPaymentRequestEvidence200ResponseWarningsWidthMillisEnum];

/**
 * 
 * @export
 * @interface GetPaymentRequestEvidenceRecords200ResponseInner
 */
export interface GetPaymentRequestEvidenceRecords200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidenceRecords200ResponseInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidenceRecords200ResponseInner
     */
    'evidenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidenceRecords200ResponseInner
     */
    'userAccountId': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidenceRecords200ResponseInner
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidenceRecords200ResponseInner
     */
    'paymentType': GetPaymentRequestEvidenceRecords200ResponseInnerPaymentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidenceRecords200ResponseInner
     */
    'electronicMethod': GetPaymentRequestEvidenceRecords200ResponseInnerElectronicMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidenceRecords200ResponseInner
     */
    'documentSize': GetPaymentRequestEvidenceRecords200ResponseInnerDocumentSizeEnum;
    /**
     * 
     * @type {number}
     * @memberof GetPaymentRequestEvidenceRecords200ResponseInner
     */
    'detectedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetPaymentRequestEvidenceRecords200ResponseInner
     */
    'calculatedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetPaymentRequestEvidenceRecords200ResponseInner
     */
    'colorGradation': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetPaymentRequestEvidenceRecords200ResponseInner
     */
    'verticalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetPaymentRequestEvidenceRecords200ResponseInner
     */
    'horizontalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetPaymentRequestEvidenceRecords200ResponseInner
     */
    'heightMillis': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetPaymentRequestEvidenceRecords200ResponseInner
     */
    'widthMillis': number | null;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidenceRecords200ResponseInner
     */
    'legalValidity': GetPaymentRequestEvidenceRecords200ResponseInnerLegalValidityEnum;
    /**
     * 
     * @type {boolean}
     * @memberof GetPaymentRequestEvidenceRecords200ResponseInner
     */
    'dpiForciblyValid': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetPaymentRequestEvidenceRecords200ResponseInner
     */
    'colorGradationForciblyValid': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidenceRecords200ResponseInner
     */
    'note': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetPaymentRequestEvidenceRecords200ResponseInner
     */
    'irrelevantToLedger': boolean;
    /**
     * 
     * @type {GetPaymentRequestEvidenceRecords200ResponseInnerFile}
     * @memberof GetPaymentRequestEvidenceRecords200ResponseInner
     */
    'file': GetPaymentRequestEvidenceRecords200ResponseInnerFile;
    /**
     * 
     * @type {GetPaymentRequestEvidenceRecords200ResponseInnerInvoiceIssuer}
     * @memberof GetPaymentRequestEvidenceRecords200ResponseInner
     */
    'invoiceIssuer': GetPaymentRequestEvidenceRecords200ResponseInnerInvoiceIssuer | null;
    /**
     * 
     * @type {GetPaymentRequestEvidenceRecords200ResponseInnerErrors}
     * @memberof GetPaymentRequestEvidenceRecords200ResponseInner
     */
    'errors': GetPaymentRequestEvidenceRecords200ResponseInnerErrors;
    /**
     * 
     * @type {GetPaymentRequestEvidenceRecords200ResponseInnerWarnings}
     * @memberof GetPaymentRequestEvidenceRecords200ResponseInner
     */
    'warnings': GetPaymentRequestEvidenceRecords200ResponseInnerWarnings;
    /**
     * 
     * @type {GetPaymentRequestEvidenceRecords200ResponseInnerUpdatedBy}
     * @memberof GetPaymentRequestEvidenceRecords200ResponseInner
     */
    'updatedBy': GetPaymentRequestEvidenceRecords200ResponseInnerUpdatedBy;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidenceRecords200ResponseInner
     */
    'updatedAt': string;
    /**
     * 
     * @type {GetPaymentRequestEvidenceRecords200ResponseInnerUploadedBy}
     * @memberof GetPaymentRequestEvidenceRecords200ResponseInner
     */
    'uploadedBy': GetPaymentRequestEvidenceRecords200ResponseInnerUploadedBy;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidenceRecords200ResponseInner
     */
    'uploadedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetPaymentRequestEvidenceRecords200ResponseInner
     */
    'uploadedByRecipient': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetPaymentRequestEvidenceRecords200ResponseInner
     */
    'deleted': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidenceRecords200ResponseInner
     */
    'uploadedFrom': string;
}

export const GetPaymentRequestEvidenceRecords200ResponseInnerPaymentTypeEnum = {
    cardTransaction: 'CARD_TRANSACTION',
    paymentRequest: 'PAYMENT_REQUEST'
} as const;

export type GetPaymentRequestEvidenceRecords200ResponseInnerPaymentTypeEnum = typeof GetPaymentRequestEvidenceRecords200ResponseInnerPaymentTypeEnum[keyof typeof GetPaymentRequestEvidenceRecords200ResponseInnerPaymentTypeEnum];
export const GetPaymentRequestEvidenceRecords200ResponseInnerElectronicMethodEnum = {
    fullElectronic: 'FULL_ELECTRONIC',
    originallyPaper: 'ORIGINALLY_PAPER',
    unknown: 'UNKNOWN'
} as const;

export type GetPaymentRequestEvidenceRecords200ResponseInnerElectronicMethodEnum = typeof GetPaymentRequestEvidenceRecords200ResponseInnerElectronicMethodEnum[keyof typeof GetPaymentRequestEvidenceRecords200ResponseInnerElectronicMethodEnum];
export const GetPaymentRequestEvidenceRecords200ResponseInnerDocumentSizeEnum = {
    overA4: 'OVER_A4',
    a4OrSmaller: 'A4_OR_SMALLER',
    unknown: 'UNKNOWN'
} as const;

export type GetPaymentRequestEvidenceRecords200ResponseInnerDocumentSizeEnum = typeof GetPaymentRequestEvidenceRecords200ResponseInnerDocumentSizeEnum[keyof typeof GetPaymentRequestEvidenceRecords200ResponseInnerDocumentSizeEnum];
export const GetPaymentRequestEvidenceRecords200ResponseInnerLegalValidityEnum = {
    valid: 'VALID',
    invalid: 'INVALID',
    inputRequired: 'INPUT_REQUIRED',
    outOfTarget: 'OUT_OF_TARGET'
} as const;

export type GetPaymentRequestEvidenceRecords200ResponseInnerLegalValidityEnum = typeof GetPaymentRequestEvidenceRecords200ResponseInnerLegalValidityEnum[keyof typeof GetPaymentRequestEvidenceRecords200ResponseInnerLegalValidityEnum];

/**
 * 
 * @export
 * @interface GetPaymentRequestEvidenceRecords200ResponseInnerErrors
 */
export interface GetPaymentRequestEvidenceRecords200ResponseInnerErrors {
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidenceRecords200ResponseInnerErrors
     */
    'detectedDpi'?: GetPaymentRequestEvidenceRecords200ResponseInnerErrorsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidenceRecords200ResponseInnerErrors
     */
    'calculatedDpi'?: GetPaymentRequestEvidenceRecords200ResponseInnerErrorsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidenceRecords200ResponseInnerErrors
     */
    'colorGradation'?: GetPaymentRequestEvidenceRecords200ResponseInnerErrorsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidenceRecords200ResponseInnerErrors
     */
    'heightMillis'?: GetPaymentRequestEvidenceRecords200ResponseInnerErrorsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidenceRecords200ResponseInnerErrors
     */
    'widthMillis'?: GetPaymentRequestEvidenceRecords200ResponseInnerErrorsWidthMillisEnum;
}

export const GetPaymentRequestEvidenceRecords200ResponseInnerErrorsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetPaymentRequestEvidenceRecords200ResponseInnerErrorsDetectedDpiEnum = typeof GetPaymentRequestEvidenceRecords200ResponseInnerErrorsDetectedDpiEnum[keyof typeof GetPaymentRequestEvidenceRecords200ResponseInnerErrorsDetectedDpiEnum];
export const GetPaymentRequestEvidenceRecords200ResponseInnerErrorsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetPaymentRequestEvidenceRecords200ResponseInnerErrorsCalculatedDpiEnum = typeof GetPaymentRequestEvidenceRecords200ResponseInnerErrorsCalculatedDpiEnum[keyof typeof GetPaymentRequestEvidenceRecords200ResponseInnerErrorsCalculatedDpiEnum];
export const GetPaymentRequestEvidenceRecords200ResponseInnerErrorsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type GetPaymentRequestEvidenceRecords200ResponseInnerErrorsColorGradationEnum = typeof GetPaymentRequestEvidenceRecords200ResponseInnerErrorsColorGradationEnum[keyof typeof GetPaymentRequestEvidenceRecords200ResponseInnerErrorsColorGradationEnum];
export const GetPaymentRequestEvidenceRecords200ResponseInnerErrorsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetPaymentRequestEvidenceRecords200ResponseInnerErrorsHeightMillisEnum = typeof GetPaymentRequestEvidenceRecords200ResponseInnerErrorsHeightMillisEnum[keyof typeof GetPaymentRequestEvidenceRecords200ResponseInnerErrorsHeightMillisEnum];
export const GetPaymentRequestEvidenceRecords200ResponseInnerErrorsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetPaymentRequestEvidenceRecords200ResponseInnerErrorsWidthMillisEnum = typeof GetPaymentRequestEvidenceRecords200ResponseInnerErrorsWidthMillisEnum[keyof typeof GetPaymentRequestEvidenceRecords200ResponseInnerErrorsWidthMillisEnum];

/**
 * 
 * @export
 * @interface GetPaymentRequestEvidenceRecords200ResponseInnerFile
 */
export interface GetPaymentRequestEvidenceRecords200ResponseInnerFile {
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidenceRecords200ResponseInnerFile
     */
    'id': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidenceRecords200ResponseInnerFile
     */
    'name': string;
    /**
     * A URL with expiration date-time accessible from the front-end. This is not fully supported yet. In responses from certain endpoints, the url is set to null.
     * @type {string}
     * @memberof GetPaymentRequestEvidenceRecords200ResponseInnerFile
     */
    'url': string | null;
}
/**
 * Set null if it\'s evidence not analyzed using invoicing-system-compliance feature. Also set null if invoicing-system-compliance feature has been made not available for the organization by the feature-flag.
 * @export
 * @interface GetPaymentRequestEvidenceRecords200ResponseInnerInvoiceIssuer
 */
export interface GetPaymentRequestEvidenceRecords200ResponseInnerInvoiceIssuer {
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidenceRecords200ResponseInnerInvoiceIssuer
     */
    'name': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidenceRecords200ResponseInnerInvoiceIssuer
     */
    'registrationNumber': string | null;
    /**
     * isQualified retains the result of querying the 国税庁API to see if registrationNumber is qualified, as is.
     * @type {boolean}
     * @memberof GetPaymentRequestEvidenceRecords200ResponseInnerInvoiceIssuer
     */
    'isQualified': boolean;
    /**
     * AsQualified indicates whether this issuer should be treated as a qualified invoice issuer within the user\'s system, even if the RegistrationNumber is not confirmed as qualified in the National Tax Agency\'s business registration system.
     * @type {boolean}
     * @memberof GetPaymentRequestEvidenceRecords200ResponseInnerInvoiceIssuer
     */
    'asQualified': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidenceRecords200ResponseInnerInvoiceIssuer
     */
    'partnerId': string | null;
}
/**
 * 
 * @export
 * @interface GetPaymentRequestEvidenceRecords200ResponseInnerUpdatedBy
 */
export interface GetPaymentRequestEvidenceRecords200ResponseInnerUpdatedBy {
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidenceRecords200ResponseInnerUpdatedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidenceRecords200ResponseInnerUpdatedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetPaymentRequestEvidenceRecords200ResponseInnerUploadedBy
 */
export interface GetPaymentRequestEvidenceRecords200ResponseInnerUploadedBy {
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidenceRecords200ResponseInnerUploadedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidenceRecords200ResponseInnerUploadedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetPaymentRequestEvidenceRecords200ResponseInnerWarnings
 */
export interface GetPaymentRequestEvidenceRecords200ResponseInnerWarnings {
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidenceRecords200ResponseInnerWarnings
     */
    'detectedDpi'?: GetPaymentRequestEvidenceRecords200ResponseInnerWarningsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidenceRecords200ResponseInnerWarnings
     */
    'calculatedDpi'?: GetPaymentRequestEvidenceRecords200ResponseInnerWarningsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidenceRecords200ResponseInnerWarnings
     */
    'colorGradation'?: GetPaymentRequestEvidenceRecords200ResponseInnerWarningsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidenceRecords200ResponseInnerWarnings
     */
    'heightMillis'?: GetPaymentRequestEvidenceRecords200ResponseInnerWarningsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidenceRecords200ResponseInnerWarnings
     */
    'widthMillis'?: GetPaymentRequestEvidenceRecords200ResponseInnerWarningsWidthMillisEnum;
}

export const GetPaymentRequestEvidenceRecords200ResponseInnerWarningsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetPaymentRequestEvidenceRecords200ResponseInnerWarningsDetectedDpiEnum = typeof GetPaymentRequestEvidenceRecords200ResponseInnerWarningsDetectedDpiEnum[keyof typeof GetPaymentRequestEvidenceRecords200ResponseInnerWarningsDetectedDpiEnum];
export const GetPaymentRequestEvidenceRecords200ResponseInnerWarningsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetPaymentRequestEvidenceRecords200ResponseInnerWarningsCalculatedDpiEnum = typeof GetPaymentRequestEvidenceRecords200ResponseInnerWarningsCalculatedDpiEnum[keyof typeof GetPaymentRequestEvidenceRecords200ResponseInnerWarningsCalculatedDpiEnum];
export const GetPaymentRequestEvidenceRecords200ResponseInnerWarningsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type GetPaymentRequestEvidenceRecords200ResponseInnerWarningsColorGradationEnum = typeof GetPaymentRequestEvidenceRecords200ResponseInnerWarningsColorGradationEnum[keyof typeof GetPaymentRequestEvidenceRecords200ResponseInnerWarningsColorGradationEnum];
export const GetPaymentRequestEvidenceRecords200ResponseInnerWarningsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetPaymentRequestEvidenceRecords200ResponseInnerWarningsHeightMillisEnum = typeof GetPaymentRequestEvidenceRecords200ResponseInnerWarningsHeightMillisEnum[keyof typeof GetPaymentRequestEvidenceRecords200ResponseInnerWarningsHeightMillisEnum];
export const GetPaymentRequestEvidenceRecords200ResponseInnerWarningsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetPaymentRequestEvidenceRecords200ResponseInnerWarningsWidthMillisEnum = typeof GetPaymentRequestEvidenceRecords200ResponseInnerWarningsWidthMillisEnum[keyof typeof GetPaymentRequestEvidenceRecords200ResponseInnerWarningsWidthMillisEnum];

/**
 * 
 * @export
 * @interface GetPaymentRequestEvidences200ResponseInner
 */
export interface GetPaymentRequestEvidences200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidences200ResponseInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidences200ResponseInner
     */
    'userAccountId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidences200ResponseInner
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidences200ResponseInner
     */
    'paymentType': GetPaymentRequestEvidences200ResponseInnerPaymentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidences200ResponseInner
     */
    'electronicMethod': GetPaymentRequestEvidences200ResponseInnerElectronicMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidences200ResponseInner
     */
    'documentSize': GetPaymentRequestEvidences200ResponseInnerDocumentSizeEnum;
    /**
     * 
     * @type {number}
     * @memberof GetPaymentRequestEvidences200ResponseInner
     */
    'detectedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetPaymentRequestEvidences200ResponseInner
     */
    'calculatedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetPaymentRequestEvidences200ResponseInner
     */
    'colorGradation': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetPaymentRequestEvidences200ResponseInner
     */
    'verticalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetPaymentRequestEvidences200ResponseInner
     */
    'horizontalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetPaymentRequestEvidences200ResponseInner
     */
    'heightMillis': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetPaymentRequestEvidences200ResponseInner
     */
    'widthMillis': number | null;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidences200ResponseInner
     */
    'legalValidity': GetPaymentRequestEvidences200ResponseInnerLegalValidityEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidences200ResponseInner
     */
    'note': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetPaymentRequestEvidences200ResponseInner
     */
    'irrelevantToLedger': boolean;
    /**
     * 
     * @type {GetPaymentRequestEvidences200ResponseInnerFile}
     * @memberof GetPaymentRequestEvidences200ResponseInner
     */
    'file': GetPaymentRequestEvidences200ResponseInnerFile;
    /**
     * 
     * @type {GetPaymentRequestEvidences200ResponseInnerInvoiceIssuer}
     * @memberof GetPaymentRequestEvidences200ResponseInner
     */
    'invoiceIssuer': GetPaymentRequestEvidences200ResponseInnerInvoiceIssuer | null;
    /**
     * 
     * @type {GetPaymentRequestEvidences200ResponseInnerErrors}
     * @memberof GetPaymentRequestEvidences200ResponseInner
     */
    'errors': GetPaymentRequestEvidences200ResponseInnerErrors;
    /**
     * 
     * @type {GetPaymentRequestEvidences200ResponseInnerWarnings}
     * @memberof GetPaymentRequestEvidences200ResponseInner
     */
    'warnings': GetPaymentRequestEvidences200ResponseInnerWarnings;
    /**
     * 
     * @type {GetPaymentRequestEvidences200ResponseInnerUpdatedBy}
     * @memberof GetPaymentRequestEvidences200ResponseInner
     */
    'updatedBy': GetPaymentRequestEvidences200ResponseInnerUpdatedBy;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidences200ResponseInner
     */
    'updatedAt': string;
    /**
     * 
     * @type {GetPaymentRequestEvidences200ResponseInnerUploadedBy}
     * @memberof GetPaymentRequestEvidences200ResponseInner
     */
    'uploadedBy': GetPaymentRequestEvidences200ResponseInnerUploadedBy;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidences200ResponseInner
     */
    'uploadedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetPaymentRequestEvidences200ResponseInner
     */
    'needsMigration'?: boolean;
}

export const GetPaymentRequestEvidences200ResponseInnerPaymentTypeEnum = {
    cardTransaction: 'CARD_TRANSACTION',
    paymentRequest: 'PAYMENT_REQUEST'
} as const;

export type GetPaymentRequestEvidences200ResponseInnerPaymentTypeEnum = typeof GetPaymentRequestEvidences200ResponseInnerPaymentTypeEnum[keyof typeof GetPaymentRequestEvidences200ResponseInnerPaymentTypeEnum];
export const GetPaymentRequestEvidences200ResponseInnerElectronicMethodEnum = {
    fullElectronic: 'FULL_ELECTRONIC',
    originallyPaper: 'ORIGINALLY_PAPER',
    unknown: 'UNKNOWN'
} as const;

export type GetPaymentRequestEvidences200ResponseInnerElectronicMethodEnum = typeof GetPaymentRequestEvidences200ResponseInnerElectronicMethodEnum[keyof typeof GetPaymentRequestEvidences200ResponseInnerElectronicMethodEnum];
export const GetPaymentRequestEvidences200ResponseInnerDocumentSizeEnum = {
    overA4: 'OVER_A4',
    a4OrSmaller: 'A4_OR_SMALLER',
    unknown: 'UNKNOWN'
} as const;

export type GetPaymentRequestEvidences200ResponseInnerDocumentSizeEnum = typeof GetPaymentRequestEvidences200ResponseInnerDocumentSizeEnum[keyof typeof GetPaymentRequestEvidences200ResponseInnerDocumentSizeEnum];
export const GetPaymentRequestEvidences200ResponseInnerLegalValidityEnum = {
    valid: 'VALID',
    invalid: 'INVALID',
    inputRequired: 'INPUT_REQUIRED',
    outOfTarget: 'OUT_OF_TARGET'
} as const;

export type GetPaymentRequestEvidences200ResponseInnerLegalValidityEnum = typeof GetPaymentRequestEvidences200ResponseInnerLegalValidityEnum[keyof typeof GetPaymentRequestEvidences200ResponseInnerLegalValidityEnum];

/**
 * 
 * @export
 * @interface GetPaymentRequestEvidences200ResponseInnerErrors
 */
export interface GetPaymentRequestEvidences200ResponseInnerErrors {
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidences200ResponseInnerErrors
     */
    'detectedDpi'?: GetPaymentRequestEvidences200ResponseInnerErrorsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidences200ResponseInnerErrors
     */
    'calculatedDpi'?: GetPaymentRequestEvidences200ResponseInnerErrorsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidences200ResponseInnerErrors
     */
    'colorGradation'?: GetPaymentRequestEvidences200ResponseInnerErrorsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidences200ResponseInnerErrors
     */
    'heightMillis'?: GetPaymentRequestEvidences200ResponseInnerErrorsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidences200ResponseInnerErrors
     */
    'widthMillis'?: GetPaymentRequestEvidences200ResponseInnerErrorsWidthMillisEnum;
}

export const GetPaymentRequestEvidences200ResponseInnerErrorsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetPaymentRequestEvidences200ResponseInnerErrorsDetectedDpiEnum = typeof GetPaymentRequestEvidences200ResponseInnerErrorsDetectedDpiEnum[keyof typeof GetPaymentRequestEvidences200ResponseInnerErrorsDetectedDpiEnum];
export const GetPaymentRequestEvidences200ResponseInnerErrorsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetPaymentRequestEvidences200ResponseInnerErrorsCalculatedDpiEnum = typeof GetPaymentRequestEvidences200ResponseInnerErrorsCalculatedDpiEnum[keyof typeof GetPaymentRequestEvidences200ResponseInnerErrorsCalculatedDpiEnum];
export const GetPaymentRequestEvidences200ResponseInnerErrorsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type GetPaymentRequestEvidences200ResponseInnerErrorsColorGradationEnum = typeof GetPaymentRequestEvidences200ResponseInnerErrorsColorGradationEnum[keyof typeof GetPaymentRequestEvidences200ResponseInnerErrorsColorGradationEnum];
export const GetPaymentRequestEvidences200ResponseInnerErrorsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetPaymentRequestEvidences200ResponseInnerErrorsHeightMillisEnum = typeof GetPaymentRequestEvidences200ResponseInnerErrorsHeightMillisEnum[keyof typeof GetPaymentRequestEvidences200ResponseInnerErrorsHeightMillisEnum];
export const GetPaymentRequestEvidences200ResponseInnerErrorsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetPaymentRequestEvidences200ResponseInnerErrorsWidthMillisEnum = typeof GetPaymentRequestEvidences200ResponseInnerErrorsWidthMillisEnum[keyof typeof GetPaymentRequestEvidences200ResponseInnerErrorsWidthMillisEnum];

/**
 * 
 * @export
 * @interface GetPaymentRequestEvidences200ResponseInnerFile
 */
export interface GetPaymentRequestEvidences200ResponseInnerFile {
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidences200ResponseInnerFile
     */
    'id': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidences200ResponseInnerFile
     */
    'name': string;
    /**
     * A URL with expiration date-time accessible from the front-end. This is not fully supported yet. In responses from certain endpoints, the url is set to null.
     * @type {string}
     * @memberof GetPaymentRequestEvidences200ResponseInnerFile
     */
    'url': string | null;
}
/**
 * Set null if it\'s evidence not analyzed using invoicing-system-compliance feature. Also set null if invoicing-system-compliance feature has been made not available for the organization by the feature-flag.
 * @export
 * @interface GetPaymentRequestEvidences200ResponseInnerInvoiceIssuer
 */
export interface GetPaymentRequestEvidences200ResponseInnerInvoiceIssuer {
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidences200ResponseInnerInvoiceIssuer
     */
    'name': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidences200ResponseInnerInvoiceIssuer
     */
    'registrationNumber': string | null;
    /**
     * isQualified retains the result of querying the 国税庁API to see if registrationNumber is qualified, as is.
     * @type {boolean}
     * @memberof GetPaymentRequestEvidences200ResponseInnerInvoiceIssuer
     */
    'isQualified': boolean;
    /**
     * AsQualified indicates whether this issuer should be treated as a qualified invoice issuer within the user\'s system, even if the RegistrationNumber is not confirmed as qualified in the National Tax Agency\'s business registration system.
     * @type {boolean}
     * @memberof GetPaymentRequestEvidences200ResponseInnerInvoiceIssuer
     */
    'asQualified': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidences200ResponseInnerInvoiceIssuer
     */
    'partnerId': string | null;
}
/**
 * 
 * @export
 * @interface GetPaymentRequestEvidences200ResponseInnerUpdatedBy
 */
export interface GetPaymentRequestEvidences200ResponseInnerUpdatedBy {
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidences200ResponseInnerUpdatedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidences200ResponseInnerUpdatedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetPaymentRequestEvidences200ResponseInnerUploadedBy
 */
export interface GetPaymentRequestEvidences200ResponseInnerUploadedBy {
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidences200ResponseInnerUploadedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidences200ResponseInnerUploadedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetPaymentRequestEvidences200ResponseInnerWarnings
 */
export interface GetPaymentRequestEvidences200ResponseInnerWarnings {
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidences200ResponseInnerWarnings
     */
    'detectedDpi'?: GetPaymentRequestEvidences200ResponseInnerWarningsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidences200ResponseInnerWarnings
     */
    'calculatedDpi'?: GetPaymentRequestEvidences200ResponseInnerWarningsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidences200ResponseInnerWarnings
     */
    'colorGradation'?: GetPaymentRequestEvidences200ResponseInnerWarningsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidences200ResponseInnerWarnings
     */
    'heightMillis'?: GetPaymentRequestEvidences200ResponseInnerWarningsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidences200ResponseInnerWarnings
     */
    'widthMillis'?: GetPaymentRequestEvidences200ResponseInnerWarningsWidthMillisEnum;
}

export const GetPaymentRequestEvidences200ResponseInnerWarningsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetPaymentRequestEvidences200ResponseInnerWarningsDetectedDpiEnum = typeof GetPaymentRequestEvidences200ResponseInnerWarningsDetectedDpiEnum[keyof typeof GetPaymentRequestEvidences200ResponseInnerWarningsDetectedDpiEnum];
export const GetPaymentRequestEvidences200ResponseInnerWarningsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetPaymentRequestEvidences200ResponseInnerWarningsCalculatedDpiEnum = typeof GetPaymentRequestEvidences200ResponseInnerWarningsCalculatedDpiEnum[keyof typeof GetPaymentRequestEvidences200ResponseInnerWarningsCalculatedDpiEnum];
export const GetPaymentRequestEvidences200ResponseInnerWarningsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type GetPaymentRequestEvidences200ResponseInnerWarningsColorGradationEnum = typeof GetPaymentRequestEvidences200ResponseInnerWarningsColorGradationEnum[keyof typeof GetPaymentRequestEvidences200ResponseInnerWarningsColorGradationEnum];
export const GetPaymentRequestEvidences200ResponseInnerWarningsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetPaymentRequestEvidences200ResponseInnerWarningsHeightMillisEnum = typeof GetPaymentRequestEvidences200ResponseInnerWarningsHeightMillisEnum[keyof typeof GetPaymentRequestEvidences200ResponseInnerWarningsHeightMillisEnum];
export const GetPaymentRequestEvidences200ResponseInnerWarningsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetPaymentRequestEvidences200ResponseInnerWarningsWidthMillisEnum = typeof GetPaymentRequestEvidences200ResponseInnerWarningsWidthMillisEnum[keyof typeof GetPaymentRequestEvidences200ResponseInnerWarningsWidthMillisEnum];

/**
 * BankAccount with TransferFeeCondition
 * @export
 * @interface GetPaymentRequestsBankAccountsList200ResponseInner
 */
export interface GetPaymentRequestsBankAccountsList200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestsBankAccountsList200ResponseInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestsBankAccountsList200ResponseInner
     */
    'recordId': string;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestsBankAccountsList200ResponseInner
     */
    'bankNumber': string;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestsBankAccountsList200ResponseInner
     */
    'bankName': string;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestsBankAccountsList200ResponseInner
     */
    'branchNumber': string;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestsBankAccountsList200ResponseInner
     */
    'branchName': string;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestsBankAccountsList200ResponseInner
     */
    'accountType': GetPaymentRequestsBankAccountsList200ResponseInnerAccountTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestsBankAccountsList200ResponseInner
     */
    'accountNumber': string;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestsBankAccountsList200ResponseInner
     */
    'companyCode': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestsBankAccountsList200ResponseInner
     */
    'companyName': string;
    /**
     * 
     * @type {GetPaymentRequestsBankAccountsList200ResponseInnerTransferFeeCondition}
     * @memberof GetPaymentRequestsBankAccountsList200ResponseInner
     */
    'transferFeeCondition': GetPaymentRequestsBankAccountsList200ResponseInnerTransferFeeCondition;
}

export const GetPaymentRequestsBankAccountsList200ResponseInnerAccountTypeEnum = {
    savingsAccount: 'SAVINGS_ACCOUNT',
    currentAccount: 'CURRENT_ACCOUNT',
    other: 'OTHER'
} as const;

export type GetPaymentRequestsBankAccountsList200ResponseInnerAccountTypeEnum = typeof GetPaymentRequestsBankAccountsList200ResponseInnerAccountTypeEnum[keyof typeof GetPaymentRequestsBankAccountsList200ResponseInnerAccountTypeEnum];

/**
 * 
 * @export
 * @interface GetPaymentRequestsBankAccountsList200ResponseInnerTransferFeeCondition
 */
export interface GetPaymentRequestsBankAccountsList200ResponseInnerTransferFeeCondition {
    /**
     * 
     * @type {number}
     * @memberof GetPaymentRequestsBankAccountsList200ResponseInnerTransferFeeCondition
     */
    'threshold': number | null;
    /**
     * 
     * @type {GetPaymentRequestsBankAccountsList200ResponseInnerTransferFeeConditionSameBranch}
     * @memberof GetPaymentRequestsBankAccountsList200ResponseInnerTransferFeeCondition
     */
    'sameBranch': GetPaymentRequestsBankAccountsList200ResponseInnerTransferFeeConditionSameBranch | null;
    /**
     * 
     * @type {GetPaymentRequestsBankAccountsList200ResponseInnerTransferFeeConditionOtherBranch}
     * @memberof GetPaymentRequestsBankAccountsList200ResponseInnerTransferFeeCondition
     */
    'otherBranch': GetPaymentRequestsBankAccountsList200ResponseInnerTransferFeeConditionOtherBranch | null;
    /**
     * 
     * @type {GetPaymentRequestsBankAccountsList200ResponseInnerTransferFeeConditionOtherBank}
     * @memberof GetPaymentRequestsBankAccountsList200ResponseInnerTransferFeeCondition
     */
    'otherBank': GetPaymentRequestsBankAccountsList200ResponseInnerTransferFeeConditionOtherBank | null;
}
/**
 * If the corresponding transferFeeCondition.threshold is specified, null is not allowed, otherwise only null is allowed.
 * @export
 * @interface GetPaymentRequestsBankAccountsList200ResponseInnerTransferFeeConditionOtherBank
 */
export interface GetPaymentRequestsBankAccountsList200ResponseInnerTransferFeeConditionOtherBank {
    /**
     * 
     * @type {number}
     * @memberof GetPaymentRequestsBankAccountsList200ResponseInnerTransferFeeConditionOtherBank
     */
    'atLeast': number;
    /**
     * 
     * @type {number}
     * @memberof GetPaymentRequestsBankAccountsList200ResponseInnerTransferFeeConditionOtherBank
     */
    'lessThan': number;
}
/**
 * If the corresponding transferFeeCondition.threshold is specified, null is not allowed, otherwise only null is allowed.
 * @export
 * @interface GetPaymentRequestsBankAccountsList200ResponseInnerTransferFeeConditionOtherBranch
 */
export interface GetPaymentRequestsBankAccountsList200ResponseInnerTransferFeeConditionOtherBranch {
    /**
     * 
     * @type {number}
     * @memberof GetPaymentRequestsBankAccountsList200ResponseInnerTransferFeeConditionOtherBranch
     */
    'atLeast': number;
    /**
     * 
     * @type {number}
     * @memberof GetPaymentRequestsBankAccountsList200ResponseInnerTransferFeeConditionOtherBranch
     */
    'lessThan': number;
}
/**
 * If the corresponding transferFeeCondition.threshold is specified, null is not allowed, otherwise only null is allowed.
 * @export
 * @interface GetPaymentRequestsBankAccountsList200ResponseInnerTransferFeeConditionSameBranch
 */
export interface GetPaymentRequestsBankAccountsList200ResponseInnerTransferFeeConditionSameBranch {
    /**
     * 
     * @type {number}
     * @memberof GetPaymentRequestsBankAccountsList200ResponseInnerTransferFeeConditionSameBranch
     */
    'atLeast': number;
    /**
     * 
     * @type {number}
     * @memberof GetPaymentRequestsBankAccountsList200ResponseInnerTransferFeeConditionSameBranch
     */
    'lessThan': number;
}
/**
 * 
 * @export
 * @interface GetPinretrieverDecryptPinBlock200Response
 */
export interface GetPinretrieverDecryptPinBlock200Response {
    /**
     * 
     * @type {Array<number>}
     * @memberof GetPinretrieverDecryptPinBlock200Response
     */
    'pinBlock': Array<number>;
}
/**
 * 
 * @export
 * @interface GetPinretrieverDecryptPinBlockRequest
 */
export interface GetPinretrieverDecryptPinBlockRequest {
    /**
     * 
     * @type {string}
     * @memberof GetPinretrieverDecryptPinBlockRequest
     */
    'cardId': string;
    /**
     * 
     * @type {Array<number>}
     * @memberof GetPinretrieverDecryptPinBlockRequest
     */
    'pinBlock': Array<number>;
}
/**
 * 
 * @export
 * @interface GetPinretrieverEncryptPin200Response
 */
export interface GetPinretrieverEncryptPin200Response {
    /**
     * 
     * @type {Array<number>}
     * @memberof GetPinretrieverEncryptPin200Response
     */
    'encryptedPin': Array<number>;
}
/**
 * 
 * @export
 * @interface GetPinretrieverEncryptPinRequest
 */
export interface GetPinretrieverEncryptPinRequest {
    /**
     * 
     * @type {string}
     * @memberof GetPinretrieverEncryptPinRequest
     */
    'cardId': string;
    /**
     * 
     * @type {string}
     * @memberof GetPinretrieverEncryptPinRequest
     */
    'clientZpk': string;
}
/**
 * 
 * @export
 * @interface GetPinretrieverHsmPublickey200Response
 */
export interface GetPinretrieverHsmPublickey200Response {
    /**
     * 
     * @type {string}
     * @memberof GetPinretrieverHsmPublickey200Response
     */
    'hsmPublicKey': string;
}
/**
 * 
 * @export
 * @interface GetPurchaseApplication200Response
 */
export interface GetPurchaseApplication200Response {
    /**
     * 
     * @type {GetPurchaseApplication200ResponseApplication}
     * @memberof GetPurchaseApplication200Response
     */
    'application': GetPurchaseApplication200ResponseApplication;
    /**
     * 
     * @type {Array<GetPurchaseApplication200ResponseAttachmentsInner>}
     * @memberof GetPurchaseApplication200Response
     */
    'attachments': Array<GetPurchaseApplication200ResponseAttachmentsInner>;
    /**
     * 
     * @type {Array<GetPurchaseApplication200ResponseLinkedCardTransactionsInner>}
     * @memberof GetPurchaseApplication200Response
     */
    'linkedCardTransactions': Array<GetPurchaseApplication200ResponseLinkedCardTransactionsInner>;
}
/**
 * 
 * @export
 * @interface GetPurchaseApplication200ResponseApplication
 */
export interface GetPurchaseApplication200ResponseApplication {
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplication200ResponseApplication
     */
    'applicationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplication200ResponseApplication
     */
    'applicationNumber': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplication200ResponseApplication
     */
    'paymentDate': string;
    /**
     * 
     * @type {GetPurchaseApplication200ResponseApplicationSubmittedBy}
     * @memberof GetPurchaseApplication200ResponseApplication
     */
    'submittedBy': GetPurchaseApplication200ResponseApplicationSubmittedBy;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplication200ResponseApplication
     */
    'submittedAt': string;
    /**
     * 
     * @type {Array<GetPurchaseApplication200ResponseApplicationApproversInner>}
     * @memberof GetPurchaseApplication200ResponseApplication
     */
    'approvers': Array<GetPurchaseApplication200ResponseApplicationApproversInner>;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplication200ResponseApplication
     */
    'department': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplication200ResponseApplication
     */
    'purchaseReason': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplication200ResponseApplication
     */
    'purchaseDetails': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplication200ResponseApplication
     */
    'placeOfUse': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplication200ResponseApplication
     */
    'purposeOfUse': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplication200ResponseApplication
     */
    'url': string;
    /**
     * 
     * @type {number}
     * @memberof GetPurchaseApplication200ResponseApplication
     */
    'amount': number;
    /**
     * 
     * @type {GetPurchaseApplication200ResponseApplicationUserAccount}
     * @memberof GetPurchaseApplication200ResponseApplication
     */
    'userAccount': GetPurchaseApplication200ResponseApplicationUserAccount | null;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplication200ResponseApplication
     */
    'remarks': string;
    /**
     * 
     * @type {GetPurchaseApplication200ResponseApplicationWorkRequestedBy}
     * @memberof GetPurchaseApplication200ResponseApplication
     */
    'workRequestedBy': GetPurchaseApplication200ResponseApplicationWorkRequestedBy;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplication200ResponseApplication
     */
    'workRequestApprovers': string;
    /**
     * 
     * @type {GetPurchaseApplication200ResponseApplicationStatus}
     * @memberof GetPurchaseApplication200ResponseApplication
     */
    'status': GetPurchaseApplication200ResponseApplicationStatus;
    /**
     * 
     * @type {GetPurchaseApplication200ResponseApplicationCreatedBy}
     * @memberof GetPurchaseApplication200ResponseApplication
     */
    'createdBy': GetPurchaseApplication200ResponseApplicationCreatedBy;
}
/**
 * 
 * @export
 * @interface GetPurchaseApplication200ResponseApplicationApproversInner
 */
export interface GetPurchaseApplication200ResponseApplicationApproversInner {
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplication200ResponseApplicationApproversInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplication200ResponseApplicationApproversInner
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetPurchaseApplication200ResponseApplicationCreatedBy
 */
export interface GetPurchaseApplication200ResponseApplicationCreatedBy {
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplication200ResponseApplicationCreatedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplication200ResponseApplicationCreatedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetPurchaseApplication200ResponseApplicationStatus
 */
export interface GetPurchaseApplication200ResponseApplicationStatus {
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplication200ResponseApplicationStatus
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplication200ResponseApplicationStatus
     */
    'comment': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplication200ResponseApplicationStatus
     */
    'statusChangedAt': string;
    /**
     * 
     * @type {GetPurchaseApplication200ResponseApplicationStatusCreatedBy}
     * @memberof GetPurchaseApplication200ResponseApplicationStatus
     */
    'createdBy': GetPurchaseApplication200ResponseApplicationStatusCreatedBy;
}
/**
 * 
 * @export
 * @interface GetPurchaseApplication200ResponseApplicationStatusCreatedBy
 */
export interface GetPurchaseApplication200ResponseApplicationStatusCreatedBy {
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplication200ResponseApplicationStatusCreatedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplication200ResponseApplicationStatusCreatedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetPurchaseApplication200ResponseApplicationSubmittedBy
 */
export interface GetPurchaseApplication200ResponseApplicationSubmittedBy {
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplication200ResponseApplicationSubmittedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplication200ResponseApplicationSubmittedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetPurchaseApplication200ResponseApplicationUserAccount
 */
export interface GetPurchaseApplication200ResponseApplicationUserAccount {
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplication200ResponseApplicationUserAccount
     */
    'userAccountId': string;
    /**
     * 
     * @type {GetPurchaseApplication200ResponseApplicationUserAccountUser}
     * @memberof GetPurchaseApplication200ResponseApplicationUserAccount
     */
    'user': GetPurchaseApplication200ResponseApplicationUserAccountUser;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplication200ResponseApplicationUserAccount
     */
    'cardLabel': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplication200ResponseApplicationUserAccount
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplication200ResponseApplicationUserAccount
     */
    'organizationName': string;
    /**
     * 
     * @type {GetPurchaseApplication200ResponseApplicationUserAccountUserAccountGroup}
     * @memberof GetPurchaseApplication200ResponseApplicationUserAccount
     */
    'userAccountGroup': GetPurchaseApplication200ResponseApplicationUserAccountUserAccountGroup | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetPurchaseApplication200ResponseApplicationUserAccount
     */
    'isOnDemand': boolean;
}
/**
 * 
 * @export
 * @interface GetPurchaseApplication200ResponseApplicationUserAccountUser
 */
export interface GetPurchaseApplication200ResponseApplicationUserAccountUser {
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplication200ResponseApplicationUserAccountUser
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplication200ResponseApplicationUserAccountUser
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplication200ResponseApplicationUserAccountUser
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplication200ResponseApplicationUserAccountUser
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplication200ResponseApplicationUserAccountUser
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetPurchaseApplication200ResponseApplicationUserAccountUser
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetPurchaseApplication200ResponseApplicationUserAccountUser
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetPurchaseApplication200ResponseApplicationUserAccountUser
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetPurchaseApplication200ResponseApplicationUserAccountUser
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetPurchaseApplication200ResponseApplicationUserAccountUser
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplication200ResponseApplicationUserAccountUser
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface GetPurchaseApplication200ResponseApplicationUserAccountUserAccountGroup
 */
export interface GetPurchaseApplication200ResponseApplicationUserAccountUserAccountGroup {
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplication200ResponseApplicationUserAccountUserAccountGroup
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplication200ResponseApplicationUserAccountUserAccountGroup
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof GetPurchaseApplication200ResponseApplicationUserAccountUserAccountGroup
     */
    'sortNum': number;
}
/**
 * 
 * @export
 * @interface GetPurchaseApplication200ResponseApplicationWorkRequestedBy
 */
export interface GetPurchaseApplication200ResponseApplicationWorkRequestedBy {
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplication200ResponseApplicationWorkRequestedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplication200ResponseApplicationWorkRequestedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetPurchaseApplication200ResponseAttachmentsInner
 */
export interface GetPurchaseApplication200ResponseAttachmentsInner {
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplication200ResponseAttachmentsInner
     */
    'attachmentId': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplication200ResponseAttachmentsInner
     */
    'fileName': string;
}
/**
 * 
 * @export
 * @interface GetPurchaseApplication200ResponseLinkedCardTransactionsInner
 */
export interface GetPurchaseApplication200ResponseLinkedCardTransactionsInner {
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplication200ResponseLinkedCardTransactionsInner
     */
    'visaTransactionReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplication200ResponseLinkedCardTransactionsInner
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetPurchaseApplication200ResponseLinkedCardTransactionsInner
     */
    'canUnlink': boolean;
}
/**
 * 
 * @export
 * @interface GetPurchaseApplicationTemplates200ResponseInner
 */
export interface GetPurchaseApplicationTemplates200ResponseInner {
    /**
     * 
     * @type {GetPurchaseApplicationTemplates200ResponseInnerTemplateOverview}
     * @memberof GetPurchaseApplicationTemplates200ResponseInner
     */
    'templateOverview': GetPurchaseApplicationTemplates200ResponseInnerTemplateOverview;
}
/**
 * 
 * @export
 * @interface GetPurchaseApplicationTemplates200ResponseInnerTemplateOverview
 */
export interface GetPurchaseApplicationTemplates200ResponseInnerTemplateOverview {
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplates200ResponseInnerTemplateOverview
     */
    'purchaseTemplateNumber': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplates200ResponseInnerTemplateOverview
     */
    'templateId': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplates200ResponseInnerTemplateOverview
     */
    'templateName': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplates200ResponseInnerTemplateOverview
     */
    'scopeDisclosure': GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewScopeDisclosureEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplates200ResponseInnerTemplateOverview
     */
    'templateCategory': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplates200ResponseInnerTemplateOverview
     */
    'templateDetail': string;
    /**
     * 
     * @type {GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewSubmittedBy}
     * @memberof GetPurchaseApplicationTemplates200ResponseInnerTemplateOverview
     */
    'submittedBy': GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewSubmittedBy;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplates200ResponseInnerTemplateOverview
     */
    'submittedAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplates200ResponseInnerTemplateOverview
     */
    'department': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplates200ResponseInnerTemplateOverview
     */
    'purchaseReason': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplates200ResponseInnerTemplateOverview
     */
    'purchaseDetails': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplates200ResponseInnerTemplateOverview
     */
    'placeOfUse': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplates200ResponseInnerTemplateOverview
     */
    'purposeOfUse': GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewPurposeOfUseEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplates200ResponseInnerTemplateOverview
     */
    'url': string;
    /**
     * 
     * @type {number}
     * @memberof GetPurchaseApplicationTemplates200ResponseInnerTemplateOverview
     */
    'amount': number | null;
    /**
     * 
     * @type {GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewUserAccount}
     * @memberof GetPurchaseApplicationTemplates200ResponseInnerTemplateOverview
     */
    'userAccount': GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewUserAccount | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetPurchaseApplicationTemplates200ResponseInnerTemplateOverview
     */
    'isOnDemandCard': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplates200ResponseInnerTemplateOverview
     */
    'remarks': string;
    /**
     * 
     * @type {GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewCreatedBy}
     * @memberof GetPurchaseApplicationTemplates200ResponseInnerTemplateOverview
     */
    'createdBy': GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewCreatedBy;
    /**
     * 
     * @type {Array<GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewApproversInner>}
     * @memberof GetPurchaseApplicationTemplates200ResponseInnerTemplateOverview
     */
    'approvers': Array<GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewApproversInner>;
}

export const GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewScopeDisclosureEnum = {
    public: 'PUBLIC',
    individual: 'INDIVIDUAL'
} as const;

export type GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewScopeDisclosureEnum = typeof GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewScopeDisclosureEnum[keyof typeof GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewScopeDisclosureEnum];
export const GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewPurposeOfUseEnum = {
    software: 'SOFTWARE',
    fixtures: 'FIXTURES',
    conference: 'CONFERENCE',
    entertainment: 'ENTERTAINMENT',
    travel: 'TRAVEL',
    other: 'OTHER',
    initialValue: 'INITIAL_VALUE'
} as const;

export type GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewPurposeOfUseEnum = typeof GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewPurposeOfUseEnum[keyof typeof GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewPurposeOfUseEnum];

/**
 * 
 * @export
 * @interface GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewApproversInner
 */
export interface GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewApproversInner {
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewApproversInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewApproversInner
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewApproversInner
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewApproversInner
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewApproversInner
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewApproversInner
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewApproversInner
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewApproversInner
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewApproversInner
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewApproversInner
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewApproversInner
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewCreatedBy
 */
export interface GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewCreatedBy {
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewCreatedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewCreatedBy
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewCreatedBy
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewCreatedBy
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewCreatedBy
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewCreatedBy
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewCreatedBy
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewCreatedBy
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewCreatedBy
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewCreatedBy
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewCreatedBy
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewSubmittedBy
 */
export interface GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewSubmittedBy {
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewSubmittedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewSubmittedBy
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewSubmittedBy
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewSubmittedBy
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewSubmittedBy
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewSubmittedBy
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewSubmittedBy
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewSubmittedBy
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewSubmittedBy
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewSubmittedBy
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewSubmittedBy
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewUserAccount
 */
export interface GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewUserAccount {
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewUserAccount
     */
    'userAccountId': string;
    /**
     * 
     * @type {GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewUserAccountUser}
     * @memberof GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewUserAccount
     */
    'user': GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewUserAccountUser;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewUserAccount
     */
    'cardLabel': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewUserAccount
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewUserAccount
     */
    'organizationName': string;
    /**
     * 
     * @type {GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewUserAccountUserAccountGroup}
     * @memberof GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewUserAccount
     */
    'userAccountGroup': GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewUserAccountUserAccountGroup | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewUserAccount
     */
    'isOnDemand': boolean;
}
/**
 * 
 * @export
 * @interface GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewUserAccountUser
 */
export interface GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewUserAccountUser {
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewUserAccountUser
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewUserAccountUser
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewUserAccountUser
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewUserAccountUser
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewUserAccountUser
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewUserAccountUser
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewUserAccountUser
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewUserAccountUser
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewUserAccountUser
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewUserAccountUser
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewUserAccountUser
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewUserAccountUserAccountGroup
 */
export interface GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewUserAccountUserAccountGroup {
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewUserAccountUserAccountGroup
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewUserAccountUserAccountGroup
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewUserAccountUserAccountGroup
     */
    'sortNum': number;
}
/**
 * 
 * @export
 * @interface GetPurchaseApplicationTemplatesDetail200Response
 */
export interface GetPurchaseApplicationTemplatesDetail200Response {
    /**
     * 
     * @type {GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverview}
     * @memberof GetPurchaseApplicationTemplatesDetail200Response
     */
    'templateOverview': GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverview;
}
/**
 * 
 * @export
 * @interface GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverview
 */
export interface GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverview {
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverview
     */
    'purchaseTemplateNumber': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverview
     */
    'templateId': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverview
     */
    'templateName': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverview
     */
    'scopeDisclosure': GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewScopeDisclosureEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverview
     */
    'templateCategory': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverview
     */
    'templateDetail': string;
    /**
     * 
     * @type {GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewSubmittedBy}
     * @memberof GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverview
     */
    'submittedBy': GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewSubmittedBy;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverview
     */
    'submittedAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverview
     */
    'department': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverview
     */
    'purchaseReason': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverview
     */
    'purchaseDetails': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverview
     */
    'placeOfUse': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverview
     */
    'purposeOfUse': GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewPurposeOfUseEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverview
     */
    'url': string;
    /**
     * 
     * @type {number}
     * @memberof GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverview
     */
    'amount': number | null;
    /**
     * 
     * @type {GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewUserAccount}
     * @memberof GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverview
     */
    'userAccount': GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewUserAccount | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverview
     */
    'isOnDemandCard': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverview
     */
    'remarks': string;
    /**
     * 
     * @type {GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewCreatedBy}
     * @memberof GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverview
     */
    'createdBy': GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewCreatedBy;
    /**
     * 
     * @type {Array<GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewApproversInner>}
     * @memberof GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverview
     */
    'approvers': Array<GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewApproversInner>;
}

export const GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewScopeDisclosureEnum = {
    public: 'PUBLIC',
    individual: 'INDIVIDUAL'
} as const;

export type GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewScopeDisclosureEnum = typeof GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewScopeDisclosureEnum[keyof typeof GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewScopeDisclosureEnum];
export const GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewPurposeOfUseEnum = {
    software: 'SOFTWARE',
    fixtures: 'FIXTURES',
    conference: 'CONFERENCE',
    entertainment: 'ENTERTAINMENT',
    travel: 'TRAVEL',
    other: 'OTHER',
    initialValue: 'INITIAL_VALUE'
} as const;

export type GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewPurposeOfUseEnum = typeof GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewPurposeOfUseEnum[keyof typeof GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewPurposeOfUseEnum];

/**
 * 
 * @export
 * @interface GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewApproversInner
 */
export interface GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewApproversInner {
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewApproversInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewApproversInner
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewApproversInner
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewApproversInner
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewApproversInner
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewApproversInner
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewApproversInner
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewApproversInner
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewApproversInner
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewApproversInner
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewApproversInner
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewCreatedBy
 */
export interface GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewCreatedBy {
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewCreatedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewCreatedBy
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewCreatedBy
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewCreatedBy
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewCreatedBy
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewCreatedBy
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewCreatedBy
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewCreatedBy
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewCreatedBy
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewCreatedBy
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewCreatedBy
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewSubmittedBy
 */
export interface GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewSubmittedBy {
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewSubmittedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewSubmittedBy
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewSubmittedBy
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewSubmittedBy
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewSubmittedBy
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewSubmittedBy
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewSubmittedBy
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewSubmittedBy
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewSubmittedBy
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewSubmittedBy
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewSubmittedBy
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewUserAccount
 */
export interface GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewUserAccount {
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewUserAccount
     */
    'userAccountId': string;
    /**
     * 
     * @type {GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewUserAccountUser}
     * @memberof GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewUserAccount
     */
    'user': GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewUserAccountUser;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewUserAccount
     */
    'cardLabel': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewUserAccount
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewUserAccount
     */
    'organizationName': string;
    /**
     * 
     * @type {GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewUserAccountUserAccountGroup}
     * @memberof GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewUserAccount
     */
    'userAccountGroup': GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewUserAccountUserAccountGroup | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewUserAccount
     */
    'isOnDemand': boolean;
}
/**
 * 
 * @export
 * @interface GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewUserAccountUser
 */
export interface GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewUserAccountUser {
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewUserAccountUser
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewUserAccountUser
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewUserAccountUser
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewUserAccountUser
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewUserAccountUser
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewUserAccountUser
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewUserAccountUser
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewUserAccountUser
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewUserAccountUser
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewUserAccountUser
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewUserAccountUser
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewUserAccountUserAccountGroup
 */
export interface GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewUserAccountUserAccountGroup {
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewUserAccountUserAccountGroup
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewUserAccountUserAccountGroup
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewUserAccountUserAccountGroup
     */
    'sortNum': number;
}
/**
 * @type GetPurchaseApplications200Response
 * @export
 */
export type GetPurchaseApplications200Response = Array<GetPurchaseApplications200ResponseOneOfInner1> | Array<GetPurchaseApplications200ResponseOneOfInner>;

/**
 * 
 * @export
 * @interface GetPurchaseApplications200ResponseOneOfInner
 */
export interface GetPurchaseApplications200ResponseOneOfInner {
    /**
     * 
     * @type {GetPurchaseApplications200ResponseOneOfInnerApplication}
     * @memberof GetPurchaseApplications200ResponseOneOfInner
     */
    'application': GetPurchaseApplications200ResponseOneOfInnerApplication;
    /**
     * 
     * @type {Array<GetPurchaseApplications200ResponseOneOfInnerAttachmentsInner>}
     * @memberof GetPurchaseApplications200ResponseOneOfInner
     */
    'attachments': Array<GetPurchaseApplications200ResponseOneOfInnerAttachmentsInner>;
    /**
     * 
     * @type {Array<GetPurchaseApplications200ResponseOneOfInnerLinkedCardTransactionsInner>}
     * @memberof GetPurchaseApplications200ResponseOneOfInner
     */
    'linkedCardTransactions': Array<GetPurchaseApplications200ResponseOneOfInnerLinkedCardTransactionsInner>;
}
/**
 * 
 * @export
 * @interface GetPurchaseApplications200ResponseOneOfInner1
 */
export interface GetPurchaseApplications200ResponseOneOfInner1 {
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplications200ResponseOneOfInner1
     */
    'applicationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplications200ResponseOneOfInner1
     */
    'applicationNumber': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplications200ResponseOneOfInner1
     */
    'paymentDate': string;
    /**
     * 
     * @type {GetPurchaseApplications200ResponseOneOfInner1SubmittedBy}
     * @memberof GetPurchaseApplications200ResponseOneOfInner1
     */
    'submittedBy': GetPurchaseApplications200ResponseOneOfInner1SubmittedBy;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplications200ResponseOneOfInner1
     */
    'submittedAt': string;
    /**
     * 
     * @type {Array<GetPurchaseApplications200ResponseOneOfInner1ApproversInner>}
     * @memberof GetPurchaseApplications200ResponseOneOfInner1
     */
    'approvers': Array<GetPurchaseApplications200ResponseOneOfInner1ApproversInner>;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplications200ResponseOneOfInner1
     */
    'department': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplications200ResponseOneOfInner1
     */
    'purchaseReason': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplications200ResponseOneOfInner1
     */
    'purchaseDetails': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplications200ResponseOneOfInner1
     */
    'placeOfUse': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplications200ResponseOneOfInner1
     */
    'purposeOfUse': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplications200ResponseOneOfInner1
     */
    'url': string;
    /**
     * 
     * @type {number}
     * @memberof GetPurchaseApplications200ResponseOneOfInner1
     */
    'amount': number;
    /**
     * 
     * @type {GetPurchaseApplications200ResponseOneOfInner1UserAccount}
     * @memberof GetPurchaseApplications200ResponseOneOfInner1
     */
    'userAccount': GetPurchaseApplications200ResponseOneOfInner1UserAccount | null;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplications200ResponseOneOfInner1
     */
    'remarks': string;
    /**
     * 
     * @type {GetPurchaseApplications200ResponseOneOfInner1WorkRequestedBy}
     * @memberof GetPurchaseApplications200ResponseOneOfInner1
     */
    'workRequestedBy': GetPurchaseApplications200ResponseOneOfInner1WorkRequestedBy;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplications200ResponseOneOfInner1
     */
    'workRequestApprovers': string;
    /**
     * 
     * @type {GetPurchaseApplications200ResponseOneOfInner1Status}
     * @memberof GetPurchaseApplications200ResponseOneOfInner1
     */
    'status': GetPurchaseApplications200ResponseOneOfInner1Status;
    /**
     * 
     * @type {GetPurchaseApplications200ResponseOneOfInner1CreatedBy}
     * @memberof GetPurchaseApplications200ResponseOneOfInner1
     */
    'createdBy': GetPurchaseApplications200ResponseOneOfInner1CreatedBy;
}
/**
 * 
 * @export
 * @interface GetPurchaseApplications200ResponseOneOfInner1ApproversInner
 */
export interface GetPurchaseApplications200ResponseOneOfInner1ApproversInner {
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplications200ResponseOneOfInner1ApproversInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplications200ResponseOneOfInner1ApproversInner
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetPurchaseApplications200ResponseOneOfInner1CreatedBy
 */
export interface GetPurchaseApplications200ResponseOneOfInner1CreatedBy {
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplications200ResponseOneOfInner1CreatedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplications200ResponseOneOfInner1CreatedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetPurchaseApplications200ResponseOneOfInner1Status
 */
export interface GetPurchaseApplications200ResponseOneOfInner1Status {
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplications200ResponseOneOfInner1Status
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplications200ResponseOneOfInner1Status
     */
    'comment': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplications200ResponseOneOfInner1Status
     */
    'statusChangedAt': string;
    /**
     * 
     * @type {GetPurchaseApplications200ResponseOneOfInner1StatusCreatedBy}
     * @memberof GetPurchaseApplications200ResponseOneOfInner1Status
     */
    'createdBy': GetPurchaseApplications200ResponseOneOfInner1StatusCreatedBy;
}
/**
 * 
 * @export
 * @interface GetPurchaseApplications200ResponseOneOfInner1StatusCreatedBy
 */
export interface GetPurchaseApplications200ResponseOneOfInner1StatusCreatedBy {
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplications200ResponseOneOfInner1StatusCreatedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplications200ResponseOneOfInner1StatusCreatedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetPurchaseApplications200ResponseOneOfInner1SubmittedBy
 */
export interface GetPurchaseApplications200ResponseOneOfInner1SubmittedBy {
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplications200ResponseOneOfInner1SubmittedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplications200ResponseOneOfInner1SubmittedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetPurchaseApplications200ResponseOneOfInner1UserAccount
 */
export interface GetPurchaseApplications200ResponseOneOfInner1UserAccount {
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplications200ResponseOneOfInner1UserAccount
     */
    'userAccountId': string;
    /**
     * 
     * @type {GetPurchaseApplications200ResponseOneOfInner1UserAccountUser}
     * @memberof GetPurchaseApplications200ResponseOneOfInner1UserAccount
     */
    'user': GetPurchaseApplications200ResponseOneOfInner1UserAccountUser;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplications200ResponseOneOfInner1UserAccount
     */
    'cardLabel': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplications200ResponseOneOfInner1UserAccount
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplications200ResponseOneOfInner1UserAccount
     */
    'organizationName': string;
    /**
     * 
     * @type {GetPurchaseApplications200ResponseOneOfInner1UserAccountUserAccountGroup}
     * @memberof GetPurchaseApplications200ResponseOneOfInner1UserAccount
     */
    'userAccountGroup': GetPurchaseApplications200ResponseOneOfInner1UserAccountUserAccountGroup | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetPurchaseApplications200ResponseOneOfInner1UserAccount
     */
    'isOnDemand': boolean;
}
/**
 * 
 * @export
 * @interface GetPurchaseApplications200ResponseOneOfInner1UserAccountUser
 */
export interface GetPurchaseApplications200ResponseOneOfInner1UserAccountUser {
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplications200ResponseOneOfInner1UserAccountUser
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplications200ResponseOneOfInner1UserAccountUser
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplications200ResponseOneOfInner1UserAccountUser
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplications200ResponseOneOfInner1UserAccountUser
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplications200ResponseOneOfInner1UserAccountUser
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetPurchaseApplications200ResponseOneOfInner1UserAccountUser
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetPurchaseApplications200ResponseOneOfInner1UserAccountUser
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetPurchaseApplications200ResponseOneOfInner1UserAccountUser
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetPurchaseApplications200ResponseOneOfInner1UserAccountUser
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetPurchaseApplications200ResponseOneOfInner1UserAccountUser
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplications200ResponseOneOfInner1UserAccountUser
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface GetPurchaseApplications200ResponseOneOfInner1UserAccountUserAccountGroup
 */
export interface GetPurchaseApplications200ResponseOneOfInner1UserAccountUserAccountGroup {
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplications200ResponseOneOfInner1UserAccountUserAccountGroup
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplications200ResponseOneOfInner1UserAccountUserAccountGroup
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof GetPurchaseApplications200ResponseOneOfInner1UserAccountUserAccountGroup
     */
    'sortNum': number;
}
/**
 * 
 * @export
 * @interface GetPurchaseApplications200ResponseOneOfInner1WorkRequestedBy
 */
export interface GetPurchaseApplications200ResponseOneOfInner1WorkRequestedBy {
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplications200ResponseOneOfInner1WorkRequestedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplications200ResponseOneOfInner1WorkRequestedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetPurchaseApplications200ResponseOneOfInnerApplication
 */
export interface GetPurchaseApplications200ResponseOneOfInnerApplication {
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplications200ResponseOneOfInnerApplication
     */
    'applicationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplications200ResponseOneOfInnerApplication
     */
    'applicationNumber': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplications200ResponseOneOfInnerApplication
     */
    'paymentDate': string;
    /**
     * 
     * @type {GetPurchaseApplications200ResponseOneOfInnerApplicationSubmittedBy}
     * @memberof GetPurchaseApplications200ResponseOneOfInnerApplication
     */
    'submittedBy': GetPurchaseApplications200ResponseOneOfInnerApplicationSubmittedBy;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplications200ResponseOneOfInnerApplication
     */
    'submittedAt': string;
    /**
     * 
     * @type {Array<GetPurchaseApplications200ResponseOneOfInnerApplicationApproversInner>}
     * @memberof GetPurchaseApplications200ResponseOneOfInnerApplication
     */
    'approvers': Array<GetPurchaseApplications200ResponseOneOfInnerApplicationApproversInner>;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplications200ResponseOneOfInnerApplication
     */
    'department': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplications200ResponseOneOfInnerApplication
     */
    'purchaseReason': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplications200ResponseOneOfInnerApplication
     */
    'purchaseDetails': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplications200ResponseOneOfInnerApplication
     */
    'placeOfUse': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplications200ResponseOneOfInnerApplication
     */
    'purposeOfUse': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplications200ResponseOneOfInnerApplication
     */
    'url': string;
    /**
     * 
     * @type {number}
     * @memberof GetPurchaseApplications200ResponseOneOfInnerApplication
     */
    'amount': number;
    /**
     * 
     * @type {GetPurchaseApplications200ResponseOneOfInnerApplicationUserAccount}
     * @memberof GetPurchaseApplications200ResponseOneOfInnerApplication
     */
    'userAccount': GetPurchaseApplications200ResponseOneOfInnerApplicationUserAccount | null;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplications200ResponseOneOfInnerApplication
     */
    'remarks': string;
    /**
     * 
     * @type {GetPurchaseApplications200ResponseOneOfInnerApplicationWorkRequestedBy}
     * @memberof GetPurchaseApplications200ResponseOneOfInnerApplication
     */
    'workRequestedBy': GetPurchaseApplications200ResponseOneOfInnerApplicationWorkRequestedBy;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplications200ResponseOneOfInnerApplication
     */
    'workRequestApprovers': string;
    /**
     * 
     * @type {GetPurchaseApplications200ResponseOneOfInnerApplicationStatus}
     * @memberof GetPurchaseApplications200ResponseOneOfInnerApplication
     */
    'status': GetPurchaseApplications200ResponseOneOfInnerApplicationStatus;
    /**
     * 
     * @type {GetPurchaseApplications200ResponseOneOfInnerApplicationCreatedBy}
     * @memberof GetPurchaseApplications200ResponseOneOfInnerApplication
     */
    'createdBy': GetPurchaseApplications200ResponseOneOfInnerApplicationCreatedBy;
}
/**
 * 
 * @export
 * @interface GetPurchaseApplications200ResponseOneOfInnerApplicationApproversInner
 */
export interface GetPurchaseApplications200ResponseOneOfInnerApplicationApproversInner {
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplications200ResponseOneOfInnerApplicationApproversInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplications200ResponseOneOfInnerApplicationApproversInner
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetPurchaseApplications200ResponseOneOfInnerApplicationCreatedBy
 */
export interface GetPurchaseApplications200ResponseOneOfInnerApplicationCreatedBy {
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplications200ResponseOneOfInnerApplicationCreatedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplications200ResponseOneOfInnerApplicationCreatedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetPurchaseApplications200ResponseOneOfInnerApplicationStatus
 */
export interface GetPurchaseApplications200ResponseOneOfInnerApplicationStatus {
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplications200ResponseOneOfInnerApplicationStatus
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplications200ResponseOneOfInnerApplicationStatus
     */
    'comment': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplications200ResponseOneOfInnerApplicationStatus
     */
    'statusChangedAt': string;
    /**
     * 
     * @type {GetPurchaseApplications200ResponseOneOfInnerApplicationStatusCreatedBy}
     * @memberof GetPurchaseApplications200ResponseOneOfInnerApplicationStatus
     */
    'createdBy': GetPurchaseApplications200ResponseOneOfInnerApplicationStatusCreatedBy;
}
/**
 * 
 * @export
 * @interface GetPurchaseApplications200ResponseOneOfInnerApplicationStatusCreatedBy
 */
export interface GetPurchaseApplications200ResponseOneOfInnerApplicationStatusCreatedBy {
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplications200ResponseOneOfInnerApplicationStatusCreatedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplications200ResponseOneOfInnerApplicationStatusCreatedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetPurchaseApplications200ResponseOneOfInnerApplicationSubmittedBy
 */
export interface GetPurchaseApplications200ResponseOneOfInnerApplicationSubmittedBy {
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplications200ResponseOneOfInnerApplicationSubmittedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplications200ResponseOneOfInnerApplicationSubmittedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetPurchaseApplications200ResponseOneOfInnerApplicationUserAccount
 */
export interface GetPurchaseApplications200ResponseOneOfInnerApplicationUserAccount {
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplications200ResponseOneOfInnerApplicationUserAccount
     */
    'userAccountId': string;
    /**
     * 
     * @type {GetPurchaseApplications200ResponseOneOfInnerApplicationUserAccountUser}
     * @memberof GetPurchaseApplications200ResponseOneOfInnerApplicationUserAccount
     */
    'user': GetPurchaseApplications200ResponseOneOfInnerApplicationUserAccountUser;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplications200ResponseOneOfInnerApplicationUserAccount
     */
    'cardLabel': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplications200ResponseOneOfInnerApplicationUserAccount
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplications200ResponseOneOfInnerApplicationUserAccount
     */
    'organizationName': string;
    /**
     * 
     * @type {GetPurchaseApplications200ResponseOneOfInnerApplicationUserAccountUserAccountGroup}
     * @memberof GetPurchaseApplications200ResponseOneOfInnerApplicationUserAccount
     */
    'userAccountGroup': GetPurchaseApplications200ResponseOneOfInnerApplicationUserAccountUserAccountGroup | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetPurchaseApplications200ResponseOneOfInnerApplicationUserAccount
     */
    'isOnDemand': boolean;
}
/**
 * 
 * @export
 * @interface GetPurchaseApplications200ResponseOneOfInnerApplicationUserAccountUser
 */
export interface GetPurchaseApplications200ResponseOneOfInnerApplicationUserAccountUser {
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplications200ResponseOneOfInnerApplicationUserAccountUser
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplications200ResponseOneOfInnerApplicationUserAccountUser
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplications200ResponseOneOfInnerApplicationUserAccountUser
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplications200ResponseOneOfInnerApplicationUserAccountUser
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplications200ResponseOneOfInnerApplicationUserAccountUser
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetPurchaseApplications200ResponseOneOfInnerApplicationUserAccountUser
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetPurchaseApplications200ResponseOneOfInnerApplicationUserAccountUser
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetPurchaseApplications200ResponseOneOfInnerApplicationUserAccountUser
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetPurchaseApplications200ResponseOneOfInnerApplicationUserAccountUser
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetPurchaseApplications200ResponseOneOfInnerApplicationUserAccountUser
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplications200ResponseOneOfInnerApplicationUserAccountUser
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface GetPurchaseApplications200ResponseOneOfInnerApplicationUserAccountUserAccountGroup
 */
export interface GetPurchaseApplications200ResponseOneOfInnerApplicationUserAccountUserAccountGroup {
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplications200ResponseOneOfInnerApplicationUserAccountUserAccountGroup
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplications200ResponseOneOfInnerApplicationUserAccountUserAccountGroup
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof GetPurchaseApplications200ResponseOneOfInnerApplicationUserAccountUserAccountGroup
     */
    'sortNum': number;
}
/**
 * 
 * @export
 * @interface GetPurchaseApplications200ResponseOneOfInnerApplicationWorkRequestedBy
 */
export interface GetPurchaseApplications200ResponseOneOfInnerApplicationWorkRequestedBy {
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplications200ResponseOneOfInnerApplicationWorkRequestedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplications200ResponseOneOfInnerApplicationWorkRequestedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetPurchaseApplications200ResponseOneOfInnerAttachmentsInner
 */
export interface GetPurchaseApplications200ResponseOneOfInnerAttachmentsInner {
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplications200ResponseOneOfInnerAttachmentsInner
     */
    'attachmentId': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplications200ResponseOneOfInnerAttachmentsInner
     */
    'fileName': string;
}
/**
 * 
 * @export
 * @interface GetPurchaseApplications200ResponseOneOfInnerLinkedCardTransactionsInner
 */
export interface GetPurchaseApplications200ResponseOneOfInnerLinkedCardTransactionsInner {
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplications200ResponseOneOfInnerLinkedCardTransactionsInner
     */
    'visaTransactionReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplications200ResponseOneOfInnerLinkedCardTransactionsInner
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetPurchaseApplications200ResponseOneOfInnerLinkedCardTransactionsInner
     */
    'canUnlink': boolean;
}
/**
 * 
 * @export
 * @interface GetPurchaseApplicationsRequestedCount200Response
 */
export interface GetPurchaseApplicationsRequestedCount200Response {
    /**
     * 
     * @type {number}
     * @memberof GetPurchaseApplicationsRequestedCount200Response
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface GetPurchaseApplicationsRequestedList200ResponseInner
 */
export interface GetPurchaseApplicationsRequestedList200ResponseInner {
    /**
     * 
     * @type {GetPurchaseApplicationsRequestedList200ResponseInnerApplication}
     * @memberof GetPurchaseApplicationsRequestedList200ResponseInner
     */
    'application': GetPurchaseApplicationsRequestedList200ResponseInnerApplication;
    /**
     * 
     * @type {Array<GetPurchaseApplicationsRequestedList200ResponseInnerAttachmentsInner>}
     * @memberof GetPurchaseApplicationsRequestedList200ResponseInner
     */
    'attachments': Array<GetPurchaseApplicationsRequestedList200ResponseInnerAttachmentsInner>;
    /**
     * 
     * @type {Array<GetPurchaseApplicationsRequestedList200ResponseInnerLinkedCardTransactionsInner>}
     * @memberof GetPurchaseApplicationsRequestedList200ResponseInner
     */
    'linkedCardTransactions': Array<GetPurchaseApplicationsRequestedList200ResponseInnerLinkedCardTransactionsInner>;
}
/**
 * 
 * @export
 * @interface GetPurchaseApplicationsRequestedList200ResponseInnerApplication
 */
export interface GetPurchaseApplicationsRequestedList200ResponseInnerApplication {
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationsRequestedList200ResponseInnerApplication
     */
    'applicationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationsRequestedList200ResponseInnerApplication
     */
    'applicationNumber': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationsRequestedList200ResponseInnerApplication
     */
    'paymentDate': string;
    /**
     * 
     * @type {GetPurchaseApplicationsRequestedList200ResponseInnerApplicationSubmittedBy}
     * @memberof GetPurchaseApplicationsRequestedList200ResponseInnerApplication
     */
    'submittedBy': GetPurchaseApplicationsRequestedList200ResponseInnerApplicationSubmittedBy;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationsRequestedList200ResponseInnerApplication
     */
    'submittedAt': string;
    /**
     * 
     * @type {Array<GetPurchaseApplicationsRequestedList200ResponseInnerApplicationApproversInner>}
     * @memberof GetPurchaseApplicationsRequestedList200ResponseInnerApplication
     */
    'approvers': Array<GetPurchaseApplicationsRequestedList200ResponseInnerApplicationApproversInner>;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationsRequestedList200ResponseInnerApplication
     */
    'department': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationsRequestedList200ResponseInnerApplication
     */
    'purchaseReason': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationsRequestedList200ResponseInnerApplication
     */
    'purchaseDetails': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationsRequestedList200ResponseInnerApplication
     */
    'placeOfUse': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationsRequestedList200ResponseInnerApplication
     */
    'purposeOfUse': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationsRequestedList200ResponseInnerApplication
     */
    'url': string;
    /**
     * 
     * @type {number}
     * @memberof GetPurchaseApplicationsRequestedList200ResponseInnerApplication
     */
    'amount': number;
    /**
     * 
     * @type {GetPurchaseApplicationsRequestedList200ResponseInnerApplicationUserAccount}
     * @memberof GetPurchaseApplicationsRequestedList200ResponseInnerApplication
     */
    'userAccount': GetPurchaseApplicationsRequestedList200ResponseInnerApplicationUserAccount | null;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationsRequestedList200ResponseInnerApplication
     */
    'remarks': string;
    /**
     * 
     * @type {GetPurchaseApplicationsRequestedList200ResponseInnerApplicationWorkRequestedBy}
     * @memberof GetPurchaseApplicationsRequestedList200ResponseInnerApplication
     */
    'workRequestedBy': GetPurchaseApplicationsRequestedList200ResponseInnerApplicationWorkRequestedBy;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationsRequestedList200ResponseInnerApplication
     */
    'workRequestApprovers': string;
    /**
     * 
     * @type {GetPurchaseApplicationsRequestedList200ResponseInnerApplicationStatus}
     * @memberof GetPurchaseApplicationsRequestedList200ResponseInnerApplication
     */
    'status': GetPurchaseApplicationsRequestedList200ResponseInnerApplicationStatus;
    /**
     * 
     * @type {GetPurchaseApplicationsRequestedList200ResponseInnerApplicationCreatedBy}
     * @memberof GetPurchaseApplicationsRequestedList200ResponseInnerApplication
     */
    'createdBy': GetPurchaseApplicationsRequestedList200ResponseInnerApplicationCreatedBy;
}
/**
 * 
 * @export
 * @interface GetPurchaseApplicationsRequestedList200ResponseInnerApplicationApproversInner
 */
export interface GetPurchaseApplicationsRequestedList200ResponseInnerApplicationApproversInner {
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationsRequestedList200ResponseInnerApplicationApproversInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationsRequestedList200ResponseInnerApplicationApproversInner
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetPurchaseApplicationsRequestedList200ResponseInnerApplicationCreatedBy
 */
export interface GetPurchaseApplicationsRequestedList200ResponseInnerApplicationCreatedBy {
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationsRequestedList200ResponseInnerApplicationCreatedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationsRequestedList200ResponseInnerApplicationCreatedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetPurchaseApplicationsRequestedList200ResponseInnerApplicationStatus
 */
export interface GetPurchaseApplicationsRequestedList200ResponseInnerApplicationStatus {
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationsRequestedList200ResponseInnerApplicationStatus
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationsRequestedList200ResponseInnerApplicationStatus
     */
    'comment': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationsRequestedList200ResponseInnerApplicationStatus
     */
    'statusChangedAt': string;
    /**
     * 
     * @type {GetPurchaseApplicationsRequestedList200ResponseInnerApplicationStatusCreatedBy}
     * @memberof GetPurchaseApplicationsRequestedList200ResponseInnerApplicationStatus
     */
    'createdBy': GetPurchaseApplicationsRequestedList200ResponseInnerApplicationStatusCreatedBy;
}
/**
 * 
 * @export
 * @interface GetPurchaseApplicationsRequestedList200ResponseInnerApplicationStatusCreatedBy
 */
export interface GetPurchaseApplicationsRequestedList200ResponseInnerApplicationStatusCreatedBy {
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationsRequestedList200ResponseInnerApplicationStatusCreatedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationsRequestedList200ResponseInnerApplicationStatusCreatedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetPurchaseApplicationsRequestedList200ResponseInnerApplicationSubmittedBy
 */
export interface GetPurchaseApplicationsRequestedList200ResponseInnerApplicationSubmittedBy {
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationsRequestedList200ResponseInnerApplicationSubmittedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationsRequestedList200ResponseInnerApplicationSubmittedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetPurchaseApplicationsRequestedList200ResponseInnerApplicationUserAccount
 */
export interface GetPurchaseApplicationsRequestedList200ResponseInnerApplicationUserAccount {
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationsRequestedList200ResponseInnerApplicationUserAccount
     */
    'userAccountId': string;
    /**
     * 
     * @type {GetPurchaseApplicationsRequestedList200ResponseInnerApplicationUserAccountUser}
     * @memberof GetPurchaseApplicationsRequestedList200ResponseInnerApplicationUserAccount
     */
    'user': GetPurchaseApplicationsRequestedList200ResponseInnerApplicationUserAccountUser;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationsRequestedList200ResponseInnerApplicationUserAccount
     */
    'cardLabel': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationsRequestedList200ResponseInnerApplicationUserAccount
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationsRequestedList200ResponseInnerApplicationUserAccount
     */
    'organizationName': string;
    /**
     * 
     * @type {GetPurchaseApplicationsRequestedList200ResponseInnerApplicationUserAccountUserAccountGroup}
     * @memberof GetPurchaseApplicationsRequestedList200ResponseInnerApplicationUserAccount
     */
    'userAccountGroup': GetPurchaseApplicationsRequestedList200ResponseInnerApplicationUserAccountUserAccountGroup | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetPurchaseApplicationsRequestedList200ResponseInnerApplicationUserAccount
     */
    'isOnDemand': boolean;
}
/**
 * 
 * @export
 * @interface GetPurchaseApplicationsRequestedList200ResponseInnerApplicationUserAccountUser
 */
export interface GetPurchaseApplicationsRequestedList200ResponseInnerApplicationUserAccountUser {
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationsRequestedList200ResponseInnerApplicationUserAccountUser
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationsRequestedList200ResponseInnerApplicationUserAccountUser
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationsRequestedList200ResponseInnerApplicationUserAccountUser
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationsRequestedList200ResponseInnerApplicationUserAccountUser
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationsRequestedList200ResponseInnerApplicationUserAccountUser
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetPurchaseApplicationsRequestedList200ResponseInnerApplicationUserAccountUser
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetPurchaseApplicationsRequestedList200ResponseInnerApplicationUserAccountUser
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetPurchaseApplicationsRequestedList200ResponseInnerApplicationUserAccountUser
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetPurchaseApplicationsRequestedList200ResponseInnerApplicationUserAccountUser
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetPurchaseApplicationsRequestedList200ResponseInnerApplicationUserAccountUser
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationsRequestedList200ResponseInnerApplicationUserAccountUser
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface GetPurchaseApplicationsRequestedList200ResponseInnerApplicationUserAccountUserAccountGroup
 */
export interface GetPurchaseApplicationsRequestedList200ResponseInnerApplicationUserAccountUserAccountGroup {
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationsRequestedList200ResponseInnerApplicationUserAccountUserAccountGroup
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationsRequestedList200ResponseInnerApplicationUserAccountUserAccountGroup
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof GetPurchaseApplicationsRequestedList200ResponseInnerApplicationUserAccountUserAccountGroup
     */
    'sortNum': number;
}
/**
 * 
 * @export
 * @interface GetPurchaseApplicationsRequestedList200ResponseInnerApplicationWorkRequestedBy
 */
export interface GetPurchaseApplicationsRequestedList200ResponseInnerApplicationWorkRequestedBy {
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationsRequestedList200ResponseInnerApplicationWorkRequestedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationsRequestedList200ResponseInnerApplicationWorkRequestedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetPurchaseApplicationsRequestedList200ResponseInnerAttachmentsInner
 */
export interface GetPurchaseApplicationsRequestedList200ResponseInnerAttachmentsInner {
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationsRequestedList200ResponseInnerAttachmentsInner
     */
    'attachmentId': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationsRequestedList200ResponseInnerAttachmentsInner
     */
    'fileName': string;
}
/**
 * 
 * @export
 * @interface GetPurchaseApplicationsRequestedList200ResponseInnerLinkedCardTransactionsInner
 */
export interface GetPurchaseApplicationsRequestedList200ResponseInnerLinkedCardTransactionsInner {
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationsRequestedList200ResponseInnerLinkedCardTransactionsInner
     */
    'visaTransactionReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationsRequestedList200ResponseInnerLinkedCardTransactionsInner
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetPurchaseApplicationsRequestedList200ResponseInnerLinkedCardTransactionsInner
     */
    'canUnlink': boolean;
}
/**
 * 
 * @export
 * @interface GetPurchaseApplicationsSubmittedSelf200ResponseInner
 */
export interface GetPurchaseApplicationsSubmittedSelf200ResponseInner {
    /**
     * 
     * @type {GetPurchaseApplicationsSubmittedSelf200ResponseInnerApplication}
     * @memberof GetPurchaseApplicationsSubmittedSelf200ResponseInner
     */
    'application': GetPurchaseApplicationsSubmittedSelf200ResponseInnerApplication;
    /**
     * 
     * @type {Array<GetPurchaseApplicationsSubmittedSelf200ResponseInnerAttachmentsInner>}
     * @memberof GetPurchaseApplicationsSubmittedSelf200ResponseInner
     */
    'attachments': Array<GetPurchaseApplicationsSubmittedSelf200ResponseInnerAttachmentsInner>;
    /**
     * 
     * @type {Array<GetPurchaseApplicationsSubmittedSelf200ResponseInnerLinkedCardTransactionsInner>}
     * @memberof GetPurchaseApplicationsSubmittedSelf200ResponseInner
     */
    'linkedCardTransactions': Array<GetPurchaseApplicationsSubmittedSelf200ResponseInnerLinkedCardTransactionsInner>;
}
/**
 * 
 * @export
 * @interface GetPurchaseApplicationsSubmittedSelf200ResponseInnerApplication
 */
export interface GetPurchaseApplicationsSubmittedSelf200ResponseInnerApplication {
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationsSubmittedSelf200ResponseInnerApplication
     */
    'applicationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationsSubmittedSelf200ResponseInnerApplication
     */
    'applicationNumber': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationsSubmittedSelf200ResponseInnerApplication
     */
    'paymentDate': string;
    /**
     * 
     * @type {GetPurchaseApplicationsSubmittedSelf200ResponseInnerApplicationSubmittedBy}
     * @memberof GetPurchaseApplicationsSubmittedSelf200ResponseInnerApplication
     */
    'submittedBy': GetPurchaseApplicationsSubmittedSelf200ResponseInnerApplicationSubmittedBy;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationsSubmittedSelf200ResponseInnerApplication
     */
    'submittedAt': string;
    /**
     * 
     * @type {Array<GetPurchaseApplicationsSubmittedSelf200ResponseInnerApplicationApproversInner>}
     * @memberof GetPurchaseApplicationsSubmittedSelf200ResponseInnerApplication
     */
    'approvers': Array<GetPurchaseApplicationsSubmittedSelf200ResponseInnerApplicationApproversInner>;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationsSubmittedSelf200ResponseInnerApplication
     */
    'department': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationsSubmittedSelf200ResponseInnerApplication
     */
    'purchaseReason': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationsSubmittedSelf200ResponseInnerApplication
     */
    'purchaseDetails': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationsSubmittedSelf200ResponseInnerApplication
     */
    'placeOfUse': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationsSubmittedSelf200ResponseInnerApplication
     */
    'purposeOfUse': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationsSubmittedSelf200ResponseInnerApplication
     */
    'url': string;
    /**
     * 
     * @type {number}
     * @memberof GetPurchaseApplicationsSubmittedSelf200ResponseInnerApplication
     */
    'amount': number;
    /**
     * 
     * @type {GetPurchaseApplicationsSubmittedSelf200ResponseInnerApplicationUserAccount}
     * @memberof GetPurchaseApplicationsSubmittedSelf200ResponseInnerApplication
     */
    'userAccount': GetPurchaseApplicationsSubmittedSelf200ResponseInnerApplicationUserAccount | null;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationsSubmittedSelf200ResponseInnerApplication
     */
    'remarks': string;
    /**
     * 
     * @type {GetPurchaseApplicationsSubmittedSelf200ResponseInnerApplicationWorkRequestedBy}
     * @memberof GetPurchaseApplicationsSubmittedSelf200ResponseInnerApplication
     */
    'workRequestedBy': GetPurchaseApplicationsSubmittedSelf200ResponseInnerApplicationWorkRequestedBy;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationsSubmittedSelf200ResponseInnerApplication
     */
    'workRequestApprovers': string;
    /**
     * 
     * @type {GetPurchaseApplicationsSubmittedSelf200ResponseInnerApplicationStatus}
     * @memberof GetPurchaseApplicationsSubmittedSelf200ResponseInnerApplication
     */
    'status': GetPurchaseApplicationsSubmittedSelf200ResponseInnerApplicationStatus;
    /**
     * 
     * @type {GetPurchaseApplicationsSubmittedSelf200ResponseInnerApplicationCreatedBy}
     * @memberof GetPurchaseApplicationsSubmittedSelf200ResponseInnerApplication
     */
    'createdBy': GetPurchaseApplicationsSubmittedSelf200ResponseInnerApplicationCreatedBy;
}
/**
 * 
 * @export
 * @interface GetPurchaseApplicationsSubmittedSelf200ResponseInnerApplicationApproversInner
 */
export interface GetPurchaseApplicationsSubmittedSelf200ResponseInnerApplicationApproversInner {
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationsSubmittedSelf200ResponseInnerApplicationApproversInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationsSubmittedSelf200ResponseInnerApplicationApproversInner
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetPurchaseApplicationsSubmittedSelf200ResponseInnerApplicationCreatedBy
 */
export interface GetPurchaseApplicationsSubmittedSelf200ResponseInnerApplicationCreatedBy {
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationsSubmittedSelf200ResponseInnerApplicationCreatedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationsSubmittedSelf200ResponseInnerApplicationCreatedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetPurchaseApplicationsSubmittedSelf200ResponseInnerApplicationStatus
 */
export interface GetPurchaseApplicationsSubmittedSelf200ResponseInnerApplicationStatus {
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationsSubmittedSelf200ResponseInnerApplicationStatus
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationsSubmittedSelf200ResponseInnerApplicationStatus
     */
    'comment': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationsSubmittedSelf200ResponseInnerApplicationStatus
     */
    'statusChangedAt': string;
    /**
     * 
     * @type {GetPurchaseApplicationsSubmittedSelf200ResponseInnerApplicationStatusCreatedBy}
     * @memberof GetPurchaseApplicationsSubmittedSelf200ResponseInnerApplicationStatus
     */
    'createdBy': GetPurchaseApplicationsSubmittedSelf200ResponseInnerApplicationStatusCreatedBy;
}
/**
 * 
 * @export
 * @interface GetPurchaseApplicationsSubmittedSelf200ResponseInnerApplicationStatusCreatedBy
 */
export interface GetPurchaseApplicationsSubmittedSelf200ResponseInnerApplicationStatusCreatedBy {
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationsSubmittedSelf200ResponseInnerApplicationStatusCreatedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationsSubmittedSelf200ResponseInnerApplicationStatusCreatedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetPurchaseApplicationsSubmittedSelf200ResponseInnerApplicationSubmittedBy
 */
export interface GetPurchaseApplicationsSubmittedSelf200ResponseInnerApplicationSubmittedBy {
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationsSubmittedSelf200ResponseInnerApplicationSubmittedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationsSubmittedSelf200ResponseInnerApplicationSubmittedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetPurchaseApplicationsSubmittedSelf200ResponseInnerApplicationUserAccount
 */
export interface GetPurchaseApplicationsSubmittedSelf200ResponseInnerApplicationUserAccount {
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationsSubmittedSelf200ResponseInnerApplicationUserAccount
     */
    'userAccountId': string;
    /**
     * 
     * @type {GetPurchaseApplicationsSubmittedSelf200ResponseInnerApplicationUserAccountUser}
     * @memberof GetPurchaseApplicationsSubmittedSelf200ResponseInnerApplicationUserAccount
     */
    'user': GetPurchaseApplicationsSubmittedSelf200ResponseInnerApplicationUserAccountUser;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationsSubmittedSelf200ResponseInnerApplicationUserAccount
     */
    'cardLabel': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationsSubmittedSelf200ResponseInnerApplicationUserAccount
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationsSubmittedSelf200ResponseInnerApplicationUserAccount
     */
    'organizationName': string;
    /**
     * 
     * @type {GetPurchaseApplicationsSubmittedSelf200ResponseInnerApplicationUserAccountUserAccountGroup}
     * @memberof GetPurchaseApplicationsSubmittedSelf200ResponseInnerApplicationUserAccount
     */
    'userAccountGroup': GetPurchaseApplicationsSubmittedSelf200ResponseInnerApplicationUserAccountUserAccountGroup | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetPurchaseApplicationsSubmittedSelf200ResponseInnerApplicationUserAccount
     */
    'isOnDemand': boolean;
}
/**
 * 
 * @export
 * @interface GetPurchaseApplicationsSubmittedSelf200ResponseInnerApplicationUserAccountUser
 */
export interface GetPurchaseApplicationsSubmittedSelf200ResponseInnerApplicationUserAccountUser {
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationsSubmittedSelf200ResponseInnerApplicationUserAccountUser
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationsSubmittedSelf200ResponseInnerApplicationUserAccountUser
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationsSubmittedSelf200ResponseInnerApplicationUserAccountUser
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationsSubmittedSelf200ResponseInnerApplicationUserAccountUser
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationsSubmittedSelf200ResponseInnerApplicationUserAccountUser
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetPurchaseApplicationsSubmittedSelf200ResponseInnerApplicationUserAccountUser
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetPurchaseApplicationsSubmittedSelf200ResponseInnerApplicationUserAccountUser
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetPurchaseApplicationsSubmittedSelf200ResponseInnerApplicationUserAccountUser
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetPurchaseApplicationsSubmittedSelf200ResponseInnerApplicationUserAccountUser
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetPurchaseApplicationsSubmittedSelf200ResponseInnerApplicationUserAccountUser
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationsSubmittedSelf200ResponseInnerApplicationUserAccountUser
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface GetPurchaseApplicationsSubmittedSelf200ResponseInnerApplicationUserAccountUserAccountGroup
 */
export interface GetPurchaseApplicationsSubmittedSelf200ResponseInnerApplicationUserAccountUserAccountGroup {
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationsSubmittedSelf200ResponseInnerApplicationUserAccountUserAccountGroup
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationsSubmittedSelf200ResponseInnerApplicationUserAccountUserAccountGroup
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof GetPurchaseApplicationsSubmittedSelf200ResponseInnerApplicationUserAccountUserAccountGroup
     */
    'sortNum': number;
}
/**
 * 
 * @export
 * @interface GetPurchaseApplicationsSubmittedSelf200ResponseInnerApplicationWorkRequestedBy
 */
export interface GetPurchaseApplicationsSubmittedSelf200ResponseInnerApplicationWorkRequestedBy {
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationsSubmittedSelf200ResponseInnerApplicationWorkRequestedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationsSubmittedSelf200ResponseInnerApplicationWorkRequestedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetPurchaseApplicationsSubmittedSelf200ResponseInnerAttachmentsInner
 */
export interface GetPurchaseApplicationsSubmittedSelf200ResponseInnerAttachmentsInner {
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationsSubmittedSelf200ResponseInnerAttachmentsInner
     */
    'attachmentId': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationsSubmittedSelf200ResponseInnerAttachmentsInner
     */
    'fileName': string;
}
/**
 * 
 * @export
 * @interface GetPurchaseApplicationsSubmittedSelf200ResponseInnerLinkedCardTransactionsInner
 */
export interface GetPurchaseApplicationsSubmittedSelf200ResponseInnerLinkedCardTransactionsInner {
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationsSubmittedSelf200ResponseInnerLinkedCardTransactionsInner
     */
    'visaTransactionReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationsSubmittedSelf200ResponseInnerLinkedCardTransactionsInner
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetPurchaseApplicationsSubmittedSelf200ResponseInnerLinkedCardTransactionsInner
     */
    'canUnlink': boolean;
}
/**
 * 
 * @export
 * @interface GetQualifiedInvoiceIssuer200Response
 */
export interface GetQualifiedInvoiceIssuer200Response {
    /**
     * 
     * @type {string}
     * @memberof GetQualifiedInvoiceIssuer200Response
     */
    'registrationNumber': string;
    /**
     * 
     * @type {string}
     * @memberof GetQualifiedInvoiceIssuer200Response
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetQualifiedInvoiceIssuer200Response
     */
    'kana': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetQualifiedInvoiceIssuer200Response
     */
    'isQualified': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetQualifiedInvoiceIssuer200Response
     */
    'registrationDate': string;
}
/**
 * 
 * @export
 * @interface GetRewardPointBalance200Response
 */
export interface GetRewardPointBalance200Response {
    /**
     * Current reward points balance
     * @type {number}
     * @memberof GetRewardPointBalance200Response
     */
    'amount': number;
}
/**
 * 
 * @export
 * @interface GetRewardPointTransactions200Response
 */
export interface GetRewardPointTransactions200Response {
    /**
     * 
     * @type {Array<GetRewardPointTransactions200ResponseTransactionsInner>}
     * @memberof GetRewardPointTransactions200Response
     */
    'transactions': Array<GetRewardPointTransactions200ResponseTransactionsInner>;
}
/**
 * 
 * @export
 * @interface GetRewardPointTransactions200ResponseTransactionsInner
 */
export interface GetRewardPointTransactions200ResponseTransactionsInner {
    /**
     * Description of the transaction
     * @type {string}
     * @memberof GetRewardPointTransactions200ResponseTransactionsInner
     */
    'id'?: string;
    /**
     * Number of points issued
     * @type {number}
     * @memberof GetRewardPointTransactions200ResponseTransactionsInner
     */
    'amount'?: number;
    /**
     * When the points were issued
     * @type {string}
     * @memberof GetRewardPointTransactions200ResponseTransactionsInner
     */
    'appliedAt'?: string;
    /**
     * When the points were executed
     * @type {string}
     * @memberof GetRewardPointTransactions200ResponseTransactionsInner
     */
    'executedAt'?: string;
    /**
     * Memo of the transaction
     * @type {string}
     * @memberof GetRewardPointTransactions200ResponseTransactionsInner
     */
    'memo'?: string;
    /**
     * Description of the transaction. While memo is given by the issuer, description is given by the system.
     * @type {string}
     * @memberof GetRewardPointTransactions200ResponseTransactionsInner
     */
    'description': string;
}
/**
 * 
 * @export
 * @interface GetRewards200ResponseInner
 */
export interface GetRewards200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetRewards200ResponseInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetRewards200ResponseInner
     */
    'logoFileName': string;
    /**
     * 
     * @type {string}
     * @memberof GetRewards200ResponseInner
     */
    'serviceName': string;
    /**
     * 
     * @type {string}
     * @memberof GetRewards200ResponseInner
     */
    'benefitsSummary': string;
    /**
     * 
     * @type {Array<Array<GetRewards200ResponseInnerServiceDescriptionsInnerInner>>}
     * @memberof GetRewards200ResponseInner
     */
    'serviceDescriptions': Array<Array<GetRewards200ResponseInnerServiceDescriptionsInnerInner>>;
    /**
     * 
     * @type {Array<GetRewards200ResponseInnerBenefitsInner>}
     * @memberof GetRewards200ResponseInner
     */
    'benefits': Array<GetRewards200ResponseInnerBenefitsInner>;
    /**
     * 
     * @type {Array<Array<GetRewards200ResponseInnerConditionsInnerInner>>}
     * @memberof GetRewards200ResponseInner
     */
    'conditions': Array<Array<GetRewards200ResponseInnerConditionsInnerInner>>;
    /**
     * 
     * @type {Array<Array<GetRewards200ResponseInnerNotesInnerInner>>}
     * @memberof GetRewards200ResponseInner
     */
    'notes': Array<Array<GetRewards200ResponseInnerNotesInnerInner>> | null;
    /**
     * 
     * @type {Array<Array<GetRewards200ResponseInnerApplicationMethodsInnerInner>>}
     * @memberof GetRewards200ResponseInner
     */
    'applicationMethods': Array<Array<GetRewards200ResponseInnerApplicationMethodsInnerInner>>;
}
/**
 * 
 * @export
 * @interface GetRewards200ResponseInnerApplicationMethodsInnerInner
 */
export interface GetRewards200ResponseInnerApplicationMethodsInnerInner {
    /**
     * 
     * @type {string}
     * @memberof GetRewards200ResponseInnerApplicationMethodsInnerInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetRewards200ResponseInnerApplicationMethodsInnerInner
     */
    'text': string;
    /**
     * 
     * @type {string}
     * @memberof GetRewards200ResponseInnerApplicationMethodsInnerInner
     */
    'url': string | null;
}
/**
 * 
 * @export
 * @interface GetRewards200ResponseInnerBenefitsInner
 */
export interface GetRewards200ResponseInnerBenefitsInner {
    /**
     * 
     * @type {Array<GetRewards200ResponseInnerBenefitsInnerContentsInner>}
     * @memberof GetRewards200ResponseInnerBenefitsInner
     */
    'contents': Array<GetRewards200ResponseInnerBenefitsInnerContentsInner>;
    /**
     * 
     * @type {Array<GetRewards200ResponseInnerBenefitsInnerBenefitCaptionsInner>}
     * @memberof GetRewards200ResponseInnerBenefitsInner
     */
    'benefitCaptions': Array<GetRewards200ResponseInnerBenefitsInnerBenefitCaptionsInner>;
}
/**
 * 
 * @export
 * @interface GetRewards200ResponseInnerBenefitsInnerBenefitCaptionsInner
 */
export interface GetRewards200ResponseInnerBenefitsInnerBenefitCaptionsInner {
    /**
     * 
     * @type {string}
     * @memberof GetRewards200ResponseInnerBenefitsInnerBenefitCaptionsInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetRewards200ResponseInnerBenefitsInnerBenefitCaptionsInner
     */
    'text': string;
    /**
     * 
     * @type {string}
     * @memberof GetRewards200ResponseInnerBenefitsInnerBenefitCaptionsInner
     */
    'url': string | null;
}
/**
 * 
 * @export
 * @interface GetRewards200ResponseInnerBenefitsInnerContentsInner
 */
export interface GetRewards200ResponseInnerBenefitsInnerContentsInner {
    /**
     * 
     * @type {string}
     * @memberof GetRewards200ResponseInnerBenefitsInnerContentsInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetRewards200ResponseInnerBenefitsInnerContentsInner
     */
    'text': string;
    /**
     * 
     * @type {string}
     * @memberof GetRewards200ResponseInnerBenefitsInnerContentsInner
     */
    'url': string | null;
}
/**
 * 
 * @export
 * @interface GetRewards200ResponseInnerConditionsInnerInner
 */
export interface GetRewards200ResponseInnerConditionsInnerInner {
    /**
     * 
     * @type {string}
     * @memberof GetRewards200ResponseInnerConditionsInnerInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetRewards200ResponseInnerConditionsInnerInner
     */
    'text': string;
    /**
     * 
     * @type {string}
     * @memberof GetRewards200ResponseInnerConditionsInnerInner
     */
    'url': string | null;
}
/**
 * 
 * @export
 * @interface GetRewards200ResponseInnerNotesInnerInner
 */
export interface GetRewards200ResponseInnerNotesInnerInner {
    /**
     * 
     * @type {string}
     * @memberof GetRewards200ResponseInnerNotesInnerInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetRewards200ResponseInnerNotesInnerInner
     */
    'text': string;
    /**
     * 
     * @type {string}
     * @memberof GetRewards200ResponseInnerNotesInnerInner
     */
    'url': string | null;
}
/**
 * 
 * @export
 * @interface GetRewards200ResponseInnerServiceDescriptionsInnerInner
 */
export interface GetRewards200ResponseInnerServiceDescriptionsInnerInner {
    /**
     * 
     * @type {string}
     * @memberof GetRewards200ResponseInnerServiceDescriptionsInnerInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetRewards200ResponseInnerServiceDescriptionsInnerInner
     */
    'text': string;
    /**
     * 
     * @type {string}
     * @memberof GetRewards200ResponseInnerServiceDescriptionsInnerInner
     */
    'url': string | null;
}
/**
 * 
 * @export
 * @interface GetRoleResourceForUser200ResponseInner
 */
export interface GetRoleResourceForUser200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetRoleResourceForUser200ResponseInner
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof GetRoleResourceForUser200ResponseInner
     */
    'resourceScope': GetRoleResourceForUser200ResponseInnerResourceScopeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetRoleResourceForUser200ResponseInner
     */
    'resourceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetRoleResourceForUser200ResponseInner
     */
    'role': GetRoleResourceForUser200ResponseInnerRoleEnum;
}

export const GetRoleResourceForUser200ResponseInnerResourceScopeEnum = {
    account: 'USER_ACCOUNT',
    accountGroup: 'USER_ACCOUNT_GROUP',
    accountAll: 'USER_ACCOUNT_ALL'
} as const;

export type GetRoleResourceForUser200ResponseInnerResourceScopeEnum = typeof GetRoleResourceForUser200ResponseInnerResourceScopeEnum[keyof typeof GetRoleResourceForUser200ResponseInnerResourceScopeEnum];
export const GetRoleResourceForUser200ResponseInnerRoleEnum = {
    admin: 'USER_ACCOUNT_ADMIN',
    assist: 'USER_ACCOUNT_ASSIST'
} as const;

export type GetRoleResourceForUser200ResponseInnerRoleEnum = typeof GetRoleResourceForUser200ResponseInnerRoleEnum[keyof typeof GetRoleResourceForUser200ResponseInnerRoleEnum];

/**
 * 
 * @export
 * @interface GetRoles200ResponseInner
 */
export interface GetRoles200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetRoles200ResponseInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetRoles200ResponseInner
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetRoles200ResponseInner
     */
    'category': GetRoles200ResponseInnerCategoryEnum;
}

export const GetRoles200ResponseInnerCategoryEnum = {
    system: 'SYSTEM',
    app: 'APP',
    card: 'CARD'
} as const;

export type GetRoles200ResponseInnerCategoryEnum = typeof GetRoles200ResponseInnerCategoryEnum[keyof typeof GetRoles200ResponseInnerCategoryEnum];

/**
 * 
 * @export
 * @interface GetRolesWithTopRelatedResources200ResponseInner
 */
export interface GetRolesWithTopRelatedResources200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetRolesWithTopRelatedResources200ResponseInner
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof GetRolesWithTopRelatedResources200ResponseInner
     */
    'resourceScope': GetRolesWithTopRelatedResources200ResponseInnerResourceScopeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetRolesWithTopRelatedResources200ResponseInner
     */
    'resourceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetRolesWithTopRelatedResources200ResponseInner
     */
    'role': GetRolesWithTopRelatedResources200ResponseInnerRoleEnum;
}

export const GetRolesWithTopRelatedResources200ResponseInnerResourceScopeEnum = {
    account: 'USER_ACCOUNT',
    accountGroup: 'USER_ACCOUNT_GROUP',
    accountAll: 'USER_ACCOUNT_ALL'
} as const;

export type GetRolesWithTopRelatedResources200ResponseInnerResourceScopeEnum = typeof GetRolesWithTopRelatedResources200ResponseInnerResourceScopeEnum[keyof typeof GetRolesWithTopRelatedResources200ResponseInnerResourceScopeEnum];
export const GetRolesWithTopRelatedResources200ResponseInnerRoleEnum = {
    admin: 'USER_ACCOUNT_ADMIN',
    assist: 'USER_ACCOUNT_ASSIST'
} as const;

export type GetRolesWithTopRelatedResources200ResponseInnerRoleEnum = typeof GetRolesWithTopRelatedResources200ResponseInnerRoleEnum[keyof typeof GetRolesWithTopRelatedResources200ResponseInnerRoleEnum];

/**
 * 
 * @export
 * @interface GetRolesWithTopRelatedResourcesByOrganizationId200ResponseInner
 */
export interface GetRolesWithTopRelatedResourcesByOrganizationId200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetRolesWithTopRelatedResourcesByOrganizationId200ResponseInner
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof GetRolesWithTopRelatedResourcesByOrganizationId200ResponseInner
     */
    'resourceScope': GetRolesWithTopRelatedResourcesByOrganizationId200ResponseInnerResourceScopeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetRolesWithTopRelatedResourcesByOrganizationId200ResponseInner
     */
    'resourceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetRolesWithTopRelatedResourcesByOrganizationId200ResponseInner
     */
    'role': GetRolesWithTopRelatedResourcesByOrganizationId200ResponseInnerRoleEnum;
}

export const GetRolesWithTopRelatedResourcesByOrganizationId200ResponseInnerResourceScopeEnum = {
    account: 'USER_ACCOUNT',
    accountGroup: 'USER_ACCOUNT_GROUP',
    accountAll: 'USER_ACCOUNT_ALL'
} as const;

export type GetRolesWithTopRelatedResourcesByOrganizationId200ResponseInnerResourceScopeEnum = typeof GetRolesWithTopRelatedResourcesByOrganizationId200ResponseInnerResourceScopeEnum[keyof typeof GetRolesWithTopRelatedResourcesByOrganizationId200ResponseInnerResourceScopeEnum];
export const GetRolesWithTopRelatedResourcesByOrganizationId200ResponseInnerRoleEnum = {
    admin: 'USER_ACCOUNT_ADMIN',
    assist: 'USER_ACCOUNT_ASSIST'
} as const;

export type GetRolesWithTopRelatedResourcesByOrganizationId200ResponseInnerRoleEnum = typeof GetRolesWithTopRelatedResourcesByOrganizationId200ResponseInnerRoleEnum[keyof typeof GetRolesWithTopRelatedResourcesByOrganizationId200ResponseInnerRoleEnum];

/**
 * 
 * @export
 * @interface GetSlackCardNotificationSettings200ResponseInner
 */
export interface GetSlackCardNotificationSettings200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetSlackCardNotificationSettings200ResponseInner
     */
    'channelId': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetSlackCardNotificationSettings200ResponseInner
     */
    'transactionTypes': Array<GetSlackCardNotificationSettings200ResponseInnerTransactionTypesEnum>;
    /**
     * 
     * @type {number}
     * @memberof GetSlackCardNotificationSettings200ResponseInner
     */
    'largeAmountThreshold': number | null;
    /**
     * 
     * @type {Array<GetSlackCardNotificationSettings200ResponseInnerUserAccountsInner>}
     * @memberof GetSlackCardNotificationSettings200ResponseInner
     */
    'userAccounts': Array<GetSlackCardNotificationSettings200ResponseInnerUserAccountsInner>;
    /**
     * 
     * @type {Array<GetSlackCardNotificationSettings200ResponseInnerUserAccountGroupsInner>}
     * @memberof GetSlackCardNotificationSettings200ResponseInner
     */
    'userAccountGroups': Array<GetSlackCardNotificationSettings200ResponseInnerUserAccountGroupsInner>;
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackCardNotificationSettings200ResponseInner
     */
    'isAllUserAccount': boolean;
}

export const GetSlackCardNotificationSettings200ResponseInnerTransactionTypesEnum = {
    unknownTransactionType: 'UNKNOWN_TRANSACTION_TYPE',
    successfulTransaction: 'SUCCESSFUL_TRANSACTION',
    incorrectCardInput: 'INCORRECT_CARD_INPUT',
    insufficientBalance: 'INSUFFICIENT_BALANCE',
    otherError: 'OTHER_ERROR',
    potentialFraud: 'POTENTIAL_FRAUD',
    criticalError: 'CRITICAL_ERROR',
    unusualUser: 'UNUSUAL_USER',
    limitationByUser: 'LIMITATION_BY_USER',
    unsupportedTransaction: 'UNSUPPORTED_TRANSACTION',
    carelessUser: 'CARELESS_USER'
} as const;

export type GetSlackCardNotificationSettings200ResponseInnerTransactionTypesEnum = typeof GetSlackCardNotificationSettings200ResponseInnerTransactionTypesEnum[keyof typeof GetSlackCardNotificationSettings200ResponseInnerTransactionTypesEnum];

/**
 * 
 * @export
 * @interface GetSlackCardNotificationSettings200ResponseInnerUserAccountGroupsInner
 */
export interface GetSlackCardNotificationSettings200ResponseInnerUserAccountGroupsInner {
    /**
     * 
     * @type {string}
     * @memberof GetSlackCardNotificationSettings200ResponseInnerUserAccountGroupsInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetSlackCardNotificationSettings200ResponseInnerUserAccountGroupsInner
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof GetSlackCardNotificationSettings200ResponseInnerUserAccountGroupsInner
     */
    'sortNum': number;
}
/**
 * 
 * @export
 * @interface GetSlackCardNotificationSettings200ResponseInnerUserAccountsInner
 */
export interface GetSlackCardNotificationSettings200ResponseInnerUserAccountsInner {
    /**
     * 
     * @type {string}
     * @memberof GetSlackCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'cardId': string;
    /**
     * 
     * @type {string}
     * @memberof GetSlackCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'cardLabel': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'isActivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'isDeactivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'isLocked': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'isSuspended': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'isFrozen': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'isVirtualCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'isCreditCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'isOnDemand': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'isMetalCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'isPhysicalStorePaymentDisabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetSlackCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'panLastFourDigits': string;
    /**
     * 
     * @type {string}
     * @memberof GetSlackCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'userAccountId': string;
    /**
     * 
     * @type {number}
     * @memberof GetSlackCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'transactionUpperLimit': number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetSlackCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'availableCurrencies': Array<GetSlackCardNotificationSettings200ResponseInnerUserAccountsInnerAvailableCurrenciesEnum>;
    /**
     * 
     * @type {Array<GetSlackCardNotificationSettings200ResponseInnerUserAccountsInnerAvailableMerchantCategoriesInner>}
     * @memberof GetSlackCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'availableMerchantCategories': Array<GetSlackCardNotificationSettings200ResponseInnerUserAccountsInnerAvailableMerchantCategoriesInner> | null;
    /**
     * 
     * @type {GetSlackCardNotificationSettings200ResponseInnerUserAccountsInnerUser}
     * @memberof GetSlackCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'user': GetSlackCardNotificationSettings200ResponseInnerUserAccountsInnerUser;
    /**
     * 
     * @type {GetSlackCardNotificationSettings200ResponseInnerUserAccountsInnerUserAccountGroup}
     * @memberof GetSlackCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'userAccountGroup'?: GetSlackCardNotificationSettings200ResponseInnerUserAccountsInnerUserAccountGroup | null;
    /**
     * 
     * @type {number}
     * @memberof GetSlackCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'monthlyTotalUsage': number;
    /**
     * 
     * @type {number}
     * @memberof GetSlackCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'monthlyUsageLimit': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetSlackCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'dailyTotalUsage': number;
    /**
     * 
     * @type {number}
     * @memberof GetSlackCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'dailyUsageLimit': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetSlackCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'totalUsageAmount': number;
    /**
     * 
     * @type {number}
     * @memberof GetSlackCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'totalUsageAmountLimit': number | null;
    /**
     * 
     * @type {string}
     * @memberof GetSlackCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'expiredDate': string | null;
}

export const GetSlackCardNotificationSettings200ResponseInnerUserAccountsInnerAvailableCurrenciesEnum = {
    jpy: 'JPY',
    usd: 'USD',
    gbp: 'GBP',
    eur: 'EUR',
    sgd: 'SGD',
    aud: 'AUD',
    cny: 'CNY',
    hkd: 'HKD',
    idr: 'IDR',
    krw: 'KRW',
    nzd: 'NZD',
    php: 'PHP',
    rub: 'RUB',
    vnd: 'VND',
    inr: 'INR',
    thb: 'THB',
    lak: 'LAK',
    myr: 'MYR',
    twd: 'TWD',
    chf: 'CHF',
    cad: 'CAD',
    mxn: 'MXN',
    nok: 'NOK',
    huf: 'HUF',
    hrk: 'HRK',
    czk: 'CZK',
    dkk: 'DKK',
    isk: 'ISK',
    mdl: 'MDL',
    sek: 'SEK',
    mkd: 'MKD',
    rsd: 'RSD',
    ron: 'RON',
    bgn: 'BGN',
    bam: 'BAM',
    pln: 'PLN',
    mad: 'MAD',
    zar: 'ZAR',
    rwf: 'RWF',
    kes: 'KES',
    ngn: 'NGN',
    aed: 'AED',
    sar: 'SAR',
    egp: 'EGP',
    qar: 'QAR',
    omr: 'OMR',
    ils: 'ILS',
    try: 'TRY',
    kzt: 'KZT',
    cop: 'COP',
    gtq: 'GTQ'
} as const;

export type GetSlackCardNotificationSettings200ResponseInnerUserAccountsInnerAvailableCurrenciesEnum = typeof GetSlackCardNotificationSettings200ResponseInnerUserAccountsInnerAvailableCurrenciesEnum[keyof typeof GetSlackCardNotificationSettings200ResponseInnerUserAccountsInnerAvailableCurrenciesEnum];

/**
 * 
 * @export
 * @interface GetSlackCardNotificationSettings200ResponseInnerUserAccountsInnerAvailableMerchantCategoriesInner
 */
export interface GetSlackCardNotificationSettings200ResponseInnerUserAccountsInnerAvailableMerchantCategoriesInner {
    /**
     * 
     * @type {string}
     * @memberof GetSlackCardNotificationSettings200ResponseInnerUserAccountsInnerAvailableMerchantCategoriesInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetSlackCardNotificationSettings200ResponseInnerUserAccountsInnerAvailableMerchantCategoriesInner
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetSlackCardNotificationSettings200ResponseInnerUserAccountsInnerAvailableMerchantCategoriesInner
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof GetSlackCardNotificationSettings200ResponseInnerUserAccountsInnerAvailableMerchantCategoriesInner
     */
    'logoUrl': string;
}
/**
 * 
 * @export
 * @interface GetSlackCardNotificationSettings200ResponseInnerUserAccountsInnerUser
 */
export interface GetSlackCardNotificationSettings200ResponseInnerUserAccountsInnerUser {
    /**
     * 
     * @type {string}
     * @memberof GetSlackCardNotificationSettings200ResponseInnerUserAccountsInnerUser
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetSlackCardNotificationSettings200ResponseInnerUserAccountsInnerUser
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetSlackCardNotificationSettings200ResponseInnerUserAccountsInnerUser
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetSlackCardNotificationSettings200ResponseInnerUserAccountsInnerUser
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof GetSlackCardNotificationSettings200ResponseInnerUserAccountsInnerUser
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackCardNotificationSettings200ResponseInnerUserAccountsInnerUser
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackCardNotificationSettings200ResponseInnerUserAccountsInnerUser
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackCardNotificationSettings200ResponseInnerUserAccountsInnerUser
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackCardNotificationSettings200ResponseInnerUserAccountsInnerUser
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackCardNotificationSettings200ResponseInnerUserAccountsInnerUser
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetSlackCardNotificationSettings200ResponseInnerUserAccountsInnerUser
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface GetSlackCardNotificationSettings200ResponseInnerUserAccountsInnerUserAccountGroup
 */
export interface GetSlackCardNotificationSettings200ResponseInnerUserAccountsInnerUserAccountGroup {
    /**
     * 
     * @type {string}
     * @memberof GetSlackCardNotificationSettings200ResponseInnerUserAccountsInnerUserAccountGroup
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetSlackCardNotificationSettings200ResponseInnerUserAccountsInnerUserAccountGroup
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof GetSlackCardNotificationSettings200ResponseInnerUserAccountsInnerUserAccountGroup
     */
    'sortNum': number;
}
/**
 * 
 * @export
 * @interface GetSlackChannel200Response
 */
export interface GetSlackChannel200Response {
    /**
     * 
     * @type {string}
     * @memberof GetSlackChannel200Response
     */
    'channelId': string;
    /**
     * 
     * @type {string}
     * @memberof GetSlackChannel200Response
     */
    'channelName': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackChannel200Response
     */
    'isPrivate': boolean;
}
/**
 * 
 * @export
 * @interface GetSlackChannels200ResponseInner
 */
export interface GetSlackChannels200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetSlackChannels200ResponseInner
     */
    'channelId': string;
    /**
     * 
     * @type {string}
     * @memberof GetSlackChannels200ResponseInner
     */
    'channelName': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackChannels200ResponseInner
     */
    'isPrivate': boolean;
}
/**
 * 
 * @export
 * @interface GetSlackChannelsWithCursor200Response
 */
export interface GetSlackChannelsWithCursor200Response {
    /**
     * 
     * @type {Array<GetSlackChannelsWithCursor200ResponseChannelsInner>}
     * @memberof GetSlackChannelsWithCursor200Response
     */
    'channels': Array<GetSlackChannelsWithCursor200ResponseChannelsInner>;
    /**
     * 
     * @type {string}
     * @memberof GetSlackChannelsWithCursor200Response
     */
    'nextCursor'?: string;
}
/**
 * 
 * @export
 * @interface GetSlackChannelsWithCursor200ResponseChannelsInner
 */
export interface GetSlackChannelsWithCursor200ResponseChannelsInner {
    /**
     * 
     * @type {string}
     * @memberof GetSlackChannelsWithCursor200ResponseChannelsInner
     */
    'channelId': string;
    /**
     * 
     * @type {string}
     * @memberof GetSlackChannelsWithCursor200ResponseChannelsInner
     */
    'channelName': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackChannelsWithCursor200ResponseChannelsInner
     */
    'isPrivate': boolean;
}
/**
 * 
 * @export
 * @interface GetSlackEvidenceReminder200ResponseInner
 */
export interface GetSlackEvidenceReminder200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetSlackEvidenceReminder200ResponseInner
     */
    'channelId': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackEvidenceReminder200ResponseInner
     */
    'isAllUserAccount': boolean;
    /**
     * 
     * @type {Array<GetSlackEvidenceReminder200ResponseInnerUserAccountsInner>}
     * @memberof GetSlackEvidenceReminder200ResponseInner
     */
    'userAccounts': Array<GetSlackEvidenceReminder200ResponseInnerUserAccountsInner>;
    /**
     * 
     * @type {Array<GetSlackEvidenceReminder200ResponseInnerUserAccountGroupsInner>}
     * @memberof GetSlackEvidenceReminder200ResponseInner
     */
    'userAccountGroups': Array<GetSlackEvidenceReminder200ResponseInnerUserAccountGroupsInner>;
    /**
     * 
     * @type {Array<GetSlackEvidenceReminder200ResponseInnerSettingsInner>}
     * @memberof GetSlackEvidenceReminder200ResponseInner
     */
    'settings': Array<GetSlackEvidenceReminder200ResponseInnerSettingsInner>;
}
/**
 * 
 * @export
 * @interface GetSlackEvidenceReminder200ResponseInnerSettingsInner
 */
export interface GetSlackEvidenceReminder200ResponseInnerSettingsInner {
    /**
     * 
     * @type {string}
     * @memberof GetSlackEvidenceReminder200ResponseInnerSettingsInner
     */
    'notificationScope': GetSlackEvidenceReminder200ResponseInnerSettingsInnerNotificationScopeEnum;
    /**
     * 
     * @type {Array<GetSlackEvidenceReminder200ResponseInnerSettingsInnerRemindersInner>}
     * @memberof GetSlackEvidenceReminder200ResponseInnerSettingsInner
     */
    'reminders': Array<GetSlackEvidenceReminder200ResponseInnerSettingsInnerRemindersInner>;
}

export const GetSlackEvidenceReminder200ResponseInnerSettingsInnerNotificationScopeEnum = {
    thisMonth: 'THIS_MONTH',
    prevMonth: 'PREV_MONTH'
} as const;

export type GetSlackEvidenceReminder200ResponseInnerSettingsInnerNotificationScopeEnum = typeof GetSlackEvidenceReminder200ResponseInnerSettingsInnerNotificationScopeEnum[keyof typeof GetSlackEvidenceReminder200ResponseInnerSettingsInnerNotificationScopeEnum];

/**
 * 
 * @export
 * @interface GetSlackEvidenceReminder200ResponseInnerSettingsInnerRemindersInner
 */
export interface GetSlackEvidenceReminder200ResponseInnerSettingsInnerRemindersInner {
    /**
     * 
     * @type {string}
     * @memberof GetSlackEvidenceReminder200ResponseInnerSettingsInnerRemindersInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetSlackEvidenceReminder200ResponseInnerSettingsInnerRemindersInner
     */
    'effectiveDayType': GetSlackEvidenceReminder200ResponseInnerSettingsInnerRemindersInnerEffectiveDayTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof GetSlackEvidenceReminder200ResponseInnerSettingsInnerRemindersInner
     */
    'effectiveDay': number;
    /**
     * 
     * @type {number}
     * @memberof GetSlackEvidenceReminder200ResponseInnerSettingsInnerRemindersInner
     */
    'effectiveHours': number;
    /**
     * 
     * @type {number}
     * @memberof GetSlackEvidenceReminder200ResponseInnerSettingsInnerRemindersInner
     */
    'effectiveMinutes': number;
}

export const GetSlackEvidenceReminder200ResponseInnerSettingsInnerRemindersInnerEffectiveDayTypeEnum = {
    number: 'NUMBER',
    endOfMonth: 'END_OF_MONTH'
} as const;

export type GetSlackEvidenceReminder200ResponseInnerSettingsInnerRemindersInnerEffectiveDayTypeEnum = typeof GetSlackEvidenceReminder200ResponseInnerSettingsInnerRemindersInnerEffectiveDayTypeEnum[keyof typeof GetSlackEvidenceReminder200ResponseInnerSettingsInnerRemindersInnerEffectiveDayTypeEnum];

/**
 * 
 * @export
 * @interface GetSlackEvidenceReminder200ResponseInnerUserAccountGroupsInner
 */
export interface GetSlackEvidenceReminder200ResponseInnerUserAccountGroupsInner {
    /**
     * 
     * @type {string}
     * @memberof GetSlackEvidenceReminder200ResponseInnerUserAccountGroupsInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetSlackEvidenceReminder200ResponseInnerUserAccountGroupsInner
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof GetSlackEvidenceReminder200ResponseInnerUserAccountGroupsInner
     */
    'sortNum': number;
}
/**
 * 
 * @export
 * @interface GetSlackEvidenceReminder200ResponseInnerUserAccountsInner
 */
export interface GetSlackEvidenceReminder200ResponseInnerUserAccountsInner {
    /**
     * 
     * @type {string}
     * @memberof GetSlackEvidenceReminder200ResponseInnerUserAccountsInner
     */
    'cardId': string;
    /**
     * 
     * @type {string}
     * @memberof GetSlackEvidenceReminder200ResponseInnerUserAccountsInner
     */
    'cardLabel': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackEvidenceReminder200ResponseInnerUserAccountsInner
     */
    'isActivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackEvidenceReminder200ResponseInnerUserAccountsInner
     */
    'isDeactivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackEvidenceReminder200ResponseInnerUserAccountsInner
     */
    'isLocked': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackEvidenceReminder200ResponseInnerUserAccountsInner
     */
    'isSuspended': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackEvidenceReminder200ResponseInnerUserAccountsInner
     */
    'isFrozen': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackEvidenceReminder200ResponseInnerUserAccountsInner
     */
    'isVirtualCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackEvidenceReminder200ResponseInnerUserAccountsInner
     */
    'isCreditCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackEvidenceReminder200ResponseInnerUserAccountsInner
     */
    'isOnDemand': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackEvidenceReminder200ResponseInnerUserAccountsInner
     */
    'isMetalCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackEvidenceReminder200ResponseInnerUserAccountsInner
     */
    'isPhysicalStorePaymentDisabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetSlackEvidenceReminder200ResponseInnerUserAccountsInner
     */
    'panLastFourDigits': string;
    /**
     * 
     * @type {string}
     * @memberof GetSlackEvidenceReminder200ResponseInnerUserAccountsInner
     */
    'userAccountId': string;
    /**
     * 
     * @type {number}
     * @memberof GetSlackEvidenceReminder200ResponseInnerUserAccountsInner
     */
    'transactionUpperLimit': number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetSlackEvidenceReminder200ResponseInnerUserAccountsInner
     */
    'availableCurrencies': Array<GetSlackEvidenceReminder200ResponseInnerUserAccountsInnerAvailableCurrenciesEnum>;
    /**
     * 
     * @type {Array<GetSlackEvidenceReminder200ResponseInnerUserAccountsInnerAvailableMerchantCategoriesInner>}
     * @memberof GetSlackEvidenceReminder200ResponseInnerUserAccountsInner
     */
    'availableMerchantCategories': Array<GetSlackEvidenceReminder200ResponseInnerUserAccountsInnerAvailableMerchantCategoriesInner> | null;
    /**
     * 
     * @type {GetSlackEvidenceReminder200ResponseInnerUserAccountsInnerUser}
     * @memberof GetSlackEvidenceReminder200ResponseInnerUserAccountsInner
     */
    'user': GetSlackEvidenceReminder200ResponseInnerUserAccountsInnerUser;
    /**
     * 
     * @type {GetSlackEvidenceReminder200ResponseInnerUserAccountsInnerUserAccountGroup}
     * @memberof GetSlackEvidenceReminder200ResponseInnerUserAccountsInner
     */
    'userAccountGroup'?: GetSlackEvidenceReminder200ResponseInnerUserAccountsInnerUserAccountGroup | null;
    /**
     * 
     * @type {number}
     * @memberof GetSlackEvidenceReminder200ResponseInnerUserAccountsInner
     */
    'monthlyTotalUsage': number;
    /**
     * 
     * @type {number}
     * @memberof GetSlackEvidenceReminder200ResponseInnerUserAccountsInner
     */
    'monthlyUsageLimit': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetSlackEvidenceReminder200ResponseInnerUserAccountsInner
     */
    'dailyTotalUsage': number;
    /**
     * 
     * @type {number}
     * @memberof GetSlackEvidenceReminder200ResponseInnerUserAccountsInner
     */
    'dailyUsageLimit': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetSlackEvidenceReminder200ResponseInnerUserAccountsInner
     */
    'totalUsageAmount': number;
    /**
     * 
     * @type {number}
     * @memberof GetSlackEvidenceReminder200ResponseInnerUserAccountsInner
     */
    'totalUsageAmountLimit': number | null;
    /**
     * 
     * @type {string}
     * @memberof GetSlackEvidenceReminder200ResponseInnerUserAccountsInner
     */
    'expiredDate': string | null;
}

export const GetSlackEvidenceReminder200ResponseInnerUserAccountsInnerAvailableCurrenciesEnum = {
    jpy: 'JPY',
    usd: 'USD',
    gbp: 'GBP',
    eur: 'EUR',
    sgd: 'SGD',
    aud: 'AUD',
    cny: 'CNY',
    hkd: 'HKD',
    idr: 'IDR',
    krw: 'KRW',
    nzd: 'NZD',
    php: 'PHP',
    rub: 'RUB',
    vnd: 'VND',
    inr: 'INR',
    thb: 'THB',
    lak: 'LAK',
    myr: 'MYR',
    twd: 'TWD',
    chf: 'CHF',
    cad: 'CAD',
    mxn: 'MXN',
    nok: 'NOK',
    huf: 'HUF',
    hrk: 'HRK',
    czk: 'CZK',
    dkk: 'DKK',
    isk: 'ISK',
    mdl: 'MDL',
    sek: 'SEK',
    mkd: 'MKD',
    rsd: 'RSD',
    ron: 'RON',
    bgn: 'BGN',
    bam: 'BAM',
    pln: 'PLN',
    mad: 'MAD',
    zar: 'ZAR',
    rwf: 'RWF',
    kes: 'KES',
    ngn: 'NGN',
    aed: 'AED',
    sar: 'SAR',
    egp: 'EGP',
    qar: 'QAR',
    omr: 'OMR',
    ils: 'ILS',
    try: 'TRY',
    kzt: 'KZT',
    cop: 'COP',
    gtq: 'GTQ'
} as const;

export type GetSlackEvidenceReminder200ResponseInnerUserAccountsInnerAvailableCurrenciesEnum = typeof GetSlackEvidenceReminder200ResponseInnerUserAccountsInnerAvailableCurrenciesEnum[keyof typeof GetSlackEvidenceReminder200ResponseInnerUserAccountsInnerAvailableCurrenciesEnum];

/**
 * 
 * @export
 * @interface GetSlackEvidenceReminder200ResponseInnerUserAccountsInnerAvailableMerchantCategoriesInner
 */
export interface GetSlackEvidenceReminder200ResponseInnerUserAccountsInnerAvailableMerchantCategoriesInner {
    /**
     * 
     * @type {string}
     * @memberof GetSlackEvidenceReminder200ResponseInnerUserAccountsInnerAvailableMerchantCategoriesInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetSlackEvidenceReminder200ResponseInnerUserAccountsInnerAvailableMerchantCategoriesInner
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetSlackEvidenceReminder200ResponseInnerUserAccountsInnerAvailableMerchantCategoriesInner
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof GetSlackEvidenceReminder200ResponseInnerUserAccountsInnerAvailableMerchantCategoriesInner
     */
    'logoUrl': string;
}
/**
 * 
 * @export
 * @interface GetSlackEvidenceReminder200ResponseInnerUserAccountsInnerUser
 */
export interface GetSlackEvidenceReminder200ResponseInnerUserAccountsInnerUser {
    /**
     * 
     * @type {string}
     * @memberof GetSlackEvidenceReminder200ResponseInnerUserAccountsInnerUser
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetSlackEvidenceReminder200ResponseInnerUserAccountsInnerUser
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetSlackEvidenceReminder200ResponseInnerUserAccountsInnerUser
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetSlackEvidenceReminder200ResponseInnerUserAccountsInnerUser
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof GetSlackEvidenceReminder200ResponseInnerUserAccountsInnerUser
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackEvidenceReminder200ResponseInnerUserAccountsInnerUser
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackEvidenceReminder200ResponseInnerUserAccountsInnerUser
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackEvidenceReminder200ResponseInnerUserAccountsInnerUser
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackEvidenceReminder200ResponseInnerUserAccountsInnerUser
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackEvidenceReminder200ResponseInnerUserAccountsInnerUser
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetSlackEvidenceReminder200ResponseInnerUserAccountsInnerUser
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface GetSlackEvidenceReminder200ResponseInnerUserAccountsInnerUserAccountGroup
 */
export interface GetSlackEvidenceReminder200ResponseInnerUserAccountsInnerUserAccountGroup {
    /**
     * 
     * @type {string}
     * @memberof GetSlackEvidenceReminder200ResponseInnerUserAccountsInnerUserAccountGroup
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetSlackEvidenceReminder200ResponseInnerUserAccountsInnerUserAccountGroup
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof GetSlackEvidenceReminder200ResponseInnerUserAccountsInnerUserAccountGroup
     */
    'sortNum': number;
}
/**
 * 
 * @export
 * @interface GetSlackEvidenceReminderPerChannel200Response
 */
export interface GetSlackEvidenceReminderPerChannel200Response {
    /**
     * 
     * @type {string}
     * @memberof GetSlackEvidenceReminderPerChannel200Response
     */
    'channelId': string;
    /**
     * 
     * @type {Array<GetSlackEvidenceReminderPerChannel200ResponseSettingsInner>}
     * @memberof GetSlackEvidenceReminderPerChannel200Response
     */
    'settings': Array<GetSlackEvidenceReminderPerChannel200ResponseSettingsInner>;
}
/**
 * 
 * @export
 * @interface GetSlackEvidenceReminderPerChannel200ResponseSettingsInner
 */
export interface GetSlackEvidenceReminderPerChannel200ResponseSettingsInner {
    /**
     * 
     * @type {string}
     * @memberof GetSlackEvidenceReminderPerChannel200ResponseSettingsInner
     */
    'notificationScope': GetSlackEvidenceReminderPerChannel200ResponseSettingsInnerNotificationScopeEnum;
    /**
     * 
     * @type {Array<GetSlackEvidenceReminderPerChannel200ResponseSettingsInnerRemindersInner>}
     * @memberof GetSlackEvidenceReminderPerChannel200ResponseSettingsInner
     */
    'reminders': Array<GetSlackEvidenceReminderPerChannel200ResponseSettingsInnerRemindersInner>;
}

export const GetSlackEvidenceReminderPerChannel200ResponseSettingsInnerNotificationScopeEnum = {
    thisMonth: 'THIS_MONTH',
    prevMonth: 'PREV_MONTH'
} as const;

export type GetSlackEvidenceReminderPerChannel200ResponseSettingsInnerNotificationScopeEnum = typeof GetSlackEvidenceReminderPerChannel200ResponseSettingsInnerNotificationScopeEnum[keyof typeof GetSlackEvidenceReminderPerChannel200ResponseSettingsInnerNotificationScopeEnum];

/**
 * 
 * @export
 * @interface GetSlackEvidenceReminderPerChannel200ResponseSettingsInnerRemindersInner
 */
export interface GetSlackEvidenceReminderPerChannel200ResponseSettingsInnerRemindersInner {
    /**
     * 
     * @type {string}
     * @memberof GetSlackEvidenceReminderPerChannel200ResponseSettingsInnerRemindersInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetSlackEvidenceReminderPerChannel200ResponseSettingsInnerRemindersInner
     */
    'effectiveDayType': GetSlackEvidenceReminderPerChannel200ResponseSettingsInnerRemindersInnerEffectiveDayTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof GetSlackEvidenceReminderPerChannel200ResponseSettingsInnerRemindersInner
     */
    'effectiveDay': number;
    /**
     * 
     * @type {number}
     * @memberof GetSlackEvidenceReminderPerChannel200ResponseSettingsInnerRemindersInner
     */
    'effectiveHours': number;
    /**
     * 
     * @type {number}
     * @memberof GetSlackEvidenceReminderPerChannel200ResponseSettingsInnerRemindersInner
     */
    'effectiveMinutes': number;
}

export const GetSlackEvidenceReminderPerChannel200ResponseSettingsInnerRemindersInnerEffectiveDayTypeEnum = {
    number: 'NUMBER',
    endOfMonth: 'END_OF_MONTH'
} as const;

export type GetSlackEvidenceReminderPerChannel200ResponseSettingsInnerRemindersInnerEffectiveDayTypeEnum = typeof GetSlackEvidenceReminderPerChannel200ResponseSettingsInnerRemindersInnerEffectiveDayTypeEnum[keyof typeof GetSlackEvidenceReminderPerChannel200ResponseSettingsInnerRemindersInnerEffectiveDayTypeEnum];

/**
 * 
 * @export
 * @interface GetSlackNotificationChannelSettingForPurchaseApplication200Response
 */
export interface GetSlackNotificationChannelSettingForPurchaseApplication200Response {
    /**
     * 
     * @type {string}
     * @memberof GetSlackNotificationChannelSettingForPurchaseApplication200Response
     */
    'channelId': string;
    /**
     * 
     * @type {GetSlackNotificationChannelSettingForPurchaseApplication200ResponseNotificationAtCreation}
     * @memberof GetSlackNotificationChannelSettingForPurchaseApplication200Response
     */
    'notificationAtCreation': GetSlackNotificationChannelSettingForPurchaseApplication200ResponseNotificationAtCreation;
    /**
     * 
     * @type {GetSlackNotificationChannelSettingForPurchaseApplication200ResponseNotificationAtApproverAction}
     * @memberof GetSlackNotificationChannelSettingForPurchaseApplication200Response
     */
    'notificationAtApproverAction': GetSlackNotificationChannelSettingForPurchaseApplication200ResponseNotificationAtApproverAction;
}
/**
 * 
 * @export
 * @interface GetSlackNotificationChannelSettingForPurchaseApplication200ResponseNotificationAtApproverAction
 */
export interface GetSlackNotificationChannelSettingForPurchaseApplication200ResponseNotificationAtApproverAction {
    /**
     * 
     * @type {Array<string>}
     * @memberof GetSlackNotificationChannelSettingForPurchaseApplication200ResponseNotificationAtApproverAction
     */
    'actionTypes': Array<string>;
    /**
     * 
     * @type {Array<GetSlackNotificationChannelSettingForPurchaseApplication200ResponseNotificationAtApproverActionApplicantUsersInner>}
     * @memberof GetSlackNotificationChannelSettingForPurchaseApplication200ResponseNotificationAtApproverAction
     */
    'applicantUsers': Array<GetSlackNotificationChannelSettingForPurchaseApplication200ResponseNotificationAtApproverActionApplicantUsersInner>;
    /**
     * 
     * @type {Array<GetSlackNotificationChannelSettingForPurchaseApplication200ResponseNotificationAtApproverActionApproverUsersInner>}
     * @memberof GetSlackNotificationChannelSettingForPurchaseApplication200ResponseNotificationAtApproverAction
     */
    'approverUsers': Array<GetSlackNotificationChannelSettingForPurchaseApplication200ResponseNotificationAtApproverActionApproverUsersInner>;
}
/**
 * 
 * @export
 * @interface GetSlackNotificationChannelSettingForPurchaseApplication200ResponseNotificationAtApproverActionApplicantUsersInner
 */
export interface GetSlackNotificationChannelSettingForPurchaseApplication200ResponseNotificationAtApproverActionApplicantUsersInner {
    /**
     * 
     * @type {string}
     * @memberof GetSlackNotificationChannelSettingForPurchaseApplication200ResponseNotificationAtApproverActionApplicantUsersInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetSlackNotificationChannelSettingForPurchaseApplication200ResponseNotificationAtApproverActionApplicantUsersInner
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetSlackNotificationChannelSettingForPurchaseApplication200ResponseNotificationAtApproverActionApplicantUsersInner
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetSlackNotificationChannelSettingForPurchaseApplication200ResponseNotificationAtApproverActionApplicantUsersInner
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof GetSlackNotificationChannelSettingForPurchaseApplication200ResponseNotificationAtApproverActionApplicantUsersInner
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackNotificationChannelSettingForPurchaseApplication200ResponseNotificationAtApproverActionApplicantUsersInner
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackNotificationChannelSettingForPurchaseApplication200ResponseNotificationAtApproverActionApplicantUsersInner
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackNotificationChannelSettingForPurchaseApplication200ResponseNotificationAtApproverActionApplicantUsersInner
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackNotificationChannelSettingForPurchaseApplication200ResponseNotificationAtApproverActionApplicantUsersInner
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackNotificationChannelSettingForPurchaseApplication200ResponseNotificationAtApproverActionApplicantUsersInner
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetSlackNotificationChannelSettingForPurchaseApplication200ResponseNotificationAtApproverActionApplicantUsersInner
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface GetSlackNotificationChannelSettingForPurchaseApplication200ResponseNotificationAtApproverActionApproverUsersInner
 */
export interface GetSlackNotificationChannelSettingForPurchaseApplication200ResponseNotificationAtApproverActionApproverUsersInner {
    /**
     * 
     * @type {string}
     * @memberof GetSlackNotificationChannelSettingForPurchaseApplication200ResponseNotificationAtApproverActionApproverUsersInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetSlackNotificationChannelSettingForPurchaseApplication200ResponseNotificationAtApproverActionApproverUsersInner
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetSlackNotificationChannelSettingForPurchaseApplication200ResponseNotificationAtApproverActionApproverUsersInner
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetSlackNotificationChannelSettingForPurchaseApplication200ResponseNotificationAtApproverActionApproverUsersInner
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof GetSlackNotificationChannelSettingForPurchaseApplication200ResponseNotificationAtApproverActionApproverUsersInner
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackNotificationChannelSettingForPurchaseApplication200ResponseNotificationAtApproverActionApproverUsersInner
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackNotificationChannelSettingForPurchaseApplication200ResponseNotificationAtApproverActionApproverUsersInner
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackNotificationChannelSettingForPurchaseApplication200ResponseNotificationAtApproverActionApproverUsersInner
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackNotificationChannelSettingForPurchaseApplication200ResponseNotificationAtApproverActionApproverUsersInner
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackNotificationChannelSettingForPurchaseApplication200ResponseNotificationAtApproverActionApproverUsersInner
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetSlackNotificationChannelSettingForPurchaseApplication200ResponseNotificationAtApproverActionApproverUsersInner
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface GetSlackNotificationChannelSettingForPurchaseApplication200ResponseNotificationAtCreation
 */
export interface GetSlackNotificationChannelSettingForPurchaseApplication200ResponseNotificationAtCreation {
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackNotificationChannelSettingForPurchaseApplication200ResponseNotificationAtCreation
     */
    'isNotify': boolean;
    /**
     * 
     * @type {Array<GetSlackNotificationChannelSettingForPurchaseApplication200ResponseNotificationAtCreationApplicantUsersInner>}
     * @memberof GetSlackNotificationChannelSettingForPurchaseApplication200ResponseNotificationAtCreation
     */
    'applicantUsers': Array<GetSlackNotificationChannelSettingForPurchaseApplication200ResponseNotificationAtCreationApplicantUsersInner>;
    /**
     * 
     * @type {Array<GetSlackNotificationChannelSettingForPurchaseApplication200ResponseNotificationAtCreationApproverUsersInner>}
     * @memberof GetSlackNotificationChannelSettingForPurchaseApplication200ResponseNotificationAtCreation
     */
    'approverUsers': Array<GetSlackNotificationChannelSettingForPurchaseApplication200ResponseNotificationAtCreationApproverUsersInner>;
}
/**
 * 
 * @export
 * @interface GetSlackNotificationChannelSettingForPurchaseApplication200ResponseNotificationAtCreationApplicantUsersInner
 */
export interface GetSlackNotificationChannelSettingForPurchaseApplication200ResponseNotificationAtCreationApplicantUsersInner {
    /**
     * 
     * @type {string}
     * @memberof GetSlackNotificationChannelSettingForPurchaseApplication200ResponseNotificationAtCreationApplicantUsersInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetSlackNotificationChannelSettingForPurchaseApplication200ResponseNotificationAtCreationApplicantUsersInner
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetSlackNotificationChannelSettingForPurchaseApplication200ResponseNotificationAtCreationApplicantUsersInner
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetSlackNotificationChannelSettingForPurchaseApplication200ResponseNotificationAtCreationApplicantUsersInner
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof GetSlackNotificationChannelSettingForPurchaseApplication200ResponseNotificationAtCreationApplicantUsersInner
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackNotificationChannelSettingForPurchaseApplication200ResponseNotificationAtCreationApplicantUsersInner
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackNotificationChannelSettingForPurchaseApplication200ResponseNotificationAtCreationApplicantUsersInner
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackNotificationChannelSettingForPurchaseApplication200ResponseNotificationAtCreationApplicantUsersInner
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackNotificationChannelSettingForPurchaseApplication200ResponseNotificationAtCreationApplicantUsersInner
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackNotificationChannelSettingForPurchaseApplication200ResponseNotificationAtCreationApplicantUsersInner
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetSlackNotificationChannelSettingForPurchaseApplication200ResponseNotificationAtCreationApplicantUsersInner
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface GetSlackNotificationChannelSettingForPurchaseApplication200ResponseNotificationAtCreationApproverUsersInner
 */
export interface GetSlackNotificationChannelSettingForPurchaseApplication200ResponseNotificationAtCreationApproverUsersInner {
    /**
     * 
     * @type {string}
     * @memberof GetSlackNotificationChannelSettingForPurchaseApplication200ResponseNotificationAtCreationApproverUsersInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetSlackNotificationChannelSettingForPurchaseApplication200ResponseNotificationAtCreationApproverUsersInner
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetSlackNotificationChannelSettingForPurchaseApplication200ResponseNotificationAtCreationApproverUsersInner
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetSlackNotificationChannelSettingForPurchaseApplication200ResponseNotificationAtCreationApproverUsersInner
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof GetSlackNotificationChannelSettingForPurchaseApplication200ResponseNotificationAtCreationApproverUsersInner
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackNotificationChannelSettingForPurchaseApplication200ResponseNotificationAtCreationApproverUsersInner
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackNotificationChannelSettingForPurchaseApplication200ResponseNotificationAtCreationApproverUsersInner
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackNotificationChannelSettingForPurchaseApplication200ResponseNotificationAtCreationApproverUsersInner
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackNotificationChannelSettingForPurchaseApplication200ResponseNotificationAtCreationApproverUsersInner
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackNotificationChannelSettingForPurchaseApplication200ResponseNotificationAtCreationApproverUsersInner
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetSlackNotificationChannelSettingForPurchaseApplication200ResponseNotificationAtCreationApproverUsersInner
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface GetSlackNotificationSettingsForPurchaseApplication200ResponseInner
 */
export interface GetSlackNotificationSettingsForPurchaseApplication200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetSlackNotificationSettingsForPurchaseApplication200ResponseInner
     */
    'channelId': string;
    /**
     * 
     * @type {GetSlackNotificationSettingsForPurchaseApplication200ResponseInnerNotificationAtCreation}
     * @memberof GetSlackNotificationSettingsForPurchaseApplication200ResponseInner
     */
    'notificationAtCreation': GetSlackNotificationSettingsForPurchaseApplication200ResponseInnerNotificationAtCreation;
    /**
     * 
     * @type {GetSlackNotificationSettingsForPurchaseApplication200ResponseInnerNotificationAtApproverAction}
     * @memberof GetSlackNotificationSettingsForPurchaseApplication200ResponseInner
     */
    'notificationAtApproverAction': GetSlackNotificationSettingsForPurchaseApplication200ResponseInnerNotificationAtApproverAction;
}
/**
 * 
 * @export
 * @interface GetSlackNotificationSettingsForPurchaseApplication200ResponseInnerNotificationAtApproverAction
 */
export interface GetSlackNotificationSettingsForPurchaseApplication200ResponseInnerNotificationAtApproverAction {
    /**
     * 
     * @type {Array<string>}
     * @memberof GetSlackNotificationSettingsForPurchaseApplication200ResponseInnerNotificationAtApproverAction
     */
    'actionTypes': Array<string>;
    /**
     * 
     * @type {Array<GetSlackNotificationSettingsForPurchaseApplication200ResponseInnerNotificationAtApproverActionApplicantUsersInner>}
     * @memberof GetSlackNotificationSettingsForPurchaseApplication200ResponseInnerNotificationAtApproverAction
     */
    'applicantUsers': Array<GetSlackNotificationSettingsForPurchaseApplication200ResponseInnerNotificationAtApproverActionApplicantUsersInner>;
    /**
     * 
     * @type {Array<GetSlackNotificationSettingsForPurchaseApplication200ResponseInnerNotificationAtApproverActionApproverUsersInner>}
     * @memberof GetSlackNotificationSettingsForPurchaseApplication200ResponseInnerNotificationAtApproverAction
     */
    'approverUsers': Array<GetSlackNotificationSettingsForPurchaseApplication200ResponseInnerNotificationAtApproverActionApproverUsersInner>;
}
/**
 * 
 * @export
 * @interface GetSlackNotificationSettingsForPurchaseApplication200ResponseInnerNotificationAtApproverActionApplicantUsersInner
 */
export interface GetSlackNotificationSettingsForPurchaseApplication200ResponseInnerNotificationAtApproverActionApplicantUsersInner {
    /**
     * 
     * @type {string}
     * @memberof GetSlackNotificationSettingsForPurchaseApplication200ResponseInnerNotificationAtApproverActionApplicantUsersInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetSlackNotificationSettingsForPurchaseApplication200ResponseInnerNotificationAtApproverActionApplicantUsersInner
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetSlackNotificationSettingsForPurchaseApplication200ResponseInnerNotificationAtApproverActionApplicantUsersInner
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetSlackNotificationSettingsForPurchaseApplication200ResponseInnerNotificationAtApproverActionApplicantUsersInner
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof GetSlackNotificationSettingsForPurchaseApplication200ResponseInnerNotificationAtApproverActionApplicantUsersInner
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackNotificationSettingsForPurchaseApplication200ResponseInnerNotificationAtApproverActionApplicantUsersInner
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackNotificationSettingsForPurchaseApplication200ResponseInnerNotificationAtApproverActionApplicantUsersInner
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackNotificationSettingsForPurchaseApplication200ResponseInnerNotificationAtApproverActionApplicantUsersInner
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackNotificationSettingsForPurchaseApplication200ResponseInnerNotificationAtApproverActionApplicantUsersInner
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackNotificationSettingsForPurchaseApplication200ResponseInnerNotificationAtApproverActionApplicantUsersInner
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetSlackNotificationSettingsForPurchaseApplication200ResponseInnerNotificationAtApproverActionApplicantUsersInner
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface GetSlackNotificationSettingsForPurchaseApplication200ResponseInnerNotificationAtApproverActionApproverUsersInner
 */
export interface GetSlackNotificationSettingsForPurchaseApplication200ResponseInnerNotificationAtApproverActionApproverUsersInner {
    /**
     * 
     * @type {string}
     * @memberof GetSlackNotificationSettingsForPurchaseApplication200ResponseInnerNotificationAtApproverActionApproverUsersInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetSlackNotificationSettingsForPurchaseApplication200ResponseInnerNotificationAtApproverActionApproverUsersInner
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetSlackNotificationSettingsForPurchaseApplication200ResponseInnerNotificationAtApproverActionApproverUsersInner
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetSlackNotificationSettingsForPurchaseApplication200ResponseInnerNotificationAtApproverActionApproverUsersInner
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof GetSlackNotificationSettingsForPurchaseApplication200ResponseInnerNotificationAtApproverActionApproverUsersInner
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackNotificationSettingsForPurchaseApplication200ResponseInnerNotificationAtApproverActionApproverUsersInner
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackNotificationSettingsForPurchaseApplication200ResponseInnerNotificationAtApproverActionApproverUsersInner
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackNotificationSettingsForPurchaseApplication200ResponseInnerNotificationAtApproverActionApproverUsersInner
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackNotificationSettingsForPurchaseApplication200ResponseInnerNotificationAtApproverActionApproverUsersInner
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackNotificationSettingsForPurchaseApplication200ResponseInnerNotificationAtApproverActionApproverUsersInner
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetSlackNotificationSettingsForPurchaseApplication200ResponseInnerNotificationAtApproverActionApproverUsersInner
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface GetSlackNotificationSettingsForPurchaseApplication200ResponseInnerNotificationAtCreation
 */
export interface GetSlackNotificationSettingsForPurchaseApplication200ResponseInnerNotificationAtCreation {
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackNotificationSettingsForPurchaseApplication200ResponseInnerNotificationAtCreation
     */
    'isNotify': boolean;
    /**
     * 
     * @type {Array<GetSlackNotificationSettingsForPurchaseApplication200ResponseInnerNotificationAtCreationApplicantUsersInner>}
     * @memberof GetSlackNotificationSettingsForPurchaseApplication200ResponseInnerNotificationAtCreation
     */
    'applicantUsers': Array<GetSlackNotificationSettingsForPurchaseApplication200ResponseInnerNotificationAtCreationApplicantUsersInner>;
    /**
     * 
     * @type {Array<GetSlackNotificationSettingsForPurchaseApplication200ResponseInnerNotificationAtCreationApproverUsersInner>}
     * @memberof GetSlackNotificationSettingsForPurchaseApplication200ResponseInnerNotificationAtCreation
     */
    'approverUsers': Array<GetSlackNotificationSettingsForPurchaseApplication200ResponseInnerNotificationAtCreationApproverUsersInner>;
}
/**
 * 
 * @export
 * @interface GetSlackNotificationSettingsForPurchaseApplication200ResponseInnerNotificationAtCreationApplicantUsersInner
 */
export interface GetSlackNotificationSettingsForPurchaseApplication200ResponseInnerNotificationAtCreationApplicantUsersInner {
    /**
     * 
     * @type {string}
     * @memberof GetSlackNotificationSettingsForPurchaseApplication200ResponseInnerNotificationAtCreationApplicantUsersInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetSlackNotificationSettingsForPurchaseApplication200ResponseInnerNotificationAtCreationApplicantUsersInner
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetSlackNotificationSettingsForPurchaseApplication200ResponseInnerNotificationAtCreationApplicantUsersInner
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetSlackNotificationSettingsForPurchaseApplication200ResponseInnerNotificationAtCreationApplicantUsersInner
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof GetSlackNotificationSettingsForPurchaseApplication200ResponseInnerNotificationAtCreationApplicantUsersInner
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackNotificationSettingsForPurchaseApplication200ResponseInnerNotificationAtCreationApplicantUsersInner
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackNotificationSettingsForPurchaseApplication200ResponseInnerNotificationAtCreationApplicantUsersInner
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackNotificationSettingsForPurchaseApplication200ResponseInnerNotificationAtCreationApplicantUsersInner
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackNotificationSettingsForPurchaseApplication200ResponseInnerNotificationAtCreationApplicantUsersInner
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackNotificationSettingsForPurchaseApplication200ResponseInnerNotificationAtCreationApplicantUsersInner
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetSlackNotificationSettingsForPurchaseApplication200ResponseInnerNotificationAtCreationApplicantUsersInner
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface GetSlackNotificationSettingsForPurchaseApplication200ResponseInnerNotificationAtCreationApproverUsersInner
 */
export interface GetSlackNotificationSettingsForPurchaseApplication200ResponseInnerNotificationAtCreationApproverUsersInner {
    /**
     * 
     * @type {string}
     * @memberof GetSlackNotificationSettingsForPurchaseApplication200ResponseInnerNotificationAtCreationApproverUsersInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetSlackNotificationSettingsForPurchaseApplication200ResponseInnerNotificationAtCreationApproverUsersInner
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetSlackNotificationSettingsForPurchaseApplication200ResponseInnerNotificationAtCreationApproverUsersInner
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetSlackNotificationSettingsForPurchaseApplication200ResponseInnerNotificationAtCreationApproverUsersInner
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof GetSlackNotificationSettingsForPurchaseApplication200ResponseInnerNotificationAtCreationApproverUsersInner
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackNotificationSettingsForPurchaseApplication200ResponseInnerNotificationAtCreationApproverUsersInner
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackNotificationSettingsForPurchaseApplication200ResponseInnerNotificationAtCreationApproverUsersInner
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackNotificationSettingsForPurchaseApplication200ResponseInnerNotificationAtCreationApproverUsersInner
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackNotificationSettingsForPurchaseApplication200ResponseInnerNotificationAtCreationApproverUsersInner
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackNotificationSettingsForPurchaseApplication200ResponseInnerNotificationAtCreationApproverUsersInner
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetSlackNotificationSettingsForPurchaseApplication200ResponseInnerNotificationAtCreationApproverUsersInner
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface GetSlackTeam200Response
 */
export interface GetSlackTeam200Response {
    /**
     * 
     * @type {string}
     * @memberof GetSlackTeam200Response
     */
    'orgAccountId': string;
    /**
     * 
     * @type {string}
     * @memberof GetSlackTeam200Response
     */
    'slackTeamId': string;
    /**
     * 
     * @type {string}
     * @memberof GetSlackTeam200Response
     */
    'slackTeamName': string;
    /**
     * 
     * @type {string}
     * @memberof GetSlackTeam200Response
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof GetSlackTeam200Response
     */
    'tokenVersion': string;
    /**
     * 
     * @type {string}
     * @memberof GetSlackTeam200Response
     */
    'latestTokenVersion': string;
    /**
     * 
     * @type {string}
     * @memberof GetSlackTeam200Response
     */
    'tokenScope': string;
}
/**
 * 
 * @export
 * @interface GetSlackVersion200Response
 */
export interface GetSlackVersion200Response {
    /**
     * 
     * @type {string}
     * @memberof GetSlackVersion200Response
     */
    'latestTokenVersion': string;
    /**
     * 
     * @type {string}
     * @memberof GetSlackVersion200Response
     */
    'tokenScope': string;
}
/**
 * 
 * @export
 * @interface GetSubmittedTrustdockData200Response
 */
export interface GetSubmittedTrustdockData200Response {
    /**
     * 
     * @type {string}
     * @memberof GetSubmittedTrustdockData200Response
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetSubmittedTrustdockData200Response
     */
    'organizationName': string;
    /**
     * 
     * @type {string}
     * @memberof GetSubmittedTrustdockData200Response
     */
    'corporateNumber': string;
    /**
     * 
     * @type {string}
     * @memberof GetSubmittedTrustdockData200Response
     */
    'businessDescriptionName': string;
    /**
     * 
     * @type {string}
     * @memberof GetSubmittedTrustdockData200Response
     */
    'businessDescriptionId': string;
    /**
     * 
     * @type {string}
     * @memberof GetSubmittedTrustdockData200Response
     */
    'purposeTransaction': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetSubmittedTrustdockData200Response
     */
    'purposeTransactionOther': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetSubmittedTrustdockData200Response
     */
    'postalCode': string;
    /**
     * 
     * @type {string}
     * @memberof GetSubmittedTrustdockData200Response
     */
    'address': string;
    /**
     * 
     * @type {string}
     * @memberof GetSubmittedTrustdockData200Response
     */
    'phoneNumber': string;
    /**
     * 
     * @type {string}
     * @memberof GetSubmittedTrustdockData200Response
     */
    'representativeName': string;
    /**
     * 
     * @type {string}
     * @memberof GetSubmittedTrustdockData200Response
     */
    'bankName': string;
    /**
     * 
     * @type {string}
     * @memberof GetSubmittedTrustdockData200Response
     */
    'branchName': string;
    /**
     * 
     * @type {string}
     * @memberof GetSubmittedTrustdockData200Response
     */
    'bankAccountType': string;
    /**
     * 
     * @type {string}
     * @memberof GetSubmittedTrustdockData200Response
     */
    'bankAccountNumber': string;
    /**
     * 
     * @type {string}
     * @memberof GetSubmittedTrustdockData200Response
     */
    'bankAccountHolder': string;
    /**
     * 
     * @type {Array<GetSubmittedTrustdockData200ResponseOrganizationUsersInner>}
     * @memberof GetSubmittedTrustdockData200Response
     */
    'organizationUsers': Array<GetSubmittedTrustdockData200ResponseOrganizationUsersInner>;
    /**
     * 
     * @type {string}
     * @memberof GetSubmittedTrustdockData200Response
     */
    'vcCooperationPlan': string;
    /**
     * 
     * @type {string}
     * @memberof GetSubmittedTrustdockData200Response
     */
    'vcCooperationPlanRewardType': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetSubmittedTrustdockData200Response
     */
    'promotionCode': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetSubmittedTrustdockData200Response
     */
    'isSpecialOrganization': string;
    /**
     * 
     * @type {string}
     * @memberof GetSubmittedTrustdockData200Response
     */
    'corporateType': string | null;
    /**
     * 
     * @type {Array<GetSubmittedTrustdockData200ResponseBeneficialOwnersInner>}
     * @memberof GetSubmittedTrustdockData200Response
     */
    'beneficialOwners': Array<GetSubmittedTrustdockData200ResponseBeneficialOwnersInner> | null;
    /**
     * 
     * @type {string}
     * @memberof GetSubmittedTrustdockData200Response
     */
    'isRepresentative': string;
    /**
     * 
     * @type {string}
     * @memberof GetSubmittedTrustdockData200Response
     */
    'transactionManagerName': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetSubmittedTrustdockData200Response
     */
    'transactionManagerBirthday': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetSubmittedTrustdockData200Response
     */
    'transactionManagerAddress': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetSubmittedTrustdockData200Response
     */
    'transactionManagerEmail': string | null;
}
/**
 * 
 * @export
 * @interface GetSubmittedTrustdockData200ResponseBeneficialOwnersInner
 */
export interface GetSubmittedTrustdockData200ResponseBeneficialOwnersInner {
    /**
     * 
     * @type {string}
     * @memberof GetSubmittedTrustdockData200ResponseBeneficialOwnersInner
     */
    'corporateRelationships'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetSubmittedTrustdockData200ResponseBeneficialOwnersInner
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetSubmittedTrustdockData200ResponseBeneficialOwnersInner
     */
    'beneficialOwnerType': string;
    /**
     * 
     * @type {string}
     * @memberof GetSubmittedTrustdockData200ResponseBeneficialOwnersInner
     */
    'gender': string;
    /**
     * 
     * @type {string}
     * @memberof GetSubmittedTrustdockData200ResponseBeneficialOwnersInner
     */
    'birthday': string;
    /**
     * 
     * @type {string}
     * @memberof GetSubmittedTrustdockData200ResponseBeneficialOwnersInner
     */
    'countryResidence': string;
    /**
     * 
     * @type {string}
     * @memberof GetSubmittedTrustdockData200ResponseBeneficialOwnersInner
     */
    'address': string;
    /**
     * 
     * @type {string}
     * @memberof GetSubmittedTrustdockData200ResponseBeneficialOwnersInner
     */
    'isPoliticallyExposedPersons': string;
}
/**
 * 
 * @export
 * @interface GetSubmittedTrustdockData200ResponseOrganizationUsersInner
 */
export interface GetSubmittedTrustdockData200ResponseOrganizationUsersInner {
    /**
     * 
     * @type {string}
     * @memberof GetSubmittedTrustdockData200ResponseOrganizationUsersInner
     */
    'userName': string;
    /**
     * 
     * @type {string}
     * @memberof GetSubmittedTrustdockData200ResponseOrganizationUsersInner
     */
    'userMailAddress': string;
    /**
     * 
     * @type {string}
     * @memberof GetSubmittedTrustdockData200ResponseOrganizationUsersInner
     */
    'userPrivilege': GetSubmittedTrustdockData200ResponseOrganizationUsersInnerUserPrivilegeEnum;
}

export const GetSubmittedTrustdockData200ResponseOrganizationUsersInnerUserPrivilegeEnum = {
    generalUser: 'GENERAL_USER',
    organizationAdmin: 'ORGANIZATION_ADMIN',
    viewer: 'VIEWER',
    bookkeeper: 'BOOKKEEPER'
} as const;

export type GetSubmittedTrustdockData200ResponseOrganizationUsersInnerUserPrivilegeEnum = typeof GetSubmittedTrustdockData200ResponseOrganizationUsersInnerUserPrivilegeEnum[keyof typeof GetSubmittedTrustdockData200ResponseOrganizationUsersInnerUserPrivilegeEnum];

/**
 * 
 * @export
 * @interface GetSuspiciousTransactions200Response
 */
export interface GetSuspiciousTransactions200Response {
    /**
     * 
     * @type {number}
     * @memberof GetSuspiciousTransactions200Response
     */
    'amount': number;
    /**
     * 
     * @type {Array<GetSuspiciousTransactions200ResponseTransactionDetailListInner>}
     * @memberof GetSuspiciousTransactions200Response
     */
    'transactionDetailList': Array<GetSuspiciousTransactions200ResponseTransactionDetailListInner>;
}
/**
 * @type GetSuspiciousTransactions200ResponseTransactionDetailListInner
 * @export
 */
export type GetSuspiciousTransactions200ResponseTransactionDetailListInner = GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf | GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1;

/**
 * 
 * @export
 * @interface GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf
 */
export interface GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf {
    /**
     * 
     * @type {GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransaction}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf
     */
    'cardTransaction': GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransaction;
    /**
     * 
     * @type {GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransactionEvidenceStatus}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf
     */
    'cardTransactionEvidenceStatus': GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransactionEvidenceStatus;
    /**
     * 
     * @type {Array<GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInner>}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf
     */
    'evidenceList': Array<GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInner>;
    /**
     * 
     * @type {Array<GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfRequestHistoryInner>}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf
     */
    'requestHistory': Array<GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfRequestHistoryInner>;
    /**
     * 
     * @type {GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfComment}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf
     */
    'comment'?: GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfComment;
    /**
     * 
     * @type {GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceRemindStatus}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf
     */
    'evidenceRemindStatus': GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceRemindStatus;
    /**
     * 
     * @type {GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfUserAccount}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf
     */
    'userAccount': GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfUserAccount;
    /**
     * 
     * @type {Array<GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfPurchaseApplicationsInner>}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf
     */
    'purchaseApplications': Array<GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfPurchaseApplicationsInner>;
}
/**
 * 
 * @export
 * @interface GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1
 */
export interface GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1 {
    /**
     * 
     * @type {GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1CardTransaction}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1
     */
    'cardTransaction': GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1CardTransaction;
    /**
     * 
     * @type {GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1Comment}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1
     */
    'comment'?: GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1Comment;
    /**
     * 
     * @type {GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1UserAccount}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1
     */
    'userAccount': GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1UserAccount;
}
/**
 * 
 * @export
 * @interface GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1CardTransaction
 */
export interface GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1CardTransaction {
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1CardTransaction
     */
    'visaTransactionReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1CardTransaction
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1CardTransaction
     */
    'merchantName': string;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1CardTransaction
     */
    'merchantNameKana': string;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1CardTransaction
     */
    'merchantNameKanji': string;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1CardTransaction
     */
    'mergedMerchantName': string;
    /**
     * 
     * @type {number}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1CardTransaction
     */
    'amount': number;
    /**
     * 
     * @type {number}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1CardTransaction
     */
    'amountFx': number;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1CardTransaction
     */
    'currencyCode': string;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1CardTransaction
     */
    'failureReason': string;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1CardTransaction
     */
    'processedAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1CardTransaction
     */
    'transactionType': GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1CardTransactionTransactionTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1CardTransaction
     */
    'transactionStatus': GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1CardTransactionTransactionStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1CardTransaction
     */
    'creditSettlement': number;
    /**
     * 
     * @type {Array<GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1CardTransactionTransactionRecordListInner>}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1CardTransaction
     */
    'transactionRecordList': Array<GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1CardTransactionTransactionRecordListInner>;
}

export const GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1CardTransactionTransactionTypeEnum = {
    confirm: 'CONFIRM',
    notConfirm: 'NOT_CONFIRM'
} as const;

export type GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1CardTransactionTransactionTypeEnum = typeof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1CardTransactionTransactionTypeEnum[keyof typeof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1CardTransactionTransactionTypeEnum];
export const GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1CardTransactionTransactionStatusEnum = {
    fail: 'FAIL'
} as const;

export type GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1CardTransactionTransactionStatusEnum = typeof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1CardTransactionTransactionStatusEnum[keyof typeof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1CardTransactionTransactionStatusEnum];

/**
 * 
 * @export
 * @interface GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1CardTransactionTransactionRecordListInner
 */
export interface GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1CardTransactionTransactionRecordListInner {
    /**
     * 
     * @type {number}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1CardTransactionTransactionRecordListInner
     */
    'amount': number;
    /**
     * 
     * @type {number}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1CardTransactionTransactionRecordListInner
     */
    'amountFx': number;
    /**
     * 
     * @type {number}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1CardTransactionTransactionRecordListInner
     */
    'totalAmount': number;
    /**
     * 
     * @type {number}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1CardTransactionTransactionRecordListInner
     */
    'totalAmountFx': number;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1CardTransactionTransactionRecordListInner
     */
    'currencyCode': string;
    /**
     * 
     * @type {number}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1CardTransactionTransactionRecordListInner
     */
    'fxRate': number | null;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1CardTransactionTransactionRecordListInner
     */
    'processedAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1CardTransactionTransactionRecordListInner
     */
    'transactionDetailType': GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1CardTransactionTransactionRecordListInnerTransactionDetailTypeEnum;
}

export const GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1CardTransactionTransactionRecordListInnerTransactionDetailTypeEnum = {
    purchase: 'PURCHASE',
    settlement: 'SETTLEMENT',
    validation: 'VALIDATION',
    refund: 'REFUND',
    cancel: 'CANCEL',
    refundCancel: 'REFUND_CANCEL',
    refundPartialCancel: 'REFUND_PARTIAL_CANCEL'
} as const;

export type GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1CardTransactionTransactionRecordListInnerTransactionDetailTypeEnum = typeof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1CardTransactionTransactionRecordListInnerTransactionDetailTypeEnum[keyof typeof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1CardTransactionTransactionRecordListInnerTransactionDetailTypeEnum];

/**
 * 
 * @export
 * @interface GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1Comment
 */
export interface GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1Comment {
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1Comment
     */
    'cardTransactionCommentId': string;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1Comment
     */
    'visaTransactionReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1Comment
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1Comment
     */
    'comment': string;
    /**
     * 
     * @type {GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1CommentCreatedBy}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1Comment
     */
    'createdBy': GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1CommentCreatedBy;
}
/**
 * 
 * @export
 * @interface GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1CommentCreatedBy
 */
export interface GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1CommentCreatedBy {
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1CommentCreatedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1CommentCreatedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1UserAccount
 */
export interface GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1UserAccount {
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1UserAccount
     */
    'userAccountId': string;
    /**
     * 
     * @type {GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1UserAccountUser}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1UserAccount
     */
    'user': GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1UserAccountUser;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1UserAccount
     */
    'cardLabel': string;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1UserAccount
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1UserAccount
     */
    'organizationName': string;
    /**
     * 
     * @type {GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1UserAccountUserAccountGroup}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1UserAccount
     */
    'userAccountGroup': GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1UserAccountUserAccountGroup | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1UserAccount
     */
    'isOnDemand': boolean;
}
/**
 * 
 * @export
 * @interface GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1UserAccountUser
 */
export interface GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1UserAccountUser {
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1UserAccountUser
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1UserAccountUser
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1UserAccountUser
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1UserAccountUser
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1UserAccountUser
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1UserAccountUser
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1UserAccountUser
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1UserAccountUser
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1UserAccountUser
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1UserAccountUser
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1UserAccountUser
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1UserAccountUserAccountGroup
 */
export interface GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1UserAccountUserAccountGroup {
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1UserAccountUserAccountGroup
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1UserAccountUserAccountGroup
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOf1UserAccountUserAccountGroup
     */
    'sortNum': number;
}
/**
 * 
 * @export
 * @interface GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransaction
 */
export interface GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransaction {
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransaction
     */
    'visaTransactionReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransaction
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransaction
     */
    'merchantName': string;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransaction
     */
    'merchantNameKana': string;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransaction
     */
    'merchantNameKanji': string;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransaction
     */
    'mergedMerchantName': string;
    /**
     * 
     * @type {number}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransaction
     */
    'amount': number;
    /**
     * 
     * @type {number}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransaction
     */
    'amountFx': number;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransaction
     */
    'currencyCode': string;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransaction
     */
    'processedAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransaction
     */
    'transactionType': GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransactionTransactionTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransaction
     */
    'transactionStatus': GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransactionTransactionStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransaction
     */
    'creditSettlement': number;
    /**
     * 
     * @type {Array<GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransactionTransactionRecordListInner>}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransaction
     */
    'transactionRecordList': Array<GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransactionTransactionRecordListInner>;
    /**
     * 
     * @type {boolean}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransaction
     */
    'isCleared': boolean;
}

export const GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransactionTransactionTypeEnum = {
    confirm: 'CONFIRM',
    notConfirm: 'NOT_CONFIRM'
} as const;

export type GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransactionTransactionTypeEnum = typeof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransactionTransactionTypeEnum[keyof typeof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransactionTransactionTypeEnum];
export const GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransactionTransactionStatusEnum = {
    success: 'SUCCESS'
} as const;

export type GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransactionTransactionStatusEnum = typeof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransactionTransactionStatusEnum[keyof typeof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransactionTransactionStatusEnum];

/**
 * 
 * @export
 * @interface GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransactionEvidenceStatus
 */
export interface GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransactionEvidenceStatus {
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransactionEvidenceStatus
     */
    'visaTransactionReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransactionEvidenceStatus
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransactionEvidenceStatus
     */
    'isRequested': boolean;
    /**
     * 
     * @type {GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransactionEvidenceStatusRequestedBy}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransactionEvidenceStatus
     */
    'requestedBy': GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransactionEvidenceStatusRequestedBy | null;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransactionEvidenceStatus
     */
    'requestedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransactionEvidenceStatus
     */
    'isLocked': boolean;
    /**
     * 
     * @type {GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransactionEvidenceStatusLockedBy}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransactionEvidenceStatus
     */
    'lockedBy': GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransactionEvidenceStatusLockedBy | null;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransactionEvidenceStatus
     */
    'lockedAt': string;
}
/**
 * 
 * @export
 * @interface GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransactionEvidenceStatusLockedBy
 */
export interface GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransactionEvidenceStatusLockedBy {
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransactionEvidenceStatusLockedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransactionEvidenceStatusLockedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransactionEvidenceStatusRequestedBy
 */
export interface GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransactionEvidenceStatusRequestedBy {
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransactionEvidenceStatusRequestedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransactionEvidenceStatusRequestedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransactionTransactionRecordListInner
 */
export interface GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransactionTransactionRecordListInner {
    /**
     * 
     * @type {number}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransactionTransactionRecordListInner
     */
    'amount': number;
    /**
     * 
     * @type {number}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransactionTransactionRecordListInner
     */
    'amountFx': number;
    /**
     * 
     * @type {number}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransactionTransactionRecordListInner
     */
    'totalAmount': number;
    /**
     * 
     * @type {number}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransactionTransactionRecordListInner
     */
    'totalAmountFx': number;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransactionTransactionRecordListInner
     */
    'currencyCode': string;
    /**
     * 
     * @type {number}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransactionTransactionRecordListInner
     */
    'fxRate': number | null;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransactionTransactionRecordListInner
     */
    'processedAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransactionTransactionRecordListInner
     */
    'transactionDetailType': GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransactionTransactionRecordListInner
     */
    'isCleared': boolean;
}

export const GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum = {
    purchase: 'PURCHASE',
    settlement: 'SETTLEMENT',
    validation: 'VALIDATION',
    refund: 'REFUND',
    cancel: 'CANCEL',
    refundCancel: 'REFUND_CANCEL',
    refundPartialCancel: 'REFUND_PARTIAL_CANCEL'
} as const;

export type GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum = typeof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum[keyof typeof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum];

/**
 * 
 * @export
 * @interface GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfComment
 */
export interface GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfComment {
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfComment
     */
    'cardTransactionCommentId': string;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfComment
     */
    'visaTransactionReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfComment
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfComment
     */
    'comment': string;
    /**
     * 
     * @type {GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCommentCreatedBy}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfComment
     */
    'createdBy': GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCommentCreatedBy;
}
/**
 * 
 * @export
 * @interface GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCommentCreatedBy
 */
export interface GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCommentCreatedBy {
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCommentCreatedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCommentCreatedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInner
 */
export interface GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInner {
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInner
     * @deprecated
     */
    'cardTransactionEvidenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInner
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInner
     * @deprecated
     */
    'visaTransactionReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInner
     */
    'paymentType': GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerPaymentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInner
     */
    'fileName': string;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInner
     */
    'fileExtension': string;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInner
     */
    'electronicMethod': GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerElectronicMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInner
     */
    'documentSize': GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerDocumentSizeEnum;
    /**
     * 
     * @type {number}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInner
     * @deprecated
     */
    'dpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInner
     */
    'detectedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInner
     */
    'calculatedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInner
     */
    'colorGradation': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInner
     */
    'verticalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInner
     */
    'horizontalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInner
     */
    'heightMillis': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInner
     */
    'widthMillis': number | null;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInner
     */
    'legalValidity': GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerLegalValidityEnum;
    /**
     * 
     * @type {boolean}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInner
     */
    'dpiForciblyValid': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInner
     */
    'colorGradationForciblyValid': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInner
     */
    'note': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInner
     */
    'irrelevantToLedger': boolean;
    /**
     * 
     * @type {GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerInvoiceIssuer}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInner
     */
    'invoiceIssuer': GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerInvoiceIssuer | null;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInner
     * @deprecated
     */
    'dpiError': GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerDpiErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInner
     * @deprecated
     */
    'detectedDpiError': GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerDetectedDpiErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInner
     * @deprecated
     */
    'calculatedDpiError': GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerCalculatedDpiErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInner
     * @deprecated
     */
    'colorGradationError': GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerColorGradationErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInner
     * @deprecated
     */
    'heightMillisError': GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerHeightMillisErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInner
     * @deprecated
     */
    'widthMillisError': GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerWidthMillisErrorEnum;
    /**
     * 
     * @type {GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerErrors}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInner
     */
    'errors': GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerErrors;
    /**
     * 
     * @type {GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerWarnings}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInner
     */
    'warnings': GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerWarnings;
    /**
     * 
     * @type {GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerCreatedBy}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInner
     */
    'createdBy': GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerCreatedBy;
    /**
     * 
     * @type {GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerUpdatedBy}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInner
     */
    'updatedBy': GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerUpdatedBy;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInner
     */
    'updatedAt': string;
    /**
     * 
     * @type {GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerUploadedBy}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInner
     */
    'uploadedBy': GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerUploadedBy;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInner
     */
    'uploadedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInner
     */
    'uploadedByRecipient': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInner
     */
    'needsMigration': boolean | null;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInner
     */
    'uploadedFrom': string;
}

export const GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerPaymentTypeEnum = {
    cardTransaction: 'CARD_TRANSACTION',
    paymentRequest: 'PAYMENT_REQUEST'
} as const;

export type GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerPaymentTypeEnum = typeof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerPaymentTypeEnum[keyof typeof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerPaymentTypeEnum];
export const GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerElectronicMethodEnum = {
    fullElectronic: 'FULL_ELECTRONIC',
    originallyPaper: 'ORIGINALLY_PAPER',
    unknown: 'UNKNOWN'
} as const;

export type GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerElectronicMethodEnum = typeof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerElectronicMethodEnum[keyof typeof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerElectronicMethodEnum];
export const GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerDocumentSizeEnum = {
    overA4: 'OVER_A4',
    a4OrSmaller: 'A4_OR_SMALLER',
    unknown: 'UNKNOWN'
} as const;

export type GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerDocumentSizeEnum = typeof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerDocumentSizeEnum[keyof typeof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerDocumentSizeEnum];
export const GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerLegalValidityEnum = {
    valid: 'VALID',
    invalid: 'INVALID',
    inputRequired: 'INPUT_REQUIRED',
    outOfTarget: 'OUT_OF_TARGET'
} as const;

export type GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerLegalValidityEnum = typeof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerLegalValidityEnum[keyof typeof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerLegalValidityEnum];
export const GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerDpiErrorEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerDpiErrorEnum = typeof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerDpiErrorEnum[keyof typeof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerDpiErrorEnum];
export const GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerDetectedDpiErrorEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerDetectedDpiErrorEnum = typeof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerDetectedDpiErrorEnum[keyof typeof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerDetectedDpiErrorEnum];
export const GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerCalculatedDpiErrorEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerCalculatedDpiErrorEnum = typeof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerCalculatedDpiErrorEnum[keyof typeof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerCalculatedDpiErrorEnum];
export const GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerColorGradationErrorEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerColorGradationErrorEnum = typeof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerColorGradationErrorEnum[keyof typeof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerColorGradationErrorEnum];
export const GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerHeightMillisErrorEnum = {
    required: 'REQUIRED'
} as const;

export type GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerHeightMillisErrorEnum = typeof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerHeightMillisErrorEnum[keyof typeof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerHeightMillisErrorEnum];
export const GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerWidthMillisErrorEnum = {
    required: 'REQUIRED'
} as const;

export type GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerWidthMillisErrorEnum = typeof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerWidthMillisErrorEnum[keyof typeof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerWidthMillisErrorEnum];

/**
 * 
 * @export
 * @interface GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerCreatedBy
 */
export interface GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerCreatedBy {
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerCreatedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerCreatedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerErrors
 */
export interface GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerErrors {
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerErrors
     */
    'detectedDpi'?: GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerErrorsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerErrors
     */
    'calculatedDpi'?: GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerErrorsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerErrors
     */
    'colorGradation'?: GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerErrorsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerErrors
     */
    'heightMillis'?: GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerErrorsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerErrors
     */
    'widthMillis'?: GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerErrorsWidthMillisEnum;
}

export const GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerErrorsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerErrorsDetectedDpiEnum = typeof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerErrorsDetectedDpiEnum[keyof typeof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerErrorsDetectedDpiEnum];
export const GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerErrorsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerErrorsCalculatedDpiEnum = typeof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerErrorsCalculatedDpiEnum[keyof typeof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerErrorsCalculatedDpiEnum];
export const GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerErrorsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerErrorsColorGradationEnum = typeof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerErrorsColorGradationEnum[keyof typeof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerErrorsColorGradationEnum];
export const GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerErrorsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerErrorsHeightMillisEnum = typeof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerErrorsHeightMillisEnum[keyof typeof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerErrorsHeightMillisEnum];
export const GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerErrorsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerErrorsWidthMillisEnum = typeof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerErrorsWidthMillisEnum[keyof typeof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerErrorsWidthMillisEnum];

/**
 * Set null if it\'s evidence not analyzed using invoicing-system-compliance feature. Also set null if invoicing-system-compliance feature has been made not available for the organization by the feature-flag.
 * @export
 * @interface GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerInvoiceIssuer
 */
export interface GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerInvoiceIssuer {
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerInvoiceIssuer
     */
    'name': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerInvoiceIssuer
     */
    'registrationNumber': string | null;
    /**
     * isQualified retains the result of querying the 国税庁API to see if registrationNumber is qualified, as is.
     * @type {boolean}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerInvoiceIssuer
     */
    'isQualified': boolean;
    /**
     * AsQualified indicates whether this issuer should be treated as a qualified invoice issuer within the user\'s system, even if the RegistrationNumber is not confirmed as qualified in the National Tax Agency\'s business registration system.
     * @type {boolean}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerInvoiceIssuer
     */
    'asQualified': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerInvoiceIssuer
     */
    'partnerId': string | null;
}
/**
 * 
 * @export
 * @interface GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerUpdatedBy
 */
export interface GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerUpdatedBy {
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerUpdatedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerUpdatedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerUploadedBy
 */
export interface GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerUploadedBy {
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerUploadedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerUploadedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerWarnings
 */
export interface GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerWarnings {
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerWarnings
     */
    'detectedDpi'?: GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerWarningsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerWarnings
     */
    'calculatedDpi'?: GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerWarningsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerWarnings
     */
    'colorGradation'?: GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerWarningsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerWarnings
     */
    'heightMillis'?: GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerWarningsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerWarnings
     */
    'widthMillis'?: GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerWarningsWidthMillisEnum;
}

export const GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerWarningsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerWarningsDetectedDpiEnum = typeof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerWarningsDetectedDpiEnum[keyof typeof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerWarningsDetectedDpiEnum];
export const GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerWarningsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerWarningsCalculatedDpiEnum = typeof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerWarningsCalculatedDpiEnum[keyof typeof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerWarningsCalculatedDpiEnum];
export const GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerWarningsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerWarningsColorGradationEnum = typeof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerWarningsColorGradationEnum[keyof typeof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerWarningsColorGradationEnum];
export const GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerWarningsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerWarningsHeightMillisEnum = typeof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerWarningsHeightMillisEnum[keyof typeof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerWarningsHeightMillisEnum];
export const GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerWarningsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerWarningsWidthMillisEnum = typeof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerWarningsWidthMillisEnum[keyof typeof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerWarningsWidthMillisEnum];

/**
 * 
 * @export
 * @interface GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceRemindStatus
 */
export interface GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceRemindStatus {
    /**
     * 
     * @type {boolean}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceRemindStatus
     */
    'isAutoRemind': boolean;
}
/**
 * 
 * @export
 * @interface GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfPurchaseApplicationsInner
 */
export interface GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfPurchaseApplicationsInner {
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfPurchaseApplicationsInner
     */
    'applicationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfPurchaseApplicationsInner
     */
    'applicationNumber': string;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfPurchaseApplicationsInner
     */
    'paymentDate': string;
    /**
     * 
     * @type {GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfPurchaseApplicationsInnerSubmittedBy}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfPurchaseApplicationsInner
     */
    'submittedBy': GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfPurchaseApplicationsInnerSubmittedBy;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfPurchaseApplicationsInner
     */
    'submittedAt': string;
    /**
     * 
     * @type {Array<GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfPurchaseApplicationsInnerApproversInner>}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfPurchaseApplicationsInner
     */
    'approvers': Array<GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfPurchaseApplicationsInnerApproversInner>;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfPurchaseApplicationsInner
     */
    'department': string;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfPurchaseApplicationsInner
     */
    'purchaseReason': string;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfPurchaseApplicationsInner
     */
    'purchaseDetails': string;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfPurchaseApplicationsInner
     */
    'placeOfUse': string;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfPurchaseApplicationsInner
     */
    'purposeOfUse': string;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfPurchaseApplicationsInner
     */
    'url': string;
    /**
     * 
     * @type {number}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfPurchaseApplicationsInner
     */
    'amount': number;
    /**
     * 
     * @type {GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfPurchaseApplicationsInnerUserAccount}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfPurchaseApplicationsInner
     */
    'userAccount': GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfPurchaseApplicationsInnerUserAccount | null;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfPurchaseApplicationsInner
     */
    'remarks': string;
    /**
     * 
     * @type {GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfPurchaseApplicationsInnerWorkRequestedBy}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfPurchaseApplicationsInner
     */
    'workRequestedBy': GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfPurchaseApplicationsInnerWorkRequestedBy;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfPurchaseApplicationsInner
     */
    'workRequestApprovers': string;
    /**
     * 
     * @type {GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfPurchaseApplicationsInnerStatus}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfPurchaseApplicationsInner
     */
    'status': GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfPurchaseApplicationsInnerStatus;
    /**
     * 
     * @type {GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfPurchaseApplicationsInnerCreatedBy}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfPurchaseApplicationsInner
     */
    'createdBy': GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfPurchaseApplicationsInnerCreatedBy;
}
/**
 * 
 * @export
 * @interface GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfPurchaseApplicationsInnerApproversInner
 */
export interface GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfPurchaseApplicationsInnerApproversInner {
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfPurchaseApplicationsInnerApproversInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfPurchaseApplicationsInnerApproversInner
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfPurchaseApplicationsInnerCreatedBy
 */
export interface GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfPurchaseApplicationsInnerCreatedBy {
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfPurchaseApplicationsInnerCreatedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfPurchaseApplicationsInnerCreatedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfPurchaseApplicationsInnerStatus
 */
export interface GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfPurchaseApplicationsInnerStatus {
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfPurchaseApplicationsInnerStatus
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfPurchaseApplicationsInnerStatus
     */
    'comment': string;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfPurchaseApplicationsInnerStatus
     */
    'statusChangedAt': string;
    /**
     * 
     * @type {GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfPurchaseApplicationsInnerStatusCreatedBy}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfPurchaseApplicationsInnerStatus
     */
    'createdBy': GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfPurchaseApplicationsInnerStatusCreatedBy;
}
/**
 * 
 * @export
 * @interface GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfPurchaseApplicationsInnerStatusCreatedBy
 */
export interface GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfPurchaseApplicationsInnerStatusCreatedBy {
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfPurchaseApplicationsInnerStatusCreatedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfPurchaseApplicationsInnerStatusCreatedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfPurchaseApplicationsInnerSubmittedBy
 */
export interface GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfPurchaseApplicationsInnerSubmittedBy {
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfPurchaseApplicationsInnerSubmittedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfPurchaseApplicationsInnerSubmittedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfPurchaseApplicationsInnerUserAccount
 */
export interface GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfPurchaseApplicationsInnerUserAccount {
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfPurchaseApplicationsInnerUserAccount
     */
    'userAccountId': string;
    /**
     * 
     * @type {GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfPurchaseApplicationsInnerUserAccountUser}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfPurchaseApplicationsInnerUserAccount
     */
    'user': GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfPurchaseApplicationsInnerUserAccountUser;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfPurchaseApplicationsInnerUserAccount
     */
    'cardLabel': string;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfPurchaseApplicationsInnerUserAccount
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfPurchaseApplicationsInnerUserAccount
     */
    'organizationName': string;
    /**
     * 
     * @type {GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfPurchaseApplicationsInnerUserAccountUserAccountGroup}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfPurchaseApplicationsInnerUserAccount
     */
    'userAccountGroup': GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfPurchaseApplicationsInnerUserAccountUserAccountGroup | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfPurchaseApplicationsInnerUserAccount
     */
    'isOnDemand': boolean;
}
/**
 * 
 * @export
 * @interface GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfPurchaseApplicationsInnerUserAccountUser
 */
export interface GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfPurchaseApplicationsInnerUserAccountUser {
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfPurchaseApplicationsInnerUserAccountUser
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfPurchaseApplicationsInnerUserAccountUser
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfPurchaseApplicationsInnerUserAccountUser
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfPurchaseApplicationsInnerUserAccountUser
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfPurchaseApplicationsInnerUserAccountUser
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfPurchaseApplicationsInnerUserAccountUser
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfPurchaseApplicationsInnerUserAccountUser
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfPurchaseApplicationsInnerUserAccountUser
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfPurchaseApplicationsInnerUserAccountUser
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfPurchaseApplicationsInnerUserAccountUser
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfPurchaseApplicationsInnerUserAccountUser
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfPurchaseApplicationsInnerUserAccountUserAccountGroup
 */
export interface GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfPurchaseApplicationsInnerUserAccountUserAccountGroup {
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfPurchaseApplicationsInnerUserAccountUserAccountGroup
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfPurchaseApplicationsInnerUserAccountUserAccountGroup
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfPurchaseApplicationsInnerUserAccountUserAccountGroup
     */
    'sortNum': number;
}
/**
 * 
 * @export
 * @interface GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfPurchaseApplicationsInnerWorkRequestedBy
 */
export interface GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfPurchaseApplicationsInnerWorkRequestedBy {
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfPurchaseApplicationsInnerWorkRequestedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfPurchaseApplicationsInnerWorkRequestedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfRequestHistoryInner
 */
export interface GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfRequestHistoryInner {
    /**
     * 
     * @type {number}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfRequestHistoryInner
     */
    'requestId': number;
    /**
     * 
     * @type {GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfRequestHistoryInnerRequestedBy}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfRequestHistoryInner
     */
    'requestedBy': GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfRequestHistoryInnerRequestedBy;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfRequestHistoryInner
     */
    'requestedAt': string;
}
/**
 * 
 * @export
 * @interface GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfRequestHistoryInnerRequestedBy
 */
export interface GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfRequestHistoryInnerRequestedBy {
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfRequestHistoryInnerRequestedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfRequestHistoryInnerRequestedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfUserAccount
 */
export interface GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfUserAccount {
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfUserAccount
     */
    'userAccountId': string;
    /**
     * 
     * @type {GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfUserAccountUser}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfUserAccount
     */
    'user': GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfUserAccountUser;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfUserAccount
     */
    'cardLabel': string;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfUserAccount
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfUserAccount
     */
    'organizationName': string;
    /**
     * 
     * @type {GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfUserAccountUserAccountGroup}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfUserAccount
     */
    'userAccountGroup': GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfUserAccountUserAccountGroup | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfUserAccount
     */
    'isOnDemand': boolean;
}
/**
 * 
 * @export
 * @interface GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfUserAccountUser
 */
export interface GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfUserAccountUser {
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfUserAccountUser
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfUserAccountUser
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfUserAccountUser
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfUserAccountUser
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfUserAccountUser
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfUserAccountUser
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfUserAccountUser
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfUserAccountUser
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfUserAccountUser
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfUserAccountUser
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfUserAccountUser
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfUserAccountUserAccountGroup
 */
export interface GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfUserAccountUserAccountGroup {
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfUserAccountUserAccountGroup
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfUserAccountUserAccountGroup
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfUserAccountUserAccountGroup
     */
    'sortNum': number;
}
/**
 * 
 * @export
 * @interface GetTeamsCardNotificationSettings200ResponseInner
 */
export interface GetTeamsCardNotificationSettings200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetTeamsCardNotificationSettings200ResponseInner
     */
    'channelId': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetTeamsCardNotificationSettings200ResponseInner
     */
    'transactionTypes': Array<GetTeamsCardNotificationSettings200ResponseInnerTransactionTypesEnum>;
    /**
     * 
     * @type {number}
     * @memberof GetTeamsCardNotificationSettings200ResponseInner
     */
    'largeAmountThreshold': number | null;
    /**
     * 
     * @type {Array<GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInner>}
     * @memberof GetTeamsCardNotificationSettings200ResponseInner
     */
    'userAccounts': Array<GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInner>;
    /**
     * 
     * @type {Array<GetTeamsCardNotificationSettings200ResponseInnerUserAccountGroupsInner>}
     * @memberof GetTeamsCardNotificationSettings200ResponseInner
     */
    'userAccountGroups': Array<GetTeamsCardNotificationSettings200ResponseInnerUserAccountGroupsInner>;
    /**
     * 
     * @type {boolean}
     * @memberof GetTeamsCardNotificationSettings200ResponseInner
     */
    'isAllUserAccount': boolean;
}

export const GetTeamsCardNotificationSettings200ResponseInnerTransactionTypesEnum = {
    unknownTransactionType: 'UNKNOWN_TRANSACTION_TYPE',
    successfulTransaction: 'SUCCESSFUL_TRANSACTION',
    incorrectCardInput: 'INCORRECT_CARD_INPUT',
    insufficientBalance: 'INSUFFICIENT_BALANCE',
    otherError: 'OTHER_ERROR',
    potentialFraud: 'POTENTIAL_FRAUD',
    criticalError: 'CRITICAL_ERROR',
    unusualUser: 'UNUSUAL_USER',
    limitationByUser: 'LIMITATION_BY_USER',
    unsupportedTransaction: 'UNSUPPORTED_TRANSACTION',
    carelessUser: 'CARELESS_USER'
} as const;

export type GetTeamsCardNotificationSettings200ResponseInnerTransactionTypesEnum = typeof GetTeamsCardNotificationSettings200ResponseInnerTransactionTypesEnum[keyof typeof GetTeamsCardNotificationSettings200ResponseInnerTransactionTypesEnum];

/**
 * 
 * @export
 * @interface GetTeamsCardNotificationSettings200ResponseInnerUserAccountGroupsInner
 */
export interface GetTeamsCardNotificationSettings200ResponseInnerUserAccountGroupsInner {
    /**
     * 
     * @type {string}
     * @memberof GetTeamsCardNotificationSettings200ResponseInnerUserAccountGroupsInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetTeamsCardNotificationSettings200ResponseInnerUserAccountGroupsInner
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof GetTeamsCardNotificationSettings200ResponseInnerUserAccountGroupsInner
     */
    'sortNum': number;
}
/**
 * 
 * @export
 * @interface GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInner
 */
export interface GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInner {
    /**
     * 
     * @type {string}
     * @memberof GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'cardId': string;
    /**
     * 
     * @type {string}
     * @memberof GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'cardLabel': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'isActivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'isDeactivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'isLocked': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'isSuspended': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'isFrozen': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'isVirtualCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'isCreditCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'isOnDemand': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'isMetalCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'isPhysicalStorePaymentDisabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'panLastFourDigits': string;
    /**
     * 
     * @type {string}
     * @memberof GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'userAccountId': string;
    /**
     * 
     * @type {number}
     * @memberof GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'transactionUpperLimit': number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'availableCurrencies': Array<GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInnerAvailableCurrenciesEnum>;
    /**
     * 
     * @type {Array<GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInnerAvailableMerchantCategoriesInner>}
     * @memberof GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'availableMerchantCategories': Array<GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInnerAvailableMerchantCategoriesInner> | null;
    /**
     * 
     * @type {GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInnerUser}
     * @memberof GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'user': GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInnerUser;
    /**
     * 
     * @type {GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInnerUserAccountGroup}
     * @memberof GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'userAccountGroup'?: GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInnerUserAccountGroup | null;
    /**
     * 
     * @type {number}
     * @memberof GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'monthlyTotalUsage': number;
    /**
     * 
     * @type {number}
     * @memberof GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'monthlyUsageLimit': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'dailyTotalUsage': number;
    /**
     * 
     * @type {number}
     * @memberof GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'dailyUsageLimit': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'totalUsageAmount': number;
    /**
     * 
     * @type {number}
     * @memberof GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'totalUsageAmountLimit': number | null;
    /**
     * 
     * @type {string}
     * @memberof GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'expiredDate': string | null;
}

export const GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInnerAvailableCurrenciesEnum = {
    jpy: 'JPY',
    usd: 'USD',
    gbp: 'GBP',
    eur: 'EUR',
    sgd: 'SGD',
    aud: 'AUD',
    cny: 'CNY',
    hkd: 'HKD',
    idr: 'IDR',
    krw: 'KRW',
    nzd: 'NZD',
    php: 'PHP',
    rub: 'RUB',
    vnd: 'VND',
    inr: 'INR',
    thb: 'THB',
    lak: 'LAK',
    myr: 'MYR',
    twd: 'TWD',
    chf: 'CHF',
    cad: 'CAD',
    mxn: 'MXN',
    nok: 'NOK',
    huf: 'HUF',
    hrk: 'HRK',
    czk: 'CZK',
    dkk: 'DKK',
    isk: 'ISK',
    mdl: 'MDL',
    sek: 'SEK',
    mkd: 'MKD',
    rsd: 'RSD',
    ron: 'RON',
    bgn: 'BGN',
    bam: 'BAM',
    pln: 'PLN',
    mad: 'MAD',
    zar: 'ZAR',
    rwf: 'RWF',
    kes: 'KES',
    ngn: 'NGN',
    aed: 'AED',
    sar: 'SAR',
    egp: 'EGP',
    qar: 'QAR',
    omr: 'OMR',
    ils: 'ILS',
    try: 'TRY',
    kzt: 'KZT',
    cop: 'COP',
    gtq: 'GTQ'
} as const;

export type GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInnerAvailableCurrenciesEnum = typeof GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInnerAvailableCurrenciesEnum[keyof typeof GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInnerAvailableCurrenciesEnum];

/**
 * 
 * @export
 * @interface GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInnerAvailableMerchantCategoriesInner
 */
export interface GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInnerAvailableMerchantCategoriesInner {
    /**
     * 
     * @type {string}
     * @memberof GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInnerAvailableMerchantCategoriesInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInnerAvailableMerchantCategoriesInner
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInnerAvailableMerchantCategoriesInner
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInnerAvailableMerchantCategoriesInner
     */
    'logoUrl': string;
}
/**
 * 
 * @export
 * @interface GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInnerUser
 */
export interface GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInnerUser {
    /**
     * 
     * @type {string}
     * @memberof GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInnerUser
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInnerUser
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInnerUser
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInnerUser
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInnerUser
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInnerUser
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInnerUser
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInnerUser
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInnerUser
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInnerUser
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInnerUser
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInnerUserAccountGroup
 */
export interface GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInnerUserAccountGroup {
    /**
     * 
     * @type {string}
     * @memberof GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInnerUserAccountGroup
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInnerUserAccountGroup
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInnerUserAccountGroup
     */
    'sortNum': number;
}
/**
 * 
 * @export
 * @interface GetTeamsChannel200Response
 */
export interface GetTeamsChannel200Response {
    /**
     * 
     * @type {string}
     * @memberof GetTeamsChannel200Response
     */
    'channelId': string;
    /**
     * 
     * @type {string}
     * @memberof GetTeamsChannel200Response
     */
    'channelName': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetTeamsChannel200Response
     */
    'isPrivate': boolean;
}
/**
 * 
 * @export
 * @interface GetTeamsChannelsWithCursor200Response
 */
export interface GetTeamsChannelsWithCursor200Response {
    /**
     * 
     * @type {Array<GetTeamsChannelsWithCursor200ResponseChannelsInner>}
     * @memberof GetTeamsChannelsWithCursor200Response
     */
    'channels': Array<GetTeamsChannelsWithCursor200ResponseChannelsInner>;
    /**
     * 
     * @type {string}
     * @memberof GetTeamsChannelsWithCursor200Response
     */
    'nextCursor'?: string;
}
/**
 * 
 * @export
 * @interface GetTeamsChannelsWithCursor200ResponseChannelsInner
 */
export interface GetTeamsChannelsWithCursor200ResponseChannelsInner {
    /**
     * 
     * @type {string}
     * @memberof GetTeamsChannelsWithCursor200ResponseChannelsInner
     */
    'channelId': string;
    /**
     * 
     * @type {string}
     * @memberof GetTeamsChannelsWithCursor200ResponseChannelsInner
     */
    'channelName': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetTeamsChannelsWithCursor200ResponseChannelsInner
     */
    'isPrivate': boolean;
}
/**
 * 
 * @export
 * @interface GetTeamsTeam200Response
 */
export interface GetTeamsTeam200Response {
    /**
     * 
     * @type {string}
     * @memberof GetTeamsTeam200Response
     */
    'orgAccountId': string;
    /**
     * 
     * @type {string}
     * @memberof GetTeamsTeam200Response
     */
    'teamsTeamId': string;
    /**
     * 
     * @type {string}
     * @memberof GetTeamsTeam200Response
     */
    'teamsTeamName': string;
    /**
     * 
     * @type {string}
     * @memberof GetTeamsTeam200Response
     */
    'status': GetTeamsTeam200ResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof GetTeamsTeam200Response
     */
    'tokenVersion': string;
    /**
     * 
     * @type {string}
     * @memberof GetTeamsTeam200Response
     */
    'latestTokenVersion': string;
    /**
     * 
     * @type {string}
     * @memberof GetTeamsTeam200Response
     */
    'tokenScope': string;
}

export const GetTeamsTeam200ResponseStatusEnum = {
    unknown: 'UNKNOWN',
    active: 'ACTIVE',
    inactive: 'INACTIVE',
    cancelled: 'CANCELLED',
    invalidated: 'INVALIDATED',
    suspended: 'SUSPENDED',
    pending: 'PENDING'
} as const;

export type GetTeamsTeam200ResponseStatusEnum = typeof GetTeamsTeam200ResponseStatusEnum[keyof typeof GetTeamsTeam200ResponseStatusEnum];

/**
 * 
 * @export
 * @interface GetTeamsVersion200Response
 */
export interface GetTeamsVersion200Response {
    /**
     * 
     * @type {string}
     * @memberof GetTeamsVersion200Response
     */
    'latestTokenVersion': string;
    /**
     * 
     * @type {string}
     * @memberof GetTeamsVersion200Response
     */
    'tokenScope': string;
}
/**
 * 
 * @export
 * @interface GetTechnicalSupportUsers200ResponseInner
 */
export interface GetTechnicalSupportUsers200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetTechnicalSupportUsers200ResponseInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetTechnicalSupportUsers200ResponseInner
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetTechnicalSupportUsers200ResponseInner
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetTechnicalSupportUsers200ResponseInner
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof GetTechnicalSupportUsers200ResponseInner
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetTechnicalSupportUsers200ResponseInner
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetTechnicalSupportUsers200ResponseInner
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetTechnicalSupportUsers200ResponseInner
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetTechnicalSupportUsers200ResponseInner
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetTechnicalSupportUsers200ResponseInner
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetTechnicalSupportUsers200ResponseInner
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface GetTheUserAccountInformation200Response
 */
export interface GetTheUserAccountInformation200Response {
    /**
     * 
     * @type {string}
     * @memberof GetTheUserAccountInformation200Response
     */
    'userAccountId': string;
    /**
     * 
     * @type {GetTheUserAccountInformation200ResponseUser}
     * @memberof GetTheUserAccountInformation200Response
     */
    'user': GetTheUserAccountInformation200ResponseUser;
    /**
     * 
     * @type {string}
     * @memberof GetTheUserAccountInformation200Response
     */
    'cardLabel': string;
    /**
     * 
     * @type {string}
     * @memberof GetTheUserAccountInformation200Response
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetTheUserAccountInformation200Response
     */
    'organizationName': string;
    /**
     * 
     * @type {GetTheUserAccountInformation200ResponseUserAccountGroup}
     * @memberof GetTheUserAccountInformation200Response
     */
    'userAccountGroup': GetTheUserAccountInformation200ResponseUserAccountGroup | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetTheUserAccountInformation200Response
     */
    'isOnDemand': boolean;
}
/**
 * 
 * @export
 * @interface GetTheUserAccountInformation200ResponseUser
 */
export interface GetTheUserAccountInformation200ResponseUser {
    /**
     * 
     * @type {string}
     * @memberof GetTheUserAccountInformation200ResponseUser
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetTheUserAccountInformation200ResponseUser
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetTheUserAccountInformation200ResponseUser
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetTheUserAccountInformation200ResponseUser
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof GetTheUserAccountInformation200ResponseUser
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetTheUserAccountInformation200ResponseUser
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetTheUserAccountInformation200ResponseUser
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetTheUserAccountInformation200ResponseUser
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetTheUserAccountInformation200ResponseUser
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetTheUserAccountInformation200ResponseUser
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetTheUserAccountInformation200ResponseUser
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface GetTheUserAccountInformation200ResponseUserAccountGroup
 */
export interface GetTheUserAccountInformation200ResponseUserAccountGroup {
    /**
     * 
     * @type {string}
     * @memberof GetTheUserAccountInformation200ResponseUserAccountGroup
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetTheUserAccountInformation200ResponseUserAccountGroup
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof GetTheUserAccountInformation200ResponseUserAccountGroup
     */
    'sortNum': number;
}
/**
 * 
 * @export
 * @interface GetTransactionEvidenceEmailAddress200Response
 */
export interface GetTransactionEvidenceEmailAddress200Response {
    /**
     * 
     * @type {string}
     * @memberof GetTransactionEvidenceEmailAddress200Response
     */
    'userAccountId': string;
    /**
     * 
     * @type {string}
     * @memberof GetTransactionEvidenceEmailAddress200Response
     */
    'emailAddress': string;
}
/**
 * 
 * @export
 * @interface GetTransactionEvidenceEmails200ResponseInner
 */
export interface GetTransactionEvidenceEmails200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetTransactionEvidenceEmails200ResponseInner
     */
    'transactionEvidenceEmailId': string;
    /**
     * 
     * @type {string}
     * @memberof GetTransactionEvidenceEmails200ResponseInner
     */
    'userAccountId': string;
    /**
     * 
     * @type {string}
     * @memberof GetTransactionEvidenceEmails200ResponseInner
     */
    'senderName': string;
    /**
     * 
     * @type {string}
     * @memberof GetTransactionEvidenceEmails200ResponseInner
     */
    'emailTo': string;
    /**
     * 
     * @type {string}
     * @memberof GetTransactionEvidenceEmails200ResponseInner
     */
    'emailFrom': string;
    /**
     * 
     * @type {string}
     * @memberof GetTransactionEvidenceEmails200ResponseInner
     */
    'emailSubject': string;
    /**
     * 
     * @type {Array<GetTransactionEvidenceEmails200ResponseInnerAttachmentListInner>}
     * @memberof GetTransactionEvidenceEmails200ResponseInner
     */
    'attachmentList': Array<GetTransactionEvidenceEmails200ResponseInnerAttachmentListInner>;
    /**
     * 
     * @type {string}
     * @memberof GetTransactionEvidenceEmails200ResponseInner
     */
    'createdDate': string;
}
/**
 * 
 * @export
 * @interface GetTransactionEvidenceEmails200ResponseInnerAttachmentListInner
 */
export interface GetTransactionEvidenceEmails200ResponseInnerAttachmentListInner {
    /**
     * 
     * @type {string}
     * @memberof GetTransactionEvidenceEmails200ResponseInnerAttachmentListInner
     */
    'attachmentId': string;
    /**
     * 
     * @type {string}
     * @memberof GetTransactionEvidenceEmails200ResponseInnerAttachmentListInner
     */
    'name': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetTransactionEvidenceEmails200ResponseInnerAttachmentListInner
     */
    'isUploaded': boolean;
}
/**
 * 
 * @export
 * @interface GetTrustdockIdentityVerifications200Response
 */
export interface GetTrustdockIdentityVerifications200Response {
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockIdentityVerifications200Response
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockIdentityVerifications200Response
     */
    'organizationId': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockIdentityVerifications200Response
     */
    'organizationCreateRequestId': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockIdentityVerifications200Response
     */
    'organizationName': string;
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockIdentityVerifications200Response
     */
    'corporateNumber': string;
    /**
     * 
     * @type {number}
     * @memberof GetTrustdockIdentityVerifications200Response
     */
    'businessDescriptionId': number;
    /**
     * 
     * @type {number}
     * @memberof GetTrustdockIdentityVerifications200Response
     */
    'purposeTransaction': number;
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockIdentityVerifications200Response
     */
    'purposeTransactionOther': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockIdentityVerifications200Response
     */
    'postalCode': string;
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockIdentityVerifications200Response
     */
    'address': string;
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockIdentityVerifications200Response
     */
    'phoneNumber': string;
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockIdentityVerifications200Response
     */
    'representativeName': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetTrustdockIdentityVerifications200Response
     */
    'isExistsBeneficialOwner': boolean;
    /**
     * 
     * @type {GetTrustdockIdentityVerifications200ResponseCorporateType}
     * @memberof GetTrustdockIdentityVerifications200Response
     */
    'corporateType': GetTrustdockIdentityVerifications200ResponseCorporateType | null;
    /**
     * 
     * @type {Array<GetTrustdockIdentityVerifications200ResponseBeneficialOwnersInner>}
     * @memberof GetTrustdockIdentityVerifications200Response
     */
    'beneficialOwners': Array<GetTrustdockIdentityVerifications200ResponseBeneficialOwnersInner> | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetTrustdockIdentityVerifications200Response
     */
    'isRepresentative': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockIdentityVerifications200Response
     */
    'transactionManagerName': string;
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockIdentityVerifications200Response
     */
    'transactionManagerBirthday': string;
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockIdentityVerifications200Response
     */
    'transactionManagerAddress': string;
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockIdentityVerifications200Response
     */
    'transactionManagerEmail': string;
    /**
     * 
     * @type {Array<GetTrustdockIdentityVerifications200ResponseIdentificationInner>}
     * @memberof GetTrustdockIdentityVerifications200Response
     */
    'identification': Array<GetTrustdockIdentityVerifications200ResponseIdentificationInner>;
    /**
     * 
     * @type {Array<GetTrustdockIdentityVerifications200ResponseAntisocialForcesCheckInner>}
     * @memberof GetTrustdockIdentityVerifications200Response
     */
    'antisocialForcesCheck': Array<GetTrustdockIdentityVerifications200ResponseAntisocialForcesCheckInner>;
    /**
     * 
     * @type {Array<GetTrustdockIdentityVerifications200ResponseSnailMailVerificationInner>}
     * @memberof GetTrustdockIdentityVerifications200Response
     */
    'snailMailVerification': Array<GetTrustdockIdentityVerifications200ResponseSnailMailVerificationInner> | null;
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockIdentityVerifications200Response
     */
    'note': string | null;
    /**
     * 
     * @type {GetTrustdockIdentityVerifications200ResponseStatus}
     * @memberof GetTrustdockIdentityVerifications200Response
     */
    'status': GetTrustdockIdentityVerifications200ResponseStatus | null;
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockIdentityVerifications200Response
     */
    'createdAt': string;
}
/**
 * 
 * @export
 * @interface GetTrustdockIdentityVerifications200ResponseAntisocialForcesCheckInner
 */
export interface GetTrustdockIdentityVerifications200ResponseAntisocialForcesCheckInner {
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockIdentityVerifications200ResponseAntisocialForcesCheckInner
     */
    'organizationIdentityVerificationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockIdentityVerifications200ResponseAntisocialForcesCheckInner
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockIdentityVerifications200ResponseAntisocialForcesCheckInner
     */
    'payloadId': string;
    /**
     * 
     * @type {number}
     * @memberof GetTrustdockIdentityVerifications200ResponseAntisocialForcesCheckInner
     */
    'payloadDetailId': number;
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockIdentityVerifications200ResponseAntisocialForcesCheckInner
     */
    'category': string;
    /**
     * 
     * @type {object}
     * @memberof GetTrustdockIdentityVerifications200ResponseAntisocialForcesCheckInner
     */
    'condition'?: object;
    /**
     * 
     * @type {Array<object>}
     * @memberof GetTrustdockIdentityVerifications200ResponseAntisocialForcesCheckInner
     */
    'results'?: Array<object> | null;
}
/**
 * 
 * @export
 * @interface GetTrustdockIdentityVerifications200ResponseBeneficialOwnersInner
 */
export interface GetTrustdockIdentityVerifications200ResponseBeneficialOwnersInner {
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockIdentityVerifications200ResponseBeneficialOwnersInner
     */
    'corporateRelationships': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockIdentityVerifications200ResponseBeneficialOwnersInner
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockIdentityVerifications200ResponseBeneficialOwnersInner
     */
    'beneficialOwnerType': string;
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockIdentityVerifications200ResponseBeneficialOwnersInner
     */
    'gender': string;
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockIdentityVerifications200ResponseBeneficialOwnersInner
     */
    'birthday': string;
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockIdentityVerifications200ResponseBeneficialOwnersInner
     */
    'countryResidence': string;
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockIdentityVerifications200ResponseBeneficialOwnersInner
     */
    'address': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetTrustdockIdentityVerifications200ResponseBeneficialOwnersInner
     */
    'isPoliticallyExposedPersons': boolean;
}
/**
 * @type GetTrustdockIdentityVerifications200ResponseCorporateType
 * @export
 */
export type GetTrustdockIdentityVerifications200ResponseCorporateType = GetTrustdockIdentityVerifications200ResponseCorporateTypeOneOf;

/**
 * 
 * @export
 * @enum {string}
 */

export const GetTrustdockIdentityVerifications200ResponseCorporateTypeOneOf = {
    majorityCapitalVoteCorporate: 'MAJORITY_CAPITAL_VOTE_CORPORATE',
    exceptMajorityCapitalVoteCorporate: 'EXCEPT_MAJORITY_CAPITAL_VOTE_CORPORATE'
} as const;

export type GetTrustdockIdentityVerifications200ResponseCorporateTypeOneOf = typeof GetTrustdockIdentityVerifications200ResponseCorporateTypeOneOf[keyof typeof GetTrustdockIdentityVerifications200ResponseCorporateTypeOneOf];


/**
 * 
 * @export
 * @interface GetTrustdockIdentityVerifications200ResponseIdentificationInner
 */
export interface GetTrustdockIdentityVerifications200ResponseIdentificationInner {
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockIdentityVerifications200ResponseIdentificationInner
     */
    'trustdockIdentificationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockIdentityVerifications200ResponseIdentificationInner
     */
    'state': string;
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockIdentityVerifications200ResponseIdentificationInner
     */
    'result': string | null;
    /**
     * 
     * @type {Array<GetTrustdockIdentityVerifications200ResponseIdentificationInnerRecordsInner>}
     * @memberof GetTrustdockIdentityVerifications200ResponseIdentificationInner
     */
    'records'?: Array<GetTrustdockIdentityVerifications200ResponseIdentificationInnerRecordsInner> | null;
}
/**
 * 
 * @export
 * @interface GetTrustdockIdentityVerifications200ResponseIdentificationInnerRecordsInner
 */
export interface GetTrustdockIdentityVerifications200ResponseIdentificationInnerRecordsInner {
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockIdentityVerifications200ResponseIdentificationInnerRecordsInner
     */
    'state': string;
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockIdentityVerifications200ResponseIdentificationInnerRecordsInner
     */
    'result': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockIdentityVerifications200ResponseIdentificationInnerRecordsInner
     */
    'planId'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockIdentityVerifications200ResponseIdentificationInnerRecordsInner
     */
    'plan'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetTrustdockIdentityVerifications200ResponseIdentificationInnerRecordsInner
     */
    'reasons'?: Array<string>;
}
/**
 * 
 * @export
 * @interface GetTrustdockIdentityVerifications200ResponseSnailMailVerificationInner
 */
export interface GetTrustdockIdentityVerifications200ResponseSnailMailVerificationInner {
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockIdentityVerifications200ResponseSnailMailVerificationInner
     */
    'organizationIdentityVerificationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockIdentityVerifications200ResponseSnailMailVerificationInner
     */
    'snailMailVerificationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockIdentityVerifications200ResponseSnailMailVerificationInner
     */
    'result': string;
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockIdentityVerifications200ResponseSnailMailVerificationInner
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockIdentityVerifications200ResponseSnailMailVerificationInner
     */
    'detail': string;
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockIdentityVerifications200ResponseSnailMailVerificationInner
     */
    'inquiryNumber': string;
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockIdentityVerifications200ResponseSnailMailVerificationInner
     */
    'acceptAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockIdentityVerifications200ResponseSnailMailVerificationInner
     */
    'confirmedAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockIdentityVerifications200ResponseSnailMailVerificationInner
     */
    'confirmedBy': string | null;
}
/**
 * 
 * @export
 * @interface GetTrustdockIdentityVerifications200ResponseStatus
 */
export interface GetTrustdockIdentityVerifications200ResponseStatus {
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockIdentityVerifications200ResponseStatus
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockIdentityVerifications200ResponseStatus
     */
    'statusChangedUserId': string;
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockIdentityVerifications200ResponseStatus
     */
    'statusChangedUserName': string;
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockIdentityVerifications200ResponseStatus
     */
    'statusChangedAt': string;
}
/**
 * 
 * @export
 * @interface GetTrustdockSubmitIdentificationDocumentPublishUrl200Response
 */
export interface GetTrustdockSubmitIdentificationDocumentPublishUrl200Response {
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockSubmitIdentificationDocumentPublishUrl200Response
     */
    'url': string;
}
/**
 * 
 * @export
 * @interface GetTrustdockVerifications200Response
 */
export interface GetTrustdockVerifications200Response {
    /**
     * 
     * @type {GetTrustdockVerifications200ResponseIdDocument}
     * @memberof GetTrustdockVerifications200Response
     */
    'idDocument': GetTrustdockVerifications200ResponseIdDocument;
    /**
     * 
     * @type {GetTrustdockVerifications200ResponseCompanyVerificationDocument}
     * @memberof GetTrustdockVerifications200Response
     */
    'companyVerificationDocument': GetTrustdockVerifications200ResponseCompanyVerificationDocument;
    /**
     * 
     * @type {GetTrustdockVerifications200ResponseSupplementalDocument}
     * @memberof GetTrustdockVerifications200Response
     */
    'supplementalDocument': GetTrustdockVerifications200ResponseSupplementalDocument | null;
}
/**
 * 
 * @export
 * @interface GetTrustdockVerifications200ResponseCompanyVerificationDocument
 */
export interface GetTrustdockVerifications200ResponseCompanyVerificationDocument {
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockVerifications200ResponseCompanyVerificationDocument
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockVerifications200ResponseCompanyVerificationDocument
     */
    'publicId': string;
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockVerifications200ResponseCompanyVerificationDocument
     */
    'idForHelper': string;
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockVerifications200ResponseCompanyVerificationDocument
     */
    'state': GetTrustdockVerifications200ResponseCompanyVerificationDocumentStateEnum;
    /**
     * 
     * @type {GetTrustdockVerifications200ResponseCompanyVerificationDocumentResult}
     * @memberof GetTrustdockVerifications200ResponseCompanyVerificationDocument
     */
    'result': GetTrustdockVerifications200ResponseCompanyVerificationDocumentResult | null;
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockVerifications200ResponseCompanyVerificationDocument
     */
    'acceptedAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockVerifications200ResponseCompanyVerificationDocument
     */
    'plansSelectedAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockVerifications200ResponseCompanyVerificationDocument
     */
    'documentSubmittedAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockVerifications200ResponseCompanyVerificationDocument
     */
    'preparedAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockVerifications200ResponseCompanyVerificationDocument
     */
    'verifiedAt': string | null;
    /**
     * 
     * @type {GetTrustdockVerifications200ResponseCompanyVerificationDocumentComparingData}
     * @memberof GetTrustdockVerifications200ResponseCompanyVerificationDocument
     */
    'comparingData': GetTrustdockVerifications200ResponseCompanyVerificationDocumentComparingData;
    /**
     * 
     * @type {Array<GetTrustdockVerifications200ResponseCompanyVerificationDocumentRecordsInner>}
     * @memberof GetTrustdockVerifications200ResponseCompanyVerificationDocument
     */
    'records': Array<GetTrustdockVerifications200ResponseCompanyVerificationDocumentRecordsInner> | null;
}

export const GetTrustdockVerifications200ResponseCompanyVerificationDocumentStateEnum = {
    accepted: 'accepted',
    plansSelected: 'plans_selected',
    documentSubmitted: 'document_submitted',
    inProgress: 'in_progress',
    verified: 'verified'
} as const;

export type GetTrustdockVerifications200ResponseCompanyVerificationDocumentStateEnum = typeof GetTrustdockVerifications200ResponseCompanyVerificationDocumentStateEnum[keyof typeof GetTrustdockVerifications200ResponseCompanyVerificationDocumentStateEnum];

/**
 * 
 * @export
 * @interface GetTrustdockVerifications200ResponseCompanyVerificationDocumentComparingData
 */
export interface GetTrustdockVerifications200ResponseCompanyVerificationDocumentComparingData {
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockVerifications200ResponseCompanyVerificationDocumentComparingData
     */
    'submittedAt'?: string;
}
/**
 * 
 * @export
 * @interface GetTrustdockVerifications200ResponseCompanyVerificationDocumentRecordsInner
 */
export interface GetTrustdockVerifications200ResponseCompanyVerificationDocumentRecordsInner {
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockVerifications200ResponseCompanyVerificationDocumentRecordsInner
     */
    'state': GetTrustdockVerifications200ResponseCompanyVerificationDocumentRecordsInnerStateEnum;
    /**
     * 
     * @type {GetTrustdockVerifications200ResponseCompanyVerificationDocumentRecordsInnerResult}
     * @memberof GetTrustdockVerifications200ResponseCompanyVerificationDocumentRecordsInner
     */
    'result': GetTrustdockVerifications200ResponseCompanyVerificationDocumentRecordsInnerResult | null;
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockVerifications200ResponseCompanyVerificationDocumentRecordsInner
     */
    'verifiedAt': string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetTrustdockVerifications200ResponseCompanyVerificationDocumentRecordsInner
     */
    'verifiedBy': Array<string> | null;
    /**
     * 
     * @type {GetTrustdockVerifications200ResponseCompanyVerificationDocumentRecordsInnerPlan}
     * @memberof GetTrustdockVerifications200ResponseCompanyVerificationDocumentRecordsInner
     */
    'plan': GetTrustdockVerifications200ResponseCompanyVerificationDocumentRecordsInnerPlan | null;
    /**
     * 
     * @type {object}
     * @memberof GetTrustdockVerifications200ResponseCompanyVerificationDocumentRecordsInner
     */
    'document': object | null;
    /**
     * 
     * @type {Array<GetTrustdockVerifications200ResponseCompanyVerificationDocumentRecordsInnerReasonsInner>}
     * @memberof GetTrustdockVerifications200ResponseCompanyVerificationDocumentRecordsInner
     */
    'reasons': Array<GetTrustdockVerifications200ResponseCompanyVerificationDocumentRecordsInnerReasonsInner> | null;
}

export const GetTrustdockVerifications200ResponseCompanyVerificationDocumentRecordsInnerStateEnum = {
    accepted: 'accepted',
    plansSelected: 'plans_selected',
    documentSubmitted: 'document_submitted',
    inProgress: 'in_progress',
    verified: 'verified'
} as const;

export type GetTrustdockVerifications200ResponseCompanyVerificationDocumentRecordsInnerStateEnum = typeof GetTrustdockVerifications200ResponseCompanyVerificationDocumentRecordsInnerStateEnum[keyof typeof GetTrustdockVerifications200ResponseCompanyVerificationDocumentRecordsInnerStateEnum];

/**
 * 
 * @export
 * @interface GetTrustdockVerifications200ResponseCompanyVerificationDocumentRecordsInnerPlan
 */
export interface GetTrustdockVerifications200ResponseCompanyVerificationDocumentRecordsInnerPlan {
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockVerifications200ResponseCompanyVerificationDocumentRecordsInnerPlan
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockVerifications200ResponseCompanyVerificationDocumentRecordsInnerPlan
     */
    'name'?: string | null;
}
/**
 * 
 * @export
 * @interface GetTrustdockVerifications200ResponseCompanyVerificationDocumentRecordsInnerReasonsInner
 */
export interface GetTrustdockVerifications200ResponseCompanyVerificationDocumentRecordsInnerReasonsInner {
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockVerifications200ResponseCompanyVerificationDocumentRecordsInnerReasonsInner
     */
    'target'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockVerifications200ResponseCompanyVerificationDocumentRecordsInnerReasonsInner
     */
    'code'?: string | null;
    /**
     * 
     * @type {GetTrustdockVerifications200ResponseCompanyVerificationDocumentRecordsInnerReasonsInnerDetail}
     * @memberof GetTrustdockVerifications200ResponseCompanyVerificationDocumentRecordsInnerReasonsInner
     */
    'detail'?: GetTrustdockVerifications200ResponseCompanyVerificationDocumentRecordsInnerReasonsInnerDetail | null;
}
/**
 * 
 * @export
 * @interface GetTrustdockVerifications200ResponseCompanyVerificationDocumentRecordsInnerReasonsInnerDetail
 */
export interface GetTrustdockVerifications200ResponseCompanyVerificationDocumentRecordsInnerReasonsInnerDetail {
    /**
     * 
     * @type {Array<string>}
     * @memberof GetTrustdockVerifications200ResponseCompanyVerificationDocumentRecordsInnerReasonsInnerDetail
     */
    'fields'?: Array<string> | null;
}
/**
 * @type GetTrustdockVerifications200ResponseCompanyVerificationDocumentRecordsInnerResult
 * @export
 */
export type GetTrustdockVerifications200ResponseCompanyVerificationDocumentRecordsInnerResult = GetTrustdockVerifications200ResponseCompanyVerificationDocumentRecordsInnerResultOneOf;

/**
 * 
 * @export
 * @enum {string}
 */

export const GetTrustdockVerifications200ResponseCompanyVerificationDocumentRecordsInnerResultOneOf = {
    approved: 'approved',
    denied: 'denied'
} as const;

export type GetTrustdockVerifications200ResponseCompanyVerificationDocumentRecordsInnerResultOneOf = typeof GetTrustdockVerifications200ResponseCompanyVerificationDocumentRecordsInnerResultOneOf[keyof typeof GetTrustdockVerifications200ResponseCompanyVerificationDocumentRecordsInnerResultOneOf];


/**
 * @type GetTrustdockVerifications200ResponseCompanyVerificationDocumentResult
 * @export
 */
export type GetTrustdockVerifications200ResponseCompanyVerificationDocumentResult = GetTrustdockVerifications200ResponseCompanyVerificationDocumentResultOneOf;

/**
 * 
 * @export
 * @enum {string}
 */

export const GetTrustdockVerifications200ResponseCompanyVerificationDocumentResultOneOf = {
    approved: 'approved',
    denied: 'denied'
} as const;

export type GetTrustdockVerifications200ResponseCompanyVerificationDocumentResultOneOf = typeof GetTrustdockVerifications200ResponseCompanyVerificationDocumentResultOneOf[keyof typeof GetTrustdockVerifications200ResponseCompanyVerificationDocumentResultOneOf];


/**
 * 
 * @export
 * @interface GetTrustdockVerifications200ResponseIdDocument
 */
export interface GetTrustdockVerifications200ResponseIdDocument {
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockVerifications200ResponseIdDocument
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockVerifications200ResponseIdDocument
     */
    'publicId': string;
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockVerifications200ResponseIdDocument
     */
    'idForHelper': string;
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockVerifications200ResponseIdDocument
     */
    'state': GetTrustdockVerifications200ResponseIdDocumentStateEnum;
    /**
     * 
     * @type {GetTrustdockVerifications200ResponseIdDocumentResult}
     * @memberof GetTrustdockVerifications200ResponseIdDocument
     */
    'result': GetTrustdockVerifications200ResponseIdDocumentResult | null;
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockVerifications200ResponseIdDocument
     */
    'acceptedAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockVerifications200ResponseIdDocument
     */
    'plansSelectedAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockVerifications200ResponseIdDocument
     */
    'documentSubmittedAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockVerifications200ResponseIdDocument
     */
    'preparedAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockVerifications200ResponseIdDocument
     */
    'verifiedAt': string | null;
    /**
     * 
     * @type {GetTrustdockVerifications200ResponseIdDocumentComparingData}
     * @memberof GetTrustdockVerifications200ResponseIdDocument
     */
    'comparingData': GetTrustdockVerifications200ResponseIdDocumentComparingData;
    /**
     * 
     * @type {Array<GetTrustdockVerifications200ResponseIdDocumentRecordsInner>}
     * @memberof GetTrustdockVerifications200ResponseIdDocument
     */
    'records': Array<GetTrustdockVerifications200ResponseIdDocumentRecordsInner> | null;
}

export const GetTrustdockVerifications200ResponseIdDocumentStateEnum = {
    accepted: 'accepted',
    plansSelected: 'plans_selected',
    documentSubmitted: 'document_submitted',
    inProgress: 'in_progress',
    verified: 'verified'
} as const;

export type GetTrustdockVerifications200ResponseIdDocumentStateEnum = typeof GetTrustdockVerifications200ResponseIdDocumentStateEnum[keyof typeof GetTrustdockVerifications200ResponseIdDocumentStateEnum];

/**
 * 
 * @export
 * @interface GetTrustdockVerifications200ResponseIdDocumentComparingData
 */
export interface GetTrustdockVerifications200ResponseIdDocumentComparingData {
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockVerifications200ResponseIdDocumentComparingData
     */
    'submittedAt'?: string;
}
/**
 * 
 * @export
 * @interface GetTrustdockVerifications200ResponseIdDocumentRecordsInner
 */
export interface GetTrustdockVerifications200ResponseIdDocumentRecordsInner {
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockVerifications200ResponseIdDocumentRecordsInner
     */
    'state': GetTrustdockVerifications200ResponseIdDocumentRecordsInnerStateEnum;
    /**
     * 
     * @type {GetTrustdockVerifications200ResponseIdDocumentRecordsInnerResult}
     * @memberof GetTrustdockVerifications200ResponseIdDocumentRecordsInner
     */
    'result': GetTrustdockVerifications200ResponseIdDocumentRecordsInnerResult | null;
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockVerifications200ResponseIdDocumentRecordsInner
     */
    'verifiedAt': string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetTrustdockVerifications200ResponseIdDocumentRecordsInner
     */
    'verifiedBy': Array<string> | null;
    /**
     * 
     * @type {GetTrustdockVerifications200ResponseIdDocumentRecordsInnerPlan}
     * @memberof GetTrustdockVerifications200ResponseIdDocumentRecordsInner
     */
    'plan': GetTrustdockVerifications200ResponseIdDocumentRecordsInnerPlan | null;
    /**
     * 
     * @type {object}
     * @memberof GetTrustdockVerifications200ResponseIdDocumentRecordsInner
     */
    'document': object | null;
    /**
     * 
     * @type {Array<GetTrustdockVerifications200ResponseIdDocumentRecordsInnerReasonsInner>}
     * @memberof GetTrustdockVerifications200ResponseIdDocumentRecordsInner
     */
    'reasons': Array<GetTrustdockVerifications200ResponseIdDocumentRecordsInnerReasonsInner> | null;
}

export const GetTrustdockVerifications200ResponseIdDocumentRecordsInnerStateEnum = {
    accepted: 'accepted',
    plansSelected: 'plans_selected',
    documentSubmitted: 'document_submitted',
    inProgress: 'in_progress',
    verified: 'verified'
} as const;

export type GetTrustdockVerifications200ResponseIdDocumentRecordsInnerStateEnum = typeof GetTrustdockVerifications200ResponseIdDocumentRecordsInnerStateEnum[keyof typeof GetTrustdockVerifications200ResponseIdDocumentRecordsInnerStateEnum];

/**
 * 
 * @export
 * @interface GetTrustdockVerifications200ResponseIdDocumentRecordsInnerPlan
 */
export interface GetTrustdockVerifications200ResponseIdDocumentRecordsInnerPlan {
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockVerifications200ResponseIdDocumentRecordsInnerPlan
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockVerifications200ResponseIdDocumentRecordsInnerPlan
     */
    'name'?: string | null;
}
/**
 * 
 * @export
 * @interface GetTrustdockVerifications200ResponseIdDocumentRecordsInnerReasonsInner
 */
export interface GetTrustdockVerifications200ResponseIdDocumentRecordsInnerReasonsInner {
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockVerifications200ResponseIdDocumentRecordsInnerReasonsInner
     */
    'target'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockVerifications200ResponseIdDocumentRecordsInnerReasonsInner
     */
    'code'?: string | null;
    /**
     * 
     * @type {GetTrustdockVerifications200ResponseIdDocumentRecordsInnerReasonsInnerDetail}
     * @memberof GetTrustdockVerifications200ResponseIdDocumentRecordsInnerReasonsInner
     */
    'detail'?: GetTrustdockVerifications200ResponseIdDocumentRecordsInnerReasonsInnerDetail | null;
}
/**
 * 
 * @export
 * @interface GetTrustdockVerifications200ResponseIdDocumentRecordsInnerReasonsInnerDetail
 */
export interface GetTrustdockVerifications200ResponseIdDocumentRecordsInnerReasonsInnerDetail {
    /**
     * 
     * @type {Array<string>}
     * @memberof GetTrustdockVerifications200ResponseIdDocumentRecordsInnerReasonsInnerDetail
     */
    'fields'?: Array<string> | null;
}
/**
 * @type GetTrustdockVerifications200ResponseIdDocumentRecordsInnerResult
 * @export
 */
export type GetTrustdockVerifications200ResponseIdDocumentRecordsInnerResult = GetTrustdockVerifications200ResponseIdDocumentRecordsInnerResultOneOf;

/**
 * 
 * @export
 * @enum {string}
 */

export const GetTrustdockVerifications200ResponseIdDocumentRecordsInnerResultOneOf = {
    approved: 'approved',
    denied: 'denied'
} as const;

export type GetTrustdockVerifications200ResponseIdDocumentRecordsInnerResultOneOf = typeof GetTrustdockVerifications200ResponseIdDocumentRecordsInnerResultOneOf[keyof typeof GetTrustdockVerifications200ResponseIdDocumentRecordsInnerResultOneOf];


/**
 * @type GetTrustdockVerifications200ResponseIdDocumentResult
 * @export
 */
export type GetTrustdockVerifications200ResponseIdDocumentResult = GetTrustdockVerifications200ResponseIdDocumentResultOneOf;

/**
 * 
 * @export
 * @enum {string}
 */

export const GetTrustdockVerifications200ResponseIdDocumentResultOneOf = {
    approved: 'approved',
    denied: 'denied'
} as const;

export type GetTrustdockVerifications200ResponseIdDocumentResultOneOf = typeof GetTrustdockVerifications200ResponseIdDocumentResultOneOf[keyof typeof GetTrustdockVerifications200ResponseIdDocumentResultOneOf];


/**
 * 
 * @export
 * @interface GetTrustdockVerifications200ResponseSupplementalDocument
 */
export interface GetTrustdockVerifications200ResponseSupplementalDocument {
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockVerifications200ResponseSupplementalDocument
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockVerifications200ResponseSupplementalDocument
     */
    'publicId': string;
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockVerifications200ResponseSupplementalDocument
     */
    'idForHelper': string;
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockVerifications200ResponseSupplementalDocument
     */
    'state': GetTrustdockVerifications200ResponseSupplementalDocumentStateEnum;
    /**
     * 
     * @type {GetTrustdockVerifications200ResponseSupplementalDocumentResult}
     * @memberof GetTrustdockVerifications200ResponseSupplementalDocument
     */
    'result': GetTrustdockVerifications200ResponseSupplementalDocumentResult | null;
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockVerifications200ResponseSupplementalDocument
     */
    'acceptedAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockVerifications200ResponseSupplementalDocument
     */
    'plansSelectedAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockVerifications200ResponseSupplementalDocument
     */
    'documentSubmittedAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockVerifications200ResponseSupplementalDocument
     */
    'preparedAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockVerifications200ResponseSupplementalDocument
     */
    'verifiedAt': string | null;
    /**
     * 
     * @type {GetTrustdockVerifications200ResponseSupplementalDocumentComparingData}
     * @memberof GetTrustdockVerifications200ResponseSupplementalDocument
     */
    'comparingData': GetTrustdockVerifications200ResponseSupplementalDocumentComparingData;
    /**
     * 
     * @type {Array<GetTrustdockVerifications200ResponseSupplementalDocumentRecordsInner>}
     * @memberof GetTrustdockVerifications200ResponseSupplementalDocument
     */
    'records': Array<GetTrustdockVerifications200ResponseSupplementalDocumentRecordsInner> | null;
}

export const GetTrustdockVerifications200ResponseSupplementalDocumentStateEnum = {
    accepted: 'accepted',
    plansSelected: 'plans_selected',
    documentSubmitted: 'document_submitted',
    inProgress: 'in_progress',
    verified: 'verified'
} as const;

export type GetTrustdockVerifications200ResponseSupplementalDocumentStateEnum = typeof GetTrustdockVerifications200ResponseSupplementalDocumentStateEnum[keyof typeof GetTrustdockVerifications200ResponseSupplementalDocumentStateEnum];

/**
 * 
 * @export
 * @interface GetTrustdockVerifications200ResponseSupplementalDocumentComparingData
 */
export interface GetTrustdockVerifications200ResponseSupplementalDocumentComparingData {
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockVerifications200ResponseSupplementalDocumentComparingData
     */
    'submittedAt'?: string;
}
/**
 * 
 * @export
 * @interface GetTrustdockVerifications200ResponseSupplementalDocumentRecordsInner
 */
export interface GetTrustdockVerifications200ResponseSupplementalDocumentRecordsInner {
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockVerifications200ResponseSupplementalDocumentRecordsInner
     */
    'state': GetTrustdockVerifications200ResponseSupplementalDocumentRecordsInnerStateEnum;
    /**
     * 
     * @type {GetTrustdockVerifications200ResponseSupplementalDocumentRecordsInnerResult}
     * @memberof GetTrustdockVerifications200ResponseSupplementalDocumentRecordsInner
     */
    'result': GetTrustdockVerifications200ResponseSupplementalDocumentRecordsInnerResult | null;
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockVerifications200ResponseSupplementalDocumentRecordsInner
     */
    'verifiedAt': string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetTrustdockVerifications200ResponseSupplementalDocumentRecordsInner
     */
    'verifiedBy': Array<string> | null;
    /**
     * 
     * @type {GetTrustdockVerifications200ResponseSupplementalDocumentRecordsInnerPlan}
     * @memberof GetTrustdockVerifications200ResponseSupplementalDocumentRecordsInner
     */
    'plan': GetTrustdockVerifications200ResponseSupplementalDocumentRecordsInnerPlan | null;
    /**
     * 
     * @type {object}
     * @memberof GetTrustdockVerifications200ResponseSupplementalDocumentRecordsInner
     */
    'document': object | null;
    /**
     * 
     * @type {Array<GetTrustdockVerifications200ResponseSupplementalDocumentRecordsInnerReasonsInner>}
     * @memberof GetTrustdockVerifications200ResponseSupplementalDocumentRecordsInner
     */
    'reasons': Array<GetTrustdockVerifications200ResponseSupplementalDocumentRecordsInnerReasonsInner> | null;
}

export const GetTrustdockVerifications200ResponseSupplementalDocumentRecordsInnerStateEnum = {
    accepted: 'accepted',
    plansSelected: 'plans_selected',
    documentSubmitted: 'document_submitted',
    inProgress: 'in_progress',
    verified: 'verified'
} as const;

export type GetTrustdockVerifications200ResponseSupplementalDocumentRecordsInnerStateEnum = typeof GetTrustdockVerifications200ResponseSupplementalDocumentRecordsInnerStateEnum[keyof typeof GetTrustdockVerifications200ResponseSupplementalDocumentRecordsInnerStateEnum];

/**
 * 
 * @export
 * @interface GetTrustdockVerifications200ResponseSupplementalDocumentRecordsInnerPlan
 */
export interface GetTrustdockVerifications200ResponseSupplementalDocumentRecordsInnerPlan {
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockVerifications200ResponseSupplementalDocumentRecordsInnerPlan
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockVerifications200ResponseSupplementalDocumentRecordsInnerPlan
     */
    'name'?: string | null;
}
/**
 * 
 * @export
 * @interface GetTrustdockVerifications200ResponseSupplementalDocumentRecordsInnerReasonsInner
 */
export interface GetTrustdockVerifications200ResponseSupplementalDocumentRecordsInnerReasonsInner {
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockVerifications200ResponseSupplementalDocumentRecordsInnerReasonsInner
     */
    'target'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockVerifications200ResponseSupplementalDocumentRecordsInnerReasonsInner
     */
    'code'?: string | null;
    /**
     * 
     * @type {GetTrustdockVerifications200ResponseSupplementalDocumentRecordsInnerReasonsInnerDetail}
     * @memberof GetTrustdockVerifications200ResponseSupplementalDocumentRecordsInnerReasonsInner
     */
    'detail'?: GetTrustdockVerifications200ResponseSupplementalDocumentRecordsInnerReasonsInnerDetail | null;
}
/**
 * 
 * @export
 * @interface GetTrustdockVerifications200ResponseSupplementalDocumentRecordsInnerReasonsInnerDetail
 */
export interface GetTrustdockVerifications200ResponseSupplementalDocumentRecordsInnerReasonsInnerDetail {
    /**
     * 
     * @type {Array<string>}
     * @memberof GetTrustdockVerifications200ResponseSupplementalDocumentRecordsInnerReasonsInnerDetail
     */
    'fields'?: Array<string> | null;
}
/**
 * @type GetTrustdockVerifications200ResponseSupplementalDocumentRecordsInnerResult
 * @export
 */
export type GetTrustdockVerifications200ResponseSupplementalDocumentRecordsInnerResult = GetTrustdockVerifications200ResponseSupplementalDocumentRecordsInnerResultOneOf;

/**
 * 
 * @export
 * @enum {string}
 */

export const GetTrustdockVerifications200ResponseSupplementalDocumentRecordsInnerResultOneOf = {
    approved: 'approved',
    denied: 'denied'
} as const;

export type GetTrustdockVerifications200ResponseSupplementalDocumentRecordsInnerResultOneOf = typeof GetTrustdockVerifications200ResponseSupplementalDocumentRecordsInnerResultOneOf[keyof typeof GetTrustdockVerifications200ResponseSupplementalDocumentRecordsInnerResultOneOf];


/**
 * @type GetTrustdockVerifications200ResponseSupplementalDocumentResult
 * @export
 */
export type GetTrustdockVerifications200ResponseSupplementalDocumentResult = GetTrustdockVerifications200ResponseSupplementalDocumentResultOneOf;

/**
 * 
 * @export
 * @enum {string}
 */

export const GetTrustdockVerifications200ResponseSupplementalDocumentResultOneOf = {
    approved: 'approved',
    denied: 'denied'
} as const;

export type GetTrustdockVerifications200ResponseSupplementalDocumentResultOneOf = typeof GetTrustdockVerifications200ResponseSupplementalDocumentResultOneOf[keyof typeof GetTrustdockVerifications200ResponseSupplementalDocumentResultOneOf];


/**
 * 
 * @export
 * @interface GetUnreadMessageCount200Response
 */
export interface GetUnreadMessageCount200Response {
    /**
     * 
     * @type {number}
     * @memberof GetUnreadMessageCount200Response
     */
    'count'?: number;
}
/**
 * 
 * @export
 * @interface GetUsageFee200Response
 */
export interface GetUsageFee200Response {
    /**
     * 
     * @type {string}
     * @memberof GetUsageFee200Response
     */
    'usageFeeId': string;
    /**
     * 
     * @type {number}
     * @memberof GetUsageFee200Response
     */
    'yearMonth': number;
    /**
     * 
     * @type {string}
     * @memberof GetUsageFee200Response
     */
    'scheduledPaymentDate': string;
    /**
     * 
     * @type {string}
     * @memberof GetUsageFee200Response
     */
    'paymentDate': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetUsageFee200Response
     */
    'paymentType': GetUsageFee200ResponsePaymentTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof GetUsageFee200Response
     */
    'totalAmount': number;
    /**
     * 
     * @type {number}
     * @memberof GetUsageFee200Response
     */
    'pointAmount': number;
    /**
     * 
     * @type {number}
     * @memberof GetUsageFee200Response
     */
    'billsNum': number;
    /**
     * 
     * @type {number}
     * @memberof GetUsageFee200Response
     */
    'unitPrice': number;
    /**
     * 
     * @type {number}
     * @memberof GetUsageFee200Response
     */
    'transferAgencyFeeAmount': number;
    /**
     * 
     * @type {number}
     * @memberof GetUsageFee200Response
     */
    'discountQuota': number;
    /**
     * 
     * @type {number}
     * @memberof GetUsageFee200Response
     */
    'discountedNum': number;
    /**
     * 
     * @type {number}
     * @memberof GetUsageFee200Response
     */
    'discountUnitPrice': number;
    /**
     * 
     * @type {number}
     * @memberof GetUsageFee200Response
     */
    'discountedAmount': number;
    /**
     * 
     * @type {number}
     * @memberof GetUsageFee200Response
     */
    'cardsNum': number;
    /**
     * 
     * @type {number}
     * @memberof GetUsageFee200Response
     */
    'cardUnitPrice': number;
    /**
     * 
     * @type {number}
     * @memberof GetUsageFee200Response
     */
    'cardUsageFeeAmount': number;
    /**
     * 
     * @type {number}
     * @memberof GetUsageFee200Response
     */
    'cardDiscountedNum': number;
    /**
     * 
     * @type {number}
     * @memberof GetUsageFee200Response
     */
    'cardDiscountUnitPrice': number;
    /**
     * 
     * @type {number}
     * @memberof GetUsageFee200Response
     */
    'cardDiscountedAmount': number;
    /**
     * 
     * @type {number}
     * @memberof GetUsageFee200Response
     */
    'virtualCardsNum': number;
    /**
     * 
     * @type {number}
     * @memberof GetUsageFee200Response
     */
    'virtualCardUnitPrice': number;
    /**
     * 
     * @type {number}
     * @memberof GetUsageFee200Response
     */
    'virtualCardUsageFeeAmount': number;
    /**
     * 
     * @type {number}
     * @memberof GetUsageFee200Response
     */
    'virtualCardDiscountedNum': number;
    /**
     * 
     * @type {number}
     * @memberof GetUsageFee200Response
     */
    'virtualCardDiscountUnitPrice': number;
    /**
     * 
     * @type {number}
     * @memberof GetUsageFee200Response
     */
    'virtualCardDiscountedAmount': number;
    /**
     * 
     * @type {number}
     * @memberof GetUsageFee200Response
     */
    'subTotal': number;
    /**
     * 
     * @type {number}
     * @memberof GetUsageFee200Response
     */
    'salesTaxAmount': number;
    /**
     * 
     * @type {GetUsageFee200ResponseLatestStatus}
     * @memberof GetUsageFee200Response
     */
    'latestStatus': GetUsageFee200ResponseLatestStatus;
    /**
     * 
     * @type {Array<GetUsageFee200ResponseBillsInner>}
     * @memberof GetUsageFee200Response
     */
    'bills': Array<GetUsageFee200ResponseBillsInner>;
    /**
     * 
     * @type {boolean}
     * @memberof GetUsageFee200Response
     */
    'isCardUsageFeeWaived': boolean;
}

export const GetUsageFee200ResponsePaymentTypeEnum = {
    payBill: 'PAY_BILL',
    usageFee: 'USAGE_FEE',
    card: 'CARD'
} as const;

export type GetUsageFee200ResponsePaymentTypeEnum = typeof GetUsageFee200ResponsePaymentTypeEnum[keyof typeof GetUsageFee200ResponsePaymentTypeEnum];

/**
 * 
 * @export
 * @interface GetUsageFee200ResponseBillsInner
 */
export interface GetUsageFee200ResponseBillsInner {
    /**
     * 
     * @type {string}
     * @memberof GetUsageFee200ResponseBillsInner
     */
    'billId': string;
    /**
     * 
     * @type {string}
     * @memberof GetUsageFee200ResponseBillsInner
     */
    'bankAccountActivityId': string;
    /**
     * 
     * @type {string}
     * @memberof GetUsageFee200ResponseBillsInner
     */
    'supplierName': string;
    /**
     * 
     * @type {string}
     * @memberof GetUsageFee200ResponseBillsInner
     */
    'latestStatus': GetUsageFee200ResponseBillsInnerLatestStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof GetUsageFee200ResponseBillsInner
     */
    'amount': number;
    /**
     * 
     * @type {string}
     * @memberof GetUsageFee200ResponseBillsInner
     */
    'appliedAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetUsageFee200ResponseBillsInner
     */
    'transferDate': string;
}

export const GetUsageFee200ResponseBillsInnerLatestStatusEnum = {
    reserved: 'RESERVED',
    requestingExternalAccountTransfer: 'REQUESTING_EXTERNAL_ACCOUNT_TRANSFER',
    completed: 'COMPLETED',
    insufficientBalance: 'INSUFFICIENT_BALANCE',
    uploaded: 'UPLOADED',
    readCompleted: 'READ_COMPLETED',
    awaitingApproval: 'AWAITING_APPROVAL',
    approved: 'APPROVED',
    transferCompleted: 'TRANSFER_COMPLETED',
    readError: 'READ_ERROR',
    transferFailed: 'TRANSFER_FAILED',
    approvalExpired: 'APPROVAL_EXPIRED',
    approvalRejected: 'APPROVAL_REJECTED',
    otherError: 'OTHER_ERROR',
    pending: 'PENDING'
} as const;

export type GetUsageFee200ResponseBillsInnerLatestStatusEnum = typeof GetUsageFee200ResponseBillsInnerLatestStatusEnum[keyof typeof GetUsageFee200ResponseBillsInnerLatestStatusEnum];

/**
 * 
 * @export
 * @interface GetUsageFee200ResponseLatestStatus
 */
export interface GetUsageFee200ResponseLatestStatus {
    /**
     * 
     * @type {string}
     * @memberof GetUsageFee200ResponseLatestStatus
     */
    'status': GetUsageFee200ResponseLatestStatusStatusEnum;
}

export const GetUsageFee200ResponseLatestStatusStatusEnum = {
    reserved: 'RESERVED',
    requestingExternalAccountTransfer: 'REQUESTING_EXTERNAL_ACCOUNT_TRANSFER',
    completed: 'COMPLETED',
    insufficientBalance: 'INSUFFICIENT_BALANCE',
    transferReceivable: 'TRANSFER_RECEIVABLE'
} as const;

export type GetUsageFee200ResponseLatestStatusStatusEnum = typeof GetUsageFee200ResponseLatestStatusStatusEnum[keyof typeof GetUsageFee200ResponseLatestStatusStatusEnum];

/**
 * 
 * @export
 * @interface GetUserAccountGroups200ResponseInner
 */
export interface GetUserAccountGroups200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetUserAccountGroups200ResponseInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetUserAccountGroups200ResponseInner
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof GetUserAccountGroups200ResponseInner
     */
    'sortNum': number;
}
/**
 * 
 * @export
 * @interface GetUserAccountYearMonthSummary200ResponseInner
 */
export interface GetUserAccountYearMonthSummary200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetUserAccountYearMonthSummary200ResponseInner
     */
    'comment': string;
    /**
     * 
     * @type {GetUserAccountYearMonthSummary200ResponseInnerMerchant}
     * @memberof GetUserAccountYearMonthSummary200ResponseInner
     */
    'merchant': GetUserAccountYearMonthSummary200ResponseInnerMerchant;
    /**
     * 
     * @type {Array<GetUserAccountYearMonthSummary200ResponseInnerUserAccountsInner>}
     * @memberof GetUserAccountYearMonthSummary200ResponseInner
     */
    'userAccounts': Array<GetUserAccountYearMonthSummary200ResponseInnerUserAccountsInner>;
}
/**
 * 
 * @export
 * @interface GetUserAccountYearMonthSummary200ResponseInnerMerchant
 */
export interface GetUserAccountYearMonthSummary200ResponseInnerMerchant {
    /**
     * 
     * @type {string}
     * @memberof GetUserAccountYearMonthSummary200ResponseInnerMerchant
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetUserAccountYearMonthSummary200ResponseInnerMerchant
     */
    'logoUrl': string;
    /**
     * 
     * @type {string}
     * @memberof GetUserAccountYearMonthSummary200ResponseInnerMerchant
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetUserAccountYearMonthSummary200ResponseInnerMerchant
     */
    'nameJp': string;
}
/**
 * 
 * @export
 * @interface GetUserAccountYearMonthSummary200ResponseInnerUserAccountsInner
 */
export interface GetUserAccountYearMonthSummary200ResponseInnerUserAccountsInner {
    /**
     * 
     * @type {GetUserAccountYearMonthSummary200ResponseInnerUserAccountsInnerCard}
     * @memberof GetUserAccountYearMonthSummary200ResponseInnerUserAccountsInner
     */
    'card': GetUserAccountYearMonthSummary200ResponseInnerUserAccountsInnerCard;
    /**
     * 
     * @type {string}
     * @memberof GetUserAccountYearMonthSummary200ResponseInnerUserAccountsInner
     */
    'comment': string;
    /**
     * 
     * @type {string}
     * @memberof GetUserAccountYearMonthSummary200ResponseInnerUserAccountsInner
     */
    'firstUseYearMonth': string;
    /**
     * 
     * @type {Array<GetUserAccountYearMonthSummary200ResponseInnerUserAccountsInnerRecordsInner>}
     * @memberof GetUserAccountYearMonthSummary200ResponseInnerUserAccountsInner
     */
    'records': Array<GetUserAccountYearMonthSummary200ResponseInnerUserAccountsInnerRecordsInner>;
}
/**
 * 
 * @export
 * @interface GetUserAccountYearMonthSummary200ResponseInnerUserAccountsInnerCard
 */
export interface GetUserAccountYearMonthSummary200ResponseInnerUserAccountsInnerCard {
    /**
     * 
     * @type {string}
     * @memberof GetUserAccountYearMonthSummary200ResponseInnerUserAccountsInnerCard
     */
    'cardId': string;
    /**
     * 
     * @type {string}
     * @memberof GetUserAccountYearMonthSummary200ResponseInnerUserAccountsInnerCard
     */
    'cardLabel': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserAccountYearMonthSummary200ResponseInnerUserAccountsInnerCard
     */
    'isActivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserAccountYearMonthSummary200ResponseInnerUserAccountsInnerCard
     */
    'isDeactivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserAccountYearMonthSummary200ResponseInnerUserAccountsInnerCard
     */
    'isFrozen': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserAccountYearMonthSummary200ResponseInnerUserAccountsInnerCard
     */
    'isLocked': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserAccountYearMonthSummary200ResponseInnerUserAccountsInnerCard
     */
    'isSuspended': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserAccountYearMonthSummary200ResponseInnerUserAccountsInnerCard
     */
    'isVirtualCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserAccountYearMonthSummary200ResponseInnerUserAccountsInnerCard
     */
    'isCreaditCard'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserAccountYearMonthSummary200ResponseInnerUserAccountsInnerCard
     */
    'isOnDemand'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserAccountYearMonthSummary200ResponseInnerUserAccountsInnerCard
     */
    'isMetalCard': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetUserAccountYearMonthSummary200ResponseInnerUserAccountsInnerCard
     */
    'panLastFourDigits': string;
    /**
     * 
     * @type {GetUserAccountYearMonthSummary200ResponseInnerUserAccountsInnerCardUser}
     * @memberof GetUserAccountYearMonthSummary200ResponseInnerUserAccountsInnerCard
     */
    'user'?: GetUserAccountYearMonthSummary200ResponseInnerUserAccountsInnerCardUser;
    /**
     * 
     * @type {string}
     * @memberof GetUserAccountYearMonthSummary200ResponseInnerUserAccountsInnerCard
     */
    'userAccountId': string;
    /**
     * 
     * @type {GetUserAccountYearMonthSummary200ResponseInnerUserAccountsInnerCardUserAccountGroup}
     * @memberof GetUserAccountYearMonthSummary200ResponseInnerUserAccountsInnerCard
     */
    'userAccountGroup'?: GetUserAccountYearMonthSummary200ResponseInnerUserAccountsInnerCardUserAccountGroup;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserAccountYearMonthSummary200ResponseInnerUserAccountsInnerCard
     */
    'isPhysicalStorePaymentDisabled': boolean;
}
/**
 * 
 * @export
 * @interface GetUserAccountYearMonthSummary200ResponseInnerUserAccountsInnerCardUser
 */
export interface GetUserAccountYearMonthSummary200ResponseInnerUserAccountsInnerCardUser {
    /**
     * 
     * @type {string}
     * @memberof GetUserAccountYearMonthSummary200ResponseInnerUserAccountsInnerCardUser
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetUserAccountYearMonthSummary200ResponseInnerUserAccountsInnerCardUser
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetUserAccountYearMonthSummary200ResponseInnerUserAccountsInnerCardUser
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetUserAccountYearMonthSummary200ResponseInnerUserAccountsInnerCardUser
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof GetUserAccountYearMonthSummary200ResponseInnerUserAccountsInnerCardUser
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserAccountYearMonthSummary200ResponseInnerUserAccountsInnerCardUser
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserAccountYearMonthSummary200ResponseInnerUserAccountsInnerCardUser
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserAccountYearMonthSummary200ResponseInnerUserAccountsInnerCardUser
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserAccountYearMonthSummary200ResponseInnerUserAccountsInnerCardUser
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserAccountYearMonthSummary200ResponseInnerUserAccountsInnerCardUser
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetUserAccountYearMonthSummary200ResponseInnerUserAccountsInnerCardUser
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface GetUserAccountYearMonthSummary200ResponseInnerUserAccountsInnerCardUserAccountGroup
 */
export interface GetUserAccountYearMonthSummary200ResponseInnerUserAccountsInnerCardUserAccountGroup {
    /**
     * 
     * @type {string}
     * @memberof GetUserAccountYearMonthSummary200ResponseInnerUserAccountsInnerCardUserAccountGroup
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetUserAccountYearMonthSummary200ResponseInnerUserAccountsInnerCardUserAccountGroup
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof GetUserAccountYearMonthSummary200ResponseInnerUserAccountsInnerCardUserAccountGroup
     */
    'sortNum': number;
}
/**
 * 
 * @export
 * @interface GetUserAccountYearMonthSummary200ResponseInnerUserAccountsInnerRecordsInner
 */
export interface GetUserAccountYearMonthSummary200ResponseInnerUserAccountsInnerRecordsInner {
    /**
     * 
     * @type {number}
     * @memberof GetUserAccountYearMonthSummary200ResponseInnerUserAccountsInnerRecordsInner
     */
    'amount': number;
    /**
     * 
     * @type {string}
     * @memberof GetUserAccountYearMonthSummary200ResponseInnerUserAccountsInnerRecordsInner
     */
    'comment': string;
    /**
     * 
     * @type {string}
     * @memberof GetUserAccountYearMonthSummary200ResponseInnerUserAccountsInnerRecordsInner
     */
    'yearMonth': string;
}
/**
 * 
 * @export
 * @interface GetUserAccountsWithDefaultCommentTemplate200ResponseInner
 */
export interface GetUserAccountsWithDefaultCommentTemplate200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetUserAccountsWithDefaultCommentTemplate200ResponseInner
     */
    'cardLabel': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserAccountsWithDefaultCommentTemplate200ResponseInner
     */
    'setDefaultTemplate': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetUserAccountsWithDefaultCommentTemplate200ResponseInner
     */
    'userAccountId': string;
}
/**
 * 
 * @export
 * @interface GetUserCards200ResponseInner
 */
export interface GetUserCards200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetUserCards200ResponseInner
     */
    'cardId': string;
    /**
     * 
     * @type {string}
     * @memberof GetUserCards200ResponseInner
     */
    'cardLabel': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserCards200ResponseInner
     */
    'isActivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserCards200ResponseInner
     */
    'isDeactivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserCards200ResponseInner
     */
    'isLocked': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserCards200ResponseInner
     */
    'isSuspended': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserCards200ResponseInner
     */
    'isFrozen': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserCards200ResponseInner
     */
    'isVirtualCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserCards200ResponseInner
     */
    'isCreditCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserCards200ResponseInner
     */
    'isOnDemand': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserCards200ResponseInner
     */
    'isMetalCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserCards200ResponseInner
     */
    'isPhysicalStorePaymentDisabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetUserCards200ResponseInner
     */
    'panLastFourDigits': string;
    /**
     * 
     * @type {string}
     * @memberof GetUserCards200ResponseInner
     */
    'userAccountId': string;
    /**
     * 
     * @type {number}
     * @memberof GetUserCards200ResponseInner
     */
    'transactionUpperLimit': number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetUserCards200ResponseInner
     */
    'availableCurrencies': Array<GetUserCards200ResponseInnerAvailableCurrenciesEnum>;
    /**
     * 
     * @type {Array<GetUserCards200ResponseInnerAvailableMerchantCategoriesInner>}
     * @memberof GetUserCards200ResponseInner
     */
    'availableMerchantCategories': Array<GetUserCards200ResponseInnerAvailableMerchantCategoriesInner> | null;
    /**
     * 
     * @type {GetUserCards200ResponseInnerUser}
     * @memberof GetUserCards200ResponseInner
     */
    'user': GetUserCards200ResponseInnerUser;
    /**
     * 
     * @type {GetUserCards200ResponseInnerUserAccountGroup}
     * @memberof GetUserCards200ResponseInner
     */
    'userAccountGroup'?: GetUserCards200ResponseInnerUserAccountGroup | null;
    /**
     * 
     * @type {number}
     * @memberof GetUserCards200ResponseInner
     */
    'monthlyTotalUsage': number;
    /**
     * 
     * @type {number}
     * @memberof GetUserCards200ResponseInner
     */
    'monthlyUsageLimit': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetUserCards200ResponseInner
     */
    'dailyTotalUsage': number;
    /**
     * 
     * @type {number}
     * @memberof GetUserCards200ResponseInner
     */
    'dailyUsageLimit': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetUserCards200ResponseInner
     */
    'totalUsageAmount': number;
    /**
     * 
     * @type {number}
     * @memberof GetUserCards200ResponseInner
     */
    'totalUsageAmountLimit': number | null;
    /**
     * 
     * @type {string}
     * @memberof GetUserCards200ResponseInner
     */
    'expiredDate': string | null;
}

export const GetUserCards200ResponseInnerAvailableCurrenciesEnum = {
    jpy: 'JPY',
    usd: 'USD',
    gbp: 'GBP',
    eur: 'EUR',
    sgd: 'SGD',
    aud: 'AUD',
    cny: 'CNY',
    hkd: 'HKD',
    idr: 'IDR',
    krw: 'KRW',
    nzd: 'NZD',
    php: 'PHP',
    rub: 'RUB',
    vnd: 'VND',
    inr: 'INR',
    thb: 'THB',
    lak: 'LAK',
    myr: 'MYR',
    twd: 'TWD',
    chf: 'CHF',
    cad: 'CAD',
    mxn: 'MXN',
    nok: 'NOK',
    huf: 'HUF',
    hrk: 'HRK',
    czk: 'CZK',
    dkk: 'DKK',
    isk: 'ISK',
    mdl: 'MDL',
    sek: 'SEK',
    mkd: 'MKD',
    rsd: 'RSD',
    ron: 'RON',
    bgn: 'BGN',
    bam: 'BAM',
    pln: 'PLN',
    mad: 'MAD',
    zar: 'ZAR',
    rwf: 'RWF',
    kes: 'KES',
    ngn: 'NGN',
    aed: 'AED',
    sar: 'SAR',
    egp: 'EGP',
    qar: 'QAR',
    omr: 'OMR',
    ils: 'ILS',
    try: 'TRY',
    kzt: 'KZT',
    cop: 'COP',
    gtq: 'GTQ'
} as const;

export type GetUserCards200ResponseInnerAvailableCurrenciesEnum = typeof GetUserCards200ResponseInnerAvailableCurrenciesEnum[keyof typeof GetUserCards200ResponseInnerAvailableCurrenciesEnum];

/**
 * 
 * @export
 * @interface GetUserCards200ResponseInnerAvailableMerchantCategoriesInner
 */
export interface GetUserCards200ResponseInnerAvailableMerchantCategoriesInner {
    /**
     * 
     * @type {string}
     * @memberof GetUserCards200ResponseInnerAvailableMerchantCategoriesInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetUserCards200ResponseInnerAvailableMerchantCategoriesInner
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetUserCards200ResponseInnerAvailableMerchantCategoriesInner
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof GetUserCards200ResponseInnerAvailableMerchantCategoriesInner
     */
    'logoUrl': string;
}
/**
 * 
 * @export
 * @interface GetUserCards200ResponseInnerUser
 */
export interface GetUserCards200ResponseInnerUser {
    /**
     * 
     * @type {string}
     * @memberof GetUserCards200ResponseInnerUser
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetUserCards200ResponseInnerUser
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetUserCards200ResponseInnerUser
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetUserCards200ResponseInnerUser
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof GetUserCards200ResponseInnerUser
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserCards200ResponseInnerUser
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserCards200ResponseInnerUser
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserCards200ResponseInnerUser
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserCards200ResponseInnerUser
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserCards200ResponseInnerUser
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetUserCards200ResponseInnerUser
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface GetUserCards200ResponseInnerUserAccountGroup
 */
export interface GetUserCards200ResponseInnerUserAccountGroup {
    /**
     * 
     * @type {string}
     * @memberof GetUserCards200ResponseInnerUserAccountGroup
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetUserCards200ResponseInnerUserAccountGroup
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof GetUserCards200ResponseInnerUserAccountGroup
     */
    'sortNum': number;
}
/**
 * 
 * @export
 * @interface GetUserCardsExtended200ResponseInner
 */
export interface GetUserCardsExtended200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetUserCardsExtended200ResponseInner
     */
    'cardId': string;
    /**
     * 
     * @type {string}
     * @memberof GetUserCardsExtended200ResponseInner
     */
    'userAccountId': string;
    /**
     * 
     * @type {string}
     * @memberof GetUserCardsExtended200ResponseInner
     */
    'expiredDate': string | null;
    /**
     * 
     * @type {number}
     * @memberof GetUserCardsExtended200ResponseInner
     */
    'monthlyUsageLimit': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetUserCardsExtended200ResponseInner
     */
    'monthlyUsageAmount': number;
    /**
     * 
     * @type {number}
     * @memberof GetUserCardsExtended200ResponseInner
     */
    'totalUsageLimit': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetUserCardsExtended200ResponseInner
     */
    'totalUsageAmount': number;
}
/**
 * 
 * @export
 * @interface GetUserCardsExtendedForRoleResources200ResponseInner
 */
export interface GetUserCardsExtendedForRoleResources200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetUserCardsExtendedForRoleResources200ResponseInner
     */
    'cardId': string;
    /**
     * 
     * @type {string}
     * @memberof GetUserCardsExtendedForRoleResources200ResponseInner
     */
    'userAccountId': string;
    /**
     * 
     * @type {string}
     * @memberof GetUserCardsExtendedForRoleResources200ResponseInner
     */
    'expiredDate': string | null;
    /**
     * 
     * @type {number}
     * @memberof GetUserCardsExtendedForRoleResources200ResponseInner
     */
    'monthlyUsageLimit': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetUserCardsExtendedForRoleResources200ResponseInner
     */
    'monthlyUsageAmount': number;
    /**
     * 
     * @type {number}
     * @memberof GetUserCardsExtendedForRoleResources200ResponseInner
     */
    'totalUsageLimit': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetUserCardsExtendedForRoleResources200ResponseInner
     */
    'totalUsageAmount': number;
}
/**
 * 
 * @export
 * @interface GetUserCardsLight200ResponseInner
 */
export interface GetUserCardsLight200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetUserCardsLight200ResponseInner
     */
    'cardId': string;
    /**
     * 
     * @type {string}
     * @memberof GetUserCardsLight200ResponseInner
     */
    'cardLabel': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserCardsLight200ResponseInner
     */
    'isActivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserCardsLight200ResponseInner
     */
    'isDeactivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserCardsLight200ResponseInner
     */
    'isFrozen': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserCardsLight200ResponseInner
     */
    'isLocked': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserCardsLight200ResponseInner
     */
    'isSuspended': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserCardsLight200ResponseInner
     */
    'isVirtualCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserCardsLight200ResponseInner
     */
    'isCreaditCard'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserCardsLight200ResponseInner
     */
    'isOnDemand'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserCardsLight200ResponseInner
     */
    'isMetalCard': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetUserCardsLight200ResponseInner
     */
    'panLastFourDigits': string;
    /**
     * 
     * @type {GetUserCardsLight200ResponseInnerUser}
     * @memberof GetUserCardsLight200ResponseInner
     */
    'user'?: GetUserCardsLight200ResponseInnerUser;
    /**
     * 
     * @type {string}
     * @memberof GetUserCardsLight200ResponseInner
     */
    'userAccountId': string;
    /**
     * 
     * @type {GetUserCardsLight200ResponseInnerUserAccountGroup}
     * @memberof GetUserCardsLight200ResponseInner
     */
    'userAccountGroup'?: GetUserCardsLight200ResponseInnerUserAccountGroup;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserCardsLight200ResponseInner
     */
    'isPhysicalStorePaymentDisabled': boolean;
}
/**
 * 
 * @export
 * @interface GetUserCardsLight200ResponseInnerUser
 */
export interface GetUserCardsLight200ResponseInnerUser {
    /**
     * 
     * @type {string}
     * @memberof GetUserCardsLight200ResponseInnerUser
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetUserCardsLight200ResponseInnerUser
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetUserCardsLight200ResponseInnerUser
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetUserCardsLight200ResponseInnerUser
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof GetUserCardsLight200ResponseInnerUser
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserCardsLight200ResponseInnerUser
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserCardsLight200ResponseInnerUser
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserCardsLight200ResponseInnerUser
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserCardsLight200ResponseInnerUser
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserCardsLight200ResponseInnerUser
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetUserCardsLight200ResponseInnerUser
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface GetUserCardsLight200ResponseInnerUserAccountGroup
 */
export interface GetUserCardsLight200ResponseInnerUserAccountGroup {
    /**
     * 
     * @type {string}
     * @memberof GetUserCardsLight200ResponseInnerUserAccountGroup
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetUserCardsLight200ResponseInnerUserAccountGroup
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof GetUserCardsLight200ResponseInnerUserAccountGroup
     */
    'sortNum': number;
}
/**
 * 
 * @export
 * @interface GetUserCardsLightForRoleResources200ResponseInner
 */
export interface GetUserCardsLightForRoleResources200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetUserCardsLightForRoleResources200ResponseInner
     */
    'cardId': string;
    /**
     * 
     * @type {string}
     * @memberof GetUserCardsLightForRoleResources200ResponseInner
     */
    'cardLabel': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserCardsLightForRoleResources200ResponseInner
     */
    'isActivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserCardsLightForRoleResources200ResponseInner
     */
    'isDeactivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserCardsLightForRoleResources200ResponseInner
     */
    'isFrozen': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserCardsLightForRoleResources200ResponseInner
     */
    'isLocked': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserCardsLightForRoleResources200ResponseInner
     */
    'isSuspended': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserCardsLightForRoleResources200ResponseInner
     */
    'isVirtualCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserCardsLightForRoleResources200ResponseInner
     */
    'isCreaditCard'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserCardsLightForRoleResources200ResponseInner
     */
    'isOnDemand'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetUserCardsLightForRoleResources200ResponseInner
     */
    'panLastFourDigits': string;
    /**
     * 
     * @type {GetUserCardsLightForRoleResources200ResponseInnerUser}
     * @memberof GetUserCardsLightForRoleResources200ResponseInner
     */
    'user'?: GetUserCardsLightForRoleResources200ResponseInnerUser;
    /**
     * 
     * @type {string}
     * @memberof GetUserCardsLightForRoleResources200ResponseInner
     */
    'userAccountId': string;
    /**
     * 
     * @type {GetUserCardsLightForRoleResources200ResponseInnerUserAccountGroup}
     * @memberof GetUserCardsLightForRoleResources200ResponseInner
     */
    'userAccountGroup'?: GetUserCardsLightForRoleResources200ResponseInnerUserAccountGroup;
    /**
     * 
     * @type {string}
     * @memberof GetUserCardsLightForRoleResources200ResponseInner
     */
    'resourceScope': GetUserCardsLightForRoleResources200ResponseInnerResourceScopeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetUserCardsLightForRoleResources200ResponseInner
     */
    'resourceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetUserCardsLightForRoleResources200ResponseInner
     */
    'role': GetUserCardsLightForRoleResources200ResponseInnerRoleEnum;
}

export const GetUserCardsLightForRoleResources200ResponseInnerResourceScopeEnum = {
    account: 'USER_ACCOUNT',
    accountGroup: 'USER_ACCOUNT_GROUP',
    accountAll: 'USER_ACCOUNT_ALL'
} as const;

export type GetUserCardsLightForRoleResources200ResponseInnerResourceScopeEnum = typeof GetUserCardsLightForRoleResources200ResponseInnerResourceScopeEnum[keyof typeof GetUserCardsLightForRoleResources200ResponseInnerResourceScopeEnum];
export const GetUserCardsLightForRoleResources200ResponseInnerRoleEnum = {
    admin: 'USER_ACCOUNT_ADMIN',
    assist: 'USER_ACCOUNT_ASSIST'
} as const;

export type GetUserCardsLightForRoleResources200ResponseInnerRoleEnum = typeof GetUserCardsLightForRoleResources200ResponseInnerRoleEnum[keyof typeof GetUserCardsLightForRoleResources200ResponseInnerRoleEnum];

/**
 * 
 * @export
 * @interface GetUserCardsLightForRoleResources200ResponseInnerUser
 */
export interface GetUserCardsLightForRoleResources200ResponseInnerUser {
    /**
     * 
     * @type {string}
     * @memberof GetUserCardsLightForRoleResources200ResponseInnerUser
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetUserCardsLightForRoleResources200ResponseInnerUser
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetUserCardsLightForRoleResources200ResponseInnerUser
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetUserCardsLightForRoleResources200ResponseInnerUser
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof GetUserCardsLightForRoleResources200ResponseInnerUser
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserCardsLightForRoleResources200ResponseInnerUser
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserCardsLightForRoleResources200ResponseInnerUser
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserCardsLightForRoleResources200ResponseInnerUser
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserCardsLightForRoleResources200ResponseInnerUser
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserCardsLightForRoleResources200ResponseInnerUser
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetUserCardsLightForRoleResources200ResponseInnerUser
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface GetUserCardsLightForRoleResources200ResponseInnerUserAccountGroup
 */
export interface GetUserCardsLightForRoleResources200ResponseInnerUserAccountGroup {
    /**
     * 
     * @type {string}
     * @memberof GetUserCardsLightForRoleResources200ResponseInnerUserAccountGroup
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetUserCardsLightForRoleResources200ResponseInnerUserAccountGroup
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof GetUserCardsLightForRoleResources200ResponseInnerUserAccountGroup
     */
    'sortNum': number;
}
/**
 * 
 * @export
 * @interface GetUserMessageDetail200Response
 */
export interface GetUserMessageDetail200Response {
    /**
     * 
     * @type {number}
     * @memberof GetUserMessageDetail200Response
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof GetUserMessageDetail200Response
     */
    'subject': string;
    /**
     * 
     * @type {string}
     * @memberof GetUserMessageDetail200Response
     */
    'body': string;
    /**
     * 
     * @type {string}
     * @memberof GetUserMessageDetail200Response
     */
    'readAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetUserMessageDetail200Response
     */
    'displayStartAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetUserMessageDetail200Response
     */
    'displayEndAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetUserMessageDetail200Response
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetUserMessageDetail200Response
     */
    'bodyStyle': GetUserMessageDetail200ResponseBodyStyleEnum;
}

export const GetUserMessageDetail200ResponseBodyStyleEnum = {
    md: 'MD',
    text: 'TEXT'
} as const;

export type GetUserMessageDetail200ResponseBodyStyleEnum = typeof GetUserMessageDetail200ResponseBodyStyleEnum[keyof typeof GetUserMessageDetail200ResponseBodyStyleEnum];

/**
 * 
 * @export
 * @interface GetUserMessages200Response
 */
export interface GetUserMessages200Response {
    /**
     * 
     * @type {Array<GetUserMessages200ResponseMessagesInner>}
     * @memberof GetUserMessages200Response
     */
    'messages': Array<GetUserMessages200ResponseMessagesInner>;
    /**
     * Total number of messages
     * @type {number}
     * @memberof GetUserMessages200Response
     */
    'totalCount': number;
}
/**
 * 
 * @export
 * @interface GetUserMessages200ResponseMessagesInner
 */
export interface GetUserMessages200ResponseMessagesInner {
    /**
     * 
     * @type {number}
     * @memberof GetUserMessages200ResponseMessagesInner
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof GetUserMessages200ResponseMessagesInner
     */
    'subject': string;
    /**
     * 
     * @type {string}
     * @memberof GetUserMessages200ResponseMessagesInner
     */
    'readAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetUserMessages200ResponseMessagesInner
     */
    'displayStartAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetUserMessages200ResponseMessagesInner
     */
    'displayEndAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetUserMessages200ResponseMessagesInner
     */
    'createdAt': string;
}
/**
 * 
 * @export
 * @interface GetUsers200ResponseInner
 */
export interface GetUsers200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetUsers200ResponseInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetUsers200ResponseInner
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetUsers200ResponseInner
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetUsers200ResponseInner
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof GetUsers200ResponseInner
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetUsers200ResponseInner
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetUsers200ResponseInner
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetUsers200ResponseInner
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetUsers200ResponseInner
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetUsers200ResponseInner
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetUsers200ResponseInner
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface GetUsersMe200Response
 */
export interface GetUsersMe200Response {
    /**
     * 
     * @type {string}
     * @memberof GetUsersMe200Response
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetUsersMe200Response
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetUsersMe200Response
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetUsersMe200Response
     */
    'email': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetUsersMe200Response
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetUsersMe200Response
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetUsersMe200Response
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetUsersMe200Response
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetUsersMe200Response
     */
    'isSystemAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetUsersMe200Response
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetUsersMe200Response
     */
    'twoFactorAuthRegisterStatus': string;
    /**
     * 
     * @type {string}
     * @memberof GetUsersMe200Response
     */
    'smsPhoneNumber': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetUsersMe200Response
     */
    'roles': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof GetUsersMe200Response
     */
    'organizationName': string;
    /**
     * 
     * @type {Array<GetUsersMe200ResponseContractsInner>}
     * @memberof GetUsersMe200Response
     */
    'contracts': Array<GetUsersMe200ResponseContractsInner>;
    /**
     * 
     * @type {boolean}
     * @memberof GetUsersMe200Response
     */
    'hasCardContract': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetUsersMe200Response
     */
    'hasPayContract': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetUsersMe200Response
     */
    'isJournalFeatureEnabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetUsersMe200Response
     */
    'freeeCompanyId': string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetUsersMe200Response
     */
    'availableFeatures': Array<GetUsersMe200ResponseAvailableFeaturesEnum>;
}

export const GetUsersMe200ResponseAvailableFeaturesEnum = {
    invoicingSystemCompliance: 'INVOICING_SYSTEM_COMPLIANCE',
    paymentRequest: 'PAYMENT_REQUEST',
    workflow: 'WORKFLOW',
    workApplication: 'WORK_APPLICATION',
    coworker: 'COWORKER',
    teamsApp: 'TEAMS_APP',
    adBoost: 'AD_BOOST'
} as const;

export type GetUsersMe200ResponseAvailableFeaturesEnum = typeof GetUsersMe200ResponseAvailableFeaturesEnum[keyof typeof GetUsersMe200ResponseAvailableFeaturesEnum];

/**
 * 
 * @export
 * @interface GetUsersMe200ResponseContractsInner
 */
export interface GetUsersMe200ResponseContractsInner {
    /**
     * 
     * @type {number}
     * @memberof GetUsersMe200ResponseContractsInner
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof GetUsersMe200ResponseContractsInner
     */
    'organizationId': number;
    /**
     * 
     * @type {string}
     * @memberof GetUsersMe200ResponseContractsInner
     */
    'contractType': string;
    /**
     * 
     * @type {string}
     * @memberof GetUsersMe200ResponseContractsInner
     */
    'startAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetUsersMe200ResponseContractsInner
     */
    'endAt': string;
}
/**
 * 
 * @export
 * @interface GetVentureCapitals200ResponseInner
 */
export interface GetVentureCapitals200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetVentureCapitals200ResponseInner
     */
    'vcCode': string;
    /**
     * 
     * @type {string}
     * @memberof GetVentureCapitals200ResponseInner
     */
    'vcName': string;
}
/**
 * 取引時確認詳細情報 
 * @export
 * @interface GetZeusOrganizationIdentityVerificationsForPresident200ResponseInner
 */
export interface GetZeusOrganizationIdentityVerificationsForPresident200ResponseInner {
    /**
     * 取引時確認ID
     * @type {string}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInner
     */
    'id': string;
    /**
     * 法人名
     * @type {string}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInner
     */
    'organizationName': string;
    /**
     * 法人番号
     * @type {string}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInner
     */
    'corporateNumber': string;
    /**
     * 法人種別
     * @type {string}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInner
     */
    'corporateType'?: GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerCorporateTypeEnum;
    /**
     * 代表者氏名
     * @type {string}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInner
     */
    'representativeName': string;
    /**
     * 本社所在地：住所
     * @type {string}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInner
     */
    'address': string;
    /**
     * 本社所在地：郵便番号
     * @type {string}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInner
     */
    'postalCode': string;
    /**
     * 電話番号
     * @type {string}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInner
     */
    'phoneNumber': string;
    /**
     * メールアドレス
     * @type {string}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInner
     */
    'email': string;
    /**
     * 作成日時
     * @type {string}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInner
     */
    'createdAt': string;
    /**
     * メモ
     * @type {string}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInner
     */
    'note'?: string;
    /**
     * 利用目的
     * @type {string}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInner
     */
    'purposeTransaction': GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerPurposeTransactionEnum;
    /**
     * 利用目的その他
     * @type {string}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInner
     */
    'purposeTransactionOther'?: string;
    /**
     * 反社チェック一覧
     * @type {Array<GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerAntisocialForcesCheckInner>}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInner
     */
    'antisocialForcesCheck': Array<GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerAntisocialForcesCheckInner>;
    /**
     * 実質的支配者一覧
     * @type {Array<GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerBeneficialOwnersInner>}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInner
     */
    'beneficialOwners': Array<GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerBeneficialOwnersInner>;
    /**
     * マイナンバーで確認済の認証情報一式
     * @type {Array<GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerIdentityVerificationInner>}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInner
     */
    'identityVerification': Array<GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerIdentityVerificationInner>;
    /**
     * 郵送確認一覧
     * @type {Array<GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerSnailMailVerificationInner>}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInner
     */
    'snailMailVerification': Array<GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerSnailMailVerificationInner>;
    /**
     * 
     * @type {GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerStatusHistory}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInner
     */
    'statusHistory'?: GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerStatusHistory;
}

export const GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerCorporateTypeEnum = {
    exceptMajorityCapitalVoteCorporate: 'EXCEPT_MAJORITY_CAPITAL_VOTE_CORPORATE',
    majorityCapitalVoteCorporate: 'MAJORITY_CAPITAL_VOTE_CORPORATE'
} as const;

export type GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerCorporateTypeEnum = typeof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerCorporateTypeEnum[keyof typeof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerCorporateTypeEnum];
export const GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerPurposeTransactionEnum = {
    adExpenses: 'AD_EXPENSES',
    calculatedAsExpense: 'CALCULATED_AS_EXPENSE',
    other: 'OTHER',
    stocking: 'STOCKING',
    systemUsageFee: 'SYSTEM_USAGE_FEE'
} as const;

export type GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerPurposeTransactionEnum = typeof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerPurposeTransactionEnum[keyof typeof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerPurposeTransactionEnum];

/**
 * 
 * @export
 * @interface GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerAntisocialForcesCheckInner
 */
export interface GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerAntisocialForcesCheckInner {
    /**
     * 
     * @type {string}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerAntisocialForcesCheckInner
     */
    'category': GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerAntisocialForcesCheckInnerCategoryEnum;
    /**
     * 
     * @type {GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerAntisocialForcesCheckInnerCondition}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerAntisocialForcesCheckInner
     */
    'condition'?: GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerAntisocialForcesCheckInnerCondition;
    /**
     * 
     * @type {string}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerAntisocialForcesCheckInner
     */
    'organizationIdentityVerificationId': string;
    /**
     * 
     * @type {number}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerAntisocialForcesCheckInner
     */
    'payloadDetailId': number;
    /**
     * 
     * @type {string}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerAntisocialForcesCheckInner
     */
    'payloadId': string;
    /**
     * 
     * @type {Array<GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerAntisocialForcesCheckInnerResultsInner>}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerAntisocialForcesCheckInner
     */
    'results'?: Array<GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerAntisocialForcesCheckInnerResultsInner>;
    /**
     * 
     * @type {string}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerAntisocialForcesCheckInner
     */
    'status': string;
}

export const GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerAntisocialForcesCheckInnerCategoryEnum = {
    company: 'company',
    customer: 'customer'
} as const;

export type GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerAntisocialForcesCheckInnerCategoryEnum = typeof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerAntisocialForcesCheckInnerCategoryEnum[keyof typeof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerAntisocialForcesCheckInnerCategoryEnum];

/**
 * 
 * @export
 * @interface GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerAntisocialForcesCheckInnerCondition
 */
export interface GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerAntisocialForcesCheckInnerCondition {
    /**
     * 
     * @type {string}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerAntisocialForcesCheckInnerCondition
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerAntisocialForcesCheckInnerResultsInner
 */
export interface GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerAntisocialForcesCheckInnerResultsInner {
    /**
     * 住所
     * @type {string}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerAntisocialForcesCheckInnerResultsInner
     */
    'address': string;
    /**
     * 区分
     * @type {string}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerAntisocialForcesCheckInnerResultsInner
     */
    'antisocial_group': string;
    /**
     * 生年月日（個人の場合）
     * @type {string}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerAntisocialForcesCheckInnerResultsInner
     */
    'birthday': string;
    /**
     * 媒体名
     * @type {string}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerAntisocialForcesCheckInnerResultsInner
     */
    'journal_name': string;
    /**
     * 名前
     * @type {string}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerAntisocialForcesCheckInnerResultsInner
     */
    'name': string;
    /**
     * 備考
     * @type {string}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerAntisocialForcesCheckInnerResultsInner
     */
    'note': string;
    /**
     * 掲載日および媒体ソースの記載ページ数
     * @type {string}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerAntisocialForcesCheckInnerResultsInner
     */
    'reported_at': string;
}
/**
 * 
 * @export
 * @interface GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerBeneficialOwnersInner
 */
export interface GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerBeneficialOwnersInner {
    /**
     * 住所
     * @type {string}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerBeneficialOwnersInner
     */
    'address': string;
    /**
     * 
     * @type {string}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerBeneficialOwnersInner
     */
    'beneficialOwnerType': GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerBeneficialOwnersInnerBeneficialOwnerTypeEnum;
    /**
     * 生年月日
     * @type {string}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerBeneficialOwnersInner
     */
    'birthday'?: string;
    /**
     * 法人との関係性
     * @type {string}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerBeneficialOwnersInner
     */
    'corporateRelationships'?: GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerBeneficialOwnersInnerCorporateRelationshipsEnum;
    /**
     * 居住国
     * @type {string}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerBeneficialOwnersInner
     */
    'countryResidence'?: string;
    /**
     * 性別
     * @type {string}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerBeneficialOwnersInner
     */
    'gender'?: GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerBeneficialOwnersInnerGenderEnum;
    /**
     * 外国人PEPsに該当するか
     * @type {boolean}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerBeneficialOwnersInner
     */
    'isPoliticallyExposedPersons': boolean;
    /**
     * 氏名・法人名
     * @type {string}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerBeneficialOwnersInner
     */
    'name': string;
}

export const GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerBeneficialOwnersInnerBeneficialOwnerTypeEnum = {
    corporation: 'CORPORATION',
    person: 'PERSON'
} as const;

export type GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerBeneficialOwnersInnerBeneficialOwnerTypeEnum = typeof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerBeneficialOwnersInnerBeneficialOwnerTypeEnum[keyof typeof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerBeneficialOwnersInnerBeneficialOwnerTypeEnum];
export const GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerBeneficialOwnersInnerCorporateRelationshipsEnum = {
    businessExecutor: 'BUSINESS_EXECUTOR',
    hasControllingInfluenceOverBusinessActivity: 'HAS_CONTROLLING_INFLUENCE_OVER_BUSINESS_ACTIVITY',
    hasRightOver25Per: 'HAS_RIGHT_OVER_25PER',
    hasRightOver50Per: 'HAS_RIGHT_OVER_50PER'
} as const;

export type GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerBeneficialOwnersInnerCorporateRelationshipsEnum = typeof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerBeneficialOwnersInnerCorporateRelationshipsEnum[keyof typeof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerBeneficialOwnersInnerCorporateRelationshipsEnum];
export const GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerBeneficialOwnersInnerGenderEnum = {
    female: 'FEMALE',
    male: 'MALE'
} as const;

export type GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerBeneficialOwnersInnerGenderEnum = typeof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerBeneficialOwnersInnerGenderEnum[keyof typeof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerBeneficialOwnersInnerGenderEnum];

/**
 * 
 * @export
 * @interface GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerIdentityVerificationInner
 */
export interface GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerIdentityVerificationInner {
    /**
     * 犯収法確認書類タイプ、本人確認書類(ワ方式)
     * @type {string}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerIdentityVerificationInner
     */
    'methodType': GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerIdentityVerificationInnerMethodTypeEnum;
    /**
     * 
     * @type {Array<GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerIdentityVerificationInnerRecordsInner>}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerIdentityVerificationInner
     */
    'records'?: Array<GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerIdentityVerificationInnerRecordsInner>;
    /**
     * 各種検証に紐づくID
     * @type {string}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerIdentityVerificationInner
     */
    'relatedIdentityVerificationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerIdentityVerificationInner
     */
    'result'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerIdentityVerificationInner
     */
    'state': string;
    /**
     * 参照URL
     * @type {Array<string>}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerIdentityVerificationInner
     */
    'verificationReferenceURLs'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerIdentityVerificationInner
     */
    'verificationSourceType': GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerIdentityVerificationInnerVerificationSourceTypeEnum;
}

export const GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerIdentityVerificationInnerMethodTypeEnum = {
    companyVerificationDocument: 'COMPANY_VERIFICATION_DOCUMENT',
    idDocument: 'ID_DOCUMENT',
    idDocumentI: 'ID_DOCUMENT_I',
    idDocumentWa: 'ID_DOCUMENT_WA',
    supplementalDocument: 'SUPPLEMENTAL_DOCUMENT'
} as const;

export type GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerIdentityVerificationInnerMethodTypeEnum = typeof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerIdentityVerificationInnerMethodTypeEnum[keyof typeof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerIdentityVerificationInnerMethodTypeEnum];
export const GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerIdentityVerificationInnerVerificationSourceTypeEnum = {
    internal: 'INTERNAL',
    pocketSign: 'POCKET_SIGN',
    trustdock: 'TRUSTDOCK'
} as const;

export type GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerIdentityVerificationInnerVerificationSourceTypeEnum = typeof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerIdentityVerificationInnerVerificationSourceTypeEnum[keyof typeof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerIdentityVerificationInnerVerificationSourceTypeEnum];

/**
 * 
 * @export
 * @interface GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerIdentityVerificationInnerRecordsInner
 */
export interface GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerIdentityVerificationInnerRecordsInner {
    /**
     * 
     * @type {Array<string>}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerIdentityVerificationInnerRecordsInner
     */
    'reasons': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerIdentityVerificationInnerRecordsInner
     */
    'result'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerIdentityVerificationInnerRecordsInner
     */
    'state': string;
}
/**
 * 
 * @export
 * @interface GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerSnailMailVerificationInner
 */
export interface GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerSnailMailVerificationInner {
    /**
     * 
     * @type {string}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerSnailMailVerificationInner
     */
    'acceptAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerSnailMailVerificationInner
     */
    'confirmedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerSnailMailVerificationInner
     */
    'confirmedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerSnailMailVerificationInner
     */
    'detail'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerSnailMailVerificationInner
     */
    'inquiryNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerSnailMailVerificationInner
     */
    'organizationIdentityVerificationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerSnailMailVerificationInner
     */
    'result'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerSnailMailVerificationInner
     */
    'snailMailVerificationId'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerSnailMailVerificationInner
     */
    'status'?: string;
}
/**
 * 
 * @export
 * @interface GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerStatusHistory
 */
export interface GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerStatusHistory {
    /**
     * 
     * @type {string}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerStatusHistory
     */
    'changedAt': string;
    /**
     * 
     * @type {GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerStatusHistoryChangedBy}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerStatusHistory
     */
    'changedBy': GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerStatusHistoryChangedBy;
    /**
     * 
     * @type {string}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerStatusHistory
     */
    'status': GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerStatusHistoryStatusEnum;
}

export const GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerStatusHistoryStatusEnum = {
    approved: 'APPROVED',
    rejected: 'REJECTED'
} as const;

export type GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerStatusHistoryStatusEnum = typeof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerStatusHistoryStatusEnum[keyof typeof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerStatusHistoryStatusEnum];

/**
 * 
 * @export
 * @interface GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerStatusHistoryChangedBy
 */
export interface GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerStatusHistoryChangedBy {
    /**
     * 
     * @type {string}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerStatusHistoryChangedBy
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerStatusHistoryChangedBy
     */
    'userId': string;
}
/**
 * 
 * @export
 * @interface GetZeusOrganizations200Response
 */
export interface GetZeusOrganizations200Response {
    /**
     * 
     * @type {Array<GetZeusOrganizations200ResponseOrganizationsInner>}
     * @memberof GetZeusOrganizations200Response
     */
    'organizations': Array<GetZeusOrganizations200ResponseOrganizationsInner>;
    /**
     * Total number of messages
     * @type {number}
     * @memberof GetZeusOrganizations200Response
     */
    'totalCount': number;
}
/**
 * 
 * @export
 * @interface GetZeusOrganizations200ResponseOrganizationsInner
 */
export interface GetZeusOrganizations200ResponseOrganizationsInner {
    /**
     * 
     * @type {string}
     * @memberof GetZeusOrganizations200ResponseOrganizationsInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetZeusOrganizations200ResponseOrganizationsInner
     */
    'name': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetZeusOrganizations200ResponseOrganizationsInner
     */
    'connectedMoneytree': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetZeusOrganizations200ResponseOrganizationsInner
     */
    'brandType'?: GetZeusOrganizations200ResponseOrganizationsInnerBrandTypeEnum;
}

export const GetZeusOrganizations200ResponseOrganizationsInnerBrandTypeEnum = {
    upsider: 'UPSIDER',
    presidentCard: 'PRESIDENT_CARD'
} as const;

export type GetZeusOrganizations200ResponseOrganizationsInnerBrandTypeEnum = typeof GetZeusOrganizations200ResponseOrganizationsInnerBrandTypeEnum[keyof typeof GetZeusOrganizations200ResponseOrganizationsInnerBrandTypeEnum];

/**
 * @type GuaranteeMoneyBalance
 * @export
 */
export type GuaranteeMoneyBalance = GuaranteeMoneyBalanceOneOf | string;

/**
 * 
 * @export
 * @interface GuaranteeMoneyBalanceHistory
 */
export interface GuaranteeMoneyBalanceHistory {
    /**
     * 
     * @type {number}
     * @memberof GuaranteeMoneyBalanceHistory
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof GuaranteeMoneyBalanceHistory
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof GuaranteeMoneyBalanceHistory
     */
    'organizationName': string;
    /**
     * 
     * @type {number}
     * @memberof GuaranteeMoneyBalanceHistory
     */
    'amount': number;
    /**
     * 
     * @type {string}
     * @memberof GuaranteeMoneyBalanceHistory
     */
    'transactionType': string;
    /**
     * 
     * @type {string}
     * @memberof GuaranteeMoneyBalanceHistory
     */
    'cardBillId': string | null;
    /**
     * 
     * @type {string}
     * @memberof GuaranteeMoneyBalanceHistory
     */
    'usageFeeId': string | null;
    /**
     * 
     * @type {number}
     * @memberof GuaranteeMoneyBalanceHistory
     */
    'balance': number;
    /**
     * 
     * @type {string}
     * @memberof GuaranteeMoneyBalanceHistory
     */
    'confirmedAt': string;
}
/**
 * 
 * @export
 * @interface GuaranteeMoneyBalanceOneOf
 */
export interface GuaranteeMoneyBalanceOneOf {
    /**
     * 
     * @type {string}
     * @memberof GuaranteeMoneyBalanceOneOf
     */
    'organizationId': string;
    /**
     * 
     * @type {number}
     * @memberof GuaranteeMoneyBalanceOneOf
     */
    'sequenceNum': number;
    /**
     * 
     * @type {number}
     * @memberof GuaranteeMoneyBalanceOneOf
     */
    'amount': number;
    /**
     * 
     * @type {string}
     * @memberof GuaranteeMoneyBalanceOneOf
     */
    'transactionType': string;
    /**
     * 
     * @type {number}
     * @memberof GuaranteeMoneyBalanceOneOf
     */
    'balance': number;
    /**
     * 
     * @type {string}
     * @memberof GuaranteeMoneyBalanceOneOf
     */
    'confirmedAt': string;
}
/**
 * 
 * @export
 * @interface GuaranteeMoneyDeposits
 */
export interface GuaranteeMoneyDeposits {
    /**
     * 
     * @type {number}
     * @memberof GuaranteeMoneyDeposits
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof GuaranteeMoneyDeposits
     */
    'organizationId': string;
    /**
     * 
     * @type {number}
     * @memberof GuaranteeMoneyDeposits
     */
    'depositTransactionId': number;
    /**
     * 
     * @type {number}
     * @memberof GuaranteeMoneyDeposits
     */
    'depositAmount': number;
    /**
     * 
     * @type {number}
     * @memberof GuaranteeMoneyDeposits
     */
    'remainingAmount': number;
    /**
     * 
     * @type {string}
     * @memberof GuaranteeMoneyDeposits
     */
    'depositDate': string;
    /**
     * 
     * @type {string}
     * @memberof GuaranteeMoneyDeposits
     */
    'validThroughDate': string;
    /**
     * 
     * @type {string}
     * @memberof GuaranteeMoneyDeposits
     */
    'withdrawalDueDate': string | null;
}
/**
 * 
 * @export
 * @interface JournalEntry
 */
export interface JournalEntry {
    /**
     * 
     * @type {string}
     * @memberof JournalEntry
     */
    'id': string;
    /**
     * 
     * @type {number}
     * @memberof JournalEntry
     */
    'amount': number | null;
    /**
     * 
     * @type {string}
     * @memberof JournalEntry
     */
    'freeeAccountItemId': string | null;
    /**
     * 
     * @type {string}
     * @memberof JournalEntry
     */
    'freeeTaxCode': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof JournalEntry
     */
    'isInvalidTaxCode': boolean;
    /**
     * 
     * @type {string}
     * @memberof JournalEntry
     */
    'invalidTaxCodeCause': JournalEntryInvalidTaxCodeCauseEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof JournalEntry
     */
    'freeeMemoTags': Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof JournalEntry
     */
    'freeeSectionId': string | null;
    /**
     * 
     * @type {string}
     * @memberof JournalEntry
     */
    'freeeItemId': string | null;
    /**
     * 
     * @type {string}
     * @memberof JournalEntry
     */
    'segment1TagId': string | null;
    /**
     * 
     * @type {string}
     * @memberof JournalEntry
     */
    'segment2TagId': string | null;
    /**
     * 
     * @type {string}
     * @memberof JournalEntry
     */
    'segment3TagId': string | null;
    /**
     * 
     * @type {string}
     * @memberof JournalEntry
     */
    'description': string | null;
}

export const JournalEntryInvalidTaxCodeCauseEnum = {
    qualifiedButPartDeduct: 'QUALIFIED_BUT_PART_DEDUCT',
    notQualifiedButFullDeduct: 'NOT_QUALIFIED_BUT_FULL_DEDUCT',
    preStartButPartDeduct: 'PRE_START_BUT_PART_DEDUCT',
    inconsistentDeductRate: 'INCONSISTENT_DEDUCT_RATE'
} as const;

export type JournalEntryInvalidTaxCodeCauseEnum = typeof JournalEntryInvalidTaxCodeCauseEnum[keyof typeof JournalEntryInvalidTaxCodeCauseEnum];

/**
 * 
 * @export
 * @interface LinkedCardTransaction
 */
export interface LinkedCardTransaction {
    /**
     * 
     * @type {string}
     * @memberof LinkedCardTransaction
     */
    'visaTransactionReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof LinkedCardTransaction
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {boolean}
     * @memberof LinkedCardTransaction
     */
    'canUnlink': boolean;
}
/**
 * 
 * @export
 * @interface LockCardForPotentialFraud200Response
 */
export interface LockCardForPotentialFraud200Response {
    /**
     * 
     * @type {string}
     * @memberof LockCardForPotentialFraud200Response
     */
    'cardId': string;
    /**
     * 
     * @type {boolean}
     * @memberof LockCardForPotentialFraud200Response
     */
    'isActivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LockCardForPotentialFraud200Response
     */
    'isDeactivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LockCardForPotentialFraud200Response
     */
    'isLocked': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LockCardForPotentialFraud200Response
     */
    'isSuspended': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LockCardForPotentialFraud200Response
     */
    'isFrozen': boolean;
    /**
     * 
     * @type {string}
     * @memberof LockCardForPotentialFraud200Response
     */
    'panLastFourDigits': string;
    /**
     * 
     * @type {string}
     * @memberof LockCardForPotentialFraud200Response
     */
    'linkedUserAccountId': string;
    /**
     * 
     * @type {string}
     * @memberof LockCardForPotentialFraud200Response
     */
    'createdAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof LockCardForPotentialFraud200Response
     */
    'isActive': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LockCardForPotentialFraud200Response
     */
    'isVirtualCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LockCardForPotentialFraud200Response
     */
    'isCreditCard': boolean;
}
/**
 * @type LockCardForPotentialFraudRequest
 * @export
 */
export type LockCardForPotentialFraudRequest = LockCardForPotentialFraudRequestOneOf | LockCardForPotentialFraudRequestOneOf1;

/**
 * 
 * @export
 * @interface LockCardForPotentialFraudRequestOneOf
 */
export interface LockCardForPotentialFraudRequestOneOf {
    /**
     * 
     * @type {string}
     * @memberof LockCardForPotentialFraudRequestOneOf
     */
    'lockType': LockCardForPotentialFraudRequestOneOfLockTypeEnum;
}

export const LockCardForPotentialFraudRequestOneOfLockTypeEnum = {
    vrm: 'VRM',
    transactionSpike: 'TRANSACTION_SPIKE',
    merchantLeakage: 'MERCHANT_LEAKAGE',
    suspiciousTransaction: 'SUSPICIOUS_TRANSACTION',
    threeDSecure: 'THREE_D_SECURE'
} as const;

export type LockCardForPotentialFraudRequestOneOfLockTypeEnum = typeof LockCardForPotentialFraudRequestOneOfLockTypeEnum[keyof typeof LockCardForPotentialFraudRequestOneOfLockTypeEnum];

/**
 * 
 * @export
 * @interface LockCardForPotentialFraudRequestOneOf1
 */
export interface LockCardForPotentialFraudRequestOneOf1 {
    /**
     * 
     * @type {string}
     * @memberof LockCardForPotentialFraudRequestOneOf1
     */
    'lockType': LockCardForPotentialFraudRequestOneOf1LockTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof LockCardForPotentialFraudRequestOneOf1
     */
    'description': string;
}

export const LockCardForPotentialFraudRequestOneOf1LockTypeEnum = {
    other: 'OTHER'
} as const;

export type LockCardForPotentialFraudRequestOneOf1LockTypeEnum = typeof LockCardForPotentialFraudRequestOneOf1LockTypeEnum[keyof typeof LockCardForPotentialFraudRequestOneOf1LockTypeEnum];

/**
 * 
 * @export
 * @interface LockCardOnFraudDetected200Response
 */
export interface LockCardOnFraudDetected200Response {
    /**
     * 
     * @type {string}
     * @memberof LockCardOnFraudDetected200Response
     */
    'cardId': string;
    /**
     * 
     * @type {boolean}
     * @memberof LockCardOnFraudDetected200Response
     */
    'isActivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LockCardOnFraudDetected200Response
     */
    'isDeactivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LockCardOnFraudDetected200Response
     */
    'isLocked': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LockCardOnFraudDetected200Response
     */
    'isSuspended': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LockCardOnFraudDetected200Response
     */
    'isFrozen': boolean;
    /**
     * 
     * @type {string}
     * @memberof LockCardOnFraudDetected200Response
     */
    'panLastFourDigits': string;
    /**
     * 
     * @type {string}
     * @memberof LockCardOnFraudDetected200Response
     */
    'linkedUserAccountId': string;
    /**
     * 
     * @type {string}
     * @memberof LockCardOnFraudDetected200Response
     */
    'createdAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof LockCardOnFraudDetected200Response
     */
    'isActive': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LockCardOnFraudDetected200Response
     */
    'isVirtualCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LockCardOnFraudDetected200Response
     */
    'isCreditCard': boolean;
}
/**
 * @type LockCardOnFraudDetectedRequest
 * @export
 */
export type LockCardOnFraudDetectedRequest = LockCardOnFraudDetectedRequestOneOf | LockCardOnFraudDetectedRequestOneOf1;

/**
 * 
 * @export
 * @interface LockCardOnFraudDetectedRequestOneOf
 */
export interface LockCardOnFraudDetectedRequestOneOf {
    /**
     * 
     * @type {string}
     * @memberof LockCardOnFraudDetectedRequestOneOf
     */
    'lockType': LockCardOnFraudDetectedRequestOneOfLockTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof LockCardOnFraudDetectedRequestOneOf
     */
    'triggeredTransactionId': string;
}

export const LockCardOnFraudDetectedRequestOneOfLockTypeEnum = {
    vrm: 'VRM',
    transactionSpike: 'TRANSACTION_SPIKE',
    merchantLeakage: 'MERCHANT_LEAKAGE',
    suspiciousTransaction: 'SUSPICIOUS_TRANSACTION',
    threeDSecure: 'THREE_D_SECURE',
    rule: 'RULE'
} as const;

export type LockCardOnFraudDetectedRequestOneOfLockTypeEnum = typeof LockCardOnFraudDetectedRequestOneOfLockTypeEnum[keyof typeof LockCardOnFraudDetectedRequestOneOfLockTypeEnum];

/**
 * 
 * @export
 * @interface LockCardOnFraudDetectedRequestOneOf1
 */
export interface LockCardOnFraudDetectedRequestOneOf1 {
    /**
     * 
     * @type {string}
     * @memberof LockCardOnFraudDetectedRequestOneOf1
     */
    'lockType': LockCardOnFraudDetectedRequestOneOf1LockTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof LockCardOnFraudDetectedRequestOneOf1
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof LockCardOnFraudDetectedRequestOneOf1
     */
    'triggeredTransactionId': string;
}

export const LockCardOnFraudDetectedRequestOneOf1LockTypeEnum = {
    other: 'OTHER'
} as const;

export type LockCardOnFraudDetectedRequestOneOf1LockTypeEnum = typeof LockCardOnFraudDetectedRequestOneOf1LockTypeEnum[keyof typeof LockCardOnFraudDetectedRequestOneOf1LockTypeEnum];

/**
 * 
 * @export
 * @interface Login200Response
 */
export interface Login200Response {
    /**
     * 
     * @type {string}
     * @memberof Login200Response
     */
    'twoFactorAuthRegisterStatus': string;
    /**
     * 
     * @type {string}
     * @memberof Login200Response
     */
    'token': string | null;
    /**
     * 
     * @type {string}
     * @memberof Login200Response
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof Login200Response
     */
    'smsPhoneNumber': string;
}
/**
 * 
 * @export
 * @interface LoginApp200Response
 */
export interface LoginApp200Response {
    /**
     * 
     * @type {string}
     * @memberof LoginApp200Response
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof LoginApp200Response
     */
    'userName': string;
    /**
     * 
     * @type {string}
     * @memberof LoginApp200Response
     */
    'email': string;
    /**
     * 
     * @type {LoginApp200ResponseOrganization}
     * @memberof LoginApp200Response
     */
    'organization': LoginApp200ResponseOrganization;
    /**
     * 
     * @type {string}
     * @memberof LoginApp200Response
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof LoginApp200Response
     */
    'organizationName': string;
    /**
     * 
     * @type {Array<LoginApp200ResponseContractsInner>}
     * @memberof LoginApp200Response
     */
    'contracts': Array<LoginApp200ResponseContractsInner>;
    /**
     * 
     * @type {boolean}
     * @memberof LoginApp200Response
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LoginApp200Response
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LoginApp200Response
     */
    'isSystemAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LoginApp200Response
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LoginApp200Response
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LoginApp200Response
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof LoginApp200Response
     */
    'roles': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof LoginApp200Response
     */
    'twoFactorAuthRegisterStatus': string;
    /**
     * 
     * @type {string}
     * @memberof LoginApp200Response
     */
    'smsPhoneNumber': string;
    /**
     * 
     * @type {boolean}
     * @memberof LoginApp200Response
     */
    'hasCardContract': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LoginApp200Response
     */
    'hasPayContract': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LoginApp200Response
     */
    'isJournalFeatureEnabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof LoginApp200Response
     */
    'freeeCompanyId': string | null;
    /**
     * 
     * @type {string}
     * @memberof LoginApp200Response
     */
    'token': string;
}
/**
 * 
 * @export
 * @interface LoginApp200ResponseContractsInner
 */
export interface LoginApp200ResponseContractsInner {
    /**
     * 
     * @type {number}
     * @memberof LoginApp200ResponseContractsInner
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof LoginApp200ResponseContractsInner
     */
    'organizationId': number;
    /**
     * 
     * @type {string}
     * @memberof LoginApp200ResponseContractsInner
     */
    'contractType': string;
    /**
     * 
     * @type {string}
     * @memberof LoginApp200ResponseContractsInner
     */
    'startAt': string;
    /**
     * 
     * @type {string}
     * @memberof LoginApp200ResponseContractsInner
     */
    'endAt': string;
}
/**
 * 
 * @export
 * @interface LoginApp200ResponseOrganization
 */
export interface LoginApp200ResponseOrganization {
    /**
     * 
     * @type {string}
     * @memberof LoginApp200ResponseOrganization
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof LoginApp200ResponseOrganization
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof LoginApp200ResponseOrganization
     */
    'representativeName': string;
    /**
     * 
     * @type {string}
     * @memberof LoginApp200ResponseOrganization
     */
    'phoneNumber': string;
    /**
     * 
     * @type {string}
     * @memberof LoginApp200ResponseOrganization
     */
    'postalCode': string;
    /**
     * 
     * @type {string}
     * @memberof LoginApp200ResponseOrganization
     */
    'address': string;
    /**
     * 
     * @type {string}
     * @memberof LoginApp200ResponseOrganization
     */
    'deliveryPostalCode': string;
    /**
     * 
     * @type {string}
     * @memberof LoginApp200ResponseOrganization
     */
    'deliveryAddress': string;
    /**
     * 
     * @type {string}
     * @memberof LoginApp200ResponseOrganization
     */
    'invoiceEmail': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof LoginApp200ResponseOrganization
     */
    'isApprovalFeatureEnabled': boolean;
}
/**
 * 
 * @export
 * @interface LoginAppRequest
 */
export interface LoginAppRequest {
    /**
     * 
     * @type {string}
     * @memberof LoginAppRequest
     */
    'emailAddress': string;
    /**
     * 
     * @type {number}
     * @memberof LoginAppRequest
     */
    'verificationCode': number;
}
/**
 * 
 * @export
 * @interface LoginRecoveryCode200Response
 */
export interface LoginRecoveryCode200Response {
    /**
     * 
     * @type {string}
     * @memberof LoginRecoveryCode200Response
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof LoginRecoveryCode200Response
     */
    'userName': string;
    /**
     * 
     * @type {string}
     * @memberof LoginRecoveryCode200Response
     */
    'email': string;
    /**
     * 
     * @type {LoginRecoveryCode200ResponseOrganization}
     * @memberof LoginRecoveryCode200Response
     */
    'organization': LoginRecoveryCode200ResponseOrganization;
    /**
     * 
     * @type {string}
     * @memberof LoginRecoveryCode200Response
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof LoginRecoveryCode200Response
     */
    'organizationName': string;
    /**
     * 
     * @type {Array<LoginRecoveryCode200ResponseContractsInner>}
     * @memberof LoginRecoveryCode200Response
     */
    'contracts': Array<LoginRecoveryCode200ResponseContractsInner>;
    /**
     * 
     * @type {boolean}
     * @memberof LoginRecoveryCode200Response
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LoginRecoveryCode200Response
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LoginRecoveryCode200Response
     */
    'isSystemAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LoginRecoveryCode200Response
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LoginRecoveryCode200Response
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LoginRecoveryCode200Response
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof LoginRecoveryCode200Response
     */
    'roles': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof LoginRecoveryCode200Response
     */
    'twoFactorAuthRegisterStatus': string;
    /**
     * 
     * @type {string}
     * @memberof LoginRecoveryCode200Response
     */
    'smsPhoneNumber': string;
    /**
     * 
     * @type {boolean}
     * @memberof LoginRecoveryCode200Response
     */
    'hasCardContract': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LoginRecoveryCode200Response
     */
    'hasPayContract': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LoginRecoveryCode200Response
     */
    'isJournalFeatureEnabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof LoginRecoveryCode200Response
     */
    'freeeCompanyId': string | null;
    /**
     * 
     * @type {string}
     * @memberof LoginRecoveryCode200Response
     */
    'token': string;
}
/**
 * 
 * @export
 * @interface LoginRecoveryCode200ResponseContractsInner
 */
export interface LoginRecoveryCode200ResponseContractsInner {
    /**
     * 
     * @type {number}
     * @memberof LoginRecoveryCode200ResponseContractsInner
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof LoginRecoveryCode200ResponseContractsInner
     */
    'organizationId': number;
    /**
     * 
     * @type {string}
     * @memberof LoginRecoveryCode200ResponseContractsInner
     */
    'contractType': string;
    /**
     * 
     * @type {string}
     * @memberof LoginRecoveryCode200ResponseContractsInner
     */
    'startAt': string;
    /**
     * 
     * @type {string}
     * @memberof LoginRecoveryCode200ResponseContractsInner
     */
    'endAt': string;
}
/**
 * 
 * @export
 * @interface LoginRecoveryCode200ResponseOrganization
 */
export interface LoginRecoveryCode200ResponseOrganization {
    /**
     * 
     * @type {string}
     * @memberof LoginRecoveryCode200ResponseOrganization
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof LoginRecoveryCode200ResponseOrganization
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof LoginRecoveryCode200ResponseOrganization
     */
    'representativeName': string;
    /**
     * 
     * @type {string}
     * @memberof LoginRecoveryCode200ResponseOrganization
     */
    'phoneNumber': string;
    /**
     * 
     * @type {string}
     * @memberof LoginRecoveryCode200ResponseOrganization
     */
    'postalCode': string;
    /**
     * 
     * @type {string}
     * @memberof LoginRecoveryCode200ResponseOrganization
     */
    'address': string;
    /**
     * 
     * @type {string}
     * @memberof LoginRecoveryCode200ResponseOrganization
     */
    'deliveryPostalCode': string;
    /**
     * 
     * @type {string}
     * @memberof LoginRecoveryCode200ResponseOrganization
     */
    'deliveryAddress': string;
    /**
     * 
     * @type {string}
     * @memberof LoginRecoveryCode200ResponseOrganization
     */
    'invoiceEmail': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof LoginRecoveryCode200ResponseOrganization
     */
    'isApprovalFeatureEnabled': boolean;
}
/**
 * 
 * @export
 * @interface LoginRecoveryCodeRequest
 */
export interface LoginRecoveryCodeRequest {
    /**
     * 
     * @type {string}
     * @memberof LoginRecoveryCodeRequest
     */
    'emailAddress': string;
    /**
     * 
     * @type {string}
     * @memberof LoginRecoveryCodeRequest
     */
    'recoveryCode': string;
}
/**
 * 
 * @export
 * @interface LoginRequest
 */
export interface LoginRequest {
    /**
     * 
     * @type {string}
     * @memberof LoginRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof LoginRequest
     */
    'password': string;
}
/**
 * 
 * @export
 * @interface LoginSms200Response
 */
export interface LoginSms200Response {
    /**
     * 
     * @type {string}
     * @memberof LoginSms200Response
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof LoginSms200Response
     */
    'userName': string;
    /**
     * 
     * @type {string}
     * @memberof LoginSms200Response
     */
    'email': string;
    /**
     * 
     * @type {LoginSms200ResponseOrganization}
     * @memberof LoginSms200Response
     */
    'organization': LoginSms200ResponseOrganization;
    /**
     * 
     * @type {string}
     * @memberof LoginSms200Response
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof LoginSms200Response
     */
    'organizationName': string;
    /**
     * 
     * @type {Array<LoginSms200ResponseContractsInner>}
     * @memberof LoginSms200Response
     */
    'contracts': Array<LoginSms200ResponseContractsInner>;
    /**
     * 
     * @type {boolean}
     * @memberof LoginSms200Response
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LoginSms200Response
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LoginSms200Response
     */
    'isSystemAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LoginSms200Response
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LoginSms200Response
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LoginSms200Response
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof LoginSms200Response
     */
    'roles': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof LoginSms200Response
     */
    'twoFactorAuthRegisterStatus': string;
    /**
     * 
     * @type {string}
     * @memberof LoginSms200Response
     */
    'smsPhoneNumber': string;
    /**
     * 
     * @type {boolean}
     * @memberof LoginSms200Response
     */
    'hasCardContract': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LoginSms200Response
     */
    'hasPayContract': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LoginSms200Response
     */
    'isJournalFeatureEnabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof LoginSms200Response
     */
    'freeeCompanyId': string | null;
    /**
     * 
     * @type {string}
     * @memberof LoginSms200Response
     */
    'token': string;
}
/**
 * 
 * @export
 * @interface LoginSms200ResponseContractsInner
 */
export interface LoginSms200ResponseContractsInner {
    /**
     * 
     * @type {number}
     * @memberof LoginSms200ResponseContractsInner
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof LoginSms200ResponseContractsInner
     */
    'organizationId': number;
    /**
     * 
     * @type {string}
     * @memberof LoginSms200ResponseContractsInner
     */
    'contractType': string;
    /**
     * 
     * @type {string}
     * @memberof LoginSms200ResponseContractsInner
     */
    'startAt': string;
    /**
     * 
     * @type {string}
     * @memberof LoginSms200ResponseContractsInner
     */
    'endAt': string;
}
/**
 * 
 * @export
 * @interface LoginSms200ResponseOrganization
 */
export interface LoginSms200ResponseOrganization {
    /**
     * 
     * @type {string}
     * @memberof LoginSms200ResponseOrganization
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof LoginSms200ResponseOrganization
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof LoginSms200ResponseOrganization
     */
    'representativeName': string;
    /**
     * 
     * @type {string}
     * @memberof LoginSms200ResponseOrganization
     */
    'phoneNumber': string;
    /**
     * 
     * @type {string}
     * @memberof LoginSms200ResponseOrganization
     */
    'postalCode': string;
    /**
     * 
     * @type {string}
     * @memberof LoginSms200ResponseOrganization
     */
    'address': string;
    /**
     * 
     * @type {string}
     * @memberof LoginSms200ResponseOrganization
     */
    'deliveryPostalCode': string;
    /**
     * 
     * @type {string}
     * @memberof LoginSms200ResponseOrganization
     */
    'deliveryAddress': string;
    /**
     * 
     * @type {string}
     * @memberof LoginSms200ResponseOrganization
     */
    'invoiceEmail': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof LoginSms200ResponseOrganization
     */
    'isApprovalFeatureEnabled': boolean;
}
/**
 * 
 * @export
 * @interface LoginSmsRequest
 */
export interface LoginSmsRequest {
    /**
     * 
     * @type {string}
     * @memberof LoginSmsRequest
     */
    'emailAddress': string;
    /**
     * 
     * @type {string}
     * @memberof LoginSmsRequest
     */
    'idToken': string;
}
/**
 * 
 * @export
 * @interface MergedCardTransaction
 */
export interface MergedCardTransaction {
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransaction
     */
    'visaTransactionReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransaction
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransaction
     */
    'merchantName': string;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransaction
     */
    'merchantNameKana': string;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransaction
     */
    'merchantNameKanji': string;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransaction
     */
    'mergedMerchantName': string;
    /**
     * 
     * @type {number}
     * @memberof MergedCardTransaction
     */
    'amount': number;
    /**
     * 
     * @type {number}
     * @memberof MergedCardTransaction
     */
    'amountFx': number;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransaction
     */
    'currencyCode': string;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransaction
     */
    'processedAt': string;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransaction
     */
    'transactionType': MergedCardTransactionTransactionTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof MergedCardTransaction
     */
    'creditSettlement': number;
    /**
     * 
     * @type {Array<MergedCardTransactionTransactionRecordListInner>}
     * @memberof MergedCardTransaction
     */
    'transactionRecordList': Array<MergedCardTransactionTransactionRecordListInner>;
    /**
     * 
     * @type {boolean}
     * @memberof MergedCardTransaction
     */
    'isCleared': boolean;
}

export const MergedCardTransactionTransactionTypeEnum = {
    confirm: 'CONFIRM',
    notConfirm: 'NOT_CONFIRM'
} as const;

export type MergedCardTransactionTransactionTypeEnum = typeof MergedCardTransactionTransactionTypeEnum[keyof typeof MergedCardTransactionTransactionTypeEnum];

/**
 * 
 * @export
 * @interface MergedCardTransactionDetail
 */
export interface MergedCardTransactionDetail {
    /**
     * 
     * @type {MergedCardTransactionDetailMergedCardTransaction}
     * @memberof MergedCardTransactionDetail
     */
    'mergedCardTransaction': MergedCardTransactionDetailMergedCardTransaction;
    /**
     * 
     * @type {MergedCardTransactionDetailCardTransactionEvidenceStatus}
     * @memberof MergedCardTransactionDetail
     */
    'cardTransactionEvidenceStatus': MergedCardTransactionDetailCardTransactionEvidenceStatus;
    /**
     * 
     * @type {Array<MergedCardTransactionDetailEvidenceListInner>}
     * @memberof MergedCardTransactionDetail
     */
    'evidenceList': Array<MergedCardTransactionDetailEvidenceListInner>;
    /**
     * 
     * @type {Array<MergedCardTransactionDetailRequestHistoryInner>}
     * @memberof MergedCardTransactionDetail
     */
    'requestHistory': Array<MergedCardTransactionDetailRequestHistoryInner>;
    /**
     * 
     * @type {MergedCardTransactionDetailComment}
     * @memberof MergedCardTransactionDetail
     */
    'comment'?: MergedCardTransactionDetailComment;
    /**
     * 
     * @type {MergedCardTransactionDetailEvidenceRemindStatus}
     * @memberof MergedCardTransactionDetail
     */
    'evidenceRemindStatus': MergedCardTransactionDetailEvidenceRemindStatus;
    /**
     * 
     * @type {MergedCardTransactionDetailUserAccount}
     * @memberof MergedCardTransactionDetail
     */
    'userAccount': MergedCardTransactionDetailUserAccount;
    /**
     * 
     * @type {Array<MergedCardTransactionDetailPurchaseApplicationsInner>}
     * @memberof MergedCardTransactionDetail
     */
    'purchaseApplications': Array<MergedCardTransactionDetailPurchaseApplicationsInner>;
}
/**
 * 
 * @export
 * @interface MergedCardTransactionDetailCardTransactionEvidenceStatus
 */
export interface MergedCardTransactionDetailCardTransactionEvidenceStatus {
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailCardTransactionEvidenceStatus
     */
    'visaTransactionReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailCardTransactionEvidenceStatus
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {boolean}
     * @memberof MergedCardTransactionDetailCardTransactionEvidenceStatus
     */
    'isRequested': boolean;
    /**
     * 
     * @type {MergedCardTransactionDetailCardTransactionEvidenceStatusRequestedBy}
     * @memberof MergedCardTransactionDetailCardTransactionEvidenceStatus
     */
    'requestedBy': MergedCardTransactionDetailCardTransactionEvidenceStatusRequestedBy | null;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailCardTransactionEvidenceStatus
     */
    'requestedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof MergedCardTransactionDetailCardTransactionEvidenceStatus
     */
    'isLocked': boolean;
    /**
     * 
     * @type {MergedCardTransactionDetailCardTransactionEvidenceStatusLockedBy}
     * @memberof MergedCardTransactionDetailCardTransactionEvidenceStatus
     */
    'lockedBy': MergedCardTransactionDetailCardTransactionEvidenceStatusLockedBy | null;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailCardTransactionEvidenceStatus
     */
    'lockedAt': string;
}
/**
 * 
 * @export
 * @interface MergedCardTransactionDetailCardTransactionEvidenceStatusLockedBy
 */
export interface MergedCardTransactionDetailCardTransactionEvidenceStatusLockedBy {
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailCardTransactionEvidenceStatusLockedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailCardTransactionEvidenceStatusLockedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface MergedCardTransactionDetailCardTransactionEvidenceStatusRequestedBy
 */
export interface MergedCardTransactionDetailCardTransactionEvidenceStatusRequestedBy {
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailCardTransactionEvidenceStatusRequestedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailCardTransactionEvidenceStatusRequestedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface MergedCardTransactionDetailComment
 */
export interface MergedCardTransactionDetailComment {
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailComment
     */
    'cardTransactionCommentId': string;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailComment
     */
    'visaTransactionReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailComment
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailComment
     */
    'comment': string;
    /**
     * 
     * @type {MergedCardTransactionDetailCommentCreatedBy}
     * @memberof MergedCardTransactionDetailComment
     */
    'createdBy': MergedCardTransactionDetailCommentCreatedBy;
}
/**
 * 
 * @export
 * @interface MergedCardTransactionDetailCommentCreatedBy
 */
export interface MergedCardTransactionDetailCommentCreatedBy {
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailCommentCreatedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailCommentCreatedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface MergedCardTransactionDetailEvidenceListInner
 */
export interface MergedCardTransactionDetailEvidenceListInner {
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailEvidenceListInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailEvidenceListInner
     * @deprecated
     */
    'cardTransactionEvidenceId': string;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailEvidenceListInner
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailEvidenceListInner
     * @deprecated
     */
    'visaTransactionReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailEvidenceListInner
     */
    'paymentType': MergedCardTransactionDetailEvidenceListInnerPaymentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailEvidenceListInner
     */
    'fileName': string;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailEvidenceListInner
     */
    'fileExtension': string;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailEvidenceListInner
     */
    'electronicMethod': MergedCardTransactionDetailEvidenceListInnerElectronicMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailEvidenceListInner
     */
    'documentSize': MergedCardTransactionDetailEvidenceListInnerDocumentSizeEnum;
    /**
     * 
     * @type {number}
     * @memberof MergedCardTransactionDetailEvidenceListInner
     * @deprecated
     */
    'dpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof MergedCardTransactionDetailEvidenceListInner
     */
    'detectedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof MergedCardTransactionDetailEvidenceListInner
     */
    'calculatedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof MergedCardTransactionDetailEvidenceListInner
     */
    'colorGradation': number | null;
    /**
     * 
     * @type {number}
     * @memberof MergedCardTransactionDetailEvidenceListInner
     */
    'verticalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof MergedCardTransactionDetailEvidenceListInner
     */
    'horizontalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof MergedCardTransactionDetailEvidenceListInner
     */
    'heightMillis': number | null;
    /**
     * 
     * @type {number}
     * @memberof MergedCardTransactionDetailEvidenceListInner
     */
    'widthMillis': number | null;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailEvidenceListInner
     */
    'legalValidity': MergedCardTransactionDetailEvidenceListInnerLegalValidityEnum;
    /**
     * 
     * @type {boolean}
     * @memberof MergedCardTransactionDetailEvidenceListInner
     */
    'dpiForciblyValid': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MergedCardTransactionDetailEvidenceListInner
     */
    'colorGradationForciblyValid': boolean;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailEvidenceListInner
     */
    'note': string;
    /**
     * 
     * @type {boolean}
     * @memberof MergedCardTransactionDetailEvidenceListInner
     */
    'irrelevantToLedger': boolean;
    /**
     * 
     * @type {MergedCardTransactionDetailEvidenceListInnerInvoiceIssuer}
     * @memberof MergedCardTransactionDetailEvidenceListInner
     */
    'invoiceIssuer': MergedCardTransactionDetailEvidenceListInnerInvoiceIssuer | null;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailEvidenceListInner
     * @deprecated
     */
    'dpiError': MergedCardTransactionDetailEvidenceListInnerDpiErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailEvidenceListInner
     * @deprecated
     */
    'detectedDpiError': MergedCardTransactionDetailEvidenceListInnerDetectedDpiErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailEvidenceListInner
     * @deprecated
     */
    'calculatedDpiError': MergedCardTransactionDetailEvidenceListInnerCalculatedDpiErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailEvidenceListInner
     * @deprecated
     */
    'colorGradationError': MergedCardTransactionDetailEvidenceListInnerColorGradationErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailEvidenceListInner
     * @deprecated
     */
    'heightMillisError': MergedCardTransactionDetailEvidenceListInnerHeightMillisErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailEvidenceListInner
     * @deprecated
     */
    'widthMillisError': MergedCardTransactionDetailEvidenceListInnerWidthMillisErrorEnum;
    /**
     * 
     * @type {MergedCardTransactionDetailEvidenceListInnerErrors}
     * @memberof MergedCardTransactionDetailEvidenceListInner
     */
    'errors': MergedCardTransactionDetailEvidenceListInnerErrors;
    /**
     * 
     * @type {MergedCardTransactionDetailEvidenceListInnerWarnings}
     * @memberof MergedCardTransactionDetailEvidenceListInner
     */
    'warnings': MergedCardTransactionDetailEvidenceListInnerWarnings;
    /**
     * 
     * @type {MergedCardTransactionDetailEvidenceListInnerCreatedBy}
     * @memberof MergedCardTransactionDetailEvidenceListInner
     */
    'createdBy': MergedCardTransactionDetailEvidenceListInnerCreatedBy;
    /**
     * 
     * @type {MergedCardTransactionDetailEvidenceListInnerUpdatedBy}
     * @memberof MergedCardTransactionDetailEvidenceListInner
     */
    'updatedBy': MergedCardTransactionDetailEvidenceListInnerUpdatedBy;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailEvidenceListInner
     */
    'updatedAt': string;
    /**
     * 
     * @type {MergedCardTransactionDetailEvidenceListInnerUploadedBy}
     * @memberof MergedCardTransactionDetailEvidenceListInner
     */
    'uploadedBy': MergedCardTransactionDetailEvidenceListInnerUploadedBy;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailEvidenceListInner
     */
    'uploadedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof MergedCardTransactionDetailEvidenceListInner
     */
    'uploadedByRecipient': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MergedCardTransactionDetailEvidenceListInner
     */
    'needsMigration': boolean | null;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailEvidenceListInner
     */
    'uploadedFrom': string;
}

export const MergedCardTransactionDetailEvidenceListInnerPaymentTypeEnum = {
    cardTransaction: 'CARD_TRANSACTION',
    paymentRequest: 'PAYMENT_REQUEST'
} as const;

export type MergedCardTransactionDetailEvidenceListInnerPaymentTypeEnum = typeof MergedCardTransactionDetailEvidenceListInnerPaymentTypeEnum[keyof typeof MergedCardTransactionDetailEvidenceListInnerPaymentTypeEnum];
export const MergedCardTransactionDetailEvidenceListInnerElectronicMethodEnum = {
    fullElectronic: 'FULL_ELECTRONIC',
    originallyPaper: 'ORIGINALLY_PAPER',
    unknown: 'UNKNOWN'
} as const;

export type MergedCardTransactionDetailEvidenceListInnerElectronicMethodEnum = typeof MergedCardTransactionDetailEvidenceListInnerElectronicMethodEnum[keyof typeof MergedCardTransactionDetailEvidenceListInnerElectronicMethodEnum];
export const MergedCardTransactionDetailEvidenceListInnerDocumentSizeEnum = {
    overA4: 'OVER_A4',
    a4OrSmaller: 'A4_OR_SMALLER',
    unknown: 'UNKNOWN'
} as const;

export type MergedCardTransactionDetailEvidenceListInnerDocumentSizeEnum = typeof MergedCardTransactionDetailEvidenceListInnerDocumentSizeEnum[keyof typeof MergedCardTransactionDetailEvidenceListInnerDocumentSizeEnum];
export const MergedCardTransactionDetailEvidenceListInnerLegalValidityEnum = {
    valid: 'VALID',
    invalid: 'INVALID',
    inputRequired: 'INPUT_REQUIRED',
    outOfTarget: 'OUT_OF_TARGET'
} as const;

export type MergedCardTransactionDetailEvidenceListInnerLegalValidityEnum = typeof MergedCardTransactionDetailEvidenceListInnerLegalValidityEnum[keyof typeof MergedCardTransactionDetailEvidenceListInnerLegalValidityEnum];
export const MergedCardTransactionDetailEvidenceListInnerDpiErrorEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type MergedCardTransactionDetailEvidenceListInnerDpiErrorEnum = typeof MergedCardTransactionDetailEvidenceListInnerDpiErrorEnum[keyof typeof MergedCardTransactionDetailEvidenceListInnerDpiErrorEnum];
export const MergedCardTransactionDetailEvidenceListInnerDetectedDpiErrorEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type MergedCardTransactionDetailEvidenceListInnerDetectedDpiErrorEnum = typeof MergedCardTransactionDetailEvidenceListInnerDetectedDpiErrorEnum[keyof typeof MergedCardTransactionDetailEvidenceListInnerDetectedDpiErrorEnum];
export const MergedCardTransactionDetailEvidenceListInnerCalculatedDpiErrorEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type MergedCardTransactionDetailEvidenceListInnerCalculatedDpiErrorEnum = typeof MergedCardTransactionDetailEvidenceListInnerCalculatedDpiErrorEnum[keyof typeof MergedCardTransactionDetailEvidenceListInnerCalculatedDpiErrorEnum];
export const MergedCardTransactionDetailEvidenceListInnerColorGradationErrorEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type MergedCardTransactionDetailEvidenceListInnerColorGradationErrorEnum = typeof MergedCardTransactionDetailEvidenceListInnerColorGradationErrorEnum[keyof typeof MergedCardTransactionDetailEvidenceListInnerColorGradationErrorEnum];
export const MergedCardTransactionDetailEvidenceListInnerHeightMillisErrorEnum = {
    required: 'REQUIRED'
} as const;

export type MergedCardTransactionDetailEvidenceListInnerHeightMillisErrorEnum = typeof MergedCardTransactionDetailEvidenceListInnerHeightMillisErrorEnum[keyof typeof MergedCardTransactionDetailEvidenceListInnerHeightMillisErrorEnum];
export const MergedCardTransactionDetailEvidenceListInnerWidthMillisErrorEnum = {
    required: 'REQUIRED'
} as const;

export type MergedCardTransactionDetailEvidenceListInnerWidthMillisErrorEnum = typeof MergedCardTransactionDetailEvidenceListInnerWidthMillisErrorEnum[keyof typeof MergedCardTransactionDetailEvidenceListInnerWidthMillisErrorEnum];

/**
 * 
 * @export
 * @interface MergedCardTransactionDetailEvidenceListInnerCreatedBy
 */
export interface MergedCardTransactionDetailEvidenceListInnerCreatedBy {
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailEvidenceListInnerCreatedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailEvidenceListInnerCreatedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface MergedCardTransactionDetailEvidenceListInnerErrors
 */
export interface MergedCardTransactionDetailEvidenceListInnerErrors {
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailEvidenceListInnerErrors
     */
    'detectedDpi'?: MergedCardTransactionDetailEvidenceListInnerErrorsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailEvidenceListInnerErrors
     */
    'calculatedDpi'?: MergedCardTransactionDetailEvidenceListInnerErrorsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailEvidenceListInnerErrors
     */
    'colorGradation'?: MergedCardTransactionDetailEvidenceListInnerErrorsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailEvidenceListInnerErrors
     */
    'heightMillis'?: MergedCardTransactionDetailEvidenceListInnerErrorsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailEvidenceListInnerErrors
     */
    'widthMillis'?: MergedCardTransactionDetailEvidenceListInnerErrorsWidthMillisEnum;
}

export const MergedCardTransactionDetailEvidenceListInnerErrorsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type MergedCardTransactionDetailEvidenceListInnerErrorsDetectedDpiEnum = typeof MergedCardTransactionDetailEvidenceListInnerErrorsDetectedDpiEnum[keyof typeof MergedCardTransactionDetailEvidenceListInnerErrorsDetectedDpiEnum];
export const MergedCardTransactionDetailEvidenceListInnerErrorsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type MergedCardTransactionDetailEvidenceListInnerErrorsCalculatedDpiEnum = typeof MergedCardTransactionDetailEvidenceListInnerErrorsCalculatedDpiEnum[keyof typeof MergedCardTransactionDetailEvidenceListInnerErrorsCalculatedDpiEnum];
export const MergedCardTransactionDetailEvidenceListInnerErrorsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type MergedCardTransactionDetailEvidenceListInnerErrorsColorGradationEnum = typeof MergedCardTransactionDetailEvidenceListInnerErrorsColorGradationEnum[keyof typeof MergedCardTransactionDetailEvidenceListInnerErrorsColorGradationEnum];
export const MergedCardTransactionDetailEvidenceListInnerErrorsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type MergedCardTransactionDetailEvidenceListInnerErrorsHeightMillisEnum = typeof MergedCardTransactionDetailEvidenceListInnerErrorsHeightMillisEnum[keyof typeof MergedCardTransactionDetailEvidenceListInnerErrorsHeightMillisEnum];
export const MergedCardTransactionDetailEvidenceListInnerErrorsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type MergedCardTransactionDetailEvidenceListInnerErrorsWidthMillisEnum = typeof MergedCardTransactionDetailEvidenceListInnerErrorsWidthMillisEnum[keyof typeof MergedCardTransactionDetailEvidenceListInnerErrorsWidthMillisEnum];

/**
 * Set null if it\'s evidence not analyzed using invoicing-system-compliance feature. Also set null if invoicing-system-compliance feature has been made not available for the organization by the feature-flag.
 * @export
 * @interface MergedCardTransactionDetailEvidenceListInnerInvoiceIssuer
 */
export interface MergedCardTransactionDetailEvidenceListInnerInvoiceIssuer {
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailEvidenceListInnerInvoiceIssuer
     */
    'name': string | null;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailEvidenceListInnerInvoiceIssuer
     */
    'registrationNumber': string | null;
    /**
     * isQualified retains the result of querying the 国税庁API to see if registrationNumber is qualified, as is.
     * @type {boolean}
     * @memberof MergedCardTransactionDetailEvidenceListInnerInvoiceIssuer
     */
    'isQualified': boolean;
    /**
     * AsQualified indicates whether this issuer should be treated as a qualified invoice issuer within the user\'s system, even if the RegistrationNumber is not confirmed as qualified in the National Tax Agency\'s business registration system.
     * @type {boolean}
     * @memberof MergedCardTransactionDetailEvidenceListInnerInvoiceIssuer
     */
    'asQualified': boolean;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailEvidenceListInnerInvoiceIssuer
     */
    'partnerId': string | null;
}
/**
 * 
 * @export
 * @interface MergedCardTransactionDetailEvidenceListInnerUpdatedBy
 */
export interface MergedCardTransactionDetailEvidenceListInnerUpdatedBy {
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailEvidenceListInnerUpdatedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailEvidenceListInnerUpdatedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface MergedCardTransactionDetailEvidenceListInnerUploadedBy
 */
export interface MergedCardTransactionDetailEvidenceListInnerUploadedBy {
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailEvidenceListInnerUploadedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailEvidenceListInnerUploadedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface MergedCardTransactionDetailEvidenceListInnerWarnings
 */
export interface MergedCardTransactionDetailEvidenceListInnerWarnings {
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailEvidenceListInnerWarnings
     */
    'detectedDpi'?: MergedCardTransactionDetailEvidenceListInnerWarningsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailEvidenceListInnerWarnings
     */
    'calculatedDpi'?: MergedCardTransactionDetailEvidenceListInnerWarningsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailEvidenceListInnerWarnings
     */
    'colorGradation'?: MergedCardTransactionDetailEvidenceListInnerWarningsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailEvidenceListInnerWarnings
     */
    'heightMillis'?: MergedCardTransactionDetailEvidenceListInnerWarningsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailEvidenceListInnerWarnings
     */
    'widthMillis'?: MergedCardTransactionDetailEvidenceListInnerWarningsWidthMillisEnum;
}

export const MergedCardTransactionDetailEvidenceListInnerWarningsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type MergedCardTransactionDetailEvidenceListInnerWarningsDetectedDpiEnum = typeof MergedCardTransactionDetailEvidenceListInnerWarningsDetectedDpiEnum[keyof typeof MergedCardTransactionDetailEvidenceListInnerWarningsDetectedDpiEnum];
export const MergedCardTransactionDetailEvidenceListInnerWarningsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type MergedCardTransactionDetailEvidenceListInnerWarningsCalculatedDpiEnum = typeof MergedCardTransactionDetailEvidenceListInnerWarningsCalculatedDpiEnum[keyof typeof MergedCardTransactionDetailEvidenceListInnerWarningsCalculatedDpiEnum];
export const MergedCardTransactionDetailEvidenceListInnerWarningsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type MergedCardTransactionDetailEvidenceListInnerWarningsColorGradationEnum = typeof MergedCardTransactionDetailEvidenceListInnerWarningsColorGradationEnum[keyof typeof MergedCardTransactionDetailEvidenceListInnerWarningsColorGradationEnum];
export const MergedCardTransactionDetailEvidenceListInnerWarningsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type MergedCardTransactionDetailEvidenceListInnerWarningsHeightMillisEnum = typeof MergedCardTransactionDetailEvidenceListInnerWarningsHeightMillisEnum[keyof typeof MergedCardTransactionDetailEvidenceListInnerWarningsHeightMillisEnum];
export const MergedCardTransactionDetailEvidenceListInnerWarningsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type MergedCardTransactionDetailEvidenceListInnerWarningsWidthMillisEnum = typeof MergedCardTransactionDetailEvidenceListInnerWarningsWidthMillisEnum[keyof typeof MergedCardTransactionDetailEvidenceListInnerWarningsWidthMillisEnum];

/**
 * 
 * @export
 * @interface MergedCardTransactionDetailEvidenceRemindStatus
 */
export interface MergedCardTransactionDetailEvidenceRemindStatus {
    /**
     * 
     * @type {boolean}
     * @memberof MergedCardTransactionDetailEvidenceRemindStatus
     */
    'isAutoRemind': boolean;
}
/**
 * 
 * @export
 * @interface MergedCardTransactionDetailMergedCardTransaction
 */
export interface MergedCardTransactionDetailMergedCardTransaction {
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailMergedCardTransaction
     */
    'visaTransactionReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailMergedCardTransaction
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailMergedCardTransaction
     */
    'merchantName': string;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailMergedCardTransaction
     */
    'merchantNameKana': string;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailMergedCardTransaction
     */
    'merchantNameKanji': string;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailMergedCardTransaction
     */
    'mergedMerchantName': string;
    /**
     * 
     * @type {number}
     * @memberof MergedCardTransactionDetailMergedCardTransaction
     */
    'amount': number;
    /**
     * 
     * @type {number}
     * @memberof MergedCardTransactionDetailMergedCardTransaction
     */
    'amountFx': number;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailMergedCardTransaction
     */
    'currencyCode': string;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailMergedCardTransaction
     */
    'processedAt': string;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailMergedCardTransaction
     */
    'transactionType': MergedCardTransactionDetailMergedCardTransactionTransactionTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof MergedCardTransactionDetailMergedCardTransaction
     */
    'creditSettlement': number;
    /**
     * 
     * @type {Array<MergedCardTransactionDetailMergedCardTransactionTransactionRecordListInner>}
     * @memberof MergedCardTransactionDetailMergedCardTransaction
     */
    'transactionRecordList': Array<MergedCardTransactionDetailMergedCardTransactionTransactionRecordListInner>;
    /**
     * 
     * @type {boolean}
     * @memberof MergedCardTransactionDetailMergedCardTransaction
     */
    'isCleared': boolean;
}

export const MergedCardTransactionDetailMergedCardTransactionTransactionTypeEnum = {
    confirm: 'CONFIRM',
    notConfirm: 'NOT_CONFIRM'
} as const;

export type MergedCardTransactionDetailMergedCardTransactionTransactionTypeEnum = typeof MergedCardTransactionDetailMergedCardTransactionTransactionTypeEnum[keyof typeof MergedCardTransactionDetailMergedCardTransactionTransactionTypeEnum];

/**
 * 
 * @export
 * @interface MergedCardTransactionDetailMergedCardTransactionTransactionRecordListInner
 */
export interface MergedCardTransactionDetailMergedCardTransactionTransactionRecordListInner {
    /**
     * 
     * @type {number}
     * @memberof MergedCardTransactionDetailMergedCardTransactionTransactionRecordListInner
     */
    'amount': number;
    /**
     * 
     * @type {number}
     * @memberof MergedCardTransactionDetailMergedCardTransactionTransactionRecordListInner
     */
    'amountFx': number;
    /**
     * 
     * @type {number}
     * @memberof MergedCardTransactionDetailMergedCardTransactionTransactionRecordListInner
     */
    'totalAmount': number;
    /**
     * 
     * @type {number}
     * @memberof MergedCardTransactionDetailMergedCardTransactionTransactionRecordListInner
     */
    'totalAmountFx': number;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailMergedCardTransactionTransactionRecordListInner
     */
    'currencyCode': string;
    /**
     * 
     * @type {number}
     * @memberof MergedCardTransactionDetailMergedCardTransactionTransactionRecordListInner
     */
    'fxRate': number | null;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailMergedCardTransactionTransactionRecordListInner
     */
    'processedAt': string;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailMergedCardTransactionTransactionRecordListInner
     */
    'transactionDetailType': MergedCardTransactionDetailMergedCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof MergedCardTransactionDetailMergedCardTransactionTransactionRecordListInner
     */
    'isCleared': boolean;
}

export const MergedCardTransactionDetailMergedCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum = {
    purchase: 'PURCHASE',
    settlement: 'SETTLEMENT',
    validation: 'VALIDATION',
    refund: 'REFUND',
    cancel: 'CANCEL',
    refundCancel: 'REFUND_CANCEL',
    refundPartialCancel: 'REFUND_PARTIAL_CANCEL'
} as const;

export type MergedCardTransactionDetailMergedCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum = typeof MergedCardTransactionDetailMergedCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum[keyof typeof MergedCardTransactionDetailMergedCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum];

/**
 * 
 * @export
 * @interface MergedCardTransactionDetailPurchaseApplicationsInner
 */
export interface MergedCardTransactionDetailPurchaseApplicationsInner {
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailPurchaseApplicationsInner
     */
    'applicationId': string;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailPurchaseApplicationsInner
     */
    'applicationNumber': string;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailPurchaseApplicationsInner
     */
    'paymentDate': string;
    /**
     * 
     * @type {MergedCardTransactionDetailPurchaseApplicationsInnerSubmittedBy}
     * @memberof MergedCardTransactionDetailPurchaseApplicationsInner
     */
    'submittedBy': MergedCardTransactionDetailPurchaseApplicationsInnerSubmittedBy;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailPurchaseApplicationsInner
     */
    'submittedAt': string;
    /**
     * 
     * @type {Array<MergedCardTransactionDetailPurchaseApplicationsInnerApproversInner>}
     * @memberof MergedCardTransactionDetailPurchaseApplicationsInner
     */
    'approvers': Array<MergedCardTransactionDetailPurchaseApplicationsInnerApproversInner>;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailPurchaseApplicationsInner
     */
    'department': string;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailPurchaseApplicationsInner
     */
    'purchaseReason': string;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailPurchaseApplicationsInner
     */
    'purchaseDetails': string;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailPurchaseApplicationsInner
     */
    'placeOfUse': string;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailPurchaseApplicationsInner
     */
    'purposeOfUse': string;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailPurchaseApplicationsInner
     */
    'url': string;
    /**
     * 
     * @type {number}
     * @memberof MergedCardTransactionDetailPurchaseApplicationsInner
     */
    'amount': number;
    /**
     * 
     * @type {MergedCardTransactionDetailPurchaseApplicationsInnerUserAccount}
     * @memberof MergedCardTransactionDetailPurchaseApplicationsInner
     */
    'userAccount': MergedCardTransactionDetailPurchaseApplicationsInnerUserAccount | null;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailPurchaseApplicationsInner
     */
    'remarks': string;
    /**
     * 
     * @type {MergedCardTransactionDetailPurchaseApplicationsInnerWorkRequestedBy}
     * @memberof MergedCardTransactionDetailPurchaseApplicationsInner
     */
    'workRequestedBy': MergedCardTransactionDetailPurchaseApplicationsInnerWorkRequestedBy;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailPurchaseApplicationsInner
     */
    'workRequestApprovers': string;
    /**
     * 
     * @type {MergedCardTransactionDetailPurchaseApplicationsInnerStatus}
     * @memberof MergedCardTransactionDetailPurchaseApplicationsInner
     */
    'status': MergedCardTransactionDetailPurchaseApplicationsInnerStatus;
    /**
     * 
     * @type {MergedCardTransactionDetailPurchaseApplicationsInnerCreatedBy}
     * @memberof MergedCardTransactionDetailPurchaseApplicationsInner
     */
    'createdBy': MergedCardTransactionDetailPurchaseApplicationsInnerCreatedBy;
}
/**
 * 
 * @export
 * @interface MergedCardTransactionDetailPurchaseApplicationsInnerApproversInner
 */
export interface MergedCardTransactionDetailPurchaseApplicationsInnerApproversInner {
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailPurchaseApplicationsInnerApproversInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailPurchaseApplicationsInnerApproversInner
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface MergedCardTransactionDetailPurchaseApplicationsInnerCreatedBy
 */
export interface MergedCardTransactionDetailPurchaseApplicationsInnerCreatedBy {
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailPurchaseApplicationsInnerCreatedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailPurchaseApplicationsInnerCreatedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface MergedCardTransactionDetailPurchaseApplicationsInnerStatus
 */
export interface MergedCardTransactionDetailPurchaseApplicationsInnerStatus {
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailPurchaseApplicationsInnerStatus
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailPurchaseApplicationsInnerStatus
     */
    'comment': string;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailPurchaseApplicationsInnerStatus
     */
    'statusChangedAt': string;
    /**
     * 
     * @type {MergedCardTransactionDetailPurchaseApplicationsInnerStatusCreatedBy}
     * @memberof MergedCardTransactionDetailPurchaseApplicationsInnerStatus
     */
    'createdBy': MergedCardTransactionDetailPurchaseApplicationsInnerStatusCreatedBy;
}
/**
 * 
 * @export
 * @interface MergedCardTransactionDetailPurchaseApplicationsInnerStatusCreatedBy
 */
export interface MergedCardTransactionDetailPurchaseApplicationsInnerStatusCreatedBy {
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailPurchaseApplicationsInnerStatusCreatedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailPurchaseApplicationsInnerStatusCreatedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface MergedCardTransactionDetailPurchaseApplicationsInnerSubmittedBy
 */
export interface MergedCardTransactionDetailPurchaseApplicationsInnerSubmittedBy {
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailPurchaseApplicationsInnerSubmittedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailPurchaseApplicationsInnerSubmittedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface MergedCardTransactionDetailPurchaseApplicationsInnerUserAccount
 */
export interface MergedCardTransactionDetailPurchaseApplicationsInnerUserAccount {
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailPurchaseApplicationsInnerUserAccount
     */
    'userAccountId': string;
    /**
     * 
     * @type {MergedCardTransactionDetailPurchaseApplicationsInnerUserAccountUser}
     * @memberof MergedCardTransactionDetailPurchaseApplicationsInnerUserAccount
     */
    'user': MergedCardTransactionDetailPurchaseApplicationsInnerUserAccountUser;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailPurchaseApplicationsInnerUserAccount
     */
    'cardLabel': string;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailPurchaseApplicationsInnerUserAccount
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailPurchaseApplicationsInnerUserAccount
     */
    'organizationName': string;
    /**
     * 
     * @type {MergedCardTransactionDetailPurchaseApplicationsInnerUserAccountUserAccountGroup}
     * @memberof MergedCardTransactionDetailPurchaseApplicationsInnerUserAccount
     */
    'userAccountGroup': MergedCardTransactionDetailPurchaseApplicationsInnerUserAccountUserAccountGroup | null;
    /**
     * 
     * @type {boolean}
     * @memberof MergedCardTransactionDetailPurchaseApplicationsInnerUserAccount
     */
    'isOnDemand': boolean;
}
/**
 * 
 * @export
 * @interface MergedCardTransactionDetailPurchaseApplicationsInnerUserAccountUser
 */
export interface MergedCardTransactionDetailPurchaseApplicationsInnerUserAccountUser {
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailPurchaseApplicationsInnerUserAccountUser
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailPurchaseApplicationsInnerUserAccountUser
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailPurchaseApplicationsInnerUserAccountUser
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailPurchaseApplicationsInnerUserAccountUser
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailPurchaseApplicationsInnerUserAccountUser
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MergedCardTransactionDetailPurchaseApplicationsInnerUserAccountUser
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MergedCardTransactionDetailPurchaseApplicationsInnerUserAccountUser
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MergedCardTransactionDetailPurchaseApplicationsInnerUserAccountUser
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MergedCardTransactionDetailPurchaseApplicationsInnerUserAccountUser
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MergedCardTransactionDetailPurchaseApplicationsInnerUserAccountUser
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailPurchaseApplicationsInnerUserAccountUser
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface MergedCardTransactionDetailPurchaseApplicationsInnerUserAccountUserAccountGroup
 */
export interface MergedCardTransactionDetailPurchaseApplicationsInnerUserAccountUserAccountGroup {
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailPurchaseApplicationsInnerUserAccountUserAccountGroup
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailPurchaseApplicationsInnerUserAccountUserAccountGroup
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof MergedCardTransactionDetailPurchaseApplicationsInnerUserAccountUserAccountGroup
     */
    'sortNum': number;
}
/**
 * 
 * @export
 * @interface MergedCardTransactionDetailPurchaseApplicationsInnerWorkRequestedBy
 */
export interface MergedCardTransactionDetailPurchaseApplicationsInnerWorkRequestedBy {
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailPurchaseApplicationsInnerWorkRequestedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailPurchaseApplicationsInnerWorkRequestedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface MergedCardTransactionDetailRequestHistoryInner
 */
export interface MergedCardTransactionDetailRequestHistoryInner {
    /**
     * 
     * @type {number}
     * @memberof MergedCardTransactionDetailRequestHistoryInner
     */
    'requestId': number;
    /**
     * 
     * @type {MergedCardTransactionDetailRequestHistoryInnerRequestedBy}
     * @memberof MergedCardTransactionDetailRequestHistoryInner
     */
    'requestedBy': MergedCardTransactionDetailRequestHistoryInnerRequestedBy;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailRequestHistoryInner
     */
    'requestedAt': string;
}
/**
 * 
 * @export
 * @interface MergedCardTransactionDetailRequestHistoryInnerRequestedBy
 */
export interface MergedCardTransactionDetailRequestHistoryInnerRequestedBy {
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailRequestHistoryInnerRequestedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailRequestHistoryInnerRequestedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface MergedCardTransactionDetailUserAccount
 */
export interface MergedCardTransactionDetailUserAccount {
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailUserAccount
     */
    'userAccountId': string;
    /**
     * 
     * @type {MergedCardTransactionDetailUserAccountUser}
     * @memberof MergedCardTransactionDetailUserAccount
     */
    'user': MergedCardTransactionDetailUserAccountUser;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailUserAccount
     */
    'cardLabel': string;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailUserAccount
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailUserAccount
     */
    'organizationName': string;
    /**
     * 
     * @type {MergedCardTransactionDetailUserAccountUserAccountGroup}
     * @memberof MergedCardTransactionDetailUserAccount
     */
    'userAccountGroup': MergedCardTransactionDetailUserAccountUserAccountGroup | null;
    /**
     * 
     * @type {boolean}
     * @memberof MergedCardTransactionDetailUserAccount
     */
    'isOnDemand': boolean;
}
/**
 * 
 * @export
 * @interface MergedCardTransactionDetailUserAccountUser
 */
export interface MergedCardTransactionDetailUserAccountUser {
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailUserAccountUser
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailUserAccountUser
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailUserAccountUser
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailUserAccountUser
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailUserAccountUser
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MergedCardTransactionDetailUserAccountUser
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MergedCardTransactionDetailUserAccountUser
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MergedCardTransactionDetailUserAccountUser
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MergedCardTransactionDetailUserAccountUser
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MergedCardTransactionDetailUserAccountUser
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailUserAccountUser
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface MergedCardTransactionDetailUserAccountUserAccountGroup
 */
export interface MergedCardTransactionDetailUserAccountUserAccountGroup {
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailUserAccountUserAccountGroup
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailUserAccountUserAccountGroup
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof MergedCardTransactionDetailUserAccountUserAccountGroup
     */
    'sortNum': number;
}
/**
 * 
 * @export
 * @interface MergedCardTransactionTransactionRecordListInner
 */
export interface MergedCardTransactionTransactionRecordListInner {
    /**
     * 
     * @type {number}
     * @memberof MergedCardTransactionTransactionRecordListInner
     */
    'amount': number;
    /**
     * 
     * @type {number}
     * @memberof MergedCardTransactionTransactionRecordListInner
     */
    'amountFx': number;
    /**
     * 
     * @type {number}
     * @memberof MergedCardTransactionTransactionRecordListInner
     */
    'totalAmount': number;
    /**
     * 
     * @type {number}
     * @memberof MergedCardTransactionTransactionRecordListInner
     */
    'totalAmountFx': number;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionTransactionRecordListInner
     */
    'currencyCode': string;
    /**
     * 
     * @type {number}
     * @memberof MergedCardTransactionTransactionRecordListInner
     */
    'fxRate': number | null;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionTransactionRecordListInner
     */
    'processedAt': string;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionTransactionRecordListInner
     */
    'transactionDetailType': MergedCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof MergedCardTransactionTransactionRecordListInner
     */
    'isCleared': boolean;
}

export const MergedCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum = {
    purchase: 'PURCHASE',
    settlement: 'SETTLEMENT',
    validation: 'VALIDATION',
    refund: 'REFUND',
    cancel: 'CANCEL',
    refundCancel: 'REFUND_CANCEL',
    refundPartialCancel: 'REFUND_PARTIAL_CANCEL'
} as const;

export type MergedCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum = typeof MergedCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum[keyof typeof MergedCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum];

/**
 * 
 * @export
 * @interface MoveSlackNotificationSettingForCardRequest
 */
export interface MoveSlackNotificationSettingForCardRequest {
    /**
     * 
     * @type {string}
     * @memberof MoveSlackNotificationSettingForCardRequest
     */
    'channelId': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof MoveSlackNotificationSettingForCardRequest
     */
    'transactionTypes': Array<MoveSlackNotificationSettingForCardRequestTransactionTypesEnum>;
    /**
     * 
     * @type {number}
     * @memberof MoveSlackNotificationSettingForCardRequest
     */
    'largeAmountThreshold'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof MoveSlackNotificationSettingForCardRequest
     */
    'userAccountIds': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof MoveSlackNotificationSettingForCardRequest
     */
    'groupIds': Array<string>;
}

export const MoveSlackNotificationSettingForCardRequestTransactionTypesEnum = {
    unknownTransactionType: 'UNKNOWN_TRANSACTION_TYPE',
    successfulTransaction: 'SUCCESSFUL_TRANSACTION',
    incorrectCardInput: 'INCORRECT_CARD_INPUT',
    insufficientBalance: 'INSUFFICIENT_BALANCE',
    otherError: 'OTHER_ERROR',
    potentialFraud: 'POTENTIAL_FRAUD',
    criticalError: 'CRITICAL_ERROR',
    unusualUser: 'UNUSUAL_USER',
    limitationByUser: 'LIMITATION_BY_USER',
    unsupportedTransaction: 'UNSUPPORTED_TRANSACTION',
    carelessUser: 'CARELESS_USER'
} as const;

export type MoveSlackNotificationSettingForCardRequestTransactionTypesEnum = typeof MoveSlackNotificationSettingForCardRequestTransactionTypesEnum[keyof typeof MoveSlackNotificationSettingForCardRequestTransactionTypesEnum];

/**
 * 
 * @export
 * @interface MoveTeamsNotificationSettingForCardRequest
 */
export interface MoveTeamsNotificationSettingForCardRequest {
    /**
     * 
     * @type {string}
     * @memberof MoveTeamsNotificationSettingForCardRequest
     */
    'channelId': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof MoveTeamsNotificationSettingForCardRequest
     */
    'transactionTypes': Array<MoveTeamsNotificationSettingForCardRequestTransactionTypesEnum>;
    /**
     * 
     * @type {number}
     * @memberof MoveTeamsNotificationSettingForCardRequest
     */
    'largeAmountThreshold'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof MoveTeamsNotificationSettingForCardRequest
     */
    'userAccountIds': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof MoveTeamsNotificationSettingForCardRequest
     */
    'groupIds': Array<string>;
}

export const MoveTeamsNotificationSettingForCardRequestTransactionTypesEnum = {
    unknownTransactionType: 'UNKNOWN_TRANSACTION_TYPE',
    successfulTransaction: 'SUCCESSFUL_TRANSACTION',
    incorrectCardInput: 'INCORRECT_CARD_INPUT',
    insufficientBalance: 'INSUFFICIENT_BALANCE',
    otherError: 'OTHER_ERROR',
    potentialFraud: 'POTENTIAL_FRAUD',
    criticalError: 'CRITICAL_ERROR',
    unusualUser: 'UNUSUAL_USER',
    limitationByUser: 'LIMITATION_BY_USER',
    unsupportedTransaction: 'UNSUPPORTED_TRANSACTION',
    carelessUser: 'CARELESS_USER'
} as const;

export type MoveTeamsNotificationSettingForCardRequestTransactionTypesEnum = typeof MoveTeamsNotificationSettingForCardRequestTransactionTypesEnum[keyof typeof MoveTeamsNotificationSettingForCardRequestTransactionTypesEnum];

/**
 * 
 * @export
 * @interface OnboardingRequest
 */
export interface OnboardingRequest {
    /**
     * 
     * @type {string}
     * @memberof OnboardingRequest
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof OnboardingRequest
     */
    'organizationName': string;
    /**
     * 
     * @type {string}
     * @memberof OnboardingRequest
     */
    'corporateNumber': string;
    /**
     * 
     * @type {string}
     * @memberof OnboardingRequest
     */
    'representativeName': string;
    /**
     * 
     * @type {string}
     * @memberof OnboardingRequest
     */
    'phoneNumber': string;
    /**
     * 
     * @type {string}
     * @memberof OnboardingRequest
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof OnboardingRequest
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface OrgMonthlyCardTransaction
 */
export interface OrgMonthlyCardTransaction {
    /**
     * 
     * @type {number}
     * @memberof OrgMonthlyCardTransaction
     */
    'amount': number;
    /**
     * 
     * @type {Array<OrgMonthlyCardTransactionMergedTransactionDetailListInner>}
     * @memberof OrgMonthlyCardTransaction
     */
    'mergedTransactionDetailList': Array<OrgMonthlyCardTransactionMergedTransactionDetailListInner>;
}
/**
 * 
 * @export
 * @interface OrgMonthlyCardTransactionMergedTransactionDetailListInner
 */
export interface OrgMonthlyCardTransactionMergedTransactionDetailListInner {
    /**
     * 
     * @type {OrgMonthlyCardTransactionMergedTransactionDetailListInnerMergedCardTransaction}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInner
     */
    'mergedCardTransaction': OrgMonthlyCardTransactionMergedTransactionDetailListInnerMergedCardTransaction;
    /**
     * 
     * @type {OrgMonthlyCardTransactionMergedTransactionDetailListInnerCardTransactionEvidenceStatus}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInner
     */
    'cardTransactionEvidenceStatus': OrgMonthlyCardTransactionMergedTransactionDetailListInnerCardTransactionEvidenceStatus;
    /**
     * 
     * @type {Array<OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInner>}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInner
     */
    'evidenceList': Array<OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInner>;
    /**
     * 
     * @type {Array<OrgMonthlyCardTransactionMergedTransactionDetailListInnerRequestHistoryInner>}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInner
     */
    'requestHistory': Array<OrgMonthlyCardTransactionMergedTransactionDetailListInnerRequestHistoryInner>;
    /**
     * 
     * @type {OrgMonthlyCardTransactionMergedTransactionDetailListInnerComment}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInner
     */
    'comment'?: OrgMonthlyCardTransactionMergedTransactionDetailListInnerComment;
    /**
     * 
     * @type {OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceRemindStatus}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInner
     */
    'evidenceRemindStatus': OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceRemindStatus;
    /**
     * 
     * @type {OrgMonthlyCardTransactionMergedTransactionDetailListInnerUserAccount}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInner
     */
    'userAccount': OrgMonthlyCardTransactionMergedTransactionDetailListInnerUserAccount;
    /**
     * 
     * @type {Array<OrgMonthlyCardTransactionMergedTransactionDetailListInnerPurchaseApplicationsInner>}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInner
     */
    'purchaseApplications': Array<OrgMonthlyCardTransactionMergedTransactionDetailListInnerPurchaseApplicationsInner>;
}
/**
 * 
 * @export
 * @interface OrgMonthlyCardTransactionMergedTransactionDetailListInnerCardTransactionEvidenceStatus
 */
export interface OrgMonthlyCardTransactionMergedTransactionDetailListInnerCardTransactionEvidenceStatus {
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerCardTransactionEvidenceStatus
     */
    'visaTransactionReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerCardTransactionEvidenceStatus
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {boolean}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerCardTransactionEvidenceStatus
     */
    'isRequested': boolean;
    /**
     * 
     * @type {OrgMonthlyCardTransactionMergedTransactionDetailListInnerCardTransactionEvidenceStatusRequestedBy}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerCardTransactionEvidenceStatus
     */
    'requestedBy': OrgMonthlyCardTransactionMergedTransactionDetailListInnerCardTransactionEvidenceStatusRequestedBy | null;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerCardTransactionEvidenceStatus
     */
    'requestedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerCardTransactionEvidenceStatus
     */
    'isLocked': boolean;
    /**
     * 
     * @type {OrgMonthlyCardTransactionMergedTransactionDetailListInnerCardTransactionEvidenceStatusLockedBy}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerCardTransactionEvidenceStatus
     */
    'lockedBy': OrgMonthlyCardTransactionMergedTransactionDetailListInnerCardTransactionEvidenceStatusLockedBy | null;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerCardTransactionEvidenceStatus
     */
    'lockedAt': string;
}
/**
 * 
 * @export
 * @interface OrgMonthlyCardTransactionMergedTransactionDetailListInnerCardTransactionEvidenceStatusLockedBy
 */
export interface OrgMonthlyCardTransactionMergedTransactionDetailListInnerCardTransactionEvidenceStatusLockedBy {
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerCardTransactionEvidenceStatusLockedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerCardTransactionEvidenceStatusLockedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface OrgMonthlyCardTransactionMergedTransactionDetailListInnerCardTransactionEvidenceStatusRequestedBy
 */
export interface OrgMonthlyCardTransactionMergedTransactionDetailListInnerCardTransactionEvidenceStatusRequestedBy {
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerCardTransactionEvidenceStatusRequestedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerCardTransactionEvidenceStatusRequestedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface OrgMonthlyCardTransactionMergedTransactionDetailListInnerComment
 */
export interface OrgMonthlyCardTransactionMergedTransactionDetailListInnerComment {
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerComment
     */
    'cardTransactionCommentId': string;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerComment
     */
    'visaTransactionReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerComment
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerComment
     */
    'comment': string;
    /**
     * 
     * @type {OrgMonthlyCardTransactionMergedTransactionDetailListInnerCommentCreatedBy}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerComment
     */
    'createdBy': OrgMonthlyCardTransactionMergedTransactionDetailListInnerCommentCreatedBy;
}
/**
 * 
 * @export
 * @interface OrgMonthlyCardTransactionMergedTransactionDetailListInnerCommentCreatedBy
 */
export interface OrgMonthlyCardTransactionMergedTransactionDetailListInnerCommentCreatedBy {
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerCommentCreatedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerCommentCreatedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInner
 */
export interface OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInner {
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInner
     * @deprecated
     */
    'cardTransactionEvidenceId': string;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInner
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInner
     * @deprecated
     */
    'visaTransactionReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInner
     */
    'paymentType': OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerPaymentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInner
     */
    'fileName': string;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInner
     */
    'fileExtension': string;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInner
     */
    'electronicMethod': OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerElectronicMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInner
     */
    'documentSize': OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerDocumentSizeEnum;
    /**
     * 
     * @type {number}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInner
     * @deprecated
     */
    'dpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInner
     */
    'detectedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInner
     */
    'calculatedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInner
     */
    'colorGradation': number | null;
    /**
     * 
     * @type {number}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInner
     */
    'verticalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInner
     */
    'horizontalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInner
     */
    'heightMillis': number | null;
    /**
     * 
     * @type {number}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInner
     */
    'widthMillis': number | null;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInner
     */
    'legalValidity': OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerLegalValidityEnum;
    /**
     * 
     * @type {boolean}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInner
     */
    'dpiForciblyValid': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInner
     */
    'colorGradationForciblyValid': boolean;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInner
     */
    'note': string;
    /**
     * 
     * @type {boolean}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInner
     */
    'irrelevantToLedger': boolean;
    /**
     * 
     * @type {OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerInvoiceIssuer}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInner
     */
    'invoiceIssuer': OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerInvoiceIssuer | null;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInner
     * @deprecated
     */
    'dpiError': OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerDpiErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInner
     * @deprecated
     */
    'detectedDpiError': OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerDetectedDpiErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInner
     * @deprecated
     */
    'calculatedDpiError': OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerCalculatedDpiErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInner
     * @deprecated
     */
    'colorGradationError': OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerColorGradationErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInner
     * @deprecated
     */
    'heightMillisError': OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerHeightMillisErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInner
     * @deprecated
     */
    'widthMillisError': OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerWidthMillisErrorEnum;
    /**
     * 
     * @type {OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerErrors}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInner
     */
    'errors': OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerErrors;
    /**
     * 
     * @type {OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerWarnings}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInner
     */
    'warnings': OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerWarnings;
    /**
     * 
     * @type {OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerCreatedBy}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInner
     */
    'createdBy': OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerCreatedBy;
    /**
     * 
     * @type {OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerUpdatedBy}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInner
     */
    'updatedBy': OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerUpdatedBy;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInner
     */
    'updatedAt': string;
    /**
     * 
     * @type {OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerUploadedBy}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInner
     */
    'uploadedBy': OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerUploadedBy;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInner
     */
    'uploadedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInner
     */
    'uploadedByRecipient': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInner
     */
    'needsMigration': boolean | null;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInner
     */
    'uploadedFrom': string;
}

export const OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerPaymentTypeEnum = {
    cardTransaction: 'CARD_TRANSACTION',
    paymentRequest: 'PAYMENT_REQUEST'
} as const;

export type OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerPaymentTypeEnum = typeof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerPaymentTypeEnum[keyof typeof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerPaymentTypeEnum];
export const OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerElectronicMethodEnum = {
    fullElectronic: 'FULL_ELECTRONIC',
    originallyPaper: 'ORIGINALLY_PAPER',
    unknown: 'UNKNOWN'
} as const;

export type OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerElectronicMethodEnum = typeof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerElectronicMethodEnum[keyof typeof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerElectronicMethodEnum];
export const OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerDocumentSizeEnum = {
    overA4: 'OVER_A4',
    a4OrSmaller: 'A4_OR_SMALLER',
    unknown: 'UNKNOWN'
} as const;

export type OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerDocumentSizeEnum = typeof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerDocumentSizeEnum[keyof typeof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerDocumentSizeEnum];
export const OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerLegalValidityEnum = {
    valid: 'VALID',
    invalid: 'INVALID',
    inputRequired: 'INPUT_REQUIRED',
    outOfTarget: 'OUT_OF_TARGET'
} as const;

export type OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerLegalValidityEnum = typeof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerLegalValidityEnum[keyof typeof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerLegalValidityEnum];
export const OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerDpiErrorEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerDpiErrorEnum = typeof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerDpiErrorEnum[keyof typeof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerDpiErrorEnum];
export const OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerDetectedDpiErrorEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerDetectedDpiErrorEnum = typeof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerDetectedDpiErrorEnum[keyof typeof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerDetectedDpiErrorEnum];
export const OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerCalculatedDpiErrorEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerCalculatedDpiErrorEnum = typeof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerCalculatedDpiErrorEnum[keyof typeof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerCalculatedDpiErrorEnum];
export const OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerColorGradationErrorEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerColorGradationErrorEnum = typeof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerColorGradationErrorEnum[keyof typeof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerColorGradationErrorEnum];
export const OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerHeightMillisErrorEnum = {
    required: 'REQUIRED'
} as const;

export type OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerHeightMillisErrorEnum = typeof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerHeightMillisErrorEnum[keyof typeof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerHeightMillisErrorEnum];
export const OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerWidthMillisErrorEnum = {
    required: 'REQUIRED'
} as const;

export type OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerWidthMillisErrorEnum = typeof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerWidthMillisErrorEnum[keyof typeof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerWidthMillisErrorEnum];

/**
 * 
 * @export
 * @interface OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerCreatedBy
 */
export interface OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerCreatedBy {
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerCreatedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerCreatedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerErrors
 */
export interface OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerErrors {
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerErrors
     */
    'detectedDpi'?: OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerErrorsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerErrors
     */
    'calculatedDpi'?: OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerErrorsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerErrors
     */
    'colorGradation'?: OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerErrorsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerErrors
     */
    'heightMillis'?: OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerErrorsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerErrors
     */
    'widthMillis'?: OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerErrorsWidthMillisEnum;
}

export const OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerErrorsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerErrorsDetectedDpiEnum = typeof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerErrorsDetectedDpiEnum[keyof typeof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerErrorsDetectedDpiEnum];
export const OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerErrorsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerErrorsCalculatedDpiEnum = typeof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerErrorsCalculatedDpiEnum[keyof typeof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerErrorsCalculatedDpiEnum];
export const OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerErrorsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerErrorsColorGradationEnum = typeof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerErrorsColorGradationEnum[keyof typeof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerErrorsColorGradationEnum];
export const OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerErrorsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerErrorsHeightMillisEnum = typeof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerErrorsHeightMillisEnum[keyof typeof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerErrorsHeightMillisEnum];
export const OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerErrorsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerErrorsWidthMillisEnum = typeof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerErrorsWidthMillisEnum[keyof typeof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerErrorsWidthMillisEnum];

/**
 * Set null if it\'s evidence not analyzed using invoicing-system-compliance feature. Also set null if invoicing-system-compliance feature has been made not available for the organization by the feature-flag.
 * @export
 * @interface OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerInvoiceIssuer
 */
export interface OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerInvoiceIssuer {
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerInvoiceIssuer
     */
    'name': string | null;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerInvoiceIssuer
     */
    'registrationNumber': string | null;
    /**
     * isQualified retains the result of querying the 国税庁API to see if registrationNumber is qualified, as is.
     * @type {boolean}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerInvoiceIssuer
     */
    'isQualified': boolean;
    /**
     * AsQualified indicates whether this issuer should be treated as a qualified invoice issuer within the user\'s system, even if the RegistrationNumber is not confirmed as qualified in the National Tax Agency\'s business registration system.
     * @type {boolean}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerInvoiceIssuer
     */
    'asQualified': boolean;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerInvoiceIssuer
     */
    'partnerId': string | null;
}
/**
 * 
 * @export
 * @interface OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerUpdatedBy
 */
export interface OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerUpdatedBy {
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerUpdatedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerUpdatedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerUploadedBy
 */
export interface OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerUploadedBy {
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerUploadedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerUploadedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerWarnings
 */
export interface OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerWarnings {
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerWarnings
     */
    'detectedDpi'?: OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerWarningsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerWarnings
     */
    'calculatedDpi'?: OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerWarningsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerWarnings
     */
    'colorGradation'?: OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerWarningsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerWarnings
     */
    'heightMillis'?: OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerWarningsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerWarnings
     */
    'widthMillis'?: OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerWarningsWidthMillisEnum;
}

export const OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerWarningsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerWarningsDetectedDpiEnum = typeof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerWarningsDetectedDpiEnum[keyof typeof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerWarningsDetectedDpiEnum];
export const OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerWarningsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerWarningsCalculatedDpiEnum = typeof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerWarningsCalculatedDpiEnum[keyof typeof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerWarningsCalculatedDpiEnum];
export const OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerWarningsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerWarningsColorGradationEnum = typeof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerWarningsColorGradationEnum[keyof typeof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerWarningsColorGradationEnum];
export const OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerWarningsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerWarningsHeightMillisEnum = typeof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerWarningsHeightMillisEnum[keyof typeof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerWarningsHeightMillisEnum];
export const OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerWarningsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerWarningsWidthMillisEnum = typeof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerWarningsWidthMillisEnum[keyof typeof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerWarningsWidthMillisEnum];

/**
 * 
 * @export
 * @interface OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceRemindStatus
 */
export interface OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceRemindStatus {
    /**
     * 
     * @type {boolean}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceRemindStatus
     */
    'isAutoRemind': boolean;
}
/**
 * 
 * @export
 * @interface OrgMonthlyCardTransactionMergedTransactionDetailListInnerMergedCardTransaction
 */
export interface OrgMonthlyCardTransactionMergedTransactionDetailListInnerMergedCardTransaction {
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerMergedCardTransaction
     */
    'visaTransactionReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerMergedCardTransaction
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerMergedCardTransaction
     */
    'merchantName': string;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerMergedCardTransaction
     */
    'merchantNameKana': string;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerMergedCardTransaction
     */
    'merchantNameKanji': string;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerMergedCardTransaction
     */
    'mergedMerchantName': string;
    /**
     * 
     * @type {number}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerMergedCardTransaction
     */
    'amount': number;
    /**
     * 
     * @type {number}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerMergedCardTransaction
     */
    'amountFx': number;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerMergedCardTransaction
     */
    'currencyCode': string;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerMergedCardTransaction
     */
    'processedAt': string;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerMergedCardTransaction
     */
    'transactionType': OrgMonthlyCardTransactionMergedTransactionDetailListInnerMergedCardTransactionTransactionTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerMergedCardTransaction
     */
    'creditSettlement': number;
    /**
     * 
     * @type {Array<OrgMonthlyCardTransactionMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner>}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerMergedCardTransaction
     */
    'transactionRecordList': Array<OrgMonthlyCardTransactionMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner>;
    /**
     * 
     * @type {boolean}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerMergedCardTransaction
     */
    'isCleared': boolean;
}

export const OrgMonthlyCardTransactionMergedTransactionDetailListInnerMergedCardTransactionTransactionTypeEnum = {
    confirm: 'CONFIRM',
    notConfirm: 'NOT_CONFIRM'
} as const;

export type OrgMonthlyCardTransactionMergedTransactionDetailListInnerMergedCardTransactionTransactionTypeEnum = typeof OrgMonthlyCardTransactionMergedTransactionDetailListInnerMergedCardTransactionTransactionTypeEnum[keyof typeof OrgMonthlyCardTransactionMergedTransactionDetailListInnerMergedCardTransactionTransactionTypeEnum];

/**
 * 
 * @export
 * @interface OrgMonthlyCardTransactionMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner
 */
export interface OrgMonthlyCardTransactionMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner {
    /**
     * 
     * @type {number}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner
     */
    'amount': number;
    /**
     * 
     * @type {number}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner
     */
    'amountFx': number;
    /**
     * 
     * @type {number}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner
     */
    'totalAmount': number;
    /**
     * 
     * @type {number}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner
     */
    'totalAmountFx': number;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner
     */
    'currencyCode': string;
    /**
     * 
     * @type {number}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner
     */
    'fxRate': number | null;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner
     */
    'processedAt': string;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner
     */
    'transactionDetailType': OrgMonthlyCardTransactionMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner
     */
    'isCleared': boolean;
}

export const OrgMonthlyCardTransactionMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum = {
    purchase: 'PURCHASE',
    settlement: 'SETTLEMENT',
    validation: 'VALIDATION',
    refund: 'REFUND',
    cancel: 'CANCEL',
    refundCancel: 'REFUND_CANCEL',
    refundPartialCancel: 'REFUND_PARTIAL_CANCEL'
} as const;

export type OrgMonthlyCardTransactionMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum = typeof OrgMonthlyCardTransactionMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum[keyof typeof OrgMonthlyCardTransactionMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum];

/**
 * 
 * @export
 * @interface OrgMonthlyCardTransactionMergedTransactionDetailListInnerPurchaseApplicationsInner
 */
export interface OrgMonthlyCardTransactionMergedTransactionDetailListInnerPurchaseApplicationsInner {
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerPurchaseApplicationsInner
     */
    'applicationId': string;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerPurchaseApplicationsInner
     */
    'applicationNumber': string;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerPurchaseApplicationsInner
     */
    'paymentDate': string;
    /**
     * 
     * @type {OrgMonthlyCardTransactionMergedTransactionDetailListInnerPurchaseApplicationsInnerSubmittedBy}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerPurchaseApplicationsInner
     */
    'submittedBy': OrgMonthlyCardTransactionMergedTransactionDetailListInnerPurchaseApplicationsInnerSubmittedBy;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerPurchaseApplicationsInner
     */
    'submittedAt': string;
    /**
     * 
     * @type {Array<OrgMonthlyCardTransactionMergedTransactionDetailListInnerPurchaseApplicationsInnerApproversInner>}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerPurchaseApplicationsInner
     */
    'approvers': Array<OrgMonthlyCardTransactionMergedTransactionDetailListInnerPurchaseApplicationsInnerApproversInner>;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerPurchaseApplicationsInner
     */
    'department': string;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerPurchaseApplicationsInner
     */
    'purchaseReason': string;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerPurchaseApplicationsInner
     */
    'purchaseDetails': string;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerPurchaseApplicationsInner
     */
    'placeOfUse': string;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerPurchaseApplicationsInner
     */
    'purposeOfUse': string;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerPurchaseApplicationsInner
     */
    'url': string;
    /**
     * 
     * @type {number}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerPurchaseApplicationsInner
     */
    'amount': number;
    /**
     * 
     * @type {OrgMonthlyCardTransactionMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccount}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerPurchaseApplicationsInner
     */
    'userAccount': OrgMonthlyCardTransactionMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccount | null;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerPurchaseApplicationsInner
     */
    'remarks': string;
    /**
     * 
     * @type {OrgMonthlyCardTransactionMergedTransactionDetailListInnerPurchaseApplicationsInnerWorkRequestedBy}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerPurchaseApplicationsInner
     */
    'workRequestedBy': OrgMonthlyCardTransactionMergedTransactionDetailListInnerPurchaseApplicationsInnerWorkRequestedBy;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerPurchaseApplicationsInner
     */
    'workRequestApprovers': string;
    /**
     * 
     * @type {OrgMonthlyCardTransactionMergedTransactionDetailListInnerPurchaseApplicationsInnerStatus}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerPurchaseApplicationsInner
     */
    'status': OrgMonthlyCardTransactionMergedTransactionDetailListInnerPurchaseApplicationsInnerStatus;
    /**
     * 
     * @type {OrgMonthlyCardTransactionMergedTransactionDetailListInnerPurchaseApplicationsInnerCreatedBy}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerPurchaseApplicationsInner
     */
    'createdBy': OrgMonthlyCardTransactionMergedTransactionDetailListInnerPurchaseApplicationsInnerCreatedBy;
}
/**
 * 
 * @export
 * @interface OrgMonthlyCardTransactionMergedTransactionDetailListInnerPurchaseApplicationsInnerApproversInner
 */
export interface OrgMonthlyCardTransactionMergedTransactionDetailListInnerPurchaseApplicationsInnerApproversInner {
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerPurchaseApplicationsInnerApproversInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerPurchaseApplicationsInnerApproversInner
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface OrgMonthlyCardTransactionMergedTransactionDetailListInnerPurchaseApplicationsInnerCreatedBy
 */
export interface OrgMonthlyCardTransactionMergedTransactionDetailListInnerPurchaseApplicationsInnerCreatedBy {
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerPurchaseApplicationsInnerCreatedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerPurchaseApplicationsInnerCreatedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface OrgMonthlyCardTransactionMergedTransactionDetailListInnerPurchaseApplicationsInnerStatus
 */
export interface OrgMonthlyCardTransactionMergedTransactionDetailListInnerPurchaseApplicationsInnerStatus {
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerPurchaseApplicationsInnerStatus
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerPurchaseApplicationsInnerStatus
     */
    'comment': string;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerPurchaseApplicationsInnerStatus
     */
    'statusChangedAt': string;
    /**
     * 
     * @type {OrgMonthlyCardTransactionMergedTransactionDetailListInnerPurchaseApplicationsInnerStatusCreatedBy}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerPurchaseApplicationsInnerStatus
     */
    'createdBy': OrgMonthlyCardTransactionMergedTransactionDetailListInnerPurchaseApplicationsInnerStatusCreatedBy;
}
/**
 * 
 * @export
 * @interface OrgMonthlyCardTransactionMergedTransactionDetailListInnerPurchaseApplicationsInnerStatusCreatedBy
 */
export interface OrgMonthlyCardTransactionMergedTransactionDetailListInnerPurchaseApplicationsInnerStatusCreatedBy {
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerPurchaseApplicationsInnerStatusCreatedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerPurchaseApplicationsInnerStatusCreatedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface OrgMonthlyCardTransactionMergedTransactionDetailListInnerPurchaseApplicationsInnerSubmittedBy
 */
export interface OrgMonthlyCardTransactionMergedTransactionDetailListInnerPurchaseApplicationsInnerSubmittedBy {
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerPurchaseApplicationsInnerSubmittedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerPurchaseApplicationsInnerSubmittedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface OrgMonthlyCardTransactionMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccount
 */
export interface OrgMonthlyCardTransactionMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccount {
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccount
     */
    'userAccountId': string;
    /**
     * 
     * @type {OrgMonthlyCardTransactionMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUser}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccount
     */
    'user': OrgMonthlyCardTransactionMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUser;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccount
     */
    'cardLabel': string;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccount
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccount
     */
    'organizationName': string;
    /**
     * 
     * @type {OrgMonthlyCardTransactionMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUserAccountGroup}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccount
     */
    'userAccountGroup': OrgMonthlyCardTransactionMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUserAccountGroup | null;
    /**
     * 
     * @type {boolean}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccount
     */
    'isOnDemand': boolean;
}
/**
 * 
 * @export
 * @interface OrgMonthlyCardTransactionMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUser
 */
export interface OrgMonthlyCardTransactionMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUser {
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUser
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUser
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUser
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUser
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUser
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUser
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUser
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUser
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUser
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUser
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUser
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface OrgMonthlyCardTransactionMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUserAccountGroup
 */
export interface OrgMonthlyCardTransactionMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUserAccountGroup {
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUserAccountGroup
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUserAccountGroup
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerPurchaseApplicationsInnerUserAccountUserAccountGroup
     */
    'sortNum': number;
}
/**
 * 
 * @export
 * @interface OrgMonthlyCardTransactionMergedTransactionDetailListInnerPurchaseApplicationsInnerWorkRequestedBy
 */
export interface OrgMonthlyCardTransactionMergedTransactionDetailListInnerPurchaseApplicationsInnerWorkRequestedBy {
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerPurchaseApplicationsInnerWorkRequestedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerPurchaseApplicationsInnerWorkRequestedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface OrgMonthlyCardTransactionMergedTransactionDetailListInnerRequestHistoryInner
 */
export interface OrgMonthlyCardTransactionMergedTransactionDetailListInnerRequestHistoryInner {
    /**
     * 
     * @type {number}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerRequestHistoryInner
     */
    'requestId': number;
    /**
     * 
     * @type {OrgMonthlyCardTransactionMergedTransactionDetailListInnerRequestHistoryInnerRequestedBy}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerRequestHistoryInner
     */
    'requestedBy': OrgMonthlyCardTransactionMergedTransactionDetailListInnerRequestHistoryInnerRequestedBy;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerRequestHistoryInner
     */
    'requestedAt': string;
}
/**
 * 
 * @export
 * @interface OrgMonthlyCardTransactionMergedTransactionDetailListInnerRequestHistoryInnerRequestedBy
 */
export interface OrgMonthlyCardTransactionMergedTransactionDetailListInnerRequestHistoryInnerRequestedBy {
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerRequestHistoryInnerRequestedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerRequestHistoryInnerRequestedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface OrgMonthlyCardTransactionMergedTransactionDetailListInnerUserAccount
 */
export interface OrgMonthlyCardTransactionMergedTransactionDetailListInnerUserAccount {
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerUserAccount
     */
    'userAccountId': string;
    /**
     * 
     * @type {OrgMonthlyCardTransactionMergedTransactionDetailListInnerUserAccountUser}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerUserAccount
     */
    'user': OrgMonthlyCardTransactionMergedTransactionDetailListInnerUserAccountUser;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerUserAccount
     */
    'cardLabel': string;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerUserAccount
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerUserAccount
     */
    'organizationName': string;
    /**
     * 
     * @type {OrgMonthlyCardTransactionMergedTransactionDetailListInnerUserAccountUserAccountGroup}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerUserAccount
     */
    'userAccountGroup': OrgMonthlyCardTransactionMergedTransactionDetailListInnerUserAccountUserAccountGroup | null;
    /**
     * 
     * @type {boolean}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerUserAccount
     */
    'isOnDemand': boolean;
}
/**
 * 
 * @export
 * @interface OrgMonthlyCardTransactionMergedTransactionDetailListInnerUserAccountUser
 */
export interface OrgMonthlyCardTransactionMergedTransactionDetailListInnerUserAccountUser {
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerUserAccountUser
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerUserAccountUser
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerUserAccountUser
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerUserAccountUser
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerUserAccountUser
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerUserAccountUser
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerUserAccountUser
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerUserAccountUser
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerUserAccountUser
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerUserAccountUser
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerUserAccountUser
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface OrgMonthlyCardTransactionMergedTransactionDetailListInnerUserAccountUserAccountGroup
 */
export interface OrgMonthlyCardTransactionMergedTransactionDetailListInnerUserAccountUserAccountGroup {
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerUserAccountUserAccountGroup
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerUserAccountUserAccountGroup
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerUserAccountUserAccountGroup
     */
    'sortNum': number;
}
/**
 * 
 * @export
 * @interface Organization
 */
export interface Organization {
    /**
     * 
     * @type {string}
     * @memberof Organization
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Organization
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof Organization
     */
    'representativeName': string;
    /**
     * 
     * @type {string}
     * @memberof Organization
     */
    'phoneNumber': string;
    /**
     * 
     * @type {string}
     * @memberof Organization
     */
    'postalCode': string;
    /**
     * 
     * @type {string}
     * @memberof Organization
     */
    'address': string;
    /**
     * 
     * @type {string}
     * @memberof Organization
     */
    'deliveryPostalCode': string;
    /**
     * 
     * @type {string}
     * @memberof Organization
     */
    'deliveryAddress': string;
    /**
     * 
     * @type {string}
     * @memberof Organization
     */
    'invoiceEmail': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof Organization
     */
    'isApprovalFeatureEnabled': boolean;
}
/**
 * 
 * @export
 * @interface OrganizationCreatePreRequest200Response
 */
export interface OrganizationCreatePreRequest200Response {
    /**
     * 
     * @type {string}
     * @memberof OrganizationCreatePreRequest200Response
     */
    'code': string;
}
/**
 * 
 * @export
 * @interface OrganizationCreatePreRequestRequest
 */
export interface OrganizationCreatePreRequestRequest {
    /**
     * 
     * @type {string}
     * @memberof OrganizationCreatePreRequestRequest
     */
    'organizationName': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationCreatePreRequestRequest
     */
    'personName': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationCreatePreRequestRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationCreatePreRequestRequest
     */
    'phoneNumber': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationCreatePreRequestRequest
     */
    'employeeNumber': OrganizationCreatePreRequestRequestEmployeeNumberEnum;
    /**
     * 
     * @type {string}
     * @memberof OrganizationCreatePreRequestRequest
     */
    'plan': OrganizationCreatePreRequestRequestPlanEnum;
    /**
     * 
     * @type {number}
     * @memberof OrganizationCreatePreRequestRequest
     */
    'monthlyTransactionAmountInTenThousandsYen': number;
    /**
     * 
     * @type {string}
     * @memberof OrganizationCreatePreRequestRequest
     */
    'mediaCode': string | null;
    /**
     * 
     * @type {string}
     * @memberof OrganizationCreatePreRequestRequest
     */
    'campaignApplicationCode': string | null;
}

export const OrganizationCreatePreRequestRequestEmployeeNumberEnum = {
    under10: 'UNDER_10',
    overOr10Under50: 'OVER_OR_10_UNDER_50',
    overOr50Under100: 'OVER_OR_50_UNDER_100',
    overOr100Under500: 'OVER_OR_100_UNDER_500',
    overOr500: 'OVER_OR_500'
} as const;

export type OrganizationCreatePreRequestRequestEmployeeNumberEnum = typeof OrganizationCreatePreRequestRequestEmployeeNumberEnum[keyof typeof OrganizationCreatePreRequestRequestEmployeeNumberEnum];
export const OrganizationCreatePreRequestRequestPlanEnum = {
    deferredPayment: 'DEFERRED_PAYMENT',
    deposit: 'DEPOSIT'
} as const;

export type OrganizationCreatePreRequestRequestPlanEnum = typeof OrganizationCreatePreRequestRequestPlanEnum[keyof typeof OrganizationCreatePreRequestRequestPlanEnum];

/**
 * 
 * @export
 * @interface OrganizationCreateRequest
 */
export interface OrganizationCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof OrganizationCreateRequest
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationCreateRequest
     */
    'organizationName': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationCreateRequest
     */
    'corporateNumber': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationCreateRequest
     */
    'representativeName': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationCreateRequest
     */
    'phoneNumber': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationCreateRequest
     */
    'createdAt': string;
}
/**
 * 
 * @export
 * @interface OrganizationIdentityVerification
 */
export interface OrganizationIdentityVerification {
    /**
     * 
     * @type {string}
     * @memberof OrganizationIdentityVerification
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationIdentityVerification
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationIdentityVerification
     */
    'organizationCreateRequestId': string | null;
    /**
     * 
     * @type {string}
     * @memberof OrganizationIdentityVerification
     */
    'organizationName': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationIdentityVerification
     */
    'corporateNumber': string;
    /**
     * 
     * @type {number}
     * @memberof OrganizationIdentityVerification
     */
    'businessDescriptionId': number;
    /**
     * 
     * @type {number}
     * @memberof OrganizationIdentityVerification
     */
    'purposeTransaction': number;
    /**
     * 
     * @type {string}
     * @memberof OrganizationIdentityVerification
     */
    'purposeTransactionOther': string | null;
    /**
     * 
     * @type {string}
     * @memberof OrganizationIdentityVerification
     */
    'postalCode': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationIdentityVerification
     */
    'address': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationIdentityVerification
     */
    'phoneNumber': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationIdentityVerification
     */
    'representativeName': string;
    /**
     * 
     * @type {boolean}
     * @memberof OrganizationIdentityVerification
     */
    'isExistsBeneficialOwner': boolean;
    /**
     * 
     * @type {string}
     * @memberof OrganizationIdentityVerification
     */
    'corporateType': string | null;
    /**
     * 
     * @type {Array<OrganizationIdentityVerificationBeneficialOwnersInner>}
     * @memberof OrganizationIdentityVerification
     */
    'beneficialOwners': Array<OrganizationIdentityVerificationBeneficialOwnersInner>;
    /**
     * 
     * @type {boolean}
     * @memberof OrganizationIdentityVerification
     */
    'isRepresentative': boolean;
    /**
     * 
     * @type {string}
     * @memberof OrganizationIdentityVerification
     */
    'transactionManagerName': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationIdentityVerification
     */
    'transactionManagerBirthday': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationIdentityVerification
     */
    'transactionManagerAddress': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationIdentityVerification
     */
    'transactionManagerEmail': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationIdentityVerification
     */
    'note': string | null;
    /**
     * 
     * @type {OrganizationIdentityVerificationStatus}
     * @memberof OrganizationIdentityVerification
     */
    'status': OrganizationIdentityVerificationStatus | null;
    /**
     * 
     * @type {Array<OrganizationIdentityVerificationIdentificationInner>}
     * @memberof OrganizationIdentityVerification
     */
    'identification': Array<OrganizationIdentityVerificationIdentificationInner>;
    /**
     * 
     * @type {Array<OrganizationIdentityVerificationAntisocialForcesCheckInner>}
     * @memberof OrganizationIdentityVerification
     */
    'antisocialForcesCheck': Array<OrganizationIdentityVerificationAntisocialForcesCheckInner>;
    /**
     * 
     * @type {Array<OrganizationIdentityVerificationSnailMailVerificationInner>}
     * @memberof OrganizationIdentityVerification
     */
    'snailMailVerification': Array<OrganizationIdentityVerificationSnailMailVerificationInner> | null;
    /**
     * 
     * @type {string}
     * @memberof OrganizationIdentityVerification
     */
    'createdAt': string;
}
/**
 * 
 * @export
 * @interface OrganizationIdentityVerificationAntisocialForcesCheckInner
 */
export interface OrganizationIdentityVerificationAntisocialForcesCheckInner {
    /**
     * 
     * @type {string}
     * @memberof OrganizationIdentityVerificationAntisocialForcesCheckInner
     */
    'organizationIdentityVerificationId': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationIdentityVerificationAntisocialForcesCheckInner
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationIdentityVerificationAntisocialForcesCheckInner
     */
    'payloadId': string;
    /**
     * 
     * @type {number}
     * @memberof OrganizationIdentityVerificationAntisocialForcesCheckInner
     */
    'payloadDetailId': number;
    /**
     * 
     * @type {string}
     * @memberof OrganizationIdentityVerificationAntisocialForcesCheckInner
     */
    'category': string;
    /**
     * 
     * @type {object}
     * @memberof OrganizationIdentityVerificationAntisocialForcesCheckInner
     */
    'condition'?: object;
    /**
     * 
     * @type {Array<object>}
     * @memberof OrganizationIdentityVerificationAntisocialForcesCheckInner
     */
    'results'?: Array<object> | null;
}
/**
 * 
 * @export
 * @interface OrganizationIdentityVerificationBeneficialOwnersInner
 */
export interface OrganizationIdentityVerificationBeneficialOwnersInner {
    /**
     * 
     * @type {string}
     * @memberof OrganizationIdentityVerificationBeneficialOwnersInner
     */
    'corporateRelationships'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrganizationIdentityVerificationBeneficialOwnersInner
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationIdentityVerificationBeneficialOwnersInner
     */
    'beneficialOwnerType': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationIdentityVerificationBeneficialOwnersInner
     */
    'gender': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationIdentityVerificationBeneficialOwnersInner
     */
    'birthday': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationIdentityVerificationBeneficialOwnersInner
     */
    'countryResidence': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationIdentityVerificationBeneficialOwnersInner
     */
    'address': string;
    /**
     * 
     * @type {boolean}
     * @memberof OrganizationIdentityVerificationBeneficialOwnersInner
     */
    'isPoliticallyExposedPersons': boolean;
}
/**
 * 
 * @export
 * @interface OrganizationIdentityVerificationIdentificationInner
 */
export interface OrganizationIdentityVerificationIdentificationInner {
    /**
     * 
     * @type {string}
     * @memberof OrganizationIdentityVerificationIdentificationInner
     */
    'trustdockIdentificationId': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationIdentityVerificationIdentificationInner
     */
    'state': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationIdentityVerificationIdentificationInner
     */
    'result': string | null;
    /**
     * 
     * @type {Array<OrganizationIdentityVerificationIdentificationInnerRecordsInner>}
     * @memberof OrganizationIdentityVerificationIdentificationInner
     */
    'records'?: Array<OrganizationIdentityVerificationIdentificationInnerRecordsInner> | null;
}
/**
 * 
 * @export
 * @interface OrganizationIdentityVerificationIdentificationInnerRecordsInner
 */
export interface OrganizationIdentityVerificationIdentificationInnerRecordsInner {
    /**
     * 
     * @type {string}
     * @memberof OrganizationIdentityVerificationIdentificationInnerRecordsInner
     */
    'state': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationIdentityVerificationIdentificationInnerRecordsInner
     */
    'result': string | null;
    /**
     * 
     * @type {string}
     * @memberof OrganizationIdentityVerificationIdentificationInnerRecordsInner
     */
    'planId'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationIdentityVerificationIdentificationInnerRecordsInner
     */
    'plan'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof OrganizationIdentityVerificationIdentificationInnerRecordsInner
     */
    'reasons'?: Array<string>;
}
/**
 * 
 * @export
 * @interface OrganizationIdentityVerificationSnailMailVerificationInner
 */
export interface OrganizationIdentityVerificationSnailMailVerificationInner {
    /**
     * 
     * @type {string}
     * @memberof OrganizationIdentityVerificationSnailMailVerificationInner
     */
    'organizationIdentityVerificationId': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationIdentityVerificationSnailMailVerificationInner
     */
    'snailMailVerificationId': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationIdentityVerificationSnailMailVerificationInner
     */
    'result': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationIdentityVerificationSnailMailVerificationInner
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationIdentityVerificationSnailMailVerificationInner
     */
    'detail': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationIdentityVerificationSnailMailVerificationInner
     */
    'inquiryNumber': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationIdentityVerificationSnailMailVerificationInner
     */
    'acceptAt': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationIdentityVerificationSnailMailVerificationInner
     */
    'confirmedAt': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationIdentityVerificationSnailMailVerificationInner
     */
    'confirmedBy': string | null;
}
/**
 * 
 * @export
 * @interface OrganizationIdentityVerificationStatus
 */
export interface OrganizationIdentityVerificationStatus {
    /**
     * 
     * @type {string}
     * @memberof OrganizationIdentityVerificationStatus
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationIdentityVerificationStatus
     */
    'statusChangedUserId'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationIdentityVerificationStatus
     */
    'statusChangedUserName': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationIdentityVerificationStatus
     */
    'statusChangedAt': string;
}
/**
 * 
 * @export
 * @interface ParseOrganizationChartForWorkflow200Response
 */
export interface ParseOrganizationChartForWorkflow200Response {
    /**
     * 
     * @type {Array<ParseOrganizationChartForWorkflow200ResponseEmployeesInner>}
     * @memberof ParseOrganizationChartForWorkflow200Response
     */
    'employees': Array<ParseOrganizationChartForWorkflow200ResponseEmployeesInner>;
    /**
     * 
     * @type {Array<ParseOrganizationChartForWorkflow200ResponseDepartmentsInner>}
     * @memberof ParseOrganizationChartForWorkflow200Response
     */
    'departments': Array<ParseOrganizationChartForWorkflow200ResponseDepartmentsInner>;
    /**
     * 
     * @type {Array<ParseOrganizationChartForWorkflow200ResponseRolesInner>}
     * @memberof ParseOrganizationChartForWorkflow200Response
     */
    'roles': Array<ParseOrganizationChartForWorkflow200ResponseRolesInner>;
}
/**
 * 
 * @export
 * @interface ParseOrganizationChartForWorkflow200ResponseDepartmentsInner
 */
export interface ParseOrganizationChartForWorkflow200ResponseDepartmentsInner {
    /**
     * 
     * @type {string}
     * @memberof ParseOrganizationChartForWorkflow200ResponseDepartmentsInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ParseOrganizationChartForWorkflow200ResponseDepartmentsInner
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface ParseOrganizationChartForWorkflow200ResponseEmployeesInner
 */
export interface ParseOrganizationChartForWorkflow200ResponseEmployeesInner {
    /**
     * 
     * @type {string}
     * @memberof ParseOrganizationChartForWorkflow200ResponseEmployeesInner
     */
    'name': string | null;
    /**
     * 
     * @type {string}
     * @memberof ParseOrganizationChartForWorkflow200ResponseEmployeesInner
     */
    'email': string | null;
    /**
     * Indicates the role to which the employee has, the employee may have more than one role, and contains the corresponding IDs of the roles.
     * @type {Array<string>}
     * @memberof ParseOrganizationChartForWorkflow200ResponseEmployeesInner
     */
    'roleIds': Array<string>;
    /**
     * Indicates the department to which the employee belongs, the employee may belong to more than one department, and contains the corresponding IDs of the department.
     * @type {Array<string>}
     * @memberof ParseOrganizationChartForWorkflow200ResponseEmployeesInner
     */
    'departmentIds': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ParseOrganizationChartForWorkflow200ResponseEmployeesInner
     */
    'userId': string | null;
    /**
     * 
     * @type {string}
     * @memberof ParseOrganizationChartForWorkflow200ResponseEmployeesInner
     */
    'slackUserId': string | null;
}
/**
 * 
 * @export
 * @interface ParseOrganizationChartForWorkflow200ResponseRolesInner
 */
export interface ParseOrganizationChartForWorkflow200ResponseRolesInner {
    /**
     * 
     * @type {string}
     * @memberof ParseOrganizationChartForWorkflow200ResponseRolesInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ParseOrganizationChartForWorkflow200ResponseRolesInner
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface ParseOrganizationChartForWorkflowRequest
 */
export interface ParseOrganizationChartForWorkflowRequest {
    /**
     * 
     * @type {File}
     * @memberof ParseOrganizationChartForWorkflowRequest
     */
    'file': File;
}
/**
 * 
 * @export
 * @interface PostAdditionMerchantGeneralBlockList200Response
 */
export interface PostAdditionMerchantGeneralBlockList200Response {
    /**
     * 
     * @type {string}
     * @memberof PostAdditionMerchantGeneralBlockList200Response
     */
    'id': string;
}
/**
 * 
 * @export
 * @interface PostAdditionMerchantGeneralBlockListRequest
 */
export interface PostAdditionMerchantGeneralBlockListRequest {
    /**
     * 
     * @type {string}
     * @memberof PostAdditionMerchantGeneralBlockListRequest
     */
    'merchantName': string;
    /**
     * 
     * @type {string}
     * @memberof PostAdditionMerchantGeneralBlockListRequest
     */
    'merchantId': string;
    /**
     * 
     * @type {string}
     * @memberof PostAdditionMerchantGeneralBlockListRequest
     */
    'acquirerId': string;
    /**
     * 
     * @type {string}
     * @memberof PostAdditionMerchantGeneralBlockListRequest
     */
    'patternType': PostAdditionMerchantGeneralBlockListRequestPatternTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof PostAdditionMerchantGeneralBlockListRequest
     */
    'storeType': PostAdditionMerchantGeneralBlockListRequestStoreTypeEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof PostAdditionMerchantGeneralBlockListRequest
     */
    'allowedOrganizationIds': Array<string>;
}

export const PostAdditionMerchantGeneralBlockListRequestPatternTypeEnum = {
    exact: 'EXACT',
    prefix: 'PREFIX',
    suffix: 'SUFFIX',
    regexp: 'REGEXP',
    unknown: 'UNKNOWN'
} as const;

export type PostAdditionMerchantGeneralBlockListRequestPatternTypeEnum = typeof PostAdditionMerchantGeneralBlockListRequestPatternTypeEnum[keyof typeof PostAdditionMerchantGeneralBlockListRequestPatternTypeEnum];
export const PostAdditionMerchantGeneralBlockListRequestStoreTypeEnum = {
    all: 'ALL',
    physicalStore: 'PHYSICAL_STORE',
    ecStore: 'EC_STORE',
    unknown: 'UNKNOWN'
} as const;

export type PostAdditionMerchantGeneralBlockListRequestStoreTypeEnum = typeof PostAdditionMerchantGeneralBlockListRequestStoreTypeEnum[keyof typeof PostAdditionMerchantGeneralBlockListRequestStoreTypeEnum];

/**
 * 
 * @export
 * @interface PostAlliancesGcpApplications200Response
 */
export interface PostAlliancesGcpApplications200Response {
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGcpApplications200Response
     */
    'id': string;
    /**
     * 
     * @type {PostAlliancesGcpApplications200ResponseAlliance}
     * @memberof PostAlliancesGcpApplications200Response
     */
    'alliance': PostAlliancesGcpApplications200ResponseAlliance;
    /**
     * 
     * @type {PostAlliancesGcpApplications200ResponseApplicant}
     * @memberof PostAlliancesGcpApplications200Response
     */
    'applicant': PostAlliancesGcpApplications200ResponseApplicant;
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGcpApplications200Response
     */
    'appliedAt': string;
    /**
     * 
     * @type {PostAlliancesGcpApplications200ResponseBillingAdminOrganization}
     * @memberof PostAlliancesGcpApplications200Response
     */
    'billingAdminOrganization': PostAlliancesGcpApplications200ResponseBillingAdminOrganization;
    /**
     * 
     * @type {PostAlliancesGcpApplications200ResponseBillingAdminPerson}
     * @memberof PostAlliancesGcpApplications200Response
     */
    'billingAdminPerson': PostAlliancesGcpApplications200ResponseBillingAdminPerson;
    /**
     * 
     * @type {PostAlliancesGcpApplications200ResponseBillingUserAccount}
     * @memberof PostAlliancesGcpApplications200Response
     */
    'billingUserAccount': PostAlliancesGcpApplications200ResponseBillingUserAccount;
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGcpApplications200Response
     */
    'adminName': string;
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGcpApplications200Response
     */
    'adminTel': string;
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGcpApplications200Response
     */
    'adminEmail': string;
    /**
     * 
     * @type {number}
     * @memberof PostAlliancesGcpApplications200Response
     */
    'expectedMonthlyUsage': number;
    /**
     * 
     * @type {number}
     * @memberof PostAlliancesGcpApplications200Response
     */
    'expectedMaxMonthlyUsage'?: number | null;
}
/**
 * 
 * @export
 * @interface PostAlliancesGcpApplications200ResponseAlliance
 */
export interface PostAlliancesGcpApplications200ResponseAlliance {
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGcpApplications200ResponseAlliance
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGcpApplications200ResponseAlliance
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGcpApplications200ResponseAlliance
     */
    'partnerName': string;
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGcpApplications200ResponseAlliance
     */
    'serviceName': string;
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGcpApplications200ResponseAlliance
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGcpApplications200ResponseAlliance
     */
    'startAt': string;
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGcpApplications200ResponseAlliance
     */
    'endAt': string;
}
/**
 * 
 * @export
 * @interface PostAlliancesGcpApplications200ResponseApplicant
 */
export interface PostAlliancesGcpApplications200ResponseApplicant {
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGcpApplications200ResponseApplicant
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGcpApplications200ResponseApplicant
     */
    'organizationName': string;
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGcpApplications200ResponseApplicant
     */
    'organizationAddress': string;
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGcpApplications200ResponseApplicant
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGcpApplications200ResponseApplicant
     */
    'userName': string;
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGcpApplications200ResponseApplicant
     */
    'userEmail': string;
}
/**
 * 
 * @export
 * @interface PostAlliancesGcpApplications200ResponseBillingAdminOrganization
 */
export interface PostAlliancesGcpApplications200ResponseBillingAdminOrganization {
    /**
     * 
     * @type {boolean}
     * @memberof PostAlliancesGcpApplications200ResponseBillingAdminOrganization
     */
    'sameAsApplicant': boolean;
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGcpApplications200ResponseBillingAdminOrganization
     */
    'name': string | null;
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGcpApplications200ResponseBillingAdminOrganization
     */
    'address': string | null;
}
/**
 * 
 * @export
 * @interface PostAlliancesGcpApplications200ResponseBillingAdminPerson
 */
export interface PostAlliancesGcpApplications200ResponseBillingAdminPerson {
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGcpApplications200ResponseBillingAdminPerson
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGcpApplications200ResponseBillingAdminPerson
     */
    'tel': string;
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGcpApplications200ResponseBillingAdminPerson
     */
    'email': string;
}
/**
 * 
 * @export
 * @interface PostAlliancesGcpApplications200ResponseBillingUserAccount
 */
export interface PostAlliancesGcpApplications200ResponseBillingUserAccount {
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGcpApplications200ResponseBillingUserAccount
     */
    'userAccountId': string;
    /**
     * 
     * @type {PostAlliancesGcpApplications200ResponseBillingUserAccountUser}
     * @memberof PostAlliancesGcpApplications200ResponseBillingUserAccount
     */
    'user': PostAlliancesGcpApplications200ResponseBillingUserAccountUser;
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGcpApplications200ResponseBillingUserAccount
     */
    'cardLabel': string;
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGcpApplications200ResponseBillingUserAccount
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGcpApplications200ResponseBillingUserAccount
     */
    'organizationName': string;
    /**
     * 
     * @type {PostAlliancesGcpApplications200ResponseBillingUserAccountUserAccountGroup}
     * @memberof PostAlliancesGcpApplications200ResponseBillingUserAccount
     */
    'userAccountGroup': PostAlliancesGcpApplications200ResponseBillingUserAccountUserAccountGroup | null;
    /**
     * 
     * @type {boolean}
     * @memberof PostAlliancesGcpApplications200ResponseBillingUserAccount
     */
    'isOnDemand': boolean;
}
/**
 * 
 * @export
 * @interface PostAlliancesGcpApplications200ResponseBillingUserAccountUser
 */
export interface PostAlliancesGcpApplications200ResponseBillingUserAccountUser {
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGcpApplications200ResponseBillingUserAccountUser
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGcpApplications200ResponseBillingUserAccountUser
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGcpApplications200ResponseBillingUserAccountUser
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGcpApplications200ResponseBillingUserAccountUser
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGcpApplications200ResponseBillingUserAccountUser
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PostAlliancesGcpApplications200ResponseBillingUserAccountUser
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PostAlliancesGcpApplications200ResponseBillingUserAccountUser
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PostAlliancesGcpApplications200ResponseBillingUserAccountUser
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PostAlliancesGcpApplications200ResponseBillingUserAccountUser
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PostAlliancesGcpApplications200ResponseBillingUserAccountUser
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGcpApplications200ResponseBillingUserAccountUser
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface PostAlliancesGcpApplications200ResponseBillingUserAccountUserAccountGroup
 */
export interface PostAlliancesGcpApplications200ResponseBillingUserAccountUserAccountGroup {
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGcpApplications200ResponseBillingUserAccountUserAccountGroup
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGcpApplications200ResponseBillingUserAccountUserAccountGroup
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof PostAlliancesGcpApplications200ResponseBillingUserAccountUserAccountGroup
     */
    'sortNum': number;
}
/**
 * 
 * @export
 * @interface PostAlliancesGcpApplicationsRequest
 */
export interface PostAlliancesGcpApplicationsRequest {
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGcpApplicationsRequest
     */
    'adminName': string;
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGcpApplicationsRequest
     */
    'adminTel': string;
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGcpApplicationsRequest
     */
    'adminEmail': string;
    /**
     * 
     * @type {number}
     * @memberof PostAlliancesGcpApplicationsRequest
     */
    'expectedMonthlyUsage': number;
    /**
     * 
     * @type {number}
     * @memberof PostAlliancesGcpApplicationsRequest
     */
    'expectedMaxMonthlyUsage': number | null;
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGcpApplicationsRequest
     */
    'billingUserAccountId': string;
    /**
     * 
     * @type {PostAlliancesGcpApplicationsRequestBillingAdminPerson}
     * @memberof PostAlliancesGcpApplicationsRequest
     */
    'billingAdminPerson': PostAlliancesGcpApplicationsRequestBillingAdminPerson;
    /**
     * 
     * @type {PostAlliancesGcpApplicationsRequestBillingAdminOrganization}
     * @memberof PostAlliancesGcpApplicationsRequest
     */
    'billingAdminOrganization': PostAlliancesGcpApplicationsRequestBillingAdminOrganization;
}
/**
 * 
 * @export
 * @interface PostAlliancesGcpApplicationsRequestBillingAdminOrganization
 */
export interface PostAlliancesGcpApplicationsRequestBillingAdminOrganization {
    /**
     * 
     * @type {boolean}
     * @memberof PostAlliancesGcpApplicationsRequestBillingAdminOrganization
     */
    'sameAsApplicant': boolean;
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGcpApplicationsRequestBillingAdminOrganization
     */
    'name': string | null;
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGcpApplicationsRequestBillingAdminOrganization
     */
    'address': string | null;
}
/**
 * 
 * @export
 * @interface PostAlliancesGcpApplicationsRequestBillingAdminPerson
 */
export interface PostAlliancesGcpApplicationsRequestBillingAdminPerson {
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGcpApplicationsRequestBillingAdminPerson
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGcpApplicationsRequestBillingAdminPerson
     */
    'tel': string;
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGcpApplicationsRequestBillingAdminPerson
     */
    'email': string;
}
/**
 * 
 * @export
 * @interface PostAlliancesGwsApplications200Response
 */
export interface PostAlliancesGwsApplications200Response {
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGwsApplications200Response
     */
    'id': string;
    /**
     * 
     * @type {PostAlliancesGwsApplications200ResponseAlliance}
     * @memberof PostAlliancesGwsApplications200Response
     */
    'alliance': PostAlliancesGwsApplications200ResponseAlliance;
    /**
     * 
     * @type {PostAlliancesGwsApplications200ResponseApplicant}
     * @memberof PostAlliancesGwsApplications200Response
     */
    'applicant': PostAlliancesGwsApplications200ResponseApplicant;
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGwsApplications200Response
     */
    'appliedAt': string;
    /**
     * 
     * @type {PostAlliancesGwsApplications200ResponseBillingAdminOrganization}
     * @memberof PostAlliancesGwsApplications200Response
     */
    'billingAdminOrganization': PostAlliancesGwsApplications200ResponseBillingAdminOrganization;
    /**
     * 
     * @type {PostAlliancesGwsApplications200ResponseBillingAdminPerson}
     * @memberof PostAlliancesGwsApplications200Response
     */
    'billingAdminPerson': PostAlliancesGwsApplications200ResponseBillingAdminPerson;
    /**
     * 
     * @type {PostAlliancesGwsApplications200ResponseBillingUserAccount}
     * @memberof PostAlliancesGwsApplications200Response
     */
    'billingUserAccount': PostAlliancesGwsApplications200ResponseBillingUserAccount;
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGwsApplications200Response
     */
    'contractType': PostAlliancesGwsApplications200ResponseContractTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGwsApplications200Response
     */
    'edition': string;
    /**
     * 
     * @type {number}
     * @memberof PostAlliancesGwsApplications200Response
     */
    'numberOfIds': number;
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGwsApplications200Response
     */
    'paymentPlan': PostAlliancesGwsApplications200ResponsePaymentPlanEnum;
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGwsApplications200Response
     */
    'contactPersonName': string;
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGwsApplications200Response
     */
    'contactTel': string;
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGwsApplications200Response
     */
    'contactEmail': string;
}

export const PostAlliancesGwsApplications200ResponseContractTypeEnum = {
    new: 'NEW',
    update: 'UPDATE'
} as const;

export type PostAlliancesGwsApplications200ResponseContractTypeEnum = typeof PostAlliancesGwsApplications200ResponseContractTypeEnum[keyof typeof PostAlliancesGwsApplications200ResponseContractTypeEnum];
export const PostAlliancesGwsApplications200ResponsePaymentPlanEnum = {
    monthly: 'MONTHLY',
    annual: 'ANNUAL'
} as const;

export type PostAlliancesGwsApplications200ResponsePaymentPlanEnum = typeof PostAlliancesGwsApplications200ResponsePaymentPlanEnum[keyof typeof PostAlliancesGwsApplications200ResponsePaymentPlanEnum];

/**
 * 
 * @export
 * @interface PostAlliancesGwsApplications200ResponseAlliance
 */
export interface PostAlliancesGwsApplications200ResponseAlliance {
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGwsApplications200ResponseAlliance
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGwsApplications200ResponseAlliance
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGwsApplications200ResponseAlliance
     */
    'partnerName': string;
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGwsApplications200ResponseAlliance
     */
    'serviceName': string;
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGwsApplications200ResponseAlliance
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGwsApplications200ResponseAlliance
     */
    'startAt': string;
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGwsApplications200ResponseAlliance
     */
    'endAt': string;
}
/**
 * 
 * @export
 * @interface PostAlliancesGwsApplications200ResponseApplicant
 */
export interface PostAlliancesGwsApplications200ResponseApplicant {
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGwsApplications200ResponseApplicant
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGwsApplications200ResponseApplicant
     */
    'organizationName': string;
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGwsApplications200ResponseApplicant
     */
    'organizationAddress': string;
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGwsApplications200ResponseApplicant
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGwsApplications200ResponseApplicant
     */
    'userName': string;
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGwsApplications200ResponseApplicant
     */
    'userEmail': string;
}
/**
 * 
 * @export
 * @interface PostAlliancesGwsApplications200ResponseBillingAdminOrganization
 */
export interface PostAlliancesGwsApplications200ResponseBillingAdminOrganization {
    /**
     * 
     * @type {boolean}
     * @memberof PostAlliancesGwsApplications200ResponseBillingAdminOrganization
     */
    'sameAsApplicant': boolean;
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGwsApplications200ResponseBillingAdminOrganization
     */
    'name': string | null;
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGwsApplications200ResponseBillingAdminOrganization
     */
    'address': string | null;
}
/**
 * 
 * @export
 * @interface PostAlliancesGwsApplications200ResponseBillingAdminPerson
 */
export interface PostAlliancesGwsApplications200ResponseBillingAdminPerson {
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGwsApplications200ResponseBillingAdminPerson
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGwsApplications200ResponseBillingAdminPerson
     */
    'tel': string;
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGwsApplications200ResponseBillingAdminPerson
     */
    'email': string;
}
/**
 * 
 * @export
 * @interface PostAlliancesGwsApplications200ResponseBillingUserAccount
 */
export interface PostAlliancesGwsApplications200ResponseBillingUserAccount {
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGwsApplications200ResponseBillingUserAccount
     */
    'userAccountId': string;
    /**
     * 
     * @type {PostAlliancesGwsApplications200ResponseBillingUserAccountUser}
     * @memberof PostAlliancesGwsApplications200ResponseBillingUserAccount
     */
    'user': PostAlliancesGwsApplications200ResponseBillingUserAccountUser;
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGwsApplications200ResponseBillingUserAccount
     */
    'cardLabel': string;
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGwsApplications200ResponseBillingUserAccount
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGwsApplications200ResponseBillingUserAccount
     */
    'organizationName': string;
    /**
     * 
     * @type {PostAlliancesGwsApplications200ResponseBillingUserAccountUserAccountGroup}
     * @memberof PostAlliancesGwsApplications200ResponseBillingUserAccount
     */
    'userAccountGroup': PostAlliancesGwsApplications200ResponseBillingUserAccountUserAccountGroup | null;
    /**
     * 
     * @type {boolean}
     * @memberof PostAlliancesGwsApplications200ResponseBillingUserAccount
     */
    'isOnDemand': boolean;
}
/**
 * 
 * @export
 * @interface PostAlliancesGwsApplications200ResponseBillingUserAccountUser
 */
export interface PostAlliancesGwsApplications200ResponseBillingUserAccountUser {
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGwsApplications200ResponseBillingUserAccountUser
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGwsApplications200ResponseBillingUserAccountUser
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGwsApplications200ResponseBillingUserAccountUser
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGwsApplications200ResponseBillingUserAccountUser
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGwsApplications200ResponseBillingUserAccountUser
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PostAlliancesGwsApplications200ResponseBillingUserAccountUser
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PostAlliancesGwsApplications200ResponseBillingUserAccountUser
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PostAlliancesGwsApplications200ResponseBillingUserAccountUser
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PostAlliancesGwsApplications200ResponseBillingUserAccountUser
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PostAlliancesGwsApplications200ResponseBillingUserAccountUser
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGwsApplications200ResponseBillingUserAccountUser
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface PostAlliancesGwsApplications200ResponseBillingUserAccountUserAccountGroup
 */
export interface PostAlliancesGwsApplications200ResponseBillingUserAccountUserAccountGroup {
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGwsApplications200ResponseBillingUserAccountUserAccountGroup
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGwsApplications200ResponseBillingUserAccountUserAccountGroup
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof PostAlliancesGwsApplications200ResponseBillingUserAccountUserAccountGroup
     */
    'sortNum': number;
}
/**
 * 
 * @export
 * @interface PostAlliancesGwsApplicationsRequest
 */
export interface PostAlliancesGwsApplicationsRequest {
    /**
     * 
     * @type {PostAlliancesGwsApplicationsRequestBillingAdminOrganization}
     * @memberof PostAlliancesGwsApplicationsRequest
     */
    'billingAdminOrganization': PostAlliancesGwsApplicationsRequestBillingAdminOrganization;
    /**
     * 
     * @type {PostAlliancesGwsApplicationsRequestBillingAdminPerson}
     * @memberof PostAlliancesGwsApplicationsRequest
     */
    'billingAdminPerson': PostAlliancesGwsApplicationsRequestBillingAdminPerson;
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGwsApplicationsRequest
     */
    'billingUserAccountId': string;
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGwsApplicationsRequest
     */
    'contractType': PostAlliancesGwsApplicationsRequestContractTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGwsApplicationsRequest
     */
    'edition': string;
    /**
     * 
     * @type {number}
     * @memberof PostAlliancesGwsApplicationsRequest
     */
    'numberOfIds': number;
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGwsApplicationsRequest
     */
    'paymentPlan': PostAlliancesGwsApplicationsRequestPaymentPlanEnum;
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGwsApplicationsRequest
     */
    'contactPersonName': string;
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGwsApplicationsRequest
     */
    'contactTel': string;
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGwsApplicationsRequest
     */
    'contactEmail': string;
}

export const PostAlliancesGwsApplicationsRequestContractTypeEnum = {
    new: 'NEW',
    update: 'UPDATE'
} as const;

export type PostAlliancesGwsApplicationsRequestContractTypeEnum = typeof PostAlliancesGwsApplicationsRequestContractTypeEnum[keyof typeof PostAlliancesGwsApplicationsRequestContractTypeEnum];
export const PostAlliancesGwsApplicationsRequestPaymentPlanEnum = {
    monthly: 'MONTHLY',
    annual: 'ANNUAL'
} as const;

export type PostAlliancesGwsApplicationsRequestPaymentPlanEnum = typeof PostAlliancesGwsApplicationsRequestPaymentPlanEnum[keyof typeof PostAlliancesGwsApplicationsRequestPaymentPlanEnum];

/**
 * 
 * @export
 * @interface PostAlliancesGwsApplicationsRequestBillingAdminOrganization
 */
export interface PostAlliancesGwsApplicationsRequestBillingAdminOrganization {
    /**
     * 
     * @type {boolean}
     * @memberof PostAlliancesGwsApplicationsRequestBillingAdminOrganization
     */
    'sameAsApplicant': boolean;
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGwsApplicationsRequestBillingAdminOrganization
     */
    'name': string | null;
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGwsApplicationsRequestBillingAdminOrganization
     */
    'address': string | null;
}
/**
 * 
 * @export
 * @interface PostAlliancesGwsApplicationsRequestBillingAdminPerson
 */
export interface PostAlliancesGwsApplicationsRequestBillingAdminPerson {
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGwsApplicationsRequestBillingAdminPerson
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGwsApplicationsRequestBillingAdminPerson
     */
    'tel': string;
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGwsApplicationsRequestBillingAdminPerson
     */
    'email': string;
}
/**
 * 
 * @export
 * @interface PostBalances200ResponseInner
 */
export interface PostBalances200ResponseInner {
    /**
     * 
     * @type {number}
     * @memberof PostBalances200ResponseInner
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof PostBalances200ResponseInner
     */
    'balanceId': number;
    /**
     * 
     * @type {string}
     * @memberof PostBalances200ResponseInner
     */
    'checkDate': string | null;
    /**
     * 
     * @type {number}
     * @memberof PostBalances200ResponseInner
     */
    'balance': number;
    /**
     * 
     * @type {number}
     * @memberof PostBalances200ResponseInner
     */
    'balanceInBase': number;
    /**
     * 
     * @type {number}
     * @memberof PostBalances200ResponseInner
     */
    'accountId': number;
}
/**
 * 
 * @export
 * @interface PostBalancesRequest
 */
export interface PostBalancesRequest {
    /**
     * 
     * @type {Array<number>}
     * @memberof PostBalancesRequest
     */
    'mtBankAccountIds': Array<number>;
}
/**
 * 
 * @export
 * @interface PostBulkAdditionMerchantOrgBlockListsRequestInner
 */
export interface PostBulkAdditionMerchantOrgBlockListsRequestInner {
    /**
     * 
     * @type {string}
     * @memberof PostBulkAdditionMerchantOrgBlockListsRequestInner
     */
    'merchantName': string;
    /**
     * 
     * @type {string}
     * @memberof PostBulkAdditionMerchantOrgBlockListsRequestInner
     */
    'merchantId': string;
    /**
     * 
     * @type {string}
     * @memberof PostBulkAdditionMerchantOrgBlockListsRequestInner
     */
    'acquirerId': string;
    /**
     * 
     * @type {string}
     * @memberof PostBulkAdditionMerchantOrgBlockListsRequestInner
     */
    'patternType': PostBulkAdditionMerchantOrgBlockListsRequestInnerPatternTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof PostBulkAdditionMerchantOrgBlockListsRequestInner
     */
    'storeType': PostBulkAdditionMerchantOrgBlockListsRequestInnerStoreTypeEnum;
}

export const PostBulkAdditionMerchantOrgBlockListsRequestInnerPatternTypeEnum = {
    exact: 'EXACT',
    prefix: 'PREFIX',
    suffix: 'SUFFIX',
    regexp: 'REGEXP',
    unknown: 'UNKNOWN'
} as const;

export type PostBulkAdditionMerchantOrgBlockListsRequestInnerPatternTypeEnum = typeof PostBulkAdditionMerchantOrgBlockListsRequestInnerPatternTypeEnum[keyof typeof PostBulkAdditionMerchantOrgBlockListsRequestInnerPatternTypeEnum];
export const PostBulkAdditionMerchantOrgBlockListsRequestInnerStoreTypeEnum = {
    all: 'ALL',
    physicalStore: 'PHYSICAL_STORE',
    ecStore: 'EC_STORE',
    unknown: 'UNKNOWN'
} as const;

export type PostBulkAdditionMerchantOrgBlockListsRequestInnerStoreTypeEnum = typeof PostBulkAdditionMerchantOrgBlockListsRequestInnerStoreTypeEnum[keyof typeof PostBulkAdditionMerchantOrgBlockListsRequestInnerStoreTypeEnum];

/**
 * 
 * @export
 * @interface PostCancelRequestForEvidenceRequest200Response
 */
export interface PostCancelRequestForEvidenceRequest200Response {
    /**
     * 
     * @type {PostCancelRequestForEvidenceRequest200ResponseEvidenceStatus}
     * @memberof PostCancelRequestForEvidenceRequest200Response
     */
    'evidenceStatus': PostCancelRequestForEvidenceRequest200ResponseEvidenceStatus | null;
    /**
     * 
     * @type {PostCancelRequestForEvidenceRequest200ResponseEvidenceRemindStatus}
     * @memberof PostCancelRequestForEvidenceRequest200Response
     */
    'evidenceRemindStatus': PostCancelRequestForEvidenceRequest200ResponseEvidenceRemindStatus | null;
    /**
     * 
     * @type {Array<PostCancelRequestForEvidenceRequest200ResponseRequestHistoryInner>}
     * @memberof PostCancelRequestForEvidenceRequest200Response
     */
    'requestHistory': Array<PostCancelRequestForEvidenceRequest200ResponseRequestHistoryInner>;
}
/**
 * 
 * @export
 * @interface PostCancelRequestForEvidenceRequest200ResponseEvidenceRemindStatus
 */
export interface PostCancelRequestForEvidenceRequest200ResponseEvidenceRemindStatus {
    /**
     * 
     * @type {boolean}
     * @memberof PostCancelRequestForEvidenceRequest200ResponseEvidenceRemindStatus
     */
    'isAutoRemind': boolean;
}
/**
 * 
 * @export
 * @interface PostCancelRequestForEvidenceRequest200ResponseEvidenceStatus
 */
export interface PostCancelRequestForEvidenceRequest200ResponseEvidenceStatus {
    /**
     * 
     * @type {string}
     * @memberof PostCancelRequestForEvidenceRequest200ResponseEvidenceStatus
     */
    'visaTransactionReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof PostCancelRequestForEvidenceRequest200ResponseEvidenceStatus
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {boolean}
     * @memberof PostCancelRequestForEvidenceRequest200ResponseEvidenceStatus
     */
    'isRequested': boolean;
    /**
     * 
     * @type {PostCancelRequestForEvidenceRequest200ResponseEvidenceStatusRequestedBy}
     * @memberof PostCancelRequestForEvidenceRequest200ResponseEvidenceStatus
     */
    'requestedBy': PostCancelRequestForEvidenceRequest200ResponseEvidenceStatusRequestedBy | null;
    /**
     * 
     * @type {string}
     * @memberof PostCancelRequestForEvidenceRequest200ResponseEvidenceStatus
     */
    'requestedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof PostCancelRequestForEvidenceRequest200ResponseEvidenceStatus
     */
    'isLocked': boolean;
    /**
     * 
     * @type {PostCancelRequestForEvidenceRequest200ResponseEvidenceStatusLockedBy}
     * @memberof PostCancelRequestForEvidenceRequest200ResponseEvidenceStatus
     */
    'lockedBy': PostCancelRequestForEvidenceRequest200ResponseEvidenceStatusLockedBy | null;
    /**
     * 
     * @type {string}
     * @memberof PostCancelRequestForEvidenceRequest200ResponseEvidenceStatus
     */
    'lockedAt': string;
}
/**
 * 
 * @export
 * @interface PostCancelRequestForEvidenceRequest200ResponseEvidenceStatusLockedBy
 */
export interface PostCancelRequestForEvidenceRequest200ResponseEvidenceStatusLockedBy {
    /**
     * 
     * @type {string}
     * @memberof PostCancelRequestForEvidenceRequest200ResponseEvidenceStatusLockedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PostCancelRequestForEvidenceRequest200ResponseEvidenceStatusLockedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface PostCancelRequestForEvidenceRequest200ResponseEvidenceStatusRequestedBy
 */
export interface PostCancelRequestForEvidenceRequest200ResponseEvidenceStatusRequestedBy {
    /**
     * 
     * @type {string}
     * @memberof PostCancelRequestForEvidenceRequest200ResponseEvidenceStatusRequestedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PostCancelRequestForEvidenceRequest200ResponseEvidenceStatusRequestedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface PostCancelRequestForEvidenceRequest200ResponseRequestHistoryInner
 */
export interface PostCancelRequestForEvidenceRequest200ResponseRequestHistoryInner {
    /**
     * 
     * @type {number}
     * @memberof PostCancelRequestForEvidenceRequest200ResponseRequestHistoryInner
     */
    'requestId': number;
    /**
     * 
     * @type {PostCancelRequestForEvidenceRequest200ResponseRequestHistoryInnerRequestedBy}
     * @memberof PostCancelRequestForEvidenceRequest200ResponseRequestHistoryInner
     */
    'requestedBy': PostCancelRequestForEvidenceRequest200ResponseRequestHistoryInnerRequestedBy;
    /**
     * 
     * @type {string}
     * @memberof PostCancelRequestForEvidenceRequest200ResponseRequestHistoryInner
     */
    'requestedAt': string;
}
/**
 * 
 * @export
 * @interface PostCancelRequestForEvidenceRequest200ResponseRequestHistoryInnerRequestedBy
 */
export interface PostCancelRequestForEvidenceRequest200ResponseRequestHistoryInnerRequestedBy {
    /**
     * 
     * @type {string}
     * @memberof PostCancelRequestForEvidenceRequest200ResponseRequestHistoryInnerRequestedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PostCancelRequestForEvidenceRequest200ResponseRequestHistoryInnerRequestedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface PostCardsVirtualIssue200Response
 */
export interface PostCardsVirtualIssue200Response {
    /**
     * 
     * @type {boolean}
     * @memberof PostCardsVirtualIssue200Response
     */
    'valid': boolean;
    /**
     * 
     * @type {string}
     * @memberof PostCardsVirtualIssue200Response
     */
    'cardId': string | null;
    /**
     * 
     * @type {string}
     * @memberof PostCardsVirtualIssue200Response
     */
    'userAccountId': string | null;
}
/**
 * 
 * @export
 * @interface PostCardsVirtualIssueRequest
 */
export interface PostCardsVirtualIssueRequest {
    /**
     * 
     * @type {number}
     * @memberof PostCardsVirtualIssueRequest
     */
    'userId': number;
    /**
     * 
     * @type {string}
     * @memberof PostCardsVirtualIssueRequest
     */
    'cardLabel': string | null;
    /**
     * 
     * @type {number}
     * @memberof PostCardsVirtualIssueRequest
     */
    'userAccountGroupId': number | null;
}
/**
 * 
 * @export
 * @interface PostCardsVirtualOndemandIssue200Response
 */
export interface PostCardsVirtualOndemandIssue200Response {
    /**
     * 
     * @type {boolean}
     * @memberof PostCardsVirtualOndemandIssue200Response
     */
    'valid': boolean;
    /**
     * 
     * @type {string}
     * @memberof PostCardsVirtualOndemandIssue200Response
     */
    'cardId': string | null;
    /**
     * 
     * @type {string}
     * @memberof PostCardsVirtualOndemandIssue200Response
     */
    'userAccountId': string | null;
}
/**
 * 
 * @export
 * @interface PostFaceToFaceKycIdentityDocumentRequest
 */
export interface PostFaceToFaceKycIdentityDocumentRequest {
    /**
     * Identity document file
     * @type {File}
     * @memberof PostFaceToFaceKycIdentityDocumentRequest
     */
    'file': File;
    /**
     * Type of personal identification document
     * @type {string}
     * @memberof PostFaceToFaceKycIdentityDocumentRequest
     */
    'personalDocumentType'?: PostFaceToFaceKycIdentityDocumentRequestPersonalDocumentTypeEnum;
    /**
     * Name of the person who verified the document
     * @type {string}
     * @memberof PostFaceToFaceKycIdentityDocumentRequest
     */
    'verifiedBy'?: string;
}

export const PostFaceToFaceKycIdentityDocumentRequestPersonalDocumentTypeEnum = {
    passport: 'PASSPORT',
    individualNumberCard: 'INDIVIDUAL_NUMBER_CARD',
    driversLicenseFront: 'DRIVERS_LICENSE_FRONT',
    driversLicenseBack: 'DRIVERS_LICENSE_BACK'
} as const;

export type PostFaceToFaceKycIdentityDocumentRequestPersonalDocumentTypeEnum = typeof PostFaceToFaceKycIdentityDocumentRequestPersonalDocumentTypeEnum[keyof typeof PostFaceToFaceKycIdentityDocumentRequestPersonalDocumentTypeEnum];

/**
 * 
 * @export
 * @interface PostFaceToFaceKycRequest200Response
 */
export interface PostFaceToFaceKycRequest200Response {
    /**
     * Request ID
     * @type {string}
     * @memberof PostFaceToFaceKycRequest200Response
     */
    'id': string;
}
/**
 * 
 * @export
 * @interface PostFaceToFaceKycRequestRequest
 */
export interface PostFaceToFaceKycRequestRequest {
    /**
     * 実質的支配者
     * @type {Array<PostFaceToFaceKycRequestRequestBeneficialOwnersInner>}
     * @memberof PostFaceToFaceKycRequestRequest
     */
    'beneficialOwners'?: Array<PostFaceToFaceKycRequestRequestBeneficialOwnersInner>;
    /**
     * 本社所在地：住所
     * @type {string}
     * @memberof PostFaceToFaceKycRequestRequest
     */
    'corporateAddress': string;
    /**
     * 法人番号
     * @type {string}
     * @memberof PostFaceToFaceKycRequestRequest
     */
    'corporateNumber': string;
    /**
     * 本社所在地：郵便番号
     * @type {string}
     * @memberof PostFaceToFaceKycRequestRequest
     */
    'corporatePostalCode': string;
    /**
     * 法人種別(enum)
     * @type {string}
     * @memberof PostFaceToFaceKycRequestRequest
     */
    'corporateType': PostFaceToFaceKycRequestRequestCorporateTypeEnum;
    /**
     * メールアドレス
     * @type {string}
     * @memberof PostFaceToFaceKycRequestRequest
     */
    'email': string;
    /**
     * 法人名
     * @type {string}
     * @memberof PostFaceToFaceKycRequestRequest
     */
    'organizationName': string;
    /**
     * 代表者住所
     * @type {string}
     * @memberof PostFaceToFaceKycRequestRequest
     */
    'representativeAddress': string;
    /**
     * 代表者生年月日(YYYYMMDD)
     * @type {string}
     * @memberof PostFaceToFaceKycRequestRequest
     */
    'representativeBirthday': string;
    /**
     * 代表者氏名
     * @type {string}
     * @memberof PostFaceToFaceKycRequestRequest
     */
    'representativeName': string;
    /**
     * 代表者電話番号
     * @type {string}
     * @memberof PostFaceToFaceKycRequestRequest
     */
    'representativePhoneNumber': string;
}

export const PostFaceToFaceKycRequestRequestCorporateTypeEnum = {
    exceptMajorityCapitalVoteCorporate: 'EXCEPT_MAJORITY_CAPITAL_VOTE_CORPORATE',
    majorityCapitalVoteCorporate: 'MAJORITY_CAPITAL_VOTE_CORPORATE'
} as const;

export type PostFaceToFaceKycRequestRequestCorporateTypeEnum = typeof PostFaceToFaceKycRequestRequestCorporateTypeEnum[keyof typeof PostFaceToFaceKycRequestRequestCorporateTypeEnum];

/**
 * 
 * @export
 * @interface PostFaceToFaceKycRequestRequestBeneficialOwnersInner
 */
export interface PostFaceToFaceKycRequestRequestBeneficialOwnersInner {
    /**
     * 住所
     * @type {string}
     * @memberof PostFaceToFaceKycRequestRequestBeneficialOwnersInner
     */
    'address': string;
    /**
     * 実質的支配者タイプ
     * @type {string}
     * @memberof PostFaceToFaceKycRequestRequestBeneficialOwnersInner
     */
    'beneficialOwnerType': PostFaceToFaceKycRequestRequestBeneficialOwnersInnerBeneficialOwnerTypeEnum;
    /**
     * 生年月日
     * @type {string}
     * @memberof PostFaceToFaceKycRequestRequestBeneficialOwnersInner
     */
    'birthday'?: string;
    /**
     * 法人との関係性
     * @type {string}
     * @memberof PostFaceToFaceKycRequestRequestBeneficialOwnersInner
     */
    'corporateRelationships'?: PostFaceToFaceKycRequestRequestBeneficialOwnersInnerCorporateRelationshipsEnum;
    /**
     * 居住国
     * @type {string}
     * @memberof PostFaceToFaceKycRequestRequestBeneficialOwnersInner
     */
    'countryResidence'?: string;
    /**
     * 性別
     * @type {string}
     * @memberof PostFaceToFaceKycRequestRequestBeneficialOwnersInner
     */
    'gender'?: PostFaceToFaceKycRequestRequestBeneficialOwnersInnerGenderEnum;
    /**
     * 外国人PEPsに該当するか
     * @type {boolean}
     * @memberof PostFaceToFaceKycRequestRequestBeneficialOwnersInner
     */
    'isPoliticallyExposedPersons': boolean;
    /**
     * 氏名・法人名
     * @type {string}
     * @memberof PostFaceToFaceKycRequestRequestBeneficialOwnersInner
     */
    'name': string;
}

export const PostFaceToFaceKycRequestRequestBeneficialOwnersInnerBeneficialOwnerTypeEnum = {
    corporation: 'CORPORATION',
    person: 'PERSON'
} as const;

export type PostFaceToFaceKycRequestRequestBeneficialOwnersInnerBeneficialOwnerTypeEnum = typeof PostFaceToFaceKycRequestRequestBeneficialOwnersInnerBeneficialOwnerTypeEnum[keyof typeof PostFaceToFaceKycRequestRequestBeneficialOwnersInnerBeneficialOwnerTypeEnum];
export const PostFaceToFaceKycRequestRequestBeneficialOwnersInnerCorporateRelationshipsEnum = {
    businessExecutor: 'BUSINESS_EXECUTOR',
    hasControllingInfluenceOverBusinessActivity: 'HAS_CONTROLLING_INFLUENCE_OVER_BUSINESS_ACTIVITY',
    hasRightOver25Per: 'HAS_RIGHT_OVER_25PER',
    hasRightOver50Per: 'HAS_RIGHT_OVER_50PER'
} as const;

export type PostFaceToFaceKycRequestRequestBeneficialOwnersInnerCorporateRelationshipsEnum = typeof PostFaceToFaceKycRequestRequestBeneficialOwnersInnerCorporateRelationshipsEnum[keyof typeof PostFaceToFaceKycRequestRequestBeneficialOwnersInnerCorporateRelationshipsEnum];
export const PostFaceToFaceKycRequestRequestBeneficialOwnersInnerGenderEnum = {
    female: 'FEMALE',
    male: 'MALE'
} as const;

export type PostFaceToFaceKycRequestRequestBeneficialOwnersInnerGenderEnum = typeof PostFaceToFaceKycRequestRequestBeneficialOwnersInnerGenderEnum[keyof typeof PostFaceToFaceKycRequestRequestBeneficialOwnersInnerGenderEnum];

/**
 * 
 * @export
 * @interface PostFreeeAccountForPointsRequest
 */
export interface PostFreeeAccountForPointsRequest {
    /**
     * 
     * @type {number}
     * @memberof PostFreeeAccountForPointsRequest
     */
    'companyId': number;
    /**
     * 
     * @type {number}
     * @memberof PostFreeeAccountForPointsRequest
     */
    'accountItemId': number;
}
/**
 * 
 * @export
 * @interface PostOrganizationsDealsRequest
 */
export interface PostOrganizationsDealsRequest {
    /**
     * 
     * @type {string}
     * @memberof PostOrganizationsDealsRequest
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof PostOrganizationsDealsRequest
     */
    'orgAccountId': string;
}
/**
 * 
 * @export
 * @interface PostPaymentRequestsBankAccount200Response
 */
export interface PostPaymentRequestsBankAccount200Response {
    /**
     * 
     * @type {string}
     * @memberof PostPaymentRequestsBankAccount200Response
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PostPaymentRequestsBankAccount200Response
     */
    'recordId': string;
}
/**
 * 
 * @export
 * @interface PostPaymentRequestsBankAccountRequest
 */
export interface PostPaymentRequestsBankAccountRequest {
    /**
     * 
     * @type {string}
     * @memberof PostPaymentRequestsBankAccountRequest
     */
    'bankNumber': string;
    /**
     * 
     * @type {string}
     * @memberof PostPaymentRequestsBankAccountRequest
     */
    'bankName': string;
    /**
     * 
     * @type {string}
     * @memberof PostPaymentRequestsBankAccountRequest
     */
    'branchNumber': string;
    /**
     * 
     * @type {string}
     * @memberof PostPaymentRequestsBankAccountRequest
     */
    'branchName': string;
    /**
     * 
     * @type {string}
     * @memberof PostPaymentRequestsBankAccountRequest
     */
    'accountType': PostPaymentRequestsBankAccountRequestAccountTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof PostPaymentRequestsBankAccountRequest
     */
    'accountNumber': string;
    /**
     * 
     * @type {string}
     * @memberof PostPaymentRequestsBankAccountRequest
     */
    'companyCode': string | null;
    /**
     * 
     * @type {string}
     * @memberof PostPaymentRequestsBankAccountRequest
     */
    'companyName': string;
    /**
     * 
     * @type {PostPaymentRequestsBankAccountRequestTransferFeeCondition}
     * @memberof PostPaymentRequestsBankAccountRequest
     */
    'transferFeeCondition': PostPaymentRequestsBankAccountRequestTransferFeeCondition;
}

export const PostPaymentRequestsBankAccountRequestAccountTypeEnum = {
    savingsAccount: 'SAVINGS_ACCOUNT',
    currentAccount: 'CURRENT_ACCOUNT',
    thriftAccount: 'THRIFT_ACCOUNT',
    other: 'OTHER'
} as const;

export type PostPaymentRequestsBankAccountRequestAccountTypeEnum = typeof PostPaymentRequestsBankAccountRequestAccountTypeEnum[keyof typeof PostPaymentRequestsBankAccountRequestAccountTypeEnum];

/**
 * 
 * @export
 * @interface PostPaymentRequestsBankAccountRequestTransferFeeCondition
 */
export interface PostPaymentRequestsBankAccountRequestTransferFeeCondition {
    /**
     * 
     * @type {number}
     * @memberof PostPaymentRequestsBankAccountRequestTransferFeeCondition
     */
    'threshold': number | null;
    /**
     * 
     * @type {PostPaymentRequestsBankAccountRequestTransferFeeConditionSameBranch}
     * @memberof PostPaymentRequestsBankAccountRequestTransferFeeCondition
     */
    'sameBranch': PostPaymentRequestsBankAccountRequestTransferFeeConditionSameBranch | null;
    /**
     * 
     * @type {PostPaymentRequestsBankAccountRequestTransferFeeConditionOtherBranch}
     * @memberof PostPaymentRequestsBankAccountRequestTransferFeeCondition
     */
    'otherBranch': PostPaymentRequestsBankAccountRequestTransferFeeConditionOtherBranch | null;
    /**
     * 
     * @type {PostPaymentRequestsBankAccountRequestTransferFeeConditionOtherBank}
     * @memberof PostPaymentRequestsBankAccountRequestTransferFeeCondition
     */
    'otherBank': PostPaymentRequestsBankAccountRequestTransferFeeConditionOtherBank | null;
}
/**
 * If the corresponding transferFeeCondition.threshold is specified, null is not allowed, otherwise only null is allowed.
 * @export
 * @interface PostPaymentRequestsBankAccountRequestTransferFeeConditionOtherBank
 */
export interface PostPaymentRequestsBankAccountRequestTransferFeeConditionOtherBank {
    /**
     * 
     * @type {number}
     * @memberof PostPaymentRequestsBankAccountRequestTransferFeeConditionOtherBank
     */
    'atLeast': number;
    /**
     * 
     * @type {number}
     * @memberof PostPaymentRequestsBankAccountRequestTransferFeeConditionOtherBank
     */
    'lessThan': number;
}
/**
 * If the corresponding transferFeeCondition.threshold is specified, null is not allowed, otherwise only null is allowed.
 * @export
 * @interface PostPaymentRequestsBankAccountRequestTransferFeeConditionOtherBranch
 */
export interface PostPaymentRequestsBankAccountRequestTransferFeeConditionOtherBranch {
    /**
     * 
     * @type {number}
     * @memberof PostPaymentRequestsBankAccountRequestTransferFeeConditionOtherBranch
     */
    'atLeast': number;
    /**
     * 
     * @type {number}
     * @memberof PostPaymentRequestsBankAccountRequestTransferFeeConditionOtherBranch
     */
    'lessThan': number;
}
/**
 * If the corresponding transferFeeCondition.threshold is specified, null is not allowed, otherwise only null is allowed.
 * @export
 * @interface PostPaymentRequestsBankAccountRequestTransferFeeConditionSameBranch
 */
export interface PostPaymentRequestsBankAccountRequestTransferFeeConditionSameBranch {
    /**
     * 
     * @type {number}
     * @memberof PostPaymentRequestsBankAccountRequestTransferFeeConditionSameBranch
     */
    'atLeast': number;
    /**
     * 
     * @type {number}
     * @memberof PostPaymentRequestsBankAccountRequestTransferFeeConditionSameBranch
     */
    'lessThan': number;
}
/**
 * 
 * @export
 * @interface PostSlackMessageToCoworker200Response
 */
export interface PostSlackMessageToCoworker200Response {
    /**
     * 
     * @type {string}
     * @memberof PostSlackMessageToCoworker200Response
     */
    'text': string;
    /**
     * 
     * @type {string}
     * @memberof PostSlackMessageToCoworker200Response
     */
    'taskType': string;
    /**
     * 
     * @type {Array<PostSlackMessageToCoworker200ResponseActionsInner>}
     * @memberof PostSlackMessageToCoworker200Response
     */
    'actions': Array<PostSlackMessageToCoworker200ResponseActionsInner>;
    /**
     * 
     * @type {boolean}
     * @memberof PostSlackMessageToCoworker200Response
     */
    'isEndedTalk': boolean;
    /**
     * 
     * @type {string}
     * @memberof PostSlackMessageToCoworker200Response
     */
    'talkId': string;
}
/**
 * 
 * @export
 * @interface PostSlackMessageToCoworker200ResponseActionsInner
 */
export interface PostSlackMessageToCoworker200ResponseActionsInner {
    /**
     * 
     * @type {string}
     * @memberof PostSlackMessageToCoworker200ResponseActionsInner
     */
    'lebel': string;
    /**
     * 
     * @type {string}
     * @memberof PostSlackMessageToCoworker200ResponseActionsInner
     */
    'style': string;
    /**
     * 
     * @type {number}
     * @memberof PostSlackMessageToCoworker200ResponseActionsInner
     */
    'order': number;
}
/**
 * 
 * @export
 * @interface PostSlackMessageToCoworkerRequest
 */
export interface PostSlackMessageToCoworkerRequest {
    /**
     * 
     * @type {string}
     * @memberof PostSlackMessageToCoworkerRequest
     */
    'text': string;
    /**
     * 
     * @type {string}
     * @memberof PostSlackMessageToCoworkerRequest
     */
    'eventType': string;
    /**
     * 
     * @type {string}
     * @memberof PostSlackMessageToCoworkerRequest
     */
    'channelId': string;
    /**
     * 
     * @type {string}
     * @memberof PostSlackMessageToCoworkerRequest
     */
    'threadId': string;
    /**
     * 
     * @type {string}
     * @memberof PostSlackMessageToCoworkerRequest
     */
    'talkSpaceId': string;
    /**
     * 
     * @type {string}
     * @memberof PostSlackMessageToCoworkerRequest
     */
    'messageAddress': string;
    /**
     * 
     * @type {number}
     * @memberof PostSlackMessageToCoworkerRequest
     */
    'attachedFilesNum': number;
}
/**
 * 
 * @export
 * @interface PostTransactions200ResponseInner
 */
export interface PostTransactions200ResponseInner {
    /**
     * 
     * @type {number}
     * @memberof PostTransactions200ResponseInner
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof PostTransactions200ResponseInner
     */
    'transactionId': number;
    /**
     * 
     * @type {string}
     * @memberof PostTransactions200ResponseInner
     */
    'transactionType': string | null;
    /**
     * 
     * @type {number}
     * @memberof PostTransactions200ResponseInner
     */
    'amount': number;
    /**
     * 
     * @type {string}
     * @memberof PostTransactions200ResponseInner
     */
    'date': string;
    /**
     * 
     * @type {string}
     * @memberof PostTransactions200ResponseInner
     */
    'descriptionGuest': string | null;
    /**
     * 
     * @type {string}
     * @memberof PostTransactions200ResponseInner
     */
    'descriptionPretty': string | null;
    /**
     * 
     * @type {string}
     * @memberof PostTransactions200ResponseInner
     */
    'descriptionRaw': string | null;
    /**
     * 
     * @type {number}
     * @memberof PostTransactions200ResponseInner
     */
    'accountId': number;
    /**
     * 
     * @type {number}
     * @memberof PostTransactions200ResponseInner
     */
    'categoryId': number | null;
    /**
     * 
     * @type {number}
     * @memberof PostTransactions200ResponseInner
     */
    'balance': number | null;
    /**
     * 
     * @type {number}
     * @memberof PostTransactions200ResponseInner
     */
    'balanceType'?: number;
    /**
     * 
     * @type {string}
     * @memberof PostTransactions200ResponseInner
     */
    'mtCreatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof PostTransactions200ResponseInner
     */
    'mtUpdatedAt': string;
}
/**
 * 
 * @export
 * @interface PostTransactionsRequest
 */
export interface PostTransactionsRequest {
    /**
     * 
     * @type {Array<number>}
     * @memberof PostTransactionsRequest
     */
    'mtBankAccountIds': Array<number>;
}
/**
 * 
 * @export
 * @interface PostTrustdockWebhooksRequest
 */
export interface PostTrustdockWebhooksRequest {
    /**
     * 
     * @type {PostTrustdockWebhooksRequestForm}
     * @memberof PostTrustdockWebhooksRequest
     */
    'form': PostTrustdockWebhooksRequestForm;
}
/**
 * 
 * @export
 * @interface PostTrustdockWebhooksRequestForm
 */
export interface PostTrustdockWebhooksRequestForm {
    /**
     * 
     * @type {string}
     * @memberof PostTrustdockWebhooksRequestForm
     */
    'type': string;
    /**
     * 
     * @type {PostTrustdockWebhooksRequestFormData}
     * @memberof PostTrustdockWebhooksRequestForm
     */
    'data': PostTrustdockWebhooksRequestFormData;
}
/**
 * 
 * @export
 * @interface PostTrustdockWebhooksRequestFormData
 */
export interface PostTrustdockWebhooksRequestFormData {
    /**
     * 
     * @type {string}
     * @memberof PostTrustdockWebhooksRequestFormData
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PostTrustdockWebhooksRequestFormData
     */
    'publicId': string;
    /**
     * 
     * @type {string}
     * @memberof PostTrustdockWebhooksRequestFormData
     */
    'idForHelper': string;
    /**
     * 
     * @type {string}
     * @memberof PostTrustdockWebhooksRequestFormData
     */
    'state': string;
    /**
     * 
     * @type {string}
     * @memberof PostTrustdockWebhooksRequestFormData
     */
    'result': string | null;
    /**
     * 
     * @type {string}
     * @memberof PostTrustdockWebhooksRequestFormData
     */
    'acceptedAt': string;
    /**
     * 
     * @type {string}
     * @memberof PostTrustdockWebhooksRequestFormData
     */
    'plansSelectedAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof PostTrustdockWebhooksRequestFormData
     */
    'documentSubmittedAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof PostTrustdockWebhooksRequestFormData
     */
    'preparedAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof PostTrustdockWebhooksRequestFormData
     */
    'verifiedAt': string | null;
    /**
     * 
     * @type {PostTrustdockWebhooksRequestFormDataComparingData}
     * @memberof PostTrustdockWebhooksRequestFormData
     */
    'comparingData': PostTrustdockWebhooksRequestFormDataComparingData | null;
    /**
     * 
     * @type {Array<PostTrustdockWebhooksRequestFormDataRecordsInner>}
     * @memberof PostTrustdockWebhooksRequestFormData
     */
    'records': Array<PostTrustdockWebhooksRequestFormDataRecordsInner> | null;
}
/**
 * 
 * @export
 * @interface PostTrustdockWebhooksRequestFormDataComparingData
 */
export interface PostTrustdockWebhooksRequestFormDataComparingData {
    /**
     * 
     * @type {string}
     * @memberof PostTrustdockWebhooksRequestFormDataComparingData
     */
    'submittedAt': string;
}
/**
 * 
 * @export
 * @interface PostTrustdockWebhooksRequestFormDataRecordsInner
 */
export interface PostTrustdockWebhooksRequestFormDataRecordsInner {
    /**
     * 
     * @type {string}
     * @memberof PostTrustdockWebhooksRequestFormDataRecordsInner
     */
    'state': string;
    /**
     * 
     * @type {string}
     * @memberof PostTrustdockWebhooksRequestFormDataRecordsInner
     */
    'result': string | null;
    /**
     * 
     * @type {string}
     * @memberof PostTrustdockWebhooksRequestFormDataRecordsInner
     */
    'verifiedAt': string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof PostTrustdockWebhooksRequestFormDataRecordsInner
     */
    'verifiedBy': Array<string> | null;
    /**
     * 
     * @type {PostTrustdockWebhooksRequestFormDataRecordsInnerPlan}
     * @memberof PostTrustdockWebhooksRequestFormDataRecordsInner
     */
    'plan': PostTrustdockWebhooksRequestFormDataRecordsInnerPlan | null;
    /**
     * 
     * @type {object}
     * @memberof PostTrustdockWebhooksRequestFormDataRecordsInner
     */
    'document': object | null;
    /**
     * 
     * @type {Array<PostTrustdockWebhooksRequestFormDataRecordsInnerReasonsInner>}
     * @memberof PostTrustdockWebhooksRequestFormDataRecordsInner
     */
    'reasons': Array<PostTrustdockWebhooksRequestFormDataRecordsInnerReasonsInner> | null;
}
/**
 * 
 * @export
 * @interface PostTrustdockWebhooksRequestFormDataRecordsInnerPlan
 */
export interface PostTrustdockWebhooksRequestFormDataRecordsInnerPlan {
    /**
     * 
     * @type {string}
     * @memberof PostTrustdockWebhooksRequestFormDataRecordsInnerPlan
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PostTrustdockWebhooksRequestFormDataRecordsInnerPlan
     */
    'name'?: string | null;
}
/**
 * 
 * @export
 * @interface PostTrustdockWebhooksRequestFormDataRecordsInnerReasonsInner
 */
export interface PostTrustdockWebhooksRequestFormDataRecordsInnerReasonsInner {
    /**
     * 
     * @type {string}
     * @memberof PostTrustdockWebhooksRequestFormDataRecordsInnerReasonsInner
     */
    'target': string | null;
    /**
     * 
     * @type {string}
     * @memberof PostTrustdockWebhooksRequestFormDataRecordsInnerReasonsInner
     */
    'code': string | null;
    /**
     * 
     * @type {PostTrustdockWebhooksRequestFormDataRecordsInnerReasonsInnerDetail}
     * @memberof PostTrustdockWebhooksRequestFormDataRecordsInnerReasonsInner
     */
    'detail': PostTrustdockWebhooksRequestFormDataRecordsInnerReasonsInnerDetail | null;
}
/**
 * 
 * @export
 * @interface PostTrustdockWebhooksRequestFormDataRecordsInnerReasonsInnerDetail
 */
export interface PostTrustdockWebhooksRequestFormDataRecordsInnerReasonsInnerDetail {
    /**
     * 
     * @type {Array<string>}
     * @memberof PostTrustdockWebhooksRequestFormDataRecordsInnerReasonsInnerDetail
     */
    'fields'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface PostTrustdockWebhooksSnailMailRequest
 */
export interface PostTrustdockWebhooksSnailMailRequest {
    /**
     * 
     * @type {PostTrustdockWebhooksSnailMailRequestForm}
     * @memberof PostTrustdockWebhooksSnailMailRequest
     */
    'form': PostTrustdockWebhooksSnailMailRequestForm;
}
/**
 * 
 * @export
 * @interface PostTrustdockWebhooksSnailMailRequestForm
 */
export interface PostTrustdockWebhooksSnailMailRequestForm {
    /**
     * 
     * @type {number}
     * @memberof PostTrustdockWebhooksSnailMailRequestForm
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof PostTrustdockWebhooksSnailMailRequestForm
     */
    'result': string;
    /**
     * 
     * @type {PostTrustdockWebhooksSnailMailRequestFormDelivery}
     * @memberof PostTrustdockWebhooksSnailMailRequestForm
     */
    'delivery': PostTrustdockWebhooksSnailMailRequestFormDelivery;
    /**
     * 
     * @type {string}
     * @memberof PostTrustdockWebhooksSnailMailRequestForm
     */
    'createdAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof PostTrustdockWebhooksSnailMailRequestForm
     */
    'confirmedAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof PostTrustdockWebhooksSnailMailRequestForm
     */
    'confirmedBy': string | null;
}
/**
 * 
 * @export
 * @interface PostTrustdockWebhooksSnailMailRequestFormDelivery
 */
export interface PostTrustdockWebhooksSnailMailRequestFormDelivery {
    /**
     * 
     * @type {string}
     * @memberof PostTrustdockWebhooksSnailMailRequestFormDelivery
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof PostTrustdockWebhooksSnailMailRequestFormDelivery
     */
    'detail': string | null;
    /**
     * 
     * @type {string}
     * @memberof PostTrustdockWebhooksSnailMailRequestFormDelivery
     */
    'inquiryNumber': string | null;
    /**
     * 
     * @type {Array<PostTrustdockWebhooksSnailMailRequestFormDeliveryHistoriesInner>}
     * @memberof PostTrustdockWebhooksSnailMailRequestFormDelivery
     */
    'histories': Array<PostTrustdockWebhooksSnailMailRequestFormDeliveryHistoriesInner>;
}
/**
 * 
 * @export
 * @interface PostTrustdockWebhooksSnailMailRequestFormDeliveryHistoriesInner
 */
export interface PostTrustdockWebhooksSnailMailRequestFormDeliveryHistoriesInner {
    /**
     * 
     * @type {string}
     * @memberof PostTrustdockWebhooksSnailMailRequestFormDeliveryHistoriesInner
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof PostTrustdockWebhooksSnailMailRequestFormDeliveryHistoriesInner
     */
    'detail': string | null;
    /**
     * 
     * @type {string}
     * @memberof PostTrustdockWebhooksSnailMailRequestFormDeliveryHistoriesInner
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof PostTrustdockWebhooksSnailMailRequestFormDeliveryHistoriesInner
     */
    'updateAt': string;
}
/**
 * 
 * @export
 * @interface PurchaseApplicationAttachment
 */
export interface PurchaseApplicationAttachment {
    /**
     * 
     * @type {string}
     * @memberof PurchaseApplicationAttachment
     */
    'attachmentId': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseApplicationAttachment
     */
    'fileName': string;
}
/**
 * 
 * @export
 * @interface PurchaseApplicationDetail
 */
export interface PurchaseApplicationDetail {
    /**
     * 
     * @type {PurchaseApplicationDetailApplication}
     * @memberof PurchaseApplicationDetail
     */
    'application': PurchaseApplicationDetailApplication;
    /**
     * 
     * @type {Array<PurchaseApplicationDetailAttachmentsInner>}
     * @memberof PurchaseApplicationDetail
     */
    'attachments': Array<PurchaseApplicationDetailAttachmentsInner>;
    /**
     * 
     * @type {Array<PurchaseApplicationDetailLinkedCardTransactionsInner>}
     * @memberof PurchaseApplicationDetail
     */
    'linkedCardTransactions': Array<PurchaseApplicationDetailLinkedCardTransactionsInner>;
}
/**
 * 
 * @export
 * @interface PurchaseApplicationDetailApplication
 */
export interface PurchaseApplicationDetailApplication {
    /**
     * 
     * @type {string}
     * @memberof PurchaseApplicationDetailApplication
     */
    'applicationId': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseApplicationDetailApplication
     */
    'applicationNumber': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseApplicationDetailApplication
     */
    'paymentDate': string;
    /**
     * 
     * @type {PurchaseApplicationDetailApplicationSubmittedBy}
     * @memberof PurchaseApplicationDetailApplication
     */
    'submittedBy': PurchaseApplicationDetailApplicationSubmittedBy;
    /**
     * 
     * @type {string}
     * @memberof PurchaseApplicationDetailApplication
     */
    'submittedAt': string;
    /**
     * 
     * @type {Array<PurchaseApplicationDetailApplicationApproversInner>}
     * @memberof PurchaseApplicationDetailApplication
     */
    'approvers': Array<PurchaseApplicationDetailApplicationApproversInner>;
    /**
     * 
     * @type {string}
     * @memberof PurchaseApplicationDetailApplication
     */
    'department': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseApplicationDetailApplication
     */
    'purchaseReason': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseApplicationDetailApplication
     */
    'purchaseDetails': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseApplicationDetailApplication
     */
    'placeOfUse': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseApplicationDetailApplication
     */
    'purposeOfUse': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseApplicationDetailApplication
     */
    'url': string;
    /**
     * 
     * @type {number}
     * @memberof PurchaseApplicationDetailApplication
     */
    'amount': number;
    /**
     * 
     * @type {PurchaseApplicationDetailApplicationUserAccount}
     * @memberof PurchaseApplicationDetailApplication
     */
    'userAccount': PurchaseApplicationDetailApplicationUserAccount | null;
    /**
     * 
     * @type {string}
     * @memberof PurchaseApplicationDetailApplication
     */
    'remarks': string;
    /**
     * 
     * @type {PurchaseApplicationDetailApplicationWorkRequestedBy}
     * @memberof PurchaseApplicationDetailApplication
     */
    'workRequestedBy': PurchaseApplicationDetailApplicationWorkRequestedBy;
    /**
     * 
     * @type {string}
     * @memberof PurchaseApplicationDetailApplication
     */
    'workRequestApprovers': string;
    /**
     * 
     * @type {PurchaseApplicationDetailApplicationStatus}
     * @memberof PurchaseApplicationDetailApplication
     */
    'status': PurchaseApplicationDetailApplicationStatus;
    /**
     * 
     * @type {PurchaseApplicationDetailApplicationCreatedBy}
     * @memberof PurchaseApplicationDetailApplication
     */
    'createdBy': PurchaseApplicationDetailApplicationCreatedBy;
}
/**
 * 
 * @export
 * @interface PurchaseApplicationDetailApplicationApproversInner
 */
export interface PurchaseApplicationDetailApplicationApproversInner {
    /**
     * 
     * @type {string}
     * @memberof PurchaseApplicationDetailApplicationApproversInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseApplicationDetailApplicationApproversInner
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface PurchaseApplicationDetailApplicationCreatedBy
 */
export interface PurchaseApplicationDetailApplicationCreatedBy {
    /**
     * 
     * @type {string}
     * @memberof PurchaseApplicationDetailApplicationCreatedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseApplicationDetailApplicationCreatedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface PurchaseApplicationDetailApplicationStatus
 */
export interface PurchaseApplicationDetailApplicationStatus {
    /**
     * 
     * @type {string}
     * @memberof PurchaseApplicationDetailApplicationStatus
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseApplicationDetailApplicationStatus
     */
    'comment': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseApplicationDetailApplicationStatus
     */
    'statusChangedAt': string;
    /**
     * 
     * @type {PurchaseApplicationDetailApplicationStatusCreatedBy}
     * @memberof PurchaseApplicationDetailApplicationStatus
     */
    'createdBy': PurchaseApplicationDetailApplicationStatusCreatedBy;
}
/**
 * 
 * @export
 * @interface PurchaseApplicationDetailApplicationStatusCreatedBy
 */
export interface PurchaseApplicationDetailApplicationStatusCreatedBy {
    /**
     * 
     * @type {string}
     * @memberof PurchaseApplicationDetailApplicationStatusCreatedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseApplicationDetailApplicationStatusCreatedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface PurchaseApplicationDetailApplicationSubmittedBy
 */
export interface PurchaseApplicationDetailApplicationSubmittedBy {
    /**
     * 
     * @type {string}
     * @memberof PurchaseApplicationDetailApplicationSubmittedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseApplicationDetailApplicationSubmittedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface PurchaseApplicationDetailApplicationUserAccount
 */
export interface PurchaseApplicationDetailApplicationUserAccount {
    /**
     * 
     * @type {string}
     * @memberof PurchaseApplicationDetailApplicationUserAccount
     */
    'userAccountId': string;
    /**
     * 
     * @type {PurchaseApplicationDetailApplicationUserAccountUser}
     * @memberof PurchaseApplicationDetailApplicationUserAccount
     */
    'user': PurchaseApplicationDetailApplicationUserAccountUser;
    /**
     * 
     * @type {string}
     * @memberof PurchaseApplicationDetailApplicationUserAccount
     */
    'cardLabel': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseApplicationDetailApplicationUserAccount
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseApplicationDetailApplicationUserAccount
     */
    'organizationName': string;
    /**
     * 
     * @type {PurchaseApplicationDetailApplicationUserAccountUserAccountGroup}
     * @memberof PurchaseApplicationDetailApplicationUserAccount
     */
    'userAccountGroup': PurchaseApplicationDetailApplicationUserAccountUserAccountGroup | null;
    /**
     * 
     * @type {boolean}
     * @memberof PurchaseApplicationDetailApplicationUserAccount
     */
    'isOnDemand': boolean;
}
/**
 * 
 * @export
 * @interface PurchaseApplicationDetailApplicationUserAccountUser
 */
export interface PurchaseApplicationDetailApplicationUserAccountUser {
    /**
     * 
     * @type {string}
     * @memberof PurchaseApplicationDetailApplicationUserAccountUser
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseApplicationDetailApplicationUserAccountUser
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseApplicationDetailApplicationUserAccountUser
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseApplicationDetailApplicationUserAccountUser
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseApplicationDetailApplicationUserAccountUser
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PurchaseApplicationDetailApplicationUserAccountUser
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PurchaseApplicationDetailApplicationUserAccountUser
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PurchaseApplicationDetailApplicationUserAccountUser
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PurchaseApplicationDetailApplicationUserAccountUser
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PurchaseApplicationDetailApplicationUserAccountUser
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof PurchaseApplicationDetailApplicationUserAccountUser
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface PurchaseApplicationDetailApplicationUserAccountUserAccountGroup
 */
export interface PurchaseApplicationDetailApplicationUserAccountUserAccountGroup {
    /**
     * 
     * @type {string}
     * @memberof PurchaseApplicationDetailApplicationUserAccountUserAccountGroup
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseApplicationDetailApplicationUserAccountUserAccountGroup
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof PurchaseApplicationDetailApplicationUserAccountUserAccountGroup
     */
    'sortNum': number;
}
/**
 * 
 * @export
 * @interface PurchaseApplicationDetailApplicationWorkRequestedBy
 */
export interface PurchaseApplicationDetailApplicationWorkRequestedBy {
    /**
     * 
     * @type {string}
     * @memberof PurchaseApplicationDetailApplicationWorkRequestedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseApplicationDetailApplicationWorkRequestedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface PurchaseApplicationDetailAttachmentsInner
 */
export interface PurchaseApplicationDetailAttachmentsInner {
    /**
     * 
     * @type {string}
     * @memberof PurchaseApplicationDetailAttachmentsInner
     */
    'attachmentId': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseApplicationDetailAttachmentsInner
     */
    'fileName': string;
}
/**
 * 
 * @export
 * @interface PurchaseApplicationDetailLinkedCardTransactionsInner
 */
export interface PurchaseApplicationDetailLinkedCardTransactionsInner {
    /**
     * 
     * @type {string}
     * @memberof PurchaseApplicationDetailLinkedCardTransactionsInner
     */
    'visaTransactionReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseApplicationDetailLinkedCardTransactionsInner
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {boolean}
     * @memberof PurchaseApplicationDetailLinkedCardTransactionsInner
     */
    'canUnlink': boolean;
}
/**
 * 
 * @export
 * @interface PurchaseApplicationRecord
 */
export interface PurchaseApplicationRecord {
    /**
     * 
     * @type {string}
     * @memberof PurchaseApplicationRecord
     */
    'applicationId': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseApplicationRecord
     */
    'applicationNumber': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseApplicationRecord
     */
    'paymentDate': string;
    /**
     * 
     * @type {PurchaseApplicationRecordSubmittedBy}
     * @memberof PurchaseApplicationRecord
     */
    'submittedBy': PurchaseApplicationRecordSubmittedBy;
    /**
     * 
     * @type {string}
     * @memberof PurchaseApplicationRecord
     */
    'submittedAt': string;
    /**
     * 
     * @type {Array<PurchaseApplicationRecordApproversInner>}
     * @memberof PurchaseApplicationRecord
     */
    'approvers': Array<PurchaseApplicationRecordApproversInner>;
    /**
     * 
     * @type {string}
     * @memberof PurchaseApplicationRecord
     */
    'department': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseApplicationRecord
     */
    'purchaseReason': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseApplicationRecord
     */
    'purchaseDetails': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseApplicationRecord
     */
    'placeOfUse': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseApplicationRecord
     */
    'purposeOfUse': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseApplicationRecord
     */
    'url': string;
    /**
     * 
     * @type {number}
     * @memberof PurchaseApplicationRecord
     */
    'amount': number;
    /**
     * 
     * @type {PurchaseApplicationRecordUserAccount}
     * @memberof PurchaseApplicationRecord
     */
    'userAccount': PurchaseApplicationRecordUserAccount | null;
    /**
     * 
     * @type {string}
     * @memberof PurchaseApplicationRecord
     */
    'remarks': string;
    /**
     * 
     * @type {PurchaseApplicationRecordWorkRequestedBy}
     * @memberof PurchaseApplicationRecord
     */
    'workRequestedBy': PurchaseApplicationRecordWorkRequestedBy;
    /**
     * 
     * @type {string}
     * @memberof PurchaseApplicationRecord
     */
    'workRequestApprovers': string;
    /**
     * 
     * @type {PurchaseApplicationRecordStatus}
     * @memberof PurchaseApplicationRecord
     */
    'status': PurchaseApplicationRecordStatus;
    /**
     * 
     * @type {PurchaseApplicationRecordCreatedBy}
     * @memberof PurchaseApplicationRecord
     */
    'createdBy': PurchaseApplicationRecordCreatedBy;
}
/**
 * 
 * @export
 * @interface PurchaseApplicationRecordApproversInner
 */
export interface PurchaseApplicationRecordApproversInner {
    /**
     * 
     * @type {string}
     * @memberof PurchaseApplicationRecordApproversInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseApplicationRecordApproversInner
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface PurchaseApplicationRecordCreatedBy
 */
export interface PurchaseApplicationRecordCreatedBy {
    /**
     * 
     * @type {string}
     * @memberof PurchaseApplicationRecordCreatedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseApplicationRecordCreatedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface PurchaseApplicationRecordStatus
 */
export interface PurchaseApplicationRecordStatus {
    /**
     * 
     * @type {string}
     * @memberof PurchaseApplicationRecordStatus
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseApplicationRecordStatus
     */
    'comment': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseApplicationRecordStatus
     */
    'statusChangedAt': string;
    /**
     * 
     * @type {PurchaseApplicationRecordStatusCreatedBy}
     * @memberof PurchaseApplicationRecordStatus
     */
    'createdBy': PurchaseApplicationRecordStatusCreatedBy;
}
/**
 * 
 * @export
 * @interface PurchaseApplicationRecordStatusCreatedBy
 */
export interface PurchaseApplicationRecordStatusCreatedBy {
    /**
     * 
     * @type {string}
     * @memberof PurchaseApplicationRecordStatusCreatedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseApplicationRecordStatusCreatedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface PurchaseApplicationRecordSubmittedBy
 */
export interface PurchaseApplicationRecordSubmittedBy {
    /**
     * 
     * @type {string}
     * @memberof PurchaseApplicationRecordSubmittedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseApplicationRecordSubmittedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface PurchaseApplicationRecordUserAccount
 */
export interface PurchaseApplicationRecordUserAccount {
    /**
     * 
     * @type {string}
     * @memberof PurchaseApplicationRecordUserAccount
     */
    'userAccountId': string;
    /**
     * 
     * @type {PurchaseApplicationRecordUserAccountUser}
     * @memberof PurchaseApplicationRecordUserAccount
     */
    'user': PurchaseApplicationRecordUserAccountUser;
    /**
     * 
     * @type {string}
     * @memberof PurchaseApplicationRecordUserAccount
     */
    'cardLabel': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseApplicationRecordUserAccount
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseApplicationRecordUserAccount
     */
    'organizationName': string;
    /**
     * 
     * @type {PurchaseApplicationRecordUserAccountUserAccountGroup}
     * @memberof PurchaseApplicationRecordUserAccount
     */
    'userAccountGroup': PurchaseApplicationRecordUserAccountUserAccountGroup | null;
    /**
     * 
     * @type {boolean}
     * @memberof PurchaseApplicationRecordUserAccount
     */
    'isOnDemand': boolean;
}
/**
 * 
 * @export
 * @interface PurchaseApplicationRecordUserAccountUser
 */
export interface PurchaseApplicationRecordUserAccountUser {
    /**
     * 
     * @type {string}
     * @memberof PurchaseApplicationRecordUserAccountUser
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseApplicationRecordUserAccountUser
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseApplicationRecordUserAccountUser
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseApplicationRecordUserAccountUser
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseApplicationRecordUserAccountUser
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PurchaseApplicationRecordUserAccountUser
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PurchaseApplicationRecordUserAccountUser
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PurchaseApplicationRecordUserAccountUser
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PurchaseApplicationRecordUserAccountUser
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PurchaseApplicationRecordUserAccountUser
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof PurchaseApplicationRecordUserAccountUser
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface PurchaseApplicationRecordUserAccountUserAccountGroup
 */
export interface PurchaseApplicationRecordUserAccountUserAccountGroup {
    /**
     * 
     * @type {string}
     * @memberof PurchaseApplicationRecordUserAccountUserAccountGroup
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseApplicationRecordUserAccountUserAccountGroup
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof PurchaseApplicationRecordUserAccountUserAccountGroup
     */
    'sortNum': number;
}
/**
 * 
 * @export
 * @interface PurchaseApplicationRecordWorkRequestedBy
 */
export interface PurchaseApplicationRecordWorkRequestedBy {
    /**
     * 
     * @type {string}
     * @memberof PurchaseApplicationRecordWorkRequestedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseApplicationRecordWorkRequestedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface PurchaseApplicationStatus
 */
export interface PurchaseApplicationStatus {
    /**
     * 
     * @type {string}
     * @memberof PurchaseApplicationStatus
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseApplicationStatus
     */
    'comment': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseApplicationStatus
     */
    'statusChangedAt': string;
    /**
     * 
     * @type {PurchaseApplicationStatusCreatedBy}
     * @memberof PurchaseApplicationStatus
     */
    'createdBy': PurchaseApplicationStatusCreatedBy;
}
/**
 * 
 * @export
 * @interface PurchaseApplicationStatusCreatedBy
 */
export interface PurchaseApplicationStatusCreatedBy {
    /**
     * 
     * @type {string}
     * @memberof PurchaseApplicationStatusCreatedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseApplicationStatusCreatedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface PurchaseTemplateDetailResponseForTemplate
 */
export interface PurchaseTemplateDetailResponseForTemplate {
    /**
     * 
     * @type {PurchaseTemplateDetailResponseForTemplateTemplateOverview}
     * @memberof PurchaseTemplateDetailResponseForTemplate
     */
    'templateOverview': PurchaseTemplateDetailResponseForTemplateTemplateOverview;
}
/**
 * 
 * @export
 * @interface PurchaseTemplateDetailResponseForTemplateTemplateOverview
 */
export interface PurchaseTemplateDetailResponseForTemplateTemplateOverview {
    /**
     * 
     * @type {string}
     * @memberof PurchaseTemplateDetailResponseForTemplateTemplateOverview
     */
    'purchaseTemplateNumber': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseTemplateDetailResponseForTemplateTemplateOverview
     */
    'templateId': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseTemplateDetailResponseForTemplateTemplateOverview
     */
    'templateName': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseTemplateDetailResponseForTemplateTemplateOverview
     */
    'scopeDisclosure': PurchaseTemplateDetailResponseForTemplateTemplateOverviewScopeDisclosureEnum;
    /**
     * 
     * @type {string}
     * @memberof PurchaseTemplateDetailResponseForTemplateTemplateOverview
     */
    'templateCategory': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseTemplateDetailResponseForTemplateTemplateOverview
     */
    'templateDetail': string;
    /**
     * 
     * @type {PurchaseTemplateDetailResponseForTemplateTemplateOverviewSubmittedBy}
     * @memberof PurchaseTemplateDetailResponseForTemplateTemplateOverview
     */
    'submittedBy': PurchaseTemplateDetailResponseForTemplateTemplateOverviewSubmittedBy;
    /**
     * 
     * @type {string}
     * @memberof PurchaseTemplateDetailResponseForTemplateTemplateOverview
     */
    'submittedAt': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseTemplateDetailResponseForTemplateTemplateOverview
     */
    'department': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseTemplateDetailResponseForTemplateTemplateOverview
     */
    'purchaseReason': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseTemplateDetailResponseForTemplateTemplateOverview
     */
    'purchaseDetails': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseTemplateDetailResponseForTemplateTemplateOverview
     */
    'placeOfUse': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseTemplateDetailResponseForTemplateTemplateOverview
     */
    'purposeOfUse': PurchaseTemplateDetailResponseForTemplateTemplateOverviewPurposeOfUseEnum;
    /**
     * 
     * @type {string}
     * @memberof PurchaseTemplateDetailResponseForTemplateTemplateOverview
     */
    'url': string;
    /**
     * 
     * @type {number}
     * @memberof PurchaseTemplateDetailResponseForTemplateTemplateOverview
     */
    'amount': number | null;
    /**
     * 
     * @type {PurchaseTemplateDetailResponseForTemplateTemplateOverviewUserAccount}
     * @memberof PurchaseTemplateDetailResponseForTemplateTemplateOverview
     */
    'userAccount': PurchaseTemplateDetailResponseForTemplateTemplateOverviewUserAccount | null;
    /**
     * 
     * @type {boolean}
     * @memberof PurchaseTemplateDetailResponseForTemplateTemplateOverview
     */
    'isOnDemandCard': boolean;
    /**
     * 
     * @type {string}
     * @memberof PurchaseTemplateDetailResponseForTemplateTemplateOverview
     */
    'remarks': string;
    /**
     * 
     * @type {PurchaseTemplateDetailResponseForTemplateTemplateOverviewCreatedBy}
     * @memberof PurchaseTemplateDetailResponseForTemplateTemplateOverview
     */
    'createdBy': PurchaseTemplateDetailResponseForTemplateTemplateOverviewCreatedBy;
    /**
     * 
     * @type {Array<PurchaseTemplateDetailResponseForTemplateTemplateOverviewApproversInner>}
     * @memberof PurchaseTemplateDetailResponseForTemplateTemplateOverview
     */
    'approvers': Array<PurchaseTemplateDetailResponseForTemplateTemplateOverviewApproversInner>;
}

export const PurchaseTemplateDetailResponseForTemplateTemplateOverviewScopeDisclosureEnum = {
    public: 'PUBLIC',
    individual: 'INDIVIDUAL'
} as const;

export type PurchaseTemplateDetailResponseForTemplateTemplateOverviewScopeDisclosureEnum = typeof PurchaseTemplateDetailResponseForTemplateTemplateOverviewScopeDisclosureEnum[keyof typeof PurchaseTemplateDetailResponseForTemplateTemplateOverviewScopeDisclosureEnum];
export const PurchaseTemplateDetailResponseForTemplateTemplateOverviewPurposeOfUseEnum = {
    software: 'SOFTWARE',
    fixtures: 'FIXTURES',
    conference: 'CONFERENCE',
    entertainment: 'ENTERTAINMENT',
    travel: 'TRAVEL',
    other: 'OTHER',
    initialValue: 'INITIAL_VALUE'
} as const;

export type PurchaseTemplateDetailResponseForTemplateTemplateOverviewPurposeOfUseEnum = typeof PurchaseTemplateDetailResponseForTemplateTemplateOverviewPurposeOfUseEnum[keyof typeof PurchaseTemplateDetailResponseForTemplateTemplateOverviewPurposeOfUseEnum];

/**
 * 
 * @export
 * @interface PurchaseTemplateDetailResponseForTemplateTemplateOverviewApproversInner
 */
export interface PurchaseTemplateDetailResponseForTemplateTemplateOverviewApproversInner {
    /**
     * 
     * @type {string}
     * @memberof PurchaseTemplateDetailResponseForTemplateTemplateOverviewApproversInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseTemplateDetailResponseForTemplateTemplateOverviewApproversInner
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseTemplateDetailResponseForTemplateTemplateOverviewApproversInner
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseTemplateDetailResponseForTemplateTemplateOverviewApproversInner
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseTemplateDetailResponseForTemplateTemplateOverviewApproversInner
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PurchaseTemplateDetailResponseForTemplateTemplateOverviewApproversInner
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PurchaseTemplateDetailResponseForTemplateTemplateOverviewApproversInner
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PurchaseTemplateDetailResponseForTemplateTemplateOverviewApproversInner
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PurchaseTemplateDetailResponseForTemplateTemplateOverviewApproversInner
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PurchaseTemplateDetailResponseForTemplateTemplateOverviewApproversInner
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof PurchaseTemplateDetailResponseForTemplateTemplateOverviewApproversInner
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface PurchaseTemplateDetailResponseForTemplateTemplateOverviewCreatedBy
 */
export interface PurchaseTemplateDetailResponseForTemplateTemplateOverviewCreatedBy {
    /**
     * 
     * @type {string}
     * @memberof PurchaseTemplateDetailResponseForTemplateTemplateOverviewCreatedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseTemplateDetailResponseForTemplateTemplateOverviewCreatedBy
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseTemplateDetailResponseForTemplateTemplateOverviewCreatedBy
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseTemplateDetailResponseForTemplateTemplateOverviewCreatedBy
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseTemplateDetailResponseForTemplateTemplateOverviewCreatedBy
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PurchaseTemplateDetailResponseForTemplateTemplateOverviewCreatedBy
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PurchaseTemplateDetailResponseForTemplateTemplateOverviewCreatedBy
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PurchaseTemplateDetailResponseForTemplateTemplateOverviewCreatedBy
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PurchaseTemplateDetailResponseForTemplateTemplateOverviewCreatedBy
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PurchaseTemplateDetailResponseForTemplateTemplateOverviewCreatedBy
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof PurchaseTemplateDetailResponseForTemplateTemplateOverviewCreatedBy
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface PurchaseTemplateDetailResponseForTemplateTemplateOverviewSubmittedBy
 */
export interface PurchaseTemplateDetailResponseForTemplateTemplateOverviewSubmittedBy {
    /**
     * 
     * @type {string}
     * @memberof PurchaseTemplateDetailResponseForTemplateTemplateOverviewSubmittedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseTemplateDetailResponseForTemplateTemplateOverviewSubmittedBy
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseTemplateDetailResponseForTemplateTemplateOverviewSubmittedBy
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseTemplateDetailResponseForTemplateTemplateOverviewSubmittedBy
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseTemplateDetailResponseForTemplateTemplateOverviewSubmittedBy
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PurchaseTemplateDetailResponseForTemplateTemplateOverviewSubmittedBy
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PurchaseTemplateDetailResponseForTemplateTemplateOverviewSubmittedBy
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PurchaseTemplateDetailResponseForTemplateTemplateOverviewSubmittedBy
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PurchaseTemplateDetailResponseForTemplateTemplateOverviewSubmittedBy
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PurchaseTemplateDetailResponseForTemplateTemplateOverviewSubmittedBy
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof PurchaseTemplateDetailResponseForTemplateTemplateOverviewSubmittedBy
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface PurchaseTemplateDetailResponseForTemplateTemplateOverviewUserAccount
 */
export interface PurchaseTemplateDetailResponseForTemplateTemplateOverviewUserAccount {
    /**
     * 
     * @type {string}
     * @memberof PurchaseTemplateDetailResponseForTemplateTemplateOverviewUserAccount
     */
    'userAccountId': string;
    /**
     * 
     * @type {PurchaseTemplateDetailResponseForTemplateTemplateOverviewUserAccountUser}
     * @memberof PurchaseTemplateDetailResponseForTemplateTemplateOverviewUserAccount
     */
    'user': PurchaseTemplateDetailResponseForTemplateTemplateOverviewUserAccountUser;
    /**
     * 
     * @type {string}
     * @memberof PurchaseTemplateDetailResponseForTemplateTemplateOverviewUserAccount
     */
    'cardLabel': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseTemplateDetailResponseForTemplateTemplateOverviewUserAccount
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseTemplateDetailResponseForTemplateTemplateOverviewUserAccount
     */
    'organizationName': string;
    /**
     * 
     * @type {PurchaseTemplateDetailResponseForTemplateTemplateOverviewUserAccountUserAccountGroup}
     * @memberof PurchaseTemplateDetailResponseForTemplateTemplateOverviewUserAccount
     */
    'userAccountGroup': PurchaseTemplateDetailResponseForTemplateTemplateOverviewUserAccountUserAccountGroup | null;
    /**
     * 
     * @type {boolean}
     * @memberof PurchaseTemplateDetailResponseForTemplateTemplateOverviewUserAccount
     */
    'isOnDemand': boolean;
}
/**
 * 
 * @export
 * @interface PurchaseTemplateDetailResponseForTemplateTemplateOverviewUserAccountUser
 */
export interface PurchaseTemplateDetailResponseForTemplateTemplateOverviewUserAccountUser {
    /**
     * 
     * @type {string}
     * @memberof PurchaseTemplateDetailResponseForTemplateTemplateOverviewUserAccountUser
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseTemplateDetailResponseForTemplateTemplateOverviewUserAccountUser
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseTemplateDetailResponseForTemplateTemplateOverviewUserAccountUser
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseTemplateDetailResponseForTemplateTemplateOverviewUserAccountUser
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseTemplateDetailResponseForTemplateTemplateOverviewUserAccountUser
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PurchaseTemplateDetailResponseForTemplateTemplateOverviewUserAccountUser
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PurchaseTemplateDetailResponseForTemplateTemplateOverviewUserAccountUser
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PurchaseTemplateDetailResponseForTemplateTemplateOverviewUserAccountUser
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PurchaseTemplateDetailResponseForTemplateTemplateOverviewUserAccountUser
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PurchaseTemplateDetailResponseForTemplateTemplateOverviewUserAccountUser
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof PurchaseTemplateDetailResponseForTemplateTemplateOverviewUserAccountUser
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface PurchaseTemplateDetailResponseForTemplateTemplateOverviewUserAccountUserAccountGroup
 */
export interface PurchaseTemplateDetailResponseForTemplateTemplateOverviewUserAccountUserAccountGroup {
    /**
     * 
     * @type {string}
     * @memberof PurchaseTemplateDetailResponseForTemplateTemplateOverviewUserAccountUserAccountGroup
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseTemplateDetailResponseForTemplateTemplateOverviewUserAccountUserAccountGroup
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof PurchaseTemplateDetailResponseForTemplateTemplateOverviewUserAccountUserAccountGroup
     */
    'sortNum': number;
}
/**
 * 
 * @export
 * @interface PutFreeeEndJournalEntryTransitionModeRequest
 */
export interface PutFreeeEndJournalEntryTransitionModeRequest {
    /**
     * 
     * @type {string}
     * @memberof PutFreeeEndJournalEntryTransitionModeRequest
     */
    'endDate': string;
}
/**
 * 
 * @export
 * @interface PutOrganizationPaymentMethodRequest
 */
export interface PutOrganizationPaymentMethodRequest {
    /**
     * 
     * @type {string}
     * @memberof PutOrganizationPaymentMethodRequest
     */
    'paymentMethod': PutOrganizationPaymentMethodRequestPaymentMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof PutOrganizationPaymentMethodRequest
     */
    'externalAccountTransferAgency': PutOrganizationPaymentMethodRequestExternalAccountTransferAgencyEnum;
    /**
     * 
     * @type {string}
     * @memberof PutOrganizationPaymentMethodRequest
     */
    'paymentScheme': PutOrganizationPaymentMethodRequestPaymentSchemeEnum;
}

export const PutOrganizationPaymentMethodRequestPaymentMethodEnum = {
    accountTransfer: 'ACCOUNT_TRANSFER',
    bankTransfer: 'BANK_TRANSFER'
} as const;

export type PutOrganizationPaymentMethodRequestPaymentMethodEnum = typeof PutOrganizationPaymentMethodRequestPaymentMethodEnum[keyof typeof PutOrganizationPaymentMethodRequestPaymentMethodEnum];
export const PutOrganizationPaymentMethodRequestExternalAccountTransferAgencyEnum = {
    moneyForwardKessai: 'MONEY_FORWARD_KESSAI',
    ufj: 'UFJ'
} as const;

export type PutOrganizationPaymentMethodRequestExternalAccountTransferAgencyEnum = typeof PutOrganizationPaymentMethodRequestExternalAccountTransferAgencyEnum[keyof typeof PutOrganizationPaymentMethodRequestExternalAccountTransferAgencyEnum];
export const PutOrganizationPaymentMethodRequestPaymentSchemeEnum = {
    fifteenthDayPayment: 'FIFTEENTH_DAY_PAYMENT',
    twoMonthsLaterFifteenthDayPayment: 'TWO_MONTHS_LATER_FIFTEENTH_DAY_PAYMENT',
    endOfTwoMonthsLaterPayment: 'END_OF_TWO_MONTHS_LATER_PAYMENT',
    twentiethDayPayment: 'TWENTIETH_DAY_PAYMENT',
    endOfMonthPayment: 'END_OF_MONTH_PAYMENT',
    twoMonthsLaterSixthDayPayment: 'TWO_MONTHS_LATER_SIXTH_DAY_PAYMENT'
} as const;

export type PutOrganizationPaymentMethodRequestPaymentSchemeEnum = typeof PutOrganizationPaymentMethodRequestPaymentSchemeEnum[keyof typeof PutOrganizationPaymentMethodRequestPaymentSchemeEnum];

/**
 * 
 * @export
 * @interface PutOrganizationsDealsRequest
 */
export interface PutOrganizationsDealsRequest {
    /**
     * 
     * @type {Array<PutOrganizationsDealsRequestDealsInner>}
     * @memberof PutOrganizationsDealsRequest
     */
    'deals': Array<PutOrganizationsDealsRequestDealsInner>;
}
/**
 * 
 * @export
 * @interface PutOrganizationsDealsRequestDealsInner
 */
export interface PutOrganizationsDealsRequestDealsInner {
    /**
     * 
     * @type {string}
     * @memberof PutOrganizationsDealsRequestDealsInner
     */
    'dealId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PutOrganizationsDealsRequestDealsInner
     */
    'freeePartnerId'?: string;
    /**
     * 
     * @type {Array<PutOrganizationsDealsRequestDealsInnerFreeeJournalEntriesInner>}
     * @memberof PutOrganizationsDealsRequestDealsInner
     */
    'freeeJournalEntries'?: Array<PutOrganizationsDealsRequestDealsInnerFreeeJournalEntriesInner>;
}
/**
 * 
 * @export
 * @interface PutOrganizationsDealsRequestDealsInnerFreeeJournalEntriesInner
 */
export interface PutOrganizationsDealsRequestDealsInnerFreeeJournalEntriesInner {
    /**
     * 
     * @type {string}
     * @memberof PutOrganizationsDealsRequestDealsInnerFreeeJournalEntriesInner
     */
    'freeeAccountItemId': string | null;
    /**
     * 
     * @type {string}
     * @memberof PutOrganizationsDealsRequestDealsInnerFreeeJournalEntriesInner
     */
    'freeeTaxCode': string | null;
    /**
     * 
     * @type {string}
     * @memberof PutOrganizationsDealsRequestDealsInnerFreeeJournalEntriesInner
     */
    'amount': string | null;
    /**
     * 
     * @type {string}
     * @memberof PutOrganizationsDealsRequestDealsInnerFreeeJournalEntriesInner
     */
    'freeeItemId': string | null;
    /**
     * 
     * @type {string}
     * @memberof PutOrganizationsDealsRequestDealsInnerFreeeJournalEntriesInner
     */
    'freeeSectionId': string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof PutOrganizationsDealsRequestDealsInnerFreeeJournalEntriesInner
     */
    'freeeMemoTagIds': Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof PutOrganizationsDealsRequestDealsInnerFreeeJournalEntriesInner
     */
    'segment1TagId': string | null;
    /**
     * 
     * @type {string}
     * @memberof PutOrganizationsDealsRequestDealsInnerFreeeJournalEntriesInner
     */
    'segment2TagId': string | null;
    /**
     * 
     * @type {string}
     * @memberof PutOrganizationsDealsRequestDealsInnerFreeeJournalEntriesInner
     */
    'segment3TagId': string | null;
    /**
     * 
     * @type {string}
     * @memberof PutOrganizationsDealsRequestDealsInnerFreeeJournalEntriesInner
     */
    'description': string | null;
}
/**
 * 
 * @export
 * @interface PutPaymentRequestRequest
 */
export interface PutPaymentRequestRequest {
    /**
     * 
     * @type {PutPaymentRequestRequestSupplier}
     * @memberof PutPaymentRequestRequest
     */
    'supplier': PutPaymentRequestRequestSupplier;
    /**
     * 
     * @type {string}
     * @memberof PutPaymentRequestRequest
     */
    'dueDate': string;
    /**
     * 
     * @type {number}
     * @memberof PutPaymentRequestRequest
     */
    'totalAmount': number;
    /**
     * 
     * @type {string}
     * @memberof PutPaymentRequestRequest
     */
    'transferFeeResponsibility': PutPaymentRequestRequestTransferFeeResponsibilityEnum;
    /**
     * 
     * @type {string}
     * @memberof PutPaymentRequestRequest
     */
    'memo': string | null;
    /**
     * 
     * @type {string}
     * @memberof PutPaymentRequestRequest
     */
    'withholdingCalculatingMethod': PutPaymentRequestRequestWithholdingCalculatingMethodEnum;
    /**
     * 
     * @type {number}
     * @memberof PutPaymentRequestRequest
     */
    'withholdingAmount': number | null;
    /**
     * 
     * @type {PutPaymentRequestRequestEvidenceInvoiceIssuer}
     * @memberof PutPaymentRequestRequest
     */
    'evidenceInvoiceIssuer': PutPaymentRequestRequestEvidenceInvoiceIssuer;
}

export const PutPaymentRequestRequestTransferFeeResponsibilityEnum = {
    self: 'SELF',
    supplier: 'SUPPLIER'
} as const;

export type PutPaymentRequestRequestTransferFeeResponsibilityEnum = typeof PutPaymentRequestRequestTransferFeeResponsibilityEnum[keyof typeof PutPaymentRequestRequestTransferFeeResponsibilityEnum];
export const PutPaymentRequestRequestWithholdingCalculatingMethodEnum = {
    none: 'NONE',
    manuscriptOrLecture: 'MANUSCRIPT_OR_LECTURE',
    lawyerOrCpa: 'LAWYER_OR_CPA',
    judicialScrivener: 'JUDICIAL_SCRIVENER',
    other: 'OTHER'
} as const;

export type PutPaymentRequestRequestWithholdingCalculatingMethodEnum = typeof PutPaymentRequestRequestWithholdingCalculatingMethodEnum[keyof typeof PutPaymentRequestRequestWithholdingCalculatingMethodEnum];

/**
 * 
 * @export
 * @interface PutPaymentRequestRequestEvidenceInvoiceIssuer
 */
export interface PutPaymentRequestRequestEvidenceInvoiceIssuer {
    /**
     * 
     * @type {string}
     * @memberof PutPaymentRequestRequestEvidenceInvoiceIssuer
     */
    'name': string | null;
    /**
     * 
     * @type {string}
     * @memberof PutPaymentRequestRequestEvidenceInvoiceIssuer
     */
    'registrationNumber': string | null;
}
/**
 * 
 * @export
 * @interface PutPaymentRequestRequestSupplier
 */
export interface PutPaymentRequestRequestSupplier {
    /**
     * 
     * @type {string}
     * @memberof PutPaymentRequestRequestSupplier
     */
    'partnerId': string | null;
    /**
     * 
     * @type {string}
     * @memberof PutPaymentRequestRequestSupplier
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof PutPaymentRequestRequestSupplier
     */
    'bankNumber': string;
    /**
     * 
     * @type {string}
     * @memberof PutPaymentRequestRequestSupplier
     */
    'bankName': string;
    /**
     * 
     * @type {string}
     * @memberof PutPaymentRequestRequestSupplier
     */
    'branchNumber': string;
    /**
     * 
     * @type {string}
     * @memberof PutPaymentRequestRequestSupplier
     */
    'branchName': string;
    /**
     * 
     * @type {string}
     * @memberof PutPaymentRequestRequestSupplier
     */
    'accountType': PutPaymentRequestRequestSupplierAccountTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof PutPaymentRequestRequestSupplier
     */
    'accountNumber': string;
    /**
     * 
     * @type {string}
     * @memberof PutPaymentRequestRequestSupplier
     */
    'companyCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PutPaymentRequestRequestSupplier
     */
    'companyName': string;
}

export const PutPaymentRequestRequestSupplierAccountTypeEnum = {
    savingsAccount: 'SAVINGS_ACCOUNT',
    currentAccount: 'CURRENT_ACCOUNT',
    thriftAccount: 'THRIFT_ACCOUNT',
    other: 'OTHER'
} as const;

export type PutPaymentRequestRequestSupplierAccountTypeEnum = typeof PutPaymentRequestRequestSupplierAccountTypeEnum[keyof typeof PutPaymentRequestRequestSupplierAccountTypeEnum];

/**
 * 
 * @export
 * @interface PutPaymentRequestsBankAccount200Response
 */
export interface PutPaymentRequestsBankAccount200Response {
    /**
     * 
     * @type {string}
     * @memberof PutPaymentRequestsBankAccount200Response
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PutPaymentRequestsBankAccount200Response
     */
    'recordId': string;
}
/**
 * 
 * @export
 * @interface PutPaymentRequestsBankAccountRequest
 */
export interface PutPaymentRequestsBankAccountRequest {
    /**
     * 
     * @type {string}
     * @memberof PutPaymentRequestsBankAccountRequest
     */
    'bankNumber': string;
    /**
     * 
     * @type {string}
     * @memberof PutPaymentRequestsBankAccountRequest
     */
    'bankName': string;
    /**
     * 
     * @type {string}
     * @memberof PutPaymentRequestsBankAccountRequest
     */
    'branchNumber': string;
    /**
     * 
     * @type {string}
     * @memberof PutPaymentRequestsBankAccountRequest
     */
    'branchName': string;
    /**
     * 
     * @type {string}
     * @memberof PutPaymentRequestsBankAccountRequest
     */
    'accountType': PutPaymentRequestsBankAccountRequestAccountTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof PutPaymentRequestsBankAccountRequest
     */
    'accountNumber': string;
    /**
     * 
     * @type {string}
     * @memberof PutPaymentRequestsBankAccountRequest
     */
    'companyCode': string | null;
    /**
     * 
     * @type {string}
     * @memberof PutPaymentRequestsBankAccountRequest
     */
    'companyName': string;
    /**
     * 
     * @type {PutPaymentRequestsBankAccountRequestTransferFeeCondition}
     * @memberof PutPaymentRequestsBankAccountRequest
     */
    'transferFeeCondition': PutPaymentRequestsBankAccountRequestTransferFeeCondition;
}

export const PutPaymentRequestsBankAccountRequestAccountTypeEnum = {
    savingsAccount: 'SAVINGS_ACCOUNT',
    currentAccount: 'CURRENT_ACCOUNT',
    other: 'OTHER'
} as const;

export type PutPaymentRequestsBankAccountRequestAccountTypeEnum = typeof PutPaymentRequestsBankAccountRequestAccountTypeEnum[keyof typeof PutPaymentRequestsBankAccountRequestAccountTypeEnum];

/**
 * 
 * @export
 * @interface PutPaymentRequestsBankAccountRequestTransferFeeCondition
 */
export interface PutPaymentRequestsBankAccountRequestTransferFeeCondition {
    /**
     * 
     * @type {number}
     * @memberof PutPaymentRequestsBankAccountRequestTransferFeeCondition
     */
    'threshold': number | null;
    /**
     * 
     * @type {PutPaymentRequestsBankAccountRequestTransferFeeConditionSameBranch}
     * @memberof PutPaymentRequestsBankAccountRequestTransferFeeCondition
     */
    'sameBranch': PutPaymentRequestsBankAccountRequestTransferFeeConditionSameBranch | null;
    /**
     * 
     * @type {PutPaymentRequestsBankAccountRequestTransferFeeConditionOtherBranch}
     * @memberof PutPaymentRequestsBankAccountRequestTransferFeeCondition
     */
    'otherBranch': PutPaymentRequestsBankAccountRequestTransferFeeConditionOtherBranch | null;
    /**
     * 
     * @type {PutPaymentRequestsBankAccountRequestTransferFeeConditionOtherBank}
     * @memberof PutPaymentRequestsBankAccountRequestTransferFeeCondition
     */
    'otherBank': PutPaymentRequestsBankAccountRequestTransferFeeConditionOtherBank | null;
}
/**
 * If the corresponding transferFeeCondition.threshold is specified, null is not allowed, otherwise only null is allowed.
 * @export
 * @interface PutPaymentRequestsBankAccountRequestTransferFeeConditionOtherBank
 */
export interface PutPaymentRequestsBankAccountRequestTransferFeeConditionOtherBank {
    /**
     * 
     * @type {number}
     * @memberof PutPaymentRequestsBankAccountRequestTransferFeeConditionOtherBank
     */
    'atLeast': number;
    /**
     * 
     * @type {number}
     * @memberof PutPaymentRequestsBankAccountRequestTransferFeeConditionOtherBank
     */
    'lessThan': number;
}
/**
 * If the corresponding transferFeeCondition.threshold is specified, null is not allowed, otherwise only null is allowed.
 * @export
 * @interface PutPaymentRequestsBankAccountRequestTransferFeeConditionOtherBranch
 */
export interface PutPaymentRequestsBankAccountRequestTransferFeeConditionOtherBranch {
    /**
     * 
     * @type {number}
     * @memberof PutPaymentRequestsBankAccountRequestTransferFeeConditionOtherBranch
     */
    'atLeast': number;
    /**
     * 
     * @type {number}
     * @memberof PutPaymentRequestsBankAccountRequestTransferFeeConditionOtherBranch
     */
    'lessThan': number;
}
/**
 * If the corresponding transferFeeCondition.threshold is specified, null is not allowed, otherwise only null is allowed.
 * @export
 * @interface PutPaymentRequestsBankAccountRequestTransferFeeConditionSameBranch
 */
export interface PutPaymentRequestsBankAccountRequestTransferFeeConditionSameBranch {
    /**
     * 
     * @type {number}
     * @memberof PutPaymentRequestsBankAccountRequestTransferFeeConditionSameBranch
     */
    'atLeast': number;
    /**
     * 
     * @type {number}
     * @memberof PutPaymentRequestsBankAccountRequestTransferFeeConditionSameBranch
     */
    'lessThan': number;
}
/**
 * 
 * @export
 * @interface PutTransactionEvidenceEmailsLinkToTransactionRequest
 */
export interface PutTransactionEvidenceEmailsLinkToTransactionRequest {
    /**
     * 
     * @type {string}
     * @memberof PutTransactionEvidenceEmailsLinkToTransactionRequest
     */
    'visaTransactionReferenceId': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PutTransactionEvidenceEmailsLinkToTransactionRequest
     */
    'transactionEvidenceEmailFileIdList': Array<string>;
}
/**
 * 
 * @export
 * @interface PutTransactionEvidenceEmailsMarkAsRead200Response
 */
export interface PutTransactionEvidenceEmailsMarkAsRead200Response {
    /**
     * 
     * @type {string}
     * @memberof PutTransactionEvidenceEmailsMarkAsRead200Response
     */
    'emailId': string;
    /**
     * 
     * @type {string}
     * @memberof PutTransactionEvidenceEmailsMarkAsRead200Response
     */
    'to': string;
    /**
     * 
     * @type {string}
     * @memberof PutTransactionEvidenceEmailsMarkAsRead200Response
     */
    'from': string;
    /**
     * 
     * @type {boolean}
     * @memberof PutTransactionEvidenceEmailsMarkAsRead200Response
     */
    'read': boolean;
    /**
     * 
     * @type {string}
     * @memberof PutTransactionEvidenceEmailsMarkAsRead200Response
     */
    'subject': string;
}
/**
 * 
 * @export
 * @interface PutTransactionEvidenceEmailsMarkAsReadRequest
 */
export interface PutTransactionEvidenceEmailsMarkAsReadRequest {
    /**
     * 
     * @type {string}
     * @memberof PutTransactionEvidenceEmailsMarkAsReadRequest
     */
    'emailId': string;
    /**
     * 
     * @type {boolean}
     * @memberof PutTransactionEvidenceEmailsMarkAsReadRequest
     */
    'markRead': boolean;
}
/**
 * 
 * @export
 * @interface PutTransactionEvidenceEmailsMoveToTrashRequest
 */
export interface PutTransactionEvidenceEmailsMoveToTrashRequest {
    /**
     * 
     * @type {string}
     * @memberof PutTransactionEvidenceEmailsMoveToTrashRequest
     */
    'transactionEvidenceEmailId': string;
    /**
     * 
     * @type {string}
     * @memberof PutTransactionEvidenceEmailsMoveToTrashRequest
     */
    'userAccountId': string;
}
/**
 * 
 * @export
 * @interface PutZeusGiveRewardPointsRequest
 */
export interface PutZeusGiveRewardPointsRequest {
    /**
     * ポイント数
     * @type {number}
     * @memberof PutZeusGiveRewardPointsRequest
     */
    'amount': number;
    /**
     * 表示名
     * @type {string}
     * @memberof PutZeusGiveRewardPointsRequest
     */
    'description': string;
    /**
     * メモ
     * @type {string}
     * @memberof PutZeusGiveRewardPointsRequest
     */
    'memo'?: string;
}
/**
 * 
 * @export
 * @interface QualifiedInvoiceIssuer
 */
export interface QualifiedInvoiceIssuer {
    /**
     * 
     * @type {string}
     * @memberof QualifiedInvoiceIssuer
     */
    'registrationNumber': string;
    /**
     * 
     * @type {string}
     * @memberof QualifiedInvoiceIssuer
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof QualifiedInvoiceIssuer
     */
    'kana': string;
    /**
     * 
     * @type {boolean}
     * @memberof QualifiedInvoiceIssuer
     */
    'isQualified': boolean;
    /**
     * 
     * @type {string}
     * @memberof QualifiedInvoiceIssuer
     */
    'registrationDate': string;
}
/**
 * 
 * @export
 * @interface QueryByIdsPaymentRequests200ResponseInner
 */
export interface QueryByIdsPaymentRequests200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof QueryByIdsPaymentRequests200ResponseInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof QueryByIdsPaymentRequests200ResponseInner
     */
    'serialNumber': string;
    /**
     * 
     * @type {QueryByIdsPaymentRequests200ResponseInnerSupplier}
     * @memberof QueryByIdsPaymentRequests200ResponseInner
     */
    'supplier': QueryByIdsPaymentRequests200ResponseInnerSupplier;
    /**
     * 
     * @type {string}
     * @memberof QueryByIdsPaymentRequests200ResponseInner
     */
    'dueDate': string;
    /**
     * 
     * @type {number}
     * @memberof QueryByIdsPaymentRequests200ResponseInner
     */
    'totalAmount': number;
    /**
     * 
     * @type {string}
     * @memberof QueryByIdsPaymentRequests200ResponseInner
     */
    'transferFeeResponsibility': QueryByIdsPaymentRequests200ResponseInnerTransferFeeResponsibilityEnum;
    /**
     * 
     * @type {string}
     * @memberof QueryByIdsPaymentRequests200ResponseInner
     */
    'memo': string | null;
    /**
     * 
     * @type {string}
     * @memberof QueryByIdsPaymentRequests200ResponseInner
     */
    'withholdingCalculatingMethod': QueryByIdsPaymentRequests200ResponseInnerWithholdingCalculatingMethodEnum;
    /**
     * 
     * @type {number}
     * @memberof QueryByIdsPaymentRequests200ResponseInner
     */
    'withholdingAmount': number | null;
    /**
     * 
     * @type {string}
     * @memberof QueryByIdsPaymentRequests200ResponseInner
     */
    'status': QueryByIdsPaymentRequests200ResponseInnerStatusEnum;
    /**
     * 
     * @type {QueryByIdsPaymentRequests200ResponseInnerRequestor}
     * @memberof QueryByIdsPaymentRequests200ResponseInner
     */
    'requestor': QueryByIdsPaymentRequests200ResponseInnerRequestor;
    /**
     * requestorName is the name of the requesting user at the time this PaymentRequest was requested. The free word search targets the name of requesting user, but it is the requestorName that is targeted, not the name of the user at the time of the search. Use requestor.name if you want to know what is the name at present of the user.
     * @type {string}
     * @memberof QueryByIdsPaymentRequests200ResponseInner
     */
    'requestorName': string;
    /**
     * 
     * @type {string}
     * @memberof QueryByIdsPaymentRequests200ResponseInner
     */
    'requestedAt': string;
    /**
     * If bank transfer data has already been created, return the ID. Otherwise, null.
     * @type {string}
     * @memberof QueryByIdsPaymentRequests200ResponseInner
     */
    'bankTransferId': string | null;
    /**
     * 
     * @type {string}
     * @memberof QueryByIdsPaymentRequests200ResponseInner
     */
    'invoiceEvidenceId': string;
}

export const QueryByIdsPaymentRequests200ResponseInnerTransferFeeResponsibilityEnum = {
    self: 'SELF',
    supplier: 'SUPPLIER'
} as const;

export type QueryByIdsPaymentRequests200ResponseInnerTransferFeeResponsibilityEnum = typeof QueryByIdsPaymentRequests200ResponseInnerTransferFeeResponsibilityEnum[keyof typeof QueryByIdsPaymentRequests200ResponseInnerTransferFeeResponsibilityEnum];
export const QueryByIdsPaymentRequests200ResponseInnerWithholdingCalculatingMethodEnum = {
    none: 'NONE',
    manuscriptOrLecture: 'MANUSCRIPT_OR_LECTURE',
    lawyerOrCpa: 'LAWYER_OR_CPA',
    judicialScrivener: 'JUDICIAL_SCRIVENER',
    other: 'OTHER'
} as const;

export type QueryByIdsPaymentRequests200ResponseInnerWithholdingCalculatingMethodEnum = typeof QueryByIdsPaymentRequests200ResponseInnerWithholdingCalculatingMethodEnum[keyof typeof QueryByIdsPaymentRequests200ResponseInnerWithholdingCalculatingMethodEnum];
export const QueryByIdsPaymentRequests200ResponseInnerStatusEnum = {
    pendingWorkflowCompletion: 'PENDING_WORKFLOW_COMPLETION',
    canceled: 'CANCELED',
    payable: 'PAYABLE',
    attachedToBankTransfer: 'ATTACHED_TO_BANK_TRANSFER',
    deactivated: 'DEACTIVATED'
} as const;

export type QueryByIdsPaymentRequests200ResponseInnerStatusEnum = typeof QueryByIdsPaymentRequests200ResponseInnerStatusEnum[keyof typeof QueryByIdsPaymentRequests200ResponseInnerStatusEnum];

/**
 * 
 * @export
 * @interface QueryByIdsPaymentRequests200ResponseInnerRequestor
 */
export interface QueryByIdsPaymentRequests200ResponseInnerRequestor {
    /**
     * 
     * @type {string}
     * @memberof QueryByIdsPaymentRequests200ResponseInnerRequestor
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof QueryByIdsPaymentRequests200ResponseInnerRequestor
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface QueryByIdsPaymentRequests200ResponseInnerSupplier
 */
export interface QueryByIdsPaymentRequests200ResponseInnerSupplier {
    /**
     * 
     * @type {string}
     * @memberof QueryByIdsPaymentRequests200ResponseInnerSupplier
     */
    'partnerId': string | null;
    /**
     * 
     * @type {string}
     * @memberof QueryByIdsPaymentRequests200ResponseInnerSupplier
     */
    'name': string;
    /**
     * 
     * @type {QueryByIdsPaymentRequests200ResponseInnerSupplierBankAccount}
     * @memberof QueryByIdsPaymentRequests200ResponseInnerSupplier
     */
    'bankAccount': QueryByIdsPaymentRequests200ResponseInnerSupplierBankAccount;
}
/**
 * 
 * @export
 * @interface QueryByIdsPaymentRequests200ResponseInnerSupplierBankAccount
 */
export interface QueryByIdsPaymentRequests200ResponseInnerSupplierBankAccount {
    /**
     * 
     * @type {string}
     * @memberof QueryByIdsPaymentRequests200ResponseInnerSupplierBankAccount
     */
    'bankNumber': string;
    /**
     * 
     * @type {string}
     * @memberof QueryByIdsPaymentRequests200ResponseInnerSupplierBankAccount
     */
    'bankName': string;
    /**
     * 
     * @type {string}
     * @memberof QueryByIdsPaymentRequests200ResponseInnerSupplierBankAccount
     */
    'branchNumber': string;
    /**
     * 
     * @type {string}
     * @memberof QueryByIdsPaymentRequests200ResponseInnerSupplierBankAccount
     */
    'branchName': string;
    /**
     * 
     * @type {string}
     * @memberof QueryByIdsPaymentRequests200ResponseInnerSupplierBankAccount
     */
    'accountType': QueryByIdsPaymentRequests200ResponseInnerSupplierBankAccountAccountTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof QueryByIdsPaymentRequests200ResponseInnerSupplierBankAccount
     */
    'accountNumber': string;
    /**
     * 
     * @type {string}
     * @memberof QueryByIdsPaymentRequests200ResponseInnerSupplierBankAccount
     */
    'companyCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof QueryByIdsPaymentRequests200ResponseInnerSupplierBankAccount
     */
    'companyName': string;
}

export const QueryByIdsPaymentRequests200ResponseInnerSupplierBankAccountAccountTypeEnum = {
    savingsAccount: 'SAVINGS_ACCOUNT',
    currentAccount: 'CURRENT_ACCOUNT',
    thriftAccount: 'THRIFT_ACCOUNT',
    other: 'OTHER'
} as const;

export type QueryByIdsPaymentRequests200ResponseInnerSupplierBankAccountAccountTypeEnum = typeof QueryByIdsPaymentRequests200ResponseInnerSupplierBankAccountAccountTypeEnum[keyof typeof QueryByIdsPaymentRequests200ResponseInnerSupplierBankAccountAccountTypeEnum];

/**
 * 
 * @export
 * @interface QueryByIdsPaymentRequestsRequest
 */
export interface QueryByIdsPaymentRequestsRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof QueryByIdsPaymentRequestsRequest
     */
    'paymentRequestIds': Array<string>;
}
/**
 * 
 * @export
 * @interface RateConfig
 */
export interface RateConfig {
    /**
     * 
     * @type {string}
     * @memberof RateConfig
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof RateConfig
     */
    'organizationId'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof RateConfig
     */
    'preferential': boolean;
    /**
     * 
     * @type {RateConfigRule}
     * @memberof RateConfig
     */
    'rule'?: RateConfigRule | null;
    /**
     * 
     * @type {RateConfigRuleSet}
     * @memberof RateConfig
     */
    'ruleSet'?: RateConfigRuleSet | null;
    /**
     * 
     * @type {string}
     * @memberof RateConfig
     */
    'startAt': string;
    /**
     * 
     * @type {string}
     * @memberof RateConfig
     */
    'endAt': string;
}
/**
 * 
 * @export
 * @interface RateConfigRule
 */
export interface RateConfigRule {
    /**
     * 
     * @type {string}
     * @memberof RateConfigRule
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof RateConfigRule
     */
    'code': string;
    /**
     * 
     * @type {number}
     * @memberof RateConfigRule
     */
    'rate': number;
    /**
     * 
     * @type {string}
     * @memberof RateConfigRule
     */
    'merchantCategoryCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RateConfigRule
     */
    'merchantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RateConfigRule
     */
    'binSponsor'?: RateConfigRuleBinSponsorEnum;
    /**
     * 
     * @type {string}
     * @memberof RateConfigRule
     */
    'creditOrPrepaid'?: RateConfigRuleCreditOrPrepaidEnum;
    /**
     * 
     * @type {number}
     * @memberof RateConfigRule
     */
    'minimumTotalAmount': number;
}

export const RateConfigRuleBinSponsorEnum = {
    lc: 'LC',
    cs: 'CS'
} as const;

export type RateConfigRuleBinSponsorEnum = typeof RateConfigRuleBinSponsorEnum[keyof typeof RateConfigRuleBinSponsorEnum];
export const RateConfigRuleCreditOrPrepaidEnum = {
    credit: 'CREDIT',
    prepaid: 'PREPAID'
} as const;

export type RateConfigRuleCreditOrPrepaidEnum = typeof RateConfigRuleCreditOrPrepaidEnum[keyof typeof RateConfigRuleCreditOrPrepaidEnum];

/**
 * 
 * @export
 * @interface RateConfigRuleSet
 */
export interface RateConfigRuleSet {
    /**
     * 
     * @type {string}
     * @memberof RateConfigRuleSet
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof RateConfigRuleSet
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof RateConfigRuleSet
     */
    'description': string;
    /**
     * 
     * @type {Array<RateConfigRuleSetRulesInner>}
     * @memberof RateConfigRuleSet
     */
    'rules': Array<RateConfigRuleSetRulesInner>;
}
/**
 * 
 * @export
 * @interface RateConfigRuleSetRulesInner
 */
export interface RateConfigRuleSetRulesInner {
    /**
     * 
     * @type {string}
     * @memberof RateConfigRuleSetRulesInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof RateConfigRuleSetRulesInner
     */
    'code': string;
    /**
     * 
     * @type {number}
     * @memberof RateConfigRuleSetRulesInner
     */
    'rate': number;
    /**
     * 
     * @type {string}
     * @memberof RateConfigRuleSetRulesInner
     */
    'merchantCategoryCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RateConfigRuleSetRulesInner
     */
    'merchantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RateConfigRuleSetRulesInner
     */
    'binSponsor'?: RateConfigRuleSetRulesInnerBinSponsorEnum;
    /**
     * 
     * @type {string}
     * @memberof RateConfigRuleSetRulesInner
     */
    'creditOrPrepaid'?: RateConfigRuleSetRulesInnerCreditOrPrepaidEnum;
    /**
     * 
     * @type {number}
     * @memberof RateConfigRuleSetRulesInner
     */
    'minimumTotalAmount': number;
}

export const RateConfigRuleSetRulesInnerBinSponsorEnum = {
    lc: 'LC',
    cs: 'CS'
} as const;

export type RateConfigRuleSetRulesInnerBinSponsorEnum = typeof RateConfigRuleSetRulesInnerBinSponsorEnum[keyof typeof RateConfigRuleSetRulesInnerBinSponsorEnum];
export const RateConfigRuleSetRulesInnerCreditOrPrepaidEnum = {
    credit: 'CREDIT',
    prepaid: 'PREPAID'
} as const;

export type RateConfigRuleSetRulesInnerCreditOrPrepaidEnum = typeof RateConfigRuleSetRulesInnerCreditOrPrepaidEnum[keyof typeof RateConfigRuleSetRulesInnerCreditOrPrepaidEnum];

/**
 * 
 * @export
 * @interface RateRule
 */
export interface RateRule {
    /**
     * 
     * @type {string}
     * @memberof RateRule
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof RateRule
     */
    'code': string;
    /**
     * 
     * @type {number}
     * @memberof RateRule
     */
    'rate': number;
    /**
     * 
     * @type {string}
     * @memberof RateRule
     */
    'merchantCategoryCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RateRule
     */
    'merchantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RateRule
     */
    'binSponsor'?: RateRuleBinSponsorEnum;
    /**
     * 
     * @type {string}
     * @memberof RateRule
     */
    'creditOrPrepaid'?: RateRuleCreditOrPrepaidEnum;
    /**
     * 
     * @type {number}
     * @memberof RateRule
     */
    'minimumTotalAmount': number;
}

export const RateRuleBinSponsorEnum = {
    lc: 'LC',
    cs: 'CS'
} as const;

export type RateRuleBinSponsorEnum = typeof RateRuleBinSponsorEnum[keyof typeof RateRuleBinSponsorEnum];
export const RateRuleCreditOrPrepaidEnum = {
    credit: 'CREDIT',
    prepaid: 'PREPAID'
} as const;

export type RateRuleCreditOrPrepaidEnum = typeof RateRuleCreditOrPrepaidEnum[keyof typeof RateRuleCreditOrPrepaidEnum];

/**
 * 
 * @export
 * @interface RateRuleSet
 */
export interface RateRuleSet {
    /**
     * 
     * @type {string}
     * @memberof RateRuleSet
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof RateRuleSet
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof RateRuleSet
     */
    'description': string;
    /**
     * 
     * @type {Array<RateRuleSetRulesInner>}
     * @memberof RateRuleSet
     */
    'rules': Array<RateRuleSetRulesInner>;
}
/**
 * 
 * @export
 * @interface RateRuleSetRulesInner
 */
export interface RateRuleSetRulesInner {
    /**
     * 
     * @type {string}
     * @memberof RateRuleSetRulesInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof RateRuleSetRulesInner
     */
    'code': string;
    /**
     * 
     * @type {number}
     * @memberof RateRuleSetRulesInner
     */
    'rate': number;
    /**
     * 
     * @type {string}
     * @memberof RateRuleSetRulesInner
     */
    'merchantCategoryCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RateRuleSetRulesInner
     */
    'merchantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RateRuleSetRulesInner
     */
    'binSponsor'?: RateRuleSetRulesInnerBinSponsorEnum;
    /**
     * 
     * @type {string}
     * @memberof RateRuleSetRulesInner
     */
    'creditOrPrepaid'?: RateRuleSetRulesInnerCreditOrPrepaidEnum;
    /**
     * 
     * @type {number}
     * @memberof RateRuleSetRulesInner
     */
    'minimumTotalAmount': number;
}

export const RateRuleSetRulesInnerBinSponsorEnum = {
    lc: 'LC',
    cs: 'CS'
} as const;

export type RateRuleSetRulesInnerBinSponsorEnum = typeof RateRuleSetRulesInnerBinSponsorEnum[keyof typeof RateRuleSetRulesInnerBinSponsorEnum];
export const RateRuleSetRulesInnerCreditOrPrepaidEnum = {
    credit: 'CREDIT',
    prepaid: 'PREPAID'
} as const;

export type RateRuleSetRulesInnerCreditOrPrepaidEnum = typeof RateRuleSetRulesInnerCreditOrPrepaidEnum[keyof typeof RateRuleSetRulesInnerCreditOrPrepaidEnum];

/**
 * 
 * @export
 * @interface RegisterNoteForOrganizationIdentityVerification200Response
 */
export interface RegisterNoteForOrganizationIdentityVerification200Response {
    /**
     * 
     * @type {string}
     * @memberof RegisterNoteForOrganizationIdentityVerification200Response
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof RegisterNoteForOrganizationIdentityVerification200Response
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof RegisterNoteForOrganizationIdentityVerification200Response
     */
    'organizationCreateRequestId': string | null;
    /**
     * 
     * @type {string}
     * @memberof RegisterNoteForOrganizationIdentityVerification200Response
     */
    'organizationName': string;
    /**
     * 
     * @type {string}
     * @memberof RegisterNoteForOrganizationIdentityVerification200Response
     */
    'corporateNumber': string;
    /**
     * 
     * @type {number}
     * @memberof RegisterNoteForOrganizationIdentityVerification200Response
     */
    'businessDescriptionId': number;
    /**
     * 
     * @type {number}
     * @memberof RegisterNoteForOrganizationIdentityVerification200Response
     */
    'purposeTransaction': number;
    /**
     * 
     * @type {string}
     * @memberof RegisterNoteForOrganizationIdentityVerification200Response
     */
    'purposeTransactionOther': string | null;
    /**
     * 
     * @type {string}
     * @memberof RegisterNoteForOrganizationIdentityVerification200Response
     */
    'postalCode': string;
    /**
     * 
     * @type {string}
     * @memberof RegisterNoteForOrganizationIdentityVerification200Response
     */
    'address': string;
    /**
     * 
     * @type {string}
     * @memberof RegisterNoteForOrganizationIdentityVerification200Response
     */
    'phoneNumber': string;
    /**
     * 
     * @type {string}
     * @memberof RegisterNoteForOrganizationIdentityVerification200Response
     */
    'representativeName': string;
    /**
     * 
     * @type {boolean}
     * @memberof RegisterNoteForOrganizationIdentityVerification200Response
     */
    'isExistsBeneficialOwner': boolean;
    /**
     * 
     * @type {string}
     * @memberof RegisterNoteForOrganizationIdentityVerification200Response
     */
    'corporateType': string | null;
    /**
     * 
     * @type {Array<RegisterNoteForOrganizationIdentityVerification200ResponseBeneficialOwnersInner>}
     * @memberof RegisterNoteForOrganizationIdentityVerification200Response
     */
    'beneficialOwners': Array<RegisterNoteForOrganizationIdentityVerification200ResponseBeneficialOwnersInner>;
    /**
     * 
     * @type {boolean}
     * @memberof RegisterNoteForOrganizationIdentityVerification200Response
     */
    'isRepresentative': boolean;
    /**
     * 
     * @type {string}
     * @memberof RegisterNoteForOrganizationIdentityVerification200Response
     */
    'transactionManagerName': string;
    /**
     * 
     * @type {string}
     * @memberof RegisterNoteForOrganizationIdentityVerification200Response
     */
    'transactionManagerBirthday': string;
    /**
     * 
     * @type {string}
     * @memberof RegisterNoteForOrganizationIdentityVerification200Response
     */
    'transactionManagerAddress': string;
    /**
     * 
     * @type {string}
     * @memberof RegisterNoteForOrganizationIdentityVerification200Response
     */
    'transactionManagerEmail': string;
    /**
     * 
     * @type {string}
     * @memberof RegisterNoteForOrganizationIdentityVerification200Response
     */
    'note': string | null;
    /**
     * 
     * @type {RegisterNoteForOrganizationIdentityVerification200ResponseStatus}
     * @memberof RegisterNoteForOrganizationIdentityVerification200Response
     */
    'status': RegisterNoteForOrganizationIdentityVerification200ResponseStatus | null;
    /**
     * 
     * @type {Array<RegisterNoteForOrganizationIdentityVerification200ResponseIdentificationInner>}
     * @memberof RegisterNoteForOrganizationIdentityVerification200Response
     */
    'identification': Array<RegisterNoteForOrganizationIdentityVerification200ResponseIdentificationInner>;
    /**
     * 
     * @type {Array<RegisterNoteForOrganizationIdentityVerification200ResponseAntisocialForcesCheckInner>}
     * @memberof RegisterNoteForOrganizationIdentityVerification200Response
     */
    'antisocialForcesCheck': Array<RegisterNoteForOrganizationIdentityVerification200ResponseAntisocialForcesCheckInner>;
    /**
     * 
     * @type {Array<RegisterNoteForOrganizationIdentityVerification200ResponseSnailMailVerificationInner>}
     * @memberof RegisterNoteForOrganizationIdentityVerification200Response
     */
    'snailMailVerification': Array<RegisterNoteForOrganizationIdentityVerification200ResponseSnailMailVerificationInner> | null;
    /**
     * 
     * @type {string}
     * @memberof RegisterNoteForOrganizationIdentityVerification200Response
     */
    'createdAt': string;
}
/**
 * 
 * @export
 * @interface RegisterNoteForOrganizationIdentityVerification200ResponseAntisocialForcesCheckInner
 */
export interface RegisterNoteForOrganizationIdentityVerification200ResponseAntisocialForcesCheckInner {
    /**
     * 
     * @type {string}
     * @memberof RegisterNoteForOrganizationIdentityVerification200ResponseAntisocialForcesCheckInner
     */
    'organizationIdentityVerificationId': string;
    /**
     * 
     * @type {string}
     * @memberof RegisterNoteForOrganizationIdentityVerification200ResponseAntisocialForcesCheckInner
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof RegisterNoteForOrganizationIdentityVerification200ResponseAntisocialForcesCheckInner
     */
    'payloadId': string;
    /**
     * 
     * @type {number}
     * @memberof RegisterNoteForOrganizationIdentityVerification200ResponseAntisocialForcesCheckInner
     */
    'payloadDetailId': number;
    /**
     * 
     * @type {string}
     * @memberof RegisterNoteForOrganizationIdentityVerification200ResponseAntisocialForcesCheckInner
     */
    'category': string;
    /**
     * 
     * @type {object}
     * @memberof RegisterNoteForOrganizationIdentityVerification200ResponseAntisocialForcesCheckInner
     */
    'condition'?: object;
    /**
     * 
     * @type {Array<object>}
     * @memberof RegisterNoteForOrganizationIdentityVerification200ResponseAntisocialForcesCheckInner
     */
    'results'?: Array<object> | null;
}
/**
 * 
 * @export
 * @interface RegisterNoteForOrganizationIdentityVerification200ResponseBeneficialOwnersInner
 */
export interface RegisterNoteForOrganizationIdentityVerification200ResponseBeneficialOwnersInner {
    /**
     * 
     * @type {string}
     * @memberof RegisterNoteForOrganizationIdentityVerification200ResponseBeneficialOwnersInner
     */
    'corporateRelationships'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RegisterNoteForOrganizationIdentityVerification200ResponseBeneficialOwnersInner
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof RegisterNoteForOrganizationIdentityVerification200ResponseBeneficialOwnersInner
     */
    'beneficialOwnerType': string;
    /**
     * 
     * @type {string}
     * @memberof RegisterNoteForOrganizationIdentityVerification200ResponseBeneficialOwnersInner
     */
    'gender': string;
    /**
     * 
     * @type {string}
     * @memberof RegisterNoteForOrganizationIdentityVerification200ResponseBeneficialOwnersInner
     */
    'birthday': string;
    /**
     * 
     * @type {string}
     * @memberof RegisterNoteForOrganizationIdentityVerification200ResponseBeneficialOwnersInner
     */
    'countryResidence': string;
    /**
     * 
     * @type {string}
     * @memberof RegisterNoteForOrganizationIdentityVerification200ResponseBeneficialOwnersInner
     */
    'address': string;
    /**
     * 
     * @type {boolean}
     * @memberof RegisterNoteForOrganizationIdentityVerification200ResponseBeneficialOwnersInner
     */
    'isPoliticallyExposedPersons': boolean;
}
/**
 * 
 * @export
 * @interface RegisterNoteForOrganizationIdentityVerification200ResponseIdentificationInner
 */
export interface RegisterNoteForOrganizationIdentityVerification200ResponseIdentificationInner {
    /**
     * 
     * @type {string}
     * @memberof RegisterNoteForOrganizationIdentityVerification200ResponseIdentificationInner
     */
    'trustdockIdentificationId': string;
    /**
     * 
     * @type {string}
     * @memberof RegisterNoteForOrganizationIdentityVerification200ResponseIdentificationInner
     */
    'state': string;
    /**
     * 
     * @type {string}
     * @memberof RegisterNoteForOrganizationIdentityVerification200ResponseIdentificationInner
     */
    'result': string | null;
    /**
     * 
     * @type {Array<RegisterNoteForOrganizationIdentityVerification200ResponseIdentificationInnerRecordsInner>}
     * @memberof RegisterNoteForOrganizationIdentityVerification200ResponseIdentificationInner
     */
    'records'?: Array<RegisterNoteForOrganizationIdentityVerification200ResponseIdentificationInnerRecordsInner> | null;
}
/**
 * 
 * @export
 * @interface RegisterNoteForOrganizationIdentityVerification200ResponseIdentificationInnerRecordsInner
 */
export interface RegisterNoteForOrganizationIdentityVerification200ResponseIdentificationInnerRecordsInner {
    /**
     * 
     * @type {string}
     * @memberof RegisterNoteForOrganizationIdentityVerification200ResponseIdentificationInnerRecordsInner
     */
    'state': string;
    /**
     * 
     * @type {string}
     * @memberof RegisterNoteForOrganizationIdentityVerification200ResponseIdentificationInnerRecordsInner
     */
    'result': string | null;
    /**
     * 
     * @type {string}
     * @memberof RegisterNoteForOrganizationIdentityVerification200ResponseIdentificationInnerRecordsInner
     */
    'planId'?: string;
    /**
     * 
     * @type {string}
     * @memberof RegisterNoteForOrganizationIdentityVerification200ResponseIdentificationInnerRecordsInner
     */
    'plan'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof RegisterNoteForOrganizationIdentityVerification200ResponseIdentificationInnerRecordsInner
     */
    'reasons'?: Array<string>;
}
/**
 * 
 * @export
 * @interface RegisterNoteForOrganizationIdentityVerification200ResponseSnailMailVerificationInner
 */
export interface RegisterNoteForOrganizationIdentityVerification200ResponseSnailMailVerificationInner {
    /**
     * 
     * @type {string}
     * @memberof RegisterNoteForOrganizationIdentityVerification200ResponseSnailMailVerificationInner
     */
    'organizationIdentityVerificationId': string;
    /**
     * 
     * @type {string}
     * @memberof RegisterNoteForOrganizationIdentityVerification200ResponseSnailMailVerificationInner
     */
    'snailMailVerificationId': string;
    /**
     * 
     * @type {string}
     * @memberof RegisterNoteForOrganizationIdentityVerification200ResponseSnailMailVerificationInner
     */
    'result': string;
    /**
     * 
     * @type {string}
     * @memberof RegisterNoteForOrganizationIdentityVerification200ResponseSnailMailVerificationInner
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof RegisterNoteForOrganizationIdentityVerification200ResponseSnailMailVerificationInner
     */
    'detail': string;
    /**
     * 
     * @type {string}
     * @memberof RegisterNoteForOrganizationIdentityVerification200ResponseSnailMailVerificationInner
     */
    'inquiryNumber': string;
    /**
     * 
     * @type {string}
     * @memberof RegisterNoteForOrganizationIdentityVerification200ResponseSnailMailVerificationInner
     */
    'acceptAt': string;
    /**
     * 
     * @type {string}
     * @memberof RegisterNoteForOrganizationIdentityVerification200ResponseSnailMailVerificationInner
     */
    'confirmedAt': string;
    /**
     * 
     * @type {string}
     * @memberof RegisterNoteForOrganizationIdentityVerification200ResponseSnailMailVerificationInner
     */
    'confirmedBy': string | null;
}
/**
 * 
 * @export
 * @interface RegisterNoteForOrganizationIdentityVerification200ResponseStatus
 */
export interface RegisterNoteForOrganizationIdentityVerification200ResponseStatus {
    /**
     * 
     * @type {string}
     * @memberof RegisterNoteForOrganizationIdentityVerification200ResponseStatus
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof RegisterNoteForOrganizationIdentityVerification200ResponseStatus
     */
    'statusChangedUserId'?: string;
    /**
     * 
     * @type {string}
     * @memberof RegisterNoteForOrganizationIdentityVerification200ResponseStatus
     */
    'statusChangedUserName': string;
    /**
     * 
     * @type {string}
     * @memberof RegisterNoteForOrganizationIdentityVerification200ResponseStatus
     */
    'statusChangedAt': string;
}
/**
 * 
 * @export
 * @interface RegisterNoteForOrganizationIdentityVerificationRequest
 */
export interface RegisterNoteForOrganizationIdentityVerificationRequest {
    /**
     * 
     * @type {string}
     * @memberof RegisterNoteForOrganizationIdentityVerificationRequest
     */
    'note': string;
}
/**
 * 
 * @export
 * @interface RegisterNoteRequest
 */
export interface RegisterNoteRequest {
    /**
     * 
     * @type {string}
     * @memberof RegisterNoteRequest
     */
    'note': string;
}
/**
 * 
 * @export
 * @interface RegisterOrganizationChartForWorkflowRequest
 */
export interface RegisterOrganizationChartForWorkflowRequest {
    /**
     * 
     * @type {Array<RegisterOrganizationChartForWorkflowRequestDepartmentsInner>}
     * @memberof RegisterOrganizationChartForWorkflowRequest
     */
    'departments': Array<RegisterOrganizationChartForWorkflowRequestDepartmentsInner>;
    /**
     * 
     * @type {Array<RegisterOrganizationChartForWorkflowRequestEmployeesInner>}
     * @memberof RegisterOrganizationChartForWorkflowRequest
     */
    'employees': Array<RegisterOrganizationChartForWorkflowRequestEmployeesInner>;
    /**
     * 
     * @type {Array<RegisterOrganizationChartForWorkflowRequestRolesInner>}
     * @memberof RegisterOrganizationChartForWorkflowRequest
     */
    'roles': Array<RegisterOrganizationChartForWorkflowRequestRolesInner>;
}
/**
 * 
 * @export
 * @interface RegisterOrganizationChartForWorkflowRequestDepartmentsInner
 */
export interface RegisterOrganizationChartForWorkflowRequestDepartmentsInner {
    /**
     * 
     * @type {string}
     * @memberof RegisterOrganizationChartForWorkflowRequestDepartmentsInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof RegisterOrganizationChartForWorkflowRequestDepartmentsInner
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface RegisterOrganizationChartForWorkflowRequestEmployeesInner
 */
export interface RegisterOrganizationChartForWorkflowRequestEmployeesInner {
    /**
     * 
     * @type {string}
     * @memberof RegisterOrganizationChartForWorkflowRequestEmployeesInner
     */
    'name': string;
    /**
     * Indicates the role to which the employee has, the employee may have more than one role, and contains the corresponding IDs of the roles.
     * @type {Array<string>}
     * @memberof RegisterOrganizationChartForWorkflowRequestEmployeesInner
     */
    'roleIds': Array<string>;
    /**
     * Indicates the department to which the employee belongs, the employee may belong to more than one department, and contains the corresponding IDs of the department.
     * @type {Array<string>}
     * @memberof RegisterOrganizationChartForWorkflowRequestEmployeesInner
     */
    'departmentIds': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof RegisterOrganizationChartForWorkflowRequestEmployeesInner
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof RegisterOrganizationChartForWorkflowRequestEmployeesInner
     */
    'slackUserId': string | null;
}
/**
 * 
 * @export
 * @interface RegisterOrganizationChartForWorkflowRequestRolesInner
 */
export interface RegisterOrganizationChartForWorkflowRequestRolesInner {
    /**
     * 
     * @type {string}
     * @memberof RegisterOrganizationChartForWorkflowRequestRolesInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof RegisterOrganizationChartForWorkflowRequestRolesInner
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface RegisterTfaAppVerificationCode200Response
 */
export interface RegisterTfaAppVerificationCode200Response {
    /**
     * 
     * @type {string}
     * @memberof RegisterTfaAppVerificationCode200Response
     */
    'token': string;
}
/**
 * 
 * @export
 * @interface RegisterTfaAppVerificationCodeRequest
 */
export interface RegisterTfaAppVerificationCodeRequest {
    /**
     * 
     * @type {number}
     * @memberof RegisterTfaAppVerificationCodeRequest
     */
    'verificationCode': number;
}
/**
 * 
 * @export
 * @interface RegisterTfaSmsAuth200Response
 */
export interface RegisterTfaSmsAuth200Response {
    /**
     * 
     * @type {string}
     * @memberof RegisterTfaSmsAuth200Response
     */
    'token': string;
}
/**
 * 
 * @export
 * @interface RegisterTfaSmsAuthRequest
 */
export interface RegisterTfaSmsAuthRequest {
    /**
     * 
     * @type {string}
     * @memberof RegisterTfaSmsAuthRequest
     */
    'idToken': string;
}
/**
 * 
 * @export
 * @interface RejectOrganizationIdentityVerification200Response
 */
export interface RejectOrganizationIdentityVerification200Response {
    /**
     * 
     * @type {string}
     * @memberof RejectOrganizationIdentityVerification200Response
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof RejectOrganizationIdentityVerification200Response
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof RejectOrganizationIdentityVerification200Response
     */
    'organizationCreateRequestId': string | null;
    /**
     * 
     * @type {string}
     * @memberof RejectOrganizationIdentityVerification200Response
     */
    'organizationName': string;
    /**
     * 
     * @type {string}
     * @memberof RejectOrganizationIdentityVerification200Response
     */
    'corporateNumber': string;
    /**
     * 
     * @type {number}
     * @memberof RejectOrganizationIdentityVerification200Response
     */
    'businessDescriptionId': number;
    /**
     * 
     * @type {number}
     * @memberof RejectOrganizationIdentityVerification200Response
     */
    'purposeTransaction': number;
    /**
     * 
     * @type {string}
     * @memberof RejectOrganizationIdentityVerification200Response
     */
    'purposeTransactionOther': string | null;
    /**
     * 
     * @type {string}
     * @memberof RejectOrganizationIdentityVerification200Response
     */
    'postalCode': string;
    /**
     * 
     * @type {string}
     * @memberof RejectOrganizationIdentityVerification200Response
     */
    'address': string;
    /**
     * 
     * @type {string}
     * @memberof RejectOrganizationIdentityVerification200Response
     */
    'phoneNumber': string;
    /**
     * 
     * @type {string}
     * @memberof RejectOrganizationIdentityVerification200Response
     */
    'representativeName': string;
    /**
     * 
     * @type {boolean}
     * @memberof RejectOrganizationIdentityVerification200Response
     */
    'isExistsBeneficialOwner': boolean;
    /**
     * 
     * @type {string}
     * @memberof RejectOrganizationIdentityVerification200Response
     */
    'corporateType': string | null;
    /**
     * 
     * @type {Array<RejectOrganizationIdentityVerification200ResponseBeneficialOwnersInner>}
     * @memberof RejectOrganizationIdentityVerification200Response
     */
    'beneficialOwners': Array<RejectOrganizationIdentityVerification200ResponseBeneficialOwnersInner>;
    /**
     * 
     * @type {boolean}
     * @memberof RejectOrganizationIdentityVerification200Response
     */
    'isRepresentative': boolean;
    /**
     * 
     * @type {string}
     * @memberof RejectOrganizationIdentityVerification200Response
     */
    'transactionManagerName': string;
    /**
     * 
     * @type {string}
     * @memberof RejectOrganizationIdentityVerification200Response
     */
    'transactionManagerBirthday': string;
    /**
     * 
     * @type {string}
     * @memberof RejectOrganizationIdentityVerification200Response
     */
    'transactionManagerAddress': string;
    /**
     * 
     * @type {string}
     * @memberof RejectOrganizationIdentityVerification200Response
     */
    'transactionManagerEmail': string;
    /**
     * 
     * @type {string}
     * @memberof RejectOrganizationIdentityVerification200Response
     */
    'note': string | null;
    /**
     * 
     * @type {RejectOrganizationIdentityVerification200ResponseStatus}
     * @memberof RejectOrganizationIdentityVerification200Response
     */
    'status': RejectOrganizationIdentityVerification200ResponseStatus | null;
    /**
     * 
     * @type {Array<RejectOrganizationIdentityVerification200ResponseIdentificationInner>}
     * @memberof RejectOrganizationIdentityVerification200Response
     */
    'identification': Array<RejectOrganizationIdentityVerification200ResponseIdentificationInner>;
    /**
     * 
     * @type {Array<RejectOrganizationIdentityVerification200ResponseAntisocialForcesCheckInner>}
     * @memberof RejectOrganizationIdentityVerification200Response
     */
    'antisocialForcesCheck': Array<RejectOrganizationIdentityVerification200ResponseAntisocialForcesCheckInner>;
    /**
     * 
     * @type {Array<RejectOrganizationIdentityVerification200ResponseSnailMailVerificationInner>}
     * @memberof RejectOrganizationIdentityVerification200Response
     */
    'snailMailVerification': Array<RejectOrganizationIdentityVerification200ResponseSnailMailVerificationInner> | null;
    /**
     * 
     * @type {string}
     * @memberof RejectOrganizationIdentityVerification200Response
     */
    'createdAt': string;
}
/**
 * 
 * @export
 * @interface RejectOrganizationIdentityVerification200ResponseAntisocialForcesCheckInner
 */
export interface RejectOrganizationIdentityVerification200ResponseAntisocialForcesCheckInner {
    /**
     * 
     * @type {string}
     * @memberof RejectOrganizationIdentityVerification200ResponseAntisocialForcesCheckInner
     */
    'organizationIdentityVerificationId': string;
    /**
     * 
     * @type {string}
     * @memberof RejectOrganizationIdentityVerification200ResponseAntisocialForcesCheckInner
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof RejectOrganizationIdentityVerification200ResponseAntisocialForcesCheckInner
     */
    'payloadId': string;
    /**
     * 
     * @type {number}
     * @memberof RejectOrganizationIdentityVerification200ResponseAntisocialForcesCheckInner
     */
    'payloadDetailId': number;
    /**
     * 
     * @type {string}
     * @memberof RejectOrganizationIdentityVerification200ResponseAntisocialForcesCheckInner
     */
    'category': string;
    /**
     * 
     * @type {object}
     * @memberof RejectOrganizationIdentityVerification200ResponseAntisocialForcesCheckInner
     */
    'condition'?: object;
    /**
     * 
     * @type {Array<object>}
     * @memberof RejectOrganizationIdentityVerification200ResponseAntisocialForcesCheckInner
     */
    'results'?: Array<object> | null;
}
/**
 * 
 * @export
 * @interface RejectOrganizationIdentityVerification200ResponseBeneficialOwnersInner
 */
export interface RejectOrganizationIdentityVerification200ResponseBeneficialOwnersInner {
    /**
     * 
     * @type {string}
     * @memberof RejectOrganizationIdentityVerification200ResponseBeneficialOwnersInner
     */
    'corporateRelationships'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RejectOrganizationIdentityVerification200ResponseBeneficialOwnersInner
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof RejectOrganizationIdentityVerification200ResponseBeneficialOwnersInner
     */
    'beneficialOwnerType': string;
    /**
     * 
     * @type {string}
     * @memberof RejectOrganizationIdentityVerification200ResponseBeneficialOwnersInner
     */
    'gender': string;
    /**
     * 
     * @type {string}
     * @memberof RejectOrganizationIdentityVerification200ResponseBeneficialOwnersInner
     */
    'birthday': string;
    /**
     * 
     * @type {string}
     * @memberof RejectOrganizationIdentityVerification200ResponseBeneficialOwnersInner
     */
    'countryResidence': string;
    /**
     * 
     * @type {string}
     * @memberof RejectOrganizationIdentityVerification200ResponseBeneficialOwnersInner
     */
    'address': string;
    /**
     * 
     * @type {boolean}
     * @memberof RejectOrganizationIdentityVerification200ResponseBeneficialOwnersInner
     */
    'isPoliticallyExposedPersons': boolean;
}
/**
 * 
 * @export
 * @interface RejectOrganizationIdentityVerification200ResponseIdentificationInner
 */
export interface RejectOrganizationIdentityVerification200ResponseIdentificationInner {
    /**
     * 
     * @type {string}
     * @memberof RejectOrganizationIdentityVerification200ResponseIdentificationInner
     */
    'trustdockIdentificationId': string;
    /**
     * 
     * @type {string}
     * @memberof RejectOrganizationIdentityVerification200ResponseIdentificationInner
     */
    'state': string;
    /**
     * 
     * @type {string}
     * @memberof RejectOrganizationIdentityVerification200ResponseIdentificationInner
     */
    'result': string | null;
    /**
     * 
     * @type {Array<RejectOrganizationIdentityVerification200ResponseIdentificationInnerRecordsInner>}
     * @memberof RejectOrganizationIdentityVerification200ResponseIdentificationInner
     */
    'records'?: Array<RejectOrganizationIdentityVerification200ResponseIdentificationInnerRecordsInner> | null;
}
/**
 * 
 * @export
 * @interface RejectOrganizationIdentityVerification200ResponseIdentificationInnerRecordsInner
 */
export interface RejectOrganizationIdentityVerification200ResponseIdentificationInnerRecordsInner {
    /**
     * 
     * @type {string}
     * @memberof RejectOrganizationIdentityVerification200ResponseIdentificationInnerRecordsInner
     */
    'state': string;
    /**
     * 
     * @type {string}
     * @memberof RejectOrganizationIdentityVerification200ResponseIdentificationInnerRecordsInner
     */
    'result': string | null;
    /**
     * 
     * @type {string}
     * @memberof RejectOrganizationIdentityVerification200ResponseIdentificationInnerRecordsInner
     */
    'planId'?: string;
    /**
     * 
     * @type {string}
     * @memberof RejectOrganizationIdentityVerification200ResponseIdentificationInnerRecordsInner
     */
    'plan'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof RejectOrganizationIdentityVerification200ResponseIdentificationInnerRecordsInner
     */
    'reasons'?: Array<string>;
}
/**
 * 
 * @export
 * @interface RejectOrganizationIdentityVerification200ResponseSnailMailVerificationInner
 */
export interface RejectOrganizationIdentityVerification200ResponseSnailMailVerificationInner {
    /**
     * 
     * @type {string}
     * @memberof RejectOrganizationIdentityVerification200ResponseSnailMailVerificationInner
     */
    'organizationIdentityVerificationId': string;
    /**
     * 
     * @type {string}
     * @memberof RejectOrganizationIdentityVerification200ResponseSnailMailVerificationInner
     */
    'snailMailVerificationId': string;
    /**
     * 
     * @type {string}
     * @memberof RejectOrganizationIdentityVerification200ResponseSnailMailVerificationInner
     */
    'result': string;
    /**
     * 
     * @type {string}
     * @memberof RejectOrganizationIdentityVerification200ResponseSnailMailVerificationInner
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof RejectOrganizationIdentityVerification200ResponseSnailMailVerificationInner
     */
    'detail': string;
    /**
     * 
     * @type {string}
     * @memberof RejectOrganizationIdentityVerification200ResponseSnailMailVerificationInner
     */
    'inquiryNumber': string;
    /**
     * 
     * @type {string}
     * @memberof RejectOrganizationIdentityVerification200ResponseSnailMailVerificationInner
     */
    'acceptAt': string;
    /**
     * 
     * @type {string}
     * @memberof RejectOrganizationIdentityVerification200ResponseSnailMailVerificationInner
     */
    'confirmedAt': string;
    /**
     * 
     * @type {string}
     * @memberof RejectOrganizationIdentityVerification200ResponseSnailMailVerificationInner
     */
    'confirmedBy': string | null;
}
/**
 * 
 * @export
 * @interface RejectOrganizationIdentityVerification200ResponseStatus
 */
export interface RejectOrganizationIdentityVerification200ResponseStatus {
    /**
     * 
     * @type {string}
     * @memberof RejectOrganizationIdentityVerification200ResponseStatus
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof RejectOrganizationIdentityVerification200ResponseStatus
     */
    'statusChangedUserId'?: string;
    /**
     * 
     * @type {string}
     * @memberof RejectOrganizationIdentityVerification200ResponseStatus
     */
    'statusChangedUserName': string;
    /**
     * 
     * @type {string}
     * @memberof RejectOrganizationIdentityVerification200ResponseStatus
     */
    'statusChangedAt': string;
}
/**
 * 
 * @export
 * @interface RejectPurchaseApplicationRequest
 */
export interface RejectPurchaseApplicationRequest {
    /**
     * 
     * @type {string}
     * @memberof RejectPurchaseApplicationRequest
     */
    'comment': string;
}
/**
 * 
 * @export
 * @interface RenameUserAccountGroup200ResponseInner
 */
export interface RenameUserAccountGroup200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof RenameUserAccountGroup200ResponseInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof RenameUserAccountGroup200ResponseInner
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof RenameUserAccountGroup200ResponseInner
     */
    'sortNum': number;
}
/**
 * 
 * @export
 * @interface RenameUserAccountGroupRequest
 */
export interface RenameUserAccountGroupRequest {
    /**
     * 
     * @type {string}
     * @memberof RenameUserAccountGroupRequest
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface ReplaceVirtualCard200Response
 */
export interface ReplaceVirtualCard200Response {
    /**
     * 
     * @type {boolean}
     * @memberof ReplaceVirtualCard200Response
     */
    'valid': boolean;
    /**
     * 
     * @type {string}
     * @memberof ReplaceVirtualCard200Response
     */
    'cardId': string | null;
    /**
     * 
     * @type {string}
     * @memberof ReplaceVirtualCard200Response
     */
    'userAccountId': string | null;
}
/**
 * 
 * @export
 * @interface ReplaceVirtualCardRequest
 */
export interface ReplaceVirtualCardRequest {
    /**
     * 
     * @type {number}
     * @memberof ReplaceVirtualCardRequest
     */
    'userId': number;
}
/**
 * 
 * @export
 * @interface RequestAddSystemAdminRole400Response
 */
export interface RequestAddSystemAdminRole400Response {
    /**
     * 
     * @type {RequestAddSystemAdminRole400ResponseErrors}
     * @memberof RequestAddSystemAdminRole400Response
     */
    'errors': RequestAddSystemAdminRole400ResponseErrors;
}
/**
 * 
 * @export
 * @interface RequestAddSystemAdminRole400ResponseErrors
 */
export interface RequestAddSystemAdminRole400ResponseErrors {
    /**
     * 
     * @type {string}
     * @memberof RequestAddSystemAdminRole400ResponseErrors
     */
    'reason': RequestAddSystemAdminRole400ResponseErrorsReasonEnum;
}

export const RequestAddSystemAdminRole400ResponseErrorsReasonEnum = {
    notSpecifiedRole: 'NOT_SPECIFIED_ROLE',
    notFoundUser: 'NOT_FOUND_USER',
    notFoundRole: 'NOT_FOUND_ROLE',
    alreadyRegistered: 'ALREADY_REGISTERED',
    notCoveredOrganization: 'NOT_COVERED_ORGANIZATION'
} as const;

export type RequestAddSystemAdminRole400ResponseErrorsReasonEnum = typeof RequestAddSystemAdminRole400ResponseErrorsReasonEnum[keyof typeof RequestAddSystemAdminRole400ResponseErrorsReasonEnum];

/**
 * 
 * @export
 * @interface RequestAddSystemAdminRoleRequest
 */
export interface RequestAddSystemAdminRoleRequest {
    /**
     * 
     * @type {Array<number>}
     * @memberof RequestAddSystemAdminRoleRequest
     */
    'roleIds': Array<number>;
}
/**
 * 
 * @export
 * @interface RequestSendingMetalCardRequest
 */
export interface RequestSendingMetalCardRequest {
    /**
     * The address to send the card to
     * @type {string}
     * @memberof RequestSendingMetalCardRequest
     */
    'deliveryAddress': string;
    /**
     * The postal code to send the card to
     * @type {string}
     * @memberof RequestSendingMetalCardRequest
     */
    'deliveryPostalCode': string;
    /**
     * The recipient to send the card to
     * @type {string}
     * @memberof RequestSendingMetalCardRequest
     */
    'deliveryRecipient': string;
    /**
     * The organization name to send the card to
     * @type {string}
     * @memberof RequestSendingMetalCardRequest
     */
    'organizationName'?: string;
    /**
     * The department name to send the card to
     * @type {string}
     * @memberof RequestSendingMetalCardRequest
     */
    'organizationDepartmentName'?: string;
}
/**
 * 
 * @export
 * @interface RequestSendingRequest
 */
export interface RequestSendingRequest {
    /**
     * 
     * @type {number}
     * @memberof RequestSendingRequest
     */
    'quantity': number;
    /**
     * 
     * @type {string}
     * @memberof RequestSendingRequest
     */
    'deliveryRecipient': string;
    /**
     * 
     * @type {string}
     * @memberof RequestSendingRequest
     */
    'deliveryPostalCode': string;
    /**
     * 
     * @type {string}
     * @memberof RequestSendingRequest
     */
    'deliveryAddress': string;
    /**
     * 
     * @type {string}
     * @memberof RequestSendingRequest
     */
    'organizationName': string;
    /**
     * 
     * @type {string}
     * @memberof RequestSendingRequest
     */
    'organizationDepartmentName': string;
}
/**
 * 
 * @export
 * @interface RequestUpdateSystemAdminRole400Response
 */
export interface RequestUpdateSystemAdminRole400Response {
    /**
     * 
     * @type {RequestUpdateSystemAdminRole400ResponseErrors}
     * @memberof RequestUpdateSystemAdminRole400Response
     */
    'errors': RequestUpdateSystemAdminRole400ResponseErrors;
}
/**
 * 
 * @export
 * @interface RequestUpdateSystemAdminRole400ResponseErrors
 */
export interface RequestUpdateSystemAdminRole400ResponseErrors {
    /**
     * 
     * @type {string}
     * @memberof RequestUpdateSystemAdminRole400ResponseErrors
     */
    'reason': RequestUpdateSystemAdminRole400ResponseErrorsReasonEnum;
}

export const RequestUpdateSystemAdminRole400ResponseErrorsReasonEnum = {
    specifiedRole: 'NOT_SPECIFIED_ROLE',
    foundUser: 'NOT_FOUND_USER',
    foundRole: 'NOT_FOUND_ROLE',
    coveredOrganization: 'NOT_COVERED_ORGANIZATION'
} as const;

export type RequestUpdateSystemAdminRole400ResponseErrorsReasonEnum = typeof RequestUpdateSystemAdminRole400ResponseErrorsReasonEnum[keyof typeof RequestUpdateSystemAdminRole400ResponseErrorsReasonEnum];

/**
 * 
 * @export
 * @interface RequestUpdateSystemAdminRoleRequest
 */
export interface RequestUpdateSystemAdminRoleRequest {
    /**
     * 
     * @type {Array<number>}
     * @memberof RequestUpdateSystemAdminRoleRequest
     */
    'roleIds': Array<number>;
}
/**
 * 
 * @export
 * @interface ResendSnailMailForOrganizationIdentityVerificationRequest
 */
export interface ResendSnailMailForOrganizationIdentityVerificationRequest {
    /**
     * 
     * @type {string}
     * @memberof ResendSnailMailForOrganizationIdentityVerificationRequest
     */
    'organizationName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResendSnailMailForOrganizationIdentityVerificationRequest
     */
    'postalCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResendSnailMailForOrganizationIdentityVerificationRequest
     */
    'address'?: string;
}
/**
 * 
 * @export
 * @interface ResendUserInvite200Response
 */
export interface ResendUserInvite200Response {
    /**
     * 
     * @type {string}
     * @memberof ResendUserInvite200Response
     */
    'userId': string | null;
    /**
     * 
     * @type {ResendUserInvite200ResponseResult}
     * @memberof ResendUserInvite200Response
     */
    'result': ResendUserInvite200ResponseResult;
}
/**
 * @type ResendUserInvite200ResponseResult
 * @export
 */
export type ResendUserInvite200ResponseResult = ResendUserInvite200ResponseResultOneOf | ResendUserInvite200ResponseResultOneOf1;

/**
 * 
 * @export
 * @interface ResendUserInvite200ResponseResultOneOf
 */
export interface ResendUserInvite200ResponseResultOneOf {
    /**
     * 
     * @type {string}
     * @memberof ResendUserInvite200ResponseResultOneOf
     */
    'data': string | null;
}
/**
 * 
 * @export
 * @interface ResendUserInvite200ResponseResultOneOf1
 */
export interface ResendUserInvite200ResponseResultOneOf1 {
    /**
     * 
     * @type {string}
     * @memberof ResendUserInvite200ResponseResultOneOf1
     */
    'reason': ResendUserInvite200ResponseResultOneOf1ReasonEnum;
}

export const ResendUserInvite200ResponseResultOneOf1ReasonEnum = {
    notFound: 'NOT_FOUND',
    alreadyRegistered: 'ALREADY_REGISTERED'
} as const;

export type ResendUserInvite200ResponseResultOneOf1ReasonEnum = typeof ResendUserInvite200ResponseResultOneOf1ReasonEnum[keyof typeof ResendUserInvite200ResponseResultOneOf1ReasonEnum];

/**
 * 
 * @export
 * @interface ResumeCard200Response
 */
export interface ResumeCard200Response {
    /**
     * 
     * @type {string}
     * @memberof ResumeCard200Response
     */
    'cardId': string;
    /**
     * 
     * @type {boolean}
     * @memberof ResumeCard200Response
     */
    'isActivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResumeCard200Response
     */
    'isDeactivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResumeCard200Response
     */
    'isLocked': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResumeCard200Response
     */
    'isSuspended': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResumeCard200Response
     */
    'isFrozen': boolean;
    /**
     * 
     * @type {string}
     * @memberof ResumeCard200Response
     */
    'panLastFourDigits': string;
    /**
     * 
     * @type {string}
     * @memberof ResumeCard200Response
     */
    'linkedUserAccountId': string;
    /**
     * 
     * @type {string}
     * @memberof ResumeCard200Response
     */
    'createdAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof ResumeCard200Response
     */
    'isActive': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResumeCard200Response
     */
    'isVirtualCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResumeCard200Response
     */
    'isCreditCard': boolean;
}
/**
 * 
 * @export
 * @interface ResynchronizeCardTransactionsForFreeeRequest
 */
export interface ResynchronizeCardTransactionsForFreeeRequest {
    /**
     * 
     * @type {string}
     * @memberof ResynchronizeCardTransactionsForFreeeRequest
     */
    'from': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const RewardType = {
    advertising: 'ADVERTISING',
    fixed: 'FIXED'
} as const;

export type RewardType = typeof RewardType[keyof typeof RewardType];


/**
 * 
 * @export
 * @interface Role
 */
export interface Role {
    /**
     * 
     * @type {string}
     * @memberof Role
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Role
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof Role
     */
    'category': RoleCategoryEnum;
}

export const RoleCategoryEnum = {
    system: 'SYSTEM',
    app: 'APP',
    card: 'CARD'
} as const;

export type RoleCategoryEnum = typeof RoleCategoryEnum[keyof typeof RoleCategoryEnum];

/**
 * 
 * @export
 * @interface SaveDealAsDraft200Response
 */
export interface SaveDealAsDraft200Response {
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsDraft200Response
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsDraft200Response
     */
    'issuedAt': string;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsDraft200Response
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsDraft200Response
     */
    'freeeDealId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsDraft200Response
     */
    'freeePartnerId': string | null;
    /**
     * 
     * @type {number}
     * @memberof SaveDealAsDraft200Response
     */
    'partnerId': number | null;
    /**
     * 
     * @type {number}
     * @memberof SaveDealAsDraft200Response
     */
    'amountYen': number;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsDraft200Response
     */
    'visaTransactionReferenceId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsDraft200Response
     */
    'status': SaveDealAsDraft200ResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsDraft200Response
     */
    'cardHolder': string | null;
    /**
     * 
     * @type {SaveDealAsDraft200ResponseJournalizedBy}
     * @memberof SaveDealAsDraft200Response
     */
    'journalizedBy': SaveDealAsDraft200ResponseJournalizedBy | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsDraft200Response
     */
    'journalizedAt': string | null;
    /**
     * 
     * @type {SaveDealAsDraft200ResponseIntegratedBy}
     * @memberof SaveDealAsDraft200Response
     */
    'integratedBy': SaveDealAsDraft200ResponseIntegratedBy | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsDraft200Response
     */
    'integratedAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsDraft200Response
     */
    'userAccountId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsDraft200Response
     */
    'userAccountName': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsDraft200Response
     */
    'userAccountGroupId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsDraft200Response
     */
    'userAccountGroupName': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SaveDealAsDraft200Response
     */
    'isOnDemand': boolean | null;
    /**
     * 
     * @type {Array<SaveDealAsDraft200ResponseJournalEntriesInner>}
     * @memberof SaveDealAsDraft200Response
     */
    'journalEntries': Array<SaveDealAsDraft200ResponseJournalEntriesInner>;
    /**
     * 
     * @type {Array<SaveDealAsDraft200ResponseCardTransactionEvidenceListInner>}
     * @memberof SaveDealAsDraft200Response
     */
    'cardTransactionEvidenceList': Array<SaveDealAsDraft200ResponseCardTransactionEvidenceListInner>;
    /**
     * true if the deal has one or more evidences and those all are not qualified, which should be shown as a warning to users.
     * @type {boolean}
     * @memberof SaveDealAsDraft200Response
     */
    'isAllEvidencesNotQualified': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SaveDealAsDraft200Response
     */
    'canSync': boolean;
    /**
     * 
     * @type {SaveDealAsDraft200ResponseInvoiceIssuer}
     * @memberof SaveDealAsDraft200Response
     */
    'invoiceIssuer': SaveDealAsDraft200ResponseInvoiceIssuer | null;
}

export const SaveDealAsDraft200ResponseStatusEnum = {
    notEntered: 'NOT_ENTERED',
    automaticJournalized: 'AUTOMATIC_JOURNALIZED',
    automaticIntegrated: 'AUTOMATIC_INTEGRATED',
    entering: 'ENTERING',
    journalized: 'JOURNALIZED',
    changedAfterJournalization: 'CHANGED_AFTER_JOURNALIZATION',
    integrated: 'INTEGRATED',
    changedAfterIntegration: 'CHANGED_AFTER_INTEGRATION',
    ignored: 'IGNORED',
    readyAutomaticIntegration: 'READY_AUTOMATIC_INTEGRATION'
} as const;

export type SaveDealAsDraft200ResponseStatusEnum = typeof SaveDealAsDraft200ResponseStatusEnum[keyof typeof SaveDealAsDraft200ResponseStatusEnum];

/**
 * 
 * @export
 * @interface SaveDealAsDraft200ResponseCardTransactionEvidenceListInner
 */
export interface SaveDealAsDraft200ResponseCardTransactionEvidenceListInner {
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsDraft200ResponseCardTransactionEvidenceListInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsDraft200ResponseCardTransactionEvidenceListInner
     * @deprecated
     */
    'cardTransactionEvidenceId': string;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsDraft200ResponseCardTransactionEvidenceListInner
     * @deprecated
     */
    'visaTransactionReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsDraft200ResponseCardTransactionEvidenceListInner
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsDraft200ResponseCardTransactionEvidenceListInner
     */
    'fileName': string;
    /**
     * 
     * @type {SaveDealAsDraft200ResponseCardTransactionEvidenceListInnerCreatedBy}
     * @memberof SaveDealAsDraft200ResponseCardTransactionEvidenceListInner
     */
    'createdBy': SaveDealAsDraft200ResponseCardTransactionEvidenceListInnerCreatedBy;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsDraft200ResponseCardTransactionEvidenceListInner
     */
    'uploadedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof SaveDealAsDraft200ResponseCardTransactionEvidenceListInner
     */
    'isQualified': boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof SaveDealAsDraft200ResponseCardTransactionEvidenceListInner
     */
    'asQualified': boolean | null;
}
/**
 * 
 * @export
 * @interface SaveDealAsDraft200ResponseCardTransactionEvidenceListInnerCreatedBy
 */
export interface SaveDealAsDraft200ResponseCardTransactionEvidenceListInnerCreatedBy {
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsDraft200ResponseCardTransactionEvidenceListInnerCreatedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsDraft200ResponseCardTransactionEvidenceListInnerCreatedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface SaveDealAsDraft200ResponseIntegratedBy
 */
export interface SaveDealAsDraft200ResponseIntegratedBy {
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsDraft200ResponseIntegratedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsDraft200ResponseIntegratedBy
     */
    'name': string;
}
/**
 * null if none of the related evidences have been processed according to the invoicing system compliance. partnerId in this object is currently not supported and is always set as null.
 * @export
 * @interface SaveDealAsDraft200ResponseInvoiceIssuer
 */
export interface SaveDealAsDraft200ResponseInvoiceIssuer {
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsDraft200ResponseInvoiceIssuer
     */
    'name': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsDraft200ResponseInvoiceIssuer
     */
    'registrationNumber': string | null;
    /**
     * isQualified retains the result of querying the 国税庁API to see if registrationNumber is qualified, as is.
     * @type {boolean}
     * @memberof SaveDealAsDraft200ResponseInvoiceIssuer
     */
    'isQualified': boolean;
    /**
     * AsQualified indicates whether this issuer should be treated as a qualified invoice issuer within the user\'s system, even if the RegistrationNumber is not confirmed as qualified in the National Tax Agency\'s business registration system.
     * @type {boolean}
     * @memberof SaveDealAsDraft200ResponseInvoiceIssuer
     */
    'asQualified': boolean;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsDraft200ResponseInvoiceIssuer
     */
    'partnerId': string | null;
}
/**
 * 
 * @export
 * @interface SaveDealAsDraft200ResponseJournalEntriesInner
 */
export interface SaveDealAsDraft200ResponseJournalEntriesInner {
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsDraft200ResponseJournalEntriesInner
     */
    'id': string;
    /**
     * 
     * @type {number}
     * @memberof SaveDealAsDraft200ResponseJournalEntriesInner
     */
    'amount': number | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsDraft200ResponseJournalEntriesInner
     */
    'freeeAccountItemId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsDraft200ResponseJournalEntriesInner
     */
    'freeeTaxCode': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SaveDealAsDraft200ResponseJournalEntriesInner
     */
    'isInvalidTaxCode': boolean;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsDraft200ResponseJournalEntriesInner
     */
    'invalidTaxCodeCause': SaveDealAsDraft200ResponseJournalEntriesInnerInvalidTaxCodeCauseEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof SaveDealAsDraft200ResponseJournalEntriesInner
     */
    'freeeMemoTags': Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsDraft200ResponseJournalEntriesInner
     */
    'freeeSectionId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsDraft200ResponseJournalEntriesInner
     */
    'freeeItemId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsDraft200ResponseJournalEntriesInner
     */
    'segment1TagId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsDraft200ResponseJournalEntriesInner
     */
    'segment2TagId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsDraft200ResponseJournalEntriesInner
     */
    'segment3TagId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsDraft200ResponseJournalEntriesInner
     */
    'description': string | null;
}

export const SaveDealAsDraft200ResponseJournalEntriesInnerInvalidTaxCodeCauseEnum = {
    qualifiedButPartDeduct: 'QUALIFIED_BUT_PART_DEDUCT',
    notQualifiedButFullDeduct: 'NOT_QUALIFIED_BUT_FULL_DEDUCT',
    preStartButPartDeduct: 'PRE_START_BUT_PART_DEDUCT',
    inconsistentDeductRate: 'INCONSISTENT_DEDUCT_RATE'
} as const;

export type SaveDealAsDraft200ResponseJournalEntriesInnerInvalidTaxCodeCauseEnum = typeof SaveDealAsDraft200ResponseJournalEntriesInnerInvalidTaxCodeCauseEnum[keyof typeof SaveDealAsDraft200ResponseJournalEntriesInnerInvalidTaxCodeCauseEnum];

/**
 * 
 * @export
 * @interface SaveDealAsDraft200ResponseJournalizedBy
 */
export interface SaveDealAsDraft200ResponseJournalizedBy {
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsDraft200ResponseJournalizedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsDraft200ResponseJournalizedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface SaveDealAsDraftRequest
 */
export interface SaveDealAsDraftRequest {
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsDraftRequest
     */
    'freeePartnerId': string;
    /**
     * 
     * @type {Array<SaveDealAsDraftRequestFreeeJournalEntriesInner>}
     * @memberof SaveDealAsDraftRequest
     */
    'freeeJournalEntries': Array<SaveDealAsDraftRequestFreeeJournalEntriesInner>;
    /**
     * 
     * @type {SaveDealAsDraftRequestInvoiceIssuer}
     * @memberof SaveDealAsDraftRequest
     */
    'invoiceIssuer': SaveDealAsDraftRequestInvoiceIssuer | null;
}
/**
 * 
 * @export
 * @interface SaveDealAsDraftRequestFreeeJournalEntriesInner
 */
export interface SaveDealAsDraftRequestFreeeJournalEntriesInner {
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsDraftRequestFreeeJournalEntriesInner
     */
    'freeeAccountItemId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsDraftRequestFreeeJournalEntriesInner
     */
    'freeeTaxCode': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsDraftRequestFreeeJournalEntriesInner
     */
    'amount': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsDraftRequestFreeeJournalEntriesInner
     */
    'freeeItemId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsDraftRequestFreeeJournalEntriesInner
     */
    'freeeSectionId': string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof SaveDealAsDraftRequestFreeeJournalEntriesInner
     */
    'freeeMemoTagIds': Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsDraftRequestFreeeJournalEntriesInner
     */
    'segment1TagId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsDraftRequestFreeeJournalEntriesInner
     */
    'segment2TagId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsDraftRequestFreeeJournalEntriesInner
     */
    'segment3TagId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsDraftRequestFreeeJournalEntriesInner
     */
    'description': string | null;
}
/**
 * 
 * @export
 * @interface SaveDealAsDraftRequestInvoiceIssuer
 */
export interface SaveDealAsDraftRequestInvoiceIssuer {
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsDraftRequestInvoiceIssuer
     */
    'name': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsDraftRequestInvoiceIssuer
     */
    'registrationNumber': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SaveDealAsDraftRequestInvoiceIssuer
     */
    'asQualified': boolean | null;
}
/**
 * 
 * @export
 * @interface SaveDealAsIgnore200Response
 */
export interface SaveDealAsIgnore200Response {
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsIgnore200Response
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsIgnore200Response
     */
    'issuedAt': string;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsIgnore200Response
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsIgnore200Response
     */
    'freeeDealId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsIgnore200Response
     */
    'freeePartnerId': string | null;
    /**
     * 
     * @type {number}
     * @memberof SaveDealAsIgnore200Response
     */
    'partnerId': number | null;
    /**
     * 
     * @type {number}
     * @memberof SaveDealAsIgnore200Response
     */
    'amountYen': number;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsIgnore200Response
     */
    'visaTransactionReferenceId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsIgnore200Response
     */
    'status': SaveDealAsIgnore200ResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsIgnore200Response
     */
    'cardHolder': string | null;
    /**
     * 
     * @type {SaveDealAsIgnore200ResponseJournalizedBy}
     * @memberof SaveDealAsIgnore200Response
     */
    'journalizedBy': SaveDealAsIgnore200ResponseJournalizedBy | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsIgnore200Response
     */
    'journalizedAt': string | null;
    /**
     * 
     * @type {SaveDealAsIgnore200ResponseIntegratedBy}
     * @memberof SaveDealAsIgnore200Response
     */
    'integratedBy': SaveDealAsIgnore200ResponseIntegratedBy | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsIgnore200Response
     */
    'integratedAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsIgnore200Response
     */
    'userAccountId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsIgnore200Response
     */
    'userAccountName': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsIgnore200Response
     */
    'userAccountGroupId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsIgnore200Response
     */
    'userAccountGroupName': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SaveDealAsIgnore200Response
     */
    'isOnDemand': boolean | null;
    /**
     * 
     * @type {Array<SaveDealAsIgnore200ResponseJournalEntriesInner>}
     * @memberof SaveDealAsIgnore200Response
     */
    'journalEntries': Array<SaveDealAsIgnore200ResponseJournalEntriesInner>;
    /**
     * 
     * @type {Array<SaveDealAsIgnore200ResponseCardTransactionEvidenceListInner>}
     * @memberof SaveDealAsIgnore200Response
     */
    'cardTransactionEvidenceList': Array<SaveDealAsIgnore200ResponseCardTransactionEvidenceListInner>;
    /**
     * true if the deal has one or more evidences and those all are not qualified, which should be shown as a warning to users.
     * @type {boolean}
     * @memberof SaveDealAsIgnore200Response
     */
    'isAllEvidencesNotQualified': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SaveDealAsIgnore200Response
     */
    'canSync': boolean;
    /**
     * 
     * @type {SaveDealAsIgnore200ResponseInvoiceIssuer}
     * @memberof SaveDealAsIgnore200Response
     */
    'invoiceIssuer': SaveDealAsIgnore200ResponseInvoiceIssuer | null;
}

export const SaveDealAsIgnore200ResponseStatusEnum = {
    notEntered: 'NOT_ENTERED',
    automaticJournalized: 'AUTOMATIC_JOURNALIZED',
    automaticIntegrated: 'AUTOMATIC_INTEGRATED',
    entering: 'ENTERING',
    journalized: 'JOURNALIZED',
    changedAfterJournalization: 'CHANGED_AFTER_JOURNALIZATION',
    integrated: 'INTEGRATED',
    changedAfterIntegration: 'CHANGED_AFTER_INTEGRATION',
    ignored: 'IGNORED',
    readyAutomaticIntegration: 'READY_AUTOMATIC_INTEGRATION'
} as const;

export type SaveDealAsIgnore200ResponseStatusEnum = typeof SaveDealAsIgnore200ResponseStatusEnum[keyof typeof SaveDealAsIgnore200ResponseStatusEnum];

/**
 * 
 * @export
 * @interface SaveDealAsIgnore200ResponseCardTransactionEvidenceListInner
 */
export interface SaveDealAsIgnore200ResponseCardTransactionEvidenceListInner {
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsIgnore200ResponseCardTransactionEvidenceListInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsIgnore200ResponseCardTransactionEvidenceListInner
     * @deprecated
     */
    'cardTransactionEvidenceId': string;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsIgnore200ResponseCardTransactionEvidenceListInner
     * @deprecated
     */
    'visaTransactionReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsIgnore200ResponseCardTransactionEvidenceListInner
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsIgnore200ResponseCardTransactionEvidenceListInner
     */
    'fileName': string;
    /**
     * 
     * @type {SaveDealAsIgnore200ResponseCardTransactionEvidenceListInnerCreatedBy}
     * @memberof SaveDealAsIgnore200ResponseCardTransactionEvidenceListInner
     */
    'createdBy': SaveDealAsIgnore200ResponseCardTransactionEvidenceListInnerCreatedBy;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsIgnore200ResponseCardTransactionEvidenceListInner
     */
    'uploadedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof SaveDealAsIgnore200ResponseCardTransactionEvidenceListInner
     */
    'isQualified': boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof SaveDealAsIgnore200ResponseCardTransactionEvidenceListInner
     */
    'asQualified': boolean | null;
}
/**
 * 
 * @export
 * @interface SaveDealAsIgnore200ResponseCardTransactionEvidenceListInnerCreatedBy
 */
export interface SaveDealAsIgnore200ResponseCardTransactionEvidenceListInnerCreatedBy {
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsIgnore200ResponseCardTransactionEvidenceListInnerCreatedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsIgnore200ResponseCardTransactionEvidenceListInnerCreatedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface SaveDealAsIgnore200ResponseIntegratedBy
 */
export interface SaveDealAsIgnore200ResponseIntegratedBy {
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsIgnore200ResponseIntegratedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsIgnore200ResponseIntegratedBy
     */
    'name': string;
}
/**
 * null if none of the related evidences have been processed according to the invoicing system compliance. partnerId in this object is currently not supported and is always set as null.
 * @export
 * @interface SaveDealAsIgnore200ResponseInvoiceIssuer
 */
export interface SaveDealAsIgnore200ResponseInvoiceIssuer {
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsIgnore200ResponseInvoiceIssuer
     */
    'name': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsIgnore200ResponseInvoiceIssuer
     */
    'registrationNumber': string | null;
    /**
     * isQualified retains the result of querying the 国税庁API to see if registrationNumber is qualified, as is.
     * @type {boolean}
     * @memberof SaveDealAsIgnore200ResponseInvoiceIssuer
     */
    'isQualified': boolean;
    /**
     * AsQualified indicates whether this issuer should be treated as a qualified invoice issuer within the user\'s system, even if the RegistrationNumber is not confirmed as qualified in the National Tax Agency\'s business registration system.
     * @type {boolean}
     * @memberof SaveDealAsIgnore200ResponseInvoiceIssuer
     */
    'asQualified': boolean;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsIgnore200ResponseInvoiceIssuer
     */
    'partnerId': string | null;
}
/**
 * 
 * @export
 * @interface SaveDealAsIgnore200ResponseJournalEntriesInner
 */
export interface SaveDealAsIgnore200ResponseJournalEntriesInner {
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsIgnore200ResponseJournalEntriesInner
     */
    'id': string;
    /**
     * 
     * @type {number}
     * @memberof SaveDealAsIgnore200ResponseJournalEntriesInner
     */
    'amount': number | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsIgnore200ResponseJournalEntriesInner
     */
    'freeeAccountItemId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsIgnore200ResponseJournalEntriesInner
     */
    'freeeTaxCode': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SaveDealAsIgnore200ResponseJournalEntriesInner
     */
    'isInvalidTaxCode': boolean;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsIgnore200ResponseJournalEntriesInner
     */
    'invalidTaxCodeCause': SaveDealAsIgnore200ResponseJournalEntriesInnerInvalidTaxCodeCauseEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof SaveDealAsIgnore200ResponseJournalEntriesInner
     */
    'freeeMemoTags': Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsIgnore200ResponseJournalEntriesInner
     */
    'freeeSectionId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsIgnore200ResponseJournalEntriesInner
     */
    'freeeItemId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsIgnore200ResponseJournalEntriesInner
     */
    'segment1TagId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsIgnore200ResponseJournalEntriesInner
     */
    'segment2TagId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsIgnore200ResponseJournalEntriesInner
     */
    'segment3TagId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsIgnore200ResponseJournalEntriesInner
     */
    'description': string | null;
}

export const SaveDealAsIgnore200ResponseJournalEntriesInnerInvalidTaxCodeCauseEnum = {
    qualifiedButPartDeduct: 'QUALIFIED_BUT_PART_DEDUCT',
    notQualifiedButFullDeduct: 'NOT_QUALIFIED_BUT_FULL_DEDUCT',
    preStartButPartDeduct: 'PRE_START_BUT_PART_DEDUCT',
    inconsistentDeductRate: 'INCONSISTENT_DEDUCT_RATE'
} as const;

export type SaveDealAsIgnore200ResponseJournalEntriesInnerInvalidTaxCodeCauseEnum = typeof SaveDealAsIgnore200ResponseJournalEntriesInnerInvalidTaxCodeCauseEnum[keyof typeof SaveDealAsIgnore200ResponseJournalEntriesInnerInvalidTaxCodeCauseEnum];

/**
 * 
 * @export
 * @interface SaveDealAsIgnore200ResponseJournalizedBy
 */
export interface SaveDealAsIgnore200ResponseJournalizedBy {
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsIgnore200ResponseJournalizedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsIgnore200ResponseJournalizedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface SaveDealAsReturnToEditing200Response
 */
export interface SaveDealAsReturnToEditing200Response {
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsReturnToEditing200Response
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsReturnToEditing200Response
     */
    'issuedAt': string;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsReturnToEditing200Response
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsReturnToEditing200Response
     */
    'freeeDealId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsReturnToEditing200Response
     */
    'freeePartnerId': string | null;
    /**
     * 
     * @type {number}
     * @memberof SaveDealAsReturnToEditing200Response
     */
    'partnerId': number | null;
    /**
     * 
     * @type {number}
     * @memberof SaveDealAsReturnToEditing200Response
     */
    'amountYen': number;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsReturnToEditing200Response
     */
    'visaTransactionReferenceId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsReturnToEditing200Response
     */
    'status': SaveDealAsReturnToEditing200ResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsReturnToEditing200Response
     */
    'cardHolder': string | null;
    /**
     * 
     * @type {SaveDealAsReturnToEditing200ResponseJournalizedBy}
     * @memberof SaveDealAsReturnToEditing200Response
     */
    'journalizedBy': SaveDealAsReturnToEditing200ResponseJournalizedBy | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsReturnToEditing200Response
     */
    'journalizedAt': string | null;
    /**
     * 
     * @type {SaveDealAsReturnToEditing200ResponseIntegratedBy}
     * @memberof SaveDealAsReturnToEditing200Response
     */
    'integratedBy': SaveDealAsReturnToEditing200ResponseIntegratedBy | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsReturnToEditing200Response
     */
    'integratedAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsReturnToEditing200Response
     */
    'userAccountId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsReturnToEditing200Response
     */
    'userAccountName': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsReturnToEditing200Response
     */
    'userAccountGroupId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsReturnToEditing200Response
     */
    'userAccountGroupName': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SaveDealAsReturnToEditing200Response
     */
    'isOnDemand': boolean | null;
    /**
     * 
     * @type {Array<SaveDealAsReturnToEditing200ResponseJournalEntriesInner>}
     * @memberof SaveDealAsReturnToEditing200Response
     */
    'journalEntries': Array<SaveDealAsReturnToEditing200ResponseJournalEntriesInner>;
    /**
     * 
     * @type {Array<SaveDealAsReturnToEditing200ResponseCardTransactionEvidenceListInner>}
     * @memberof SaveDealAsReturnToEditing200Response
     */
    'cardTransactionEvidenceList': Array<SaveDealAsReturnToEditing200ResponseCardTransactionEvidenceListInner>;
    /**
     * true if the deal has one or more evidences and those all are not qualified, which should be shown as a warning to users.
     * @type {boolean}
     * @memberof SaveDealAsReturnToEditing200Response
     */
    'isAllEvidencesNotQualified': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SaveDealAsReturnToEditing200Response
     */
    'canSync': boolean;
    /**
     * 
     * @type {SaveDealAsReturnToEditing200ResponseInvoiceIssuer}
     * @memberof SaveDealAsReturnToEditing200Response
     */
    'invoiceIssuer': SaveDealAsReturnToEditing200ResponseInvoiceIssuer | null;
}

export const SaveDealAsReturnToEditing200ResponseStatusEnum = {
    notEntered: 'NOT_ENTERED',
    automaticJournalized: 'AUTOMATIC_JOURNALIZED',
    automaticIntegrated: 'AUTOMATIC_INTEGRATED',
    entering: 'ENTERING',
    journalized: 'JOURNALIZED',
    changedAfterJournalization: 'CHANGED_AFTER_JOURNALIZATION',
    integrated: 'INTEGRATED',
    changedAfterIntegration: 'CHANGED_AFTER_INTEGRATION',
    ignored: 'IGNORED',
    readyAutomaticIntegration: 'READY_AUTOMATIC_INTEGRATION'
} as const;

export type SaveDealAsReturnToEditing200ResponseStatusEnum = typeof SaveDealAsReturnToEditing200ResponseStatusEnum[keyof typeof SaveDealAsReturnToEditing200ResponseStatusEnum];

/**
 * 
 * @export
 * @interface SaveDealAsReturnToEditing200ResponseCardTransactionEvidenceListInner
 */
export interface SaveDealAsReturnToEditing200ResponseCardTransactionEvidenceListInner {
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsReturnToEditing200ResponseCardTransactionEvidenceListInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsReturnToEditing200ResponseCardTransactionEvidenceListInner
     * @deprecated
     */
    'cardTransactionEvidenceId': string;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsReturnToEditing200ResponseCardTransactionEvidenceListInner
     * @deprecated
     */
    'visaTransactionReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsReturnToEditing200ResponseCardTransactionEvidenceListInner
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsReturnToEditing200ResponseCardTransactionEvidenceListInner
     */
    'fileName': string;
    /**
     * 
     * @type {SaveDealAsReturnToEditing200ResponseCardTransactionEvidenceListInnerCreatedBy}
     * @memberof SaveDealAsReturnToEditing200ResponseCardTransactionEvidenceListInner
     */
    'createdBy': SaveDealAsReturnToEditing200ResponseCardTransactionEvidenceListInnerCreatedBy;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsReturnToEditing200ResponseCardTransactionEvidenceListInner
     */
    'uploadedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof SaveDealAsReturnToEditing200ResponseCardTransactionEvidenceListInner
     */
    'isQualified': boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof SaveDealAsReturnToEditing200ResponseCardTransactionEvidenceListInner
     */
    'asQualified': boolean | null;
}
/**
 * 
 * @export
 * @interface SaveDealAsReturnToEditing200ResponseCardTransactionEvidenceListInnerCreatedBy
 */
export interface SaveDealAsReturnToEditing200ResponseCardTransactionEvidenceListInnerCreatedBy {
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsReturnToEditing200ResponseCardTransactionEvidenceListInnerCreatedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsReturnToEditing200ResponseCardTransactionEvidenceListInnerCreatedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface SaveDealAsReturnToEditing200ResponseIntegratedBy
 */
export interface SaveDealAsReturnToEditing200ResponseIntegratedBy {
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsReturnToEditing200ResponseIntegratedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsReturnToEditing200ResponseIntegratedBy
     */
    'name': string;
}
/**
 * null if none of the related evidences have been processed according to the invoicing system compliance. partnerId in this object is currently not supported and is always set as null.
 * @export
 * @interface SaveDealAsReturnToEditing200ResponseInvoiceIssuer
 */
export interface SaveDealAsReturnToEditing200ResponseInvoiceIssuer {
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsReturnToEditing200ResponseInvoiceIssuer
     */
    'name': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsReturnToEditing200ResponseInvoiceIssuer
     */
    'registrationNumber': string | null;
    /**
     * isQualified retains the result of querying the 国税庁API to see if registrationNumber is qualified, as is.
     * @type {boolean}
     * @memberof SaveDealAsReturnToEditing200ResponseInvoiceIssuer
     */
    'isQualified': boolean;
    /**
     * AsQualified indicates whether this issuer should be treated as a qualified invoice issuer within the user\'s system, even if the RegistrationNumber is not confirmed as qualified in the National Tax Agency\'s business registration system.
     * @type {boolean}
     * @memberof SaveDealAsReturnToEditing200ResponseInvoiceIssuer
     */
    'asQualified': boolean;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsReturnToEditing200ResponseInvoiceIssuer
     */
    'partnerId': string | null;
}
/**
 * 
 * @export
 * @interface SaveDealAsReturnToEditing200ResponseJournalEntriesInner
 */
export interface SaveDealAsReturnToEditing200ResponseJournalEntriesInner {
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsReturnToEditing200ResponseJournalEntriesInner
     */
    'id': string;
    /**
     * 
     * @type {number}
     * @memberof SaveDealAsReturnToEditing200ResponseJournalEntriesInner
     */
    'amount': number | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsReturnToEditing200ResponseJournalEntriesInner
     */
    'freeeAccountItemId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsReturnToEditing200ResponseJournalEntriesInner
     */
    'freeeTaxCode': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SaveDealAsReturnToEditing200ResponseJournalEntriesInner
     */
    'isInvalidTaxCode': boolean;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsReturnToEditing200ResponseJournalEntriesInner
     */
    'invalidTaxCodeCause': SaveDealAsReturnToEditing200ResponseJournalEntriesInnerInvalidTaxCodeCauseEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof SaveDealAsReturnToEditing200ResponseJournalEntriesInner
     */
    'freeeMemoTags': Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsReturnToEditing200ResponseJournalEntriesInner
     */
    'freeeSectionId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsReturnToEditing200ResponseJournalEntriesInner
     */
    'freeeItemId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsReturnToEditing200ResponseJournalEntriesInner
     */
    'segment1TagId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsReturnToEditing200ResponseJournalEntriesInner
     */
    'segment2TagId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsReturnToEditing200ResponseJournalEntriesInner
     */
    'segment3TagId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsReturnToEditing200ResponseJournalEntriesInner
     */
    'description': string | null;
}

export const SaveDealAsReturnToEditing200ResponseJournalEntriesInnerInvalidTaxCodeCauseEnum = {
    qualifiedButPartDeduct: 'QUALIFIED_BUT_PART_DEDUCT',
    notQualifiedButFullDeduct: 'NOT_QUALIFIED_BUT_FULL_DEDUCT',
    preStartButPartDeduct: 'PRE_START_BUT_PART_DEDUCT',
    inconsistentDeductRate: 'INCONSISTENT_DEDUCT_RATE'
} as const;

export type SaveDealAsReturnToEditing200ResponseJournalEntriesInnerInvalidTaxCodeCauseEnum = typeof SaveDealAsReturnToEditing200ResponseJournalEntriesInnerInvalidTaxCodeCauseEnum[keyof typeof SaveDealAsReturnToEditing200ResponseJournalEntriesInnerInvalidTaxCodeCauseEnum];

/**
 * 
 * @export
 * @interface SaveDealAsReturnToEditing200ResponseJournalizedBy
 */
export interface SaveDealAsReturnToEditing200ResponseJournalizedBy {
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsReturnToEditing200ResponseJournalizedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsReturnToEditing200ResponseJournalizedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface SaveDealWithJournalizing200Response
 */
export interface SaveDealWithJournalizing200Response {
    /**
     * 
     * @type {string}
     * @memberof SaveDealWithJournalizing200Response
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SaveDealWithJournalizing200Response
     */
    'issuedAt': string;
    /**
     * 
     * @type {string}
     * @memberof SaveDealWithJournalizing200Response
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof SaveDealWithJournalizing200Response
     */
    'freeeDealId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealWithJournalizing200Response
     */
    'freeePartnerId': string | null;
    /**
     * 
     * @type {number}
     * @memberof SaveDealWithJournalizing200Response
     */
    'partnerId': number | null;
    /**
     * 
     * @type {number}
     * @memberof SaveDealWithJournalizing200Response
     */
    'amountYen': number;
    /**
     * 
     * @type {string}
     * @memberof SaveDealWithJournalizing200Response
     */
    'visaTransactionReferenceId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealWithJournalizing200Response
     */
    'status': SaveDealWithJournalizing200ResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof SaveDealWithJournalizing200Response
     */
    'cardHolder': string | null;
    /**
     * 
     * @type {SaveDealWithJournalizing200ResponseJournalizedBy}
     * @memberof SaveDealWithJournalizing200Response
     */
    'journalizedBy': SaveDealWithJournalizing200ResponseJournalizedBy | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealWithJournalizing200Response
     */
    'journalizedAt': string | null;
    /**
     * 
     * @type {SaveDealWithJournalizing200ResponseIntegratedBy}
     * @memberof SaveDealWithJournalizing200Response
     */
    'integratedBy': SaveDealWithJournalizing200ResponseIntegratedBy | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealWithJournalizing200Response
     */
    'integratedAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealWithJournalizing200Response
     */
    'userAccountId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealWithJournalizing200Response
     */
    'userAccountName': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealWithJournalizing200Response
     */
    'userAccountGroupId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealWithJournalizing200Response
     */
    'userAccountGroupName': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SaveDealWithJournalizing200Response
     */
    'isOnDemand': boolean | null;
    /**
     * 
     * @type {Array<SaveDealWithJournalizing200ResponseJournalEntriesInner>}
     * @memberof SaveDealWithJournalizing200Response
     */
    'journalEntries': Array<SaveDealWithJournalizing200ResponseJournalEntriesInner>;
    /**
     * 
     * @type {Array<SaveDealWithJournalizing200ResponseCardTransactionEvidenceListInner>}
     * @memberof SaveDealWithJournalizing200Response
     */
    'cardTransactionEvidenceList': Array<SaveDealWithJournalizing200ResponseCardTransactionEvidenceListInner>;
    /**
     * true if the deal has one or more evidences and those all are not qualified, which should be shown as a warning to users.
     * @type {boolean}
     * @memberof SaveDealWithJournalizing200Response
     */
    'isAllEvidencesNotQualified': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SaveDealWithJournalizing200Response
     */
    'canSync': boolean;
    /**
     * 
     * @type {SaveDealWithJournalizing200ResponseInvoiceIssuer}
     * @memberof SaveDealWithJournalizing200Response
     */
    'invoiceIssuer': SaveDealWithJournalizing200ResponseInvoiceIssuer | null;
}

export const SaveDealWithJournalizing200ResponseStatusEnum = {
    notEntered: 'NOT_ENTERED',
    automaticJournalized: 'AUTOMATIC_JOURNALIZED',
    automaticIntegrated: 'AUTOMATIC_INTEGRATED',
    entering: 'ENTERING',
    journalized: 'JOURNALIZED',
    changedAfterJournalization: 'CHANGED_AFTER_JOURNALIZATION',
    integrated: 'INTEGRATED',
    changedAfterIntegration: 'CHANGED_AFTER_INTEGRATION',
    ignored: 'IGNORED',
    readyAutomaticIntegration: 'READY_AUTOMATIC_INTEGRATION'
} as const;

export type SaveDealWithJournalizing200ResponseStatusEnum = typeof SaveDealWithJournalizing200ResponseStatusEnum[keyof typeof SaveDealWithJournalizing200ResponseStatusEnum];

/**
 * 
 * @export
 * @interface SaveDealWithJournalizing200ResponseCardTransactionEvidenceListInner
 */
export interface SaveDealWithJournalizing200ResponseCardTransactionEvidenceListInner {
    /**
     * 
     * @type {string}
     * @memberof SaveDealWithJournalizing200ResponseCardTransactionEvidenceListInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SaveDealWithJournalizing200ResponseCardTransactionEvidenceListInner
     * @deprecated
     */
    'cardTransactionEvidenceId': string;
    /**
     * 
     * @type {string}
     * @memberof SaveDealWithJournalizing200ResponseCardTransactionEvidenceListInner
     * @deprecated
     */
    'visaTransactionReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof SaveDealWithJournalizing200ResponseCardTransactionEvidenceListInner
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof SaveDealWithJournalizing200ResponseCardTransactionEvidenceListInner
     */
    'fileName': string;
    /**
     * 
     * @type {SaveDealWithJournalizing200ResponseCardTransactionEvidenceListInnerCreatedBy}
     * @memberof SaveDealWithJournalizing200ResponseCardTransactionEvidenceListInner
     */
    'createdBy': SaveDealWithJournalizing200ResponseCardTransactionEvidenceListInnerCreatedBy;
    /**
     * 
     * @type {string}
     * @memberof SaveDealWithJournalizing200ResponseCardTransactionEvidenceListInner
     */
    'uploadedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof SaveDealWithJournalizing200ResponseCardTransactionEvidenceListInner
     */
    'isQualified': boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof SaveDealWithJournalizing200ResponseCardTransactionEvidenceListInner
     */
    'asQualified': boolean | null;
}
/**
 * 
 * @export
 * @interface SaveDealWithJournalizing200ResponseCardTransactionEvidenceListInnerCreatedBy
 */
export interface SaveDealWithJournalizing200ResponseCardTransactionEvidenceListInnerCreatedBy {
    /**
     * 
     * @type {string}
     * @memberof SaveDealWithJournalizing200ResponseCardTransactionEvidenceListInnerCreatedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SaveDealWithJournalizing200ResponseCardTransactionEvidenceListInnerCreatedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface SaveDealWithJournalizing200ResponseIntegratedBy
 */
export interface SaveDealWithJournalizing200ResponseIntegratedBy {
    /**
     * 
     * @type {string}
     * @memberof SaveDealWithJournalizing200ResponseIntegratedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SaveDealWithJournalizing200ResponseIntegratedBy
     */
    'name': string;
}
/**
 * null if none of the related evidences have been processed according to the invoicing system compliance. partnerId in this object is currently not supported and is always set as null.
 * @export
 * @interface SaveDealWithJournalizing200ResponseInvoiceIssuer
 */
export interface SaveDealWithJournalizing200ResponseInvoiceIssuer {
    /**
     * 
     * @type {string}
     * @memberof SaveDealWithJournalizing200ResponseInvoiceIssuer
     */
    'name': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealWithJournalizing200ResponseInvoiceIssuer
     */
    'registrationNumber': string | null;
    /**
     * isQualified retains the result of querying the 国税庁API to see if registrationNumber is qualified, as is.
     * @type {boolean}
     * @memberof SaveDealWithJournalizing200ResponseInvoiceIssuer
     */
    'isQualified': boolean;
    /**
     * AsQualified indicates whether this issuer should be treated as a qualified invoice issuer within the user\'s system, even if the RegistrationNumber is not confirmed as qualified in the National Tax Agency\'s business registration system.
     * @type {boolean}
     * @memberof SaveDealWithJournalizing200ResponseInvoiceIssuer
     */
    'asQualified': boolean;
    /**
     * 
     * @type {string}
     * @memberof SaveDealWithJournalizing200ResponseInvoiceIssuer
     */
    'partnerId': string | null;
}
/**
 * 
 * @export
 * @interface SaveDealWithJournalizing200ResponseJournalEntriesInner
 */
export interface SaveDealWithJournalizing200ResponseJournalEntriesInner {
    /**
     * 
     * @type {string}
     * @memberof SaveDealWithJournalizing200ResponseJournalEntriesInner
     */
    'id': string;
    /**
     * 
     * @type {number}
     * @memberof SaveDealWithJournalizing200ResponseJournalEntriesInner
     */
    'amount': number | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealWithJournalizing200ResponseJournalEntriesInner
     */
    'freeeAccountItemId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealWithJournalizing200ResponseJournalEntriesInner
     */
    'freeeTaxCode': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SaveDealWithJournalizing200ResponseJournalEntriesInner
     */
    'isInvalidTaxCode': boolean;
    /**
     * 
     * @type {string}
     * @memberof SaveDealWithJournalizing200ResponseJournalEntriesInner
     */
    'invalidTaxCodeCause': SaveDealWithJournalizing200ResponseJournalEntriesInnerInvalidTaxCodeCauseEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof SaveDealWithJournalizing200ResponseJournalEntriesInner
     */
    'freeeMemoTags': Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealWithJournalizing200ResponseJournalEntriesInner
     */
    'freeeSectionId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealWithJournalizing200ResponseJournalEntriesInner
     */
    'freeeItemId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealWithJournalizing200ResponseJournalEntriesInner
     */
    'segment1TagId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealWithJournalizing200ResponseJournalEntriesInner
     */
    'segment2TagId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealWithJournalizing200ResponseJournalEntriesInner
     */
    'segment3TagId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealWithJournalizing200ResponseJournalEntriesInner
     */
    'description': string | null;
}

export const SaveDealWithJournalizing200ResponseJournalEntriesInnerInvalidTaxCodeCauseEnum = {
    qualifiedButPartDeduct: 'QUALIFIED_BUT_PART_DEDUCT',
    notQualifiedButFullDeduct: 'NOT_QUALIFIED_BUT_FULL_DEDUCT',
    preStartButPartDeduct: 'PRE_START_BUT_PART_DEDUCT',
    inconsistentDeductRate: 'INCONSISTENT_DEDUCT_RATE'
} as const;

export type SaveDealWithJournalizing200ResponseJournalEntriesInnerInvalidTaxCodeCauseEnum = typeof SaveDealWithJournalizing200ResponseJournalEntriesInnerInvalidTaxCodeCauseEnum[keyof typeof SaveDealWithJournalizing200ResponseJournalEntriesInnerInvalidTaxCodeCauseEnum];

/**
 * 
 * @export
 * @interface SaveDealWithJournalizing200ResponseJournalizedBy
 */
export interface SaveDealWithJournalizing200ResponseJournalizedBy {
    /**
     * 
     * @type {string}
     * @memberof SaveDealWithJournalizing200ResponseJournalizedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SaveDealWithJournalizing200ResponseJournalizedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface SaveDealWithJournalizingRequest
 */
export interface SaveDealWithJournalizingRequest {
    /**
     * 
     * @type {string}
     * @memberof SaveDealWithJournalizingRequest
     */
    'freeePartnerId': string | null;
    /**
     * 
     * @type {Array<SaveDealWithJournalizingRequestFreeeJournalEntriesInner>}
     * @memberof SaveDealWithJournalizingRequest
     */
    'freeeJournalEntries': Array<SaveDealWithJournalizingRequestFreeeJournalEntriesInner>;
    /**
     * 
     * @type {SaveDealWithJournalizingRequestInvoiceIssuer}
     * @memberof SaveDealWithJournalizingRequest
     */
    'invoiceIssuer': SaveDealWithJournalizingRequestInvoiceIssuer | null;
}
/**
 * 
 * @export
 * @interface SaveDealWithJournalizingRequestFreeeJournalEntriesInner
 */
export interface SaveDealWithJournalizingRequestFreeeJournalEntriesInner {
    /**
     * 
     * @type {string}
     * @memberof SaveDealWithJournalizingRequestFreeeJournalEntriesInner
     */
    'freeeAccountItemId': string;
    /**
     * 
     * @type {string}
     * @memberof SaveDealWithJournalizingRequestFreeeJournalEntriesInner
     */
    'freeeTaxCode': string;
    /**
     * 
     * @type {number}
     * @memberof SaveDealWithJournalizingRequestFreeeJournalEntriesInner
     */
    'amount': number;
    /**
     * 
     * @type {string}
     * @memberof SaveDealWithJournalizingRequestFreeeJournalEntriesInner
     */
    'freeeItemId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealWithJournalizingRequestFreeeJournalEntriesInner
     */
    'freeeSectionId': string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof SaveDealWithJournalizingRequestFreeeJournalEntriesInner
     */
    'freeeMemoTagIds': Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealWithJournalizingRequestFreeeJournalEntriesInner
     */
    'segment1TagId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealWithJournalizingRequestFreeeJournalEntriesInner
     */
    'segment2TagId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealWithJournalizingRequestFreeeJournalEntriesInner
     */
    'segment3TagId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealWithJournalizingRequestFreeeJournalEntriesInner
     */
    'description': string | null;
}
/**
 * 
 * @export
 * @interface SaveDealWithJournalizingRequestInvoiceIssuer
 */
export interface SaveDealWithJournalizingRequestInvoiceIssuer {
    /**
     * 
     * @type {string}
     * @memberof SaveDealWithJournalizingRequestInvoiceIssuer
     */
    'name': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealWithJournalizingRequestInvoiceIssuer
     */
    'registrationNumber': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SaveDealWithJournalizingRequestInvoiceIssuer
     */
    'asQualified': boolean | null;
}
/**
 * 
 * @export
 * @interface SaveDealsAsIgnoreRequest
 */
export interface SaveDealsAsIgnoreRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof SaveDealsAsIgnoreRequest
     */
    'dealIds': Array<string>;
}
/**
 * 
 * @export
 * @interface SaveDealsAsJournalizedRequest
 */
export interface SaveDealsAsJournalizedRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof SaveDealsAsJournalizedRequest
     */
    'dealIds': Array<string>;
}
/**
 * 
 * @export
 * @interface SaveDealsAsReturnToEditingRequest
 */
export interface SaveDealsAsReturnToEditingRequest {
    /**
     * 
     * @type {Array<number>}
     * @memberof SaveDealsAsReturnToEditingRequest
     */
    'dealIds': Array<number>;
}
/**
 * 
 * @export
 * @interface SearchBankTransfers200ResponseInner
 */
export interface SearchBankTransfers200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof SearchBankTransfers200ResponseInner
     */
    'id': string;
    /**
     * 
     * @type {number}
     * @memberof SearchBankTransfers200ResponseInner
     */
    'totalCount': number;
    /**
     * 
     * @type {number}
     * @memberof SearchBankTransfers200ResponseInner
     */
    'totalAmount': number;
    /**
     * 
     * @type {string}
     * @memberof SearchBankTransfers200ResponseInner
     */
    'fileFormat': SearchBankTransfers200ResponseInnerFileFormatEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof SearchBankTransfers200ResponseInner
     */
    'paymentRequestIds': Array<string>;
    /**
     * 
     * @type {SearchBankTransfers200ResponseInnerSourceBankAccount}
     * @memberof SearchBankTransfers200ResponseInner
     */
    'sourceBankAccount': SearchBankTransfers200ResponseInnerSourceBankAccount;
    /**
     * 
     * @type {SearchBankTransfers200ResponseInnerRequestedBy}
     * @memberof SearchBankTransfers200ResponseInner
     */
    'requestedBy': SearchBankTransfers200ResponseInnerRequestedBy;
    /**
     * 
     * @type {string}
     * @memberof SearchBankTransfers200ResponseInner
     */
    'processedAt': string;
    /**
     * 
     * @type {string}
     * @memberof SearchBankTransfers200ResponseInner
     */
    'transferAt': string;
    /**
     * null if the transfer data has not been downloaded.
     * @type {string}
     * @memberof SearchBankTransfers200ResponseInner
     */
    'downloadedAt': string | null;
}

export const SearchBankTransfers200ResponseInnerFileFormatEnum = {
    disableLineBreak: 'ZENGIN_DISABLE_LINE_BREAK',
    enableLineBreak: 'ZENGIN_ENABLE_LINE_BREAK',
    csv: 'ZENGIN_CSV'
} as const;

export type SearchBankTransfers200ResponseInnerFileFormatEnum = typeof SearchBankTransfers200ResponseInnerFileFormatEnum[keyof typeof SearchBankTransfers200ResponseInnerFileFormatEnum];

/**
 * 
 * @export
 * @interface SearchBankTransfers200ResponseInnerRequestedBy
 */
export interface SearchBankTransfers200ResponseInnerRequestedBy {
    /**
     * 
     * @type {string}
     * @memberof SearchBankTransfers200ResponseInnerRequestedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SearchBankTransfers200ResponseInnerRequestedBy
     */
    'name': string;
}
/**
 * BankAccount without TransferFeeCondition
 * @export
 * @interface SearchBankTransfers200ResponseInnerSourceBankAccount
 */
export interface SearchBankTransfers200ResponseInnerSourceBankAccount {
    /**
     * 
     * @type {string}
     * @memberof SearchBankTransfers200ResponseInnerSourceBankAccount
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SearchBankTransfers200ResponseInnerSourceBankAccount
     */
    'bankNumber': string;
    /**
     * 
     * @type {string}
     * @memberof SearchBankTransfers200ResponseInnerSourceBankAccount
     */
    'bankName': string;
    /**
     * 
     * @type {string}
     * @memberof SearchBankTransfers200ResponseInnerSourceBankAccount
     */
    'branchNumber': string;
    /**
     * 
     * @type {string}
     * @memberof SearchBankTransfers200ResponseInnerSourceBankAccount
     */
    'branchName': string;
    /**
     * 
     * @type {string}
     * @memberof SearchBankTransfers200ResponseInnerSourceBankAccount
     */
    'accountType': SearchBankTransfers200ResponseInnerSourceBankAccountAccountTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof SearchBankTransfers200ResponseInnerSourceBankAccount
     */
    'accountNumber': string;
    /**
     * 
     * @type {string}
     * @memberof SearchBankTransfers200ResponseInnerSourceBankAccount
     */
    'companyCode': string;
    /**
     * 
     * @type {string}
     * @memberof SearchBankTransfers200ResponseInnerSourceBankAccount
     */
    'companyName': string;
}

export const SearchBankTransfers200ResponseInnerSourceBankAccountAccountTypeEnum = {
    savingsAccount: 'SAVINGS_ACCOUNT',
    currentAccount: 'CURRENT_ACCOUNT',
    thriftAccount: 'THRIFT_ACCOUNT',
    other: 'OTHER'
} as const;

export type SearchBankTransfers200ResponseInnerSourceBankAccountAccountTypeEnum = typeof SearchBankTransfers200ResponseInnerSourceBankAccountAccountTypeEnum[keyof typeof SearchBankTransfers200ResponseInnerSourceBankAccountAccountTypeEnum];

/**
 * 
 * @export
 * @interface SearchCorporationsInNationalTaxAgency200ResponseInner
 */
export interface SearchCorporationsInNationalTaxAgency200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof SearchCorporationsInNationalTaxAgency200ResponseInner
     */
    'corporateNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchCorporationsInNationalTaxAgency200ResponseInner
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchCorporationsInNationalTaxAgency200ResponseInner
     */
    'postalCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchCorporationsInNationalTaxAgency200ResponseInner
     */
    'address'?: string;
}
/**
 * 
 * @export
 * @interface SearchDeals200ResponseInner
 */
export interface SearchDeals200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof SearchDeals200ResponseInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SearchDeals200ResponseInner
     */
    'issuedAt': string;
    /**
     * 
     * @type {string}
     * @memberof SearchDeals200ResponseInner
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof SearchDeals200ResponseInner
     */
    'freeeDealId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SearchDeals200ResponseInner
     */
    'freeePartnerId': string | null;
    /**
     * 
     * @type {number}
     * @memberof SearchDeals200ResponseInner
     */
    'partnerId': number | null;
    /**
     * 
     * @type {number}
     * @memberof SearchDeals200ResponseInner
     */
    'amountYen': number;
    /**
     * 
     * @type {string}
     * @memberof SearchDeals200ResponseInner
     */
    'visaTransactionReferenceId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SearchDeals200ResponseInner
     */
    'status': SearchDeals200ResponseInnerStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof SearchDeals200ResponseInner
     */
    'cardHolder': string | null;
    /**
     * 
     * @type {SearchDeals200ResponseInnerJournalizedBy}
     * @memberof SearchDeals200ResponseInner
     */
    'journalizedBy': SearchDeals200ResponseInnerJournalizedBy | null;
    /**
     * 
     * @type {string}
     * @memberof SearchDeals200ResponseInner
     */
    'journalizedAt': string | null;
    /**
     * 
     * @type {SearchDeals200ResponseInnerIntegratedBy}
     * @memberof SearchDeals200ResponseInner
     */
    'integratedBy': SearchDeals200ResponseInnerIntegratedBy | null;
    /**
     * 
     * @type {string}
     * @memberof SearchDeals200ResponseInner
     */
    'integratedAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof SearchDeals200ResponseInner
     */
    'userAccountId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SearchDeals200ResponseInner
     */
    'userAccountName': string | null;
    /**
     * 
     * @type {string}
     * @memberof SearchDeals200ResponseInner
     */
    'userAccountGroupId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SearchDeals200ResponseInner
     */
    'userAccountGroupName': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SearchDeals200ResponseInner
     */
    'isOnDemand': boolean | null;
    /**
     * 
     * @type {Array<SearchDeals200ResponseInnerJournalEntriesInner>}
     * @memberof SearchDeals200ResponseInner
     */
    'journalEntries': Array<SearchDeals200ResponseInnerJournalEntriesInner>;
    /**
     * 
     * @type {Array<SearchDeals200ResponseInnerCardTransactionEvidenceListInner>}
     * @memberof SearchDeals200ResponseInner
     */
    'cardTransactionEvidenceList': Array<SearchDeals200ResponseInnerCardTransactionEvidenceListInner>;
    /**
     * true if the deal has one or more evidences and those all are not qualified, which should be shown as a warning to users.
     * @type {boolean}
     * @memberof SearchDeals200ResponseInner
     */
    'isAllEvidencesNotQualified': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SearchDeals200ResponseInner
     */
    'canSync': boolean;
    /**
     * 
     * @type {SearchDeals200ResponseInnerInvoiceIssuer}
     * @memberof SearchDeals200ResponseInner
     */
    'invoiceIssuer': SearchDeals200ResponseInnerInvoiceIssuer | null;
}

export const SearchDeals200ResponseInnerStatusEnum = {
    notEntered: 'NOT_ENTERED',
    automaticJournalized: 'AUTOMATIC_JOURNALIZED',
    automaticIntegrated: 'AUTOMATIC_INTEGRATED',
    entering: 'ENTERING',
    journalized: 'JOURNALIZED',
    changedAfterJournalization: 'CHANGED_AFTER_JOURNALIZATION',
    integrated: 'INTEGRATED',
    changedAfterIntegration: 'CHANGED_AFTER_INTEGRATION',
    ignored: 'IGNORED',
    readyAutomaticIntegration: 'READY_AUTOMATIC_INTEGRATION'
} as const;

export type SearchDeals200ResponseInnerStatusEnum = typeof SearchDeals200ResponseInnerStatusEnum[keyof typeof SearchDeals200ResponseInnerStatusEnum];

/**
 * 
 * @export
 * @interface SearchDeals200ResponseInnerCardTransactionEvidenceListInner
 */
export interface SearchDeals200ResponseInnerCardTransactionEvidenceListInner {
    /**
     * 
     * @type {string}
     * @memberof SearchDeals200ResponseInnerCardTransactionEvidenceListInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SearchDeals200ResponseInnerCardTransactionEvidenceListInner
     * @deprecated
     */
    'cardTransactionEvidenceId': string;
    /**
     * 
     * @type {string}
     * @memberof SearchDeals200ResponseInnerCardTransactionEvidenceListInner
     * @deprecated
     */
    'visaTransactionReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof SearchDeals200ResponseInnerCardTransactionEvidenceListInner
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof SearchDeals200ResponseInnerCardTransactionEvidenceListInner
     */
    'fileName': string;
    /**
     * 
     * @type {SearchDeals200ResponseInnerCardTransactionEvidenceListInnerCreatedBy}
     * @memberof SearchDeals200ResponseInnerCardTransactionEvidenceListInner
     */
    'createdBy': SearchDeals200ResponseInnerCardTransactionEvidenceListInnerCreatedBy;
    /**
     * 
     * @type {string}
     * @memberof SearchDeals200ResponseInnerCardTransactionEvidenceListInner
     */
    'uploadedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof SearchDeals200ResponseInnerCardTransactionEvidenceListInner
     */
    'isQualified': boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof SearchDeals200ResponseInnerCardTransactionEvidenceListInner
     */
    'asQualified': boolean | null;
}
/**
 * 
 * @export
 * @interface SearchDeals200ResponseInnerCardTransactionEvidenceListInnerCreatedBy
 */
export interface SearchDeals200ResponseInnerCardTransactionEvidenceListInnerCreatedBy {
    /**
     * 
     * @type {string}
     * @memberof SearchDeals200ResponseInnerCardTransactionEvidenceListInnerCreatedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SearchDeals200ResponseInnerCardTransactionEvidenceListInnerCreatedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface SearchDeals200ResponseInnerIntegratedBy
 */
export interface SearchDeals200ResponseInnerIntegratedBy {
    /**
     * 
     * @type {string}
     * @memberof SearchDeals200ResponseInnerIntegratedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SearchDeals200ResponseInnerIntegratedBy
     */
    'name': string;
}
/**
 * null if none of the related evidences have been processed according to the invoicing system compliance. partnerId in this object is currently not supported and is always set as null.
 * @export
 * @interface SearchDeals200ResponseInnerInvoiceIssuer
 */
export interface SearchDeals200ResponseInnerInvoiceIssuer {
    /**
     * 
     * @type {string}
     * @memberof SearchDeals200ResponseInnerInvoiceIssuer
     */
    'name': string | null;
    /**
     * 
     * @type {string}
     * @memberof SearchDeals200ResponseInnerInvoiceIssuer
     */
    'registrationNumber': string | null;
    /**
     * isQualified retains the result of querying the 国税庁API to see if registrationNumber is qualified, as is.
     * @type {boolean}
     * @memberof SearchDeals200ResponseInnerInvoiceIssuer
     */
    'isQualified': boolean;
    /**
     * AsQualified indicates whether this issuer should be treated as a qualified invoice issuer within the user\'s system, even if the RegistrationNumber is not confirmed as qualified in the National Tax Agency\'s business registration system.
     * @type {boolean}
     * @memberof SearchDeals200ResponseInnerInvoiceIssuer
     */
    'asQualified': boolean;
    /**
     * 
     * @type {string}
     * @memberof SearchDeals200ResponseInnerInvoiceIssuer
     */
    'partnerId': string | null;
}
/**
 * 
 * @export
 * @interface SearchDeals200ResponseInnerJournalEntriesInner
 */
export interface SearchDeals200ResponseInnerJournalEntriesInner {
    /**
     * 
     * @type {string}
     * @memberof SearchDeals200ResponseInnerJournalEntriesInner
     */
    'id': string;
    /**
     * 
     * @type {number}
     * @memberof SearchDeals200ResponseInnerJournalEntriesInner
     */
    'amount': number | null;
    /**
     * 
     * @type {string}
     * @memberof SearchDeals200ResponseInnerJournalEntriesInner
     */
    'freeeAccountItemId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SearchDeals200ResponseInnerJournalEntriesInner
     */
    'freeeTaxCode': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SearchDeals200ResponseInnerJournalEntriesInner
     */
    'isInvalidTaxCode': boolean;
    /**
     * 
     * @type {string}
     * @memberof SearchDeals200ResponseInnerJournalEntriesInner
     */
    'invalidTaxCodeCause': SearchDeals200ResponseInnerJournalEntriesInnerInvalidTaxCodeCauseEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof SearchDeals200ResponseInnerJournalEntriesInner
     */
    'freeeMemoTags': Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof SearchDeals200ResponseInnerJournalEntriesInner
     */
    'freeeSectionId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SearchDeals200ResponseInnerJournalEntriesInner
     */
    'freeeItemId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SearchDeals200ResponseInnerJournalEntriesInner
     */
    'segment1TagId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SearchDeals200ResponseInnerJournalEntriesInner
     */
    'segment2TagId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SearchDeals200ResponseInnerJournalEntriesInner
     */
    'segment3TagId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SearchDeals200ResponseInnerJournalEntriesInner
     */
    'description': string | null;
}

export const SearchDeals200ResponseInnerJournalEntriesInnerInvalidTaxCodeCauseEnum = {
    qualifiedButPartDeduct: 'QUALIFIED_BUT_PART_DEDUCT',
    notQualifiedButFullDeduct: 'NOT_QUALIFIED_BUT_FULL_DEDUCT',
    preStartButPartDeduct: 'PRE_START_BUT_PART_DEDUCT',
    inconsistentDeductRate: 'INCONSISTENT_DEDUCT_RATE'
} as const;

export type SearchDeals200ResponseInnerJournalEntriesInnerInvalidTaxCodeCauseEnum = typeof SearchDeals200ResponseInnerJournalEntriesInnerInvalidTaxCodeCauseEnum[keyof typeof SearchDeals200ResponseInnerJournalEntriesInnerInvalidTaxCodeCauseEnum];

/**
 * 
 * @export
 * @interface SearchDeals200ResponseInnerJournalizedBy
 */
export interface SearchDeals200ResponseInnerJournalizedBy {
    /**
     * 
     * @type {string}
     * @memberof SearchDeals200ResponseInnerJournalizedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SearchDeals200ResponseInnerJournalizedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface SearchDealsRequest
 */
export interface SearchDealsRequest {
    /**
     * 
     * @type {number}
     * @memberof SearchDealsRequest
     */
    'limit'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SearchDealsRequest
     */
    'offset'?: number | null;
    /**
     * 
     * @type {SearchDealsRequestSearchCriteria}
     * @memberof SearchDealsRequest
     */
    'searchCriteria': SearchDealsRequestSearchCriteria;
    /**
     * 
     * @type {SearchDealsRequestSortingCriteria}
     * @memberof SearchDealsRequest
     */
    'sortingCriteria': SearchDealsRequestSortingCriteria | null;
}
/**
 * 
 * @export
 * @interface SearchDealsRequestSearchCriteria
 */
export interface SearchDealsRequestSearchCriteria {
    /**
     * 
     * @type {Array<string>}
     * @memberof SearchDealsRequestSearchCriteria
     */
    'dealStatusList'?: Array<SearchDealsRequestSearchCriteriaDealStatusListEnum>;
    /**
     * 
     * @type {string}
     * @memberof SearchDealsRequestSearchCriteria
     */
    'userAccountId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SearchDealsRequestSearchCriteria
     */
    'userAccountGroupId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SearchDealsRequestSearchCriteria
     */
    'dealKeyword'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof SearchDealsRequestSearchCriteria
     */
    'dealIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof SearchDealsRequestSearchCriteria
     */
    'yearMonth'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SearchDealsRequestSearchCriteria
     */
    'startDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SearchDealsRequestSearchCriteria
     */
    'endDate'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SearchDealsRequestSearchCriteria
     */
    'amountLowerLimit'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SearchDealsRequestSearchCriteria
     */
    'amountUpperLimit'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof SearchDealsRequestSearchCriteria
     */
    'qualifiedEvidence'?: SearchDealsRequestSearchCriteriaQualifiedEvidenceEnum;
    /**
     * 
     * @type {number}
     * @memberof SearchDealsRequestSearchCriteria
     */
    'accountItemId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SearchDealsRequestSearchCriteria
     */
    'taxCode'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SearchDealsRequestSearchCriteria
     */
    'itemId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SearchDealsRequestSearchCriteria
     */
    'sectionId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SearchDealsRequestSearchCriteria
     */
    'tagId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SearchDealsRequestSearchCriteria
     */
    'partnerId'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof SearchDealsRequestSearchCriteria
     */
    'canSync'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof SearchDealsRequestSearchCriteria
     */
    'isInvalidTaxCode'?: boolean | null;
}

export const SearchDealsRequestSearchCriteriaDealStatusListEnum = {
    notEntered: 'NOT_ENTERED',
    automaticJournalized: 'AUTOMATIC_JOURNALIZED',
    automaticIntegrated: 'AUTOMATIC_INTEGRATED',
    entering: 'ENTERING',
    journalized: 'JOURNALIZED',
    changedAfterJournalization: 'CHANGED_AFTER_JOURNALIZATION',
    integrated: 'INTEGRATED',
    changedAfterIntegration: 'CHANGED_AFTER_INTEGRATION',
    ignored: 'IGNORED',
    readyAutomaticIntegration: 'READY_AUTOMATIC_INTEGRATION'
} as const;

export type SearchDealsRequestSearchCriteriaDealStatusListEnum = typeof SearchDealsRequestSearchCriteriaDealStatusListEnum[keyof typeof SearchDealsRequestSearchCriteriaDealStatusListEnum];
export const SearchDealsRequestSearchCriteriaQualifiedEvidenceEnum = {
    allNotQualified: 'ALL_NOT_QUALIFIED',
    containQualified: 'CONTAIN_QUALIFIED'
} as const;

export type SearchDealsRequestSearchCriteriaQualifiedEvidenceEnum = typeof SearchDealsRequestSearchCriteriaQualifiedEvidenceEnum[keyof typeof SearchDealsRequestSearchCriteriaQualifiedEvidenceEnum];

/**
 * 
 * @export
 * @interface SearchDealsRequestSortingCriteria
 */
export interface SearchDealsRequestSortingCriteria {
    /**
     * 
     * @type {string}
     * @memberof SearchDealsRequestSortingCriteria
     */
    'field': SearchDealsRequestSortingCriteriaFieldEnum;
    /**
     * 
     * @type {string}
     * @memberof SearchDealsRequestSortingCriteria
     */
    'sortOrder': SearchDealsRequestSortingCriteriaSortOrderEnum;
}

export const SearchDealsRequestSortingCriteriaFieldEnum = {
    issuedAt: 'ISSUED_AT',
    dealName: 'DEAL_NAME',
    amount: 'AMOUNT'
} as const;

export type SearchDealsRequestSortingCriteriaFieldEnum = typeof SearchDealsRequestSortingCriteriaFieldEnum[keyof typeof SearchDealsRequestSortingCriteriaFieldEnum];
export const SearchDealsRequestSortingCriteriaSortOrderEnum = {
    asc: 'ASC',
    desc: 'DESC'
} as const;

export type SearchDealsRequestSortingCriteriaSortOrderEnum = typeof SearchDealsRequestSortingCriteriaSortOrderEnum[keyof typeof SearchDealsRequestSortingCriteriaSortOrderEnum];

/**
 * 
 * @export
 * @interface SearchEvidences200ResponseInner
 */
export interface SearchEvidences200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof SearchEvidences200ResponseInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SearchEvidences200ResponseInner
     */
    'userAccountId': string;
    /**
     * 
     * @type {string}
     * @memberof SearchEvidences200ResponseInner
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof SearchEvidences200ResponseInner
     */
    'paymentType': SearchEvidences200ResponseInnerPaymentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof SearchEvidences200ResponseInner
     */
    'paidAt': string;
    /**
     * 
     * @type {number}
     * @memberof SearchEvidences200ResponseInner
     */
    'amount': number;
    /**
     * 
     * @type {number}
     * @memberof SearchEvidences200ResponseInner
     */
    'amountFx': number;
    /**
     * 
     * @type {string}
     * @memberof SearchEvidences200ResponseInner
     */
    'currency': string;
    /**
     * 
     * @type {string}
     * @memberof SearchEvidences200ResponseInner
     */
    'issuer': string;
    /**
     * 
     * @type {string}
     * @memberof SearchEvidences200ResponseInner
     */
    'fileName': string;
    /**
     * 
     * @type {string}
     * @memberof SearchEvidences200ResponseInner
     */
    'fileExtension': string;
    /**
     * 
     * @type {string}
     * @memberof SearchEvidences200ResponseInner
     */
    'electronicMethod': SearchEvidences200ResponseInnerElectronicMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof SearchEvidences200ResponseInner
     */
    'documentSize': SearchEvidences200ResponseInnerDocumentSizeEnum;
    /**
     * 
     * @type {number}
     * @memberof SearchEvidences200ResponseInner
     * @deprecated
     */
    'dpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof SearchEvidences200ResponseInner
     */
    'detectedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof SearchEvidences200ResponseInner
     */
    'calculatedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof SearchEvidences200ResponseInner
     */
    'colorGradation': number | null;
    /**
     * 
     * @type {number}
     * @memberof SearchEvidences200ResponseInner
     */
    'verticalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof SearchEvidences200ResponseInner
     */
    'horizontalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof SearchEvidences200ResponseInner
     */
    'heightMillis': number | null;
    /**
     * 
     * @type {number}
     * @memberof SearchEvidences200ResponseInner
     */
    'widthMillis': number | null;
    /**
     * 
     * @type {string}
     * @memberof SearchEvidences200ResponseInner
     */
    'legalValidity': SearchEvidences200ResponseInnerLegalValidityEnum;
    /**
     * 
     * @type {string}
     * @memberof SearchEvidences200ResponseInner
     */
    'note': string;
    /**
     * 
     * @type {boolean}
     * @memberof SearchEvidences200ResponseInner
     */
    'irrelevantToLedger': boolean;
    /**
     * 
     * @type {SearchEvidences200ResponseInnerInvoiceIssuer}
     * @memberof SearchEvidences200ResponseInner
     */
    'invoiceIssuer': SearchEvidences200ResponseInnerInvoiceIssuer | null;
    /**
     * 
     * @type {string}
     * @memberof SearchEvidences200ResponseInner
     * @deprecated
     */
    'dpiError': SearchEvidences200ResponseInnerDpiErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof SearchEvidences200ResponseInner
     * @deprecated
     */
    'detectedDpiError': SearchEvidences200ResponseInnerDetectedDpiErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof SearchEvidences200ResponseInner
     * @deprecated
     */
    'calculatedDpiError': SearchEvidences200ResponseInnerCalculatedDpiErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof SearchEvidences200ResponseInner
     * @deprecated
     */
    'colorGradationError': SearchEvidences200ResponseInnerColorGradationErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof SearchEvidences200ResponseInner
     * @deprecated
     */
    'heightMillisError': SearchEvidences200ResponseInnerHeightMillisErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof SearchEvidences200ResponseInner
     * @deprecated
     */
    'widthMillisError': SearchEvidences200ResponseInnerWidthMillisErrorEnum;
    /**
     * 
     * @type {SearchEvidences200ResponseInnerErrors}
     * @memberof SearchEvidences200ResponseInner
     */
    'errors': SearchEvidences200ResponseInnerErrors;
    /**
     * 
     * @type {SearchEvidences200ResponseInnerWarnings}
     * @memberof SearchEvidences200ResponseInner
     */
    'warnings': SearchEvidences200ResponseInnerWarnings;
    /**
     * 
     * @type {SearchEvidences200ResponseInnerUpdatedBy}
     * @memberof SearchEvidences200ResponseInner
     */
    'updatedBy': SearchEvidences200ResponseInnerUpdatedBy;
    /**
     * 
     * @type {string}
     * @memberof SearchEvidences200ResponseInner
     */
    'updatedAt': string;
    /**
     * 
     * @type {SearchEvidences200ResponseInnerUploadedBy}
     * @memberof SearchEvidences200ResponseInner
     */
    'uploadedBy': SearchEvidences200ResponseInnerUploadedBy;
    /**
     * 
     * @type {string}
     * @memberof SearchEvidences200ResponseInner
     */
    'uploadedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof SearchEvidences200ResponseInner
     */
    'deleted': boolean;
}

export const SearchEvidences200ResponseInnerPaymentTypeEnum = {
    cardTransaction: 'CARD_TRANSACTION',
    paymentRequest: 'PAYMENT_REQUEST'
} as const;

export type SearchEvidences200ResponseInnerPaymentTypeEnum = typeof SearchEvidences200ResponseInnerPaymentTypeEnum[keyof typeof SearchEvidences200ResponseInnerPaymentTypeEnum];
export const SearchEvidences200ResponseInnerElectronicMethodEnum = {
    fullElectronic: 'FULL_ELECTRONIC',
    originallyPaper: 'ORIGINALLY_PAPER',
    unknown: 'UNKNOWN'
} as const;

export type SearchEvidences200ResponseInnerElectronicMethodEnum = typeof SearchEvidences200ResponseInnerElectronicMethodEnum[keyof typeof SearchEvidences200ResponseInnerElectronicMethodEnum];
export const SearchEvidences200ResponseInnerDocumentSizeEnum = {
    overA4: 'OVER_A4',
    a4OrSmaller: 'A4_OR_SMALLER',
    unknown: 'UNKNOWN'
} as const;

export type SearchEvidences200ResponseInnerDocumentSizeEnum = typeof SearchEvidences200ResponseInnerDocumentSizeEnum[keyof typeof SearchEvidences200ResponseInnerDocumentSizeEnum];
export const SearchEvidences200ResponseInnerLegalValidityEnum = {
    valid: 'VALID',
    invalid: 'INVALID',
    inputRequired: 'INPUT_REQUIRED',
    outOfTarget: 'OUT_OF_TARGET'
} as const;

export type SearchEvidences200ResponseInnerLegalValidityEnum = typeof SearchEvidences200ResponseInnerLegalValidityEnum[keyof typeof SearchEvidences200ResponseInnerLegalValidityEnum];
export const SearchEvidences200ResponseInnerDpiErrorEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type SearchEvidences200ResponseInnerDpiErrorEnum = typeof SearchEvidences200ResponseInnerDpiErrorEnum[keyof typeof SearchEvidences200ResponseInnerDpiErrorEnum];
export const SearchEvidences200ResponseInnerDetectedDpiErrorEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type SearchEvidences200ResponseInnerDetectedDpiErrorEnum = typeof SearchEvidences200ResponseInnerDetectedDpiErrorEnum[keyof typeof SearchEvidences200ResponseInnerDetectedDpiErrorEnum];
export const SearchEvidences200ResponseInnerCalculatedDpiErrorEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type SearchEvidences200ResponseInnerCalculatedDpiErrorEnum = typeof SearchEvidences200ResponseInnerCalculatedDpiErrorEnum[keyof typeof SearchEvidences200ResponseInnerCalculatedDpiErrorEnum];
export const SearchEvidences200ResponseInnerColorGradationErrorEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type SearchEvidences200ResponseInnerColorGradationErrorEnum = typeof SearchEvidences200ResponseInnerColorGradationErrorEnum[keyof typeof SearchEvidences200ResponseInnerColorGradationErrorEnum];
export const SearchEvidences200ResponseInnerHeightMillisErrorEnum = {
    required: 'REQUIRED'
} as const;

export type SearchEvidences200ResponseInnerHeightMillisErrorEnum = typeof SearchEvidences200ResponseInnerHeightMillisErrorEnum[keyof typeof SearchEvidences200ResponseInnerHeightMillisErrorEnum];
export const SearchEvidences200ResponseInnerWidthMillisErrorEnum = {
    required: 'REQUIRED'
} as const;

export type SearchEvidences200ResponseInnerWidthMillisErrorEnum = typeof SearchEvidences200ResponseInnerWidthMillisErrorEnum[keyof typeof SearchEvidences200ResponseInnerWidthMillisErrorEnum];

/**
 * 
 * @export
 * @interface SearchEvidences200ResponseInnerErrors
 */
export interface SearchEvidences200ResponseInnerErrors {
    /**
     * 
     * @type {string}
     * @memberof SearchEvidences200ResponseInnerErrors
     */
    'detectedDpi'?: SearchEvidences200ResponseInnerErrorsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof SearchEvidences200ResponseInnerErrors
     */
    'calculatedDpi'?: SearchEvidences200ResponseInnerErrorsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof SearchEvidences200ResponseInnerErrors
     */
    'colorGradation'?: SearchEvidences200ResponseInnerErrorsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof SearchEvidences200ResponseInnerErrors
     */
    'heightMillis'?: SearchEvidences200ResponseInnerErrorsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof SearchEvidences200ResponseInnerErrors
     */
    'widthMillis'?: SearchEvidences200ResponseInnerErrorsWidthMillisEnum;
}

export const SearchEvidences200ResponseInnerErrorsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type SearchEvidences200ResponseInnerErrorsDetectedDpiEnum = typeof SearchEvidences200ResponseInnerErrorsDetectedDpiEnum[keyof typeof SearchEvidences200ResponseInnerErrorsDetectedDpiEnum];
export const SearchEvidences200ResponseInnerErrorsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type SearchEvidences200ResponseInnerErrorsCalculatedDpiEnum = typeof SearchEvidences200ResponseInnerErrorsCalculatedDpiEnum[keyof typeof SearchEvidences200ResponseInnerErrorsCalculatedDpiEnum];
export const SearchEvidences200ResponseInnerErrorsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type SearchEvidences200ResponseInnerErrorsColorGradationEnum = typeof SearchEvidences200ResponseInnerErrorsColorGradationEnum[keyof typeof SearchEvidences200ResponseInnerErrorsColorGradationEnum];
export const SearchEvidences200ResponseInnerErrorsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type SearchEvidences200ResponseInnerErrorsHeightMillisEnum = typeof SearchEvidences200ResponseInnerErrorsHeightMillisEnum[keyof typeof SearchEvidences200ResponseInnerErrorsHeightMillisEnum];
export const SearchEvidences200ResponseInnerErrorsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type SearchEvidences200ResponseInnerErrorsWidthMillisEnum = typeof SearchEvidences200ResponseInnerErrorsWidthMillisEnum[keyof typeof SearchEvidences200ResponseInnerErrorsWidthMillisEnum];

/**
 * Set null if it\'s evidence not analyzed using invoicing-system-compliance feature. Also set null if invoicing-system-compliance feature has been made not available for the organization by the feature-flag.
 * @export
 * @interface SearchEvidences200ResponseInnerInvoiceIssuer
 */
export interface SearchEvidences200ResponseInnerInvoiceIssuer {
    /**
     * 
     * @type {string}
     * @memberof SearchEvidences200ResponseInnerInvoiceIssuer
     */
    'name': string | null;
    /**
     * 
     * @type {string}
     * @memberof SearchEvidences200ResponseInnerInvoiceIssuer
     */
    'registrationNumber': string | null;
    /**
     * isQualified retains the result of querying the 国税庁API to see if registrationNumber is qualified, as is.
     * @type {boolean}
     * @memberof SearchEvidences200ResponseInnerInvoiceIssuer
     */
    'isQualified': boolean;
    /**
     * AsQualified indicates whether this issuer should be treated as a qualified invoice issuer within the user\'s system, even if the RegistrationNumber is not confirmed as qualified in the National Tax Agency\'s business registration system.
     * @type {boolean}
     * @memberof SearchEvidences200ResponseInnerInvoiceIssuer
     */
    'asQualified': boolean;
    /**
     * 
     * @type {string}
     * @memberof SearchEvidences200ResponseInnerInvoiceIssuer
     */
    'partnerId': string | null;
}
/**
 * 
 * @export
 * @interface SearchEvidences200ResponseInnerUpdatedBy
 */
export interface SearchEvidences200ResponseInnerUpdatedBy {
    /**
     * 
     * @type {string}
     * @memberof SearchEvidences200ResponseInnerUpdatedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SearchEvidences200ResponseInnerUpdatedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface SearchEvidences200ResponseInnerUploadedBy
 */
export interface SearchEvidences200ResponseInnerUploadedBy {
    /**
     * 
     * @type {string}
     * @memberof SearchEvidences200ResponseInnerUploadedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SearchEvidences200ResponseInnerUploadedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface SearchEvidences200ResponseInnerWarnings
 */
export interface SearchEvidences200ResponseInnerWarnings {
    /**
     * 
     * @type {string}
     * @memberof SearchEvidences200ResponseInnerWarnings
     */
    'detectedDpi'?: SearchEvidences200ResponseInnerWarningsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof SearchEvidences200ResponseInnerWarnings
     */
    'calculatedDpi'?: SearchEvidences200ResponseInnerWarningsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof SearchEvidences200ResponseInnerWarnings
     */
    'colorGradation'?: SearchEvidences200ResponseInnerWarningsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof SearchEvidences200ResponseInnerWarnings
     */
    'heightMillis'?: SearchEvidences200ResponseInnerWarningsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof SearchEvidences200ResponseInnerWarnings
     */
    'widthMillis'?: SearchEvidences200ResponseInnerWarningsWidthMillisEnum;
}

export const SearchEvidences200ResponseInnerWarningsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type SearchEvidences200ResponseInnerWarningsDetectedDpiEnum = typeof SearchEvidences200ResponseInnerWarningsDetectedDpiEnum[keyof typeof SearchEvidences200ResponseInnerWarningsDetectedDpiEnum];
export const SearchEvidences200ResponseInnerWarningsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type SearchEvidences200ResponseInnerWarningsCalculatedDpiEnum = typeof SearchEvidences200ResponseInnerWarningsCalculatedDpiEnum[keyof typeof SearchEvidences200ResponseInnerWarningsCalculatedDpiEnum];
export const SearchEvidences200ResponseInnerWarningsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type SearchEvidences200ResponseInnerWarningsColorGradationEnum = typeof SearchEvidences200ResponseInnerWarningsColorGradationEnum[keyof typeof SearchEvidences200ResponseInnerWarningsColorGradationEnum];
export const SearchEvidences200ResponseInnerWarningsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type SearchEvidences200ResponseInnerWarningsHeightMillisEnum = typeof SearchEvidences200ResponseInnerWarningsHeightMillisEnum[keyof typeof SearchEvidences200ResponseInnerWarningsHeightMillisEnum];
export const SearchEvidences200ResponseInnerWarningsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type SearchEvidences200ResponseInnerWarningsWidthMillisEnum = typeof SearchEvidences200ResponseInnerWarningsWidthMillisEnum[keyof typeof SearchEvidences200ResponseInnerWarningsWidthMillisEnum];

/**
 * 
 * @export
 * @interface SearchMyPaymentRequests200ResponseInner
 */
export interface SearchMyPaymentRequests200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof SearchMyPaymentRequests200ResponseInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SearchMyPaymentRequests200ResponseInner
     */
    'serialNumber': string;
    /**
     * 
     * @type {SearchMyPaymentRequests200ResponseInnerSupplier}
     * @memberof SearchMyPaymentRequests200ResponseInner
     */
    'supplier': SearchMyPaymentRequests200ResponseInnerSupplier;
    /**
     * 
     * @type {string}
     * @memberof SearchMyPaymentRequests200ResponseInner
     */
    'dueDate': string;
    /**
     * 
     * @type {number}
     * @memberof SearchMyPaymentRequests200ResponseInner
     */
    'totalAmount': number;
    /**
     * 
     * @type {string}
     * @memberof SearchMyPaymentRequests200ResponseInner
     */
    'transferFeeResponsibility': SearchMyPaymentRequests200ResponseInnerTransferFeeResponsibilityEnum;
    /**
     * 
     * @type {string}
     * @memberof SearchMyPaymentRequests200ResponseInner
     */
    'memo': string | null;
    /**
     * 
     * @type {string}
     * @memberof SearchMyPaymentRequests200ResponseInner
     */
    'withholdingCalculatingMethod': SearchMyPaymentRequests200ResponseInnerWithholdingCalculatingMethodEnum;
    /**
     * 
     * @type {number}
     * @memberof SearchMyPaymentRequests200ResponseInner
     */
    'withholdingAmount': number | null;
    /**
     * 
     * @type {string}
     * @memberof SearchMyPaymentRequests200ResponseInner
     */
    'status': SearchMyPaymentRequests200ResponseInnerStatusEnum;
    /**
     * 
     * @type {SearchMyPaymentRequests200ResponseInnerRequestor}
     * @memberof SearchMyPaymentRequests200ResponseInner
     */
    'requestor': SearchMyPaymentRequests200ResponseInnerRequestor;
    /**
     * requestorName is the name of the requesting user at the time this PaymentRequest was requested. The free word search targets the name of requesting user, but it is the requestorName that is targeted, not the name of the user at the time of the search. Use requestor.name if you want to know what is the name at present of the user.
     * @type {string}
     * @memberof SearchMyPaymentRequests200ResponseInner
     */
    'requestorName': string;
    /**
     * 
     * @type {string}
     * @memberof SearchMyPaymentRequests200ResponseInner
     */
    'requestedAt': string;
    /**
     * If bank transfer data has already been created, return the ID. Otherwise, null.
     * @type {string}
     * @memberof SearchMyPaymentRequests200ResponseInner
     */
    'bankTransferId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SearchMyPaymentRequests200ResponseInner
     */
    'invoiceEvidenceId': string;
}

export const SearchMyPaymentRequests200ResponseInnerTransferFeeResponsibilityEnum = {
    self: 'SELF',
    supplier: 'SUPPLIER'
} as const;

export type SearchMyPaymentRequests200ResponseInnerTransferFeeResponsibilityEnum = typeof SearchMyPaymentRequests200ResponseInnerTransferFeeResponsibilityEnum[keyof typeof SearchMyPaymentRequests200ResponseInnerTransferFeeResponsibilityEnum];
export const SearchMyPaymentRequests200ResponseInnerWithholdingCalculatingMethodEnum = {
    none: 'NONE',
    manuscriptOrLecture: 'MANUSCRIPT_OR_LECTURE',
    lawyerOrCpa: 'LAWYER_OR_CPA',
    judicialScrivener: 'JUDICIAL_SCRIVENER',
    other: 'OTHER'
} as const;

export type SearchMyPaymentRequests200ResponseInnerWithholdingCalculatingMethodEnum = typeof SearchMyPaymentRequests200ResponseInnerWithholdingCalculatingMethodEnum[keyof typeof SearchMyPaymentRequests200ResponseInnerWithholdingCalculatingMethodEnum];
export const SearchMyPaymentRequests200ResponseInnerStatusEnum = {
    pendingWorkflowCompletion: 'PENDING_WORKFLOW_COMPLETION',
    canceled: 'CANCELED',
    payable: 'PAYABLE',
    attachedToBankTransfer: 'ATTACHED_TO_BANK_TRANSFER',
    deactivated: 'DEACTIVATED'
} as const;

export type SearchMyPaymentRequests200ResponseInnerStatusEnum = typeof SearchMyPaymentRequests200ResponseInnerStatusEnum[keyof typeof SearchMyPaymentRequests200ResponseInnerStatusEnum];

/**
 * 
 * @export
 * @interface SearchMyPaymentRequests200ResponseInnerRequestor
 */
export interface SearchMyPaymentRequests200ResponseInnerRequestor {
    /**
     * 
     * @type {string}
     * @memberof SearchMyPaymentRequests200ResponseInnerRequestor
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SearchMyPaymentRequests200ResponseInnerRequestor
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface SearchMyPaymentRequests200ResponseInnerSupplier
 */
export interface SearchMyPaymentRequests200ResponseInnerSupplier {
    /**
     * 
     * @type {string}
     * @memberof SearchMyPaymentRequests200ResponseInnerSupplier
     */
    'partnerId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SearchMyPaymentRequests200ResponseInnerSupplier
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof SearchMyPaymentRequests200ResponseInnerSupplier
     */
    'bankNumber': string;
    /**
     * 
     * @type {string}
     * @memberof SearchMyPaymentRequests200ResponseInnerSupplier
     */
    'bankName': string;
    /**
     * 
     * @type {string}
     * @memberof SearchMyPaymentRequests200ResponseInnerSupplier
     */
    'branchNumber': string;
    /**
     * 
     * @type {string}
     * @memberof SearchMyPaymentRequests200ResponseInnerSupplier
     */
    'branchName': string;
    /**
     * 
     * @type {string}
     * @memberof SearchMyPaymentRequests200ResponseInnerSupplier
     */
    'accountType': SearchMyPaymentRequests200ResponseInnerSupplierAccountTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof SearchMyPaymentRequests200ResponseInnerSupplier
     */
    'accountNumber': string;
    /**
     * 
     * @type {string}
     * @memberof SearchMyPaymentRequests200ResponseInnerSupplier
     */
    'companyCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SearchMyPaymentRequests200ResponseInnerSupplier
     */
    'companyName': string;
}

export const SearchMyPaymentRequests200ResponseInnerSupplierAccountTypeEnum = {
    savingsAccount: 'SAVINGS_ACCOUNT',
    currentAccount: 'CURRENT_ACCOUNT',
    thriftAccount: 'THRIFT_ACCOUNT',
    other: 'OTHER'
} as const;

export type SearchMyPaymentRequests200ResponseInnerSupplierAccountTypeEnum = typeof SearchMyPaymentRequests200ResponseInnerSupplierAccountTypeEnum[keyof typeof SearchMyPaymentRequests200ResponseInnerSupplierAccountTypeEnum];

/**
 * 
 * @export
 * @interface SearchOrganizations200ResponseInner
 */
export interface SearchOrganizations200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof SearchOrganizations200ResponseInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SearchOrganizations200ResponseInner
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface SearchPaymentRequests200ResponseInner
 */
export interface SearchPaymentRequests200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof SearchPaymentRequests200ResponseInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SearchPaymentRequests200ResponseInner
     */
    'serialNumber': string;
    /**
     * 
     * @type {SearchPaymentRequests200ResponseInnerSupplier}
     * @memberof SearchPaymentRequests200ResponseInner
     */
    'supplier': SearchPaymentRequests200ResponseInnerSupplier;
    /**
     * 
     * @type {string}
     * @memberof SearchPaymentRequests200ResponseInner
     */
    'dueDate': string;
    /**
     * 
     * @type {number}
     * @memberof SearchPaymentRequests200ResponseInner
     */
    'totalAmount': number;
    /**
     * 
     * @type {string}
     * @memberof SearchPaymentRequests200ResponseInner
     */
    'transferFeeResponsibility': SearchPaymentRequests200ResponseInnerTransferFeeResponsibilityEnum;
    /**
     * 
     * @type {string}
     * @memberof SearchPaymentRequests200ResponseInner
     */
    'memo': string | null;
    /**
     * 
     * @type {string}
     * @memberof SearchPaymentRequests200ResponseInner
     */
    'withholdingCalculatingMethod': SearchPaymentRequests200ResponseInnerWithholdingCalculatingMethodEnum;
    /**
     * 
     * @type {number}
     * @memberof SearchPaymentRequests200ResponseInner
     */
    'withholdingAmount': number | null;
    /**
     * 
     * @type {string}
     * @memberof SearchPaymentRequests200ResponseInner
     */
    'status': SearchPaymentRequests200ResponseInnerStatusEnum;
    /**
     * 
     * @type {SearchPaymentRequests200ResponseInnerRequestor}
     * @memberof SearchPaymentRequests200ResponseInner
     */
    'requestor': SearchPaymentRequests200ResponseInnerRequestor;
    /**
     * requestorName is the name of the requesting user at the time this PaymentRequest was requested. The free word search targets the name of requesting user, but it is the requestorName that is targeted, not the name of the user at the time of the search. Use requestor.name if you want to know what is the name at present of the user.
     * @type {string}
     * @memberof SearchPaymentRequests200ResponseInner
     */
    'requestorName': string;
    /**
     * 
     * @type {string}
     * @memberof SearchPaymentRequests200ResponseInner
     */
    'requestedAt': string;
    /**
     * If bank transfer data has already been created, return the ID. Otherwise, null.
     * @type {string}
     * @memberof SearchPaymentRequests200ResponseInner
     */
    'bankTransferId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SearchPaymentRequests200ResponseInner
     */
    'invoiceEvidenceId': string;
}

export const SearchPaymentRequests200ResponseInnerTransferFeeResponsibilityEnum = {
    self: 'SELF',
    supplier: 'SUPPLIER'
} as const;

export type SearchPaymentRequests200ResponseInnerTransferFeeResponsibilityEnum = typeof SearchPaymentRequests200ResponseInnerTransferFeeResponsibilityEnum[keyof typeof SearchPaymentRequests200ResponseInnerTransferFeeResponsibilityEnum];
export const SearchPaymentRequests200ResponseInnerWithholdingCalculatingMethodEnum = {
    none: 'NONE',
    manuscriptOrLecture: 'MANUSCRIPT_OR_LECTURE',
    lawyerOrCpa: 'LAWYER_OR_CPA',
    judicialScrivener: 'JUDICIAL_SCRIVENER',
    other: 'OTHER'
} as const;

export type SearchPaymentRequests200ResponseInnerWithholdingCalculatingMethodEnum = typeof SearchPaymentRequests200ResponseInnerWithholdingCalculatingMethodEnum[keyof typeof SearchPaymentRequests200ResponseInnerWithholdingCalculatingMethodEnum];
export const SearchPaymentRequests200ResponseInnerStatusEnum = {
    pendingWorkflowCompletion: 'PENDING_WORKFLOW_COMPLETION',
    canceled: 'CANCELED',
    payable: 'PAYABLE',
    attachedToBankTransfer: 'ATTACHED_TO_BANK_TRANSFER',
    deactivated: 'DEACTIVATED'
} as const;

export type SearchPaymentRequests200ResponseInnerStatusEnum = typeof SearchPaymentRequests200ResponseInnerStatusEnum[keyof typeof SearchPaymentRequests200ResponseInnerStatusEnum];

/**
 * 
 * @export
 * @interface SearchPaymentRequests200ResponseInnerRequestor
 */
export interface SearchPaymentRequests200ResponseInnerRequestor {
    /**
     * 
     * @type {string}
     * @memberof SearchPaymentRequests200ResponseInnerRequestor
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SearchPaymentRequests200ResponseInnerRequestor
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface SearchPaymentRequests200ResponseInnerSupplier
 */
export interface SearchPaymentRequests200ResponseInnerSupplier {
    /**
     * 
     * @type {string}
     * @memberof SearchPaymentRequests200ResponseInnerSupplier
     */
    'partnerId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SearchPaymentRequests200ResponseInnerSupplier
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof SearchPaymentRequests200ResponseInnerSupplier
     */
    'bankNumber': string;
    /**
     * 
     * @type {string}
     * @memberof SearchPaymentRequests200ResponseInnerSupplier
     */
    'bankName': string;
    /**
     * 
     * @type {string}
     * @memberof SearchPaymentRequests200ResponseInnerSupplier
     */
    'branchNumber': string;
    /**
     * 
     * @type {string}
     * @memberof SearchPaymentRequests200ResponseInnerSupplier
     */
    'branchName': string;
    /**
     * 
     * @type {string}
     * @memberof SearchPaymentRequests200ResponseInnerSupplier
     */
    'accountType': SearchPaymentRequests200ResponseInnerSupplierAccountTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof SearchPaymentRequests200ResponseInnerSupplier
     */
    'accountNumber': string;
    /**
     * 
     * @type {string}
     * @memberof SearchPaymentRequests200ResponseInnerSupplier
     */
    'companyCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SearchPaymentRequests200ResponseInnerSupplier
     */
    'companyName': string;
}

export const SearchPaymentRequests200ResponseInnerSupplierAccountTypeEnum = {
    savingsAccount: 'SAVINGS_ACCOUNT',
    currentAccount: 'CURRENT_ACCOUNT',
    thriftAccount: 'THRIFT_ACCOUNT',
    other: 'OTHER'
} as const;

export type SearchPaymentRequests200ResponseInnerSupplierAccountTypeEnum = typeof SearchPaymentRequests200ResponseInnerSupplierAccountTypeEnum[keyof typeof SearchPaymentRequests200ResponseInnerSupplierAccountTypeEnum];

/**
 * 
 * @export
 * @interface SendOrganizationIdentityVerificationRequest
 */
export interface SendOrganizationIdentityVerificationRequest {
    /**
     * 
     * @type {string}
     * @memberof SendOrganizationIdentityVerificationRequest
     */
    'corporateNumber': string;
    /**
     * 
     * @type {number}
     * @memberof SendOrganizationIdentityVerificationRequest
     */
    'businessDescriptionId': number;
    /**
     * 
     * @type {string}
     * @memberof SendOrganizationIdentityVerificationRequest
     */
    'purposeTransaction': string;
    /**
     * 
     * @type {string}
     * @memberof SendOrganizationIdentityVerificationRequest
     */
    'purposeTransactionOther': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SendOrganizationIdentityVerificationRequest
     */
    'isExistsBeneficialOwner': boolean;
    /**
     * 
     * @type {SendOrganizationIdentityVerificationRequestCorporateType}
     * @memberof SendOrganizationIdentityVerificationRequest
     */
    'corporateType': SendOrganizationIdentityVerificationRequestCorporateType | null;
    /**
     * 
     * @type {Array<SendOrganizationIdentityVerificationRequestBeneficialOwnersInner>}
     * @memberof SendOrganizationIdentityVerificationRequest
     */
    'beneficialOwners'?: Array<SendOrganizationIdentityVerificationRequestBeneficialOwnersInner>;
    /**
     * 
     * @type {boolean}
     * @memberof SendOrganizationIdentityVerificationRequest
     */
    'isRepresentative': boolean;
    /**
     * 
     * @type {string}
     * @memberof SendOrganizationIdentityVerificationRequest
     */
    'transactionManagerName': string;
    /**
     * 
     * @type {string}
     * @memberof SendOrganizationIdentityVerificationRequest
     */
    'transactionManagerBirthday': string;
    /**
     * 
     * @type {string}
     * @memberof SendOrganizationIdentityVerificationRequest
     */
    'transactionManagerAddress': string;
    /**
     * 
     * @type {string}
     * @memberof SendOrganizationIdentityVerificationRequest
     */
    'transactionManagerEmail': string;
}
/**
 * 
 * @export
 * @interface SendOrganizationIdentityVerificationRequestBeneficialOwnersInner
 */
export interface SendOrganizationIdentityVerificationRequestBeneficialOwnersInner {
    /**
     * 
     * @type {string}
     * @memberof SendOrganizationIdentityVerificationRequestBeneficialOwnersInner
     */
    'corporateRelationships': SendOrganizationIdentityVerificationRequestBeneficialOwnersInnerCorporateRelationshipsEnum;
    /**
     * 
     * @type {string}
     * @memberof SendOrganizationIdentityVerificationRequestBeneficialOwnersInner
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof SendOrganizationIdentityVerificationRequestBeneficialOwnersInner
     */
    'beneficialOwnerType': string;
    /**
     * 
     * @type {string}
     * @memberof SendOrganizationIdentityVerificationRequestBeneficialOwnersInner
     */
    'gender': string;
    /**
     * 
     * @type {string}
     * @memberof SendOrganizationIdentityVerificationRequestBeneficialOwnersInner
     */
    'birthday': string;
    /**
     * 
     * @type {string}
     * @memberof SendOrganizationIdentityVerificationRequestBeneficialOwnersInner
     */
    'countryResidence': string;
    /**
     * 
     * @type {string}
     * @memberof SendOrganizationIdentityVerificationRequestBeneficialOwnersInner
     */
    'address': string;
    /**
     * 
     * @type {boolean}
     * @memberof SendOrganizationIdentityVerificationRequestBeneficialOwnersInner
     */
    'isPoliticallyExposedPersons': boolean;
}

export const SendOrganizationIdentityVerificationRequestBeneficialOwnersInnerCorporateRelationshipsEnum = {
    hasRightOver50Per: 'HAS_RIGHT_OVER_50PER',
    hasRightOver25Per: 'HAS_RIGHT_OVER_25PER',
    hasControllingInfluenceOverBusinessActivity: 'HAS_CONTROLLING_INFLUENCE_OVER_BUSINESS_ACTIVITY',
    businessExecutor: 'BUSINESS_EXECUTOR'
} as const;

export type SendOrganizationIdentityVerificationRequestBeneficialOwnersInnerCorporateRelationshipsEnum = typeof SendOrganizationIdentityVerificationRequestBeneficialOwnersInnerCorporateRelationshipsEnum[keyof typeof SendOrganizationIdentityVerificationRequestBeneficialOwnersInnerCorporateRelationshipsEnum];

/**
 * @type SendOrganizationIdentityVerificationRequestCorporateType
 * @export
 */
export type SendOrganizationIdentityVerificationRequestCorporateType = SendOrganizationIdentityVerificationRequestCorporateTypeOneOf;

/**
 * 
 * @export
 * @enum {string}
 */

export const SendOrganizationIdentityVerificationRequestCorporateTypeOneOf = {
    majorityCapitalVoteCorporate: 'MAJORITY_CAPITAL_VOTE_CORPORATE',
    exceptMajorityCapitalVoteCorporate: 'EXCEPT_MAJORITY_CAPITAL_VOTE_CORPORATE'
} as const;

export type SendOrganizationIdentityVerificationRequestCorporateTypeOneOf = typeof SendOrganizationIdentityVerificationRequestCorporateTypeOneOf[keyof typeof SendOrganizationIdentityVerificationRequestCorporateTypeOneOf];


/**
 * 
 * @export
 * @interface SendTransactionAuthorizationRequestRequest
 */
export interface SendTransactionAuthorizationRequestRequest {
    /**
     * 
     * @type {string}
     * @memberof SendTransactionAuthorizationRequestRequest
     */
    'transactionReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof SendTransactionAuthorizationRequestRequest
     */
    'usage': SendTransactionAuthorizationRequestRequestUsageEnum;
    /**
     * 
     * @type {string}
     * @memberof SendTransactionAuthorizationRequestRequest
     */
    'usageDetail': string | null;
}

export const SendTransactionAuthorizationRequestRequestUsageEnum = {
    stocking: 'STOCKING',
    gift: 'GIFT',
    businessNecessity: 'BUSINESS_NECESSITY'
} as const;

export type SendTransactionAuthorizationRequestRequestUsageEnum = typeof SendTransactionAuthorizationRequestRequestUsageEnum[keyof typeof SendTransactionAuthorizationRequestRequestUsageEnum];

/**
 * 
 * @export
 * @interface SignUpForSlackRequest
 */
export interface SignUpForSlackRequest {
    /**
     * 
     * @type {string}
     * @memberof SignUpForSlackRequest
     */
    'slackOAuthCode': string;
    /**
     * 
     * @type {string}
     * @memberof SignUpForSlackRequest
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof SignUpForSlackRequest
     */
    'redirectUrl': string;
}
/**
 * 
 * @export
 * @interface SubmitCompletedWorkflowOfDraftPaymentRequests200Response
 */
export interface SubmitCompletedWorkflowOfDraftPaymentRequests200Response {
    /**
     * 
     * @type {string}
     * @memberof SubmitCompletedWorkflowOfDraftPaymentRequests200Response
     */
    'workflowInstanceId': string;
}
/**
 * 
 * @export
 * @interface SubmitCompletedWorkflowOfDraftPaymentRequestsRequest
 */
export interface SubmitCompletedWorkflowOfDraftPaymentRequestsRequest {
    /**
     * 
     * @type {SubmitCompletedWorkflowOfDraftPaymentRequestsRequestSupplier}
     * @memberof SubmitCompletedWorkflowOfDraftPaymentRequestsRequest
     */
    'supplier': SubmitCompletedWorkflowOfDraftPaymentRequestsRequestSupplier;
    /**
     * 
     * @type {string}
     * @memberof SubmitCompletedWorkflowOfDraftPaymentRequestsRequest
     */
    'dueDate': string;
    /**
     * 
     * @type {number}
     * @memberof SubmitCompletedWorkflowOfDraftPaymentRequestsRequest
     */
    'totalAmount': number;
    /**
     * 
     * @type {string}
     * @memberof SubmitCompletedWorkflowOfDraftPaymentRequestsRequest
     */
    'transferFeeResponsibility': SubmitCompletedWorkflowOfDraftPaymentRequestsRequestTransferFeeResponsibilityEnum;
    /**
     * 
     * @type {string}
     * @memberof SubmitCompletedWorkflowOfDraftPaymentRequestsRequest
     */
    'withholdingCalculatingMethod': SubmitCompletedWorkflowOfDraftPaymentRequestsRequestWithholdingCalculatingMethodEnum;
    /**
     * 
     * @type {number}
     * @memberof SubmitCompletedWorkflowOfDraftPaymentRequestsRequest
     */
    'withholdingAmount': number | null;
    /**
     * 
     * @type {string}
     * @memberof SubmitCompletedWorkflowOfDraftPaymentRequestsRequest
     */
    'memo': string | null;
    /**
     * Please set the ID of the evidence from which the payment request. If you are treating the new file as an invoice, be sure to set `evidence`.
     * @type {string}
     * @memberof SubmitCompletedWorkflowOfDraftPaymentRequestsRequest
     */
    'invoiceEvidenceId': string | null;
    /**
     * 
     * @type {SubmitCompletedWorkflowOfDraftPaymentRequestsRequestEvidence}
     * @memberof SubmitCompletedWorkflowOfDraftPaymentRequestsRequest
     */
    'evidence': SubmitCompletedWorkflowOfDraftPaymentRequestsRequestEvidence | null;
}

export const SubmitCompletedWorkflowOfDraftPaymentRequestsRequestTransferFeeResponsibilityEnum = {
    self: 'SELF',
    supplier: 'SUPPLIER'
} as const;

export type SubmitCompletedWorkflowOfDraftPaymentRequestsRequestTransferFeeResponsibilityEnum = typeof SubmitCompletedWorkflowOfDraftPaymentRequestsRequestTransferFeeResponsibilityEnum[keyof typeof SubmitCompletedWorkflowOfDraftPaymentRequestsRequestTransferFeeResponsibilityEnum];
export const SubmitCompletedWorkflowOfDraftPaymentRequestsRequestWithholdingCalculatingMethodEnum = {
    none: 'NONE',
    manuscriptOrLecture: 'MANUSCRIPT_OR_LECTURE',
    lawyerOrCpa: 'LAWYER_OR_CPA',
    judicialScrivener: 'JUDICIAL_SCRIVENER',
    other: 'OTHER'
} as const;

export type SubmitCompletedWorkflowOfDraftPaymentRequestsRequestWithholdingCalculatingMethodEnum = typeof SubmitCompletedWorkflowOfDraftPaymentRequestsRequestWithholdingCalculatingMethodEnum[keyof typeof SubmitCompletedWorkflowOfDraftPaymentRequestsRequestWithholdingCalculatingMethodEnum];

/**
 * Please set only if you want to update the evidence information at the time of draft registration. If you want the uploaded file to be treated as an invoice, be sure to set the `invoiceEvidenceId`.
 * @export
 * @interface SubmitCompletedWorkflowOfDraftPaymentRequestsRequestEvidence
 */
export interface SubmitCompletedWorkflowOfDraftPaymentRequestsRequestEvidence {
    /**
     * 
     * @type {string}
     * @memberof SubmitCompletedWorkflowOfDraftPaymentRequestsRequestEvidence
     */
    'fileId': string;
    /**
     * 
     * @type {string}
     * @memberof SubmitCompletedWorkflowOfDraftPaymentRequestsRequestEvidence
     */
    'electronicMethod'?: SubmitCompletedWorkflowOfDraftPaymentRequestsRequestEvidenceElectronicMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof SubmitCompletedWorkflowOfDraftPaymentRequestsRequestEvidence
     */
    'documentSize'?: SubmitCompletedWorkflowOfDraftPaymentRequestsRequestEvidenceDocumentSizeEnum;
    /**
     * 
     * @type {number}
     * @memberof SubmitCompletedWorkflowOfDraftPaymentRequestsRequestEvidence
     */
    'heightMillis': number | null;
    /**
     * 
     * @type {number}
     * @memberof SubmitCompletedWorkflowOfDraftPaymentRequestsRequestEvidence
     */
    'widthMillis': number | null;
    /**
     * 
     * @type {string}
     * @memberof SubmitCompletedWorkflowOfDraftPaymentRequestsRequestEvidence
     */
    'note'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SubmitCompletedWorkflowOfDraftPaymentRequestsRequestEvidence
     */
    'irrelevantToLedger'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof SubmitCompletedWorkflowOfDraftPaymentRequestsRequestEvidence
     */
    'invoiceIssuerName': string | null;
    /**
     * 
     * @type {string}
     * @memberof SubmitCompletedWorkflowOfDraftPaymentRequestsRequestEvidence
     */
    'invoiceIssuerRegistrationNumber': string | null;
}

export const SubmitCompletedWorkflowOfDraftPaymentRequestsRequestEvidenceElectronicMethodEnum = {
    fullElectronic: 'FULL_ELECTRONIC',
    originallyPaper: 'ORIGINALLY_PAPER',
    unknown: 'UNKNOWN'
} as const;

export type SubmitCompletedWorkflowOfDraftPaymentRequestsRequestEvidenceElectronicMethodEnum = typeof SubmitCompletedWorkflowOfDraftPaymentRequestsRequestEvidenceElectronicMethodEnum[keyof typeof SubmitCompletedWorkflowOfDraftPaymentRequestsRequestEvidenceElectronicMethodEnum];
export const SubmitCompletedWorkflowOfDraftPaymentRequestsRequestEvidenceDocumentSizeEnum = {
    overA4: 'OVER_A4',
    a4OrSmaller: 'A4_OR_SMALLER',
    unknown: 'UNKNOWN'
} as const;

export type SubmitCompletedWorkflowOfDraftPaymentRequestsRequestEvidenceDocumentSizeEnum = typeof SubmitCompletedWorkflowOfDraftPaymentRequestsRequestEvidenceDocumentSizeEnum[keyof typeof SubmitCompletedWorkflowOfDraftPaymentRequestsRequestEvidenceDocumentSizeEnum];

/**
 * 
 * @export
 * @interface SubmitCompletedWorkflowOfDraftPaymentRequestsRequestSupplier
 */
export interface SubmitCompletedWorkflowOfDraftPaymentRequestsRequestSupplier {
    /**
     * 
     * @type {string}
     * @memberof SubmitCompletedWorkflowOfDraftPaymentRequestsRequestSupplier
     */
    'partnerId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SubmitCompletedWorkflowOfDraftPaymentRequestsRequestSupplier
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof SubmitCompletedWorkflowOfDraftPaymentRequestsRequestSupplier
     */
    'bankNumber': string;
    /**
     * 
     * @type {string}
     * @memberof SubmitCompletedWorkflowOfDraftPaymentRequestsRequestSupplier
     */
    'bankName': string;
    /**
     * 
     * @type {string}
     * @memberof SubmitCompletedWorkflowOfDraftPaymentRequestsRequestSupplier
     */
    'branchNumber': string;
    /**
     * 
     * @type {string}
     * @memberof SubmitCompletedWorkflowOfDraftPaymentRequestsRequestSupplier
     */
    'branchName': string;
    /**
     * 
     * @type {string}
     * @memberof SubmitCompletedWorkflowOfDraftPaymentRequestsRequestSupplier
     */
    'accountNumber': string;
    /**
     * 
     * @type {string}
     * @memberof SubmitCompletedWorkflowOfDraftPaymentRequestsRequestSupplier
     */
    'accountType': SubmitCompletedWorkflowOfDraftPaymentRequestsRequestSupplierAccountTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof SubmitCompletedWorkflowOfDraftPaymentRequestsRequestSupplier
     */
    'companyName': string;
}

export const SubmitCompletedWorkflowOfDraftPaymentRequestsRequestSupplierAccountTypeEnum = {
    savingsAccount: 'SAVINGS_ACCOUNT',
    currentAccount: 'CURRENT_ACCOUNT',
    thriftAccount: 'THRIFT_ACCOUNT',
    other: 'OTHER'
} as const;

export type SubmitCompletedWorkflowOfDraftPaymentRequestsRequestSupplierAccountTypeEnum = typeof SubmitCompletedWorkflowOfDraftPaymentRequestsRequestSupplierAccountTypeEnum[keyof typeof SubmitCompletedWorkflowOfDraftPaymentRequestsRequestSupplierAccountTypeEnum];

/**
 * 
 * @export
 * @interface SubmitCompletedWorkflowOfPaymentRequests200Response
 */
export interface SubmitCompletedWorkflowOfPaymentRequests200Response {
    /**
     * 
     * @type {string}
     * @memberof SubmitCompletedWorkflowOfPaymentRequests200Response
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SubmitCompletedWorkflowOfPaymentRequests200Response
     */
    'workflowInstanceId': string;
}
/**
 * 
 * @export
 * @interface SubmitCompletedWorkflowOfPaymentRequestsRequest
 */
export interface SubmitCompletedWorkflowOfPaymentRequestsRequest {
    /**
     * 
     * @type {SubmitCompletedWorkflowOfPaymentRequestsRequestSupplier}
     * @memberof SubmitCompletedWorkflowOfPaymentRequestsRequest
     */
    'supplier': SubmitCompletedWorkflowOfPaymentRequestsRequestSupplier;
    /**
     * 
     * @type {string}
     * @memberof SubmitCompletedWorkflowOfPaymentRequestsRequest
     */
    'dueDate': string;
    /**
     * 
     * @type {number}
     * @memberof SubmitCompletedWorkflowOfPaymentRequestsRequest
     */
    'totalAmount': number;
    /**
     * 
     * @type {string}
     * @memberof SubmitCompletedWorkflowOfPaymentRequestsRequest
     */
    'transferFeeResponsibility': SubmitCompletedWorkflowOfPaymentRequestsRequestTransferFeeResponsibilityEnum;
    /**
     * 
     * @type {string}
     * @memberof SubmitCompletedWorkflowOfPaymentRequestsRequest
     */
    'memo': string | null;
    /**
     * 
     * @type {string}
     * @memberof SubmitCompletedWorkflowOfPaymentRequestsRequest
     */
    'withholdingCalculatingMethod': SubmitCompletedWorkflowOfPaymentRequestsRequestWithholdingCalculatingMethodEnum;
    /**
     * 
     * @type {number}
     * @memberof SubmitCompletedWorkflowOfPaymentRequestsRequest
     */
    'withholdingAmount': number | null;
    /**
     * 
     * @type {SubmitCompletedWorkflowOfPaymentRequestsRequestEvidence}
     * @memberof SubmitCompletedWorkflowOfPaymentRequestsRequest
     */
    'evidence': SubmitCompletedWorkflowOfPaymentRequestsRequestEvidence;
}

export const SubmitCompletedWorkflowOfPaymentRequestsRequestTransferFeeResponsibilityEnum = {
    self: 'SELF',
    supplier: 'SUPPLIER'
} as const;

export type SubmitCompletedWorkflowOfPaymentRequestsRequestTransferFeeResponsibilityEnum = typeof SubmitCompletedWorkflowOfPaymentRequestsRequestTransferFeeResponsibilityEnum[keyof typeof SubmitCompletedWorkflowOfPaymentRequestsRequestTransferFeeResponsibilityEnum];
export const SubmitCompletedWorkflowOfPaymentRequestsRequestWithholdingCalculatingMethodEnum = {
    none: 'NONE',
    manuscriptOrLecture: 'MANUSCRIPT_OR_LECTURE',
    lawyerOrCpa: 'LAWYER_OR_CPA',
    judicialScrivener: 'JUDICIAL_SCRIVENER',
    other: 'OTHER'
} as const;

export type SubmitCompletedWorkflowOfPaymentRequestsRequestWithholdingCalculatingMethodEnum = typeof SubmitCompletedWorkflowOfPaymentRequestsRequestWithholdingCalculatingMethodEnum[keyof typeof SubmitCompletedWorkflowOfPaymentRequestsRequestWithholdingCalculatingMethodEnum];

/**
 * 
 * @export
 * @interface SubmitCompletedWorkflowOfPaymentRequestsRequestEvidence
 */
export interface SubmitCompletedWorkflowOfPaymentRequestsRequestEvidence {
    /**
     * 
     * @type {string}
     * @memberof SubmitCompletedWorkflowOfPaymentRequestsRequestEvidence
     */
    'fileId': string;
    /**
     * 
     * @type {string}
     * @memberof SubmitCompletedWorkflowOfPaymentRequestsRequestEvidence
     */
    'electronicMethod'?: SubmitCompletedWorkflowOfPaymentRequestsRequestEvidenceElectronicMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof SubmitCompletedWorkflowOfPaymentRequestsRequestEvidence
     */
    'documentSize'?: SubmitCompletedWorkflowOfPaymentRequestsRequestEvidenceDocumentSizeEnum;
    /**
     * 
     * @type {number}
     * @memberof SubmitCompletedWorkflowOfPaymentRequestsRequestEvidence
     */
    'heightMillis': number | null;
    /**
     * 
     * @type {number}
     * @memberof SubmitCompletedWorkflowOfPaymentRequestsRequestEvidence
     */
    'widthMillis': number | null;
    /**
     * 
     * @type {string}
     * @memberof SubmitCompletedWorkflowOfPaymentRequestsRequestEvidence
     */
    'note'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SubmitCompletedWorkflowOfPaymentRequestsRequestEvidence
     */
    'irrelevantToLedger'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof SubmitCompletedWorkflowOfPaymentRequestsRequestEvidence
     */
    'invoiceIssuerName': string | null;
    /**
     * 
     * @type {string}
     * @memberof SubmitCompletedWorkflowOfPaymentRequestsRequestEvidence
     */
    'invoiceIssuerRegistrationNumber': string | null;
}

export const SubmitCompletedWorkflowOfPaymentRequestsRequestEvidenceElectronicMethodEnum = {
    fullElectronic: 'FULL_ELECTRONIC',
    originallyPaper: 'ORIGINALLY_PAPER',
    unknown: 'UNKNOWN'
} as const;

export type SubmitCompletedWorkflowOfPaymentRequestsRequestEvidenceElectronicMethodEnum = typeof SubmitCompletedWorkflowOfPaymentRequestsRequestEvidenceElectronicMethodEnum[keyof typeof SubmitCompletedWorkflowOfPaymentRequestsRequestEvidenceElectronicMethodEnum];
export const SubmitCompletedWorkflowOfPaymentRequestsRequestEvidenceDocumentSizeEnum = {
    overA4: 'OVER_A4',
    a4OrSmaller: 'A4_OR_SMALLER',
    unknown: 'UNKNOWN'
} as const;

export type SubmitCompletedWorkflowOfPaymentRequestsRequestEvidenceDocumentSizeEnum = typeof SubmitCompletedWorkflowOfPaymentRequestsRequestEvidenceDocumentSizeEnum[keyof typeof SubmitCompletedWorkflowOfPaymentRequestsRequestEvidenceDocumentSizeEnum];

/**
 * 
 * @export
 * @interface SubmitCompletedWorkflowOfPaymentRequestsRequestSupplier
 */
export interface SubmitCompletedWorkflowOfPaymentRequestsRequestSupplier {
    /**
     * 
     * @type {string}
     * @memberof SubmitCompletedWorkflowOfPaymentRequestsRequestSupplier
     */
    'partnerId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SubmitCompletedWorkflowOfPaymentRequestsRequestSupplier
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof SubmitCompletedWorkflowOfPaymentRequestsRequestSupplier
     */
    'bankNumber': string;
    /**
     * 
     * @type {string}
     * @memberof SubmitCompletedWorkflowOfPaymentRequestsRequestSupplier
     */
    'bankName': string;
    /**
     * 
     * @type {string}
     * @memberof SubmitCompletedWorkflowOfPaymentRequestsRequestSupplier
     */
    'branchNumber': string;
    /**
     * 
     * @type {string}
     * @memberof SubmitCompletedWorkflowOfPaymentRequestsRequestSupplier
     */
    'branchName': string;
    /**
     * 
     * @type {string}
     * @memberof SubmitCompletedWorkflowOfPaymentRequestsRequestSupplier
     */
    'accountNumber': string;
    /**
     * 
     * @type {string}
     * @memberof SubmitCompletedWorkflowOfPaymentRequestsRequestSupplier
     */
    'accountType': SubmitCompletedWorkflowOfPaymentRequestsRequestSupplierAccountTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof SubmitCompletedWorkflowOfPaymentRequestsRequestSupplier
     */
    'companyName': string;
}

export const SubmitCompletedWorkflowOfPaymentRequestsRequestSupplierAccountTypeEnum = {
    savingsAccount: 'SAVINGS_ACCOUNT',
    currentAccount: 'CURRENT_ACCOUNT',
    thriftAccount: 'THRIFT_ACCOUNT',
    other: 'OTHER'
} as const;

export type SubmitCompletedWorkflowOfPaymentRequestsRequestSupplierAccountTypeEnum = typeof SubmitCompletedWorkflowOfPaymentRequestsRequestSupplierAccountTypeEnum[keyof typeof SubmitCompletedWorkflowOfPaymentRequestsRequestSupplierAccountTypeEnum];

/**
 * 
 * @export
 * @interface SuccessCardTransaction
 */
export interface SuccessCardTransaction {
    /**
     * 
     * @type {SuccessCardTransactionCardTransaction}
     * @memberof SuccessCardTransaction
     */
    'cardTransaction': SuccessCardTransactionCardTransaction;
    /**
     * 
     * @type {SuccessCardTransactionCardTransactionEvidenceStatus}
     * @memberof SuccessCardTransaction
     */
    'cardTransactionEvidenceStatus': SuccessCardTransactionCardTransactionEvidenceStatus;
    /**
     * 
     * @type {Array<SuccessCardTransactionEvidenceListInner>}
     * @memberof SuccessCardTransaction
     */
    'evidenceList': Array<SuccessCardTransactionEvidenceListInner>;
    /**
     * 
     * @type {Array<SuccessCardTransactionRequestHistoryInner>}
     * @memberof SuccessCardTransaction
     */
    'requestHistory': Array<SuccessCardTransactionRequestHistoryInner>;
    /**
     * 
     * @type {SuccessCardTransactionComment}
     * @memberof SuccessCardTransaction
     */
    'comment'?: SuccessCardTransactionComment;
    /**
     * 
     * @type {SuccessCardTransactionEvidenceRemindStatus}
     * @memberof SuccessCardTransaction
     */
    'evidenceRemindStatus': SuccessCardTransactionEvidenceRemindStatus;
    /**
     * 
     * @type {SuccessCardTransactionUserAccount}
     * @memberof SuccessCardTransaction
     */
    'userAccount': SuccessCardTransactionUserAccount;
    /**
     * 
     * @type {Array<SuccessCardTransactionPurchaseApplicationsInner>}
     * @memberof SuccessCardTransaction
     */
    'purchaseApplications': Array<SuccessCardTransactionPurchaseApplicationsInner>;
}
/**
 * 
 * @export
 * @interface SuccessCardTransactionCardTransaction
 */
export interface SuccessCardTransactionCardTransaction {
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionCardTransaction
     */
    'visaTransactionReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionCardTransaction
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionCardTransaction
     */
    'merchantName': string;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionCardTransaction
     */
    'merchantNameKana': string;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionCardTransaction
     */
    'merchantNameKanji': string;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionCardTransaction
     */
    'mergedMerchantName': string;
    /**
     * 
     * @type {number}
     * @memberof SuccessCardTransactionCardTransaction
     */
    'amount': number;
    /**
     * 
     * @type {number}
     * @memberof SuccessCardTransactionCardTransaction
     */
    'amountFx': number;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionCardTransaction
     */
    'currencyCode': string;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionCardTransaction
     */
    'processedAt': string;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionCardTransaction
     */
    'transactionType': SuccessCardTransactionCardTransactionTransactionTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionCardTransaction
     */
    'transactionStatus': SuccessCardTransactionCardTransactionTransactionStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof SuccessCardTransactionCardTransaction
     */
    'creditSettlement': number;
    /**
     * 
     * @type {Array<SuccessCardTransactionCardTransactionTransactionRecordListInner>}
     * @memberof SuccessCardTransactionCardTransaction
     */
    'transactionRecordList': Array<SuccessCardTransactionCardTransactionTransactionRecordListInner>;
    /**
     * 
     * @type {boolean}
     * @memberof SuccessCardTransactionCardTransaction
     */
    'isCleared': boolean;
}

export const SuccessCardTransactionCardTransactionTransactionTypeEnum = {
    confirm: 'CONFIRM',
    notConfirm: 'NOT_CONFIRM'
} as const;

export type SuccessCardTransactionCardTransactionTransactionTypeEnum = typeof SuccessCardTransactionCardTransactionTransactionTypeEnum[keyof typeof SuccessCardTransactionCardTransactionTransactionTypeEnum];
export const SuccessCardTransactionCardTransactionTransactionStatusEnum = {
    success: 'SUCCESS'
} as const;

export type SuccessCardTransactionCardTransactionTransactionStatusEnum = typeof SuccessCardTransactionCardTransactionTransactionStatusEnum[keyof typeof SuccessCardTransactionCardTransactionTransactionStatusEnum];

/**
 * 
 * @export
 * @interface SuccessCardTransactionCardTransactionEvidenceStatus
 */
export interface SuccessCardTransactionCardTransactionEvidenceStatus {
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionCardTransactionEvidenceStatus
     */
    'visaTransactionReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionCardTransactionEvidenceStatus
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {boolean}
     * @memberof SuccessCardTransactionCardTransactionEvidenceStatus
     */
    'isRequested': boolean;
    /**
     * 
     * @type {SuccessCardTransactionCardTransactionEvidenceStatusRequestedBy}
     * @memberof SuccessCardTransactionCardTransactionEvidenceStatus
     */
    'requestedBy': SuccessCardTransactionCardTransactionEvidenceStatusRequestedBy | null;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionCardTransactionEvidenceStatus
     */
    'requestedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof SuccessCardTransactionCardTransactionEvidenceStatus
     */
    'isLocked': boolean;
    /**
     * 
     * @type {SuccessCardTransactionCardTransactionEvidenceStatusLockedBy}
     * @memberof SuccessCardTransactionCardTransactionEvidenceStatus
     */
    'lockedBy': SuccessCardTransactionCardTransactionEvidenceStatusLockedBy | null;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionCardTransactionEvidenceStatus
     */
    'lockedAt': string;
}
/**
 * 
 * @export
 * @interface SuccessCardTransactionCardTransactionEvidenceStatusLockedBy
 */
export interface SuccessCardTransactionCardTransactionEvidenceStatusLockedBy {
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionCardTransactionEvidenceStatusLockedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionCardTransactionEvidenceStatusLockedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface SuccessCardTransactionCardTransactionEvidenceStatusRequestedBy
 */
export interface SuccessCardTransactionCardTransactionEvidenceStatusRequestedBy {
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionCardTransactionEvidenceStatusRequestedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionCardTransactionEvidenceStatusRequestedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface SuccessCardTransactionCardTransactionTransactionRecordListInner
 */
export interface SuccessCardTransactionCardTransactionTransactionRecordListInner {
    /**
     * 
     * @type {number}
     * @memberof SuccessCardTransactionCardTransactionTransactionRecordListInner
     */
    'amount': number;
    /**
     * 
     * @type {number}
     * @memberof SuccessCardTransactionCardTransactionTransactionRecordListInner
     */
    'amountFx': number;
    /**
     * 
     * @type {number}
     * @memberof SuccessCardTransactionCardTransactionTransactionRecordListInner
     */
    'totalAmount': number;
    /**
     * 
     * @type {number}
     * @memberof SuccessCardTransactionCardTransactionTransactionRecordListInner
     */
    'totalAmountFx': number;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionCardTransactionTransactionRecordListInner
     */
    'currencyCode': string;
    /**
     * 
     * @type {number}
     * @memberof SuccessCardTransactionCardTransactionTransactionRecordListInner
     */
    'fxRate': number | null;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionCardTransactionTransactionRecordListInner
     */
    'processedAt': string;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionCardTransactionTransactionRecordListInner
     */
    'transactionDetailType': SuccessCardTransactionCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof SuccessCardTransactionCardTransactionTransactionRecordListInner
     */
    'isCleared': boolean;
}

export const SuccessCardTransactionCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum = {
    purchase: 'PURCHASE',
    settlement: 'SETTLEMENT',
    validation: 'VALIDATION',
    refund: 'REFUND',
    cancel: 'CANCEL',
    refundCancel: 'REFUND_CANCEL',
    refundPartialCancel: 'REFUND_PARTIAL_CANCEL'
} as const;

export type SuccessCardTransactionCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum = typeof SuccessCardTransactionCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum[keyof typeof SuccessCardTransactionCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum];

/**
 * 
 * @export
 * @interface SuccessCardTransactionComment
 */
export interface SuccessCardTransactionComment {
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionComment
     */
    'cardTransactionCommentId': string;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionComment
     */
    'visaTransactionReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionComment
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionComment
     */
    'comment': string;
    /**
     * 
     * @type {SuccessCardTransactionCommentCreatedBy}
     * @memberof SuccessCardTransactionComment
     */
    'createdBy': SuccessCardTransactionCommentCreatedBy;
}
/**
 * 
 * @export
 * @interface SuccessCardTransactionCommentCreatedBy
 */
export interface SuccessCardTransactionCommentCreatedBy {
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionCommentCreatedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionCommentCreatedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface SuccessCardTransactionEvidenceListInner
 */
export interface SuccessCardTransactionEvidenceListInner {
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionEvidenceListInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionEvidenceListInner
     * @deprecated
     */
    'cardTransactionEvidenceId': string;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionEvidenceListInner
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionEvidenceListInner
     * @deprecated
     */
    'visaTransactionReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionEvidenceListInner
     */
    'paymentType': SuccessCardTransactionEvidenceListInnerPaymentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionEvidenceListInner
     */
    'fileName': string;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionEvidenceListInner
     */
    'fileExtension': string;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionEvidenceListInner
     */
    'electronicMethod': SuccessCardTransactionEvidenceListInnerElectronicMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionEvidenceListInner
     */
    'documentSize': SuccessCardTransactionEvidenceListInnerDocumentSizeEnum;
    /**
     * 
     * @type {number}
     * @memberof SuccessCardTransactionEvidenceListInner
     * @deprecated
     */
    'dpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof SuccessCardTransactionEvidenceListInner
     */
    'detectedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof SuccessCardTransactionEvidenceListInner
     */
    'calculatedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof SuccessCardTransactionEvidenceListInner
     */
    'colorGradation': number | null;
    /**
     * 
     * @type {number}
     * @memberof SuccessCardTransactionEvidenceListInner
     */
    'verticalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof SuccessCardTransactionEvidenceListInner
     */
    'horizontalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof SuccessCardTransactionEvidenceListInner
     */
    'heightMillis': number | null;
    /**
     * 
     * @type {number}
     * @memberof SuccessCardTransactionEvidenceListInner
     */
    'widthMillis': number | null;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionEvidenceListInner
     */
    'legalValidity': SuccessCardTransactionEvidenceListInnerLegalValidityEnum;
    /**
     * 
     * @type {boolean}
     * @memberof SuccessCardTransactionEvidenceListInner
     */
    'dpiForciblyValid': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SuccessCardTransactionEvidenceListInner
     */
    'colorGradationForciblyValid': boolean;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionEvidenceListInner
     */
    'note': string;
    /**
     * 
     * @type {boolean}
     * @memberof SuccessCardTransactionEvidenceListInner
     */
    'irrelevantToLedger': boolean;
    /**
     * 
     * @type {SuccessCardTransactionEvidenceListInnerInvoiceIssuer}
     * @memberof SuccessCardTransactionEvidenceListInner
     */
    'invoiceIssuer': SuccessCardTransactionEvidenceListInnerInvoiceIssuer | null;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionEvidenceListInner
     * @deprecated
     */
    'dpiError': SuccessCardTransactionEvidenceListInnerDpiErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionEvidenceListInner
     * @deprecated
     */
    'detectedDpiError': SuccessCardTransactionEvidenceListInnerDetectedDpiErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionEvidenceListInner
     * @deprecated
     */
    'calculatedDpiError': SuccessCardTransactionEvidenceListInnerCalculatedDpiErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionEvidenceListInner
     * @deprecated
     */
    'colorGradationError': SuccessCardTransactionEvidenceListInnerColorGradationErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionEvidenceListInner
     * @deprecated
     */
    'heightMillisError': SuccessCardTransactionEvidenceListInnerHeightMillisErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionEvidenceListInner
     * @deprecated
     */
    'widthMillisError': SuccessCardTransactionEvidenceListInnerWidthMillisErrorEnum;
    /**
     * 
     * @type {SuccessCardTransactionEvidenceListInnerErrors}
     * @memberof SuccessCardTransactionEvidenceListInner
     */
    'errors': SuccessCardTransactionEvidenceListInnerErrors;
    /**
     * 
     * @type {SuccessCardTransactionEvidenceListInnerWarnings}
     * @memberof SuccessCardTransactionEvidenceListInner
     */
    'warnings': SuccessCardTransactionEvidenceListInnerWarnings;
    /**
     * 
     * @type {SuccessCardTransactionEvidenceListInnerCreatedBy}
     * @memberof SuccessCardTransactionEvidenceListInner
     */
    'createdBy': SuccessCardTransactionEvidenceListInnerCreatedBy;
    /**
     * 
     * @type {SuccessCardTransactionEvidenceListInnerUpdatedBy}
     * @memberof SuccessCardTransactionEvidenceListInner
     */
    'updatedBy': SuccessCardTransactionEvidenceListInnerUpdatedBy;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionEvidenceListInner
     */
    'updatedAt': string;
    /**
     * 
     * @type {SuccessCardTransactionEvidenceListInnerUploadedBy}
     * @memberof SuccessCardTransactionEvidenceListInner
     */
    'uploadedBy': SuccessCardTransactionEvidenceListInnerUploadedBy;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionEvidenceListInner
     */
    'uploadedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof SuccessCardTransactionEvidenceListInner
     */
    'uploadedByRecipient': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SuccessCardTransactionEvidenceListInner
     */
    'needsMigration': boolean | null;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionEvidenceListInner
     */
    'uploadedFrom': string;
}

export const SuccessCardTransactionEvidenceListInnerPaymentTypeEnum = {
    cardTransaction: 'CARD_TRANSACTION',
    paymentRequest: 'PAYMENT_REQUEST'
} as const;

export type SuccessCardTransactionEvidenceListInnerPaymentTypeEnum = typeof SuccessCardTransactionEvidenceListInnerPaymentTypeEnum[keyof typeof SuccessCardTransactionEvidenceListInnerPaymentTypeEnum];
export const SuccessCardTransactionEvidenceListInnerElectronicMethodEnum = {
    fullElectronic: 'FULL_ELECTRONIC',
    originallyPaper: 'ORIGINALLY_PAPER',
    unknown: 'UNKNOWN'
} as const;

export type SuccessCardTransactionEvidenceListInnerElectronicMethodEnum = typeof SuccessCardTransactionEvidenceListInnerElectronicMethodEnum[keyof typeof SuccessCardTransactionEvidenceListInnerElectronicMethodEnum];
export const SuccessCardTransactionEvidenceListInnerDocumentSizeEnum = {
    overA4: 'OVER_A4',
    a4OrSmaller: 'A4_OR_SMALLER',
    unknown: 'UNKNOWN'
} as const;

export type SuccessCardTransactionEvidenceListInnerDocumentSizeEnum = typeof SuccessCardTransactionEvidenceListInnerDocumentSizeEnum[keyof typeof SuccessCardTransactionEvidenceListInnerDocumentSizeEnum];
export const SuccessCardTransactionEvidenceListInnerLegalValidityEnum = {
    valid: 'VALID',
    invalid: 'INVALID',
    inputRequired: 'INPUT_REQUIRED',
    outOfTarget: 'OUT_OF_TARGET'
} as const;

export type SuccessCardTransactionEvidenceListInnerLegalValidityEnum = typeof SuccessCardTransactionEvidenceListInnerLegalValidityEnum[keyof typeof SuccessCardTransactionEvidenceListInnerLegalValidityEnum];
export const SuccessCardTransactionEvidenceListInnerDpiErrorEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type SuccessCardTransactionEvidenceListInnerDpiErrorEnum = typeof SuccessCardTransactionEvidenceListInnerDpiErrorEnum[keyof typeof SuccessCardTransactionEvidenceListInnerDpiErrorEnum];
export const SuccessCardTransactionEvidenceListInnerDetectedDpiErrorEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type SuccessCardTransactionEvidenceListInnerDetectedDpiErrorEnum = typeof SuccessCardTransactionEvidenceListInnerDetectedDpiErrorEnum[keyof typeof SuccessCardTransactionEvidenceListInnerDetectedDpiErrorEnum];
export const SuccessCardTransactionEvidenceListInnerCalculatedDpiErrorEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type SuccessCardTransactionEvidenceListInnerCalculatedDpiErrorEnum = typeof SuccessCardTransactionEvidenceListInnerCalculatedDpiErrorEnum[keyof typeof SuccessCardTransactionEvidenceListInnerCalculatedDpiErrorEnum];
export const SuccessCardTransactionEvidenceListInnerColorGradationErrorEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type SuccessCardTransactionEvidenceListInnerColorGradationErrorEnum = typeof SuccessCardTransactionEvidenceListInnerColorGradationErrorEnum[keyof typeof SuccessCardTransactionEvidenceListInnerColorGradationErrorEnum];
export const SuccessCardTransactionEvidenceListInnerHeightMillisErrorEnum = {
    required: 'REQUIRED'
} as const;

export type SuccessCardTransactionEvidenceListInnerHeightMillisErrorEnum = typeof SuccessCardTransactionEvidenceListInnerHeightMillisErrorEnum[keyof typeof SuccessCardTransactionEvidenceListInnerHeightMillisErrorEnum];
export const SuccessCardTransactionEvidenceListInnerWidthMillisErrorEnum = {
    required: 'REQUIRED'
} as const;

export type SuccessCardTransactionEvidenceListInnerWidthMillisErrorEnum = typeof SuccessCardTransactionEvidenceListInnerWidthMillisErrorEnum[keyof typeof SuccessCardTransactionEvidenceListInnerWidthMillisErrorEnum];

/**
 * 
 * @export
 * @interface SuccessCardTransactionEvidenceListInnerCreatedBy
 */
export interface SuccessCardTransactionEvidenceListInnerCreatedBy {
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionEvidenceListInnerCreatedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionEvidenceListInnerCreatedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface SuccessCardTransactionEvidenceListInnerErrors
 */
export interface SuccessCardTransactionEvidenceListInnerErrors {
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionEvidenceListInnerErrors
     */
    'detectedDpi'?: SuccessCardTransactionEvidenceListInnerErrorsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionEvidenceListInnerErrors
     */
    'calculatedDpi'?: SuccessCardTransactionEvidenceListInnerErrorsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionEvidenceListInnerErrors
     */
    'colorGradation'?: SuccessCardTransactionEvidenceListInnerErrorsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionEvidenceListInnerErrors
     */
    'heightMillis'?: SuccessCardTransactionEvidenceListInnerErrorsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionEvidenceListInnerErrors
     */
    'widthMillis'?: SuccessCardTransactionEvidenceListInnerErrorsWidthMillisEnum;
}

export const SuccessCardTransactionEvidenceListInnerErrorsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type SuccessCardTransactionEvidenceListInnerErrorsDetectedDpiEnum = typeof SuccessCardTransactionEvidenceListInnerErrorsDetectedDpiEnum[keyof typeof SuccessCardTransactionEvidenceListInnerErrorsDetectedDpiEnum];
export const SuccessCardTransactionEvidenceListInnerErrorsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type SuccessCardTransactionEvidenceListInnerErrorsCalculatedDpiEnum = typeof SuccessCardTransactionEvidenceListInnerErrorsCalculatedDpiEnum[keyof typeof SuccessCardTransactionEvidenceListInnerErrorsCalculatedDpiEnum];
export const SuccessCardTransactionEvidenceListInnerErrorsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type SuccessCardTransactionEvidenceListInnerErrorsColorGradationEnum = typeof SuccessCardTransactionEvidenceListInnerErrorsColorGradationEnum[keyof typeof SuccessCardTransactionEvidenceListInnerErrorsColorGradationEnum];
export const SuccessCardTransactionEvidenceListInnerErrorsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type SuccessCardTransactionEvidenceListInnerErrorsHeightMillisEnum = typeof SuccessCardTransactionEvidenceListInnerErrorsHeightMillisEnum[keyof typeof SuccessCardTransactionEvidenceListInnerErrorsHeightMillisEnum];
export const SuccessCardTransactionEvidenceListInnerErrorsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type SuccessCardTransactionEvidenceListInnerErrorsWidthMillisEnum = typeof SuccessCardTransactionEvidenceListInnerErrorsWidthMillisEnum[keyof typeof SuccessCardTransactionEvidenceListInnerErrorsWidthMillisEnum];

/**
 * Set null if it\'s evidence not analyzed using invoicing-system-compliance feature. Also set null if invoicing-system-compliance feature has been made not available for the organization by the feature-flag.
 * @export
 * @interface SuccessCardTransactionEvidenceListInnerInvoiceIssuer
 */
export interface SuccessCardTransactionEvidenceListInnerInvoiceIssuer {
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionEvidenceListInnerInvoiceIssuer
     */
    'name': string | null;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionEvidenceListInnerInvoiceIssuer
     */
    'registrationNumber': string | null;
    /**
     * isQualified retains the result of querying the 国税庁API to see if registrationNumber is qualified, as is.
     * @type {boolean}
     * @memberof SuccessCardTransactionEvidenceListInnerInvoiceIssuer
     */
    'isQualified': boolean;
    /**
     * AsQualified indicates whether this issuer should be treated as a qualified invoice issuer within the user\'s system, even if the RegistrationNumber is not confirmed as qualified in the National Tax Agency\'s business registration system.
     * @type {boolean}
     * @memberof SuccessCardTransactionEvidenceListInnerInvoiceIssuer
     */
    'asQualified': boolean;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionEvidenceListInnerInvoiceIssuer
     */
    'partnerId': string | null;
}
/**
 * 
 * @export
 * @interface SuccessCardTransactionEvidenceListInnerUpdatedBy
 */
export interface SuccessCardTransactionEvidenceListInnerUpdatedBy {
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionEvidenceListInnerUpdatedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionEvidenceListInnerUpdatedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface SuccessCardTransactionEvidenceListInnerUploadedBy
 */
export interface SuccessCardTransactionEvidenceListInnerUploadedBy {
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionEvidenceListInnerUploadedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionEvidenceListInnerUploadedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface SuccessCardTransactionEvidenceListInnerWarnings
 */
export interface SuccessCardTransactionEvidenceListInnerWarnings {
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionEvidenceListInnerWarnings
     */
    'detectedDpi'?: SuccessCardTransactionEvidenceListInnerWarningsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionEvidenceListInnerWarnings
     */
    'calculatedDpi'?: SuccessCardTransactionEvidenceListInnerWarningsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionEvidenceListInnerWarnings
     */
    'colorGradation'?: SuccessCardTransactionEvidenceListInnerWarningsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionEvidenceListInnerWarnings
     */
    'heightMillis'?: SuccessCardTransactionEvidenceListInnerWarningsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionEvidenceListInnerWarnings
     */
    'widthMillis'?: SuccessCardTransactionEvidenceListInnerWarningsWidthMillisEnum;
}

export const SuccessCardTransactionEvidenceListInnerWarningsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type SuccessCardTransactionEvidenceListInnerWarningsDetectedDpiEnum = typeof SuccessCardTransactionEvidenceListInnerWarningsDetectedDpiEnum[keyof typeof SuccessCardTransactionEvidenceListInnerWarningsDetectedDpiEnum];
export const SuccessCardTransactionEvidenceListInnerWarningsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type SuccessCardTransactionEvidenceListInnerWarningsCalculatedDpiEnum = typeof SuccessCardTransactionEvidenceListInnerWarningsCalculatedDpiEnum[keyof typeof SuccessCardTransactionEvidenceListInnerWarningsCalculatedDpiEnum];
export const SuccessCardTransactionEvidenceListInnerWarningsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type SuccessCardTransactionEvidenceListInnerWarningsColorGradationEnum = typeof SuccessCardTransactionEvidenceListInnerWarningsColorGradationEnum[keyof typeof SuccessCardTransactionEvidenceListInnerWarningsColorGradationEnum];
export const SuccessCardTransactionEvidenceListInnerWarningsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type SuccessCardTransactionEvidenceListInnerWarningsHeightMillisEnum = typeof SuccessCardTransactionEvidenceListInnerWarningsHeightMillisEnum[keyof typeof SuccessCardTransactionEvidenceListInnerWarningsHeightMillisEnum];
export const SuccessCardTransactionEvidenceListInnerWarningsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type SuccessCardTransactionEvidenceListInnerWarningsWidthMillisEnum = typeof SuccessCardTransactionEvidenceListInnerWarningsWidthMillisEnum[keyof typeof SuccessCardTransactionEvidenceListInnerWarningsWidthMillisEnum];

/**
 * 
 * @export
 * @interface SuccessCardTransactionEvidenceRemindStatus
 */
export interface SuccessCardTransactionEvidenceRemindStatus {
    /**
     * 
     * @type {boolean}
     * @memberof SuccessCardTransactionEvidenceRemindStatus
     */
    'isAutoRemind': boolean;
}
/**
 * 
 * @export
 * @interface SuccessCardTransactionPurchaseApplicationsInner
 */
export interface SuccessCardTransactionPurchaseApplicationsInner {
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionPurchaseApplicationsInner
     */
    'applicationId': string;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionPurchaseApplicationsInner
     */
    'applicationNumber': string;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionPurchaseApplicationsInner
     */
    'paymentDate': string;
    /**
     * 
     * @type {SuccessCardTransactionPurchaseApplicationsInnerSubmittedBy}
     * @memberof SuccessCardTransactionPurchaseApplicationsInner
     */
    'submittedBy': SuccessCardTransactionPurchaseApplicationsInnerSubmittedBy;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionPurchaseApplicationsInner
     */
    'submittedAt': string;
    /**
     * 
     * @type {Array<SuccessCardTransactionPurchaseApplicationsInnerApproversInner>}
     * @memberof SuccessCardTransactionPurchaseApplicationsInner
     */
    'approvers': Array<SuccessCardTransactionPurchaseApplicationsInnerApproversInner>;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionPurchaseApplicationsInner
     */
    'department': string;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionPurchaseApplicationsInner
     */
    'purchaseReason': string;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionPurchaseApplicationsInner
     */
    'purchaseDetails': string;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionPurchaseApplicationsInner
     */
    'placeOfUse': string;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionPurchaseApplicationsInner
     */
    'purposeOfUse': string;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionPurchaseApplicationsInner
     */
    'url': string;
    /**
     * 
     * @type {number}
     * @memberof SuccessCardTransactionPurchaseApplicationsInner
     */
    'amount': number;
    /**
     * 
     * @type {SuccessCardTransactionPurchaseApplicationsInnerUserAccount}
     * @memberof SuccessCardTransactionPurchaseApplicationsInner
     */
    'userAccount': SuccessCardTransactionPurchaseApplicationsInnerUserAccount | null;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionPurchaseApplicationsInner
     */
    'remarks': string;
    /**
     * 
     * @type {SuccessCardTransactionPurchaseApplicationsInnerWorkRequestedBy}
     * @memberof SuccessCardTransactionPurchaseApplicationsInner
     */
    'workRequestedBy': SuccessCardTransactionPurchaseApplicationsInnerWorkRequestedBy;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionPurchaseApplicationsInner
     */
    'workRequestApprovers': string;
    /**
     * 
     * @type {SuccessCardTransactionPurchaseApplicationsInnerStatus}
     * @memberof SuccessCardTransactionPurchaseApplicationsInner
     */
    'status': SuccessCardTransactionPurchaseApplicationsInnerStatus;
    /**
     * 
     * @type {SuccessCardTransactionPurchaseApplicationsInnerCreatedBy}
     * @memberof SuccessCardTransactionPurchaseApplicationsInner
     */
    'createdBy': SuccessCardTransactionPurchaseApplicationsInnerCreatedBy;
}
/**
 * 
 * @export
 * @interface SuccessCardTransactionPurchaseApplicationsInnerApproversInner
 */
export interface SuccessCardTransactionPurchaseApplicationsInnerApproversInner {
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionPurchaseApplicationsInnerApproversInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionPurchaseApplicationsInnerApproversInner
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface SuccessCardTransactionPurchaseApplicationsInnerCreatedBy
 */
export interface SuccessCardTransactionPurchaseApplicationsInnerCreatedBy {
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionPurchaseApplicationsInnerCreatedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionPurchaseApplicationsInnerCreatedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface SuccessCardTransactionPurchaseApplicationsInnerStatus
 */
export interface SuccessCardTransactionPurchaseApplicationsInnerStatus {
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionPurchaseApplicationsInnerStatus
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionPurchaseApplicationsInnerStatus
     */
    'comment': string;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionPurchaseApplicationsInnerStatus
     */
    'statusChangedAt': string;
    /**
     * 
     * @type {SuccessCardTransactionPurchaseApplicationsInnerStatusCreatedBy}
     * @memberof SuccessCardTransactionPurchaseApplicationsInnerStatus
     */
    'createdBy': SuccessCardTransactionPurchaseApplicationsInnerStatusCreatedBy;
}
/**
 * 
 * @export
 * @interface SuccessCardTransactionPurchaseApplicationsInnerStatusCreatedBy
 */
export interface SuccessCardTransactionPurchaseApplicationsInnerStatusCreatedBy {
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionPurchaseApplicationsInnerStatusCreatedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionPurchaseApplicationsInnerStatusCreatedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface SuccessCardTransactionPurchaseApplicationsInnerSubmittedBy
 */
export interface SuccessCardTransactionPurchaseApplicationsInnerSubmittedBy {
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionPurchaseApplicationsInnerSubmittedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionPurchaseApplicationsInnerSubmittedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface SuccessCardTransactionPurchaseApplicationsInnerUserAccount
 */
export interface SuccessCardTransactionPurchaseApplicationsInnerUserAccount {
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionPurchaseApplicationsInnerUserAccount
     */
    'userAccountId': string;
    /**
     * 
     * @type {SuccessCardTransactionPurchaseApplicationsInnerUserAccountUser}
     * @memberof SuccessCardTransactionPurchaseApplicationsInnerUserAccount
     */
    'user': SuccessCardTransactionPurchaseApplicationsInnerUserAccountUser;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionPurchaseApplicationsInnerUserAccount
     */
    'cardLabel': string;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionPurchaseApplicationsInnerUserAccount
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionPurchaseApplicationsInnerUserAccount
     */
    'organizationName': string;
    /**
     * 
     * @type {SuccessCardTransactionPurchaseApplicationsInnerUserAccountUserAccountGroup}
     * @memberof SuccessCardTransactionPurchaseApplicationsInnerUserAccount
     */
    'userAccountGroup': SuccessCardTransactionPurchaseApplicationsInnerUserAccountUserAccountGroup | null;
    /**
     * 
     * @type {boolean}
     * @memberof SuccessCardTransactionPurchaseApplicationsInnerUserAccount
     */
    'isOnDemand': boolean;
}
/**
 * 
 * @export
 * @interface SuccessCardTransactionPurchaseApplicationsInnerUserAccountUser
 */
export interface SuccessCardTransactionPurchaseApplicationsInnerUserAccountUser {
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionPurchaseApplicationsInnerUserAccountUser
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionPurchaseApplicationsInnerUserAccountUser
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionPurchaseApplicationsInnerUserAccountUser
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionPurchaseApplicationsInnerUserAccountUser
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionPurchaseApplicationsInnerUserAccountUser
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SuccessCardTransactionPurchaseApplicationsInnerUserAccountUser
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SuccessCardTransactionPurchaseApplicationsInnerUserAccountUser
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SuccessCardTransactionPurchaseApplicationsInnerUserAccountUser
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SuccessCardTransactionPurchaseApplicationsInnerUserAccountUser
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SuccessCardTransactionPurchaseApplicationsInnerUserAccountUser
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionPurchaseApplicationsInnerUserAccountUser
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface SuccessCardTransactionPurchaseApplicationsInnerUserAccountUserAccountGroup
 */
export interface SuccessCardTransactionPurchaseApplicationsInnerUserAccountUserAccountGroup {
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionPurchaseApplicationsInnerUserAccountUserAccountGroup
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionPurchaseApplicationsInnerUserAccountUserAccountGroup
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof SuccessCardTransactionPurchaseApplicationsInnerUserAccountUserAccountGroup
     */
    'sortNum': number;
}
/**
 * 
 * @export
 * @interface SuccessCardTransactionPurchaseApplicationsInnerWorkRequestedBy
 */
export interface SuccessCardTransactionPurchaseApplicationsInnerWorkRequestedBy {
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionPurchaseApplicationsInnerWorkRequestedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionPurchaseApplicationsInnerWorkRequestedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface SuccessCardTransactionRequestHistoryInner
 */
export interface SuccessCardTransactionRequestHistoryInner {
    /**
     * 
     * @type {number}
     * @memberof SuccessCardTransactionRequestHistoryInner
     */
    'requestId': number;
    /**
     * 
     * @type {SuccessCardTransactionRequestHistoryInnerRequestedBy}
     * @memberof SuccessCardTransactionRequestHistoryInner
     */
    'requestedBy': SuccessCardTransactionRequestHistoryInnerRequestedBy;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionRequestHistoryInner
     */
    'requestedAt': string;
}
/**
 * 
 * @export
 * @interface SuccessCardTransactionRequestHistoryInnerRequestedBy
 */
export interface SuccessCardTransactionRequestHistoryInnerRequestedBy {
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionRequestHistoryInnerRequestedBy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionRequestHistoryInnerRequestedBy
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface SuccessCardTransactionUserAccount
 */
export interface SuccessCardTransactionUserAccount {
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionUserAccount
     */
    'userAccountId': string;
    /**
     * 
     * @type {SuccessCardTransactionUserAccountUser}
     * @memberof SuccessCardTransactionUserAccount
     */
    'user': SuccessCardTransactionUserAccountUser;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionUserAccount
     */
    'cardLabel': string;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionUserAccount
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionUserAccount
     */
    'organizationName': string;
    /**
     * 
     * @type {SuccessCardTransactionUserAccountUserAccountGroup}
     * @memberof SuccessCardTransactionUserAccount
     */
    'userAccountGroup': SuccessCardTransactionUserAccountUserAccountGroup | null;
    /**
     * 
     * @type {boolean}
     * @memberof SuccessCardTransactionUserAccount
     */
    'isOnDemand': boolean;
}
/**
 * 
 * @export
 * @interface SuccessCardTransactionUserAccountUser
 */
export interface SuccessCardTransactionUserAccountUser {
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionUserAccountUser
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionUserAccountUser
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionUserAccountUser
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionUserAccountUser
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionUserAccountUser
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SuccessCardTransactionUserAccountUser
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SuccessCardTransactionUserAccountUser
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SuccessCardTransactionUserAccountUser
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SuccessCardTransactionUserAccountUser
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SuccessCardTransactionUserAccountUser
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionUserAccountUser
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface SuccessCardTransactionUserAccountUserAccountGroup
 */
export interface SuccessCardTransactionUserAccountUserAccountGroup {
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionUserAccountUserAccountGroup
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionUserAccountUserAccountGroup
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof SuccessCardTransactionUserAccountUserAccountGroup
     */
    'sortNum': number;
}
/**
 * 
 * @export
 * @interface SuspendCard200Response
 */
export interface SuspendCard200Response {
    /**
     * 
     * @type {string}
     * @memberof SuspendCard200Response
     */
    'cardId': string;
    /**
     * 
     * @type {boolean}
     * @memberof SuspendCard200Response
     */
    'isActivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SuspendCard200Response
     */
    'isDeactivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SuspendCard200Response
     */
    'isLocked': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SuspendCard200Response
     */
    'isSuspended': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SuspendCard200Response
     */
    'isFrozen': boolean;
    /**
     * 
     * @type {string}
     * @memberof SuspendCard200Response
     */
    'panLastFourDigits': string;
    /**
     * 
     * @type {string}
     * @memberof SuspendCard200Response
     */
    'linkedUserAccountId': string;
    /**
     * 
     * @type {string}
     * @memberof SuspendCard200Response
     */
    'createdAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof SuspendCard200Response
     */
    'isActive': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SuspendCard200Response
     */
    'isVirtualCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SuspendCard200Response
     */
    'isCreditCard': boolean;
}
/**
 * 
 * @export
 * @interface SyncMoneytreeAccessToken200Response
 */
export interface SyncMoneytreeAccessToken200Response {
    /**
     * 
     * @type {string}
     * @memberof SyncMoneytreeAccessToken200Response
     */
    'status': string;
}
/**
 * 
 * @export
 * @interface SyncRequestForFreeeDealsRequest
 */
export interface SyncRequestForFreeeDealsRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof SyncRequestForFreeeDealsRequest
     */
    'dealIds': Array<string>;
}
/**
 * 
 * @export
 * @interface TransactionEvidenceEmail
 */
export interface TransactionEvidenceEmail {
    /**
     * 
     * @type {string}
     * @memberof TransactionEvidenceEmail
     */
    'transactionEvidenceEmailId': string;
    /**
     * 
     * @type {string}
     * @memberof TransactionEvidenceEmail
     */
    'userAccountId': string;
    /**
     * 
     * @type {string}
     * @memberof TransactionEvidenceEmail
     */
    'senderName': string;
    /**
     * 
     * @type {string}
     * @memberof TransactionEvidenceEmail
     */
    'emailTo': string;
    /**
     * 
     * @type {string}
     * @memberof TransactionEvidenceEmail
     */
    'emailFrom': string;
    /**
     * 
     * @type {string}
     * @memberof TransactionEvidenceEmail
     */
    'emailSubject': string;
    /**
     * 
     * @type {Array<TransactionEvidenceEmailAttachmentListInner>}
     * @memberof TransactionEvidenceEmail
     */
    'attachmentList': Array<TransactionEvidenceEmailAttachmentListInner>;
    /**
     * 
     * @type {string}
     * @memberof TransactionEvidenceEmail
     */
    'createdDate': string;
}
/**
 * 
 * @export
 * @interface TransactionEvidenceEmailAttachment
 */
export interface TransactionEvidenceEmailAttachment {
    /**
     * 
     * @type {string}
     * @memberof TransactionEvidenceEmailAttachment
     */
    'attachmentId': string;
    /**
     * 
     * @type {string}
     * @memberof TransactionEvidenceEmailAttachment
     */
    'name': string;
    /**
     * 
     * @type {boolean}
     * @memberof TransactionEvidenceEmailAttachment
     */
    'isUploaded': boolean;
}
/**
 * 
 * @export
 * @interface TransactionEvidenceEmailAttachmentListInner
 */
export interface TransactionEvidenceEmailAttachmentListInner {
    /**
     * 
     * @type {string}
     * @memberof TransactionEvidenceEmailAttachmentListInner
     */
    'attachmentId': string;
    /**
     * 
     * @type {string}
     * @memberof TransactionEvidenceEmailAttachmentListInner
     */
    'name': string;
    /**
     * 
     * @type {boolean}
     * @memberof TransactionEvidenceEmailAttachmentListInner
     */
    'isUploaded': boolean;
}
/**
 * 
 * @export
 * @interface TwoFactorAuthResetAsTokenRequest
 */
export interface TwoFactorAuthResetAsTokenRequest {
    /**
     * 
     * @type {string}
     * @memberof TwoFactorAuthResetAsTokenRequest
     */
    'token': string;
}
/**
 * 
 * @export
 * @interface UnlockCardForNotPotentialFraud200Response
 */
export interface UnlockCardForNotPotentialFraud200Response {
    /**
     * 
     * @type {string}
     * @memberof UnlockCardForNotPotentialFraud200Response
     */
    'cardId': string;
    /**
     * 
     * @type {boolean}
     * @memberof UnlockCardForNotPotentialFraud200Response
     */
    'isActivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UnlockCardForNotPotentialFraud200Response
     */
    'isDeactivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UnlockCardForNotPotentialFraud200Response
     */
    'isLocked': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UnlockCardForNotPotentialFraud200Response
     */
    'isSuspended': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UnlockCardForNotPotentialFraud200Response
     */
    'isFrozen': boolean;
    /**
     * 
     * @type {string}
     * @memberof UnlockCardForNotPotentialFraud200Response
     */
    'panLastFourDigits': string;
    /**
     * 
     * @type {string}
     * @memberof UnlockCardForNotPotentialFraud200Response
     */
    'linkedUserAccountId': string;
    /**
     * 
     * @type {string}
     * @memberof UnlockCardForNotPotentialFraud200Response
     */
    'createdAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof UnlockCardForNotPotentialFraud200Response
     */
    'isActive': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UnlockCardForNotPotentialFraud200Response
     */
    'isVirtualCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UnlockCardForNotPotentialFraud200Response
     */
    'isCreditCard': boolean;
}
/**
 * 
 * @export
 * @interface UnlockCardOnFraudCleared200Response
 */
export interface UnlockCardOnFraudCleared200Response {
    /**
     * 
     * @type {string}
     * @memberof UnlockCardOnFraudCleared200Response
     */
    'cardId': string;
    /**
     * 
     * @type {boolean}
     * @memberof UnlockCardOnFraudCleared200Response
     */
    'isActivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UnlockCardOnFraudCleared200Response
     */
    'isDeactivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UnlockCardOnFraudCleared200Response
     */
    'isLocked': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UnlockCardOnFraudCleared200Response
     */
    'isSuspended': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UnlockCardOnFraudCleared200Response
     */
    'isFrozen': boolean;
    /**
     * 
     * @type {string}
     * @memberof UnlockCardOnFraudCleared200Response
     */
    'panLastFourDigits': string;
    /**
     * 
     * @type {string}
     * @memberof UnlockCardOnFraudCleared200Response
     */
    'linkedUserAccountId': string;
    /**
     * 
     * @type {string}
     * @memberof UnlockCardOnFraudCleared200Response
     */
    'createdAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof UnlockCardOnFraudCleared200Response
     */
    'isActive': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UnlockCardOnFraudCleared200Response
     */
    'isVirtualCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UnlockCardOnFraudCleared200Response
     */
    'isCreditCard': boolean;
}
/**
 * 
 * @export
 * @interface UpdateAvailableCurrencies200Response
 */
export interface UpdateAvailableCurrencies200Response {
    /**
     * 
     * @type {string}
     * @memberof UpdateAvailableCurrencies200Response
     */
    'cardId': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAvailableCurrencies200Response
     */
    'cardLabel': string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateAvailableCurrencies200Response
     */
    'isActivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateAvailableCurrencies200Response
     */
    'isDeactivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateAvailableCurrencies200Response
     */
    'isLocked': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateAvailableCurrencies200Response
     */
    'isSuspended': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateAvailableCurrencies200Response
     */
    'isFrozen': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateAvailableCurrencies200Response
     */
    'isVirtualCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateAvailableCurrencies200Response
     */
    'isCreditCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateAvailableCurrencies200Response
     */
    'isOnDemand': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateAvailableCurrencies200Response
     */
    'isMetalCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateAvailableCurrencies200Response
     */
    'isPhysicalStorePaymentDisabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateAvailableCurrencies200Response
     */
    'panLastFourDigits': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAvailableCurrencies200Response
     */
    'userAccountId': string;
    /**
     * 
     * @type {number}
     * @memberof UpdateAvailableCurrencies200Response
     */
    'transactionUpperLimit': number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateAvailableCurrencies200Response
     */
    'availableCurrencies': Array<UpdateAvailableCurrencies200ResponseAvailableCurrenciesEnum>;
    /**
     * 
     * @type {Array<UpdateAvailableCurrencies200ResponseAvailableMerchantCategoriesInner>}
     * @memberof UpdateAvailableCurrencies200Response
     */
    'availableMerchantCategories': Array<UpdateAvailableCurrencies200ResponseAvailableMerchantCategoriesInner> | null;
    /**
     * 
     * @type {UpdateAvailableCurrencies200ResponseUser}
     * @memberof UpdateAvailableCurrencies200Response
     */
    'user': UpdateAvailableCurrencies200ResponseUser;
    /**
     * 
     * @type {UpdateAvailableCurrencies200ResponseUserAccountGroup}
     * @memberof UpdateAvailableCurrencies200Response
     */
    'userAccountGroup'?: UpdateAvailableCurrencies200ResponseUserAccountGroup | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateAvailableCurrencies200Response
     */
    'monthlyTotalUsage': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateAvailableCurrencies200Response
     */
    'monthlyUsageLimit': number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateAvailableCurrencies200Response
     */
    'dailyTotalUsage': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateAvailableCurrencies200Response
     */
    'dailyUsageLimit': number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateAvailableCurrencies200Response
     */
    'totalUsageAmount': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateAvailableCurrencies200Response
     */
    'totalUsageAmountLimit': number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateAvailableCurrencies200Response
     */
    'expiredDate': string | null;
}

export const UpdateAvailableCurrencies200ResponseAvailableCurrenciesEnum = {
    jpy: 'JPY',
    usd: 'USD',
    gbp: 'GBP',
    eur: 'EUR',
    sgd: 'SGD',
    aud: 'AUD',
    cny: 'CNY',
    hkd: 'HKD',
    idr: 'IDR',
    krw: 'KRW',
    nzd: 'NZD',
    php: 'PHP',
    rub: 'RUB',
    vnd: 'VND',
    inr: 'INR',
    thb: 'THB',
    lak: 'LAK',
    myr: 'MYR',
    twd: 'TWD',
    chf: 'CHF',
    cad: 'CAD',
    mxn: 'MXN',
    nok: 'NOK',
    huf: 'HUF',
    hrk: 'HRK',
    czk: 'CZK',
    dkk: 'DKK',
    isk: 'ISK',
    mdl: 'MDL',
    sek: 'SEK',
    mkd: 'MKD',
    rsd: 'RSD',
    ron: 'RON',
    bgn: 'BGN',
    bam: 'BAM',
    pln: 'PLN',
    mad: 'MAD',
    zar: 'ZAR',
    rwf: 'RWF',
    kes: 'KES',
    ngn: 'NGN',
    aed: 'AED',
    sar: 'SAR',
    egp: 'EGP',
    qar: 'QAR',
    omr: 'OMR',
    ils: 'ILS',
    try: 'TRY',
    kzt: 'KZT',
    cop: 'COP',
    gtq: 'GTQ'
} as const;

export type UpdateAvailableCurrencies200ResponseAvailableCurrenciesEnum = typeof UpdateAvailableCurrencies200ResponseAvailableCurrenciesEnum[keyof typeof UpdateAvailableCurrencies200ResponseAvailableCurrenciesEnum];

/**
 * 
 * @export
 * @interface UpdateAvailableCurrencies200ResponseAvailableMerchantCategoriesInner
 */
export interface UpdateAvailableCurrencies200ResponseAvailableMerchantCategoriesInner {
    /**
     * 
     * @type {string}
     * @memberof UpdateAvailableCurrencies200ResponseAvailableMerchantCategoriesInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAvailableCurrencies200ResponseAvailableMerchantCategoriesInner
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAvailableCurrencies200ResponseAvailableMerchantCategoriesInner
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAvailableCurrencies200ResponseAvailableMerchantCategoriesInner
     */
    'logoUrl': string;
}
/**
 * 
 * @export
 * @interface UpdateAvailableCurrencies200ResponseUser
 */
export interface UpdateAvailableCurrencies200ResponseUser {
    /**
     * 
     * @type {string}
     * @memberof UpdateAvailableCurrencies200ResponseUser
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAvailableCurrencies200ResponseUser
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAvailableCurrencies200ResponseUser
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAvailableCurrencies200ResponseUser
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAvailableCurrencies200ResponseUser
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateAvailableCurrencies200ResponseUser
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateAvailableCurrencies200ResponseUser
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateAvailableCurrencies200ResponseUser
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateAvailableCurrencies200ResponseUser
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateAvailableCurrencies200ResponseUser
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateAvailableCurrencies200ResponseUser
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface UpdateAvailableCurrencies200ResponseUserAccountGroup
 */
export interface UpdateAvailableCurrencies200ResponseUserAccountGroup {
    /**
     * 
     * @type {string}
     * @memberof UpdateAvailableCurrencies200ResponseUserAccountGroup
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAvailableCurrencies200ResponseUserAccountGroup
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof UpdateAvailableCurrencies200ResponseUserAccountGroup
     */
    'sortNum': number;
}
/**
 * 
 * @export
 * @interface UpdateAvailableCurrenciesRequest
 */
export interface UpdateAvailableCurrenciesRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateAvailableCurrenciesRequest
     */
    'newAvailableCurrencies': Array<UpdateAvailableCurrenciesRequestNewAvailableCurrenciesEnum>;
}

export const UpdateAvailableCurrenciesRequestNewAvailableCurrenciesEnum = {
    jpy: 'JPY',
    usd: 'USD',
    gbp: 'GBP',
    eur: 'EUR',
    sgd: 'SGD',
    aud: 'AUD',
    cny: 'CNY',
    hkd: 'HKD',
    idr: 'IDR',
    krw: 'KRW',
    nzd: 'NZD',
    php: 'PHP',
    rub: 'RUB',
    vnd: 'VND',
    inr: 'INR',
    thb: 'THB',
    lak: 'LAK',
    myr: 'MYR',
    twd: 'TWD',
    chf: 'CHF',
    cad: 'CAD',
    mxn: 'MXN',
    nok: 'NOK',
    huf: 'HUF',
    hrk: 'HRK',
    czk: 'CZK',
    dkk: 'DKK',
    isk: 'ISK',
    mdl: 'MDL',
    sek: 'SEK',
    mkd: 'MKD',
    rsd: 'RSD',
    ron: 'RON',
    bgn: 'BGN',
    bam: 'BAM',
    pln: 'PLN',
    mad: 'MAD',
    zar: 'ZAR',
    rwf: 'RWF',
    kes: 'KES',
    ngn: 'NGN',
    aed: 'AED',
    sar: 'SAR',
    egp: 'EGP',
    qar: 'QAR',
    omr: 'OMR',
    ils: 'ILS',
    try: 'TRY',
    kzt: 'KZT',
    cop: 'COP',
    gtq: 'GTQ'
} as const;

export type UpdateAvailableCurrenciesRequestNewAvailableCurrenciesEnum = typeof UpdateAvailableCurrenciesRequestNewAvailableCurrenciesEnum[keyof typeof UpdateAvailableCurrenciesRequestNewAvailableCurrenciesEnum];

/**
 * 
 * @export
 * @interface UpdateAvailableMerchantCategories200Response
 */
export interface UpdateAvailableMerchantCategories200Response {
    /**
     * 
     * @type {string}
     * @memberof UpdateAvailableMerchantCategories200Response
     */
    'cardId': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAvailableMerchantCategories200Response
     */
    'cardLabel': string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateAvailableMerchantCategories200Response
     */
    'isActivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateAvailableMerchantCategories200Response
     */
    'isDeactivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateAvailableMerchantCategories200Response
     */
    'isLocked': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateAvailableMerchantCategories200Response
     */
    'isSuspended': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateAvailableMerchantCategories200Response
     */
    'isFrozen': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateAvailableMerchantCategories200Response
     */
    'isVirtualCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateAvailableMerchantCategories200Response
     */
    'isCreditCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateAvailableMerchantCategories200Response
     */
    'isOnDemand': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateAvailableMerchantCategories200Response
     */
    'isMetalCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateAvailableMerchantCategories200Response
     */
    'isPhysicalStorePaymentDisabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateAvailableMerchantCategories200Response
     */
    'panLastFourDigits': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAvailableMerchantCategories200Response
     */
    'userAccountId': string;
    /**
     * 
     * @type {number}
     * @memberof UpdateAvailableMerchantCategories200Response
     */
    'transactionUpperLimit': number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateAvailableMerchantCategories200Response
     */
    'availableCurrencies': Array<UpdateAvailableMerchantCategories200ResponseAvailableCurrenciesEnum>;
    /**
     * 
     * @type {Array<UpdateAvailableMerchantCategories200ResponseAvailableMerchantCategoriesInner>}
     * @memberof UpdateAvailableMerchantCategories200Response
     */
    'availableMerchantCategories': Array<UpdateAvailableMerchantCategories200ResponseAvailableMerchantCategoriesInner> | null;
    /**
     * 
     * @type {UpdateAvailableMerchantCategories200ResponseUser}
     * @memberof UpdateAvailableMerchantCategories200Response
     */
    'user': UpdateAvailableMerchantCategories200ResponseUser;
    /**
     * 
     * @type {UpdateAvailableMerchantCategories200ResponseUserAccountGroup}
     * @memberof UpdateAvailableMerchantCategories200Response
     */
    'userAccountGroup'?: UpdateAvailableMerchantCategories200ResponseUserAccountGroup | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateAvailableMerchantCategories200Response
     */
    'monthlyTotalUsage': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateAvailableMerchantCategories200Response
     */
    'monthlyUsageLimit': number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateAvailableMerchantCategories200Response
     */
    'dailyTotalUsage': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateAvailableMerchantCategories200Response
     */
    'dailyUsageLimit': number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateAvailableMerchantCategories200Response
     */
    'totalUsageAmount': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateAvailableMerchantCategories200Response
     */
    'totalUsageAmountLimit': number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateAvailableMerchantCategories200Response
     */
    'expiredDate': string | null;
}

export const UpdateAvailableMerchantCategories200ResponseAvailableCurrenciesEnum = {
    jpy: 'JPY',
    usd: 'USD',
    gbp: 'GBP',
    eur: 'EUR',
    sgd: 'SGD',
    aud: 'AUD',
    cny: 'CNY',
    hkd: 'HKD',
    idr: 'IDR',
    krw: 'KRW',
    nzd: 'NZD',
    php: 'PHP',
    rub: 'RUB',
    vnd: 'VND',
    inr: 'INR',
    thb: 'THB',
    lak: 'LAK',
    myr: 'MYR',
    twd: 'TWD',
    chf: 'CHF',
    cad: 'CAD',
    mxn: 'MXN',
    nok: 'NOK',
    huf: 'HUF',
    hrk: 'HRK',
    czk: 'CZK',
    dkk: 'DKK',
    isk: 'ISK',
    mdl: 'MDL',
    sek: 'SEK',
    mkd: 'MKD',
    rsd: 'RSD',
    ron: 'RON',
    bgn: 'BGN',
    bam: 'BAM',
    pln: 'PLN',
    mad: 'MAD',
    zar: 'ZAR',
    rwf: 'RWF',
    kes: 'KES',
    ngn: 'NGN',
    aed: 'AED',
    sar: 'SAR',
    egp: 'EGP',
    qar: 'QAR',
    omr: 'OMR',
    ils: 'ILS',
    try: 'TRY',
    kzt: 'KZT',
    cop: 'COP',
    gtq: 'GTQ'
} as const;

export type UpdateAvailableMerchantCategories200ResponseAvailableCurrenciesEnum = typeof UpdateAvailableMerchantCategories200ResponseAvailableCurrenciesEnum[keyof typeof UpdateAvailableMerchantCategories200ResponseAvailableCurrenciesEnum];

/**
 * 
 * @export
 * @interface UpdateAvailableMerchantCategories200ResponseAvailableMerchantCategoriesInner
 */
export interface UpdateAvailableMerchantCategories200ResponseAvailableMerchantCategoriesInner {
    /**
     * 
     * @type {string}
     * @memberof UpdateAvailableMerchantCategories200ResponseAvailableMerchantCategoriesInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAvailableMerchantCategories200ResponseAvailableMerchantCategoriesInner
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAvailableMerchantCategories200ResponseAvailableMerchantCategoriesInner
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAvailableMerchantCategories200ResponseAvailableMerchantCategoriesInner
     */
    'logoUrl': string;
}
/**
 * 
 * @export
 * @interface UpdateAvailableMerchantCategories200ResponseUser
 */
export interface UpdateAvailableMerchantCategories200ResponseUser {
    /**
     * 
     * @type {string}
     * @memberof UpdateAvailableMerchantCategories200ResponseUser
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAvailableMerchantCategories200ResponseUser
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAvailableMerchantCategories200ResponseUser
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAvailableMerchantCategories200ResponseUser
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAvailableMerchantCategories200ResponseUser
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateAvailableMerchantCategories200ResponseUser
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateAvailableMerchantCategories200ResponseUser
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateAvailableMerchantCategories200ResponseUser
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateAvailableMerchantCategories200ResponseUser
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateAvailableMerchantCategories200ResponseUser
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateAvailableMerchantCategories200ResponseUser
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface UpdateAvailableMerchantCategories200ResponseUserAccountGroup
 */
export interface UpdateAvailableMerchantCategories200ResponseUserAccountGroup {
    /**
     * 
     * @type {string}
     * @memberof UpdateAvailableMerchantCategories200ResponseUserAccountGroup
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAvailableMerchantCategories200ResponseUserAccountGroup
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof UpdateAvailableMerchantCategories200ResponseUserAccountGroup
     */
    'sortNum': number;
}
/**
 * 
 * @export
 * @interface UpdateAvailableMerchantCategoriesRequest
 */
export interface UpdateAvailableMerchantCategoriesRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateAvailableMerchantCategoriesRequest
     */
    'newAvailableMerchantCategoryIds': Array<string>;
}
/**
 * 
 * @export
 * @interface UpdateCardAccountUnitRequest
 */
export interface UpdateCardAccountUnitRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateCardAccountUnitRequest
     */
    'cardAccountUnit'?: UpdateCardAccountUnitRequestCardAccountUnitEnum;
}

export const UpdateCardAccountUnitRequestCardAccountUnitEnum = {
    all: 'ALL',
    group: 'GROUP',
    single: 'SINGLE'
} as const;

export type UpdateCardAccountUnitRequestCardAccountUnitEnum = typeof UpdateCardAccountUnitRequestCardAccountUnitEnum[keyof typeof UpdateCardAccountUnitRequestCardAccountUnitEnum];

/**
 * 
 * @export
 * @interface UpdateCardCountLimitRequest
 */
export interface UpdateCardCountLimitRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateCardCountLimitRequest
     */
    'cardCountLimit': number;
}
/**
 * 
 * @export
 * @interface UpdateCardHolder200Response
 */
export interface UpdateCardHolder200Response {
    /**
     * 
     * @type {string}
     * @memberof UpdateCardHolder200Response
     */
    'cardId': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCardHolder200Response
     */
    'cardLabel': string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCardHolder200Response
     */
    'isActivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCardHolder200Response
     */
    'isDeactivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCardHolder200Response
     */
    'isLocked': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCardHolder200Response
     */
    'isSuspended': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCardHolder200Response
     */
    'isFrozen': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCardHolder200Response
     */
    'isVirtualCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCardHolder200Response
     */
    'isCreditCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCardHolder200Response
     */
    'isOnDemand': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCardHolder200Response
     */
    'isMetalCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCardHolder200Response
     */
    'isPhysicalStorePaymentDisabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateCardHolder200Response
     */
    'panLastFourDigits': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCardHolder200Response
     */
    'userAccountId': string;
    /**
     * 
     * @type {number}
     * @memberof UpdateCardHolder200Response
     */
    'transactionUpperLimit': number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateCardHolder200Response
     */
    'availableCurrencies': Array<UpdateCardHolder200ResponseAvailableCurrenciesEnum>;
    /**
     * 
     * @type {Array<UpdateCardHolder200ResponseAvailableMerchantCategoriesInner>}
     * @memberof UpdateCardHolder200Response
     */
    'availableMerchantCategories': Array<UpdateCardHolder200ResponseAvailableMerchantCategoriesInner> | null;
    /**
     * 
     * @type {UpdateCardHolder200ResponseUser}
     * @memberof UpdateCardHolder200Response
     */
    'user': UpdateCardHolder200ResponseUser;
    /**
     * 
     * @type {UpdateCardHolder200ResponseUserAccountGroup}
     * @memberof UpdateCardHolder200Response
     */
    'userAccountGroup'?: UpdateCardHolder200ResponseUserAccountGroup | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateCardHolder200Response
     */
    'monthlyTotalUsage': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateCardHolder200Response
     */
    'monthlyUsageLimit': number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateCardHolder200Response
     */
    'dailyTotalUsage': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateCardHolder200Response
     */
    'dailyUsageLimit': number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateCardHolder200Response
     */
    'totalUsageAmount': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateCardHolder200Response
     */
    'totalUsageAmountLimit': number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateCardHolder200Response
     */
    'expiredDate': string | null;
}

export const UpdateCardHolder200ResponseAvailableCurrenciesEnum = {
    jpy: 'JPY',
    usd: 'USD',
    gbp: 'GBP',
    eur: 'EUR',
    sgd: 'SGD',
    aud: 'AUD',
    cny: 'CNY',
    hkd: 'HKD',
    idr: 'IDR',
    krw: 'KRW',
    nzd: 'NZD',
    php: 'PHP',
    rub: 'RUB',
    vnd: 'VND',
    inr: 'INR',
    thb: 'THB',
    lak: 'LAK',
    myr: 'MYR',
    twd: 'TWD',
    chf: 'CHF',
    cad: 'CAD',
    mxn: 'MXN',
    nok: 'NOK',
    huf: 'HUF',
    hrk: 'HRK',
    czk: 'CZK',
    dkk: 'DKK',
    isk: 'ISK',
    mdl: 'MDL',
    sek: 'SEK',
    mkd: 'MKD',
    rsd: 'RSD',
    ron: 'RON',
    bgn: 'BGN',
    bam: 'BAM',
    pln: 'PLN',
    mad: 'MAD',
    zar: 'ZAR',
    rwf: 'RWF',
    kes: 'KES',
    ngn: 'NGN',
    aed: 'AED',
    sar: 'SAR',
    egp: 'EGP',
    qar: 'QAR',
    omr: 'OMR',
    ils: 'ILS',
    try: 'TRY',
    kzt: 'KZT',
    cop: 'COP',
    gtq: 'GTQ'
} as const;

export type UpdateCardHolder200ResponseAvailableCurrenciesEnum = typeof UpdateCardHolder200ResponseAvailableCurrenciesEnum[keyof typeof UpdateCardHolder200ResponseAvailableCurrenciesEnum];

/**
 * 
 * @export
 * @interface UpdateCardHolder200ResponseAvailableMerchantCategoriesInner
 */
export interface UpdateCardHolder200ResponseAvailableMerchantCategoriesInner {
    /**
     * 
     * @type {string}
     * @memberof UpdateCardHolder200ResponseAvailableMerchantCategoriesInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCardHolder200ResponseAvailableMerchantCategoriesInner
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCardHolder200ResponseAvailableMerchantCategoriesInner
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCardHolder200ResponseAvailableMerchantCategoriesInner
     */
    'logoUrl': string;
}
/**
 * 
 * @export
 * @interface UpdateCardHolder200ResponseUser
 */
export interface UpdateCardHolder200ResponseUser {
    /**
     * 
     * @type {string}
     * @memberof UpdateCardHolder200ResponseUser
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCardHolder200ResponseUser
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCardHolder200ResponseUser
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCardHolder200ResponseUser
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCardHolder200ResponseUser
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCardHolder200ResponseUser
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCardHolder200ResponseUser
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCardHolder200ResponseUser
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCardHolder200ResponseUser
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCardHolder200ResponseUser
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateCardHolder200ResponseUser
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface UpdateCardHolder200ResponseUserAccountGroup
 */
export interface UpdateCardHolder200ResponseUserAccountGroup {
    /**
     * 
     * @type {string}
     * @memberof UpdateCardHolder200ResponseUserAccountGroup
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCardHolder200ResponseUserAccountGroup
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof UpdateCardHolder200ResponseUserAccountGroup
     */
    'sortNum': number;
}
/**
 * 
 * @export
 * @interface UpdateCardHolderRequest
 */
export interface UpdateCardHolderRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateCardHolderRequest
     */
    'userId': number;
}
/**
 * 
 * @export
 * @interface UpdateCardLock200Response
 */
export interface UpdateCardLock200Response {
    /**
     * 
     * @type {string}
     * @memberof UpdateCardLock200Response
     */
    'cardId': string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCardLock200Response
     */
    'isActivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCardLock200Response
     */
    'isDeactivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCardLock200Response
     */
    'isLocked': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCardLock200Response
     */
    'isSuspended': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCardLock200Response
     */
    'isFrozen': boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateCardLock200Response
     */
    'panLastFourDigits': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCardLock200Response
     */
    'linkedUserAccountId': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCardLock200Response
     */
    'createdAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCardLock200Response
     */
    'isActive': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCardLock200Response
     */
    'isVirtualCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCardLock200Response
     */
    'isCreditCard': boolean;
}
/**
 * 
 * @export
 * @interface UpdateCardUnlock200Response
 */
export interface UpdateCardUnlock200Response {
    /**
     * 
     * @type {string}
     * @memberof UpdateCardUnlock200Response
     */
    'cardId': string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCardUnlock200Response
     */
    'isActivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCardUnlock200Response
     */
    'isDeactivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCardUnlock200Response
     */
    'isLocked': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCardUnlock200Response
     */
    'isSuspended': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCardUnlock200Response
     */
    'isFrozen': boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateCardUnlock200Response
     */
    'panLastFourDigits': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCardUnlock200Response
     */
    'linkedUserAccountId': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCardUnlock200Response
     */
    'createdAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCardUnlock200Response
     */
    'isActive': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCardUnlock200Response
     */
    'isVirtualCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCardUnlock200Response
     */
    'isCreditCard': boolean;
}
/**
 * 
 * @export
 * @interface UpdateCommentRequest
 */
export interface UpdateCommentRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateCommentRequest
     */
    'comment': string;
}
/**
 * 
 * @export
 * @interface UpdateCommentTemplateRequest
 */
export interface UpdateCommentTemplateRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateCommentTemplateRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCommentTemplateRequest
     */
    'template': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateCommentTemplateRequest
     */
    'userAccountIdsSetAsDefault'?: Array<string>;
}
/**
 * 
 * @export
 * @interface UpdateCorporateDocumentResultRequest
 */
export interface UpdateCorporateDocumentResultRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateCorporateDocumentResultRequest
     */
    'result': UpdateCorporateDocumentResultRequestResultEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateCorporateDocumentResultRequest
     */
    'reason': string | null;
}

export const UpdateCorporateDocumentResultRequestResultEnum = {
    approved: 'APPROVED',
    denied: 'DENIED'
} as const;

export type UpdateCorporateDocumentResultRequestResultEnum = typeof UpdateCorporateDocumentResultRequestResultEnum[keyof typeof UpdateCorporateDocumentResultRequestResultEnum];

/**
 * 
 * @export
 * @interface UpdateDailyUserUsageLimit200Response
 */
export interface UpdateDailyUserUsageLimit200Response {
    /**
     * 
     * @type {string}
     * @memberof UpdateDailyUserUsageLimit200Response
     */
    'cardId': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDailyUserUsageLimit200Response
     */
    'cardLabel': string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateDailyUserUsageLimit200Response
     */
    'isActivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateDailyUserUsageLimit200Response
     */
    'isDeactivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateDailyUserUsageLimit200Response
     */
    'isLocked': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateDailyUserUsageLimit200Response
     */
    'isSuspended': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateDailyUserUsageLimit200Response
     */
    'isFrozen': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateDailyUserUsageLimit200Response
     */
    'isVirtualCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateDailyUserUsageLimit200Response
     */
    'isCreditCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateDailyUserUsageLimit200Response
     */
    'isOnDemand': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateDailyUserUsageLimit200Response
     */
    'isMetalCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateDailyUserUsageLimit200Response
     */
    'isPhysicalStorePaymentDisabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateDailyUserUsageLimit200Response
     */
    'panLastFourDigits': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDailyUserUsageLimit200Response
     */
    'userAccountId': string;
    /**
     * 
     * @type {number}
     * @memberof UpdateDailyUserUsageLimit200Response
     */
    'transactionUpperLimit': number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateDailyUserUsageLimit200Response
     */
    'availableCurrencies': Array<UpdateDailyUserUsageLimit200ResponseAvailableCurrenciesEnum>;
    /**
     * 
     * @type {Array<UpdateDailyUserUsageLimit200ResponseAvailableMerchantCategoriesInner>}
     * @memberof UpdateDailyUserUsageLimit200Response
     */
    'availableMerchantCategories': Array<UpdateDailyUserUsageLimit200ResponseAvailableMerchantCategoriesInner> | null;
    /**
     * 
     * @type {UpdateDailyUserUsageLimit200ResponseUser}
     * @memberof UpdateDailyUserUsageLimit200Response
     */
    'user': UpdateDailyUserUsageLimit200ResponseUser;
    /**
     * 
     * @type {UpdateDailyUserUsageLimit200ResponseUserAccountGroup}
     * @memberof UpdateDailyUserUsageLimit200Response
     */
    'userAccountGroup'?: UpdateDailyUserUsageLimit200ResponseUserAccountGroup | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateDailyUserUsageLimit200Response
     */
    'monthlyTotalUsage': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateDailyUserUsageLimit200Response
     */
    'monthlyUsageLimit': number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateDailyUserUsageLimit200Response
     */
    'dailyTotalUsage': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateDailyUserUsageLimit200Response
     */
    'dailyUsageLimit': number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateDailyUserUsageLimit200Response
     */
    'totalUsageAmount': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateDailyUserUsageLimit200Response
     */
    'totalUsageAmountLimit': number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateDailyUserUsageLimit200Response
     */
    'expiredDate': string | null;
}

export const UpdateDailyUserUsageLimit200ResponseAvailableCurrenciesEnum = {
    jpy: 'JPY',
    usd: 'USD',
    gbp: 'GBP',
    eur: 'EUR',
    sgd: 'SGD',
    aud: 'AUD',
    cny: 'CNY',
    hkd: 'HKD',
    idr: 'IDR',
    krw: 'KRW',
    nzd: 'NZD',
    php: 'PHP',
    rub: 'RUB',
    vnd: 'VND',
    inr: 'INR',
    thb: 'THB',
    lak: 'LAK',
    myr: 'MYR',
    twd: 'TWD',
    chf: 'CHF',
    cad: 'CAD',
    mxn: 'MXN',
    nok: 'NOK',
    huf: 'HUF',
    hrk: 'HRK',
    czk: 'CZK',
    dkk: 'DKK',
    isk: 'ISK',
    mdl: 'MDL',
    sek: 'SEK',
    mkd: 'MKD',
    rsd: 'RSD',
    ron: 'RON',
    bgn: 'BGN',
    bam: 'BAM',
    pln: 'PLN',
    mad: 'MAD',
    zar: 'ZAR',
    rwf: 'RWF',
    kes: 'KES',
    ngn: 'NGN',
    aed: 'AED',
    sar: 'SAR',
    egp: 'EGP',
    qar: 'QAR',
    omr: 'OMR',
    ils: 'ILS',
    try: 'TRY',
    kzt: 'KZT',
    cop: 'COP',
    gtq: 'GTQ'
} as const;

export type UpdateDailyUserUsageLimit200ResponseAvailableCurrenciesEnum = typeof UpdateDailyUserUsageLimit200ResponseAvailableCurrenciesEnum[keyof typeof UpdateDailyUserUsageLimit200ResponseAvailableCurrenciesEnum];

/**
 * 
 * @export
 * @interface UpdateDailyUserUsageLimit200ResponseAvailableMerchantCategoriesInner
 */
export interface UpdateDailyUserUsageLimit200ResponseAvailableMerchantCategoriesInner {
    /**
     * 
     * @type {string}
     * @memberof UpdateDailyUserUsageLimit200ResponseAvailableMerchantCategoriesInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDailyUserUsageLimit200ResponseAvailableMerchantCategoriesInner
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDailyUserUsageLimit200ResponseAvailableMerchantCategoriesInner
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDailyUserUsageLimit200ResponseAvailableMerchantCategoriesInner
     */
    'logoUrl': string;
}
/**
 * 
 * @export
 * @interface UpdateDailyUserUsageLimit200ResponseUser
 */
export interface UpdateDailyUserUsageLimit200ResponseUser {
    /**
     * 
     * @type {string}
     * @memberof UpdateDailyUserUsageLimit200ResponseUser
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDailyUserUsageLimit200ResponseUser
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDailyUserUsageLimit200ResponseUser
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDailyUserUsageLimit200ResponseUser
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDailyUserUsageLimit200ResponseUser
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateDailyUserUsageLimit200ResponseUser
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateDailyUserUsageLimit200ResponseUser
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateDailyUserUsageLimit200ResponseUser
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateDailyUserUsageLimit200ResponseUser
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateDailyUserUsageLimit200ResponseUser
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateDailyUserUsageLimit200ResponseUser
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface UpdateDailyUserUsageLimit200ResponseUserAccountGroup
 */
export interface UpdateDailyUserUsageLimit200ResponseUserAccountGroup {
    /**
     * 
     * @type {string}
     * @memberof UpdateDailyUserUsageLimit200ResponseUserAccountGroup
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDailyUserUsageLimit200ResponseUserAccountGroup
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof UpdateDailyUserUsageLimit200ResponseUserAccountGroup
     */
    'sortNum': number;
}
/**
 * 
 * @export
 * @interface UpdateDailyUserUsageLimitRequest
 */
export interface UpdateDailyUserUsageLimitRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateDailyUserUsageLimitRequest
     */
    'newUsageLimit': number;
}
/**
 * 
 * @export
 * @interface UpdateDepositRestrictionForOrganizationRequest
 */
export interface UpdateDepositRestrictionForOrganizationRequest {
    /**
     * 入金禁止フラグ
     * @type {boolean}
     * @memberof UpdateDepositRestrictionForOrganizationRequest
     */
    'depositBlocked': boolean;
    /**
     * 入金制限開始日時
     * @type {string}
     * @memberof UpdateDepositRestrictionForOrganizationRequest
     */
    'startAt': string;
    /**
     * 入金制限終了日時
     * @type {string}
     * @memberof UpdateDepositRestrictionForOrganizationRequest
     */
    'endAt': string;
}
/**
 * 
 * @export
 * @interface UpdateEmailNotificationRequest
 */
export interface UpdateEmailNotificationRequest {
    /**
     * 
     * @type {boolean}
     * @memberof UpdateEmailNotificationRequest
     */
    'enabled'?: boolean;
}
/**
 * 
 * @export
 * @interface UpdateEmbedUrlMethodRequest
 */
export interface UpdateEmbedUrlMethodRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateEmbedUrlMethodRequest
     */
    'embedUrlMethod': UpdateEmbedUrlMethodRequestEmbedUrlMethodEnum;
}

export const UpdateEmbedUrlMethodRequestEmbedUrlMethodEnum = {
    none: 'NONE',
    back: 'BACK',
    front: 'FRONT'
} as const;

export type UpdateEmbedUrlMethodRequestEmbedUrlMethodEnum = typeof UpdateEmbedUrlMethodRequestEmbedUrlMethodEnum[keyof typeof UpdateEmbedUrlMethodRequestEmbedUrlMethodEnum];

/**
 * 
 * @export
 * @interface UpdateEvidenceImageRequest
 */
export interface UpdateEvidenceImageRequest {
    /**
     * 
     * @type {File}
     * @memberof UpdateEvidenceImageRequest
     */
    'file'?: File;
    /**
     * 
     * @type {string}
     * @memberof UpdateEvidenceImageRequest
     */
    'electronicMethod'?: UpdateEvidenceImageRequestElectronicMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateEvidenceImageRequest
     */
    'documentSize'?: UpdateEvidenceImageRequestDocumentSizeEnum;
    /**
     * 
     * @type {number}
     * @memberof UpdateEvidenceImageRequest
     */
    'heightMillis'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateEvidenceImageRequest
     */
    'widthMillis'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateEvidenceImageRequest
     */
    'note'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateEvidenceImageRequest
     */
    'irrelevantToLedger'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateEvidenceImageRequest
     */
    'dpiForciblyValid'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateEvidenceImageRequest
     */
    'colorGradationForciblyValid'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateEvidenceImageRequest
     */
    'uploadedByRecipient'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateEvidenceImageRequest
     */
    'uploadedFrom'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateEvidenceImageRequest
     */
    'invoiceIssuerName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateEvidenceImageRequest
     */
    'invoiceIssuerRegistrationNumber'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateEvidenceImageRequest
     */
    'asQualified'?: boolean | null;
}

export const UpdateEvidenceImageRequestElectronicMethodEnum = {
    fullElectronic: 'FULL_ELECTRONIC',
    originallyPaper: 'ORIGINALLY_PAPER',
    unknown: 'UNKNOWN'
} as const;

export type UpdateEvidenceImageRequestElectronicMethodEnum = typeof UpdateEvidenceImageRequestElectronicMethodEnum[keyof typeof UpdateEvidenceImageRequestElectronicMethodEnum];
export const UpdateEvidenceImageRequestDocumentSizeEnum = {
    overA4: 'OVER_A4',
    a4OrSmaller: 'A4_OR_SMALLER',
    unknown: 'UNKNOWN'
} as const;

export type UpdateEvidenceImageRequestDocumentSizeEnum = typeof UpdateEvidenceImageRequestDocumentSizeEnum[keyof typeof UpdateEvidenceImageRequestDocumentSizeEnum];

/**
 * 
 * @export
 * @interface UpdateEvidenceInfoRequest
 */
export interface UpdateEvidenceInfoRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateEvidenceInfoRequest
     */
    'electronicMethod'?: UpdateEvidenceInfoRequestElectronicMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateEvidenceInfoRequest
     */
    'documentSize'?: UpdateEvidenceInfoRequestDocumentSizeEnum;
    /**
     * 
     * @type {number}
     * @memberof UpdateEvidenceInfoRequest
     */
    'heightMillis'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateEvidenceInfoRequest
     */
    'widthMillis'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateEvidenceInfoRequest
     */
    'note'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateEvidenceInfoRequest
     */
    'irrelevantToLedger'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateEvidenceInfoRequest
     */
    'dpiForciblyValid'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateEvidenceInfoRequest
     */
    'colorGradationForciblyValid'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateEvidenceInfoRequest
     */
    'uploadedByRecipient'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateEvidenceInfoRequest
     */
    'uploadedFrom'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateEvidenceInfoRequest
     */
    'invoiceIssuerRegistrationNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateEvidenceInfoRequest
     */
    'invoiceIssuerName'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateEvidenceInfoRequest
     */
    'asQualified'?: boolean | null;
}

export const UpdateEvidenceInfoRequestElectronicMethodEnum = {
    fullElectronic: 'FULL_ELECTRONIC',
    originallyPaper: 'ORIGINALLY_PAPER',
    unknown: 'UNKNOWN'
} as const;

export type UpdateEvidenceInfoRequestElectronicMethodEnum = typeof UpdateEvidenceInfoRequestElectronicMethodEnum[keyof typeof UpdateEvidenceInfoRequestElectronicMethodEnum];
export const UpdateEvidenceInfoRequestDocumentSizeEnum = {
    overA4: 'OVER_A4',
    a4OrSmaller: 'A4_OR_SMALLER',
    unknown: 'UNKNOWN'
} as const;

export type UpdateEvidenceInfoRequestDocumentSizeEnum = typeof UpdateEvidenceInfoRequestDocumentSizeEnum[keyof typeof UpdateEvidenceInfoRequestDocumentSizeEnum];

/**
 * 
 * @export
 * @interface UpdateFreeeConnect200Response
 */
export interface UpdateFreeeConnect200Response {
    /**
     * 
     * @type {string}
     * @memberof UpdateFreeeConnect200Response
     */
    'status': string;
}
/**
 * 
 * @export
 * @interface UpdateFreeeJournalingRequest
 */
export interface UpdateFreeeJournalingRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateFreeeJournalingRequest
     */
    'freeeCompanyId': string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateFreeeJournalingRequest
     */
    'useJournaling': boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateFreeeJournalingRequest
     */
    'yearMonth': string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateFreeeJournalingRequest
     */
    'transitionModeEndDate': string | null;
}
/**
 * 
 * @export
 * @interface UpdateFreeeSelectCompany200Response
 */
export interface UpdateFreeeSelectCompany200Response {
    /**
     * 
     * @type {string}
     * @memberof UpdateFreeeSelectCompany200Response
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateFreeeSelectCompany200Response
     */
    'freeeCompanyId': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateFreeeSelectCompany200Response
     */
    'freeeCompanyName': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateFreeeSelectCompany200Response
     */
    'cardAccountUnit': UpdateFreeeSelectCompany200ResponseCardAccountUnitEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateFreeeSelectCompany200Response
     */
    'connectedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateFreeeSelectCompany200Response
     */
    'isJournalFeatureEnabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateFreeeSelectCompany200Response
     */
    'journalEntryTransitionModeEndDate': string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateFreeeSelectCompany200Response
     */
    'accountItemIdForPointUse': string;
}

export const UpdateFreeeSelectCompany200ResponseCardAccountUnitEnum = {
    all: 'ALL',
    group: 'GROUP',
    single: 'SINGLE'
} as const;

export type UpdateFreeeSelectCompany200ResponseCardAccountUnitEnum = typeof UpdateFreeeSelectCompany200ResponseCardAccountUnitEnum[keyof typeof UpdateFreeeSelectCompany200ResponseCardAccountUnitEnum];

/**
 * 
 * @export
 * @interface UpdateFreeeSelectCompanyRequest
 */
export interface UpdateFreeeSelectCompanyRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateFreeeSelectCompanyRequest
     */
    'freeeCompanyId': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateFreeeSelectCompanyRequest
     */
    'freeeCompanyName': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateFreeeSelectCompanyRequest
     */
    'transitionModeEndDate': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateFreeeSelectCompanyRequest
     */
    'useJournaling': boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateFreeeSelectCompanyRequest
     */
    'yearMonth': string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateFreeeSelectCompanyRequest
     */
    'cardAccountUnit'?: UpdateFreeeSelectCompanyRequestCardAccountUnitEnum;
}

export const UpdateFreeeSelectCompanyRequestCardAccountUnitEnum = {
    all: 'ALL',
    group: 'GROUP',
    single: 'SINGLE'
} as const;

export type UpdateFreeeSelectCompanyRequestCardAccountUnitEnum = typeof UpdateFreeeSelectCompanyRequestCardAccountUnitEnum[keyof typeof UpdateFreeeSelectCompanyRequestCardAccountUnitEnum];

/**
 * 
 * @export
 * @interface UpdateLockStatusOfEvidencesRequest
 */
export interface UpdateLockStatusOfEvidencesRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateLockStatusOfEvidencesRequest
     */
    'yearMonth': string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateLockStatusOfEvidencesRequest
     */
    'isLocked': boolean;
}
/**
 * 
 * @export
 * @interface UpdateMerchantGeneralBlockAllowedOrganizationIdsRequest
 */
export interface UpdateMerchantGeneralBlockAllowedOrganizationIdsRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateMerchantGeneralBlockAllowedOrganizationIdsRequest
     */
    'allowedOrganizationIds': Array<string>;
}
/**
 * 
 * @export
 * @interface UpdateMerchantGeneralBlockListRequest
 */
export interface UpdateMerchantGeneralBlockListRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateMerchantGeneralBlockListRequest
     */
    'merchantName': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateMerchantGeneralBlockListRequest
     */
    'merchantId': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateMerchantGeneralBlockListRequest
     */
    'acquirerId': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateMerchantGeneralBlockListRequest
     */
    'patternType': UpdateMerchantGeneralBlockListRequestPatternTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateMerchantGeneralBlockListRequest
     */
    'storeType': UpdateMerchantGeneralBlockListRequestStoreTypeEnum;
}

export const UpdateMerchantGeneralBlockListRequestPatternTypeEnum = {
    exact: 'EXACT',
    prefix: 'PREFIX',
    suffix: 'SUFFIX',
    regexp: 'REGEXP',
    unknown: 'UNKNOWN'
} as const;

export type UpdateMerchantGeneralBlockListRequestPatternTypeEnum = typeof UpdateMerchantGeneralBlockListRequestPatternTypeEnum[keyof typeof UpdateMerchantGeneralBlockListRequestPatternTypeEnum];
export const UpdateMerchantGeneralBlockListRequestStoreTypeEnum = {
    all: 'ALL',
    physicalStore: 'PHYSICAL_STORE',
    ecStore: 'EC_STORE',
    unknown: 'UNKNOWN'
} as const;

export type UpdateMerchantGeneralBlockListRequestStoreTypeEnum = typeof UpdateMerchantGeneralBlockListRequestStoreTypeEnum[keyof typeof UpdateMerchantGeneralBlockListRequestStoreTypeEnum];

/**
 * 
 * @export
 * @interface UpdateMerchantOrgBlockListRequest
 */
export interface UpdateMerchantOrgBlockListRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateMerchantOrgBlockListRequest
     */
    'merchantName': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateMerchantOrgBlockListRequest
     */
    'merchantId': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateMerchantOrgBlockListRequest
     */
    'acquirerId': string;
    /**
     * 
     * @type {Strign}
     * @memberof UpdateMerchantOrgBlockListRequest
     */
    'patternType': UpdateMerchantOrgBlockListRequestPatternTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateMerchantOrgBlockListRequest
     */
    'storeType': UpdateMerchantOrgBlockListRequestStoreTypeEnum;
}

export const UpdateMerchantOrgBlockListRequestPatternTypeEnum = {
    exact: 'EXACT',
    prefix: 'PREFIX',
    suffix: 'SUFFIX',
    regexp: 'REGEXP',
    unknown: 'UNKNOWN'
} as const;

export type UpdateMerchantOrgBlockListRequestPatternTypeEnum = typeof UpdateMerchantOrgBlockListRequestPatternTypeEnum[keyof typeof UpdateMerchantOrgBlockListRequestPatternTypeEnum];
export const UpdateMerchantOrgBlockListRequestStoreTypeEnum = {
    all: 'ALL',
    physicalStore: 'PHYSICAL_STORE',
    ecStore: 'EC_STORE',
    unknown: 'UNKNOWN'
} as const;

export type UpdateMerchantOrgBlockListRequestStoreTypeEnum = typeof UpdateMerchantOrgBlockListRequestStoreTypeEnum[keyof typeof UpdateMerchantOrgBlockListRequestStoreTypeEnum];

/**
 * 
 * @export
 * @interface UpdateMerchantOrganizationCommentRequest
 */
export interface UpdateMerchantOrganizationCommentRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateMerchantOrganizationCommentRequest
     */
    'comment': string;
}
/**
 * 
 * @export
 * @interface UpdateOrganization200Response
 */
export interface UpdateOrganization200Response {
    /**
     * 
     * @type {number}
     * @memberof UpdateOrganization200Response
     */
    'id': number;
    /**
     * 
     * @type {Array<UpdateOrganization200ResponseContractsInner>}
     * @memberof UpdateOrganization200Response
     */
    'contracts': Array<UpdateOrganization200ResponseContractsInner>;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganization200Response
     */
    'orgAccountId'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganization200Response
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganization200Response
     */
    'representativeName': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganization200Response
     */
    'phoneNumber': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganization200Response
     */
    'postalCode': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganization200Response
     */
    'address': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganization200Response
     */
    'deliveryPostalCode': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganization200Response
     */
    'deliveryAddress': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganization200Response
     */
    'invoiceEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateOrganization200Response
     */
    'isApprovalFeatureEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateOrganization200Response
     */
    'isBlacklisted'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateOrganization200Response
     */
    'isSendTransactionFailureEmail'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateOrganization200Response
     */
    'isVCCooperationPlanEnabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganization200Response
     */
    'promotionCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganization200Response
     */
    'paymentScheme': UpdateOrganization200ResponsePaymentSchemeEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganization200Response
     */
    'identityVerificationScheduledDate'?: string | null;
}

export const UpdateOrganization200ResponsePaymentSchemeEnum = {
    fifteenthDayPayment: 'FIFTEENTH_DAY_PAYMENT',
    endOfMonthPayment: 'END_OF_MONTH_PAYMENT',
    twoMonthsLaterFifteenthDayPayment: 'TWO_MONTHS_LATER_FIFTEENTH_DAY_PAYMENT',
    twoMonthsLaterSixthDayPayment: 'TWO_MONTHS_LATER_SIXTH_DAY_PAYMENT',
    endOfTwoMonthsLaterPayment: 'END_OF_TWO_MONTHS_LATER_PAYMENT'
} as const;

export type UpdateOrganization200ResponsePaymentSchemeEnum = typeof UpdateOrganization200ResponsePaymentSchemeEnum[keyof typeof UpdateOrganization200ResponsePaymentSchemeEnum];

/**
 * 
 * @export
 * @interface UpdateOrganization200ResponseContractsInner
 */
export interface UpdateOrganization200ResponseContractsInner {
    /**
     * 
     * @type {number}
     * @memberof UpdateOrganization200ResponseContractsInner
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateOrganization200ResponseContractsInner
     */
    'organizationId': number;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganization200ResponseContractsInner
     */
    'contractType': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganization200ResponseContractsInner
     */
    'startAt': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganization200ResponseContractsInner
     */
    'endAt': string;
}
/**
 * 
 * @export
 * @interface UpdateOrganizationRequest
 */
export interface UpdateOrganizationRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganizationRequest
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganizationRequest
     */
    'organizationName': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganizationRequest
     */
    'representativeName': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganizationRequest
     */
    'postalCode': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganizationRequest
     */
    'address': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganizationRequest
     */
    'deliveryPostalCode': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganizationRequest
     */
    'deliveryAddress': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganizationRequest
     */
    'phoneNumber': string;
}
/**
 * 
 * @export
 * @interface UpdatePaymentRequestEvidenceFileRequest
 */
export interface UpdatePaymentRequestEvidenceFileRequest {
    /**
     * 
     * @type {File}
     * @memberof UpdatePaymentRequestEvidenceFileRequest
     */
    'file'?: File;
    /**
     * 
     * @type {string}
     * @memberof UpdatePaymentRequestEvidenceFileRequest
     */
    'electronicMethod'?: UpdatePaymentRequestEvidenceFileRequestElectronicMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdatePaymentRequestEvidenceFileRequest
     */
    'documentSize'?: UpdatePaymentRequestEvidenceFileRequestDocumentSizeEnum;
    /**
     * 
     * @type {number}
     * @memberof UpdatePaymentRequestEvidenceFileRequest
     */
    'heightMillis'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdatePaymentRequestEvidenceFileRequest
     */
    'widthMillis'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdatePaymentRequestEvidenceFileRequest
     */
    'dpiForciblyValid'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdatePaymentRequestEvidenceFileRequest
     */
    'colorGradationForciblyValid'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof UpdatePaymentRequestEvidenceFileRequest
     */
    'note'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdatePaymentRequestEvidenceFileRequest
     */
    'irrelevantToLedger'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdatePaymentRequestEvidenceFileRequest
     */
    'uploadedByRecipient'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof UpdatePaymentRequestEvidenceFileRequest
     */
    'uploadedFrom'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdatePaymentRequestEvidenceFileRequest
     */
    'invoiceIssuerRegistrationNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdatePaymentRequestEvidenceFileRequest
     */
    'invoiceIssuerName'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdatePaymentRequestEvidenceFileRequest
     */
    'asQualified'?: boolean | null;
}

export const UpdatePaymentRequestEvidenceFileRequestElectronicMethodEnum = {
    fullElectronic: 'FULL_ELECTRONIC',
    originallyPaper: 'ORIGINALLY_PAPER',
    unknown: 'UNKNOWN'
} as const;

export type UpdatePaymentRequestEvidenceFileRequestElectronicMethodEnum = typeof UpdatePaymentRequestEvidenceFileRequestElectronicMethodEnum[keyof typeof UpdatePaymentRequestEvidenceFileRequestElectronicMethodEnum];
export const UpdatePaymentRequestEvidenceFileRequestDocumentSizeEnum = {
    overA4: 'OVER_A4',
    a4OrSmaller: 'A4_OR_SMALLER',
    unknown: 'UNKNOWN'
} as const;

export type UpdatePaymentRequestEvidenceFileRequestDocumentSizeEnum = typeof UpdatePaymentRequestEvidenceFileRequestDocumentSizeEnum[keyof typeof UpdatePaymentRequestEvidenceFileRequestDocumentSizeEnum];

/**
 * 
 * @export
 * @interface UpdatePaymentRequestEvidenceRequest
 */
export interface UpdatePaymentRequestEvidenceRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdatePaymentRequestEvidenceRequest
     */
    'electronicMethod'?: UpdatePaymentRequestEvidenceRequestElectronicMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdatePaymentRequestEvidenceRequest
     */
    'documentSize'?: UpdatePaymentRequestEvidenceRequestDocumentSizeEnum;
    /**
     * 
     * @type {number}
     * @memberof UpdatePaymentRequestEvidenceRequest
     */
    'heightMillis'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdatePaymentRequestEvidenceRequest
     */
    'widthMillis'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdatePaymentRequestEvidenceRequest
     */
    'dpiForciblyValid'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdatePaymentRequestEvidenceRequest
     */
    'colorGradationForciblyValid'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof UpdatePaymentRequestEvidenceRequest
     */
    'note'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdatePaymentRequestEvidenceRequest
     */
    'irrelevantToLedger'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdatePaymentRequestEvidenceRequest
     */
    'uploadedByRecipient'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof UpdatePaymentRequestEvidenceRequest
     */
    'uploadedFrom'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdatePaymentRequestEvidenceRequest
     */
    'invoiceIssuerRegistrationNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdatePaymentRequestEvidenceRequest
     */
    'invoiceIssuerName'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdatePaymentRequestEvidenceRequest
     */
    'asQualified'?: boolean | null;
}

export const UpdatePaymentRequestEvidenceRequestElectronicMethodEnum = {
    fullElectronic: 'FULL_ELECTRONIC',
    originallyPaper: 'ORIGINALLY_PAPER',
    unknown: 'UNKNOWN'
} as const;

export type UpdatePaymentRequestEvidenceRequestElectronicMethodEnum = typeof UpdatePaymentRequestEvidenceRequestElectronicMethodEnum[keyof typeof UpdatePaymentRequestEvidenceRequestElectronicMethodEnum];
export const UpdatePaymentRequestEvidenceRequestDocumentSizeEnum = {
    overA4: 'OVER_A4',
    a4OrSmaller: 'A4_OR_SMALLER',
    unknown: 'UNKNOWN'
} as const;

export type UpdatePaymentRequestEvidenceRequestDocumentSizeEnum = typeof UpdatePaymentRequestEvidenceRequestDocumentSizeEnum[keyof typeof UpdatePaymentRequestEvidenceRequestDocumentSizeEnum];

/**
 * 
 * @export
 * @interface UpdatePurchaseApplicationTemplateRequest
 */
export interface UpdatePurchaseApplicationTemplateRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdatePurchaseApplicationTemplateRequest
     */
    'templateName': string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePurchaseApplicationTemplateRequest
     */
    'scopeDisclosure': UpdatePurchaseApplicationTemplateRequestScopeDisclosureEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdatePurchaseApplicationTemplateRequest
     */
    'templateCategory': string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePurchaseApplicationTemplateRequest
     */
    'templateDetail': string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePurchaseApplicationTemplateRequest
     */
    'department': string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePurchaseApplicationTemplateRequest
     */
    'purchaseReason': string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePurchaseApplicationTemplateRequest
     */
    'purchaseDetails': string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePurchaseApplicationTemplateRequest
     */
    'placeOfUse': string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePurchaseApplicationTemplateRequest
     */
    'purposeOfUse': UpdatePurchaseApplicationTemplateRequestPurposeOfUseEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdatePurchaseApplicationTemplateRequest
     */
    'url': string;
    /**
     * 
     * @type {number}
     * @memberof UpdatePurchaseApplicationTemplateRequest
     */
    'amount': number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdatePurchaseApplicationTemplateRequest
     */
    'userAccountId': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdatePurchaseApplicationTemplateRequest
     */
    'isOnDemandCard': boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdatePurchaseApplicationTemplateRequest
     */
    'remarks': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdatePurchaseApplicationTemplateRequest
     */
    'approvers': Array<string>;
}

export const UpdatePurchaseApplicationTemplateRequestScopeDisclosureEnum = {
    public: 'PUBLIC',
    individual: 'INDIVIDUAL'
} as const;

export type UpdatePurchaseApplicationTemplateRequestScopeDisclosureEnum = typeof UpdatePurchaseApplicationTemplateRequestScopeDisclosureEnum[keyof typeof UpdatePurchaseApplicationTemplateRequestScopeDisclosureEnum];
export const UpdatePurchaseApplicationTemplateRequestPurposeOfUseEnum = {
    software: 'SOFTWARE',
    fixtures: 'FIXTURES',
    conference: 'CONFERENCE',
    entertainment: 'ENTERTAINMENT',
    travel: 'TRAVEL',
    other: 'OTHER',
    initialValue: 'INITIAL_VALUE'
} as const;

export type UpdatePurchaseApplicationTemplateRequestPurposeOfUseEnum = typeof UpdatePurchaseApplicationTemplateRequestPurposeOfUseEnum[keyof typeof UpdatePurchaseApplicationTemplateRequestPurposeOfUseEnum];

/**
 * 
 * @export
 * @interface UpdateRemoveUserAccountGroupRequest
 */
export interface UpdateRemoveUserAccountGroupRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateRemoveUserAccountGroupRequest
     */
    'userAccountGroupId': number;
}
/**
 * 
 * @export
 * @interface UpdateRoleResourceForUserRequest
 */
export interface UpdateRoleResourceForUserRequest {
    /**
     * 
     * @type {Array<UpdateRoleResourceForUserRequestUserAccountInner>}
     * @memberof UpdateRoleResourceForUserRequest
     */
    'userAccount': Array<UpdateRoleResourceForUserRequestUserAccountInner>;
    /**
     * 
     * @type {Array<UpdateRoleResourceForUserRequestUserAccountGroupInner>}
     * @memberof UpdateRoleResourceForUserRequest
     */
    'userAccountGroup': Array<UpdateRoleResourceForUserRequestUserAccountGroupInner>;
    /**
     * 
     * @type {Array<UpdateRoleResourceForUserRequestUserAccountAllInner>}
     * @memberof UpdateRoleResourceForUserRequest
     */
    'userAccountAll': Array<UpdateRoleResourceForUserRequestUserAccountAllInner>;
}
/**
 * 
 * @export
 * @interface UpdateRoleResourceForUserRequestUserAccountAllInner
 */
export interface UpdateRoleResourceForUserRequestUserAccountAllInner {
    /**
     * 
     * @type {string}
     * @memberof UpdateRoleResourceForUserRequestUserAccountAllInner
     */
    'role': UpdateRoleResourceForUserRequestUserAccountAllInnerRoleEnum;
}

export const UpdateRoleResourceForUserRequestUserAccountAllInnerRoleEnum = {
    admin: 'USER_ACCOUNT_ADMIN',
    assist: 'USER_ACCOUNT_ASSIST'
} as const;

export type UpdateRoleResourceForUserRequestUserAccountAllInnerRoleEnum = typeof UpdateRoleResourceForUserRequestUserAccountAllInnerRoleEnum[keyof typeof UpdateRoleResourceForUserRequestUserAccountAllInnerRoleEnum];

/**
 * 
 * @export
 * @interface UpdateRoleResourceForUserRequestUserAccountGroupInner
 */
export interface UpdateRoleResourceForUserRequestUserAccountGroupInner {
    /**
     * 
     * @type {string}
     * @memberof UpdateRoleResourceForUserRequestUserAccountGroupInner
     */
    'role': UpdateRoleResourceForUserRequestUserAccountGroupInnerRoleEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateRoleResourceForUserRequestUserAccountGroupInner
     */
    'resourceId': string;
}

export const UpdateRoleResourceForUserRequestUserAccountGroupInnerRoleEnum = {
    admin: 'USER_ACCOUNT_ADMIN',
    assist: 'USER_ACCOUNT_ASSIST'
} as const;

export type UpdateRoleResourceForUserRequestUserAccountGroupInnerRoleEnum = typeof UpdateRoleResourceForUserRequestUserAccountGroupInnerRoleEnum[keyof typeof UpdateRoleResourceForUserRequestUserAccountGroupInnerRoleEnum];

/**
 * 
 * @export
 * @interface UpdateRoleResourceForUserRequestUserAccountInner
 */
export interface UpdateRoleResourceForUserRequestUserAccountInner {
    /**
     * 
     * @type {string}
     * @memberof UpdateRoleResourceForUserRequestUserAccountInner
     */
    'role': UpdateRoleResourceForUserRequestUserAccountInnerRoleEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateRoleResourceForUserRequestUserAccountInner
     */
    'resourceId': string;
}

export const UpdateRoleResourceForUserRequestUserAccountInnerRoleEnum = {
    admin: 'USER_ACCOUNT_ADMIN',
    assist: 'USER_ACCOUNT_ASSIST'
} as const;

export type UpdateRoleResourceForUserRequestUserAccountInnerRoleEnum = typeof UpdateRoleResourceForUserRequestUserAccountInnerRoleEnum[keyof typeof UpdateRoleResourceForUserRequestUserAccountInnerRoleEnum];

/**
 * 
 * @export
 * @interface UpdateRolesByResourceIdRequest
 */
export interface UpdateRolesByResourceIdRequest {
    /**
     * 
     * @type {Array<UpdateRolesByResourceIdRequestSettingsInner>}
     * @memberof UpdateRolesByResourceIdRequest
     */
    'settings': Array<UpdateRolesByResourceIdRequestSettingsInner>;
}
/**
 * 
 * @export
 * @interface UpdateRolesByResourceIdRequestSettingsInner
 */
export interface UpdateRolesByResourceIdRequestSettingsInner {
    /**
     * 
     * @type {string}
     * @memberof UpdateRolesByResourceIdRequestSettingsInner
     */
    'role': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateRolesByResourceIdRequestSettingsInner
     */
    'userId': string;
}
/**
 * 
 * @export
 * @interface UpdateSlackEvidenceReminderPerChannelRequest
 */
export interface UpdateSlackEvidenceReminderPerChannelRequest {
    /**
     * 
     * @type {Array<UpdateSlackEvidenceReminderPerChannelRequestSettingsInner>}
     * @memberof UpdateSlackEvidenceReminderPerChannelRequest
     */
    'settings': Array<UpdateSlackEvidenceReminderPerChannelRequestSettingsInner>;
}
/**
 * 
 * @export
 * @interface UpdateSlackEvidenceReminderPerChannelRequestSettingsInner
 */
export interface UpdateSlackEvidenceReminderPerChannelRequestSettingsInner {
    /**
     * 
     * @type {string}
     * @memberof UpdateSlackEvidenceReminderPerChannelRequestSettingsInner
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSlackEvidenceReminderPerChannelRequestSettingsInner
     */
    'effectiveDayType': UpdateSlackEvidenceReminderPerChannelRequestSettingsInnerEffectiveDayTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof UpdateSlackEvidenceReminderPerChannelRequestSettingsInner
     */
    'effectiveDay': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateSlackEvidenceReminderPerChannelRequestSettingsInner
     */
    'effectiveHours': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateSlackEvidenceReminderPerChannelRequestSettingsInner
     */
    'effectiveMinutes': number;
    /**
     * 
     * @type {string}
     * @memberof UpdateSlackEvidenceReminderPerChannelRequestSettingsInner
     */
    'notificationScope': UpdateSlackEvidenceReminderPerChannelRequestSettingsInnerNotificationScopeEnum;
}

export const UpdateSlackEvidenceReminderPerChannelRequestSettingsInnerEffectiveDayTypeEnum = {
    number: 'NUMBER',
    endOfMonth: 'END_OF_MONTH'
} as const;

export type UpdateSlackEvidenceReminderPerChannelRequestSettingsInnerEffectiveDayTypeEnum = typeof UpdateSlackEvidenceReminderPerChannelRequestSettingsInnerEffectiveDayTypeEnum[keyof typeof UpdateSlackEvidenceReminderPerChannelRequestSettingsInnerEffectiveDayTypeEnum];
export const UpdateSlackEvidenceReminderPerChannelRequestSettingsInnerNotificationScopeEnum = {
    thisMonth: 'THIS_MONTH',
    prevMonth: 'PREV_MONTH'
} as const;

export type UpdateSlackEvidenceReminderPerChannelRequestSettingsInnerNotificationScopeEnum = typeof UpdateSlackEvidenceReminderPerChannelRequestSettingsInnerNotificationScopeEnum[keyof typeof UpdateSlackEvidenceReminderPerChannelRequestSettingsInnerNotificationScopeEnum];

/**
 * 
 * @export
 * @interface UpdateSlackNotificationSettingForCardRequest
 */
export interface UpdateSlackNotificationSettingForCardRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateSlackNotificationSettingForCardRequest
     */
    'transactionTypes': Array<UpdateSlackNotificationSettingForCardRequestTransactionTypesEnum>;
    /**
     * 
     * @type {number}
     * @memberof UpdateSlackNotificationSettingForCardRequest
     */
    'largeAmountThreshold'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateSlackNotificationSettingForCardRequest
     */
    'userAccountIds': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateSlackNotificationSettingForCardRequest
     */
    'groupIds': Array<string>;
}

export const UpdateSlackNotificationSettingForCardRequestTransactionTypesEnum = {
    unknownTransactionType: 'UNKNOWN_TRANSACTION_TYPE',
    successfulTransaction: 'SUCCESSFUL_TRANSACTION',
    incorrectCardInput: 'INCORRECT_CARD_INPUT',
    insufficientBalance: 'INSUFFICIENT_BALANCE',
    otherError: 'OTHER_ERROR',
    potentialFraud: 'POTENTIAL_FRAUD',
    criticalError: 'CRITICAL_ERROR',
    unusualUser: 'UNUSUAL_USER',
    limitationByUser: 'LIMITATION_BY_USER',
    unsupportedTransaction: 'UNSUPPORTED_TRANSACTION',
    carelessUser: 'CARELESS_USER'
} as const;

export type UpdateSlackNotificationSettingForCardRequestTransactionTypesEnum = typeof UpdateSlackNotificationSettingForCardRequestTransactionTypesEnum[keyof typeof UpdateSlackNotificationSettingForCardRequestTransactionTypesEnum];

/**
 * 
 * @export
 * @interface UpdateSlackNotificationSettingForPurchaseApplicationRequest
 */
export interface UpdateSlackNotificationSettingForPurchaseApplicationRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateSlackNotificationSettingForPurchaseApplicationRequest
     */
    'movedChannelId': string;
}
/**
 * 
 * @export
 * @interface UpdateSynchronizeToFreeeLogConfirmRequest
 */
export interface UpdateSynchronizeToFreeeLogConfirmRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateSynchronizeToFreeeLogConfirmRequest
     */
    'dealIds': Array<string>;
}
/**
 * 
 * @export
 * @interface UpdateTeamsNotificationSettingForCardRequest
 */
export interface UpdateTeamsNotificationSettingForCardRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateTeamsNotificationSettingForCardRequest
     */
    'transactionTypes': Array<UpdateTeamsNotificationSettingForCardRequestTransactionTypesEnum>;
    /**
     * 
     * @type {number}
     * @memberof UpdateTeamsNotificationSettingForCardRequest
     */
    'largeAmountThreshold'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateTeamsNotificationSettingForCardRequest
     */
    'userAccountIds': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateTeamsNotificationSettingForCardRequest
     */
    'groupIds': Array<string>;
}

export const UpdateTeamsNotificationSettingForCardRequestTransactionTypesEnum = {
    unknownTransactionType: 'UNKNOWN_TRANSACTION_TYPE',
    successfulTransaction: 'SUCCESSFUL_TRANSACTION',
    incorrectCardInput: 'INCORRECT_CARD_INPUT',
    insufficientBalance: 'INSUFFICIENT_BALANCE',
    otherError: 'OTHER_ERROR',
    potentialFraud: 'POTENTIAL_FRAUD',
    criticalError: 'CRITICAL_ERROR',
    unusualUser: 'UNUSUAL_USER',
    limitationByUser: 'LIMITATION_BY_USER',
    unsupportedTransaction: 'UNSUPPORTED_TRANSACTION',
    carelessUser: 'CARELESS_USER'
} as const;

export type UpdateTeamsNotificationSettingForCardRequestTransactionTypesEnum = typeof UpdateTeamsNotificationSettingForCardRequestTransactionTypesEnum[keyof typeof UpdateTeamsNotificationSettingForCardRequestTransactionTypesEnum];

/**
 * 
 * @export
 * @interface UpdateTransactionUpperLimitForTheUserAccount200Response
 */
export interface UpdateTransactionUpperLimitForTheUserAccount200Response {
    /**
     * 
     * @type {string}
     * @memberof UpdateTransactionUpperLimitForTheUserAccount200Response
     */
    'cardId': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTransactionUpperLimitForTheUserAccount200Response
     */
    'cardLabel': string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTransactionUpperLimitForTheUserAccount200Response
     */
    'isActivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTransactionUpperLimitForTheUserAccount200Response
     */
    'isDeactivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTransactionUpperLimitForTheUserAccount200Response
     */
    'isLocked': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTransactionUpperLimitForTheUserAccount200Response
     */
    'isSuspended': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTransactionUpperLimitForTheUserAccount200Response
     */
    'isFrozen': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTransactionUpperLimitForTheUserAccount200Response
     */
    'isVirtualCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTransactionUpperLimitForTheUserAccount200Response
     */
    'isCreditCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTransactionUpperLimitForTheUserAccount200Response
     */
    'isOnDemand': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTransactionUpperLimitForTheUserAccount200Response
     */
    'isMetalCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTransactionUpperLimitForTheUserAccount200Response
     */
    'isPhysicalStorePaymentDisabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateTransactionUpperLimitForTheUserAccount200Response
     */
    'panLastFourDigits': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTransactionUpperLimitForTheUserAccount200Response
     */
    'userAccountId': string;
    /**
     * 
     * @type {number}
     * @memberof UpdateTransactionUpperLimitForTheUserAccount200Response
     */
    'transactionUpperLimit': number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateTransactionUpperLimitForTheUserAccount200Response
     */
    'availableCurrencies': Array<UpdateTransactionUpperLimitForTheUserAccount200ResponseAvailableCurrenciesEnum>;
    /**
     * 
     * @type {Array<UpdateTransactionUpperLimitForTheUserAccount200ResponseAvailableMerchantCategoriesInner>}
     * @memberof UpdateTransactionUpperLimitForTheUserAccount200Response
     */
    'availableMerchantCategories': Array<UpdateTransactionUpperLimitForTheUserAccount200ResponseAvailableMerchantCategoriesInner> | null;
    /**
     * 
     * @type {UpdateTransactionUpperLimitForTheUserAccount200ResponseUser}
     * @memberof UpdateTransactionUpperLimitForTheUserAccount200Response
     */
    'user': UpdateTransactionUpperLimitForTheUserAccount200ResponseUser;
    /**
     * 
     * @type {UpdateTransactionUpperLimitForTheUserAccount200ResponseUserAccountGroup}
     * @memberof UpdateTransactionUpperLimitForTheUserAccount200Response
     */
    'userAccountGroup'?: UpdateTransactionUpperLimitForTheUserAccount200ResponseUserAccountGroup | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateTransactionUpperLimitForTheUserAccount200Response
     */
    'monthlyTotalUsage': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateTransactionUpperLimitForTheUserAccount200Response
     */
    'monthlyUsageLimit': number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateTransactionUpperLimitForTheUserAccount200Response
     */
    'dailyTotalUsage': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateTransactionUpperLimitForTheUserAccount200Response
     */
    'dailyUsageLimit': number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateTransactionUpperLimitForTheUserAccount200Response
     */
    'totalUsageAmount': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateTransactionUpperLimitForTheUserAccount200Response
     */
    'totalUsageAmountLimit': number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTransactionUpperLimitForTheUserAccount200Response
     */
    'expiredDate': string | null;
}

export const UpdateTransactionUpperLimitForTheUserAccount200ResponseAvailableCurrenciesEnum = {
    jpy: 'JPY',
    usd: 'USD',
    gbp: 'GBP',
    eur: 'EUR',
    sgd: 'SGD',
    aud: 'AUD',
    cny: 'CNY',
    hkd: 'HKD',
    idr: 'IDR',
    krw: 'KRW',
    nzd: 'NZD',
    php: 'PHP',
    rub: 'RUB',
    vnd: 'VND',
    inr: 'INR',
    thb: 'THB',
    lak: 'LAK',
    myr: 'MYR',
    twd: 'TWD',
    chf: 'CHF',
    cad: 'CAD',
    mxn: 'MXN',
    nok: 'NOK',
    huf: 'HUF',
    hrk: 'HRK',
    czk: 'CZK',
    dkk: 'DKK',
    isk: 'ISK',
    mdl: 'MDL',
    sek: 'SEK',
    mkd: 'MKD',
    rsd: 'RSD',
    ron: 'RON',
    bgn: 'BGN',
    bam: 'BAM',
    pln: 'PLN',
    mad: 'MAD',
    zar: 'ZAR',
    rwf: 'RWF',
    kes: 'KES',
    ngn: 'NGN',
    aed: 'AED',
    sar: 'SAR',
    egp: 'EGP',
    qar: 'QAR',
    omr: 'OMR',
    ils: 'ILS',
    try: 'TRY',
    kzt: 'KZT',
    cop: 'COP',
    gtq: 'GTQ'
} as const;

export type UpdateTransactionUpperLimitForTheUserAccount200ResponseAvailableCurrenciesEnum = typeof UpdateTransactionUpperLimitForTheUserAccount200ResponseAvailableCurrenciesEnum[keyof typeof UpdateTransactionUpperLimitForTheUserAccount200ResponseAvailableCurrenciesEnum];

/**
 * 
 * @export
 * @interface UpdateTransactionUpperLimitForTheUserAccount200ResponseAvailableMerchantCategoriesInner
 */
export interface UpdateTransactionUpperLimitForTheUserAccount200ResponseAvailableMerchantCategoriesInner {
    /**
     * 
     * @type {string}
     * @memberof UpdateTransactionUpperLimitForTheUserAccount200ResponseAvailableMerchantCategoriesInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTransactionUpperLimitForTheUserAccount200ResponseAvailableMerchantCategoriesInner
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTransactionUpperLimitForTheUserAccount200ResponseAvailableMerchantCategoriesInner
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTransactionUpperLimitForTheUserAccount200ResponseAvailableMerchantCategoriesInner
     */
    'logoUrl': string;
}
/**
 * 
 * @export
 * @interface UpdateTransactionUpperLimitForTheUserAccount200ResponseUser
 */
export interface UpdateTransactionUpperLimitForTheUserAccount200ResponseUser {
    /**
     * 
     * @type {string}
     * @memberof UpdateTransactionUpperLimitForTheUserAccount200ResponseUser
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTransactionUpperLimitForTheUserAccount200ResponseUser
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTransactionUpperLimitForTheUserAccount200ResponseUser
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTransactionUpperLimitForTheUserAccount200ResponseUser
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTransactionUpperLimitForTheUserAccount200ResponseUser
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTransactionUpperLimitForTheUserAccount200ResponseUser
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTransactionUpperLimitForTheUserAccount200ResponseUser
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTransactionUpperLimitForTheUserAccount200ResponseUser
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTransactionUpperLimitForTheUserAccount200ResponseUser
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTransactionUpperLimitForTheUserAccount200ResponseUser
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateTransactionUpperLimitForTheUserAccount200ResponseUser
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface UpdateTransactionUpperLimitForTheUserAccount200ResponseUserAccountGroup
 */
export interface UpdateTransactionUpperLimitForTheUserAccount200ResponseUserAccountGroup {
    /**
     * 
     * @type {string}
     * @memberof UpdateTransactionUpperLimitForTheUserAccount200ResponseUserAccountGroup
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTransactionUpperLimitForTheUserAccount200ResponseUserAccountGroup
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof UpdateTransactionUpperLimitForTheUserAccount200ResponseUserAccountGroup
     */
    'sortNum': number;
}
/**
 * 
 * @export
 * @interface UpdateTransactionUpperLimitForTheUserAccountRequest
 */
export interface UpdateTransactionUpperLimitForTheUserAccountRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateTransactionUpperLimitForTheUserAccountRequest
     */
    'newTransactionUpperLimit': number;
}
/**
 * 
 * @export
 * @interface UpdateUserAccountGroupRequest
 */
export interface UpdateUserAccountGroupRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateUserAccountGroupRequest
     */
    'userAccountGroupId': number;
}
/**
 * 
 * @export
 * @interface UpdateUserAccountName200Response
 */
export interface UpdateUserAccountName200Response {
    /**
     * 
     * @type {string}
     * @memberof UpdateUserAccountName200Response
     */
    'cardId': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserAccountName200Response
     */
    'cardLabel': string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserAccountName200Response
     */
    'isActivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserAccountName200Response
     */
    'isDeactivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserAccountName200Response
     */
    'isLocked': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserAccountName200Response
     */
    'isSuspended': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserAccountName200Response
     */
    'isFrozen': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserAccountName200Response
     */
    'isVirtualCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserAccountName200Response
     */
    'isCreditCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserAccountName200Response
     */
    'isOnDemand': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserAccountName200Response
     */
    'isMetalCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserAccountName200Response
     */
    'isPhysicalStorePaymentDisabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserAccountName200Response
     */
    'panLastFourDigits': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserAccountName200Response
     */
    'userAccountId': string;
    /**
     * 
     * @type {number}
     * @memberof UpdateUserAccountName200Response
     */
    'transactionUpperLimit': number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateUserAccountName200Response
     */
    'availableCurrencies': Array<UpdateUserAccountName200ResponseAvailableCurrenciesEnum>;
    /**
     * 
     * @type {Array<UpdateUserAccountName200ResponseAvailableMerchantCategoriesInner>}
     * @memberof UpdateUserAccountName200Response
     */
    'availableMerchantCategories': Array<UpdateUserAccountName200ResponseAvailableMerchantCategoriesInner> | null;
    /**
     * 
     * @type {UpdateUserAccountName200ResponseUser}
     * @memberof UpdateUserAccountName200Response
     */
    'user': UpdateUserAccountName200ResponseUser;
    /**
     * 
     * @type {UpdateUserAccountName200ResponseUserAccountGroup}
     * @memberof UpdateUserAccountName200Response
     */
    'userAccountGroup'?: UpdateUserAccountName200ResponseUserAccountGroup | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateUserAccountName200Response
     */
    'monthlyTotalUsage': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateUserAccountName200Response
     */
    'monthlyUsageLimit': number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateUserAccountName200Response
     */
    'dailyTotalUsage': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateUserAccountName200Response
     */
    'dailyUsageLimit': number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateUserAccountName200Response
     */
    'totalUsageAmount': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateUserAccountName200Response
     */
    'totalUsageAmountLimit': number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserAccountName200Response
     */
    'expiredDate': string | null;
}

export const UpdateUserAccountName200ResponseAvailableCurrenciesEnum = {
    jpy: 'JPY',
    usd: 'USD',
    gbp: 'GBP',
    eur: 'EUR',
    sgd: 'SGD',
    aud: 'AUD',
    cny: 'CNY',
    hkd: 'HKD',
    idr: 'IDR',
    krw: 'KRW',
    nzd: 'NZD',
    php: 'PHP',
    rub: 'RUB',
    vnd: 'VND',
    inr: 'INR',
    thb: 'THB',
    lak: 'LAK',
    myr: 'MYR',
    twd: 'TWD',
    chf: 'CHF',
    cad: 'CAD',
    mxn: 'MXN',
    nok: 'NOK',
    huf: 'HUF',
    hrk: 'HRK',
    czk: 'CZK',
    dkk: 'DKK',
    isk: 'ISK',
    mdl: 'MDL',
    sek: 'SEK',
    mkd: 'MKD',
    rsd: 'RSD',
    ron: 'RON',
    bgn: 'BGN',
    bam: 'BAM',
    pln: 'PLN',
    mad: 'MAD',
    zar: 'ZAR',
    rwf: 'RWF',
    kes: 'KES',
    ngn: 'NGN',
    aed: 'AED',
    sar: 'SAR',
    egp: 'EGP',
    qar: 'QAR',
    omr: 'OMR',
    ils: 'ILS',
    try: 'TRY',
    kzt: 'KZT',
    cop: 'COP',
    gtq: 'GTQ'
} as const;

export type UpdateUserAccountName200ResponseAvailableCurrenciesEnum = typeof UpdateUserAccountName200ResponseAvailableCurrenciesEnum[keyof typeof UpdateUserAccountName200ResponseAvailableCurrenciesEnum];

/**
 * 
 * @export
 * @interface UpdateUserAccountName200ResponseAvailableMerchantCategoriesInner
 */
export interface UpdateUserAccountName200ResponseAvailableMerchantCategoriesInner {
    /**
     * 
     * @type {string}
     * @memberof UpdateUserAccountName200ResponseAvailableMerchantCategoriesInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserAccountName200ResponseAvailableMerchantCategoriesInner
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserAccountName200ResponseAvailableMerchantCategoriesInner
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserAccountName200ResponseAvailableMerchantCategoriesInner
     */
    'logoUrl': string;
}
/**
 * 
 * @export
 * @interface UpdateUserAccountName200ResponseUser
 */
export interface UpdateUserAccountName200ResponseUser {
    /**
     * 
     * @type {string}
     * @memberof UpdateUserAccountName200ResponseUser
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserAccountName200ResponseUser
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserAccountName200ResponseUser
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserAccountName200ResponseUser
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserAccountName200ResponseUser
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserAccountName200ResponseUser
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserAccountName200ResponseUser
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserAccountName200ResponseUser
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserAccountName200ResponseUser
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserAccountName200ResponseUser
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserAccountName200ResponseUser
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface UpdateUserAccountName200ResponseUserAccountGroup
 */
export interface UpdateUserAccountName200ResponseUserAccountGroup {
    /**
     * 
     * @type {string}
     * @memberof UpdateUserAccountName200ResponseUserAccountGroup
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserAccountName200ResponseUserAccountGroup
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof UpdateUserAccountName200ResponseUserAccountGroup
     */
    'sortNum': number;
}
/**
 * 
 * @export
 * @interface UpdateUserAccountNameRequest
 */
export interface UpdateUserAccountNameRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateUserAccountNameRequest
     */
    'cardLabel': string;
}
/**
 * 
 * @export
 * @interface UpdateUserEmail400Response
 */
export interface UpdateUserEmail400Response {
    /**
     * 
     * @type {UpdateUserEmail400ResponseErrors}
     * @memberof UpdateUserEmail400Response
     */
    'errors'?: UpdateUserEmail400ResponseErrors;
}
/**
 * 
 * @export
 * @interface UpdateUserEmail400ResponseErrors
 */
export interface UpdateUserEmail400ResponseErrors {
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateUserEmail400ResponseErrors
     */
    'email'?: Array<string>;
}
/**
 * 
 * @export
 * @interface UpdateUserEmailRequest
 */
export interface UpdateUserEmailRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateUserEmailRequest
     */
    'email': string;
}
/**
 * 
 * @export
 * @interface UpdateUserNameRequest
 */
export interface UpdateUserNameRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateUserNameRequest
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface UpdateUserOrganizationRequest
 */
export interface UpdateUserOrganizationRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateUserOrganizationRequest
     */
    'organizationId': number;
}
/**
 * 
 * @export
 * @interface UpdateUserPassword400Response
 */
export interface UpdateUserPassword400Response {
    /**
     * 
     * @type {object}
     * @memberof UpdateUserPassword400Response
     */
    'errors': object;
}
/**
 * 
 * @export
 * @interface UpdateUserPasswordRequest
 */
export interface UpdateUserPasswordRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateUserPasswordRequest
     */
    'currentPassword': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserPasswordRequest
     */
    'newPassword': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserPasswordRequest
     */
    'confirmationPassword': string;
}
/**
 * 
 * @export
 * @interface UpdateUserPrivilegeRequest
 */
export interface UpdateUserPrivilegeRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateUserPrivilegeRequest
     */
    'userPrivilege': UpdateUserPrivilegeRequestUserPrivilegeEnum;
}

export const UpdateUserPrivilegeRequestUserPrivilegeEnum = {
    generalUser: 'GENERAL_USER',
    organizationAdmin: 'ORGANIZATION_ADMIN',
    viewer: 'VIEWER',
    bookkeeper: 'BOOKKEEPER'
} as const;

export type UpdateUserPrivilegeRequestUserPrivilegeEnum = typeof UpdateUserPrivilegeRequestUserPrivilegeEnum[keyof typeof UpdateUserPrivilegeRequestUserPrivilegeEnum];

/**
 * 
 * @export
 * @interface UpdateUserUsageLimit200Response
 */
export interface UpdateUserUsageLimit200Response {
    /**
     * 
     * @type {string}
     * @memberof UpdateUserUsageLimit200Response
     */
    'cardId': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserUsageLimit200Response
     */
    'cardLabel': string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserUsageLimit200Response
     */
    'isActivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserUsageLimit200Response
     */
    'isDeactivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserUsageLimit200Response
     */
    'isLocked': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserUsageLimit200Response
     */
    'isSuspended': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserUsageLimit200Response
     */
    'isFrozen': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserUsageLimit200Response
     */
    'isVirtualCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserUsageLimit200Response
     */
    'isCreditCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserUsageLimit200Response
     */
    'isOnDemand': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserUsageLimit200Response
     */
    'isMetalCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserUsageLimit200Response
     */
    'isPhysicalStorePaymentDisabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserUsageLimit200Response
     */
    'panLastFourDigits': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserUsageLimit200Response
     */
    'userAccountId': string;
    /**
     * 
     * @type {number}
     * @memberof UpdateUserUsageLimit200Response
     */
    'transactionUpperLimit': number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateUserUsageLimit200Response
     */
    'availableCurrencies': Array<UpdateUserUsageLimit200ResponseAvailableCurrenciesEnum>;
    /**
     * 
     * @type {Array<UpdateUserUsageLimit200ResponseAvailableMerchantCategoriesInner>}
     * @memberof UpdateUserUsageLimit200Response
     */
    'availableMerchantCategories': Array<UpdateUserUsageLimit200ResponseAvailableMerchantCategoriesInner> | null;
    /**
     * 
     * @type {UpdateUserUsageLimit200ResponseUser}
     * @memberof UpdateUserUsageLimit200Response
     */
    'user': UpdateUserUsageLimit200ResponseUser;
    /**
     * 
     * @type {UpdateUserUsageLimit200ResponseUserAccountGroup}
     * @memberof UpdateUserUsageLimit200Response
     */
    'userAccountGroup'?: UpdateUserUsageLimit200ResponseUserAccountGroup | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateUserUsageLimit200Response
     */
    'monthlyTotalUsage': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateUserUsageLimit200Response
     */
    'monthlyUsageLimit': number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateUserUsageLimit200Response
     */
    'dailyTotalUsage': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateUserUsageLimit200Response
     */
    'dailyUsageLimit': number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateUserUsageLimit200Response
     */
    'totalUsageAmount': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateUserUsageLimit200Response
     */
    'totalUsageAmountLimit': number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserUsageLimit200Response
     */
    'expiredDate': string | null;
}

export const UpdateUserUsageLimit200ResponseAvailableCurrenciesEnum = {
    jpy: 'JPY',
    usd: 'USD',
    gbp: 'GBP',
    eur: 'EUR',
    sgd: 'SGD',
    aud: 'AUD',
    cny: 'CNY',
    hkd: 'HKD',
    idr: 'IDR',
    krw: 'KRW',
    nzd: 'NZD',
    php: 'PHP',
    rub: 'RUB',
    vnd: 'VND',
    inr: 'INR',
    thb: 'THB',
    lak: 'LAK',
    myr: 'MYR',
    twd: 'TWD',
    chf: 'CHF',
    cad: 'CAD',
    mxn: 'MXN',
    nok: 'NOK',
    huf: 'HUF',
    hrk: 'HRK',
    czk: 'CZK',
    dkk: 'DKK',
    isk: 'ISK',
    mdl: 'MDL',
    sek: 'SEK',
    mkd: 'MKD',
    rsd: 'RSD',
    ron: 'RON',
    bgn: 'BGN',
    bam: 'BAM',
    pln: 'PLN',
    mad: 'MAD',
    zar: 'ZAR',
    rwf: 'RWF',
    kes: 'KES',
    ngn: 'NGN',
    aed: 'AED',
    sar: 'SAR',
    egp: 'EGP',
    qar: 'QAR',
    omr: 'OMR',
    ils: 'ILS',
    try: 'TRY',
    kzt: 'KZT',
    cop: 'COP',
    gtq: 'GTQ'
} as const;

export type UpdateUserUsageLimit200ResponseAvailableCurrenciesEnum = typeof UpdateUserUsageLimit200ResponseAvailableCurrenciesEnum[keyof typeof UpdateUserUsageLimit200ResponseAvailableCurrenciesEnum];

/**
 * 
 * @export
 * @interface UpdateUserUsageLimit200ResponseAvailableMerchantCategoriesInner
 */
export interface UpdateUserUsageLimit200ResponseAvailableMerchantCategoriesInner {
    /**
     * 
     * @type {string}
     * @memberof UpdateUserUsageLimit200ResponseAvailableMerchantCategoriesInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserUsageLimit200ResponseAvailableMerchantCategoriesInner
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserUsageLimit200ResponseAvailableMerchantCategoriesInner
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserUsageLimit200ResponseAvailableMerchantCategoriesInner
     */
    'logoUrl': string;
}
/**
 * 
 * @export
 * @interface UpdateUserUsageLimit200ResponseUser
 */
export interface UpdateUserUsageLimit200ResponseUser {
    /**
     * 
     * @type {string}
     * @memberof UpdateUserUsageLimit200ResponseUser
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserUsageLimit200ResponseUser
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserUsageLimit200ResponseUser
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserUsageLimit200ResponseUser
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserUsageLimit200ResponseUser
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserUsageLimit200ResponseUser
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserUsageLimit200ResponseUser
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserUsageLimit200ResponseUser
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserUsageLimit200ResponseUser
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserUsageLimit200ResponseUser
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserUsageLimit200ResponseUser
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface UpdateUserUsageLimit200ResponseUserAccountGroup
 */
export interface UpdateUserUsageLimit200ResponseUserAccountGroup {
    /**
     * 
     * @type {string}
     * @memberof UpdateUserUsageLimit200ResponseUserAccountGroup
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserUsageLimit200ResponseUserAccountGroup
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof UpdateUserUsageLimit200ResponseUserAccountGroup
     */
    'sortNum': number;
}
/**
 * 
 * @export
 * @interface UpdateUserUsageLimitRequest
 */
export interface UpdateUserUsageLimitRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateUserUsageLimitRequest
     */
    'newUsageLimit': number;
}
/**
 * 
 * @export
 * @interface UploadCardTransactionEvidenceImageRequest
 */
export interface UploadCardTransactionEvidenceImageRequest {
    /**
     * 
     * @type {Array<File>}
     * @memberof UploadCardTransactionEvidenceImageRequest
     */
    'files'?: Array<File>;
    /**
     * 
     * @type {string}
     * @memberof UploadCardTransactionEvidenceImageRequest
     */
    'electronicMethod'?: UploadCardTransactionEvidenceImageRequestElectronicMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof UploadCardTransactionEvidenceImageRequest
     */
    'documentSize'?: UploadCardTransactionEvidenceImageRequestDocumentSizeEnum;
    /**
     * 
     * @type {number}
     * @memberof UploadCardTransactionEvidenceImageRequest
     */
    'heightMillis'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UploadCardTransactionEvidenceImageRequest
     */
    'widthMillis'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UploadCardTransactionEvidenceImageRequest
     */
    'note'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UploadCardTransactionEvidenceImageRequest
     */
    'irrelevantToLedger'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UploadCardTransactionEvidenceImageRequest
     */
    'uploadedByRecipient'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof UploadCardTransactionEvidenceImageRequest
     */
    'uploadedFrom'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UploadCardTransactionEvidenceImageRequest
     */
    'invoiceIssuerName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UploadCardTransactionEvidenceImageRequest
     */
    'invoiceIssuerRegistrationNumber'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UploadCardTransactionEvidenceImageRequest
     */
    'asQualified'?: boolean | null;
}

export const UploadCardTransactionEvidenceImageRequestElectronicMethodEnum = {
    fullElectronic: 'FULL_ELECTRONIC',
    originallyPaper: 'ORIGINALLY_PAPER',
    unknown: 'UNKNOWN'
} as const;

export type UploadCardTransactionEvidenceImageRequestElectronicMethodEnum = typeof UploadCardTransactionEvidenceImageRequestElectronicMethodEnum[keyof typeof UploadCardTransactionEvidenceImageRequestElectronicMethodEnum];
export const UploadCardTransactionEvidenceImageRequestDocumentSizeEnum = {
    overA4: 'OVER_A4',
    a4OrSmaller: 'A4_OR_SMALLER',
    unknown: 'UNKNOWN'
} as const;

export type UploadCardTransactionEvidenceImageRequestDocumentSizeEnum = typeof UploadCardTransactionEvidenceImageRequestDocumentSizeEnum[keyof typeof UploadCardTransactionEvidenceImageRequestDocumentSizeEnum];

/**
 * 
 * @export
 * @interface UploadCorporateDocumentRequest
 */
export interface UploadCorporateDocumentRequest {
    /**
     * 
     * @type {File}
     * @memberof UploadCorporateDocumentRequest
     */
    'file': File;
}
/**
 * @type UploadPaymentRequestEvidenceImage400Response
 * @export
 */
export type UploadPaymentRequestEvidenceImage400Response = UploadPaymentRequestEvidenceImage400ResponseOneOf | UploadPaymentRequestEvidenceImage400ResponseOneOf1;

/**
 * The simplest and standard error response format. Some types of errors may have a detail property in addition to this; since the type of detail depends on the type of error, the schemas are defined separately.
 * @export
 * @interface UploadPaymentRequestEvidenceImage400ResponseOneOf
 */
export interface UploadPaymentRequestEvidenceImage400ResponseOneOf {
    /**
     * 
     * @type {string}
     * @memberof UploadPaymentRequestEvidenceImage400ResponseOneOf
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof UploadPaymentRequestEvidenceImage400ResponseOneOf
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface UploadPaymentRequestEvidenceImage400ResponseOneOf1
 */
export interface UploadPaymentRequestEvidenceImage400ResponseOneOf1 {
    /**
     * Always \"validation-error\"
     * @type {string}
     * @memberof UploadPaymentRequestEvidenceImage400ResponseOneOf1
     */
    'code': string;
    /**
     * Always an empty string
     * @type {string}
     * @memberof UploadPaymentRequestEvidenceImage400ResponseOneOf1
     */
    'message': string;
    /**
     * 
     * @type {Array<UploadPaymentRequestEvidenceImage400ResponseOneOf1DetailInner>}
     * @memberof UploadPaymentRequestEvidenceImage400ResponseOneOf1
     */
    'detail': Array<UploadPaymentRequestEvidenceImage400ResponseOneOf1DetailInner>;
}
/**
 * 
 * @export
 * @interface UploadPaymentRequestEvidenceImage400ResponseOneOf1DetailInner
 */
export interface UploadPaymentRequestEvidenceImage400ResponseOneOf1DetailInner {
    /**
     * 
     * @type {string}
     * @memberof UploadPaymentRequestEvidenceImage400ResponseOneOf1DetailInner
     */
    'name': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UploadPaymentRequestEvidenceImage400ResponseOneOf1DetailInner
     */
    'messages': Array<string>;
}
/**
 * The simplest and standard error response format. Some types of errors may have a detail property in addition to this; since the type of detail depends on the type of error, the schemas are defined separately.
 * @export
 * @interface UploadPaymentRequestEvidenceImage404Response
 */
export interface UploadPaymentRequestEvidenceImage404Response {
    /**
     * 
     * @type {string}
     * @memberof UploadPaymentRequestEvidenceImage404Response
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof UploadPaymentRequestEvidenceImage404Response
     */
    'message': string;
}
/**
 * The simplest and standard error response format. Some types of errors may have a detail property in addition to this; since the type of detail depends on the type of error, the schemas are defined separately.
 * @export
 * @interface UploadPaymentRequestEvidenceImage500Response
 */
export interface UploadPaymentRequestEvidenceImage500Response {
    /**
     * 
     * @type {string}
     * @memberof UploadPaymentRequestEvidenceImage500Response
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof UploadPaymentRequestEvidenceImage500Response
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface UploadPaymentRequestEvidenceImageRequest
 */
export interface UploadPaymentRequestEvidenceImageRequest {
    /**
     * 
     * @type {File}
     * @memberof UploadPaymentRequestEvidenceImageRequest
     */
    'file'?: File;
    /**
     * 
     * @type {string}
     * @memberof UploadPaymentRequestEvidenceImageRequest
     */
    'electronicMethod'?: UploadPaymentRequestEvidenceImageRequestElectronicMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof UploadPaymentRequestEvidenceImageRequest
     */
    'documentSize'?: UploadPaymentRequestEvidenceImageRequestDocumentSizeEnum;
    /**
     * 
     * @type {number}
     * @memberof UploadPaymentRequestEvidenceImageRequest
     */
    'heightMillis'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UploadPaymentRequestEvidenceImageRequest
     */
    'widthMillis'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UploadPaymentRequestEvidenceImageRequest
     */
    'note'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UploadPaymentRequestEvidenceImageRequest
     */
    'irrelevantToLedger'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UploadPaymentRequestEvidenceImageRequest
     */
    'uploadedByRecipient'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof UploadPaymentRequestEvidenceImageRequest
     */
    'uploadedFrom'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UploadPaymentRequestEvidenceImageRequest
     */
    'invoiceIssuerName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UploadPaymentRequestEvidenceImageRequest
     */
    'invoiceIssuerRegistrationNumber'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UploadPaymentRequestEvidenceImageRequest
     */
    'asQualified'?: boolean | null;
}

export const UploadPaymentRequestEvidenceImageRequestElectronicMethodEnum = {
    fullElectronic: 'FULL_ELECTRONIC',
    originallyPaper: 'ORIGINALLY_PAPER',
    unknown: 'UNKNOWN'
} as const;

export type UploadPaymentRequestEvidenceImageRequestElectronicMethodEnum = typeof UploadPaymentRequestEvidenceImageRequestElectronicMethodEnum[keyof typeof UploadPaymentRequestEvidenceImageRequestElectronicMethodEnum];
export const UploadPaymentRequestEvidenceImageRequestDocumentSizeEnum = {
    overA4: 'OVER_A4',
    a4OrSmaller: 'A4_OR_SMALLER',
    unknown: 'UNKNOWN'
} as const;

export type UploadPaymentRequestEvidenceImageRequestDocumentSizeEnum = typeof UploadPaymentRequestEvidenceImageRequestDocumentSizeEnum[keyof typeof UploadPaymentRequestEvidenceImageRequestDocumentSizeEnum];

/**
 * 
 * @export
 * @interface UsageFee
 */
export interface UsageFee {
    /**
     * 
     * @type {string}
     * @memberof UsageFee
     */
    'usageFeeId': string;
    /**
     * 
     * @type {number}
     * @memberof UsageFee
     */
    'yearMonth': number;
    /**
     * 
     * @type {string}
     * @memberof UsageFee
     */
    'scheduledPaymentDate': string;
    /**
     * 
     * @type {string}
     * @memberof UsageFee
     */
    'paymentDate': string | null;
    /**
     * 
     * @type {string}
     * @memberof UsageFee
     */
    'paymentType': UsageFeePaymentTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof UsageFee
     */
    'totalAmount': number;
    /**
     * 
     * @type {number}
     * @memberof UsageFee
     */
    'pointAmount': number;
    /**
     * 
     * @type {number}
     * @memberof UsageFee
     */
    'billsNum': number;
    /**
     * 
     * @type {number}
     * @memberof UsageFee
     */
    'unitPrice': number;
    /**
     * 
     * @type {number}
     * @memberof UsageFee
     */
    'transferAgencyFeeAmount': number;
    /**
     * 
     * @type {number}
     * @memberof UsageFee
     */
    'discountQuota': number;
    /**
     * 
     * @type {number}
     * @memberof UsageFee
     */
    'discountedNum': number;
    /**
     * 
     * @type {number}
     * @memberof UsageFee
     */
    'discountUnitPrice': number;
    /**
     * 
     * @type {number}
     * @memberof UsageFee
     */
    'discountedAmount': number;
    /**
     * 
     * @type {number}
     * @memberof UsageFee
     */
    'cardsNum': number;
    /**
     * 
     * @type {number}
     * @memberof UsageFee
     */
    'cardUnitPrice': number;
    /**
     * 
     * @type {number}
     * @memberof UsageFee
     */
    'cardUsageFeeAmount': number;
    /**
     * 
     * @type {number}
     * @memberof UsageFee
     */
    'cardDiscountedNum': number;
    /**
     * 
     * @type {number}
     * @memberof UsageFee
     */
    'cardDiscountUnitPrice': number;
    /**
     * 
     * @type {number}
     * @memberof UsageFee
     */
    'cardDiscountedAmount': number;
    /**
     * 
     * @type {number}
     * @memberof UsageFee
     */
    'virtualCardsNum': number;
    /**
     * 
     * @type {number}
     * @memberof UsageFee
     */
    'virtualCardUnitPrice': number;
    /**
     * 
     * @type {number}
     * @memberof UsageFee
     */
    'virtualCardUsageFeeAmount': number;
    /**
     * 
     * @type {number}
     * @memberof UsageFee
     */
    'virtualCardDiscountedNum': number;
    /**
     * 
     * @type {number}
     * @memberof UsageFee
     */
    'virtualCardDiscountUnitPrice': number;
    /**
     * 
     * @type {number}
     * @memberof UsageFee
     */
    'virtualCardDiscountedAmount': number;
    /**
     * 
     * @type {number}
     * @memberof UsageFee
     */
    'subTotal': number;
    /**
     * 
     * @type {number}
     * @memberof UsageFee
     */
    'salesTaxAmount': number;
    /**
     * 
     * @type {UsageFeeLatestStatus}
     * @memberof UsageFee
     */
    'latestStatus': UsageFeeLatestStatus;
    /**
     * 
     * @type {Array<UsageFeeBillsInner>}
     * @memberof UsageFee
     */
    'bills': Array<UsageFeeBillsInner>;
    /**
     * 
     * @type {boolean}
     * @memberof UsageFee
     */
    'isCardUsageFeeWaived': boolean;
}

export const UsageFeePaymentTypeEnum = {
    payBill: 'PAY_BILL',
    usageFee: 'USAGE_FEE',
    card: 'CARD'
} as const;

export type UsageFeePaymentTypeEnum = typeof UsageFeePaymentTypeEnum[keyof typeof UsageFeePaymentTypeEnum];

/**
 * 
 * @export
 * @interface UsageFeeBillsInner
 */
export interface UsageFeeBillsInner {
    /**
     * 
     * @type {string}
     * @memberof UsageFeeBillsInner
     */
    'billId': string;
    /**
     * 
     * @type {string}
     * @memberof UsageFeeBillsInner
     */
    'bankAccountActivityId': string;
    /**
     * 
     * @type {string}
     * @memberof UsageFeeBillsInner
     */
    'supplierName': string;
    /**
     * 
     * @type {string}
     * @memberof UsageFeeBillsInner
     */
    'latestStatus': UsageFeeBillsInnerLatestStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof UsageFeeBillsInner
     */
    'amount': number;
    /**
     * 
     * @type {string}
     * @memberof UsageFeeBillsInner
     */
    'appliedAt': string;
    /**
     * 
     * @type {string}
     * @memberof UsageFeeBillsInner
     */
    'transferDate': string;
}

export const UsageFeeBillsInnerLatestStatusEnum = {
    reserved: 'RESERVED',
    requestingExternalAccountTransfer: 'REQUESTING_EXTERNAL_ACCOUNT_TRANSFER',
    completed: 'COMPLETED',
    insufficientBalance: 'INSUFFICIENT_BALANCE',
    uploaded: 'UPLOADED',
    readCompleted: 'READ_COMPLETED',
    awaitingApproval: 'AWAITING_APPROVAL',
    approved: 'APPROVED',
    transferCompleted: 'TRANSFER_COMPLETED',
    readError: 'READ_ERROR',
    transferFailed: 'TRANSFER_FAILED',
    approvalExpired: 'APPROVAL_EXPIRED',
    approvalRejected: 'APPROVAL_REJECTED',
    otherError: 'OTHER_ERROR',
    pending: 'PENDING'
} as const;

export type UsageFeeBillsInnerLatestStatusEnum = typeof UsageFeeBillsInnerLatestStatusEnum[keyof typeof UsageFeeBillsInnerLatestStatusEnum];

/**
 * 
 * @export
 * @interface UsageFeeLatestStatus
 */
export interface UsageFeeLatestStatus {
    /**
     * 
     * @type {string}
     * @memberof UsageFeeLatestStatus
     */
    'status': UsageFeeLatestStatusStatusEnum;
}

export const UsageFeeLatestStatusStatusEnum = {
    reserved: 'RESERVED',
    requestingExternalAccountTransfer: 'REQUESTING_EXTERNAL_ACCOUNT_TRANSFER',
    completed: 'COMPLETED',
    insufficientBalance: 'INSUFFICIENT_BALANCE',
    transferReceivable: 'TRANSFER_RECEIVABLE'
} as const;

export type UsageFeeLatestStatusStatusEnum = typeof UsageFeeLatestStatusStatusEnum[keyof typeof UsageFeeLatestStatusStatusEnum];

/**
 * 
 * @export
 * @interface UsageFeeStatus
 */
export interface UsageFeeStatus {
    /**
     * 
     * @type {string}
     * @memberof UsageFeeStatus
     */
    'status': UsageFeeStatusStatusEnum;
}

export const UsageFeeStatusStatusEnum = {
    reserved: 'RESERVED',
    requestingExternalAccountTransfer: 'REQUESTING_EXTERNAL_ACCOUNT_TRANSFER',
    completed: 'COMPLETED',
    insufficientBalance: 'INSUFFICIENT_BALANCE',
    transferReceivable: 'TRANSFER_RECEIVABLE'
} as const;

export type UsageFeeStatusStatusEnum = typeof UsageFeeStatusStatusEnum[keyof typeof UsageFeeStatusStatusEnum];

/**
 * 
 * @export
 * @interface User
 */
export interface User {
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface UserAccountGroup
 */
export interface UserAccountGroup {
    /**
     * 
     * @type {string}
     * @memberof UserAccountGroup
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof UserAccountGroup
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof UserAccountGroup
     */
    'sortNum': number;
}
/**
 * 
 * @export
 * @interface UserAccountLight
 */
export interface UserAccountLight {
    /**
     * 
     * @type {string}
     * @memberof UserAccountLight
     */
    'userAccountId': string;
    /**
     * 
     * @type {UserAccountLightUser}
     * @memberof UserAccountLight
     */
    'user': UserAccountLightUser;
    /**
     * 
     * @type {string}
     * @memberof UserAccountLight
     */
    'cardLabel': string;
    /**
     * 
     * @type {string}
     * @memberof UserAccountLight
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof UserAccountLight
     */
    'organizationName': string;
    /**
     * 
     * @type {UserAccountLightUserAccountGroup}
     * @memberof UserAccountLight
     */
    'userAccountGroup': UserAccountLightUserAccountGroup | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserAccountLight
     */
    'isOnDemand': boolean;
}
/**
 * 
 * @export
 * @interface UserAccountLightUser
 */
export interface UserAccountLightUser {
    /**
     * 
     * @type {string}
     * @memberof UserAccountLightUser
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof UserAccountLightUser
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof UserAccountLightUser
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof UserAccountLightUser
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof UserAccountLightUser
     */
    'unauthenticatedEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserAccountLightUser
     */
    'isOrganizationAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserAccountLightUser
     */
    'isGeneralUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserAccountLightUser
     */
    'isViewer': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserAccountLightUser
     */
    'isBookkeeper': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserAccountLightUser
     */
    'isTempPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof UserAccountLightUser
     */
    'twoFactorAuthRegisterStatus': string;
}
/**
 * 
 * @export
 * @interface UserAccountLightUserAccountGroup
 */
export interface UserAccountLightUserAccountGroup {
    /**
     * 
     * @type {string}
     * @memberof UserAccountLightUserAccountGroup
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof UserAccountLightUserAccountGroup
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof UserAccountLightUserAccountGroup
     */
    'sortNum': number;
}
/**
 * 
 * @export
 * @interface UserAccountModifiableLimits
 */
export interface UserAccountModifiableLimits {
    /**
     * 
     * @type {string}
     * @memberof UserAccountModifiableLimits
     */
    'userAccountId': string;
    /**
     * 
     * @type {string}
     * @memberof UserAccountModifiableLimits
     */
    'limitType': UserAccountModifiableLimitsLimitTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof UserAccountModifiableLimits
     */
    'limit': number | null;
}

export const UserAccountModifiableLimitsLimitTypeEnum = {
    dailyLimit: 'DAILY_LIMIT',
    monthlyLimit: 'MONTHLY_LIMIT',
    transactionLimit: 'TRANSACTION_LIMIT'
} as const;

export type UserAccountModifiableLimitsLimitTypeEnum = typeof UserAccountModifiableLimitsLimitTypeEnum[keyof typeof UserAccountModifiableLimitsLimitTypeEnum];

/**
 * 
 * @export
 * @interface UserLight
 */
export interface UserLight {
    /**
     * 
     * @type {string}
     * @memberof UserLight
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof UserLight
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface UserRoleResource
 */
export interface UserRoleResource {
    /**
     * 
     * @type {string}
     * @memberof UserRoleResource
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof UserRoleResource
     */
    'resourceScope': UserRoleResourceResourceScopeEnum;
    /**
     * 
     * @type {string}
     * @memberof UserRoleResource
     */
    'resourceId': string;
    /**
     * 
     * @type {string}
     * @memberof UserRoleResource
     */
    'role': UserRoleResourceRoleEnum;
}

export const UserRoleResourceResourceScopeEnum = {
    account: 'USER_ACCOUNT',
    accountGroup: 'USER_ACCOUNT_GROUP',
    accountAll: 'USER_ACCOUNT_ALL'
} as const;

export type UserRoleResourceResourceScopeEnum = typeof UserRoleResourceResourceScopeEnum[keyof typeof UserRoleResourceResourceScopeEnum];
export const UserRoleResourceRoleEnum = {
    admin: 'USER_ACCOUNT_ADMIN',
    assist: 'USER_ACCOUNT_ASSIST'
} as const;

export type UserRoleResourceRoleEnum = typeof UserRoleResourceRoleEnum[keyof typeof UserRoleResourceRoleEnum];

/**
 * 
 * @export
 * @enum {string}
 */

export const UserRoleResourceRole = {
    admin: 'USER_ACCOUNT_ADMIN',
    assist: 'USER_ACCOUNT_ASSIST'
} as const;

export type UserRoleResourceRole = typeof UserRoleResourceRole[keyof typeof UserRoleResourceRole];


/**
 * 
 * @export
 * @enum {string}
 */

export const UserRoleResourceScope = {
    account: 'USER_ACCOUNT',
    accountGroup: 'USER_ACCOUNT_GROUP',
    accountAll: 'USER_ACCOUNT_ALL'
} as const;

export type UserRoleResourceScope = typeof UserRoleResourceScope[keyof typeof UserRoleResourceScope];


/**
 * 
 * @export
 * @interface UsersEmailConfirm200Response
 */
export interface UsersEmailConfirm200Response {
    /**
     * 
     * @type {string}
     * @memberof UsersEmailConfirm200Response
     */
    'email': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UsersEmailConfirm200Response
     */
    'valid': boolean;
    /**
     * 
     * @type {string}
     * @memberof UsersEmailConfirm200Response
     */
    'errorMessage': string | null;
}
/**
 * 
 * @export
 * @interface UsersEmailConfirmRequest
 */
export interface UsersEmailConfirmRequest {
    /**
     * 
     * @type {string}
     * @memberof UsersEmailConfirmRequest
     */
    'token': string;
}
/**
 * 
 * @export
 * @interface VerifyMoneytreeConnections200Response
 */
export interface VerifyMoneytreeConnections200Response {
    /**
     * 
     * @type {string}
     * @memberof VerifyMoneytreeConnections200Response
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof VerifyMoneytreeConnections200Response
     */
    'email'?: string;
}

/**
 * DefaultApi - axios parameter creator
 * @export
 */
export const DefaultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add comment for card transaction
         * @param {string} organizationId 
         * @param {string} paymentReferenceId 
         * @param {AddCommentRequest} addCommentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addComment: async (organizationId: string, paymentReferenceId: string, addCommentRequest: AddCommentRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('addComment', 'organizationId', organizationId)
            // verify required parameter 'paymentReferenceId' is not null or undefined
            assertParamExists('addComment', 'paymentReferenceId', paymentReferenceId)
            // verify required parameter 'addCommentRequest' is not null or undefined
            assertParamExists('addComment', 'addCommentRequest', addCommentRequest)
            const localVarPath = `/organizations/{organizationId}/cards/transactions/{paymentReferenceId}/comment`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"paymentReferenceId"}}`, encodeURIComponent(String(paymentReferenceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addCommentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add Organization Create Request
         * @param {AddOrganizationCreateRequestRequest} addOrganizationCreateRequestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addOrganizationCreateRequest: async (addOrganizationCreateRequestRequest: AddOrganizationCreateRequestRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'addOrganizationCreateRequestRequest' is not null or undefined
            assertParamExists('addOrganizationCreateRequest', 'addOrganizationCreateRequestRequest', addOrganizationCreateRequestRequest)
            const localVarPath = `/organization_create_requests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addOrganizationCreateRequestRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary add point to organization
         * @param {string} organizationId 
         * @param {AddPointToOrganizationRequest} addPointToOrganizationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addPointToOrganization: async (organizationId: string, addPointToOrganizationRequest: AddPointToOrganizationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('addPointToOrganization', 'organizationId', organizationId)
            // verify required parameter 'addPointToOrganizationRequest' is not null or undefined
            assertParamExists('addPointToOrganization', 'addPointToOrganizationRequest', addPointToOrganizationRequest)
            const localVarPath = `/organizations/{organizationId}/give_points`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addPointToOrganizationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Agree to the agreement request
         * @param {string} organizationId 
         * @param {string} agreementRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agreeToAgreementRequest: async (organizationId: string, agreementRequestId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('agreeToAgreementRequest', 'organizationId', organizationId)
            // verify required parameter 'agreementRequestId' is not null or undefined
            assertParamExists('agreeToAgreementRequest', 'agreementRequestId', agreementRequestId)
            const localVarPath = `/organizations/{organizationId}/agreement_requests/{agreementRequestId}/agree`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"agreementRequestId"}}`, encodeURIComponent(String(agreementRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Analyze evidence
         * @param {string} organizationId 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analyzeEvidence: async (organizationId: string, file?: File, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('analyzeEvidence', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/evidences/analyze`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Analyze invoice of payment requests
         * @param {string} organizationId 
         * @param {File} file 
         * @param {string} [xUpsidrSwitchUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analyzeInvoiceOfPaymentRequests: async (organizationId: string, file: File, xUpsidrSwitchUser?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('analyzeInvoiceOfPaymentRequests', 'organizationId', organizationId)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('analyzeInvoiceOfPaymentRequests', 'file', file)
            const localVarPath = `/organizations/{organizationId}/payment_requests/invoice_analyze`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xUpsidrSwitchUser != null) {
                localVarHeaderParameter['X-Upsidr-Switch-User'] = String(xUpsidrSwitchUser);
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Approve organization identity verification
         * @param {number} organizationIdentityVerificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveOrganizationIdentityVerification: async (organizationIdentityVerificationId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationIdentityVerificationId' is not null or undefined
            assertParamExists('approveOrganizationIdentityVerification', 'organizationIdentityVerificationId', organizationIdentityVerificationId)
            const localVarPath = `/organization_identity_verifications/{organizationIdentityVerificationId}/approve`
                .replace(`{${"organizationIdentityVerificationId"}}`, encodeURIComponent(String(organizationIdentityVerificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Approve purchase application.
         * @param {string} organizationId 
         * @param {string} purchaseApplicationId 
         * @param {ApprovePurchaseApplicationRequest} approvePurchaseApplicationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approvePurchaseApplication: async (organizationId: string, purchaseApplicationId: string, approvePurchaseApplicationRequest: ApprovePurchaseApplicationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('approvePurchaseApplication', 'organizationId', organizationId)
            // verify required parameter 'purchaseApplicationId' is not null or undefined
            assertParamExists('approvePurchaseApplication', 'purchaseApplicationId', purchaseApplicationId)
            // verify required parameter 'approvePurchaseApplicationRequest' is not null or undefined
            assertParamExists('approvePurchaseApplication', 'approvePurchaseApplicationRequest', approvePurchaseApplicationRequest)
            const localVarPath = `/organizations/{organizationId}/purchase_applications/{purchaseApplicationId}/approve`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"purchaseApplicationId"}}`, encodeURIComponent(String(purchaseApplicationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(approvePurchaseApplicationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Approve workflow step of payment request
         * @param {string} organizationId 
         * @param {string} [xUpsidrSwitchUser] 
         * @param {ApproveWorkflowStepPaymentRequestsRequest} [approveWorkflowStepPaymentRequestsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveWorkflowStepPaymentRequests: async (organizationId: string, xUpsidrSwitchUser?: string, approveWorkflowStepPaymentRequestsRequest?: ApproveWorkflowStepPaymentRequestsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('approveWorkflowStepPaymentRequests', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/payment_requests/approve`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xUpsidrSwitchUser != null) {
                localVarHeaderParameter['X-Upsidr-Switch-User'] = String(xUpsidrSwitchUser);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(approveWorkflowStepPaymentRequestsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Automatically journalize deals from rules
         * @param {string} organizationId 
         * @param {string} companyId 
         * @param {AutomaticallyJournalizeDealsFromRulesRequest} automaticallyJournalizeDealsFromRulesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        automaticallyJournalizeDealsFromRules: async (organizationId: string, companyId: string, automaticallyJournalizeDealsFromRulesRequest: AutomaticallyJournalizeDealsFromRulesRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('automaticallyJournalizeDealsFromRules', 'organizationId', organizationId)
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('automaticallyJournalizeDealsFromRules', 'companyId', companyId)
            // verify required parameter 'automaticallyJournalizeDealsFromRulesRequest' is not null or undefined
            assertParamExists('automaticallyJournalizeDealsFromRules', 'automaticallyJournalizeDealsFromRulesRequest', automaticallyJournalizeDealsFromRulesRequest)
            const localVarPath = `/organizations/{organizationId}/freee/{companyId}/journalize_from_rules`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(automaticallyJournalizeDealsFromRulesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Bank Account Activities Withdrawal Reserve
         * @param {BankAccountActivitiesWithdrawalReserveRequest} bankAccountActivitiesWithdrawalReserveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bankAccountActivitiesWithdrawalReserve: async (bankAccountActivitiesWithdrawalReserveRequest: BankAccountActivitiesWithdrawalReserveRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bankAccountActivitiesWithdrawalReserveRequest' is not null or undefined
            assertParamExists('bankAccountActivitiesWithdrawalReserve', 'bankAccountActivitiesWithdrawalReserveRequest', bankAccountActivitiesWithdrawalReserveRequest)
            const localVarPath = `/bank_account_activities/withdrawal/reserve`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bankAccountActivitiesWithdrawalReserveRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Disable daily usage limit for an user account
         * @param {BulkDisableDailyUserUsageLimitRequest} bulkDisableDailyUserUsageLimitRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkDisableDailyUserUsageLimit: async (bulkDisableDailyUserUsageLimitRequest: BulkDisableDailyUserUsageLimitRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkDisableDailyUserUsageLimitRequest' is not null or undefined
            assertParamExists('bulkDisableDailyUserUsageLimit', 'bulkDisableDailyUserUsageLimitRequest', bulkDisableDailyUserUsageLimitRequest)
            const localVarPath = `/user_accounts/disable_daily_usage_limit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkDisableDailyUserUsageLimitRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Bulk disable monthly usage limit
         * @param {BulkDisableMonthlyUsageLimitRequest} bulkDisableMonthlyUsageLimitRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkDisableMonthlyUsageLimit: async (bulkDisableMonthlyUsageLimitRequest: BulkDisableMonthlyUsageLimitRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkDisableMonthlyUsageLimitRequest' is not null or undefined
            assertParamExists('bulkDisableMonthlyUsageLimit', 'bulkDisableMonthlyUsageLimitRequest', bulkDisableMonthlyUsageLimitRequest)
            const localVarPath = `/user_accounts/disable_usage_limit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkDisableMonthlyUsageLimitRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Bulk update daily usage limit
         * @param {BulkUpdateDailyUsageLimitRequest} bulkUpdateDailyUsageLimitRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkUpdateDailyUsageLimit: async (bulkUpdateDailyUsageLimitRequest: BulkUpdateDailyUsageLimitRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkUpdateDailyUsageLimitRequest' is not null or undefined
            assertParamExists('bulkUpdateDailyUsageLimit', 'bulkUpdateDailyUsageLimitRequest', bulkUpdateDailyUsageLimitRequest)
            const localVarPath = `/user_accounts/update_daily_usage_limit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkUpdateDailyUsageLimitRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Bulk update monthly usage limit
         * @param {BulkUpdateMonthlyUsageLimitRequest} bulkUpdateMonthlyUsageLimitRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkUpdateMonthlyUsageLimit: async (bulkUpdateMonthlyUsageLimitRequest: BulkUpdateMonthlyUsageLimitRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkUpdateMonthlyUsageLimitRequest' is not null or undefined
            assertParamExists('bulkUpdateMonthlyUsageLimit', 'bulkUpdateMonthlyUsageLimitRequest', bulkUpdateMonthlyUsageLimitRequest)
            const localVarPath = `/user_accounts/update_usage_limit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkUpdateMonthlyUsageLimitRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Bulk Update Organization User Privileges
         * @param {string} organizationId 
         * @param {BulkUpdateOrganizationUserPrivilegesRequest} bulkUpdateOrganizationUserPrivilegesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkUpdateOrganizationUserPrivileges: async (organizationId: string, bulkUpdateOrganizationUserPrivilegesRequest: BulkUpdateOrganizationUserPrivilegesRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('bulkUpdateOrganizationUserPrivileges', 'organizationId', organizationId)
            // verify required parameter 'bulkUpdateOrganizationUserPrivilegesRequest' is not null or undefined
            assertParamExists('bulkUpdateOrganizationUserPrivileges', 'bulkUpdateOrganizationUserPrivilegesRequest', bulkUpdateOrganizationUserPrivilegesRequest)
            const localVarPath = `/organizations/user_privilege/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkUpdateOrganizationUserPrivilegesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Cancel draft payment request
         * @param {string} organizationId 
         * @param {string} draftPaymentRequestId 
         * @param {string} [xUpsidrSwitchUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelDraftPaymentRequest: async (organizationId: string, draftPaymentRequestId: string, xUpsidrSwitchUser?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('cancelDraftPaymentRequest', 'organizationId', organizationId)
            // verify required parameter 'draftPaymentRequestId' is not null or undefined
            assertParamExists('cancelDraftPaymentRequest', 'draftPaymentRequestId', draftPaymentRequestId)
            const localVarPath = `/organizations/{organizationId}/payment_requests/drafts/{draftPaymentRequestId}/cancel`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"draftPaymentRequestId"}}`, encodeURIComponent(String(draftPaymentRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xUpsidrSwitchUser != null) {
                localVarHeaderParameter['X-Upsidr-Switch-User'] = String(xUpsidrSwitchUser);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Cancel payment request
         * @param {string} organizationId 
         * @param {string} paymentRequestId 
         * @param {string} [xUpsidrSwitchUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelPaymentRequest: async (organizationId: string, paymentRequestId: string, xUpsidrSwitchUser?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('cancelPaymentRequest', 'organizationId', organizationId)
            // verify required parameter 'paymentRequestId' is not null or undefined
            assertParamExists('cancelPaymentRequest', 'paymentRequestId', paymentRequestId)
            const localVarPath = `/organizations/{organizationId}/payment_requests/{paymentRequestId}/cancel`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"paymentRequestId"}}`, encodeURIComponent(String(paymentRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xUpsidrSwitchUser != null) {
                localVarHeaderParameter['X-Upsidr-Switch-User'] = String(xUpsidrSwitchUser);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Change Identity Verification Scheduled Date
         * @param {string} organizationId 
         * @param {ChangeIdentityVerificationScheduledDateRequest} changeIdentityVerificationScheduledDateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeIdentityVerificationScheduledDate: async (organizationId: string, changeIdentityVerificationScheduledDateRequest: ChangeIdentityVerificationScheduledDateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('changeIdentityVerificationScheduledDate', 'organizationId', organizationId)
            // verify required parameter 'changeIdentityVerificationScheduledDateRequest' is not null or undefined
            assertParamExists('changeIdentityVerificationScheduledDate', 'changeIdentityVerificationScheduledDateRequest', changeIdentityVerificationScheduledDateRequest)
            const localVarPath = `/organizations/{organizationId}/identity_verification_scheduled_date`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changeIdentityVerificationScheduledDateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Change Invoice Email
         * @param {string} organizationId 
         * @param {ChangeInvoiceEmailRequest} changeInvoiceEmailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeInvoiceEmail: async (organizationId: string, changeInvoiceEmailRequest: ChangeInvoiceEmailRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('changeInvoiceEmail', 'organizationId', organizationId)
            // verify required parameter 'changeInvoiceEmailRequest' is not null or undefined
            assertParamExists('changeInvoiceEmail', 'changeInvoiceEmailRequest', changeInvoiceEmailRequest)
            const localVarPath = `/organizations/{organizationId}/change_invoice_email`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changeInvoiceEmailRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Change to the specified ekyc result
         * @param {string} identificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeToTheSpecifiedEkycResult: async (identificationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identificationId' is not null or undefined
            assertParamExists('changeToTheSpecifiedEkycResult', 'identificationId', identificationId)
            const localVarPath = `/organization_identity_verifications/identifications/{identificationId}/result`
                .replace(`{${"identificationId"}}`, encodeURIComponent(String(identificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Check Already Registered Phone Number
         * @param {CheckAlreadyRegisteredPhoneNumberRequest} checkAlreadyRegisteredPhoneNumberRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkAlreadyRegisteredPhoneNumber: async (checkAlreadyRegisteredPhoneNumberRequest: CheckAlreadyRegisteredPhoneNumberRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'checkAlreadyRegisteredPhoneNumberRequest' is not null or undefined
            assertParamExists('checkAlreadyRegisteredPhoneNumber', 'checkAlreadyRegisteredPhoneNumberRequest', checkAlreadyRegisteredPhoneNumberRequest)
            const localVarPath = `/two_factor_auth/sms/check_already_registered_phone_number`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checkAlreadyRegisteredPhoneNumberRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Check All Organization Available Limit And Notify
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkAvailableLimit: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/organizations/check_available_limit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Check duplicate email addresses
         * @param {Array<string>} [emailAddresses] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkDuplicateEmailAddresses: async (emailAddresses?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/organization_create_requests/check_duplicate_email_addresses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (emailAddresses) {
                localVarQueryParameter['emailAddresses[]'] = emailAddresses;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkMonthlyUsageLimit: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/cards/check_monthly_usage_limit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * It is an API that waits for a redirect after the payment request fix button is pressed in the Slack App. This API does three things:   - Slack message modification - remove each button attached to the original message   - Post messages to Slack - communicate the fact that the edit button was pressed   - Create payment request for draft data
         * @summary Complete redirect from slack
         * @param {string} organizationId 
         * @param {CompleteRedirectFromSlackRequest} [completeRedirectFromSlackRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeRedirectFromSlack: async (organizationId: string, completeRedirectFromSlackRequest?: CompleteRedirectFromSlackRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('completeRedirectFromSlack', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/payment_requests/complete_redirect`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(completeRedirectFromSlackRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Count deals
         * @param {string} organizationId 
         * @param {CountDealsRequest} [countDealsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countDeals: async (organizationId: string, countDealsRequest?: CountDealsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('countDeals', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/count_deals`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(countDealsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create bank transfers for the specified payment requests.
         * @summary Create bank transfers
         * @param {string} organizationId 
         * @param {CreateBankTransfersRequest} createBankTransfersRequest 
         * @param {string} [transferDateJstFrom] yyyy-MM-dd format date in JST. Filter the bank transfers to be returned to only those which are scheduled to be transferred after this date.
         * @param {string} [transferDateJstTo] yyyy-MM-dd format date in JST. Filter the bank transfers to be returned to only those which are scheduled to be transferred before this date. Both transferDateJstFrom and transferDateJstTo are inclusive (closed interval).
         * @param {string} [sourceBankAccountId] Filter the bank transfers by the specified source bank account id.
         * @param {boolean} [downloaded] Filter the bank transfers by whether the corresponding transfer data has been downloaded.
         * @param {number} [limit] 
         * @param {number} [offset] See the description of &#x60;cursor&#x60; section Pagination
         * @param {string} [cursor] Pagination is performed by specifying either offset or cursor; if neither offset nor cursor is specified, it is assumed to be cursor-pagination and the first page is obtained with the next cursor. See below how the pagination exactly behaves:  - \&quot;\&quot; ... Get the fist page and return the next cursor  - \&quot;offset&#x3D;50\&quot; ... Get from the specified offset and never return the next cursor  - \&quot;cursor&#x3D;xxx\&quot; ... Get from the specified cursor  - \&quot;offset&#x3D;50&amp;cursor&#x3D;xxx\&quot; ... Ignore the offset and get from the specified cursor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBankTransfers: async (organizationId: string, createBankTransfersRequest: CreateBankTransfersRequest, transferDateJstFrom?: string, transferDateJstTo?: string, sourceBankAccountId?: string, downloaded?: boolean, limit?: number, offset?: number, cursor?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createBankTransfers', 'organizationId', organizationId)
            // verify required parameter 'createBankTransfersRequest' is not null or undefined
            assertParamExists('createBankTransfers', 'createBankTransfersRequest', createBankTransfersRequest)
            const localVarPath = `/organizations/{organizationId}/payment_requests/bank_transfers`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (transferDateJstFrom !== undefined) {
                localVarQueryParameter['transferDateJstFrom'] = transferDateJstFrom;
            }

            if (transferDateJstTo !== undefined) {
                localVarQueryParameter['transferDateJstTo'] = transferDateJstTo;
            }

            if (sourceBankAccountId !== undefined) {
                localVarQueryParameter['sourceBankAccountId'] = sourceBankAccountId;
            }

            if (downloaded !== undefined) {
                localVarQueryParameter['downloaded'] = downloaded;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createBankTransfersRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create category of the purchase application template.
         * @param {string} organizationId 
         * @param {CreateCategoryOfThePurchaseApplicationTemplateRequest} createCategoryOfThePurchaseApplicationTemplateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCategoryOfThePurchaseApplicationTemplate: async (organizationId: string, createCategoryOfThePurchaseApplicationTemplateRequest: CreateCategoryOfThePurchaseApplicationTemplateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createCategoryOfThePurchaseApplicationTemplate', 'organizationId', organizationId)
            // verify required parameter 'createCategoryOfThePurchaseApplicationTemplateRequest' is not null or undefined
            assertParamExists('createCategoryOfThePurchaseApplicationTemplate', 'createCategoryOfThePurchaseApplicationTemplateRequest', createCategoryOfThePurchaseApplicationTemplateRequest)
            const localVarPath = `/organizations/{organizationId}/purchase_applications/templates/category/submit`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCategoryOfThePurchaseApplicationTemplateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create comment template
         * @param {string} organizationId 
         * @param {CreateCommentTemplateRequest} createCommentTemplateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCommentTemplate: async (organizationId: string, createCommentTemplateRequest: CreateCommentTemplateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createCommentTemplate', 'organizationId', organizationId)
            // verify required parameter 'createCommentTemplateRequest' is not null or undefined
            assertParamExists('createCommentTemplate', 'createCommentTemplateRequest', createCommentTemplateRequest)
            const localVarPath = `/organizations/{organizationId}/user_accounts/comment_templates`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCommentTemplateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create deposit restriction for organization
         * @param {string} organizationId 
         * @param {CreateDepositRestrictionForOrganizationRequest} createDepositRestrictionForOrganizationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDepositRestrictionForOrganization: async (organizationId: string, createDepositRestrictionForOrganizationRequest: CreateDepositRestrictionForOrganizationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createDepositRestrictionForOrganization', 'organizationId', organizationId)
            // verify required parameter 'createDepositRestrictionForOrganizationRequest' is not null or undefined
            assertParamExists('createDepositRestrictionForOrganization', 'createDepositRestrictionForOrganizationRequest', createDepositRestrictionForOrganizationRequest)
            const localVarPath = `/organizations/{organizationId}/deposit_restrictions`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createDepositRestrictionForOrganizationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create draft of payment request
         * @param {string} organizationId 
         * @param {string} [xUpsidrSwitchUser] 
         * @param {CreateDraftOfPaymentRequestsRequest} [createDraftOfPaymentRequestsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDraftOfPaymentRequests: async (organizationId: string, xUpsidrSwitchUser?: string, createDraftOfPaymentRequestsRequest?: CreateDraftOfPaymentRequestsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createDraftOfPaymentRequests', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/payment_requests/drafts`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xUpsidrSwitchUser != null) {
                localVarHeaderParameter['X-Upsidr-Switch-User'] = String(xUpsidrSwitchUser);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createDraftOfPaymentRequestsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create evidence request
         * @param {string} organizationId 
         * @param {string} paymentReferenceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEvidenceRequest: async (organizationId: string, paymentReferenceId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createEvidenceRequest', 'organizationId', organizationId)
            // verify required parameter 'paymentReferenceId' is not null or undefined
            assertParamExists('createEvidenceRequest', 'paymentReferenceId', paymentReferenceId)
            const localVarPath = `/organizations/{organizationId}/cards/transactions/{paymentReferenceId}/evidence/request`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"paymentReferenceId"}}`, encodeURIComponent(String(paymentReferenceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create freee partner
         * @param {string} organizationId 
         * @param {string} companyId 
         * @param {CreateFreeePartnerRequest} createFreeePartnerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFreeePartner: async (organizationId: string, companyId: string, createFreeePartnerRequest: CreateFreeePartnerRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createFreeePartner', 'organizationId', organizationId)
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('createFreeePartner', 'companyId', companyId)
            // verify required parameter 'createFreeePartnerRequest' is not null or undefined
            assertParamExists('createFreeePartner', 'createFreeePartnerRequest', createFreeePartnerRequest)
            const localVarPath = `/organizations/{organizationId}/freee/{companyId}/partners`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createFreeePartnerRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create past deals
         * @param {string} organizationId 
         * @param {CreatePastDealsRequest} createPastDealsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPastDeals: async (organizationId: string, createPastDealsRequest: CreatePastDealsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createPastDeals', 'organizationId', organizationId)
            // verify required parameter 'createPastDealsRequest' is not null or undefined
            assertParamExists('createPastDeals', 'createPastDealsRequest', createPastDealsRequest)
            const localVarPath = `/organizations/{organizationId}/past_deals`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPastDealsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create purchase application.
         * @param {string} organizationId 
         * @param {CreatePurchaseApplicationRequest} createPurchaseApplicationRequest 
         * @param {string} [visaTransactionReferenceId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPurchaseApplication: async (organizationId: string, createPurchaseApplicationRequest: CreatePurchaseApplicationRequest, visaTransactionReferenceId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createPurchaseApplication', 'organizationId', organizationId)
            // verify required parameter 'createPurchaseApplicationRequest' is not null or undefined
            assertParamExists('createPurchaseApplication', 'createPurchaseApplicationRequest', createPurchaseApplicationRequest)
            const localVarPath = `/organizations/{organizationId}/purchase_applications/submit`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (visaTransactionReferenceId !== undefined) {
                localVarQueryParameter['visaTransactionReferenceId'] = visaTransactionReferenceId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPurchaseApplicationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create purchase application template.
         * @param {string} organizationId 
         * @param {CreatePurchaseApplicationTemplateRequest} createPurchaseApplicationTemplateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPurchaseApplicationTemplate: async (organizationId: string, createPurchaseApplicationTemplateRequest: CreatePurchaseApplicationTemplateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createPurchaseApplicationTemplate', 'organizationId', organizationId)
            // verify required parameter 'createPurchaseApplicationTemplateRequest' is not null or undefined
            assertParamExists('createPurchaseApplicationTemplate', 'createPurchaseApplicationTemplateRequest', createPurchaseApplicationTemplateRequest)
            const localVarPath = `/organizations/{organizationId}/purchase_applications/templates/submit`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPurchaseApplicationTemplateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Slack card notification settings of an organization
         * @param {string} organizationId 
         * @param {CreateSlackCardNotificationsRequest} createSlackCardNotificationsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSlackCardNotifications: async (organizationId: string, createSlackCardNotificationsRequest: CreateSlackCardNotificationsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createSlackCardNotifications', 'organizationId', organizationId)
            // verify required parameter 'createSlackCardNotificationsRequest' is not null or undefined
            assertParamExists('createSlackCardNotifications', 'createSlackCardNotificationsRequest', createSlackCardNotificationsRequest)
            const localVarPath = `/slack/organizations/{organizationId}/cards/notifications`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSlackCardNotificationsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create slack notification settings for purchase-application
         * @param {string} organizationId 
         * @param {CreateSlackNotificationSettingsForPurchaseApplicationRequest} createSlackNotificationSettingsForPurchaseApplicationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSlackNotificationSettingsForPurchaseApplication: async (organizationId: string, createSlackNotificationSettingsForPurchaseApplicationRequest: CreateSlackNotificationSettingsForPurchaseApplicationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createSlackNotificationSettingsForPurchaseApplication', 'organizationId', organizationId)
            // verify required parameter 'createSlackNotificationSettingsForPurchaseApplicationRequest' is not null or undefined
            assertParamExists('createSlackNotificationSettingsForPurchaseApplication', 'createSlackNotificationSettingsForPurchaseApplicationRequest', createSlackNotificationSettingsForPurchaseApplicationRequest)
            const localVarPath = `/slack/organizations/{organizationId}/purchase_applications/notifications`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSlackNotificationSettingsForPurchaseApplicationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Teams card notification settings of an organization
         * @param {string} organizationId 
         * @param {CreateTeamsCardNotificationsRequest} createTeamsCardNotificationsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTeamsCardNotifications: async (organizationId: string, createTeamsCardNotificationsRequest: CreateTeamsCardNotificationsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createTeamsCardNotifications', 'organizationId', organizationId)
            // verify required parameter 'createTeamsCardNotificationsRequest' is not null or undefined
            assertParamExists('createTeamsCardNotifications', 'createTeamsCardNotificationsRequest', createTeamsCardNotificationsRequest)
            const localVarPath = `/teams/organizations/{organizationId}/cards/notifications`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTeamsCardNotificationsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create user account groups
         * @param {string} organizationId 
         * @param {CreateUserAccountGroupsRequest} [createUserAccountGroupsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUserAccountGroups: async (organizationId: string, createUserAccountGroupsRequest?: CreateUserAccountGroupsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createUserAccountGroups', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/user_account_groups`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createUserAccountGroupsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deactivate a card
         * @param {string} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivateCard: async (cardId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cardId' is not null or undefined
            assertParamExists('deactivateCard', 'cardId', cardId)
            const localVarPath = `/cards/{cardId}/deactivate`
                .replace(`{${"cardId"}}`, encodeURIComponent(String(cardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deactivate a user
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivateUser: async (userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('deactivateUser', 'userId', userId)
            const localVarPath = `/users/{userId}/deactivate`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Defrost a card
         * @param {string} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        defrostCard: async (cardId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cardId' is not null or undefined
            assertParamExists('defrostCard', 'cardId', cardId)
            const localVarPath = `/cards/{cardId}/defrost`
                .replace(`{${"cardId"}}`, encodeURIComponent(String(cardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Card Points Rate Configs
         * @param {string} rateConfigId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCardPointsRateConfig: async (rateConfigId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rateConfigId' is not null or undefined
            assertParamExists('deleteCardPointsRateConfig', 'rateConfigId', rateConfigId)
            const localVarPath = `/card_points/rate_configs/{rateConfigId}`
                .replace(`{${"rateConfigId"}}`, encodeURIComponent(String(rateConfigId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete category of the purchase application template.
         * @param {string} organizationId 
         * @param {string} purchaseTemplateCategoryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCategoryOfThePurchaseApplicationTemplate: async (organizationId: string, purchaseTemplateCategoryId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deleteCategoryOfThePurchaseApplicationTemplate', 'organizationId', organizationId)
            // verify required parameter 'purchaseTemplateCategoryId' is not null or undefined
            assertParamExists('deleteCategoryOfThePurchaseApplicationTemplate', 'purchaseTemplateCategoryId', purchaseTemplateCategoryId)
            const localVarPath = `/organizations/{organizationId}/purchase_applications/templates/categories/{purchaseTemplateCategoryId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"purchaseTemplateCategoryId"}}`, encodeURIComponent(String(purchaseTemplateCategoryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete comment for card transaction
         * @param {string} organizationId 
         * @param {string} paymentReferenceId 
         * @param {string} cardTransactionCommentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteComment: async (organizationId: string, paymentReferenceId: string, cardTransactionCommentId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deleteComment', 'organizationId', organizationId)
            // verify required parameter 'paymentReferenceId' is not null or undefined
            assertParamExists('deleteComment', 'paymentReferenceId', paymentReferenceId)
            // verify required parameter 'cardTransactionCommentId' is not null or undefined
            assertParamExists('deleteComment', 'cardTransactionCommentId', cardTransactionCommentId)
            const localVarPath = `/organizations/{organizationId}/cards/transactions/{paymentReferenceId}/comment/{cardTransactionCommentId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"paymentReferenceId"}}`, encodeURIComponent(String(paymentReferenceId)))
                .replace(`{${"cardTransactionCommentId"}}`, encodeURIComponent(String(cardTransactionCommentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete comment template
         * @param {string} organizationId 
         * @param {string} templateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCommentTemplate: async (organizationId: string, templateId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deleteCommentTemplate', 'organizationId', organizationId)
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('deleteCommentTemplate', 'templateId', templateId)
            const localVarPath = `/organizations/{organizationId}/user_accounts/comment_templates/{templateId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"templateId"}}`, encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete deposit restriction for organization
         * @param {string} organizationId 
         * @param {string} depositRestrictionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDepositRestrictionForOrganization: async (organizationId: string, depositRestrictionId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deleteDepositRestrictionForOrganization', 'organizationId', organizationId)
            // verify required parameter 'depositRestrictionId' is not null or undefined
            assertParamExists('deleteDepositRestrictionForOrganization', 'depositRestrictionId', depositRestrictionId)
            const localVarPath = `/organizations/{organizationId}/deposit_restrictions/{depositRestrictionId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"depositRestrictionId"}}`, encodeURIComponent(String(depositRestrictionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete evidence
         * @param {string} organizationId 
         * @param {string} paymentReferenceId 
         * @param {string} cardTransactionEvidenceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEvidence: async (organizationId: string, paymentReferenceId: string, cardTransactionEvidenceId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deleteEvidence', 'organizationId', organizationId)
            // verify required parameter 'paymentReferenceId' is not null or undefined
            assertParamExists('deleteEvidence', 'paymentReferenceId', paymentReferenceId)
            // verify required parameter 'cardTransactionEvidenceId' is not null or undefined
            assertParamExists('deleteEvidence', 'cardTransactionEvidenceId', cardTransactionEvidenceId)
            const localVarPath = `/organizations/{organizationId}/cards/transactions/{paymentReferenceId}/evidence/{cardTransactionEvidenceId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"paymentReferenceId"}}`, encodeURIComponent(String(paymentReferenceId)))
                .replace(`{${"cardTransactionEvidenceId"}}`, encodeURIComponent(String(cardTransactionEvidenceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete freee connected
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFreeeConnected: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deleteFreeeConnected', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/freee/connected`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Freee End Journal Entry Transition Mode
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFreeeEndJournalEntryTransitionMode: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deleteFreeeEndJournalEntryTransitionMode', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/freee/end_journal_entry_transition_mode`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete merchant general block allowed organization ids
         * @param {string} merchantGeneralBlockListId 
         * @param {string} allowedOrganizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMerchantGeneralBlockAllowedOrganizationIds: async (merchantGeneralBlockListId: string, allowedOrganizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantGeneralBlockListId' is not null or undefined
            assertParamExists('deleteMerchantGeneralBlockAllowedOrganizationIds', 'merchantGeneralBlockListId', merchantGeneralBlockListId)
            // verify required parameter 'allowedOrganizationId' is not null or undefined
            assertParamExists('deleteMerchantGeneralBlockAllowedOrganizationIds', 'allowedOrganizationId', allowedOrganizationId)
            const localVarPath = `/merchant_general_block_lists/{merchantGeneralBlockListId}/allowed_organizations/{allowedOrganizationId}`
                .replace(`{${"merchantGeneralBlockListId"}}`, encodeURIComponent(String(merchantGeneralBlockListId)))
                .replace(`{${"allowedOrganizationId"}}`, encodeURIComponent(String(allowedOrganizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete merchant general block list
         * @param {string} merchantGeneralBlockListId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMerchantGeneralBlockList: async (merchantGeneralBlockListId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantGeneralBlockListId' is not null or undefined
            assertParamExists('deleteMerchantGeneralBlockList', 'merchantGeneralBlockListId', merchantGeneralBlockListId)
            const localVarPath = `/merchant_general_block_lists/{merchantGeneralBlockListId}`
                .replace(`{${"merchantGeneralBlockListId"}}`, encodeURIComponent(String(merchantGeneralBlockListId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete merchant org block list
         * @param {string} merchantOrgBlockListId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMerchantOrgBlockList: async (merchantOrgBlockListId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantOrgBlockListId' is not null or undefined
            assertParamExists('deleteMerchantOrgBlockList', 'merchantOrgBlockListId', merchantOrgBlockListId)
            const localVarPath = `/merchant_org_block_lists/{merchantOrgBlockListId}`
                .replace(`{${"merchantOrgBlockListId"}}`, encodeURIComponent(String(merchantOrgBlockListId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete an onboarding request
         * @param {string} onboardingRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOnboardingRequest: async (onboardingRequestId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'onboardingRequestId' is not null or undefined
            assertParamExists('deleteOnboardingRequest', 'onboardingRequestId', onboardingRequestId)
            const localVarPath = `/zeus/onboarding_requests/{onboardingRequestId}`
                .replace(`{${"onboardingRequestId"}}`, encodeURIComponent(String(onboardingRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Organization Create Request
         * @param {string} organizationCreateRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrganizationCreateRequest: async (organizationCreateRequestId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationCreateRequestId' is not null or undefined
            assertParamExists('deleteOrganizationCreateRequest', 'organizationCreateRequestId', organizationCreateRequestId)
            const localVarPath = `/organization_create_requests/{organizationCreateRequestId}`
                .replace(`{${"organizationCreateRequestId"}}`, encodeURIComponent(String(organizationCreateRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a payment request evidence specified by evidenceId.
         * @summary Delete the specific payment request evidence.
         * @param {string} organizationId 
         * @param {string} paymentRequestId 
         * @param {string} evidenceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePaymentRequestEvidence: async (organizationId: string, paymentRequestId: string, evidenceId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deletePaymentRequestEvidence', 'organizationId', organizationId)
            // verify required parameter 'paymentRequestId' is not null or undefined
            assertParamExists('deletePaymentRequestEvidence', 'paymentRequestId', paymentRequestId)
            // verify required parameter 'evidenceId' is not null or undefined
            assertParamExists('deletePaymentRequestEvidence', 'evidenceId', evidenceId)
            const localVarPath = `/organizations/{organizationId}/payment_requests/{paymentRequestId}/evidences/{evidenceId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"paymentRequestId"}}`, encodeURIComponent(String(paymentRequestId)))
                .replace(`{${"evidenceId"}}`, encodeURIComponent(String(evidenceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete purchase application.
         * @param {string} organizationId 
         * @param {string} purchaseApplicationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePurchaseApplication: async (organizationId: string, purchaseApplicationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deletePurchaseApplication', 'organizationId', organizationId)
            // verify required parameter 'purchaseApplicationId' is not null or undefined
            assertParamExists('deletePurchaseApplication', 'purchaseApplicationId', purchaseApplicationId)
            const localVarPath = `/organizations/{organizationId}/purchase_applications/{purchaseApplicationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"purchaseApplicationId"}}`, encodeURIComponent(String(purchaseApplicationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete purchase application templates detail
         * @param {string} organizationId 
         * @param {string} purchaseTemplateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePurchaseApplicationTemplatesDetail: async (organizationId: string, purchaseTemplateId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deletePurchaseApplicationTemplatesDetail', 'organizationId', organizationId)
            // verify required parameter 'purchaseTemplateId' is not null or undefined
            assertParamExists('deletePurchaseApplicationTemplatesDetail', 'purchaseTemplateId', purchaseTemplateId)
            const localVarPath = `/organizations/{organizationId}/purchase_applications/templates/{purchaseTemplateId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"purchaseTemplateId"}}`, encodeURIComponent(String(purchaseTemplateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete slack notification channel setting for purchase-application
         * @param {string} organizationId 
         * @param {string} channelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSlackNotificationChannelSettingForPurchaseApplication: async (organizationId: string, channelId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deleteSlackNotificationChannelSettingForPurchaseApplication', 'organizationId', organizationId)
            // verify required parameter 'channelId' is not null or undefined
            assertParamExists('deleteSlackNotificationChannelSettingForPurchaseApplication', 'channelId', channelId)
            const localVarPath = `/slack/organizations/{organizationId}/channels/{channelId}/purchase_applications/notification`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"channelId"}}`, encodeURIComponent(String(channelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete slack notification channel setting for card
         * @param {string} organizationId 
         * @param {string} channelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSlackNotificationSettingForCard: async (organizationId: string, channelId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deleteSlackNotificationSettingForCard', 'organizationId', organizationId)
            // verify required parameter 'channelId' is not null or undefined
            assertParamExists('deleteSlackNotificationSettingForCard', 'channelId', channelId)
            const localVarPath = `/slack/organizations/{organizationId}/channels/{channelId}/cards/notification`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"channelId"}}`, encodeURIComponent(String(channelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete system admin role
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSystemAdminRole: async (userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('deleteSystemAdminRole', 'userId', userId)
            const localVarPath = `/users/{userId}/roles/system`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete teams notification channel setting for card
         * @param {string} organizationId 
         * @param {string} channelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTeamsNotificationSettingForCard: async (organizationId: string, channelId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deleteTeamsNotificationSettingForCard', 'organizationId', organizationId)
            // verify required parameter 'channelId' is not null or undefined
            assertParamExists('deleteTeamsNotificationSettingForCard', 'channelId', channelId)
            const localVarPath = `/teams/organizations/{organizationId}/channels/{channelId}/cards/notification`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"channelId"}}`, encodeURIComponent(String(channelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete user account group
         * @param {number} userAccountGroupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserAccountGroup: async (userAccountGroupId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userAccountGroupId' is not null or undefined
            assertParamExists('deleteUserAccountGroup', 'userAccountGroupId', userAccountGroupId)
            const localVarPath = `/user_account_groups/{userAccountGroupId}`
                .replace(`{${"userAccountGroupId"}}`, encodeURIComponent(String(userAccountGroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deposit Guarantee Money Balance
         * @param {string} organizationId 
         * @param {DepositGuaranteeMoneyBalanceRequest} depositGuaranteeMoneyBalanceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        depositGuaranteeMoneyBalance: async (organizationId: string, depositGuaranteeMoneyBalanceRequest: DepositGuaranteeMoneyBalanceRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('depositGuaranteeMoneyBalance', 'organizationId', organizationId)
            // verify required parameter 'depositGuaranteeMoneyBalanceRequest' is not null or undefined
            assertParamExists('depositGuaranteeMoneyBalance', 'depositGuaranteeMoneyBalanceRequest', depositGuaranteeMoneyBalanceRequest)
            const localVarPath = `/organizations/{organizationId}/guarantee_money_balance/deposit`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(depositGuaranteeMoneyBalanceRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Disable Approval
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disableApproval: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('disableApproval', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/disable_approval`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Disable daily usage limit for an user account
         * @param {string} userAccountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disableDailyUserUsageLimit: async (userAccountId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userAccountId' is not null or undefined
            assertParamExists('disableDailyUserUsageLimit', 'userAccountId', userAccountId)
            const localVarPath = `/user_accounts/{userAccountId}/disable_daily_usage_limit`
                .replace(`{${"userAccountId"}}`, encodeURIComponent(String(userAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Disable physical store payment for the user account
         * @param {string} userAccountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disablePhysicalStorePaymentForTheUserAccount: async (userAccountId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userAccountId' is not null or undefined
            assertParamExists('disablePhysicalStorePaymentForTheUserAccount', 'userAccountId', userAccountId)
            const localVarPath = `/user_accounts/{userAccountId}/disable_physical_store_payment`
                .replace(`{${"userAccountId"}}`, encodeURIComponent(String(userAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Disable transaction upper limit for the user account
         * @param {string} userAccountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disableTransactionUpperLimitForTheUserAccount: async (userAccountId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userAccountId' is not null or undefined
            assertParamExists('disableTransactionUpperLimitForTheUserAccount', 'userAccountId', userAccountId)
            const localVarPath = `/user_accounts/{userAccountId}/disable_transaction_upper_limit`
                .replace(`{${"userAccountId"}}`, encodeURIComponent(String(userAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Disable usage limit for an user account
         * @param {string} userAccountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disableUserUsageLimit: async (userAccountId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userAccountId' is not null or undefined
            assertParamExists('disableUserUsageLimit', 'userAccountId', userAccountId)
            const localVarPath = `/user_accounts/{userAccountId}/disable_usage_limit`
                .replace(`{${"userAccountId"}}`, encodeURIComponent(String(userAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Disagree to the agreement request
         * @param {string} organizationId 
         * @param {string} agreementRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disagreeToAgreementRequest: async (organizationId: string, agreementRequestId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('disagreeToAgreementRequest', 'organizationId', organizationId)
            // verify required parameter 'agreementRequestId' is not null or undefined
            assertParamExists('disagreeToAgreementRequest', 'agreementRequestId', agreementRequestId)
            const localVarPath = `/organizations/{organizationId}/agreement_requests/{agreementRequestId}/disagree`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"agreementRequestId"}}`, encodeURIComponent(String(agreementRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Download bank transfer file
         * @param {string} organizationId 
         * @param {string} bankTransferId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadBankTransferFile: async (organizationId: string, bankTransferId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('downloadBankTransferFile', 'organizationId', organizationId)
            // verify required parameter 'bankTransferId' is not null or undefined
            assertParamExists('downloadBankTransferFile', 'bankTransferId', bankTransferId)
            const localVarPath = `/organizations/{organizationId}/payment_requests/bank_transfers/{bankTransferId}/file`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"bankTransferId"}}`, encodeURIComponent(String(bankTransferId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Download bank transfers csv
         * @param {string} organizationId 
         * @param {string} [transferDateJstFrom] yyyy-MM-dd format date in JST. Filter the bank transfers to be returned to only those which are scheduled to be transferred after this date.
         * @param {string} [transferDateJstTo] yyyy-MM-dd format date in JST. Filter the bank transfers to be returned to only those which are scheduled to be transferred before this date. Both transferDateJstFrom and transferDateJstTo are inclusive (closed interval).
         * @param {string} [sourceBankAccountId] Filter the bank transfers by the specified source bank account id.
         * @param {boolean} [downloaded] Filter the bank transfers by whether the corresponding transfer data has been downloaded.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadBankTransfersCsv: async (organizationId: string, transferDateJstFrom?: string, transferDateJstTo?: string, sourceBankAccountId?: string, downloaded?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('downloadBankTransfersCsv', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/payment_requests/bank_transfers/csv`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (transferDateJstFrom !== undefined) {
                localVarQueryParameter['transferDateJstFrom'] = transferDateJstFrom;
            }

            if (transferDateJstTo !== undefined) {
                localVarQueryParameter['transferDateJstTo'] = transferDateJstTo;
            }

            if (sourceBankAccountId !== undefined) {
                localVarQueryParameter['sourceBankAccountId'] = sourceBankAccountId;
            }

            if (downloaded !== undefined) {
                localVarQueryParameter['downloaded'] = downloaded;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Download journal entry for freee csv
         * @param {string} organizationId 
         * @param {string} yearMonth 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadJournalEntryForFreeeCsv: async (organizationId: string, yearMonth: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('downloadJournalEntryForFreeeCsv', 'organizationId', organizationId)
            // verify required parameter 'yearMonth' is not null or undefined
            assertParamExists('downloadJournalEntryForFreeeCsv', 'yearMonth', yearMonth)
            const localVarPath = `/organizations/{organizationId}/deals/download_csv`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (yearMonth !== undefined) {
                localVarQueryParameter['yearMonth'] = yearMonth;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Download Organizations Accounting Csv
         * @param {string} organizationId 
         * @param {string} yearMonth 
         * @param {boolean} isMergedFiles 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadOrganizationsAccountingCsv: async (organizationId: string, yearMonth: string, isMergedFiles: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('downloadOrganizationsAccountingCsv', 'organizationId', organizationId)
            // verify required parameter 'yearMonth' is not null or undefined
            assertParamExists('downloadOrganizationsAccountingCsv', 'yearMonth', yearMonth)
            // verify required parameter 'isMergedFiles' is not null or undefined
            assertParamExists('downloadOrganizationsAccountingCsv', 'isMergedFiles', isMergedFiles)
            const localVarPath = `/organizations/{organizationId}/cards/accounting/download_csv`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (yearMonth !== undefined) {
                localVarQueryParameter['yearMonth'] = yearMonth;
            }

            if (isMergedFiles !== undefined) {
                localVarQueryParameter['isMergedFiles'] = isMergedFiles;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Download payment requests csv
         * @param {string} organizationId 
         * @param {string} [dueDateJstFrom] yyyy-MM-dd format date in JST. Filter the payment requests to be returned to only those which have a due date after this date.
         * @param {string} [dueDateJstTo] yyyy-MM-dd format date in JST. Filter the payment requests to be returned to only those which have a due date before this date. Both dueDateJstFrom and dueDateJstTo are inclusive (closed interval).
         * @param {Array<'PENDING_WORKFLOW_COMPLETION' | 'CANCELED' | 'PAYABLE' | 'ATTACHED_TO_BANK_TRANSFER' | 'DEACTIVATED'>} [statuses] Filter the payment requests by the specified status.
         * @param {string} [supplierId] Filter the payment requests by the specified supplier id.
         * @param {boolean} [transferDataCreated] Filter the payment requests by whether the corresponding transaction data has been created.
         * @param {boolean} [withholdingApplied] Filter the payment requests by whether the withholding tax has been applied. true means the withholdingCalculatingMethod is NONE, while false, except for NONE.
         * @param {'SELF' | 'SUPPLIER'} [transferFeeResponsibility] Filter the payment requests by the specified transfer fee responsibility.
         * @param {string} [freeWord] A keyword used to search the following fields for partial matches:  - supplier name  - requestor name  - memo  - accounting items  - sections
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadPaymentRequestsCsv: async (organizationId: string, dueDateJstFrom?: string, dueDateJstTo?: string, statuses?: Array<'PENDING_WORKFLOW_COMPLETION' | 'CANCELED' | 'PAYABLE' | 'ATTACHED_TO_BANK_TRANSFER' | 'DEACTIVATED'>, supplierId?: string, transferDataCreated?: boolean, withholdingApplied?: boolean, transferFeeResponsibility?: 'SELF' | 'SUPPLIER', freeWord?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('downloadPaymentRequestsCsv', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/payment_requests/csv`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (dueDateJstFrom !== undefined) {
                localVarQueryParameter['dueDateJstFrom'] = dueDateJstFrom;
            }

            if (dueDateJstTo !== undefined) {
                localVarQueryParameter['dueDateJstTo'] = dueDateJstTo;
            }

            if (statuses) {
                localVarQueryParameter['statuses'] = statuses;
            }

            if (supplierId !== undefined) {
                localVarQueryParameter['supplierId'] = supplierId;
            }

            if (transferDataCreated !== undefined) {
                localVarQueryParameter['transferDataCreated'] = transferDataCreated;
            }

            if (withholdingApplied !== undefined) {
                localVarQueryParameter['withholdingApplied'] = withholdingApplied;
            }

            if (transferFeeResponsibility !== undefined) {
                localVarQueryParameter['transferFeeResponsibility'] = transferFeeResponsibility;
            }

            if (freeWord !== undefined) {
                localVarQueryParameter['freeWord'] = freeWord;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Download payment requests csv for payment request ids specification
         * @param {string} organizationId 
         * @param {DownloadPaymentRequestsCsvForPaymentRequestIdsSpecificationRequest} [downloadPaymentRequestsCsvForPaymentRequestIdsSpecificationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadPaymentRequestsCsvForPaymentRequestIdsSpecification: async (organizationId: string, downloadPaymentRequestsCsvForPaymentRequestIdsSpecificationRequest?: DownloadPaymentRequestsCsvForPaymentRequestIdsSpecificationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('downloadPaymentRequestsCsvForPaymentRequestIdsSpecification', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/payment_requests/download_csv`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(downloadPaymentRequestsCsvForPaymentRequestIdsSpecificationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Enable physical store payment for the user account
         * @param {string} userAccountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enablePhysicalStorePaymentForTheUserAccount: async (userAccountId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userAccountId' is not null or undefined
            assertParamExists('enablePhysicalStorePaymentForTheUserAccount', 'userAccountId', userAccountId)
            const localVarPath = `/user_accounts/{userAccountId}/enable_physical_store_payment`
                .replace(`{${"userAccountId"}}`, encodeURIComponent(String(userAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Freeze a card
         * @param {string} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        freezeCard: async (cardId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cardId' is not null or undefined
            assertParamExists('freezeCard', 'cardId', cardId)
            const localVarPath = `/cards/{cardId}/freeze`
                .replace(`{${"cardId"}}`, encodeURIComponent(String(cardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Generate Annual Fees Invoice
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateAnnualFeesInvoice: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('generateAnnualFeesInvoice', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/annual_fees/invoices/generate`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Generate Create Account Token
         * @param {GenerateCreateAccountTokenRequest} generateCreateAccountTokenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateCreateAccountToken: async (generateCreateAccountTokenRequest: GenerateCreateAccountTokenRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'generateCreateAccountTokenRequest' is not null or undefined
            assertParamExists('generateCreateAccountToken', 'generateCreateAccountTokenRequest', generateCreateAccountTokenRequest)
            const localVarPath = `/generate_create_account_token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generateCreateAccountTokenRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Generate freee redirect url
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateFreeeRedirectUrl: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('generateFreeeRedirectUrl', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/freee/redirect_url`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Generate org account ids.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateOrgAccountIds: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/organizations/generate_org_account_id`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a Card Detail as Admin
         * @param {string} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getACardDetailAsAdmin: async (cardId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cardId' is not null or undefined
            assertParamExists('getACardDetailAsAdmin', 'cardId', cardId)
            const localVarPath = `/cards/{cardId}/detail_as_admin`
                .replace(`{${"cardId"}}`, encodeURIComponent(String(cardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get accounting csv for the organization.
         * @param {string} organizationId 
         * @param {string} startYearMonth 
         * @param {string} endYearMonth 
         * @param {'FREEE' | 'MONEY_FORWARD'} accountingSystemType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountingCsvForTheOrganization: async (organizationId: string, startYearMonth: string, endYearMonth: string, accountingSystemType: 'FREEE' | 'MONEY_FORWARD', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAccountingCsvForTheOrganization', 'organizationId', organizationId)
            // verify required parameter 'startYearMonth' is not null or undefined
            assertParamExists('getAccountingCsvForTheOrganization', 'startYearMonth', startYearMonth)
            // verify required parameter 'endYearMonth' is not null or undefined
            assertParamExists('getAccountingCsvForTheOrganization', 'endYearMonth', endYearMonth)
            // verify required parameter 'accountingSystemType' is not null or undefined
            assertParamExists('getAccountingCsvForTheOrganization', 'accountingSystemType', accountingSystemType)
            const localVarPath = `/organizations/{organizationId}/accounting/download_csv`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startYearMonth !== undefined) {
                localVarQueryParameter['startYearMonth'] = startYearMonth;
            }

            if (endYearMonth !== undefined) {
                localVarQueryParameter['endYearMonth'] = endYearMonth;
            }

            if (accountingSystemType !== undefined) {
                localVarQueryParameter['accountingSystemType'] = accountingSystemType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get accounting csv for the user account.
         * @param {string} userAccountId 
         * @param {string} yearMonth 
         * @param {boolean} isMergedFiles 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountingCsvForTheUserAccount: async (userAccountId: string, yearMonth: string, isMergedFiles: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userAccountId' is not null or undefined
            assertParamExists('getAccountingCsvForTheUserAccount', 'userAccountId', userAccountId)
            // verify required parameter 'yearMonth' is not null or undefined
            assertParamExists('getAccountingCsvForTheUserAccount', 'yearMonth', yearMonth)
            // verify required parameter 'isMergedFiles' is not null or undefined
            assertParamExists('getAccountingCsvForTheUserAccount', 'isMergedFiles', isMergedFiles)
            const localVarPath = `/user_accounts/{userAccountId}/accounting/download_csv`
                .replace(`{${"userAccountId"}}`, encodeURIComponent(String(userAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (yearMonth !== undefined) {
                localVarQueryParameter['yearMonth'] = yearMonth;
            }

            if (isMergedFiles !== undefined) {
                localVarQueryParameter['isMergedFiles'] = isMergedFiles;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get admin users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminUsers: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/users/system_admin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get admins
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdmins: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAdmins', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/users/admins`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get agreement requests
         * @param {string} organizationId 
         * @param {boolean} waitingForAgreement 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgreementRequests: async (organizationId: string, waitingForAgreement: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAgreementRequests', 'organizationId', organizationId)
            // verify required parameter 'waitingForAgreement' is not null or undefined
            assertParamExists('getAgreementRequests', 'waitingForAgreement', waitingForAgreement)
            const localVarPath = `/organizations/{organizationId}/agreement_requests`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (waitingForAgreement !== undefined) {
                localVarQueryParameter['waitingForAgreement'] = waitingForAgreement;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all banks
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllBanks: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/banks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get analysis invoice of payment request
         * @param {string} organizationId 
         * @param {string} fileId 
         * @param {string} [xUpsidrSwitchUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAnalysisInvoiceOfPaymentRequest: async (organizationId: string, fileId: string, xUpsidrSwitchUser?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAnalysisInvoiceOfPaymentRequest', 'organizationId', organizationId)
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('getAnalysisInvoiceOfPaymentRequest', 'fileId', fileId)
            const localVarPath = `/organizations/{organizationId}/payment_requests/invoice_analyze`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fileId !== undefined) {
                localVarQueryParameter['fileId'] = fileId;
            }

            if (xUpsidrSwitchUser != null) {
                localVarHeaderParameter['X-Upsidr-Switch-User'] = String(xUpsidrSwitchUser);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get annual fees eligibility
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAnnualFeesEligibility: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAnnualFeesEligibility', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/annual_fees/eligibility`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get approvers
         * @param {string} userAccountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApprovers: async (userAccountId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userAccountId' is not null or undefined
            assertParamExists('getApprovers', 'userAccountId', userAccountId)
            const localVarPath = `/user_accounts/{userAccountId}/purchase_applications/approvers`
                .replace(`{${"userAccountId"}}`, encodeURIComponent(String(userAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get available currency options
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableCurrencyOptions: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user_accounts/available_currency_options`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * <p>   Return a list of feature names that are available for the organization.   Most features are unconditionally available to all organizations and   are not included in the response of this API, while some new features are not   available for the organization unless their names are included in this response. </p> <p>   The response schema are designed to ensure that information about new features   is not disclosed to organizations that cannot use them. </p>
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableFeatures: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAvailableFeatures', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/available_features`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Available merchant category options
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableMerchantCategoryOptions: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user_accounts/available_merchant_category_options`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get balance state
         * @param {string} organizationId 
         * @param {string} [targetDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBalanceState: async (organizationId: string, targetDate?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getBalanceState', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/balance_state`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (targetDate !== undefined) {
                localVarQueryParameter['targetDate'] = targetDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get bank account activities
         * @param {number} bankAccountActivityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBankAccountActivities: async (bankAccountActivityId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bankAccountActivityId' is not null or undefined
            assertParamExists('getBankAccountActivities', 'bankAccountActivityId', bankAccountActivityId)
            const localVarPath = `/bank_account_activities/{bankAccountActivityId}`
                .replace(`{${"bankAccountActivityId"}}`, encodeURIComponent(String(bankAccountActivityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a bank account confirmed activities
         * @param {string} organizationId 
         * @param {'PAY_BILL' | 'DEPOSIT' | 'WITHDRAWAL' | 'REWARD' | 'USAGE_FEE' | 'POINT' | 'CARD_POINT' | 'CAMPAIGN_POINT' | 'CARD' | 'DEPOSIT_FROM_GUARANTEE_MONEY' | 'WITHDRAWAL_TO_GUARANTEE_MONEY'} [type] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBankAccountConfirmedActivities: async (organizationId: string, type?: 'PAY_BILL' | 'DEPOSIT' | 'WITHDRAWAL' | 'REWARD' | 'USAGE_FEE' | 'POINT' | 'CARD_POINT' | 'CAMPAIGN_POINT' | 'CARD' | 'DEPOSIT_FROM_GUARANTEE_MONEY' | 'WITHDRAWAL_TO_GUARANTEE_MONEY', limit?: number, offset?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getBankAccountConfirmedActivities', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/bank_account_confirmed_activities`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get bank by name
         * @param {string} bankName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBankByName: async (bankName: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bankName' is not null or undefined
            assertParamExists('getBankByName', 'bankName', bankName)
            const localVarPath = `/banks/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (bankName !== undefined) {
                localVarQueryParameter['bankName'] = bankName;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a bank transfer
         * @param {string} organizationId 
         * @param {string} bankTransferId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBankTransfer: async (organizationId: string, bankTransferId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getBankTransfer', 'organizationId', organizationId)
            // verify required parameter 'bankTransferId' is not null or undefined
            assertParamExists('getBankTransfer', 'bankTransferId', bankTransferId)
            const localVarPath = `/organizations/{organizationId}/payment_requests/bank_transfers/{bankTransferId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"bankTransferId"}}`, encodeURIComponent(String(bankTransferId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the specified bank\'s all branches
         * @param {string} bankCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBanksAllBranches: async (bankCode: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bankCode' is not null or undefined
            assertParamExists('getBanksAllBranches', 'bankCode', bankCode)
            const localVarPath = `/banks/{bankCode}/branches`
                .replace(`{${"bankCode"}}`, encodeURIComponent(String(bankCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get bookkeepers
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBookkeepers: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getBookkeepers', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/users/bookkeepers`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get branch
         * @param {string} bankCode 
         * @param {string} branchName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBranch: async (bankCode: string, branchName: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bankCode' is not null or undefined
            assertParamExists('getBranch', 'bankCode', bankCode)
            // verify required parameter 'branchName' is not null or undefined
            assertParamExists('getBranch', 'branchName', branchName)
            const localVarPath = `/bank_branches/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (bankCode !== undefined) {
                localVarQueryParameter['bankCode'] = bankCode;
            }

            if (branchName !== undefined) {
                localVarQueryParameter['branchName'] = branchName;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all business descriptions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBusinessDescriptions: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/business-descriptions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get if an organization can activate cards
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCanActivateCard: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getCanActivateCard', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/can_activate_card`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the status of whether the organization can close
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCanCloseStatuses: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getCanCloseStatuses', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/can_close_statuses`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get can deactivate
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCanDeactivate: async (userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getCanDeactivate', 'userId', userId)
            const localVarPath = `/users/{userId}/can_deactivate`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get if the user can read card\'s sensitive info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCanReadCardSensitive: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/users/can_read_card_sensitive`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get if an organization can request a real card to be issued.
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCanRequestSendingCard: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getCanRequestSendingCard', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/can_request_sending_card`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Card Bill
         * @param {string} cardBillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardBill: async (cardBillId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cardBillId' is not null or undefined
            assertParamExists('getCardBill', 'cardBillId', cardBillId)
            const localVarPath = `/cards/{cardBillId}`
                .replace(`{${"cardBillId"}}`, encodeURIComponent(String(cardBillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Card Detail
         * @param {string} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardDetail: async (cardId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cardId' is not null or undefined
            assertParamExists('getCardDetail', 'cardId', cardId)
            const localVarPath = `/cards/{cardId}/detail`
                .replace(`{${"cardId"}}`, encodeURIComponent(String(cardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get card monthly transactions
         * @param {string} userAccountId 
         * @param {string} yearMonth 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardMonthlyTransactions: async (userAccountId: string, yearMonth: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userAccountId' is not null or undefined
            assertParamExists('getCardMonthlyTransactions', 'userAccountId', userAccountId)
            // verify required parameter 'yearMonth' is not null or undefined
            assertParamExists('getCardMonthlyTransactions', 'yearMonth', yearMonth)
            const localVarPath = `/user_accounts/{userAccountId}/cards/monthly_transactions`
                .replace(`{${"userAccountId"}}`, encodeURIComponent(String(userAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (yearMonth !== undefined) {
                localVarQueryParameter['yearMonth'] = yearMonth;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Card Points Rate Configs By OrganizationId
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardPointsRateConfigsByOrganizationId: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getCardPointsRateConfigsByOrganizationId', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/card_points/rate_configs`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get card transaction details
         * @param {string} organizationId 
         * @param {string} visaTransactionReferenceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardTransactionDetails: async (organizationId: string, visaTransactionReferenceId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getCardTransactionDetails', 'organizationId', organizationId)
            // verify required parameter 'visaTransactionReferenceId' is not null or undefined
            assertParamExists('getCardTransactionDetails', 'visaTransactionReferenceId', visaTransactionReferenceId)
            const localVarPath = `/organizations/{organizationId}/cards/transactions/details`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (visaTransactionReferenceId !== undefined) {
                localVarQueryParameter['visaTransactionReferenceId'] = visaTransactionReferenceId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get card transaction evidence record image
         * @param {string} organizationId 
         * @param {string} paymentReferenceId 
         * @param {string} cardTransactionEvidenceId 
         * @param {string} id 
         * @param {boolean} [inPdf] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardTransactionEvidenceRecordImage: async (organizationId: string, paymentReferenceId: string, cardTransactionEvidenceId: string, id: string, inPdf?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getCardTransactionEvidenceRecordImage', 'organizationId', organizationId)
            // verify required parameter 'paymentReferenceId' is not null or undefined
            assertParamExists('getCardTransactionEvidenceRecordImage', 'paymentReferenceId', paymentReferenceId)
            // verify required parameter 'cardTransactionEvidenceId' is not null or undefined
            assertParamExists('getCardTransactionEvidenceRecordImage', 'cardTransactionEvidenceId', cardTransactionEvidenceId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCardTransactionEvidenceRecordImage', 'id', id)
            const localVarPath = `/organizations/{organizationId}/cards/transactions/{paymentReferenceId}/evidence/{cardTransactionEvidenceId}/records/{id}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"paymentReferenceId"}}`, encodeURIComponent(String(paymentReferenceId)))
                .replace(`{${"cardTransactionEvidenceId"}}`, encodeURIComponent(String(cardTransactionEvidenceId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (inPdf !== undefined) {
                localVarQueryParameter['inPdf'] = inPdf;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get card transaction evidence records
         * @param {string} organizationId 
         * @param {string} paymentReferenceId 
         * @param {string} cardTransactionEvidenceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardTransactionEvidenceRecords: async (organizationId: string, paymentReferenceId: string, cardTransactionEvidenceId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getCardTransactionEvidenceRecords', 'organizationId', organizationId)
            // verify required parameter 'paymentReferenceId' is not null or undefined
            assertParamExists('getCardTransactionEvidenceRecords', 'paymentReferenceId', paymentReferenceId)
            // verify required parameter 'cardTransactionEvidenceId' is not null or undefined
            assertParamExists('getCardTransactionEvidenceRecords', 'cardTransactionEvidenceId', cardTransactionEvidenceId)
            const localVarPath = `/organizations/{organizationId}/cards/transactions/{paymentReferenceId}/evidence/{cardTransactionEvidenceId}/records`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"paymentReferenceId"}}`, encodeURIComponent(String(paymentReferenceId)))
                .replace(`{${"cardTransactionEvidenceId"}}`, encodeURIComponent(String(cardTransactionEvidenceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Card Transactions
         * @param {string} userAccountId 
         * @param {string} merchantId 
         * @param {string} toYearMonth 
         * @param {string} [fromYearMonth] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardTransactions: async (userAccountId: string, merchantId: string, toYearMonth: string, fromYearMonth?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userAccountId' is not null or undefined
            assertParamExists('getCardTransactions', 'userAccountId', userAccountId)
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('getCardTransactions', 'merchantId', merchantId)
            // verify required parameter 'toYearMonth' is not null or undefined
            assertParamExists('getCardTransactions', 'toYearMonth', toYearMonth)
            const localVarPath = `/user_accounts/{userAccountId}/cards/transactions`
                .replace(`{${"userAccountId"}}`, encodeURIComponent(String(userAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (merchantId !== undefined) {
                localVarQueryParameter['merchantId'] = merchantId;
            }

            if (fromYearMonth !== undefined) {
                localVarQueryParameter['fromYearMonth'] = fromYearMonth;
            }

            if (toYearMonth !== undefined) {
                localVarQueryParameter['toYearMonth'] = toYearMonth;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get cards
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCards: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getCards', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/cards`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get cards transactions with purchase application unlinked
         * @param {string} organizationId 
         * @param {string} yearMonth 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardsTransactionsWithPurchaseApplicationUnlinked: async (organizationId: string, yearMonth: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getCardsTransactionsWithPurchaseApplicationUnlinked', 'organizationId', organizationId)
            // verify required parameter 'yearMonth' is not null or undefined
            assertParamExists('getCardsTransactionsWithPurchaseApplicationUnlinked', 'yearMonth', yearMonth)
            const localVarPath = `/organizations/{organizationId}/cards/monthly_transactions/purchase_application/unlinked`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (yearMonth !== undefined) {
                localVarQueryParameter['yearMonth'] = yearMonth;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the category of the purchase application template for use.
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategoryOfThePurchaseApplicationTemplate: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getCategoryOfThePurchaseApplicationTemplate', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/purchase_applications/templates/categories`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get comment for card transaction
         * @param {string} organizationId 
         * @param {string} paymentReferenceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getComment: async (organizationId: string, paymentReferenceId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getComment', 'organizationId', organizationId)
            // verify required parameter 'paymentReferenceId' is not null or undefined
            assertParamExists('getComment', 'paymentReferenceId', paymentReferenceId)
            const localVarPath = `/organizations/{organizationId}/cards/transactions/{paymentReferenceId}/comment`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"paymentReferenceId"}}`, encodeURIComponent(String(paymentReferenceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get comment templates
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommentTemplates: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getCommentTemplates', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/user_accounts/comment_templates`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get comment template
         * @param {string} organizationId 
         * @param {string} templateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommentTemplatesCommentTemplateId: async (organizationId: string, templateId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getCommentTemplatesCommentTemplateId', 'organizationId', organizationId)
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('getCommentTemplatesCommentTemplateId', 'templateId', templateId)
            const localVarPath = `/organizations/{organizationId}/user_accounts/comment_templates/{templateId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"templateId"}}`, encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get current card associated with the user account
         * @param {string} userAccountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentCardAssociatedWithTheUserAccount: async (userAccountId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userAccountId' is not null or undefined
            assertParamExists('getCurrentCardAssociatedWithTheUserAccount', 'userAccountId', userAccountId)
            const localVarPath = `/user_accounts/{userAccountId}/current_card`
                .replace(`{${"userAccountId"}}`, encodeURIComponent(String(userAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get deals total amount
         * @param {number} organizationId 
         * @param {GetDealsTotalAmountRequest} [getDealsTotalAmountRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDealsTotalAmount: async (organizationId: number, getDealsTotalAmountRequest?: GetDealsTotalAmountRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getDealsTotalAmount', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/deals/total_amount`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getDealsTotalAmountRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get default comment template for user account
         * @param {string} organizationId 
         * @param {string} userAccountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDefaultCommentTemplate: async (organizationId: string, userAccountId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getDefaultCommentTemplate', 'organizationId', organizationId)
            // verify required parameter 'userAccountId' is not null or undefined
            assertParamExists('getDefaultCommentTemplate', 'userAccountId', userAccountId)
            const localVarPath = `/organizations/{organizationId}/user_accounts/{userAccountId}/default_comment_template`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"userAccountId"}}`, encodeURIComponent(String(userAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get deposit bank account
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDepositBankAccount: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getDepositBankAccount', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/deposit_bank_account`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get deposit restriction for organization
         * @param {string} organizationId 
         * @param {string} depositRestrictionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDepositRestrictionForOrganization: async (organizationId: string, depositRestrictionId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getDepositRestrictionForOrganization', 'organizationId', organizationId)
            // verify required parameter 'depositRestrictionId' is not null or undefined
            assertParamExists('getDepositRestrictionForOrganization', 'depositRestrictionId', depositRestrictionId)
            const localVarPath = `/organizations/{organizationId}/deposit_restrictions/{depositRestrictionId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"depositRestrictionId"}}`, encodeURIComponent(String(depositRestrictionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get deposit restriction list for organization
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDepositRestrictionListForOrganization: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getDepositRestrictionListForOrganization', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/deposit_restrictions`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get draft payment request
         * @param {string} organizationId 
         * @param {string} draftPaymentRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDraftPaymentRequest: async (organizationId: string, draftPaymentRequestId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getDraftPaymentRequest', 'organizationId', organizationId)
            // verify required parameter 'draftPaymentRequestId' is not null or undefined
            assertParamExists('getDraftPaymentRequest', 'draftPaymentRequestId', draftPaymentRequestId)
            const localVarPath = `/organizations/{organizationId}/payment_requests/drafts/{draftPaymentRequestId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"draftPaymentRequestId"}}`, encodeURIComponent(String(draftPaymentRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get draft payment request evidence file
         * @param {string} organizationId 
         * @param {string} draftPaymentRequestId 
         * @param {string} evidenceId 
         * @param {boolean} [inPdf] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDraftPaymentRequestEvidenceFile: async (organizationId: string, draftPaymentRequestId: string, evidenceId: string, inPdf?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getDraftPaymentRequestEvidenceFile', 'organizationId', organizationId)
            // verify required parameter 'draftPaymentRequestId' is not null or undefined
            assertParamExists('getDraftPaymentRequestEvidenceFile', 'draftPaymentRequestId', draftPaymentRequestId)
            // verify required parameter 'evidenceId' is not null or undefined
            assertParamExists('getDraftPaymentRequestEvidenceFile', 'evidenceId', evidenceId)
            const localVarPath = `/organizations/{organizationId}/payment_requests/drafts/{draftPaymentRequestId}/evidences/{evidenceId}/file`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"draftPaymentRequestId"}}`, encodeURIComponent(String(draftPaymentRequestId)))
                .replace(`{${"evidenceId"}}`, encodeURIComponent(String(evidenceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (inPdf !== undefined) {
                localVarQueryParameter['inPdf'] = inPdf;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get draft payment requests only created own
         * @param {string} organizationId 
         * @param {string} [xUpsidrSwitchUser] 
         * @param {string} [freeWord] A keyword used to search the following fields for partial matches:  - supplier name  - requestor name  - memo  - accounting items  - sections
         * @param {number} [limit] 
         * @param {number} [offset] See the description of &#x60;cursor&#x60; section Pagination
         * @param {string} [cursor] Pagination is performed by specifying either offset or cursor; if neither offset nor cursor is specified, it is assumed to be cursor-pagination and the first page is obtained with the next cursor. See below how the pagination exactly behaves:  - \&quot;\&quot; ... Get the fist page and return the next cursor  - \&quot;offset&#x3D;50\&quot; ... Get from the specified offset and never return the next cursor  - \&quot;cursor&#x3D;xxx\&quot; ... Get from the specified cursor  - \&quot;offset&#x3D;50&amp;cursor&#x3D;xxx\&quot; ... Ignore the offset and get from the specified cursor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDraftPaymentRequestsOnlyCreatedOwn: async (organizationId: string, xUpsidrSwitchUser?: string, freeWord?: string, limit?: number, offset?: number, cursor?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getDraftPaymentRequestsOnlyCreatedOwn', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/payment_requests/drafts`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (freeWord !== undefined) {
                localVarQueryParameter['freeWord'] = freeWord;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }

            if (xUpsidrSwitchUser != null) {
                localVarHeaderParameter['X-Upsidr-Switch-User'] = String(xUpsidrSwitchUser);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get earliest expiring guarantee money for organization
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEarliestExpiringGuaranteeMoneyForOrganization: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getEarliestExpiringGuaranteeMoneyForOrganization', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/guarantee_money_deposits/upcoming_expiration`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Obtain email notification configuration information for each user.
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmailNotifications: async (userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getEmailNotifications', 'userId', userId)
            const localVarPath = `/users/{userId}/email_notifications`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get error bills
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getErrorBills: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/error-bills`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the evidence specified by evidenceId.
         * @summary Get a specific evidence.
         * @param {string} organizationId 
         * @param {string} evidenceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvidence: async (organizationId: string, evidenceId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getEvidence', 'organizationId', organizationId)
            // verify required parameter 'evidenceId' is not null or undefined
            assertParamExists('getEvidence', 'evidenceId', evidenceId)
            const localVarPath = `/organizations/{organizationId}/evidences/{evidenceId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"evidenceId"}}`, encodeURIComponent(String(evidenceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get evidence file
         * @param {string} organizationId 
         * @param {string} evidenceId 
         * @param {boolean} [inPdf] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvidenceFile: async (organizationId: string, evidenceId: string, inPdf?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getEvidenceFile', 'organizationId', organizationId)
            // verify required parameter 'evidenceId' is not null or undefined
            assertParamExists('getEvidenceFile', 'evidenceId', evidenceId)
            const localVarPath = `/organizations/{organizationId}/evidences/{evidenceId}/file`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"evidenceId"}}`, encodeURIComponent(String(evidenceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (inPdf !== undefined) {
                localVarQueryParameter['inPdf'] = inPdf;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get evidence image
         * @param {string} organizationId 
         * @param {string} paymentReferenceId 
         * @param {string} cardTransactionEvidenceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvidenceImage: async (organizationId: string, paymentReferenceId: string, cardTransactionEvidenceId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getEvidenceImage', 'organizationId', organizationId)
            // verify required parameter 'paymentReferenceId' is not null or undefined
            assertParamExists('getEvidenceImage', 'paymentReferenceId', paymentReferenceId)
            // verify required parameter 'cardTransactionEvidenceId' is not null or undefined
            assertParamExists('getEvidenceImage', 'cardTransactionEvidenceId', cardTransactionEvidenceId)
            const localVarPath = `/organizations/{organizationId}/cards/transactions/{paymentReferenceId}/evidence/{cardTransactionEvidenceId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"paymentReferenceId"}}`, encodeURIComponent(String(paymentReferenceId)))
                .replace(`{${"cardTransactionEvidenceId"}}`, encodeURIComponent(String(cardTransactionEvidenceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get evidence information for card transactions
         * @param {string} organizationId 
         * @param {string} paymentReferenceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvidenceInformationForCardTransactions: async (organizationId: string, paymentReferenceId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getEvidenceInformationForCardTransactions', 'organizationId', organizationId)
            // verify required parameter 'paymentReferenceId' is not null or undefined
            assertParamExists('getEvidenceInformationForCardTransactions', 'paymentReferenceId', paymentReferenceId)
            const localVarPath = `/organizations/{organizationId}/cards/transactions/{paymentReferenceId}/evidence/request/info`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"paymentReferenceId"}}`, encodeURIComponent(String(paymentReferenceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get evidence record image
         * @param {string} organizationId 
         * @param {string} evidenceId 
         * @param {string} recordId 
         * @param {boolean} [inPdf] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvidenceRecordImage: async (organizationId: string, evidenceId: string, recordId: string, inPdf?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getEvidenceRecordImage', 'organizationId', organizationId)
            // verify required parameter 'evidenceId' is not null or undefined
            assertParamExists('getEvidenceRecordImage', 'evidenceId', evidenceId)
            // verify required parameter 'recordId' is not null or undefined
            assertParamExists('getEvidenceRecordImage', 'recordId', recordId)
            const localVarPath = `/organizations/{organizationId}/evidences/{evidenceId}/records/{recordId}/file`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"evidenceId"}}`, encodeURIComponent(String(evidenceId)))
                .replace(`{${"recordId"}}`, encodeURIComponent(String(recordId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (inPdf !== undefined) {
                localVarQueryParameter['inPdf'] = inPdf;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get evidence records
         * @param {string} organizationId 
         * @param {string} evidenceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvidenceRecords: async (organizationId: string, evidenceId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getEvidenceRecords', 'organizationId', organizationId)
            // verify required parameter 'evidenceId' is not null or undefined
            assertParamExists('getEvidenceRecords', 'evidenceId', evidenceId)
            const localVarPath = `/organizations/{organizationId}/evidences/{evidenceId}/records`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"evidenceId"}}`, encodeURIComponent(String(evidenceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get evidence zip for the organization.
         * @param {string} organizationId 
         * @param {string} yearMonth 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvidenceZipForTheOrganization: async (organizationId: string, yearMonth: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getEvidenceZipForTheOrganization', 'organizationId', organizationId)
            // verify required parameter 'yearMonth' is not null or undefined
            assertParamExists('getEvidenceZipForTheOrganization', 'yearMonth', yearMonth)
            const localVarPath = `/organizations/{organizationId}/accounting/download_evidences`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (yearMonth !== undefined) {
                localVarQueryParameter['yearMonth'] = yearMonth;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get evidences
         * @param {string} organizationId 
         * @param {string} paymentReferenceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvidences: async (organizationId: string, paymentReferenceId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getEvidences', 'organizationId', organizationId)
            // verify required parameter 'paymentReferenceId' is not null or undefined
            assertParamExists('getEvidences', 'paymentReferenceId', paymentReferenceId)
            const localVarPath = `/organizations/{organizationId}/cards/transactions/{paymentReferenceId}/evidence`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"paymentReferenceId"}}`, encodeURIComponent(String(paymentReferenceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Count evidences
         * @param {string} organizationId 
         * @param {string} [issuer] This parameter will be deleted soon. Use keyword instead. If you specify this parameter, it will behave like the keyword, that is, it is searched from note as well as issuer.
         * @param {number} [amountMin] 
         * @param {number} [amountMax] 
         * @param {string} [paidAtFrom] 
         * @param {string} [paidAtTo] 
         * @param {boolean} [irrelevantToLedger] 
         * @param {string} [keyword] Specified keyword is searched from the issuer and the note by partial match.
         * @param {boolean} [includesDeleted] 
         * @param {Array<'VALID' | 'INVALID' | 'INPUT_REQUIRED' | 'OUT_OF_TARGET'>} [legalValidities] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvidencesCount: async (organizationId: string, issuer?: string, amountMin?: number, amountMax?: number, paidAtFrom?: string, paidAtTo?: string, irrelevantToLedger?: boolean, keyword?: string, includesDeleted?: boolean, legalValidities?: Array<'VALID' | 'INVALID' | 'INPUT_REQUIRED' | 'OUT_OF_TARGET'>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getEvidencesCount', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/evidences/count`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (issuer !== undefined) {
                localVarQueryParameter['issuer'] = issuer;
            }

            if (amountMin !== undefined) {
                localVarQueryParameter['amountMin'] = amountMin;
            }

            if (amountMax !== undefined) {
                localVarQueryParameter['amountMax'] = amountMax;
            }

            if (paidAtFrom !== undefined) {
                localVarQueryParameter['paidAtFrom'] = (paidAtFrom as any instanceof Date) ?
                    (paidAtFrom as any).toISOString() :
                    paidAtFrom;
            }

            if (paidAtTo !== undefined) {
                localVarQueryParameter['paidAtTo'] = (paidAtTo as any instanceof Date) ?
                    (paidAtTo as any).toISOString() :
                    paidAtTo;
            }

            if (irrelevantToLedger !== undefined) {
                localVarQueryParameter['irrelevantToLedger'] = irrelevantToLedger;
            }

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }

            if (includesDeleted !== undefined) {
                localVarQueryParameter['includesDeleted'] = includesDeleted;
            }

            if (legalValidities) {
                localVarQueryParameter['legalValidities'] = legalValidities;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the triggered transactions of a fraud locked card
         * @param {string} organizationId 
         * @param {string} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFraudLockedCardTransactions: async (organizationId: string, cardId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getFraudLockedCardTransactions', 'organizationId', organizationId)
            // verify required parameter 'cardId' is not null or undefined
            assertParamExists('getFraudLockedCardTransactions', 'cardId', cardId)
            const localVarPath = `/organizations/{organizationId}/cards/{cardId}/lock_on_fraud_detected/transaction`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"cardId"}}`, encodeURIComponent(String(cardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get freee account items
         * @param {string} organizationId 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFreeeAccountItems: async (organizationId: string, companyId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getFreeeAccountItems', 'organizationId', organizationId)
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('getFreeeAccountItems', 'companyId', companyId)
            const localVarPath = `/organizations/{organizationId}/freee/{companyId}/account_items`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get freee companies
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFreeeCompanies: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getFreeeCompanies', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/freee/companies`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get freee connected
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFreeeConnected: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getFreeeConnected', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/freee/connected`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Freee Connected User
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFreeeConnectedUser: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getFreeeConnectedUser', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/freee/connected_user`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get freee items
         * @param {string} organizationId 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFreeeItems: async (organizationId: string, companyId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getFreeeItems', 'organizationId', organizationId)
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('getFreeeItems', 'companyId', companyId)
            const localVarPath = `/organizations/{organizationId}/freee/{companyId}/items`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get freee memo tags
         * @param {string} organizationId 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFreeeMemoTags: async (organizationId: string, companyId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getFreeeMemoTags', 'organizationId', organizationId)
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('getFreeeMemoTags', 'companyId', companyId)
            const localVarPath = `/organizations/{organizationId}/freee/{companyId}/memo_tags`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get freee partners
         * @param {string} organizationId 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFreeePartners: async (organizationId: string, companyId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getFreeePartners', 'organizationId', organizationId)
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('getFreeePartners', 'companyId', companyId)
            const localVarPath = `/organizations/{organizationId}/freee/{companyId}/partners`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get freee sections
         * @param {string} organizationId 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFreeeSections: async (organizationId: string, companyId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getFreeeSections', 'organizationId', organizationId)
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('getFreeeSections', 'companyId', companyId)
            const localVarPath = `/organizations/{organizationId}/freee/{companyId}/sections`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get freee segment tags
         * @param {string} organizationId 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFreeeSegmentTags: async (organizationId: string, companyId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getFreeeSegmentTags', 'organizationId', organizationId)
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('getFreeeSegmentTags', 'companyId', companyId)
            const localVarPath = `/organizations/{organizationId}/freee/{companyId}/segment_tags`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get freee sync status
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFreeeSyncStatus: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getFreeeSyncStatus', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/freee/sync_status`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get freee tags
         * @param {string} organizationId 
         * @param {string} companyId 
         * @param {string} tagName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFreeeTags: async (organizationId: string, companyId: string, tagName: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getFreeeTags', 'organizationId', organizationId)
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('getFreeeTags', 'companyId', companyId)
            // verify required parameter 'tagName' is not null or undefined
            assertParamExists('getFreeeTags', 'tagName', tagName)
            const localVarPath = `/organizations/{organizationId}/freee/{companyId}/tags`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
                .replace(`{${"tagName"}}`, encodeURIComponent(String(tagName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get freee taxes
         * @param {string} organizationId 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFreeeTaxes: async (organizationId: string, companyId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getFreeeTaxes', 'organizationId', organizationId)
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('getFreeeTaxes', 'companyId', companyId)
            const localVarPath = `/organizations/{organizationId}/freee/{companyId}/taxes`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get freee token
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFreeeToken: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getFreeeToken', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/freee/token`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a guarantee money balance history
         * @param {string} organizationId 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGuaranteeMoneyBalanceHistory: async (organizationId: string, limit?: number, offset?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getGuaranteeMoneyBalanceHistory', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/guarantee_money_balance_history`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a guarantee money balance information for a organization
         * @param {string} organizationId 
         * @param {string} [targetDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGuaranteeMoneyBalanceInformationForOrganization: async (organizationId: string, targetDate?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getGuaranteeMoneyBalanceInformationForOrganization', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/guarantee_money_balance`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (targetDate !== undefined) {
                localVarQueryParameter['targetDate'] = targetDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get guarantee money deposits for organization
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGuaranteeMoneyDepositsForOrganization: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getGuaranteeMoneyDepositsForOrganization', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/guarantee_money_deposits`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [from] yyyy-MM-dd format date in JST.
         * @param {string} [to] yyyy-MM-dd format date in JST.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHolidays: async (from?: string, to?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/holidays`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = to;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIdentifyVerificationsLatest: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getIdentifyVerificationsLatest', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/identity_verifications/latest`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIdentityVerifications: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getIdentityVerifications', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/identity_verifications`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Invoice List
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoiceList: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getInvoiceList', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/invoices`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Invoice Pdf
         * @param {string} organizationId 
         * @param {string} yearMonth 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoicePdf: async (organizationId: string, yearMonth: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getInvoicePdf', 'organizationId', organizationId)
            // verify required parameter 'yearMonth' is not null or undefined
            assertParamExists('getInvoicePdf', 'yearMonth', yearMonth)
            const localVarPath = `/organizations/{organizationId}/invoices/{yearMonth}.pdf`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"yearMonth"}}`, encodeURIComponent(String(yearMonth)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get issuable status
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIssuableStatus: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getIssuableStatus', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/cards/issuable_status`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get jwt for SSO
         * @param {string} nonce 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJwtSso: async (nonce: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nonce' is not null or undefined
            assertParamExists('getJwtSso', 'nonce', nonce)
            const localVarPath = `/sso/jwt`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nonce !== undefined) {
                localVarQueryParameter['nonce'] = nonce;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get list of KYC reader users ordered by creation date in descending order.
         * @summary Get KYC Reader Users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getKycReaderUsers: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/zeus/users/kyc_reader`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get latest time of sync to freee
         * @param {string} organizationId 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestTimeOfSyncToFreee: async (organizationId: string, companyId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getLatestTimeOfSyncToFreee', 'organizationId', organizationId)
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('getLatestTimeOfSyncToFreee', 'companyId', companyId)
            const localVarPath = `/organizations/{organizationId}/freee/{companyId}/latest_sync_time`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get lock status of evidences
         * @param {string} organizationId 
         * @param {string} yearMonth 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLockStatusOfEvidences: async (organizationId: string, yearMonth: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getLockStatusOfEvidences', 'organizationId', organizationId)
            // verify required parameter 'yearMonth' is not null or undefined
            assertParamExists('getLockStatusOfEvidences', 'yearMonth', yearMonth)
            const localVarPath = `/organizations/{organizationId}/cards/transactions/evidence/lock`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (yearMonth !== undefined) {
                localVarQueryParameter['yearMonth'] = yearMonth;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get merchant general blocks
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMerchantGeneralBlock: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/merchant_general_block_lists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get merchant general block detail
         * @param {string} merchantGeneralBlockListId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMerchantGeneralBlockDetail: async (merchantGeneralBlockListId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantGeneralBlockListId' is not null or undefined
            assertParamExists('getMerchantGeneralBlockDetail', 'merchantGeneralBlockListId', merchantGeneralBlockListId)
            const localVarPath = `/merchant_general_block_lists/{merchantGeneralBlockListId}`
                .replace(`{${"merchantGeneralBlockListId"}}`, encodeURIComponent(String(merchantGeneralBlockListId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get merchant org blocks
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMerchantOrgBlock: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/merchant_org_block_lists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get merchant org block list
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMerchantOrgBlockList: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getMerchantOrgBlockList', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/merchant_org_block_lists`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get merchant organization user account year month summary
         * @param {string} organizationId 
         * @param {string} merchantId 
         * @param {string} userAccountId 
         * @param {string} toYearMonth 
         * @param {string} [fromYearMonth] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMerchantOrganizationUserAccountYearMonthSummary: async (organizationId: string, merchantId: string, userAccountId: string, toYearMonth: string, fromYearMonth?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getMerchantOrganizationUserAccountYearMonthSummary', 'organizationId', organizationId)
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('getMerchantOrganizationUserAccountYearMonthSummary', 'merchantId', merchantId)
            // verify required parameter 'userAccountId' is not null or undefined
            assertParamExists('getMerchantOrganizationUserAccountYearMonthSummary', 'userAccountId', userAccountId)
            // verify required parameter 'toYearMonth' is not null or undefined
            assertParamExists('getMerchantOrganizationUserAccountYearMonthSummary', 'toYearMonth', toYearMonth)
            const localVarPath = `/organizations/{organizationId}/merchants/{merchantId}/user_accounts/{userAccountId}/user_account_year_month_summary`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"merchantId"}}`, encodeURIComponent(String(merchantId)))
                .replace(`{${"userAccountId"}}`, encodeURIComponent(String(userAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fromYearMonth !== undefined) {
                localVarQueryParameter['fromYearMonth'] = fromYearMonth;
            }

            if (toYearMonth !== undefined) {
                localVarQueryParameter['toYearMonth'] = toYearMonth;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a list of MerchantCategoryKind
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMerchantsCategoryKinds: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getMerchantsCategoryKinds', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/merchants/category_kinds`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Modifiable Daily Limits For The User Account
         * @param {string} userAccountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getModifiableDailyLimitsForTheUserAccount: async (userAccountId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userAccountId' is not null or undefined
            assertParamExists('getModifiableDailyLimitsForTheUserAccount', 'userAccountId', userAccountId)
            const localVarPath = `/user_accounts/{userAccountId}/modifiable_limit/daily_limits`
                .replace(`{${"userAccountId"}}`, encodeURIComponent(String(userAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get modifiable monthly limits for the user account
         * @param {string} userAccountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getModifiableMonthlyLimitsForTheUserAccount: async (userAccountId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userAccountId' is not null or undefined
            assertParamExists('getModifiableMonthlyLimitsForTheUserAccount', 'userAccountId', userAccountId)
            const localVarPath = `/user_accounts/{userAccountId}/modifiable_limit/monthly_limits`
                .replace(`{${"userAccountId"}}`, encodeURIComponent(String(userAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Modifiable Transaction Limits For The User Account
         * @param {string} userAccountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getModifiableTransactionLimitsForTheUserAccount: async (userAccountId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userAccountId' is not null or undefined
            assertParamExists('getModifiableTransactionLimitsForTheUserAccount', 'userAccountId', userAccountId)
            const localVarPath = `/user_accounts/{userAccountId}/modifiable_limit/transaction_limits`
                .replace(`{${"userAccountId"}}`, encodeURIComponent(String(userAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get moneytree connected
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMoneytreeConnected: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getMoneytreeConnected', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/moneytree/connected`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get moneytree oauth url
         * @param {string} organizationId 
         * @param {string} [nextTo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMoneytreeOauthUrl: async (organizationId: string, nextTo?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getMoneytreeOauthUrl', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/moneytree/oauth_url`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nextTo !== undefined) {
                localVarQueryParameter['next_to'] = nextTo;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get moneytree status
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMoneytreeStatus: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getMoneytreeStatus', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/moneytree/status`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get monthly card bills for specified yearMonths
         * @param {string} organizationId 
         * @param {string} [yearMonth] 
         * @param {string} [startYearMonth] 
         * @param {string} [endYearMonth] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMonthlyCardBill: async (organizationId: string, yearMonth?: string, startYearMonth?: string, endYearMonth?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getMonthlyCardBill', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/cards/monthly_card_bill`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (yearMonth !== undefined) {
                localVarQueryParameter['yearMonth'] = yearMonth;
            }

            if (startYearMonth !== undefined) {
                localVarQueryParameter['startYearMonth'] = startYearMonth;
            }

            if (endYearMonth !== undefined) {
                localVarQueryParameter['endYearMonth'] = endYearMonth;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get monthly card transactions for the organization.
         * @param {string} organizationId 
         * @param {string} yearMonth 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMonthlyCardTransactionsForTheOrganization: async (organizationId: string, yearMonth: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getMonthlyCardTransactionsForTheOrganization', 'organizationId', organizationId)
            // verify required parameter 'yearMonth' is not null or undefined
            assertParamExists('getMonthlyCardTransactionsForTheOrganization', 'yearMonth', yearMonth)
            const localVarPath = `/organizations/{organizationId}/cards/monthly_transactions`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (yearMonth !== undefined) {
                localVarQueryParameter['yearMonth'] = yearMonth;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get monthly user card summaries
         * @param {string} organizationId 
         * @param {string} yearMonth 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMonthlyUserCardSummaries: async (organizationId: string, yearMonth: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getMonthlyUserCardSummaries', 'organizationId', organizationId)
            // verify required parameter 'yearMonth' is not null or undefined
            assertParamExists('getMonthlyUserCardSummaries', 'yearMonth', yearMonth)
            const localVarPath = `/organizations/{organizationId}/cards/monthly_user_card_summaries`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (yearMonth !== undefined) {
                localVarQueryParameter['yearMonth'] = yearMonth;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a specific onboarding request for zeus
         * @param {string} onboardingRequestId The ID of the onboarding request to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOnboardingRequestById: async (onboardingRequestId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'onboardingRequestId' is not null or undefined
            assertParamExists('getOnboardingRequestById', 'onboardingRequestId', onboardingRequestId)
            const localVarPath = `/zeus/onboarding_requests/{onboardingRequestId}`
                .replace(`{${"onboardingRequestId"}}`, encodeURIComponent(String(onboardingRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get personal information of the onboarding request.
         * @summary Get Personal Information
         * @param {string} onboardingRequestId Onboarding request ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOnboardingRequestPersonalInfo: async (onboardingRequestId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'onboardingRequestId' is not null or undefined
            assertParamExists('getOnboardingRequestPersonalInfo', 'onboardingRequestId', onboardingRequestId)
            const localVarPath = `/zeus/onboarding_requests/{onboardingRequestId}/personal_info`
                .replace(`{${"onboardingRequestId"}}`, encodeURIComponent(String(onboardingRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get onboarding requests for zeus
         * @param {string} [key] 
         * @param {string} [createdAtFrom] 
         * @param {string} [createdAtTo] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {'id' | 'createdAt' | 'updatedAt'} [sort] 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOnboardingRequests: async (key?: string, createdAtFrom?: string, createdAtTo?: string, limit?: number, offset?: number, sort?: 'id' | 'createdAt' | 'updatedAt', order?: 'ASC' | 'DESC', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/zeus/onboarding_requests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (key !== undefined) {
                localVarQueryParameter['key'] = key;
            }

            if (createdAtFrom !== undefined) {
                localVarQueryParameter['createdAtFrom'] = (createdAtFrom as any instanceof Date) ?
                    (createdAtFrom as any).toISOString() :
                    createdAtFrom;
            }

            if (createdAtTo !== undefined) {
                localVarQueryParameter['createdAtTo'] = (createdAtTo as any instanceof Date) ?
                    (createdAtTo as any).toISOString() :
                    createdAtTo;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get org account state
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrgAccountState: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getOrgAccountState', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/account_state`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Organization
         * @param {string} organizationId 
         * @param {boolean} [underContractOnly] 
         * @param {boolean} [withCredit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganization: async (organizationId: string, underContractOnly?: boolean, withCredit?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getOrganization', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"underContractOnly"}}`, encodeURIComponent(String(underContractOnly)))
                .replace(`{${"withCredit"}}`, encodeURIComponent(String(withCredit)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Organization Accounting Csv Fields Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationAccountingCsvFieldsTypes: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/organizations/cards/accounting/csv_field_types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get organization cards extended
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationCardsExtended: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getOrganizationCardsExtended', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/cards/extended`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get organization cards light
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationCardsLight: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getOrganizationCardsLight', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/cards/light`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get organization chart departments
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationChartDepartments: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getOrganizationChartDepartments', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/workflows/organization_charts/departments`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get organization chart employees
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationChartEmployees: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getOrganizationChartEmployees', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/workflows/organization_charts/employees`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get organization chart roles
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationChartRoles: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getOrganizationChartRoles', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/workflows/organization_charts/roles`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get organizations create requests for zeus
         * @param {string} [key] 
         * @param {string} [createdAtFrom] 
         * @param {string} [createdAtTo] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {'id' | 'createdAt' | 'updatedAt'} [sort] 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationCreateRequests: async (key?: string, createdAtFrom?: string, createdAtTo?: string, limit?: number, offset?: number, sort?: 'id' | 'createdAt' | 'updatedAt', order?: 'ASC' | 'DESC', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/zeus/organization_create_requests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (key !== undefined) {
                localVarQueryParameter['key'] = key;
            }

            if (createdAtFrom !== undefined) {
                localVarQueryParameter['createdAtFrom'] = (createdAtFrom as any instanceof Date) ?
                    (createdAtFrom as any).toISOString() :
                    createdAtFrom;
            }

            if (createdAtTo !== undefined) {
                localVarQueryParameter['createdAtTo'] = (createdAtTo as any instanceof Date) ?
                    (createdAtTo as any).toISOString() :
                    createdAtTo;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Organization Me
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationMe: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/organizations/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get organization payment schemes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationPaymentSchemes: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/organizations/payment_schemes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get organization payments
         * @param {string} organizationId 
         * @param {string} [yearMonth] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationPayments: async (organizationId: string, yearMonth?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getOrganizationPayments', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/payments`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (yearMonth !== undefined) {
                localVarQueryParameter['yearMonth'] = yearMonth;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizations: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/organizations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Organizations Accounting Csv Export Fields
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationsAccountingCsvExportFields: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getOrganizationsAccountingCsvExportFields', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/cards/accounting/csv_export_fields`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a organization\'s bill
         * @param {string} organizationId 
         * @param {boolean} [beforeReservationOnly] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationsBills: async (organizationId: string, beforeReservationOnly?: boolean, limit?: number, offset?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getOrganizationsBills', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/bills`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (beforeReservationOnly !== undefined) {
                localVarQueryParameter['beforeReservationOnly'] = beforeReservationOnly;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get organizations deals
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationsDeals: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getOrganizationsDeals', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/deals`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get payment request detail
         * @param {string} organizationId 
         * @param {string} [paymentRequestId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentRequestDetail: async (organizationId: string, paymentRequestId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getPaymentRequestDetail', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/payment_requests/{paymentRequestId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"paymentRequestId"}}`, encodeURIComponent(String(paymentRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a payment request evidence specified by evidenceId.
         * @summary Get a specific payment request evidence.
         * @param {string} organizationId 
         * @param {string} paymentRequestId 
         * @param {string} evidenceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentRequestEvidence: async (organizationId: string, paymentRequestId: string, evidenceId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getPaymentRequestEvidence', 'organizationId', organizationId)
            // verify required parameter 'paymentRequestId' is not null or undefined
            assertParamExists('getPaymentRequestEvidence', 'paymentRequestId', paymentRequestId)
            // verify required parameter 'evidenceId' is not null or undefined
            assertParamExists('getPaymentRequestEvidence', 'evidenceId', evidenceId)
            const localVarPath = `/organizations/{organizationId}/payment_requests/{paymentRequestId}/evidences/{evidenceId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"paymentRequestId"}}`, encodeURIComponent(String(paymentRequestId)))
                .replace(`{${"evidenceId"}}`, encodeURIComponent(String(evidenceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get payment request evidence file
         * @param {string} organizationId 
         * @param {string} paymentRequestId 
         * @param {string} evidenceId 
         * @param {boolean} [inPdf] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentRequestEvidenceFile: async (organizationId: string, paymentRequestId: string, evidenceId: string, inPdf?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getPaymentRequestEvidenceFile', 'organizationId', organizationId)
            // verify required parameter 'paymentRequestId' is not null or undefined
            assertParamExists('getPaymentRequestEvidenceFile', 'paymentRequestId', paymentRequestId)
            // verify required parameter 'evidenceId' is not null or undefined
            assertParamExists('getPaymentRequestEvidenceFile', 'evidenceId', evidenceId)
            const localVarPath = `/organizations/{organizationId}/payment_requests/{paymentRequestId}/evidences/{evidenceId}/file`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"paymentRequestId"}}`, encodeURIComponent(String(paymentRequestId)))
                .replace(`{${"evidenceId"}}`, encodeURIComponent(String(evidenceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (inPdf !== undefined) {
                localVarQueryParameter['inPdf'] = inPdf;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get payment request evidence record file
         * @param {string} organizationId 
         * @param {string} paymentRequestId 
         * @param {string} evidenceId 
         * @param {string} recordId 
         * @param {boolean} [inPdf] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentRequestEvidenceRecordFile: async (organizationId: string, paymentRequestId: string, evidenceId: string, recordId: string, inPdf?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getPaymentRequestEvidenceRecordFile', 'organizationId', organizationId)
            // verify required parameter 'paymentRequestId' is not null or undefined
            assertParamExists('getPaymentRequestEvidenceRecordFile', 'paymentRequestId', paymentRequestId)
            // verify required parameter 'evidenceId' is not null or undefined
            assertParamExists('getPaymentRequestEvidenceRecordFile', 'evidenceId', evidenceId)
            // verify required parameter 'recordId' is not null or undefined
            assertParamExists('getPaymentRequestEvidenceRecordFile', 'recordId', recordId)
            const localVarPath = `/organizations/{organizationId}/payment_requests/{paymentRequestId}/evidences/{evidenceId}/records/{recordId}/file`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"paymentRequestId"}}`, encodeURIComponent(String(paymentRequestId)))
                .replace(`{${"evidenceId"}}`, encodeURIComponent(String(evidenceId)))
                .replace(`{${"recordId"}}`, encodeURIComponent(String(recordId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (inPdf !== undefined) {
                localVarQueryParameter['inPdf'] = inPdf;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get payment request evidence records
         * @param {string} organizationId 
         * @param {string} paymentRequestId 
         * @param {string} evidenceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentRequestEvidenceRecords: async (organizationId: string, paymentRequestId: string, evidenceId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getPaymentRequestEvidenceRecords', 'organizationId', organizationId)
            // verify required parameter 'paymentRequestId' is not null or undefined
            assertParamExists('getPaymentRequestEvidenceRecords', 'paymentRequestId', paymentRequestId)
            // verify required parameter 'evidenceId' is not null or undefined
            assertParamExists('getPaymentRequestEvidenceRecords', 'evidenceId', evidenceId)
            const localVarPath = `/organizations/{organizationId}/payment_requests/{paymentRequestId}/evidences/{evidenceId}/records`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"paymentRequestId"}}`, encodeURIComponent(String(paymentRequestId)))
                .replace(`{${"evidenceId"}}`, encodeURIComponent(String(evidenceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get all evidences for a specific payment request
         * @param {string} organizationId 
         * @param {string} paymentRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentRequestEvidences: async (organizationId: string, paymentRequestId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getPaymentRequestEvidences', 'organizationId', organizationId)
            // verify required parameter 'paymentRequestId' is not null or undefined
            assertParamExists('getPaymentRequestEvidences', 'paymentRequestId', paymentRequestId)
            const localVarPath = `/organizations/{organizationId}/payment_requests/{paymentRequestId}/evidences`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"paymentRequestId"}}`, encodeURIComponent(String(paymentRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get payment requests bank accounts list
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentRequestsBankAccountsList: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getPaymentRequestsBankAccountsList', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/payment_requests/bank_accounts`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get payment requests count linked bank transfer
         * @param {string} organizationId 
         * @param {string} paymentRequestIds When specifying more than one, separate them by commas.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentRequestsCountLinkedBankTransfer: async (organizationId: string, paymentRequestIds: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getPaymentRequestsCountLinkedBankTransfer', 'organizationId', organizationId)
            // verify required parameter 'paymentRequestIds' is not null or undefined
            assertParamExists('getPaymentRequestsCountLinkedBankTransfer', 'paymentRequestIds', paymentRequestIds)
            const localVarPath = `/organizations/{organizationId}/payment_requests/linked_bank_transfers/count`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (paymentRequestIds !== undefined) {
                localVarQueryParameter['paymentRequestIds'] = paymentRequestIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get pinretriever decrypt pin block
         * @param {GetPinretrieverDecryptPinBlockRequest} getPinretrieverDecryptPinBlockRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPinretrieverDecryptPinBlock: async (getPinretrieverDecryptPinBlockRequest: GetPinretrieverDecryptPinBlockRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'getPinretrieverDecryptPinBlockRequest' is not null or undefined
            assertParamExists('getPinretrieverDecryptPinBlock', 'getPinretrieverDecryptPinBlockRequest', getPinretrieverDecryptPinBlockRequest)
            const localVarPath = `/pinretriever/decrypt_pin_block`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getPinretrieverDecryptPinBlockRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get pinretriever encrypt pin
         * @param {GetPinretrieverEncryptPinRequest} getPinretrieverEncryptPinRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPinretrieverEncryptPin: async (getPinretrieverEncryptPinRequest: GetPinretrieverEncryptPinRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'getPinretrieverEncryptPinRequest' is not null or undefined
            assertParamExists('getPinretrieverEncryptPin', 'getPinretrieverEncryptPinRequest', getPinretrieverEncryptPinRequest)
            const localVarPath = `/pinretriever/encrypt_pin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getPinretrieverEncryptPinRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get pinretriever hsm publickey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPinretrieverHsmPublickey: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/pinretriever/hsm_publickey`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get purchase application
         * @param {string} organizationId 
         * @param {string} purchaseApplicationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPurchaseApplication: async (organizationId: string, purchaseApplicationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getPurchaseApplication', 'organizationId', organizationId)
            // verify required parameter 'purchaseApplicationId' is not null or undefined
            assertParamExists('getPurchaseApplication', 'purchaseApplicationId', purchaseApplicationId)
            const localVarPath = `/organizations/{organizationId}/purchase_applications/{purchaseApplicationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"purchaseApplicationId"}}`, encodeURIComponent(String(purchaseApplicationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get purchase application templates
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPurchaseApplicationTemplates: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getPurchaseApplicationTemplates', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/purchase_applications/templates`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get purchase application templates detail
         * @param {string} organizationId 
         * @param {string} purchaseTemplateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPurchaseApplicationTemplatesDetail: async (organizationId: string, purchaseTemplateId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getPurchaseApplicationTemplatesDetail', 'organizationId', organizationId)
            // verify required parameter 'purchaseTemplateId' is not null or undefined
            assertParamExists('getPurchaseApplicationTemplatesDetail', 'purchaseTemplateId', purchaseTemplateId)
            const localVarPath = `/organizations/{organizationId}/purchase_applications/templates/{purchaseTemplateId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"purchaseTemplateId"}}`, encodeURIComponent(String(purchaseTemplateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get purchase applications
         * @param {string} organizationId 
         * @param {string} [yearMonth] 
         * @param {string} [visaTransactionReferenceId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPurchaseApplications: async (organizationId: string, yearMonth?: string, visaTransactionReferenceId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getPurchaseApplications', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/purchase_applications`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (yearMonth !== undefined) {
                localVarQueryParameter['yearMonth'] = yearMonth;
            }

            if (visaTransactionReferenceId !== undefined) {
                localVarQueryParameter['visaTransactionReferenceId'] = visaTransactionReferenceId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPurchaseApplicationsRequestedCount: async (userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getPurchaseApplicationsRequestedCount', 'userId', userId)
            const localVarPath = `/users/{userId}/purchase_applications/requested/count`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the purchase applications requested list
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPurchaseApplicationsRequestedList: async (userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getPurchaseApplicationsRequestedList', 'userId', userId)
            const localVarPath = `/users/{userId}/purchase_applications/requested/list`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the purchase applications submitted self
         * @param {string} userId 
         * @param {string} yearMonth 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPurchaseApplicationsSubmittedSelf: async (userId: string, yearMonth: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getPurchaseApplicationsSubmittedSelf', 'userId', userId)
            // verify required parameter 'yearMonth' is not null or undefined
            assertParamExists('getPurchaseApplicationsSubmittedSelf', 'yearMonth', yearMonth)
            const localVarPath = `/users/{userId}/purchase_applications/submitted/self`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (yearMonth !== undefined) {
                localVarQueryParameter['yearMonth'] = yearMonth;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get(search) qualified invoice issuer
         * @param {string} registrationNumber 
         * @param {string} [issuerName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQualifiedInvoiceIssuer: async (registrationNumber: string, issuerName?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'registrationNumber' is not null or undefined
            assertParamExists('getQualifiedInvoiceIssuer', 'registrationNumber', registrationNumber)
            const localVarPath = `/qualified_invoice_issuers/{registrationNumber}`
                .replace(`{${"registrationNumber"}}`, encodeURIComponent(String(registrationNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (issuerName !== undefined) {
                localVarQueryParameter['issuerName'] = issuerName;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Redirect URL from Tiny URL
         * @param {string} tinyUrlParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRedirectUrlFromTinyUrl: async (tinyUrlParam: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tinyUrlParam' is not null or undefined
            assertParamExists('getRedirectUrlFromTinyUrl', 'tinyUrlParam', tinyUrlParam)
            const localVarPath = `/txn/{tinyUrlParam}`
                .replace(`{${"tinyUrlParam"}}`, encodeURIComponent(String(tinyUrlParam)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the reward points balance for the specified organization.
         * @summary Get reward points balance
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRewardPointBalance: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getRewardPointBalance', 'organizationId', organizationId)
            const localVarPath = `/zeus/organizations/{organizationId}/reward_points/balance`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get reward point transactions for the specified organization
         * @summary Get reward point transactions
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRewardPointTransactions: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getRewardPointTransactions', 'organizationId', organizationId)
            const localVarPath = `/zeus/organizations/{organizationId}/reward_points/transactions`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Rewards
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRewards: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/rewards`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get role resource for user
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoleResourceForUser: async (userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getRoleResourceForUser', 'userId', userId)
            const localVarPath = `/roles/user_account/users/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get roles
         * @param {string} category 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoles: async (category: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'category' is not null or undefined
            assertParamExists('getRoles', 'category', category)
            const localVarPath = `/roles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (category !== undefined) {
                localVarQueryParameter['category'] = category;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Roles with Top Related Resources
         * @param {string} resourceScope 
         * @param {string} resourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRolesWithTopRelatedResources: async (resourceScope: string, resourceId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resourceScope' is not null or undefined
            assertParamExists('getRolesWithTopRelatedResources', 'resourceScope', resourceScope)
            // verify required parameter 'resourceId' is not null or undefined
            assertParamExists('getRolesWithTopRelatedResources', 'resourceId', resourceId)
            const localVarPath = `/roles/user_account/{resourceScope}/{resourceId}/with_top_related_resources`
                .replace(`{${"resourceScope"}}`, encodeURIComponent(String(resourceScope)))
                .replace(`{${"resourceId"}}`, encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Roles with Top Related Resources by Organization id
         * @param {string} organizationId 
         * @param {string} resourceScope 
         * @param {string} resourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRolesWithTopRelatedResourcesByOrganizationId: async (organizationId: string, resourceScope: string, resourceId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getRolesWithTopRelatedResourcesByOrganizationId', 'organizationId', organizationId)
            // verify required parameter 'resourceScope' is not null or undefined
            assertParamExists('getRolesWithTopRelatedResourcesByOrganizationId', 'resourceScope', resourceScope)
            // verify required parameter 'resourceId' is not null or undefined
            assertParamExists('getRolesWithTopRelatedResourcesByOrganizationId', 'resourceId', resourceId)
            const localVarPath = `/roles/organizations/{organizationId}/user_account/{resourceScope}/{resourceId}/with_top_related_resources`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"resourceScope"}}`, encodeURIComponent(String(resourceScope)))
                .replace(`{${"resourceId"}}`, encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Slack card notification settings of an organization
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSlackCardNotificationSettings: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getSlackCardNotificationSettings', 'organizationId', organizationId)
            const localVarPath = `/slack/organizations/{organizationId}/cards/notifications`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a Slack channels of an organization by SlackChannelID
         * @param {string} organizationId 
         * @param {string} channelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSlackChannel: async (organizationId: string, channelId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getSlackChannel', 'organizationId', organizationId)
            // verify required parameter 'channelId' is not null or undefined
            assertParamExists('getSlackChannel', 'channelId', channelId)
            const localVarPath = `/slack/organizations/{organizationId}/channels/{channelId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"channelId"}}`, encodeURIComponent(String(channelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Slack channels of an organization
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSlackChannels: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getSlackChannels', 'organizationId', organizationId)
            const localVarPath = `/slack/organizations/{organizationId}/channels`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Slack channels with cursor of an organization
         * @param {string} organizationId 
         * @param {string} [cursor] This is used to provide paging in a cursor mode. If any value is specified, the channel after the cursor is retrieved; if the value is null, the first page is returned.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSlackChannelsWithCursor: async (organizationId: string, cursor?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getSlackChannelsWithCursor', 'organizationId', organizationId)
            const localVarPath = `/slack/organizations/{organizationId}/channels_with_cursor`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Slack evidence remind settings of an organization
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSlackEvidenceReminder: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getSlackEvidenceReminder', 'organizationId', organizationId)
            const localVarPath = `/slack/organizations/{organizationId}/cards/evidence_reminders`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Slack evidence remind settings of an slack channel
         * @param {string} organizationId 
         * @param {string} channelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSlackEvidenceReminderPerChannel: async (organizationId: string, channelId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getSlackEvidenceReminderPerChannel', 'organizationId', organizationId)
            // verify required parameter 'channelId' is not null or undefined
            assertParamExists('getSlackEvidenceReminderPerChannel', 'channelId', channelId)
            const localVarPath = `/slack/organizations/{organizationId}/cards/evidence_reminders/{channelId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"channelId"}}`, encodeURIComponent(String(channelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get slack notification channel setting for purchase-application
         * @param {string} organizationId 
         * @param {string} channelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSlackNotificationChannelSettingForPurchaseApplication: async (organizationId: string, channelId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getSlackNotificationChannelSettingForPurchaseApplication', 'organizationId', organizationId)
            // verify required parameter 'channelId' is not null or undefined
            assertParamExists('getSlackNotificationChannelSettingForPurchaseApplication', 'channelId', channelId)
            const localVarPath = `/slack/organizations/{organizationId}/channels/{channelId}/purchase_applications/notification`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"channelId"}}`, encodeURIComponent(String(channelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get slack notification settings for purchase-application
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSlackNotificationSettingsForPurchaseApplication: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getSlackNotificationSettingsForPurchaseApplication', 'organizationId', organizationId)
            const localVarPath = `/slack/organizations/{organizationId}/purchase_applications/notifications`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Slack team
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSlackTeam: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getSlackTeam', 'organizationId', organizationId)
            const localVarPath = `/slack/organizations/{organizationId}/team`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Slack version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSlackVersion: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/slack/version`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get submitted trustdock data
         * @param {string} trustdockIdentificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubmittedTrustdockData: async (trustdockIdentificationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'trustdockIdentificationId' is not null or undefined
            assertParamExists('getSubmittedTrustdockData', 'trustdockIdentificationId', trustdockIdentificationId)
            const localVarPath = `/organization_create_requests/submitted_data/{trustdockIdentificationId}`
                .replace(`{${"trustdockIdentificationId"}}`, encodeURIComponent(String(trustdockIdentificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get suspicious transaction detail list
         * @param {string} userAccountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSuspiciousTransactions: async (userAccountId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userAccountId' is not null or undefined
            assertParamExists('getSuspiciousTransactions', 'userAccountId', userAccountId)
            const localVarPath = `/users/cards/suspicious_fraud_transactions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (userAccountId !== undefined) {
                localVarQueryParameter['userAccountId'] = userAccountId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Teams card notification settings of an organization
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamsCardNotificationSettings: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getTeamsCardNotificationSettings', 'organizationId', organizationId)
            const localVarPath = `/teams/organizations/{organizationId}/cards/notifications`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Teams channels of an organization by TeamsChannelID
         * @param {string} organizationId 
         * @param {string} channelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamsChannel: async (organizationId: string, channelId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getTeamsChannel', 'organizationId', organizationId)
            // verify required parameter 'channelId' is not null or undefined
            assertParamExists('getTeamsChannel', 'channelId', channelId)
            const localVarPath = `/teams/organizations/{organizationId}/channels/{channelId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"channelId"}}`, encodeURIComponent(String(channelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Teams channels with cursor of an organization
         * @param {string} organizationId 
         * @param {string} [cursor] This is used to provide paging in a cursor mode. If any value is specified, the channel after the cursor is retrieved; if the value is null, the first page is returned.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamsChannelsWithCursor: async (organizationId: string, cursor?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getTeamsChannelsWithCursor', 'organizationId', organizationId)
            const localVarPath = `/teams/organizations/{organizationId}/channels_with_cursor`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Teams team
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamsTeam: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getTeamsTeam', 'organizationId', organizationId)
            const localVarPath = `/teams/organizations/{organizationId}/team`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Teams version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamsVersion: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/teams/version`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Technical Support Users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTechnicalSupportUsers: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/users/technical_support`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Tfa App QR Code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTfaAppQrCode: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/two_factor_auth/app/generate_qr_code`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTfaAppRecoveryCode: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/two_factor_auth/app/download_recovery_code`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get TFA SMS Recovery Code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTfaSmsRecoveryCode: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/two_factor_auth/sms/download_recovery_code`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the count of monthly transactions for the user account
         * @param {string} userAccountId 
         * @param {string} yearMonth 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTheCountOfMonthlyTransactionsForTheUserAccount: async (userAccountId: string, yearMonth: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userAccountId' is not null or undefined
            assertParamExists('getTheCountOfMonthlyTransactionsForTheUserAccount', 'userAccountId', userAccountId)
            // verify required parameter 'yearMonth' is not null or undefined
            assertParamExists('getTheCountOfMonthlyTransactionsForTheUserAccount', 'yearMonth', yearMonth)
            const localVarPath = `/user_accounts/{userAccountId}/cards/monthly_transactions/count`
                .replace(`{${"userAccountId"}}`, encodeURIComponent(String(userAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (yearMonth !== undefined) {
                localVarQueryParameter['yearMonth'] = yearMonth;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the user account information
         * @param {string} userAccountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTheUserAccountInformation: async (userAccountId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userAccountId' is not null or undefined
            assertParamExists('getTheUserAccountInformation', 'userAccountId', userAccountId)
            const localVarPath = `/user_accounts/{userAccountId}`
                .replace(`{${"userAccountId"}}`, encodeURIComponent(String(userAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get transaction evidence email address
         * @param {string} userAccountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransactionEvidenceEmailAddress: async (userAccountId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userAccountId' is not null or undefined
            assertParamExists('getTransactionEvidenceEmailAddress', 'userAccountId', userAccountId)
            const localVarPath = `/user_accounts/{userAccountId}/transaction_evidence_email_address`
                .replace(`{${"userAccountId"}}`, encodeURIComponent(String(userAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Transaction Evidence Email File
         * @param {string} userAccountId 
         * @param {number} transactionEvidenceEmailFileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransactionEvidenceEmailFile: async (userAccountId: string, transactionEvidenceEmailFileId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userAccountId' is not null or undefined
            assertParamExists('getTransactionEvidenceEmailFile', 'userAccountId', userAccountId)
            // verify required parameter 'transactionEvidenceEmailFileId' is not null or undefined
            assertParamExists('getTransactionEvidenceEmailFile', 'transactionEvidenceEmailFileId', transactionEvidenceEmailFileId)
            const localVarPath = `/user_accounts/{userAccountId}/transaction_evidence_files/{transactionEvidenceEmailFileId}`
                .replace(`{${"userAccountId"}}`, encodeURIComponent(String(userAccountId)))
                .replace(`{${"transactionEvidenceEmailFileId"}}`, encodeURIComponent(String(transactionEvidenceEmailFileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get transaction evidence emails
         * @param {string} userAccountId 
         * @param {string} startYearMonth 
         * @param {string} endYearMonth 
         * @param {boolean} [isTrash] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransactionEvidenceEmails: async (userAccountId: string, startYearMonth: string, endYearMonth: string, isTrash?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userAccountId' is not null or undefined
            assertParamExists('getTransactionEvidenceEmails', 'userAccountId', userAccountId)
            // verify required parameter 'startYearMonth' is not null or undefined
            assertParamExists('getTransactionEvidenceEmails', 'startYearMonth', startYearMonth)
            // verify required parameter 'endYearMonth' is not null or undefined
            assertParamExists('getTransactionEvidenceEmails', 'endYearMonth', endYearMonth)
            const localVarPath = `/transaction_evidence_emails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (userAccountId !== undefined) {
                localVarQueryParameter['userAccountId'] = userAccountId;
            }

            if (startYearMonth !== undefined) {
                localVarQueryParameter['startYearMonth'] = startYearMonth;
            }

            if (endYearMonth !== undefined) {
                localVarQueryParameter['endYearMonth'] = endYearMonth;
            }

            if (isTrash !== undefined) {
                localVarQueryParameter['isTrash'] = isTrash;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Trustdock Identity Verifications
         * @param {string} trustdockIdentificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrustdockIdentityVerifications: async (trustdockIdentificationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'trustdockIdentificationId' is not null or undefined
            assertParamExists('getTrustdockIdentityVerifications', 'trustdockIdentificationId', trustdockIdentificationId)
            const localVarPath = `/trustdock/{trustdockIdentificationId}/identity_verifications`
                .replace(`{${"trustdockIdentificationId"}}`, encodeURIComponent(String(trustdockIdentificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Trustdock Submit Identification Document Publish URL
         * @param {string} trustdockIdentificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrustdockSubmitIdentificationDocumentPublishUrl: async (trustdockIdentificationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'trustdockIdentificationId' is not null or undefined
            assertParamExists('getTrustdockSubmitIdentificationDocumentPublishUrl', 'trustdockIdentificationId', trustdockIdentificationId)
            const localVarPath = `/trustdock/submit_identification_document/{trustdockIdentificationId}/publish_url`
                .replace(`{${"trustdockIdentificationId"}}`, encodeURIComponent(String(trustdockIdentificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Trustdock Verifications
         * @param {string} trustdockIdentificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrustdockVerifications: async (trustdockIdentificationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'trustdockIdentificationId' is not null or undefined
            assertParamExists('getTrustdockVerifications', 'trustdockIdentificationId', trustdockIdentificationId)
            const localVarPath = `/trustdock/verifications/{trustdockIdentificationId}`
                .replace(`{${"trustdockIdentificationId"}}`, encodeURIComponent(String(trustdockIdentificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get unread message count for a user
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnreadMessageCount: async (userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUnreadMessageCount', 'userId', userId)
            const localVarPath = `/users/{userId}/user_messages/unread_count`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get an usage fee
         * @param {number} usageFeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsageFee: async (usageFeeId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'usageFeeId' is not null or undefined
            assertParamExists('getUsageFee', 'usageFeeId', usageFeeId)
            const localVarPath = `/usage_fees/{usageFeeId}`
                .replace(`{${"usageFeeId"}}`, encodeURIComponent(String(usageFeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get user account groups
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserAccountGroups: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getUserAccountGroups', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/user_account_groups`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get user account year month summary
         * @param {string} organizationId 
         * @param {string} toYearMonth 
         * @param {string} [fromYearMonth] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserAccountYearMonthSummary: async (organizationId: string, toYearMonth: string, fromYearMonth?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getUserAccountYearMonthSummary', 'organizationId', organizationId)
            // verify required parameter 'toYearMonth' is not null or undefined
            assertParamExists('getUserAccountYearMonthSummary', 'toYearMonth', toYearMonth)
            const localVarPath = `/organizations/{organizationId}/merchants/user_account_year_month_summary`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fromYearMonth !== undefined) {
                localVarQueryParameter['fromYearMonth'] = fromYearMonth;
            }

            if (toYearMonth !== undefined) {
                localVarQueryParameter['toYearMonth'] = toYearMonth;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get user accounts with default comment template
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserAccountsWithDefaultCommentTemplate: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getUserAccountsWithDefaultCommentTemplate', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/user_accounts_with_default_comment_template`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get user cards
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserCards: async (userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUserCards', 'userId', userId)
            const localVarPath = `/users/{userId}/cards`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get user cards extended
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserCardsExtended: async (userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUserCardsExtended', 'userId', userId)
            const localVarPath = `/users/{userId}/cards/extended`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get user cards extended for role resources
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserCardsExtendedForRoleResources: async (userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUserCardsExtendedForRoleResources', 'userId', userId)
            const localVarPath = `/users/{userId}/cards/extended/user_account_role_resources`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get user cards light
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserCardsLight: async (userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUserCardsLight', 'userId', userId)
            const localVarPath = `/users/{userId}/cards/light`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get user cards light for role resources
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserCardsLightForRoleResources: async (userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUserCardsLightForRoleResources', 'userId', userId)
            const localVarPath = `/users/{userId}/cards/light/user_account_role_resources`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get message detail
         * @param {string} userMessageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserMessageDetail: async (userMessageId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userMessageId' is not null or undefined
            assertParamExists('getUserMessageDetail', 'userMessageId', userMessageId)
            const localVarPath = `/user_messages/{userMessageId}`
                .replace(`{${"userMessageId"}}`, encodeURIComponent(String(userMessageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get messages for a user
         * @param {string} userId 
         * @param {number} offset 
         * @param {number} limit 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserMessages: async (userId: string, offset: number, limit: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUserMessages', 'userId', userId)
            // verify required parameter 'offset' is not null or undefined
            assertParamExists('getUserMessages', 'offset', offset)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('getUserMessages', 'limit', limit)
            const localVarPath = `/users/{userId}/user_messages`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get users
         * @param {string} organizationId 
         * @param {string} [email] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsers: async (organizationId: string, email?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getUsers', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/users`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get information on login user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersMe: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/users/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get venture capitals
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVentureCapitals: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/venture_capitals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 指定された組織の取引時確認詳細情報を取得します。 createdAtの降順で返却されます。 
         * @summary 取引時確認詳細取得（ZEUS)(PRESIDENT)
         * @param {string} organizationId 組織ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getZeusOrganizationIdentityVerificationsForPresident: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getZeusOrganizationIdentityVerificationsForPresident', 'organizationId', organizationId)
            const localVarPath = `/zeus/organizations/{organizationId}/identity_verifications_for_president`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get organizations for zeus
         * @param {string} [key] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {'ASC' | 'DESC'} [sort] 
         * @param {boolean} [connectedMoneytree] 
         * @param {'UPSIDER' | 'PRESIDENT_CARD'} [brandType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getZeusOrganizations: async (key?: string, limit?: number, offset?: number, sort?: 'ASC' | 'DESC', connectedMoneytree?: boolean, brandType?: 'UPSIDER' | 'PRESIDENT_CARD', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/zeus/organizations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (key !== undefined) {
                localVarQueryParameter['key'] = key;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (connectedMoneytree !== undefined) {
                localVarQueryParameter['connectedMoneytree'] = connectedMoneytree;
            }

            if (brandType !== undefined) {
                localVarQueryParameter['brandType'] = brandType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Initialize Modifiable Limit For The User Accounts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initializeModifiableLimitForTheUserAccounts: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user_accounts/modifiable_limit/initialize`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Linking purchase to transaction.
         * @param {string} organizationId 
         * @param {string} purchaseApplicationId 
         * @param {string} [visaTransactionReferenceId] 
         * @param {string} [userAccountId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        linkingPurchaseToTransaction: async (organizationId: string, purchaseApplicationId: string, visaTransactionReferenceId?: string, userAccountId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('linkingPurchaseToTransaction', 'organizationId', organizationId)
            // verify required parameter 'purchaseApplicationId' is not null or undefined
            assertParamExists('linkingPurchaseToTransaction', 'purchaseApplicationId', purchaseApplicationId)
            const localVarPath = `/organizations/{organizationId}/purchase_applications/{purchaseApplicationId}/link`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"purchaseApplicationId"}}`, encodeURIComponent(String(purchaseApplicationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (visaTransactionReferenceId !== undefined) {
                localVarQueryParameter['visaTransactionReferenceId'] = visaTransactionReferenceId;
            }

            if (userAccountId !== undefined) {
                localVarQueryParameter['userAccountId'] = userAccountId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Lock a card due to potential fraud
         * @param {string} organizationId 
         * @param {string} cardId 
         * @param {LockCardForPotentialFraudRequest} lockCardForPotentialFraudRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lockCardForPotentialFraud: async (organizationId: string, cardId: string, lockCardForPotentialFraudRequest: LockCardForPotentialFraudRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('lockCardForPotentialFraud', 'organizationId', organizationId)
            // verify required parameter 'cardId' is not null or undefined
            assertParamExists('lockCardForPotentialFraud', 'cardId', cardId)
            // verify required parameter 'lockCardForPotentialFraudRequest' is not null or undefined
            assertParamExists('lockCardForPotentialFraud', 'lockCardForPotentialFraudRequest', lockCardForPotentialFraudRequest)
            const localVarPath = `/organizations/{organizationId}/cards/{cardId}/lock_for_potential_fraud`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"cardId"}}`, encodeURIComponent(String(cardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(lockCardForPotentialFraudRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Lock a card due to fraud detected
         * @param {string} organizationId 
         * @param {string} cardId 
         * @param {LockCardOnFraudDetectedRequest} lockCardOnFraudDetectedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lockCardOnFraudDetected: async (organizationId: string, cardId: string, lockCardOnFraudDetectedRequest: LockCardOnFraudDetectedRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('lockCardOnFraudDetected', 'organizationId', organizationId)
            // verify required parameter 'cardId' is not null or undefined
            assertParamExists('lockCardOnFraudDetected', 'cardId', cardId)
            // verify required parameter 'lockCardOnFraudDetectedRequest' is not null or undefined
            assertParamExists('lockCardOnFraudDetected', 'lockCardOnFraudDetectedRequest', lockCardOnFraudDetectedRequest)
            const localVarPath = `/organizations/{organizationId}/cards/{cardId}/lock_on_fraud_detected`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"cardId"}}`, encodeURIComponent(String(cardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(lockCardOnFraudDetectedRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Login
         * @param {LoginRequest} loginRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login: async (loginRequest: LoginRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loginRequest' is not null or undefined
            assertParamExists('login', 'loginRequest', loginRequest)
            const localVarPath = `/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loginRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Login with APP two factor auth
         * @param {LoginAppRequest} loginAppRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginApp: async (loginAppRequest: LoginAppRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loginAppRequest' is not null or undefined
            assertParamExists('loginApp', 'loginAppRequest', loginAppRequest)
            const localVarPath = `/login/two_factor_auth/app`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loginAppRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Login with recovery code of two factor auth
         * @param {LoginRecoveryCodeRequest} loginRecoveryCodeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginRecoveryCode: async (loginRecoveryCodeRequest: LoginRecoveryCodeRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loginRecoveryCodeRequest' is not null or undefined
            assertParamExists('loginRecoveryCode', 'loginRecoveryCodeRequest', loginRecoveryCodeRequest)
            const localVarPath = `/login/two_factor_auth/recovery_code`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loginRecoveryCodeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Login with SMS two factor auth
         * @param {LoginSmsRequest} loginSmsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginSms: async (loginSmsRequest: LoginSmsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loginSmsRequest' is not null or undefined
            assertParamExists('loginSms', 'loginSmsRequest', loginSmsRequest)
            const localVarPath = `/login/two_factor_auth/sms`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loginSmsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Logout
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Move slack notification channel setting for card
         * @param {string} organizationId 
         * @param {string} currentChannelId 
         * @param {MoveSlackNotificationSettingForCardRequest} moveSlackNotificationSettingForCardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveSlackNotificationSettingForCard: async (organizationId: string, currentChannelId: string, moveSlackNotificationSettingForCardRequest: MoveSlackNotificationSettingForCardRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('moveSlackNotificationSettingForCard', 'organizationId', organizationId)
            // verify required parameter 'currentChannelId' is not null or undefined
            assertParamExists('moveSlackNotificationSettingForCard', 'currentChannelId', currentChannelId)
            // verify required parameter 'moveSlackNotificationSettingForCardRequest' is not null or undefined
            assertParamExists('moveSlackNotificationSettingForCard', 'moveSlackNotificationSettingForCardRequest', moveSlackNotificationSettingForCardRequest)
            const localVarPath = `/slack/organizations/{organizationId}/channels/{currentChannelId}/cards/notification/move`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"currentChannelId"}}`, encodeURIComponent(String(currentChannelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(moveSlackNotificationSettingForCardRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Move teams notification channel setting for card
         * @param {string} organizationId 
         * @param {string} currentChannelId 
         * @param {MoveTeamsNotificationSettingForCardRequest} moveTeamsNotificationSettingForCardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveTeamsNotificationSettingForCard: async (organizationId: string, currentChannelId: string, moveTeamsNotificationSettingForCardRequest: MoveTeamsNotificationSettingForCardRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('moveTeamsNotificationSettingForCard', 'organizationId', organizationId)
            // verify required parameter 'currentChannelId' is not null or undefined
            assertParamExists('moveTeamsNotificationSettingForCard', 'currentChannelId', currentChannelId)
            // verify required parameter 'moveTeamsNotificationSettingForCardRequest' is not null or undefined
            assertParamExists('moveTeamsNotificationSettingForCard', 'moveTeamsNotificationSettingForCardRequest', moveTeamsNotificationSettingForCardRequest)
            const localVarPath = `/teams/organizations/{organizationId}/channels/{currentChannelId}/cards/notification/move`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"currentChannelId"}}`, encodeURIComponent(String(currentChannelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(moveTeamsNotificationSettingForCardRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Organization Create Pre Request
         * @param {OrganizationCreatePreRequestRequest} organizationCreatePreRequestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationCreatePreRequest: async (organizationCreatePreRequestRequest: OrganizationCreatePreRequestRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationCreatePreRequestRequest' is not null or undefined
            assertParamExists('organizationCreatePreRequest', 'organizationCreatePreRequestRequest', organizationCreatePreRequestRequest)
            const localVarPath = `/organization_create_pre_requests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(organizationCreatePreRequestRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Parse organization chart for workflow
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        parseOrganizationChartForWorkflow: async (file: File, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('parseOrganizationChartForWorkflow', 'file', file)
            const localVarPath = `/workflows/parse_organization_chart`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Post Addition Merchant General Block List
         * @param {PostAdditionMerchantGeneralBlockListRequest} postAdditionMerchantGeneralBlockListRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAdditionMerchantGeneralBlockList: async (postAdditionMerchantGeneralBlockListRequest: PostAdditionMerchantGeneralBlockListRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postAdditionMerchantGeneralBlockListRequest' is not null or undefined
            assertParamExists('postAdditionMerchantGeneralBlockList', 'postAdditionMerchantGeneralBlockListRequest', postAdditionMerchantGeneralBlockListRequest)
            const localVarPath = `/merchant_general_block_lists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postAdditionMerchantGeneralBlockListRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationId 
         * @param {PostAlliancesGcpApplicationsRequest} postAlliancesGcpApplicationsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAlliancesGcpApplications: async (organizationId: string, postAlliancesGcpApplicationsRequest: PostAlliancesGcpApplicationsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('postAlliancesGcpApplications', 'organizationId', organizationId)
            // verify required parameter 'postAlliancesGcpApplicationsRequest' is not null or undefined
            assertParamExists('postAlliancesGcpApplications', 'postAlliancesGcpApplicationsRequest', postAlliancesGcpApplicationsRequest)
            const localVarPath = `/organizations/{organizationId}/alliances/gcp/applications`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postAlliancesGcpApplicationsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationId 
         * @param {PostAlliancesGwsApplicationsRequest} postAlliancesGwsApplicationsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAlliancesGwsApplications: async (organizationId: string, postAlliancesGwsApplicationsRequest: PostAlliancesGwsApplicationsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('postAlliancesGwsApplications', 'organizationId', organizationId)
            // verify required parameter 'postAlliancesGwsApplicationsRequest' is not null or undefined
            assertParamExists('postAlliancesGwsApplications', 'postAlliancesGwsApplicationsRequest', postAlliancesGwsApplicationsRequest)
            const localVarPath = `/organizations/{organizationId}/alliances/gws/applications`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postAlliancesGwsApplicationsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Search Bank Account Balances
         * @param {PostBalancesRequest} postBalancesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postBalances: async (postBalancesRequest: PostBalancesRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postBalancesRequest' is not null or undefined
            assertParamExists('postBalances', 'postBalancesRequest', postBalancesRequest)
            const localVarPath = `/mtbankaccounts/balances`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postBalancesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Post Bulk Addition Merchant Org Block Lists
         * @param {string} organizationId 
         * @param {Array<PostBulkAdditionMerchantOrgBlockListsRequestInner>} postBulkAdditionMerchantOrgBlockListsRequestInner 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postBulkAdditionMerchantOrgBlockLists: async (organizationId: string, postBulkAdditionMerchantOrgBlockListsRequestInner: Array<PostBulkAdditionMerchantOrgBlockListsRequestInner>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('postBulkAdditionMerchantOrgBlockLists', 'organizationId', organizationId)
            // verify required parameter 'postBulkAdditionMerchantOrgBlockListsRequestInner' is not null or undefined
            assertParamExists('postBulkAdditionMerchantOrgBlockLists', 'postBulkAdditionMerchantOrgBlockListsRequestInner', postBulkAdditionMerchantOrgBlockListsRequestInner)
            const localVarPath = `/organizations/{organizationId}/merchant_org_block_lists`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postBulkAdditionMerchantOrgBlockListsRequestInner, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Post a cancel request for a evidence request
         * @param {string} organizationId 
         * @param {string} paymentReferenceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCancelRequestForEvidenceRequest: async (organizationId: string, paymentReferenceId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('postCancelRequestForEvidenceRequest', 'organizationId', organizationId)
            // verify required parameter 'paymentReferenceId' is not null or undefined
            assertParamExists('postCancelRequestForEvidenceRequest', 'paymentReferenceId', paymentReferenceId)
            const localVarPath = `/organizations/{organizationId}/cards/transactions/{paymentReferenceId}/evidence/request/cancel`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"paymentReferenceId"}}`, encodeURIComponent(String(paymentReferenceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PostCardsVirtualIssueRequest} postCardsVirtualIssueRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCardsVirtualIssue: async (postCardsVirtualIssueRequest: PostCardsVirtualIssueRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postCardsVirtualIssueRequest' is not null or undefined
            assertParamExists('postCardsVirtualIssue', 'postCardsVirtualIssueRequest', postCardsVirtualIssueRequest)
            const localVarPath = `/cards/virtual/issue`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postCardsVirtualIssueRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCardsVirtualOndemandIssue: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/cards/virtual/ondemand/issue`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Upload identity document file with verification information.
         * @summary Upload Identity Document
         * @param {string} onboardingRequestId Onboarding request ID
         * @param {File} file Identity document file
         * @param {string} [personalDocumentType] Type of personal identification document
         * @param {string} [verifiedBy] Name of the person who verified the document
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postFaceToFaceKycIdentityDocument: async (onboardingRequestId: string, file: File, personalDocumentType?: string, verifiedBy?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'onboardingRequestId' is not null or undefined
            assertParamExists('postFaceToFaceKycIdentityDocument', 'onboardingRequestId', onboardingRequestId)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('postFaceToFaceKycIdentityDocument', 'file', file)
            const localVarPath = `/zeus/onboarding_requests/{onboardingRequestId}/face_to_face_kyc/identity_document`
                .replace(`{${"onboardingRequestId"}}`, encodeURIComponent(String(onboardingRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
            if (personalDocumentType !== undefined) { 
                localVarFormParams.append('personalDocumentType', personalDocumentType as any);
            }
    
            if (verifiedBy !== undefined) { 
                localVarFormParams.append('verifiedBy', verifiedBy as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Submit a face-to-face KYC request.
         * @summary Face-to-face KYC Request
         * @param {PostFaceToFaceKycRequestRequest} postFaceToFaceKycRequestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postFaceToFaceKycRequest: async (postFaceToFaceKycRequestRequest: PostFaceToFaceKycRequestRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postFaceToFaceKycRequestRequest' is not null or undefined
            assertParamExists('postFaceToFaceKycRequest', 'postFaceToFaceKycRequestRequest', postFaceToFaceKycRequestRequest)
            const localVarPath = `/zeus/onboarding_requests/face_to_face_kyc`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postFaceToFaceKycRequestRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Post Freee Account for Points
         * @param {string} organizationId 
         * @param {PostFreeeAccountForPointsRequest} postFreeeAccountForPointsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postFreeeAccountForPoints: async (organizationId: string, postFreeeAccountForPointsRequest: PostFreeeAccountForPointsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('postFreeeAccountForPoints', 'organizationId', organizationId)
            // verify required parameter 'postFreeeAccountForPointsRequest' is not null or undefined
            assertParamExists('postFreeeAccountForPoints', 'postFreeeAccountForPointsRequest', postFreeeAccountForPointsRequest)
            const localVarPath = `/organizations/{organizationId}/freee/account_for_points`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postFreeeAccountForPointsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {{ [key: string]: string; }} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postKycconsultingWebhooks: async (requestBody: { [key: string]: string; }, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('postKycconsultingWebhooks', 'requestBody', requestBody)
            const localVarPath = `/kycconsulting/webhooks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Post Moneytree Refresh Request
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postMoneytreeRefreshRequest: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('postMoneytreeRefreshRequest', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/moneytree/request_refresh`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Post Moneytree Refresh Request for All Organizations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postMoneytreeRefreshRequestAll: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/moneytree/request_refresh_all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create organizations deals
         * @param {string} organizationId 
         * @param {PostOrganizationsDealsRequest} postOrganizationsDealsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postOrganizationsDeals: async (organizationId: string, postOrganizationsDealsRequest: PostOrganizationsDealsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('postOrganizationsDeals', 'organizationId', organizationId)
            // verify required parameter 'postOrganizationsDealsRequest' is not null or undefined
            assertParamExists('postOrganizationsDeals', 'postOrganizationsDealsRequest', postOrganizationsDealsRequest)
            const localVarPath = `/organizations/{organizationId}/deals`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postOrganizationsDealsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Post payment requests bank account
         * @param {string} organizationId 
         * @param {PostPaymentRequestsBankAccountRequest} [postPaymentRequestsBankAccountRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postPaymentRequestsBankAccount: async (organizationId: string, postPaymentRequestsBankAccountRequest?: PostPaymentRequestsBankAccountRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('postPaymentRequestsBankAccount', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/payment_requests/bank_accounts`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postPaymentRequestsBankAccountRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Post slack message to coworker
         * @param {string} organizationId 
         * @param {PostSlackMessageToCoworkerRequest} postSlackMessageToCoworkerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postSlackMessageToCoworker: async (organizationId: string, postSlackMessageToCoworkerRequest: PostSlackMessageToCoworkerRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('postSlackMessageToCoworker', 'organizationId', organizationId)
            // verify required parameter 'postSlackMessageToCoworkerRequest' is not null or undefined
            assertParamExists('postSlackMessageToCoworker', 'postSlackMessageToCoworkerRequest', postSlackMessageToCoworkerRequest)
            const localVarPath = `/organizations/{organizationId}/human_coworker/message`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postSlackMessageToCoworkerRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Search Bank Account Transactions
         * @param {PostTransactionsRequest} postTransactionsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postTransactions: async (postTransactionsRequest: PostTransactionsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postTransactionsRequest' is not null or undefined
            assertParamExists('postTransactions', 'postTransactionsRequest', postTransactionsRequest)
            const localVarPath = `/mtbankaccounts/transactions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postTransactionsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PostTrustdockWebhooksRequest} postTrustdockWebhooksRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postTrustdockWebhooks: async (postTrustdockWebhooksRequest: PostTrustdockWebhooksRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postTrustdockWebhooksRequest' is not null or undefined
            assertParamExists('postTrustdockWebhooks', 'postTrustdockWebhooksRequest', postTrustdockWebhooksRequest)
            const localVarPath = `/trustdock/webhooks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postTrustdockWebhooksRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PostTrustdockWebhooksSnailMailRequest} postTrustdockWebhooksSnailMailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postTrustdockWebhooksSnailMail: async (postTrustdockWebhooksSnailMailRequest: PostTrustdockWebhooksSnailMailRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postTrustdockWebhooksSnailMailRequest' is not null or undefined
            assertParamExists('postTrustdockWebhooksSnailMail', 'postTrustdockWebhooksSnailMailRequest', postTrustdockWebhooksSnailMailRequest)
            const localVarPath = `/trustdock/webhooks/snail-mail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postTrustdockWebhooksSnailMailRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Put disable feature flag
         * @param {string} organizationId 
         * @param {string} featureName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putDisableFeatureFlag: async (organizationId: string, featureName: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('putDisableFeatureFlag', 'organizationId', organizationId)
            // verify required parameter 'featureName' is not null or undefined
            assertParamExists('putDisableFeatureFlag', 'featureName', featureName)
            const localVarPath = `/organizations/{organizationId}/feature/{featureName}/disable`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"featureName"}}`, encodeURIComponent(String(featureName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Put enabled feature flag
         * @param {string} organizationId 
         * @param {string} featureName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putEnabledFeatureFlag: async (organizationId: string, featureName: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('putEnabledFeatureFlag', 'organizationId', organizationId)
            // verify required parameter 'featureName' is not null or undefined
            assertParamExists('putEnabledFeatureFlag', 'featureName', featureName)
            const localVarPath = `/organizations/{organizationId}/feature/{featureName}/enable`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"featureName"}}`, encodeURIComponent(String(featureName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Put Freee End Journal Entry Transition Mode
         * @param {string} organizationId 
         * @param {PutFreeeEndJournalEntryTransitionModeRequest} putFreeeEndJournalEntryTransitionModeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putFreeeEndJournalEntryTransitionMode: async (organizationId: string, putFreeeEndJournalEntryTransitionModeRequest: PutFreeeEndJournalEntryTransitionModeRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('putFreeeEndJournalEntryTransitionMode', 'organizationId', organizationId)
            // verify required parameter 'putFreeeEndJournalEntryTransitionModeRequest' is not null or undefined
            assertParamExists('putFreeeEndJournalEntryTransitionMode', 'putFreeeEndJournalEntryTransitionModeRequest', putFreeeEndJournalEntryTransitionModeRequest)
            const localVarPath = `/organizations/{organizationId}/freee/end_journal_entry_transition_mode`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(putFreeeEndJournalEntryTransitionModeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Put Organization Payment Method
         * @param {string} organizationId 
         * @param {PutOrganizationPaymentMethodRequest} putOrganizationPaymentMethodRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putOrganizationPaymentMethod: async (organizationId: string, putOrganizationPaymentMethodRequest: PutOrganizationPaymentMethodRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('putOrganizationPaymentMethod', 'organizationId', organizationId)
            // verify required parameter 'putOrganizationPaymentMethodRequest' is not null or undefined
            assertParamExists('putOrganizationPaymentMethod', 'putOrganizationPaymentMethodRequest', putOrganizationPaymentMethodRequest)
            const localVarPath = `/organizations/{organizationId}/payment_method`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(putOrganizationPaymentMethodRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Put organizations deals
         * @param {string} organizationId 
         * @param {PutOrganizationsDealsRequest} putOrganizationsDealsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putOrganizationsDeals: async (organizationId: string, putOrganizationsDealsRequest: PutOrganizationsDealsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('putOrganizationsDeals', 'organizationId', organizationId)
            // verify required parameter 'putOrganizationsDealsRequest' is not null or undefined
            assertParamExists('putOrganizationsDeals', 'putOrganizationsDealsRequest', putOrganizationsDealsRequest)
            const localVarPath = `/organizations/{organizationId}/deals`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(putOrganizationsDealsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update payment request
         * @param {string} organizationId 
         * @param {string} [paymentRequestId] 
         * @param {PutPaymentRequestRequest} [putPaymentRequestRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putPaymentRequest: async (organizationId: string, paymentRequestId?: string, putPaymentRequestRequest?: PutPaymentRequestRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('putPaymentRequest', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/payment_requests/{paymentRequestId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"paymentRequestId"}}`, encodeURIComponent(String(paymentRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(putPaymentRequestRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Put payment requests bank account
         * @param {string} organizationId 
         * @param {string} bankAccountId 
         * @param {PutPaymentRequestsBankAccountRequest} [putPaymentRequestsBankAccountRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putPaymentRequestsBankAccount: async (organizationId: string, bankAccountId: string, putPaymentRequestsBankAccountRequest?: PutPaymentRequestsBankAccountRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('putPaymentRequestsBankAccount', 'organizationId', organizationId)
            // verify required parameter 'bankAccountId' is not null or undefined
            assertParamExists('putPaymentRequestsBankAccount', 'bankAccountId', bankAccountId)
            const localVarPath = `/organizations/{organizationId}/payment_requests/bank_accounts/{bankAccountId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"bankAccountId"}}`, encodeURIComponent(String(bankAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(putPaymentRequestsBankAccountRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Put transaction evidence emails link to transaction
         * @param {PutTransactionEvidenceEmailsLinkToTransactionRequest} putTransactionEvidenceEmailsLinkToTransactionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putTransactionEvidenceEmailsLinkToTransaction: async (putTransactionEvidenceEmailsLinkToTransactionRequest: PutTransactionEvidenceEmailsLinkToTransactionRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'putTransactionEvidenceEmailsLinkToTransactionRequest' is not null or undefined
            assertParamExists('putTransactionEvidenceEmailsLinkToTransaction', 'putTransactionEvidenceEmailsLinkToTransactionRequest', putTransactionEvidenceEmailsLinkToTransactionRequest)
            const localVarPath = `/transaction_evidence_emails/link_to_transaction`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(putTransactionEvidenceEmailsLinkToTransactionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Put transaction evidence emails mark as read
         * @param {PutTransactionEvidenceEmailsMarkAsReadRequest} putTransactionEvidenceEmailsMarkAsReadRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putTransactionEvidenceEmailsMarkAsRead: async (putTransactionEvidenceEmailsMarkAsReadRequest: PutTransactionEvidenceEmailsMarkAsReadRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'putTransactionEvidenceEmailsMarkAsReadRequest' is not null or undefined
            assertParamExists('putTransactionEvidenceEmailsMarkAsRead', 'putTransactionEvidenceEmailsMarkAsReadRequest', putTransactionEvidenceEmailsMarkAsReadRequest)
            const localVarPath = `/transaction_evidence_emails/mark_as_read`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(putTransactionEvidenceEmailsMarkAsReadRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Put transaction evidence emails move to trash
         * @param {PutTransactionEvidenceEmailsMoveToTrashRequest} putTransactionEvidenceEmailsMoveToTrashRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putTransactionEvidenceEmailsMoveToTrash: async (putTransactionEvidenceEmailsMoveToTrashRequest: PutTransactionEvidenceEmailsMoveToTrashRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'putTransactionEvidenceEmailsMoveToTrashRequest' is not null or undefined
            assertParamExists('putTransactionEvidenceEmailsMoveToTrash', 'putTransactionEvidenceEmailsMoveToTrashRequest', putTransactionEvidenceEmailsMoveToTrashRequest)
            const localVarPath = `/transaction_evidence_emails/move_to_trash`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(putTransactionEvidenceEmailsMoveToTrashRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Give reward point to organization
         * @param {string} organizationId 
         * @param {PutZeusGiveRewardPointsRequest} putZeusGiveRewardPointsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putZeusGiveRewardPoints: async (organizationId: string, putZeusGiveRewardPointsRequest: PutZeusGiveRewardPointsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('putZeusGiveRewardPoints', 'organizationId', organizationId)
            // verify required parameter 'putZeusGiveRewardPointsRequest' is not null or undefined
            assertParamExists('putZeusGiveRewardPoints', 'putZeusGiveRewardPointsRequest', putZeusGiveRewardPointsRequest)
            const localVarPath = `/zeus/organizations/{organizationId}/give_reward_points`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(putZeusGiveRewardPointsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Query by ids payment requests
         * @param {string} organizationId 
         * @param {QueryByIdsPaymentRequestsRequest} [queryByIdsPaymentRequestsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryByIdsPaymentRequests: async (organizationId: string, queryByIdsPaymentRequestsRequest?: QueryByIdsPaymentRequestsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('queryByIdsPaymentRequests', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/payment_requests/query_by_ids`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(queryByIdsPaymentRequestsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update read status of a message
         * @param {string} userMessageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readUserMessage: async (userMessageId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userMessageId' is not null or undefined
            assertParamExists('readUserMessage', 'userMessageId', userMessageId)
            const localVarPath = `/user_messages/{userMessageId}/read`
                .replace(`{${"userMessageId"}}`, encodeURIComponent(String(userMessageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary register note
         * @param {string} onboardingRequestId The ID of the onboarding request to retrieve
         * @param {RegisterNoteRequest} [registerNoteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerNote: async (onboardingRequestId: string, registerNoteRequest?: RegisterNoteRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'onboardingRequestId' is not null or undefined
            assertParamExists('registerNote', 'onboardingRequestId', onboardingRequestId)
            const localVarPath = `/zeus/onboarding_requests/{onboardingRequestId}/register_note`
                .replace(`{${"onboardingRequestId"}}`, encodeURIComponent(String(onboardingRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(registerNoteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Register note for organization identity verification
         * @param {number} organizationIdentityVerificationId 
         * @param {RegisterNoteForOrganizationIdentityVerificationRequest} registerNoteForOrganizationIdentityVerificationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerNoteForOrganizationIdentityVerification: async (organizationIdentityVerificationId: number, registerNoteForOrganizationIdentityVerificationRequest: RegisterNoteForOrganizationIdentityVerificationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationIdentityVerificationId' is not null or undefined
            assertParamExists('registerNoteForOrganizationIdentityVerification', 'organizationIdentityVerificationId', organizationIdentityVerificationId)
            // verify required parameter 'registerNoteForOrganizationIdentityVerificationRequest' is not null or undefined
            assertParamExists('registerNoteForOrganizationIdentityVerification', 'registerNoteForOrganizationIdentityVerificationRequest', registerNoteForOrganizationIdentityVerificationRequest)
            const localVarPath = `/organization_identity_verifications/{organizationIdentityVerificationId}/register_note`
                .replace(`{${"organizationIdentityVerificationId"}}`, encodeURIComponent(String(organizationIdentityVerificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(registerNoteForOrganizationIdentityVerificationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Register an organization using the onboarding request ID
         * @param {string} onboardingRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerOrganization: async (onboardingRequestId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'onboardingRequestId' is not null or undefined
            assertParamExists('registerOrganization', 'onboardingRequestId', onboardingRequestId)
            const localVarPath = `/zeus/onboarding_requests/{onboardingRequestId}/register_organization`
                .replace(`{${"onboardingRequestId"}}`, encodeURIComponent(String(onboardingRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Register organization chart for workflow
         * @param {string} organizationId 
         * @param {RegisterOrganizationChartForWorkflowRequest} [registerOrganizationChartForWorkflowRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerOrganizationChartForWorkflow: async (organizationId: string, registerOrganizationChartForWorkflowRequest?: RegisterOrganizationChartForWorkflowRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('registerOrganizationChartForWorkflow', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/workflows/organization_charts`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(registerOrganizationChartForWorkflowRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Register Tfa App Verification Code
         * @param {RegisterTfaAppVerificationCodeRequest} registerTfaAppVerificationCodeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerTfaAppVerificationCode: async (registerTfaAppVerificationCodeRequest: RegisterTfaAppVerificationCodeRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'registerTfaAppVerificationCodeRequest' is not null or undefined
            assertParamExists('registerTfaAppVerificationCode', 'registerTfaAppVerificationCodeRequest', registerTfaAppVerificationCodeRequest)
            const localVarPath = `/two_factor_auth/app/register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(registerTfaAppVerificationCodeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Register Tfa SMS Auth
         * @param {RegisterTfaSmsAuthRequest} registerTfaSmsAuthRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerTfaSmsAuth: async (registerTfaSmsAuthRequest: RegisterTfaSmsAuthRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'registerTfaSmsAuthRequest' is not null or undefined
            assertParamExists('registerTfaSmsAuth', 'registerTfaSmsAuthRequest', registerTfaSmsAuthRequest)
            const localVarPath = `/two_factor_auth/sms/register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(registerTfaSmsAuthRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Register transaction evidence email address
         * @param {string} userAccountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerTransactionEvidenceEmailAddress: async (userAccountId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userAccountId' is not null or undefined
            assertParamExists('registerTransactionEvidenceEmailAddress', 'userAccountId', userAccountId)
            const localVarPath = `/user_accounts/{userAccountId}/transaction_evidence_email_address`
                .replace(`{${"userAccountId"}}`, encodeURIComponent(String(userAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reject Organization Identity Verification
         * @param {number} organizationIdentityVerificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectOrganizationIdentityVerification: async (organizationIdentityVerificationId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationIdentityVerificationId' is not null or undefined
            assertParamExists('rejectOrganizationIdentityVerification', 'organizationIdentityVerificationId', organizationIdentityVerificationId)
            const localVarPath = `/organization_identity_verifications/{organizationIdentityVerificationId}/reject`
                .replace(`{${"organizationIdentityVerificationId"}}`, encodeURIComponent(String(organizationIdentityVerificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reject purchase application.
         * @param {string} organizationId 
         * @param {string} purchaseApplicationId 
         * @param {RejectPurchaseApplicationRequest} rejectPurchaseApplicationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectPurchaseApplication: async (organizationId: string, purchaseApplicationId: string, rejectPurchaseApplicationRequest: RejectPurchaseApplicationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('rejectPurchaseApplication', 'organizationId', organizationId)
            // verify required parameter 'purchaseApplicationId' is not null or undefined
            assertParamExists('rejectPurchaseApplication', 'purchaseApplicationId', purchaseApplicationId)
            // verify required parameter 'rejectPurchaseApplicationRequest' is not null or undefined
            assertParamExists('rejectPurchaseApplication', 'rejectPurchaseApplicationRequest', rejectPurchaseApplicationRequest)
            const localVarPath = `/organizations/{organizationId}/purchase_applications/{purchaseApplicationId}/reject`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"purchaseApplicationId"}}`, encodeURIComponent(String(purchaseApplicationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rejectPurchaseApplicationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remindCardTransactionEvidence: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/cards/transactions/evidence/remind`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remind monthly payment notifications.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remindMonthlyPaymentNotifications: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/payments/remind_notification`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remind organization monthly payment notifications.
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remindOrganizationMonthlyPaymentNotification: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('remindOrganizationMonthlyPaymentNotification', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/payments/remind_notification`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Rename user account group
         * @param {number} userAccountGroupId 
         * @param {RenameUserAccountGroupRequest} renameUserAccountGroupRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        renameUserAccountGroup: async (userAccountGroupId: number, renameUserAccountGroupRequest: RenameUserAccountGroupRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userAccountGroupId' is not null or undefined
            assertParamExists('renameUserAccountGroup', 'userAccountGroupId', userAccountGroupId)
            // verify required parameter 'renameUserAccountGroupRequest' is not null or undefined
            assertParamExists('renameUserAccountGroup', 'renameUserAccountGroupRequest', renameUserAccountGroupRequest)
            const localVarPath = `/user_account_groups/{userAccountGroupId}/rename`
                .replace(`{${"userAccountGroupId"}}`, encodeURIComponent(String(userAccountGroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(renameUserAccountGroupRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Replace Virtual Card
         * @param {string} userAccountId 
         * @param {ReplaceVirtualCardRequest} replaceVirtualCardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceVirtualCard: async (userAccountId: string, replaceVirtualCardRequest: ReplaceVirtualCardRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userAccountId' is not null or undefined
            assertParamExists('replaceVirtualCard', 'userAccountId', userAccountId)
            // verify required parameter 'replaceVirtualCardRequest' is not null or undefined
            assertParamExists('replaceVirtualCard', 'replaceVirtualCardRequest', replaceVirtualCardRequest)
            const localVarPath = `/user_accounts/{userAccountId}/cards/virtual/replace`
                .replace(`{${"userAccountId"}}`, encodeURIComponent(String(userAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(replaceVirtualCardRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary request add system admin role
         * @param {string} userId 
         * @param {RequestAddSystemAdminRoleRequest} requestAddSystemAdminRoleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestAddSystemAdminRole: async (userId: string, requestAddSystemAdminRoleRequest: RequestAddSystemAdminRoleRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('requestAddSystemAdminRole', 'userId', userId)
            // verify required parameter 'requestAddSystemAdminRoleRequest' is not null or undefined
            assertParamExists('requestAddSystemAdminRole', 'requestAddSystemAdminRoleRequest', requestAddSystemAdminRoleRequest)
            const localVarPath = `/users/{userId}/roles/system`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestAddSystemAdminRoleRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Request sending physical cards
         * @param {string} organizationId 
         * @param {RequestSendingRequest} requestSendingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestSending: async (organizationId: string, requestSendingRequest: RequestSendingRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('requestSending', 'organizationId', organizationId)
            // verify required parameter 'requestSendingRequest' is not null or undefined
            assertParamExists('requestSending', 'requestSendingRequest', requestSendingRequest)
            const localVarPath = `/organizations/{organizationId}/cards/request_sending`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestSendingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Request sending a metal card
         * @param {string} organizationId 
         * @param {RequestSendingMetalCardRequest} requestSendingMetalCardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestSendingMetalCard: async (organizationId: string, requestSendingMetalCardRequest: RequestSendingMetalCardRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('requestSendingMetalCard', 'organizationId', organizationId)
            // verify required parameter 'requestSendingMetalCardRequest' is not null or undefined
            assertParamExists('requestSendingMetalCard', 'requestSendingMetalCardRequest', requestSendingMetalCardRequest)
            const localVarPath = `/organizations/{organizationId}/cards/metal/request_sending`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestSendingMetalCardRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestSyncingClearedTransaction: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/cards/request_syncing_cleared_transaction`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Request to Generate Organizations Accounting Csv in Background
         * @param {string} organizationId 
         * @param {string} yearMonth 
         * @param {boolean} isMergedFiles 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestToOrganizationsAccountingCsvInBackground: async (organizationId: string, yearMonth: string, isMergedFiles: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('requestToOrganizationsAccountingCsvInBackground', 'organizationId', organizationId)
            // verify required parameter 'yearMonth' is not null or undefined
            assertParamExists('requestToOrganizationsAccountingCsvInBackground', 'yearMonth', yearMonth)
            // verify required parameter 'isMergedFiles' is not null or undefined
            assertParamExists('requestToOrganizationsAccountingCsvInBackground', 'isMergedFiles', isMergedFiles)
            const localVarPath = `/organizations/{organizationId}/cards/accounting/download_csv/background_generate`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (yearMonth !== undefined) {
                localVarQueryParameter['yearMonth'] = yearMonth;
            }

            if (isMergedFiles !== undefined) {
                localVarQueryParameter['isMergedFiles'] = isMergedFiles;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary request update system admin role
         * @param {string} userId 
         * @param {RequestUpdateSystemAdminRoleRequest} requestUpdateSystemAdminRoleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestUpdateSystemAdminRole: async (userId: string, requestUpdateSystemAdminRoleRequest: RequestUpdateSystemAdminRoleRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('requestUpdateSystemAdminRole', 'userId', userId)
            // verify required parameter 'requestUpdateSystemAdminRoleRequest' is not null or undefined
            assertParamExists('requestUpdateSystemAdminRole', 'requestUpdateSystemAdminRoleRequest', requestUpdateSystemAdminRoleRequest)
            const localVarPath = `/users/{userId}/roles/system`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestUpdateSystemAdminRoleRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Resend Snail Mail For Organization Identity Verification
         * @param {number} organizationIdentityVerificationId 
         * @param {ResendSnailMailForOrganizationIdentityVerificationRequest} resendSnailMailForOrganizationIdentityVerificationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendSnailMailForOrganizationIdentityVerification: async (organizationIdentityVerificationId: number, resendSnailMailForOrganizationIdentityVerificationRequest: ResendSnailMailForOrganizationIdentityVerificationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationIdentityVerificationId' is not null or undefined
            assertParamExists('resendSnailMailForOrganizationIdentityVerification', 'organizationIdentityVerificationId', organizationIdentityVerificationId)
            // verify required parameter 'resendSnailMailForOrganizationIdentityVerificationRequest' is not null or undefined
            assertParamExists('resendSnailMailForOrganizationIdentityVerification', 'resendSnailMailForOrganizationIdentityVerificationRequest', resendSnailMailForOrganizationIdentityVerificationRequest)
            const localVarPath = `/organization_identity_verifications/{organizationIdentityVerificationId}/resend_snail_mail`
                .replace(`{${"organizationIdentityVerificationId"}}`, encodeURIComponent(String(organizationIdentityVerificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resendSnailMailForOrganizationIdentityVerificationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Resend an invitation to a new user
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendUserInvite: async (userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('resendUserInvite', 'userId', userId)
            const localVarPath = `/users/{userId}/resend_invite`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Resume a suspended card
         * @param {string} organizationId 
         * @param {string} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resumeCard: async (organizationId: string, cardId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('resumeCard', 'organizationId', organizationId)
            // verify required parameter 'cardId' is not null or undefined
            assertParamExists('resumeCard', 'cardId', cardId)
            const localVarPath = `/organizations/{organizationId}/cards/{cardId}/resume`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"cardId"}}`, encodeURIComponent(String(cardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Resynchronize card transactions for freee
         * @param {string} organizationId 
         * @param {ResynchronizeCardTransactionsForFreeeRequest} resynchronizeCardTransactionsForFreeeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resynchronizeCardTransactionsForFreee: async (organizationId: string, resynchronizeCardTransactionsForFreeeRequest: ResynchronizeCardTransactionsForFreeeRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('resynchronizeCardTransactionsForFreee', 'organizationId', organizationId)
            // verify required parameter 'resynchronizeCardTransactionsForFreeeRequest' is not null or undefined
            assertParamExists('resynchronizeCardTransactionsForFreee', 'resynchronizeCardTransactionsForFreeeRequest', resynchronizeCardTransactionsForFreeeRequest)
            const localVarPath = `/organizations/{organizationId}/cards/request_resynchronizing_all_transaction`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resynchronizeCardTransactionsForFreeeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Save deal as draft
         * @param {string} organizationId 
         * @param {string} dealId 
         * @param {SaveDealAsDraftRequest} saveDealAsDraftRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveDealAsDraft: async (organizationId: string, dealId: string, saveDealAsDraftRequest: SaveDealAsDraftRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('saveDealAsDraft', 'organizationId', organizationId)
            // verify required parameter 'dealId' is not null or undefined
            assertParamExists('saveDealAsDraft', 'dealId', dealId)
            // verify required parameter 'saveDealAsDraftRequest' is not null or undefined
            assertParamExists('saveDealAsDraft', 'saveDealAsDraftRequest', saveDealAsDraftRequest)
            const localVarPath = `/organizations/{organizationId}/deals/{dealId}/draft`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"dealId"}}`, encodeURIComponent(String(dealId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(saveDealAsDraftRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Save Deal As Ignore
         * @param {string} organizationId 
         * @param {string} dealId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveDealAsIgnore: async (organizationId: string, dealId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('saveDealAsIgnore', 'organizationId', organizationId)
            // verify required parameter 'dealId' is not null or undefined
            assertParamExists('saveDealAsIgnore', 'dealId', dealId)
            const localVarPath = `/organizations/{organizationId}/deals/{dealId}/ignore`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"dealId"}}`, encodeURIComponent(String(dealId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Save deal as return to editing
         * @param {string} organizationId 
         * @param {number} dealId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveDealAsReturnToEditing: async (organizationId: string, dealId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('saveDealAsReturnToEditing', 'organizationId', organizationId)
            // verify required parameter 'dealId' is not null or undefined
            assertParamExists('saveDealAsReturnToEditing', 'dealId', dealId)
            const localVarPath = `/organizations/{organizationId}/deals/{dealId}/return_to_editing`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"dealId"}}`, encodeURIComponent(String(dealId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Save deal with journalizing
         * @param {string} organizationId 
         * @param {string} dealId 
         * @param {SaveDealWithJournalizingRequest} saveDealWithJournalizingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveDealWithJournalizing: async (organizationId: string, dealId: string, saveDealWithJournalizingRequest: SaveDealWithJournalizingRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('saveDealWithJournalizing', 'organizationId', organizationId)
            // verify required parameter 'dealId' is not null or undefined
            assertParamExists('saveDealWithJournalizing', 'dealId', dealId)
            // verify required parameter 'saveDealWithJournalizingRequest' is not null or undefined
            assertParamExists('saveDealWithJournalizing', 'saveDealWithJournalizingRequest', saveDealWithJournalizingRequest)
            const localVarPath = `/organizations/{organizationId}/deals/{dealId}/journalize`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"dealId"}}`, encodeURIComponent(String(dealId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(saveDealWithJournalizingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Save deals as ignore
         * @param {string} organizationId 
         * @param {SaveDealsAsIgnoreRequest} saveDealsAsIgnoreRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveDealsAsIgnore: async (organizationId: string, saveDealsAsIgnoreRequest: SaveDealsAsIgnoreRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('saveDealsAsIgnore', 'organizationId', organizationId)
            // verify required parameter 'saveDealsAsIgnoreRequest' is not null or undefined
            assertParamExists('saveDealsAsIgnore', 'saveDealsAsIgnoreRequest', saveDealsAsIgnoreRequest)
            const localVarPath = `/organizations/{organizationId}/deals/ignore`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(saveDealsAsIgnoreRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Save deals as journalized
         * @param {string} organizationId 
         * @param {SaveDealsAsJournalizedRequest} saveDealsAsJournalizedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveDealsAsJournalized: async (organizationId: string, saveDealsAsJournalizedRequest: SaveDealsAsJournalizedRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('saveDealsAsJournalized', 'organizationId', organizationId)
            // verify required parameter 'saveDealsAsJournalizedRequest' is not null or undefined
            assertParamExists('saveDealsAsJournalized', 'saveDealsAsJournalizedRequest', saveDealsAsJournalizedRequest)
            const localVarPath = `/organizations/{organizationId}/deals/journalized`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(saveDealsAsJournalizedRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Save deals as return to editing
         * @param {number} organizationId 
         * @param {SaveDealsAsReturnToEditingRequest} saveDealsAsReturnToEditingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveDealsAsReturnToEditing: async (organizationId: number, saveDealsAsReturnToEditingRequest: SaveDealsAsReturnToEditingRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('saveDealsAsReturnToEditing', 'organizationId', organizationId)
            // verify required parameter 'saveDealsAsReturnToEditingRequest' is not null or undefined
            assertParamExists('saveDealsAsReturnToEditing', 'saveDealsAsReturnToEditingRequest', saveDealsAsReturnToEditingRequest)
            const localVarPath = `/organizations/{organizationId}/deals/return_to_editing`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(saveDealsAsReturnToEditingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Search bank transfers
         * @param {string} organizationId 
         * @param {string} [transferDateJstFrom] yyyy-MM-dd format date in JST. Filter the bank transfers to be returned to only those which are scheduled to be transferred after this date.
         * @param {string} [transferDateJstTo] yyyy-MM-dd format date in JST. Filter the bank transfers to be returned to only those which are scheduled to be transferred before this date. Both transferDateJstFrom and transferDateJstTo are inclusive (closed interval).
         * @param {string} [sourceBankAccountId] Filter the bank transfers by the specified source bank account id.
         * @param {boolean} [downloaded] Filter the bank transfers by whether the corresponding transfer data has been downloaded.
         * @param {number} [limit] 
         * @param {number} [offset] See the description of &#x60;cursor&#x60; section Pagination
         * @param {string} [cursor] Pagination is performed by specifying either offset or cursor; if neither offset nor cursor is specified, it is assumed to be cursor-pagination and the first page is obtained with the next cursor. See below how the pagination exactly behaves:  - \&quot;\&quot; ... Get the fist page and return the next cursor  - \&quot;offset&#x3D;50\&quot; ... Get from the specified offset and never return the next cursor  - \&quot;cursor&#x3D;xxx\&quot; ... Get from the specified cursor  - \&quot;offset&#x3D;50&amp;cursor&#x3D;xxx\&quot; ... Ignore the offset and get from the specified cursor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchBankTransfers: async (organizationId: string, transferDateJstFrom?: string, transferDateJstTo?: string, sourceBankAccountId?: string, downloaded?: boolean, limit?: number, offset?: number, cursor?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('searchBankTransfers', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/payment_requests/bank_transfers`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (transferDateJstFrom !== undefined) {
                localVarQueryParameter['transferDateJstFrom'] = transferDateJstFrom;
            }

            if (transferDateJstTo !== undefined) {
                localVarQueryParameter['transferDateJstTo'] = transferDateJstTo;
            }

            if (sourceBankAccountId !== undefined) {
                localVarQueryParameter['sourceBankAccountId'] = sourceBankAccountId;
            }

            if (downloaded !== undefined) {
                localVarQueryParameter['downloaded'] = downloaded;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Search Corporations In National Tax Agency
         * @param {string} [name] 
         * @param {'PREFIX_MATCH' | 'PARTIAL_MATCH' | ''} [searchMethod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchCorporationsInNationalTaxAgency: async (name?: string, searchMethod?: 'PREFIX_MATCH' | 'PARTIAL_MATCH' | '', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/corporation_provided_national_tax_agency`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (searchMethod !== undefined) {
                localVarQueryParameter['searchMethod'] = searchMethod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Search deals
         * @param {string} organizationId 
         * @param {SearchDealsRequest} [searchDealsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchDeals: async (organizationId: string, searchDealsRequest?: SearchDealsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('searchDeals', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/search_deals`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(searchDealsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Search evidences
         * @param {string} organizationId 
         * @param {string} [issuer] This parameter will be deleted soon. Use keyword instead. If you specify this parameter, it will behave like the keyword, that is, it is searched from note as well as issuer.
         * @param {number} [amountMin] 
         * @param {number} [amountMax] 
         * @param {string} [paidAtFrom] 
         * @param {string} [paidAtTo] 
         * @param {boolean} [irrelevantToLedger] 
         * @param {string} [keyword] Specified keyword is searched from the issuer and the note by partial match.
         * @param {boolean} [includesDeleted] 
         * @param {Array<'VALID' | 'INVALID' | 'INPUT_REQUIRED' | 'OUT_OF_TARGET'>} [legalValidities] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchEvidences: async (organizationId: string, issuer?: string, amountMin?: number, amountMax?: number, paidAtFrom?: string, paidAtTo?: string, irrelevantToLedger?: boolean, keyword?: string, includesDeleted?: boolean, legalValidities?: Array<'VALID' | 'INVALID' | 'INPUT_REQUIRED' | 'OUT_OF_TARGET'>, limit?: number, offset?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('searchEvidences', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/evidences`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (issuer !== undefined) {
                localVarQueryParameter['issuer'] = issuer;
            }

            if (amountMin !== undefined) {
                localVarQueryParameter['amountMin'] = amountMin;
            }

            if (amountMax !== undefined) {
                localVarQueryParameter['amountMax'] = amountMax;
            }

            if (paidAtFrom !== undefined) {
                localVarQueryParameter['paidAtFrom'] = (paidAtFrom as any instanceof Date) ?
                    (paidAtFrom as any).toISOString() :
                    paidAtFrom;
            }

            if (paidAtTo !== undefined) {
                localVarQueryParameter['paidAtTo'] = (paidAtTo as any instanceof Date) ?
                    (paidAtTo as any).toISOString() :
                    paidAtTo;
            }

            if (irrelevantToLedger !== undefined) {
                localVarQueryParameter['irrelevantToLedger'] = irrelevantToLedger;
            }

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }

            if (includesDeleted !== undefined) {
                localVarQueryParameter['includesDeleted'] = includesDeleted;
            }

            if (legalValidities) {
                localVarQueryParameter['legalValidities'] = legalValidities;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Search my payment requests
         * @param {string} organizationId 
         * @param {string} [dueDateJstFrom] yyyy-MM-dd format date in JST. Filter the payment requests to be returned to only those which have a due date after this date.
         * @param {string} [dueDateJstTo] yyyy-MM-dd format date in JST. Filter the payment requests to be returned to only those which have a due date before this date. Both dueDateJstFrom and dueDateJstTo are inclusive (closed interval).
         * @param {string} [requestedDateJstFrom] yyyy-MM-dd format date in JST. Filter the payment requests to be returned to only those which have a requested at after this date.
         * @param {string} [requestedDateJstTo] yyyy-MM-dd format date in JST. Filter the payment requests to be returned to only those which have a requested at before this date.
         * @param {Array<'PENDING_WORKFLOW_COMPLETION' | 'CANCELED' | 'PAYABLE' | 'ATTACHED_TO_BANK_TRANSFER' | 'DEACTIVATED'>} [statuses] Filter the payment requests by the specified statuses. This parameter accepts both the following two forms:  - [comma separated style] /payment_requests?statuses&#x3D;PAYABLE,ATTACHED_TO_BANK_TRANSFER  - [exploded style]        /payment_requests?statuses&#x3D;PAYABLE&amp;statuses&#x3D;ATTACHED_TO_BANK_TRANSFER
         * @param {string} [supplierId] Filter the payment requests by the specified supplier id.
         * @param {boolean} [transferDataCreated] Filter the payment requests by whether the corresponding transaction data has been created.
         * @param {boolean} [withholdingApplied] Filter the payment requests by whether the withholding tax has been applied. true means the withholdingCalculatingMethod is NONE, while false, except for NONE.
         * @param {'SELF' | 'SUPPLIER'} [transferFeeResponsibility] Filter the payment requests by the specified transfer fee responsibility.
         * @param {string} [freeWord] A keyword used to search the following fields for partial matches:  - supplier name  - requestor name  - memo  - accounting items  - sections
         * @param {number} [limit] 
         * @param {number} [offset] See the description of &#x60;cursor&#x60; section Pagination
         * @param {string} [cursor] Pagination is performed by specifying either offset or cursor; if neither offset nor cursor is specified, it is assumed to be cursor-pagination and the first page is obtained with the next cursor. See below how the pagination exactly behaves:  - \&quot;\&quot; ... Get the fist page and return the next cursor  - \&quot;offset&#x3D;50\&quot; ... Get from the specified offset and never return the next cursor  - \&quot;cursor&#x3D;xxx\&quot; ... Get from the specified cursor  - \&quot;offset&#x3D;50&amp;cursor&#x3D;xxx\&quot; ... Ignore the offset and get from the specified cursor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchMyPaymentRequests: async (organizationId: string, dueDateJstFrom?: string, dueDateJstTo?: string, requestedDateJstFrom?: string, requestedDateJstTo?: string, statuses?: Array<'PENDING_WORKFLOW_COMPLETION' | 'CANCELED' | 'PAYABLE' | 'ATTACHED_TO_BANK_TRANSFER' | 'DEACTIVATED'>, supplierId?: string, transferDataCreated?: boolean, withholdingApplied?: boolean, transferFeeResponsibility?: 'SELF' | 'SUPPLIER', freeWord?: string, limit?: number, offset?: number, cursor?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('searchMyPaymentRequests', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/payment_requests/self`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (dueDateJstFrom !== undefined) {
                localVarQueryParameter['dueDateJstFrom'] = dueDateJstFrom;
            }

            if (dueDateJstTo !== undefined) {
                localVarQueryParameter['dueDateJstTo'] = dueDateJstTo;
            }

            if (requestedDateJstFrom !== undefined) {
                localVarQueryParameter['requestedDateJstFrom'] = requestedDateJstFrom;
            }

            if (requestedDateJstTo !== undefined) {
                localVarQueryParameter['requestedDateJstTo'] = requestedDateJstTo;
            }

            if (statuses) {
                localVarQueryParameter['statuses'] = statuses;
            }

            if (supplierId !== undefined) {
                localVarQueryParameter['supplierId'] = supplierId;
            }

            if (transferDataCreated !== undefined) {
                localVarQueryParameter['transferDataCreated'] = transferDataCreated;
            }

            if (withholdingApplied !== undefined) {
                localVarQueryParameter['withholdingApplied'] = withholdingApplied;
            }

            if (transferFeeResponsibility !== undefined) {
                localVarQueryParameter['transferFeeResponsibility'] = transferFeeResponsibility;
            }

            if (freeWord !== undefined) {
                localVarQueryParameter['freeWord'] = freeWord;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Search Organizations
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchOrganizations: async (key: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'key' is not null or undefined
            assertParamExists('searchOrganizations', 'key', key)
            const localVarPath = `/organizations/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (key !== undefined) {
                localVarQueryParameter['key'] = key;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Search payment requests
         * @param {string} organizationId 
         * @param {string} [dueDateJstFrom] yyyy-MM-dd format date in JST. Filter the payment requests to be returned to only those which have a due date after this date.
         * @param {string} [dueDateJstTo] yyyy-MM-dd format date in JST. Filter the payment requests to be returned to only those which have a due date before this date. Both dueDateJstFrom and dueDateJstTo are inclusive (closed interval).
         * @param {string} [requestedDateJstFrom] yyyy-MM-dd format date in JST. Filter the payment requests to be returned to only those which have a requested at after this date.
         * @param {string} [requestedDateJstTo] yyyy-MM-dd format date in JST. Filter the payment requests to be returned to only those which have a requested at before this date.
         * @param {Array<'PENDING_WORKFLOW_COMPLETION' | 'CANCELED' | 'PAYABLE' | 'ATTACHED_TO_BANK_TRANSFER' | 'DEACTIVATED'>} [statuses] Filter the payment requests by the specified statuses. This parameter accepts both the following two forms:  - [comma separated style] /payment_requests?statuses&#x3D;PAYABLE,ATTACHED_TO_BANK_TRANSFER  - [exploded style]        /payment_requests?statuses&#x3D;PAYABLE&amp;statuses&#x3D;ATTACHED_TO_BANK_TRANSFER
         * @param {string} [supplierId] Filter the payment requests by the specified supplier id.
         * @param {boolean} [transferDataCreated] Filter the payment requests by whether the corresponding transaction data has been created.
         * @param {boolean} [withholdingApplied] Filter the payment requests by whether the withholding tax has been applied. true means the withholdingCalculatingMethod is NONE, while false, except for NONE.
         * @param {'SELF' | 'SUPPLIER'} [transferFeeResponsibility] Filter the payment requests by the specified transfer fee responsibility.
         * @param {string} [requestorId] Filter the payment requests by the specified requestor id.
         * @param {string} [freeWord] A keyword used to search the following fields for partial matches:  - supplier name  - requestor name  - memo  - accounting items  - sections
         * @param {number} [limit] 
         * @param {number} [offset] See the description of &#x60;cursor&#x60; section Pagination
         * @param {string} [cursor] Pagination is performed by specifying either offset or cursor; if neither offset nor cursor is specified, it is assumed to be cursor-pagination and the first page is obtained with the next cursor. See below how the pagination exactly behaves:  - \&quot;\&quot; ... Get the fist page and return the next cursor  - \&quot;offset&#x3D;50\&quot; ... Get from the specified offset and never return the next cursor  - \&quot;cursor&#x3D;xxx\&quot; ... Get from the specified cursor  - \&quot;offset&#x3D;50&amp;cursor&#x3D;xxx\&quot; ... Ignore the offset and get from the specified cursor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchPaymentRequests: async (organizationId: string, dueDateJstFrom?: string, dueDateJstTo?: string, requestedDateJstFrom?: string, requestedDateJstTo?: string, statuses?: Array<'PENDING_WORKFLOW_COMPLETION' | 'CANCELED' | 'PAYABLE' | 'ATTACHED_TO_BANK_TRANSFER' | 'DEACTIVATED'>, supplierId?: string, transferDataCreated?: boolean, withholdingApplied?: boolean, transferFeeResponsibility?: 'SELF' | 'SUPPLIER', requestorId?: string, freeWord?: string, limit?: number, offset?: number, cursor?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('searchPaymentRequests', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/payment_requests`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (dueDateJstFrom !== undefined) {
                localVarQueryParameter['dueDateJstFrom'] = dueDateJstFrom;
            }

            if (dueDateJstTo !== undefined) {
                localVarQueryParameter['dueDateJstTo'] = dueDateJstTo;
            }

            if (requestedDateJstFrom !== undefined) {
                localVarQueryParameter['requestedDateJstFrom'] = requestedDateJstFrom;
            }

            if (requestedDateJstTo !== undefined) {
                localVarQueryParameter['requestedDateJstTo'] = requestedDateJstTo;
            }

            if (statuses) {
                localVarQueryParameter['statuses'] = statuses;
            }

            if (supplierId !== undefined) {
                localVarQueryParameter['supplierId'] = supplierId;
            }

            if (transferDataCreated !== undefined) {
                localVarQueryParameter['transferDataCreated'] = transferDataCreated;
            }

            if (withholdingApplied !== undefined) {
                localVarQueryParameter['withholdingApplied'] = withholdingApplied;
            }

            if (transferFeeResponsibility !== undefined) {
                localVarQueryParameter['transferFeeResponsibility'] = transferFeeResponsibility;
            }

            if (requestorId !== undefined) {
                localVarQueryParameter['requestorId'] = requestorId;
            }

            if (freeWord !== undefined) {
                localVarQueryParameter['freeWord'] = freeWord;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary send back onboarding request
         * @param {string} onboardingRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendBackOnboardingRequest: async (onboardingRequestId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'onboardingRequestId' is not null or undefined
            assertParamExists('sendBackOnboardingRequest', 'onboardingRequestId', onboardingRequestId)
            const localVarPath = `/zeus/onboarding_requests/{onboardingRequestId}/send_back`
                .replace(`{${"onboardingRequestId"}}`, encodeURIComponent(String(onboardingRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary send changed credit notifications
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendChangedCreditNotifications: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/organizations/send_changed_credit_notifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Send Organization Identity Verification
         * @param {string} organizationId 
         * @param {SendOrganizationIdentityVerificationRequest} sendOrganizationIdentityVerificationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendOrganizationIdentityVerification: async (organizationId: string, sendOrganizationIdentityVerificationRequest: SendOrganizationIdentityVerificationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('sendOrganizationIdentityVerification', 'organizationId', organizationId)
            // verify required parameter 'sendOrganizationIdentityVerificationRequest' is not null or undefined
            assertParamExists('sendOrganizationIdentityVerification', 'sendOrganizationIdentityVerificationRequest', sendOrganizationIdentityVerificationRequest)
            const localVarPath = `/organizations/{organizationId}/apply_identity_verification`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendOrganizationIdentityVerificationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Send Transaction Authorization Request
         * @param {string} organizationId 
         * @param {SendTransactionAuthorizationRequestRequest} sendTransactionAuthorizationRequestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendTransactionAuthorizationRequest: async (organizationId: string, sendTransactionAuthorizationRequestRequest: SendTransactionAuthorizationRequestRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('sendTransactionAuthorizationRequest', 'organizationId', organizationId)
            // verify required parameter 'sendTransactionAuthorizationRequestRequest' is not null or undefined
            assertParamExists('sendTransactionAuthorizationRequest', 'sendTransactionAuthorizationRequestRequest', sendTransactionAuthorizationRequestRequest)
            const localVarPath = `/organizations/{organizationId}/transaction_authorization_request`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendTransactionAuthorizationRequestRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Sign Up For Slack
         * @param {SignUpForSlackRequest} signUpForSlackRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signUpForSlack: async (signUpForSlackRequest: SignUpForSlackRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'signUpForSlackRequest' is not null or undefined
            assertParamExists('signUpForSlack', 'signUpForSlackRequest', signUpForSlackRequest)
            const localVarPath = `/slack/signup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(signUpForSlackRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Submit completed workflow of draft payment request
         * @param {string} organizationId 
         * @param {string} draftPaymentRequestId 
         * @param {string} [xUpsidrSwitchUser] 
         * @param {SubmitCompletedWorkflowOfDraftPaymentRequestsRequest} [submitCompletedWorkflowOfDraftPaymentRequestsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitCompletedWorkflowOfDraftPaymentRequests: async (organizationId: string, draftPaymentRequestId: string, xUpsidrSwitchUser?: string, submitCompletedWorkflowOfDraftPaymentRequestsRequest?: SubmitCompletedWorkflowOfDraftPaymentRequestsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('submitCompletedWorkflowOfDraftPaymentRequests', 'organizationId', organizationId)
            // verify required parameter 'draftPaymentRequestId' is not null or undefined
            assertParamExists('submitCompletedWorkflowOfDraftPaymentRequests', 'draftPaymentRequestId', draftPaymentRequestId)
            const localVarPath = `/organizations/{organizationId}/payment_requests/drafts/{draftPaymentRequestId}/submit_completed`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"draftPaymentRequestId"}}`, encodeURIComponent(String(draftPaymentRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xUpsidrSwitchUser != null) {
                localVarHeaderParameter['X-Upsidr-Switch-User'] = String(xUpsidrSwitchUser);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(submitCompletedWorkflowOfDraftPaymentRequestsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Submit completed workflow of payment request
         * @param {string} organizationId 
         * @param {string} [xUpsidrSwitchUser] 
         * @param {SubmitCompletedWorkflowOfPaymentRequestsRequest} [submitCompletedWorkflowOfPaymentRequestsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitCompletedWorkflowOfPaymentRequests: async (organizationId: string, xUpsidrSwitchUser?: string, submitCompletedWorkflowOfPaymentRequestsRequest?: SubmitCompletedWorkflowOfPaymentRequestsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('submitCompletedWorkflowOfPaymentRequests', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/payment_requests/submit_completed`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xUpsidrSwitchUser != null) {
                localVarHeaderParameter['X-Upsidr-Switch-User'] = String(xUpsidrSwitchUser);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(submitCompletedWorkflowOfPaymentRequestsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Submit workflow
         * @param {string} organizationId 
         * @param {string} workflowInstanceId 
         * @param {string} [xUpsidrSwitchUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitWorkflow: async (organizationId: string, workflowInstanceId: string, xUpsidrSwitchUser?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('submitWorkflow', 'organizationId', organizationId)
            // verify required parameter 'workflowInstanceId' is not null or undefined
            assertParamExists('submitWorkflow', 'workflowInstanceId', workflowInstanceId)
            const localVarPath = `/organizations/{organizationId}/workflows/instances/{workflowInstanceId}/submit`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"workflowInstanceId"}}`, encodeURIComponent(String(workflowInstanceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xUpsidrSwitchUser != null) {
                localVarHeaderParameter['X-Upsidr-Switch-User'] = String(xUpsidrSwitchUser);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Suspend a card
         * @param {string} organizationId 
         * @param {string} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suspendCard: async (organizationId: string, cardId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('suspendCard', 'organizationId', organizationId)
            // verify required parameter 'cardId' is not null or undefined
            assertParamExists('suspendCard', 'cardId', cardId)
            const localVarPath = `/organizations/{organizationId}/cards/{cardId}/suspend`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"cardId"}}`, encodeURIComponent(String(cardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncAllCardStatuses: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/cards/sync_card_statuses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Sync all users to each marketing tools
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncAllUsersToEachMarketingTools: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/marketing/sync_all_users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Sync freee account items
         * @param {string} organizationId 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncFreeeAccountItems: async (organizationId: string, companyId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('syncFreeeAccountItems', 'organizationId', organizationId)
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('syncFreeeAccountItems', 'companyId', companyId)
            const localVarPath = `/organizations/{organizationId}/freee/{companyId}/account_items/sync`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Sync freee partners
         * @param {string} organizationId 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncFreeePartners: async (organizationId: string, companyId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('syncFreeePartners', 'organizationId', organizationId)
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('syncFreeePartners', 'companyId', companyId)
            const localVarPath = `/organizations/{organizationId}/freee/{companyId}/partners/sync`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Sync freee segment tags
         * @param {string} organizationId 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncFreeeSegmentTags: async (organizationId: string, companyId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('syncFreeeSegmentTags', 'organizationId', organizationId)
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('syncFreeeSegmentTags', 'companyId', companyId)
            const localVarPath = `/organizations/{organizationId}/freee/{companyId}/segment_tags/sync`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Sync Moneytree access token
         * @param {string} code Authorization code received from Moneytree after successful authentication.
         * @param {string} state OAuth state parameter to ensure request consistency.
         * @param {string} [nextTo] URL to redirect to after syncing access token.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncMoneytreeAccessToken: async (code: string, state: string, nextTo?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('syncMoneytreeAccessToken', 'code', code)
            // verify required parameter 'state' is not null or undefined
            assertParamExists('syncMoneytreeAccessToken', 'state', state)
            const localVarPath = `/moneytree/token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }

            if (nextTo !== undefined) {
                localVarQueryParameter['next_to'] = nextTo;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Sync Request for Freee Deals
         * @param {string} organizationId 
         * @param {string} companyId 
         * @param {SyncRequestForFreeeDealsRequest} syncRequestForFreeeDealsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncRequestForFreeeDeals: async (organizationId: string, companyId: string, syncRequestForFreeeDealsRequest: SyncRequestForFreeeDealsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('syncRequestForFreeeDeals', 'organizationId', organizationId)
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('syncRequestForFreeeDeals', 'companyId', companyId)
            // verify required parameter 'syncRequestForFreeeDealsRequest' is not null or undefined
            assertParamExists('syncRequestForFreeeDeals', 'syncRequestForFreeeDealsRequest', syncRequestForFreeeDealsRequest)
            const localVarPath = `/organizations/{organizationId}/freee/{companyId}/deals/request_sync_to_freee`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(syncRequestForFreeeDealsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Two Factor Auth Reset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        twoFactorAuthReset: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/two_factor_auth/reset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Two Factor Auth Reset As Token
         * @param {TwoFactorAuthResetAsTokenRequest} twoFactorAuthResetAsTokenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        twoFactorAuthResetAsToken: async (twoFactorAuthResetAsTokenRequest: TwoFactorAuthResetAsTokenRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'twoFactorAuthResetAsTokenRequest' is not null or undefined
            assertParamExists('twoFactorAuthResetAsToken', 'twoFactorAuthResetAsTokenRequest', twoFactorAuthResetAsTokenRequest)
            const localVarPath = `/users/two_factor_auth/reset_as_token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(twoFactorAuthResetAsTokenRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Unlinking purchase to transaction.
         * @param {string} organizationId 
         * @param {string} purchaseApplicationId 
         * @param {string} [visaTransactionReferenceId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unlinkingPurchaseToTransaction: async (organizationId: string, purchaseApplicationId: string, visaTransactionReferenceId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('unlinkingPurchaseToTransaction', 'organizationId', organizationId)
            // verify required parameter 'purchaseApplicationId' is not null or undefined
            assertParamExists('unlinkingPurchaseToTransaction', 'purchaseApplicationId', purchaseApplicationId)
            const localVarPath = `/organizations/{organizationId}/purchase_applications/{purchaseApplicationId}/unlink`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"purchaseApplicationId"}}`, encodeURIComponent(String(purchaseApplicationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (visaTransactionReferenceId !== undefined) {
                localVarQueryParameter['visaTransactionReferenceId'] = visaTransactionReferenceId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Unlock a card due to no potential fraud
         * @param {string} organizationId 
         * @param {string} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unlockCardForNotPotentialFraud: async (organizationId: string, cardId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('unlockCardForNotPotentialFraud', 'organizationId', organizationId)
            // verify required parameter 'cardId' is not null or undefined
            assertParamExists('unlockCardForNotPotentialFraud', 'cardId', cardId)
            const localVarPath = `/organizations/{organizationId}/cards/{cardId}/unlock_for_potential_fraud`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"cardId"}}`, encodeURIComponent(String(cardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Unlock a card due to fraud cleared
         * @param {string} organizationId 
         * @param {string} cardId 
         * @param {string} visaTransactionReferenceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unlockCardOnFraudCleared: async (organizationId: string, cardId: string, visaTransactionReferenceId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('unlockCardOnFraudCleared', 'organizationId', organizationId)
            // verify required parameter 'cardId' is not null or undefined
            assertParamExists('unlockCardOnFraudCleared', 'cardId', cardId)
            // verify required parameter 'visaTransactionReferenceId' is not null or undefined
            assertParamExists('unlockCardOnFraudCleared', 'visaTransactionReferenceId', visaTransactionReferenceId)
            const localVarPath = `/organizations/{organizationId}/cards/{cardId}/unlock_on_fraud_cleared`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"cardId"}}`, encodeURIComponent(String(cardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (visaTransactionReferenceId !== undefined) {
                localVarQueryParameter['visaTransactionReferenceId'] = visaTransactionReferenceId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Available Currencies
         * @param {string} userAccountId 
         * @param {UpdateAvailableCurrenciesRequest} updateAvailableCurrenciesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAvailableCurrencies: async (userAccountId: string, updateAvailableCurrenciesRequest: UpdateAvailableCurrenciesRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userAccountId' is not null or undefined
            assertParamExists('updateAvailableCurrencies', 'userAccountId', userAccountId)
            // verify required parameter 'updateAvailableCurrenciesRequest' is not null or undefined
            assertParamExists('updateAvailableCurrencies', 'updateAvailableCurrenciesRequest', updateAvailableCurrenciesRequest)
            const localVarPath = `/user_accounts/{userAccountId}/available_currencies`
                .replace(`{${"userAccountId"}}`, encodeURIComponent(String(userAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAvailableCurrenciesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Available Merchant Categories
         * @param {string} userAccountId 
         * @param {UpdateAvailableMerchantCategoriesRequest} updateAvailableMerchantCategoriesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAvailableMerchantCategories: async (userAccountId: string, updateAvailableMerchantCategoriesRequest: UpdateAvailableMerchantCategoriesRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userAccountId' is not null or undefined
            assertParamExists('updateAvailableMerchantCategories', 'userAccountId', userAccountId)
            // verify required parameter 'updateAvailableMerchantCategoriesRequest' is not null or undefined
            assertParamExists('updateAvailableMerchantCategories', 'updateAvailableMerchantCategoriesRequest', updateAvailableMerchantCategoriesRequest)
            const localVarPath = `/user_accounts/{userAccountId}/available_merchant_categories`
                .replace(`{${"userAccountId"}}`, encodeURIComponent(String(userAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAvailableMerchantCategoriesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary update card account unit
         * @param {string} organizationId 
         * @param {UpdateCardAccountUnitRequest} updateCardAccountUnitRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCardAccountUnit: async (organizationId: string, updateCardAccountUnitRequest: UpdateCardAccountUnitRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateCardAccountUnit', 'organizationId', organizationId)
            // verify required parameter 'updateCardAccountUnitRequest' is not null or undefined
            assertParamExists('updateCardAccountUnit', 'updateCardAccountUnitRequest', updateCardAccountUnitRequest)
            const localVarPath = `/organizations/{organizationId}/freee/set_card_account_unit`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCardAccountUnitRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Card Count Limit
         * @param {string} organizationId 
         * @param {UpdateCardCountLimitRequest} updateCardCountLimitRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCardCountLimit: async (organizationId: string, updateCardCountLimitRequest: UpdateCardCountLimitRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateCardCountLimit', 'organizationId', organizationId)
            // verify required parameter 'updateCardCountLimitRequest' is not null or undefined
            assertParamExists('updateCardCountLimit', 'updateCardCountLimitRequest', updateCardCountLimitRequest)
            const localVarPath = `/organizations/{organizationId}/card_count_limit`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCardCountLimitRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update card holder for the user account
         * @param {string} userAccountId 
         * @param {UpdateCardHolderRequest} updateCardHolderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCardHolder: async (userAccountId: string, updateCardHolderRequest: UpdateCardHolderRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userAccountId' is not null or undefined
            assertParamExists('updateCardHolder', 'userAccountId', userAccountId)
            // verify required parameter 'updateCardHolderRequest' is not null or undefined
            assertParamExists('updateCardHolder', 'updateCardHolderRequest', updateCardHolderRequest)
            const localVarPath = `/user_accounts/{userAccountId}/update_card_holder`
                .replace(`{${"userAccountId"}}`, encodeURIComponent(String(userAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCardHolderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Lock a card
         * @param {string} organizationId 
         * @param {string} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCardLock: async (organizationId: string, cardId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateCardLock', 'organizationId', organizationId)
            // verify required parameter 'cardId' is not null or undefined
            assertParamExists('updateCardLock', 'cardId', cardId)
            const localVarPath = `/organizations/{organizationId}/cards/{cardId}/lock`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"cardId"}}`, encodeURIComponent(String(cardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Unlock a card
         * @param {string} organizationId 
         * @param {string} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCardUnlock: async (organizationId: string, cardId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateCardUnlock', 'organizationId', organizationId)
            // verify required parameter 'cardId' is not null or undefined
            assertParamExists('updateCardUnlock', 'cardId', cardId)
            const localVarPath = `/organizations/{organizationId}/cards/{cardId}/unlock`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"cardId"}}`, encodeURIComponent(String(cardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update comment for card transaction
         * @param {string} organizationId 
         * @param {string} paymentReferenceId 
         * @param {string} cardTransactionCommentId 
         * @param {UpdateCommentRequest} updateCommentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateComment: async (organizationId: string, paymentReferenceId: string, cardTransactionCommentId: string, updateCommentRequest: UpdateCommentRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateComment', 'organizationId', organizationId)
            // verify required parameter 'paymentReferenceId' is not null or undefined
            assertParamExists('updateComment', 'paymentReferenceId', paymentReferenceId)
            // verify required parameter 'cardTransactionCommentId' is not null or undefined
            assertParamExists('updateComment', 'cardTransactionCommentId', cardTransactionCommentId)
            // verify required parameter 'updateCommentRequest' is not null or undefined
            assertParamExists('updateComment', 'updateCommentRequest', updateCommentRequest)
            const localVarPath = `/organizations/{organizationId}/cards/transactions/{paymentReferenceId}/comment/{cardTransactionCommentId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"paymentReferenceId"}}`, encodeURIComponent(String(paymentReferenceId)))
                .replace(`{${"cardTransactionCommentId"}}`, encodeURIComponent(String(cardTransactionCommentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCommentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update comment template
         * @param {string} organizationId 
         * @param {string} templateId 
         * @param {UpdateCommentTemplateRequest} updateCommentTemplateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCommentTemplate: async (organizationId: string, templateId: string, updateCommentTemplateRequest: UpdateCommentTemplateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateCommentTemplate', 'organizationId', organizationId)
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('updateCommentTemplate', 'templateId', templateId)
            // verify required parameter 'updateCommentTemplateRequest' is not null or undefined
            assertParamExists('updateCommentTemplate', 'updateCommentTemplateRequest', updateCommentTemplateRequest)
            const localVarPath = `/organizations/{organizationId}/user_accounts/comment_templates/{templateId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"templateId"}}`, encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCommentTemplateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update corporate document verification result
         * @param {string} organizationIdentityVerificationId 
         * @param {UpdateCorporateDocumentResultRequest} updateCorporateDocumentResultRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCorporateDocumentResult: async (organizationIdentityVerificationId: string, updateCorporateDocumentResultRequest: UpdateCorporateDocumentResultRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationIdentityVerificationId' is not null or undefined
            assertParamExists('updateCorporateDocumentResult', 'organizationIdentityVerificationId', organizationIdentityVerificationId)
            // verify required parameter 'updateCorporateDocumentResultRequest' is not null or undefined
            assertParamExists('updateCorporateDocumentResult', 'updateCorporateDocumentResultRequest', updateCorporateDocumentResultRequest)
            const localVarPath = `/zeus/organization_identity_verifications/{organizationIdentityVerificationId}/corporate_document/result`
                .replace(`{${"organizationIdentityVerificationId"}}`, encodeURIComponent(String(organizationIdentityVerificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCorporateDocumentResultRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update daily usage limit for the user account
         * @param {string} userAccountId 
         * @param {UpdateDailyUserUsageLimitRequest} updateDailyUserUsageLimitRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDailyUserUsageLimit: async (userAccountId: string, updateDailyUserUsageLimitRequest: UpdateDailyUserUsageLimitRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userAccountId' is not null or undefined
            assertParamExists('updateDailyUserUsageLimit', 'userAccountId', userAccountId)
            // verify required parameter 'updateDailyUserUsageLimitRequest' is not null or undefined
            assertParamExists('updateDailyUserUsageLimit', 'updateDailyUserUsageLimitRequest', updateDailyUserUsageLimitRequest)
            const localVarPath = `/user_accounts/{userAccountId}/update_daily_usage_limit`
                .replace(`{${"userAccountId"}}`, encodeURIComponent(String(userAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDailyUserUsageLimitRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update deposit restriction for organization
         * @param {string} organizationId 
         * @param {string} depositRestrictionId 
         * @param {UpdateDepositRestrictionForOrganizationRequest} updateDepositRestrictionForOrganizationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDepositRestrictionForOrganization: async (organizationId: string, depositRestrictionId: string, updateDepositRestrictionForOrganizationRequest: UpdateDepositRestrictionForOrganizationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateDepositRestrictionForOrganization', 'organizationId', organizationId)
            // verify required parameter 'depositRestrictionId' is not null or undefined
            assertParamExists('updateDepositRestrictionForOrganization', 'depositRestrictionId', depositRestrictionId)
            // verify required parameter 'updateDepositRestrictionForOrganizationRequest' is not null or undefined
            assertParamExists('updateDepositRestrictionForOrganization', 'updateDepositRestrictionForOrganizationRequest', updateDepositRestrictionForOrganizationRequest)
            const localVarPath = `/organizations/{organizationId}/deposit_restrictions/{depositRestrictionId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"depositRestrictionId"}}`, encodeURIComponent(String(depositRestrictionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDepositRestrictionForOrganizationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Toggle on/off email notification settings per user
         * @param {string} userId 
         * @param {string} emailNotificationId 
         * @param {UpdateEmailNotificationRequest} updateEmailNotificationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEmailNotification: async (userId: string, emailNotificationId: string, updateEmailNotificationRequest: UpdateEmailNotificationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateEmailNotification', 'userId', userId)
            // verify required parameter 'emailNotificationId' is not null or undefined
            assertParamExists('updateEmailNotification', 'emailNotificationId', emailNotificationId)
            // verify required parameter 'updateEmailNotificationRequest' is not null or undefined
            assertParamExists('updateEmailNotification', 'updateEmailNotificationRequest', updateEmailNotificationRequest)
            const localVarPath = `/users/{userId}/email_notifications/{emailNotificationId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"emailNotificationId"}}`, encodeURIComponent(String(emailNotificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateEmailNotificationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary update embed url method
         * @param {string} organizationId 
         * @param {UpdateEmbedUrlMethodRequest} updateEmbedUrlMethodRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEmbedUrlMethod: async (organizationId: string, updateEmbedUrlMethodRequest: UpdateEmbedUrlMethodRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateEmbedUrlMethod', 'organizationId', organizationId)
            // verify required parameter 'updateEmbedUrlMethodRequest' is not null or undefined
            assertParamExists('updateEmbedUrlMethod', 'updateEmbedUrlMethodRequest', updateEmbedUrlMethodRequest)
            const localVarPath = `/organizations/{organizationId}/freee/embed_url_method`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateEmbedUrlMethodRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update evidence image
         * @param {string} organizationId 
         * @param {string} paymentReferenceId 
         * @param {string} cardTransactionEvidenceId 
         * @param {File} [file] 
         * @param {string} [electronicMethod] 
         * @param {string} [documentSize] 
         * @param {number} [heightMillis] 
         * @param {number} [widthMillis] 
         * @param {string} [note] 
         * @param {boolean} [irrelevantToLedger] 
         * @param {boolean} [dpiForciblyValid] 
         * @param {boolean} [colorGradationForciblyValid] 
         * @param {boolean} [uploadedByRecipient] 
         * @param {string} [uploadedFrom] 
         * @param {string} [invoiceIssuerName] 
         * @param {string} [invoiceIssuerRegistrationNumber] 
         * @param {boolean} [asQualified] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEvidenceImage: async (organizationId: string, paymentReferenceId: string, cardTransactionEvidenceId: string, file?: File, electronicMethod?: string, documentSize?: string, heightMillis?: number, widthMillis?: number, note?: string, irrelevantToLedger?: boolean, dpiForciblyValid?: boolean, colorGradationForciblyValid?: boolean, uploadedByRecipient?: boolean, uploadedFrom?: string, invoiceIssuerName?: string, invoiceIssuerRegistrationNumber?: string, asQualified?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateEvidenceImage', 'organizationId', organizationId)
            // verify required parameter 'paymentReferenceId' is not null or undefined
            assertParamExists('updateEvidenceImage', 'paymentReferenceId', paymentReferenceId)
            // verify required parameter 'cardTransactionEvidenceId' is not null or undefined
            assertParamExists('updateEvidenceImage', 'cardTransactionEvidenceId', cardTransactionEvidenceId)
            const localVarPath = `/organizations/{organizationId}/cards/transactions/{paymentReferenceId}/evidence/{cardTransactionEvidenceId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"paymentReferenceId"}}`, encodeURIComponent(String(paymentReferenceId)))
                .replace(`{${"cardTransactionEvidenceId"}}`, encodeURIComponent(String(cardTransactionEvidenceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
            if (electronicMethod !== undefined) { 
                localVarFormParams.append('electronicMethod', electronicMethod as any);
            }
    
            if (documentSize !== undefined) { 
                localVarFormParams.append('documentSize', documentSize as any);
            }
    
            if (heightMillis !== undefined) { 
                localVarFormParams.append('heightMillis', heightMillis as any);
            }
    
            if (widthMillis !== undefined) { 
                localVarFormParams.append('widthMillis', widthMillis as any);
            }
    
            if (note !== undefined) { 
                localVarFormParams.append('note', note as any);
            }
    
            if (irrelevantToLedger !== undefined) { 
                localVarFormParams.append('irrelevantToLedger', irrelevantToLedger as any);
            }
    
            if (dpiForciblyValid !== undefined) { 
                localVarFormParams.append('dpiForciblyValid', dpiForciblyValid as any);
            }
    
            if (colorGradationForciblyValid !== undefined) { 
                localVarFormParams.append('colorGradationForciblyValid', colorGradationForciblyValid as any);
            }
    
            if (uploadedByRecipient !== undefined) { 
                localVarFormParams.append('uploadedByRecipient', uploadedByRecipient as any);
            }
    
            if (uploadedFrom !== undefined) { 
                localVarFormParams.append('uploadedFrom', uploadedFrom as any);
            }
    
            if (invoiceIssuerName !== undefined) { 
                localVarFormParams.append('invoiceIssuerName', invoiceIssuerName as any);
            }
    
            if (invoiceIssuerRegistrationNumber !== undefined) { 
                localVarFormParams.append('invoiceIssuerRegistrationNumber', invoiceIssuerRegistrationNumber as any);
            }
    
            if (asQualified !== undefined) { 
                localVarFormParams.append('asQualified', asQualified as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update evidence info
         * @param {string} organizationId 
         * @param {string} paymentReferenceId 
         * @param {string} cardTransactionEvidenceId 
         * @param {UpdateEvidenceInfoRequest} updateEvidenceInfoRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEvidenceInfo: async (organizationId: string, paymentReferenceId: string, cardTransactionEvidenceId: string, updateEvidenceInfoRequest: UpdateEvidenceInfoRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateEvidenceInfo', 'organizationId', organizationId)
            // verify required parameter 'paymentReferenceId' is not null or undefined
            assertParamExists('updateEvidenceInfo', 'paymentReferenceId', paymentReferenceId)
            // verify required parameter 'cardTransactionEvidenceId' is not null or undefined
            assertParamExists('updateEvidenceInfo', 'cardTransactionEvidenceId', cardTransactionEvidenceId)
            // verify required parameter 'updateEvidenceInfoRequest' is not null or undefined
            assertParamExists('updateEvidenceInfo', 'updateEvidenceInfoRequest', updateEvidenceInfoRequest)
            const localVarPath = `/organizations/{organizationId}/cards/transactions/{paymentReferenceId}/evidence/{cardTransactionEvidenceId}/info`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"paymentReferenceId"}}`, encodeURIComponent(String(paymentReferenceId)))
                .replace(`{${"cardTransactionEvidenceId"}}`, encodeURIComponent(String(cardTransactionEvidenceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateEvidenceInfoRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update freee connect
         * @param {string} organizationId 
         * @param {string} code 
         * @param {string} state 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFreeeConnect: async (organizationId: string, code: string, state: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateFreeeConnect', 'organizationId', organizationId)
            // verify required parameter 'code' is not null or undefined
            assertParamExists('updateFreeeConnect', 'code', code)
            // verify required parameter 'state' is not null or undefined
            assertParamExists('updateFreeeConnect', 'state', state)
            const localVarPath = `/organizations/{organizationId}/freee/connect`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Turn on/off freee journaling
         * @param {string} organizationId 
         * @param {UpdateFreeeJournalingRequest} updateFreeeJournalingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFreeeJournaling: async (organizationId: string, updateFreeeJournalingRequest: UpdateFreeeJournalingRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateFreeeJournaling', 'organizationId', organizationId)
            // verify required parameter 'updateFreeeJournalingRequest' is not null or undefined
            assertParamExists('updateFreeeJournaling', 'updateFreeeJournalingRequest', updateFreeeJournalingRequest)
            const localVarPath = `/organizations/{organizationId}/freee/journaling`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateFreeeJournalingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update freee select company
         * @param {string} organizationId 
         * @param {UpdateFreeeSelectCompanyRequest} updateFreeeSelectCompanyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFreeeSelectCompany: async (organizationId: string, updateFreeeSelectCompanyRequest: UpdateFreeeSelectCompanyRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateFreeeSelectCompany', 'organizationId', organizationId)
            // verify required parameter 'updateFreeeSelectCompanyRequest' is not null or undefined
            assertParamExists('updateFreeeSelectCompany', 'updateFreeeSelectCompanyRequest', updateFreeeSelectCompanyRequest)
            const localVarPath = `/organizations/{organizationId}/freee/select_company`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateFreeeSelectCompanyRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update lock status of evidences
         * @param {string} organizationId 
         * @param {UpdateLockStatusOfEvidencesRequest} updateLockStatusOfEvidencesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLockStatusOfEvidences: async (organizationId: string, updateLockStatusOfEvidencesRequest: UpdateLockStatusOfEvidencesRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateLockStatusOfEvidences', 'organizationId', organizationId)
            // verify required parameter 'updateLockStatusOfEvidencesRequest' is not null or undefined
            assertParamExists('updateLockStatusOfEvidences', 'updateLockStatusOfEvidencesRequest', updateLockStatusOfEvidencesRequest)
            const localVarPath = `/organizations/{organizationId}/cards/transactions/evidence/lock`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateLockStatusOfEvidencesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update merchant general block allowed organization ids
         * @param {string} merchantGeneralBlockListId 
         * @param {UpdateMerchantGeneralBlockAllowedOrganizationIdsRequest} updateMerchantGeneralBlockAllowedOrganizationIdsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMerchantGeneralBlockAllowedOrganizationIds: async (merchantGeneralBlockListId: string, updateMerchantGeneralBlockAllowedOrganizationIdsRequest: UpdateMerchantGeneralBlockAllowedOrganizationIdsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantGeneralBlockListId' is not null or undefined
            assertParamExists('updateMerchantGeneralBlockAllowedOrganizationIds', 'merchantGeneralBlockListId', merchantGeneralBlockListId)
            // verify required parameter 'updateMerchantGeneralBlockAllowedOrganizationIdsRequest' is not null or undefined
            assertParamExists('updateMerchantGeneralBlockAllowedOrganizationIds', 'updateMerchantGeneralBlockAllowedOrganizationIdsRequest', updateMerchantGeneralBlockAllowedOrganizationIdsRequest)
            const localVarPath = `/merchant_general_block_lists/{merchantGeneralBlockListId}/allowed_organizations`
                .replace(`{${"merchantGeneralBlockListId"}}`, encodeURIComponent(String(merchantGeneralBlockListId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateMerchantGeneralBlockAllowedOrganizationIdsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update merchant general block list
         * @param {string} merchantGeneralBlockListId 
         * @param {UpdateMerchantGeneralBlockListRequest} updateMerchantGeneralBlockListRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMerchantGeneralBlockList: async (merchantGeneralBlockListId: string, updateMerchantGeneralBlockListRequest: UpdateMerchantGeneralBlockListRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantGeneralBlockListId' is not null or undefined
            assertParamExists('updateMerchantGeneralBlockList', 'merchantGeneralBlockListId', merchantGeneralBlockListId)
            // verify required parameter 'updateMerchantGeneralBlockListRequest' is not null or undefined
            assertParamExists('updateMerchantGeneralBlockList', 'updateMerchantGeneralBlockListRequest', updateMerchantGeneralBlockListRequest)
            const localVarPath = `/merchant_general_block_lists/{merchantGeneralBlockListId}`
                .replace(`{${"merchantGeneralBlockListId"}}`, encodeURIComponent(String(merchantGeneralBlockListId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateMerchantGeneralBlockListRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update merchant org block list
         * @param {string} merchantOrgBlockListId 
         * @param {UpdateMerchantOrgBlockListRequest} updateMerchantOrgBlockListRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMerchantOrgBlockList: async (merchantOrgBlockListId: string, updateMerchantOrgBlockListRequest: UpdateMerchantOrgBlockListRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantOrgBlockListId' is not null or undefined
            assertParamExists('updateMerchantOrgBlockList', 'merchantOrgBlockListId', merchantOrgBlockListId)
            // verify required parameter 'updateMerchantOrgBlockListRequest' is not null or undefined
            assertParamExists('updateMerchantOrgBlockList', 'updateMerchantOrgBlockListRequest', updateMerchantOrgBlockListRequest)
            const localVarPath = `/merchant_org_block_lists/{merchantOrgBlockListId}`
                .replace(`{${"merchantOrgBlockListId"}}`, encodeURIComponent(String(merchantOrgBlockListId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateMerchantOrgBlockListRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Merchant Organization Comment
         * @param {string} organizationId 
         * @param {string} merchantId 
         * @param {string} userAccountId 
         * @param {UpdateMerchantOrganizationCommentRequest} updateMerchantOrganizationCommentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMerchantOrganizationComment: async (organizationId: string, merchantId: string, userAccountId: string, updateMerchantOrganizationCommentRequest: UpdateMerchantOrganizationCommentRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateMerchantOrganizationComment', 'organizationId', organizationId)
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('updateMerchantOrganizationComment', 'merchantId', merchantId)
            // verify required parameter 'userAccountId' is not null or undefined
            assertParamExists('updateMerchantOrganizationComment', 'userAccountId', userAccountId)
            // verify required parameter 'updateMerchantOrganizationCommentRequest' is not null or undefined
            assertParamExists('updateMerchantOrganizationComment', 'updateMerchantOrganizationCommentRequest', updateMerchantOrganizationCommentRequest)
            const localVarPath = `/organizations/{organizationId}/merchants/{merchantId}/user_accounts/{userAccountId}/comment`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"merchantId"}}`, encodeURIComponent(String(merchantId)))
                .replace(`{${"userAccountId"}}`, encodeURIComponent(String(userAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateMerchantOrganizationCommentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Organization
         * @param {string} organizationId 
         * @param {UpdateOrganizationRequest} updateOrganizationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganization: async (organizationId: string, updateOrganizationRequest: UpdateOrganizationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateOrganization', 'organizationId', organizationId)
            // verify required parameter 'updateOrganizationRequest' is not null or undefined
            assertParamExists('updateOrganization', 'updateOrganizationRequest', updateOrganizationRequest)
            const localVarPath = `/organizations/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateOrganizationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Organizations Accounting Csv Export Fields
         * @param {string} organizationId 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganizationsAccountingCsvExportFields: async (organizationId: string, requestBody: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateOrganizationsAccountingCsvExportFields', 'organizationId', organizationId)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('updateOrganizationsAccountingCsvExportFields', 'requestBody', requestBody)
            const localVarPath = `/organizations/{organizationId}/cards/accounting/csv_export_fields`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update the payment request evidence specified by evidenceId.
         * @summary Update the specific payment request evidence.
         * @param {string} organizationId 
         * @param {string} paymentRequestId 
         * @param {string} evidenceId 
         * @param {UpdatePaymentRequestEvidenceRequest} updatePaymentRequestEvidenceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePaymentRequestEvidence: async (organizationId: string, paymentRequestId: string, evidenceId: string, updatePaymentRequestEvidenceRequest: UpdatePaymentRequestEvidenceRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updatePaymentRequestEvidence', 'organizationId', organizationId)
            // verify required parameter 'paymentRequestId' is not null or undefined
            assertParamExists('updatePaymentRequestEvidence', 'paymentRequestId', paymentRequestId)
            // verify required parameter 'evidenceId' is not null or undefined
            assertParamExists('updatePaymentRequestEvidence', 'evidenceId', evidenceId)
            // verify required parameter 'updatePaymentRequestEvidenceRequest' is not null or undefined
            assertParamExists('updatePaymentRequestEvidence', 'updatePaymentRequestEvidenceRequest', updatePaymentRequestEvidenceRequest)
            const localVarPath = `/organizations/{organizationId}/payment_requests/{paymentRequestId}/evidences/{evidenceId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"paymentRequestId"}}`, encodeURIComponent(String(paymentRequestId)))
                .replace(`{${"evidenceId"}}`, encodeURIComponent(String(evidenceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePaymentRequestEvidenceRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update the payment request evidence file specified by evidenceId. This also accept properties other than a file binary.
         * @summary Update the specific payment request evidence file.
         * @param {string} organizationId 
         * @param {string} paymentRequestId 
         * @param {string} evidenceId 
         * @param {File} [file] 
         * @param {string} [electronicMethod] 
         * @param {string} [documentSize] 
         * @param {number} [heightMillis] 
         * @param {number} [widthMillis] 
         * @param {boolean} [dpiForciblyValid] 
         * @param {boolean} [colorGradationForciblyValid] 
         * @param {string} [note] 
         * @param {boolean} [irrelevantToLedger] 
         * @param {boolean} [uploadedByRecipient] 
         * @param {string} [uploadedFrom] 
         * @param {string} [invoiceIssuerRegistrationNumber] 
         * @param {string} [invoiceIssuerName] 
         * @param {boolean} [asQualified] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePaymentRequestEvidenceFile: async (organizationId: string, paymentRequestId: string, evidenceId: string, file?: File, electronicMethod?: string, documentSize?: string, heightMillis?: number, widthMillis?: number, dpiForciblyValid?: boolean, colorGradationForciblyValid?: boolean, note?: string, irrelevantToLedger?: boolean, uploadedByRecipient?: boolean, uploadedFrom?: string, invoiceIssuerRegistrationNumber?: string, invoiceIssuerName?: string, asQualified?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updatePaymentRequestEvidenceFile', 'organizationId', organizationId)
            // verify required parameter 'paymentRequestId' is not null or undefined
            assertParamExists('updatePaymentRequestEvidenceFile', 'paymentRequestId', paymentRequestId)
            // verify required parameter 'evidenceId' is not null or undefined
            assertParamExists('updatePaymentRequestEvidenceFile', 'evidenceId', evidenceId)
            const localVarPath = `/organizations/{organizationId}/payment_requests/{paymentRequestId}/evidences/{evidenceId}/file`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"paymentRequestId"}}`, encodeURIComponent(String(paymentRequestId)))
                .replace(`{${"evidenceId"}}`, encodeURIComponent(String(evidenceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
            if (electronicMethod !== undefined) { 
                localVarFormParams.append('electronicMethod', electronicMethod as any);
            }
    
            if (documentSize !== undefined) { 
                localVarFormParams.append('documentSize', documentSize as any);
            }
    
            if (heightMillis !== undefined) { 
                localVarFormParams.append('heightMillis', heightMillis as any);
            }
    
            if (widthMillis !== undefined) { 
                localVarFormParams.append('widthMillis', widthMillis as any);
            }
    
            if (dpiForciblyValid !== undefined) { 
                localVarFormParams.append('dpiForciblyValid', dpiForciblyValid as any);
            }
    
            if (colorGradationForciblyValid !== undefined) { 
                localVarFormParams.append('colorGradationForciblyValid', colorGradationForciblyValid as any);
            }
    
            if (note !== undefined) { 
                localVarFormParams.append('note', note as any);
            }
    
            if (irrelevantToLedger !== undefined) { 
                localVarFormParams.append('irrelevantToLedger', irrelevantToLedger as any);
            }
    
            if (uploadedByRecipient !== undefined) { 
                localVarFormParams.append('uploadedByRecipient', uploadedByRecipient as any);
            }
    
            if (uploadedFrom !== undefined) { 
                localVarFormParams.append('uploadedFrom', uploadedFrom as any);
            }
    
            if (invoiceIssuerRegistrationNumber !== undefined) { 
                localVarFormParams.append('invoiceIssuerRegistrationNumber', invoiceIssuerRegistrationNumber as any);
            }
    
            if (invoiceIssuerName !== undefined) { 
                localVarFormParams.append('invoiceIssuerName', invoiceIssuerName as any);
            }
    
            if (asQualified !== undefined) { 
                localVarFormParams.append('asQualified', asQualified as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update purchase application template.
         * @param {string} organizationId 
         * @param {string} purchaseTemplateId 
         * @param {UpdatePurchaseApplicationTemplateRequest} [updatePurchaseApplicationTemplateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePurchaseApplicationTemplate: async (organizationId: string, purchaseTemplateId: string, updatePurchaseApplicationTemplateRequest?: UpdatePurchaseApplicationTemplateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updatePurchaseApplicationTemplate', 'organizationId', organizationId)
            // verify required parameter 'purchaseTemplateId' is not null or undefined
            assertParamExists('updatePurchaseApplicationTemplate', 'purchaseTemplateId', purchaseTemplateId)
            const localVarPath = `/organizations/{organizationId}/purchase_applications/templates/{purchaseTemplateId}/update`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"purchaseTemplateId"}}`, encodeURIComponent(String(purchaseTemplateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePurchaseApplicationTemplateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update remove user account group
         * @param {string} userAccountId 
         * @param {UpdateRemoveUserAccountGroupRequest} updateRemoveUserAccountGroupRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRemoveUserAccountGroup: async (userAccountId: string, updateRemoveUserAccountGroupRequest: UpdateRemoveUserAccountGroupRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userAccountId' is not null or undefined
            assertParamExists('updateRemoveUserAccountGroup', 'userAccountId', userAccountId)
            // verify required parameter 'updateRemoveUserAccountGroupRequest' is not null or undefined
            assertParamExists('updateRemoveUserAccountGroup', 'updateRemoveUserAccountGroupRequest', updateRemoveUserAccountGroupRequest)
            const localVarPath = `/user_accounts/{userAccountId}/remove_user_account_group`
                .replace(`{${"userAccountId"}}`, encodeURIComponent(String(userAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateRemoveUserAccountGroupRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update role resource for user
         * @param {string} userId 
         * @param {UpdateRoleResourceForUserRequest} updateRoleResourceForUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRoleResourceForUser: async (userId: string, updateRoleResourceForUserRequest: UpdateRoleResourceForUserRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateRoleResourceForUser', 'userId', userId)
            // verify required parameter 'updateRoleResourceForUserRequest' is not null or undefined
            assertParamExists('updateRoleResourceForUser', 'updateRoleResourceForUserRequest', updateRoleResourceForUserRequest)
            const localVarPath = `/roles/user_account/users/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateRoleResourceForUserRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Roles by Resource Id
         * @param {string} resourceScope 
         * @param {string} resourceId 
         * @param {UpdateRolesByResourceIdRequest} updateRolesByResourceIdRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRolesByResourceId: async (resourceScope: string, resourceId: string, updateRolesByResourceIdRequest: UpdateRolesByResourceIdRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resourceScope' is not null or undefined
            assertParamExists('updateRolesByResourceId', 'resourceScope', resourceScope)
            // verify required parameter 'resourceId' is not null or undefined
            assertParamExists('updateRolesByResourceId', 'resourceId', resourceId)
            // verify required parameter 'updateRolesByResourceIdRequest' is not null or undefined
            assertParamExists('updateRolesByResourceId', 'updateRolesByResourceIdRequest', updateRolesByResourceIdRequest)
            const localVarPath = `/roles/user_account/{resourceScope}/{resourceId}`
                .replace(`{${"resourceScope"}}`, encodeURIComponent(String(resourceScope)))
                .replace(`{${"resourceId"}}`, encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateRolesByResourceIdRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Slack evidence remind settings of an slack channel
         * @param {string} organizationId 
         * @param {string} channelId 
         * @param {UpdateSlackEvidenceReminderPerChannelRequest} updateSlackEvidenceReminderPerChannelRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSlackEvidenceReminderPerChannel: async (organizationId: string, channelId: string, updateSlackEvidenceReminderPerChannelRequest: UpdateSlackEvidenceReminderPerChannelRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateSlackEvidenceReminderPerChannel', 'organizationId', organizationId)
            // verify required parameter 'channelId' is not null or undefined
            assertParamExists('updateSlackEvidenceReminderPerChannel', 'channelId', channelId)
            // verify required parameter 'updateSlackEvidenceReminderPerChannelRequest' is not null or undefined
            assertParamExists('updateSlackEvidenceReminderPerChannel', 'updateSlackEvidenceReminderPerChannelRequest', updateSlackEvidenceReminderPerChannelRequest)
            const localVarPath = `/slack/organizations/{organizationId}/cards/evidence_reminders/{channelId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"channelId"}}`, encodeURIComponent(String(channelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSlackEvidenceReminderPerChannelRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update slack notification channel setting for card
         * @param {string} organizationId 
         * @param {string} channelId 
         * @param {UpdateSlackNotificationSettingForCardRequest} updateSlackNotificationSettingForCardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSlackNotificationSettingForCard: async (organizationId: string, channelId: string, updateSlackNotificationSettingForCardRequest: UpdateSlackNotificationSettingForCardRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateSlackNotificationSettingForCard', 'organizationId', organizationId)
            // verify required parameter 'channelId' is not null or undefined
            assertParamExists('updateSlackNotificationSettingForCard', 'channelId', channelId)
            // verify required parameter 'updateSlackNotificationSettingForCardRequest' is not null or undefined
            assertParamExists('updateSlackNotificationSettingForCard', 'updateSlackNotificationSettingForCardRequest', updateSlackNotificationSettingForCardRequest)
            const localVarPath = `/slack/organizations/{organizationId}/channels/{channelId}/cards/notification`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"channelId"}}`, encodeURIComponent(String(channelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSlackNotificationSettingForCardRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update slack notification channel setting for purchase-application
         * @param {string} organizationId 
         * @param {string} channelId 
         * @param {UpdateSlackNotificationSettingForPurchaseApplicationRequest} updateSlackNotificationSettingForPurchaseApplicationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSlackNotificationSettingForPurchaseApplication: async (organizationId: string, channelId: string, updateSlackNotificationSettingForPurchaseApplicationRequest: UpdateSlackNotificationSettingForPurchaseApplicationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateSlackNotificationSettingForPurchaseApplication', 'organizationId', organizationId)
            // verify required parameter 'channelId' is not null or undefined
            assertParamExists('updateSlackNotificationSettingForPurchaseApplication', 'channelId', channelId)
            // verify required parameter 'updateSlackNotificationSettingForPurchaseApplicationRequest' is not null or undefined
            assertParamExists('updateSlackNotificationSettingForPurchaseApplication', 'updateSlackNotificationSettingForPurchaseApplicationRequest', updateSlackNotificationSettingForPurchaseApplicationRequest)
            const localVarPath = `/slack/organizations/{organizationId}/channels/{channelId}/purchase_applications/notification`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"channelId"}}`, encodeURIComponent(String(channelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSlackNotificationSettingForPurchaseApplicationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update sync to freee from deal
         * @param {string} organizationId 
         * @param {string} companyId 
         * @param {string} dealId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSyncToFreeeFromDeal: async (organizationId: string, companyId: string, dealId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateSyncToFreeeFromDeal', 'organizationId', organizationId)
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('updateSyncToFreeeFromDeal', 'companyId', companyId)
            // verify required parameter 'dealId' is not null or undefined
            assertParamExists('updateSyncToFreeeFromDeal', 'dealId', dealId)
            const localVarPath = `/organizations/{organizationId}/freee/{companyId}/deals/{dealId}/sync_to_freee`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
                .replace(`{${"dealId"}}`, encodeURIComponent(String(dealId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update synchronize to freee log confirm
         * @param {string} organizationId 
         * @param {string} companyId 
         * @param {UpdateSynchronizeToFreeeLogConfirmRequest} updateSynchronizeToFreeeLogConfirmRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSynchronizeToFreeeLogConfirm: async (organizationId: string, companyId: string, updateSynchronizeToFreeeLogConfirmRequest: UpdateSynchronizeToFreeeLogConfirmRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateSynchronizeToFreeeLogConfirm', 'organizationId', organizationId)
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('updateSynchronizeToFreeeLogConfirm', 'companyId', companyId)
            // verify required parameter 'updateSynchronizeToFreeeLogConfirmRequest' is not null or undefined
            assertParamExists('updateSynchronizeToFreeeLogConfirm', 'updateSynchronizeToFreeeLogConfirmRequest', updateSynchronizeToFreeeLogConfirmRequest)
            const localVarPath = `/organizations/{organizationId}/freee/{companyId}/synchronize_to_freee_log/confirm`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSynchronizeToFreeeLogConfirmRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Teams notification channel setting for card
         * @param {string} organizationId 
         * @param {string} channelId 
         * @param {UpdateTeamsNotificationSettingForCardRequest} updateTeamsNotificationSettingForCardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTeamsNotificationSettingForCard: async (organizationId: string, channelId: string, updateTeamsNotificationSettingForCardRequest: UpdateTeamsNotificationSettingForCardRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateTeamsNotificationSettingForCard', 'organizationId', organizationId)
            // verify required parameter 'channelId' is not null or undefined
            assertParamExists('updateTeamsNotificationSettingForCard', 'channelId', channelId)
            // verify required parameter 'updateTeamsNotificationSettingForCardRequest' is not null or undefined
            assertParamExists('updateTeamsNotificationSettingForCard', 'updateTeamsNotificationSettingForCardRequest', updateTeamsNotificationSettingForCardRequest)
            const localVarPath = `/teams/organizations/{organizationId}/channels/{channelId}/cards/notification`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"channelId"}}`, encodeURIComponent(String(channelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTeamsNotificationSettingForCardRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update transaction upper limit for the user account
         * @param {string} userAccountId 
         * @param {UpdateTransactionUpperLimitForTheUserAccountRequest} updateTransactionUpperLimitForTheUserAccountRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTransactionUpperLimitForTheUserAccount: async (userAccountId: string, updateTransactionUpperLimitForTheUserAccountRequest: UpdateTransactionUpperLimitForTheUserAccountRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userAccountId' is not null or undefined
            assertParamExists('updateTransactionUpperLimitForTheUserAccount', 'userAccountId', userAccountId)
            // verify required parameter 'updateTransactionUpperLimitForTheUserAccountRequest' is not null or undefined
            assertParamExists('updateTransactionUpperLimitForTheUserAccount', 'updateTransactionUpperLimitForTheUserAccountRequest', updateTransactionUpperLimitForTheUserAccountRequest)
            const localVarPath = `/user_accounts/{userAccountId}/update_transaction_upper_limit`
                .replace(`{${"userAccountId"}}`, encodeURIComponent(String(userAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTransactionUpperLimitForTheUserAccountRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update user account group
         * @param {string} userAccountId 
         * @param {UpdateUserAccountGroupRequest} updateUserAccountGroupRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserAccountGroup: async (userAccountId: string, updateUserAccountGroupRequest: UpdateUserAccountGroupRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userAccountId' is not null or undefined
            assertParamExists('updateUserAccountGroup', 'userAccountId', userAccountId)
            // verify required parameter 'updateUserAccountGroupRequest' is not null or undefined
            assertParamExists('updateUserAccountGroup', 'updateUserAccountGroupRequest', updateUserAccountGroupRequest)
            const localVarPath = `/user_accounts/{userAccountId}/set_user_account_group`
                .replace(`{${"userAccountId"}}`, encodeURIComponent(String(userAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUserAccountGroupRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update user account name
         * @param {string} userAccountId 
         * @param {UpdateUserAccountNameRequest} updateUserAccountNameRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserAccountName: async (userAccountId: string, updateUserAccountNameRequest: UpdateUserAccountNameRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userAccountId' is not null or undefined
            assertParamExists('updateUserAccountName', 'userAccountId', userAccountId)
            // verify required parameter 'updateUserAccountNameRequest' is not null or undefined
            assertParamExists('updateUserAccountName', 'updateUserAccountNameRequest', updateUserAccountNameRequest)
            const localVarPath = `/user_accounts/{userAccountId}/rename`
                .replace(`{${"userAccountId"}}`, encodeURIComponent(String(userAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUserAccountNameRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary update user email, settings per user
         * @param {string} userId 
         * @param {UpdateUserEmailRequest} updateUserEmailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserEmail: async (userId: string, updateUserEmailRequest: UpdateUserEmailRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateUserEmail', 'userId', userId)
            // verify required parameter 'updateUserEmailRequest' is not null or undefined
            assertParamExists('updateUserEmail', 'updateUserEmailRequest', updateUserEmailRequest)
            const localVarPath = `/users/{userId}/email`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUserEmailRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary update user name, settings per user
         * @param {string} userId 
         * @param {UpdateUserNameRequest} updateUserNameRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserName: async (userId: string, updateUserNameRequest: UpdateUserNameRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateUserName', 'userId', userId)
            // verify required parameter 'updateUserNameRequest' is not null or undefined
            assertParamExists('updateUserName', 'updateUserNameRequest', updateUserNameRequest)
            const localVarPath = `/users/{userId}/name`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUserNameRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary update user organization
         * @param {string} userId 
         * @param {UpdateUserOrganizationRequest} updateUserOrganizationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserOrganization: async (userId: string, updateUserOrganizationRequest: UpdateUserOrganizationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateUserOrganization', 'userId', userId)
            // verify required parameter 'updateUserOrganizationRequest' is not null or undefined
            assertParamExists('updateUserOrganization', 'updateUserOrganizationRequest', updateUserOrganizationRequest)
            const localVarPath = `/users/{userId}/organization`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUserOrganizationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary update user password
         * @param {string} userId 
         * @param {UpdateUserPasswordRequest} updateUserPasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserPassword: async (userId: string, updateUserPasswordRequest: UpdateUserPasswordRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateUserPassword', 'userId', userId)
            // verify required parameter 'updateUserPasswordRequest' is not null or undefined
            assertParamExists('updateUserPassword', 'updateUserPasswordRequest', updateUserPasswordRequest)
            const localVarPath = `/users/{userId}/password`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUserPasswordRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update User Privilege
         * @param {string} organizationId 
         * @param {string} userId 
         * @param {UpdateUserPrivilegeRequest} updateUserPrivilegeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserPrivilege: async (organizationId: string, userId: string, updateUserPrivilegeRequest: UpdateUserPrivilegeRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateUserPrivilege', 'organizationId', organizationId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateUserPrivilege', 'userId', userId)
            // verify required parameter 'updateUserPrivilegeRequest' is not null or undefined
            assertParamExists('updateUserPrivilege', 'updateUserPrivilegeRequest', updateUserPrivilegeRequest)
            const localVarPath = `/organizations/user_privilege/{organizationId}/{userId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUserPrivilegeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update usage limit for the user account
         * @param {string} userAccountId 
         * @param {UpdateUserUsageLimitRequest} updateUserUsageLimitRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserUsageLimit: async (userAccountId: string, updateUserUsageLimitRequest: UpdateUserUsageLimitRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userAccountId' is not null or undefined
            assertParamExists('updateUserUsageLimit', 'userAccountId', userAccountId)
            // verify required parameter 'updateUserUsageLimitRequest' is not null or undefined
            assertParamExists('updateUserUsageLimit', 'updateUserUsageLimitRequest', updateUserUsageLimitRequest)
            const localVarPath = `/user_accounts/{userAccountId}/update_usage_limit`
                .replace(`{${"userAccountId"}}`, encodeURIComponent(String(userAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUserUsageLimitRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload card transaction evidence images
         * @param {string} organizationId 
         * @param {string} paymentReferenceId 
         * @param {Array<File>} [files] 
         * @param {string} [electronicMethod] 
         * @param {string} [documentSize] 
         * @param {number} [heightMillis] 
         * @param {number} [widthMillis] 
         * @param {string} [note] 
         * @param {boolean} [irrelevantToLedger] 
         * @param {boolean} [uploadedByRecipient] 
         * @param {string} [uploadedFrom] 
         * @param {string} [invoiceIssuerName] 
         * @param {string} [invoiceIssuerRegistrationNumber] 
         * @param {boolean} [asQualified] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadCardTransactionEvidenceImage: async (organizationId: string, paymentReferenceId: string, files?: Array<File>, electronicMethod?: string, documentSize?: string, heightMillis?: number, widthMillis?: number, note?: string, irrelevantToLedger?: boolean, uploadedByRecipient?: boolean, uploadedFrom?: string, invoiceIssuerName?: string, invoiceIssuerRegistrationNumber?: string, asQualified?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('uploadCardTransactionEvidenceImage', 'organizationId', organizationId)
            // verify required parameter 'paymentReferenceId' is not null or undefined
            assertParamExists('uploadCardTransactionEvidenceImage', 'paymentReferenceId', paymentReferenceId)
            const localVarPath = `/organizations/{organizationId}/cards/transactions/{paymentReferenceId}/evidence`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"paymentReferenceId"}}`, encodeURIComponent(String(paymentReferenceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (files) {
                files.forEach((element) => {
                    localVarFormParams.append('files', element as any);
                })
            }

    
            if (electronicMethod !== undefined) { 
                localVarFormParams.append('electronicMethod', electronicMethod as any);
            }
    
            if (documentSize !== undefined) { 
                localVarFormParams.append('documentSize', documentSize as any);
            }
    
            if (heightMillis !== undefined) { 
                localVarFormParams.append('heightMillis', heightMillis as any);
            }
    
            if (widthMillis !== undefined) { 
                localVarFormParams.append('widthMillis', widthMillis as any);
            }
    
            if (note !== undefined) { 
                localVarFormParams.append('note', note as any);
            }
    
            if (irrelevantToLedger !== undefined) { 
                localVarFormParams.append('irrelevantToLedger', irrelevantToLedger as any);
            }
    
            if (uploadedByRecipient !== undefined) { 
                localVarFormParams.append('uploadedByRecipient', uploadedByRecipient as any);
            }
    
            if (uploadedFrom !== undefined) { 
                localVarFormParams.append('uploadedFrom', uploadedFrom as any);
            }
    
            if (invoiceIssuerName !== undefined) { 
                localVarFormParams.append('invoiceIssuerName', invoiceIssuerName as any);
            }
    
            if (invoiceIssuerRegistrationNumber !== undefined) { 
                localVarFormParams.append('invoiceIssuerRegistrationNumber', invoiceIssuerRegistrationNumber as any);
            }
    
            if (asQualified !== undefined) { 
                localVarFormParams.append('asQualified', asQualified as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload corporate document
         * @param {string} organizationIdentityVerificationId 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadCorporateDocument: async (organizationIdentityVerificationId: string, file: File, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationIdentityVerificationId' is not null or undefined
            assertParamExists('uploadCorporateDocument', 'organizationIdentityVerificationId', organizationIdentityVerificationId)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadCorporateDocument', 'file', file)
            const localVarPath = `/zeus/organization_identity_verifications/{organizationIdentityVerificationId}/corporate_document`
                .replace(`{${"organizationIdentityVerificationId"}}`, encodeURIComponent(String(organizationIdentityVerificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload payment request evidence image
         * @param {string} organizationId 
         * @param {string} paymentRequestId 
         * @param {File} [file] 
         * @param {string} [electronicMethod] 
         * @param {string} [documentSize] 
         * @param {number} [heightMillis] 
         * @param {number} [widthMillis] 
         * @param {string} [note] 
         * @param {boolean} [irrelevantToLedger] 
         * @param {boolean} [uploadedByRecipient] 
         * @param {string} [uploadedFrom] 
         * @param {string} [invoiceIssuerName] 
         * @param {string} [invoiceIssuerRegistrationNumber] 
         * @param {boolean} [asQualified] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadPaymentRequestEvidenceImage: async (organizationId: string, paymentRequestId: string, file?: File, electronicMethod?: string, documentSize?: string, heightMillis?: number, widthMillis?: number, note?: string, irrelevantToLedger?: boolean, uploadedByRecipient?: boolean, uploadedFrom?: string, invoiceIssuerName?: string, invoiceIssuerRegistrationNumber?: string, asQualified?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('uploadPaymentRequestEvidenceImage', 'organizationId', organizationId)
            // verify required parameter 'paymentRequestId' is not null or undefined
            assertParamExists('uploadPaymentRequestEvidenceImage', 'paymentRequestId', paymentRequestId)
            const localVarPath = `/organizations/{organizationId}/payment_requests/{paymentRequestId}/evidences`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"paymentRequestId"}}`, encodeURIComponent(String(paymentRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
            if (electronicMethod !== undefined) { 
                localVarFormParams.append('electronicMethod', electronicMethod as any);
            }
    
            if (documentSize !== undefined) { 
                localVarFormParams.append('documentSize', documentSize as any);
            }
    
            if (heightMillis !== undefined) { 
                localVarFormParams.append('heightMillis', heightMillis as any);
            }
    
            if (widthMillis !== undefined) { 
                localVarFormParams.append('widthMillis', widthMillis as any);
            }
    
            if (note !== undefined) { 
                localVarFormParams.append('note', note as any);
            }
    
            if (irrelevantToLedger !== undefined) { 
                localVarFormParams.append('irrelevantToLedger', irrelevantToLedger as any);
            }
    
            if (uploadedByRecipient !== undefined) { 
                localVarFormParams.append('uploadedByRecipient', uploadedByRecipient as any);
            }
    
            if (uploadedFrom !== undefined) { 
                localVarFormParams.append('uploadedFrom', uploadedFrom as any);
            }
    
            if (invoiceIssuerName !== undefined) { 
                localVarFormParams.append('invoiceIssuerName', invoiceIssuerName as any);
            }
    
            if (invoiceIssuerRegistrationNumber !== undefined) { 
                localVarFormParams.append('invoiceIssuerRegistrationNumber', invoiceIssuerRegistrationNumber as any);
            }
    
            if (asQualified !== undefined) { 
                localVarFormParams.append('asQualified', asQualified as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Users email confirm
         * @param {UsersEmailConfirmRequest} usersEmailConfirmRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersEmailConfirm: async (usersEmailConfirmRequest: UsersEmailConfirmRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'usersEmailConfirmRequest' is not null or undefined
            assertParamExists('usersEmailConfirm', 'usersEmailConfirmRequest', usersEmailConfirmRequest)
            const localVarPath = `/users/email/confirm`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(usersEmailConfirmRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Verify moneytree connections
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyMoneytreeConnections: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('verifyMoneytreeConnections', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/moneytree/connections/verify`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DefaultApi - functional programming interface
 * @export
 */
export const DefaultApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Add comment for card transaction
         * @param {string} organizationId 
         * @param {string} paymentReferenceId 
         * @param {AddCommentRequest} addCommentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addComment(organizationId: string, paymentReferenceId: string, addCommentRequest: AddCommentRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addComment(organizationId, paymentReferenceId, addCommentRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Add Organization Create Request
         * @param {AddOrganizationCreateRequestRequest} addOrganizationCreateRequestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addOrganizationCreateRequest(addOrganizationCreateRequestRequest: AddOrganizationCreateRequestRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddOrganizationCreateRequest200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addOrganizationCreateRequest(addOrganizationCreateRequestRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary add point to organization
         * @param {string} organizationId 
         * @param {AddPointToOrganizationRequest} addPointToOrganizationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addPointToOrganization(organizationId: string, addPointToOrganizationRequest: AddPointToOrganizationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addPointToOrganization(organizationId, addPointToOrganizationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Agree to the agreement request
         * @param {string} organizationId 
         * @param {string} agreementRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agreeToAgreementRequest(organizationId: string, agreementRequestId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.agreeToAgreementRequest(organizationId, agreementRequestId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Analyze evidence
         * @param {string} organizationId 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async analyzeEvidence(organizationId: string, file?: File, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AnalyzeEvidence200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.analyzeEvidence(organizationId, file, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Analyze invoice of payment requests
         * @param {string} organizationId 
         * @param {File} file 
         * @param {string} [xUpsidrSwitchUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async analyzeInvoiceOfPaymentRequests(organizationId: string, file: File, xUpsidrSwitchUser?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AnalyzeInvoiceOfPaymentRequests200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.analyzeInvoiceOfPaymentRequests(organizationId, file, xUpsidrSwitchUser, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Approve organization identity verification
         * @param {number} organizationIdentityVerificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async approveOrganizationIdentityVerification(organizationIdentityVerificationId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApproveOrganizationIdentityVerification200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.approveOrganizationIdentityVerification(organizationIdentityVerificationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Approve purchase application.
         * @param {string} organizationId 
         * @param {string} purchaseApplicationId 
         * @param {ApprovePurchaseApplicationRequest} approvePurchaseApplicationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async approvePurchaseApplication(organizationId: string, purchaseApplicationId: string, approvePurchaseApplicationRequest: ApprovePurchaseApplicationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.approvePurchaseApplication(organizationId, purchaseApplicationId, approvePurchaseApplicationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Approve workflow step of payment request
         * @param {string} organizationId 
         * @param {string} [xUpsidrSwitchUser] 
         * @param {ApproveWorkflowStepPaymentRequestsRequest} [approveWorkflowStepPaymentRequestsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async approveWorkflowStepPaymentRequests(organizationId: string, xUpsidrSwitchUser?: string, approveWorkflowStepPaymentRequestsRequest?: ApproveWorkflowStepPaymentRequestsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.approveWorkflowStepPaymentRequests(organizationId, xUpsidrSwitchUser, approveWorkflowStepPaymentRequestsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Automatically journalize deals from rules
         * @param {string} organizationId 
         * @param {string} companyId 
         * @param {AutomaticallyJournalizeDealsFromRulesRequest} automaticallyJournalizeDealsFromRulesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async automaticallyJournalizeDealsFromRules(organizationId: string, companyId: string, automaticallyJournalizeDealsFromRulesRequest: AutomaticallyJournalizeDealsFromRulesRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.automaticallyJournalizeDealsFromRules(organizationId, companyId, automaticallyJournalizeDealsFromRulesRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Bank Account Activities Withdrawal Reserve
         * @param {BankAccountActivitiesWithdrawalReserveRequest} bankAccountActivitiesWithdrawalReserveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bankAccountActivitiesWithdrawalReserve(bankAccountActivitiesWithdrawalReserveRequest: BankAccountActivitiesWithdrawalReserveRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BankAccountActivitiesWithdrawalReserve200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bankAccountActivitiesWithdrawalReserve(bankAccountActivitiesWithdrawalReserveRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Disable daily usage limit for an user account
         * @param {BulkDisableDailyUserUsageLimitRequest} bulkDisableDailyUserUsageLimitRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkDisableDailyUserUsageLimit(bulkDisableDailyUserUsageLimitRequest: BulkDisableDailyUserUsageLimitRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BulkDisableDailyUserUsageLimit200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkDisableDailyUserUsageLimit(bulkDisableDailyUserUsageLimitRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Bulk disable monthly usage limit
         * @param {BulkDisableMonthlyUsageLimitRequest} bulkDisableMonthlyUsageLimitRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkDisableMonthlyUsageLimit(bulkDisableMonthlyUsageLimitRequest: BulkDisableMonthlyUsageLimitRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BulkDisableMonthlyUsageLimit200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkDisableMonthlyUsageLimit(bulkDisableMonthlyUsageLimitRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Bulk update daily usage limit
         * @param {BulkUpdateDailyUsageLimitRequest} bulkUpdateDailyUsageLimitRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkUpdateDailyUsageLimit(bulkUpdateDailyUsageLimitRequest: BulkUpdateDailyUsageLimitRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BulkUpdateDailyUsageLimit200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkUpdateDailyUsageLimit(bulkUpdateDailyUsageLimitRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Bulk update monthly usage limit
         * @param {BulkUpdateMonthlyUsageLimitRequest} bulkUpdateMonthlyUsageLimitRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkUpdateMonthlyUsageLimit(bulkUpdateMonthlyUsageLimitRequest: BulkUpdateMonthlyUsageLimitRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BulkUpdateMonthlyUsageLimit200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkUpdateMonthlyUsageLimit(bulkUpdateMonthlyUsageLimitRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Bulk Update Organization User Privileges
         * @param {string} organizationId 
         * @param {BulkUpdateOrganizationUserPrivilegesRequest} bulkUpdateOrganizationUserPrivilegesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkUpdateOrganizationUserPrivileges(organizationId: string, bulkUpdateOrganizationUserPrivilegesRequest: BulkUpdateOrganizationUserPrivilegesRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkUpdateOrganizationUserPrivileges(organizationId, bulkUpdateOrganizationUserPrivilegesRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Cancel draft payment request
         * @param {string} organizationId 
         * @param {string} draftPaymentRequestId 
         * @param {string} [xUpsidrSwitchUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelDraftPaymentRequest(organizationId: string, draftPaymentRequestId: string, xUpsidrSwitchUser?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelDraftPaymentRequest(organizationId, draftPaymentRequestId, xUpsidrSwitchUser, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Cancel payment request
         * @param {string} organizationId 
         * @param {string} paymentRequestId 
         * @param {string} [xUpsidrSwitchUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelPaymentRequest(organizationId: string, paymentRequestId: string, xUpsidrSwitchUser?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelPaymentRequest(organizationId, paymentRequestId, xUpsidrSwitchUser, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Change Identity Verification Scheduled Date
         * @param {string} organizationId 
         * @param {ChangeIdentityVerificationScheduledDateRequest} changeIdentityVerificationScheduledDateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeIdentityVerificationScheduledDate(organizationId: string, changeIdentityVerificationScheduledDateRequest: ChangeIdentityVerificationScheduledDateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChangeIdentityVerificationScheduledDate200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeIdentityVerificationScheduledDate(organizationId, changeIdentityVerificationScheduledDateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Change Invoice Email
         * @param {string} organizationId 
         * @param {ChangeInvoiceEmailRequest} changeInvoiceEmailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeInvoiceEmail(organizationId: string, changeInvoiceEmailRequest: ChangeInvoiceEmailRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChangeInvoiceEmail200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeInvoiceEmail(organizationId, changeInvoiceEmailRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Change to the specified ekyc result
         * @param {string} identificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeToTheSpecifiedEkycResult(identificationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeToTheSpecifiedEkycResult(identificationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Check Already Registered Phone Number
         * @param {CheckAlreadyRegisteredPhoneNumberRequest} checkAlreadyRegisteredPhoneNumberRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkAlreadyRegisteredPhoneNumber(checkAlreadyRegisteredPhoneNumberRequest: CheckAlreadyRegisteredPhoneNumberRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckAlreadyRegisteredPhoneNumber200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkAlreadyRegisteredPhoneNumber(checkAlreadyRegisteredPhoneNumberRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Check All Organization Available Limit And Notify
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkAvailableLimit(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkAvailableLimit(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Check duplicate email addresses
         * @param {Array<string>} [emailAddresses] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkDuplicateEmailAddresses(emailAddresses?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CheckDuplicateEmailAddresses200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkDuplicateEmailAddresses(emailAddresses, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkMonthlyUsageLimit(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkMonthlyUsageLimit(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * It is an API that waits for a redirect after the payment request fix button is pressed in the Slack App. This API does three things:   - Slack message modification - remove each button attached to the original message   - Post messages to Slack - communicate the fact that the edit button was pressed   - Create payment request for draft data
         * @summary Complete redirect from slack
         * @param {string} organizationId 
         * @param {CompleteRedirectFromSlackRequest} [completeRedirectFromSlackRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async completeRedirectFromSlack(organizationId: string, completeRedirectFromSlackRequest?: CompleteRedirectFromSlackRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompleteRedirectFromSlack200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.completeRedirectFromSlack(organizationId, completeRedirectFromSlackRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Count deals
         * @param {string} organizationId 
         * @param {CountDealsRequest} [countDealsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countDeals(organizationId: string, countDealsRequest?: CountDealsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countDeals(organizationId, countDealsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Create bank transfers for the specified payment requests.
         * @summary Create bank transfers
         * @param {string} organizationId 
         * @param {CreateBankTransfersRequest} createBankTransfersRequest 
         * @param {string} [transferDateJstFrom] yyyy-MM-dd format date in JST. Filter the bank transfers to be returned to only those which are scheduled to be transferred after this date.
         * @param {string} [transferDateJstTo] yyyy-MM-dd format date in JST. Filter the bank transfers to be returned to only those which are scheduled to be transferred before this date. Both transferDateJstFrom and transferDateJstTo are inclusive (closed interval).
         * @param {string} [sourceBankAccountId] Filter the bank transfers by the specified source bank account id.
         * @param {boolean} [downloaded] Filter the bank transfers by whether the corresponding transfer data has been downloaded.
         * @param {number} [limit] 
         * @param {number} [offset] See the description of &#x60;cursor&#x60; section Pagination
         * @param {string} [cursor] Pagination is performed by specifying either offset or cursor; if neither offset nor cursor is specified, it is assumed to be cursor-pagination and the first page is obtained with the next cursor. See below how the pagination exactly behaves:  - \&quot;\&quot; ... Get the fist page and return the next cursor  - \&quot;offset&#x3D;50\&quot; ... Get from the specified offset and never return the next cursor  - \&quot;cursor&#x3D;xxx\&quot; ... Get from the specified cursor  - \&quot;offset&#x3D;50&amp;cursor&#x3D;xxx\&quot; ... Ignore the offset and get from the specified cursor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createBankTransfers(organizationId: string, createBankTransfersRequest: CreateBankTransfersRequest, transferDateJstFrom?: string, transferDateJstTo?: string, sourceBankAccountId?: string, downloaded?: boolean, limit?: number, offset?: number, cursor?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateBankTransfers200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createBankTransfers(organizationId, createBankTransfersRequest, transferDateJstFrom, transferDateJstTo, sourceBankAccountId, downloaded, limit, offset, cursor, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create category of the purchase application template.
         * @param {string} organizationId 
         * @param {CreateCategoryOfThePurchaseApplicationTemplateRequest} createCategoryOfThePurchaseApplicationTemplateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCategoryOfThePurchaseApplicationTemplate(organizationId: string, createCategoryOfThePurchaseApplicationTemplateRequest: CreateCategoryOfThePurchaseApplicationTemplateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCategoryOfThePurchaseApplicationTemplate(organizationId, createCategoryOfThePurchaseApplicationTemplateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create comment template
         * @param {string} organizationId 
         * @param {CreateCommentTemplateRequest} createCommentTemplateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCommentTemplate(organizationId: string, createCommentTemplateRequest: CreateCommentTemplateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCommentTemplate(organizationId, createCommentTemplateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create deposit restriction for organization
         * @param {string} organizationId 
         * @param {CreateDepositRestrictionForOrganizationRequest} createDepositRestrictionForOrganizationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDepositRestrictionForOrganization(organizationId: string, createDepositRestrictionForOrganizationRequest: CreateDepositRestrictionForOrganizationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDepositRestrictionForOrganization(organizationId, createDepositRestrictionForOrganizationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create draft of payment request
         * @param {string} organizationId 
         * @param {string} [xUpsidrSwitchUser] 
         * @param {CreateDraftOfPaymentRequestsRequest} [createDraftOfPaymentRequestsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDraftOfPaymentRequests(organizationId: string, xUpsidrSwitchUser?: string, createDraftOfPaymentRequestsRequest?: CreateDraftOfPaymentRequestsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateDraftOfPaymentRequests200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDraftOfPaymentRequests(organizationId, xUpsidrSwitchUser, createDraftOfPaymentRequestsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create evidence request
         * @param {string} organizationId 
         * @param {string} paymentReferenceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEvidenceRequest(organizationId: string, paymentReferenceId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateEvidenceRequest200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEvidenceRequest(organizationId, paymentReferenceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create freee partner
         * @param {string} organizationId 
         * @param {string} companyId 
         * @param {CreateFreeePartnerRequest} createFreeePartnerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createFreeePartner(organizationId: string, companyId: string, createFreeePartnerRequest: CreateFreeePartnerRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateFreeePartner200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createFreeePartner(organizationId, companyId, createFreeePartnerRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create past deals
         * @param {string} organizationId 
         * @param {CreatePastDealsRequest} createPastDealsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPastDeals(organizationId: string, createPastDealsRequest: CreatePastDealsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPastDeals(organizationId, createPastDealsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create purchase application.
         * @param {string} organizationId 
         * @param {CreatePurchaseApplicationRequest} createPurchaseApplicationRequest 
         * @param {string} [visaTransactionReferenceId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPurchaseApplication(organizationId: string, createPurchaseApplicationRequest: CreatePurchaseApplicationRequest, visaTransactionReferenceId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPurchaseApplication(organizationId, createPurchaseApplicationRequest, visaTransactionReferenceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create purchase application template.
         * @param {string} organizationId 
         * @param {CreatePurchaseApplicationTemplateRequest} createPurchaseApplicationTemplateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPurchaseApplicationTemplate(organizationId: string, createPurchaseApplicationTemplateRequest: CreatePurchaseApplicationTemplateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPurchaseApplicationTemplate(organizationId, createPurchaseApplicationTemplateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create Slack card notification settings of an organization
         * @param {string} organizationId 
         * @param {CreateSlackCardNotificationsRequest} createSlackCardNotificationsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSlackCardNotifications(organizationId: string, createSlackCardNotificationsRequest: CreateSlackCardNotificationsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSlackCardNotifications(organizationId, createSlackCardNotificationsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create slack notification settings for purchase-application
         * @param {string} organizationId 
         * @param {CreateSlackNotificationSettingsForPurchaseApplicationRequest} createSlackNotificationSettingsForPurchaseApplicationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSlackNotificationSettingsForPurchaseApplication(organizationId: string, createSlackNotificationSettingsForPurchaseApplicationRequest: CreateSlackNotificationSettingsForPurchaseApplicationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSlackNotificationSettingsForPurchaseApplication(organizationId, createSlackNotificationSettingsForPurchaseApplicationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create Teams card notification settings of an organization
         * @param {string} organizationId 
         * @param {CreateTeamsCardNotificationsRequest} createTeamsCardNotificationsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTeamsCardNotifications(organizationId: string, createTeamsCardNotificationsRequest: CreateTeamsCardNotificationsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTeamsCardNotifications(organizationId, createTeamsCardNotificationsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create user account groups
         * @param {string} organizationId 
         * @param {CreateUserAccountGroupsRequest} [createUserAccountGroupsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createUserAccountGroups(organizationId: string, createUserAccountGroupsRequest?: CreateUserAccountGroupsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CreateUserAccountGroups200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createUserAccountGroups(organizationId, createUserAccountGroupsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Deactivate a card
         * @param {string} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deactivateCard(cardId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeactivateCard200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deactivateCard(cardId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Deactivate a user
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deactivateUser(userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deactivateUser(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Defrost a card
         * @param {string} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async defrostCard(cardId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DefrostCard200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.defrostCard(cardId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete Card Points Rate Configs
         * @param {string} rateConfigId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCardPointsRateConfig(rateConfigId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCardPointsRateConfig(rateConfigId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete category of the purchase application template.
         * @param {string} organizationId 
         * @param {string} purchaseTemplateCategoryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCategoryOfThePurchaseApplicationTemplate(organizationId: string, purchaseTemplateCategoryId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCategoryOfThePurchaseApplicationTemplate(organizationId, purchaseTemplateCategoryId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete comment for card transaction
         * @param {string} organizationId 
         * @param {string} paymentReferenceId 
         * @param {string} cardTransactionCommentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteComment(organizationId: string, paymentReferenceId: string, cardTransactionCommentId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteComment(organizationId, paymentReferenceId, cardTransactionCommentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete comment template
         * @param {string} organizationId 
         * @param {string} templateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCommentTemplate(organizationId: string, templateId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCommentTemplate(organizationId, templateId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete deposit restriction for organization
         * @param {string} organizationId 
         * @param {string} depositRestrictionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDepositRestrictionForOrganization(organizationId: string, depositRestrictionId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDepositRestrictionForOrganization(organizationId, depositRestrictionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete evidence
         * @param {string} organizationId 
         * @param {string} paymentReferenceId 
         * @param {string} cardTransactionEvidenceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEvidence(organizationId: string, paymentReferenceId: string, cardTransactionEvidenceId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEvidence(organizationId, paymentReferenceId, cardTransactionEvidenceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete freee connected
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteFreeeConnected(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteFreeeConnected200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteFreeeConnected(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete Freee End Journal Entry Transition Mode
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteFreeeEndJournalEntryTransitionMode(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteFreeeEndJournalEntryTransitionMode(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete merchant general block allowed organization ids
         * @param {string} merchantGeneralBlockListId 
         * @param {string} allowedOrganizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteMerchantGeneralBlockAllowedOrganizationIds(merchantGeneralBlockListId: string, allowedOrganizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteMerchantGeneralBlockAllowedOrganizationIds(merchantGeneralBlockListId, allowedOrganizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete merchant general block list
         * @param {string} merchantGeneralBlockListId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteMerchantGeneralBlockList(merchantGeneralBlockListId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteMerchantGeneralBlockList(merchantGeneralBlockListId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete merchant org block list
         * @param {string} merchantOrgBlockListId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteMerchantOrgBlockList(merchantOrgBlockListId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteMerchantOrgBlockList(merchantOrgBlockListId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete an onboarding request
         * @param {string} onboardingRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOnboardingRequest(onboardingRequestId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOnboardingRequest(onboardingRequestId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete Organization Create Request
         * @param {string} organizationCreateRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrganizationCreateRequest(organizationCreateRequestId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrganizationCreateRequest(organizationCreateRequestId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Delete a payment request evidence specified by evidenceId.
         * @summary Delete the specific payment request evidence.
         * @param {string} organizationId 
         * @param {string} paymentRequestId 
         * @param {string} evidenceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePaymentRequestEvidence(organizationId: string, paymentRequestId: string, evidenceId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePaymentRequestEvidence(organizationId, paymentRequestId, evidenceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete purchase application.
         * @param {string} organizationId 
         * @param {string} purchaseApplicationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePurchaseApplication(organizationId: string, purchaseApplicationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePurchaseApplication(organizationId, purchaseApplicationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete purchase application templates detail
         * @param {string} organizationId 
         * @param {string} purchaseTemplateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePurchaseApplicationTemplatesDetail(organizationId: string, purchaseTemplateId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePurchaseApplicationTemplatesDetail(organizationId, purchaseTemplateId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete slack notification channel setting for purchase-application
         * @param {string} organizationId 
         * @param {string} channelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSlackNotificationChannelSettingForPurchaseApplication(organizationId: string, channelId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSlackNotificationChannelSettingForPurchaseApplication(organizationId, channelId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete slack notification channel setting for card
         * @param {string} organizationId 
         * @param {string} channelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSlackNotificationSettingForCard(organizationId: string, channelId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSlackNotificationSettingForCard(organizationId, channelId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete system admin role
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSystemAdminRole(userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSystemAdminRole(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete teams notification channel setting for card
         * @param {string} organizationId 
         * @param {string} channelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTeamsNotificationSettingForCard(organizationId: string, channelId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTeamsNotificationSettingForCard(organizationId, channelId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete user account group
         * @param {number} userAccountGroupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteUserAccountGroup(userAccountGroupId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DeleteUserAccountGroup200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteUserAccountGroup(userAccountGroupId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Deposit Guarantee Money Balance
         * @param {string} organizationId 
         * @param {DepositGuaranteeMoneyBalanceRequest} depositGuaranteeMoneyBalanceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async depositGuaranteeMoneyBalance(organizationId: string, depositGuaranteeMoneyBalanceRequest: DepositGuaranteeMoneyBalanceRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.depositGuaranteeMoneyBalance(organizationId, depositGuaranteeMoneyBalanceRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Disable Approval
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async disableApproval(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DisableApproval200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.disableApproval(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Disable daily usage limit for an user account
         * @param {string} userAccountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async disableDailyUserUsageLimit(userAccountId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DisableDailyUserUsageLimit200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.disableDailyUserUsageLimit(userAccountId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Disable physical store payment for the user account
         * @param {string} userAccountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async disablePhysicalStorePaymentForTheUserAccount(userAccountId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DisablePhysicalStorePaymentForTheUserAccount200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.disablePhysicalStorePaymentForTheUserAccount(userAccountId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Disable transaction upper limit for the user account
         * @param {string} userAccountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async disableTransactionUpperLimitForTheUserAccount(userAccountId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DisableTransactionUpperLimitForTheUserAccount200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.disableTransactionUpperLimitForTheUserAccount(userAccountId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Disable usage limit for an user account
         * @param {string} userAccountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async disableUserUsageLimit(userAccountId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DisableUserUsageLimit200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.disableUserUsageLimit(userAccountId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Disagree to the agreement request
         * @param {string} organizationId 
         * @param {string} agreementRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async disagreeToAgreementRequest(organizationId: string, agreementRequestId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.disagreeToAgreementRequest(organizationId, agreementRequestId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Download bank transfer file
         * @param {string} organizationId 
         * @param {string} bankTransferId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadBankTransferFile(organizationId: string, bankTransferId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadBankTransferFile(organizationId, bankTransferId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Download bank transfers csv
         * @param {string} organizationId 
         * @param {string} [transferDateJstFrom] yyyy-MM-dd format date in JST. Filter the bank transfers to be returned to only those which are scheduled to be transferred after this date.
         * @param {string} [transferDateJstTo] yyyy-MM-dd format date in JST. Filter the bank transfers to be returned to only those which are scheduled to be transferred before this date. Both transferDateJstFrom and transferDateJstTo are inclusive (closed interval).
         * @param {string} [sourceBankAccountId] Filter the bank transfers by the specified source bank account id.
         * @param {boolean} [downloaded] Filter the bank transfers by whether the corresponding transfer data has been downloaded.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadBankTransfersCsv(organizationId: string, transferDateJstFrom?: string, transferDateJstTo?: string, sourceBankAccountId?: string, downloaded?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadBankTransfersCsv(organizationId, transferDateJstFrom, transferDateJstTo, sourceBankAccountId, downloaded, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Download journal entry for freee csv
         * @param {string} organizationId 
         * @param {string} yearMonth 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadJournalEntryForFreeeCsv(organizationId: string, yearMonth: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadJournalEntryForFreeeCsv(organizationId, yearMonth, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Download Organizations Accounting Csv
         * @param {string} organizationId 
         * @param {string} yearMonth 
         * @param {boolean} isMergedFiles 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadOrganizationsAccountingCsv(organizationId: string, yearMonth: string, isMergedFiles: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadOrganizationsAccountingCsv(organizationId, yearMonth, isMergedFiles, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Download payment requests csv
         * @param {string} organizationId 
         * @param {string} [dueDateJstFrom] yyyy-MM-dd format date in JST. Filter the payment requests to be returned to only those which have a due date after this date.
         * @param {string} [dueDateJstTo] yyyy-MM-dd format date in JST. Filter the payment requests to be returned to only those which have a due date before this date. Both dueDateJstFrom and dueDateJstTo are inclusive (closed interval).
         * @param {Array<'PENDING_WORKFLOW_COMPLETION' | 'CANCELED' | 'PAYABLE' | 'ATTACHED_TO_BANK_TRANSFER' | 'DEACTIVATED'>} [statuses] Filter the payment requests by the specified status.
         * @param {string} [supplierId] Filter the payment requests by the specified supplier id.
         * @param {boolean} [transferDataCreated] Filter the payment requests by whether the corresponding transaction data has been created.
         * @param {boolean} [withholdingApplied] Filter the payment requests by whether the withholding tax has been applied. true means the withholdingCalculatingMethod is NONE, while false, except for NONE.
         * @param {'SELF' | 'SUPPLIER'} [transferFeeResponsibility] Filter the payment requests by the specified transfer fee responsibility.
         * @param {string} [freeWord] A keyword used to search the following fields for partial matches:  - supplier name  - requestor name  - memo  - accounting items  - sections
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadPaymentRequestsCsv(organizationId: string, dueDateJstFrom?: string, dueDateJstTo?: string, statuses?: Array<'PENDING_WORKFLOW_COMPLETION' | 'CANCELED' | 'PAYABLE' | 'ATTACHED_TO_BANK_TRANSFER' | 'DEACTIVATED'>, supplierId?: string, transferDataCreated?: boolean, withholdingApplied?: boolean, transferFeeResponsibility?: 'SELF' | 'SUPPLIER', freeWord?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadPaymentRequestsCsv(organizationId, dueDateJstFrom, dueDateJstTo, statuses, supplierId, transferDataCreated, withholdingApplied, transferFeeResponsibility, freeWord, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Download payment requests csv for payment request ids specification
         * @param {string} organizationId 
         * @param {DownloadPaymentRequestsCsvForPaymentRequestIdsSpecificationRequest} [downloadPaymentRequestsCsvForPaymentRequestIdsSpecificationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadPaymentRequestsCsvForPaymentRequestIdsSpecification(organizationId: string, downloadPaymentRequestsCsvForPaymentRequestIdsSpecificationRequest?: DownloadPaymentRequestsCsvForPaymentRequestIdsSpecificationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadPaymentRequestsCsvForPaymentRequestIdsSpecification(organizationId, downloadPaymentRequestsCsvForPaymentRequestIdsSpecificationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Enable physical store payment for the user account
         * @param {string} userAccountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enablePhysicalStorePaymentForTheUserAccount(userAccountId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnablePhysicalStorePaymentForTheUserAccount200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.enablePhysicalStorePaymentForTheUserAccount(userAccountId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Freeze a card
         * @param {string} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async freezeCard(cardId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FreezeCard200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.freezeCard(cardId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Generate Annual Fees Invoice
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateAnnualFeesInvoice(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateAnnualFeesInvoice(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Generate Create Account Token
         * @param {GenerateCreateAccountTokenRequest} generateCreateAccountTokenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateCreateAccountToken(generateCreateAccountTokenRequest: GenerateCreateAccountTokenRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateCreateAccountToken(generateCreateAccountTokenRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Generate freee redirect url
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateFreeeRedirectUrl(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenerateFreeeRedirectUrl200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateFreeeRedirectUrl(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Generate org account ids.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateOrgAccountIds(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateOrgAccountIds(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get a Card Detail as Admin
         * @param {string} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getACardDetailAsAdmin(cardId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetACardDetailAsAdmin200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getACardDetailAsAdmin(cardId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get accounting csv for the organization.
         * @param {string} organizationId 
         * @param {string} startYearMonth 
         * @param {string} endYearMonth 
         * @param {'FREEE' | 'MONEY_FORWARD'} accountingSystemType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccountingCsvForTheOrganization(organizationId: string, startYearMonth: string, endYearMonth: string, accountingSystemType: 'FREEE' | 'MONEY_FORWARD', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccountingCsvForTheOrganization(organizationId, startYearMonth, endYearMonth, accountingSystemType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get accounting csv for the user account.
         * @param {string} userAccountId 
         * @param {string} yearMonth 
         * @param {boolean} isMergedFiles 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccountingCsvForTheUserAccount(userAccountId: string, yearMonth: string, isMergedFiles: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccountingCsvForTheUserAccount(userAccountId, yearMonth, isMergedFiles, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get admin users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdminUsers(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAdminUsers200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminUsers(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get admins
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdmins(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetAdmins200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdmins(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get agreement requests
         * @param {string} organizationId 
         * @param {boolean} waitingForAgreement 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAgreementRequests(organizationId: string, waitingForAgreement: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetAgreementRequests200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAgreementRequests(organizationId, waitingForAgreement, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all banks
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllBanks(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetAllBanks200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllBanks(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get analysis invoice of payment request
         * @param {string} organizationId 
         * @param {string} fileId 
         * @param {string} [xUpsidrSwitchUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAnalysisInvoiceOfPaymentRequest(organizationId: string, fileId: string, xUpsidrSwitchUser?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAnalysisInvoiceOfPaymentRequest200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAnalysisInvoiceOfPaymentRequest(organizationId, fileId, xUpsidrSwitchUser, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get annual fees eligibility
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAnnualFeesEligibility(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAnnualFeesEligibility200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAnnualFeesEligibility(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get approvers
         * @param {string} userAccountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApprovers(userAccountId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetApprovers200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApprovers(userAccountId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get available currency options
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAvailableCurrencyOptions(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAvailableCurrencyOptions(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * <p>   Return a list of feature names that are available for the organization.   Most features are unconditionally available to all organizations and   are not included in the response of this API, while some new features are not   available for the organization unless their names are included in this response. </p> <p>   The response schema are designed to ensure that information about new features   is not disclosed to organizations that cannot use them. </p>
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAvailableFeatures(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAvailableFeatures(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Available merchant category options
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAvailableMerchantCategoryOptions(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAvailableMerchantCategoryOptions200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAvailableMerchantCategoryOptions(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get balance state
         * @param {string} organizationId 
         * @param {string} [targetDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBalanceState(organizationId: string, targetDate?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetBalanceState200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBalanceState(organizationId, targetDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get bank account activities
         * @param {number} bankAccountActivityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBankAccountActivities(bankAccountActivityId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetBankAccountActivities200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBankAccountActivities(bankAccountActivityId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get a bank account confirmed activities
         * @param {string} organizationId 
         * @param {'PAY_BILL' | 'DEPOSIT' | 'WITHDRAWAL' | 'REWARD' | 'USAGE_FEE' | 'POINT' | 'CARD_POINT' | 'CAMPAIGN_POINT' | 'CARD' | 'DEPOSIT_FROM_GUARANTEE_MONEY' | 'WITHDRAWAL_TO_GUARANTEE_MONEY'} [type] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBankAccountConfirmedActivities(organizationId: string, type?: 'PAY_BILL' | 'DEPOSIT' | 'WITHDRAWAL' | 'REWARD' | 'USAGE_FEE' | 'POINT' | 'CARD_POINT' | 'CAMPAIGN_POINT' | 'CARD' | 'DEPOSIT_FROM_GUARANTEE_MONEY' | 'WITHDRAWAL_TO_GUARANTEE_MONEY', limit?: number, offset?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetBankAccountConfirmedActivities200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBankAccountConfirmedActivities(organizationId, type, limit, offset, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get bank by name
         * @param {string} bankName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBankByName(bankName: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetBankByName200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBankByName(bankName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get a bank transfer
         * @param {string} organizationId 
         * @param {string} bankTransferId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBankTransfer(organizationId: string, bankTransferId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetBankTransfer200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBankTransfer(organizationId, bankTransferId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get the specified bank\'s all branches
         * @param {string} bankCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBanksAllBranches(bankCode: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetBanksAllBranches200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBanksAllBranches(bankCode, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get bookkeepers
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBookkeepers(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetBookkeepers200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBookkeepers(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get branch
         * @param {string} bankCode 
         * @param {string} branchName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBranch(bankCode: string, branchName: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetBranch200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBranch(bankCode, branchName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all business descriptions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBusinessDescriptions(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetBusinessDescriptions200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBusinessDescriptions(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get if an organization can activate cards
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCanActivateCard(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCanActivateCard(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get the status of whether the organization can close
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCanCloseStatuses(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCanCloseStatuses200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCanCloseStatuses(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get can deactivate
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCanDeactivate(userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCanDeactivate200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCanDeactivate(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get if the user can read card\'s sensitive info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCanReadCardSensitive(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCanReadCardSensitive(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get if an organization can request a real card to be issued.
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCanRequestSendingCard(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCanRequestSendingCard(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Card Bill
         * @param {string} cardBillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCardBill(cardBillId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCardBill200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCardBill(cardBillId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Card Detail
         * @param {string} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCardDetail(cardId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCardDetail200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCardDetail(cardId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get card monthly transactions
         * @param {string} userAccountId 
         * @param {string} yearMonth 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCardMonthlyTransactions(userAccountId: string, yearMonth: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCardMonthlyTransactions200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCardMonthlyTransactions(userAccountId, yearMonth, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Card Points Rate Configs By OrganizationId
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCardPointsRateConfigsByOrganizationId(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetCardPointsRateConfigsByOrganizationId200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCardPointsRateConfigsByOrganizationId(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get card transaction details
         * @param {string} organizationId 
         * @param {string} visaTransactionReferenceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCardTransactionDetails(organizationId: string, visaTransactionReferenceId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCardTransactionDetails200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCardTransactionDetails(organizationId, visaTransactionReferenceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get card transaction evidence record image
         * @param {string} organizationId 
         * @param {string} paymentReferenceId 
         * @param {string} cardTransactionEvidenceId 
         * @param {string} id 
         * @param {boolean} [inPdf] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCardTransactionEvidenceRecordImage(organizationId: string, paymentReferenceId: string, cardTransactionEvidenceId: string, id: string, inPdf?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCardTransactionEvidenceRecordImage(organizationId, paymentReferenceId, cardTransactionEvidenceId, id, inPdf, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get card transaction evidence records
         * @param {string} organizationId 
         * @param {string} paymentReferenceId 
         * @param {string} cardTransactionEvidenceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCardTransactionEvidenceRecords(organizationId: string, paymentReferenceId: string, cardTransactionEvidenceId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetCardTransactionEvidenceRecords200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCardTransactionEvidenceRecords(organizationId, paymentReferenceId, cardTransactionEvidenceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Card Transactions
         * @param {string} userAccountId 
         * @param {string} merchantId 
         * @param {string} toYearMonth 
         * @param {string} [fromYearMonth] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCardTransactions(userAccountId: string, merchantId: string, toYearMonth: string, fromYearMonth?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCardTransactions200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCardTransactions(userAccountId, merchantId, toYearMonth, fromYearMonth, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get cards
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCards(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetCards200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCards(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get cards transactions with purchase application unlinked
         * @param {string} organizationId 
         * @param {string} yearMonth 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCardsTransactionsWithPurchaseApplicationUnlinked(organizationId: string, yearMonth: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCardsTransactionsWithPurchaseApplicationUnlinked(organizationId, yearMonth, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get the category of the purchase application template for use.
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCategoryOfThePurchaseApplicationTemplate(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetCategoryOfThePurchaseApplicationTemplate200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCategoryOfThePurchaseApplicationTemplate(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get comment for card transaction
         * @param {string} organizationId 
         * @param {string} paymentReferenceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getComment(organizationId: string, paymentReferenceId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetComment200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getComment(organizationId, paymentReferenceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get comment templates
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCommentTemplates(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetCommentTemplates200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCommentTemplates(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get comment template
         * @param {string} organizationId 
         * @param {string} templateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCommentTemplatesCommentTemplateId(organizationId: string, templateId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCommentTemplatesCommentTemplateId200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCommentTemplatesCommentTemplateId(organizationId, templateId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get current card associated with the user account
         * @param {string} userAccountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCurrentCardAssociatedWithTheUserAccount(userAccountId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCurrentCardAssociatedWithTheUserAccount200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCurrentCardAssociatedWithTheUserAccount(userAccountId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary get deals total amount
         * @param {number} organizationId 
         * @param {GetDealsTotalAmountRequest} [getDealsTotalAmountRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDealsTotalAmount(organizationId: number, getDealsTotalAmountRequest?: GetDealsTotalAmountRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDealsTotalAmount(organizationId, getDealsTotalAmountRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get default comment template for user account
         * @param {string} organizationId 
         * @param {string} userAccountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDefaultCommentTemplate(organizationId: string, userAccountId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetDefaultCommentTemplate200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDefaultCommentTemplate(organizationId, userAccountId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get deposit bank account
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDepositBankAccount(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetDepositBankAccount200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDepositBankAccount(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get deposit restriction for organization
         * @param {string} organizationId 
         * @param {string} depositRestrictionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDepositRestrictionForOrganization(organizationId: string, depositRestrictionId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetDepositRestrictionForOrganization200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDepositRestrictionForOrganization(organizationId, depositRestrictionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get deposit restriction list for organization
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDepositRestrictionListForOrganization(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetDepositRestrictionListForOrganization200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDepositRestrictionListForOrganization(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get draft payment request
         * @param {string} organizationId 
         * @param {string} draftPaymentRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDraftPaymentRequest(organizationId: string, draftPaymentRequestId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetDraftPaymentRequest200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDraftPaymentRequest(organizationId, draftPaymentRequestId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get draft payment request evidence file
         * @param {string} organizationId 
         * @param {string} draftPaymentRequestId 
         * @param {string} evidenceId 
         * @param {boolean} [inPdf] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDraftPaymentRequestEvidenceFile(organizationId: string, draftPaymentRequestId: string, evidenceId: string, inPdf?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDraftPaymentRequestEvidenceFile(organizationId, draftPaymentRequestId, evidenceId, inPdf, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get draft payment requests only created own
         * @param {string} organizationId 
         * @param {string} [xUpsidrSwitchUser] 
         * @param {string} [freeWord] A keyword used to search the following fields for partial matches:  - supplier name  - requestor name  - memo  - accounting items  - sections
         * @param {number} [limit] 
         * @param {number} [offset] See the description of &#x60;cursor&#x60; section Pagination
         * @param {string} [cursor] Pagination is performed by specifying either offset or cursor; if neither offset nor cursor is specified, it is assumed to be cursor-pagination and the first page is obtained with the next cursor. See below how the pagination exactly behaves:  - \&quot;\&quot; ... Get the fist page and return the next cursor  - \&quot;offset&#x3D;50\&quot; ... Get from the specified offset and never return the next cursor  - \&quot;cursor&#x3D;xxx\&quot; ... Get from the specified cursor  - \&quot;offset&#x3D;50&amp;cursor&#x3D;xxx\&quot; ... Ignore the offset and get from the specified cursor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDraftPaymentRequestsOnlyCreatedOwn(organizationId: string, xUpsidrSwitchUser?: string, freeWord?: string, limit?: number, offset?: number, cursor?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetDraftPaymentRequestsOnlyCreatedOwn200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDraftPaymentRequestsOnlyCreatedOwn(organizationId, xUpsidrSwitchUser, freeWord, limit, offset, cursor, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary get earliest expiring guarantee money for organization
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEarliestExpiringGuaranteeMoneyForOrganization(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetEarliestExpiringGuaranteeMoneyForOrganization200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEarliestExpiringGuaranteeMoneyForOrganization(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Obtain email notification configuration information for each user.
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmailNotifications(userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetEmailNotifications200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEmailNotifications(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get error bills
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getErrorBills(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetErrorBills200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getErrorBills(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get the evidence specified by evidenceId.
         * @summary Get a specific evidence.
         * @param {string} organizationId 
         * @param {string} evidenceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEvidence(organizationId: string, evidenceId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetEvidence200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEvidence(organizationId, evidenceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get evidence file
         * @param {string} organizationId 
         * @param {string} evidenceId 
         * @param {boolean} [inPdf] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEvidenceFile(organizationId: string, evidenceId: string, inPdf?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEvidenceFile(organizationId, evidenceId, inPdf, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get evidence image
         * @param {string} organizationId 
         * @param {string} paymentReferenceId 
         * @param {string} cardTransactionEvidenceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEvidenceImage(organizationId: string, paymentReferenceId: string, cardTransactionEvidenceId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEvidenceImage(organizationId, paymentReferenceId, cardTransactionEvidenceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get evidence information for card transactions
         * @param {string} organizationId 
         * @param {string} paymentReferenceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEvidenceInformationForCardTransactions(organizationId: string, paymentReferenceId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetEvidenceInformationForCardTransactions200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEvidenceInformationForCardTransactions(organizationId, paymentReferenceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get evidence record image
         * @param {string} organizationId 
         * @param {string} evidenceId 
         * @param {string} recordId 
         * @param {boolean} [inPdf] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEvidenceRecordImage(organizationId: string, evidenceId: string, recordId: string, inPdf?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEvidenceRecordImage(organizationId, evidenceId, recordId, inPdf, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get evidence records
         * @param {string} organizationId 
         * @param {string} evidenceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEvidenceRecords(organizationId: string, evidenceId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetEvidenceRecords200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEvidenceRecords(organizationId, evidenceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get evidence zip for the organization.
         * @param {string} organizationId 
         * @param {string} yearMonth 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEvidenceZipForTheOrganization(organizationId: string, yearMonth: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEvidenceZipForTheOrganization(organizationId, yearMonth, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get evidences
         * @param {string} organizationId 
         * @param {string} paymentReferenceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEvidences(organizationId: string, paymentReferenceId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetEvidences200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEvidences(organizationId, paymentReferenceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Count evidences
         * @param {string} organizationId 
         * @param {string} [issuer] This parameter will be deleted soon. Use keyword instead. If you specify this parameter, it will behave like the keyword, that is, it is searched from note as well as issuer.
         * @param {number} [amountMin] 
         * @param {number} [amountMax] 
         * @param {string} [paidAtFrom] 
         * @param {string} [paidAtTo] 
         * @param {boolean} [irrelevantToLedger] 
         * @param {string} [keyword] Specified keyword is searched from the issuer and the note by partial match.
         * @param {boolean} [includesDeleted] 
         * @param {Array<'VALID' | 'INVALID' | 'INPUT_REQUIRED' | 'OUT_OF_TARGET'>} [legalValidities] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEvidencesCount(organizationId: string, issuer?: string, amountMin?: number, amountMax?: number, paidAtFrom?: string, paidAtTo?: string, irrelevantToLedger?: boolean, keyword?: string, includesDeleted?: boolean, legalValidities?: Array<'VALID' | 'INVALID' | 'INPUT_REQUIRED' | 'OUT_OF_TARGET'>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetEvidencesCount200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEvidencesCount(organizationId, issuer, amountMin, amountMax, paidAtFrom, paidAtTo, irrelevantToLedger, keyword, includesDeleted, legalValidities, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get the triggered transactions of a fraud locked card
         * @param {string} organizationId 
         * @param {string} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFraudLockedCardTransactions(organizationId: string, cardId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetFraudLockedCardTransactions200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFraudLockedCardTransactions(organizationId, cardId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get freee account items
         * @param {string} organizationId 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFreeeAccountItems(organizationId: string, companyId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetFreeeAccountItems200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFreeeAccountItems(organizationId, companyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get freee companies
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFreeeCompanies(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetFreeeCompanies200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFreeeCompanies(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get freee connected
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFreeeConnected(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetFreeeConnected200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFreeeConnected(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Freee Connected User
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFreeeConnectedUser(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetFreeeConnectedUser200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFreeeConnectedUser(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get freee items
         * @param {string} organizationId 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFreeeItems(organizationId: string, companyId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetFreeeItems200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFreeeItems(organizationId, companyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get freee memo tags
         * @param {string} organizationId 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFreeeMemoTags(organizationId: string, companyId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetFreeeMemoTags200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFreeeMemoTags(organizationId, companyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get freee partners
         * @param {string} organizationId 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFreeePartners(organizationId: string, companyId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetFreeePartners200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFreeePartners(organizationId, companyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get freee sections
         * @param {string} organizationId 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFreeeSections(organizationId: string, companyId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetFreeeSections200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFreeeSections(organizationId, companyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get freee segment tags
         * @param {string} organizationId 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFreeeSegmentTags(organizationId: string, companyId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetFreeeSegmentTags200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFreeeSegmentTags(organizationId, companyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get freee sync status
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFreeeSyncStatus(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetFreeeSyncStatus200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFreeeSyncStatus(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get freee tags
         * @param {string} organizationId 
         * @param {string} companyId 
         * @param {string} tagName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFreeeTags(organizationId: string, companyId: string, tagName: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetFreeeTags200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFreeeTags(organizationId, companyId, tagName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get freee taxes
         * @param {string} organizationId 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFreeeTaxes(organizationId: string, companyId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetFreeeTaxes200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFreeeTaxes(organizationId, companyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get freee token
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFreeeToken(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetFreeeToken200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFreeeToken(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get a guarantee money balance history
         * @param {string} organizationId 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGuaranteeMoneyBalanceHistory(organizationId: string, limit?: number, offset?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetGuaranteeMoneyBalanceHistory200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGuaranteeMoneyBalanceHistory(organizationId, limit, offset, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get a guarantee money balance information for a organization
         * @param {string} organizationId 
         * @param {string} [targetDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGuaranteeMoneyBalanceInformationForOrganization(organizationId: string, targetDate?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetGuaranteeMoneyBalanceInformationForOrganization200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGuaranteeMoneyBalanceInformationForOrganization(organizationId, targetDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get guarantee money deposits for organization
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGuaranteeMoneyDepositsForOrganization(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetGuaranteeMoneyDepositsForOrganization200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGuaranteeMoneyDepositsForOrganization(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [from] yyyy-MM-dd format date in JST.
         * @param {string} [to] yyyy-MM-dd format date in JST.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHolidays(from?: string, to?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHolidays(from, to, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getIdentifyVerificationsLatest(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetIdentifyVerificationsLatest200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getIdentifyVerificationsLatest(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getIdentityVerifications(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetIdentityVerifications200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getIdentityVerifications(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Invoice List
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInvoiceList(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetInvoiceList200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInvoiceList(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Invoice Pdf
         * @param {string} organizationId 
         * @param {string} yearMonth 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInvoicePdf(organizationId: string, yearMonth: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInvoicePdf(organizationId, yearMonth, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get issuable status
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getIssuableStatus(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetIssuableStatus200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getIssuableStatus(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get jwt for SSO
         * @param {string} nonce 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getJwtSso(nonce: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetJwtSso200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getJwtSso(nonce, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get list of KYC reader users ordered by creation date in descending order.
         * @summary Get KYC Reader Users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getKycReaderUsers(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetKycReaderUsers200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getKycReaderUsers(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get latest time of sync to freee
         * @param {string} organizationId 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLatestTimeOfSyncToFreee(organizationId: string, companyId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetLatestTimeOfSyncToFreee200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLatestTimeOfSyncToFreee(organizationId, companyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get lock status of evidences
         * @param {string} organizationId 
         * @param {string} yearMonth 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLockStatusOfEvidences(organizationId: string, yearMonth: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetLockStatusOfEvidences200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLockStatusOfEvidences(organizationId, yearMonth, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get merchant general blocks
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMerchantGeneralBlock(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetMerchantGeneralBlock200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMerchantGeneralBlock(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get merchant general block detail
         * @param {string} merchantGeneralBlockListId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMerchantGeneralBlockDetail(merchantGeneralBlockListId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMerchantGeneralBlockDetail200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMerchantGeneralBlockDetail(merchantGeneralBlockListId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get merchant org blocks
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMerchantOrgBlock(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetMerchantOrgBlock200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMerchantOrgBlock(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get merchant org block list
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMerchantOrgBlockList(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetMerchantOrgBlockList200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMerchantOrgBlockList(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get merchant organization user account year month summary
         * @param {string} organizationId 
         * @param {string} merchantId 
         * @param {string} userAccountId 
         * @param {string} toYearMonth 
         * @param {string} [fromYearMonth] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMerchantOrganizationUserAccountYearMonthSummary(organizationId: string, merchantId: string, userAccountId: string, toYearMonth: string, fromYearMonth?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMerchantOrganizationUserAccountYearMonthSummary200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMerchantOrganizationUserAccountYearMonthSummary(organizationId, merchantId, userAccountId, toYearMonth, fromYearMonth, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get a list of MerchantCategoryKind
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMerchantsCategoryKinds(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetMerchantsCategoryKinds200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMerchantsCategoryKinds(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Modifiable Daily Limits For The User Account
         * @param {string} userAccountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getModifiableDailyLimitsForTheUserAccount(userAccountId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetModifiableDailyLimitsForTheUserAccount200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getModifiableDailyLimitsForTheUserAccount(userAccountId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary get modifiable monthly limits for the user account
         * @param {string} userAccountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getModifiableMonthlyLimitsForTheUserAccount(userAccountId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetModifiableMonthlyLimitsForTheUserAccount200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getModifiableMonthlyLimitsForTheUserAccount(userAccountId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Modifiable Transaction Limits For The User Account
         * @param {string} userAccountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getModifiableTransactionLimitsForTheUserAccount(userAccountId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetModifiableTransactionLimitsForTheUserAccount200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getModifiableTransactionLimitsForTheUserAccount(userAccountId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get moneytree connected
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMoneytreeConnected(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMoneytreeConnected200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMoneytreeConnected(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get moneytree oauth url
         * @param {string} organizationId 
         * @param {string} [nextTo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMoneytreeOauthUrl(organizationId: string, nextTo?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMoneytreeOauthUrl200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMoneytreeOauthUrl(organizationId, nextTo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get moneytree status
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMoneytreeStatus(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMoneytreeStatus200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMoneytreeStatus(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get monthly card bills for specified yearMonths
         * @param {string} organizationId 
         * @param {string} [yearMonth] 
         * @param {string} [startYearMonth] 
         * @param {string} [endYearMonth] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMonthlyCardBill(organizationId: string, yearMonth?: string, startYearMonth?: string, endYearMonth?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMonthlyCardBill200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMonthlyCardBill(organizationId, yearMonth, startYearMonth, endYearMonth, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get monthly card transactions for the organization.
         * @param {string} organizationId 
         * @param {string} yearMonth 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMonthlyCardTransactionsForTheOrganization(organizationId: string, yearMonth: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMonthlyCardTransactionsForTheOrganization200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMonthlyCardTransactionsForTheOrganization(organizationId, yearMonth, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get monthly user card summaries
         * @param {string} organizationId 
         * @param {string} yearMonth 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMonthlyUserCardSummaries(organizationId: string, yearMonth: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetMonthlyUserCardSummaries200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMonthlyUserCardSummaries(organizationId, yearMonth, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get a specific onboarding request for zeus
         * @param {string} onboardingRequestId The ID of the onboarding request to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOnboardingRequestById(onboardingRequestId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetOnboardingRequestById200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOnboardingRequestById(onboardingRequestId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get personal information of the onboarding request.
         * @summary Get Personal Information
         * @param {string} onboardingRequestId Onboarding request ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOnboardingRequestPersonalInfo(onboardingRequestId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetOnboardingRequestPersonalInfo200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOnboardingRequestPersonalInfo(onboardingRequestId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get onboarding requests for zeus
         * @param {string} [key] 
         * @param {string} [createdAtFrom] 
         * @param {string} [createdAtTo] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {'id' | 'createdAt' | 'updatedAt'} [sort] 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOnboardingRequests(key?: string, createdAtFrom?: string, createdAtTo?: string, limit?: number, offset?: number, sort?: 'id' | 'createdAt' | 'updatedAt', order?: 'ASC' | 'DESC', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetOnboardingRequests200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOnboardingRequests(key, createdAtFrom, createdAtTo, limit, offset, sort, order, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get org account state
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrgAccountState(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetOrgAccountState200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrgAccountState(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Organization
         * @param {string} organizationId 
         * @param {boolean} [underContractOnly] 
         * @param {boolean} [withCredit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganization(organizationId: string, underContractOnly?: boolean, withCredit?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetOrganization200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganization(organizationId, underContractOnly, withCredit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Organization Accounting Csv Fields Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationAccountingCsvFieldsTypes(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetOrganizationAccountingCsvFieldsTypes200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationAccountingCsvFieldsTypes(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get organization cards extended
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationCardsExtended(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetOrganizationCardsExtended200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationCardsExtended(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get organization cards light
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationCardsLight(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetOrganizationCardsLight200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationCardsLight(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get organization chart departments
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationChartDepartments(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetOrganizationChartDepartments200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationChartDepartments(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get organization chart employees
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationChartEmployees(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetOrganizationChartEmployees200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationChartEmployees(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get organization chart roles
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationChartRoles(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetOrganizationChartRoles200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationChartRoles(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get organizations create requests for zeus
         * @param {string} [key] 
         * @param {string} [createdAtFrom] 
         * @param {string} [createdAtTo] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {'id' | 'createdAt' | 'updatedAt'} [sort] 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationCreateRequests(key?: string, createdAtFrom?: string, createdAtTo?: string, limit?: number, offset?: number, sort?: 'id' | 'createdAt' | 'updatedAt', order?: 'ASC' | 'DESC', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetOrganizationCreateRequests200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationCreateRequests(key, createdAtFrom, createdAtTo, limit, offset, sort, order, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Organization Me
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationMe(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetOrganizationMe200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationMe(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get organization payment schemes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationPaymentSchemes(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Array<GetOrganizationPaymentSchemes200ResponseInnerInner>>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationPaymentSchemes(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get organization payments
         * @param {string} organizationId 
         * @param {string} [yearMonth] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationPayments(organizationId: string, yearMonth?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetOrganizationPayments200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationPayments(organizationId, yearMonth, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizations(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetOrganizations200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizations(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Organizations Accounting Csv Export Fields
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationsAccountingCsvExportFields(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationsAccountingCsvExportFields(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get a organization\'s bill
         * @param {string} organizationId 
         * @param {boolean} [beforeReservationOnly] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationsBills(organizationId: string, beforeReservationOnly?: boolean, limit?: number, offset?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetOrganizationsBills200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationsBills(organizationId, beforeReservationOnly, limit, offset, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get organizations deals
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationsDeals(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetOrganizationsDeals200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationsDeals(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get payment request detail
         * @param {string} organizationId 
         * @param {string} [paymentRequestId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPaymentRequestDetail(organizationId: string, paymentRequestId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPaymentRequestDetail200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPaymentRequestDetail(organizationId, paymentRequestId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get a payment request evidence specified by evidenceId.
         * @summary Get a specific payment request evidence.
         * @param {string} organizationId 
         * @param {string} paymentRequestId 
         * @param {string} evidenceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPaymentRequestEvidence(organizationId: string, paymentRequestId: string, evidenceId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPaymentRequestEvidence200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPaymentRequestEvidence(organizationId, paymentRequestId, evidenceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get payment request evidence file
         * @param {string} organizationId 
         * @param {string} paymentRequestId 
         * @param {string} evidenceId 
         * @param {boolean} [inPdf] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPaymentRequestEvidenceFile(organizationId: string, paymentRequestId: string, evidenceId: string, inPdf?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPaymentRequestEvidenceFile(organizationId, paymentRequestId, evidenceId, inPdf, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get payment request evidence record file
         * @param {string} organizationId 
         * @param {string} paymentRequestId 
         * @param {string} evidenceId 
         * @param {string} recordId 
         * @param {boolean} [inPdf] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPaymentRequestEvidenceRecordFile(organizationId: string, paymentRequestId: string, evidenceId: string, recordId: string, inPdf?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPaymentRequestEvidenceRecordFile(organizationId, paymentRequestId, evidenceId, recordId, inPdf, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get payment request evidence records
         * @param {string} organizationId 
         * @param {string} paymentRequestId 
         * @param {string} evidenceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPaymentRequestEvidenceRecords(organizationId: string, paymentRequestId: string, evidenceId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetPaymentRequestEvidenceRecords200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPaymentRequestEvidenceRecords(organizationId, paymentRequestId, evidenceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary get all evidences for a specific payment request
         * @param {string} organizationId 
         * @param {string} paymentRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPaymentRequestEvidences(organizationId: string, paymentRequestId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetPaymentRequestEvidences200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPaymentRequestEvidences(organizationId, paymentRequestId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get payment requests bank accounts list
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPaymentRequestsBankAccountsList(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetPaymentRequestsBankAccountsList200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPaymentRequestsBankAccountsList(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get payment requests count linked bank transfer
         * @param {string} organizationId 
         * @param {string} paymentRequestIds When specifying more than one, separate them by commas.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPaymentRequestsCountLinkedBankTransfer(organizationId: string, paymentRequestIds: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPaymentRequestsCountLinkedBankTransfer(organizationId, paymentRequestIds, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary get pinretriever decrypt pin block
         * @param {GetPinretrieverDecryptPinBlockRequest} getPinretrieverDecryptPinBlockRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPinretrieverDecryptPinBlock(getPinretrieverDecryptPinBlockRequest: GetPinretrieverDecryptPinBlockRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPinretrieverDecryptPinBlock200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPinretrieverDecryptPinBlock(getPinretrieverDecryptPinBlockRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary get pinretriever encrypt pin
         * @param {GetPinretrieverEncryptPinRequest} getPinretrieverEncryptPinRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPinretrieverEncryptPin(getPinretrieverEncryptPinRequest: GetPinretrieverEncryptPinRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPinretrieverEncryptPin200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPinretrieverEncryptPin(getPinretrieverEncryptPinRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary get pinretriever hsm publickey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPinretrieverHsmPublickey(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPinretrieverHsmPublickey200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPinretrieverHsmPublickey(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get purchase application
         * @param {string} organizationId 
         * @param {string} purchaseApplicationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPurchaseApplication(organizationId: string, purchaseApplicationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPurchaseApplication200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPurchaseApplication(organizationId, purchaseApplicationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get purchase application templates
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPurchaseApplicationTemplates(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetPurchaseApplicationTemplates200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPurchaseApplicationTemplates(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get purchase application templates detail
         * @param {string} organizationId 
         * @param {string} purchaseTemplateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPurchaseApplicationTemplatesDetail(organizationId: string, purchaseTemplateId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPurchaseApplicationTemplatesDetail200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPurchaseApplicationTemplatesDetail(organizationId, purchaseTemplateId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get purchase applications
         * @param {string} organizationId 
         * @param {string} [yearMonth] 
         * @param {string} [visaTransactionReferenceId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPurchaseApplications(organizationId: string, yearMonth?: string, visaTransactionReferenceId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPurchaseApplications200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPurchaseApplications(organizationId, yearMonth, visaTransactionReferenceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPurchaseApplicationsRequestedCount(userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPurchaseApplicationsRequestedCount200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPurchaseApplicationsRequestedCount(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get the purchase applications requested list
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPurchaseApplicationsRequestedList(userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetPurchaseApplicationsRequestedList200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPurchaseApplicationsRequestedList(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get the purchase applications submitted self
         * @param {string} userId 
         * @param {string} yearMonth 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPurchaseApplicationsSubmittedSelf(userId: string, yearMonth: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetPurchaseApplicationsSubmittedSelf200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPurchaseApplicationsSubmittedSelf(userId, yearMonth, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary get(search) qualified invoice issuer
         * @param {string} registrationNumber 
         * @param {string} [issuerName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getQualifiedInvoiceIssuer(registrationNumber: string, issuerName?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetQualifiedInvoiceIssuer200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getQualifiedInvoiceIssuer(registrationNumber, issuerName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Redirect URL from Tiny URL
         * @param {string} tinyUrlParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRedirectUrlFromTinyUrl(tinyUrlParam: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRedirectUrlFromTinyUrl(tinyUrlParam, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get the reward points balance for the specified organization.
         * @summary Get reward points balance
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRewardPointBalance(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetRewardPointBalance200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRewardPointBalance(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get reward point transactions for the specified organization
         * @summary Get reward point transactions
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRewardPointTransactions(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetRewardPointTransactions200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRewardPointTransactions(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Rewards
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRewards(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetRewards200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRewards(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get role resource for user
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRoleResourceForUser(userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetRoleResourceForUser200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRoleResourceForUser(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get roles
         * @param {string} category 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRoles(category: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetRoles200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRoles(category, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Roles with Top Related Resources
         * @param {string} resourceScope 
         * @param {string} resourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRolesWithTopRelatedResources(resourceScope: string, resourceId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetRolesWithTopRelatedResources200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRolesWithTopRelatedResources(resourceScope, resourceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Roles with Top Related Resources by Organization id
         * @param {string} organizationId 
         * @param {string} resourceScope 
         * @param {string} resourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRolesWithTopRelatedResourcesByOrganizationId(organizationId: string, resourceScope: string, resourceId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetRolesWithTopRelatedResourcesByOrganizationId200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRolesWithTopRelatedResourcesByOrganizationId(organizationId, resourceScope, resourceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Slack card notification settings of an organization
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSlackCardNotificationSettings(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetSlackCardNotificationSettings200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSlackCardNotificationSettings(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get a Slack channels of an organization by SlackChannelID
         * @param {string} organizationId 
         * @param {string} channelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSlackChannel(organizationId: string, channelId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSlackChannel200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSlackChannel(organizationId, channelId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Slack channels of an organization
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSlackChannels(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetSlackChannels200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSlackChannels(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Slack channels with cursor of an organization
         * @param {string} organizationId 
         * @param {string} [cursor] This is used to provide paging in a cursor mode. If any value is specified, the channel after the cursor is retrieved; if the value is null, the first page is returned.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSlackChannelsWithCursor(organizationId: string, cursor?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSlackChannelsWithCursor200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSlackChannelsWithCursor(organizationId, cursor, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Slack evidence remind settings of an organization
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSlackEvidenceReminder(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetSlackEvidenceReminder200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSlackEvidenceReminder(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Slack evidence remind settings of an slack channel
         * @param {string} organizationId 
         * @param {string} channelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSlackEvidenceReminderPerChannel(organizationId: string, channelId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSlackEvidenceReminderPerChannel200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSlackEvidenceReminderPerChannel(organizationId, channelId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get slack notification channel setting for purchase-application
         * @param {string} organizationId 
         * @param {string} channelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSlackNotificationChannelSettingForPurchaseApplication(organizationId: string, channelId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSlackNotificationChannelSettingForPurchaseApplication200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSlackNotificationChannelSettingForPurchaseApplication(organizationId, channelId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get slack notification settings for purchase-application
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSlackNotificationSettingsForPurchaseApplication(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetSlackNotificationSettingsForPurchaseApplication200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSlackNotificationSettingsForPurchaseApplication(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Slack team
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSlackTeam(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSlackTeam200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSlackTeam(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Slack version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSlackVersion(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSlackVersion200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSlackVersion(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get submitted trustdock data
         * @param {string} trustdockIdentificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSubmittedTrustdockData(trustdockIdentificationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSubmittedTrustdockData200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSubmittedTrustdockData(trustdockIdentificationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get suspicious transaction detail list
         * @param {string} userAccountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSuspiciousTransactions(userAccountId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSuspiciousTransactions200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSuspiciousTransactions(userAccountId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Teams card notification settings of an organization
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTeamsCardNotificationSettings(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetTeamsCardNotificationSettings200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTeamsCardNotificationSettings(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Teams channels of an organization by TeamsChannelID
         * @param {string} organizationId 
         * @param {string} channelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTeamsChannel(organizationId: string, channelId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTeamsChannel200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTeamsChannel(organizationId, channelId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Teams channels with cursor of an organization
         * @param {string} organizationId 
         * @param {string} [cursor] This is used to provide paging in a cursor mode. If any value is specified, the channel after the cursor is retrieved; if the value is null, the first page is returned.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTeamsChannelsWithCursor(organizationId: string, cursor?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTeamsChannelsWithCursor200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTeamsChannelsWithCursor(organizationId, cursor, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Teams team
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTeamsTeam(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTeamsTeam200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTeamsTeam(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Teams version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTeamsVersion(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTeamsVersion200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTeamsVersion(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Technical Support Users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTechnicalSupportUsers(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetTechnicalSupportUsers200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTechnicalSupportUsers(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Tfa App QR Code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTfaAppQrCode(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTfaAppQrCode(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTfaAppRecoveryCode(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTfaAppRecoveryCode(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get TFA SMS Recovery Code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTfaSmsRecoveryCode(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTfaSmsRecoveryCode(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get the count of monthly transactions for the user account
         * @param {string} userAccountId 
         * @param {string} yearMonth 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTheCountOfMonthlyTransactionsForTheUserAccount(userAccountId: string, yearMonth: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTheCountOfMonthlyTransactionsForTheUserAccount(userAccountId, yearMonth, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get the user account information
         * @param {string} userAccountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTheUserAccountInformation(userAccountId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTheUserAccountInformation200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTheUserAccountInformation(userAccountId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get transaction evidence email address
         * @param {string} userAccountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTransactionEvidenceEmailAddress(userAccountId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTransactionEvidenceEmailAddress200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTransactionEvidenceEmailAddress(userAccountId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Transaction Evidence Email File
         * @param {string} userAccountId 
         * @param {number} transactionEvidenceEmailFileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTransactionEvidenceEmailFile(userAccountId: string, transactionEvidenceEmailFileId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTransactionEvidenceEmailFile(userAccountId, transactionEvidenceEmailFileId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get transaction evidence emails
         * @param {string} userAccountId 
         * @param {string} startYearMonth 
         * @param {string} endYearMonth 
         * @param {boolean} [isTrash] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTransactionEvidenceEmails(userAccountId: string, startYearMonth: string, endYearMonth: string, isTrash?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetTransactionEvidenceEmails200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTransactionEvidenceEmails(userAccountId, startYearMonth, endYearMonth, isTrash, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Trustdock Identity Verifications
         * @param {string} trustdockIdentificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTrustdockIdentityVerifications(trustdockIdentificationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTrustdockIdentityVerifications200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTrustdockIdentityVerifications(trustdockIdentificationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Trustdock Submit Identification Document Publish URL
         * @param {string} trustdockIdentificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTrustdockSubmitIdentificationDocumentPublishUrl(trustdockIdentificationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTrustdockSubmitIdentificationDocumentPublishUrl200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTrustdockSubmitIdentificationDocumentPublishUrl(trustdockIdentificationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Trustdock Verifications
         * @param {string} trustdockIdentificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTrustdockVerifications(trustdockIdentificationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTrustdockVerifications200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTrustdockVerifications(trustdockIdentificationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get unread message count for a user
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUnreadMessageCount(userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUnreadMessageCount200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUnreadMessageCount(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get an usage fee
         * @param {number} usageFeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUsageFee(usageFeeId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUsageFee200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUsageFee(usageFeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get user account groups
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserAccountGroups(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetUserAccountGroups200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserAccountGroups(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get user account year month summary
         * @param {string} organizationId 
         * @param {string} toYearMonth 
         * @param {string} [fromYearMonth] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserAccountYearMonthSummary(organizationId: string, toYearMonth: string, fromYearMonth?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetUserAccountYearMonthSummary200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserAccountYearMonthSummary(organizationId, toYearMonth, fromYearMonth, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get user accounts with default comment template
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserAccountsWithDefaultCommentTemplate(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetUserAccountsWithDefaultCommentTemplate200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserAccountsWithDefaultCommentTemplate(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get user cards
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserCards(userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetUserCards200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserCards(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get user cards extended
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserCardsExtended(userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetUserCardsExtended200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserCardsExtended(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get user cards extended for role resources
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserCardsExtendedForRoleResources(userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetUserCardsExtendedForRoleResources200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserCardsExtendedForRoleResources(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get user cards light
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserCardsLight(userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetUserCardsLight200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserCardsLight(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get user cards light for role resources
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserCardsLightForRoleResources(userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetUserCardsLightForRoleResources200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserCardsLightForRoleResources(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get message detail
         * @param {string} userMessageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserMessageDetail(userMessageId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUserMessageDetail200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserMessageDetail(userMessageId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get messages for a user
         * @param {string} userId 
         * @param {number} offset 
         * @param {number} limit 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserMessages(userId: string, offset: number, limit: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUserMessages200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserMessages(userId, offset, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get users
         * @param {string} organizationId 
         * @param {string} [email] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUsers(organizationId: string, email?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetUsers200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUsers(organizationId, email, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get information on login user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUsersMe(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUsersMe200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUsersMe(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary get venture capitals
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVentureCapitals(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetVentureCapitals200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVentureCapitals(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 指定された組織の取引時確認詳細情報を取得します。 createdAtの降順で返却されます。 
         * @summary 取引時確認詳細取得（ZEUS)(PRESIDENT)
         * @param {string} organizationId 組織ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getZeusOrganizationIdentityVerificationsForPresident(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetZeusOrganizationIdentityVerificationsForPresident200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getZeusOrganizationIdentityVerificationsForPresident(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get organizations for zeus
         * @param {string} [key] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {'ASC' | 'DESC'} [sort] 
         * @param {boolean} [connectedMoneytree] 
         * @param {'UPSIDER' | 'PRESIDENT_CARD'} [brandType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getZeusOrganizations(key?: string, limit?: number, offset?: number, sort?: 'ASC' | 'DESC', connectedMoneytree?: boolean, brandType?: 'UPSIDER' | 'PRESIDENT_CARD', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetZeusOrganizations200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getZeusOrganizations(key, limit, offset, sort, connectedMoneytree, brandType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Initialize Modifiable Limit For The User Accounts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async initializeModifiableLimitForTheUserAccounts(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.initializeModifiableLimitForTheUserAccounts(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Linking purchase to transaction.
         * @param {string} organizationId 
         * @param {string} purchaseApplicationId 
         * @param {string} [visaTransactionReferenceId] 
         * @param {string} [userAccountId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async linkingPurchaseToTransaction(organizationId: string, purchaseApplicationId: string, visaTransactionReferenceId?: string, userAccountId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.linkingPurchaseToTransaction(organizationId, purchaseApplicationId, visaTransactionReferenceId, userAccountId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Lock a card due to potential fraud
         * @param {string} organizationId 
         * @param {string} cardId 
         * @param {LockCardForPotentialFraudRequest} lockCardForPotentialFraudRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async lockCardForPotentialFraud(organizationId: string, cardId: string, lockCardForPotentialFraudRequest: LockCardForPotentialFraudRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LockCardForPotentialFraud200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.lockCardForPotentialFraud(organizationId, cardId, lockCardForPotentialFraudRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Lock a card due to fraud detected
         * @param {string} organizationId 
         * @param {string} cardId 
         * @param {LockCardOnFraudDetectedRequest} lockCardOnFraudDetectedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async lockCardOnFraudDetected(organizationId: string, cardId: string, lockCardOnFraudDetectedRequest: LockCardOnFraudDetectedRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LockCardOnFraudDetected200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.lockCardOnFraudDetected(organizationId, cardId, lockCardOnFraudDetectedRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Login
         * @param {LoginRequest} loginRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async login(loginRequest: LoginRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Login200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.login(loginRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Login with APP two factor auth
         * @param {LoginAppRequest} loginAppRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loginApp(loginAppRequest: LoginAppRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginApp200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loginApp(loginAppRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Login with recovery code of two factor auth
         * @param {LoginRecoveryCodeRequest} loginRecoveryCodeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loginRecoveryCode(loginRecoveryCodeRequest: LoginRecoveryCodeRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginRecoveryCode200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loginRecoveryCode(loginRecoveryCodeRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Login with SMS two factor auth
         * @param {LoginSmsRequest} loginSmsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loginSms(loginSmsRequest: LoginSmsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginSms200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loginSms(loginSmsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Logout
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async logout(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.logout(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Move slack notification channel setting for card
         * @param {string} organizationId 
         * @param {string} currentChannelId 
         * @param {MoveSlackNotificationSettingForCardRequest} moveSlackNotificationSettingForCardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async moveSlackNotificationSettingForCard(organizationId: string, currentChannelId: string, moveSlackNotificationSettingForCardRequest: MoveSlackNotificationSettingForCardRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.moveSlackNotificationSettingForCard(organizationId, currentChannelId, moveSlackNotificationSettingForCardRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Move teams notification channel setting for card
         * @param {string} organizationId 
         * @param {string} currentChannelId 
         * @param {MoveTeamsNotificationSettingForCardRequest} moveTeamsNotificationSettingForCardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async moveTeamsNotificationSettingForCard(organizationId: string, currentChannelId: string, moveTeamsNotificationSettingForCardRequest: MoveTeamsNotificationSettingForCardRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.moveTeamsNotificationSettingForCard(organizationId, currentChannelId, moveTeamsNotificationSettingForCardRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Organization Create Pre Request
         * @param {OrganizationCreatePreRequestRequest} organizationCreatePreRequestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationCreatePreRequest(organizationCreatePreRequestRequest: OrganizationCreatePreRequestRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationCreatePreRequest200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationCreatePreRequest(organizationCreatePreRequestRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Parse organization chart for workflow
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async parseOrganizationChartForWorkflow(file: File, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ParseOrganizationChartForWorkflow200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.parseOrganizationChartForWorkflow(file, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Post Addition Merchant General Block List
         * @param {PostAdditionMerchantGeneralBlockListRequest} postAdditionMerchantGeneralBlockListRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postAdditionMerchantGeneralBlockList(postAdditionMerchantGeneralBlockListRequest: PostAdditionMerchantGeneralBlockListRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostAdditionMerchantGeneralBlockList200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postAdditionMerchantGeneralBlockList(postAdditionMerchantGeneralBlockListRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} organizationId 
         * @param {PostAlliancesGcpApplicationsRequest} postAlliancesGcpApplicationsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postAlliancesGcpApplications(organizationId: string, postAlliancesGcpApplicationsRequest: PostAlliancesGcpApplicationsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostAlliancesGcpApplications200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postAlliancesGcpApplications(organizationId, postAlliancesGcpApplicationsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} organizationId 
         * @param {PostAlliancesGwsApplicationsRequest} postAlliancesGwsApplicationsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postAlliancesGwsApplications(organizationId: string, postAlliancesGwsApplicationsRequest: PostAlliancesGwsApplicationsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostAlliancesGwsApplications200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postAlliancesGwsApplications(organizationId, postAlliancesGwsApplicationsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Search Bank Account Balances
         * @param {PostBalancesRequest} postBalancesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postBalances(postBalancesRequest: PostBalancesRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PostBalances200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postBalances(postBalancesRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Post Bulk Addition Merchant Org Block Lists
         * @param {string} organizationId 
         * @param {Array<PostBulkAdditionMerchantOrgBlockListsRequestInner>} postBulkAdditionMerchantOrgBlockListsRequestInner 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postBulkAdditionMerchantOrgBlockLists(organizationId: string, postBulkAdditionMerchantOrgBlockListsRequestInner: Array<PostBulkAdditionMerchantOrgBlockListsRequestInner>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postBulkAdditionMerchantOrgBlockLists(organizationId, postBulkAdditionMerchantOrgBlockListsRequestInner, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Post a cancel request for a evidence request
         * @param {string} organizationId 
         * @param {string} paymentReferenceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postCancelRequestForEvidenceRequest(organizationId: string, paymentReferenceId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostCancelRequestForEvidenceRequest200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postCancelRequestForEvidenceRequest(organizationId, paymentReferenceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PostCardsVirtualIssueRequest} postCardsVirtualIssueRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postCardsVirtualIssue(postCardsVirtualIssueRequest: PostCardsVirtualIssueRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostCardsVirtualIssue200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postCardsVirtualIssue(postCardsVirtualIssueRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postCardsVirtualOndemandIssue(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostCardsVirtualOndemandIssue200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postCardsVirtualOndemandIssue(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Upload identity document file with verification information.
         * @summary Upload Identity Document
         * @param {string} onboardingRequestId Onboarding request ID
         * @param {File} file Identity document file
         * @param {string} [personalDocumentType] Type of personal identification document
         * @param {string} [verifiedBy] Name of the person who verified the document
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postFaceToFaceKycIdentityDocument(onboardingRequestId: string, file: File, personalDocumentType?: string, verifiedBy?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postFaceToFaceKycIdentityDocument(onboardingRequestId, file, personalDocumentType, verifiedBy, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Submit a face-to-face KYC request.
         * @summary Face-to-face KYC Request
         * @param {PostFaceToFaceKycRequestRequest} postFaceToFaceKycRequestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postFaceToFaceKycRequest(postFaceToFaceKycRequestRequest: PostFaceToFaceKycRequestRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostFaceToFaceKycRequest200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postFaceToFaceKycRequest(postFaceToFaceKycRequestRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Post Freee Account for Points
         * @param {string} organizationId 
         * @param {PostFreeeAccountForPointsRequest} postFreeeAccountForPointsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postFreeeAccountForPoints(organizationId: string, postFreeeAccountForPointsRequest: PostFreeeAccountForPointsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postFreeeAccountForPoints(organizationId, postFreeeAccountForPointsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {{ [key: string]: string; }} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postKycconsultingWebhooks(requestBody: { [key: string]: string; }, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postKycconsultingWebhooks(requestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Post Moneytree Refresh Request
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postMoneytreeRefreshRequest(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postMoneytreeRefreshRequest(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Post Moneytree Refresh Request for All Organizations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postMoneytreeRefreshRequestAll(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postMoneytreeRefreshRequestAll(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create organizations deals
         * @param {string} organizationId 
         * @param {PostOrganizationsDealsRequest} postOrganizationsDealsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postOrganizationsDeals(organizationId: string, postOrganizationsDealsRequest: PostOrganizationsDealsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postOrganizationsDeals(organizationId, postOrganizationsDealsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Post payment requests bank account
         * @param {string} organizationId 
         * @param {PostPaymentRequestsBankAccountRequest} [postPaymentRequestsBankAccountRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postPaymentRequestsBankAccount(organizationId: string, postPaymentRequestsBankAccountRequest?: PostPaymentRequestsBankAccountRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostPaymentRequestsBankAccount200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postPaymentRequestsBankAccount(organizationId, postPaymentRequestsBankAccountRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Post slack message to coworker
         * @param {string} organizationId 
         * @param {PostSlackMessageToCoworkerRequest} postSlackMessageToCoworkerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postSlackMessageToCoworker(organizationId: string, postSlackMessageToCoworkerRequest: PostSlackMessageToCoworkerRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostSlackMessageToCoworker200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postSlackMessageToCoworker(organizationId, postSlackMessageToCoworkerRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Search Bank Account Transactions
         * @param {PostTransactionsRequest} postTransactionsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postTransactions(postTransactionsRequest: PostTransactionsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PostTransactions200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postTransactions(postTransactionsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PostTrustdockWebhooksRequest} postTrustdockWebhooksRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postTrustdockWebhooks(postTrustdockWebhooksRequest: PostTrustdockWebhooksRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postTrustdockWebhooks(postTrustdockWebhooksRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PostTrustdockWebhooksSnailMailRequest} postTrustdockWebhooksSnailMailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postTrustdockWebhooksSnailMail(postTrustdockWebhooksSnailMailRequest: PostTrustdockWebhooksSnailMailRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postTrustdockWebhooksSnailMail(postTrustdockWebhooksSnailMailRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Put disable feature flag
         * @param {string} organizationId 
         * @param {string} featureName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putDisableFeatureFlag(organizationId: string, featureName: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putDisableFeatureFlag(organizationId, featureName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Put enabled feature flag
         * @param {string} organizationId 
         * @param {string} featureName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putEnabledFeatureFlag(organizationId: string, featureName: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putEnabledFeatureFlag(organizationId, featureName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Put Freee End Journal Entry Transition Mode
         * @param {string} organizationId 
         * @param {PutFreeeEndJournalEntryTransitionModeRequest} putFreeeEndJournalEntryTransitionModeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putFreeeEndJournalEntryTransitionMode(organizationId: string, putFreeeEndJournalEntryTransitionModeRequest: PutFreeeEndJournalEntryTransitionModeRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putFreeeEndJournalEntryTransitionMode(organizationId, putFreeeEndJournalEntryTransitionModeRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Put Organization Payment Method
         * @param {string} organizationId 
         * @param {PutOrganizationPaymentMethodRequest} putOrganizationPaymentMethodRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putOrganizationPaymentMethod(organizationId: string, putOrganizationPaymentMethodRequest: PutOrganizationPaymentMethodRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putOrganizationPaymentMethod(organizationId, putOrganizationPaymentMethodRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Put organizations deals
         * @param {string} organizationId 
         * @param {PutOrganizationsDealsRequest} putOrganizationsDealsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putOrganizationsDeals(organizationId: string, putOrganizationsDealsRequest: PutOrganizationsDealsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putOrganizationsDeals(organizationId, putOrganizationsDealsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update payment request
         * @param {string} organizationId 
         * @param {string} [paymentRequestId] 
         * @param {PutPaymentRequestRequest} [putPaymentRequestRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putPaymentRequest(organizationId: string, paymentRequestId?: string, putPaymentRequestRequest?: PutPaymentRequestRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putPaymentRequest(organizationId, paymentRequestId, putPaymentRequestRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Put payment requests bank account
         * @param {string} organizationId 
         * @param {string} bankAccountId 
         * @param {PutPaymentRequestsBankAccountRequest} [putPaymentRequestsBankAccountRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putPaymentRequestsBankAccount(organizationId: string, bankAccountId: string, putPaymentRequestsBankAccountRequest?: PutPaymentRequestsBankAccountRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PutPaymentRequestsBankAccount200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putPaymentRequestsBankAccount(organizationId, bankAccountId, putPaymentRequestsBankAccountRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Put transaction evidence emails link to transaction
         * @param {PutTransactionEvidenceEmailsLinkToTransactionRequest} putTransactionEvidenceEmailsLinkToTransactionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putTransactionEvidenceEmailsLinkToTransaction(putTransactionEvidenceEmailsLinkToTransactionRequest: PutTransactionEvidenceEmailsLinkToTransactionRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putTransactionEvidenceEmailsLinkToTransaction(putTransactionEvidenceEmailsLinkToTransactionRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Put transaction evidence emails mark as read
         * @param {PutTransactionEvidenceEmailsMarkAsReadRequest} putTransactionEvidenceEmailsMarkAsReadRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putTransactionEvidenceEmailsMarkAsRead(putTransactionEvidenceEmailsMarkAsReadRequest: PutTransactionEvidenceEmailsMarkAsReadRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PutTransactionEvidenceEmailsMarkAsRead200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putTransactionEvidenceEmailsMarkAsRead(putTransactionEvidenceEmailsMarkAsReadRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Put transaction evidence emails move to trash
         * @param {PutTransactionEvidenceEmailsMoveToTrashRequest} putTransactionEvidenceEmailsMoveToTrashRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putTransactionEvidenceEmailsMoveToTrash(putTransactionEvidenceEmailsMoveToTrashRequest: PutTransactionEvidenceEmailsMoveToTrashRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putTransactionEvidenceEmailsMoveToTrash(putTransactionEvidenceEmailsMoveToTrashRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Give reward point to organization
         * @param {string} organizationId 
         * @param {PutZeusGiveRewardPointsRequest} putZeusGiveRewardPointsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putZeusGiveRewardPoints(organizationId: string, putZeusGiveRewardPointsRequest: PutZeusGiveRewardPointsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putZeusGiveRewardPoints(organizationId, putZeusGiveRewardPointsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Query by ids payment requests
         * @param {string} organizationId 
         * @param {QueryByIdsPaymentRequestsRequest} [queryByIdsPaymentRequestsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async queryByIdsPaymentRequests(organizationId: string, queryByIdsPaymentRequestsRequest?: QueryByIdsPaymentRequestsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<QueryByIdsPaymentRequests200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.queryByIdsPaymentRequests(organizationId, queryByIdsPaymentRequestsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update read status of a message
         * @param {string} userMessageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async readUserMessage(userMessageId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.readUserMessage(userMessageId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary register note
         * @param {string} onboardingRequestId The ID of the onboarding request to retrieve
         * @param {RegisterNoteRequest} [registerNoteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async registerNote(onboardingRequestId: string, registerNoteRequest?: RegisterNoteRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.registerNote(onboardingRequestId, registerNoteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Register note for organization identity verification
         * @param {number} organizationIdentityVerificationId 
         * @param {RegisterNoteForOrganizationIdentityVerificationRequest} registerNoteForOrganizationIdentityVerificationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async registerNoteForOrganizationIdentityVerification(organizationIdentityVerificationId: number, registerNoteForOrganizationIdentityVerificationRequest: RegisterNoteForOrganizationIdentityVerificationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RegisterNoteForOrganizationIdentityVerification200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.registerNoteForOrganizationIdentityVerification(organizationIdentityVerificationId, registerNoteForOrganizationIdentityVerificationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Register an organization using the onboarding request ID
         * @param {string} onboardingRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async registerOrganization(onboardingRequestId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.registerOrganization(onboardingRequestId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Register organization chart for workflow
         * @param {string} organizationId 
         * @param {RegisterOrganizationChartForWorkflowRequest} [registerOrganizationChartForWorkflowRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async registerOrganizationChartForWorkflow(organizationId: string, registerOrganizationChartForWorkflowRequest?: RegisterOrganizationChartForWorkflowRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.registerOrganizationChartForWorkflow(organizationId, registerOrganizationChartForWorkflowRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Register Tfa App Verification Code
         * @param {RegisterTfaAppVerificationCodeRequest} registerTfaAppVerificationCodeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async registerTfaAppVerificationCode(registerTfaAppVerificationCodeRequest: RegisterTfaAppVerificationCodeRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RegisterTfaAppVerificationCode200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.registerTfaAppVerificationCode(registerTfaAppVerificationCodeRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Register Tfa SMS Auth
         * @param {RegisterTfaSmsAuthRequest} registerTfaSmsAuthRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async registerTfaSmsAuth(registerTfaSmsAuthRequest: RegisterTfaSmsAuthRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RegisterTfaSmsAuth200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.registerTfaSmsAuth(registerTfaSmsAuthRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Register transaction evidence email address
         * @param {string} userAccountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async registerTransactionEvidenceEmailAddress(userAccountId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.registerTransactionEvidenceEmailAddress(userAccountId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Reject Organization Identity Verification
         * @param {number} organizationIdentityVerificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rejectOrganizationIdentityVerification(organizationIdentityVerificationId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RejectOrganizationIdentityVerification200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rejectOrganizationIdentityVerification(organizationIdentityVerificationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Reject purchase application.
         * @param {string} organizationId 
         * @param {string} purchaseApplicationId 
         * @param {RejectPurchaseApplicationRequest} rejectPurchaseApplicationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rejectPurchaseApplication(organizationId: string, purchaseApplicationId: string, rejectPurchaseApplicationRequest: RejectPurchaseApplicationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rejectPurchaseApplication(organizationId, purchaseApplicationId, rejectPurchaseApplicationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remindCardTransactionEvidence(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remindCardTransactionEvidence(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Remind monthly payment notifications.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remindMonthlyPaymentNotifications(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remindMonthlyPaymentNotifications(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Remind organization monthly payment notifications.
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remindOrganizationMonthlyPaymentNotification(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remindOrganizationMonthlyPaymentNotification(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Rename user account group
         * @param {number} userAccountGroupId 
         * @param {RenameUserAccountGroupRequest} renameUserAccountGroupRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async renameUserAccountGroup(userAccountGroupId: number, renameUserAccountGroupRequest: RenameUserAccountGroupRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RenameUserAccountGroup200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.renameUserAccountGroup(userAccountGroupId, renameUserAccountGroupRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Replace Virtual Card
         * @param {string} userAccountId 
         * @param {ReplaceVirtualCardRequest} replaceVirtualCardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async replaceVirtualCard(userAccountId: string, replaceVirtualCardRequest: ReplaceVirtualCardRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReplaceVirtualCard200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.replaceVirtualCard(userAccountId, replaceVirtualCardRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary request add system admin role
         * @param {string} userId 
         * @param {RequestAddSystemAdminRoleRequest} requestAddSystemAdminRoleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestAddSystemAdminRole(userId: string, requestAddSystemAdminRoleRequest: RequestAddSystemAdminRoleRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestAddSystemAdminRole(userId, requestAddSystemAdminRoleRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Request sending physical cards
         * @param {string} organizationId 
         * @param {RequestSendingRequest} requestSendingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestSending(organizationId: string, requestSendingRequest: RequestSendingRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestSending(organizationId, requestSendingRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Request sending a metal card
         * @param {string} organizationId 
         * @param {RequestSendingMetalCardRequest} requestSendingMetalCardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestSendingMetalCard(organizationId: string, requestSendingMetalCardRequest: RequestSendingMetalCardRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestSendingMetalCard(organizationId, requestSendingMetalCardRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestSyncingClearedTransaction(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestSyncingClearedTransaction(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Request to Generate Organizations Accounting Csv in Background
         * @param {string} organizationId 
         * @param {string} yearMonth 
         * @param {boolean} isMergedFiles 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestToOrganizationsAccountingCsvInBackground(organizationId: string, yearMonth: string, isMergedFiles: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestToOrganizationsAccountingCsvInBackground(organizationId, yearMonth, isMergedFiles, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary request update system admin role
         * @param {string} userId 
         * @param {RequestUpdateSystemAdminRoleRequest} requestUpdateSystemAdminRoleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestUpdateSystemAdminRole(userId: string, requestUpdateSystemAdminRoleRequest: RequestUpdateSystemAdminRoleRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestUpdateSystemAdminRole(userId, requestUpdateSystemAdminRoleRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Resend Snail Mail For Organization Identity Verification
         * @param {number} organizationIdentityVerificationId 
         * @param {ResendSnailMailForOrganizationIdentityVerificationRequest} resendSnailMailForOrganizationIdentityVerificationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resendSnailMailForOrganizationIdentityVerification(organizationIdentityVerificationId: number, resendSnailMailForOrganizationIdentityVerificationRequest: ResendSnailMailForOrganizationIdentityVerificationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resendSnailMailForOrganizationIdentityVerification(organizationIdentityVerificationId, resendSnailMailForOrganizationIdentityVerificationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Resend an invitation to a new user
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resendUserInvite(userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResendUserInvite200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resendUserInvite(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Resume a suspended card
         * @param {string} organizationId 
         * @param {string} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resumeCard(organizationId: string, cardId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResumeCard200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resumeCard(organizationId, cardId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Resynchronize card transactions for freee
         * @param {string} organizationId 
         * @param {ResynchronizeCardTransactionsForFreeeRequest} resynchronizeCardTransactionsForFreeeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resynchronizeCardTransactionsForFreee(organizationId: string, resynchronizeCardTransactionsForFreeeRequest: ResynchronizeCardTransactionsForFreeeRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resynchronizeCardTransactionsForFreee(organizationId, resynchronizeCardTransactionsForFreeeRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Save deal as draft
         * @param {string} organizationId 
         * @param {string} dealId 
         * @param {SaveDealAsDraftRequest} saveDealAsDraftRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveDealAsDraft(organizationId: string, dealId: string, saveDealAsDraftRequest: SaveDealAsDraftRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SaveDealAsDraft200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveDealAsDraft(organizationId, dealId, saveDealAsDraftRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Save Deal As Ignore
         * @param {string} organizationId 
         * @param {string} dealId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveDealAsIgnore(organizationId: string, dealId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SaveDealAsIgnore200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveDealAsIgnore(organizationId, dealId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Save deal as return to editing
         * @param {string} organizationId 
         * @param {number} dealId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveDealAsReturnToEditing(organizationId: string, dealId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SaveDealAsReturnToEditing200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveDealAsReturnToEditing(organizationId, dealId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Save deal with journalizing
         * @param {string} organizationId 
         * @param {string} dealId 
         * @param {SaveDealWithJournalizingRequest} saveDealWithJournalizingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveDealWithJournalizing(organizationId: string, dealId: string, saveDealWithJournalizingRequest: SaveDealWithJournalizingRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SaveDealWithJournalizing200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveDealWithJournalizing(organizationId, dealId, saveDealWithJournalizingRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Save deals as ignore
         * @param {string} organizationId 
         * @param {SaveDealsAsIgnoreRequest} saveDealsAsIgnoreRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveDealsAsIgnore(organizationId: string, saveDealsAsIgnoreRequest: SaveDealsAsIgnoreRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveDealsAsIgnore(organizationId, saveDealsAsIgnoreRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Save deals as journalized
         * @param {string} organizationId 
         * @param {SaveDealsAsJournalizedRequest} saveDealsAsJournalizedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveDealsAsJournalized(organizationId: string, saveDealsAsJournalizedRequest: SaveDealsAsJournalizedRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveDealsAsJournalized(organizationId, saveDealsAsJournalizedRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Save deals as return to editing
         * @param {number} organizationId 
         * @param {SaveDealsAsReturnToEditingRequest} saveDealsAsReturnToEditingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveDealsAsReturnToEditing(organizationId: number, saveDealsAsReturnToEditingRequest: SaveDealsAsReturnToEditingRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveDealsAsReturnToEditing(organizationId, saveDealsAsReturnToEditingRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Search bank transfers
         * @param {string} organizationId 
         * @param {string} [transferDateJstFrom] yyyy-MM-dd format date in JST. Filter the bank transfers to be returned to only those which are scheduled to be transferred after this date.
         * @param {string} [transferDateJstTo] yyyy-MM-dd format date in JST. Filter the bank transfers to be returned to only those which are scheduled to be transferred before this date. Both transferDateJstFrom and transferDateJstTo are inclusive (closed interval).
         * @param {string} [sourceBankAccountId] Filter the bank transfers by the specified source bank account id.
         * @param {boolean} [downloaded] Filter the bank transfers by whether the corresponding transfer data has been downloaded.
         * @param {number} [limit] 
         * @param {number} [offset] See the description of &#x60;cursor&#x60; section Pagination
         * @param {string} [cursor] Pagination is performed by specifying either offset or cursor; if neither offset nor cursor is specified, it is assumed to be cursor-pagination and the first page is obtained with the next cursor. See below how the pagination exactly behaves:  - \&quot;\&quot; ... Get the fist page and return the next cursor  - \&quot;offset&#x3D;50\&quot; ... Get from the specified offset and never return the next cursor  - \&quot;cursor&#x3D;xxx\&quot; ... Get from the specified cursor  - \&quot;offset&#x3D;50&amp;cursor&#x3D;xxx\&quot; ... Ignore the offset and get from the specified cursor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchBankTransfers(organizationId: string, transferDateJstFrom?: string, transferDateJstTo?: string, sourceBankAccountId?: string, downloaded?: boolean, limit?: number, offset?: number, cursor?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SearchBankTransfers200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchBankTransfers(organizationId, transferDateJstFrom, transferDateJstTo, sourceBankAccountId, downloaded, limit, offset, cursor, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Search Corporations In National Tax Agency
         * @param {string} [name] 
         * @param {'PREFIX_MATCH' | 'PARTIAL_MATCH' | ''} [searchMethod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchCorporationsInNationalTaxAgency(name?: string, searchMethod?: 'PREFIX_MATCH' | 'PARTIAL_MATCH' | '', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SearchCorporationsInNationalTaxAgency200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchCorporationsInNationalTaxAgency(name, searchMethod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Search deals
         * @param {string} organizationId 
         * @param {SearchDealsRequest} [searchDealsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchDeals(organizationId: string, searchDealsRequest?: SearchDealsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SearchDeals200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchDeals(organizationId, searchDealsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Search evidences
         * @param {string} organizationId 
         * @param {string} [issuer] This parameter will be deleted soon. Use keyword instead. If you specify this parameter, it will behave like the keyword, that is, it is searched from note as well as issuer.
         * @param {number} [amountMin] 
         * @param {number} [amountMax] 
         * @param {string} [paidAtFrom] 
         * @param {string} [paidAtTo] 
         * @param {boolean} [irrelevantToLedger] 
         * @param {string} [keyword] Specified keyword is searched from the issuer and the note by partial match.
         * @param {boolean} [includesDeleted] 
         * @param {Array<'VALID' | 'INVALID' | 'INPUT_REQUIRED' | 'OUT_OF_TARGET'>} [legalValidities] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchEvidences(organizationId: string, issuer?: string, amountMin?: number, amountMax?: number, paidAtFrom?: string, paidAtTo?: string, irrelevantToLedger?: boolean, keyword?: string, includesDeleted?: boolean, legalValidities?: Array<'VALID' | 'INVALID' | 'INPUT_REQUIRED' | 'OUT_OF_TARGET'>, limit?: number, offset?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SearchEvidences200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchEvidences(organizationId, issuer, amountMin, amountMax, paidAtFrom, paidAtTo, irrelevantToLedger, keyword, includesDeleted, legalValidities, limit, offset, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Search my payment requests
         * @param {string} organizationId 
         * @param {string} [dueDateJstFrom] yyyy-MM-dd format date in JST. Filter the payment requests to be returned to only those which have a due date after this date.
         * @param {string} [dueDateJstTo] yyyy-MM-dd format date in JST. Filter the payment requests to be returned to only those which have a due date before this date. Both dueDateJstFrom and dueDateJstTo are inclusive (closed interval).
         * @param {string} [requestedDateJstFrom] yyyy-MM-dd format date in JST. Filter the payment requests to be returned to only those which have a requested at after this date.
         * @param {string} [requestedDateJstTo] yyyy-MM-dd format date in JST. Filter the payment requests to be returned to only those which have a requested at before this date.
         * @param {Array<'PENDING_WORKFLOW_COMPLETION' | 'CANCELED' | 'PAYABLE' | 'ATTACHED_TO_BANK_TRANSFER' | 'DEACTIVATED'>} [statuses] Filter the payment requests by the specified statuses. This parameter accepts both the following two forms:  - [comma separated style] /payment_requests?statuses&#x3D;PAYABLE,ATTACHED_TO_BANK_TRANSFER  - [exploded style]        /payment_requests?statuses&#x3D;PAYABLE&amp;statuses&#x3D;ATTACHED_TO_BANK_TRANSFER
         * @param {string} [supplierId] Filter the payment requests by the specified supplier id.
         * @param {boolean} [transferDataCreated] Filter the payment requests by whether the corresponding transaction data has been created.
         * @param {boolean} [withholdingApplied] Filter the payment requests by whether the withholding tax has been applied. true means the withholdingCalculatingMethod is NONE, while false, except for NONE.
         * @param {'SELF' | 'SUPPLIER'} [transferFeeResponsibility] Filter the payment requests by the specified transfer fee responsibility.
         * @param {string} [freeWord] A keyword used to search the following fields for partial matches:  - supplier name  - requestor name  - memo  - accounting items  - sections
         * @param {number} [limit] 
         * @param {number} [offset] See the description of &#x60;cursor&#x60; section Pagination
         * @param {string} [cursor] Pagination is performed by specifying either offset or cursor; if neither offset nor cursor is specified, it is assumed to be cursor-pagination and the first page is obtained with the next cursor. See below how the pagination exactly behaves:  - \&quot;\&quot; ... Get the fist page and return the next cursor  - \&quot;offset&#x3D;50\&quot; ... Get from the specified offset and never return the next cursor  - \&quot;cursor&#x3D;xxx\&quot; ... Get from the specified cursor  - \&quot;offset&#x3D;50&amp;cursor&#x3D;xxx\&quot; ... Ignore the offset and get from the specified cursor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchMyPaymentRequests(organizationId: string, dueDateJstFrom?: string, dueDateJstTo?: string, requestedDateJstFrom?: string, requestedDateJstTo?: string, statuses?: Array<'PENDING_WORKFLOW_COMPLETION' | 'CANCELED' | 'PAYABLE' | 'ATTACHED_TO_BANK_TRANSFER' | 'DEACTIVATED'>, supplierId?: string, transferDataCreated?: boolean, withholdingApplied?: boolean, transferFeeResponsibility?: 'SELF' | 'SUPPLIER', freeWord?: string, limit?: number, offset?: number, cursor?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SearchMyPaymentRequests200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchMyPaymentRequests(organizationId, dueDateJstFrom, dueDateJstTo, requestedDateJstFrom, requestedDateJstTo, statuses, supplierId, transferDataCreated, withholdingApplied, transferFeeResponsibility, freeWord, limit, offset, cursor, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Search Organizations
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchOrganizations(key: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SearchOrganizations200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchOrganizations(key, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Search payment requests
         * @param {string} organizationId 
         * @param {string} [dueDateJstFrom] yyyy-MM-dd format date in JST. Filter the payment requests to be returned to only those which have a due date after this date.
         * @param {string} [dueDateJstTo] yyyy-MM-dd format date in JST. Filter the payment requests to be returned to only those which have a due date before this date. Both dueDateJstFrom and dueDateJstTo are inclusive (closed interval).
         * @param {string} [requestedDateJstFrom] yyyy-MM-dd format date in JST. Filter the payment requests to be returned to only those which have a requested at after this date.
         * @param {string} [requestedDateJstTo] yyyy-MM-dd format date in JST. Filter the payment requests to be returned to only those which have a requested at before this date.
         * @param {Array<'PENDING_WORKFLOW_COMPLETION' | 'CANCELED' | 'PAYABLE' | 'ATTACHED_TO_BANK_TRANSFER' | 'DEACTIVATED'>} [statuses] Filter the payment requests by the specified statuses. This parameter accepts both the following two forms:  - [comma separated style] /payment_requests?statuses&#x3D;PAYABLE,ATTACHED_TO_BANK_TRANSFER  - [exploded style]        /payment_requests?statuses&#x3D;PAYABLE&amp;statuses&#x3D;ATTACHED_TO_BANK_TRANSFER
         * @param {string} [supplierId] Filter the payment requests by the specified supplier id.
         * @param {boolean} [transferDataCreated] Filter the payment requests by whether the corresponding transaction data has been created.
         * @param {boolean} [withholdingApplied] Filter the payment requests by whether the withholding tax has been applied. true means the withholdingCalculatingMethod is NONE, while false, except for NONE.
         * @param {'SELF' | 'SUPPLIER'} [transferFeeResponsibility] Filter the payment requests by the specified transfer fee responsibility.
         * @param {string} [requestorId] Filter the payment requests by the specified requestor id.
         * @param {string} [freeWord] A keyword used to search the following fields for partial matches:  - supplier name  - requestor name  - memo  - accounting items  - sections
         * @param {number} [limit] 
         * @param {number} [offset] See the description of &#x60;cursor&#x60; section Pagination
         * @param {string} [cursor] Pagination is performed by specifying either offset or cursor; if neither offset nor cursor is specified, it is assumed to be cursor-pagination and the first page is obtained with the next cursor. See below how the pagination exactly behaves:  - \&quot;\&quot; ... Get the fist page and return the next cursor  - \&quot;offset&#x3D;50\&quot; ... Get from the specified offset and never return the next cursor  - \&quot;cursor&#x3D;xxx\&quot; ... Get from the specified cursor  - \&quot;offset&#x3D;50&amp;cursor&#x3D;xxx\&quot; ... Ignore the offset and get from the specified cursor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchPaymentRequests(organizationId: string, dueDateJstFrom?: string, dueDateJstTo?: string, requestedDateJstFrom?: string, requestedDateJstTo?: string, statuses?: Array<'PENDING_WORKFLOW_COMPLETION' | 'CANCELED' | 'PAYABLE' | 'ATTACHED_TO_BANK_TRANSFER' | 'DEACTIVATED'>, supplierId?: string, transferDataCreated?: boolean, withholdingApplied?: boolean, transferFeeResponsibility?: 'SELF' | 'SUPPLIER', requestorId?: string, freeWord?: string, limit?: number, offset?: number, cursor?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SearchPaymentRequests200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchPaymentRequests(organizationId, dueDateJstFrom, dueDateJstTo, requestedDateJstFrom, requestedDateJstTo, statuses, supplierId, transferDataCreated, withholdingApplied, transferFeeResponsibility, requestorId, freeWord, limit, offset, cursor, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary send back onboarding request
         * @param {string} onboardingRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendBackOnboardingRequest(onboardingRequestId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendBackOnboardingRequest(onboardingRequestId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary send changed credit notifications
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendChangedCreditNotifications(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendChangedCreditNotifications(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Send Organization Identity Verification
         * @param {string} organizationId 
         * @param {SendOrganizationIdentityVerificationRequest} sendOrganizationIdentityVerificationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendOrganizationIdentityVerification(organizationId: string, sendOrganizationIdentityVerificationRequest: SendOrganizationIdentityVerificationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendOrganizationIdentityVerification(organizationId, sendOrganizationIdentityVerificationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Send Transaction Authorization Request
         * @param {string} organizationId 
         * @param {SendTransactionAuthorizationRequestRequest} sendTransactionAuthorizationRequestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendTransactionAuthorizationRequest(organizationId: string, sendTransactionAuthorizationRequestRequest: SendTransactionAuthorizationRequestRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendTransactionAuthorizationRequest(organizationId, sendTransactionAuthorizationRequestRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Sign Up For Slack
         * @param {SignUpForSlackRequest} signUpForSlackRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async signUpForSlack(signUpForSlackRequest: SignUpForSlackRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.signUpForSlack(signUpForSlackRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Submit completed workflow of draft payment request
         * @param {string} organizationId 
         * @param {string} draftPaymentRequestId 
         * @param {string} [xUpsidrSwitchUser] 
         * @param {SubmitCompletedWorkflowOfDraftPaymentRequestsRequest} [submitCompletedWorkflowOfDraftPaymentRequestsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submitCompletedWorkflowOfDraftPaymentRequests(organizationId: string, draftPaymentRequestId: string, xUpsidrSwitchUser?: string, submitCompletedWorkflowOfDraftPaymentRequestsRequest?: SubmitCompletedWorkflowOfDraftPaymentRequestsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubmitCompletedWorkflowOfDraftPaymentRequests200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submitCompletedWorkflowOfDraftPaymentRequests(organizationId, draftPaymentRequestId, xUpsidrSwitchUser, submitCompletedWorkflowOfDraftPaymentRequestsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Submit completed workflow of payment request
         * @param {string} organizationId 
         * @param {string} [xUpsidrSwitchUser] 
         * @param {SubmitCompletedWorkflowOfPaymentRequestsRequest} [submitCompletedWorkflowOfPaymentRequestsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submitCompletedWorkflowOfPaymentRequests(organizationId: string, xUpsidrSwitchUser?: string, submitCompletedWorkflowOfPaymentRequestsRequest?: SubmitCompletedWorkflowOfPaymentRequestsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubmitCompletedWorkflowOfPaymentRequests200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submitCompletedWorkflowOfPaymentRequests(organizationId, xUpsidrSwitchUser, submitCompletedWorkflowOfPaymentRequestsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Submit workflow
         * @param {string} organizationId 
         * @param {string} workflowInstanceId 
         * @param {string} [xUpsidrSwitchUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submitWorkflow(organizationId: string, workflowInstanceId: string, xUpsidrSwitchUser?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submitWorkflow(organizationId, workflowInstanceId, xUpsidrSwitchUser, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Suspend a card
         * @param {string} organizationId 
         * @param {string} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async suspendCard(organizationId: string, cardId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuspendCard200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.suspendCard(organizationId, cardId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncAllCardStatuses(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncAllCardStatuses(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Sync all users to each marketing tools
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncAllUsersToEachMarketingTools(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncAllUsersToEachMarketingTools(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Sync freee account items
         * @param {string} organizationId 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncFreeeAccountItems(organizationId: string, companyId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncFreeeAccountItems(organizationId, companyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Sync freee partners
         * @param {string} organizationId 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncFreeePartners(organizationId: string, companyId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncFreeePartners(organizationId, companyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Sync freee segment tags
         * @param {string} organizationId 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncFreeeSegmentTags(organizationId: string, companyId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncFreeeSegmentTags(organizationId, companyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Sync Moneytree access token
         * @param {string} code Authorization code received from Moneytree after successful authentication.
         * @param {string} state OAuth state parameter to ensure request consistency.
         * @param {string} [nextTo] URL to redirect to after syncing access token.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncMoneytreeAccessToken(code: string, state: string, nextTo?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SyncMoneytreeAccessToken200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncMoneytreeAccessToken(code, state, nextTo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Sync Request for Freee Deals
         * @param {string} organizationId 
         * @param {string} companyId 
         * @param {SyncRequestForFreeeDealsRequest} syncRequestForFreeeDealsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncRequestForFreeeDeals(organizationId: string, companyId: string, syncRequestForFreeeDealsRequest: SyncRequestForFreeeDealsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncRequestForFreeeDeals(organizationId, companyId, syncRequestForFreeeDealsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Two Factor Auth Reset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async twoFactorAuthReset(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.twoFactorAuthReset(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Two Factor Auth Reset As Token
         * @param {TwoFactorAuthResetAsTokenRequest} twoFactorAuthResetAsTokenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async twoFactorAuthResetAsToken(twoFactorAuthResetAsTokenRequest: TwoFactorAuthResetAsTokenRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.twoFactorAuthResetAsToken(twoFactorAuthResetAsTokenRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Unlinking purchase to transaction.
         * @param {string} organizationId 
         * @param {string} purchaseApplicationId 
         * @param {string} [visaTransactionReferenceId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unlinkingPurchaseToTransaction(organizationId: string, purchaseApplicationId: string, visaTransactionReferenceId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unlinkingPurchaseToTransaction(organizationId, purchaseApplicationId, visaTransactionReferenceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Unlock a card due to no potential fraud
         * @param {string} organizationId 
         * @param {string} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unlockCardForNotPotentialFraud(organizationId: string, cardId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnlockCardForNotPotentialFraud200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unlockCardForNotPotentialFraud(organizationId, cardId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Unlock a card due to fraud cleared
         * @param {string} organizationId 
         * @param {string} cardId 
         * @param {string} visaTransactionReferenceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unlockCardOnFraudCleared(organizationId: string, cardId: string, visaTransactionReferenceId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnlockCardOnFraudCleared200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unlockCardOnFraudCleared(organizationId, cardId, visaTransactionReferenceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update Available Currencies
         * @param {string} userAccountId 
         * @param {UpdateAvailableCurrenciesRequest} updateAvailableCurrenciesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAvailableCurrencies(userAccountId: string, updateAvailableCurrenciesRequest: UpdateAvailableCurrenciesRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateAvailableCurrencies200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAvailableCurrencies(userAccountId, updateAvailableCurrenciesRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update Available Merchant Categories
         * @param {string} userAccountId 
         * @param {UpdateAvailableMerchantCategoriesRequest} updateAvailableMerchantCategoriesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAvailableMerchantCategories(userAccountId: string, updateAvailableMerchantCategoriesRequest: UpdateAvailableMerchantCategoriesRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateAvailableMerchantCategories200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAvailableMerchantCategories(userAccountId, updateAvailableMerchantCategoriesRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary update card account unit
         * @param {string} organizationId 
         * @param {UpdateCardAccountUnitRequest} updateCardAccountUnitRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCardAccountUnit(organizationId: string, updateCardAccountUnitRequest: UpdateCardAccountUnitRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCardAccountUnit(organizationId, updateCardAccountUnitRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update Card Count Limit
         * @param {string} organizationId 
         * @param {UpdateCardCountLimitRequest} updateCardCountLimitRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCardCountLimit(organizationId: string, updateCardCountLimitRequest: UpdateCardCountLimitRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCardCountLimit(organizationId, updateCardCountLimitRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update card holder for the user account
         * @param {string} userAccountId 
         * @param {UpdateCardHolderRequest} updateCardHolderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCardHolder(userAccountId: string, updateCardHolderRequest: UpdateCardHolderRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateCardHolder200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCardHolder(userAccountId, updateCardHolderRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Lock a card
         * @param {string} organizationId 
         * @param {string} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCardLock(organizationId: string, cardId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateCardLock200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCardLock(organizationId, cardId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Unlock a card
         * @param {string} organizationId 
         * @param {string} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCardUnlock(organizationId: string, cardId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateCardUnlock200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCardUnlock(organizationId, cardId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update comment for card transaction
         * @param {string} organizationId 
         * @param {string} paymentReferenceId 
         * @param {string} cardTransactionCommentId 
         * @param {UpdateCommentRequest} updateCommentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateComment(organizationId: string, paymentReferenceId: string, cardTransactionCommentId: string, updateCommentRequest: UpdateCommentRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateComment(organizationId, paymentReferenceId, cardTransactionCommentId, updateCommentRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update comment template
         * @param {string} organizationId 
         * @param {string} templateId 
         * @param {UpdateCommentTemplateRequest} updateCommentTemplateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCommentTemplate(organizationId: string, templateId: string, updateCommentTemplateRequest: UpdateCommentTemplateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCommentTemplate(organizationId, templateId, updateCommentTemplateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update corporate document verification result
         * @param {string} organizationIdentityVerificationId 
         * @param {UpdateCorporateDocumentResultRequest} updateCorporateDocumentResultRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCorporateDocumentResult(organizationIdentityVerificationId: string, updateCorporateDocumentResultRequest: UpdateCorporateDocumentResultRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCorporateDocumentResult(organizationIdentityVerificationId, updateCorporateDocumentResultRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update daily usage limit for the user account
         * @param {string} userAccountId 
         * @param {UpdateDailyUserUsageLimitRequest} updateDailyUserUsageLimitRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDailyUserUsageLimit(userAccountId: string, updateDailyUserUsageLimitRequest: UpdateDailyUserUsageLimitRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateDailyUserUsageLimit200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDailyUserUsageLimit(userAccountId, updateDailyUserUsageLimitRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update deposit restriction for organization
         * @param {string} organizationId 
         * @param {string} depositRestrictionId 
         * @param {UpdateDepositRestrictionForOrganizationRequest} updateDepositRestrictionForOrganizationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDepositRestrictionForOrganization(organizationId: string, depositRestrictionId: string, updateDepositRestrictionForOrganizationRequest: UpdateDepositRestrictionForOrganizationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDepositRestrictionForOrganization(organizationId, depositRestrictionId, updateDepositRestrictionForOrganizationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Toggle on/off email notification settings per user
         * @param {string} userId 
         * @param {string} emailNotificationId 
         * @param {UpdateEmailNotificationRequest} updateEmailNotificationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEmailNotification(userId: string, emailNotificationId: string, updateEmailNotificationRequest: UpdateEmailNotificationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEmailNotification(userId, emailNotificationId, updateEmailNotificationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary update embed url method
         * @param {string} organizationId 
         * @param {UpdateEmbedUrlMethodRequest} updateEmbedUrlMethodRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEmbedUrlMethod(organizationId: string, updateEmbedUrlMethodRequest: UpdateEmbedUrlMethodRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEmbedUrlMethod(organizationId, updateEmbedUrlMethodRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update evidence image
         * @param {string} organizationId 
         * @param {string} paymentReferenceId 
         * @param {string} cardTransactionEvidenceId 
         * @param {File} [file] 
         * @param {string} [electronicMethod] 
         * @param {string} [documentSize] 
         * @param {number} [heightMillis] 
         * @param {number} [widthMillis] 
         * @param {string} [note] 
         * @param {boolean} [irrelevantToLedger] 
         * @param {boolean} [dpiForciblyValid] 
         * @param {boolean} [colorGradationForciblyValid] 
         * @param {boolean} [uploadedByRecipient] 
         * @param {string} [uploadedFrom] 
         * @param {string} [invoiceIssuerName] 
         * @param {string} [invoiceIssuerRegistrationNumber] 
         * @param {boolean} [asQualified] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEvidenceImage(organizationId: string, paymentReferenceId: string, cardTransactionEvidenceId: string, file?: File, electronicMethod?: string, documentSize?: string, heightMillis?: number, widthMillis?: number, note?: string, irrelevantToLedger?: boolean, dpiForciblyValid?: boolean, colorGradationForciblyValid?: boolean, uploadedByRecipient?: boolean, uploadedFrom?: string, invoiceIssuerName?: string, invoiceIssuerRegistrationNumber?: string, asQualified?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEvidenceImage(organizationId, paymentReferenceId, cardTransactionEvidenceId, file, electronicMethod, documentSize, heightMillis, widthMillis, note, irrelevantToLedger, dpiForciblyValid, colorGradationForciblyValid, uploadedByRecipient, uploadedFrom, invoiceIssuerName, invoiceIssuerRegistrationNumber, asQualified, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update evidence info
         * @param {string} organizationId 
         * @param {string} paymentReferenceId 
         * @param {string} cardTransactionEvidenceId 
         * @param {UpdateEvidenceInfoRequest} updateEvidenceInfoRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEvidenceInfo(organizationId: string, paymentReferenceId: string, cardTransactionEvidenceId: string, updateEvidenceInfoRequest: UpdateEvidenceInfoRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEvidenceInfo(organizationId, paymentReferenceId, cardTransactionEvidenceId, updateEvidenceInfoRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update freee connect
         * @param {string} organizationId 
         * @param {string} code 
         * @param {string} state 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateFreeeConnect(organizationId: string, code: string, state: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateFreeeConnect200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateFreeeConnect(organizationId, code, state, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Turn on/off freee journaling
         * @param {string} organizationId 
         * @param {UpdateFreeeJournalingRequest} updateFreeeJournalingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateFreeeJournaling(organizationId: string, updateFreeeJournalingRequest: UpdateFreeeJournalingRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateFreeeJournaling(organizationId, updateFreeeJournalingRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update freee select company
         * @param {string} organizationId 
         * @param {UpdateFreeeSelectCompanyRequest} updateFreeeSelectCompanyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateFreeeSelectCompany(organizationId: string, updateFreeeSelectCompanyRequest: UpdateFreeeSelectCompanyRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateFreeeSelectCompany200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateFreeeSelectCompany(organizationId, updateFreeeSelectCompanyRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update lock status of evidences
         * @param {string} organizationId 
         * @param {UpdateLockStatusOfEvidencesRequest} updateLockStatusOfEvidencesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateLockStatusOfEvidences(organizationId: string, updateLockStatusOfEvidencesRequest: UpdateLockStatusOfEvidencesRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateLockStatusOfEvidences(organizationId, updateLockStatusOfEvidencesRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update merchant general block allowed organization ids
         * @param {string} merchantGeneralBlockListId 
         * @param {UpdateMerchantGeneralBlockAllowedOrganizationIdsRequest} updateMerchantGeneralBlockAllowedOrganizationIdsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMerchantGeneralBlockAllowedOrganizationIds(merchantGeneralBlockListId: string, updateMerchantGeneralBlockAllowedOrganizationIdsRequest: UpdateMerchantGeneralBlockAllowedOrganizationIdsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMerchantGeneralBlockAllowedOrganizationIds(merchantGeneralBlockListId, updateMerchantGeneralBlockAllowedOrganizationIdsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update merchant general block list
         * @param {string} merchantGeneralBlockListId 
         * @param {UpdateMerchantGeneralBlockListRequest} updateMerchantGeneralBlockListRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMerchantGeneralBlockList(merchantGeneralBlockListId: string, updateMerchantGeneralBlockListRequest: UpdateMerchantGeneralBlockListRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMerchantGeneralBlockList(merchantGeneralBlockListId, updateMerchantGeneralBlockListRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update merchant org block list
         * @param {string} merchantOrgBlockListId 
         * @param {UpdateMerchantOrgBlockListRequest} updateMerchantOrgBlockListRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMerchantOrgBlockList(merchantOrgBlockListId: string, updateMerchantOrgBlockListRequest: UpdateMerchantOrgBlockListRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMerchantOrgBlockList(merchantOrgBlockListId, updateMerchantOrgBlockListRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update Merchant Organization Comment
         * @param {string} organizationId 
         * @param {string} merchantId 
         * @param {string} userAccountId 
         * @param {UpdateMerchantOrganizationCommentRequest} updateMerchantOrganizationCommentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMerchantOrganizationComment(organizationId: string, merchantId: string, userAccountId: string, updateMerchantOrganizationCommentRequest: UpdateMerchantOrganizationCommentRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMerchantOrganizationComment(organizationId, merchantId, userAccountId, updateMerchantOrganizationCommentRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update Organization
         * @param {string} organizationId 
         * @param {UpdateOrganizationRequest} updateOrganizationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOrganization(organizationId: string, updateOrganizationRequest: UpdateOrganizationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateOrganization200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOrganization(organizationId, updateOrganizationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update Organizations Accounting Csv Export Fields
         * @param {string} organizationId 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOrganizationsAccountingCsvExportFields(organizationId: string, requestBody: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOrganizationsAccountingCsvExportFields(organizationId, requestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update the payment request evidence specified by evidenceId.
         * @summary Update the specific payment request evidence.
         * @param {string} organizationId 
         * @param {string} paymentRequestId 
         * @param {string} evidenceId 
         * @param {UpdatePaymentRequestEvidenceRequest} updatePaymentRequestEvidenceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePaymentRequestEvidence(organizationId: string, paymentRequestId: string, evidenceId: string, updatePaymentRequestEvidenceRequest: UpdatePaymentRequestEvidenceRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePaymentRequestEvidence(organizationId, paymentRequestId, evidenceId, updatePaymentRequestEvidenceRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update the payment request evidence file specified by evidenceId. This also accept properties other than a file binary.
         * @summary Update the specific payment request evidence file.
         * @param {string} organizationId 
         * @param {string} paymentRequestId 
         * @param {string} evidenceId 
         * @param {File} [file] 
         * @param {string} [electronicMethod] 
         * @param {string} [documentSize] 
         * @param {number} [heightMillis] 
         * @param {number} [widthMillis] 
         * @param {boolean} [dpiForciblyValid] 
         * @param {boolean} [colorGradationForciblyValid] 
         * @param {string} [note] 
         * @param {boolean} [irrelevantToLedger] 
         * @param {boolean} [uploadedByRecipient] 
         * @param {string} [uploadedFrom] 
         * @param {string} [invoiceIssuerRegistrationNumber] 
         * @param {string} [invoiceIssuerName] 
         * @param {boolean} [asQualified] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePaymentRequestEvidenceFile(organizationId: string, paymentRequestId: string, evidenceId: string, file?: File, electronicMethod?: string, documentSize?: string, heightMillis?: number, widthMillis?: number, dpiForciblyValid?: boolean, colorGradationForciblyValid?: boolean, note?: string, irrelevantToLedger?: boolean, uploadedByRecipient?: boolean, uploadedFrom?: string, invoiceIssuerRegistrationNumber?: string, invoiceIssuerName?: string, asQualified?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePaymentRequestEvidenceFile(organizationId, paymentRequestId, evidenceId, file, electronicMethod, documentSize, heightMillis, widthMillis, dpiForciblyValid, colorGradationForciblyValid, note, irrelevantToLedger, uploadedByRecipient, uploadedFrom, invoiceIssuerRegistrationNumber, invoiceIssuerName, asQualified, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update purchase application template.
         * @param {string} organizationId 
         * @param {string} purchaseTemplateId 
         * @param {UpdatePurchaseApplicationTemplateRequest} [updatePurchaseApplicationTemplateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePurchaseApplicationTemplate(organizationId: string, purchaseTemplateId: string, updatePurchaseApplicationTemplateRequest?: UpdatePurchaseApplicationTemplateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePurchaseApplicationTemplate(organizationId, purchaseTemplateId, updatePurchaseApplicationTemplateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update remove user account group
         * @param {string} userAccountId 
         * @param {UpdateRemoveUserAccountGroupRequest} updateRemoveUserAccountGroupRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRemoveUserAccountGroup(userAccountId: string, updateRemoveUserAccountGroupRequest: UpdateRemoveUserAccountGroupRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateRemoveUserAccountGroup(userAccountId, updateRemoveUserAccountGroupRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update role resource for user
         * @param {string} userId 
         * @param {UpdateRoleResourceForUserRequest} updateRoleResourceForUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRoleResourceForUser(userId: string, updateRoleResourceForUserRequest: UpdateRoleResourceForUserRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateRoleResourceForUser(userId, updateRoleResourceForUserRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update Roles by Resource Id
         * @param {string} resourceScope 
         * @param {string} resourceId 
         * @param {UpdateRolesByResourceIdRequest} updateRolesByResourceIdRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRolesByResourceId(resourceScope: string, resourceId: string, updateRolesByResourceIdRequest: UpdateRolesByResourceIdRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateRolesByResourceId(resourceScope, resourceId, updateRolesByResourceIdRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update Slack evidence remind settings of an slack channel
         * @param {string} organizationId 
         * @param {string} channelId 
         * @param {UpdateSlackEvidenceReminderPerChannelRequest} updateSlackEvidenceReminderPerChannelRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSlackEvidenceReminderPerChannel(organizationId: string, channelId: string, updateSlackEvidenceReminderPerChannelRequest: UpdateSlackEvidenceReminderPerChannelRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSlackEvidenceReminderPerChannel(organizationId, channelId, updateSlackEvidenceReminderPerChannelRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update slack notification channel setting for card
         * @param {string} organizationId 
         * @param {string} channelId 
         * @param {UpdateSlackNotificationSettingForCardRequest} updateSlackNotificationSettingForCardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSlackNotificationSettingForCard(organizationId: string, channelId: string, updateSlackNotificationSettingForCardRequest: UpdateSlackNotificationSettingForCardRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSlackNotificationSettingForCard(organizationId, channelId, updateSlackNotificationSettingForCardRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update slack notification channel setting for purchase-application
         * @param {string} organizationId 
         * @param {string} channelId 
         * @param {UpdateSlackNotificationSettingForPurchaseApplicationRequest} updateSlackNotificationSettingForPurchaseApplicationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSlackNotificationSettingForPurchaseApplication(organizationId: string, channelId: string, updateSlackNotificationSettingForPurchaseApplicationRequest: UpdateSlackNotificationSettingForPurchaseApplicationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSlackNotificationSettingForPurchaseApplication(organizationId, channelId, updateSlackNotificationSettingForPurchaseApplicationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update sync to freee from deal
         * @param {string} organizationId 
         * @param {string} companyId 
         * @param {string} dealId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSyncToFreeeFromDeal(organizationId: string, companyId: string, dealId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSyncToFreeeFromDeal(organizationId, companyId, dealId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update synchronize to freee log confirm
         * @param {string} organizationId 
         * @param {string} companyId 
         * @param {UpdateSynchronizeToFreeeLogConfirmRequest} updateSynchronizeToFreeeLogConfirmRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSynchronizeToFreeeLogConfirm(organizationId: string, companyId: string, updateSynchronizeToFreeeLogConfirmRequest: UpdateSynchronizeToFreeeLogConfirmRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSynchronizeToFreeeLogConfirm(organizationId, companyId, updateSynchronizeToFreeeLogConfirmRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update Teams notification channel setting for card
         * @param {string} organizationId 
         * @param {string} channelId 
         * @param {UpdateTeamsNotificationSettingForCardRequest} updateTeamsNotificationSettingForCardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTeamsNotificationSettingForCard(organizationId: string, channelId: string, updateTeamsNotificationSettingForCardRequest: UpdateTeamsNotificationSettingForCardRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTeamsNotificationSettingForCard(organizationId, channelId, updateTeamsNotificationSettingForCardRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update transaction upper limit for the user account
         * @param {string} userAccountId 
         * @param {UpdateTransactionUpperLimitForTheUserAccountRequest} updateTransactionUpperLimitForTheUserAccountRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTransactionUpperLimitForTheUserAccount(userAccountId: string, updateTransactionUpperLimitForTheUserAccountRequest: UpdateTransactionUpperLimitForTheUserAccountRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateTransactionUpperLimitForTheUserAccount200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTransactionUpperLimitForTheUserAccount(userAccountId, updateTransactionUpperLimitForTheUserAccountRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update user account group
         * @param {string} userAccountId 
         * @param {UpdateUserAccountGroupRequest} updateUserAccountGroupRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserAccountGroup(userAccountId: string, updateUserAccountGroupRequest: UpdateUserAccountGroupRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserAccountGroup(userAccountId, updateUserAccountGroupRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update user account name
         * @param {string} userAccountId 
         * @param {UpdateUserAccountNameRequest} updateUserAccountNameRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserAccountName(userAccountId: string, updateUserAccountNameRequest: UpdateUserAccountNameRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateUserAccountName200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserAccountName(userAccountId, updateUserAccountNameRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary update user email, settings per user
         * @param {string} userId 
         * @param {UpdateUserEmailRequest} updateUserEmailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserEmail(userId: string, updateUserEmailRequest: UpdateUserEmailRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserEmail(userId, updateUserEmailRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary update user name, settings per user
         * @param {string} userId 
         * @param {UpdateUserNameRequest} updateUserNameRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserName(userId: string, updateUserNameRequest: UpdateUserNameRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserName(userId, updateUserNameRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary update user organization
         * @param {string} userId 
         * @param {UpdateUserOrganizationRequest} updateUserOrganizationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserOrganization(userId: string, updateUserOrganizationRequest: UpdateUserOrganizationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserOrganization(userId, updateUserOrganizationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary update user password
         * @param {string} userId 
         * @param {UpdateUserPasswordRequest} updateUserPasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserPassword(userId: string, updateUserPasswordRequest: UpdateUserPasswordRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserPassword(userId, updateUserPasswordRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update User Privilege
         * @param {string} organizationId 
         * @param {string} userId 
         * @param {UpdateUserPrivilegeRequest} updateUserPrivilegeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserPrivilege(organizationId: string, userId: string, updateUserPrivilegeRequest: UpdateUserPrivilegeRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserPrivilege(organizationId, userId, updateUserPrivilegeRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update usage limit for the user account
         * @param {string} userAccountId 
         * @param {UpdateUserUsageLimitRequest} updateUserUsageLimitRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserUsageLimit(userAccountId: string, updateUserUsageLimitRequest: UpdateUserUsageLimitRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateUserUsageLimit200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserUsageLimit(userAccountId, updateUserUsageLimitRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Upload card transaction evidence images
         * @param {string} organizationId 
         * @param {string} paymentReferenceId 
         * @param {Array<File>} [files] 
         * @param {string} [electronicMethod] 
         * @param {string} [documentSize] 
         * @param {number} [heightMillis] 
         * @param {number} [widthMillis] 
         * @param {string} [note] 
         * @param {boolean} [irrelevantToLedger] 
         * @param {boolean} [uploadedByRecipient] 
         * @param {string} [uploadedFrom] 
         * @param {string} [invoiceIssuerName] 
         * @param {string} [invoiceIssuerRegistrationNumber] 
         * @param {boolean} [asQualified] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadCardTransactionEvidenceImage(organizationId: string, paymentReferenceId: string, files?: Array<File>, electronicMethod?: string, documentSize?: string, heightMillis?: number, widthMillis?: number, note?: string, irrelevantToLedger?: boolean, uploadedByRecipient?: boolean, uploadedFrom?: string, invoiceIssuerName?: string, invoiceIssuerRegistrationNumber?: string, asQualified?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadCardTransactionEvidenceImage(organizationId, paymentReferenceId, files, electronicMethod, documentSize, heightMillis, widthMillis, note, irrelevantToLedger, uploadedByRecipient, uploadedFrom, invoiceIssuerName, invoiceIssuerRegistrationNumber, asQualified, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Upload corporate document
         * @param {string} organizationIdentityVerificationId 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadCorporateDocument(organizationIdentityVerificationId: string, file: File, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadCorporateDocument(organizationIdentityVerificationId, file, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Upload payment request evidence image
         * @param {string} organizationId 
         * @param {string} paymentRequestId 
         * @param {File} [file] 
         * @param {string} [electronicMethod] 
         * @param {string} [documentSize] 
         * @param {number} [heightMillis] 
         * @param {number} [widthMillis] 
         * @param {string} [note] 
         * @param {boolean} [irrelevantToLedger] 
         * @param {boolean} [uploadedByRecipient] 
         * @param {string} [uploadedFrom] 
         * @param {string} [invoiceIssuerName] 
         * @param {string} [invoiceIssuerRegistrationNumber] 
         * @param {boolean} [asQualified] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadPaymentRequestEvidenceImage(organizationId: string, paymentRequestId: string, file?: File, electronicMethod?: string, documentSize?: string, heightMillis?: number, widthMillis?: number, note?: string, irrelevantToLedger?: boolean, uploadedByRecipient?: boolean, uploadedFrom?: string, invoiceIssuerName?: string, invoiceIssuerRegistrationNumber?: string, asQualified?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadPaymentRequestEvidenceImage(organizationId, paymentRequestId, file, electronicMethod, documentSize, heightMillis, widthMillis, note, irrelevantToLedger, uploadedByRecipient, uploadedFrom, invoiceIssuerName, invoiceIssuerRegistrationNumber, asQualified, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Users email confirm
         * @param {UsersEmailConfirmRequest} usersEmailConfirmRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersEmailConfirm(usersEmailConfirmRequest: UsersEmailConfirmRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UsersEmailConfirm200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersEmailConfirm(usersEmailConfirmRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Verify moneytree connections
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyMoneytreeConnections(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VerifyMoneytreeConnections200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyMoneytreeConnections(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DefaultApi - factory interface
 * @export
 */
export const DefaultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DefaultApiFp(configuration)
    return {
        /**
         * 
         * @summary Add comment for card transaction
         * @param {DefaultApiAddCommentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addComment(requestParameters: DefaultApiAddCommentRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.addComment(requestParameters.organizationId, requestParameters.paymentReferenceId, requestParameters.addCommentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add Organization Create Request
         * @param {DefaultApiAddOrganizationCreateRequestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addOrganizationCreateRequest(requestParameters: DefaultApiAddOrganizationCreateRequestRequest, options?: AxiosRequestConfig): AxiosPromise<AddOrganizationCreateRequest200Response> {
            return localVarFp.addOrganizationCreateRequest(requestParameters.addOrganizationCreateRequestRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary add point to organization
         * @param {DefaultApiAddPointToOrganizationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addPointToOrganization(requestParameters: DefaultApiAddPointToOrganizationRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.addPointToOrganization(requestParameters.organizationId, requestParameters.addPointToOrganizationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Agree to the agreement request
         * @param {DefaultApiAgreeToAgreementRequestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agreeToAgreementRequest(requestParameters: DefaultApiAgreeToAgreementRequestRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.agreeToAgreementRequest(requestParameters.organizationId, requestParameters.agreementRequestId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Analyze evidence
         * @param {DefaultApiAnalyzeEvidenceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analyzeEvidence(requestParameters: DefaultApiAnalyzeEvidenceRequest, options?: AxiosRequestConfig): AxiosPromise<AnalyzeEvidence200Response> {
            return localVarFp.analyzeEvidence(requestParameters.organizationId, requestParameters.file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Analyze invoice of payment requests
         * @param {DefaultApiAnalyzeInvoiceOfPaymentRequestsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analyzeInvoiceOfPaymentRequests(requestParameters: DefaultApiAnalyzeInvoiceOfPaymentRequestsRequest, options?: AxiosRequestConfig): AxiosPromise<AnalyzeInvoiceOfPaymentRequests200Response> {
            return localVarFp.analyzeInvoiceOfPaymentRequests(requestParameters.organizationId, requestParameters.file, requestParameters.xUpsidrSwitchUser, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Approve organization identity verification
         * @param {DefaultApiApproveOrganizationIdentityVerificationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveOrganizationIdentityVerification(requestParameters: DefaultApiApproveOrganizationIdentityVerificationRequest, options?: AxiosRequestConfig): AxiosPromise<ApproveOrganizationIdentityVerification200Response> {
            return localVarFp.approveOrganizationIdentityVerification(requestParameters.organizationIdentityVerificationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Approve purchase application.
         * @param {DefaultApiApprovePurchaseApplicationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approvePurchaseApplication(requestParameters: DefaultApiApprovePurchaseApplicationRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.approvePurchaseApplication(requestParameters.organizationId, requestParameters.purchaseApplicationId, requestParameters.approvePurchaseApplicationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Approve workflow step of payment request
         * @param {DefaultApiApproveWorkflowStepPaymentRequestsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveWorkflowStepPaymentRequests(requestParameters: DefaultApiApproveWorkflowStepPaymentRequestsRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.approveWorkflowStepPaymentRequests(requestParameters.organizationId, requestParameters.xUpsidrSwitchUser, requestParameters.approveWorkflowStepPaymentRequestsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Automatically journalize deals from rules
         * @param {DefaultApiAutomaticallyJournalizeDealsFromRulesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        automaticallyJournalizeDealsFromRules(requestParameters: DefaultApiAutomaticallyJournalizeDealsFromRulesRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.automaticallyJournalizeDealsFromRules(requestParameters.organizationId, requestParameters.companyId, requestParameters.automaticallyJournalizeDealsFromRulesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Bank Account Activities Withdrawal Reserve
         * @param {DefaultApiBankAccountActivitiesWithdrawalReserveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bankAccountActivitiesWithdrawalReserve(requestParameters: DefaultApiBankAccountActivitiesWithdrawalReserveRequest, options?: AxiosRequestConfig): AxiosPromise<BankAccountActivitiesWithdrawalReserve200Response> {
            return localVarFp.bankAccountActivitiesWithdrawalReserve(requestParameters.bankAccountActivitiesWithdrawalReserveRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Disable daily usage limit for an user account
         * @param {DefaultApiBulkDisableDailyUserUsageLimitRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkDisableDailyUserUsageLimit(requestParameters: DefaultApiBulkDisableDailyUserUsageLimitRequest, options?: AxiosRequestConfig): AxiosPromise<Array<BulkDisableDailyUserUsageLimit200ResponseInner>> {
            return localVarFp.bulkDisableDailyUserUsageLimit(requestParameters.bulkDisableDailyUserUsageLimitRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Bulk disable monthly usage limit
         * @param {DefaultApiBulkDisableMonthlyUsageLimitRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkDisableMonthlyUsageLimit(requestParameters: DefaultApiBulkDisableMonthlyUsageLimitRequest, options?: AxiosRequestConfig): AxiosPromise<Array<BulkDisableMonthlyUsageLimit200ResponseInner>> {
            return localVarFp.bulkDisableMonthlyUsageLimit(requestParameters.bulkDisableMonthlyUsageLimitRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Bulk update daily usage limit
         * @param {DefaultApiBulkUpdateDailyUsageLimitRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkUpdateDailyUsageLimit(requestParameters: DefaultApiBulkUpdateDailyUsageLimitRequest, options?: AxiosRequestConfig): AxiosPromise<Array<BulkUpdateDailyUsageLimit200ResponseInner>> {
            return localVarFp.bulkUpdateDailyUsageLimit(requestParameters.bulkUpdateDailyUsageLimitRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Bulk update monthly usage limit
         * @param {DefaultApiBulkUpdateMonthlyUsageLimitRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkUpdateMonthlyUsageLimit(requestParameters: DefaultApiBulkUpdateMonthlyUsageLimitRequest, options?: AxiosRequestConfig): AxiosPromise<Array<BulkUpdateMonthlyUsageLimit200ResponseInner>> {
            return localVarFp.bulkUpdateMonthlyUsageLimit(requestParameters.bulkUpdateMonthlyUsageLimitRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Bulk Update Organization User Privileges
         * @param {DefaultApiBulkUpdateOrganizationUserPrivilegesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkUpdateOrganizationUserPrivileges(requestParameters: DefaultApiBulkUpdateOrganizationUserPrivilegesRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.bulkUpdateOrganizationUserPrivileges(requestParameters.organizationId, requestParameters.bulkUpdateOrganizationUserPrivilegesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Cancel draft payment request
         * @param {DefaultApiCancelDraftPaymentRequestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelDraftPaymentRequest(requestParameters: DefaultApiCancelDraftPaymentRequestRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.cancelDraftPaymentRequest(requestParameters.organizationId, requestParameters.draftPaymentRequestId, requestParameters.xUpsidrSwitchUser, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Cancel payment request
         * @param {DefaultApiCancelPaymentRequestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelPaymentRequest(requestParameters: DefaultApiCancelPaymentRequestRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.cancelPaymentRequest(requestParameters.organizationId, requestParameters.paymentRequestId, requestParameters.xUpsidrSwitchUser, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Change Identity Verification Scheduled Date
         * @param {DefaultApiChangeIdentityVerificationScheduledDateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeIdentityVerificationScheduledDate(requestParameters: DefaultApiChangeIdentityVerificationScheduledDateRequest, options?: AxiosRequestConfig): AxiosPromise<ChangeIdentityVerificationScheduledDate200Response> {
            return localVarFp.changeIdentityVerificationScheduledDate(requestParameters.organizationId, requestParameters.changeIdentityVerificationScheduledDateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Change Invoice Email
         * @param {DefaultApiChangeInvoiceEmailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeInvoiceEmail(requestParameters: DefaultApiChangeInvoiceEmailRequest, options?: AxiosRequestConfig): AxiosPromise<ChangeInvoiceEmail200Response> {
            return localVarFp.changeInvoiceEmail(requestParameters.organizationId, requestParameters.changeInvoiceEmailRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Change to the specified ekyc result
         * @param {DefaultApiChangeToTheSpecifiedEkycResultRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeToTheSpecifiedEkycResult(requestParameters: DefaultApiChangeToTheSpecifiedEkycResultRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.changeToTheSpecifiedEkycResult(requestParameters.identificationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Check Already Registered Phone Number
         * @param {DefaultApiCheckAlreadyRegisteredPhoneNumberRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkAlreadyRegisteredPhoneNumber(requestParameters: DefaultApiCheckAlreadyRegisteredPhoneNumberRequest, options?: AxiosRequestConfig): AxiosPromise<CheckAlreadyRegisteredPhoneNumber200Response> {
            return localVarFp.checkAlreadyRegisteredPhoneNumber(requestParameters.checkAlreadyRegisteredPhoneNumberRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Check All Organization Available Limit And Notify
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkAvailableLimit(options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.checkAvailableLimit(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Check duplicate email addresses
         * @param {DefaultApiCheckDuplicateEmailAddressesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkDuplicateEmailAddresses(requestParameters: DefaultApiCheckDuplicateEmailAddressesRequest = {}, options?: AxiosRequestConfig): AxiosPromise<Array<CheckDuplicateEmailAddresses200ResponseInner>> {
            return localVarFp.checkDuplicateEmailAddresses(requestParameters.emailAddresses, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkMonthlyUsageLimit(options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.checkMonthlyUsageLimit(options).then((request) => request(axios, basePath));
        },
        /**
         * It is an API that waits for a redirect after the payment request fix button is pressed in the Slack App. This API does three things:   - Slack message modification - remove each button attached to the original message   - Post messages to Slack - communicate the fact that the edit button was pressed   - Create payment request for draft data
         * @summary Complete redirect from slack
         * @param {DefaultApiCompleteRedirectFromSlackRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeRedirectFromSlack(requestParameters: DefaultApiCompleteRedirectFromSlackRequest, options?: AxiosRequestConfig): AxiosPromise<CompleteRedirectFromSlack200Response> {
            return localVarFp.completeRedirectFromSlack(requestParameters.organizationId, requestParameters.completeRedirectFromSlackRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Count deals
         * @param {DefaultApiCountDealsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countDeals(requestParameters: DefaultApiCountDealsRequest, options?: AxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.countDeals(requestParameters.organizationId, requestParameters.countDealsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create bank transfers for the specified payment requests.
         * @summary Create bank transfers
         * @param {DefaultApiCreateBankTransfersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBankTransfers(requestParameters: DefaultApiCreateBankTransfersRequest, options?: AxiosRequestConfig): AxiosPromise<CreateBankTransfers200Response> {
            return localVarFp.createBankTransfers(requestParameters.organizationId, requestParameters.createBankTransfersRequest, requestParameters.transferDateJstFrom, requestParameters.transferDateJstTo, requestParameters.sourceBankAccountId, requestParameters.downloaded, requestParameters.limit, requestParameters.offset, requestParameters.cursor, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create category of the purchase application template.
         * @param {DefaultApiCreateCategoryOfThePurchaseApplicationTemplateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCategoryOfThePurchaseApplicationTemplate(requestParameters: DefaultApiCreateCategoryOfThePurchaseApplicationTemplateRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createCategoryOfThePurchaseApplicationTemplate(requestParameters.organizationId, requestParameters.createCategoryOfThePurchaseApplicationTemplateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create comment template
         * @param {DefaultApiCreateCommentTemplateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCommentTemplate(requestParameters: DefaultApiCreateCommentTemplateRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createCommentTemplate(requestParameters.organizationId, requestParameters.createCommentTemplateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create deposit restriction for organization
         * @param {DefaultApiCreateDepositRestrictionForOrganizationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDepositRestrictionForOrganization(requestParameters: DefaultApiCreateDepositRestrictionForOrganizationRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createDepositRestrictionForOrganization(requestParameters.organizationId, requestParameters.createDepositRestrictionForOrganizationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create draft of payment request
         * @param {DefaultApiCreateDraftOfPaymentRequestsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDraftOfPaymentRequests(requestParameters: DefaultApiCreateDraftOfPaymentRequestsRequest, options?: AxiosRequestConfig): AxiosPromise<CreateDraftOfPaymentRequests200Response> {
            return localVarFp.createDraftOfPaymentRequests(requestParameters.organizationId, requestParameters.xUpsidrSwitchUser, requestParameters.createDraftOfPaymentRequestsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create evidence request
         * @param {DefaultApiCreateEvidenceRequestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEvidenceRequest(requestParameters: DefaultApiCreateEvidenceRequestRequest, options?: AxiosRequestConfig): AxiosPromise<CreateEvidenceRequest200Response> {
            return localVarFp.createEvidenceRequest(requestParameters.organizationId, requestParameters.paymentReferenceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create freee partner
         * @param {DefaultApiCreateFreeePartnerRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFreeePartner(requestParameters: DefaultApiCreateFreeePartnerRequest, options?: AxiosRequestConfig): AxiosPromise<CreateFreeePartner200Response> {
            return localVarFp.createFreeePartner(requestParameters.organizationId, requestParameters.companyId, requestParameters.createFreeePartnerRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create past deals
         * @param {DefaultApiCreatePastDealsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPastDeals(requestParameters: DefaultApiCreatePastDealsRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createPastDeals(requestParameters.organizationId, requestParameters.createPastDealsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create purchase application.
         * @param {DefaultApiCreatePurchaseApplicationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPurchaseApplication(requestParameters: DefaultApiCreatePurchaseApplicationRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createPurchaseApplication(requestParameters.organizationId, requestParameters.createPurchaseApplicationRequest, requestParameters.visaTransactionReferenceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create purchase application template.
         * @param {DefaultApiCreatePurchaseApplicationTemplateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPurchaseApplicationTemplate(requestParameters: DefaultApiCreatePurchaseApplicationTemplateRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createPurchaseApplicationTemplate(requestParameters.organizationId, requestParameters.createPurchaseApplicationTemplateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Slack card notification settings of an organization
         * @param {DefaultApiCreateSlackCardNotificationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSlackCardNotifications(requestParameters: DefaultApiCreateSlackCardNotificationsRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createSlackCardNotifications(requestParameters.organizationId, requestParameters.createSlackCardNotificationsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create slack notification settings for purchase-application
         * @param {DefaultApiCreateSlackNotificationSettingsForPurchaseApplicationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSlackNotificationSettingsForPurchaseApplication(requestParameters: DefaultApiCreateSlackNotificationSettingsForPurchaseApplicationRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createSlackNotificationSettingsForPurchaseApplication(requestParameters.organizationId, requestParameters.createSlackNotificationSettingsForPurchaseApplicationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Teams card notification settings of an organization
         * @param {DefaultApiCreateTeamsCardNotificationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTeamsCardNotifications(requestParameters: DefaultApiCreateTeamsCardNotificationsRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createTeamsCardNotifications(requestParameters.organizationId, requestParameters.createTeamsCardNotificationsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create user account groups
         * @param {DefaultApiCreateUserAccountGroupsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUserAccountGroups(requestParameters: DefaultApiCreateUserAccountGroupsRequest, options?: AxiosRequestConfig): AxiosPromise<Array<CreateUserAccountGroups200ResponseInner>> {
            return localVarFp.createUserAccountGroups(requestParameters.organizationId, requestParameters.createUserAccountGroupsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deactivate a card
         * @param {DefaultApiDeactivateCardRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivateCard(requestParameters: DefaultApiDeactivateCardRequest, options?: AxiosRequestConfig): AxiosPromise<DeactivateCard200Response> {
            return localVarFp.deactivateCard(requestParameters.cardId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deactivate a user
         * @param {DefaultApiDeactivateUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivateUser(requestParameters: DefaultApiDeactivateUserRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deactivateUser(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Defrost a card
         * @param {DefaultApiDefrostCardRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        defrostCard(requestParameters: DefaultApiDefrostCardRequest, options?: AxiosRequestConfig): AxiosPromise<DefrostCard200Response> {
            return localVarFp.defrostCard(requestParameters.cardId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Card Points Rate Configs
         * @param {DefaultApiDeleteCardPointsRateConfigRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCardPointsRateConfig(requestParameters: DefaultApiDeleteCardPointsRateConfigRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteCardPointsRateConfig(requestParameters.rateConfigId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete category of the purchase application template.
         * @param {DefaultApiDeleteCategoryOfThePurchaseApplicationTemplateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCategoryOfThePurchaseApplicationTemplate(requestParameters: DefaultApiDeleteCategoryOfThePurchaseApplicationTemplateRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteCategoryOfThePurchaseApplicationTemplate(requestParameters.organizationId, requestParameters.purchaseTemplateCategoryId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete comment for card transaction
         * @param {DefaultApiDeleteCommentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteComment(requestParameters: DefaultApiDeleteCommentRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteComment(requestParameters.organizationId, requestParameters.paymentReferenceId, requestParameters.cardTransactionCommentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete comment template
         * @param {DefaultApiDeleteCommentTemplateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCommentTemplate(requestParameters: DefaultApiDeleteCommentTemplateRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteCommentTemplate(requestParameters.organizationId, requestParameters.templateId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete deposit restriction for organization
         * @param {DefaultApiDeleteDepositRestrictionForOrganizationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDepositRestrictionForOrganization(requestParameters: DefaultApiDeleteDepositRestrictionForOrganizationRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteDepositRestrictionForOrganization(requestParameters.organizationId, requestParameters.depositRestrictionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete evidence
         * @param {DefaultApiDeleteEvidenceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEvidence(requestParameters: DefaultApiDeleteEvidenceRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteEvidence(requestParameters.organizationId, requestParameters.paymentReferenceId, requestParameters.cardTransactionEvidenceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete freee connected
         * @param {DefaultApiDeleteFreeeConnectedRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFreeeConnected(requestParameters: DefaultApiDeleteFreeeConnectedRequest, options?: AxiosRequestConfig): AxiosPromise<DeleteFreeeConnected200Response> {
            return localVarFp.deleteFreeeConnected(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Freee End Journal Entry Transition Mode
         * @param {DefaultApiDeleteFreeeEndJournalEntryTransitionModeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFreeeEndJournalEntryTransitionMode(requestParameters: DefaultApiDeleteFreeeEndJournalEntryTransitionModeRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteFreeeEndJournalEntryTransitionMode(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete merchant general block allowed organization ids
         * @param {DefaultApiDeleteMerchantGeneralBlockAllowedOrganizationIdsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMerchantGeneralBlockAllowedOrganizationIds(requestParameters: DefaultApiDeleteMerchantGeneralBlockAllowedOrganizationIdsRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteMerchantGeneralBlockAllowedOrganizationIds(requestParameters.merchantGeneralBlockListId, requestParameters.allowedOrganizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete merchant general block list
         * @param {DefaultApiDeleteMerchantGeneralBlockListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMerchantGeneralBlockList(requestParameters: DefaultApiDeleteMerchantGeneralBlockListRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteMerchantGeneralBlockList(requestParameters.merchantGeneralBlockListId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete merchant org block list
         * @param {DefaultApiDeleteMerchantOrgBlockListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMerchantOrgBlockList(requestParameters: DefaultApiDeleteMerchantOrgBlockListRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteMerchantOrgBlockList(requestParameters.merchantOrgBlockListId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete an onboarding request
         * @param {DefaultApiDeleteOnboardingRequestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOnboardingRequest(requestParameters: DefaultApiDeleteOnboardingRequestRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteOnboardingRequest(requestParameters.onboardingRequestId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Organization Create Request
         * @param {DefaultApiDeleteOrganizationCreateRequestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrganizationCreateRequest(requestParameters: DefaultApiDeleteOrganizationCreateRequestRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteOrganizationCreateRequest(requestParameters.organizationCreateRequestId, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a payment request evidence specified by evidenceId.
         * @summary Delete the specific payment request evidence.
         * @param {DefaultApiDeletePaymentRequestEvidenceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePaymentRequestEvidence(requestParameters: DefaultApiDeletePaymentRequestEvidenceRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deletePaymentRequestEvidence(requestParameters.organizationId, requestParameters.paymentRequestId, requestParameters.evidenceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete purchase application.
         * @param {DefaultApiDeletePurchaseApplicationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePurchaseApplication(requestParameters: DefaultApiDeletePurchaseApplicationRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deletePurchaseApplication(requestParameters.organizationId, requestParameters.purchaseApplicationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete purchase application templates detail
         * @param {DefaultApiDeletePurchaseApplicationTemplatesDetailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePurchaseApplicationTemplatesDetail(requestParameters: DefaultApiDeletePurchaseApplicationTemplatesDetailRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deletePurchaseApplicationTemplatesDetail(requestParameters.organizationId, requestParameters.purchaseTemplateId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete slack notification channel setting for purchase-application
         * @param {DefaultApiDeleteSlackNotificationChannelSettingForPurchaseApplicationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSlackNotificationChannelSettingForPurchaseApplication(requestParameters: DefaultApiDeleteSlackNotificationChannelSettingForPurchaseApplicationRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteSlackNotificationChannelSettingForPurchaseApplication(requestParameters.organizationId, requestParameters.channelId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete slack notification channel setting for card
         * @param {DefaultApiDeleteSlackNotificationSettingForCardRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSlackNotificationSettingForCard(requestParameters: DefaultApiDeleteSlackNotificationSettingForCardRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteSlackNotificationSettingForCard(requestParameters.organizationId, requestParameters.channelId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete system admin role
         * @param {DefaultApiDeleteSystemAdminRoleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSystemAdminRole(requestParameters: DefaultApiDeleteSystemAdminRoleRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteSystemAdminRole(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete teams notification channel setting for card
         * @param {DefaultApiDeleteTeamsNotificationSettingForCardRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTeamsNotificationSettingForCard(requestParameters: DefaultApiDeleteTeamsNotificationSettingForCardRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteTeamsNotificationSettingForCard(requestParameters.organizationId, requestParameters.channelId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete user account group
         * @param {DefaultApiDeleteUserAccountGroupRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserAccountGroup(requestParameters: DefaultApiDeleteUserAccountGroupRequest, options?: AxiosRequestConfig): AxiosPromise<Array<DeleteUserAccountGroup200ResponseInner>> {
            return localVarFp.deleteUserAccountGroup(requestParameters.userAccountGroupId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deposit Guarantee Money Balance
         * @param {DefaultApiDepositGuaranteeMoneyBalanceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        depositGuaranteeMoneyBalance(requestParameters: DefaultApiDepositGuaranteeMoneyBalanceRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.depositGuaranteeMoneyBalance(requestParameters.organizationId, requestParameters.depositGuaranteeMoneyBalanceRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Disable Approval
         * @param {DefaultApiDisableApprovalRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disableApproval(requestParameters: DefaultApiDisableApprovalRequest, options?: AxiosRequestConfig): AxiosPromise<DisableApproval200Response> {
            return localVarFp.disableApproval(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Disable daily usage limit for an user account
         * @param {DefaultApiDisableDailyUserUsageLimitRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disableDailyUserUsageLimit(requestParameters: DefaultApiDisableDailyUserUsageLimitRequest, options?: AxiosRequestConfig): AxiosPromise<DisableDailyUserUsageLimit200Response> {
            return localVarFp.disableDailyUserUsageLimit(requestParameters.userAccountId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Disable physical store payment for the user account
         * @param {DefaultApiDisablePhysicalStorePaymentForTheUserAccountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disablePhysicalStorePaymentForTheUserAccount(requestParameters: DefaultApiDisablePhysicalStorePaymentForTheUserAccountRequest, options?: AxiosRequestConfig): AxiosPromise<DisablePhysicalStorePaymentForTheUserAccount200Response> {
            return localVarFp.disablePhysicalStorePaymentForTheUserAccount(requestParameters.userAccountId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Disable transaction upper limit for the user account
         * @param {DefaultApiDisableTransactionUpperLimitForTheUserAccountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disableTransactionUpperLimitForTheUserAccount(requestParameters: DefaultApiDisableTransactionUpperLimitForTheUserAccountRequest, options?: AxiosRequestConfig): AxiosPromise<DisableTransactionUpperLimitForTheUserAccount200Response> {
            return localVarFp.disableTransactionUpperLimitForTheUserAccount(requestParameters.userAccountId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Disable usage limit for an user account
         * @param {DefaultApiDisableUserUsageLimitRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disableUserUsageLimit(requestParameters: DefaultApiDisableUserUsageLimitRequest, options?: AxiosRequestConfig): AxiosPromise<DisableUserUsageLimit200Response> {
            return localVarFp.disableUserUsageLimit(requestParameters.userAccountId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Disagree to the agreement request
         * @param {DefaultApiDisagreeToAgreementRequestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disagreeToAgreementRequest(requestParameters: DefaultApiDisagreeToAgreementRequestRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.disagreeToAgreementRequest(requestParameters.organizationId, requestParameters.agreementRequestId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Download bank transfer file
         * @param {DefaultApiDownloadBankTransferFileRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadBankTransferFile(requestParameters: DefaultApiDownloadBankTransferFileRequest, options?: AxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.downloadBankTransferFile(requestParameters.organizationId, requestParameters.bankTransferId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Download bank transfers csv
         * @param {DefaultApiDownloadBankTransfersCsvRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadBankTransfersCsv(requestParameters: DefaultApiDownloadBankTransfersCsvRequest, options?: AxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.downloadBankTransfersCsv(requestParameters.organizationId, requestParameters.transferDateJstFrom, requestParameters.transferDateJstTo, requestParameters.sourceBankAccountId, requestParameters.downloaded, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Download journal entry for freee csv
         * @param {DefaultApiDownloadJournalEntryForFreeeCsvRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadJournalEntryForFreeeCsv(requestParameters: DefaultApiDownloadJournalEntryForFreeeCsvRequest, options?: AxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.downloadJournalEntryForFreeeCsv(requestParameters.organizationId, requestParameters.yearMonth, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Download Organizations Accounting Csv
         * @param {DefaultApiDownloadOrganizationsAccountingCsvRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadOrganizationsAccountingCsv(requestParameters: DefaultApiDownloadOrganizationsAccountingCsvRequest, options?: AxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.downloadOrganizationsAccountingCsv(requestParameters.organizationId, requestParameters.yearMonth, requestParameters.isMergedFiles, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Download payment requests csv
         * @param {DefaultApiDownloadPaymentRequestsCsvRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadPaymentRequestsCsv(requestParameters: DefaultApiDownloadPaymentRequestsCsvRequest, options?: AxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.downloadPaymentRequestsCsv(requestParameters.organizationId, requestParameters.dueDateJstFrom, requestParameters.dueDateJstTo, requestParameters.statuses, requestParameters.supplierId, requestParameters.transferDataCreated, requestParameters.withholdingApplied, requestParameters.transferFeeResponsibility, requestParameters.freeWord, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Download payment requests csv for payment request ids specification
         * @param {DefaultApiDownloadPaymentRequestsCsvForPaymentRequestIdsSpecificationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadPaymentRequestsCsvForPaymentRequestIdsSpecification(requestParameters: DefaultApiDownloadPaymentRequestsCsvForPaymentRequestIdsSpecificationRequest, options?: AxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.downloadPaymentRequestsCsvForPaymentRequestIdsSpecification(requestParameters.organizationId, requestParameters.downloadPaymentRequestsCsvForPaymentRequestIdsSpecificationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Enable physical store payment for the user account
         * @param {DefaultApiEnablePhysicalStorePaymentForTheUserAccountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enablePhysicalStorePaymentForTheUserAccount(requestParameters: DefaultApiEnablePhysicalStorePaymentForTheUserAccountRequest, options?: AxiosRequestConfig): AxiosPromise<EnablePhysicalStorePaymentForTheUserAccount200Response> {
            return localVarFp.enablePhysicalStorePaymentForTheUserAccount(requestParameters.userAccountId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Freeze a card
         * @param {DefaultApiFreezeCardRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        freezeCard(requestParameters: DefaultApiFreezeCardRequest, options?: AxiosRequestConfig): AxiosPromise<FreezeCard200Response> {
            return localVarFp.freezeCard(requestParameters.cardId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Generate Annual Fees Invoice
         * @param {DefaultApiGenerateAnnualFeesInvoiceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateAnnualFeesInvoice(requestParameters: DefaultApiGenerateAnnualFeesInvoiceRequest, options?: AxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.generateAnnualFeesInvoice(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Generate Create Account Token
         * @param {DefaultApiGenerateCreateAccountTokenRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateCreateAccountToken(requestParameters: DefaultApiGenerateCreateAccountTokenRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.generateCreateAccountToken(requestParameters.generateCreateAccountTokenRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Generate freee redirect url
         * @param {DefaultApiGenerateFreeeRedirectUrlRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateFreeeRedirectUrl(requestParameters: DefaultApiGenerateFreeeRedirectUrlRequest, options?: AxiosRequestConfig): AxiosPromise<GenerateFreeeRedirectUrl200Response> {
            return localVarFp.generateFreeeRedirectUrl(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Generate org account ids.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateOrgAccountIds(options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.generateOrgAccountIds(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a Card Detail as Admin
         * @param {DefaultApiGetACardDetailAsAdminRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getACardDetailAsAdmin(requestParameters: DefaultApiGetACardDetailAsAdminRequest, options?: AxiosRequestConfig): AxiosPromise<GetACardDetailAsAdmin200Response> {
            return localVarFp.getACardDetailAsAdmin(requestParameters.cardId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get accounting csv for the organization.
         * @param {DefaultApiGetAccountingCsvForTheOrganizationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountingCsvForTheOrganization(requestParameters: DefaultApiGetAccountingCsvForTheOrganizationRequest, options?: AxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.getAccountingCsvForTheOrganization(requestParameters.organizationId, requestParameters.startYearMonth, requestParameters.endYearMonth, requestParameters.accountingSystemType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get accounting csv for the user account.
         * @param {DefaultApiGetAccountingCsvForTheUserAccountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountingCsvForTheUserAccount(requestParameters: DefaultApiGetAccountingCsvForTheUserAccountRequest, options?: AxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.getAccountingCsvForTheUserAccount(requestParameters.userAccountId, requestParameters.yearMonth, requestParameters.isMergedFiles, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get admin users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminUsers(options?: AxiosRequestConfig): AxiosPromise<GetAdminUsers200Response> {
            return localVarFp.getAdminUsers(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get admins
         * @param {DefaultApiGetAdminsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdmins(requestParameters: DefaultApiGetAdminsRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetAdmins200ResponseInner>> {
            return localVarFp.getAdmins(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get agreement requests
         * @param {DefaultApiGetAgreementRequestsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgreementRequests(requestParameters: DefaultApiGetAgreementRequestsRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetAgreementRequests200ResponseInner>> {
            return localVarFp.getAgreementRequests(requestParameters.organizationId, requestParameters.waitingForAgreement, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all banks
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllBanks(options?: AxiosRequestConfig): AxiosPromise<Array<GetAllBanks200ResponseInner>> {
            return localVarFp.getAllBanks(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get analysis invoice of payment request
         * @param {DefaultApiGetAnalysisInvoiceOfPaymentRequestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAnalysisInvoiceOfPaymentRequest(requestParameters: DefaultApiGetAnalysisInvoiceOfPaymentRequestRequest, options?: AxiosRequestConfig): AxiosPromise<GetAnalysisInvoiceOfPaymentRequest200Response> {
            return localVarFp.getAnalysisInvoiceOfPaymentRequest(requestParameters.organizationId, requestParameters.fileId, requestParameters.xUpsidrSwitchUser, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get annual fees eligibility
         * @param {DefaultApiGetAnnualFeesEligibilityRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAnnualFeesEligibility(requestParameters: DefaultApiGetAnnualFeesEligibilityRequest, options?: AxiosRequestConfig): AxiosPromise<GetAnnualFeesEligibility200Response> {
            return localVarFp.getAnnualFeesEligibility(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get approvers
         * @param {DefaultApiGetApproversRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApprovers(requestParameters: DefaultApiGetApproversRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetApprovers200ResponseInner>> {
            return localVarFp.getApprovers(requestParameters.userAccountId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get available currency options
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableCurrencyOptions(options?: AxiosRequestConfig): AxiosPromise<Array<string>> {
            return localVarFp.getAvailableCurrencyOptions(options).then((request) => request(axios, basePath));
        },
        /**
         * <p>   Return a list of feature names that are available for the organization.   Most features are unconditionally available to all organizations and   are not included in the response of this API, while some new features are not   available for the organization unless their names are included in this response. </p> <p>   The response schema are designed to ensure that information about new features   is not disclosed to organizations that cannot use them. </p>
         * @param {DefaultApiGetAvailableFeaturesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableFeatures(requestParameters: DefaultApiGetAvailableFeaturesRequest, options?: AxiosRequestConfig): AxiosPromise<Array<string>> {
            return localVarFp.getAvailableFeatures(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Available merchant category options
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableMerchantCategoryOptions(options?: AxiosRequestConfig): AxiosPromise<GetAvailableMerchantCategoryOptions200Response> {
            return localVarFp.getAvailableMerchantCategoryOptions(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get balance state
         * @param {DefaultApiGetBalanceStateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBalanceState(requestParameters: DefaultApiGetBalanceStateRequest, options?: AxiosRequestConfig): AxiosPromise<GetBalanceState200Response> {
            return localVarFp.getBalanceState(requestParameters.organizationId, requestParameters.targetDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get bank account activities
         * @param {DefaultApiGetBankAccountActivitiesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBankAccountActivities(requestParameters: DefaultApiGetBankAccountActivitiesRequest, options?: AxiosRequestConfig): AxiosPromise<GetBankAccountActivities200Response> {
            return localVarFp.getBankAccountActivities(requestParameters.bankAccountActivityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a bank account confirmed activities
         * @param {DefaultApiGetBankAccountConfirmedActivitiesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBankAccountConfirmedActivities(requestParameters: DefaultApiGetBankAccountConfirmedActivitiesRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetBankAccountConfirmedActivities200ResponseInner>> {
            return localVarFp.getBankAccountConfirmedActivities(requestParameters.organizationId, requestParameters.type, requestParameters.limit, requestParameters.offset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get bank by name
         * @param {DefaultApiGetBankByNameRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBankByName(requestParameters: DefaultApiGetBankByNameRequest, options?: AxiosRequestConfig): AxiosPromise<GetBankByName200Response> {
            return localVarFp.getBankByName(requestParameters.bankName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a bank transfer
         * @param {DefaultApiGetBankTransferRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBankTransfer(requestParameters: DefaultApiGetBankTransferRequest, options?: AxiosRequestConfig): AxiosPromise<GetBankTransfer200Response> {
            return localVarFp.getBankTransfer(requestParameters.organizationId, requestParameters.bankTransferId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the specified bank\'s all branches
         * @param {DefaultApiGetBanksAllBranchesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBanksAllBranches(requestParameters: DefaultApiGetBanksAllBranchesRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetBanksAllBranches200ResponseInner>> {
            return localVarFp.getBanksAllBranches(requestParameters.bankCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get bookkeepers
         * @param {DefaultApiGetBookkeepersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBookkeepers(requestParameters: DefaultApiGetBookkeepersRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetBookkeepers200ResponseInner>> {
            return localVarFp.getBookkeepers(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get branch
         * @param {DefaultApiGetBranchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBranch(requestParameters: DefaultApiGetBranchRequest, options?: AxiosRequestConfig): AxiosPromise<GetBranch200Response> {
            return localVarFp.getBranch(requestParameters.bankCode, requestParameters.branchName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all business descriptions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBusinessDescriptions(options?: AxiosRequestConfig): AxiosPromise<Array<GetBusinessDescriptions200ResponseInner>> {
            return localVarFp.getBusinessDescriptions(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get if an organization can activate cards
         * @param {DefaultApiGetCanActivateCardRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCanActivateCard(requestParameters: DefaultApiGetCanActivateCardRequest, options?: AxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.getCanActivateCard(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the status of whether the organization can close
         * @param {DefaultApiGetCanCloseStatusesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCanCloseStatuses(requestParameters: DefaultApiGetCanCloseStatusesRequest, options?: AxiosRequestConfig): AxiosPromise<GetCanCloseStatuses200Response> {
            return localVarFp.getCanCloseStatuses(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get can deactivate
         * @param {DefaultApiGetCanDeactivateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCanDeactivate(requestParameters: DefaultApiGetCanDeactivateRequest, options?: AxiosRequestConfig): AxiosPromise<GetCanDeactivate200Response> {
            return localVarFp.getCanDeactivate(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get if the user can read card\'s sensitive info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCanReadCardSensitive(options?: AxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.getCanReadCardSensitive(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get if an organization can request a real card to be issued.
         * @param {DefaultApiGetCanRequestSendingCardRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCanRequestSendingCard(requestParameters: DefaultApiGetCanRequestSendingCardRequest, options?: AxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.getCanRequestSendingCard(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Card Bill
         * @param {DefaultApiGetCardBillRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardBill(requestParameters: DefaultApiGetCardBillRequest, options?: AxiosRequestConfig): AxiosPromise<GetCardBill200Response> {
            return localVarFp.getCardBill(requestParameters.cardBillId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Card Detail
         * @param {DefaultApiGetCardDetailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardDetail(requestParameters: DefaultApiGetCardDetailRequest, options?: AxiosRequestConfig): AxiosPromise<GetCardDetail200Response> {
            return localVarFp.getCardDetail(requestParameters.cardId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get card monthly transactions
         * @param {DefaultApiGetCardMonthlyTransactionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardMonthlyTransactions(requestParameters: DefaultApiGetCardMonthlyTransactionsRequest, options?: AxiosRequestConfig): AxiosPromise<GetCardMonthlyTransactions200Response> {
            return localVarFp.getCardMonthlyTransactions(requestParameters.userAccountId, requestParameters.yearMonth, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Card Points Rate Configs By OrganizationId
         * @param {DefaultApiGetCardPointsRateConfigsByOrganizationIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardPointsRateConfigsByOrganizationId(requestParameters: DefaultApiGetCardPointsRateConfigsByOrganizationIdRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetCardPointsRateConfigsByOrganizationId200ResponseInner>> {
            return localVarFp.getCardPointsRateConfigsByOrganizationId(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get card transaction details
         * @param {DefaultApiGetCardTransactionDetailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardTransactionDetails(requestParameters: DefaultApiGetCardTransactionDetailsRequest, options?: AxiosRequestConfig): AxiosPromise<GetCardTransactionDetails200Response> {
            return localVarFp.getCardTransactionDetails(requestParameters.organizationId, requestParameters.visaTransactionReferenceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get card transaction evidence record image
         * @param {DefaultApiGetCardTransactionEvidenceRecordImageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardTransactionEvidenceRecordImage(requestParameters: DefaultApiGetCardTransactionEvidenceRecordImageRequest, options?: AxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.getCardTransactionEvidenceRecordImage(requestParameters.organizationId, requestParameters.paymentReferenceId, requestParameters.cardTransactionEvidenceId, requestParameters.id, requestParameters.inPdf, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get card transaction evidence records
         * @param {DefaultApiGetCardTransactionEvidenceRecordsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardTransactionEvidenceRecords(requestParameters: DefaultApiGetCardTransactionEvidenceRecordsRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetCardTransactionEvidenceRecords200ResponseInner>> {
            return localVarFp.getCardTransactionEvidenceRecords(requestParameters.organizationId, requestParameters.paymentReferenceId, requestParameters.cardTransactionEvidenceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Card Transactions
         * @param {DefaultApiGetCardTransactionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardTransactions(requestParameters: DefaultApiGetCardTransactionsRequest, options?: AxiosRequestConfig): AxiosPromise<GetCardTransactions200Response> {
            return localVarFp.getCardTransactions(requestParameters.userAccountId, requestParameters.merchantId, requestParameters.toYearMonth, requestParameters.fromYearMonth, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get cards
         * @param {DefaultApiGetCardsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCards(requestParameters: DefaultApiGetCardsRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetCards200ResponseInner>> {
            return localVarFp.getCards(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get cards transactions with purchase application unlinked
         * @param {DefaultApiGetCardsTransactionsWithPurchaseApplicationUnlinkedRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardsTransactionsWithPurchaseApplicationUnlinked(requestParameters: DefaultApiGetCardsTransactionsWithPurchaseApplicationUnlinkedRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInner>> {
            return localVarFp.getCardsTransactionsWithPurchaseApplicationUnlinked(requestParameters.organizationId, requestParameters.yearMonth, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the category of the purchase application template for use.
         * @param {DefaultApiGetCategoryOfThePurchaseApplicationTemplateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategoryOfThePurchaseApplicationTemplate(requestParameters: DefaultApiGetCategoryOfThePurchaseApplicationTemplateRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetCategoryOfThePurchaseApplicationTemplate200ResponseInner>> {
            return localVarFp.getCategoryOfThePurchaseApplicationTemplate(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get comment for card transaction
         * @param {DefaultApiGetCommentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getComment(requestParameters: DefaultApiGetCommentRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetComment200ResponseInner>> {
            return localVarFp.getComment(requestParameters.organizationId, requestParameters.paymentReferenceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get comment templates
         * @param {DefaultApiGetCommentTemplatesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommentTemplates(requestParameters: DefaultApiGetCommentTemplatesRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetCommentTemplates200ResponseInner>> {
            return localVarFp.getCommentTemplates(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get comment template
         * @param {DefaultApiGetCommentTemplatesCommentTemplateIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommentTemplatesCommentTemplateId(requestParameters: DefaultApiGetCommentTemplatesCommentTemplateIdRequest, options?: AxiosRequestConfig): AxiosPromise<GetCommentTemplatesCommentTemplateId200Response> {
            return localVarFp.getCommentTemplatesCommentTemplateId(requestParameters.organizationId, requestParameters.templateId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get current card associated with the user account
         * @param {DefaultApiGetCurrentCardAssociatedWithTheUserAccountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentCardAssociatedWithTheUserAccount(requestParameters: DefaultApiGetCurrentCardAssociatedWithTheUserAccountRequest, options?: AxiosRequestConfig): AxiosPromise<GetCurrentCardAssociatedWithTheUserAccount200Response> {
            return localVarFp.getCurrentCardAssociatedWithTheUserAccount(requestParameters.userAccountId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get deals total amount
         * @param {DefaultApiGetDealsTotalAmountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDealsTotalAmount(requestParameters: DefaultApiGetDealsTotalAmountRequest, options?: AxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.getDealsTotalAmount(requestParameters.organizationId, requestParameters.getDealsTotalAmountRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get default comment template for user account
         * @param {DefaultApiGetDefaultCommentTemplateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDefaultCommentTemplate(requestParameters: DefaultApiGetDefaultCommentTemplateRequest, options?: AxiosRequestConfig): AxiosPromise<GetDefaultCommentTemplate200Response> {
            return localVarFp.getDefaultCommentTemplate(requestParameters.organizationId, requestParameters.userAccountId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get deposit bank account
         * @param {DefaultApiGetDepositBankAccountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDepositBankAccount(requestParameters: DefaultApiGetDepositBankAccountRequest, options?: AxiosRequestConfig): AxiosPromise<GetDepositBankAccount200Response> {
            return localVarFp.getDepositBankAccount(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get deposit restriction for organization
         * @param {DefaultApiGetDepositRestrictionForOrganizationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDepositRestrictionForOrganization(requestParameters: DefaultApiGetDepositRestrictionForOrganizationRequest, options?: AxiosRequestConfig): AxiosPromise<GetDepositRestrictionForOrganization200Response> {
            return localVarFp.getDepositRestrictionForOrganization(requestParameters.organizationId, requestParameters.depositRestrictionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get deposit restriction list for organization
         * @param {DefaultApiGetDepositRestrictionListForOrganizationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDepositRestrictionListForOrganization(requestParameters: DefaultApiGetDepositRestrictionListForOrganizationRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetDepositRestrictionListForOrganization200ResponseInner>> {
            return localVarFp.getDepositRestrictionListForOrganization(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get draft payment request
         * @param {DefaultApiGetDraftPaymentRequestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDraftPaymentRequest(requestParameters: DefaultApiGetDraftPaymentRequestRequest, options?: AxiosRequestConfig): AxiosPromise<GetDraftPaymentRequest200Response> {
            return localVarFp.getDraftPaymentRequest(requestParameters.organizationId, requestParameters.draftPaymentRequestId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get draft payment request evidence file
         * @param {DefaultApiGetDraftPaymentRequestEvidenceFileRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDraftPaymentRequestEvidenceFile(requestParameters: DefaultApiGetDraftPaymentRequestEvidenceFileRequest, options?: AxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.getDraftPaymentRequestEvidenceFile(requestParameters.organizationId, requestParameters.draftPaymentRequestId, requestParameters.evidenceId, requestParameters.inPdf, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get draft payment requests only created own
         * @param {DefaultApiGetDraftPaymentRequestsOnlyCreatedOwnRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDraftPaymentRequestsOnlyCreatedOwn(requestParameters: DefaultApiGetDraftPaymentRequestsOnlyCreatedOwnRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetDraftPaymentRequestsOnlyCreatedOwn200ResponseInner>> {
            return localVarFp.getDraftPaymentRequestsOnlyCreatedOwn(requestParameters.organizationId, requestParameters.xUpsidrSwitchUser, requestParameters.freeWord, requestParameters.limit, requestParameters.offset, requestParameters.cursor, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get earliest expiring guarantee money for organization
         * @param {DefaultApiGetEarliestExpiringGuaranteeMoneyForOrganizationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEarliestExpiringGuaranteeMoneyForOrganization(requestParameters: DefaultApiGetEarliestExpiringGuaranteeMoneyForOrganizationRequest, options?: AxiosRequestConfig): AxiosPromise<GetEarliestExpiringGuaranteeMoneyForOrganization200Response> {
            return localVarFp.getEarliestExpiringGuaranteeMoneyForOrganization(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtain email notification configuration information for each user.
         * @param {DefaultApiGetEmailNotificationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmailNotifications(requestParameters: DefaultApiGetEmailNotificationsRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetEmailNotifications200ResponseInner>> {
            return localVarFp.getEmailNotifications(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get error bills
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getErrorBills(options?: AxiosRequestConfig): AxiosPromise<Array<GetErrorBills200ResponseInner>> {
            return localVarFp.getErrorBills(options).then((request) => request(axios, basePath));
        },
        /**
         * Get the evidence specified by evidenceId.
         * @summary Get a specific evidence.
         * @param {DefaultApiGetEvidenceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvidence(requestParameters: DefaultApiGetEvidenceRequest, options?: AxiosRequestConfig): AxiosPromise<GetEvidence200Response> {
            return localVarFp.getEvidence(requestParameters.organizationId, requestParameters.evidenceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get evidence file
         * @param {DefaultApiGetEvidenceFileRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvidenceFile(requestParameters: DefaultApiGetEvidenceFileRequest, options?: AxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.getEvidenceFile(requestParameters.organizationId, requestParameters.evidenceId, requestParameters.inPdf, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get evidence image
         * @param {DefaultApiGetEvidenceImageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvidenceImage(requestParameters: DefaultApiGetEvidenceImageRequest, options?: AxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.getEvidenceImage(requestParameters.organizationId, requestParameters.paymentReferenceId, requestParameters.cardTransactionEvidenceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get evidence information for card transactions
         * @param {DefaultApiGetEvidenceInformationForCardTransactionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvidenceInformationForCardTransactions(requestParameters: DefaultApiGetEvidenceInformationForCardTransactionsRequest, options?: AxiosRequestConfig): AxiosPromise<GetEvidenceInformationForCardTransactions200Response> {
            return localVarFp.getEvidenceInformationForCardTransactions(requestParameters.organizationId, requestParameters.paymentReferenceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get evidence record image
         * @param {DefaultApiGetEvidenceRecordImageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvidenceRecordImage(requestParameters: DefaultApiGetEvidenceRecordImageRequest, options?: AxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.getEvidenceRecordImage(requestParameters.organizationId, requestParameters.evidenceId, requestParameters.recordId, requestParameters.inPdf, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get evidence records
         * @param {DefaultApiGetEvidenceRecordsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvidenceRecords(requestParameters: DefaultApiGetEvidenceRecordsRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetEvidenceRecords200ResponseInner>> {
            return localVarFp.getEvidenceRecords(requestParameters.organizationId, requestParameters.evidenceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get evidence zip for the organization.
         * @param {DefaultApiGetEvidenceZipForTheOrganizationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvidenceZipForTheOrganization(requestParameters: DefaultApiGetEvidenceZipForTheOrganizationRequest, options?: AxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.getEvidenceZipForTheOrganization(requestParameters.organizationId, requestParameters.yearMonth, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get evidences
         * @param {DefaultApiGetEvidencesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvidences(requestParameters: DefaultApiGetEvidencesRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetEvidences200ResponseInner>> {
            return localVarFp.getEvidences(requestParameters.organizationId, requestParameters.paymentReferenceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Count evidences
         * @param {DefaultApiGetEvidencesCountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvidencesCount(requestParameters: DefaultApiGetEvidencesCountRequest, options?: AxiosRequestConfig): AxiosPromise<GetEvidencesCount200Response> {
            return localVarFp.getEvidencesCount(requestParameters.organizationId, requestParameters.issuer, requestParameters.amountMin, requestParameters.amountMax, requestParameters.paidAtFrom, requestParameters.paidAtTo, requestParameters.irrelevantToLedger, requestParameters.keyword, requestParameters.includesDeleted, requestParameters.legalValidities, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the triggered transactions of a fraud locked card
         * @param {DefaultApiGetFraudLockedCardTransactionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFraudLockedCardTransactions(requestParameters: DefaultApiGetFraudLockedCardTransactionsRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetFraudLockedCardTransactions200ResponseInner>> {
            return localVarFp.getFraudLockedCardTransactions(requestParameters.organizationId, requestParameters.cardId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get freee account items
         * @param {DefaultApiGetFreeeAccountItemsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFreeeAccountItems(requestParameters: DefaultApiGetFreeeAccountItemsRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetFreeeAccountItems200ResponseInner>> {
            return localVarFp.getFreeeAccountItems(requestParameters.organizationId, requestParameters.companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get freee companies
         * @param {DefaultApiGetFreeeCompaniesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFreeeCompanies(requestParameters: DefaultApiGetFreeeCompaniesRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetFreeeCompanies200ResponseInner>> {
            return localVarFp.getFreeeCompanies(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get freee connected
         * @param {DefaultApiGetFreeeConnectedRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFreeeConnected(requestParameters: DefaultApiGetFreeeConnectedRequest, options?: AxiosRequestConfig): AxiosPromise<GetFreeeConnected200Response> {
            return localVarFp.getFreeeConnected(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Freee Connected User
         * @param {DefaultApiGetFreeeConnectedUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFreeeConnectedUser(requestParameters: DefaultApiGetFreeeConnectedUserRequest, options?: AxiosRequestConfig): AxiosPromise<GetFreeeConnectedUser200Response> {
            return localVarFp.getFreeeConnectedUser(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get freee items
         * @param {DefaultApiGetFreeeItemsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFreeeItems(requestParameters: DefaultApiGetFreeeItemsRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetFreeeItems200ResponseInner>> {
            return localVarFp.getFreeeItems(requestParameters.organizationId, requestParameters.companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get freee memo tags
         * @param {DefaultApiGetFreeeMemoTagsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFreeeMemoTags(requestParameters: DefaultApiGetFreeeMemoTagsRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetFreeeMemoTags200ResponseInner>> {
            return localVarFp.getFreeeMemoTags(requestParameters.organizationId, requestParameters.companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get freee partners
         * @param {DefaultApiGetFreeePartnersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFreeePartners(requestParameters: DefaultApiGetFreeePartnersRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetFreeePartners200ResponseInner>> {
            return localVarFp.getFreeePartners(requestParameters.organizationId, requestParameters.companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get freee sections
         * @param {DefaultApiGetFreeeSectionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFreeeSections(requestParameters: DefaultApiGetFreeeSectionsRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetFreeeSections200ResponseInner>> {
            return localVarFp.getFreeeSections(requestParameters.organizationId, requestParameters.companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get freee segment tags
         * @param {DefaultApiGetFreeeSegmentTagsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFreeeSegmentTags(requestParameters: DefaultApiGetFreeeSegmentTagsRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetFreeeSegmentTags200ResponseInner>> {
            return localVarFp.getFreeeSegmentTags(requestParameters.organizationId, requestParameters.companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get freee sync status
         * @param {DefaultApiGetFreeeSyncStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFreeeSyncStatus(requestParameters: DefaultApiGetFreeeSyncStatusRequest, options?: AxiosRequestConfig): AxiosPromise<GetFreeeSyncStatus200Response> {
            return localVarFp.getFreeeSyncStatus(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get freee tags
         * @param {DefaultApiGetFreeeTagsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFreeeTags(requestParameters: DefaultApiGetFreeeTagsRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetFreeeTags200ResponseInner>> {
            return localVarFp.getFreeeTags(requestParameters.organizationId, requestParameters.companyId, requestParameters.tagName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get freee taxes
         * @param {DefaultApiGetFreeeTaxesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFreeeTaxes(requestParameters: DefaultApiGetFreeeTaxesRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetFreeeTaxes200ResponseInner>> {
            return localVarFp.getFreeeTaxes(requestParameters.organizationId, requestParameters.companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get freee token
         * @param {DefaultApiGetFreeeTokenRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFreeeToken(requestParameters: DefaultApiGetFreeeTokenRequest, options?: AxiosRequestConfig): AxiosPromise<GetFreeeToken200Response> {
            return localVarFp.getFreeeToken(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a guarantee money balance history
         * @param {DefaultApiGetGuaranteeMoneyBalanceHistoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGuaranteeMoneyBalanceHistory(requestParameters: DefaultApiGetGuaranteeMoneyBalanceHistoryRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetGuaranteeMoneyBalanceHistory200ResponseInner>> {
            return localVarFp.getGuaranteeMoneyBalanceHistory(requestParameters.organizationId, requestParameters.limit, requestParameters.offset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a guarantee money balance information for a organization
         * @param {DefaultApiGetGuaranteeMoneyBalanceInformationForOrganizationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGuaranteeMoneyBalanceInformationForOrganization(requestParameters: DefaultApiGetGuaranteeMoneyBalanceInformationForOrganizationRequest, options?: AxiosRequestConfig): AxiosPromise<GetGuaranteeMoneyBalanceInformationForOrganization200Response> {
            return localVarFp.getGuaranteeMoneyBalanceInformationForOrganization(requestParameters.organizationId, requestParameters.targetDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get guarantee money deposits for organization
         * @param {DefaultApiGetGuaranteeMoneyDepositsForOrganizationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGuaranteeMoneyDepositsForOrganization(requestParameters: DefaultApiGetGuaranteeMoneyDepositsForOrganizationRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetGuaranteeMoneyDepositsForOrganization200ResponseInner>> {
            return localVarFp.getGuaranteeMoneyDepositsForOrganization(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetHolidaysRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHolidays(requestParameters: DefaultApiGetHolidaysRequest = {}, options?: AxiosRequestConfig): AxiosPromise<Array<string>> {
            return localVarFp.getHolidays(requestParameters.from, requestParameters.to, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetIdentifyVerificationsLatestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIdentifyVerificationsLatest(requestParameters: DefaultApiGetIdentifyVerificationsLatestRequest, options?: AxiosRequestConfig): AxiosPromise<GetIdentifyVerificationsLatest200Response> {
            return localVarFp.getIdentifyVerificationsLatest(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetIdentityVerificationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIdentityVerifications(requestParameters: DefaultApiGetIdentityVerificationsRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetIdentityVerifications200ResponseInner>> {
            return localVarFp.getIdentityVerifications(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Invoice List
         * @param {DefaultApiGetInvoiceListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoiceList(requestParameters: DefaultApiGetInvoiceListRequest, options?: AxiosRequestConfig): AxiosPromise<GetInvoiceList200Response> {
            return localVarFp.getInvoiceList(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Invoice Pdf
         * @param {DefaultApiGetInvoicePdfRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoicePdf(requestParameters: DefaultApiGetInvoicePdfRequest, options?: AxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.getInvoicePdf(requestParameters.organizationId, requestParameters.yearMonth, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get issuable status
         * @param {DefaultApiGetIssuableStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIssuableStatus(requestParameters: DefaultApiGetIssuableStatusRequest, options?: AxiosRequestConfig): AxiosPromise<GetIssuableStatus200Response> {
            return localVarFp.getIssuableStatus(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get jwt for SSO
         * @param {DefaultApiGetJwtSsoRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJwtSso(requestParameters: DefaultApiGetJwtSsoRequest, options?: AxiosRequestConfig): AxiosPromise<GetJwtSso200Response> {
            return localVarFp.getJwtSso(requestParameters.nonce, options).then((request) => request(axios, basePath));
        },
        /**
         * Get list of KYC reader users ordered by creation date in descending order.
         * @summary Get KYC Reader Users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getKycReaderUsers(options?: AxiosRequestConfig): AxiosPromise<Array<GetKycReaderUsers200ResponseInner>> {
            return localVarFp.getKycReaderUsers(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get latest time of sync to freee
         * @param {DefaultApiGetLatestTimeOfSyncToFreeeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestTimeOfSyncToFreee(requestParameters: DefaultApiGetLatestTimeOfSyncToFreeeRequest, options?: AxiosRequestConfig): AxiosPromise<GetLatestTimeOfSyncToFreee200Response> {
            return localVarFp.getLatestTimeOfSyncToFreee(requestParameters.organizationId, requestParameters.companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get lock status of evidences
         * @param {DefaultApiGetLockStatusOfEvidencesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLockStatusOfEvidences(requestParameters: DefaultApiGetLockStatusOfEvidencesRequest, options?: AxiosRequestConfig): AxiosPromise<GetLockStatusOfEvidences200Response> {
            return localVarFp.getLockStatusOfEvidences(requestParameters.organizationId, requestParameters.yearMonth, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get merchant general blocks
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMerchantGeneralBlock(options?: AxiosRequestConfig): AxiosPromise<Array<GetMerchantGeneralBlock200ResponseInner>> {
            return localVarFp.getMerchantGeneralBlock(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get merchant general block detail
         * @param {DefaultApiGetMerchantGeneralBlockDetailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMerchantGeneralBlockDetail(requestParameters: DefaultApiGetMerchantGeneralBlockDetailRequest, options?: AxiosRequestConfig): AxiosPromise<GetMerchantGeneralBlockDetail200Response> {
            return localVarFp.getMerchantGeneralBlockDetail(requestParameters.merchantGeneralBlockListId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get merchant org blocks
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMerchantOrgBlock(options?: AxiosRequestConfig): AxiosPromise<Array<GetMerchantOrgBlock200ResponseInner>> {
            return localVarFp.getMerchantOrgBlock(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get merchant org block list
         * @param {DefaultApiGetMerchantOrgBlockListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMerchantOrgBlockList(requestParameters: DefaultApiGetMerchantOrgBlockListRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetMerchantOrgBlockList200ResponseInner>> {
            return localVarFp.getMerchantOrgBlockList(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get merchant organization user account year month summary
         * @param {DefaultApiGetMerchantOrganizationUserAccountYearMonthSummaryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMerchantOrganizationUserAccountYearMonthSummary(requestParameters: DefaultApiGetMerchantOrganizationUserAccountYearMonthSummaryRequest, options?: AxiosRequestConfig): AxiosPromise<GetMerchantOrganizationUserAccountYearMonthSummary200Response> {
            return localVarFp.getMerchantOrganizationUserAccountYearMonthSummary(requestParameters.organizationId, requestParameters.merchantId, requestParameters.userAccountId, requestParameters.toYearMonth, requestParameters.fromYearMonth, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a list of MerchantCategoryKind
         * @param {DefaultApiGetMerchantsCategoryKindsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMerchantsCategoryKinds(requestParameters: DefaultApiGetMerchantsCategoryKindsRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetMerchantsCategoryKinds200ResponseInner>> {
            return localVarFp.getMerchantsCategoryKinds(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Modifiable Daily Limits For The User Account
         * @param {DefaultApiGetModifiableDailyLimitsForTheUserAccountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getModifiableDailyLimitsForTheUserAccount(requestParameters: DefaultApiGetModifiableDailyLimitsForTheUserAccountRequest, options?: AxiosRequestConfig): AxiosPromise<GetModifiableDailyLimitsForTheUserAccount200Response> {
            return localVarFp.getModifiableDailyLimitsForTheUserAccount(requestParameters.userAccountId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get modifiable monthly limits for the user account
         * @param {DefaultApiGetModifiableMonthlyLimitsForTheUserAccountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getModifiableMonthlyLimitsForTheUserAccount(requestParameters: DefaultApiGetModifiableMonthlyLimitsForTheUserAccountRequest, options?: AxiosRequestConfig): AxiosPromise<GetModifiableMonthlyLimitsForTheUserAccount200Response> {
            return localVarFp.getModifiableMonthlyLimitsForTheUserAccount(requestParameters.userAccountId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Modifiable Transaction Limits For The User Account
         * @param {DefaultApiGetModifiableTransactionLimitsForTheUserAccountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getModifiableTransactionLimitsForTheUserAccount(requestParameters: DefaultApiGetModifiableTransactionLimitsForTheUserAccountRequest, options?: AxiosRequestConfig): AxiosPromise<GetModifiableTransactionLimitsForTheUserAccount200Response> {
            return localVarFp.getModifiableTransactionLimitsForTheUserAccount(requestParameters.userAccountId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get moneytree connected
         * @param {DefaultApiGetMoneytreeConnectedRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMoneytreeConnected(requestParameters: DefaultApiGetMoneytreeConnectedRequest, options?: AxiosRequestConfig): AxiosPromise<GetMoneytreeConnected200Response> {
            return localVarFp.getMoneytreeConnected(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get moneytree oauth url
         * @param {DefaultApiGetMoneytreeOauthUrlRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMoneytreeOauthUrl(requestParameters: DefaultApiGetMoneytreeOauthUrlRequest, options?: AxiosRequestConfig): AxiosPromise<GetMoneytreeOauthUrl200Response> {
            return localVarFp.getMoneytreeOauthUrl(requestParameters.organizationId, requestParameters.nextTo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get moneytree status
         * @param {DefaultApiGetMoneytreeStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMoneytreeStatus(requestParameters: DefaultApiGetMoneytreeStatusRequest, options?: AxiosRequestConfig): AxiosPromise<GetMoneytreeStatus200Response> {
            return localVarFp.getMoneytreeStatus(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get monthly card bills for specified yearMonths
         * @param {DefaultApiGetMonthlyCardBillRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMonthlyCardBill(requestParameters: DefaultApiGetMonthlyCardBillRequest, options?: AxiosRequestConfig): AxiosPromise<GetMonthlyCardBill200Response> {
            return localVarFp.getMonthlyCardBill(requestParameters.organizationId, requestParameters.yearMonth, requestParameters.startYearMonth, requestParameters.endYearMonth, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get monthly card transactions for the organization.
         * @param {DefaultApiGetMonthlyCardTransactionsForTheOrganizationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMonthlyCardTransactionsForTheOrganization(requestParameters: DefaultApiGetMonthlyCardTransactionsForTheOrganizationRequest, options?: AxiosRequestConfig): AxiosPromise<GetMonthlyCardTransactionsForTheOrganization200Response> {
            return localVarFp.getMonthlyCardTransactionsForTheOrganization(requestParameters.organizationId, requestParameters.yearMonth, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get monthly user card summaries
         * @param {DefaultApiGetMonthlyUserCardSummariesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMonthlyUserCardSummaries(requestParameters: DefaultApiGetMonthlyUserCardSummariesRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetMonthlyUserCardSummaries200ResponseInner>> {
            return localVarFp.getMonthlyUserCardSummaries(requestParameters.organizationId, requestParameters.yearMonth, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a specific onboarding request for zeus
         * @param {DefaultApiGetOnboardingRequestByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOnboardingRequestById(requestParameters: DefaultApiGetOnboardingRequestByIdRequest, options?: AxiosRequestConfig): AxiosPromise<GetOnboardingRequestById200Response> {
            return localVarFp.getOnboardingRequestById(requestParameters.onboardingRequestId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get personal information of the onboarding request.
         * @summary Get Personal Information
         * @param {DefaultApiGetOnboardingRequestPersonalInfoRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOnboardingRequestPersonalInfo(requestParameters: DefaultApiGetOnboardingRequestPersonalInfoRequest, options?: AxiosRequestConfig): AxiosPromise<GetOnboardingRequestPersonalInfo200Response> {
            return localVarFp.getOnboardingRequestPersonalInfo(requestParameters.onboardingRequestId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get onboarding requests for zeus
         * @param {DefaultApiGetOnboardingRequestsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOnboardingRequests(requestParameters: DefaultApiGetOnboardingRequestsRequest = {}, options?: AxiosRequestConfig): AxiosPromise<GetOnboardingRequests200Response> {
            return localVarFp.getOnboardingRequests(requestParameters.key, requestParameters.createdAtFrom, requestParameters.createdAtTo, requestParameters.limit, requestParameters.offset, requestParameters.sort, requestParameters.order, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get org account state
         * @param {DefaultApiGetOrgAccountStateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrgAccountState(requestParameters: DefaultApiGetOrgAccountStateRequest, options?: AxiosRequestConfig): AxiosPromise<GetOrgAccountState200Response> {
            return localVarFp.getOrgAccountState(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Organization
         * @param {DefaultApiGetOrganizationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganization(requestParameters: DefaultApiGetOrganizationRequest, options?: AxiosRequestConfig): AxiosPromise<GetOrganization200Response> {
            return localVarFp.getOrganization(requestParameters.organizationId, requestParameters.underContractOnly, requestParameters.withCredit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Organization Accounting Csv Fields Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationAccountingCsvFieldsTypes(options?: AxiosRequestConfig): AxiosPromise<Array<GetOrganizationAccountingCsvFieldsTypes200ResponseInner>> {
            return localVarFp.getOrganizationAccountingCsvFieldsTypes(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get organization cards extended
         * @param {DefaultApiGetOrganizationCardsExtendedRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationCardsExtended(requestParameters: DefaultApiGetOrganizationCardsExtendedRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetOrganizationCardsExtended200ResponseInner>> {
            return localVarFp.getOrganizationCardsExtended(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get organization cards light
         * @param {DefaultApiGetOrganizationCardsLightRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationCardsLight(requestParameters: DefaultApiGetOrganizationCardsLightRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetOrganizationCardsLight200ResponseInner>> {
            return localVarFp.getOrganizationCardsLight(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get organization chart departments
         * @param {DefaultApiGetOrganizationChartDepartmentsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationChartDepartments(requestParameters: DefaultApiGetOrganizationChartDepartmentsRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetOrganizationChartDepartments200ResponseInner>> {
            return localVarFp.getOrganizationChartDepartments(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get organization chart employees
         * @param {DefaultApiGetOrganizationChartEmployeesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationChartEmployees(requestParameters: DefaultApiGetOrganizationChartEmployeesRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetOrganizationChartEmployees200ResponseInner>> {
            return localVarFp.getOrganizationChartEmployees(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get organization chart roles
         * @param {DefaultApiGetOrganizationChartRolesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationChartRoles(requestParameters: DefaultApiGetOrganizationChartRolesRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetOrganizationChartRoles200ResponseInner>> {
            return localVarFp.getOrganizationChartRoles(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get organizations create requests for zeus
         * @param {DefaultApiGetOrganizationCreateRequestsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationCreateRequests(requestParameters: DefaultApiGetOrganizationCreateRequestsRequest = {}, options?: AxiosRequestConfig): AxiosPromise<GetOrganizationCreateRequests200Response> {
            return localVarFp.getOrganizationCreateRequests(requestParameters.key, requestParameters.createdAtFrom, requestParameters.createdAtTo, requestParameters.limit, requestParameters.offset, requestParameters.sort, requestParameters.order, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Organization Me
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationMe(options?: AxiosRequestConfig): AxiosPromise<GetOrganizationMe200Response> {
            return localVarFp.getOrganizationMe(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get organization payment schemes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationPaymentSchemes(options?: AxiosRequestConfig): AxiosPromise<Array<Array<GetOrganizationPaymentSchemes200ResponseInnerInner>>> {
            return localVarFp.getOrganizationPaymentSchemes(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get organization payments
         * @param {DefaultApiGetOrganizationPaymentsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationPayments(requestParameters: DefaultApiGetOrganizationPaymentsRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetOrganizationPayments200ResponseInner>> {
            return localVarFp.getOrganizationPayments(requestParameters.organizationId, requestParameters.yearMonth, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizations(options?: AxiosRequestConfig): AxiosPromise<Array<GetOrganizations200ResponseInner>> {
            return localVarFp.getOrganizations(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Organizations Accounting Csv Export Fields
         * @param {DefaultApiGetOrganizationsAccountingCsvExportFieldsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationsAccountingCsvExportFields(requestParameters: DefaultApiGetOrganizationsAccountingCsvExportFieldsRequest, options?: AxiosRequestConfig): AxiosPromise<Array<string>> {
            return localVarFp.getOrganizationsAccountingCsvExportFields(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a organization\'s bill
         * @param {DefaultApiGetOrganizationsBillsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationsBills(requestParameters: DefaultApiGetOrganizationsBillsRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetOrganizationsBills200ResponseInner>> {
            return localVarFp.getOrganizationsBills(requestParameters.organizationId, requestParameters.beforeReservationOnly, requestParameters.limit, requestParameters.offset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get organizations deals
         * @param {DefaultApiGetOrganizationsDealsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationsDeals(requestParameters: DefaultApiGetOrganizationsDealsRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetOrganizationsDeals200ResponseInner>> {
            return localVarFp.getOrganizationsDeals(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get payment request detail
         * @param {DefaultApiGetPaymentRequestDetailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentRequestDetail(requestParameters: DefaultApiGetPaymentRequestDetailRequest, options?: AxiosRequestConfig): AxiosPromise<GetPaymentRequestDetail200Response> {
            return localVarFp.getPaymentRequestDetail(requestParameters.organizationId, requestParameters.paymentRequestId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a payment request evidence specified by evidenceId.
         * @summary Get a specific payment request evidence.
         * @param {DefaultApiGetPaymentRequestEvidenceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentRequestEvidence(requestParameters: DefaultApiGetPaymentRequestEvidenceRequest, options?: AxiosRequestConfig): AxiosPromise<GetPaymentRequestEvidence200Response> {
            return localVarFp.getPaymentRequestEvidence(requestParameters.organizationId, requestParameters.paymentRequestId, requestParameters.evidenceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get payment request evidence file
         * @param {DefaultApiGetPaymentRequestEvidenceFileRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentRequestEvidenceFile(requestParameters: DefaultApiGetPaymentRequestEvidenceFileRequest, options?: AxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.getPaymentRequestEvidenceFile(requestParameters.organizationId, requestParameters.paymentRequestId, requestParameters.evidenceId, requestParameters.inPdf, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get payment request evidence record file
         * @param {DefaultApiGetPaymentRequestEvidenceRecordFileRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentRequestEvidenceRecordFile(requestParameters: DefaultApiGetPaymentRequestEvidenceRecordFileRequest, options?: AxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.getPaymentRequestEvidenceRecordFile(requestParameters.organizationId, requestParameters.paymentRequestId, requestParameters.evidenceId, requestParameters.recordId, requestParameters.inPdf, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get payment request evidence records
         * @param {DefaultApiGetPaymentRequestEvidenceRecordsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentRequestEvidenceRecords(requestParameters: DefaultApiGetPaymentRequestEvidenceRecordsRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetPaymentRequestEvidenceRecords200ResponseInner>> {
            return localVarFp.getPaymentRequestEvidenceRecords(requestParameters.organizationId, requestParameters.paymentRequestId, requestParameters.evidenceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get all evidences for a specific payment request
         * @param {DefaultApiGetPaymentRequestEvidencesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentRequestEvidences(requestParameters: DefaultApiGetPaymentRequestEvidencesRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetPaymentRequestEvidences200ResponseInner>> {
            return localVarFp.getPaymentRequestEvidences(requestParameters.organizationId, requestParameters.paymentRequestId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get payment requests bank accounts list
         * @param {DefaultApiGetPaymentRequestsBankAccountsListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentRequestsBankAccountsList(requestParameters: DefaultApiGetPaymentRequestsBankAccountsListRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetPaymentRequestsBankAccountsList200ResponseInner>> {
            return localVarFp.getPaymentRequestsBankAccountsList(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get payment requests count linked bank transfer
         * @param {DefaultApiGetPaymentRequestsCountLinkedBankTransferRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentRequestsCountLinkedBankTransfer(requestParameters: DefaultApiGetPaymentRequestsCountLinkedBankTransferRequest, options?: AxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.getPaymentRequestsCountLinkedBankTransfer(requestParameters.organizationId, requestParameters.paymentRequestIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get pinretriever decrypt pin block
         * @param {DefaultApiGetPinretrieverDecryptPinBlockRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPinretrieverDecryptPinBlock(requestParameters: DefaultApiGetPinretrieverDecryptPinBlockRequest, options?: AxiosRequestConfig): AxiosPromise<GetPinretrieverDecryptPinBlock200Response> {
            return localVarFp.getPinretrieverDecryptPinBlock(requestParameters.getPinretrieverDecryptPinBlockRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get pinretriever encrypt pin
         * @param {DefaultApiGetPinretrieverEncryptPinRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPinretrieverEncryptPin(requestParameters: DefaultApiGetPinretrieverEncryptPinRequest, options?: AxiosRequestConfig): AxiosPromise<GetPinretrieverEncryptPin200Response> {
            return localVarFp.getPinretrieverEncryptPin(requestParameters.getPinretrieverEncryptPinRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get pinretriever hsm publickey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPinretrieverHsmPublickey(options?: AxiosRequestConfig): AxiosPromise<GetPinretrieverHsmPublickey200Response> {
            return localVarFp.getPinretrieverHsmPublickey(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get purchase application
         * @param {DefaultApiGetPurchaseApplicationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPurchaseApplication(requestParameters: DefaultApiGetPurchaseApplicationRequest, options?: AxiosRequestConfig): AxiosPromise<GetPurchaseApplication200Response> {
            return localVarFp.getPurchaseApplication(requestParameters.organizationId, requestParameters.purchaseApplicationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get purchase application templates
         * @param {DefaultApiGetPurchaseApplicationTemplatesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPurchaseApplicationTemplates(requestParameters: DefaultApiGetPurchaseApplicationTemplatesRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetPurchaseApplicationTemplates200ResponseInner>> {
            return localVarFp.getPurchaseApplicationTemplates(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get purchase application templates detail
         * @param {DefaultApiGetPurchaseApplicationTemplatesDetailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPurchaseApplicationTemplatesDetail(requestParameters: DefaultApiGetPurchaseApplicationTemplatesDetailRequest, options?: AxiosRequestConfig): AxiosPromise<GetPurchaseApplicationTemplatesDetail200Response> {
            return localVarFp.getPurchaseApplicationTemplatesDetail(requestParameters.organizationId, requestParameters.purchaseTemplateId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get purchase applications
         * @param {DefaultApiGetPurchaseApplicationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPurchaseApplications(requestParameters: DefaultApiGetPurchaseApplicationsRequest, options?: AxiosRequestConfig): AxiosPromise<GetPurchaseApplications200Response> {
            return localVarFp.getPurchaseApplications(requestParameters.organizationId, requestParameters.yearMonth, requestParameters.visaTransactionReferenceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetPurchaseApplicationsRequestedCountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPurchaseApplicationsRequestedCount(requestParameters: DefaultApiGetPurchaseApplicationsRequestedCountRequest, options?: AxiosRequestConfig): AxiosPromise<GetPurchaseApplicationsRequestedCount200Response> {
            return localVarFp.getPurchaseApplicationsRequestedCount(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the purchase applications requested list
         * @param {DefaultApiGetPurchaseApplicationsRequestedListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPurchaseApplicationsRequestedList(requestParameters: DefaultApiGetPurchaseApplicationsRequestedListRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetPurchaseApplicationsRequestedList200ResponseInner>> {
            return localVarFp.getPurchaseApplicationsRequestedList(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the purchase applications submitted self
         * @param {DefaultApiGetPurchaseApplicationsSubmittedSelfRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPurchaseApplicationsSubmittedSelf(requestParameters: DefaultApiGetPurchaseApplicationsSubmittedSelfRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetPurchaseApplicationsSubmittedSelf200ResponseInner>> {
            return localVarFp.getPurchaseApplicationsSubmittedSelf(requestParameters.userId, requestParameters.yearMonth, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get(search) qualified invoice issuer
         * @param {DefaultApiGetQualifiedInvoiceIssuerRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQualifiedInvoiceIssuer(requestParameters: DefaultApiGetQualifiedInvoiceIssuerRequest, options?: AxiosRequestConfig): AxiosPromise<GetQualifiedInvoiceIssuer200Response> {
            return localVarFp.getQualifiedInvoiceIssuer(requestParameters.registrationNumber, requestParameters.issuerName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Redirect URL from Tiny URL
         * @param {DefaultApiGetRedirectUrlFromTinyUrlRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRedirectUrlFromTinyUrl(requestParameters: DefaultApiGetRedirectUrlFromTinyUrlRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getRedirectUrlFromTinyUrl(requestParameters.tinyUrlParam, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the reward points balance for the specified organization.
         * @summary Get reward points balance
         * @param {DefaultApiGetRewardPointBalanceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRewardPointBalance(requestParameters: DefaultApiGetRewardPointBalanceRequest, options?: AxiosRequestConfig): AxiosPromise<GetRewardPointBalance200Response> {
            return localVarFp.getRewardPointBalance(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get reward point transactions for the specified organization
         * @summary Get reward point transactions
         * @param {DefaultApiGetRewardPointTransactionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRewardPointTransactions(requestParameters: DefaultApiGetRewardPointTransactionsRequest, options?: AxiosRequestConfig): AxiosPromise<GetRewardPointTransactions200Response> {
            return localVarFp.getRewardPointTransactions(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Rewards
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRewards(options?: AxiosRequestConfig): AxiosPromise<Array<GetRewards200ResponseInner>> {
            return localVarFp.getRewards(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get role resource for user
         * @param {DefaultApiGetRoleResourceForUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoleResourceForUser(requestParameters: DefaultApiGetRoleResourceForUserRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetRoleResourceForUser200ResponseInner>> {
            return localVarFp.getRoleResourceForUser(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get roles
         * @param {DefaultApiGetRolesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoles(requestParameters: DefaultApiGetRolesRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetRoles200ResponseInner>> {
            return localVarFp.getRoles(requestParameters.category, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Roles with Top Related Resources
         * @param {DefaultApiGetRolesWithTopRelatedResourcesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRolesWithTopRelatedResources(requestParameters: DefaultApiGetRolesWithTopRelatedResourcesRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetRolesWithTopRelatedResources200ResponseInner>> {
            return localVarFp.getRolesWithTopRelatedResources(requestParameters.resourceScope, requestParameters.resourceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Roles with Top Related Resources by Organization id
         * @param {DefaultApiGetRolesWithTopRelatedResourcesByOrganizationIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRolesWithTopRelatedResourcesByOrganizationId(requestParameters: DefaultApiGetRolesWithTopRelatedResourcesByOrganizationIdRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetRolesWithTopRelatedResourcesByOrganizationId200ResponseInner>> {
            return localVarFp.getRolesWithTopRelatedResourcesByOrganizationId(requestParameters.organizationId, requestParameters.resourceScope, requestParameters.resourceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Slack card notification settings of an organization
         * @param {DefaultApiGetSlackCardNotificationSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSlackCardNotificationSettings(requestParameters: DefaultApiGetSlackCardNotificationSettingsRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetSlackCardNotificationSettings200ResponseInner>> {
            return localVarFp.getSlackCardNotificationSettings(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a Slack channels of an organization by SlackChannelID
         * @param {DefaultApiGetSlackChannelRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSlackChannel(requestParameters: DefaultApiGetSlackChannelRequest, options?: AxiosRequestConfig): AxiosPromise<GetSlackChannel200Response> {
            return localVarFp.getSlackChannel(requestParameters.organizationId, requestParameters.channelId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Slack channels of an organization
         * @param {DefaultApiGetSlackChannelsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSlackChannels(requestParameters: DefaultApiGetSlackChannelsRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetSlackChannels200ResponseInner>> {
            return localVarFp.getSlackChannels(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Slack channels with cursor of an organization
         * @param {DefaultApiGetSlackChannelsWithCursorRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSlackChannelsWithCursor(requestParameters: DefaultApiGetSlackChannelsWithCursorRequest, options?: AxiosRequestConfig): AxiosPromise<GetSlackChannelsWithCursor200Response> {
            return localVarFp.getSlackChannelsWithCursor(requestParameters.organizationId, requestParameters.cursor, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Slack evidence remind settings of an organization
         * @param {DefaultApiGetSlackEvidenceReminderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSlackEvidenceReminder(requestParameters: DefaultApiGetSlackEvidenceReminderRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetSlackEvidenceReminder200ResponseInner>> {
            return localVarFp.getSlackEvidenceReminder(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Slack evidence remind settings of an slack channel
         * @param {DefaultApiGetSlackEvidenceReminderPerChannelRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSlackEvidenceReminderPerChannel(requestParameters: DefaultApiGetSlackEvidenceReminderPerChannelRequest, options?: AxiosRequestConfig): AxiosPromise<GetSlackEvidenceReminderPerChannel200Response> {
            return localVarFp.getSlackEvidenceReminderPerChannel(requestParameters.organizationId, requestParameters.channelId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get slack notification channel setting for purchase-application
         * @param {DefaultApiGetSlackNotificationChannelSettingForPurchaseApplicationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSlackNotificationChannelSettingForPurchaseApplication(requestParameters: DefaultApiGetSlackNotificationChannelSettingForPurchaseApplicationRequest, options?: AxiosRequestConfig): AxiosPromise<GetSlackNotificationChannelSettingForPurchaseApplication200Response> {
            return localVarFp.getSlackNotificationChannelSettingForPurchaseApplication(requestParameters.organizationId, requestParameters.channelId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get slack notification settings for purchase-application
         * @param {DefaultApiGetSlackNotificationSettingsForPurchaseApplicationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSlackNotificationSettingsForPurchaseApplication(requestParameters: DefaultApiGetSlackNotificationSettingsForPurchaseApplicationRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetSlackNotificationSettingsForPurchaseApplication200ResponseInner>> {
            return localVarFp.getSlackNotificationSettingsForPurchaseApplication(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Slack team
         * @param {DefaultApiGetSlackTeamRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSlackTeam(requestParameters: DefaultApiGetSlackTeamRequest, options?: AxiosRequestConfig): AxiosPromise<GetSlackTeam200Response> {
            return localVarFp.getSlackTeam(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Slack version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSlackVersion(options?: AxiosRequestConfig): AxiosPromise<GetSlackVersion200Response> {
            return localVarFp.getSlackVersion(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get submitted trustdock data
         * @param {DefaultApiGetSubmittedTrustdockDataRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubmittedTrustdockData(requestParameters: DefaultApiGetSubmittedTrustdockDataRequest, options?: AxiosRequestConfig): AxiosPromise<GetSubmittedTrustdockData200Response> {
            return localVarFp.getSubmittedTrustdockData(requestParameters.trustdockIdentificationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get suspicious transaction detail list
         * @param {DefaultApiGetSuspiciousTransactionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSuspiciousTransactions(requestParameters: DefaultApiGetSuspiciousTransactionsRequest, options?: AxiosRequestConfig): AxiosPromise<GetSuspiciousTransactions200Response> {
            return localVarFp.getSuspiciousTransactions(requestParameters.userAccountId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Teams card notification settings of an organization
         * @param {DefaultApiGetTeamsCardNotificationSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamsCardNotificationSettings(requestParameters: DefaultApiGetTeamsCardNotificationSettingsRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetTeamsCardNotificationSettings200ResponseInner>> {
            return localVarFp.getTeamsCardNotificationSettings(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Teams channels of an organization by TeamsChannelID
         * @param {DefaultApiGetTeamsChannelRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamsChannel(requestParameters: DefaultApiGetTeamsChannelRequest, options?: AxiosRequestConfig): AxiosPromise<GetTeamsChannel200Response> {
            return localVarFp.getTeamsChannel(requestParameters.organizationId, requestParameters.channelId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Teams channels with cursor of an organization
         * @param {DefaultApiGetTeamsChannelsWithCursorRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamsChannelsWithCursor(requestParameters: DefaultApiGetTeamsChannelsWithCursorRequest, options?: AxiosRequestConfig): AxiosPromise<GetTeamsChannelsWithCursor200Response> {
            return localVarFp.getTeamsChannelsWithCursor(requestParameters.organizationId, requestParameters.cursor, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Teams team
         * @param {DefaultApiGetTeamsTeamRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamsTeam(requestParameters: DefaultApiGetTeamsTeamRequest, options?: AxiosRequestConfig): AxiosPromise<GetTeamsTeam200Response> {
            return localVarFp.getTeamsTeam(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Teams version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamsVersion(options?: AxiosRequestConfig): AxiosPromise<GetTeamsVersion200Response> {
            return localVarFp.getTeamsVersion(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Technical Support Users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTechnicalSupportUsers(options?: AxiosRequestConfig): AxiosPromise<Array<GetTechnicalSupportUsers200ResponseInner>> {
            return localVarFp.getTechnicalSupportUsers(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Tfa App QR Code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTfaAppQrCode(options?: AxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.getTfaAppQrCode(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTfaAppRecoveryCode(options?: AxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.getTfaAppRecoveryCode(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get TFA SMS Recovery Code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTfaSmsRecoveryCode(options?: AxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.getTfaSmsRecoveryCode(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the count of monthly transactions for the user account
         * @param {DefaultApiGetTheCountOfMonthlyTransactionsForTheUserAccountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTheCountOfMonthlyTransactionsForTheUserAccount(requestParameters: DefaultApiGetTheCountOfMonthlyTransactionsForTheUserAccountRequest, options?: AxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.getTheCountOfMonthlyTransactionsForTheUserAccount(requestParameters.userAccountId, requestParameters.yearMonth, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the user account information
         * @param {DefaultApiGetTheUserAccountInformationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTheUserAccountInformation(requestParameters: DefaultApiGetTheUserAccountInformationRequest, options?: AxiosRequestConfig): AxiosPromise<GetTheUserAccountInformation200Response> {
            return localVarFp.getTheUserAccountInformation(requestParameters.userAccountId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get transaction evidence email address
         * @param {DefaultApiGetTransactionEvidenceEmailAddressRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransactionEvidenceEmailAddress(requestParameters: DefaultApiGetTransactionEvidenceEmailAddressRequest, options?: AxiosRequestConfig): AxiosPromise<GetTransactionEvidenceEmailAddress200Response> {
            return localVarFp.getTransactionEvidenceEmailAddress(requestParameters.userAccountId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Transaction Evidence Email File
         * @param {DefaultApiGetTransactionEvidenceEmailFileRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransactionEvidenceEmailFile(requestParameters: DefaultApiGetTransactionEvidenceEmailFileRequest, options?: AxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.getTransactionEvidenceEmailFile(requestParameters.userAccountId, requestParameters.transactionEvidenceEmailFileId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get transaction evidence emails
         * @param {DefaultApiGetTransactionEvidenceEmailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransactionEvidenceEmails(requestParameters: DefaultApiGetTransactionEvidenceEmailsRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetTransactionEvidenceEmails200ResponseInner>> {
            return localVarFp.getTransactionEvidenceEmails(requestParameters.userAccountId, requestParameters.startYearMonth, requestParameters.endYearMonth, requestParameters.isTrash, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Trustdock Identity Verifications
         * @param {DefaultApiGetTrustdockIdentityVerificationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrustdockIdentityVerifications(requestParameters: DefaultApiGetTrustdockIdentityVerificationsRequest, options?: AxiosRequestConfig): AxiosPromise<GetTrustdockIdentityVerifications200Response> {
            return localVarFp.getTrustdockIdentityVerifications(requestParameters.trustdockIdentificationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Trustdock Submit Identification Document Publish URL
         * @param {DefaultApiGetTrustdockSubmitIdentificationDocumentPublishUrlRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrustdockSubmitIdentificationDocumentPublishUrl(requestParameters: DefaultApiGetTrustdockSubmitIdentificationDocumentPublishUrlRequest, options?: AxiosRequestConfig): AxiosPromise<GetTrustdockSubmitIdentificationDocumentPublishUrl200Response> {
            return localVarFp.getTrustdockSubmitIdentificationDocumentPublishUrl(requestParameters.trustdockIdentificationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Trustdock Verifications
         * @param {DefaultApiGetTrustdockVerificationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrustdockVerifications(requestParameters: DefaultApiGetTrustdockVerificationsRequest, options?: AxiosRequestConfig): AxiosPromise<GetTrustdockVerifications200Response> {
            return localVarFp.getTrustdockVerifications(requestParameters.trustdockIdentificationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get unread message count for a user
         * @param {DefaultApiGetUnreadMessageCountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnreadMessageCount(requestParameters: DefaultApiGetUnreadMessageCountRequest, options?: AxiosRequestConfig): AxiosPromise<GetUnreadMessageCount200Response> {
            return localVarFp.getUnreadMessageCount(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get an usage fee
         * @param {DefaultApiGetUsageFeeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsageFee(requestParameters: DefaultApiGetUsageFeeRequest, options?: AxiosRequestConfig): AxiosPromise<GetUsageFee200Response> {
            return localVarFp.getUsageFee(requestParameters.usageFeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get user account groups
         * @param {DefaultApiGetUserAccountGroupsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserAccountGroups(requestParameters: DefaultApiGetUserAccountGroupsRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetUserAccountGroups200ResponseInner>> {
            return localVarFp.getUserAccountGroups(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get user account year month summary
         * @param {DefaultApiGetUserAccountYearMonthSummaryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserAccountYearMonthSummary(requestParameters: DefaultApiGetUserAccountYearMonthSummaryRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetUserAccountYearMonthSummary200ResponseInner>> {
            return localVarFp.getUserAccountYearMonthSummary(requestParameters.organizationId, requestParameters.toYearMonth, requestParameters.fromYearMonth, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get user accounts with default comment template
         * @param {DefaultApiGetUserAccountsWithDefaultCommentTemplateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserAccountsWithDefaultCommentTemplate(requestParameters: DefaultApiGetUserAccountsWithDefaultCommentTemplateRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetUserAccountsWithDefaultCommentTemplate200ResponseInner>> {
            return localVarFp.getUserAccountsWithDefaultCommentTemplate(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get user cards
         * @param {DefaultApiGetUserCardsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserCards(requestParameters: DefaultApiGetUserCardsRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetUserCards200ResponseInner>> {
            return localVarFp.getUserCards(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get user cards extended
         * @param {DefaultApiGetUserCardsExtendedRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserCardsExtended(requestParameters: DefaultApiGetUserCardsExtendedRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetUserCardsExtended200ResponseInner>> {
            return localVarFp.getUserCardsExtended(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get user cards extended for role resources
         * @param {DefaultApiGetUserCardsExtendedForRoleResourcesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserCardsExtendedForRoleResources(requestParameters: DefaultApiGetUserCardsExtendedForRoleResourcesRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetUserCardsExtendedForRoleResources200ResponseInner>> {
            return localVarFp.getUserCardsExtendedForRoleResources(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get user cards light
         * @param {DefaultApiGetUserCardsLightRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserCardsLight(requestParameters: DefaultApiGetUserCardsLightRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetUserCardsLight200ResponseInner>> {
            return localVarFp.getUserCardsLight(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get user cards light for role resources
         * @param {DefaultApiGetUserCardsLightForRoleResourcesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserCardsLightForRoleResources(requestParameters: DefaultApiGetUserCardsLightForRoleResourcesRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetUserCardsLightForRoleResources200ResponseInner>> {
            return localVarFp.getUserCardsLightForRoleResources(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get message detail
         * @param {DefaultApiGetUserMessageDetailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserMessageDetail(requestParameters: DefaultApiGetUserMessageDetailRequest, options?: AxiosRequestConfig): AxiosPromise<GetUserMessageDetail200Response> {
            return localVarFp.getUserMessageDetail(requestParameters.userMessageId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get messages for a user
         * @param {DefaultApiGetUserMessagesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserMessages(requestParameters: DefaultApiGetUserMessagesRequest, options?: AxiosRequestConfig): AxiosPromise<GetUserMessages200Response> {
            return localVarFp.getUserMessages(requestParameters.userId, requestParameters.offset, requestParameters.limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get users
         * @param {DefaultApiGetUsersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsers(requestParameters: DefaultApiGetUsersRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetUsers200ResponseInner>> {
            return localVarFp.getUsers(requestParameters.organizationId, requestParameters.email, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get information on login user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersMe(options?: AxiosRequestConfig): AxiosPromise<GetUsersMe200Response> {
            return localVarFp.getUsersMe(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get venture capitals
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVentureCapitals(options?: AxiosRequestConfig): AxiosPromise<Array<GetVentureCapitals200ResponseInner>> {
            return localVarFp.getVentureCapitals(options).then((request) => request(axios, basePath));
        },
        /**
         * 指定された組織の取引時確認詳細情報を取得します。 createdAtの降順で返却されます。 
         * @summary 取引時確認詳細取得（ZEUS)(PRESIDENT)
         * @param {DefaultApiGetZeusOrganizationIdentityVerificationsForPresidentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getZeusOrganizationIdentityVerificationsForPresident(requestParameters: DefaultApiGetZeusOrganizationIdentityVerificationsForPresidentRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetZeusOrganizationIdentityVerificationsForPresident200ResponseInner>> {
            return localVarFp.getZeusOrganizationIdentityVerificationsForPresident(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get organizations for zeus
         * @param {DefaultApiGetZeusOrganizationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getZeusOrganizations(requestParameters: DefaultApiGetZeusOrganizationsRequest = {}, options?: AxiosRequestConfig): AxiosPromise<GetZeusOrganizations200Response> {
            return localVarFp.getZeusOrganizations(requestParameters.key, requestParameters.limit, requestParameters.offset, requestParameters.sort, requestParameters.connectedMoneytree, requestParameters.brandType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Initialize Modifiable Limit For The User Accounts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initializeModifiableLimitForTheUserAccounts(options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.initializeModifiableLimitForTheUserAccounts(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Linking purchase to transaction.
         * @param {DefaultApiLinkingPurchaseToTransactionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        linkingPurchaseToTransaction(requestParameters: DefaultApiLinkingPurchaseToTransactionRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.linkingPurchaseToTransaction(requestParameters.organizationId, requestParameters.purchaseApplicationId, requestParameters.visaTransactionReferenceId, requestParameters.userAccountId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Lock a card due to potential fraud
         * @param {DefaultApiLockCardForPotentialFraudRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lockCardForPotentialFraud(requestParameters: DefaultApiLockCardForPotentialFraudRequest, options?: AxiosRequestConfig): AxiosPromise<LockCardForPotentialFraud200Response> {
            return localVarFp.lockCardForPotentialFraud(requestParameters.organizationId, requestParameters.cardId, requestParameters.lockCardForPotentialFraudRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Lock a card due to fraud detected
         * @param {DefaultApiLockCardOnFraudDetectedRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lockCardOnFraudDetected(requestParameters: DefaultApiLockCardOnFraudDetectedRequest, options?: AxiosRequestConfig): AxiosPromise<LockCardOnFraudDetected200Response> {
            return localVarFp.lockCardOnFraudDetected(requestParameters.organizationId, requestParameters.cardId, requestParameters.lockCardOnFraudDetectedRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Login
         * @param {DefaultApiLoginRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login(requestParameters: DefaultApiLoginRequest, options?: AxiosRequestConfig): AxiosPromise<Login200Response> {
            return localVarFp.login(requestParameters.loginRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Login with APP two factor auth
         * @param {DefaultApiLoginAppRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginApp(requestParameters: DefaultApiLoginAppRequest, options?: AxiosRequestConfig): AxiosPromise<LoginApp200Response> {
            return localVarFp.loginApp(requestParameters.loginAppRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Login with recovery code of two factor auth
         * @param {DefaultApiLoginRecoveryCodeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginRecoveryCode(requestParameters: DefaultApiLoginRecoveryCodeRequest, options?: AxiosRequestConfig): AxiosPromise<LoginRecoveryCode200Response> {
            return localVarFp.loginRecoveryCode(requestParameters.loginRecoveryCodeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Login with SMS two factor auth
         * @param {DefaultApiLoginSmsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginSms(requestParameters: DefaultApiLoginSmsRequest, options?: AxiosRequestConfig): AxiosPromise<LoginSms200Response> {
            return localVarFp.loginSms(requestParameters.loginSmsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Logout
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout(options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.logout(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Move slack notification channel setting for card
         * @param {DefaultApiMoveSlackNotificationSettingForCardRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveSlackNotificationSettingForCard(requestParameters: DefaultApiMoveSlackNotificationSettingForCardRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.moveSlackNotificationSettingForCard(requestParameters.organizationId, requestParameters.currentChannelId, requestParameters.moveSlackNotificationSettingForCardRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Move teams notification channel setting for card
         * @param {DefaultApiMoveTeamsNotificationSettingForCardRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveTeamsNotificationSettingForCard(requestParameters: DefaultApiMoveTeamsNotificationSettingForCardRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.moveTeamsNotificationSettingForCard(requestParameters.organizationId, requestParameters.currentChannelId, requestParameters.moveTeamsNotificationSettingForCardRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Organization Create Pre Request
         * @param {DefaultApiOrganizationCreatePreRequestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationCreatePreRequest(requestParameters: DefaultApiOrganizationCreatePreRequestRequest, options?: AxiosRequestConfig): AxiosPromise<OrganizationCreatePreRequest200Response> {
            return localVarFp.organizationCreatePreRequest(requestParameters.organizationCreatePreRequestRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Parse organization chart for workflow
         * @param {DefaultApiParseOrganizationChartForWorkflowRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        parseOrganizationChartForWorkflow(requestParameters: DefaultApiParseOrganizationChartForWorkflowRequest, options?: AxiosRequestConfig): AxiosPromise<ParseOrganizationChartForWorkflow200Response> {
            return localVarFp.parseOrganizationChartForWorkflow(requestParameters.file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Post Addition Merchant General Block List
         * @param {DefaultApiPostAdditionMerchantGeneralBlockListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAdditionMerchantGeneralBlockList(requestParameters: DefaultApiPostAdditionMerchantGeneralBlockListRequest, options?: AxiosRequestConfig): AxiosPromise<PostAdditionMerchantGeneralBlockList200Response> {
            return localVarFp.postAdditionMerchantGeneralBlockList(requestParameters.postAdditionMerchantGeneralBlockListRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiPostAlliancesGcpApplicationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAlliancesGcpApplications(requestParameters: DefaultApiPostAlliancesGcpApplicationsRequest, options?: AxiosRequestConfig): AxiosPromise<PostAlliancesGcpApplications200Response> {
            return localVarFp.postAlliancesGcpApplications(requestParameters.organizationId, requestParameters.postAlliancesGcpApplicationsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiPostAlliancesGwsApplicationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAlliancesGwsApplications(requestParameters: DefaultApiPostAlliancesGwsApplicationsRequest, options?: AxiosRequestConfig): AxiosPromise<PostAlliancesGwsApplications200Response> {
            return localVarFp.postAlliancesGwsApplications(requestParameters.organizationId, requestParameters.postAlliancesGwsApplicationsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Search Bank Account Balances
         * @param {DefaultApiPostBalancesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postBalances(requestParameters: DefaultApiPostBalancesRequest, options?: AxiosRequestConfig): AxiosPromise<Array<PostBalances200ResponseInner>> {
            return localVarFp.postBalances(requestParameters.postBalancesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Post Bulk Addition Merchant Org Block Lists
         * @param {DefaultApiPostBulkAdditionMerchantOrgBlockListsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postBulkAdditionMerchantOrgBlockLists(requestParameters: DefaultApiPostBulkAdditionMerchantOrgBlockListsRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postBulkAdditionMerchantOrgBlockLists(requestParameters.organizationId, requestParameters.postBulkAdditionMerchantOrgBlockListsRequestInner, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Post a cancel request for a evidence request
         * @param {DefaultApiPostCancelRequestForEvidenceRequestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCancelRequestForEvidenceRequest(requestParameters: DefaultApiPostCancelRequestForEvidenceRequestRequest, options?: AxiosRequestConfig): AxiosPromise<PostCancelRequestForEvidenceRequest200Response> {
            return localVarFp.postCancelRequestForEvidenceRequest(requestParameters.organizationId, requestParameters.paymentReferenceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiPostCardsVirtualIssueRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCardsVirtualIssue(requestParameters: DefaultApiPostCardsVirtualIssueRequest, options?: AxiosRequestConfig): AxiosPromise<PostCardsVirtualIssue200Response> {
            return localVarFp.postCardsVirtualIssue(requestParameters.postCardsVirtualIssueRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCardsVirtualOndemandIssue(options?: AxiosRequestConfig): AxiosPromise<PostCardsVirtualOndemandIssue200Response> {
            return localVarFp.postCardsVirtualOndemandIssue(options).then((request) => request(axios, basePath));
        },
        /**
         * Upload identity document file with verification information.
         * @summary Upload Identity Document
         * @param {DefaultApiPostFaceToFaceKycIdentityDocumentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postFaceToFaceKycIdentityDocument(requestParameters: DefaultApiPostFaceToFaceKycIdentityDocumentRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postFaceToFaceKycIdentityDocument(requestParameters.onboardingRequestId, requestParameters.file, requestParameters.personalDocumentType, requestParameters.verifiedBy, options).then((request) => request(axios, basePath));
        },
        /**
         * Submit a face-to-face KYC request.
         * @summary Face-to-face KYC Request
         * @param {DefaultApiPostFaceToFaceKycRequestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postFaceToFaceKycRequest(requestParameters: DefaultApiPostFaceToFaceKycRequestRequest, options?: AxiosRequestConfig): AxiosPromise<PostFaceToFaceKycRequest200Response> {
            return localVarFp.postFaceToFaceKycRequest(requestParameters.postFaceToFaceKycRequestRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Post Freee Account for Points
         * @param {DefaultApiPostFreeeAccountForPointsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postFreeeAccountForPoints(requestParameters: DefaultApiPostFreeeAccountForPointsRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postFreeeAccountForPoints(requestParameters.organizationId, requestParameters.postFreeeAccountForPointsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiPostKycconsultingWebhooksRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postKycconsultingWebhooks(requestParameters: DefaultApiPostKycconsultingWebhooksRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postKycconsultingWebhooks(requestParameters.requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Post Moneytree Refresh Request
         * @param {DefaultApiPostMoneytreeRefreshRequestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postMoneytreeRefreshRequest(requestParameters: DefaultApiPostMoneytreeRefreshRequestRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postMoneytreeRefreshRequest(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Post Moneytree Refresh Request for All Organizations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postMoneytreeRefreshRequestAll(options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postMoneytreeRefreshRequestAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create organizations deals
         * @param {DefaultApiPostOrganizationsDealsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postOrganizationsDeals(requestParameters: DefaultApiPostOrganizationsDealsRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postOrganizationsDeals(requestParameters.organizationId, requestParameters.postOrganizationsDealsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Post payment requests bank account
         * @param {DefaultApiPostPaymentRequestsBankAccountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postPaymentRequestsBankAccount(requestParameters: DefaultApiPostPaymentRequestsBankAccountRequest, options?: AxiosRequestConfig): AxiosPromise<PostPaymentRequestsBankAccount200Response> {
            return localVarFp.postPaymentRequestsBankAccount(requestParameters.organizationId, requestParameters.postPaymentRequestsBankAccountRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Post slack message to coworker
         * @param {DefaultApiPostSlackMessageToCoworkerRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postSlackMessageToCoworker(requestParameters: DefaultApiPostSlackMessageToCoworkerRequest, options?: AxiosRequestConfig): AxiosPromise<PostSlackMessageToCoworker200Response> {
            return localVarFp.postSlackMessageToCoworker(requestParameters.organizationId, requestParameters.postSlackMessageToCoworkerRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Search Bank Account Transactions
         * @param {DefaultApiPostTransactionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postTransactions(requestParameters: DefaultApiPostTransactionsRequest, options?: AxiosRequestConfig): AxiosPromise<Array<PostTransactions200ResponseInner>> {
            return localVarFp.postTransactions(requestParameters.postTransactionsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiPostTrustdockWebhooksRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postTrustdockWebhooks(requestParameters: DefaultApiPostTrustdockWebhooksRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postTrustdockWebhooks(requestParameters.postTrustdockWebhooksRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiPostTrustdockWebhooksSnailMailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postTrustdockWebhooksSnailMail(requestParameters: DefaultApiPostTrustdockWebhooksSnailMailRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postTrustdockWebhooksSnailMail(requestParameters.postTrustdockWebhooksSnailMailRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Put disable feature flag
         * @param {DefaultApiPutDisableFeatureFlagRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putDisableFeatureFlag(requestParameters: DefaultApiPutDisableFeatureFlagRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.putDisableFeatureFlag(requestParameters.organizationId, requestParameters.featureName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Put enabled feature flag
         * @param {DefaultApiPutEnabledFeatureFlagRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putEnabledFeatureFlag(requestParameters: DefaultApiPutEnabledFeatureFlagRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.putEnabledFeatureFlag(requestParameters.organizationId, requestParameters.featureName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Put Freee End Journal Entry Transition Mode
         * @param {DefaultApiPutFreeeEndJournalEntryTransitionModeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putFreeeEndJournalEntryTransitionMode(requestParameters: DefaultApiPutFreeeEndJournalEntryTransitionModeRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.putFreeeEndJournalEntryTransitionMode(requestParameters.organizationId, requestParameters.putFreeeEndJournalEntryTransitionModeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Put Organization Payment Method
         * @param {DefaultApiPutOrganizationPaymentMethodRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putOrganizationPaymentMethod(requestParameters: DefaultApiPutOrganizationPaymentMethodRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.putOrganizationPaymentMethod(requestParameters.organizationId, requestParameters.putOrganizationPaymentMethodRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Put organizations deals
         * @param {DefaultApiPutOrganizationsDealsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putOrganizationsDeals(requestParameters: DefaultApiPutOrganizationsDealsRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.putOrganizationsDeals(requestParameters.organizationId, requestParameters.putOrganizationsDealsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update payment request
         * @param {DefaultApiPutPaymentRequestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putPaymentRequest(requestParameters: DefaultApiPutPaymentRequestRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.putPaymentRequest(requestParameters.organizationId, requestParameters.paymentRequestId, requestParameters.putPaymentRequestRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Put payment requests bank account
         * @param {DefaultApiPutPaymentRequestsBankAccountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putPaymentRequestsBankAccount(requestParameters: DefaultApiPutPaymentRequestsBankAccountRequest, options?: AxiosRequestConfig): AxiosPromise<PutPaymentRequestsBankAccount200Response> {
            return localVarFp.putPaymentRequestsBankAccount(requestParameters.organizationId, requestParameters.bankAccountId, requestParameters.putPaymentRequestsBankAccountRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Put transaction evidence emails link to transaction
         * @param {DefaultApiPutTransactionEvidenceEmailsLinkToTransactionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putTransactionEvidenceEmailsLinkToTransaction(requestParameters: DefaultApiPutTransactionEvidenceEmailsLinkToTransactionRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.putTransactionEvidenceEmailsLinkToTransaction(requestParameters.putTransactionEvidenceEmailsLinkToTransactionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Put transaction evidence emails mark as read
         * @param {DefaultApiPutTransactionEvidenceEmailsMarkAsReadRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putTransactionEvidenceEmailsMarkAsRead(requestParameters: DefaultApiPutTransactionEvidenceEmailsMarkAsReadRequest, options?: AxiosRequestConfig): AxiosPromise<PutTransactionEvidenceEmailsMarkAsRead200Response> {
            return localVarFp.putTransactionEvidenceEmailsMarkAsRead(requestParameters.putTransactionEvidenceEmailsMarkAsReadRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Put transaction evidence emails move to trash
         * @param {DefaultApiPutTransactionEvidenceEmailsMoveToTrashRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putTransactionEvidenceEmailsMoveToTrash(requestParameters: DefaultApiPutTransactionEvidenceEmailsMoveToTrashRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.putTransactionEvidenceEmailsMoveToTrash(requestParameters.putTransactionEvidenceEmailsMoveToTrashRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Give reward point to organization
         * @param {DefaultApiPutZeusGiveRewardPointsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putZeusGiveRewardPoints(requestParameters: DefaultApiPutZeusGiveRewardPointsRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.putZeusGiveRewardPoints(requestParameters.organizationId, requestParameters.putZeusGiveRewardPointsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Query by ids payment requests
         * @param {DefaultApiQueryByIdsPaymentRequestsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryByIdsPaymentRequests(requestParameters: DefaultApiQueryByIdsPaymentRequestsRequest, options?: AxiosRequestConfig): AxiosPromise<Array<QueryByIdsPaymentRequests200ResponseInner>> {
            return localVarFp.queryByIdsPaymentRequests(requestParameters.organizationId, requestParameters.queryByIdsPaymentRequestsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update read status of a message
         * @param {DefaultApiReadUserMessageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readUserMessage(requestParameters: DefaultApiReadUserMessageRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.readUserMessage(requestParameters.userMessageId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary register note
         * @param {DefaultApiRegisterNoteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerNote(requestParameters: DefaultApiRegisterNoteRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.registerNote(requestParameters.onboardingRequestId, requestParameters.registerNoteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Register note for organization identity verification
         * @param {DefaultApiRegisterNoteForOrganizationIdentityVerificationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerNoteForOrganizationIdentityVerification(requestParameters: DefaultApiRegisterNoteForOrganizationIdentityVerificationRequest, options?: AxiosRequestConfig): AxiosPromise<RegisterNoteForOrganizationIdentityVerification200Response> {
            return localVarFp.registerNoteForOrganizationIdentityVerification(requestParameters.organizationIdentityVerificationId, requestParameters.registerNoteForOrganizationIdentityVerificationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Register an organization using the onboarding request ID
         * @param {DefaultApiRegisterOrganizationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerOrganization(requestParameters: DefaultApiRegisterOrganizationRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.registerOrganization(requestParameters.onboardingRequestId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Register organization chart for workflow
         * @param {DefaultApiRegisterOrganizationChartForWorkflowRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerOrganizationChartForWorkflow(requestParameters: DefaultApiRegisterOrganizationChartForWorkflowRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.registerOrganizationChartForWorkflow(requestParameters.organizationId, requestParameters.registerOrganizationChartForWorkflowRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Register Tfa App Verification Code
         * @param {DefaultApiRegisterTfaAppVerificationCodeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerTfaAppVerificationCode(requestParameters: DefaultApiRegisterTfaAppVerificationCodeRequest, options?: AxiosRequestConfig): AxiosPromise<RegisterTfaAppVerificationCode200Response> {
            return localVarFp.registerTfaAppVerificationCode(requestParameters.registerTfaAppVerificationCodeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Register Tfa SMS Auth
         * @param {DefaultApiRegisterTfaSmsAuthRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerTfaSmsAuth(requestParameters: DefaultApiRegisterTfaSmsAuthRequest, options?: AxiosRequestConfig): AxiosPromise<RegisterTfaSmsAuth200Response> {
            return localVarFp.registerTfaSmsAuth(requestParameters.registerTfaSmsAuthRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Register transaction evidence email address
         * @param {DefaultApiRegisterTransactionEvidenceEmailAddressRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerTransactionEvidenceEmailAddress(requestParameters: DefaultApiRegisterTransactionEvidenceEmailAddressRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.registerTransactionEvidenceEmailAddress(requestParameters.userAccountId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reject Organization Identity Verification
         * @param {DefaultApiRejectOrganizationIdentityVerificationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectOrganizationIdentityVerification(requestParameters: DefaultApiRejectOrganizationIdentityVerificationRequest, options?: AxiosRequestConfig): AxiosPromise<RejectOrganizationIdentityVerification200Response> {
            return localVarFp.rejectOrganizationIdentityVerification(requestParameters.organizationIdentityVerificationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reject purchase application.
         * @param {DefaultApiRejectPurchaseApplicationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectPurchaseApplication(requestParameters: DefaultApiRejectPurchaseApplicationRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.rejectPurchaseApplication(requestParameters.organizationId, requestParameters.purchaseApplicationId, requestParameters.rejectPurchaseApplicationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remindCardTransactionEvidence(options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.remindCardTransactionEvidence(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remind monthly payment notifications.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remindMonthlyPaymentNotifications(options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.remindMonthlyPaymentNotifications(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remind organization monthly payment notifications.
         * @param {DefaultApiRemindOrganizationMonthlyPaymentNotificationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remindOrganizationMonthlyPaymentNotification(requestParameters: DefaultApiRemindOrganizationMonthlyPaymentNotificationRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.remindOrganizationMonthlyPaymentNotification(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Rename user account group
         * @param {DefaultApiRenameUserAccountGroupRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        renameUserAccountGroup(requestParameters: DefaultApiRenameUserAccountGroupRequest, options?: AxiosRequestConfig): AxiosPromise<Array<RenameUserAccountGroup200ResponseInner>> {
            return localVarFp.renameUserAccountGroup(requestParameters.userAccountGroupId, requestParameters.renameUserAccountGroupRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Replace Virtual Card
         * @param {DefaultApiReplaceVirtualCardRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceVirtualCard(requestParameters: DefaultApiReplaceVirtualCardRequest, options?: AxiosRequestConfig): AxiosPromise<ReplaceVirtualCard200Response> {
            return localVarFp.replaceVirtualCard(requestParameters.userAccountId, requestParameters.replaceVirtualCardRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary request add system admin role
         * @param {DefaultApiRequestAddSystemAdminRoleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestAddSystemAdminRole(requestParameters: DefaultApiRequestAddSystemAdminRoleRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.requestAddSystemAdminRole(requestParameters.userId, requestParameters.requestAddSystemAdminRoleRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Request sending physical cards
         * @param {DefaultApiRequestSendingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestSending(requestParameters: DefaultApiRequestSendingRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.requestSending(requestParameters.organizationId, requestParameters.requestSendingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Request sending a metal card
         * @param {DefaultApiRequestSendingMetalCardRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestSendingMetalCard(requestParameters: DefaultApiRequestSendingMetalCardRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.requestSendingMetalCard(requestParameters.organizationId, requestParameters.requestSendingMetalCardRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestSyncingClearedTransaction(options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.requestSyncingClearedTransaction(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Request to Generate Organizations Accounting Csv in Background
         * @param {DefaultApiRequestToOrganizationsAccountingCsvInBackgroundRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestToOrganizationsAccountingCsvInBackground(requestParameters: DefaultApiRequestToOrganizationsAccountingCsvInBackgroundRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.requestToOrganizationsAccountingCsvInBackground(requestParameters.organizationId, requestParameters.yearMonth, requestParameters.isMergedFiles, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary request update system admin role
         * @param {DefaultApiRequestUpdateSystemAdminRoleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestUpdateSystemAdminRole(requestParameters: DefaultApiRequestUpdateSystemAdminRoleRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.requestUpdateSystemAdminRole(requestParameters.userId, requestParameters.requestUpdateSystemAdminRoleRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Resend Snail Mail For Organization Identity Verification
         * @param {DefaultApiResendSnailMailForOrganizationIdentityVerificationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendSnailMailForOrganizationIdentityVerification(requestParameters: DefaultApiResendSnailMailForOrganizationIdentityVerificationRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.resendSnailMailForOrganizationIdentityVerification(requestParameters.organizationIdentityVerificationId, requestParameters.resendSnailMailForOrganizationIdentityVerificationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Resend an invitation to a new user
         * @param {DefaultApiResendUserInviteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendUserInvite(requestParameters: DefaultApiResendUserInviteRequest, options?: AxiosRequestConfig): AxiosPromise<ResendUserInvite200Response> {
            return localVarFp.resendUserInvite(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Resume a suspended card
         * @param {DefaultApiResumeCardRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resumeCard(requestParameters: DefaultApiResumeCardRequest, options?: AxiosRequestConfig): AxiosPromise<ResumeCard200Response> {
            return localVarFp.resumeCard(requestParameters.organizationId, requestParameters.cardId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Resynchronize card transactions for freee
         * @param {DefaultApiResynchronizeCardTransactionsForFreeeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resynchronizeCardTransactionsForFreee(requestParameters: DefaultApiResynchronizeCardTransactionsForFreeeRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.resynchronizeCardTransactionsForFreee(requestParameters.organizationId, requestParameters.resynchronizeCardTransactionsForFreeeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Save deal as draft
         * @param {DefaultApiSaveDealAsDraftRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveDealAsDraft(requestParameters: DefaultApiSaveDealAsDraftRequest, options?: AxiosRequestConfig): AxiosPromise<SaveDealAsDraft200Response> {
            return localVarFp.saveDealAsDraft(requestParameters.organizationId, requestParameters.dealId, requestParameters.saveDealAsDraftRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Save Deal As Ignore
         * @param {DefaultApiSaveDealAsIgnoreRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveDealAsIgnore(requestParameters: DefaultApiSaveDealAsIgnoreRequest, options?: AxiosRequestConfig): AxiosPromise<SaveDealAsIgnore200Response> {
            return localVarFp.saveDealAsIgnore(requestParameters.organizationId, requestParameters.dealId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Save deal as return to editing
         * @param {DefaultApiSaveDealAsReturnToEditingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveDealAsReturnToEditing(requestParameters: DefaultApiSaveDealAsReturnToEditingRequest, options?: AxiosRequestConfig): AxiosPromise<SaveDealAsReturnToEditing200Response> {
            return localVarFp.saveDealAsReturnToEditing(requestParameters.organizationId, requestParameters.dealId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Save deal with journalizing
         * @param {DefaultApiSaveDealWithJournalizingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveDealWithJournalizing(requestParameters: DefaultApiSaveDealWithJournalizingRequest, options?: AxiosRequestConfig): AxiosPromise<SaveDealWithJournalizing200Response> {
            return localVarFp.saveDealWithJournalizing(requestParameters.organizationId, requestParameters.dealId, requestParameters.saveDealWithJournalizingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Save deals as ignore
         * @param {DefaultApiSaveDealsAsIgnoreRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveDealsAsIgnore(requestParameters: DefaultApiSaveDealsAsIgnoreRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.saveDealsAsIgnore(requestParameters.organizationId, requestParameters.saveDealsAsIgnoreRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Save deals as journalized
         * @param {DefaultApiSaveDealsAsJournalizedRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveDealsAsJournalized(requestParameters: DefaultApiSaveDealsAsJournalizedRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.saveDealsAsJournalized(requestParameters.organizationId, requestParameters.saveDealsAsJournalizedRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Save deals as return to editing
         * @param {DefaultApiSaveDealsAsReturnToEditingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveDealsAsReturnToEditing(requestParameters: DefaultApiSaveDealsAsReturnToEditingRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.saveDealsAsReturnToEditing(requestParameters.organizationId, requestParameters.saveDealsAsReturnToEditingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Search bank transfers
         * @param {DefaultApiSearchBankTransfersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchBankTransfers(requestParameters: DefaultApiSearchBankTransfersRequest, options?: AxiosRequestConfig): AxiosPromise<Array<SearchBankTransfers200ResponseInner>> {
            return localVarFp.searchBankTransfers(requestParameters.organizationId, requestParameters.transferDateJstFrom, requestParameters.transferDateJstTo, requestParameters.sourceBankAccountId, requestParameters.downloaded, requestParameters.limit, requestParameters.offset, requestParameters.cursor, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Search Corporations In National Tax Agency
         * @param {DefaultApiSearchCorporationsInNationalTaxAgencyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchCorporationsInNationalTaxAgency(requestParameters: DefaultApiSearchCorporationsInNationalTaxAgencyRequest = {}, options?: AxiosRequestConfig): AxiosPromise<Array<SearchCorporationsInNationalTaxAgency200ResponseInner>> {
            return localVarFp.searchCorporationsInNationalTaxAgency(requestParameters.name, requestParameters.searchMethod, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Search deals
         * @param {DefaultApiSearchDealsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchDeals(requestParameters: DefaultApiSearchDealsRequest, options?: AxiosRequestConfig): AxiosPromise<Array<SearchDeals200ResponseInner>> {
            return localVarFp.searchDeals(requestParameters.organizationId, requestParameters.searchDealsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Search evidences
         * @param {DefaultApiSearchEvidencesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchEvidences(requestParameters: DefaultApiSearchEvidencesRequest, options?: AxiosRequestConfig): AxiosPromise<Array<SearchEvidences200ResponseInner>> {
            return localVarFp.searchEvidences(requestParameters.organizationId, requestParameters.issuer, requestParameters.amountMin, requestParameters.amountMax, requestParameters.paidAtFrom, requestParameters.paidAtTo, requestParameters.irrelevantToLedger, requestParameters.keyword, requestParameters.includesDeleted, requestParameters.legalValidities, requestParameters.limit, requestParameters.offset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Search my payment requests
         * @param {DefaultApiSearchMyPaymentRequestsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchMyPaymentRequests(requestParameters: DefaultApiSearchMyPaymentRequestsRequest, options?: AxiosRequestConfig): AxiosPromise<Array<SearchMyPaymentRequests200ResponseInner>> {
            return localVarFp.searchMyPaymentRequests(requestParameters.organizationId, requestParameters.dueDateJstFrom, requestParameters.dueDateJstTo, requestParameters.requestedDateJstFrom, requestParameters.requestedDateJstTo, requestParameters.statuses, requestParameters.supplierId, requestParameters.transferDataCreated, requestParameters.withholdingApplied, requestParameters.transferFeeResponsibility, requestParameters.freeWord, requestParameters.limit, requestParameters.offset, requestParameters.cursor, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Search Organizations
         * @param {DefaultApiSearchOrganizationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchOrganizations(requestParameters: DefaultApiSearchOrganizationsRequest, options?: AxiosRequestConfig): AxiosPromise<Array<SearchOrganizations200ResponseInner>> {
            return localVarFp.searchOrganizations(requestParameters.key, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Search payment requests
         * @param {DefaultApiSearchPaymentRequestsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchPaymentRequests(requestParameters: DefaultApiSearchPaymentRequestsRequest, options?: AxiosRequestConfig): AxiosPromise<Array<SearchPaymentRequests200ResponseInner>> {
            return localVarFp.searchPaymentRequests(requestParameters.organizationId, requestParameters.dueDateJstFrom, requestParameters.dueDateJstTo, requestParameters.requestedDateJstFrom, requestParameters.requestedDateJstTo, requestParameters.statuses, requestParameters.supplierId, requestParameters.transferDataCreated, requestParameters.withholdingApplied, requestParameters.transferFeeResponsibility, requestParameters.requestorId, requestParameters.freeWord, requestParameters.limit, requestParameters.offset, requestParameters.cursor, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary send back onboarding request
         * @param {DefaultApiSendBackOnboardingRequestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendBackOnboardingRequest(requestParameters: DefaultApiSendBackOnboardingRequestRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.sendBackOnboardingRequest(requestParameters.onboardingRequestId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary send changed credit notifications
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendChangedCreditNotifications(options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.sendChangedCreditNotifications(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Send Organization Identity Verification
         * @param {DefaultApiSendOrganizationIdentityVerificationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendOrganizationIdentityVerification(requestParameters: DefaultApiSendOrganizationIdentityVerificationRequest, options?: AxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.sendOrganizationIdentityVerification(requestParameters.organizationId, requestParameters.sendOrganizationIdentityVerificationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Send Transaction Authorization Request
         * @param {DefaultApiSendTransactionAuthorizationRequestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendTransactionAuthorizationRequest(requestParameters: DefaultApiSendTransactionAuthorizationRequestRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.sendTransactionAuthorizationRequest(requestParameters.organizationId, requestParameters.sendTransactionAuthorizationRequestRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sign Up For Slack
         * @param {DefaultApiSignUpForSlackRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signUpForSlack(requestParameters: DefaultApiSignUpForSlackRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.signUpForSlack(requestParameters.signUpForSlackRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Submit completed workflow of draft payment request
         * @param {DefaultApiSubmitCompletedWorkflowOfDraftPaymentRequestsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitCompletedWorkflowOfDraftPaymentRequests(requestParameters: DefaultApiSubmitCompletedWorkflowOfDraftPaymentRequestsRequest, options?: AxiosRequestConfig): AxiosPromise<SubmitCompletedWorkflowOfDraftPaymentRequests200Response> {
            return localVarFp.submitCompletedWorkflowOfDraftPaymentRequests(requestParameters.organizationId, requestParameters.draftPaymentRequestId, requestParameters.xUpsidrSwitchUser, requestParameters.submitCompletedWorkflowOfDraftPaymentRequestsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Submit completed workflow of payment request
         * @param {DefaultApiSubmitCompletedWorkflowOfPaymentRequestsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitCompletedWorkflowOfPaymentRequests(requestParameters: DefaultApiSubmitCompletedWorkflowOfPaymentRequestsRequest, options?: AxiosRequestConfig): AxiosPromise<SubmitCompletedWorkflowOfPaymentRequests200Response> {
            return localVarFp.submitCompletedWorkflowOfPaymentRequests(requestParameters.organizationId, requestParameters.xUpsidrSwitchUser, requestParameters.submitCompletedWorkflowOfPaymentRequestsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Submit workflow
         * @param {DefaultApiSubmitWorkflowRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitWorkflow(requestParameters: DefaultApiSubmitWorkflowRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.submitWorkflow(requestParameters.organizationId, requestParameters.workflowInstanceId, requestParameters.xUpsidrSwitchUser, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Suspend a card
         * @param {DefaultApiSuspendCardRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suspendCard(requestParameters: DefaultApiSuspendCardRequest, options?: AxiosRequestConfig): AxiosPromise<SuspendCard200Response> {
            return localVarFp.suspendCard(requestParameters.organizationId, requestParameters.cardId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncAllCardStatuses(options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.syncAllCardStatuses(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sync all users to each marketing tools
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncAllUsersToEachMarketingTools(options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.syncAllUsersToEachMarketingTools(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sync freee account items
         * @param {DefaultApiSyncFreeeAccountItemsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncFreeeAccountItems(requestParameters: DefaultApiSyncFreeeAccountItemsRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.syncFreeeAccountItems(requestParameters.organizationId, requestParameters.companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sync freee partners
         * @param {DefaultApiSyncFreeePartnersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncFreeePartners(requestParameters: DefaultApiSyncFreeePartnersRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.syncFreeePartners(requestParameters.organizationId, requestParameters.companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sync freee segment tags
         * @param {DefaultApiSyncFreeeSegmentTagsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncFreeeSegmentTags(requestParameters: DefaultApiSyncFreeeSegmentTagsRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.syncFreeeSegmentTags(requestParameters.organizationId, requestParameters.companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sync Moneytree access token
         * @param {DefaultApiSyncMoneytreeAccessTokenRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncMoneytreeAccessToken(requestParameters: DefaultApiSyncMoneytreeAccessTokenRequest, options?: AxiosRequestConfig): AxiosPromise<SyncMoneytreeAccessToken200Response> {
            return localVarFp.syncMoneytreeAccessToken(requestParameters.code, requestParameters.state, requestParameters.nextTo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sync Request for Freee Deals
         * @param {DefaultApiSyncRequestForFreeeDealsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncRequestForFreeeDeals(requestParameters: DefaultApiSyncRequestForFreeeDealsRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.syncRequestForFreeeDeals(requestParameters.organizationId, requestParameters.companyId, requestParameters.syncRequestForFreeeDealsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Two Factor Auth Reset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        twoFactorAuthReset(options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.twoFactorAuthReset(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Two Factor Auth Reset As Token
         * @param {DefaultApiTwoFactorAuthResetAsTokenRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        twoFactorAuthResetAsToken(requestParameters: DefaultApiTwoFactorAuthResetAsTokenRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.twoFactorAuthResetAsToken(requestParameters.twoFactorAuthResetAsTokenRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Unlinking purchase to transaction.
         * @param {DefaultApiUnlinkingPurchaseToTransactionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unlinkingPurchaseToTransaction(requestParameters: DefaultApiUnlinkingPurchaseToTransactionRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.unlinkingPurchaseToTransaction(requestParameters.organizationId, requestParameters.purchaseApplicationId, requestParameters.visaTransactionReferenceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Unlock a card due to no potential fraud
         * @param {DefaultApiUnlockCardForNotPotentialFraudRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unlockCardForNotPotentialFraud(requestParameters: DefaultApiUnlockCardForNotPotentialFraudRequest, options?: AxiosRequestConfig): AxiosPromise<UnlockCardForNotPotentialFraud200Response> {
            return localVarFp.unlockCardForNotPotentialFraud(requestParameters.organizationId, requestParameters.cardId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Unlock a card due to fraud cleared
         * @param {DefaultApiUnlockCardOnFraudClearedRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unlockCardOnFraudCleared(requestParameters: DefaultApiUnlockCardOnFraudClearedRequest, options?: AxiosRequestConfig): AxiosPromise<UnlockCardOnFraudCleared200Response> {
            return localVarFp.unlockCardOnFraudCleared(requestParameters.organizationId, requestParameters.cardId, requestParameters.visaTransactionReferenceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Available Currencies
         * @param {DefaultApiUpdateAvailableCurrenciesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAvailableCurrencies(requestParameters: DefaultApiUpdateAvailableCurrenciesRequest, options?: AxiosRequestConfig): AxiosPromise<UpdateAvailableCurrencies200Response> {
            return localVarFp.updateAvailableCurrencies(requestParameters.userAccountId, requestParameters.updateAvailableCurrenciesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Available Merchant Categories
         * @param {DefaultApiUpdateAvailableMerchantCategoriesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAvailableMerchantCategories(requestParameters: DefaultApiUpdateAvailableMerchantCategoriesRequest, options?: AxiosRequestConfig): AxiosPromise<UpdateAvailableMerchantCategories200Response> {
            return localVarFp.updateAvailableMerchantCategories(requestParameters.userAccountId, requestParameters.updateAvailableMerchantCategoriesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary update card account unit
         * @param {DefaultApiUpdateCardAccountUnitRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCardAccountUnit(requestParameters: DefaultApiUpdateCardAccountUnitRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateCardAccountUnit(requestParameters.organizationId, requestParameters.updateCardAccountUnitRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Card Count Limit
         * @param {DefaultApiUpdateCardCountLimitRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCardCountLimit(requestParameters: DefaultApiUpdateCardCountLimitRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateCardCountLimit(requestParameters.organizationId, requestParameters.updateCardCountLimitRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update card holder for the user account
         * @param {DefaultApiUpdateCardHolderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCardHolder(requestParameters: DefaultApiUpdateCardHolderRequest, options?: AxiosRequestConfig): AxiosPromise<UpdateCardHolder200Response> {
            return localVarFp.updateCardHolder(requestParameters.userAccountId, requestParameters.updateCardHolderRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Lock a card
         * @param {DefaultApiUpdateCardLockRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCardLock(requestParameters: DefaultApiUpdateCardLockRequest, options?: AxiosRequestConfig): AxiosPromise<UpdateCardLock200Response> {
            return localVarFp.updateCardLock(requestParameters.organizationId, requestParameters.cardId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Unlock a card
         * @param {DefaultApiUpdateCardUnlockRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCardUnlock(requestParameters: DefaultApiUpdateCardUnlockRequest, options?: AxiosRequestConfig): AxiosPromise<UpdateCardUnlock200Response> {
            return localVarFp.updateCardUnlock(requestParameters.organizationId, requestParameters.cardId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update comment for card transaction
         * @param {DefaultApiUpdateCommentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateComment(requestParameters: DefaultApiUpdateCommentRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateComment(requestParameters.organizationId, requestParameters.paymentReferenceId, requestParameters.cardTransactionCommentId, requestParameters.updateCommentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update comment template
         * @param {DefaultApiUpdateCommentTemplateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCommentTemplate(requestParameters: DefaultApiUpdateCommentTemplateRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateCommentTemplate(requestParameters.organizationId, requestParameters.templateId, requestParameters.updateCommentTemplateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update corporate document verification result
         * @param {DefaultApiUpdateCorporateDocumentResultRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCorporateDocumentResult(requestParameters: DefaultApiUpdateCorporateDocumentResultRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateCorporateDocumentResult(requestParameters.organizationIdentityVerificationId, requestParameters.updateCorporateDocumentResultRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update daily usage limit for the user account
         * @param {DefaultApiUpdateDailyUserUsageLimitRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDailyUserUsageLimit(requestParameters: DefaultApiUpdateDailyUserUsageLimitRequest, options?: AxiosRequestConfig): AxiosPromise<UpdateDailyUserUsageLimit200Response> {
            return localVarFp.updateDailyUserUsageLimit(requestParameters.userAccountId, requestParameters.updateDailyUserUsageLimitRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update deposit restriction for organization
         * @param {DefaultApiUpdateDepositRestrictionForOrganizationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDepositRestrictionForOrganization(requestParameters: DefaultApiUpdateDepositRestrictionForOrganizationRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateDepositRestrictionForOrganization(requestParameters.organizationId, requestParameters.depositRestrictionId, requestParameters.updateDepositRestrictionForOrganizationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Toggle on/off email notification settings per user
         * @param {DefaultApiUpdateEmailNotificationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEmailNotification(requestParameters: DefaultApiUpdateEmailNotificationRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateEmailNotification(requestParameters.userId, requestParameters.emailNotificationId, requestParameters.updateEmailNotificationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary update embed url method
         * @param {DefaultApiUpdateEmbedUrlMethodRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEmbedUrlMethod(requestParameters: DefaultApiUpdateEmbedUrlMethodRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateEmbedUrlMethod(requestParameters.organizationId, requestParameters.updateEmbedUrlMethodRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update evidence image
         * @param {DefaultApiUpdateEvidenceImageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEvidenceImage(requestParameters: DefaultApiUpdateEvidenceImageRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateEvidenceImage(requestParameters.organizationId, requestParameters.paymentReferenceId, requestParameters.cardTransactionEvidenceId, requestParameters.file, requestParameters.electronicMethod, requestParameters.documentSize, requestParameters.heightMillis, requestParameters.widthMillis, requestParameters.note, requestParameters.irrelevantToLedger, requestParameters.dpiForciblyValid, requestParameters.colorGradationForciblyValid, requestParameters.uploadedByRecipient, requestParameters.uploadedFrom, requestParameters.invoiceIssuerName, requestParameters.invoiceIssuerRegistrationNumber, requestParameters.asQualified, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update evidence info
         * @param {DefaultApiUpdateEvidenceInfoRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEvidenceInfo(requestParameters: DefaultApiUpdateEvidenceInfoRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateEvidenceInfo(requestParameters.organizationId, requestParameters.paymentReferenceId, requestParameters.cardTransactionEvidenceId, requestParameters.updateEvidenceInfoRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update freee connect
         * @param {DefaultApiUpdateFreeeConnectRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFreeeConnect(requestParameters: DefaultApiUpdateFreeeConnectRequest, options?: AxiosRequestConfig): AxiosPromise<UpdateFreeeConnect200Response> {
            return localVarFp.updateFreeeConnect(requestParameters.organizationId, requestParameters.code, requestParameters.state, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Turn on/off freee journaling
         * @param {DefaultApiUpdateFreeeJournalingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFreeeJournaling(requestParameters: DefaultApiUpdateFreeeJournalingRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateFreeeJournaling(requestParameters.organizationId, requestParameters.updateFreeeJournalingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update freee select company
         * @param {DefaultApiUpdateFreeeSelectCompanyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFreeeSelectCompany(requestParameters: DefaultApiUpdateFreeeSelectCompanyRequest, options?: AxiosRequestConfig): AxiosPromise<UpdateFreeeSelectCompany200Response> {
            return localVarFp.updateFreeeSelectCompany(requestParameters.organizationId, requestParameters.updateFreeeSelectCompanyRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update lock status of evidences
         * @param {DefaultApiUpdateLockStatusOfEvidencesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLockStatusOfEvidences(requestParameters: DefaultApiUpdateLockStatusOfEvidencesRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateLockStatusOfEvidences(requestParameters.organizationId, requestParameters.updateLockStatusOfEvidencesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update merchant general block allowed organization ids
         * @param {DefaultApiUpdateMerchantGeneralBlockAllowedOrganizationIdsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMerchantGeneralBlockAllowedOrganizationIds(requestParameters: DefaultApiUpdateMerchantGeneralBlockAllowedOrganizationIdsRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateMerchantGeneralBlockAllowedOrganizationIds(requestParameters.merchantGeneralBlockListId, requestParameters.updateMerchantGeneralBlockAllowedOrganizationIdsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update merchant general block list
         * @param {DefaultApiUpdateMerchantGeneralBlockListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMerchantGeneralBlockList(requestParameters: DefaultApiUpdateMerchantGeneralBlockListRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateMerchantGeneralBlockList(requestParameters.merchantGeneralBlockListId, requestParameters.updateMerchantGeneralBlockListRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update merchant org block list
         * @param {DefaultApiUpdateMerchantOrgBlockListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMerchantOrgBlockList(requestParameters: DefaultApiUpdateMerchantOrgBlockListRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateMerchantOrgBlockList(requestParameters.merchantOrgBlockListId, requestParameters.updateMerchantOrgBlockListRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Merchant Organization Comment
         * @param {DefaultApiUpdateMerchantOrganizationCommentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMerchantOrganizationComment(requestParameters: DefaultApiUpdateMerchantOrganizationCommentRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateMerchantOrganizationComment(requestParameters.organizationId, requestParameters.merchantId, requestParameters.userAccountId, requestParameters.updateMerchantOrganizationCommentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Organization
         * @param {DefaultApiUpdateOrganizationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganization(requestParameters: DefaultApiUpdateOrganizationRequest, options?: AxiosRequestConfig): AxiosPromise<UpdateOrganization200Response> {
            return localVarFp.updateOrganization(requestParameters.organizationId, requestParameters.updateOrganizationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Organizations Accounting Csv Export Fields
         * @param {DefaultApiUpdateOrganizationsAccountingCsvExportFieldsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganizationsAccountingCsvExportFields(requestParameters: DefaultApiUpdateOrganizationsAccountingCsvExportFieldsRequest, options?: AxiosRequestConfig): AxiosPromise<Array<string>> {
            return localVarFp.updateOrganizationsAccountingCsvExportFields(requestParameters.organizationId, requestParameters.requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Update the payment request evidence specified by evidenceId.
         * @summary Update the specific payment request evidence.
         * @param {DefaultApiUpdatePaymentRequestEvidenceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePaymentRequestEvidence(requestParameters: DefaultApiUpdatePaymentRequestEvidenceRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updatePaymentRequestEvidence(requestParameters.organizationId, requestParameters.paymentRequestId, requestParameters.evidenceId, requestParameters.updatePaymentRequestEvidenceRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update the payment request evidence file specified by evidenceId. This also accept properties other than a file binary.
         * @summary Update the specific payment request evidence file.
         * @param {DefaultApiUpdatePaymentRequestEvidenceFileRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePaymentRequestEvidenceFile(requestParameters: DefaultApiUpdatePaymentRequestEvidenceFileRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updatePaymentRequestEvidenceFile(requestParameters.organizationId, requestParameters.paymentRequestId, requestParameters.evidenceId, requestParameters.file, requestParameters.electronicMethod, requestParameters.documentSize, requestParameters.heightMillis, requestParameters.widthMillis, requestParameters.dpiForciblyValid, requestParameters.colorGradationForciblyValid, requestParameters.note, requestParameters.irrelevantToLedger, requestParameters.uploadedByRecipient, requestParameters.uploadedFrom, requestParameters.invoiceIssuerRegistrationNumber, requestParameters.invoiceIssuerName, requestParameters.asQualified, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update purchase application template.
         * @param {DefaultApiUpdatePurchaseApplicationTemplateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePurchaseApplicationTemplate(requestParameters: DefaultApiUpdatePurchaseApplicationTemplateRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updatePurchaseApplicationTemplate(requestParameters.organizationId, requestParameters.purchaseTemplateId, requestParameters.updatePurchaseApplicationTemplateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update remove user account group
         * @param {DefaultApiUpdateRemoveUserAccountGroupRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRemoveUserAccountGroup(requestParameters: DefaultApiUpdateRemoveUserAccountGroupRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateRemoveUserAccountGroup(requestParameters.userAccountId, requestParameters.updateRemoveUserAccountGroupRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update role resource for user
         * @param {DefaultApiUpdateRoleResourceForUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRoleResourceForUser(requestParameters: DefaultApiUpdateRoleResourceForUserRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateRoleResourceForUser(requestParameters.userId, requestParameters.updateRoleResourceForUserRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Roles by Resource Id
         * @param {DefaultApiUpdateRolesByResourceIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRolesByResourceId(requestParameters: DefaultApiUpdateRolesByResourceIdRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateRolesByResourceId(requestParameters.resourceScope, requestParameters.resourceId, requestParameters.updateRolesByResourceIdRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Slack evidence remind settings of an slack channel
         * @param {DefaultApiUpdateSlackEvidenceReminderPerChannelRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSlackEvidenceReminderPerChannel(requestParameters: DefaultApiUpdateSlackEvidenceReminderPerChannelRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateSlackEvidenceReminderPerChannel(requestParameters.organizationId, requestParameters.channelId, requestParameters.updateSlackEvidenceReminderPerChannelRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update slack notification channel setting for card
         * @param {DefaultApiUpdateSlackNotificationSettingForCardRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSlackNotificationSettingForCard(requestParameters: DefaultApiUpdateSlackNotificationSettingForCardRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateSlackNotificationSettingForCard(requestParameters.organizationId, requestParameters.channelId, requestParameters.updateSlackNotificationSettingForCardRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update slack notification channel setting for purchase-application
         * @param {DefaultApiUpdateSlackNotificationSettingForPurchaseApplicationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSlackNotificationSettingForPurchaseApplication(requestParameters: DefaultApiUpdateSlackNotificationSettingForPurchaseApplicationRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateSlackNotificationSettingForPurchaseApplication(requestParameters.organizationId, requestParameters.channelId, requestParameters.updateSlackNotificationSettingForPurchaseApplicationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update sync to freee from deal
         * @param {DefaultApiUpdateSyncToFreeeFromDealRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSyncToFreeeFromDeal(requestParameters: DefaultApiUpdateSyncToFreeeFromDealRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateSyncToFreeeFromDeal(requestParameters.organizationId, requestParameters.companyId, requestParameters.dealId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update synchronize to freee log confirm
         * @param {DefaultApiUpdateSynchronizeToFreeeLogConfirmRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSynchronizeToFreeeLogConfirm(requestParameters: DefaultApiUpdateSynchronizeToFreeeLogConfirmRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateSynchronizeToFreeeLogConfirm(requestParameters.organizationId, requestParameters.companyId, requestParameters.updateSynchronizeToFreeeLogConfirmRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Teams notification channel setting for card
         * @param {DefaultApiUpdateTeamsNotificationSettingForCardRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTeamsNotificationSettingForCard(requestParameters: DefaultApiUpdateTeamsNotificationSettingForCardRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateTeamsNotificationSettingForCard(requestParameters.organizationId, requestParameters.channelId, requestParameters.updateTeamsNotificationSettingForCardRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update transaction upper limit for the user account
         * @param {DefaultApiUpdateTransactionUpperLimitForTheUserAccountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTransactionUpperLimitForTheUserAccount(requestParameters: DefaultApiUpdateTransactionUpperLimitForTheUserAccountRequest, options?: AxiosRequestConfig): AxiosPromise<UpdateTransactionUpperLimitForTheUserAccount200Response> {
            return localVarFp.updateTransactionUpperLimitForTheUserAccount(requestParameters.userAccountId, requestParameters.updateTransactionUpperLimitForTheUserAccountRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update user account group
         * @param {DefaultApiUpdateUserAccountGroupRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserAccountGroup(requestParameters: DefaultApiUpdateUserAccountGroupRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateUserAccountGroup(requestParameters.userAccountId, requestParameters.updateUserAccountGroupRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update user account name
         * @param {DefaultApiUpdateUserAccountNameRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserAccountName(requestParameters: DefaultApiUpdateUserAccountNameRequest, options?: AxiosRequestConfig): AxiosPromise<UpdateUserAccountName200Response> {
            return localVarFp.updateUserAccountName(requestParameters.userAccountId, requestParameters.updateUserAccountNameRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary update user email, settings per user
         * @param {DefaultApiUpdateUserEmailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserEmail(requestParameters: DefaultApiUpdateUserEmailRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateUserEmail(requestParameters.userId, requestParameters.updateUserEmailRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary update user name, settings per user
         * @param {DefaultApiUpdateUserNameRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserName(requestParameters: DefaultApiUpdateUserNameRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateUserName(requestParameters.userId, requestParameters.updateUserNameRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary update user organization
         * @param {DefaultApiUpdateUserOrganizationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserOrganization(requestParameters: DefaultApiUpdateUserOrganizationRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateUserOrganization(requestParameters.userId, requestParameters.updateUserOrganizationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary update user password
         * @param {DefaultApiUpdateUserPasswordRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserPassword(requestParameters: DefaultApiUpdateUserPasswordRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateUserPassword(requestParameters.userId, requestParameters.updateUserPasswordRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update User Privilege
         * @param {DefaultApiUpdateUserPrivilegeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserPrivilege(requestParameters: DefaultApiUpdateUserPrivilegeRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateUserPrivilege(requestParameters.organizationId, requestParameters.userId, requestParameters.updateUserPrivilegeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update usage limit for the user account
         * @param {DefaultApiUpdateUserUsageLimitRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserUsageLimit(requestParameters: DefaultApiUpdateUserUsageLimitRequest, options?: AxiosRequestConfig): AxiosPromise<UpdateUserUsageLimit200Response> {
            return localVarFp.updateUserUsageLimit(requestParameters.userAccountId, requestParameters.updateUserUsageLimitRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upload card transaction evidence images
         * @param {DefaultApiUploadCardTransactionEvidenceImageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadCardTransactionEvidenceImage(requestParameters: DefaultApiUploadCardTransactionEvidenceImageRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.uploadCardTransactionEvidenceImage(requestParameters.organizationId, requestParameters.paymentReferenceId, requestParameters.files, requestParameters.electronicMethod, requestParameters.documentSize, requestParameters.heightMillis, requestParameters.widthMillis, requestParameters.note, requestParameters.irrelevantToLedger, requestParameters.uploadedByRecipient, requestParameters.uploadedFrom, requestParameters.invoiceIssuerName, requestParameters.invoiceIssuerRegistrationNumber, requestParameters.asQualified, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upload corporate document
         * @param {DefaultApiUploadCorporateDocumentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadCorporateDocument(requestParameters: DefaultApiUploadCorporateDocumentRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.uploadCorporateDocument(requestParameters.organizationIdentityVerificationId, requestParameters.file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upload payment request evidence image
         * @param {DefaultApiUploadPaymentRequestEvidenceImageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadPaymentRequestEvidenceImage(requestParameters: DefaultApiUploadPaymentRequestEvidenceImageRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.uploadPaymentRequestEvidenceImage(requestParameters.organizationId, requestParameters.paymentRequestId, requestParameters.file, requestParameters.electronicMethod, requestParameters.documentSize, requestParameters.heightMillis, requestParameters.widthMillis, requestParameters.note, requestParameters.irrelevantToLedger, requestParameters.uploadedByRecipient, requestParameters.uploadedFrom, requestParameters.invoiceIssuerName, requestParameters.invoiceIssuerRegistrationNumber, requestParameters.asQualified, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Users email confirm
         * @param {DefaultApiUsersEmailConfirmRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersEmailConfirm(requestParameters: DefaultApiUsersEmailConfirmRequest, options?: AxiosRequestConfig): AxiosPromise<UsersEmailConfirm200Response> {
            return localVarFp.usersEmailConfirm(requestParameters.usersEmailConfirmRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Verify moneytree connections
         * @param {DefaultApiVerifyMoneytreeConnectionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyMoneytreeConnections(requestParameters: DefaultApiVerifyMoneytreeConnectionsRequest, options?: AxiosRequestConfig): AxiosPromise<VerifyMoneytreeConnections200Response> {
            return localVarFp.verifyMoneytreeConnections(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for addComment operation in DefaultApi.
 * @export
 * @interface DefaultApiAddCommentRequest
 */
export interface DefaultApiAddCommentRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiAddComment
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiAddComment
     */
    readonly paymentReferenceId: string

    /**
     * 
     * @type {AddCommentRequest}
     * @memberof DefaultApiAddComment
     */
    readonly addCommentRequest: AddCommentRequest
}

/**
 * Request parameters for addOrganizationCreateRequest operation in DefaultApi.
 * @export
 * @interface DefaultApiAddOrganizationCreateRequestRequest
 */
export interface DefaultApiAddOrganizationCreateRequestRequest {
    /**
     * 
     * @type {AddOrganizationCreateRequestRequest}
     * @memberof DefaultApiAddOrganizationCreateRequest
     */
    readonly addOrganizationCreateRequestRequest: AddOrganizationCreateRequestRequest
}

/**
 * Request parameters for addPointToOrganization operation in DefaultApi.
 * @export
 * @interface DefaultApiAddPointToOrganizationRequest
 */
export interface DefaultApiAddPointToOrganizationRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiAddPointToOrganization
     */
    readonly organizationId: string

    /**
     * 
     * @type {AddPointToOrganizationRequest}
     * @memberof DefaultApiAddPointToOrganization
     */
    readonly addPointToOrganizationRequest: AddPointToOrganizationRequest
}

/**
 * Request parameters for agreeToAgreementRequest operation in DefaultApi.
 * @export
 * @interface DefaultApiAgreeToAgreementRequestRequest
 */
export interface DefaultApiAgreeToAgreementRequestRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiAgreeToAgreementRequest
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiAgreeToAgreementRequest
     */
    readonly agreementRequestId: string
}

/**
 * Request parameters for analyzeEvidence operation in DefaultApi.
 * @export
 * @interface DefaultApiAnalyzeEvidenceRequest
 */
export interface DefaultApiAnalyzeEvidenceRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiAnalyzeEvidence
     */
    readonly organizationId: string

    /**
     * 
     * @type {File}
     * @memberof DefaultApiAnalyzeEvidence
     */
    readonly file?: File
}

/**
 * Request parameters for analyzeInvoiceOfPaymentRequests operation in DefaultApi.
 * @export
 * @interface DefaultApiAnalyzeInvoiceOfPaymentRequestsRequest
 */
export interface DefaultApiAnalyzeInvoiceOfPaymentRequestsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiAnalyzeInvoiceOfPaymentRequests
     */
    readonly organizationId: string

    /**
     * 
     * @type {File}
     * @memberof DefaultApiAnalyzeInvoiceOfPaymentRequests
     */
    readonly file: File

    /**
     * 
     * @type {string}
     * @memberof DefaultApiAnalyzeInvoiceOfPaymentRequests
     */
    readonly xUpsidrSwitchUser?: string
}

/**
 * Request parameters for approveOrganizationIdentityVerification operation in DefaultApi.
 * @export
 * @interface DefaultApiApproveOrganizationIdentityVerificationRequest
 */
export interface DefaultApiApproveOrganizationIdentityVerificationRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiApproveOrganizationIdentityVerification
     */
    readonly organizationIdentityVerificationId: number
}

/**
 * Request parameters for approvePurchaseApplication operation in DefaultApi.
 * @export
 * @interface DefaultApiApprovePurchaseApplicationRequest
 */
export interface DefaultApiApprovePurchaseApplicationRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiApprovePurchaseApplication
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiApprovePurchaseApplication
     */
    readonly purchaseApplicationId: string

    /**
     * 
     * @type {ApprovePurchaseApplicationRequest}
     * @memberof DefaultApiApprovePurchaseApplication
     */
    readonly approvePurchaseApplicationRequest: ApprovePurchaseApplicationRequest
}

/**
 * Request parameters for approveWorkflowStepPaymentRequests operation in DefaultApi.
 * @export
 * @interface DefaultApiApproveWorkflowStepPaymentRequestsRequest
 */
export interface DefaultApiApproveWorkflowStepPaymentRequestsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiApproveWorkflowStepPaymentRequests
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiApproveWorkflowStepPaymentRequests
     */
    readonly xUpsidrSwitchUser?: string

    /**
     * 
     * @type {ApproveWorkflowStepPaymentRequestsRequest}
     * @memberof DefaultApiApproveWorkflowStepPaymentRequests
     */
    readonly approveWorkflowStepPaymentRequestsRequest?: ApproveWorkflowStepPaymentRequestsRequest
}

/**
 * Request parameters for automaticallyJournalizeDealsFromRules operation in DefaultApi.
 * @export
 * @interface DefaultApiAutomaticallyJournalizeDealsFromRulesRequest
 */
export interface DefaultApiAutomaticallyJournalizeDealsFromRulesRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiAutomaticallyJournalizeDealsFromRules
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiAutomaticallyJournalizeDealsFromRules
     */
    readonly companyId: string

    /**
     * 
     * @type {AutomaticallyJournalizeDealsFromRulesRequest}
     * @memberof DefaultApiAutomaticallyJournalizeDealsFromRules
     */
    readonly automaticallyJournalizeDealsFromRulesRequest: AutomaticallyJournalizeDealsFromRulesRequest
}

/**
 * Request parameters for bankAccountActivitiesWithdrawalReserve operation in DefaultApi.
 * @export
 * @interface DefaultApiBankAccountActivitiesWithdrawalReserveRequest
 */
export interface DefaultApiBankAccountActivitiesWithdrawalReserveRequest {
    /**
     * 
     * @type {BankAccountActivitiesWithdrawalReserveRequest}
     * @memberof DefaultApiBankAccountActivitiesWithdrawalReserve
     */
    readonly bankAccountActivitiesWithdrawalReserveRequest: BankAccountActivitiesWithdrawalReserveRequest
}

/**
 * Request parameters for bulkDisableDailyUserUsageLimit operation in DefaultApi.
 * @export
 * @interface DefaultApiBulkDisableDailyUserUsageLimitRequest
 */
export interface DefaultApiBulkDisableDailyUserUsageLimitRequest {
    /**
     * 
     * @type {BulkDisableDailyUserUsageLimitRequest}
     * @memberof DefaultApiBulkDisableDailyUserUsageLimit
     */
    readonly bulkDisableDailyUserUsageLimitRequest: BulkDisableDailyUserUsageLimitRequest
}

/**
 * Request parameters for bulkDisableMonthlyUsageLimit operation in DefaultApi.
 * @export
 * @interface DefaultApiBulkDisableMonthlyUsageLimitRequest
 */
export interface DefaultApiBulkDisableMonthlyUsageLimitRequest {
    /**
     * 
     * @type {BulkDisableMonthlyUsageLimitRequest}
     * @memberof DefaultApiBulkDisableMonthlyUsageLimit
     */
    readonly bulkDisableMonthlyUsageLimitRequest: BulkDisableMonthlyUsageLimitRequest
}

/**
 * Request parameters for bulkUpdateDailyUsageLimit operation in DefaultApi.
 * @export
 * @interface DefaultApiBulkUpdateDailyUsageLimitRequest
 */
export interface DefaultApiBulkUpdateDailyUsageLimitRequest {
    /**
     * 
     * @type {BulkUpdateDailyUsageLimitRequest}
     * @memberof DefaultApiBulkUpdateDailyUsageLimit
     */
    readonly bulkUpdateDailyUsageLimitRequest: BulkUpdateDailyUsageLimitRequest
}

/**
 * Request parameters for bulkUpdateMonthlyUsageLimit operation in DefaultApi.
 * @export
 * @interface DefaultApiBulkUpdateMonthlyUsageLimitRequest
 */
export interface DefaultApiBulkUpdateMonthlyUsageLimitRequest {
    /**
     * 
     * @type {BulkUpdateMonthlyUsageLimitRequest}
     * @memberof DefaultApiBulkUpdateMonthlyUsageLimit
     */
    readonly bulkUpdateMonthlyUsageLimitRequest: BulkUpdateMonthlyUsageLimitRequest
}

/**
 * Request parameters for bulkUpdateOrganizationUserPrivileges operation in DefaultApi.
 * @export
 * @interface DefaultApiBulkUpdateOrganizationUserPrivilegesRequest
 */
export interface DefaultApiBulkUpdateOrganizationUserPrivilegesRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiBulkUpdateOrganizationUserPrivileges
     */
    readonly organizationId: string

    /**
     * 
     * @type {BulkUpdateOrganizationUserPrivilegesRequest}
     * @memberof DefaultApiBulkUpdateOrganizationUserPrivileges
     */
    readonly bulkUpdateOrganizationUserPrivilegesRequest: BulkUpdateOrganizationUserPrivilegesRequest
}

/**
 * Request parameters for cancelDraftPaymentRequest operation in DefaultApi.
 * @export
 * @interface DefaultApiCancelDraftPaymentRequestRequest
 */
export interface DefaultApiCancelDraftPaymentRequestRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiCancelDraftPaymentRequest
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiCancelDraftPaymentRequest
     */
    readonly draftPaymentRequestId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiCancelDraftPaymentRequest
     */
    readonly xUpsidrSwitchUser?: string
}

/**
 * Request parameters for cancelPaymentRequest operation in DefaultApi.
 * @export
 * @interface DefaultApiCancelPaymentRequestRequest
 */
export interface DefaultApiCancelPaymentRequestRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiCancelPaymentRequest
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiCancelPaymentRequest
     */
    readonly paymentRequestId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiCancelPaymentRequest
     */
    readonly xUpsidrSwitchUser?: string
}

/**
 * Request parameters for changeIdentityVerificationScheduledDate operation in DefaultApi.
 * @export
 * @interface DefaultApiChangeIdentityVerificationScheduledDateRequest
 */
export interface DefaultApiChangeIdentityVerificationScheduledDateRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiChangeIdentityVerificationScheduledDate
     */
    readonly organizationId: string

    /**
     * 
     * @type {ChangeIdentityVerificationScheduledDateRequest}
     * @memberof DefaultApiChangeIdentityVerificationScheduledDate
     */
    readonly changeIdentityVerificationScheduledDateRequest: ChangeIdentityVerificationScheduledDateRequest
}

/**
 * Request parameters for changeInvoiceEmail operation in DefaultApi.
 * @export
 * @interface DefaultApiChangeInvoiceEmailRequest
 */
export interface DefaultApiChangeInvoiceEmailRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiChangeInvoiceEmail
     */
    readonly organizationId: string

    /**
     * 
     * @type {ChangeInvoiceEmailRequest}
     * @memberof DefaultApiChangeInvoiceEmail
     */
    readonly changeInvoiceEmailRequest: ChangeInvoiceEmailRequest
}

/**
 * Request parameters for changeToTheSpecifiedEkycResult operation in DefaultApi.
 * @export
 * @interface DefaultApiChangeToTheSpecifiedEkycResultRequest
 */
export interface DefaultApiChangeToTheSpecifiedEkycResultRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiChangeToTheSpecifiedEkycResult
     */
    readonly identificationId: string
}

/**
 * Request parameters for checkAlreadyRegisteredPhoneNumber operation in DefaultApi.
 * @export
 * @interface DefaultApiCheckAlreadyRegisteredPhoneNumberRequest
 */
export interface DefaultApiCheckAlreadyRegisteredPhoneNumberRequest {
    /**
     * 
     * @type {CheckAlreadyRegisteredPhoneNumberRequest}
     * @memberof DefaultApiCheckAlreadyRegisteredPhoneNumber
     */
    readonly checkAlreadyRegisteredPhoneNumberRequest: CheckAlreadyRegisteredPhoneNumberRequest
}

/**
 * Request parameters for checkDuplicateEmailAddresses operation in DefaultApi.
 * @export
 * @interface DefaultApiCheckDuplicateEmailAddressesRequest
 */
export interface DefaultApiCheckDuplicateEmailAddressesRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof DefaultApiCheckDuplicateEmailAddresses
     */
    readonly emailAddresses?: Array<string>
}

/**
 * Request parameters for completeRedirectFromSlack operation in DefaultApi.
 * @export
 * @interface DefaultApiCompleteRedirectFromSlackRequest
 */
export interface DefaultApiCompleteRedirectFromSlackRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiCompleteRedirectFromSlack
     */
    readonly organizationId: string

    /**
     * 
     * @type {CompleteRedirectFromSlackRequest}
     * @memberof DefaultApiCompleteRedirectFromSlack
     */
    readonly completeRedirectFromSlackRequest?: CompleteRedirectFromSlackRequest
}

/**
 * Request parameters for countDeals operation in DefaultApi.
 * @export
 * @interface DefaultApiCountDealsRequest
 */
export interface DefaultApiCountDealsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiCountDeals
     */
    readonly organizationId: string

    /**
     * 
     * @type {CountDealsRequest}
     * @memberof DefaultApiCountDeals
     */
    readonly countDealsRequest?: CountDealsRequest
}

/**
 * Request parameters for createBankTransfers operation in DefaultApi.
 * @export
 * @interface DefaultApiCreateBankTransfersRequest
 */
export interface DefaultApiCreateBankTransfersRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiCreateBankTransfers
     */
    readonly organizationId: string

    /**
     * 
     * @type {CreateBankTransfersRequest}
     * @memberof DefaultApiCreateBankTransfers
     */
    readonly createBankTransfersRequest: CreateBankTransfersRequest

    /**
     * yyyy-MM-dd format date in JST. Filter the bank transfers to be returned to only those which are scheduled to be transferred after this date.
     * @type {string}
     * @memberof DefaultApiCreateBankTransfers
     */
    readonly transferDateJstFrom?: string

    /**
     * yyyy-MM-dd format date in JST. Filter the bank transfers to be returned to only those which are scheduled to be transferred before this date. Both transferDateJstFrom and transferDateJstTo are inclusive (closed interval).
     * @type {string}
     * @memberof DefaultApiCreateBankTransfers
     */
    readonly transferDateJstTo?: string

    /**
     * Filter the bank transfers by the specified source bank account id.
     * @type {string}
     * @memberof DefaultApiCreateBankTransfers
     */
    readonly sourceBankAccountId?: string

    /**
     * Filter the bank transfers by whether the corresponding transfer data has been downloaded.
     * @type {boolean}
     * @memberof DefaultApiCreateBankTransfers
     */
    readonly downloaded?: boolean

    /**
     * 
     * @type {number}
     * @memberof DefaultApiCreateBankTransfers
     */
    readonly limit?: number

    /**
     * See the description of &#x60;cursor&#x60; section Pagination
     * @type {number}
     * @memberof DefaultApiCreateBankTransfers
     */
    readonly offset?: number

    /**
     * Pagination is performed by specifying either offset or cursor; if neither offset nor cursor is specified, it is assumed to be cursor-pagination and the first page is obtained with the next cursor. See below how the pagination exactly behaves:  - \&quot;\&quot; ... Get the fist page and return the next cursor  - \&quot;offset&#x3D;50\&quot; ... Get from the specified offset and never return the next cursor  - \&quot;cursor&#x3D;xxx\&quot; ... Get from the specified cursor  - \&quot;offset&#x3D;50&amp;cursor&#x3D;xxx\&quot; ... Ignore the offset and get from the specified cursor
     * @type {string}
     * @memberof DefaultApiCreateBankTransfers
     */
    readonly cursor?: string
}

/**
 * Request parameters for createCategoryOfThePurchaseApplicationTemplate operation in DefaultApi.
 * @export
 * @interface DefaultApiCreateCategoryOfThePurchaseApplicationTemplateRequest
 */
export interface DefaultApiCreateCategoryOfThePurchaseApplicationTemplateRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiCreateCategoryOfThePurchaseApplicationTemplate
     */
    readonly organizationId: string

    /**
     * 
     * @type {CreateCategoryOfThePurchaseApplicationTemplateRequest}
     * @memberof DefaultApiCreateCategoryOfThePurchaseApplicationTemplate
     */
    readonly createCategoryOfThePurchaseApplicationTemplateRequest: CreateCategoryOfThePurchaseApplicationTemplateRequest
}

/**
 * Request parameters for createCommentTemplate operation in DefaultApi.
 * @export
 * @interface DefaultApiCreateCommentTemplateRequest
 */
export interface DefaultApiCreateCommentTemplateRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiCreateCommentTemplate
     */
    readonly organizationId: string

    /**
     * 
     * @type {CreateCommentTemplateRequest}
     * @memberof DefaultApiCreateCommentTemplate
     */
    readonly createCommentTemplateRequest: CreateCommentTemplateRequest
}

/**
 * Request parameters for createDepositRestrictionForOrganization operation in DefaultApi.
 * @export
 * @interface DefaultApiCreateDepositRestrictionForOrganizationRequest
 */
export interface DefaultApiCreateDepositRestrictionForOrganizationRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiCreateDepositRestrictionForOrganization
     */
    readonly organizationId: string

    /**
     * 
     * @type {CreateDepositRestrictionForOrganizationRequest}
     * @memberof DefaultApiCreateDepositRestrictionForOrganization
     */
    readonly createDepositRestrictionForOrganizationRequest: CreateDepositRestrictionForOrganizationRequest
}

/**
 * Request parameters for createDraftOfPaymentRequests operation in DefaultApi.
 * @export
 * @interface DefaultApiCreateDraftOfPaymentRequestsRequest
 */
export interface DefaultApiCreateDraftOfPaymentRequestsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiCreateDraftOfPaymentRequests
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiCreateDraftOfPaymentRequests
     */
    readonly xUpsidrSwitchUser?: string

    /**
     * 
     * @type {CreateDraftOfPaymentRequestsRequest}
     * @memberof DefaultApiCreateDraftOfPaymentRequests
     */
    readonly createDraftOfPaymentRequestsRequest?: CreateDraftOfPaymentRequestsRequest
}

/**
 * Request parameters for createEvidenceRequest operation in DefaultApi.
 * @export
 * @interface DefaultApiCreateEvidenceRequestRequest
 */
export interface DefaultApiCreateEvidenceRequestRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiCreateEvidenceRequest
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiCreateEvidenceRequest
     */
    readonly paymentReferenceId: string
}

/**
 * Request parameters for createFreeePartner operation in DefaultApi.
 * @export
 * @interface DefaultApiCreateFreeePartnerRequest
 */
export interface DefaultApiCreateFreeePartnerRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiCreateFreeePartner
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiCreateFreeePartner
     */
    readonly companyId: string

    /**
     * 
     * @type {CreateFreeePartnerRequest}
     * @memberof DefaultApiCreateFreeePartner
     */
    readonly createFreeePartnerRequest: CreateFreeePartnerRequest
}

/**
 * Request parameters for createPastDeals operation in DefaultApi.
 * @export
 * @interface DefaultApiCreatePastDealsRequest
 */
export interface DefaultApiCreatePastDealsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiCreatePastDeals
     */
    readonly organizationId: string

    /**
     * 
     * @type {CreatePastDealsRequest}
     * @memberof DefaultApiCreatePastDeals
     */
    readonly createPastDealsRequest: CreatePastDealsRequest
}

/**
 * Request parameters for createPurchaseApplication operation in DefaultApi.
 * @export
 * @interface DefaultApiCreatePurchaseApplicationRequest
 */
export interface DefaultApiCreatePurchaseApplicationRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiCreatePurchaseApplication
     */
    readonly organizationId: string

    /**
     * 
     * @type {CreatePurchaseApplicationRequest}
     * @memberof DefaultApiCreatePurchaseApplication
     */
    readonly createPurchaseApplicationRequest: CreatePurchaseApplicationRequest

    /**
     * 
     * @type {string}
     * @memberof DefaultApiCreatePurchaseApplication
     */
    readonly visaTransactionReferenceId?: string
}

/**
 * Request parameters for createPurchaseApplicationTemplate operation in DefaultApi.
 * @export
 * @interface DefaultApiCreatePurchaseApplicationTemplateRequest
 */
export interface DefaultApiCreatePurchaseApplicationTemplateRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiCreatePurchaseApplicationTemplate
     */
    readonly organizationId: string

    /**
     * 
     * @type {CreatePurchaseApplicationTemplateRequest}
     * @memberof DefaultApiCreatePurchaseApplicationTemplate
     */
    readonly createPurchaseApplicationTemplateRequest: CreatePurchaseApplicationTemplateRequest
}

/**
 * Request parameters for createSlackCardNotifications operation in DefaultApi.
 * @export
 * @interface DefaultApiCreateSlackCardNotificationsRequest
 */
export interface DefaultApiCreateSlackCardNotificationsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiCreateSlackCardNotifications
     */
    readonly organizationId: string

    /**
     * 
     * @type {CreateSlackCardNotificationsRequest}
     * @memberof DefaultApiCreateSlackCardNotifications
     */
    readonly createSlackCardNotificationsRequest: CreateSlackCardNotificationsRequest
}

/**
 * Request parameters for createSlackNotificationSettingsForPurchaseApplication operation in DefaultApi.
 * @export
 * @interface DefaultApiCreateSlackNotificationSettingsForPurchaseApplicationRequest
 */
export interface DefaultApiCreateSlackNotificationSettingsForPurchaseApplicationRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiCreateSlackNotificationSettingsForPurchaseApplication
     */
    readonly organizationId: string

    /**
     * 
     * @type {CreateSlackNotificationSettingsForPurchaseApplicationRequest}
     * @memberof DefaultApiCreateSlackNotificationSettingsForPurchaseApplication
     */
    readonly createSlackNotificationSettingsForPurchaseApplicationRequest: CreateSlackNotificationSettingsForPurchaseApplicationRequest
}

/**
 * Request parameters for createTeamsCardNotifications operation in DefaultApi.
 * @export
 * @interface DefaultApiCreateTeamsCardNotificationsRequest
 */
export interface DefaultApiCreateTeamsCardNotificationsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiCreateTeamsCardNotifications
     */
    readonly organizationId: string

    /**
     * 
     * @type {CreateTeamsCardNotificationsRequest}
     * @memberof DefaultApiCreateTeamsCardNotifications
     */
    readonly createTeamsCardNotificationsRequest: CreateTeamsCardNotificationsRequest
}

/**
 * Request parameters for createUserAccountGroups operation in DefaultApi.
 * @export
 * @interface DefaultApiCreateUserAccountGroupsRequest
 */
export interface DefaultApiCreateUserAccountGroupsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiCreateUserAccountGroups
     */
    readonly organizationId: string

    /**
     * 
     * @type {CreateUserAccountGroupsRequest}
     * @memberof DefaultApiCreateUserAccountGroups
     */
    readonly createUserAccountGroupsRequest?: CreateUserAccountGroupsRequest
}

/**
 * Request parameters for deactivateCard operation in DefaultApi.
 * @export
 * @interface DefaultApiDeactivateCardRequest
 */
export interface DefaultApiDeactivateCardRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiDeactivateCard
     */
    readonly cardId: string
}

/**
 * Request parameters for deactivateUser operation in DefaultApi.
 * @export
 * @interface DefaultApiDeactivateUserRequest
 */
export interface DefaultApiDeactivateUserRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiDeactivateUser
     */
    readonly userId: string
}

/**
 * Request parameters for defrostCard operation in DefaultApi.
 * @export
 * @interface DefaultApiDefrostCardRequest
 */
export interface DefaultApiDefrostCardRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiDefrostCard
     */
    readonly cardId: string
}

/**
 * Request parameters for deleteCardPointsRateConfig operation in DefaultApi.
 * @export
 * @interface DefaultApiDeleteCardPointsRateConfigRequest
 */
export interface DefaultApiDeleteCardPointsRateConfigRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiDeleteCardPointsRateConfig
     */
    readonly rateConfigId: string
}

/**
 * Request parameters for deleteCategoryOfThePurchaseApplicationTemplate operation in DefaultApi.
 * @export
 * @interface DefaultApiDeleteCategoryOfThePurchaseApplicationTemplateRequest
 */
export interface DefaultApiDeleteCategoryOfThePurchaseApplicationTemplateRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiDeleteCategoryOfThePurchaseApplicationTemplate
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiDeleteCategoryOfThePurchaseApplicationTemplate
     */
    readonly purchaseTemplateCategoryId: string
}

/**
 * Request parameters for deleteComment operation in DefaultApi.
 * @export
 * @interface DefaultApiDeleteCommentRequest
 */
export interface DefaultApiDeleteCommentRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiDeleteComment
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiDeleteComment
     */
    readonly paymentReferenceId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiDeleteComment
     */
    readonly cardTransactionCommentId: string
}

/**
 * Request parameters for deleteCommentTemplate operation in DefaultApi.
 * @export
 * @interface DefaultApiDeleteCommentTemplateRequest
 */
export interface DefaultApiDeleteCommentTemplateRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiDeleteCommentTemplate
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiDeleteCommentTemplate
     */
    readonly templateId: string
}

/**
 * Request parameters for deleteDepositRestrictionForOrganization operation in DefaultApi.
 * @export
 * @interface DefaultApiDeleteDepositRestrictionForOrganizationRequest
 */
export interface DefaultApiDeleteDepositRestrictionForOrganizationRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiDeleteDepositRestrictionForOrganization
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiDeleteDepositRestrictionForOrganization
     */
    readonly depositRestrictionId: string
}

/**
 * Request parameters for deleteEvidence operation in DefaultApi.
 * @export
 * @interface DefaultApiDeleteEvidenceRequest
 */
export interface DefaultApiDeleteEvidenceRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiDeleteEvidence
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiDeleteEvidence
     */
    readonly paymentReferenceId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiDeleteEvidence
     */
    readonly cardTransactionEvidenceId: string
}

/**
 * Request parameters for deleteFreeeConnected operation in DefaultApi.
 * @export
 * @interface DefaultApiDeleteFreeeConnectedRequest
 */
export interface DefaultApiDeleteFreeeConnectedRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiDeleteFreeeConnected
     */
    readonly organizationId: string
}

/**
 * Request parameters for deleteFreeeEndJournalEntryTransitionMode operation in DefaultApi.
 * @export
 * @interface DefaultApiDeleteFreeeEndJournalEntryTransitionModeRequest
 */
export interface DefaultApiDeleteFreeeEndJournalEntryTransitionModeRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiDeleteFreeeEndJournalEntryTransitionMode
     */
    readonly organizationId: string
}

/**
 * Request parameters for deleteMerchantGeneralBlockAllowedOrganizationIds operation in DefaultApi.
 * @export
 * @interface DefaultApiDeleteMerchantGeneralBlockAllowedOrganizationIdsRequest
 */
export interface DefaultApiDeleteMerchantGeneralBlockAllowedOrganizationIdsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiDeleteMerchantGeneralBlockAllowedOrganizationIds
     */
    readonly merchantGeneralBlockListId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiDeleteMerchantGeneralBlockAllowedOrganizationIds
     */
    readonly allowedOrganizationId: string
}

/**
 * Request parameters for deleteMerchantGeneralBlockList operation in DefaultApi.
 * @export
 * @interface DefaultApiDeleteMerchantGeneralBlockListRequest
 */
export interface DefaultApiDeleteMerchantGeneralBlockListRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiDeleteMerchantGeneralBlockList
     */
    readonly merchantGeneralBlockListId: string
}

/**
 * Request parameters for deleteMerchantOrgBlockList operation in DefaultApi.
 * @export
 * @interface DefaultApiDeleteMerchantOrgBlockListRequest
 */
export interface DefaultApiDeleteMerchantOrgBlockListRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiDeleteMerchantOrgBlockList
     */
    readonly merchantOrgBlockListId: string
}

/**
 * Request parameters for deleteOnboardingRequest operation in DefaultApi.
 * @export
 * @interface DefaultApiDeleteOnboardingRequestRequest
 */
export interface DefaultApiDeleteOnboardingRequestRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiDeleteOnboardingRequest
     */
    readonly onboardingRequestId: string
}

/**
 * Request parameters for deleteOrganizationCreateRequest operation in DefaultApi.
 * @export
 * @interface DefaultApiDeleteOrganizationCreateRequestRequest
 */
export interface DefaultApiDeleteOrganizationCreateRequestRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiDeleteOrganizationCreateRequest
     */
    readonly organizationCreateRequestId: string
}

/**
 * Request parameters for deletePaymentRequestEvidence operation in DefaultApi.
 * @export
 * @interface DefaultApiDeletePaymentRequestEvidenceRequest
 */
export interface DefaultApiDeletePaymentRequestEvidenceRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiDeletePaymentRequestEvidence
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiDeletePaymentRequestEvidence
     */
    readonly paymentRequestId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiDeletePaymentRequestEvidence
     */
    readonly evidenceId: string
}

/**
 * Request parameters for deletePurchaseApplication operation in DefaultApi.
 * @export
 * @interface DefaultApiDeletePurchaseApplicationRequest
 */
export interface DefaultApiDeletePurchaseApplicationRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiDeletePurchaseApplication
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiDeletePurchaseApplication
     */
    readonly purchaseApplicationId: string
}

/**
 * Request parameters for deletePurchaseApplicationTemplatesDetail operation in DefaultApi.
 * @export
 * @interface DefaultApiDeletePurchaseApplicationTemplatesDetailRequest
 */
export interface DefaultApiDeletePurchaseApplicationTemplatesDetailRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiDeletePurchaseApplicationTemplatesDetail
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiDeletePurchaseApplicationTemplatesDetail
     */
    readonly purchaseTemplateId: string
}

/**
 * Request parameters for deleteSlackNotificationChannelSettingForPurchaseApplication operation in DefaultApi.
 * @export
 * @interface DefaultApiDeleteSlackNotificationChannelSettingForPurchaseApplicationRequest
 */
export interface DefaultApiDeleteSlackNotificationChannelSettingForPurchaseApplicationRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiDeleteSlackNotificationChannelSettingForPurchaseApplication
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiDeleteSlackNotificationChannelSettingForPurchaseApplication
     */
    readonly channelId: string
}

/**
 * Request parameters for deleteSlackNotificationSettingForCard operation in DefaultApi.
 * @export
 * @interface DefaultApiDeleteSlackNotificationSettingForCardRequest
 */
export interface DefaultApiDeleteSlackNotificationSettingForCardRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiDeleteSlackNotificationSettingForCard
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiDeleteSlackNotificationSettingForCard
     */
    readonly channelId: string
}

/**
 * Request parameters for deleteSystemAdminRole operation in DefaultApi.
 * @export
 * @interface DefaultApiDeleteSystemAdminRoleRequest
 */
export interface DefaultApiDeleteSystemAdminRoleRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiDeleteSystemAdminRole
     */
    readonly userId: string
}

/**
 * Request parameters for deleteTeamsNotificationSettingForCard operation in DefaultApi.
 * @export
 * @interface DefaultApiDeleteTeamsNotificationSettingForCardRequest
 */
export interface DefaultApiDeleteTeamsNotificationSettingForCardRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiDeleteTeamsNotificationSettingForCard
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiDeleteTeamsNotificationSettingForCard
     */
    readonly channelId: string
}

/**
 * Request parameters for deleteUserAccountGroup operation in DefaultApi.
 * @export
 * @interface DefaultApiDeleteUserAccountGroupRequest
 */
export interface DefaultApiDeleteUserAccountGroupRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiDeleteUserAccountGroup
     */
    readonly userAccountGroupId: number
}

/**
 * Request parameters for depositGuaranteeMoneyBalance operation in DefaultApi.
 * @export
 * @interface DefaultApiDepositGuaranteeMoneyBalanceRequest
 */
export interface DefaultApiDepositGuaranteeMoneyBalanceRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiDepositGuaranteeMoneyBalance
     */
    readonly organizationId: string

    /**
     * 
     * @type {DepositGuaranteeMoneyBalanceRequest}
     * @memberof DefaultApiDepositGuaranteeMoneyBalance
     */
    readonly depositGuaranteeMoneyBalanceRequest: DepositGuaranteeMoneyBalanceRequest
}

/**
 * Request parameters for disableApproval operation in DefaultApi.
 * @export
 * @interface DefaultApiDisableApprovalRequest
 */
export interface DefaultApiDisableApprovalRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiDisableApproval
     */
    readonly organizationId: string
}

/**
 * Request parameters for disableDailyUserUsageLimit operation in DefaultApi.
 * @export
 * @interface DefaultApiDisableDailyUserUsageLimitRequest
 */
export interface DefaultApiDisableDailyUserUsageLimitRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiDisableDailyUserUsageLimit
     */
    readonly userAccountId: string
}

/**
 * Request parameters for disablePhysicalStorePaymentForTheUserAccount operation in DefaultApi.
 * @export
 * @interface DefaultApiDisablePhysicalStorePaymentForTheUserAccountRequest
 */
export interface DefaultApiDisablePhysicalStorePaymentForTheUserAccountRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiDisablePhysicalStorePaymentForTheUserAccount
     */
    readonly userAccountId: string
}

/**
 * Request parameters for disableTransactionUpperLimitForTheUserAccount operation in DefaultApi.
 * @export
 * @interface DefaultApiDisableTransactionUpperLimitForTheUserAccountRequest
 */
export interface DefaultApiDisableTransactionUpperLimitForTheUserAccountRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiDisableTransactionUpperLimitForTheUserAccount
     */
    readonly userAccountId: string
}

/**
 * Request parameters for disableUserUsageLimit operation in DefaultApi.
 * @export
 * @interface DefaultApiDisableUserUsageLimitRequest
 */
export interface DefaultApiDisableUserUsageLimitRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiDisableUserUsageLimit
     */
    readonly userAccountId: string
}

/**
 * Request parameters for disagreeToAgreementRequest operation in DefaultApi.
 * @export
 * @interface DefaultApiDisagreeToAgreementRequestRequest
 */
export interface DefaultApiDisagreeToAgreementRequestRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiDisagreeToAgreementRequest
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiDisagreeToAgreementRequest
     */
    readonly agreementRequestId: string
}

/**
 * Request parameters for downloadBankTransferFile operation in DefaultApi.
 * @export
 * @interface DefaultApiDownloadBankTransferFileRequest
 */
export interface DefaultApiDownloadBankTransferFileRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiDownloadBankTransferFile
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiDownloadBankTransferFile
     */
    readonly bankTransferId: string
}

/**
 * Request parameters for downloadBankTransfersCsv operation in DefaultApi.
 * @export
 * @interface DefaultApiDownloadBankTransfersCsvRequest
 */
export interface DefaultApiDownloadBankTransfersCsvRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiDownloadBankTransfersCsv
     */
    readonly organizationId: string

    /**
     * yyyy-MM-dd format date in JST. Filter the bank transfers to be returned to only those which are scheduled to be transferred after this date.
     * @type {string}
     * @memberof DefaultApiDownloadBankTransfersCsv
     */
    readonly transferDateJstFrom?: string

    /**
     * yyyy-MM-dd format date in JST. Filter the bank transfers to be returned to only those which are scheduled to be transferred before this date. Both transferDateJstFrom and transferDateJstTo are inclusive (closed interval).
     * @type {string}
     * @memberof DefaultApiDownloadBankTransfersCsv
     */
    readonly transferDateJstTo?: string

    /**
     * Filter the bank transfers by the specified source bank account id.
     * @type {string}
     * @memberof DefaultApiDownloadBankTransfersCsv
     */
    readonly sourceBankAccountId?: string

    /**
     * Filter the bank transfers by whether the corresponding transfer data has been downloaded.
     * @type {boolean}
     * @memberof DefaultApiDownloadBankTransfersCsv
     */
    readonly downloaded?: boolean
}

/**
 * Request parameters for downloadJournalEntryForFreeeCsv operation in DefaultApi.
 * @export
 * @interface DefaultApiDownloadJournalEntryForFreeeCsvRequest
 */
export interface DefaultApiDownloadJournalEntryForFreeeCsvRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiDownloadJournalEntryForFreeeCsv
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiDownloadJournalEntryForFreeeCsv
     */
    readonly yearMonth: string
}

/**
 * Request parameters for downloadOrganizationsAccountingCsv operation in DefaultApi.
 * @export
 * @interface DefaultApiDownloadOrganizationsAccountingCsvRequest
 */
export interface DefaultApiDownloadOrganizationsAccountingCsvRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiDownloadOrganizationsAccountingCsv
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiDownloadOrganizationsAccountingCsv
     */
    readonly yearMonth: string

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiDownloadOrganizationsAccountingCsv
     */
    readonly isMergedFiles: boolean
}

/**
 * Request parameters for downloadPaymentRequestsCsv operation in DefaultApi.
 * @export
 * @interface DefaultApiDownloadPaymentRequestsCsvRequest
 */
export interface DefaultApiDownloadPaymentRequestsCsvRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiDownloadPaymentRequestsCsv
     */
    readonly organizationId: string

    /**
     * yyyy-MM-dd format date in JST. Filter the payment requests to be returned to only those which have a due date after this date.
     * @type {string}
     * @memberof DefaultApiDownloadPaymentRequestsCsv
     */
    readonly dueDateJstFrom?: string

    /**
     * yyyy-MM-dd format date in JST. Filter the payment requests to be returned to only those which have a due date before this date. Both dueDateJstFrom and dueDateJstTo are inclusive (closed interval).
     * @type {string}
     * @memberof DefaultApiDownloadPaymentRequestsCsv
     */
    readonly dueDateJstTo?: string

    /**
     * Filter the payment requests by the specified status.
     * @type {Array<'PENDING_WORKFLOW_COMPLETION' | 'CANCELED' | 'PAYABLE' | 'ATTACHED_TO_BANK_TRANSFER' | 'DEACTIVATED'>}
     * @memberof DefaultApiDownloadPaymentRequestsCsv
     */
    readonly statuses?: Array<'PENDING_WORKFLOW_COMPLETION' | 'CANCELED' | 'PAYABLE' | 'ATTACHED_TO_BANK_TRANSFER' | 'DEACTIVATED'>

    /**
     * Filter the payment requests by the specified supplier id.
     * @type {string}
     * @memberof DefaultApiDownloadPaymentRequestsCsv
     */
    readonly supplierId?: string

    /**
     * Filter the payment requests by whether the corresponding transaction data has been created.
     * @type {boolean}
     * @memberof DefaultApiDownloadPaymentRequestsCsv
     */
    readonly transferDataCreated?: boolean

    /**
     * Filter the payment requests by whether the withholding tax has been applied. true means the withholdingCalculatingMethod is NONE, while false, except for NONE.
     * @type {boolean}
     * @memberof DefaultApiDownloadPaymentRequestsCsv
     */
    readonly withholdingApplied?: boolean

    /**
     * Filter the payment requests by the specified transfer fee responsibility.
     * @type {'SELF' | 'SUPPLIER'}
     * @memberof DefaultApiDownloadPaymentRequestsCsv
     */
    readonly transferFeeResponsibility?: 'SELF' | 'SUPPLIER'

    /**
     * A keyword used to search the following fields for partial matches:  - supplier name  - requestor name  - memo  - accounting items  - sections
     * @type {string}
     * @memberof DefaultApiDownloadPaymentRequestsCsv
     */
    readonly freeWord?: string
}

/**
 * Request parameters for downloadPaymentRequestsCsvForPaymentRequestIdsSpecification operation in DefaultApi.
 * @export
 * @interface DefaultApiDownloadPaymentRequestsCsvForPaymentRequestIdsSpecificationRequest
 */
export interface DefaultApiDownloadPaymentRequestsCsvForPaymentRequestIdsSpecificationRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiDownloadPaymentRequestsCsvForPaymentRequestIdsSpecification
     */
    readonly organizationId: string

    /**
     * 
     * @type {DownloadPaymentRequestsCsvForPaymentRequestIdsSpecificationRequest}
     * @memberof DefaultApiDownloadPaymentRequestsCsvForPaymentRequestIdsSpecification
     */
    readonly downloadPaymentRequestsCsvForPaymentRequestIdsSpecificationRequest?: DownloadPaymentRequestsCsvForPaymentRequestIdsSpecificationRequest
}

/**
 * Request parameters for enablePhysicalStorePaymentForTheUserAccount operation in DefaultApi.
 * @export
 * @interface DefaultApiEnablePhysicalStorePaymentForTheUserAccountRequest
 */
export interface DefaultApiEnablePhysicalStorePaymentForTheUserAccountRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiEnablePhysicalStorePaymentForTheUserAccount
     */
    readonly userAccountId: string
}

/**
 * Request parameters for freezeCard operation in DefaultApi.
 * @export
 * @interface DefaultApiFreezeCardRequest
 */
export interface DefaultApiFreezeCardRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiFreezeCard
     */
    readonly cardId: string
}

/**
 * Request parameters for generateAnnualFeesInvoice operation in DefaultApi.
 * @export
 * @interface DefaultApiGenerateAnnualFeesInvoiceRequest
 */
export interface DefaultApiGenerateAnnualFeesInvoiceRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGenerateAnnualFeesInvoice
     */
    readonly organizationId: string
}

/**
 * Request parameters for generateCreateAccountToken operation in DefaultApi.
 * @export
 * @interface DefaultApiGenerateCreateAccountTokenRequest
 */
export interface DefaultApiGenerateCreateAccountTokenRequest {
    /**
     * 
     * @type {GenerateCreateAccountTokenRequest}
     * @memberof DefaultApiGenerateCreateAccountToken
     */
    readonly generateCreateAccountTokenRequest: GenerateCreateAccountTokenRequest
}

/**
 * Request parameters for generateFreeeRedirectUrl operation in DefaultApi.
 * @export
 * @interface DefaultApiGenerateFreeeRedirectUrlRequest
 */
export interface DefaultApiGenerateFreeeRedirectUrlRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGenerateFreeeRedirectUrl
     */
    readonly organizationId: string
}

/**
 * Request parameters for getACardDetailAsAdmin operation in DefaultApi.
 * @export
 * @interface DefaultApiGetACardDetailAsAdminRequest
 */
export interface DefaultApiGetACardDetailAsAdminRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetACardDetailAsAdmin
     */
    readonly cardId: string
}

/**
 * Request parameters for getAccountingCsvForTheOrganization operation in DefaultApi.
 * @export
 * @interface DefaultApiGetAccountingCsvForTheOrganizationRequest
 */
export interface DefaultApiGetAccountingCsvForTheOrganizationRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetAccountingCsvForTheOrganization
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetAccountingCsvForTheOrganization
     */
    readonly startYearMonth: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetAccountingCsvForTheOrganization
     */
    readonly endYearMonth: string

    /**
     * 
     * @type {'FREEE' | 'MONEY_FORWARD'}
     * @memberof DefaultApiGetAccountingCsvForTheOrganization
     */
    readonly accountingSystemType: 'FREEE' | 'MONEY_FORWARD'
}

/**
 * Request parameters for getAccountingCsvForTheUserAccount operation in DefaultApi.
 * @export
 * @interface DefaultApiGetAccountingCsvForTheUserAccountRequest
 */
export interface DefaultApiGetAccountingCsvForTheUserAccountRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetAccountingCsvForTheUserAccount
     */
    readonly userAccountId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetAccountingCsvForTheUserAccount
     */
    readonly yearMonth: string

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiGetAccountingCsvForTheUserAccount
     */
    readonly isMergedFiles: boolean
}

/**
 * Request parameters for getAdmins operation in DefaultApi.
 * @export
 * @interface DefaultApiGetAdminsRequest
 */
export interface DefaultApiGetAdminsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetAdmins
     */
    readonly organizationId: string
}

/**
 * Request parameters for getAgreementRequests operation in DefaultApi.
 * @export
 * @interface DefaultApiGetAgreementRequestsRequest
 */
export interface DefaultApiGetAgreementRequestsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetAgreementRequests
     */
    readonly organizationId: string

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiGetAgreementRequests
     */
    readonly waitingForAgreement: boolean
}

/**
 * Request parameters for getAnalysisInvoiceOfPaymentRequest operation in DefaultApi.
 * @export
 * @interface DefaultApiGetAnalysisInvoiceOfPaymentRequestRequest
 */
export interface DefaultApiGetAnalysisInvoiceOfPaymentRequestRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetAnalysisInvoiceOfPaymentRequest
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetAnalysisInvoiceOfPaymentRequest
     */
    readonly fileId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetAnalysisInvoiceOfPaymentRequest
     */
    readonly xUpsidrSwitchUser?: string
}

/**
 * Request parameters for getAnnualFeesEligibility operation in DefaultApi.
 * @export
 * @interface DefaultApiGetAnnualFeesEligibilityRequest
 */
export interface DefaultApiGetAnnualFeesEligibilityRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetAnnualFeesEligibility
     */
    readonly organizationId: string
}

/**
 * Request parameters for getApprovers operation in DefaultApi.
 * @export
 * @interface DefaultApiGetApproversRequest
 */
export interface DefaultApiGetApproversRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetApprovers
     */
    readonly userAccountId: string
}

/**
 * Request parameters for getAvailableFeatures operation in DefaultApi.
 * @export
 * @interface DefaultApiGetAvailableFeaturesRequest
 */
export interface DefaultApiGetAvailableFeaturesRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetAvailableFeatures
     */
    readonly organizationId: string
}

/**
 * Request parameters for getBalanceState operation in DefaultApi.
 * @export
 * @interface DefaultApiGetBalanceStateRequest
 */
export interface DefaultApiGetBalanceStateRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetBalanceState
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetBalanceState
     */
    readonly targetDate?: string
}

/**
 * Request parameters for getBankAccountActivities operation in DefaultApi.
 * @export
 * @interface DefaultApiGetBankAccountActivitiesRequest
 */
export interface DefaultApiGetBankAccountActivitiesRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetBankAccountActivities
     */
    readonly bankAccountActivityId: number
}

/**
 * Request parameters for getBankAccountConfirmedActivities operation in DefaultApi.
 * @export
 * @interface DefaultApiGetBankAccountConfirmedActivitiesRequest
 */
export interface DefaultApiGetBankAccountConfirmedActivitiesRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetBankAccountConfirmedActivities
     */
    readonly organizationId: string

    /**
     * 
     * @type {'PAY_BILL' | 'DEPOSIT' | 'WITHDRAWAL' | 'REWARD' | 'USAGE_FEE' | 'POINT' | 'CARD_POINT' | 'CAMPAIGN_POINT' | 'CARD' | 'DEPOSIT_FROM_GUARANTEE_MONEY' | 'WITHDRAWAL_TO_GUARANTEE_MONEY'}
     * @memberof DefaultApiGetBankAccountConfirmedActivities
     */
    readonly type?: 'PAY_BILL' | 'DEPOSIT' | 'WITHDRAWAL' | 'REWARD' | 'USAGE_FEE' | 'POINT' | 'CARD_POINT' | 'CAMPAIGN_POINT' | 'CARD' | 'DEPOSIT_FROM_GUARANTEE_MONEY' | 'WITHDRAWAL_TO_GUARANTEE_MONEY'

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetBankAccountConfirmedActivities
     */
    readonly limit?: number

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetBankAccountConfirmedActivities
     */
    readonly offset?: number
}

/**
 * Request parameters for getBankByName operation in DefaultApi.
 * @export
 * @interface DefaultApiGetBankByNameRequest
 */
export interface DefaultApiGetBankByNameRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetBankByName
     */
    readonly bankName: string
}

/**
 * Request parameters for getBankTransfer operation in DefaultApi.
 * @export
 * @interface DefaultApiGetBankTransferRequest
 */
export interface DefaultApiGetBankTransferRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetBankTransfer
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetBankTransfer
     */
    readonly bankTransferId: string
}

/**
 * Request parameters for getBanksAllBranches operation in DefaultApi.
 * @export
 * @interface DefaultApiGetBanksAllBranchesRequest
 */
export interface DefaultApiGetBanksAllBranchesRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetBanksAllBranches
     */
    readonly bankCode: string
}

/**
 * Request parameters for getBookkeepers operation in DefaultApi.
 * @export
 * @interface DefaultApiGetBookkeepersRequest
 */
export interface DefaultApiGetBookkeepersRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetBookkeepers
     */
    readonly organizationId: string
}

/**
 * Request parameters for getBranch operation in DefaultApi.
 * @export
 * @interface DefaultApiGetBranchRequest
 */
export interface DefaultApiGetBranchRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetBranch
     */
    readonly bankCode: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetBranch
     */
    readonly branchName: string
}

/**
 * Request parameters for getCanActivateCard operation in DefaultApi.
 * @export
 * @interface DefaultApiGetCanActivateCardRequest
 */
export interface DefaultApiGetCanActivateCardRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetCanActivateCard
     */
    readonly organizationId: string
}

/**
 * Request parameters for getCanCloseStatuses operation in DefaultApi.
 * @export
 * @interface DefaultApiGetCanCloseStatusesRequest
 */
export interface DefaultApiGetCanCloseStatusesRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetCanCloseStatuses
     */
    readonly organizationId: string
}

/**
 * Request parameters for getCanDeactivate operation in DefaultApi.
 * @export
 * @interface DefaultApiGetCanDeactivateRequest
 */
export interface DefaultApiGetCanDeactivateRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetCanDeactivate
     */
    readonly userId: string
}

/**
 * Request parameters for getCanRequestSendingCard operation in DefaultApi.
 * @export
 * @interface DefaultApiGetCanRequestSendingCardRequest
 */
export interface DefaultApiGetCanRequestSendingCardRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetCanRequestSendingCard
     */
    readonly organizationId: string
}

/**
 * Request parameters for getCardBill operation in DefaultApi.
 * @export
 * @interface DefaultApiGetCardBillRequest
 */
export interface DefaultApiGetCardBillRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetCardBill
     */
    readonly cardBillId: string
}

/**
 * Request parameters for getCardDetail operation in DefaultApi.
 * @export
 * @interface DefaultApiGetCardDetailRequest
 */
export interface DefaultApiGetCardDetailRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetCardDetail
     */
    readonly cardId: string
}

/**
 * Request parameters for getCardMonthlyTransactions operation in DefaultApi.
 * @export
 * @interface DefaultApiGetCardMonthlyTransactionsRequest
 */
export interface DefaultApiGetCardMonthlyTransactionsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetCardMonthlyTransactions
     */
    readonly userAccountId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetCardMonthlyTransactions
     */
    readonly yearMonth: string
}

/**
 * Request parameters for getCardPointsRateConfigsByOrganizationId operation in DefaultApi.
 * @export
 * @interface DefaultApiGetCardPointsRateConfigsByOrganizationIdRequest
 */
export interface DefaultApiGetCardPointsRateConfigsByOrganizationIdRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetCardPointsRateConfigsByOrganizationId
     */
    readonly organizationId: string
}

/**
 * Request parameters for getCardTransactionDetails operation in DefaultApi.
 * @export
 * @interface DefaultApiGetCardTransactionDetailsRequest
 */
export interface DefaultApiGetCardTransactionDetailsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetCardTransactionDetails
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetCardTransactionDetails
     */
    readonly visaTransactionReferenceId: string
}

/**
 * Request parameters for getCardTransactionEvidenceRecordImage operation in DefaultApi.
 * @export
 * @interface DefaultApiGetCardTransactionEvidenceRecordImageRequest
 */
export interface DefaultApiGetCardTransactionEvidenceRecordImageRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetCardTransactionEvidenceRecordImage
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetCardTransactionEvidenceRecordImage
     */
    readonly paymentReferenceId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetCardTransactionEvidenceRecordImage
     */
    readonly cardTransactionEvidenceId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetCardTransactionEvidenceRecordImage
     */
    readonly id: string

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiGetCardTransactionEvidenceRecordImage
     */
    readonly inPdf?: boolean
}

/**
 * Request parameters for getCardTransactionEvidenceRecords operation in DefaultApi.
 * @export
 * @interface DefaultApiGetCardTransactionEvidenceRecordsRequest
 */
export interface DefaultApiGetCardTransactionEvidenceRecordsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetCardTransactionEvidenceRecords
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetCardTransactionEvidenceRecords
     */
    readonly paymentReferenceId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetCardTransactionEvidenceRecords
     */
    readonly cardTransactionEvidenceId: string
}

/**
 * Request parameters for getCardTransactions operation in DefaultApi.
 * @export
 * @interface DefaultApiGetCardTransactionsRequest
 */
export interface DefaultApiGetCardTransactionsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetCardTransactions
     */
    readonly userAccountId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetCardTransactions
     */
    readonly merchantId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetCardTransactions
     */
    readonly toYearMonth: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetCardTransactions
     */
    readonly fromYearMonth?: string
}

/**
 * Request parameters for getCards operation in DefaultApi.
 * @export
 * @interface DefaultApiGetCardsRequest
 */
export interface DefaultApiGetCardsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetCards
     */
    readonly organizationId: string
}

/**
 * Request parameters for getCardsTransactionsWithPurchaseApplicationUnlinked operation in DefaultApi.
 * @export
 * @interface DefaultApiGetCardsTransactionsWithPurchaseApplicationUnlinkedRequest
 */
export interface DefaultApiGetCardsTransactionsWithPurchaseApplicationUnlinkedRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetCardsTransactionsWithPurchaseApplicationUnlinked
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetCardsTransactionsWithPurchaseApplicationUnlinked
     */
    readonly yearMonth: string
}

/**
 * Request parameters for getCategoryOfThePurchaseApplicationTemplate operation in DefaultApi.
 * @export
 * @interface DefaultApiGetCategoryOfThePurchaseApplicationTemplateRequest
 */
export interface DefaultApiGetCategoryOfThePurchaseApplicationTemplateRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetCategoryOfThePurchaseApplicationTemplate
     */
    readonly organizationId: string
}

/**
 * Request parameters for getComment operation in DefaultApi.
 * @export
 * @interface DefaultApiGetCommentRequest
 */
export interface DefaultApiGetCommentRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetComment
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetComment
     */
    readonly paymentReferenceId: string
}

/**
 * Request parameters for getCommentTemplates operation in DefaultApi.
 * @export
 * @interface DefaultApiGetCommentTemplatesRequest
 */
export interface DefaultApiGetCommentTemplatesRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetCommentTemplates
     */
    readonly organizationId: string
}

/**
 * Request parameters for getCommentTemplatesCommentTemplateId operation in DefaultApi.
 * @export
 * @interface DefaultApiGetCommentTemplatesCommentTemplateIdRequest
 */
export interface DefaultApiGetCommentTemplatesCommentTemplateIdRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetCommentTemplatesCommentTemplateId
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetCommentTemplatesCommentTemplateId
     */
    readonly templateId: string
}

/**
 * Request parameters for getCurrentCardAssociatedWithTheUserAccount operation in DefaultApi.
 * @export
 * @interface DefaultApiGetCurrentCardAssociatedWithTheUserAccountRequest
 */
export interface DefaultApiGetCurrentCardAssociatedWithTheUserAccountRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetCurrentCardAssociatedWithTheUserAccount
     */
    readonly userAccountId: string
}

/**
 * Request parameters for getDealsTotalAmount operation in DefaultApi.
 * @export
 * @interface DefaultApiGetDealsTotalAmountRequest
 */
export interface DefaultApiGetDealsTotalAmountRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetDealsTotalAmount
     */
    readonly organizationId: number

    /**
     * 
     * @type {GetDealsTotalAmountRequest}
     * @memberof DefaultApiGetDealsTotalAmount
     */
    readonly getDealsTotalAmountRequest?: GetDealsTotalAmountRequest
}

/**
 * Request parameters for getDefaultCommentTemplate operation in DefaultApi.
 * @export
 * @interface DefaultApiGetDefaultCommentTemplateRequest
 */
export interface DefaultApiGetDefaultCommentTemplateRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetDefaultCommentTemplate
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetDefaultCommentTemplate
     */
    readonly userAccountId: string
}

/**
 * Request parameters for getDepositBankAccount operation in DefaultApi.
 * @export
 * @interface DefaultApiGetDepositBankAccountRequest
 */
export interface DefaultApiGetDepositBankAccountRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetDepositBankAccount
     */
    readonly organizationId: string
}

/**
 * Request parameters for getDepositRestrictionForOrganization operation in DefaultApi.
 * @export
 * @interface DefaultApiGetDepositRestrictionForOrganizationRequest
 */
export interface DefaultApiGetDepositRestrictionForOrganizationRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetDepositRestrictionForOrganization
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetDepositRestrictionForOrganization
     */
    readonly depositRestrictionId: string
}

/**
 * Request parameters for getDepositRestrictionListForOrganization operation in DefaultApi.
 * @export
 * @interface DefaultApiGetDepositRestrictionListForOrganizationRequest
 */
export interface DefaultApiGetDepositRestrictionListForOrganizationRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetDepositRestrictionListForOrganization
     */
    readonly organizationId: string
}

/**
 * Request parameters for getDraftPaymentRequest operation in DefaultApi.
 * @export
 * @interface DefaultApiGetDraftPaymentRequestRequest
 */
export interface DefaultApiGetDraftPaymentRequestRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetDraftPaymentRequest
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetDraftPaymentRequest
     */
    readonly draftPaymentRequestId: string
}

/**
 * Request parameters for getDraftPaymentRequestEvidenceFile operation in DefaultApi.
 * @export
 * @interface DefaultApiGetDraftPaymentRequestEvidenceFileRequest
 */
export interface DefaultApiGetDraftPaymentRequestEvidenceFileRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetDraftPaymentRequestEvidenceFile
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetDraftPaymentRequestEvidenceFile
     */
    readonly draftPaymentRequestId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetDraftPaymentRequestEvidenceFile
     */
    readonly evidenceId: string

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiGetDraftPaymentRequestEvidenceFile
     */
    readonly inPdf?: boolean
}

/**
 * Request parameters for getDraftPaymentRequestsOnlyCreatedOwn operation in DefaultApi.
 * @export
 * @interface DefaultApiGetDraftPaymentRequestsOnlyCreatedOwnRequest
 */
export interface DefaultApiGetDraftPaymentRequestsOnlyCreatedOwnRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetDraftPaymentRequestsOnlyCreatedOwn
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetDraftPaymentRequestsOnlyCreatedOwn
     */
    readonly xUpsidrSwitchUser?: string

    /**
     * A keyword used to search the following fields for partial matches:  - supplier name  - requestor name  - memo  - accounting items  - sections
     * @type {string}
     * @memberof DefaultApiGetDraftPaymentRequestsOnlyCreatedOwn
     */
    readonly freeWord?: string

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetDraftPaymentRequestsOnlyCreatedOwn
     */
    readonly limit?: number

    /**
     * See the description of &#x60;cursor&#x60; section Pagination
     * @type {number}
     * @memberof DefaultApiGetDraftPaymentRequestsOnlyCreatedOwn
     */
    readonly offset?: number

    /**
     * Pagination is performed by specifying either offset or cursor; if neither offset nor cursor is specified, it is assumed to be cursor-pagination and the first page is obtained with the next cursor. See below how the pagination exactly behaves:  - \&quot;\&quot; ... Get the fist page and return the next cursor  - \&quot;offset&#x3D;50\&quot; ... Get from the specified offset and never return the next cursor  - \&quot;cursor&#x3D;xxx\&quot; ... Get from the specified cursor  - \&quot;offset&#x3D;50&amp;cursor&#x3D;xxx\&quot; ... Ignore the offset and get from the specified cursor
     * @type {string}
     * @memberof DefaultApiGetDraftPaymentRequestsOnlyCreatedOwn
     */
    readonly cursor?: string
}

/**
 * Request parameters for getEarliestExpiringGuaranteeMoneyForOrganization operation in DefaultApi.
 * @export
 * @interface DefaultApiGetEarliestExpiringGuaranteeMoneyForOrganizationRequest
 */
export interface DefaultApiGetEarliestExpiringGuaranteeMoneyForOrganizationRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetEarliestExpiringGuaranteeMoneyForOrganization
     */
    readonly organizationId: string
}

/**
 * Request parameters for getEmailNotifications operation in DefaultApi.
 * @export
 * @interface DefaultApiGetEmailNotificationsRequest
 */
export interface DefaultApiGetEmailNotificationsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetEmailNotifications
     */
    readonly userId: string
}

/**
 * Request parameters for getEvidence operation in DefaultApi.
 * @export
 * @interface DefaultApiGetEvidenceRequest
 */
export interface DefaultApiGetEvidenceRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetEvidence
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetEvidence
     */
    readonly evidenceId: string
}

/**
 * Request parameters for getEvidenceFile operation in DefaultApi.
 * @export
 * @interface DefaultApiGetEvidenceFileRequest
 */
export interface DefaultApiGetEvidenceFileRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetEvidenceFile
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetEvidenceFile
     */
    readonly evidenceId: string

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiGetEvidenceFile
     */
    readonly inPdf?: boolean
}

/**
 * Request parameters for getEvidenceImage operation in DefaultApi.
 * @export
 * @interface DefaultApiGetEvidenceImageRequest
 */
export interface DefaultApiGetEvidenceImageRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetEvidenceImage
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetEvidenceImage
     */
    readonly paymentReferenceId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetEvidenceImage
     */
    readonly cardTransactionEvidenceId: string
}

/**
 * Request parameters for getEvidenceInformationForCardTransactions operation in DefaultApi.
 * @export
 * @interface DefaultApiGetEvidenceInformationForCardTransactionsRequest
 */
export interface DefaultApiGetEvidenceInformationForCardTransactionsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetEvidenceInformationForCardTransactions
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetEvidenceInformationForCardTransactions
     */
    readonly paymentReferenceId: string
}

/**
 * Request parameters for getEvidenceRecordImage operation in DefaultApi.
 * @export
 * @interface DefaultApiGetEvidenceRecordImageRequest
 */
export interface DefaultApiGetEvidenceRecordImageRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetEvidenceRecordImage
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetEvidenceRecordImage
     */
    readonly evidenceId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetEvidenceRecordImage
     */
    readonly recordId: string

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiGetEvidenceRecordImage
     */
    readonly inPdf?: boolean
}

/**
 * Request parameters for getEvidenceRecords operation in DefaultApi.
 * @export
 * @interface DefaultApiGetEvidenceRecordsRequest
 */
export interface DefaultApiGetEvidenceRecordsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetEvidenceRecords
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetEvidenceRecords
     */
    readonly evidenceId: string
}

/**
 * Request parameters for getEvidenceZipForTheOrganization operation in DefaultApi.
 * @export
 * @interface DefaultApiGetEvidenceZipForTheOrganizationRequest
 */
export interface DefaultApiGetEvidenceZipForTheOrganizationRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetEvidenceZipForTheOrganization
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetEvidenceZipForTheOrganization
     */
    readonly yearMonth: string
}

/**
 * Request parameters for getEvidences operation in DefaultApi.
 * @export
 * @interface DefaultApiGetEvidencesRequest
 */
export interface DefaultApiGetEvidencesRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetEvidences
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetEvidences
     */
    readonly paymentReferenceId: string
}

/**
 * Request parameters for getEvidencesCount operation in DefaultApi.
 * @export
 * @interface DefaultApiGetEvidencesCountRequest
 */
export interface DefaultApiGetEvidencesCountRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetEvidencesCount
     */
    readonly organizationId: string

    /**
     * This parameter will be deleted soon. Use keyword instead. If you specify this parameter, it will behave like the keyword, that is, it is searched from note as well as issuer.
     * @type {string}
     * @memberof DefaultApiGetEvidencesCount
     */
    readonly issuer?: string

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetEvidencesCount
     */
    readonly amountMin?: number

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetEvidencesCount
     */
    readonly amountMax?: number

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetEvidencesCount
     */
    readonly paidAtFrom?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetEvidencesCount
     */
    readonly paidAtTo?: string

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiGetEvidencesCount
     */
    readonly irrelevantToLedger?: boolean

    /**
     * Specified keyword is searched from the issuer and the note by partial match.
     * @type {string}
     * @memberof DefaultApiGetEvidencesCount
     */
    readonly keyword?: string

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiGetEvidencesCount
     */
    readonly includesDeleted?: boolean

    /**
     * 
     * @type {Array<'VALID' | 'INVALID' | 'INPUT_REQUIRED' | 'OUT_OF_TARGET'>}
     * @memberof DefaultApiGetEvidencesCount
     */
    readonly legalValidities?: Array<'VALID' | 'INVALID' | 'INPUT_REQUIRED' | 'OUT_OF_TARGET'>
}

/**
 * Request parameters for getFraudLockedCardTransactions operation in DefaultApi.
 * @export
 * @interface DefaultApiGetFraudLockedCardTransactionsRequest
 */
export interface DefaultApiGetFraudLockedCardTransactionsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetFraudLockedCardTransactions
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetFraudLockedCardTransactions
     */
    readonly cardId: string
}

/**
 * Request parameters for getFreeeAccountItems operation in DefaultApi.
 * @export
 * @interface DefaultApiGetFreeeAccountItemsRequest
 */
export interface DefaultApiGetFreeeAccountItemsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetFreeeAccountItems
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetFreeeAccountItems
     */
    readonly companyId: string
}

/**
 * Request parameters for getFreeeCompanies operation in DefaultApi.
 * @export
 * @interface DefaultApiGetFreeeCompaniesRequest
 */
export interface DefaultApiGetFreeeCompaniesRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetFreeeCompanies
     */
    readonly organizationId: string
}

/**
 * Request parameters for getFreeeConnected operation in DefaultApi.
 * @export
 * @interface DefaultApiGetFreeeConnectedRequest
 */
export interface DefaultApiGetFreeeConnectedRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetFreeeConnected
     */
    readonly organizationId: string
}

/**
 * Request parameters for getFreeeConnectedUser operation in DefaultApi.
 * @export
 * @interface DefaultApiGetFreeeConnectedUserRequest
 */
export interface DefaultApiGetFreeeConnectedUserRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetFreeeConnectedUser
     */
    readonly organizationId: string
}

/**
 * Request parameters for getFreeeItems operation in DefaultApi.
 * @export
 * @interface DefaultApiGetFreeeItemsRequest
 */
export interface DefaultApiGetFreeeItemsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetFreeeItems
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetFreeeItems
     */
    readonly companyId: string
}

/**
 * Request parameters for getFreeeMemoTags operation in DefaultApi.
 * @export
 * @interface DefaultApiGetFreeeMemoTagsRequest
 */
export interface DefaultApiGetFreeeMemoTagsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetFreeeMemoTags
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetFreeeMemoTags
     */
    readonly companyId: string
}

/**
 * Request parameters for getFreeePartners operation in DefaultApi.
 * @export
 * @interface DefaultApiGetFreeePartnersRequest
 */
export interface DefaultApiGetFreeePartnersRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetFreeePartners
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetFreeePartners
     */
    readonly companyId: string
}

/**
 * Request parameters for getFreeeSections operation in DefaultApi.
 * @export
 * @interface DefaultApiGetFreeeSectionsRequest
 */
export interface DefaultApiGetFreeeSectionsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetFreeeSections
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetFreeeSections
     */
    readonly companyId: string
}

/**
 * Request parameters for getFreeeSegmentTags operation in DefaultApi.
 * @export
 * @interface DefaultApiGetFreeeSegmentTagsRequest
 */
export interface DefaultApiGetFreeeSegmentTagsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetFreeeSegmentTags
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetFreeeSegmentTags
     */
    readonly companyId: string
}

/**
 * Request parameters for getFreeeSyncStatus operation in DefaultApi.
 * @export
 * @interface DefaultApiGetFreeeSyncStatusRequest
 */
export interface DefaultApiGetFreeeSyncStatusRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetFreeeSyncStatus
     */
    readonly organizationId: string
}

/**
 * Request parameters for getFreeeTags operation in DefaultApi.
 * @export
 * @interface DefaultApiGetFreeeTagsRequest
 */
export interface DefaultApiGetFreeeTagsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetFreeeTags
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetFreeeTags
     */
    readonly companyId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetFreeeTags
     */
    readonly tagName: string
}

/**
 * Request parameters for getFreeeTaxes operation in DefaultApi.
 * @export
 * @interface DefaultApiGetFreeeTaxesRequest
 */
export interface DefaultApiGetFreeeTaxesRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetFreeeTaxes
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetFreeeTaxes
     */
    readonly companyId: string
}

/**
 * Request parameters for getFreeeToken operation in DefaultApi.
 * @export
 * @interface DefaultApiGetFreeeTokenRequest
 */
export interface DefaultApiGetFreeeTokenRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetFreeeToken
     */
    readonly organizationId: string
}

/**
 * Request parameters for getGuaranteeMoneyBalanceHistory operation in DefaultApi.
 * @export
 * @interface DefaultApiGetGuaranteeMoneyBalanceHistoryRequest
 */
export interface DefaultApiGetGuaranteeMoneyBalanceHistoryRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetGuaranteeMoneyBalanceHistory
     */
    readonly organizationId: string

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetGuaranteeMoneyBalanceHistory
     */
    readonly limit?: number

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetGuaranteeMoneyBalanceHistory
     */
    readonly offset?: number
}

/**
 * Request parameters for getGuaranteeMoneyBalanceInformationForOrganization operation in DefaultApi.
 * @export
 * @interface DefaultApiGetGuaranteeMoneyBalanceInformationForOrganizationRequest
 */
export interface DefaultApiGetGuaranteeMoneyBalanceInformationForOrganizationRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetGuaranteeMoneyBalanceInformationForOrganization
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetGuaranteeMoneyBalanceInformationForOrganization
     */
    readonly targetDate?: string
}

/**
 * Request parameters for getGuaranteeMoneyDepositsForOrganization operation in DefaultApi.
 * @export
 * @interface DefaultApiGetGuaranteeMoneyDepositsForOrganizationRequest
 */
export interface DefaultApiGetGuaranteeMoneyDepositsForOrganizationRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetGuaranteeMoneyDepositsForOrganization
     */
    readonly organizationId: string
}

/**
 * Request parameters for getHolidays operation in DefaultApi.
 * @export
 * @interface DefaultApiGetHolidaysRequest
 */
export interface DefaultApiGetHolidaysRequest {
    /**
     * yyyy-MM-dd format date in JST.
     * @type {string}
     * @memberof DefaultApiGetHolidays
     */
    readonly from?: string

    /**
     * yyyy-MM-dd format date in JST.
     * @type {string}
     * @memberof DefaultApiGetHolidays
     */
    readonly to?: string
}

/**
 * Request parameters for getIdentifyVerificationsLatest operation in DefaultApi.
 * @export
 * @interface DefaultApiGetIdentifyVerificationsLatestRequest
 */
export interface DefaultApiGetIdentifyVerificationsLatestRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetIdentifyVerificationsLatest
     */
    readonly organizationId: string
}

/**
 * Request parameters for getIdentityVerifications operation in DefaultApi.
 * @export
 * @interface DefaultApiGetIdentityVerificationsRequest
 */
export interface DefaultApiGetIdentityVerificationsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetIdentityVerifications
     */
    readonly organizationId: string
}

/**
 * Request parameters for getInvoiceList operation in DefaultApi.
 * @export
 * @interface DefaultApiGetInvoiceListRequest
 */
export interface DefaultApiGetInvoiceListRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetInvoiceList
     */
    readonly organizationId: string
}

/**
 * Request parameters for getInvoicePdf operation in DefaultApi.
 * @export
 * @interface DefaultApiGetInvoicePdfRequest
 */
export interface DefaultApiGetInvoicePdfRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetInvoicePdf
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetInvoicePdf
     */
    readonly yearMonth: string
}

/**
 * Request parameters for getIssuableStatus operation in DefaultApi.
 * @export
 * @interface DefaultApiGetIssuableStatusRequest
 */
export interface DefaultApiGetIssuableStatusRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetIssuableStatus
     */
    readonly organizationId: string
}

/**
 * Request parameters for getJwtSso operation in DefaultApi.
 * @export
 * @interface DefaultApiGetJwtSsoRequest
 */
export interface DefaultApiGetJwtSsoRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetJwtSso
     */
    readonly nonce: string
}

/**
 * Request parameters for getLatestTimeOfSyncToFreee operation in DefaultApi.
 * @export
 * @interface DefaultApiGetLatestTimeOfSyncToFreeeRequest
 */
export interface DefaultApiGetLatestTimeOfSyncToFreeeRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetLatestTimeOfSyncToFreee
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetLatestTimeOfSyncToFreee
     */
    readonly companyId: string
}

/**
 * Request parameters for getLockStatusOfEvidences operation in DefaultApi.
 * @export
 * @interface DefaultApiGetLockStatusOfEvidencesRequest
 */
export interface DefaultApiGetLockStatusOfEvidencesRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetLockStatusOfEvidences
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetLockStatusOfEvidences
     */
    readonly yearMonth: string
}

/**
 * Request parameters for getMerchantGeneralBlockDetail operation in DefaultApi.
 * @export
 * @interface DefaultApiGetMerchantGeneralBlockDetailRequest
 */
export interface DefaultApiGetMerchantGeneralBlockDetailRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetMerchantGeneralBlockDetail
     */
    readonly merchantGeneralBlockListId: string
}

/**
 * Request parameters for getMerchantOrgBlockList operation in DefaultApi.
 * @export
 * @interface DefaultApiGetMerchantOrgBlockListRequest
 */
export interface DefaultApiGetMerchantOrgBlockListRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetMerchantOrgBlockList
     */
    readonly organizationId: string
}

/**
 * Request parameters for getMerchantOrganizationUserAccountYearMonthSummary operation in DefaultApi.
 * @export
 * @interface DefaultApiGetMerchantOrganizationUserAccountYearMonthSummaryRequest
 */
export interface DefaultApiGetMerchantOrganizationUserAccountYearMonthSummaryRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetMerchantOrganizationUserAccountYearMonthSummary
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetMerchantOrganizationUserAccountYearMonthSummary
     */
    readonly merchantId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetMerchantOrganizationUserAccountYearMonthSummary
     */
    readonly userAccountId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetMerchantOrganizationUserAccountYearMonthSummary
     */
    readonly toYearMonth: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetMerchantOrganizationUserAccountYearMonthSummary
     */
    readonly fromYearMonth?: string
}

/**
 * Request parameters for getMerchantsCategoryKinds operation in DefaultApi.
 * @export
 * @interface DefaultApiGetMerchantsCategoryKindsRequest
 */
export interface DefaultApiGetMerchantsCategoryKindsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetMerchantsCategoryKinds
     */
    readonly organizationId: string
}

/**
 * Request parameters for getModifiableDailyLimitsForTheUserAccount operation in DefaultApi.
 * @export
 * @interface DefaultApiGetModifiableDailyLimitsForTheUserAccountRequest
 */
export interface DefaultApiGetModifiableDailyLimitsForTheUserAccountRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetModifiableDailyLimitsForTheUserAccount
     */
    readonly userAccountId: string
}

/**
 * Request parameters for getModifiableMonthlyLimitsForTheUserAccount operation in DefaultApi.
 * @export
 * @interface DefaultApiGetModifiableMonthlyLimitsForTheUserAccountRequest
 */
export interface DefaultApiGetModifiableMonthlyLimitsForTheUserAccountRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetModifiableMonthlyLimitsForTheUserAccount
     */
    readonly userAccountId: string
}

/**
 * Request parameters for getModifiableTransactionLimitsForTheUserAccount operation in DefaultApi.
 * @export
 * @interface DefaultApiGetModifiableTransactionLimitsForTheUserAccountRequest
 */
export interface DefaultApiGetModifiableTransactionLimitsForTheUserAccountRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetModifiableTransactionLimitsForTheUserAccount
     */
    readonly userAccountId: string
}

/**
 * Request parameters for getMoneytreeConnected operation in DefaultApi.
 * @export
 * @interface DefaultApiGetMoneytreeConnectedRequest
 */
export interface DefaultApiGetMoneytreeConnectedRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetMoneytreeConnected
     */
    readonly organizationId: string
}

/**
 * Request parameters for getMoneytreeOauthUrl operation in DefaultApi.
 * @export
 * @interface DefaultApiGetMoneytreeOauthUrlRequest
 */
export interface DefaultApiGetMoneytreeOauthUrlRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetMoneytreeOauthUrl
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetMoneytreeOauthUrl
     */
    readonly nextTo?: string
}

/**
 * Request parameters for getMoneytreeStatus operation in DefaultApi.
 * @export
 * @interface DefaultApiGetMoneytreeStatusRequest
 */
export interface DefaultApiGetMoneytreeStatusRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetMoneytreeStatus
     */
    readonly organizationId: string
}

/**
 * Request parameters for getMonthlyCardBill operation in DefaultApi.
 * @export
 * @interface DefaultApiGetMonthlyCardBillRequest
 */
export interface DefaultApiGetMonthlyCardBillRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetMonthlyCardBill
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetMonthlyCardBill
     */
    readonly yearMonth?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetMonthlyCardBill
     */
    readonly startYearMonth?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetMonthlyCardBill
     */
    readonly endYearMonth?: string
}

/**
 * Request parameters for getMonthlyCardTransactionsForTheOrganization operation in DefaultApi.
 * @export
 * @interface DefaultApiGetMonthlyCardTransactionsForTheOrganizationRequest
 */
export interface DefaultApiGetMonthlyCardTransactionsForTheOrganizationRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetMonthlyCardTransactionsForTheOrganization
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetMonthlyCardTransactionsForTheOrganization
     */
    readonly yearMonth: string
}

/**
 * Request parameters for getMonthlyUserCardSummaries operation in DefaultApi.
 * @export
 * @interface DefaultApiGetMonthlyUserCardSummariesRequest
 */
export interface DefaultApiGetMonthlyUserCardSummariesRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetMonthlyUserCardSummaries
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetMonthlyUserCardSummaries
     */
    readonly yearMonth: string
}

/**
 * Request parameters for getOnboardingRequestById operation in DefaultApi.
 * @export
 * @interface DefaultApiGetOnboardingRequestByIdRequest
 */
export interface DefaultApiGetOnboardingRequestByIdRequest {
    /**
     * The ID of the onboarding request to retrieve
     * @type {string}
     * @memberof DefaultApiGetOnboardingRequestById
     */
    readonly onboardingRequestId: string
}

/**
 * Request parameters for getOnboardingRequestPersonalInfo operation in DefaultApi.
 * @export
 * @interface DefaultApiGetOnboardingRequestPersonalInfoRequest
 */
export interface DefaultApiGetOnboardingRequestPersonalInfoRequest {
    /**
     * Onboarding request ID
     * @type {string}
     * @memberof DefaultApiGetOnboardingRequestPersonalInfo
     */
    readonly onboardingRequestId: string
}

/**
 * Request parameters for getOnboardingRequests operation in DefaultApi.
 * @export
 * @interface DefaultApiGetOnboardingRequestsRequest
 */
export interface DefaultApiGetOnboardingRequestsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetOnboardingRequests
     */
    readonly key?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetOnboardingRequests
     */
    readonly createdAtFrom?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetOnboardingRequests
     */
    readonly createdAtTo?: string

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetOnboardingRequests
     */
    readonly limit?: number

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetOnboardingRequests
     */
    readonly offset?: number

    /**
     * 
     * @type {'id' | 'createdAt' | 'updatedAt'}
     * @memberof DefaultApiGetOnboardingRequests
     */
    readonly sort?: 'id' | 'createdAt' | 'updatedAt'

    /**
     * 
     * @type {'ASC' | 'DESC'}
     * @memberof DefaultApiGetOnboardingRequests
     */
    readonly order?: 'ASC' | 'DESC'
}

/**
 * Request parameters for getOrgAccountState operation in DefaultApi.
 * @export
 * @interface DefaultApiGetOrgAccountStateRequest
 */
export interface DefaultApiGetOrgAccountStateRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetOrgAccountState
     */
    readonly organizationId: string
}

/**
 * Request parameters for getOrganization operation in DefaultApi.
 * @export
 * @interface DefaultApiGetOrganizationRequest
 */
export interface DefaultApiGetOrganizationRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetOrganization
     */
    readonly organizationId: string

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiGetOrganization
     */
    readonly underContractOnly?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiGetOrganization
     */
    readonly withCredit?: boolean
}

/**
 * Request parameters for getOrganizationCardsExtended operation in DefaultApi.
 * @export
 * @interface DefaultApiGetOrganizationCardsExtendedRequest
 */
export interface DefaultApiGetOrganizationCardsExtendedRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetOrganizationCardsExtended
     */
    readonly organizationId: string
}

/**
 * Request parameters for getOrganizationCardsLight operation in DefaultApi.
 * @export
 * @interface DefaultApiGetOrganizationCardsLightRequest
 */
export interface DefaultApiGetOrganizationCardsLightRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetOrganizationCardsLight
     */
    readonly organizationId: string
}

/**
 * Request parameters for getOrganizationChartDepartments operation in DefaultApi.
 * @export
 * @interface DefaultApiGetOrganizationChartDepartmentsRequest
 */
export interface DefaultApiGetOrganizationChartDepartmentsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetOrganizationChartDepartments
     */
    readonly organizationId: string
}

/**
 * Request parameters for getOrganizationChartEmployees operation in DefaultApi.
 * @export
 * @interface DefaultApiGetOrganizationChartEmployeesRequest
 */
export interface DefaultApiGetOrganizationChartEmployeesRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetOrganizationChartEmployees
     */
    readonly organizationId: string
}

/**
 * Request parameters for getOrganizationChartRoles operation in DefaultApi.
 * @export
 * @interface DefaultApiGetOrganizationChartRolesRequest
 */
export interface DefaultApiGetOrganizationChartRolesRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetOrganizationChartRoles
     */
    readonly organizationId: string
}

/**
 * Request parameters for getOrganizationCreateRequests operation in DefaultApi.
 * @export
 * @interface DefaultApiGetOrganizationCreateRequestsRequest
 */
export interface DefaultApiGetOrganizationCreateRequestsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetOrganizationCreateRequests
     */
    readonly key?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetOrganizationCreateRequests
     */
    readonly createdAtFrom?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetOrganizationCreateRequests
     */
    readonly createdAtTo?: string

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetOrganizationCreateRequests
     */
    readonly limit?: number

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetOrganizationCreateRequests
     */
    readonly offset?: number

    /**
     * 
     * @type {'id' | 'createdAt' | 'updatedAt'}
     * @memberof DefaultApiGetOrganizationCreateRequests
     */
    readonly sort?: 'id' | 'createdAt' | 'updatedAt'

    /**
     * 
     * @type {'ASC' | 'DESC'}
     * @memberof DefaultApiGetOrganizationCreateRequests
     */
    readonly order?: 'ASC' | 'DESC'
}

/**
 * Request parameters for getOrganizationPayments operation in DefaultApi.
 * @export
 * @interface DefaultApiGetOrganizationPaymentsRequest
 */
export interface DefaultApiGetOrganizationPaymentsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetOrganizationPayments
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetOrganizationPayments
     */
    readonly yearMonth?: string
}

/**
 * Request parameters for getOrganizationsAccountingCsvExportFields operation in DefaultApi.
 * @export
 * @interface DefaultApiGetOrganizationsAccountingCsvExportFieldsRequest
 */
export interface DefaultApiGetOrganizationsAccountingCsvExportFieldsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetOrganizationsAccountingCsvExportFields
     */
    readonly organizationId: string
}

/**
 * Request parameters for getOrganizationsBills operation in DefaultApi.
 * @export
 * @interface DefaultApiGetOrganizationsBillsRequest
 */
export interface DefaultApiGetOrganizationsBillsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetOrganizationsBills
     */
    readonly organizationId: string

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiGetOrganizationsBills
     */
    readonly beforeReservationOnly?: boolean

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetOrganizationsBills
     */
    readonly limit?: number

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetOrganizationsBills
     */
    readonly offset?: number
}

/**
 * Request parameters for getOrganizationsDeals operation in DefaultApi.
 * @export
 * @interface DefaultApiGetOrganizationsDealsRequest
 */
export interface DefaultApiGetOrganizationsDealsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetOrganizationsDeals
     */
    readonly organizationId: string
}

/**
 * Request parameters for getPaymentRequestDetail operation in DefaultApi.
 * @export
 * @interface DefaultApiGetPaymentRequestDetailRequest
 */
export interface DefaultApiGetPaymentRequestDetailRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetPaymentRequestDetail
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetPaymentRequestDetail
     */
    readonly paymentRequestId?: string
}

/**
 * Request parameters for getPaymentRequestEvidence operation in DefaultApi.
 * @export
 * @interface DefaultApiGetPaymentRequestEvidenceRequest
 */
export interface DefaultApiGetPaymentRequestEvidenceRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetPaymentRequestEvidence
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetPaymentRequestEvidence
     */
    readonly paymentRequestId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetPaymentRequestEvidence
     */
    readonly evidenceId: string
}

/**
 * Request parameters for getPaymentRequestEvidenceFile operation in DefaultApi.
 * @export
 * @interface DefaultApiGetPaymentRequestEvidenceFileRequest
 */
export interface DefaultApiGetPaymentRequestEvidenceFileRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetPaymentRequestEvidenceFile
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetPaymentRequestEvidenceFile
     */
    readonly paymentRequestId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetPaymentRequestEvidenceFile
     */
    readonly evidenceId: string

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiGetPaymentRequestEvidenceFile
     */
    readonly inPdf?: boolean
}

/**
 * Request parameters for getPaymentRequestEvidenceRecordFile operation in DefaultApi.
 * @export
 * @interface DefaultApiGetPaymentRequestEvidenceRecordFileRequest
 */
export interface DefaultApiGetPaymentRequestEvidenceRecordFileRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetPaymentRequestEvidenceRecordFile
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetPaymentRequestEvidenceRecordFile
     */
    readonly paymentRequestId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetPaymentRequestEvidenceRecordFile
     */
    readonly evidenceId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetPaymentRequestEvidenceRecordFile
     */
    readonly recordId: string

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiGetPaymentRequestEvidenceRecordFile
     */
    readonly inPdf?: boolean
}

/**
 * Request parameters for getPaymentRequestEvidenceRecords operation in DefaultApi.
 * @export
 * @interface DefaultApiGetPaymentRequestEvidenceRecordsRequest
 */
export interface DefaultApiGetPaymentRequestEvidenceRecordsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetPaymentRequestEvidenceRecords
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetPaymentRequestEvidenceRecords
     */
    readonly paymentRequestId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetPaymentRequestEvidenceRecords
     */
    readonly evidenceId: string
}

/**
 * Request parameters for getPaymentRequestEvidences operation in DefaultApi.
 * @export
 * @interface DefaultApiGetPaymentRequestEvidencesRequest
 */
export interface DefaultApiGetPaymentRequestEvidencesRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetPaymentRequestEvidences
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetPaymentRequestEvidences
     */
    readonly paymentRequestId: string
}

/**
 * Request parameters for getPaymentRequestsBankAccountsList operation in DefaultApi.
 * @export
 * @interface DefaultApiGetPaymentRequestsBankAccountsListRequest
 */
export interface DefaultApiGetPaymentRequestsBankAccountsListRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetPaymentRequestsBankAccountsList
     */
    readonly organizationId: string
}

/**
 * Request parameters for getPaymentRequestsCountLinkedBankTransfer operation in DefaultApi.
 * @export
 * @interface DefaultApiGetPaymentRequestsCountLinkedBankTransferRequest
 */
export interface DefaultApiGetPaymentRequestsCountLinkedBankTransferRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetPaymentRequestsCountLinkedBankTransfer
     */
    readonly organizationId: string

    /**
     * When specifying more than one, separate them by commas.
     * @type {string}
     * @memberof DefaultApiGetPaymentRequestsCountLinkedBankTransfer
     */
    readonly paymentRequestIds: string
}

/**
 * Request parameters for getPinretrieverDecryptPinBlock operation in DefaultApi.
 * @export
 * @interface DefaultApiGetPinretrieverDecryptPinBlockRequest
 */
export interface DefaultApiGetPinretrieverDecryptPinBlockRequest {
    /**
     * 
     * @type {GetPinretrieverDecryptPinBlockRequest}
     * @memberof DefaultApiGetPinretrieverDecryptPinBlock
     */
    readonly getPinretrieverDecryptPinBlockRequest: GetPinretrieverDecryptPinBlockRequest
}

/**
 * Request parameters for getPinretrieverEncryptPin operation in DefaultApi.
 * @export
 * @interface DefaultApiGetPinretrieverEncryptPinRequest
 */
export interface DefaultApiGetPinretrieverEncryptPinRequest {
    /**
     * 
     * @type {GetPinretrieverEncryptPinRequest}
     * @memberof DefaultApiGetPinretrieverEncryptPin
     */
    readonly getPinretrieverEncryptPinRequest: GetPinretrieverEncryptPinRequest
}

/**
 * Request parameters for getPurchaseApplication operation in DefaultApi.
 * @export
 * @interface DefaultApiGetPurchaseApplicationRequest
 */
export interface DefaultApiGetPurchaseApplicationRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetPurchaseApplication
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetPurchaseApplication
     */
    readonly purchaseApplicationId: string
}

/**
 * Request parameters for getPurchaseApplicationTemplates operation in DefaultApi.
 * @export
 * @interface DefaultApiGetPurchaseApplicationTemplatesRequest
 */
export interface DefaultApiGetPurchaseApplicationTemplatesRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetPurchaseApplicationTemplates
     */
    readonly organizationId: string
}

/**
 * Request parameters for getPurchaseApplicationTemplatesDetail operation in DefaultApi.
 * @export
 * @interface DefaultApiGetPurchaseApplicationTemplatesDetailRequest
 */
export interface DefaultApiGetPurchaseApplicationTemplatesDetailRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetPurchaseApplicationTemplatesDetail
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetPurchaseApplicationTemplatesDetail
     */
    readonly purchaseTemplateId: string
}

/**
 * Request parameters for getPurchaseApplications operation in DefaultApi.
 * @export
 * @interface DefaultApiGetPurchaseApplicationsRequest
 */
export interface DefaultApiGetPurchaseApplicationsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetPurchaseApplications
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetPurchaseApplications
     */
    readonly yearMonth?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetPurchaseApplications
     */
    readonly visaTransactionReferenceId?: string
}

/**
 * Request parameters for getPurchaseApplicationsRequestedCount operation in DefaultApi.
 * @export
 * @interface DefaultApiGetPurchaseApplicationsRequestedCountRequest
 */
export interface DefaultApiGetPurchaseApplicationsRequestedCountRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetPurchaseApplicationsRequestedCount
     */
    readonly userId: string
}

/**
 * Request parameters for getPurchaseApplicationsRequestedList operation in DefaultApi.
 * @export
 * @interface DefaultApiGetPurchaseApplicationsRequestedListRequest
 */
export interface DefaultApiGetPurchaseApplicationsRequestedListRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetPurchaseApplicationsRequestedList
     */
    readonly userId: string
}

/**
 * Request parameters for getPurchaseApplicationsSubmittedSelf operation in DefaultApi.
 * @export
 * @interface DefaultApiGetPurchaseApplicationsSubmittedSelfRequest
 */
export interface DefaultApiGetPurchaseApplicationsSubmittedSelfRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetPurchaseApplicationsSubmittedSelf
     */
    readonly userId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetPurchaseApplicationsSubmittedSelf
     */
    readonly yearMonth: string
}

/**
 * Request parameters for getQualifiedInvoiceIssuer operation in DefaultApi.
 * @export
 * @interface DefaultApiGetQualifiedInvoiceIssuerRequest
 */
export interface DefaultApiGetQualifiedInvoiceIssuerRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetQualifiedInvoiceIssuer
     */
    readonly registrationNumber: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetQualifiedInvoiceIssuer
     */
    readonly issuerName?: string
}

/**
 * Request parameters for getRedirectUrlFromTinyUrl operation in DefaultApi.
 * @export
 * @interface DefaultApiGetRedirectUrlFromTinyUrlRequest
 */
export interface DefaultApiGetRedirectUrlFromTinyUrlRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetRedirectUrlFromTinyUrl
     */
    readonly tinyUrlParam: string
}

/**
 * Request parameters for getRewardPointBalance operation in DefaultApi.
 * @export
 * @interface DefaultApiGetRewardPointBalanceRequest
 */
export interface DefaultApiGetRewardPointBalanceRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetRewardPointBalance
     */
    readonly organizationId: string
}

/**
 * Request parameters for getRewardPointTransactions operation in DefaultApi.
 * @export
 * @interface DefaultApiGetRewardPointTransactionsRequest
 */
export interface DefaultApiGetRewardPointTransactionsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetRewardPointTransactions
     */
    readonly organizationId: string
}

/**
 * Request parameters for getRoleResourceForUser operation in DefaultApi.
 * @export
 * @interface DefaultApiGetRoleResourceForUserRequest
 */
export interface DefaultApiGetRoleResourceForUserRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetRoleResourceForUser
     */
    readonly userId: string
}

/**
 * Request parameters for getRoles operation in DefaultApi.
 * @export
 * @interface DefaultApiGetRolesRequest
 */
export interface DefaultApiGetRolesRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetRoles
     */
    readonly category: string
}

/**
 * Request parameters for getRolesWithTopRelatedResources operation in DefaultApi.
 * @export
 * @interface DefaultApiGetRolesWithTopRelatedResourcesRequest
 */
export interface DefaultApiGetRolesWithTopRelatedResourcesRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetRolesWithTopRelatedResources
     */
    readonly resourceScope: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetRolesWithTopRelatedResources
     */
    readonly resourceId: string
}

/**
 * Request parameters for getRolesWithTopRelatedResourcesByOrganizationId operation in DefaultApi.
 * @export
 * @interface DefaultApiGetRolesWithTopRelatedResourcesByOrganizationIdRequest
 */
export interface DefaultApiGetRolesWithTopRelatedResourcesByOrganizationIdRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetRolesWithTopRelatedResourcesByOrganizationId
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetRolesWithTopRelatedResourcesByOrganizationId
     */
    readonly resourceScope: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetRolesWithTopRelatedResourcesByOrganizationId
     */
    readonly resourceId: string
}

/**
 * Request parameters for getSlackCardNotificationSettings operation in DefaultApi.
 * @export
 * @interface DefaultApiGetSlackCardNotificationSettingsRequest
 */
export interface DefaultApiGetSlackCardNotificationSettingsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetSlackCardNotificationSettings
     */
    readonly organizationId: string
}

/**
 * Request parameters for getSlackChannel operation in DefaultApi.
 * @export
 * @interface DefaultApiGetSlackChannelRequest
 */
export interface DefaultApiGetSlackChannelRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetSlackChannel
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetSlackChannel
     */
    readonly channelId: string
}

/**
 * Request parameters for getSlackChannels operation in DefaultApi.
 * @export
 * @interface DefaultApiGetSlackChannelsRequest
 */
export interface DefaultApiGetSlackChannelsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetSlackChannels
     */
    readonly organizationId: string
}

/**
 * Request parameters for getSlackChannelsWithCursor operation in DefaultApi.
 * @export
 * @interface DefaultApiGetSlackChannelsWithCursorRequest
 */
export interface DefaultApiGetSlackChannelsWithCursorRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetSlackChannelsWithCursor
     */
    readonly organizationId: string

    /**
     * This is used to provide paging in a cursor mode. If any value is specified, the channel after the cursor is retrieved; if the value is null, the first page is returned.
     * @type {string}
     * @memberof DefaultApiGetSlackChannelsWithCursor
     */
    readonly cursor?: string
}

/**
 * Request parameters for getSlackEvidenceReminder operation in DefaultApi.
 * @export
 * @interface DefaultApiGetSlackEvidenceReminderRequest
 */
export interface DefaultApiGetSlackEvidenceReminderRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetSlackEvidenceReminder
     */
    readonly organizationId: string
}

/**
 * Request parameters for getSlackEvidenceReminderPerChannel operation in DefaultApi.
 * @export
 * @interface DefaultApiGetSlackEvidenceReminderPerChannelRequest
 */
export interface DefaultApiGetSlackEvidenceReminderPerChannelRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetSlackEvidenceReminderPerChannel
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetSlackEvidenceReminderPerChannel
     */
    readonly channelId: string
}

/**
 * Request parameters for getSlackNotificationChannelSettingForPurchaseApplication operation in DefaultApi.
 * @export
 * @interface DefaultApiGetSlackNotificationChannelSettingForPurchaseApplicationRequest
 */
export interface DefaultApiGetSlackNotificationChannelSettingForPurchaseApplicationRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetSlackNotificationChannelSettingForPurchaseApplication
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetSlackNotificationChannelSettingForPurchaseApplication
     */
    readonly channelId: string
}

/**
 * Request parameters for getSlackNotificationSettingsForPurchaseApplication operation in DefaultApi.
 * @export
 * @interface DefaultApiGetSlackNotificationSettingsForPurchaseApplicationRequest
 */
export interface DefaultApiGetSlackNotificationSettingsForPurchaseApplicationRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetSlackNotificationSettingsForPurchaseApplication
     */
    readonly organizationId: string
}

/**
 * Request parameters for getSlackTeam operation in DefaultApi.
 * @export
 * @interface DefaultApiGetSlackTeamRequest
 */
export interface DefaultApiGetSlackTeamRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetSlackTeam
     */
    readonly organizationId: string
}

/**
 * Request parameters for getSubmittedTrustdockData operation in DefaultApi.
 * @export
 * @interface DefaultApiGetSubmittedTrustdockDataRequest
 */
export interface DefaultApiGetSubmittedTrustdockDataRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetSubmittedTrustdockData
     */
    readonly trustdockIdentificationId: string
}

/**
 * Request parameters for getSuspiciousTransactions operation in DefaultApi.
 * @export
 * @interface DefaultApiGetSuspiciousTransactionsRequest
 */
export interface DefaultApiGetSuspiciousTransactionsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetSuspiciousTransactions
     */
    readonly userAccountId: string
}

/**
 * Request parameters for getTeamsCardNotificationSettings operation in DefaultApi.
 * @export
 * @interface DefaultApiGetTeamsCardNotificationSettingsRequest
 */
export interface DefaultApiGetTeamsCardNotificationSettingsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetTeamsCardNotificationSettings
     */
    readonly organizationId: string
}

/**
 * Request parameters for getTeamsChannel operation in DefaultApi.
 * @export
 * @interface DefaultApiGetTeamsChannelRequest
 */
export interface DefaultApiGetTeamsChannelRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetTeamsChannel
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetTeamsChannel
     */
    readonly channelId: string
}

/**
 * Request parameters for getTeamsChannelsWithCursor operation in DefaultApi.
 * @export
 * @interface DefaultApiGetTeamsChannelsWithCursorRequest
 */
export interface DefaultApiGetTeamsChannelsWithCursorRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetTeamsChannelsWithCursor
     */
    readonly organizationId: string

    /**
     * This is used to provide paging in a cursor mode. If any value is specified, the channel after the cursor is retrieved; if the value is null, the first page is returned.
     * @type {string}
     * @memberof DefaultApiGetTeamsChannelsWithCursor
     */
    readonly cursor?: string
}

/**
 * Request parameters for getTeamsTeam operation in DefaultApi.
 * @export
 * @interface DefaultApiGetTeamsTeamRequest
 */
export interface DefaultApiGetTeamsTeamRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetTeamsTeam
     */
    readonly organizationId: string
}

/**
 * Request parameters for getTheCountOfMonthlyTransactionsForTheUserAccount operation in DefaultApi.
 * @export
 * @interface DefaultApiGetTheCountOfMonthlyTransactionsForTheUserAccountRequest
 */
export interface DefaultApiGetTheCountOfMonthlyTransactionsForTheUserAccountRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetTheCountOfMonthlyTransactionsForTheUserAccount
     */
    readonly userAccountId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetTheCountOfMonthlyTransactionsForTheUserAccount
     */
    readonly yearMonth: string
}

/**
 * Request parameters for getTheUserAccountInformation operation in DefaultApi.
 * @export
 * @interface DefaultApiGetTheUserAccountInformationRequest
 */
export interface DefaultApiGetTheUserAccountInformationRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetTheUserAccountInformation
     */
    readonly userAccountId: string
}

/**
 * Request parameters for getTransactionEvidenceEmailAddress operation in DefaultApi.
 * @export
 * @interface DefaultApiGetTransactionEvidenceEmailAddressRequest
 */
export interface DefaultApiGetTransactionEvidenceEmailAddressRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetTransactionEvidenceEmailAddress
     */
    readonly userAccountId: string
}

/**
 * Request parameters for getTransactionEvidenceEmailFile operation in DefaultApi.
 * @export
 * @interface DefaultApiGetTransactionEvidenceEmailFileRequest
 */
export interface DefaultApiGetTransactionEvidenceEmailFileRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetTransactionEvidenceEmailFile
     */
    readonly userAccountId: string

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetTransactionEvidenceEmailFile
     */
    readonly transactionEvidenceEmailFileId: number
}

/**
 * Request parameters for getTransactionEvidenceEmails operation in DefaultApi.
 * @export
 * @interface DefaultApiGetTransactionEvidenceEmailsRequest
 */
export interface DefaultApiGetTransactionEvidenceEmailsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetTransactionEvidenceEmails
     */
    readonly userAccountId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetTransactionEvidenceEmails
     */
    readonly startYearMonth: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetTransactionEvidenceEmails
     */
    readonly endYearMonth: string

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiGetTransactionEvidenceEmails
     */
    readonly isTrash?: boolean
}

/**
 * Request parameters for getTrustdockIdentityVerifications operation in DefaultApi.
 * @export
 * @interface DefaultApiGetTrustdockIdentityVerificationsRequest
 */
export interface DefaultApiGetTrustdockIdentityVerificationsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetTrustdockIdentityVerifications
     */
    readonly trustdockIdentificationId: string
}

/**
 * Request parameters for getTrustdockSubmitIdentificationDocumentPublishUrl operation in DefaultApi.
 * @export
 * @interface DefaultApiGetTrustdockSubmitIdentificationDocumentPublishUrlRequest
 */
export interface DefaultApiGetTrustdockSubmitIdentificationDocumentPublishUrlRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetTrustdockSubmitIdentificationDocumentPublishUrl
     */
    readonly trustdockIdentificationId: string
}

/**
 * Request parameters for getTrustdockVerifications operation in DefaultApi.
 * @export
 * @interface DefaultApiGetTrustdockVerificationsRequest
 */
export interface DefaultApiGetTrustdockVerificationsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetTrustdockVerifications
     */
    readonly trustdockIdentificationId: string
}

/**
 * Request parameters for getUnreadMessageCount operation in DefaultApi.
 * @export
 * @interface DefaultApiGetUnreadMessageCountRequest
 */
export interface DefaultApiGetUnreadMessageCountRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetUnreadMessageCount
     */
    readonly userId: string
}

/**
 * Request parameters for getUsageFee operation in DefaultApi.
 * @export
 * @interface DefaultApiGetUsageFeeRequest
 */
export interface DefaultApiGetUsageFeeRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetUsageFee
     */
    readonly usageFeeId: number
}

/**
 * Request parameters for getUserAccountGroups operation in DefaultApi.
 * @export
 * @interface DefaultApiGetUserAccountGroupsRequest
 */
export interface DefaultApiGetUserAccountGroupsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetUserAccountGroups
     */
    readonly organizationId: string
}

/**
 * Request parameters for getUserAccountYearMonthSummary operation in DefaultApi.
 * @export
 * @interface DefaultApiGetUserAccountYearMonthSummaryRequest
 */
export interface DefaultApiGetUserAccountYearMonthSummaryRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetUserAccountYearMonthSummary
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetUserAccountYearMonthSummary
     */
    readonly toYearMonth: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetUserAccountYearMonthSummary
     */
    readonly fromYearMonth?: string
}

/**
 * Request parameters for getUserAccountsWithDefaultCommentTemplate operation in DefaultApi.
 * @export
 * @interface DefaultApiGetUserAccountsWithDefaultCommentTemplateRequest
 */
export interface DefaultApiGetUserAccountsWithDefaultCommentTemplateRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetUserAccountsWithDefaultCommentTemplate
     */
    readonly organizationId: string
}

/**
 * Request parameters for getUserCards operation in DefaultApi.
 * @export
 * @interface DefaultApiGetUserCardsRequest
 */
export interface DefaultApiGetUserCardsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetUserCards
     */
    readonly userId: string
}

/**
 * Request parameters for getUserCardsExtended operation in DefaultApi.
 * @export
 * @interface DefaultApiGetUserCardsExtendedRequest
 */
export interface DefaultApiGetUserCardsExtendedRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetUserCardsExtended
     */
    readonly userId: string
}

/**
 * Request parameters for getUserCardsExtendedForRoleResources operation in DefaultApi.
 * @export
 * @interface DefaultApiGetUserCardsExtendedForRoleResourcesRequest
 */
export interface DefaultApiGetUserCardsExtendedForRoleResourcesRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetUserCardsExtendedForRoleResources
     */
    readonly userId: string
}

/**
 * Request parameters for getUserCardsLight operation in DefaultApi.
 * @export
 * @interface DefaultApiGetUserCardsLightRequest
 */
export interface DefaultApiGetUserCardsLightRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetUserCardsLight
     */
    readonly userId: string
}

/**
 * Request parameters for getUserCardsLightForRoleResources operation in DefaultApi.
 * @export
 * @interface DefaultApiGetUserCardsLightForRoleResourcesRequest
 */
export interface DefaultApiGetUserCardsLightForRoleResourcesRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetUserCardsLightForRoleResources
     */
    readonly userId: string
}

/**
 * Request parameters for getUserMessageDetail operation in DefaultApi.
 * @export
 * @interface DefaultApiGetUserMessageDetailRequest
 */
export interface DefaultApiGetUserMessageDetailRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetUserMessageDetail
     */
    readonly userMessageId: string
}

/**
 * Request parameters for getUserMessages operation in DefaultApi.
 * @export
 * @interface DefaultApiGetUserMessagesRequest
 */
export interface DefaultApiGetUserMessagesRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetUserMessages
     */
    readonly userId: string

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetUserMessages
     */
    readonly offset: number

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetUserMessages
     */
    readonly limit: number
}

/**
 * Request parameters for getUsers operation in DefaultApi.
 * @export
 * @interface DefaultApiGetUsersRequest
 */
export interface DefaultApiGetUsersRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetUsers
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetUsers
     */
    readonly email?: string
}

/**
 * Request parameters for getZeusOrganizationIdentityVerificationsForPresident operation in DefaultApi.
 * @export
 * @interface DefaultApiGetZeusOrganizationIdentityVerificationsForPresidentRequest
 */
export interface DefaultApiGetZeusOrganizationIdentityVerificationsForPresidentRequest {
    /**
     * 組織ID
     * @type {string}
     * @memberof DefaultApiGetZeusOrganizationIdentityVerificationsForPresident
     */
    readonly organizationId: string
}

/**
 * Request parameters for getZeusOrganizations operation in DefaultApi.
 * @export
 * @interface DefaultApiGetZeusOrganizationsRequest
 */
export interface DefaultApiGetZeusOrganizationsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetZeusOrganizations
     */
    readonly key?: string

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetZeusOrganizations
     */
    readonly limit?: number

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetZeusOrganizations
     */
    readonly offset?: number

    /**
     * 
     * @type {'ASC' | 'DESC'}
     * @memberof DefaultApiGetZeusOrganizations
     */
    readonly sort?: 'ASC' | 'DESC'

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiGetZeusOrganizations
     */
    readonly connectedMoneytree?: boolean

    /**
     * 
     * @type {'UPSIDER' | 'PRESIDENT_CARD'}
     * @memberof DefaultApiGetZeusOrganizations
     */
    readonly brandType?: 'UPSIDER' | 'PRESIDENT_CARD'
}

/**
 * Request parameters for linkingPurchaseToTransaction operation in DefaultApi.
 * @export
 * @interface DefaultApiLinkingPurchaseToTransactionRequest
 */
export interface DefaultApiLinkingPurchaseToTransactionRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiLinkingPurchaseToTransaction
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiLinkingPurchaseToTransaction
     */
    readonly purchaseApplicationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiLinkingPurchaseToTransaction
     */
    readonly visaTransactionReferenceId?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiLinkingPurchaseToTransaction
     */
    readonly userAccountId?: string
}

/**
 * Request parameters for lockCardForPotentialFraud operation in DefaultApi.
 * @export
 * @interface DefaultApiLockCardForPotentialFraudRequest
 */
export interface DefaultApiLockCardForPotentialFraudRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiLockCardForPotentialFraud
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiLockCardForPotentialFraud
     */
    readonly cardId: string

    /**
     * 
     * @type {LockCardForPotentialFraudRequest}
     * @memberof DefaultApiLockCardForPotentialFraud
     */
    readonly lockCardForPotentialFraudRequest: LockCardForPotentialFraudRequest
}

/**
 * Request parameters for lockCardOnFraudDetected operation in DefaultApi.
 * @export
 * @interface DefaultApiLockCardOnFraudDetectedRequest
 */
export interface DefaultApiLockCardOnFraudDetectedRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiLockCardOnFraudDetected
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiLockCardOnFraudDetected
     */
    readonly cardId: string

    /**
     * 
     * @type {LockCardOnFraudDetectedRequest}
     * @memberof DefaultApiLockCardOnFraudDetected
     */
    readonly lockCardOnFraudDetectedRequest: LockCardOnFraudDetectedRequest
}

/**
 * Request parameters for login operation in DefaultApi.
 * @export
 * @interface DefaultApiLoginRequest
 */
export interface DefaultApiLoginRequest {
    /**
     * 
     * @type {LoginRequest}
     * @memberof DefaultApiLogin
     */
    readonly loginRequest: LoginRequest
}

/**
 * Request parameters for loginApp operation in DefaultApi.
 * @export
 * @interface DefaultApiLoginAppRequest
 */
export interface DefaultApiLoginAppRequest {
    /**
     * 
     * @type {LoginAppRequest}
     * @memberof DefaultApiLoginApp
     */
    readonly loginAppRequest: LoginAppRequest
}

/**
 * Request parameters for loginRecoveryCode operation in DefaultApi.
 * @export
 * @interface DefaultApiLoginRecoveryCodeRequest
 */
export interface DefaultApiLoginRecoveryCodeRequest {
    /**
     * 
     * @type {LoginRecoveryCodeRequest}
     * @memberof DefaultApiLoginRecoveryCode
     */
    readonly loginRecoveryCodeRequest: LoginRecoveryCodeRequest
}

/**
 * Request parameters for loginSms operation in DefaultApi.
 * @export
 * @interface DefaultApiLoginSmsRequest
 */
export interface DefaultApiLoginSmsRequest {
    /**
     * 
     * @type {LoginSmsRequest}
     * @memberof DefaultApiLoginSms
     */
    readonly loginSmsRequest: LoginSmsRequest
}

/**
 * Request parameters for moveSlackNotificationSettingForCard operation in DefaultApi.
 * @export
 * @interface DefaultApiMoveSlackNotificationSettingForCardRequest
 */
export interface DefaultApiMoveSlackNotificationSettingForCardRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiMoveSlackNotificationSettingForCard
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiMoveSlackNotificationSettingForCard
     */
    readonly currentChannelId: string

    /**
     * 
     * @type {MoveSlackNotificationSettingForCardRequest}
     * @memberof DefaultApiMoveSlackNotificationSettingForCard
     */
    readonly moveSlackNotificationSettingForCardRequest: MoveSlackNotificationSettingForCardRequest
}

/**
 * Request parameters for moveTeamsNotificationSettingForCard operation in DefaultApi.
 * @export
 * @interface DefaultApiMoveTeamsNotificationSettingForCardRequest
 */
export interface DefaultApiMoveTeamsNotificationSettingForCardRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiMoveTeamsNotificationSettingForCard
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiMoveTeamsNotificationSettingForCard
     */
    readonly currentChannelId: string

    /**
     * 
     * @type {MoveTeamsNotificationSettingForCardRequest}
     * @memberof DefaultApiMoveTeamsNotificationSettingForCard
     */
    readonly moveTeamsNotificationSettingForCardRequest: MoveTeamsNotificationSettingForCardRequest
}

/**
 * Request parameters for organizationCreatePreRequest operation in DefaultApi.
 * @export
 * @interface DefaultApiOrganizationCreatePreRequestRequest
 */
export interface DefaultApiOrganizationCreatePreRequestRequest {
    /**
     * 
     * @type {OrganizationCreatePreRequestRequest}
     * @memberof DefaultApiOrganizationCreatePreRequest
     */
    readonly organizationCreatePreRequestRequest: OrganizationCreatePreRequestRequest
}

/**
 * Request parameters for parseOrganizationChartForWorkflow operation in DefaultApi.
 * @export
 * @interface DefaultApiParseOrganizationChartForWorkflowRequest
 */
export interface DefaultApiParseOrganizationChartForWorkflowRequest {
    /**
     * 
     * @type {File}
     * @memberof DefaultApiParseOrganizationChartForWorkflow
     */
    readonly file: File
}

/**
 * Request parameters for postAdditionMerchantGeneralBlockList operation in DefaultApi.
 * @export
 * @interface DefaultApiPostAdditionMerchantGeneralBlockListRequest
 */
export interface DefaultApiPostAdditionMerchantGeneralBlockListRequest {
    /**
     * 
     * @type {PostAdditionMerchantGeneralBlockListRequest}
     * @memberof DefaultApiPostAdditionMerchantGeneralBlockList
     */
    readonly postAdditionMerchantGeneralBlockListRequest: PostAdditionMerchantGeneralBlockListRequest
}

/**
 * Request parameters for postAlliancesGcpApplications operation in DefaultApi.
 * @export
 * @interface DefaultApiPostAlliancesGcpApplicationsRequest
 */
export interface DefaultApiPostAlliancesGcpApplicationsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiPostAlliancesGcpApplications
     */
    readonly organizationId: string

    /**
     * 
     * @type {PostAlliancesGcpApplicationsRequest}
     * @memberof DefaultApiPostAlliancesGcpApplications
     */
    readonly postAlliancesGcpApplicationsRequest: PostAlliancesGcpApplicationsRequest
}

/**
 * Request parameters for postAlliancesGwsApplications operation in DefaultApi.
 * @export
 * @interface DefaultApiPostAlliancesGwsApplicationsRequest
 */
export interface DefaultApiPostAlliancesGwsApplicationsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiPostAlliancesGwsApplications
     */
    readonly organizationId: string

    /**
     * 
     * @type {PostAlliancesGwsApplicationsRequest}
     * @memberof DefaultApiPostAlliancesGwsApplications
     */
    readonly postAlliancesGwsApplicationsRequest: PostAlliancesGwsApplicationsRequest
}

/**
 * Request parameters for postBalances operation in DefaultApi.
 * @export
 * @interface DefaultApiPostBalancesRequest
 */
export interface DefaultApiPostBalancesRequest {
    /**
     * 
     * @type {PostBalancesRequest}
     * @memberof DefaultApiPostBalances
     */
    readonly postBalancesRequest: PostBalancesRequest
}

/**
 * Request parameters for postBulkAdditionMerchantOrgBlockLists operation in DefaultApi.
 * @export
 * @interface DefaultApiPostBulkAdditionMerchantOrgBlockListsRequest
 */
export interface DefaultApiPostBulkAdditionMerchantOrgBlockListsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiPostBulkAdditionMerchantOrgBlockLists
     */
    readonly organizationId: string

    /**
     * 
     * @type {Array<PostBulkAdditionMerchantOrgBlockListsRequestInner>}
     * @memberof DefaultApiPostBulkAdditionMerchantOrgBlockLists
     */
    readonly postBulkAdditionMerchantOrgBlockListsRequestInner: Array<PostBulkAdditionMerchantOrgBlockListsRequestInner>
}

/**
 * Request parameters for postCancelRequestForEvidenceRequest operation in DefaultApi.
 * @export
 * @interface DefaultApiPostCancelRequestForEvidenceRequestRequest
 */
export interface DefaultApiPostCancelRequestForEvidenceRequestRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiPostCancelRequestForEvidenceRequest
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiPostCancelRequestForEvidenceRequest
     */
    readonly paymentReferenceId: string
}

/**
 * Request parameters for postCardsVirtualIssue operation in DefaultApi.
 * @export
 * @interface DefaultApiPostCardsVirtualIssueRequest
 */
export interface DefaultApiPostCardsVirtualIssueRequest {
    /**
     * 
     * @type {PostCardsVirtualIssueRequest}
     * @memberof DefaultApiPostCardsVirtualIssue
     */
    readonly postCardsVirtualIssueRequest: PostCardsVirtualIssueRequest
}

/**
 * Request parameters for postFaceToFaceKycIdentityDocument operation in DefaultApi.
 * @export
 * @interface DefaultApiPostFaceToFaceKycIdentityDocumentRequest
 */
export interface DefaultApiPostFaceToFaceKycIdentityDocumentRequest {
    /**
     * Onboarding request ID
     * @type {string}
     * @memberof DefaultApiPostFaceToFaceKycIdentityDocument
     */
    readonly onboardingRequestId: string

    /**
     * Identity document file
     * @type {File}
     * @memberof DefaultApiPostFaceToFaceKycIdentityDocument
     */
    readonly file: File

    /**
     * Type of personal identification document
     * @type {string}
     * @memberof DefaultApiPostFaceToFaceKycIdentityDocument
     */
    readonly personalDocumentType?: string

    /**
     * Name of the person who verified the document
     * @type {string}
     * @memberof DefaultApiPostFaceToFaceKycIdentityDocument
     */
    readonly verifiedBy?: string
}

/**
 * Request parameters for postFaceToFaceKycRequest operation in DefaultApi.
 * @export
 * @interface DefaultApiPostFaceToFaceKycRequestRequest
 */
export interface DefaultApiPostFaceToFaceKycRequestRequest {
    /**
     * 
     * @type {PostFaceToFaceKycRequestRequest}
     * @memberof DefaultApiPostFaceToFaceKycRequest
     */
    readonly postFaceToFaceKycRequestRequest: PostFaceToFaceKycRequestRequest
}

/**
 * Request parameters for postFreeeAccountForPoints operation in DefaultApi.
 * @export
 * @interface DefaultApiPostFreeeAccountForPointsRequest
 */
export interface DefaultApiPostFreeeAccountForPointsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiPostFreeeAccountForPoints
     */
    readonly organizationId: string

    /**
     * 
     * @type {PostFreeeAccountForPointsRequest}
     * @memberof DefaultApiPostFreeeAccountForPoints
     */
    readonly postFreeeAccountForPointsRequest: PostFreeeAccountForPointsRequest
}

/**
 * Request parameters for postKycconsultingWebhooks operation in DefaultApi.
 * @export
 * @interface DefaultApiPostKycconsultingWebhooksRequest
 */
export interface DefaultApiPostKycconsultingWebhooksRequest {
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof DefaultApiPostKycconsultingWebhooks
     */
    readonly requestBody: { [key: string]: string; }
}

/**
 * Request parameters for postMoneytreeRefreshRequest operation in DefaultApi.
 * @export
 * @interface DefaultApiPostMoneytreeRefreshRequestRequest
 */
export interface DefaultApiPostMoneytreeRefreshRequestRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiPostMoneytreeRefreshRequest
     */
    readonly organizationId: string
}

/**
 * Request parameters for postOrganizationsDeals operation in DefaultApi.
 * @export
 * @interface DefaultApiPostOrganizationsDealsRequest
 */
export interface DefaultApiPostOrganizationsDealsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiPostOrganizationsDeals
     */
    readonly organizationId: string

    /**
     * 
     * @type {PostOrganizationsDealsRequest}
     * @memberof DefaultApiPostOrganizationsDeals
     */
    readonly postOrganizationsDealsRequest: PostOrganizationsDealsRequest
}

/**
 * Request parameters for postPaymentRequestsBankAccount operation in DefaultApi.
 * @export
 * @interface DefaultApiPostPaymentRequestsBankAccountRequest
 */
export interface DefaultApiPostPaymentRequestsBankAccountRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiPostPaymentRequestsBankAccount
     */
    readonly organizationId: string

    /**
     * 
     * @type {PostPaymentRequestsBankAccountRequest}
     * @memberof DefaultApiPostPaymentRequestsBankAccount
     */
    readonly postPaymentRequestsBankAccountRequest?: PostPaymentRequestsBankAccountRequest
}

/**
 * Request parameters for postSlackMessageToCoworker operation in DefaultApi.
 * @export
 * @interface DefaultApiPostSlackMessageToCoworkerRequest
 */
export interface DefaultApiPostSlackMessageToCoworkerRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiPostSlackMessageToCoworker
     */
    readonly organizationId: string

    /**
     * 
     * @type {PostSlackMessageToCoworkerRequest}
     * @memberof DefaultApiPostSlackMessageToCoworker
     */
    readonly postSlackMessageToCoworkerRequest: PostSlackMessageToCoworkerRequest
}

/**
 * Request parameters for postTransactions operation in DefaultApi.
 * @export
 * @interface DefaultApiPostTransactionsRequest
 */
export interface DefaultApiPostTransactionsRequest {
    /**
     * 
     * @type {PostTransactionsRequest}
     * @memberof DefaultApiPostTransactions
     */
    readonly postTransactionsRequest: PostTransactionsRequest
}

/**
 * Request parameters for postTrustdockWebhooks operation in DefaultApi.
 * @export
 * @interface DefaultApiPostTrustdockWebhooksRequest
 */
export interface DefaultApiPostTrustdockWebhooksRequest {
    /**
     * 
     * @type {PostTrustdockWebhooksRequest}
     * @memberof DefaultApiPostTrustdockWebhooks
     */
    readonly postTrustdockWebhooksRequest: PostTrustdockWebhooksRequest
}

/**
 * Request parameters for postTrustdockWebhooksSnailMail operation in DefaultApi.
 * @export
 * @interface DefaultApiPostTrustdockWebhooksSnailMailRequest
 */
export interface DefaultApiPostTrustdockWebhooksSnailMailRequest {
    /**
     * 
     * @type {PostTrustdockWebhooksSnailMailRequest}
     * @memberof DefaultApiPostTrustdockWebhooksSnailMail
     */
    readonly postTrustdockWebhooksSnailMailRequest: PostTrustdockWebhooksSnailMailRequest
}

/**
 * Request parameters for putDisableFeatureFlag operation in DefaultApi.
 * @export
 * @interface DefaultApiPutDisableFeatureFlagRequest
 */
export interface DefaultApiPutDisableFeatureFlagRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiPutDisableFeatureFlag
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiPutDisableFeatureFlag
     */
    readonly featureName: string
}

/**
 * Request parameters for putEnabledFeatureFlag operation in DefaultApi.
 * @export
 * @interface DefaultApiPutEnabledFeatureFlagRequest
 */
export interface DefaultApiPutEnabledFeatureFlagRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiPutEnabledFeatureFlag
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiPutEnabledFeatureFlag
     */
    readonly featureName: string
}

/**
 * Request parameters for putFreeeEndJournalEntryTransitionMode operation in DefaultApi.
 * @export
 * @interface DefaultApiPutFreeeEndJournalEntryTransitionModeRequest
 */
export interface DefaultApiPutFreeeEndJournalEntryTransitionModeRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiPutFreeeEndJournalEntryTransitionMode
     */
    readonly organizationId: string

    /**
     * 
     * @type {PutFreeeEndJournalEntryTransitionModeRequest}
     * @memberof DefaultApiPutFreeeEndJournalEntryTransitionMode
     */
    readonly putFreeeEndJournalEntryTransitionModeRequest: PutFreeeEndJournalEntryTransitionModeRequest
}

/**
 * Request parameters for putOrganizationPaymentMethod operation in DefaultApi.
 * @export
 * @interface DefaultApiPutOrganizationPaymentMethodRequest
 */
export interface DefaultApiPutOrganizationPaymentMethodRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiPutOrganizationPaymentMethod
     */
    readonly organizationId: string

    /**
     * 
     * @type {PutOrganizationPaymentMethodRequest}
     * @memberof DefaultApiPutOrganizationPaymentMethod
     */
    readonly putOrganizationPaymentMethodRequest: PutOrganizationPaymentMethodRequest
}

/**
 * Request parameters for putOrganizationsDeals operation in DefaultApi.
 * @export
 * @interface DefaultApiPutOrganizationsDealsRequest
 */
export interface DefaultApiPutOrganizationsDealsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiPutOrganizationsDeals
     */
    readonly organizationId: string

    /**
     * 
     * @type {PutOrganizationsDealsRequest}
     * @memberof DefaultApiPutOrganizationsDeals
     */
    readonly putOrganizationsDealsRequest: PutOrganizationsDealsRequest
}

/**
 * Request parameters for putPaymentRequest operation in DefaultApi.
 * @export
 * @interface DefaultApiPutPaymentRequestRequest
 */
export interface DefaultApiPutPaymentRequestRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiPutPaymentRequest
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiPutPaymentRequest
     */
    readonly paymentRequestId?: string

    /**
     * 
     * @type {PutPaymentRequestRequest}
     * @memberof DefaultApiPutPaymentRequest
     */
    readonly putPaymentRequestRequest?: PutPaymentRequestRequest
}

/**
 * Request parameters for putPaymentRequestsBankAccount operation in DefaultApi.
 * @export
 * @interface DefaultApiPutPaymentRequestsBankAccountRequest
 */
export interface DefaultApiPutPaymentRequestsBankAccountRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiPutPaymentRequestsBankAccount
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiPutPaymentRequestsBankAccount
     */
    readonly bankAccountId: string

    /**
     * 
     * @type {PutPaymentRequestsBankAccountRequest}
     * @memberof DefaultApiPutPaymentRequestsBankAccount
     */
    readonly putPaymentRequestsBankAccountRequest?: PutPaymentRequestsBankAccountRequest
}

/**
 * Request parameters for putTransactionEvidenceEmailsLinkToTransaction operation in DefaultApi.
 * @export
 * @interface DefaultApiPutTransactionEvidenceEmailsLinkToTransactionRequest
 */
export interface DefaultApiPutTransactionEvidenceEmailsLinkToTransactionRequest {
    /**
     * 
     * @type {PutTransactionEvidenceEmailsLinkToTransactionRequest}
     * @memberof DefaultApiPutTransactionEvidenceEmailsLinkToTransaction
     */
    readonly putTransactionEvidenceEmailsLinkToTransactionRequest: PutTransactionEvidenceEmailsLinkToTransactionRequest
}

/**
 * Request parameters for putTransactionEvidenceEmailsMarkAsRead operation in DefaultApi.
 * @export
 * @interface DefaultApiPutTransactionEvidenceEmailsMarkAsReadRequest
 */
export interface DefaultApiPutTransactionEvidenceEmailsMarkAsReadRequest {
    /**
     * 
     * @type {PutTransactionEvidenceEmailsMarkAsReadRequest}
     * @memberof DefaultApiPutTransactionEvidenceEmailsMarkAsRead
     */
    readonly putTransactionEvidenceEmailsMarkAsReadRequest: PutTransactionEvidenceEmailsMarkAsReadRequest
}

/**
 * Request parameters for putTransactionEvidenceEmailsMoveToTrash operation in DefaultApi.
 * @export
 * @interface DefaultApiPutTransactionEvidenceEmailsMoveToTrashRequest
 */
export interface DefaultApiPutTransactionEvidenceEmailsMoveToTrashRequest {
    /**
     * 
     * @type {PutTransactionEvidenceEmailsMoveToTrashRequest}
     * @memberof DefaultApiPutTransactionEvidenceEmailsMoveToTrash
     */
    readonly putTransactionEvidenceEmailsMoveToTrashRequest: PutTransactionEvidenceEmailsMoveToTrashRequest
}

/**
 * Request parameters for putZeusGiveRewardPoints operation in DefaultApi.
 * @export
 * @interface DefaultApiPutZeusGiveRewardPointsRequest
 */
export interface DefaultApiPutZeusGiveRewardPointsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiPutZeusGiveRewardPoints
     */
    readonly organizationId: string

    /**
     * 
     * @type {PutZeusGiveRewardPointsRequest}
     * @memberof DefaultApiPutZeusGiveRewardPoints
     */
    readonly putZeusGiveRewardPointsRequest: PutZeusGiveRewardPointsRequest
}

/**
 * Request parameters for queryByIdsPaymentRequests operation in DefaultApi.
 * @export
 * @interface DefaultApiQueryByIdsPaymentRequestsRequest
 */
export interface DefaultApiQueryByIdsPaymentRequestsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiQueryByIdsPaymentRequests
     */
    readonly organizationId: string

    /**
     * 
     * @type {QueryByIdsPaymentRequestsRequest}
     * @memberof DefaultApiQueryByIdsPaymentRequests
     */
    readonly queryByIdsPaymentRequestsRequest?: QueryByIdsPaymentRequestsRequest
}

/**
 * Request parameters for readUserMessage operation in DefaultApi.
 * @export
 * @interface DefaultApiReadUserMessageRequest
 */
export interface DefaultApiReadUserMessageRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiReadUserMessage
     */
    readonly userMessageId: string
}

/**
 * Request parameters for registerNote operation in DefaultApi.
 * @export
 * @interface DefaultApiRegisterNoteRequest
 */
export interface DefaultApiRegisterNoteRequest {
    /**
     * The ID of the onboarding request to retrieve
     * @type {string}
     * @memberof DefaultApiRegisterNote
     */
    readonly onboardingRequestId: string

    /**
     * 
     * @type {RegisterNoteRequest}
     * @memberof DefaultApiRegisterNote
     */
    readonly registerNoteRequest?: RegisterNoteRequest
}

/**
 * Request parameters for registerNoteForOrganizationIdentityVerification operation in DefaultApi.
 * @export
 * @interface DefaultApiRegisterNoteForOrganizationIdentityVerificationRequest
 */
export interface DefaultApiRegisterNoteForOrganizationIdentityVerificationRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiRegisterNoteForOrganizationIdentityVerification
     */
    readonly organizationIdentityVerificationId: number

    /**
     * 
     * @type {RegisterNoteForOrganizationIdentityVerificationRequest}
     * @memberof DefaultApiRegisterNoteForOrganizationIdentityVerification
     */
    readonly registerNoteForOrganizationIdentityVerificationRequest: RegisterNoteForOrganizationIdentityVerificationRequest
}

/**
 * Request parameters for registerOrganization operation in DefaultApi.
 * @export
 * @interface DefaultApiRegisterOrganizationRequest
 */
export interface DefaultApiRegisterOrganizationRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiRegisterOrganization
     */
    readonly onboardingRequestId: string
}

/**
 * Request parameters for registerOrganizationChartForWorkflow operation in DefaultApi.
 * @export
 * @interface DefaultApiRegisterOrganizationChartForWorkflowRequest
 */
export interface DefaultApiRegisterOrganizationChartForWorkflowRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiRegisterOrganizationChartForWorkflow
     */
    readonly organizationId: string

    /**
     * 
     * @type {RegisterOrganizationChartForWorkflowRequest}
     * @memberof DefaultApiRegisterOrganizationChartForWorkflow
     */
    readonly registerOrganizationChartForWorkflowRequest?: RegisterOrganizationChartForWorkflowRequest
}

/**
 * Request parameters for registerTfaAppVerificationCode operation in DefaultApi.
 * @export
 * @interface DefaultApiRegisterTfaAppVerificationCodeRequest
 */
export interface DefaultApiRegisterTfaAppVerificationCodeRequest {
    /**
     * 
     * @type {RegisterTfaAppVerificationCodeRequest}
     * @memberof DefaultApiRegisterTfaAppVerificationCode
     */
    readonly registerTfaAppVerificationCodeRequest: RegisterTfaAppVerificationCodeRequest
}

/**
 * Request parameters for registerTfaSmsAuth operation in DefaultApi.
 * @export
 * @interface DefaultApiRegisterTfaSmsAuthRequest
 */
export interface DefaultApiRegisterTfaSmsAuthRequest {
    /**
     * 
     * @type {RegisterTfaSmsAuthRequest}
     * @memberof DefaultApiRegisterTfaSmsAuth
     */
    readonly registerTfaSmsAuthRequest: RegisterTfaSmsAuthRequest
}

/**
 * Request parameters for registerTransactionEvidenceEmailAddress operation in DefaultApi.
 * @export
 * @interface DefaultApiRegisterTransactionEvidenceEmailAddressRequest
 */
export interface DefaultApiRegisterTransactionEvidenceEmailAddressRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiRegisterTransactionEvidenceEmailAddress
     */
    readonly userAccountId: string
}

/**
 * Request parameters for rejectOrganizationIdentityVerification operation in DefaultApi.
 * @export
 * @interface DefaultApiRejectOrganizationIdentityVerificationRequest
 */
export interface DefaultApiRejectOrganizationIdentityVerificationRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiRejectOrganizationIdentityVerification
     */
    readonly organizationIdentityVerificationId: number
}

/**
 * Request parameters for rejectPurchaseApplication operation in DefaultApi.
 * @export
 * @interface DefaultApiRejectPurchaseApplicationRequest
 */
export interface DefaultApiRejectPurchaseApplicationRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiRejectPurchaseApplication
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiRejectPurchaseApplication
     */
    readonly purchaseApplicationId: string

    /**
     * 
     * @type {RejectPurchaseApplicationRequest}
     * @memberof DefaultApiRejectPurchaseApplication
     */
    readonly rejectPurchaseApplicationRequest: RejectPurchaseApplicationRequest
}

/**
 * Request parameters for remindOrganizationMonthlyPaymentNotification operation in DefaultApi.
 * @export
 * @interface DefaultApiRemindOrganizationMonthlyPaymentNotificationRequest
 */
export interface DefaultApiRemindOrganizationMonthlyPaymentNotificationRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiRemindOrganizationMonthlyPaymentNotification
     */
    readonly organizationId: string
}

/**
 * Request parameters for renameUserAccountGroup operation in DefaultApi.
 * @export
 * @interface DefaultApiRenameUserAccountGroupRequest
 */
export interface DefaultApiRenameUserAccountGroupRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiRenameUserAccountGroup
     */
    readonly userAccountGroupId: number

    /**
     * 
     * @type {RenameUserAccountGroupRequest}
     * @memberof DefaultApiRenameUserAccountGroup
     */
    readonly renameUserAccountGroupRequest: RenameUserAccountGroupRequest
}

/**
 * Request parameters for replaceVirtualCard operation in DefaultApi.
 * @export
 * @interface DefaultApiReplaceVirtualCardRequest
 */
export interface DefaultApiReplaceVirtualCardRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiReplaceVirtualCard
     */
    readonly userAccountId: string

    /**
     * 
     * @type {ReplaceVirtualCardRequest}
     * @memberof DefaultApiReplaceVirtualCard
     */
    readonly replaceVirtualCardRequest: ReplaceVirtualCardRequest
}

/**
 * Request parameters for requestAddSystemAdminRole operation in DefaultApi.
 * @export
 * @interface DefaultApiRequestAddSystemAdminRoleRequest
 */
export interface DefaultApiRequestAddSystemAdminRoleRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiRequestAddSystemAdminRole
     */
    readonly userId: string

    /**
     * 
     * @type {RequestAddSystemAdminRoleRequest}
     * @memberof DefaultApiRequestAddSystemAdminRole
     */
    readonly requestAddSystemAdminRoleRequest: RequestAddSystemAdminRoleRequest
}

/**
 * Request parameters for requestSending operation in DefaultApi.
 * @export
 * @interface DefaultApiRequestSendingRequest
 */
export interface DefaultApiRequestSendingRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiRequestSending
     */
    readonly organizationId: string

    /**
     * 
     * @type {RequestSendingRequest}
     * @memberof DefaultApiRequestSending
     */
    readonly requestSendingRequest: RequestSendingRequest
}

/**
 * Request parameters for requestSendingMetalCard operation in DefaultApi.
 * @export
 * @interface DefaultApiRequestSendingMetalCardRequest
 */
export interface DefaultApiRequestSendingMetalCardRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiRequestSendingMetalCard
     */
    readonly organizationId: string

    /**
     * 
     * @type {RequestSendingMetalCardRequest}
     * @memberof DefaultApiRequestSendingMetalCard
     */
    readonly requestSendingMetalCardRequest: RequestSendingMetalCardRequest
}

/**
 * Request parameters for requestToOrganizationsAccountingCsvInBackground operation in DefaultApi.
 * @export
 * @interface DefaultApiRequestToOrganizationsAccountingCsvInBackgroundRequest
 */
export interface DefaultApiRequestToOrganizationsAccountingCsvInBackgroundRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiRequestToOrganizationsAccountingCsvInBackground
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiRequestToOrganizationsAccountingCsvInBackground
     */
    readonly yearMonth: string

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiRequestToOrganizationsAccountingCsvInBackground
     */
    readonly isMergedFiles: boolean
}

/**
 * Request parameters for requestUpdateSystemAdminRole operation in DefaultApi.
 * @export
 * @interface DefaultApiRequestUpdateSystemAdminRoleRequest
 */
export interface DefaultApiRequestUpdateSystemAdminRoleRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiRequestUpdateSystemAdminRole
     */
    readonly userId: string

    /**
     * 
     * @type {RequestUpdateSystemAdminRoleRequest}
     * @memberof DefaultApiRequestUpdateSystemAdminRole
     */
    readonly requestUpdateSystemAdminRoleRequest: RequestUpdateSystemAdminRoleRequest
}

/**
 * Request parameters for resendSnailMailForOrganizationIdentityVerification operation in DefaultApi.
 * @export
 * @interface DefaultApiResendSnailMailForOrganizationIdentityVerificationRequest
 */
export interface DefaultApiResendSnailMailForOrganizationIdentityVerificationRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiResendSnailMailForOrganizationIdentityVerification
     */
    readonly organizationIdentityVerificationId: number

    /**
     * 
     * @type {ResendSnailMailForOrganizationIdentityVerificationRequest}
     * @memberof DefaultApiResendSnailMailForOrganizationIdentityVerification
     */
    readonly resendSnailMailForOrganizationIdentityVerificationRequest: ResendSnailMailForOrganizationIdentityVerificationRequest
}

/**
 * Request parameters for resendUserInvite operation in DefaultApi.
 * @export
 * @interface DefaultApiResendUserInviteRequest
 */
export interface DefaultApiResendUserInviteRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiResendUserInvite
     */
    readonly userId: string
}

/**
 * Request parameters for resumeCard operation in DefaultApi.
 * @export
 * @interface DefaultApiResumeCardRequest
 */
export interface DefaultApiResumeCardRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiResumeCard
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiResumeCard
     */
    readonly cardId: string
}

/**
 * Request parameters for resynchronizeCardTransactionsForFreee operation in DefaultApi.
 * @export
 * @interface DefaultApiResynchronizeCardTransactionsForFreeeRequest
 */
export interface DefaultApiResynchronizeCardTransactionsForFreeeRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiResynchronizeCardTransactionsForFreee
     */
    readonly organizationId: string

    /**
     * 
     * @type {ResynchronizeCardTransactionsForFreeeRequest}
     * @memberof DefaultApiResynchronizeCardTransactionsForFreee
     */
    readonly resynchronizeCardTransactionsForFreeeRequest: ResynchronizeCardTransactionsForFreeeRequest
}

/**
 * Request parameters for saveDealAsDraft operation in DefaultApi.
 * @export
 * @interface DefaultApiSaveDealAsDraftRequest
 */
export interface DefaultApiSaveDealAsDraftRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiSaveDealAsDraft
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiSaveDealAsDraft
     */
    readonly dealId: string

    /**
     * 
     * @type {SaveDealAsDraftRequest}
     * @memberof DefaultApiSaveDealAsDraft
     */
    readonly saveDealAsDraftRequest: SaveDealAsDraftRequest
}

/**
 * Request parameters for saveDealAsIgnore operation in DefaultApi.
 * @export
 * @interface DefaultApiSaveDealAsIgnoreRequest
 */
export interface DefaultApiSaveDealAsIgnoreRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiSaveDealAsIgnore
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiSaveDealAsIgnore
     */
    readonly dealId: string
}

/**
 * Request parameters for saveDealAsReturnToEditing operation in DefaultApi.
 * @export
 * @interface DefaultApiSaveDealAsReturnToEditingRequest
 */
export interface DefaultApiSaveDealAsReturnToEditingRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiSaveDealAsReturnToEditing
     */
    readonly organizationId: string

    /**
     * 
     * @type {number}
     * @memberof DefaultApiSaveDealAsReturnToEditing
     */
    readonly dealId: number
}

/**
 * Request parameters for saveDealWithJournalizing operation in DefaultApi.
 * @export
 * @interface DefaultApiSaveDealWithJournalizingRequest
 */
export interface DefaultApiSaveDealWithJournalizingRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiSaveDealWithJournalizing
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiSaveDealWithJournalizing
     */
    readonly dealId: string

    /**
     * 
     * @type {SaveDealWithJournalizingRequest}
     * @memberof DefaultApiSaveDealWithJournalizing
     */
    readonly saveDealWithJournalizingRequest: SaveDealWithJournalizingRequest
}

/**
 * Request parameters for saveDealsAsIgnore operation in DefaultApi.
 * @export
 * @interface DefaultApiSaveDealsAsIgnoreRequest
 */
export interface DefaultApiSaveDealsAsIgnoreRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiSaveDealsAsIgnore
     */
    readonly organizationId: string

    /**
     * 
     * @type {SaveDealsAsIgnoreRequest}
     * @memberof DefaultApiSaveDealsAsIgnore
     */
    readonly saveDealsAsIgnoreRequest: SaveDealsAsIgnoreRequest
}

/**
 * Request parameters for saveDealsAsJournalized operation in DefaultApi.
 * @export
 * @interface DefaultApiSaveDealsAsJournalizedRequest
 */
export interface DefaultApiSaveDealsAsJournalizedRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiSaveDealsAsJournalized
     */
    readonly organizationId: string

    /**
     * 
     * @type {SaveDealsAsJournalizedRequest}
     * @memberof DefaultApiSaveDealsAsJournalized
     */
    readonly saveDealsAsJournalizedRequest: SaveDealsAsJournalizedRequest
}

/**
 * Request parameters for saveDealsAsReturnToEditing operation in DefaultApi.
 * @export
 * @interface DefaultApiSaveDealsAsReturnToEditingRequest
 */
export interface DefaultApiSaveDealsAsReturnToEditingRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiSaveDealsAsReturnToEditing
     */
    readonly organizationId: number

    /**
     * 
     * @type {SaveDealsAsReturnToEditingRequest}
     * @memberof DefaultApiSaveDealsAsReturnToEditing
     */
    readonly saveDealsAsReturnToEditingRequest: SaveDealsAsReturnToEditingRequest
}

/**
 * Request parameters for searchBankTransfers operation in DefaultApi.
 * @export
 * @interface DefaultApiSearchBankTransfersRequest
 */
export interface DefaultApiSearchBankTransfersRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiSearchBankTransfers
     */
    readonly organizationId: string

    /**
     * yyyy-MM-dd format date in JST. Filter the bank transfers to be returned to only those which are scheduled to be transferred after this date.
     * @type {string}
     * @memberof DefaultApiSearchBankTransfers
     */
    readonly transferDateJstFrom?: string

    /**
     * yyyy-MM-dd format date in JST. Filter the bank transfers to be returned to only those which are scheduled to be transferred before this date. Both transferDateJstFrom and transferDateJstTo are inclusive (closed interval).
     * @type {string}
     * @memberof DefaultApiSearchBankTransfers
     */
    readonly transferDateJstTo?: string

    /**
     * Filter the bank transfers by the specified source bank account id.
     * @type {string}
     * @memberof DefaultApiSearchBankTransfers
     */
    readonly sourceBankAccountId?: string

    /**
     * Filter the bank transfers by whether the corresponding transfer data has been downloaded.
     * @type {boolean}
     * @memberof DefaultApiSearchBankTransfers
     */
    readonly downloaded?: boolean

    /**
     * 
     * @type {number}
     * @memberof DefaultApiSearchBankTransfers
     */
    readonly limit?: number

    /**
     * See the description of &#x60;cursor&#x60; section Pagination
     * @type {number}
     * @memberof DefaultApiSearchBankTransfers
     */
    readonly offset?: number

    /**
     * Pagination is performed by specifying either offset or cursor; if neither offset nor cursor is specified, it is assumed to be cursor-pagination and the first page is obtained with the next cursor. See below how the pagination exactly behaves:  - \&quot;\&quot; ... Get the fist page and return the next cursor  - \&quot;offset&#x3D;50\&quot; ... Get from the specified offset and never return the next cursor  - \&quot;cursor&#x3D;xxx\&quot; ... Get from the specified cursor  - \&quot;offset&#x3D;50&amp;cursor&#x3D;xxx\&quot; ... Ignore the offset and get from the specified cursor
     * @type {string}
     * @memberof DefaultApiSearchBankTransfers
     */
    readonly cursor?: string
}

/**
 * Request parameters for searchCorporationsInNationalTaxAgency operation in DefaultApi.
 * @export
 * @interface DefaultApiSearchCorporationsInNationalTaxAgencyRequest
 */
export interface DefaultApiSearchCorporationsInNationalTaxAgencyRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiSearchCorporationsInNationalTaxAgency
     */
    readonly name?: string

    /**
     * 
     * @type {'PREFIX_MATCH' | 'PARTIAL_MATCH' | ''}
     * @memberof DefaultApiSearchCorporationsInNationalTaxAgency
     */
    readonly searchMethod?: 'PREFIX_MATCH' | 'PARTIAL_MATCH' | ''
}

/**
 * Request parameters for searchDeals operation in DefaultApi.
 * @export
 * @interface DefaultApiSearchDealsRequest
 */
export interface DefaultApiSearchDealsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiSearchDeals
     */
    readonly organizationId: string

    /**
     * 
     * @type {SearchDealsRequest}
     * @memberof DefaultApiSearchDeals
     */
    readonly searchDealsRequest?: SearchDealsRequest
}

/**
 * Request parameters for searchEvidences operation in DefaultApi.
 * @export
 * @interface DefaultApiSearchEvidencesRequest
 */
export interface DefaultApiSearchEvidencesRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiSearchEvidences
     */
    readonly organizationId: string

    /**
     * This parameter will be deleted soon. Use keyword instead. If you specify this parameter, it will behave like the keyword, that is, it is searched from note as well as issuer.
     * @type {string}
     * @memberof DefaultApiSearchEvidences
     */
    readonly issuer?: string

    /**
     * 
     * @type {number}
     * @memberof DefaultApiSearchEvidences
     */
    readonly amountMin?: number

    /**
     * 
     * @type {number}
     * @memberof DefaultApiSearchEvidences
     */
    readonly amountMax?: number

    /**
     * 
     * @type {string}
     * @memberof DefaultApiSearchEvidences
     */
    readonly paidAtFrom?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiSearchEvidences
     */
    readonly paidAtTo?: string

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiSearchEvidences
     */
    readonly irrelevantToLedger?: boolean

    /**
     * Specified keyword is searched from the issuer and the note by partial match.
     * @type {string}
     * @memberof DefaultApiSearchEvidences
     */
    readonly keyword?: string

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiSearchEvidences
     */
    readonly includesDeleted?: boolean

    /**
     * 
     * @type {Array<'VALID' | 'INVALID' | 'INPUT_REQUIRED' | 'OUT_OF_TARGET'>}
     * @memberof DefaultApiSearchEvidences
     */
    readonly legalValidities?: Array<'VALID' | 'INVALID' | 'INPUT_REQUIRED' | 'OUT_OF_TARGET'>

    /**
     * 
     * @type {number}
     * @memberof DefaultApiSearchEvidences
     */
    readonly limit?: number

    /**
     * 
     * @type {number}
     * @memberof DefaultApiSearchEvidences
     */
    readonly offset?: number
}

/**
 * Request parameters for searchMyPaymentRequests operation in DefaultApi.
 * @export
 * @interface DefaultApiSearchMyPaymentRequestsRequest
 */
export interface DefaultApiSearchMyPaymentRequestsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiSearchMyPaymentRequests
     */
    readonly organizationId: string

    /**
     * yyyy-MM-dd format date in JST. Filter the payment requests to be returned to only those which have a due date after this date.
     * @type {string}
     * @memberof DefaultApiSearchMyPaymentRequests
     */
    readonly dueDateJstFrom?: string

    /**
     * yyyy-MM-dd format date in JST. Filter the payment requests to be returned to only those which have a due date before this date. Both dueDateJstFrom and dueDateJstTo are inclusive (closed interval).
     * @type {string}
     * @memberof DefaultApiSearchMyPaymentRequests
     */
    readonly dueDateJstTo?: string

    /**
     * yyyy-MM-dd format date in JST. Filter the payment requests to be returned to only those which have a requested at after this date.
     * @type {string}
     * @memberof DefaultApiSearchMyPaymentRequests
     */
    readonly requestedDateJstFrom?: string

    /**
     * yyyy-MM-dd format date in JST. Filter the payment requests to be returned to only those which have a requested at before this date.
     * @type {string}
     * @memberof DefaultApiSearchMyPaymentRequests
     */
    readonly requestedDateJstTo?: string

    /**
     * Filter the payment requests by the specified statuses. This parameter accepts both the following two forms:  - [comma separated style] /payment_requests?statuses&#x3D;PAYABLE,ATTACHED_TO_BANK_TRANSFER  - [exploded style]        /payment_requests?statuses&#x3D;PAYABLE&amp;statuses&#x3D;ATTACHED_TO_BANK_TRANSFER
     * @type {Array<'PENDING_WORKFLOW_COMPLETION' | 'CANCELED' | 'PAYABLE' | 'ATTACHED_TO_BANK_TRANSFER' | 'DEACTIVATED'>}
     * @memberof DefaultApiSearchMyPaymentRequests
     */
    readonly statuses?: Array<'PENDING_WORKFLOW_COMPLETION' | 'CANCELED' | 'PAYABLE' | 'ATTACHED_TO_BANK_TRANSFER' | 'DEACTIVATED'>

    /**
     * Filter the payment requests by the specified supplier id.
     * @type {string}
     * @memberof DefaultApiSearchMyPaymentRequests
     */
    readonly supplierId?: string

    /**
     * Filter the payment requests by whether the corresponding transaction data has been created.
     * @type {boolean}
     * @memberof DefaultApiSearchMyPaymentRequests
     */
    readonly transferDataCreated?: boolean

    /**
     * Filter the payment requests by whether the withholding tax has been applied. true means the withholdingCalculatingMethod is NONE, while false, except for NONE.
     * @type {boolean}
     * @memberof DefaultApiSearchMyPaymentRequests
     */
    readonly withholdingApplied?: boolean

    /**
     * Filter the payment requests by the specified transfer fee responsibility.
     * @type {'SELF' | 'SUPPLIER'}
     * @memberof DefaultApiSearchMyPaymentRequests
     */
    readonly transferFeeResponsibility?: 'SELF' | 'SUPPLIER'

    /**
     * A keyword used to search the following fields for partial matches:  - supplier name  - requestor name  - memo  - accounting items  - sections
     * @type {string}
     * @memberof DefaultApiSearchMyPaymentRequests
     */
    readonly freeWord?: string

    /**
     * 
     * @type {number}
     * @memberof DefaultApiSearchMyPaymentRequests
     */
    readonly limit?: number

    /**
     * See the description of &#x60;cursor&#x60; section Pagination
     * @type {number}
     * @memberof DefaultApiSearchMyPaymentRequests
     */
    readonly offset?: number

    /**
     * Pagination is performed by specifying either offset or cursor; if neither offset nor cursor is specified, it is assumed to be cursor-pagination and the first page is obtained with the next cursor. See below how the pagination exactly behaves:  - \&quot;\&quot; ... Get the fist page and return the next cursor  - \&quot;offset&#x3D;50\&quot; ... Get from the specified offset and never return the next cursor  - \&quot;cursor&#x3D;xxx\&quot; ... Get from the specified cursor  - \&quot;offset&#x3D;50&amp;cursor&#x3D;xxx\&quot; ... Ignore the offset and get from the specified cursor
     * @type {string}
     * @memberof DefaultApiSearchMyPaymentRequests
     */
    readonly cursor?: string
}

/**
 * Request parameters for searchOrganizations operation in DefaultApi.
 * @export
 * @interface DefaultApiSearchOrganizationsRequest
 */
export interface DefaultApiSearchOrganizationsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiSearchOrganizations
     */
    readonly key: string
}

/**
 * Request parameters for searchPaymentRequests operation in DefaultApi.
 * @export
 * @interface DefaultApiSearchPaymentRequestsRequest
 */
export interface DefaultApiSearchPaymentRequestsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiSearchPaymentRequests
     */
    readonly organizationId: string

    /**
     * yyyy-MM-dd format date in JST. Filter the payment requests to be returned to only those which have a due date after this date.
     * @type {string}
     * @memberof DefaultApiSearchPaymentRequests
     */
    readonly dueDateJstFrom?: string

    /**
     * yyyy-MM-dd format date in JST. Filter the payment requests to be returned to only those which have a due date before this date. Both dueDateJstFrom and dueDateJstTo are inclusive (closed interval).
     * @type {string}
     * @memberof DefaultApiSearchPaymentRequests
     */
    readonly dueDateJstTo?: string

    /**
     * yyyy-MM-dd format date in JST. Filter the payment requests to be returned to only those which have a requested at after this date.
     * @type {string}
     * @memberof DefaultApiSearchPaymentRequests
     */
    readonly requestedDateJstFrom?: string

    /**
     * yyyy-MM-dd format date in JST. Filter the payment requests to be returned to only those which have a requested at before this date.
     * @type {string}
     * @memberof DefaultApiSearchPaymentRequests
     */
    readonly requestedDateJstTo?: string

    /**
     * Filter the payment requests by the specified statuses. This parameter accepts both the following two forms:  - [comma separated style] /payment_requests?statuses&#x3D;PAYABLE,ATTACHED_TO_BANK_TRANSFER  - [exploded style]        /payment_requests?statuses&#x3D;PAYABLE&amp;statuses&#x3D;ATTACHED_TO_BANK_TRANSFER
     * @type {Array<'PENDING_WORKFLOW_COMPLETION' | 'CANCELED' | 'PAYABLE' | 'ATTACHED_TO_BANK_TRANSFER' | 'DEACTIVATED'>}
     * @memberof DefaultApiSearchPaymentRequests
     */
    readonly statuses?: Array<'PENDING_WORKFLOW_COMPLETION' | 'CANCELED' | 'PAYABLE' | 'ATTACHED_TO_BANK_TRANSFER' | 'DEACTIVATED'>

    /**
     * Filter the payment requests by the specified supplier id.
     * @type {string}
     * @memberof DefaultApiSearchPaymentRequests
     */
    readonly supplierId?: string

    /**
     * Filter the payment requests by whether the corresponding transaction data has been created.
     * @type {boolean}
     * @memberof DefaultApiSearchPaymentRequests
     */
    readonly transferDataCreated?: boolean

    /**
     * Filter the payment requests by whether the withholding tax has been applied. true means the withholdingCalculatingMethod is NONE, while false, except for NONE.
     * @type {boolean}
     * @memberof DefaultApiSearchPaymentRequests
     */
    readonly withholdingApplied?: boolean

    /**
     * Filter the payment requests by the specified transfer fee responsibility.
     * @type {'SELF' | 'SUPPLIER'}
     * @memberof DefaultApiSearchPaymentRequests
     */
    readonly transferFeeResponsibility?: 'SELF' | 'SUPPLIER'

    /**
     * Filter the payment requests by the specified requestor id.
     * @type {string}
     * @memberof DefaultApiSearchPaymentRequests
     */
    readonly requestorId?: string

    /**
     * A keyword used to search the following fields for partial matches:  - supplier name  - requestor name  - memo  - accounting items  - sections
     * @type {string}
     * @memberof DefaultApiSearchPaymentRequests
     */
    readonly freeWord?: string

    /**
     * 
     * @type {number}
     * @memberof DefaultApiSearchPaymentRequests
     */
    readonly limit?: number

    /**
     * See the description of &#x60;cursor&#x60; section Pagination
     * @type {number}
     * @memberof DefaultApiSearchPaymentRequests
     */
    readonly offset?: number

    /**
     * Pagination is performed by specifying either offset or cursor; if neither offset nor cursor is specified, it is assumed to be cursor-pagination and the first page is obtained with the next cursor. See below how the pagination exactly behaves:  - \&quot;\&quot; ... Get the fist page and return the next cursor  - \&quot;offset&#x3D;50\&quot; ... Get from the specified offset and never return the next cursor  - \&quot;cursor&#x3D;xxx\&quot; ... Get from the specified cursor  - \&quot;offset&#x3D;50&amp;cursor&#x3D;xxx\&quot; ... Ignore the offset and get from the specified cursor
     * @type {string}
     * @memberof DefaultApiSearchPaymentRequests
     */
    readonly cursor?: string
}

/**
 * Request parameters for sendBackOnboardingRequest operation in DefaultApi.
 * @export
 * @interface DefaultApiSendBackOnboardingRequestRequest
 */
export interface DefaultApiSendBackOnboardingRequestRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiSendBackOnboardingRequest
     */
    readonly onboardingRequestId: string
}

/**
 * Request parameters for sendOrganizationIdentityVerification operation in DefaultApi.
 * @export
 * @interface DefaultApiSendOrganizationIdentityVerificationRequest
 */
export interface DefaultApiSendOrganizationIdentityVerificationRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiSendOrganizationIdentityVerification
     */
    readonly organizationId: string

    /**
     * 
     * @type {SendOrganizationIdentityVerificationRequest}
     * @memberof DefaultApiSendOrganizationIdentityVerification
     */
    readonly sendOrganizationIdentityVerificationRequest: SendOrganizationIdentityVerificationRequest
}

/**
 * Request parameters for sendTransactionAuthorizationRequest operation in DefaultApi.
 * @export
 * @interface DefaultApiSendTransactionAuthorizationRequestRequest
 */
export interface DefaultApiSendTransactionAuthorizationRequestRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiSendTransactionAuthorizationRequest
     */
    readonly organizationId: string

    /**
     * 
     * @type {SendTransactionAuthorizationRequestRequest}
     * @memberof DefaultApiSendTransactionAuthorizationRequest
     */
    readonly sendTransactionAuthorizationRequestRequest: SendTransactionAuthorizationRequestRequest
}

/**
 * Request parameters for signUpForSlack operation in DefaultApi.
 * @export
 * @interface DefaultApiSignUpForSlackRequest
 */
export interface DefaultApiSignUpForSlackRequest {
    /**
     * 
     * @type {SignUpForSlackRequest}
     * @memberof DefaultApiSignUpForSlack
     */
    readonly signUpForSlackRequest: SignUpForSlackRequest
}

/**
 * Request parameters for submitCompletedWorkflowOfDraftPaymentRequests operation in DefaultApi.
 * @export
 * @interface DefaultApiSubmitCompletedWorkflowOfDraftPaymentRequestsRequest
 */
export interface DefaultApiSubmitCompletedWorkflowOfDraftPaymentRequestsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiSubmitCompletedWorkflowOfDraftPaymentRequests
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiSubmitCompletedWorkflowOfDraftPaymentRequests
     */
    readonly draftPaymentRequestId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiSubmitCompletedWorkflowOfDraftPaymentRequests
     */
    readonly xUpsidrSwitchUser?: string

    /**
     * 
     * @type {SubmitCompletedWorkflowOfDraftPaymentRequestsRequest}
     * @memberof DefaultApiSubmitCompletedWorkflowOfDraftPaymentRequests
     */
    readonly submitCompletedWorkflowOfDraftPaymentRequestsRequest?: SubmitCompletedWorkflowOfDraftPaymentRequestsRequest
}

/**
 * Request parameters for submitCompletedWorkflowOfPaymentRequests operation in DefaultApi.
 * @export
 * @interface DefaultApiSubmitCompletedWorkflowOfPaymentRequestsRequest
 */
export interface DefaultApiSubmitCompletedWorkflowOfPaymentRequestsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiSubmitCompletedWorkflowOfPaymentRequests
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiSubmitCompletedWorkflowOfPaymentRequests
     */
    readonly xUpsidrSwitchUser?: string

    /**
     * 
     * @type {SubmitCompletedWorkflowOfPaymentRequestsRequest}
     * @memberof DefaultApiSubmitCompletedWorkflowOfPaymentRequests
     */
    readonly submitCompletedWorkflowOfPaymentRequestsRequest?: SubmitCompletedWorkflowOfPaymentRequestsRequest
}

/**
 * Request parameters for submitWorkflow operation in DefaultApi.
 * @export
 * @interface DefaultApiSubmitWorkflowRequest
 */
export interface DefaultApiSubmitWorkflowRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiSubmitWorkflow
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiSubmitWorkflow
     */
    readonly workflowInstanceId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiSubmitWorkflow
     */
    readonly xUpsidrSwitchUser?: string
}

/**
 * Request parameters for suspendCard operation in DefaultApi.
 * @export
 * @interface DefaultApiSuspendCardRequest
 */
export interface DefaultApiSuspendCardRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiSuspendCard
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiSuspendCard
     */
    readonly cardId: string
}

/**
 * Request parameters for syncFreeeAccountItems operation in DefaultApi.
 * @export
 * @interface DefaultApiSyncFreeeAccountItemsRequest
 */
export interface DefaultApiSyncFreeeAccountItemsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiSyncFreeeAccountItems
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiSyncFreeeAccountItems
     */
    readonly companyId: string
}

/**
 * Request parameters for syncFreeePartners operation in DefaultApi.
 * @export
 * @interface DefaultApiSyncFreeePartnersRequest
 */
export interface DefaultApiSyncFreeePartnersRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiSyncFreeePartners
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiSyncFreeePartners
     */
    readonly companyId: string
}

/**
 * Request parameters for syncFreeeSegmentTags operation in DefaultApi.
 * @export
 * @interface DefaultApiSyncFreeeSegmentTagsRequest
 */
export interface DefaultApiSyncFreeeSegmentTagsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiSyncFreeeSegmentTags
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiSyncFreeeSegmentTags
     */
    readonly companyId: string
}

/**
 * Request parameters for syncMoneytreeAccessToken operation in DefaultApi.
 * @export
 * @interface DefaultApiSyncMoneytreeAccessTokenRequest
 */
export interface DefaultApiSyncMoneytreeAccessTokenRequest {
    /**
     * Authorization code received from Moneytree after successful authentication.
     * @type {string}
     * @memberof DefaultApiSyncMoneytreeAccessToken
     */
    readonly code: string

    /**
     * OAuth state parameter to ensure request consistency.
     * @type {string}
     * @memberof DefaultApiSyncMoneytreeAccessToken
     */
    readonly state: string

    /**
     * URL to redirect to after syncing access token.
     * @type {string}
     * @memberof DefaultApiSyncMoneytreeAccessToken
     */
    readonly nextTo?: string
}

/**
 * Request parameters for syncRequestForFreeeDeals operation in DefaultApi.
 * @export
 * @interface DefaultApiSyncRequestForFreeeDealsRequest
 */
export interface DefaultApiSyncRequestForFreeeDealsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiSyncRequestForFreeeDeals
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiSyncRequestForFreeeDeals
     */
    readonly companyId: string

    /**
     * 
     * @type {SyncRequestForFreeeDealsRequest}
     * @memberof DefaultApiSyncRequestForFreeeDeals
     */
    readonly syncRequestForFreeeDealsRequest: SyncRequestForFreeeDealsRequest
}

/**
 * Request parameters for twoFactorAuthResetAsToken operation in DefaultApi.
 * @export
 * @interface DefaultApiTwoFactorAuthResetAsTokenRequest
 */
export interface DefaultApiTwoFactorAuthResetAsTokenRequest {
    /**
     * 
     * @type {TwoFactorAuthResetAsTokenRequest}
     * @memberof DefaultApiTwoFactorAuthResetAsToken
     */
    readonly twoFactorAuthResetAsTokenRequest: TwoFactorAuthResetAsTokenRequest
}

/**
 * Request parameters for unlinkingPurchaseToTransaction operation in DefaultApi.
 * @export
 * @interface DefaultApiUnlinkingPurchaseToTransactionRequest
 */
export interface DefaultApiUnlinkingPurchaseToTransactionRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUnlinkingPurchaseToTransaction
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUnlinkingPurchaseToTransaction
     */
    readonly purchaseApplicationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUnlinkingPurchaseToTransaction
     */
    readonly visaTransactionReferenceId?: string
}

/**
 * Request parameters for unlockCardForNotPotentialFraud operation in DefaultApi.
 * @export
 * @interface DefaultApiUnlockCardForNotPotentialFraudRequest
 */
export interface DefaultApiUnlockCardForNotPotentialFraudRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUnlockCardForNotPotentialFraud
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUnlockCardForNotPotentialFraud
     */
    readonly cardId: string
}

/**
 * Request parameters for unlockCardOnFraudCleared operation in DefaultApi.
 * @export
 * @interface DefaultApiUnlockCardOnFraudClearedRequest
 */
export interface DefaultApiUnlockCardOnFraudClearedRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUnlockCardOnFraudCleared
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUnlockCardOnFraudCleared
     */
    readonly cardId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUnlockCardOnFraudCleared
     */
    readonly visaTransactionReferenceId: string
}

/**
 * Request parameters for updateAvailableCurrencies operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateAvailableCurrenciesRequest
 */
export interface DefaultApiUpdateAvailableCurrenciesRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateAvailableCurrencies
     */
    readonly userAccountId: string

    /**
     * 
     * @type {UpdateAvailableCurrenciesRequest}
     * @memberof DefaultApiUpdateAvailableCurrencies
     */
    readonly updateAvailableCurrenciesRequest: UpdateAvailableCurrenciesRequest
}

/**
 * Request parameters for updateAvailableMerchantCategories operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateAvailableMerchantCategoriesRequest
 */
export interface DefaultApiUpdateAvailableMerchantCategoriesRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateAvailableMerchantCategories
     */
    readonly userAccountId: string

    /**
     * 
     * @type {UpdateAvailableMerchantCategoriesRequest}
     * @memberof DefaultApiUpdateAvailableMerchantCategories
     */
    readonly updateAvailableMerchantCategoriesRequest: UpdateAvailableMerchantCategoriesRequest
}

/**
 * Request parameters for updateCardAccountUnit operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateCardAccountUnitRequest
 */
export interface DefaultApiUpdateCardAccountUnitRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateCardAccountUnit
     */
    readonly organizationId: string

    /**
     * 
     * @type {UpdateCardAccountUnitRequest}
     * @memberof DefaultApiUpdateCardAccountUnit
     */
    readonly updateCardAccountUnitRequest: UpdateCardAccountUnitRequest
}

/**
 * Request parameters for updateCardCountLimit operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateCardCountLimitRequest
 */
export interface DefaultApiUpdateCardCountLimitRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateCardCountLimit
     */
    readonly organizationId: string

    /**
     * 
     * @type {UpdateCardCountLimitRequest}
     * @memberof DefaultApiUpdateCardCountLimit
     */
    readonly updateCardCountLimitRequest: UpdateCardCountLimitRequest
}

/**
 * Request parameters for updateCardHolder operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateCardHolderRequest
 */
export interface DefaultApiUpdateCardHolderRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateCardHolder
     */
    readonly userAccountId: string

    /**
     * 
     * @type {UpdateCardHolderRequest}
     * @memberof DefaultApiUpdateCardHolder
     */
    readonly updateCardHolderRequest: UpdateCardHolderRequest
}

/**
 * Request parameters for updateCardLock operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateCardLockRequest
 */
export interface DefaultApiUpdateCardLockRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateCardLock
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateCardLock
     */
    readonly cardId: string
}

/**
 * Request parameters for updateCardUnlock operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateCardUnlockRequest
 */
export interface DefaultApiUpdateCardUnlockRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateCardUnlock
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateCardUnlock
     */
    readonly cardId: string
}

/**
 * Request parameters for updateComment operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateCommentRequest
 */
export interface DefaultApiUpdateCommentRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateComment
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateComment
     */
    readonly paymentReferenceId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateComment
     */
    readonly cardTransactionCommentId: string

    /**
     * 
     * @type {UpdateCommentRequest}
     * @memberof DefaultApiUpdateComment
     */
    readonly updateCommentRequest: UpdateCommentRequest
}

/**
 * Request parameters for updateCommentTemplate operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateCommentTemplateRequest
 */
export interface DefaultApiUpdateCommentTemplateRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateCommentTemplate
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateCommentTemplate
     */
    readonly templateId: string

    /**
     * 
     * @type {UpdateCommentTemplateRequest}
     * @memberof DefaultApiUpdateCommentTemplate
     */
    readonly updateCommentTemplateRequest: UpdateCommentTemplateRequest
}

/**
 * Request parameters for updateCorporateDocumentResult operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateCorporateDocumentResultRequest
 */
export interface DefaultApiUpdateCorporateDocumentResultRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateCorporateDocumentResult
     */
    readonly organizationIdentityVerificationId: string

    /**
     * 
     * @type {UpdateCorporateDocumentResultRequest}
     * @memberof DefaultApiUpdateCorporateDocumentResult
     */
    readonly updateCorporateDocumentResultRequest: UpdateCorporateDocumentResultRequest
}

/**
 * Request parameters for updateDailyUserUsageLimit operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateDailyUserUsageLimitRequest
 */
export interface DefaultApiUpdateDailyUserUsageLimitRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateDailyUserUsageLimit
     */
    readonly userAccountId: string

    /**
     * 
     * @type {UpdateDailyUserUsageLimitRequest}
     * @memberof DefaultApiUpdateDailyUserUsageLimit
     */
    readonly updateDailyUserUsageLimitRequest: UpdateDailyUserUsageLimitRequest
}

/**
 * Request parameters for updateDepositRestrictionForOrganization operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateDepositRestrictionForOrganizationRequest
 */
export interface DefaultApiUpdateDepositRestrictionForOrganizationRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateDepositRestrictionForOrganization
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateDepositRestrictionForOrganization
     */
    readonly depositRestrictionId: string

    /**
     * 
     * @type {UpdateDepositRestrictionForOrganizationRequest}
     * @memberof DefaultApiUpdateDepositRestrictionForOrganization
     */
    readonly updateDepositRestrictionForOrganizationRequest: UpdateDepositRestrictionForOrganizationRequest
}

/**
 * Request parameters for updateEmailNotification operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateEmailNotificationRequest
 */
export interface DefaultApiUpdateEmailNotificationRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateEmailNotification
     */
    readonly userId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateEmailNotification
     */
    readonly emailNotificationId: string

    /**
     * 
     * @type {UpdateEmailNotificationRequest}
     * @memberof DefaultApiUpdateEmailNotification
     */
    readonly updateEmailNotificationRequest: UpdateEmailNotificationRequest
}

/**
 * Request parameters for updateEmbedUrlMethod operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateEmbedUrlMethodRequest
 */
export interface DefaultApiUpdateEmbedUrlMethodRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateEmbedUrlMethod
     */
    readonly organizationId: string

    /**
     * 
     * @type {UpdateEmbedUrlMethodRequest}
     * @memberof DefaultApiUpdateEmbedUrlMethod
     */
    readonly updateEmbedUrlMethodRequest: UpdateEmbedUrlMethodRequest
}

/**
 * Request parameters for updateEvidenceImage operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateEvidenceImageRequest
 */
export interface DefaultApiUpdateEvidenceImageRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateEvidenceImage
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateEvidenceImage
     */
    readonly paymentReferenceId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateEvidenceImage
     */
    readonly cardTransactionEvidenceId: string

    /**
     * 
     * @type {File}
     * @memberof DefaultApiUpdateEvidenceImage
     */
    readonly file?: File

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateEvidenceImage
     */
    readonly electronicMethod?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateEvidenceImage
     */
    readonly documentSize?: string

    /**
     * 
     * @type {number}
     * @memberof DefaultApiUpdateEvidenceImage
     */
    readonly heightMillis?: number

    /**
     * 
     * @type {number}
     * @memberof DefaultApiUpdateEvidenceImage
     */
    readonly widthMillis?: number

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateEvidenceImage
     */
    readonly note?: string

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiUpdateEvidenceImage
     */
    readonly irrelevantToLedger?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiUpdateEvidenceImage
     */
    readonly dpiForciblyValid?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiUpdateEvidenceImage
     */
    readonly colorGradationForciblyValid?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiUpdateEvidenceImage
     */
    readonly uploadedByRecipient?: boolean

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateEvidenceImage
     */
    readonly uploadedFrom?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateEvidenceImage
     */
    readonly invoiceIssuerName?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateEvidenceImage
     */
    readonly invoiceIssuerRegistrationNumber?: string

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiUpdateEvidenceImage
     */
    readonly asQualified?: boolean
}

/**
 * Request parameters for updateEvidenceInfo operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateEvidenceInfoRequest
 */
export interface DefaultApiUpdateEvidenceInfoRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateEvidenceInfo
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateEvidenceInfo
     */
    readonly paymentReferenceId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateEvidenceInfo
     */
    readonly cardTransactionEvidenceId: string

    /**
     * 
     * @type {UpdateEvidenceInfoRequest}
     * @memberof DefaultApiUpdateEvidenceInfo
     */
    readonly updateEvidenceInfoRequest: UpdateEvidenceInfoRequest
}

/**
 * Request parameters for updateFreeeConnect operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateFreeeConnectRequest
 */
export interface DefaultApiUpdateFreeeConnectRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateFreeeConnect
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateFreeeConnect
     */
    readonly code: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateFreeeConnect
     */
    readonly state: string
}

/**
 * Request parameters for updateFreeeJournaling operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateFreeeJournalingRequest
 */
export interface DefaultApiUpdateFreeeJournalingRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateFreeeJournaling
     */
    readonly organizationId: string

    /**
     * 
     * @type {UpdateFreeeJournalingRequest}
     * @memberof DefaultApiUpdateFreeeJournaling
     */
    readonly updateFreeeJournalingRequest: UpdateFreeeJournalingRequest
}

/**
 * Request parameters for updateFreeeSelectCompany operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateFreeeSelectCompanyRequest
 */
export interface DefaultApiUpdateFreeeSelectCompanyRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateFreeeSelectCompany
     */
    readonly organizationId: string

    /**
     * 
     * @type {UpdateFreeeSelectCompanyRequest}
     * @memberof DefaultApiUpdateFreeeSelectCompany
     */
    readonly updateFreeeSelectCompanyRequest: UpdateFreeeSelectCompanyRequest
}

/**
 * Request parameters for updateLockStatusOfEvidences operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateLockStatusOfEvidencesRequest
 */
export interface DefaultApiUpdateLockStatusOfEvidencesRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateLockStatusOfEvidences
     */
    readonly organizationId: string

    /**
     * 
     * @type {UpdateLockStatusOfEvidencesRequest}
     * @memberof DefaultApiUpdateLockStatusOfEvidences
     */
    readonly updateLockStatusOfEvidencesRequest: UpdateLockStatusOfEvidencesRequest
}

/**
 * Request parameters for updateMerchantGeneralBlockAllowedOrganizationIds operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateMerchantGeneralBlockAllowedOrganizationIdsRequest
 */
export interface DefaultApiUpdateMerchantGeneralBlockAllowedOrganizationIdsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateMerchantGeneralBlockAllowedOrganizationIds
     */
    readonly merchantGeneralBlockListId: string

    /**
     * 
     * @type {UpdateMerchantGeneralBlockAllowedOrganizationIdsRequest}
     * @memberof DefaultApiUpdateMerchantGeneralBlockAllowedOrganizationIds
     */
    readonly updateMerchantGeneralBlockAllowedOrganizationIdsRequest: UpdateMerchantGeneralBlockAllowedOrganizationIdsRequest
}

/**
 * Request parameters for updateMerchantGeneralBlockList operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateMerchantGeneralBlockListRequest
 */
export interface DefaultApiUpdateMerchantGeneralBlockListRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateMerchantGeneralBlockList
     */
    readonly merchantGeneralBlockListId: string

    /**
     * 
     * @type {UpdateMerchantGeneralBlockListRequest}
     * @memberof DefaultApiUpdateMerchantGeneralBlockList
     */
    readonly updateMerchantGeneralBlockListRequest: UpdateMerchantGeneralBlockListRequest
}

/**
 * Request parameters for updateMerchantOrgBlockList operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateMerchantOrgBlockListRequest
 */
export interface DefaultApiUpdateMerchantOrgBlockListRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateMerchantOrgBlockList
     */
    readonly merchantOrgBlockListId: string

    /**
     * 
     * @type {UpdateMerchantOrgBlockListRequest}
     * @memberof DefaultApiUpdateMerchantOrgBlockList
     */
    readonly updateMerchantOrgBlockListRequest: UpdateMerchantOrgBlockListRequest
}

/**
 * Request parameters for updateMerchantOrganizationComment operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateMerchantOrganizationCommentRequest
 */
export interface DefaultApiUpdateMerchantOrganizationCommentRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateMerchantOrganizationComment
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateMerchantOrganizationComment
     */
    readonly merchantId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateMerchantOrganizationComment
     */
    readonly userAccountId: string

    /**
     * 
     * @type {UpdateMerchantOrganizationCommentRequest}
     * @memberof DefaultApiUpdateMerchantOrganizationComment
     */
    readonly updateMerchantOrganizationCommentRequest: UpdateMerchantOrganizationCommentRequest
}

/**
 * Request parameters for updateOrganization operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateOrganizationRequest
 */
export interface DefaultApiUpdateOrganizationRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateOrganization
     */
    readonly organizationId: string

    /**
     * 
     * @type {UpdateOrganizationRequest}
     * @memberof DefaultApiUpdateOrganization
     */
    readonly updateOrganizationRequest: UpdateOrganizationRequest
}

/**
 * Request parameters for updateOrganizationsAccountingCsvExportFields operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateOrganizationsAccountingCsvExportFieldsRequest
 */
export interface DefaultApiUpdateOrganizationsAccountingCsvExportFieldsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateOrganizationsAccountingCsvExportFields
     */
    readonly organizationId: string

    /**
     * 
     * @type {Array<string>}
     * @memberof DefaultApiUpdateOrganizationsAccountingCsvExportFields
     */
    readonly requestBody: Array<string>
}

/**
 * Request parameters for updatePaymentRequestEvidence operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdatePaymentRequestEvidenceRequest
 */
export interface DefaultApiUpdatePaymentRequestEvidenceRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdatePaymentRequestEvidence
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdatePaymentRequestEvidence
     */
    readonly paymentRequestId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdatePaymentRequestEvidence
     */
    readonly evidenceId: string

    /**
     * 
     * @type {UpdatePaymentRequestEvidenceRequest}
     * @memberof DefaultApiUpdatePaymentRequestEvidence
     */
    readonly updatePaymentRequestEvidenceRequest: UpdatePaymentRequestEvidenceRequest
}

/**
 * Request parameters for updatePaymentRequestEvidenceFile operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdatePaymentRequestEvidenceFileRequest
 */
export interface DefaultApiUpdatePaymentRequestEvidenceFileRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdatePaymentRequestEvidenceFile
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdatePaymentRequestEvidenceFile
     */
    readonly paymentRequestId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdatePaymentRequestEvidenceFile
     */
    readonly evidenceId: string

    /**
     * 
     * @type {File}
     * @memberof DefaultApiUpdatePaymentRequestEvidenceFile
     */
    readonly file?: File

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdatePaymentRequestEvidenceFile
     */
    readonly electronicMethod?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdatePaymentRequestEvidenceFile
     */
    readonly documentSize?: string

    /**
     * 
     * @type {number}
     * @memberof DefaultApiUpdatePaymentRequestEvidenceFile
     */
    readonly heightMillis?: number

    /**
     * 
     * @type {number}
     * @memberof DefaultApiUpdatePaymentRequestEvidenceFile
     */
    readonly widthMillis?: number

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiUpdatePaymentRequestEvidenceFile
     */
    readonly dpiForciblyValid?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiUpdatePaymentRequestEvidenceFile
     */
    readonly colorGradationForciblyValid?: boolean

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdatePaymentRequestEvidenceFile
     */
    readonly note?: string

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiUpdatePaymentRequestEvidenceFile
     */
    readonly irrelevantToLedger?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiUpdatePaymentRequestEvidenceFile
     */
    readonly uploadedByRecipient?: boolean

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdatePaymentRequestEvidenceFile
     */
    readonly uploadedFrom?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdatePaymentRequestEvidenceFile
     */
    readonly invoiceIssuerRegistrationNumber?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdatePaymentRequestEvidenceFile
     */
    readonly invoiceIssuerName?: string

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiUpdatePaymentRequestEvidenceFile
     */
    readonly asQualified?: boolean
}

/**
 * Request parameters for updatePurchaseApplicationTemplate operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdatePurchaseApplicationTemplateRequest
 */
export interface DefaultApiUpdatePurchaseApplicationTemplateRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdatePurchaseApplicationTemplate
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdatePurchaseApplicationTemplate
     */
    readonly purchaseTemplateId: string

    /**
     * 
     * @type {UpdatePurchaseApplicationTemplateRequest}
     * @memberof DefaultApiUpdatePurchaseApplicationTemplate
     */
    readonly updatePurchaseApplicationTemplateRequest?: UpdatePurchaseApplicationTemplateRequest
}

/**
 * Request parameters for updateRemoveUserAccountGroup operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateRemoveUserAccountGroupRequest
 */
export interface DefaultApiUpdateRemoveUserAccountGroupRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateRemoveUserAccountGroup
     */
    readonly userAccountId: string

    /**
     * 
     * @type {UpdateRemoveUserAccountGroupRequest}
     * @memberof DefaultApiUpdateRemoveUserAccountGroup
     */
    readonly updateRemoveUserAccountGroupRequest: UpdateRemoveUserAccountGroupRequest
}

/**
 * Request parameters for updateRoleResourceForUser operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateRoleResourceForUserRequest
 */
export interface DefaultApiUpdateRoleResourceForUserRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateRoleResourceForUser
     */
    readonly userId: string

    /**
     * 
     * @type {UpdateRoleResourceForUserRequest}
     * @memberof DefaultApiUpdateRoleResourceForUser
     */
    readonly updateRoleResourceForUserRequest: UpdateRoleResourceForUserRequest
}

/**
 * Request parameters for updateRolesByResourceId operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateRolesByResourceIdRequest
 */
export interface DefaultApiUpdateRolesByResourceIdRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateRolesByResourceId
     */
    readonly resourceScope: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateRolesByResourceId
     */
    readonly resourceId: string

    /**
     * 
     * @type {UpdateRolesByResourceIdRequest}
     * @memberof DefaultApiUpdateRolesByResourceId
     */
    readonly updateRolesByResourceIdRequest: UpdateRolesByResourceIdRequest
}

/**
 * Request parameters for updateSlackEvidenceReminderPerChannel operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateSlackEvidenceReminderPerChannelRequest
 */
export interface DefaultApiUpdateSlackEvidenceReminderPerChannelRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateSlackEvidenceReminderPerChannel
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateSlackEvidenceReminderPerChannel
     */
    readonly channelId: string

    /**
     * 
     * @type {UpdateSlackEvidenceReminderPerChannelRequest}
     * @memberof DefaultApiUpdateSlackEvidenceReminderPerChannel
     */
    readonly updateSlackEvidenceReminderPerChannelRequest: UpdateSlackEvidenceReminderPerChannelRequest
}

/**
 * Request parameters for updateSlackNotificationSettingForCard operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateSlackNotificationSettingForCardRequest
 */
export interface DefaultApiUpdateSlackNotificationSettingForCardRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateSlackNotificationSettingForCard
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateSlackNotificationSettingForCard
     */
    readonly channelId: string

    /**
     * 
     * @type {UpdateSlackNotificationSettingForCardRequest}
     * @memberof DefaultApiUpdateSlackNotificationSettingForCard
     */
    readonly updateSlackNotificationSettingForCardRequest: UpdateSlackNotificationSettingForCardRequest
}

/**
 * Request parameters for updateSlackNotificationSettingForPurchaseApplication operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateSlackNotificationSettingForPurchaseApplicationRequest
 */
export interface DefaultApiUpdateSlackNotificationSettingForPurchaseApplicationRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateSlackNotificationSettingForPurchaseApplication
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateSlackNotificationSettingForPurchaseApplication
     */
    readonly channelId: string

    /**
     * 
     * @type {UpdateSlackNotificationSettingForPurchaseApplicationRequest}
     * @memberof DefaultApiUpdateSlackNotificationSettingForPurchaseApplication
     */
    readonly updateSlackNotificationSettingForPurchaseApplicationRequest: UpdateSlackNotificationSettingForPurchaseApplicationRequest
}

/**
 * Request parameters for updateSyncToFreeeFromDeal operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateSyncToFreeeFromDealRequest
 */
export interface DefaultApiUpdateSyncToFreeeFromDealRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateSyncToFreeeFromDeal
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateSyncToFreeeFromDeal
     */
    readonly companyId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateSyncToFreeeFromDeal
     */
    readonly dealId: string
}

/**
 * Request parameters for updateSynchronizeToFreeeLogConfirm operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateSynchronizeToFreeeLogConfirmRequest
 */
export interface DefaultApiUpdateSynchronizeToFreeeLogConfirmRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateSynchronizeToFreeeLogConfirm
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateSynchronizeToFreeeLogConfirm
     */
    readonly companyId: string

    /**
     * 
     * @type {UpdateSynchronizeToFreeeLogConfirmRequest}
     * @memberof DefaultApiUpdateSynchronizeToFreeeLogConfirm
     */
    readonly updateSynchronizeToFreeeLogConfirmRequest: UpdateSynchronizeToFreeeLogConfirmRequest
}

/**
 * Request parameters for updateTeamsNotificationSettingForCard operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateTeamsNotificationSettingForCardRequest
 */
export interface DefaultApiUpdateTeamsNotificationSettingForCardRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateTeamsNotificationSettingForCard
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateTeamsNotificationSettingForCard
     */
    readonly channelId: string

    /**
     * 
     * @type {UpdateTeamsNotificationSettingForCardRequest}
     * @memberof DefaultApiUpdateTeamsNotificationSettingForCard
     */
    readonly updateTeamsNotificationSettingForCardRequest: UpdateTeamsNotificationSettingForCardRequest
}

/**
 * Request parameters for updateTransactionUpperLimitForTheUserAccount operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateTransactionUpperLimitForTheUserAccountRequest
 */
export interface DefaultApiUpdateTransactionUpperLimitForTheUserAccountRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateTransactionUpperLimitForTheUserAccount
     */
    readonly userAccountId: string

    /**
     * 
     * @type {UpdateTransactionUpperLimitForTheUserAccountRequest}
     * @memberof DefaultApiUpdateTransactionUpperLimitForTheUserAccount
     */
    readonly updateTransactionUpperLimitForTheUserAccountRequest: UpdateTransactionUpperLimitForTheUserAccountRequest
}

/**
 * Request parameters for updateUserAccountGroup operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateUserAccountGroupRequest
 */
export interface DefaultApiUpdateUserAccountGroupRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateUserAccountGroup
     */
    readonly userAccountId: string

    /**
     * 
     * @type {UpdateUserAccountGroupRequest}
     * @memberof DefaultApiUpdateUserAccountGroup
     */
    readonly updateUserAccountGroupRequest: UpdateUserAccountGroupRequest
}

/**
 * Request parameters for updateUserAccountName operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateUserAccountNameRequest
 */
export interface DefaultApiUpdateUserAccountNameRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateUserAccountName
     */
    readonly userAccountId: string

    /**
     * 
     * @type {UpdateUserAccountNameRequest}
     * @memberof DefaultApiUpdateUserAccountName
     */
    readonly updateUserAccountNameRequest: UpdateUserAccountNameRequest
}

/**
 * Request parameters for updateUserEmail operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateUserEmailRequest
 */
export interface DefaultApiUpdateUserEmailRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateUserEmail
     */
    readonly userId: string

    /**
     * 
     * @type {UpdateUserEmailRequest}
     * @memberof DefaultApiUpdateUserEmail
     */
    readonly updateUserEmailRequest: UpdateUserEmailRequest
}

/**
 * Request parameters for updateUserName operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateUserNameRequest
 */
export interface DefaultApiUpdateUserNameRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateUserName
     */
    readonly userId: string

    /**
     * 
     * @type {UpdateUserNameRequest}
     * @memberof DefaultApiUpdateUserName
     */
    readonly updateUserNameRequest: UpdateUserNameRequest
}

/**
 * Request parameters for updateUserOrganization operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateUserOrganizationRequest
 */
export interface DefaultApiUpdateUserOrganizationRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateUserOrganization
     */
    readonly userId: string

    /**
     * 
     * @type {UpdateUserOrganizationRequest}
     * @memberof DefaultApiUpdateUserOrganization
     */
    readonly updateUserOrganizationRequest: UpdateUserOrganizationRequest
}

/**
 * Request parameters for updateUserPassword operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateUserPasswordRequest
 */
export interface DefaultApiUpdateUserPasswordRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateUserPassword
     */
    readonly userId: string

    /**
     * 
     * @type {UpdateUserPasswordRequest}
     * @memberof DefaultApiUpdateUserPassword
     */
    readonly updateUserPasswordRequest: UpdateUserPasswordRequest
}

/**
 * Request parameters for updateUserPrivilege operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateUserPrivilegeRequest
 */
export interface DefaultApiUpdateUserPrivilegeRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateUserPrivilege
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateUserPrivilege
     */
    readonly userId: string

    /**
     * 
     * @type {UpdateUserPrivilegeRequest}
     * @memberof DefaultApiUpdateUserPrivilege
     */
    readonly updateUserPrivilegeRequest: UpdateUserPrivilegeRequest
}

/**
 * Request parameters for updateUserUsageLimit operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateUserUsageLimitRequest
 */
export interface DefaultApiUpdateUserUsageLimitRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateUserUsageLimit
     */
    readonly userAccountId: string

    /**
     * 
     * @type {UpdateUserUsageLimitRequest}
     * @memberof DefaultApiUpdateUserUsageLimit
     */
    readonly updateUserUsageLimitRequest: UpdateUserUsageLimitRequest
}

/**
 * Request parameters for uploadCardTransactionEvidenceImage operation in DefaultApi.
 * @export
 * @interface DefaultApiUploadCardTransactionEvidenceImageRequest
 */
export interface DefaultApiUploadCardTransactionEvidenceImageRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUploadCardTransactionEvidenceImage
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUploadCardTransactionEvidenceImage
     */
    readonly paymentReferenceId: string

    /**
     * 
     * @type {Array<File>}
     * @memberof DefaultApiUploadCardTransactionEvidenceImage
     */
    readonly files?: Array<File>

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUploadCardTransactionEvidenceImage
     */
    readonly electronicMethod?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUploadCardTransactionEvidenceImage
     */
    readonly documentSize?: string

    /**
     * 
     * @type {number}
     * @memberof DefaultApiUploadCardTransactionEvidenceImage
     */
    readonly heightMillis?: number

    /**
     * 
     * @type {number}
     * @memberof DefaultApiUploadCardTransactionEvidenceImage
     */
    readonly widthMillis?: number

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUploadCardTransactionEvidenceImage
     */
    readonly note?: string

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiUploadCardTransactionEvidenceImage
     */
    readonly irrelevantToLedger?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiUploadCardTransactionEvidenceImage
     */
    readonly uploadedByRecipient?: boolean

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUploadCardTransactionEvidenceImage
     */
    readonly uploadedFrom?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUploadCardTransactionEvidenceImage
     */
    readonly invoiceIssuerName?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUploadCardTransactionEvidenceImage
     */
    readonly invoiceIssuerRegistrationNumber?: string

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiUploadCardTransactionEvidenceImage
     */
    readonly asQualified?: boolean
}

/**
 * Request parameters for uploadCorporateDocument operation in DefaultApi.
 * @export
 * @interface DefaultApiUploadCorporateDocumentRequest
 */
export interface DefaultApiUploadCorporateDocumentRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUploadCorporateDocument
     */
    readonly organizationIdentityVerificationId: string

    /**
     * 
     * @type {File}
     * @memberof DefaultApiUploadCorporateDocument
     */
    readonly file: File
}

/**
 * Request parameters for uploadPaymentRequestEvidenceImage operation in DefaultApi.
 * @export
 * @interface DefaultApiUploadPaymentRequestEvidenceImageRequest
 */
export interface DefaultApiUploadPaymentRequestEvidenceImageRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUploadPaymentRequestEvidenceImage
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUploadPaymentRequestEvidenceImage
     */
    readonly paymentRequestId: string

    /**
     * 
     * @type {File}
     * @memberof DefaultApiUploadPaymentRequestEvidenceImage
     */
    readonly file?: File

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUploadPaymentRequestEvidenceImage
     */
    readonly electronicMethod?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUploadPaymentRequestEvidenceImage
     */
    readonly documentSize?: string

    /**
     * 
     * @type {number}
     * @memberof DefaultApiUploadPaymentRequestEvidenceImage
     */
    readonly heightMillis?: number

    /**
     * 
     * @type {number}
     * @memberof DefaultApiUploadPaymentRequestEvidenceImage
     */
    readonly widthMillis?: number

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUploadPaymentRequestEvidenceImage
     */
    readonly note?: string

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiUploadPaymentRequestEvidenceImage
     */
    readonly irrelevantToLedger?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiUploadPaymentRequestEvidenceImage
     */
    readonly uploadedByRecipient?: boolean

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUploadPaymentRequestEvidenceImage
     */
    readonly uploadedFrom?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUploadPaymentRequestEvidenceImage
     */
    readonly invoiceIssuerName?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUploadPaymentRequestEvidenceImage
     */
    readonly invoiceIssuerRegistrationNumber?: string

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiUploadPaymentRequestEvidenceImage
     */
    readonly asQualified?: boolean
}

/**
 * Request parameters for usersEmailConfirm operation in DefaultApi.
 * @export
 * @interface DefaultApiUsersEmailConfirmRequest
 */
export interface DefaultApiUsersEmailConfirmRequest {
    /**
     * 
     * @type {UsersEmailConfirmRequest}
     * @memberof DefaultApiUsersEmailConfirm
     */
    readonly usersEmailConfirmRequest: UsersEmailConfirmRequest
}

/**
 * Request parameters for verifyMoneytreeConnections operation in DefaultApi.
 * @export
 * @interface DefaultApiVerifyMoneytreeConnectionsRequest
 */
export interface DefaultApiVerifyMoneytreeConnectionsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiVerifyMoneytreeConnections
     */
    readonly organizationId: string
}

/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
export class DefaultApi extends BaseAPI {
    /**
     * 
     * @summary Add comment for card transaction
     * @param {DefaultApiAddCommentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public addComment(requestParameters: DefaultApiAddCommentRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).addComment(requestParameters.organizationId, requestParameters.paymentReferenceId, requestParameters.addCommentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add Organization Create Request
     * @param {DefaultApiAddOrganizationCreateRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public addOrganizationCreateRequest(requestParameters: DefaultApiAddOrganizationCreateRequestRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).addOrganizationCreateRequest(requestParameters.addOrganizationCreateRequestRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary add point to organization
     * @param {DefaultApiAddPointToOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public addPointToOrganization(requestParameters: DefaultApiAddPointToOrganizationRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).addPointToOrganization(requestParameters.organizationId, requestParameters.addPointToOrganizationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Agree to the agreement request
     * @param {DefaultApiAgreeToAgreementRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public agreeToAgreementRequest(requestParameters: DefaultApiAgreeToAgreementRequestRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).agreeToAgreementRequest(requestParameters.organizationId, requestParameters.agreementRequestId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Analyze evidence
     * @param {DefaultApiAnalyzeEvidenceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public analyzeEvidence(requestParameters: DefaultApiAnalyzeEvidenceRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).analyzeEvidence(requestParameters.organizationId, requestParameters.file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Analyze invoice of payment requests
     * @param {DefaultApiAnalyzeInvoiceOfPaymentRequestsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public analyzeInvoiceOfPaymentRequests(requestParameters: DefaultApiAnalyzeInvoiceOfPaymentRequestsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).analyzeInvoiceOfPaymentRequests(requestParameters.organizationId, requestParameters.file, requestParameters.xUpsidrSwitchUser, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Approve organization identity verification
     * @param {DefaultApiApproveOrganizationIdentityVerificationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public approveOrganizationIdentityVerification(requestParameters: DefaultApiApproveOrganizationIdentityVerificationRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).approveOrganizationIdentityVerification(requestParameters.organizationIdentityVerificationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Approve purchase application.
     * @param {DefaultApiApprovePurchaseApplicationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public approvePurchaseApplication(requestParameters: DefaultApiApprovePurchaseApplicationRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).approvePurchaseApplication(requestParameters.organizationId, requestParameters.purchaseApplicationId, requestParameters.approvePurchaseApplicationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Approve workflow step of payment request
     * @param {DefaultApiApproveWorkflowStepPaymentRequestsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public approveWorkflowStepPaymentRequests(requestParameters: DefaultApiApproveWorkflowStepPaymentRequestsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).approveWorkflowStepPaymentRequests(requestParameters.organizationId, requestParameters.xUpsidrSwitchUser, requestParameters.approveWorkflowStepPaymentRequestsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Automatically journalize deals from rules
     * @param {DefaultApiAutomaticallyJournalizeDealsFromRulesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public automaticallyJournalizeDealsFromRules(requestParameters: DefaultApiAutomaticallyJournalizeDealsFromRulesRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).automaticallyJournalizeDealsFromRules(requestParameters.organizationId, requestParameters.companyId, requestParameters.automaticallyJournalizeDealsFromRulesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Bank Account Activities Withdrawal Reserve
     * @param {DefaultApiBankAccountActivitiesWithdrawalReserveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public bankAccountActivitiesWithdrawalReserve(requestParameters: DefaultApiBankAccountActivitiesWithdrawalReserveRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).bankAccountActivitiesWithdrawalReserve(requestParameters.bankAccountActivitiesWithdrawalReserveRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Disable daily usage limit for an user account
     * @param {DefaultApiBulkDisableDailyUserUsageLimitRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public bulkDisableDailyUserUsageLimit(requestParameters: DefaultApiBulkDisableDailyUserUsageLimitRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).bulkDisableDailyUserUsageLimit(requestParameters.bulkDisableDailyUserUsageLimitRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Bulk disable monthly usage limit
     * @param {DefaultApiBulkDisableMonthlyUsageLimitRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public bulkDisableMonthlyUsageLimit(requestParameters: DefaultApiBulkDisableMonthlyUsageLimitRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).bulkDisableMonthlyUsageLimit(requestParameters.bulkDisableMonthlyUsageLimitRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Bulk update daily usage limit
     * @param {DefaultApiBulkUpdateDailyUsageLimitRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public bulkUpdateDailyUsageLimit(requestParameters: DefaultApiBulkUpdateDailyUsageLimitRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).bulkUpdateDailyUsageLimit(requestParameters.bulkUpdateDailyUsageLimitRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Bulk update monthly usage limit
     * @param {DefaultApiBulkUpdateMonthlyUsageLimitRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public bulkUpdateMonthlyUsageLimit(requestParameters: DefaultApiBulkUpdateMonthlyUsageLimitRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).bulkUpdateMonthlyUsageLimit(requestParameters.bulkUpdateMonthlyUsageLimitRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Bulk Update Organization User Privileges
     * @param {DefaultApiBulkUpdateOrganizationUserPrivilegesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public bulkUpdateOrganizationUserPrivileges(requestParameters: DefaultApiBulkUpdateOrganizationUserPrivilegesRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).bulkUpdateOrganizationUserPrivileges(requestParameters.organizationId, requestParameters.bulkUpdateOrganizationUserPrivilegesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Cancel draft payment request
     * @param {DefaultApiCancelDraftPaymentRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public cancelDraftPaymentRequest(requestParameters: DefaultApiCancelDraftPaymentRequestRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).cancelDraftPaymentRequest(requestParameters.organizationId, requestParameters.draftPaymentRequestId, requestParameters.xUpsidrSwitchUser, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Cancel payment request
     * @param {DefaultApiCancelPaymentRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public cancelPaymentRequest(requestParameters: DefaultApiCancelPaymentRequestRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).cancelPaymentRequest(requestParameters.organizationId, requestParameters.paymentRequestId, requestParameters.xUpsidrSwitchUser, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Change Identity Verification Scheduled Date
     * @param {DefaultApiChangeIdentityVerificationScheduledDateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public changeIdentityVerificationScheduledDate(requestParameters: DefaultApiChangeIdentityVerificationScheduledDateRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).changeIdentityVerificationScheduledDate(requestParameters.organizationId, requestParameters.changeIdentityVerificationScheduledDateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Change Invoice Email
     * @param {DefaultApiChangeInvoiceEmailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public changeInvoiceEmail(requestParameters: DefaultApiChangeInvoiceEmailRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).changeInvoiceEmail(requestParameters.organizationId, requestParameters.changeInvoiceEmailRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Change to the specified ekyc result
     * @param {DefaultApiChangeToTheSpecifiedEkycResultRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public changeToTheSpecifiedEkycResult(requestParameters: DefaultApiChangeToTheSpecifiedEkycResultRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).changeToTheSpecifiedEkycResult(requestParameters.identificationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Check Already Registered Phone Number
     * @param {DefaultApiCheckAlreadyRegisteredPhoneNumberRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public checkAlreadyRegisteredPhoneNumber(requestParameters: DefaultApiCheckAlreadyRegisteredPhoneNumberRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).checkAlreadyRegisteredPhoneNumber(requestParameters.checkAlreadyRegisteredPhoneNumberRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Check All Organization Available Limit And Notify
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public checkAvailableLimit(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).checkAvailableLimit(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Check duplicate email addresses
     * @param {DefaultApiCheckDuplicateEmailAddressesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public checkDuplicateEmailAddresses(requestParameters: DefaultApiCheckDuplicateEmailAddressesRequest = {}, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).checkDuplicateEmailAddresses(requestParameters.emailAddresses, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public checkMonthlyUsageLimit(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).checkMonthlyUsageLimit(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * It is an API that waits for a redirect after the payment request fix button is pressed in the Slack App. This API does three things:   - Slack message modification - remove each button attached to the original message   - Post messages to Slack - communicate the fact that the edit button was pressed   - Create payment request for draft data
     * @summary Complete redirect from slack
     * @param {DefaultApiCompleteRedirectFromSlackRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public completeRedirectFromSlack(requestParameters: DefaultApiCompleteRedirectFromSlackRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).completeRedirectFromSlack(requestParameters.organizationId, requestParameters.completeRedirectFromSlackRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Count deals
     * @param {DefaultApiCountDealsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public countDeals(requestParameters: DefaultApiCountDealsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).countDeals(requestParameters.organizationId, requestParameters.countDealsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create bank transfers for the specified payment requests.
     * @summary Create bank transfers
     * @param {DefaultApiCreateBankTransfersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createBankTransfers(requestParameters: DefaultApiCreateBankTransfersRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createBankTransfers(requestParameters.organizationId, requestParameters.createBankTransfersRequest, requestParameters.transferDateJstFrom, requestParameters.transferDateJstTo, requestParameters.sourceBankAccountId, requestParameters.downloaded, requestParameters.limit, requestParameters.offset, requestParameters.cursor, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create category of the purchase application template.
     * @param {DefaultApiCreateCategoryOfThePurchaseApplicationTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createCategoryOfThePurchaseApplicationTemplate(requestParameters: DefaultApiCreateCategoryOfThePurchaseApplicationTemplateRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createCategoryOfThePurchaseApplicationTemplate(requestParameters.organizationId, requestParameters.createCategoryOfThePurchaseApplicationTemplateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create comment template
     * @param {DefaultApiCreateCommentTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createCommentTemplate(requestParameters: DefaultApiCreateCommentTemplateRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createCommentTemplate(requestParameters.organizationId, requestParameters.createCommentTemplateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create deposit restriction for organization
     * @param {DefaultApiCreateDepositRestrictionForOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createDepositRestrictionForOrganization(requestParameters: DefaultApiCreateDepositRestrictionForOrganizationRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createDepositRestrictionForOrganization(requestParameters.organizationId, requestParameters.createDepositRestrictionForOrganizationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create draft of payment request
     * @param {DefaultApiCreateDraftOfPaymentRequestsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createDraftOfPaymentRequests(requestParameters: DefaultApiCreateDraftOfPaymentRequestsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createDraftOfPaymentRequests(requestParameters.organizationId, requestParameters.xUpsidrSwitchUser, requestParameters.createDraftOfPaymentRequestsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create evidence request
     * @param {DefaultApiCreateEvidenceRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createEvidenceRequest(requestParameters: DefaultApiCreateEvidenceRequestRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createEvidenceRequest(requestParameters.organizationId, requestParameters.paymentReferenceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create freee partner
     * @param {DefaultApiCreateFreeePartnerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createFreeePartner(requestParameters: DefaultApiCreateFreeePartnerRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createFreeePartner(requestParameters.organizationId, requestParameters.companyId, requestParameters.createFreeePartnerRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create past deals
     * @param {DefaultApiCreatePastDealsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createPastDeals(requestParameters: DefaultApiCreatePastDealsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createPastDeals(requestParameters.organizationId, requestParameters.createPastDealsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create purchase application.
     * @param {DefaultApiCreatePurchaseApplicationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createPurchaseApplication(requestParameters: DefaultApiCreatePurchaseApplicationRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createPurchaseApplication(requestParameters.organizationId, requestParameters.createPurchaseApplicationRequest, requestParameters.visaTransactionReferenceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create purchase application template.
     * @param {DefaultApiCreatePurchaseApplicationTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createPurchaseApplicationTemplate(requestParameters: DefaultApiCreatePurchaseApplicationTemplateRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createPurchaseApplicationTemplate(requestParameters.organizationId, requestParameters.createPurchaseApplicationTemplateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Slack card notification settings of an organization
     * @param {DefaultApiCreateSlackCardNotificationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createSlackCardNotifications(requestParameters: DefaultApiCreateSlackCardNotificationsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createSlackCardNotifications(requestParameters.organizationId, requestParameters.createSlackCardNotificationsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create slack notification settings for purchase-application
     * @param {DefaultApiCreateSlackNotificationSettingsForPurchaseApplicationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createSlackNotificationSettingsForPurchaseApplication(requestParameters: DefaultApiCreateSlackNotificationSettingsForPurchaseApplicationRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createSlackNotificationSettingsForPurchaseApplication(requestParameters.organizationId, requestParameters.createSlackNotificationSettingsForPurchaseApplicationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Teams card notification settings of an organization
     * @param {DefaultApiCreateTeamsCardNotificationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createTeamsCardNotifications(requestParameters: DefaultApiCreateTeamsCardNotificationsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createTeamsCardNotifications(requestParameters.organizationId, requestParameters.createTeamsCardNotificationsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create user account groups
     * @param {DefaultApiCreateUserAccountGroupsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createUserAccountGroups(requestParameters: DefaultApiCreateUserAccountGroupsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createUserAccountGroups(requestParameters.organizationId, requestParameters.createUserAccountGroupsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deactivate a card
     * @param {DefaultApiDeactivateCardRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deactivateCard(requestParameters: DefaultApiDeactivateCardRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deactivateCard(requestParameters.cardId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deactivate a user
     * @param {DefaultApiDeactivateUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deactivateUser(requestParameters: DefaultApiDeactivateUserRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deactivateUser(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Defrost a card
     * @param {DefaultApiDefrostCardRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public defrostCard(requestParameters: DefaultApiDefrostCardRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).defrostCard(requestParameters.cardId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Card Points Rate Configs
     * @param {DefaultApiDeleteCardPointsRateConfigRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteCardPointsRateConfig(requestParameters: DefaultApiDeleteCardPointsRateConfigRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteCardPointsRateConfig(requestParameters.rateConfigId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete category of the purchase application template.
     * @param {DefaultApiDeleteCategoryOfThePurchaseApplicationTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteCategoryOfThePurchaseApplicationTemplate(requestParameters: DefaultApiDeleteCategoryOfThePurchaseApplicationTemplateRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteCategoryOfThePurchaseApplicationTemplate(requestParameters.organizationId, requestParameters.purchaseTemplateCategoryId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete comment for card transaction
     * @param {DefaultApiDeleteCommentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteComment(requestParameters: DefaultApiDeleteCommentRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteComment(requestParameters.organizationId, requestParameters.paymentReferenceId, requestParameters.cardTransactionCommentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete comment template
     * @param {DefaultApiDeleteCommentTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteCommentTemplate(requestParameters: DefaultApiDeleteCommentTemplateRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteCommentTemplate(requestParameters.organizationId, requestParameters.templateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete deposit restriction for organization
     * @param {DefaultApiDeleteDepositRestrictionForOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteDepositRestrictionForOrganization(requestParameters: DefaultApiDeleteDepositRestrictionForOrganizationRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteDepositRestrictionForOrganization(requestParameters.organizationId, requestParameters.depositRestrictionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete evidence
     * @param {DefaultApiDeleteEvidenceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteEvidence(requestParameters: DefaultApiDeleteEvidenceRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteEvidence(requestParameters.organizationId, requestParameters.paymentReferenceId, requestParameters.cardTransactionEvidenceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete freee connected
     * @param {DefaultApiDeleteFreeeConnectedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteFreeeConnected(requestParameters: DefaultApiDeleteFreeeConnectedRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteFreeeConnected(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Freee End Journal Entry Transition Mode
     * @param {DefaultApiDeleteFreeeEndJournalEntryTransitionModeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteFreeeEndJournalEntryTransitionMode(requestParameters: DefaultApiDeleteFreeeEndJournalEntryTransitionModeRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteFreeeEndJournalEntryTransitionMode(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete merchant general block allowed organization ids
     * @param {DefaultApiDeleteMerchantGeneralBlockAllowedOrganizationIdsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteMerchantGeneralBlockAllowedOrganizationIds(requestParameters: DefaultApiDeleteMerchantGeneralBlockAllowedOrganizationIdsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteMerchantGeneralBlockAllowedOrganizationIds(requestParameters.merchantGeneralBlockListId, requestParameters.allowedOrganizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete merchant general block list
     * @param {DefaultApiDeleteMerchantGeneralBlockListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteMerchantGeneralBlockList(requestParameters: DefaultApiDeleteMerchantGeneralBlockListRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteMerchantGeneralBlockList(requestParameters.merchantGeneralBlockListId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete merchant org block list
     * @param {DefaultApiDeleteMerchantOrgBlockListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteMerchantOrgBlockList(requestParameters: DefaultApiDeleteMerchantOrgBlockListRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteMerchantOrgBlockList(requestParameters.merchantOrgBlockListId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete an onboarding request
     * @param {DefaultApiDeleteOnboardingRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteOnboardingRequest(requestParameters: DefaultApiDeleteOnboardingRequestRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteOnboardingRequest(requestParameters.onboardingRequestId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Organization Create Request
     * @param {DefaultApiDeleteOrganizationCreateRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteOrganizationCreateRequest(requestParameters: DefaultApiDeleteOrganizationCreateRequestRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteOrganizationCreateRequest(requestParameters.organizationCreateRequestId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a payment request evidence specified by evidenceId.
     * @summary Delete the specific payment request evidence.
     * @param {DefaultApiDeletePaymentRequestEvidenceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deletePaymentRequestEvidence(requestParameters: DefaultApiDeletePaymentRequestEvidenceRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deletePaymentRequestEvidence(requestParameters.organizationId, requestParameters.paymentRequestId, requestParameters.evidenceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete purchase application.
     * @param {DefaultApiDeletePurchaseApplicationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deletePurchaseApplication(requestParameters: DefaultApiDeletePurchaseApplicationRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deletePurchaseApplication(requestParameters.organizationId, requestParameters.purchaseApplicationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete purchase application templates detail
     * @param {DefaultApiDeletePurchaseApplicationTemplatesDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deletePurchaseApplicationTemplatesDetail(requestParameters: DefaultApiDeletePurchaseApplicationTemplatesDetailRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deletePurchaseApplicationTemplatesDetail(requestParameters.organizationId, requestParameters.purchaseTemplateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete slack notification channel setting for purchase-application
     * @param {DefaultApiDeleteSlackNotificationChannelSettingForPurchaseApplicationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteSlackNotificationChannelSettingForPurchaseApplication(requestParameters: DefaultApiDeleteSlackNotificationChannelSettingForPurchaseApplicationRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteSlackNotificationChannelSettingForPurchaseApplication(requestParameters.organizationId, requestParameters.channelId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete slack notification channel setting for card
     * @param {DefaultApiDeleteSlackNotificationSettingForCardRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteSlackNotificationSettingForCard(requestParameters: DefaultApiDeleteSlackNotificationSettingForCardRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteSlackNotificationSettingForCard(requestParameters.organizationId, requestParameters.channelId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete system admin role
     * @param {DefaultApiDeleteSystemAdminRoleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteSystemAdminRole(requestParameters: DefaultApiDeleteSystemAdminRoleRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteSystemAdminRole(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete teams notification channel setting for card
     * @param {DefaultApiDeleteTeamsNotificationSettingForCardRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteTeamsNotificationSettingForCard(requestParameters: DefaultApiDeleteTeamsNotificationSettingForCardRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteTeamsNotificationSettingForCard(requestParameters.organizationId, requestParameters.channelId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete user account group
     * @param {DefaultApiDeleteUserAccountGroupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteUserAccountGroup(requestParameters: DefaultApiDeleteUserAccountGroupRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteUserAccountGroup(requestParameters.userAccountGroupId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deposit Guarantee Money Balance
     * @param {DefaultApiDepositGuaranteeMoneyBalanceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public depositGuaranteeMoneyBalance(requestParameters: DefaultApiDepositGuaranteeMoneyBalanceRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).depositGuaranteeMoneyBalance(requestParameters.organizationId, requestParameters.depositGuaranteeMoneyBalanceRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Disable Approval
     * @param {DefaultApiDisableApprovalRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public disableApproval(requestParameters: DefaultApiDisableApprovalRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).disableApproval(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Disable daily usage limit for an user account
     * @param {DefaultApiDisableDailyUserUsageLimitRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public disableDailyUserUsageLimit(requestParameters: DefaultApiDisableDailyUserUsageLimitRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).disableDailyUserUsageLimit(requestParameters.userAccountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Disable physical store payment for the user account
     * @param {DefaultApiDisablePhysicalStorePaymentForTheUserAccountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public disablePhysicalStorePaymentForTheUserAccount(requestParameters: DefaultApiDisablePhysicalStorePaymentForTheUserAccountRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).disablePhysicalStorePaymentForTheUserAccount(requestParameters.userAccountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Disable transaction upper limit for the user account
     * @param {DefaultApiDisableTransactionUpperLimitForTheUserAccountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public disableTransactionUpperLimitForTheUserAccount(requestParameters: DefaultApiDisableTransactionUpperLimitForTheUserAccountRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).disableTransactionUpperLimitForTheUserAccount(requestParameters.userAccountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Disable usage limit for an user account
     * @param {DefaultApiDisableUserUsageLimitRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public disableUserUsageLimit(requestParameters: DefaultApiDisableUserUsageLimitRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).disableUserUsageLimit(requestParameters.userAccountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Disagree to the agreement request
     * @param {DefaultApiDisagreeToAgreementRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public disagreeToAgreementRequest(requestParameters: DefaultApiDisagreeToAgreementRequestRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).disagreeToAgreementRequest(requestParameters.organizationId, requestParameters.agreementRequestId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Download bank transfer file
     * @param {DefaultApiDownloadBankTransferFileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public downloadBankTransferFile(requestParameters: DefaultApiDownloadBankTransferFileRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).downloadBankTransferFile(requestParameters.organizationId, requestParameters.bankTransferId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Download bank transfers csv
     * @param {DefaultApiDownloadBankTransfersCsvRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public downloadBankTransfersCsv(requestParameters: DefaultApiDownloadBankTransfersCsvRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).downloadBankTransfersCsv(requestParameters.organizationId, requestParameters.transferDateJstFrom, requestParameters.transferDateJstTo, requestParameters.sourceBankAccountId, requestParameters.downloaded, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Download journal entry for freee csv
     * @param {DefaultApiDownloadJournalEntryForFreeeCsvRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public downloadJournalEntryForFreeeCsv(requestParameters: DefaultApiDownloadJournalEntryForFreeeCsvRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).downloadJournalEntryForFreeeCsv(requestParameters.organizationId, requestParameters.yearMonth, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Download Organizations Accounting Csv
     * @param {DefaultApiDownloadOrganizationsAccountingCsvRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public downloadOrganizationsAccountingCsv(requestParameters: DefaultApiDownloadOrganizationsAccountingCsvRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).downloadOrganizationsAccountingCsv(requestParameters.organizationId, requestParameters.yearMonth, requestParameters.isMergedFiles, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Download payment requests csv
     * @param {DefaultApiDownloadPaymentRequestsCsvRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public downloadPaymentRequestsCsv(requestParameters: DefaultApiDownloadPaymentRequestsCsvRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).downloadPaymentRequestsCsv(requestParameters.organizationId, requestParameters.dueDateJstFrom, requestParameters.dueDateJstTo, requestParameters.statuses, requestParameters.supplierId, requestParameters.transferDataCreated, requestParameters.withholdingApplied, requestParameters.transferFeeResponsibility, requestParameters.freeWord, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Download payment requests csv for payment request ids specification
     * @param {DefaultApiDownloadPaymentRequestsCsvForPaymentRequestIdsSpecificationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public downloadPaymentRequestsCsvForPaymentRequestIdsSpecification(requestParameters: DefaultApiDownloadPaymentRequestsCsvForPaymentRequestIdsSpecificationRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).downloadPaymentRequestsCsvForPaymentRequestIdsSpecification(requestParameters.organizationId, requestParameters.downloadPaymentRequestsCsvForPaymentRequestIdsSpecificationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Enable physical store payment for the user account
     * @param {DefaultApiEnablePhysicalStorePaymentForTheUserAccountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public enablePhysicalStorePaymentForTheUserAccount(requestParameters: DefaultApiEnablePhysicalStorePaymentForTheUserAccountRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).enablePhysicalStorePaymentForTheUserAccount(requestParameters.userAccountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Freeze a card
     * @param {DefaultApiFreezeCardRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public freezeCard(requestParameters: DefaultApiFreezeCardRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).freezeCard(requestParameters.cardId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Generate Annual Fees Invoice
     * @param {DefaultApiGenerateAnnualFeesInvoiceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public generateAnnualFeesInvoice(requestParameters: DefaultApiGenerateAnnualFeesInvoiceRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).generateAnnualFeesInvoice(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Generate Create Account Token
     * @param {DefaultApiGenerateCreateAccountTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public generateCreateAccountToken(requestParameters: DefaultApiGenerateCreateAccountTokenRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).generateCreateAccountToken(requestParameters.generateCreateAccountTokenRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Generate freee redirect url
     * @param {DefaultApiGenerateFreeeRedirectUrlRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public generateFreeeRedirectUrl(requestParameters: DefaultApiGenerateFreeeRedirectUrlRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).generateFreeeRedirectUrl(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Generate org account ids.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public generateOrgAccountIds(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).generateOrgAccountIds(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a Card Detail as Admin
     * @param {DefaultApiGetACardDetailAsAdminRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getACardDetailAsAdmin(requestParameters: DefaultApiGetACardDetailAsAdminRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getACardDetailAsAdmin(requestParameters.cardId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get accounting csv for the organization.
     * @param {DefaultApiGetAccountingCsvForTheOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getAccountingCsvForTheOrganization(requestParameters: DefaultApiGetAccountingCsvForTheOrganizationRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAccountingCsvForTheOrganization(requestParameters.organizationId, requestParameters.startYearMonth, requestParameters.endYearMonth, requestParameters.accountingSystemType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get accounting csv for the user account.
     * @param {DefaultApiGetAccountingCsvForTheUserAccountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getAccountingCsvForTheUserAccount(requestParameters: DefaultApiGetAccountingCsvForTheUserAccountRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAccountingCsvForTheUserAccount(requestParameters.userAccountId, requestParameters.yearMonth, requestParameters.isMergedFiles, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get admin users
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getAdminUsers(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAdminUsers(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get admins
     * @param {DefaultApiGetAdminsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getAdmins(requestParameters: DefaultApiGetAdminsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAdmins(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get agreement requests
     * @param {DefaultApiGetAgreementRequestsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getAgreementRequests(requestParameters: DefaultApiGetAgreementRequestsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAgreementRequests(requestParameters.organizationId, requestParameters.waitingForAgreement, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all banks
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getAllBanks(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAllBanks(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get analysis invoice of payment request
     * @param {DefaultApiGetAnalysisInvoiceOfPaymentRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getAnalysisInvoiceOfPaymentRequest(requestParameters: DefaultApiGetAnalysisInvoiceOfPaymentRequestRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAnalysisInvoiceOfPaymentRequest(requestParameters.organizationId, requestParameters.fileId, requestParameters.xUpsidrSwitchUser, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get annual fees eligibility
     * @param {DefaultApiGetAnnualFeesEligibilityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getAnnualFeesEligibility(requestParameters: DefaultApiGetAnnualFeesEligibilityRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAnnualFeesEligibility(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get approvers
     * @param {DefaultApiGetApproversRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getApprovers(requestParameters: DefaultApiGetApproversRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getApprovers(requestParameters.userAccountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get available currency options
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getAvailableCurrencyOptions(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAvailableCurrencyOptions(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * <p>   Return a list of feature names that are available for the organization.   Most features are unconditionally available to all organizations and   are not included in the response of this API, while some new features are not   available for the organization unless their names are included in this response. </p> <p>   The response schema are designed to ensure that information about new features   is not disclosed to organizations that cannot use them. </p>
     * @param {DefaultApiGetAvailableFeaturesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getAvailableFeatures(requestParameters: DefaultApiGetAvailableFeaturesRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAvailableFeatures(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Available merchant category options
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getAvailableMerchantCategoryOptions(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAvailableMerchantCategoryOptions(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get balance state
     * @param {DefaultApiGetBalanceStateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getBalanceState(requestParameters: DefaultApiGetBalanceStateRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getBalanceState(requestParameters.organizationId, requestParameters.targetDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get bank account activities
     * @param {DefaultApiGetBankAccountActivitiesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getBankAccountActivities(requestParameters: DefaultApiGetBankAccountActivitiesRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getBankAccountActivities(requestParameters.bankAccountActivityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a bank account confirmed activities
     * @param {DefaultApiGetBankAccountConfirmedActivitiesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getBankAccountConfirmedActivities(requestParameters: DefaultApiGetBankAccountConfirmedActivitiesRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getBankAccountConfirmedActivities(requestParameters.organizationId, requestParameters.type, requestParameters.limit, requestParameters.offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get bank by name
     * @param {DefaultApiGetBankByNameRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getBankByName(requestParameters: DefaultApiGetBankByNameRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getBankByName(requestParameters.bankName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a bank transfer
     * @param {DefaultApiGetBankTransferRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getBankTransfer(requestParameters: DefaultApiGetBankTransferRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getBankTransfer(requestParameters.organizationId, requestParameters.bankTransferId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the specified bank\'s all branches
     * @param {DefaultApiGetBanksAllBranchesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getBanksAllBranches(requestParameters: DefaultApiGetBanksAllBranchesRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getBanksAllBranches(requestParameters.bankCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get bookkeepers
     * @param {DefaultApiGetBookkeepersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getBookkeepers(requestParameters: DefaultApiGetBookkeepersRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getBookkeepers(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get branch
     * @param {DefaultApiGetBranchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getBranch(requestParameters: DefaultApiGetBranchRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getBranch(requestParameters.bankCode, requestParameters.branchName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all business descriptions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getBusinessDescriptions(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getBusinessDescriptions(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get if an organization can activate cards
     * @param {DefaultApiGetCanActivateCardRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getCanActivateCard(requestParameters: DefaultApiGetCanActivateCardRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getCanActivateCard(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the status of whether the organization can close
     * @param {DefaultApiGetCanCloseStatusesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getCanCloseStatuses(requestParameters: DefaultApiGetCanCloseStatusesRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getCanCloseStatuses(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get can deactivate
     * @param {DefaultApiGetCanDeactivateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getCanDeactivate(requestParameters: DefaultApiGetCanDeactivateRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getCanDeactivate(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get if the user can read card\'s sensitive info
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getCanReadCardSensitive(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getCanReadCardSensitive(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get if an organization can request a real card to be issued.
     * @param {DefaultApiGetCanRequestSendingCardRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getCanRequestSendingCard(requestParameters: DefaultApiGetCanRequestSendingCardRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getCanRequestSendingCard(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Card Bill
     * @param {DefaultApiGetCardBillRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getCardBill(requestParameters: DefaultApiGetCardBillRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getCardBill(requestParameters.cardBillId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Card Detail
     * @param {DefaultApiGetCardDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getCardDetail(requestParameters: DefaultApiGetCardDetailRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getCardDetail(requestParameters.cardId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get card monthly transactions
     * @param {DefaultApiGetCardMonthlyTransactionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getCardMonthlyTransactions(requestParameters: DefaultApiGetCardMonthlyTransactionsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getCardMonthlyTransactions(requestParameters.userAccountId, requestParameters.yearMonth, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Card Points Rate Configs By OrganizationId
     * @param {DefaultApiGetCardPointsRateConfigsByOrganizationIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getCardPointsRateConfigsByOrganizationId(requestParameters: DefaultApiGetCardPointsRateConfigsByOrganizationIdRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getCardPointsRateConfigsByOrganizationId(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get card transaction details
     * @param {DefaultApiGetCardTransactionDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getCardTransactionDetails(requestParameters: DefaultApiGetCardTransactionDetailsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getCardTransactionDetails(requestParameters.organizationId, requestParameters.visaTransactionReferenceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get card transaction evidence record image
     * @param {DefaultApiGetCardTransactionEvidenceRecordImageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getCardTransactionEvidenceRecordImage(requestParameters: DefaultApiGetCardTransactionEvidenceRecordImageRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getCardTransactionEvidenceRecordImage(requestParameters.organizationId, requestParameters.paymentReferenceId, requestParameters.cardTransactionEvidenceId, requestParameters.id, requestParameters.inPdf, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get card transaction evidence records
     * @param {DefaultApiGetCardTransactionEvidenceRecordsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getCardTransactionEvidenceRecords(requestParameters: DefaultApiGetCardTransactionEvidenceRecordsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getCardTransactionEvidenceRecords(requestParameters.organizationId, requestParameters.paymentReferenceId, requestParameters.cardTransactionEvidenceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Card Transactions
     * @param {DefaultApiGetCardTransactionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getCardTransactions(requestParameters: DefaultApiGetCardTransactionsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getCardTransactions(requestParameters.userAccountId, requestParameters.merchantId, requestParameters.toYearMonth, requestParameters.fromYearMonth, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get cards
     * @param {DefaultApiGetCardsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getCards(requestParameters: DefaultApiGetCardsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getCards(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get cards transactions with purchase application unlinked
     * @param {DefaultApiGetCardsTransactionsWithPurchaseApplicationUnlinkedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getCardsTransactionsWithPurchaseApplicationUnlinked(requestParameters: DefaultApiGetCardsTransactionsWithPurchaseApplicationUnlinkedRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getCardsTransactionsWithPurchaseApplicationUnlinked(requestParameters.organizationId, requestParameters.yearMonth, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the category of the purchase application template for use.
     * @param {DefaultApiGetCategoryOfThePurchaseApplicationTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getCategoryOfThePurchaseApplicationTemplate(requestParameters: DefaultApiGetCategoryOfThePurchaseApplicationTemplateRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getCategoryOfThePurchaseApplicationTemplate(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get comment for card transaction
     * @param {DefaultApiGetCommentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getComment(requestParameters: DefaultApiGetCommentRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getComment(requestParameters.organizationId, requestParameters.paymentReferenceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get comment templates
     * @param {DefaultApiGetCommentTemplatesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getCommentTemplates(requestParameters: DefaultApiGetCommentTemplatesRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getCommentTemplates(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get comment template
     * @param {DefaultApiGetCommentTemplatesCommentTemplateIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getCommentTemplatesCommentTemplateId(requestParameters: DefaultApiGetCommentTemplatesCommentTemplateIdRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getCommentTemplatesCommentTemplateId(requestParameters.organizationId, requestParameters.templateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get current card associated with the user account
     * @param {DefaultApiGetCurrentCardAssociatedWithTheUserAccountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getCurrentCardAssociatedWithTheUserAccount(requestParameters: DefaultApiGetCurrentCardAssociatedWithTheUserAccountRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getCurrentCardAssociatedWithTheUserAccount(requestParameters.userAccountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get deals total amount
     * @param {DefaultApiGetDealsTotalAmountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getDealsTotalAmount(requestParameters: DefaultApiGetDealsTotalAmountRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getDealsTotalAmount(requestParameters.organizationId, requestParameters.getDealsTotalAmountRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get default comment template for user account
     * @param {DefaultApiGetDefaultCommentTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getDefaultCommentTemplate(requestParameters: DefaultApiGetDefaultCommentTemplateRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getDefaultCommentTemplate(requestParameters.organizationId, requestParameters.userAccountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get deposit bank account
     * @param {DefaultApiGetDepositBankAccountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getDepositBankAccount(requestParameters: DefaultApiGetDepositBankAccountRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getDepositBankAccount(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get deposit restriction for organization
     * @param {DefaultApiGetDepositRestrictionForOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getDepositRestrictionForOrganization(requestParameters: DefaultApiGetDepositRestrictionForOrganizationRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getDepositRestrictionForOrganization(requestParameters.organizationId, requestParameters.depositRestrictionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get deposit restriction list for organization
     * @param {DefaultApiGetDepositRestrictionListForOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getDepositRestrictionListForOrganization(requestParameters: DefaultApiGetDepositRestrictionListForOrganizationRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getDepositRestrictionListForOrganization(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get draft payment request
     * @param {DefaultApiGetDraftPaymentRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getDraftPaymentRequest(requestParameters: DefaultApiGetDraftPaymentRequestRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getDraftPaymentRequest(requestParameters.organizationId, requestParameters.draftPaymentRequestId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get draft payment request evidence file
     * @param {DefaultApiGetDraftPaymentRequestEvidenceFileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getDraftPaymentRequestEvidenceFile(requestParameters: DefaultApiGetDraftPaymentRequestEvidenceFileRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getDraftPaymentRequestEvidenceFile(requestParameters.organizationId, requestParameters.draftPaymentRequestId, requestParameters.evidenceId, requestParameters.inPdf, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get draft payment requests only created own
     * @param {DefaultApiGetDraftPaymentRequestsOnlyCreatedOwnRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getDraftPaymentRequestsOnlyCreatedOwn(requestParameters: DefaultApiGetDraftPaymentRequestsOnlyCreatedOwnRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getDraftPaymentRequestsOnlyCreatedOwn(requestParameters.organizationId, requestParameters.xUpsidrSwitchUser, requestParameters.freeWord, requestParameters.limit, requestParameters.offset, requestParameters.cursor, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get earliest expiring guarantee money for organization
     * @param {DefaultApiGetEarliestExpiringGuaranteeMoneyForOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getEarliestExpiringGuaranteeMoneyForOrganization(requestParameters: DefaultApiGetEarliestExpiringGuaranteeMoneyForOrganizationRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getEarliestExpiringGuaranteeMoneyForOrganization(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtain email notification configuration information for each user.
     * @param {DefaultApiGetEmailNotificationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getEmailNotifications(requestParameters: DefaultApiGetEmailNotificationsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getEmailNotifications(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get error bills
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getErrorBills(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getErrorBills(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the evidence specified by evidenceId.
     * @summary Get a specific evidence.
     * @param {DefaultApiGetEvidenceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getEvidence(requestParameters: DefaultApiGetEvidenceRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getEvidence(requestParameters.organizationId, requestParameters.evidenceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get evidence file
     * @param {DefaultApiGetEvidenceFileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getEvidenceFile(requestParameters: DefaultApiGetEvidenceFileRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getEvidenceFile(requestParameters.organizationId, requestParameters.evidenceId, requestParameters.inPdf, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get evidence image
     * @param {DefaultApiGetEvidenceImageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getEvidenceImage(requestParameters: DefaultApiGetEvidenceImageRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getEvidenceImage(requestParameters.organizationId, requestParameters.paymentReferenceId, requestParameters.cardTransactionEvidenceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get evidence information for card transactions
     * @param {DefaultApiGetEvidenceInformationForCardTransactionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getEvidenceInformationForCardTransactions(requestParameters: DefaultApiGetEvidenceInformationForCardTransactionsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getEvidenceInformationForCardTransactions(requestParameters.organizationId, requestParameters.paymentReferenceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get evidence record image
     * @param {DefaultApiGetEvidenceRecordImageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getEvidenceRecordImage(requestParameters: DefaultApiGetEvidenceRecordImageRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getEvidenceRecordImage(requestParameters.organizationId, requestParameters.evidenceId, requestParameters.recordId, requestParameters.inPdf, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get evidence records
     * @param {DefaultApiGetEvidenceRecordsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getEvidenceRecords(requestParameters: DefaultApiGetEvidenceRecordsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getEvidenceRecords(requestParameters.organizationId, requestParameters.evidenceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get evidence zip for the organization.
     * @param {DefaultApiGetEvidenceZipForTheOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getEvidenceZipForTheOrganization(requestParameters: DefaultApiGetEvidenceZipForTheOrganizationRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getEvidenceZipForTheOrganization(requestParameters.organizationId, requestParameters.yearMonth, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get evidences
     * @param {DefaultApiGetEvidencesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getEvidences(requestParameters: DefaultApiGetEvidencesRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getEvidences(requestParameters.organizationId, requestParameters.paymentReferenceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Count evidences
     * @param {DefaultApiGetEvidencesCountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getEvidencesCount(requestParameters: DefaultApiGetEvidencesCountRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getEvidencesCount(requestParameters.organizationId, requestParameters.issuer, requestParameters.amountMin, requestParameters.amountMax, requestParameters.paidAtFrom, requestParameters.paidAtTo, requestParameters.irrelevantToLedger, requestParameters.keyword, requestParameters.includesDeleted, requestParameters.legalValidities, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the triggered transactions of a fraud locked card
     * @param {DefaultApiGetFraudLockedCardTransactionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getFraudLockedCardTransactions(requestParameters: DefaultApiGetFraudLockedCardTransactionsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getFraudLockedCardTransactions(requestParameters.organizationId, requestParameters.cardId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get freee account items
     * @param {DefaultApiGetFreeeAccountItemsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getFreeeAccountItems(requestParameters: DefaultApiGetFreeeAccountItemsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getFreeeAccountItems(requestParameters.organizationId, requestParameters.companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get freee companies
     * @param {DefaultApiGetFreeeCompaniesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getFreeeCompanies(requestParameters: DefaultApiGetFreeeCompaniesRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getFreeeCompanies(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get freee connected
     * @param {DefaultApiGetFreeeConnectedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getFreeeConnected(requestParameters: DefaultApiGetFreeeConnectedRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getFreeeConnected(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Freee Connected User
     * @param {DefaultApiGetFreeeConnectedUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getFreeeConnectedUser(requestParameters: DefaultApiGetFreeeConnectedUserRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getFreeeConnectedUser(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get freee items
     * @param {DefaultApiGetFreeeItemsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getFreeeItems(requestParameters: DefaultApiGetFreeeItemsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getFreeeItems(requestParameters.organizationId, requestParameters.companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get freee memo tags
     * @param {DefaultApiGetFreeeMemoTagsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getFreeeMemoTags(requestParameters: DefaultApiGetFreeeMemoTagsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getFreeeMemoTags(requestParameters.organizationId, requestParameters.companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get freee partners
     * @param {DefaultApiGetFreeePartnersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getFreeePartners(requestParameters: DefaultApiGetFreeePartnersRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getFreeePartners(requestParameters.organizationId, requestParameters.companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get freee sections
     * @param {DefaultApiGetFreeeSectionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getFreeeSections(requestParameters: DefaultApiGetFreeeSectionsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getFreeeSections(requestParameters.organizationId, requestParameters.companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get freee segment tags
     * @param {DefaultApiGetFreeeSegmentTagsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getFreeeSegmentTags(requestParameters: DefaultApiGetFreeeSegmentTagsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getFreeeSegmentTags(requestParameters.organizationId, requestParameters.companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get freee sync status
     * @param {DefaultApiGetFreeeSyncStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getFreeeSyncStatus(requestParameters: DefaultApiGetFreeeSyncStatusRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getFreeeSyncStatus(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get freee tags
     * @param {DefaultApiGetFreeeTagsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getFreeeTags(requestParameters: DefaultApiGetFreeeTagsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getFreeeTags(requestParameters.organizationId, requestParameters.companyId, requestParameters.tagName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get freee taxes
     * @param {DefaultApiGetFreeeTaxesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getFreeeTaxes(requestParameters: DefaultApiGetFreeeTaxesRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getFreeeTaxes(requestParameters.organizationId, requestParameters.companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get freee token
     * @param {DefaultApiGetFreeeTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getFreeeToken(requestParameters: DefaultApiGetFreeeTokenRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getFreeeToken(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a guarantee money balance history
     * @param {DefaultApiGetGuaranteeMoneyBalanceHistoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getGuaranteeMoneyBalanceHistory(requestParameters: DefaultApiGetGuaranteeMoneyBalanceHistoryRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getGuaranteeMoneyBalanceHistory(requestParameters.organizationId, requestParameters.limit, requestParameters.offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a guarantee money balance information for a organization
     * @param {DefaultApiGetGuaranteeMoneyBalanceInformationForOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getGuaranteeMoneyBalanceInformationForOrganization(requestParameters: DefaultApiGetGuaranteeMoneyBalanceInformationForOrganizationRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getGuaranteeMoneyBalanceInformationForOrganization(requestParameters.organizationId, requestParameters.targetDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get guarantee money deposits for organization
     * @param {DefaultApiGetGuaranteeMoneyDepositsForOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getGuaranteeMoneyDepositsForOrganization(requestParameters: DefaultApiGetGuaranteeMoneyDepositsForOrganizationRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getGuaranteeMoneyDepositsForOrganization(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetHolidaysRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getHolidays(requestParameters: DefaultApiGetHolidaysRequest = {}, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getHolidays(requestParameters.from, requestParameters.to, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetIdentifyVerificationsLatestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getIdentifyVerificationsLatest(requestParameters: DefaultApiGetIdentifyVerificationsLatestRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getIdentifyVerificationsLatest(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetIdentityVerificationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getIdentityVerifications(requestParameters: DefaultApiGetIdentityVerificationsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getIdentityVerifications(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Invoice List
     * @param {DefaultApiGetInvoiceListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getInvoiceList(requestParameters: DefaultApiGetInvoiceListRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getInvoiceList(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Invoice Pdf
     * @param {DefaultApiGetInvoicePdfRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getInvoicePdf(requestParameters: DefaultApiGetInvoicePdfRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getInvoicePdf(requestParameters.organizationId, requestParameters.yearMonth, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get issuable status
     * @param {DefaultApiGetIssuableStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getIssuableStatus(requestParameters: DefaultApiGetIssuableStatusRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getIssuableStatus(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get jwt for SSO
     * @param {DefaultApiGetJwtSsoRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getJwtSso(requestParameters: DefaultApiGetJwtSsoRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getJwtSso(requestParameters.nonce, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get list of KYC reader users ordered by creation date in descending order.
     * @summary Get KYC Reader Users
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getKycReaderUsers(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getKycReaderUsers(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get latest time of sync to freee
     * @param {DefaultApiGetLatestTimeOfSyncToFreeeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getLatestTimeOfSyncToFreee(requestParameters: DefaultApiGetLatestTimeOfSyncToFreeeRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getLatestTimeOfSyncToFreee(requestParameters.organizationId, requestParameters.companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get lock status of evidences
     * @param {DefaultApiGetLockStatusOfEvidencesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getLockStatusOfEvidences(requestParameters: DefaultApiGetLockStatusOfEvidencesRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getLockStatusOfEvidences(requestParameters.organizationId, requestParameters.yearMonth, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get merchant general blocks
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getMerchantGeneralBlock(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getMerchantGeneralBlock(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get merchant general block detail
     * @param {DefaultApiGetMerchantGeneralBlockDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getMerchantGeneralBlockDetail(requestParameters: DefaultApiGetMerchantGeneralBlockDetailRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getMerchantGeneralBlockDetail(requestParameters.merchantGeneralBlockListId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get merchant org blocks
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getMerchantOrgBlock(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getMerchantOrgBlock(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get merchant org block list
     * @param {DefaultApiGetMerchantOrgBlockListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getMerchantOrgBlockList(requestParameters: DefaultApiGetMerchantOrgBlockListRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getMerchantOrgBlockList(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get merchant organization user account year month summary
     * @param {DefaultApiGetMerchantOrganizationUserAccountYearMonthSummaryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getMerchantOrganizationUserAccountYearMonthSummary(requestParameters: DefaultApiGetMerchantOrganizationUserAccountYearMonthSummaryRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getMerchantOrganizationUserAccountYearMonthSummary(requestParameters.organizationId, requestParameters.merchantId, requestParameters.userAccountId, requestParameters.toYearMonth, requestParameters.fromYearMonth, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a list of MerchantCategoryKind
     * @param {DefaultApiGetMerchantsCategoryKindsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getMerchantsCategoryKinds(requestParameters: DefaultApiGetMerchantsCategoryKindsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getMerchantsCategoryKinds(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Modifiable Daily Limits For The User Account
     * @param {DefaultApiGetModifiableDailyLimitsForTheUserAccountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getModifiableDailyLimitsForTheUserAccount(requestParameters: DefaultApiGetModifiableDailyLimitsForTheUserAccountRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getModifiableDailyLimitsForTheUserAccount(requestParameters.userAccountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get modifiable monthly limits for the user account
     * @param {DefaultApiGetModifiableMonthlyLimitsForTheUserAccountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getModifiableMonthlyLimitsForTheUserAccount(requestParameters: DefaultApiGetModifiableMonthlyLimitsForTheUserAccountRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getModifiableMonthlyLimitsForTheUserAccount(requestParameters.userAccountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Modifiable Transaction Limits For The User Account
     * @param {DefaultApiGetModifiableTransactionLimitsForTheUserAccountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getModifiableTransactionLimitsForTheUserAccount(requestParameters: DefaultApiGetModifiableTransactionLimitsForTheUserAccountRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getModifiableTransactionLimitsForTheUserAccount(requestParameters.userAccountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get moneytree connected
     * @param {DefaultApiGetMoneytreeConnectedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getMoneytreeConnected(requestParameters: DefaultApiGetMoneytreeConnectedRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getMoneytreeConnected(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get moneytree oauth url
     * @param {DefaultApiGetMoneytreeOauthUrlRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getMoneytreeOauthUrl(requestParameters: DefaultApiGetMoneytreeOauthUrlRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getMoneytreeOauthUrl(requestParameters.organizationId, requestParameters.nextTo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get moneytree status
     * @param {DefaultApiGetMoneytreeStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getMoneytreeStatus(requestParameters: DefaultApiGetMoneytreeStatusRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getMoneytreeStatus(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get monthly card bills for specified yearMonths
     * @param {DefaultApiGetMonthlyCardBillRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getMonthlyCardBill(requestParameters: DefaultApiGetMonthlyCardBillRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getMonthlyCardBill(requestParameters.organizationId, requestParameters.yearMonth, requestParameters.startYearMonth, requestParameters.endYearMonth, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get monthly card transactions for the organization.
     * @param {DefaultApiGetMonthlyCardTransactionsForTheOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getMonthlyCardTransactionsForTheOrganization(requestParameters: DefaultApiGetMonthlyCardTransactionsForTheOrganizationRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getMonthlyCardTransactionsForTheOrganization(requestParameters.organizationId, requestParameters.yearMonth, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get monthly user card summaries
     * @param {DefaultApiGetMonthlyUserCardSummariesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getMonthlyUserCardSummaries(requestParameters: DefaultApiGetMonthlyUserCardSummariesRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getMonthlyUserCardSummaries(requestParameters.organizationId, requestParameters.yearMonth, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a specific onboarding request for zeus
     * @param {DefaultApiGetOnboardingRequestByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getOnboardingRequestById(requestParameters: DefaultApiGetOnboardingRequestByIdRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getOnboardingRequestById(requestParameters.onboardingRequestId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get personal information of the onboarding request.
     * @summary Get Personal Information
     * @param {DefaultApiGetOnboardingRequestPersonalInfoRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getOnboardingRequestPersonalInfo(requestParameters: DefaultApiGetOnboardingRequestPersonalInfoRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getOnboardingRequestPersonalInfo(requestParameters.onboardingRequestId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get onboarding requests for zeus
     * @param {DefaultApiGetOnboardingRequestsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getOnboardingRequests(requestParameters: DefaultApiGetOnboardingRequestsRequest = {}, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getOnboardingRequests(requestParameters.key, requestParameters.createdAtFrom, requestParameters.createdAtTo, requestParameters.limit, requestParameters.offset, requestParameters.sort, requestParameters.order, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get org account state
     * @param {DefaultApiGetOrgAccountStateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getOrgAccountState(requestParameters: DefaultApiGetOrgAccountStateRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getOrgAccountState(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Organization
     * @param {DefaultApiGetOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getOrganization(requestParameters: DefaultApiGetOrganizationRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getOrganization(requestParameters.organizationId, requestParameters.underContractOnly, requestParameters.withCredit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Organization Accounting Csv Fields Types
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getOrganizationAccountingCsvFieldsTypes(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getOrganizationAccountingCsvFieldsTypes(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get organization cards extended
     * @param {DefaultApiGetOrganizationCardsExtendedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getOrganizationCardsExtended(requestParameters: DefaultApiGetOrganizationCardsExtendedRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getOrganizationCardsExtended(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get organization cards light
     * @param {DefaultApiGetOrganizationCardsLightRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getOrganizationCardsLight(requestParameters: DefaultApiGetOrganizationCardsLightRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getOrganizationCardsLight(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get organization chart departments
     * @param {DefaultApiGetOrganizationChartDepartmentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getOrganizationChartDepartments(requestParameters: DefaultApiGetOrganizationChartDepartmentsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getOrganizationChartDepartments(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get organization chart employees
     * @param {DefaultApiGetOrganizationChartEmployeesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getOrganizationChartEmployees(requestParameters: DefaultApiGetOrganizationChartEmployeesRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getOrganizationChartEmployees(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get organization chart roles
     * @param {DefaultApiGetOrganizationChartRolesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getOrganizationChartRoles(requestParameters: DefaultApiGetOrganizationChartRolesRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getOrganizationChartRoles(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get organizations create requests for zeus
     * @param {DefaultApiGetOrganizationCreateRequestsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getOrganizationCreateRequests(requestParameters: DefaultApiGetOrganizationCreateRequestsRequest = {}, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getOrganizationCreateRequests(requestParameters.key, requestParameters.createdAtFrom, requestParameters.createdAtTo, requestParameters.limit, requestParameters.offset, requestParameters.sort, requestParameters.order, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Organization Me
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getOrganizationMe(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getOrganizationMe(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get organization payment schemes
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getOrganizationPaymentSchemes(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getOrganizationPaymentSchemes(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get organization payments
     * @param {DefaultApiGetOrganizationPaymentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getOrganizationPayments(requestParameters: DefaultApiGetOrganizationPaymentsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getOrganizationPayments(requestParameters.organizationId, requestParameters.yearMonth, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getOrganizations(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getOrganizations(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Organizations Accounting Csv Export Fields
     * @param {DefaultApiGetOrganizationsAccountingCsvExportFieldsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getOrganizationsAccountingCsvExportFields(requestParameters: DefaultApiGetOrganizationsAccountingCsvExportFieldsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getOrganizationsAccountingCsvExportFields(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a organization\'s bill
     * @param {DefaultApiGetOrganizationsBillsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getOrganizationsBills(requestParameters: DefaultApiGetOrganizationsBillsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getOrganizationsBills(requestParameters.organizationId, requestParameters.beforeReservationOnly, requestParameters.limit, requestParameters.offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get organizations deals
     * @param {DefaultApiGetOrganizationsDealsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getOrganizationsDeals(requestParameters: DefaultApiGetOrganizationsDealsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getOrganizationsDeals(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get payment request detail
     * @param {DefaultApiGetPaymentRequestDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getPaymentRequestDetail(requestParameters: DefaultApiGetPaymentRequestDetailRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getPaymentRequestDetail(requestParameters.organizationId, requestParameters.paymentRequestId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a payment request evidence specified by evidenceId.
     * @summary Get a specific payment request evidence.
     * @param {DefaultApiGetPaymentRequestEvidenceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getPaymentRequestEvidence(requestParameters: DefaultApiGetPaymentRequestEvidenceRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getPaymentRequestEvidence(requestParameters.organizationId, requestParameters.paymentRequestId, requestParameters.evidenceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get payment request evidence file
     * @param {DefaultApiGetPaymentRequestEvidenceFileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getPaymentRequestEvidenceFile(requestParameters: DefaultApiGetPaymentRequestEvidenceFileRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getPaymentRequestEvidenceFile(requestParameters.organizationId, requestParameters.paymentRequestId, requestParameters.evidenceId, requestParameters.inPdf, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get payment request evidence record file
     * @param {DefaultApiGetPaymentRequestEvidenceRecordFileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getPaymentRequestEvidenceRecordFile(requestParameters: DefaultApiGetPaymentRequestEvidenceRecordFileRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getPaymentRequestEvidenceRecordFile(requestParameters.organizationId, requestParameters.paymentRequestId, requestParameters.evidenceId, requestParameters.recordId, requestParameters.inPdf, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get payment request evidence records
     * @param {DefaultApiGetPaymentRequestEvidenceRecordsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getPaymentRequestEvidenceRecords(requestParameters: DefaultApiGetPaymentRequestEvidenceRecordsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getPaymentRequestEvidenceRecords(requestParameters.organizationId, requestParameters.paymentRequestId, requestParameters.evidenceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get all evidences for a specific payment request
     * @param {DefaultApiGetPaymentRequestEvidencesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getPaymentRequestEvidences(requestParameters: DefaultApiGetPaymentRequestEvidencesRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getPaymentRequestEvidences(requestParameters.organizationId, requestParameters.paymentRequestId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get payment requests bank accounts list
     * @param {DefaultApiGetPaymentRequestsBankAccountsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getPaymentRequestsBankAccountsList(requestParameters: DefaultApiGetPaymentRequestsBankAccountsListRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getPaymentRequestsBankAccountsList(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get payment requests count linked bank transfer
     * @param {DefaultApiGetPaymentRequestsCountLinkedBankTransferRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getPaymentRequestsCountLinkedBankTransfer(requestParameters: DefaultApiGetPaymentRequestsCountLinkedBankTransferRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getPaymentRequestsCountLinkedBankTransfer(requestParameters.organizationId, requestParameters.paymentRequestIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get pinretriever decrypt pin block
     * @param {DefaultApiGetPinretrieverDecryptPinBlockRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getPinretrieverDecryptPinBlock(requestParameters: DefaultApiGetPinretrieverDecryptPinBlockRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getPinretrieverDecryptPinBlock(requestParameters.getPinretrieverDecryptPinBlockRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get pinretriever encrypt pin
     * @param {DefaultApiGetPinretrieverEncryptPinRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getPinretrieverEncryptPin(requestParameters: DefaultApiGetPinretrieverEncryptPinRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getPinretrieverEncryptPin(requestParameters.getPinretrieverEncryptPinRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get pinretriever hsm publickey
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getPinretrieverHsmPublickey(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getPinretrieverHsmPublickey(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get purchase application
     * @param {DefaultApiGetPurchaseApplicationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getPurchaseApplication(requestParameters: DefaultApiGetPurchaseApplicationRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getPurchaseApplication(requestParameters.organizationId, requestParameters.purchaseApplicationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get purchase application templates
     * @param {DefaultApiGetPurchaseApplicationTemplatesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getPurchaseApplicationTemplates(requestParameters: DefaultApiGetPurchaseApplicationTemplatesRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getPurchaseApplicationTemplates(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get purchase application templates detail
     * @param {DefaultApiGetPurchaseApplicationTemplatesDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getPurchaseApplicationTemplatesDetail(requestParameters: DefaultApiGetPurchaseApplicationTemplatesDetailRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getPurchaseApplicationTemplatesDetail(requestParameters.organizationId, requestParameters.purchaseTemplateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get purchase applications
     * @param {DefaultApiGetPurchaseApplicationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getPurchaseApplications(requestParameters: DefaultApiGetPurchaseApplicationsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getPurchaseApplications(requestParameters.organizationId, requestParameters.yearMonth, requestParameters.visaTransactionReferenceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetPurchaseApplicationsRequestedCountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getPurchaseApplicationsRequestedCount(requestParameters: DefaultApiGetPurchaseApplicationsRequestedCountRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getPurchaseApplicationsRequestedCount(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the purchase applications requested list
     * @param {DefaultApiGetPurchaseApplicationsRequestedListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getPurchaseApplicationsRequestedList(requestParameters: DefaultApiGetPurchaseApplicationsRequestedListRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getPurchaseApplicationsRequestedList(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the purchase applications submitted self
     * @param {DefaultApiGetPurchaseApplicationsSubmittedSelfRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getPurchaseApplicationsSubmittedSelf(requestParameters: DefaultApiGetPurchaseApplicationsSubmittedSelfRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getPurchaseApplicationsSubmittedSelf(requestParameters.userId, requestParameters.yearMonth, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get(search) qualified invoice issuer
     * @param {DefaultApiGetQualifiedInvoiceIssuerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getQualifiedInvoiceIssuer(requestParameters: DefaultApiGetQualifiedInvoiceIssuerRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getQualifiedInvoiceIssuer(requestParameters.registrationNumber, requestParameters.issuerName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Redirect URL from Tiny URL
     * @param {DefaultApiGetRedirectUrlFromTinyUrlRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getRedirectUrlFromTinyUrl(requestParameters: DefaultApiGetRedirectUrlFromTinyUrlRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getRedirectUrlFromTinyUrl(requestParameters.tinyUrlParam, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the reward points balance for the specified organization.
     * @summary Get reward points balance
     * @param {DefaultApiGetRewardPointBalanceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getRewardPointBalance(requestParameters: DefaultApiGetRewardPointBalanceRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getRewardPointBalance(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get reward point transactions for the specified organization
     * @summary Get reward point transactions
     * @param {DefaultApiGetRewardPointTransactionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getRewardPointTransactions(requestParameters: DefaultApiGetRewardPointTransactionsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getRewardPointTransactions(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Rewards
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getRewards(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getRewards(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get role resource for user
     * @param {DefaultApiGetRoleResourceForUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getRoleResourceForUser(requestParameters: DefaultApiGetRoleResourceForUserRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getRoleResourceForUser(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get roles
     * @param {DefaultApiGetRolesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getRoles(requestParameters: DefaultApiGetRolesRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getRoles(requestParameters.category, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Roles with Top Related Resources
     * @param {DefaultApiGetRolesWithTopRelatedResourcesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getRolesWithTopRelatedResources(requestParameters: DefaultApiGetRolesWithTopRelatedResourcesRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getRolesWithTopRelatedResources(requestParameters.resourceScope, requestParameters.resourceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Roles with Top Related Resources by Organization id
     * @param {DefaultApiGetRolesWithTopRelatedResourcesByOrganizationIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getRolesWithTopRelatedResourcesByOrganizationId(requestParameters: DefaultApiGetRolesWithTopRelatedResourcesByOrganizationIdRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getRolesWithTopRelatedResourcesByOrganizationId(requestParameters.organizationId, requestParameters.resourceScope, requestParameters.resourceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Slack card notification settings of an organization
     * @param {DefaultApiGetSlackCardNotificationSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getSlackCardNotificationSettings(requestParameters: DefaultApiGetSlackCardNotificationSettingsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getSlackCardNotificationSettings(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a Slack channels of an organization by SlackChannelID
     * @param {DefaultApiGetSlackChannelRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getSlackChannel(requestParameters: DefaultApiGetSlackChannelRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getSlackChannel(requestParameters.organizationId, requestParameters.channelId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Slack channels of an organization
     * @param {DefaultApiGetSlackChannelsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getSlackChannels(requestParameters: DefaultApiGetSlackChannelsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getSlackChannels(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Slack channels with cursor of an organization
     * @param {DefaultApiGetSlackChannelsWithCursorRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getSlackChannelsWithCursor(requestParameters: DefaultApiGetSlackChannelsWithCursorRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getSlackChannelsWithCursor(requestParameters.organizationId, requestParameters.cursor, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Slack evidence remind settings of an organization
     * @param {DefaultApiGetSlackEvidenceReminderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getSlackEvidenceReminder(requestParameters: DefaultApiGetSlackEvidenceReminderRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getSlackEvidenceReminder(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Slack evidence remind settings of an slack channel
     * @param {DefaultApiGetSlackEvidenceReminderPerChannelRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getSlackEvidenceReminderPerChannel(requestParameters: DefaultApiGetSlackEvidenceReminderPerChannelRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getSlackEvidenceReminderPerChannel(requestParameters.organizationId, requestParameters.channelId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get slack notification channel setting for purchase-application
     * @param {DefaultApiGetSlackNotificationChannelSettingForPurchaseApplicationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getSlackNotificationChannelSettingForPurchaseApplication(requestParameters: DefaultApiGetSlackNotificationChannelSettingForPurchaseApplicationRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getSlackNotificationChannelSettingForPurchaseApplication(requestParameters.organizationId, requestParameters.channelId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get slack notification settings for purchase-application
     * @param {DefaultApiGetSlackNotificationSettingsForPurchaseApplicationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getSlackNotificationSettingsForPurchaseApplication(requestParameters: DefaultApiGetSlackNotificationSettingsForPurchaseApplicationRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getSlackNotificationSettingsForPurchaseApplication(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Slack team
     * @param {DefaultApiGetSlackTeamRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getSlackTeam(requestParameters: DefaultApiGetSlackTeamRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getSlackTeam(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Slack version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getSlackVersion(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getSlackVersion(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get submitted trustdock data
     * @param {DefaultApiGetSubmittedTrustdockDataRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getSubmittedTrustdockData(requestParameters: DefaultApiGetSubmittedTrustdockDataRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getSubmittedTrustdockData(requestParameters.trustdockIdentificationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get suspicious transaction detail list
     * @param {DefaultApiGetSuspiciousTransactionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getSuspiciousTransactions(requestParameters: DefaultApiGetSuspiciousTransactionsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getSuspiciousTransactions(requestParameters.userAccountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Teams card notification settings of an organization
     * @param {DefaultApiGetTeamsCardNotificationSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getTeamsCardNotificationSettings(requestParameters: DefaultApiGetTeamsCardNotificationSettingsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getTeamsCardNotificationSettings(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Teams channels of an organization by TeamsChannelID
     * @param {DefaultApiGetTeamsChannelRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getTeamsChannel(requestParameters: DefaultApiGetTeamsChannelRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getTeamsChannel(requestParameters.organizationId, requestParameters.channelId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Teams channels with cursor of an organization
     * @param {DefaultApiGetTeamsChannelsWithCursorRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getTeamsChannelsWithCursor(requestParameters: DefaultApiGetTeamsChannelsWithCursorRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getTeamsChannelsWithCursor(requestParameters.organizationId, requestParameters.cursor, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Teams team
     * @param {DefaultApiGetTeamsTeamRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getTeamsTeam(requestParameters: DefaultApiGetTeamsTeamRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getTeamsTeam(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Teams version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getTeamsVersion(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getTeamsVersion(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Technical Support Users
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getTechnicalSupportUsers(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getTechnicalSupportUsers(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Tfa App QR Code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getTfaAppQrCode(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getTfaAppQrCode(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getTfaAppRecoveryCode(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getTfaAppRecoveryCode(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get TFA SMS Recovery Code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getTfaSmsRecoveryCode(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getTfaSmsRecoveryCode(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the count of monthly transactions for the user account
     * @param {DefaultApiGetTheCountOfMonthlyTransactionsForTheUserAccountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getTheCountOfMonthlyTransactionsForTheUserAccount(requestParameters: DefaultApiGetTheCountOfMonthlyTransactionsForTheUserAccountRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getTheCountOfMonthlyTransactionsForTheUserAccount(requestParameters.userAccountId, requestParameters.yearMonth, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the user account information
     * @param {DefaultApiGetTheUserAccountInformationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getTheUserAccountInformation(requestParameters: DefaultApiGetTheUserAccountInformationRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getTheUserAccountInformation(requestParameters.userAccountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get transaction evidence email address
     * @param {DefaultApiGetTransactionEvidenceEmailAddressRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getTransactionEvidenceEmailAddress(requestParameters: DefaultApiGetTransactionEvidenceEmailAddressRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getTransactionEvidenceEmailAddress(requestParameters.userAccountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Transaction Evidence Email File
     * @param {DefaultApiGetTransactionEvidenceEmailFileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getTransactionEvidenceEmailFile(requestParameters: DefaultApiGetTransactionEvidenceEmailFileRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getTransactionEvidenceEmailFile(requestParameters.userAccountId, requestParameters.transactionEvidenceEmailFileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get transaction evidence emails
     * @param {DefaultApiGetTransactionEvidenceEmailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getTransactionEvidenceEmails(requestParameters: DefaultApiGetTransactionEvidenceEmailsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getTransactionEvidenceEmails(requestParameters.userAccountId, requestParameters.startYearMonth, requestParameters.endYearMonth, requestParameters.isTrash, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Trustdock Identity Verifications
     * @param {DefaultApiGetTrustdockIdentityVerificationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getTrustdockIdentityVerifications(requestParameters: DefaultApiGetTrustdockIdentityVerificationsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getTrustdockIdentityVerifications(requestParameters.trustdockIdentificationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Trustdock Submit Identification Document Publish URL
     * @param {DefaultApiGetTrustdockSubmitIdentificationDocumentPublishUrlRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getTrustdockSubmitIdentificationDocumentPublishUrl(requestParameters: DefaultApiGetTrustdockSubmitIdentificationDocumentPublishUrlRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getTrustdockSubmitIdentificationDocumentPublishUrl(requestParameters.trustdockIdentificationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Trustdock Verifications
     * @param {DefaultApiGetTrustdockVerificationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getTrustdockVerifications(requestParameters: DefaultApiGetTrustdockVerificationsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getTrustdockVerifications(requestParameters.trustdockIdentificationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get unread message count for a user
     * @param {DefaultApiGetUnreadMessageCountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getUnreadMessageCount(requestParameters: DefaultApiGetUnreadMessageCountRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getUnreadMessageCount(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get an usage fee
     * @param {DefaultApiGetUsageFeeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getUsageFee(requestParameters: DefaultApiGetUsageFeeRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getUsageFee(requestParameters.usageFeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get user account groups
     * @param {DefaultApiGetUserAccountGroupsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getUserAccountGroups(requestParameters: DefaultApiGetUserAccountGroupsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getUserAccountGroups(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get user account year month summary
     * @param {DefaultApiGetUserAccountYearMonthSummaryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getUserAccountYearMonthSummary(requestParameters: DefaultApiGetUserAccountYearMonthSummaryRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getUserAccountYearMonthSummary(requestParameters.organizationId, requestParameters.toYearMonth, requestParameters.fromYearMonth, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get user accounts with default comment template
     * @param {DefaultApiGetUserAccountsWithDefaultCommentTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getUserAccountsWithDefaultCommentTemplate(requestParameters: DefaultApiGetUserAccountsWithDefaultCommentTemplateRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getUserAccountsWithDefaultCommentTemplate(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get user cards
     * @param {DefaultApiGetUserCardsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getUserCards(requestParameters: DefaultApiGetUserCardsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getUserCards(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get user cards extended
     * @param {DefaultApiGetUserCardsExtendedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getUserCardsExtended(requestParameters: DefaultApiGetUserCardsExtendedRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getUserCardsExtended(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get user cards extended for role resources
     * @param {DefaultApiGetUserCardsExtendedForRoleResourcesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getUserCardsExtendedForRoleResources(requestParameters: DefaultApiGetUserCardsExtendedForRoleResourcesRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getUserCardsExtendedForRoleResources(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get user cards light
     * @param {DefaultApiGetUserCardsLightRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getUserCardsLight(requestParameters: DefaultApiGetUserCardsLightRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getUserCardsLight(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get user cards light for role resources
     * @param {DefaultApiGetUserCardsLightForRoleResourcesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getUserCardsLightForRoleResources(requestParameters: DefaultApiGetUserCardsLightForRoleResourcesRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getUserCardsLightForRoleResources(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get message detail
     * @param {DefaultApiGetUserMessageDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getUserMessageDetail(requestParameters: DefaultApiGetUserMessageDetailRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getUserMessageDetail(requestParameters.userMessageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get messages for a user
     * @param {DefaultApiGetUserMessagesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getUserMessages(requestParameters: DefaultApiGetUserMessagesRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getUserMessages(requestParameters.userId, requestParameters.offset, requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get users
     * @param {DefaultApiGetUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getUsers(requestParameters: DefaultApiGetUsersRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getUsers(requestParameters.organizationId, requestParameters.email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get information on login user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getUsersMe(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getUsersMe(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get venture capitals
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getVentureCapitals(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getVentureCapitals(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 指定された組織の取引時確認詳細情報を取得します。 createdAtの降順で返却されます。 
     * @summary 取引時確認詳細取得（ZEUS)(PRESIDENT)
     * @param {DefaultApiGetZeusOrganizationIdentityVerificationsForPresidentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getZeusOrganizationIdentityVerificationsForPresident(requestParameters: DefaultApiGetZeusOrganizationIdentityVerificationsForPresidentRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getZeusOrganizationIdentityVerificationsForPresident(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get organizations for zeus
     * @param {DefaultApiGetZeusOrganizationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getZeusOrganizations(requestParameters: DefaultApiGetZeusOrganizationsRequest = {}, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getZeusOrganizations(requestParameters.key, requestParameters.limit, requestParameters.offset, requestParameters.sort, requestParameters.connectedMoneytree, requestParameters.brandType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Initialize Modifiable Limit For The User Accounts
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public initializeModifiableLimitForTheUserAccounts(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).initializeModifiableLimitForTheUserAccounts(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Linking purchase to transaction.
     * @param {DefaultApiLinkingPurchaseToTransactionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public linkingPurchaseToTransaction(requestParameters: DefaultApiLinkingPurchaseToTransactionRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).linkingPurchaseToTransaction(requestParameters.organizationId, requestParameters.purchaseApplicationId, requestParameters.visaTransactionReferenceId, requestParameters.userAccountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Lock a card due to potential fraud
     * @param {DefaultApiLockCardForPotentialFraudRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public lockCardForPotentialFraud(requestParameters: DefaultApiLockCardForPotentialFraudRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).lockCardForPotentialFraud(requestParameters.organizationId, requestParameters.cardId, requestParameters.lockCardForPotentialFraudRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Lock a card due to fraud detected
     * @param {DefaultApiLockCardOnFraudDetectedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public lockCardOnFraudDetected(requestParameters: DefaultApiLockCardOnFraudDetectedRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).lockCardOnFraudDetected(requestParameters.organizationId, requestParameters.cardId, requestParameters.lockCardOnFraudDetectedRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Login
     * @param {DefaultApiLoginRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public login(requestParameters: DefaultApiLoginRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).login(requestParameters.loginRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Login with APP two factor auth
     * @param {DefaultApiLoginAppRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public loginApp(requestParameters: DefaultApiLoginAppRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).loginApp(requestParameters.loginAppRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Login with recovery code of two factor auth
     * @param {DefaultApiLoginRecoveryCodeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public loginRecoveryCode(requestParameters: DefaultApiLoginRecoveryCodeRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).loginRecoveryCode(requestParameters.loginRecoveryCodeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Login with SMS two factor auth
     * @param {DefaultApiLoginSmsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public loginSms(requestParameters: DefaultApiLoginSmsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).loginSms(requestParameters.loginSmsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Logout
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public logout(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).logout(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Move slack notification channel setting for card
     * @param {DefaultApiMoveSlackNotificationSettingForCardRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public moveSlackNotificationSettingForCard(requestParameters: DefaultApiMoveSlackNotificationSettingForCardRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).moveSlackNotificationSettingForCard(requestParameters.organizationId, requestParameters.currentChannelId, requestParameters.moveSlackNotificationSettingForCardRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Move teams notification channel setting for card
     * @param {DefaultApiMoveTeamsNotificationSettingForCardRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public moveTeamsNotificationSettingForCard(requestParameters: DefaultApiMoveTeamsNotificationSettingForCardRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).moveTeamsNotificationSettingForCard(requestParameters.organizationId, requestParameters.currentChannelId, requestParameters.moveTeamsNotificationSettingForCardRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Organization Create Pre Request
     * @param {DefaultApiOrganizationCreatePreRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public organizationCreatePreRequest(requestParameters: DefaultApiOrganizationCreatePreRequestRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).organizationCreatePreRequest(requestParameters.organizationCreatePreRequestRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Parse organization chart for workflow
     * @param {DefaultApiParseOrganizationChartForWorkflowRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public parseOrganizationChartForWorkflow(requestParameters: DefaultApiParseOrganizationChartForWorkflowRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).parseOrganizationChartForWorkflow(requestParameters.file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Post Addition Merchant General Block List
     * @param {DefaultApiPostAdditionMerchantGeneralBlockListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public postAdditionMerchantGeneralBlockList(requestParameters: DefaultApiPostAdditionMerchantGeneralBlockListRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).postAdditionMerchantGeneralBlockList(requestParameters.postAdditionMerchantGeneralBlockListRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiPostAlliancesGcpApplicationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public postAlliancesGcpApplications(requestParameters: DefaultApiPostAlliancesGcpApplicationsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).postAlliancesGcpApplications(requestParameters.organizationId, requestParameters.postAlliancesGcpApplicationsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiPostAlliancesGwsApplicationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public postAlliancesGwsApplications(requestParameters: DefaultApiPostAlliancesGwsApplicationsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).postAlliancesGwsApplications(requestParameters.organizationId, requestParameters.postAlliancesGwsApplicationsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Search Bank Account Balances
     * @param {DefaultApiPostBalancesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public postBalances(requestParameters: DefaultApiPostBalancesRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).postBalances(requestParameters.postBalancesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Post Bulk Addition Merchant Org Block Lists
     * @param {DefaultApiPostBulkAdditionMerchantOrgBlockListsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public postBulkAdditionMerchantOrgBlockLists(requestParameters: DefaultApiPostBulkAdditionMerchantOrgBlockListsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).postBulkAdditionMerchantOrgBlockLists(requestParameters.organizationId, requestParameters.postBulkAdditionMerchantOrgBlockListsRequestInner, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Post a cancel request for a evidence request
     * @param {DefaultApiPostCancelRequestForEvidenceRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public postCancelRequestForEvidenceRequest(requestParameters: DefaultApiPostCancelRequestForEvidenceRequestRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).postCancelRequestForEvidenceRequest(requestParameters.organizationId, requestParameters.paymentReferenceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiPostCardsVirtualIssueRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public postCardsVirtualIssue(requestParameters: DefaultApiPostCardsVirtualIssueRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).postCardsVirtualIssue(requestParameters.postCardsVirtualIssueRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public postCardsVirtualOndemandIssue(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).postCardsVirtualOndemandIssue(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Upload identity document file with verification information.
     * @summary Upload Identity Document
     * @param {DefaultApiPostFaceToFaceKycIdentityDocumentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public postFaceToFaceKycIdentityDocument(requestParameters: DefaultApiPostFaceToFaceKycIdentityDocumentRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).postFaceToFaceKycIdentityDocument(requestParameters.onboardingRequestId, requestParameters.file, requestParameters.personalDocumentType, requestParameters.verifiedBy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Submit a face-to-face KYC request.
     * @summary Face-to-face KYC Request
     * @param {DefaultApiPostFaceToFaceKycRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public postFaceToFaceKycRequest(requestParameters: DefaultApiPostFaceToFaceKycRequestRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).postFaceToFaceKycRequest(requestParameters.postFaceToFaceKycRequestRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Post Freee Account for Points
     * @param {DefaultApiPostFreeeAccountForPointsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public postFreeeAccountForPoints(requestParameters: DefaultApiPostFreeeAccountForPointsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).postFreeeAccountForPoints(requestParameters.organizationId, requestParameters.postFreeeAccountForPointsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiPostKycconsultingWebhooksRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public postKycconsultingWebhooks(requestParameters: DefaultApiPostKycconsultingWebhooksRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).postKycconsultingWebhooks(requestParameters.requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Post Moneytree Refresh Request
     * @param {DefaultApiPostMoneytreeRefreshRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public postMoneytreeRefreshRequest(requestParameters: DefaultApiPostMoneytreeRefreshRequestRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).postMoneytreeRefreshRequest(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Post Moneytree Refresh Request for All Organizations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public postMoneytreeRefreshRequestAll(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).postMoneytreeRefreshRequestAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create organizations deals
     * @param {DefaultApiPostOrganizationsDealsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public postOrganizationsDeals(requestParameters: DefaultApiPostOrganizationsDealsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).postOrganizationsDeals(requestParameters.organizationId, requestParameters.postOrganizationsDealsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Post payment requests bank account
     * @param {DefaultApiPostPaymentRequestsBankAccountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public postPaymentRequestsBankAccount(requestParameters: DefaultApiPostPaymentRequestsBankAccountRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).postPaymentRequestsBankAccount(requestParameters.organizationId, requestParameters.postPaymentRequestsBankAccountRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Post slack message to coworker
     * @param {DefaultApiPostSlackMessageToCoworkerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public postSlackMessageToCoworker(requestParameters: DefaultApiPostSlackMessageToCoworkerRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).postSlackMessageToCoworker(requestParameters.organizationId, requestParameters.postSlackMessageToCoworkerRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Search Bank Account Transactions
     * @param {DefaultApiPostTransactionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public postTransactions(requestParameters: DefaultApiPostTransactionsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).postTransactions(requestParameters.postTransactionsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiPostTrustdockWebhooksRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public postTrustdockWebhooks(requestParameters: DefaultApiPostTrustdockWebhooksRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).postTrustdockWebhooks(requestParameters.postTrustdockWebhooksRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiPostTrustdockWebhooksSnailMailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public postTrustdockWebhooksSnailMail(requestParameters: DefaultApiPostTrustdockWebhooksSnailMailRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).postTrustdockWebhooksSnailMail(requestParameters.postTrustdockWebhooksSnailMailRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Put disable feature flag
     * @param {DefaultApiPutDisableFeatureFlagRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public putDisableFeatureFlag(requestParameters: DefaultApiPutDisableFeatureFlagRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).putDisableFeatureFlag(requestParameters.organizationId, requestParameters.featureName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Put enabled feature flag
     * @param {DefaultApiPutEnabledFeatureFlagRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public putEnabledFeatureFlag(requestParameters: DefaultApiPutEnabledFeatureFlagRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).putEnabledFeatureFlag(requestParameters.organizationId, requestParameters.featureName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Put Freee End Journal Entry Transition Mode
     * @param {DefaultApiPutFreeeEndJournalEntryTransitionModeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public putFreeeEndJournalEntryTransitionMode(requestParameters: DefaultApiPutFreeeEndJournalEntryTransitionModeRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).putFreeeEndJournalEntryTransitionMode(requestParameters.organizationId, requestParameters.putFreeeEndJournalEntryTransitionModeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Put Organization Payment Method
     * @param {DefaultApiPutOrganizationPaymentMethodRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public putOrganizationPaymentMethod(requestParameters: DefaultApiPutOrganizationPaymentMethodRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).putOrganizationPaymentMethod(requestParameters.organizationId, requestParameters.putOrganizationPaymentMethodRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Put organizations deals
     * @param {DefaultApiPutOrganizationsDealsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public putOrganizationsDeals(requestParameters: DefaultApiPutOrganizationsDealsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).putOrganizationsDeals(requestParameters.organizationId, requestParameters.putOrganizationsDealsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update payment request
     * @param {DefaultApiPutPaymentRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public putPaymentRequest(requestParameters: DefaultApiPutPaymentRequestRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).putPaymentRequest(requestParameters.organizationId, requestParameters.paymentRequestId, requestParameters.putPaymentRequestRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Put payment requests bank account
     * @param {DefaultApiPutPaymentRequestsBankAccountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public putPaymentRequestsBankAccount(requestParameters: DefaultApiPutPaymentRequestsBankAccountRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).putPaymentRequestsBankAccount(requestParameters.organizationId, requestParameters.bankAccountId, requestParameters.putPaymentRequestsBankAccountRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Put transaction evidence emails link to transaction
     * @param {DefaultApiPutTransactionEvidenceEmailsLinkToTransactionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public putTransactionEvidenceEmailsLinkToTransaction(requestParameters: DefaultApiPutTransactionEvidenceEmailsLinkToTransactionRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).putTransactionEvidenceEmailsLinkToTransaction(requestParameters.putTransactionEvidenceEmailsLinkToTransactionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Put transaction evidence emails mark as read
     * @param {DefaultApiPutTransactionEvidenceEmailsMarkAsReadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public putTransactionEvidenceEmailsMarkAsRead(requestParameters: DefaultApiPutTransactionEvidenceEmailsMarkAsReadRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).putTransactionEvidenceEmailsMarkAsRead(requestParameters.putTransactionEvidenceEmailsMarkAsReadRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Put transaction evidence emails move to trash
     * @param {DefaultApiPutTransactionEvidenceEmailsMoveToTrashRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public putTransactionEvidenceEmailsMoveToTrash(requestParameters: DefaultApiPutTransactionEvidenceEmailsMoveToTrashRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).putTransactionEvidenceEmailsMoveToTrash(requestParameters.putTransactionEvidenceEmailsMoveToTrashRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Give reward point to organization
     * @param {DefaultApiPutZeusGiveRewardPointsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public putZeusGiveRewardPoints(requestParameters: DefaultApiPutZeusGiveRewardPointsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).putZeusGiveRewardPoints(requestParameters.organizationId, requestParameters.putZeusGiveRewardPointsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Query by ids payment requests
     * @param {DefaultApiQueryByIdsPaymentRequestsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public queryByIdsPaymentRequests(requestParameters: DefaultApiQueryByIdsPaymentRequestsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).queryByIdsPaymentRequests(requestParameters.organizationId, requestParameters.queryByIdsPaymentRequestsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update read status of a message
     * @param {DefaultApiReadUserMessageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public readUserMessage(requestParameters: DefaultApiReadUserMessageRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).readUserMessage(requestParameters.userMessageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary register note
     * @param {DefaultApiRegisterNoteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public registerNote(requestParameters: DefaultApiRegisterNoteRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).registerNote(requestParameters.onboardingRequestId, requestParameters.registerNoteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Register note for organization identity verification
     * @param {DefaultApiRegisterNoteForOrganizationIdentityVerificationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public registerNoteForOrganizationIdentityVerification(requestParameters: DefaultApiRegisterNoteForOrganizationIdentityVerificationRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).registerNoteForOrganizationIdentityVerification(requestParameters.organizationIdentityVerificationId, requestParameters.registerNoteForOrganizationIdentityVerificationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Register an organization using the onboarding request ID
     * @param {DefaultApiRegisterOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public registerOrganization(requestParameters: DefaultApiRegisterOrganizationRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).registerOrganization(requestParameters.onboardingRequestId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Register organization chart for workflow
     * @param {DefaultApiRegisterOrganizationChartForWorkflowRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public registerOrganizationChartForWorkflow(requestParameters: DefaultApiRegisterOrganizationChartForWorkflowRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).registerOrganizationChartForWorkflow(requestParameters.organizationId, requestParameters.registerOrganizationChartForWorkflowRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Register Tfa App Verification Code
     * @param {DefaultApiRegisterTfaAppVerificationCodeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public registerTfaAppVerificationCode(requestParameters: DefaultApiRegisterTfaAppVerificationCodeRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).registerTfaAppVerificationCode(requestParameters.registerTfaAppVerificationCodeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Register Tfa SMS Auth
     * @param {DefaultApiRegisterTfaSmsAuthRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public registerTfaSmsAuth(requestParameters: DefaultApiRegisterTfaSmsAuthRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).registerTfaSmsAuth(requestParameters.registerTfaSmsAuthRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Register transaction evidence email address
     * @param {DefaultApiRegisterTransactionEvidenceEmailAddressRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public registerTransactionEvidenceEmailAddress(requestParameters: DefaultApiRegisterTransactionEvidenceEmailAddressRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).registerTransactionEvidenceEmailAddress(requestParameters.userAccountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reject Organization Identity Verification
     * @param {DefaultApiRejectOrganizationIdentityVerificationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public rejectOrganizationIdentityVerification(requestParameters: DefaultApiRejectOrganizationIdentityVerificationRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).rejectOrganizationIdentityVerification(requestParameters.organizationIdentityVerificationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reject purchase application.
     * @param {DefaultApiRejectPurchaseApplicationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public rejectPurchaseApplication(requestParameters: DefaultApiRejectPurchaseApplicationRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).rejectPurchaseApplication(requestParameters.organizationId, requestParameters.purchaseApplicationId, requestParameters.rejectPurchaseApplicationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public remindCardTransactionEvidence(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).remindCardTransactionEvidence(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remind monthly payment notifications.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public remindMonthlyPaymentNotifications(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).remindMonthlyPaymentNotifications(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remind organization monthly payment notifications.
     * @param {DefaultApiRemindOrganizationMonthlyPaymentNotificationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public remindOrganizationMonthlyPaymentNotification(requestParameters: DefaultApiRemindOrganizationMonthlyPaymentNotificationRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).remindOrganizationMonthlyPaymentNotification(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Rename user account group
     * @param {DefaultApiRenameUserAccountGroupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public renameUserAccountGroup(requestParameters: DefaultApiRenameUserAccountGroupRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).renameUserAccountGroup(requestParameters.userAccountGroupId, requestParameters.renameUserAccountGroupRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Replace Virtual Card
     * @param {DefaultApiReplaceVirtualCardRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public replaceVirtualCard(requestParameters: DefaultApiReplaceVirtualCardRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).replaceVirtualCard(requestParameters.userAccountId, requestParameters.replaceVirtualCardRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary request add system admin role
     * @param {DefaultApiRequestAddSystemAdminRoleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public requestAddSystemAdminRole(requestParameters: DefaultApiRequestAddSystemAdminRoleRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).requestAddSystemAdminRole(requestParameters.userId, requestParameters.requestAddSystemAdminRoleRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Request sending physical cards
     * @param {DefaultApiRequestSendingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public requestSending(requestParameters: DefaultApiRequestSendingRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).requestSending(requestParameters.organizationId, requestParameters.requestSendingRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Request sending a metal card
     * @param {DefaultApiRequestSendingMetalCardRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public requestSendingMetalCard(requestParameters: DefaultApiRequestSendingMetalCardRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).requestSendingMetalCard(requestParameters.organizationId, requestParameters.requestSendingMetalCardRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public requestSyncingClearedTransaction(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).requestSyncingClearedTransaction(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Request to Generate Organizations Accounting Csv in Background
     * @param {DefaultApiRequestToOrganizationsAccountingCsvInBackgroundRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public requestToOrganizationsAccountingCsvInBackground(requestParameters: DefaultApiRequestToOrganizationsAccountingCsvInBackgroundRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).requestToOrganizationsAccountingCsvInBackground(requestParameters.organizationId, requestParameters.yearMonth, requestParameters.isMergedFiles, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary request update system admin role
     * @param {DefaultApiRequestUpdateSystemAdminRoleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public requestUpdateSystemAdminRole(requestParameters: DefaultApiRequestUpdateSystemAdminRoleRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).requestUpdateSystemAdminRole(requestParameters.userId, requestParameters.requestUpdateSystemAdminRoleRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Resend Snail Mail For Organization Identity Verification
     * @param {DefaultApiResendSnailMailForOrganizationIdentityVerificationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public resendSnailMailForOrganizationIdentityVerification(requestParameters: DefaultApiResendSnailMailForOrganizationIdentityVerificationRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).resendSnailMailForOrganizationIdentityVerification(requestParameters.organizationIdentityVerificationId, requestParameters.resendSnailMailForOrganizationIdentityVerificationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Resend an invitation to a new user
     * @param {DefaultApiResendUserInviteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public resendUserInvite(requestParameters: DefaultApiResendUserInviteRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).resendUserInvite(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Resume a suspended card
     * @param {DefaultApiResumeCardRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public resumeCard(requestParameters: DefaultApiResumeCardRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).resumeCard(requestParameters.organizationId, requestParameters.cardId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Resynchronize card transactions for freee
     * @param {DefaultApiResynchronizeCardTransactionsForFreeeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public resynchronizeCardTransactionsForFreee(requestParameters: DefaultApiResynchronizeCardTransactionsForFreeeRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).resynchronizeCardTransactionsForFreee(requestParameters.organizationId, requestParameters.resynchronizeCardTransactionsForFreeeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Save deal as draft
     * @param {DefaultApiSaveDealAsDraftRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public saveDealAsDraft(requestParameters: DefaultApiSaveDealAsDraftRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).saveDealAsDraft(requestParameters.organizationId, requestParameters.dealId, requestParameters.saveDealAsDraftRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Save Deal As Ignore
     * @param {DefaultApiSaveDealAsIgnoreRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public saveDealAsIgnore(requestParameters: DefaultApiSaveDealAsIgnoreRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).saveDealAsIgnore(requestParameters.organizationId, requestParameters.dealId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Save deal as return to editing
     * @param {DefaultApiSaveDealAsReturnToEditingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public saveDealAsReturnToEditing(requestParameters: DefaultApiSaveDealAsReturnToEditingRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).saveDealAsReturnToEditing(requestParameters.organizationId, requestParameters.dealId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Save deal with journalizing
     * @param {DefaultApiSaveDealWithJournalizingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public saveDealWithJournalizing(requestParameters: DefaultApiSaveDealWithJournalizingRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).saveDealWithJournalizing(requestParameters.organizationId, requestParameters.dealId, requestParameters.saveDealWithJournalizingRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Save deals as ignore
     * @param {DefaultApiSaveDealsAsIgnoreRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public saveDealsAsIgnore(requestParameters: DefaultApiSaveDealsAsIgnoreRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).saveDealsAsIgnore(requestParameters.organizationId, requestParameters.saveDealsAsIgnoreRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Save deals as journalized
     * @param {DefaultApiSaveDealsAsJournalizedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public saveDealsAsJournalized(requestParameters: DefaultApiSaveDealsAsJournalizedRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).saveDealsAsJournalized(requestParameters.organizationId, requestParameters.saveDealsAsJournalizedRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Save deals as return to editing
     * @param {DefaultApiSaveDealsAsReturnToEditingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public saveDealsAsReturnToEditing(requestParameters: DefaultApiSaveDealsAsReturnToEditingRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).saveDealsAsReturnToEditing(requestParameters.organizationId, requestParameters.saveDealsAsReturnToEditingRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Search bank transfers
     * @param {DefaultApiSearchBankTransfersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public searchBankTransfers(requestParameters: DefaultApiSearchBankTransfersRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).searchBankTransfers(requestParameters.organizationId, requestParameters.transferDateJstFrom, requestParameters.transferDateJstTo, requestParameters.sourceBankAccountId, requestParameters.downloaded, requestParameters.limit, requestParameters.offset, requestParameters.cursor, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Search Corporations In National Tax Agency
     * @param {DefaultApiSearchCorporationsInNationalTaxAgencyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public searchCorporationsInNationalTaxAgency(requestParameters: DefaultApiSearchCorporationsInNationalTaxAgencyRequest = {}, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).searchCorporationsInNationalTaxAgency(requestParameters.name, requestParameters.searchMethod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Search deals
     * @param {DefaultApiSearchDealsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public searchDeals(requestParameters: DefaultApiSearchDealsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).searchDeals(requestParameters.organizationId, requestParameters.searchDealsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Search evidences
     * @param {DefaultApiSearchEvidencesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public searchEvidences(requestParameters: DefaultApiSearchEvidencesRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).searchEvidences(requestParameters.organizationId, requestParameters.issuer, requestParameters.amountMin, requestParameters.amountMax, requestParameters.paidAtFrom, requestParameters.paidAtTo, requestParameters.irrelevantToLedger, requestParameters.keyword, requestParameters.includesDeleted, requestParameters.legalValidities, requestParameters.limit, requestParameters.offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Search my payment requests
     * @param {DefaultApiSearchMyPaymentRequestsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public searchMyPaymentRequests(requestParameters: DefaultApiSearchMyPaymentRequestsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).searchMyPaymentRequests(requestParameters.organizationId, requestParameters.dueDateJstFrom, requestParameters.dueDateJstTo, requestParameters.requestedDateJstFrom, requestParameters.requestedDateJstTo, requestParameters.statuses, requestParameters.supplierId, requestParameters.transferDataCreated, requestParameters.withholdingApplied, requestParameters.transferFeeResponsibility, requestParameters.freeWord, requestParameters.limit, requestParameters.offset, requestParameters.cursor, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Search Organizations
     * @param {DefaultApiSearchOrganizationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public searchOrganizations(requestParameters: DefaultApiSearchOrganizationsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).searchOrganizations(requestParameters.key, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Search payment requests
     * @param {DefaultApiSearchPaymentRequestsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public searchPaymentRequests(requestParameters: DefaultApiSearchPaymentRequestsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).searchPaymentRequests(requestParameters.organizationId, requestParameters.dueDateJstFrom, requestParameters.dueDateJstTo, requestParameters.requestedDateJstFrom, requestParameters.requestedDateJstTo, requestParameters.statuses, requestParameters.supplierId, requestParameters.transferDataCreated, requestParameters.withholdingApplied, requestParameters.transferFeeResponsibility, requestParameters.requestorId, requestParameters.freeWord, requestParameters.limit, requestParameters.offset, requestParameters.cursor, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary send back onboarding request
     * @param {DefaultApiSendBackOnboardingRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public sendBackOnboardingRequest(requestParameters: DefaultApiSendBackOnboardingRequestRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).sendBackOnboardingRequest(requestParameters.onboardingRequestId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary send changed credit notifications
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public sendChangedCreditNotifications(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).sendChangedCreditNotifications(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Send Organization Identity Verification
     * @param {DefaultApiSendOrganizationIdentityVerificationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public sendOrganizationIdentityVerification(requestParameters: DefaultApiSendOrganizationIdentityVerificationRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).sendOrganizationIdentityVerification(requestParameters.organizationId, requestParameters.sendOrganizationIdentityVerificationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Send Transaction Authorization Request
     * @param {DefaultApiSendTransactionAuthorizationRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public sendTransactionAuthorizationRequest(requestParameters: DefaultApiSendTransactionAuthorizationRequestRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).sendTransactionAuthorizationRequest(requestParameters.organizationId, requestParameters.sendTransactionAuthorizationRequestRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sign Up For Slack
     * @param {DefaultApiSignUpForSlackRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public signUpForSlack(requestParameters: DefaultApiSignUpForSlackRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).signUpForSlack(requestParameters.signUpForSlackRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Submit completed workflow of draft payment request
     * @param {DefaultApiSubmitCompletedWorkflowOfDraftPaymentRequestsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public submitCompletedWorkflowOfDraftPaymentRequests(requestParameters: DefaultApiSubmitCompletedWorkflowOfDraftPaymentRequestsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).submitCompletedWorkflowOfDraftPaymentRequests(requestParameters.organizationId, requestParameters.draftPaymentRequestId, requestParameters.xUpsidrSwitchUser, requestParameters.submitCompletedWorkflowOfDraftPaymentRequestsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Submit completed workflow of payment request
     * @param {DefaultApiSubmitCompletedWorkflowOfPaymentRequestsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public submitCompletedWorkflowOfPaymentRequests(requestParameters: DefaultApiSubmitCompletedWorkflowOfPaymentRequestsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).submitCompletedWorkflowOfPaymentRequests(requestParameters.organizationId, requestParameters.xUpsidrSwitchUser, requestParameters.submitCompletedWorkflowOfPaymentRequestsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Submit workflow
     * @param {DefaultApiSubmitWorkflowRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public submitWorkflow(requestParameters: DefaultApiSubmitWorkflowRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).submitWorkflow(requestParameters.organizationId, requestParameters.workflowInstanceId, requestParameters.xUpsidrSwitchUser, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Suspend a card
     * @param {DefaultApiSuspendCardRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public suspendCard(requestParameters: DefaultApiSuspendCardRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).suspendCard(requestParameters.organizationId, requestParameters.cardId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public syncAllCardStatuses(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).syncAllCardStatuses(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sync all users to each marketing tools
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public syncAllUsersToEachMarketingTools(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).syncAllUsersToEachMarketingTools(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sync freee account items
     * @param {DefaultApiSyncFreeeAccountItemsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public syncFreeeAccountItems(requestParameters: DefaultApiSyncFreeeAccountItemsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).syncFreeeAccountItems(requestParameters.organizationId, requestParameters.companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sync freee partners
     * @param {DefaultApiSyncFreeePartnersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public syncFreeePartners(requestParameters: DefaultApiSyncFreeePartnersRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).syncFreeePartners(requestParameters.organizationId, requestParameters.companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sync freee segment tags
     * @param {DefaultApiSyncFreeeSegmentTagsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public syncFreeeSegmentTags(requestParameters: DefaultApiSyncFreeeSegmentTagsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).syncFreeeSegmentTags(requestParameters.organizationId, requestParameters.companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sync Moneytree access token
     * @param {DefaultApiSyncMoneytreeAccessTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public syncMoneytreeAccessToken(requestParameters: DefaultApiSyncMoneytreeAccessTokenRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).syncMoneytreeAccessToken(requestParameters.code, requestParameters.state, requestParameters.nextTo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sync Request for Freee Deals
     * @param {DefaultApiSyncRequestForFreeeDealsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public syncRequestForFreeeDeals(requestParameters: DefaultApiSyncRequestForFreeeDealsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).syncRequestForFreeeDeals(requestParameters.organizationId, requestParameters.companyId, requestParameters.syncRequestForFreeeDealsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Two Factor Auth Reset
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public twoFactorAuthReset(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).twoFactorAuthReset(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Two Factor Auth Reset As Token
     * @param {DefaultApiTwoFactorAuthResetAsTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public twoFactorAuthResetAsToken(requestParameters: DefaultApiTwoFactorAuthResetAsTokenRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).twoFactorAuthResetAsToken(requestParameters.twoFactorAuthResetAsTokenRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Unlinking purchase to transaction.
     * @param {DefaultApiUnlinkingPurchaseToTransactionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public unlinkingPurchaseToTransaction(requestParameters: DefaultApiUnlinkingPurchaseToTransactionRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).unlinkingPurchaseToTransaction(requestParameters.organizationId, requestParameters.purchaseApplicationId, requestParameters.visaTransactionReferenceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Unlock a card due to no potential fraud
     * @param {DefaultApiUnlockCardForNotPotentialFraudRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public unlockCardForNotPotentialFraud(requestParameters: DefaultApiUnlockCardForNotPotentialFraudRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).unlockCardForNotPotentialFraud(requestParameters.organizationId, requestParameters.cardId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Unlock a card due to fraud cleared
     * @param {DefaultApiUnlockCardOnFraudClearedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public unlockCardOnFraudCleared(requestParameters: DefaultApiUnlockCardOnFraudClearedRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).unlockCardOnFraudCleared(requestParameters.organizationId, requestParameters.cardId, requestParameters.visaTransactionReferenceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Available Currencies
     * @param {DefaultApiUpdateAvailableCurrenciesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateAvailableCurrencies(requestParameters: DefaultApiUpdateAvailableCurrenciesRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateAvailableCurrencies(requestParameters.userAccountId, requestParameters.updateAvailableCurrenciesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Available Merchant Categories
     * @param {DefaultApiUpdateAvailableMerchantCategoriesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateAvailableMerchantCategories(requestParameters: DefaultApiUpdateAvailableMerchantCategoriesRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateAvailableMerchantCategories(requestParameters.userAccountId, requestParameters.updateAvailableMerchantCategoriesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary update card account unit
     * @param {DefaultApiUpdateCardAccountUnitRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateCardAccountUnit(requestParameters: DefaultApiUpdateCardAccountUnitRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateCardAccountUnit(requestParameters.organizationId, requestParameters.updateCardAccountUnitRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Card Count Limit
     * @param {DefaultApiUpdateCardCountLimitRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateCardCountLimit(requestParameters: DefaultApiUpdateCardCountLimitRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateCardCountLimit(requestParameters.organizationId, requestParameters.updateCardCountLimitRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update card holder for the user account
     * @param {DefaultApiUpdateCardHolderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateCardHolder(requestParameters: DefaultApiUpdateCardHolderRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateCardHolder(requestParameters.userAccountId, requestParameters.updateCardHolderRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Lock a card
     * @param {DefaultApiUpdateCardLockRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateCardLock(requestParameters: DefaultApiUpdateCardLockRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateCardLock(requestParameters.organizationId, requestParameters.cardId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Unlock a card
     * @param {DefaultApiUpdateCardUnlockRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateCardUnlock(requestParameters: DefaultApiUpdateCardUnlockRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateCardUnlock(requestParameters.organizationId, requestParameters.cardId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update comment for card transaction
     * @param {DefaultApiUpdateCommentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateComment(requestParameters: DefaultApiUpdateCommentRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateComment(requestParameters.organizationId, requestParameters.paymentReferenceId, requestParameters.cardTransactionCommentId, requestParameters.updateCommentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update comment template
     * @param {DefaultApiUpdateCommentTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateCommentTemplate(requestParameters: DefaultApiUpdateCommentTemplateRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateCommentTemplate(requestParameters.organizationId, requestParameters.templateId, requestParameters.updateCommentTemplateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update corporate document verification result
     * @param {DefaultApiUpdateCorporateDocumentResultRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateCorporateDocumentResult(requestParameters: DefaultApiUpdateCorporateDocumentResultRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateCorporateDocumentResult(requestParameters.organizationIdentityVerificationId, requestParameters.updateCorporateDocumentResultRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update daily usage limit for the user account
     * @param {DefaultApiUpdateDailyUserUsageLimitRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateDailyUserUsageLimit(requestParameters: DefaultApiUpdateDailyUserUsageLimitRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateDailyUserUsageLimit(requestParameters.userAccountId, requestParameters.updateDailyUserUsageLimitRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update deposit restriction for organization
     * @param {DefaultApiUpdateDepositRestrictionForOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateDepositRestrictionForOrganization(requestParameters: DefaultApiUpdateDepositRestrictionForOrganizationRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateDepositRestrictionForOrganization(requestParameters.organizationId, requestParameters.depositRestrictionId, requestParameters.updateDepositRestrictionForOrganizationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Toggle on/off email notification settings per user
     * @param {DefaultApiUpdateEmailNotificationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateEmailNotification(requestParameters: DefaultApiUpdateEmailNotificationRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateEmailNotification(requestParameters.userId, requestParameters.emailNotificationId, requestParameters.updateEmailNotificationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary update embed url method
     * @param {DefaultApiUpdateEmbedUrlMethodRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateEmbedUrlMethod(requestParameters: DefaultApiUpdateEmbedUrlMethodRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateEmbedUrlMethod(requestParameters.organizationId, requestParameters.updateEmbedUrlMethodRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update evidence image
     * @param {DefaultApiUpdateEvidenceImageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateEvidenceImage(requestParameters: DefaultApiUpdateEvidenceImageRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateEvidenceImage(requestParameters.organizationId, requestParameters.paymentReferenceId, requestParameters.cardTransactionEvidenceId, requestParameters.file, requestParameters.electronicMethod, requestParameters.documentSize, requestParameters.heightMillis, requestParameters.widthMillis, requestParameters.note, requestParameters.irrelevantToLedger, requestParameters.dpiForciblyValid, requestParameters.colorGradationForciblyValid, requestParameters.uploadedByRecipient, requestParameters.uploadedFrom, requestParameters.invoiceIssuerName, requestParameters.invoiceIssuerRegistrationNumber, requestParameters.asQualified, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update evidence info
     * @param {DefaultApiUpdateEvidenceInfoRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateEvidenceInfo(requestParameters: DefaultApiUpdateEvidenceInfoRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateEvidenceInfo(requestParameters.organizationId, requestParameters.paymentReferenceId, requestParameters.cardTransactionEvidenceId, requestParameters.updateEvidenceInfoRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update freee connect
     * @param {DefaultApiUpdateFreeeConnectRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateFreeeConnect(requestParameters: DefaultApiUpdateFreeeConnectRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateFreeeConnect(requestParameters.organizationId, requestParameters.code, requestParameters.state, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Turn on/off freee journaling
     * @param {DefaultApiUpdateFreeeJournalingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateFreeeJournaling(requestParameters: DefaultApiUpdateFreeeJournalingRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateFreeeJournaling(requestParameters.organizationId, requestParameters.updateFreeeJournalingRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update freee select company
     * @param {DefaultApiUpdateFreeeSelectCompanyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateFreeeSelectCompany(requestParameters: DefaultApiUpdateFreeeSelectCompanyRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateFreeeSelectCompany(requestParameters.organizationId, requestParameters.updateFreeeSelectCompanyRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update lock status of evidences
     * @param {DefaultApiUpdateLockStatusOfEvidencesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateLockStatusOfEvidences(requestParameters: DefaultApiUpdateLockStatusOfEvidencesRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateLockStatusOfEvidences(requestParameters.organizationId, requestParameters.updateLockStatusOfEvidencesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update merchant general block allowed organization ids
     * @param {DefaultApiUpdateMerchantGeneralBlockAllowedOrganizationIdsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateMerchantGeneralBlockAllowedOrganizationIds(requestParameters: DefaultApiUpdateMerchantGeneralBlockAllowedOrganizationIdsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateMerchantGeneralBlockAllowedOrganizationIds(requestParameters.merchantGeneralBlockListId, requestParameters.updateMerchantGeneralBlockAllowedOrganizationIdsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update merchant general block list
     * @param {DefaultApiUpdateMerchantGeneralBlockListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateMerchantGeneralBlockList(requestParameters: DefaultApiUpdateMerchantGeneralBlockListRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateMerchantGeneralBlockList(requestParameters.merchantGeneralBlockListId, requestParameters.updateMerchantGeneralBlockListRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update merchant org block list
     * @param {DefaultApiUpdateMerchantOrgBlockListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateMerchantOrgBlockList(requestParameters: DefaultApiUpdateMerchantOrgBlockListRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateMerchantOrgBlockList(requestParameters.merchantOrgBlockListId, requestParameters.updateMerchantOrgBlockListRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Merchant Organization Comment
     * @param {DefaultApiUpdateMerchantOrganizationCommentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateMerchantOrganizationComment(requestParameters: DefaultApiUpdateMerchantOrganizationCommentRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateMerchantOrganizationComment(requestParameters.organizationId, requestParameters.merchantId, requestParameters.userAccountId, requestParameters.updateMerchantOrganizationCommentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Organization
     * @param {DefaultApiUpdateOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateOrganization(requestParameters: DefaultApiUpdateOrganizationRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateOrganization(requestParameters.organizationId, requestParameters.updateOrganizationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Organizations Accounting Csv Export Fields
     * @param {DefaultApiUpdateOrganizationsAccountingCsvExportFieldsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateOrganizationsAccountingCsvExportFields(requestParameters: DefaultApiUpdateOrganizationsAccountingCsvExportFieldsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateOrganizationsAccountingCsvExportFields(requestParameters.organizationId, requestParameters.requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update the payment request evidence specified by evidenceId.
     * @summary Update the specific payment request evidence.
     * @param {DefaultApiUpdatePaymentRequestEvidenceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updatePaymentRequestEvidence(requestParameters: DefaultApiUpdatePaymentRequestEvidenceRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updatePaymentRequestEvidence(requestParameters.organizationId, requestParameters.paymentRequestId, requestParameters.evidenceId, requestParameters.updatePaymentRequestEvidenceRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update the payment request evidence file specified by evidenceId. This also accept properties other than a file binary.
     * @summary Update the specific payment request evidence file.
     * @param {DefaultApiUpdatePaymentRequestEvidenceFileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updatePaymentRequestEvidenceFile(requestParameters: DefaultApiUpdatePaymentRequestEvidenceFileRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updatePaymentRequestEvidenceFile(requestParameters.organizationId, requestParameters.paymentRequestId, requestParameters.evidenceId, requestParameters.file, requestParameters.electronicMethod, requestParameters.documentSize, requestParameters.heightMillis, requestParameters.widthMillis, requestParameters.dpiForciblyValid, requestParameters.colorGradationForciblyValid, requestParameters.note, requestParameters.irrelevantToLedger, requestParameters.uploadedByRecipient, requestParameters.uploadedFrom, requestParameters.invoiceIssuerRegistrationNumber, requestParameters.invoiceIssuerName, requestParameters.asQualified, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update purchase application template.
     * @param {DefaultApiUpdatePurchaseApplicationTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updatePurchaseApplicationTemplate(requestParameters: DefaultApiUpdatePurchaseApplicationTemplateRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updatePurchaseApplicationTemplate(requestParameters.organizationId, requestParameters.purchaseTemplateId, requestParameters.updatePurchaseApplicationTemplateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update remove user account group
     * @param {DefaultApiUpdateRemoveUserAccountGroupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateRemoveUserAccountGroup(requestParameters: DefaultApiUpdateRemoveUserAccountGroupRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateRemoveUserAccountGroup(requestParameters.userAccountId, requestParameters.updateRemoveUserAccountGroupRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update role resource for user
     * @param {DefaultApiUpdateRoleResourceForUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateRoleResourceForUser(requestParameters: DefaultApiUpdateRoleResourceForUserRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateRoleResourceForUser(requestParameters.userId, requestParameters.updateRoleResourceForUserRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Roles by Resource Id
     * @param {DefaultApiUpdateRolesByResourceIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateRolesByResourceId(requestParameters: DefaultApiUpdateRolesByResourceIdRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateRolesByResourceId(requestParameters.resourceScope, requestParameters.resourceId, requestParameters.updateRolesByResourceIdRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Slack evidence remind settings of an slack channel
     * @param {DefaultApiUpdateSlackEvidenceReminderPerChannelRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateSlackEvidenceReminderPerChannel(requestParameters: DefaultApiUpdateSlackEvidenceReminderPerChannelRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateSlackEvidenceReminderPerChannel(requestParameters.organizationId, requestParameters.channelId, requestParameters.updateSlackEvidenceReminderPerChannelRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update slack notification channel setting for card
     * @param {DefaultApiUpdateSlackNotificationSettingForCardRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateSlackNotificationSettingForCard(requestParameters: DefaultApiUpdateSlackNotificationSettingForCardRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateSlackNotificationSettingForCard(requestParameters.organizationId, requestParameters.channelId, requestParameters.updateSlackNotificationSettingForCardRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update slack notification channel setting for purchase-application
     * @param {DefaultApiUpdateSlackNotificationSettingForPurchaseApplicationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateSlackNotificationSettingForPurchaseApplication(requestParameters: DefaultApiUpdateSlackNotificationSettingForPurchaseApplicationRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateSlackNotificationSettingForPurchaseApplication(requestParameters.organizationId, requestParameters.channelId, requestParameters.updateSlackNotificationSettingForPurchaseApplicationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update sync to freee from deal
     * @param {DefaultApiUpdateSyncToFreeeFromDealRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateSyncToFreeeFromDeal(requestParameters: DefaultApiUpdateSyncToFreeeFromDealRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateSyncToFreeeFromDeal(requestParameters.organizationId, requestParameters.companyId, requestParameters.dealId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update synchronize to freee log confirm
     * @param {DefaultApiUpdateSynchronizeToFreeeLogConfirmRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateSynchronizeToFreeeLogConfirm(requestParameters: DefaultApiUpdateSynchronizeToFreeeLogConfirmRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateSynchronizeToFreeeLogConfirm(requestParameters.organizationId, requestParameters.companyId, requestParameters.updateSynchronizeToFreeeLogConfirmRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Teams notification channel setting for card
     * @param {DefaultApiUpdateTeamsNotificationSettingForCardRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateTeamsNotificationSettingForCard(requestParameters: DefaultApiUpdateTeamsNotificationSettingForCardRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateTeamsNotificationSettingForCard(requestParameters.organizationId, requestParameters.channelId, requestParameters.updateTeamsNotificationSettingForCardRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update transaction upper limit for the user account
     * @param {DefaultApiUpdateTransactionUpperLimitForTheUserAccountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateTransactionUpperLimitForTheUserAccount(requestParameters: DefaultApiUpdateTransactionUpperLimitForTheUserAccountRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateTransactionUpperLimitForTheUserAccount(requestParameters.userAccountId, requestParameters.updateTransactionUpperLimitForTheUserAccountRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update user account group
     * @param {DefaultApiUpdateUserAccountGroupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateUserAccountGroup(requestParameters: DefaultApiUpdateUserAccountGroupRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateUserAccountGroup(requestParameters.userAccountId, requestParameters.updateUserAccountGroupRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update user account name
     * @param {DefaultApiUpdateUserAccountNameRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateUserAccountName(requestParameters: DefaultApiUpdateUserAccountNameRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateUserAccountName(requestParameters.userAccountId, requestParameters.updateUserAccountNameRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary update user email, settings per user
     * @param {DefaultApiUpdateUserEmailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateUserEmail(requestParameters: DefaultApiUpdateUserEmailRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateUserEmail(requestParameters.userId, requestParameters.updateUserEmailRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary update user name, settings per user
     * @param {DefaultApiUpdateUserNameRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateUserName(requestParameters: DefaultApiUpdateUserNameRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateUserName(requestParameters.userId, requestParameters.updateUserNameRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary update user organization
     * @param {DefaultApiUpdateUserOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateUserOrganization(requestParameters: DefaultApiUpdateUserOrganizationRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateUserOrganization(requestParameters.userId, requestParameters.updateUserOrganizationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary update user password
     * @param {DefaultApiUpdateUserPasswordRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateUserPassword(requestParameters: DefaultApiUpdateUserPasswordRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateUserPassword(requestParameters.userId, requestParameters.updateUserPasswordRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update User Privilege
     * @param {DefaultApiUpdateUserPrivilegeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateUserPrivilege(requestParameters: DefaultApiUpdateUserPrivilegeRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateUserPrivilege(requestParameters.organizationId, requestParameters.userId, requestParameters.updateUserPrivilegeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update usage limit for the user account
     * @param {DefaultApiUpdateUserUsageLimitRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateUserUsageLimit(requestParameters: DefaultApiUpdateUserUsageLimitRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateUserUsageLimit(requestParameters.userAccountId, requestParameters.updateUserUsageLimitRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upload card transaction evidence images
     * @param {DefaultApiUploadCardTransactionEvidenceImageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public uploadCardTransactionEvidenceImage(requestParameters: DefaultApiUploadCardTransactionEvidenceImageRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).uploadCardTransactionEvidenceImage(requestParameters.organizationId, requestParameters.paymentReferenceId, requestParameters.files, requestParameters.electronicMethod, requestParameters.documentSize, requestParameters.heightMillis, requestParameters.widthMillis, requestParameters.note, requestParameters.irrelevantToLedger, requestParameters.uploadedByRecipient, requestParameters.uploadedFrom, requestParameters.invoiceIssuerName, requestParameters.invoiceIssuerRegistrationNumber, requestParameters.asQualified, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upload corporate document
     * @param {DefaultApiUploadCorporateDocumentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public uploadCorporateDocument(requestParameters: DefaultApiUploadCorporateDocumentRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).uploadCorporateDocument(requestParameters.organizationIdentityVerificationId, requestParameters.file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upload payment request evidence image
     * @param {DefaultApiUploadPaymentRequestEvidenceImageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public uploadPaymentRequestEvidenceImage(requestParameters: DefaultApiUploadPaymentRequestEvidenceImageRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).uploadPaymentRequestEvidenceImage(requestParameters.organizationId, requestParameters.paymentRequestId, requestParameters.file, requestParameters.electronicMethod, requestParameters.documentSize, requestParameters.heightMillis, requestParameters.widthMillis, requestParameters.note, requestParameters.irrelevantToLedger, requestParameters.uploadedByRecipient, requestParameters.uploadedFrom, requestParameters.invoiceIssuerName, requestParameters.invoiceIssuerRegistrationNumber, requestParameters.asQualified, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Users email confirm
     * @param {DefaultApiUsersEmailConfirmRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public usersEmailConfirm(requestParameters: DefaultApiUsersEmailConfirmRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).usersEmailConfirm(requestParameters.usersEmailConfirmRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Verify moneytree connections
     * @param {DefaultApiVerifyMoneytreeConnectionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public verifyMoneytreeConnections(requestParameters: DefaultApiVerifyMoneytreeConnectionsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).verifyMoneytreeConnections(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }
}


